
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
(function() {
    "use strict";
    var attributesObserver = (whenDefined, MutationObserver1)=>{
        const attributeChanged = (records)=>{
            for(let i = 0, { length: length } = records; i < length; i++)dispatch(records[i]);
        };
        const dispatch = ({ target: target, attributeName: attributeName, oldValue: oldValue })=>{
            target.attributeChangedCallback(attributeName, oldValue, target.getAttribute(attributeName));
        };
        return (target, is)=>{
            const { observedAttributes: attributeFilter } = target.constructor;
            if (attributeFilter) whenDefined(is).then(()=>{
                new MutationObserver1(attributeChanged).observe(target, {
                    attributes: true,
                    attributeOldValue: true,
                    attributeFilter: attributeFilter
                });
                for(let i = 0, { length: length } = attributeFilter; i < length; i++)if (target.hasAttribute(attributeFilter[i])) dispatch({
                    target: target,
                    attributeName: attributeFilter[i],
                    oldValue: null
                });
            });
            return target;
        };
    };
    const { keys: keys } = Object;
    const expando = (element)=>{
        const key = keys(element);
        const value = [];
        const ignore = new Set();
        const { length: length } = key;
        for(let i = 0; i < length; i++){
            value[i] = element[key[i]];
            try {
                delete element[key[i]];
            } catch (SafariTP) {
                ignore.add(i);
            }
        }
        return ()=>{
            for(let i = 0; i < length; i++)ignore.has(i) || (element[key[i]] = value[i]);
        };
    };
    /*! (c) Andrea Giammarchi - ISC */ const TRUE = true, FALSE = false, QSA$1 = "querySelectorAll";
    /**
	 * Start observing a generic document or root element.
	 * @param {(node:Element, connected:boolean) => void} callback triggered per each dis/connected element
	 * @param {Document|Element} [root=document] by default, the global document to observe
	 * @param {Function} [MO=MutationObserver] by default, the global MutationObserver
	 * @param {string[]} [query=['*']] the selectors to use within nodes
	 * @returns {MutationObserver}
	 */ const notify = (callback, root = document, MO = MutationObserver, query = [
        "*"
    ])=>{
        const loop = (nodes, selectors, added, removed, connected, pass)=>{
            for (const node of nodes)if (pass || QSA$1 in node) {
                if (connected) {
                    if (!added.has(node)) {
                        added.add(node);
                        removed.delete(node);
                        callback(node, connected);
                    }
                } else if (!removed.has(node)) {
                    removed.add(node);
                    added.delete(node);
                    callback(node, connected);
                }
                if (!pass) loop(node[QSA$1](selectors), selectors, added, removed, connected, TRUE);
            }
        };
        const mo = new MO((records)=>{
            if (query.length) {
                const selectors = query.join(",");
                const added = new Set(), removed = new Set();
                for (const { addedNodes: addedNodes, removedNodes: removedNodes } of records){
                    loop(removedNodes, selectors, added, removed, FALSE, FALSE);
                    loop(addedNodes, selectors, added, removed, TRUE, FALSE);
                }
            }
        });
        const { observe: observe } = mo;
        (mo.observe = (node)=>observe.call(mo, node, {
                subtree: TRUE,
                childList: TRUE
            }))(root);
        return mo;
    };
    const QSA = "querySelectorAll";
    const { document: document$2, Element: Element$1, MutationObserver: MutationObserver$2, Set: Set$2, WeakMap: WeakMap$1 } = self;
    const elements = (element)=>QSA in element;
    const { filter: filter } = [];
    var qsaObserver = (options)=>{
        const live = new WeakMap$1();
        const drop = (elements)=>{
            for(let i = 0, { length: length } = elements; i < length; i++)live.delete(elements[i]);
        };
        const flush = ()=>{
            const records = observer.takeRecords();
            for(let i = 0, { length: length } = records; i < length; i++){
                parse(filter.call(records[i].removedNodes, elements), false);
                parse(filter.call(records[i].addedNodes, elements), true);
            }
        };
        const matches = (element)=>element.matches || element.webkitMatchesSelector || element.msMatchesSelector;
        const notifier = (element, connected)=>{
            let selectors;
            if (connected) {
                for(let q, m = matches(element), i = 0, { length: length } = query; i < length; i++)if (m.call(element, q = query[i])) {
                    if (!live.has(element)) live.set(element, new Set$2());
                    selectors = live.get(element);
                    if (!selectors.has(q)) {
                        selectors.add(q);
                        options.handle(element, connected, q);
                    }
                }
            } else if (live.has(element)) {
                selectors = live.get(element);
                live.delete(element);
                selectors.forEach((q)=>{
                    options.handle(element, connected, q);
                });
            }
        };
        const parse = (elements, connected = true)=>{
            for(let i = 0, { length: length } = elements; i < length; i++)notifier(elements[i], connected);
        };
        const { query: query } = options;
        const root = options.root || document$2;
        const observer = notify(notifier, root, MutationObserver$2, query);
        const { attachShadow: attachShadow } = Element$1.prototype;
        if (attachShadow) Element$1.prototype.attachShadow = function(init) {
            const shadowRoot = attachShadow.call(this, init);
            observer.observe(shadowRoot);
            return shadowRoot;
        };
        if (query.length) parse(root[QSA](query));
        return {
            drop: drop,
            flush: flush,
            observer: observer,
            parse: parse
        };
    };
    const { customElements: customElements, document: document$1, Element: Element, MutationObserver: MutationObserver$1, Object: Object$1, Promise: Promise$1, Map: Map, Set: Set$1, WeakMap: WeakMap, Reflect: Reflect } = self;
    const { createElement: createElement } = document$1;
    const { define: define, get: get, upgrade: upgrade } = customElements;
    const { construct: construct } = Reflect || {
        construct (HTMLElement) {
            return HTMLElement.call(this);
        }
    };
    const { defineProperty: defineProperty, getOwnPropertyNames: getOwnPropertyNames, setPrototypeOf: setPrototypeOf } = Object$1;
    const shadowRoots = new WeakMap();
    const shadows = new Set$1();
    const classes = new Map();
    const defined = new Map();
    const prototypes = new Map();
    const registry = new Map();
    const shadowed = [];
    const query = [];
    const getCE = (is)=>registry.get(is) || get.call(customElements, is);
    const handle = (element, connected, selector)=>{
        const proto = prototypes.get(selector);
        if (connected && !proto.isPrototypeOf(element)) {
            const redefine = expando(element);
            override = setPrototypeOf(element, proto);
            try {
                new proto.constructor();
            } finally{
                override = null;
                redefine();
            }
        }
        const method = `${connected ? "" : "dis"}connectedCallback`;
        if (method in proto) element[method]();
    };
    const { parse: parse } = qsaObserver({
        query: query,
        handle: handle
    });
    const { parse: parseShadowed } = qsaObserver({
        query: shadowed,
        handle (element, connected) {
            if (shadowRoots.has(element)) {
                if (connected) shadows.add(element);
                else shadows.delete(element);
                if (query.length) parseShadow.call(query, element);
            }
        }
    });
    // qsaObserver also patches attachShadow
    // be sure this runs *after* that
    const { attachShadow: attachShadow } = Element.prototype;
    if (attachShadow) Element.prototype.attachShadow = function(init) {
        const root = attachShadow.call(this, init);
        shadowRoots.set(this, root);
        return root;
    };
    const whenDefined = (name)=>{
        if (!defined.has(name)) {
            let _, $ = new Promise$1(($)=>{
                _ = $;
            });
            defined.set(name, {
                $: $,
                _: _
            });
        }
        return defined.get(name).$;
    };
    const augment = attributesObserver(whenDefined, MutationObserver$1);
    let override = null;
    getOwnPropertyNames(self).filter((k)=>/^HTML.*Element$/.test(k)).forEach((k)=>{
        const HTMLElement = self[k];
        function HTMLBuiltIn() {
            const { constructor: constructor } = this;
            if (!classes.has(constructor)) throw new TypeError("Illegal constructor");
            const { is: is, tag: tag } = classes.get(constructor);
            if (is) {
                if (override) return augment(override, is);
                const element = createElement.call(document$1, tag);
                element.setAttribute("is", is);
                return augment(setPrototypeOf(element, constructor.prototype), is);
            } else return construct.call(this, HTMLElement, [], constructor);
        }
        setPrototypeOf(HTMLBuiltIn, HTMLElement);
        defineProperty(HTMLBuiltIn.prototype = HTMLElement.prototype, "constructor", {
            value: HTMLElement
        });
        defineProperty(self, k, {
            value: HTMLBuiltIn
        });
    });
    document$1.createElement = function(name, options) {
        const is = options && options.is;
        if (is) {
            const Class = registry.get(is);
            if (Class && classes.get(Class).tag === name) return new Class();
        }
        const element = createElement.call(document$1, name);
        if (is) element.setAttribute("is", is);
        return element;
    };
    customElements.get = getCE;
    customElements.whenDefined = whenDefined;
    customElements.upgrade = function(element) {
        const is = element.getAttribute("is");
        if (is) {
            const constructor = registry.get(is);
            if (constructor) {
                augment(setPrototypeOf(element, constructor.prototype), is);
                // apparently unnecessary because this is handled by qsa observer
                // if (element.isConnected && element.connectedCallback)
                //   element.connectedCallback();
                return;
            }
        }
        upgrade.call(customElements, element);
    };
    customElements.define = function(is, Class, options) {
        if (getCE(is)) throw new Error(`'${is}' has already been defined as a custom element`);
        let selector;
        const tag = options && options.extends;
        classes.set(Class, tag ? {
            is: is,
            tag: tag
        } : {
            is: "",
            tag: is
        });
        if (tag) {
            selector = `${tag}[is="${is}"]`;
            prototypes.set(selector, Class.prototype);
            registry.set(is, Class);
            query.push(selector);
        } else {
            define.apply(customElements, arguments);
            shadowed.push(selector = is);
        }
        whenDefined(is).then(()=>{
            if (tag) {
                parse(document$1.querySelectorAll(selector));
                shadows.forEach(parseShadow, [
                    selector
                ]);
            } else parseShadowed(document$1.querySelectorAll(selector));
        });
        defined.get(is)._(Class);
    };
    function parseShadow(element) {
        const root = shadowRoots.get(element);
        parse(root.querySelectorAll(this), element.isConnected);
    }
})();


/**
 * String prototype polyfills: startsWith and endsWith
 *
 * Why: Provide minimal fallbacks for environments that lack these ES6 methods.
 * Scope: Adds non-standard-compliant but practical implementations only if the
 * methods are not already defined by the runtime.
 *
 * Notes:
 * - This file conditionally extends the String prototype. We scope our changes
 *   behind feature checks to avoid overriding native implementations.
 * - These implementations are intentionally simple and cover the common cases
 *   used by this codebase. They are not meant to be spec-perfect.
 *
 * References:
 * - MDN String.prototype.startsWith
 *   https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
 * - MDN String.prototype.endsWith
 *   https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
 */ // eslint-disable-next-line no-extend-native
!String.prototype.startsWith && (String.prototype.startsWith = function(searchString, position) {
    /**
		 * @param {string} searchString - Substring to match from the start.
		 * @param {number} [position=0] - Start index for comparison.
		 * @returns {boolean} True if this string starts at position with searchString.
		 */ return this.substring(position || 0, searchString.length) === searchString;
});
// eslint-disable-next-line no-extend-native
!String.prototype.endsWith && (String.prototype.endsWith = function(searchString, length) {
    /**
		 * @param {string} search - Substring to match at the end.
		 * @param {number} [length] - Optional length to treat as the string end.
		 * @returns {boolean} True if this string ends with the given search substring.
		 */ (length === undefined || length > this.length) && (length = this.length);
    return this.substring(length - searchString.length, length) === searchString;
});




//#region js/utils/util.ts
var $4afc1a8f9e4d93e8$var$e = (e, t)=>{
    for(let n in t)e[n] = t[n];
    return e;
}, $4afc1a8f9e4d93e8$var$t = (e, t)=>Array.from(e.querySelectorAll(t)), $4afc1a8f9e4d93e8$var$n = (e, t, n)=>{
    n ? e.classList.add(t) : e.classList.remove(t);
}, $4afc1a8f9e4d93e8$var$r = (e)=>{
    if (typeof e == "string") {
        if (e === "null") return null;
        if (e === "true") return !0;
        if (e === "false") return !1;
        if (e.match(/^-?[\d\.]+$/)) return parseFloat(e);
    }
    return e;
}, $4afc1a8f9e4d93e8$var$i = (e, t)=>{
    e.style.transform = t;
}, $4afc1a8f9e4d93e8$var$a = (e, t)=>{
    let n = e.matches || e.matchesSelector || e.msMatchesSelector;
    return !!(n && n.call(e, t));
}, $4afc1a8f9e4d93e8$var$o = (e, t)=>{
    if (e && typeof e.closest == "function") return e.closest(t);
    for(; e;){
        if ($4afc1a8f9e4d93e8$var$a(e, t)) return e;
        e = e.parentElement;
    }
    return null;
}, $4afc1a8f9e4d93e8$var$s = (e)=>{
    e = e || document.documentElement;
    let t = e.requestFullscreen || e.webkitRequestFullscreen || e.webkitRequestFullScreen || e.mozRequestFullScreen || e.msRequestFullscreen;
    t && t.apply(e);
}, $4afc1a8f9e4d93e8$var$c = (e, t, n, r = "")=>{
    let i = e.querySelectorAll("." + n);
    for(let t = 0; t < i.length; t++){
        let n = i[t];
        if (n.parentNode === e) return n;
    }
    let a = document.createElement(t);
    return a.className = n, a.innerHTML = r, e.appendChild(a), a;
}, $4afc1a8f9e4d93e8$var$l = (e)=>{
    let t = document.createElement("style");
    return e && e.length > 0 && t.appendChild(document.createTextNode(e)), document.head.appendChild(t), t;
}, $4afc1a8f9e4d93e8$var$u = ()=>{
    let e = {};
    location.search.replace(/[A-Z0-9]+?=([\w\.%-]*)/gi, (t)=>{
        let n = t.split("=").shift(), r = t.split("=").pop();
        return n && r !== void 0 && (e[n] = r), t;
    });
    for(let t in e){
        let n = e[t];
        e[t] = $4afc1a8f9e4d93e8$var$r(unescape(n));
    }
    return e.dependencies !== void 0 && delete e.dependencies, e;
}, $4afc1a8f9e4d93e8$var$d = (e, t = 0)=>{
    if (e) {
        var n;
        let r, i = e.style.height;
        return e.style.height = "0px", e.parentElement && (e.parentElement.style.height = "auto"), r = t - (((n = e.parentElement) == null ? void 0 : n.offsetHeight) || 0), e.style.height = i + "px", e.parentElement && e.parentElement.style.removeProperty("height"), r;
    }
    return t;
}, $4afc1a8f9e4d93e8$var$f = {
    mp4: "video/mp4",
    m4a: "video/mp4",
    ogv: "video/ogg",
    mpeg: "video/mpeg",
    webm: "video/webm"
}, $4afc1a8f9e4d93e8$var$p = (e = "")=>{
    let t = e.split(".").pop();
    return t ? $4afc1a8f9e4d93e8$var$f[t] : void 0;
}, $4afc1a8f9e4d93e8$var$m = (e = "")=>encodeURI(e).replace(/%5B/g, "[").replace(/%5D/g, "]").replace(/[!'()*]/g, (e)=>`%${e.charCodeAt(0).toString(16).toUpperCase()}`), $4afc1a8f9e4d93e8$var$h = navigator.userAgent, $4afc1a8f9e4d93e8$var$g = /(iphone|ipod|ipad|android)/gi.test($4afc1a8f9e4d93e8$var$h) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
/chrome/i.test($4afc1a8f9e4d93e8$var$h) && /edge/i.test($4afc1a8f9e4d93e8$var$h);
var $4afc1a8f9e4d93e8$var$_ = /android/gi.test($4afc1a8f9e4d93e8$var$h), $4afc1a8f9e4d93e8$var$v = function(e) {
    if (e) {
        var t = function(e) {
            return [].slice.call(e);
        }, n = 0, r = 1, i = 2, a = 3, o = [], s = null, c = "requestAnimationFrame" in e ? function() {
            var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                sync: !1
            };
            e.cancelAnimationFrame(s);
            var n = function() {
                return u(o.filter(function(e) {
                    return e.dirty && e.active;
                }));
            };
            if (t.sync) return n();
            s = e.requestAnimationFrame(n);
        } : function() {}, l = function(e) {
            return function(t) {
                o.forEach(function(t) {
                    return t.dirty = e;
                }), c(t);
            };
        }, u = function(e) {
            e.filter(function(e) {
                return !e.styleComputed;
            }).forEach(function(e) {
                e.styleComputed = m(e);
            }), e.filter(h).forEach(g);
            var t = e.filter(p);
            t.forEach(f), t.forEach(function(e) {
                g(e), d(e);
            }), t.forEach(_);
        }, d = function(e) {
            return e.dirty = n;
        }, f = function(e) {
            e.availableWidth = e.element.parentNode.clientWidth, e.currentWidth = e.element.scrollWidth, e.previousFontSize = e.currentFontSize, e.currentFontSize = Math.min(Math.max(e.minSize, e.availableWidth / e.currentWidth * e.previousFontSize), e.maxSize), e.whiteSpace = e.multiLine && e.currentFontSize === e.minSize ? "normal" : "nowrap";
        }, p = function(e) {
            return e.dirty !== i || e.dirty === i && e.element.parentNode.clientWidth !== e.availableWidth;
        }, m = function(t) {
            var n = e.getComputedStyle(t.element, null);
            return t.currentFontSize = parseFloat(n.getPropertyValue("font-size")), t.display = n.getPropertyValue("display"), t.whiteSpace = n.getPropertyValue("white-space"), !0;
        }, h = function(e) {
            var t = !1;
            return !e.preStyleTestCompleted && (/inline-/.test(e.display) || (t = !0, e.display = "inline-block"), e.whiteSpace !== "nowrap" && (t = !0, e.whiteSpace = "nowrap"), e.preStyleTestCompleted = !0, t);
        }, g = function(e) {
            e.element.style.whiteSpace = e.whiteSpace, e.element.style.display = e.display, e.element.style.fontSize = e.currentFontSize + "px";
        }, _ = function(e) {
            e.element.dispatchEvent(new CustomEvent("fit", {
                detail: {
                    oldValue: e.previousFontSize,
                    newValue: e.currentFontSize,
                    scaleFactor: e.currentFontSize / e.previousFontSize
                }
            }));
        }, v = function(e, t) {
            return function(n) {
                e.dirty = t, e.active && c(n);
            };
        }, y = function(e) {
            return function() {
                o = o.filter(function(t) {
                    return t.element !== e.element;
                }), e.observeMutations && e.observer.disconnect(), e.element.style.whiteSpace = e.originalStyle.whiteSpace, e.element.style.display = e.originalStyle.display, e.element.style.fontSize = e.originalStyle.fontSize;
            };
        }, b = function(e) {
            return function() {
                e.active || (e.active = !0, c());
            };
        }, x = function(e) {
            return function() {
                return e.active = !1;
            };
        }, S = function(e) {
            e.observeMutations && (e.observer = new MutationObserver(v(e, r)), e.observer.observe(e.element, e.observeMutations));
        }, ee = {
            minSize: 16,
            maxSize: 512,
            multiLine: !0,
            observeMutations: "MutationObserver" in e && {
                subtree: !0,
                childList: !0,
                characterData: !0
            }
        }, C = null, w = function() {
            e.clearTimeout(C), C = e.setTimeout(l(i), E.observeWindowDelay);
        }, te = [
            "resize",
            "orientationchange"
        ];
        return Object.defineProperty(E, "observeWindow", {
            set: function(t) {
                var n = `${t ? "add" : "remove"}EventListener`;
                te.forEach(function(t) {
                    e[n](t, w);
                });
            }
        }), E.observeWindow = !0, E.observeWindowDelay = 100, E.fitAll = l(a), E;
    }
    function T(e, t) {
        var n = Object.assign({}, ee, t), r = e.map(function(e) {
            var t = Object.assign({}, n, {
                element: e,
                active: !0
            });
            return function(e) {
                e.originalStyle = {
                    whiteSpace: e.element.style.whiteSpace,
                    display: e.element.style.display,
                    fontSize: e.element.style.fontSize
                }, S(e), e.newbie = !0, e.dirty = !0, o.push(e);
            }(t), {
                element: e,
                fit: v(t, a),
                unfreeze: b(t),
                freeze: x(t),
                unsubscribe: y(t)
            };
        });
        return c(), r;
    }
    function E(e) {
        var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return typeof e == "string" ? T(t(document.querySelectorAll(e)), n) : T([
            e
        ], n)[0];
    }
}(typeof window > "u" ? null : window);
//#endregion
//#region \0@oxc-project+runtime@0.124.0/helpers/typeof.js
function $4afc1a8f9e4d93e8$var$y(e) {
    "@babel/helpers - typeof";
    return $4afc1a8f9e4d93e8$var$y = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
        return typeof e;
    } : function(e) {
        return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, $4afc1a8f9e4d93e8$var$y(e);
}
//#endregion
//#region \0@oxc-project+runtime@0.124.0/helpers/toPrimitive.js
function $4afc1a8f9e4d93e8$var$b(e, t) {
    if ($4afc1a8f9e4d93e8$var$y(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
        var r = n.call(e, t || "default");
        if ($4afc1a8f9e4d93e8$var$y(r) != "object") return r;
        throw TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
}
//#endregion
//#region \0@oxc-project+runtime@0.124.0/helpers/toPropertyKey.js
function $4afc1a8f9e4d93e8$var$x(e) {
    var t = $4afc1a8f9e4d93e8$var$b(e, "string");
    return $4afc1a8f9e4d93e8$var$y(t) == "symbol" ? t : t + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.124.0/helpers/defineProperty.js
function $4afc1a8f9e4d93e8$var$S(e, t, n) {
    return (t = $4afc1a8f9e4d93e8$var$x(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
//#endregion
//#region js/controllers/slidecontent.js
var $4afc1a8f9e4d93e8$var$ee = class {
    constructor(e){
        $4afc1a8f9e4d93e8$var$S(this, "allowedToPlayAudio", null), this.Reveal = e, this.startEmbeddedMedia = this.startEmbeddedMedia.bind(this), this.startEmbeddedIframe = this.startEmbeddedIframe.bind(this), this.preventIframeAutoFocus = this.preventIframeAutoFocus.bind(this), this.ensureMobileMediaPlaying = this.ensureMobileMediaPlaying.bind(this), this.failedAudioPlaybackTargets = /* @__PURE__ */ new Set(), this.failedVideoPlaybackTargets = /* @__PURE__ */ new Set(), this.failedMutedVideoPlaybackTargets = /* @__PURE__ */ new Set(), this.renderMediaPlayButton();
    }
    renderMediaPlayButton() {
        this.mediaPlayButton = document.createElement("button"), this.mediaPlayButton.className = "r-overlay-button r-media-play-button", this.mediaPlayButton.addEventListener("click", ()=>{
            this.resetTemporarilyMutedMedia(), new Set([
                ...this.failedAudioPlaybackTargets,
                ...this.failedVideoPlaybackTargets,
                ...this.failedMutedVideoPlaybackTargets
            ]).forEach((e)=>{
                this.startEmbeddedMedia({
                    target: e
                });
            }), this.clearMediaPlaybackErrors();
        });
    }
    shouldPreload(e) {
        if (this.Reveal.isScrollView()) return !0;
        let t = this.Reveal.getConfig().preloadIframes;
        return typeof t != "boolean" && (t = e.hasAttribute("data-preload")), t;
    }
    load(e, n = {}) {
        let r = this.Reveal.getConfig().display;
        if (r.includes("!important")) {
            let t = r.replace(/\s*!important\s*$/, "").trim();
            e.style.setProperty("display", t, "important");
        } else e.style.display = r;
        $4afc1a8f9e4d93e8$var$t(e, "img[data-src], video[data-src], audio[data-src], iframe[data-src]").forEach((e)=>{
            let t = e.tagName === "IFRAME";
            (!t || this.shouldPreload(e)) && (e.setAttribute("src", e.getAttribute("data-src")), e.setAttribute("data-lazy-loaded", ""), e.removeAttribute("data-src"), t && e.addEventListener("load", this.preventIframeAutoFocus));
        }), $4afc1a8f9e4d93e8$var$t(e, "video, audio").forEach((e)=>{
            let n = 0;
            $4afc1a8f9e4d93e8$var$t(e, "source[data-src]").forEach((e)=>{
                e.setAttribute("src", e.getAttribute("data-src")), e.removeAttribute("data-src"), e.setAttribute("data-lazy-loaded", ""), n += 1;
            }), $4afc1a8f9e4d93e8$var$g && e.tagName === "VIDEO" && e.setAttribute("playsinline", ""), n > 0 && e.load();
        });
        let i = e.slideBackgroundElement;
        if (i) {
            i.style.display = "block";
            let t = e.slideBackgroundContentElement, r = e.getAttribute("data-background-iframe");
            if (i.hasAttribute("data-loaded") === !1) {
                i.setAttribute("data-loaded", "true");
                let a = e.getAttribute("data-background-image"), o = e.getAttribute("data-background-video"), s = e.hasAttribute("data-background-video-loop"), c = e.hasAttribute("data-background-video-muted");
                if (a) /^data:/.test(a.trim()) ? t.style.backgroundImage = `url(${a.trim()})` : t.style.backgroundImage = a.split(",").map((e)=>`url(${$4afc1a8f9e4d93e8$var$m(decodeURI(e.trim()))})`).join(",");
                else if (o) {
                    let e = document.createElement("video");
                    s && e.setAttribute("loop", ""), (c || this.Reveal.isSpeakerNotes()) && (e.muted = !0), $4afc1a8f9e4d93e8$var$g && e.setAttribute("playsinline", ""), o.split(",").forEach((t)=>{
                        let n = document.createElement("source");
                        n.setAttribute("src", t);
                        let r = $4afc1a8f9e4d93e8$var$p(t);
                        r && n.setAttribute("type", r), e.appendChild(n);
                    }), t.appendChild(e);
                } else if (r && n.excludeIframes !== !0) {
                    let e = document.createElement("iframe");
                    e.setAttribute("allowfullscreen", ""), e.setAttribute("mozallowfullscreen", ""), e.setAttribute("webkitallowfullscreen", ""), e.setAttribute("allow", "autoplay"), e.setAttribute("data-src", r), e.style.width = "100%", e.style.height = "100%", e.style.maxHeight = "100%", e.style.maxWidth = "100%", t.appendChild(e);
                }
            }
            let a = t.querySelector("iframe[data-src]");
            a && this.shouldPreload(i) && !/autoplay=(1|true|yes)/gi.test(r) && a.getAttribute("src") !== r && a.setAttribute("src", r);
        }
        this.layout(e);
    }
    layout(e) {
        Array.from(e.querySelectorAll(".r-fit-text")).forEach((e)=>{
            $4afc1a8f9e4d93e8$var$v(e, {
                minSize: 24,
                maxSize: this.Reveal.getConfig().height * .8,
                observeMutations: !1,
                observeWindow: !1
            });
        });
    }
    unload(e) {
        e.style.display = "none";
        let n = this.Reveal.getSlideBackground(e);
        n && (n.style.display = "none", $4afc1a8f9e4d93e8$var$t(n, "iframe[src]").forEach((e)=>{
            e.removeAttribute("src");
        })), $4afc1a8f9e4d93e8$var$t(e, "video[data-lazy-loaded][src], audio[data-lazy-loaded][src], iframe[data-lazy-loaded][src]").forEach((e)=>{
            e.setAttribute("data-src", e.getAttribute("src")), e.removeAttribute("src");
        }), $4afc1a8f9e4d93e8$var$t(e, "video[data-lazy-loaded] source[src], audio source[src]").forEach((e)=>{
            e.setAttribute("data-src", e.getAttribute("src")), e.removeAttribute("src");
        });
    }
    formatEmbeddedContent() {
        let e = (e, n, r)=>{
            $4afc1a8f9e4d93e8$var$t(this.Reveal.getSlidesElement(), "iframe[" + e + "*=\"" + n + "\"]").forEach((t)=>{
                let n = t.getAttribute(e);
                n && n.indexOf(r) === -1 && t.setAttribute(e, n + (/\?/.test(n) ? "&" : "?") + r);
            });
        };
        e("src", "youtube.com/embed/", "enablejsapi=1"), e("data-src", "youtube.com/embed/", "enablejsapi=1"), e("src", "player.vimeo.com/", "api=1"), e("data-src", "player.vimeo.com/", "api=1");
    }
    startEmbeddedContent(e) {
        if (e) {
            let n = this.Reveal.isSpeakerNotes();
            $4afc1a8f9e4d93e8$var$t(e, "img[src$=\".gif\"]").forEach((e)=>{
                e.setAttribute("src", e.getAttribute("src"));
            }), $4afc1a8f9e4d93e8$var$t(e, "video, audio").forEach((e)=>{
                if ($4afc1a8f9e4d93e8$var$o(e, ".fragment") && !$4afc1a8f9e4d93e8$var$o(e, ".fragment.visible")) return;
                let t = this.Reveal.getConfig().autoPlayMedia;
                if (typeof t != "boolean" && (t = e.hasAttribute("data-autoplay") || !!$4afc1a8f9e4d93e8$var$o(e, ".slide-background")), t && typeof e.play == "function") {
                    if (n && !e.muted) return;
                    e.readyState > 1 ? this.startEmbeddedMedia({
                        target: e
                    }) : $4afc1a8f9e4d93e8$var$g ? (e.addEventListener("canplay", this.ensureMobileMediaPlaying), this.playMediaElement(e)) : (e.removeEventListener("loadeddata", this.startEmbeddedMedia), e.addEventListener("loadeddata", this.startEmbeddedMedia));
                }
            }), n || ($4afc1a8f9e4d93e8$var$t(e, "iframe[src]").forEach((e)=>{
                $4afc1a8f9e4d93e8$var$o(e, ".fragment") && !$4afc1a8f9e4d93e8$var$o(e, ".fragment.visible") || this.startEmbeddedIframe({
                    target: e
                });
            }), $4afc1a8f9e4d93e8$var$t(e, "iframe[data-src]").forEach((e)=>{
                $4afc1a8f9e4d93e8$var$o(e, ".fragment") && !$4afc1a8f9e4d93e8$var$o(e, ".fragment.visible") || e.getAttribute("src") !== e.getAttribute("data-src") && (e.removeEventListener("load", this.startEmbeddedIframe), e.addEventListener("load", this.startEmbeddedIframe), e.setAttribute("src", e.getAttribute("data-src")));
            }));
        }
    }
    ensureMobileMediaPlaying(e) {
        let t = e.target;
        typeof t.getVideoPlaybackQuality == "function" && setTimeout(()=>{
            let e = t.paused === !1, n = t.getVideoPlaybackQuality().totalVideoFrames;
            e && n === 0 && (t.load(), t.play());
        }, 1e3);
    }
    startEmbeddedMedia(e) {
        let t = !!$4afc1a8f9e4d93e8$var$o(e.target, "html"), n = !!$4afc1a8f9e4d93e8$var$o(e.target, ".present");
        t && n && (e.target.paused || e.target.ended) && (e.target.currentTime = 0, this.playMediaElement(e.target)), e.target.removeEventListener("loadeddata", this.startEmbeddedMedia);
    }
    playMediaElement(e) {
        let t = e.play();
        t && typeof t.catch == "function" && t.then(()=>{
            e.muted || (this.allowedToPlayAudio = !0);
        }).catch((t)=>{
            if (t.name === "NotAllowedError") {
                if (this.allowedToPlayAudio = !1, e.tagName === "VIDEO") {
                    this.onVideoPlaybackNotAllowed(e);
                    let t = !!$4afc1a8f9e4d93e8$var$o(e, "html"), n = !!$4afc1a8f9e4d93e8$var$o(e, ".present"), r = e.muted;
                    t && n && !r && (e.setAttribute("data-muted-by-reveal", "true"), e.muted = !0, e.play().catch(()=>{
                        this.onMutedVideoPlaybackNotAllowed(e);
                    }));
                } else e.tagName === "AUDIO" && this.onAudioPlaybackNotAllowed(e);
            }
        });
    }
    startEmbeddedIframe(e) {
        let t = e.target;
        if (this.preventIframeAutoFocus(e), t && t.contentWindow) {
            let n = !!$4afc1a8f9e4d93e8$var$o(e.target, "html"), r = !!$4afc1a8f9e4d93e8$var$o(e.target, ".present");
            if (n && r) {
                let e = this.Reveal.getConfig().autoPlayMedia;
                typeof e != "boolean" && (e = t.hasAttribute("data-autoplay") || !!$4afc1a8f9e4d93e8$var$o(t, ".slide-background")), /youtube\.com\/embed\//.test(t.getAttribute("src")) && e ? t.contentWindow.postMessage("{\"event\":\"command\",\"func\":\"playVideo\",\"args\":\"\"}", "*") : /player\.vimeo\.com\//.test(t.getAttribute("src")) && e ? t.contentWindow.postMessage("{\"method\":\"play\"}", "*") : t.contentWindow.postMessage("slide:start", "*");
            }
        }
    }
    stopEmbeddedContent(n, r = {}) {
        r = $4afc1a8f9e4d93e8$var$e({
            unloadIframes: !0
        }, r), n && n.parentNode && ($4afc1a8f9e4d93e8$var$t(n, "video, audio").forEach((e)=>{
            !e.hasAttribute("data-ignore") && typeof e.pause == "function" && (e.setAttribute("data-paused-by-reveal", ""), e.pause(), $4afc1a8f9e4d93e8$var$g && e.removeEventListener("canplay", this.ensureMobileMediaPlaying));
        }), $4afc1a8f9e4d93e8$var$t(n, "iframe").forEach((e)=>{
            e.contentWindow && e.contentWindow.postMessage("slide:stop", "*"), e.removeEventListener("load", this.preventIframeAutoFocus), e.removeEventListener("load", this.startEmbeddedIframe);
        }), $4afc1a8f9e4d93e8$var$t(n, "iframe[src*=\"youtube.com/embed/\"]").forEach((e)=>{
            !e.hasAttribute("data-ignore") && e.contentWindow && typeof e.contentWindow.postMessage == "function" && e.contentWindow.postMessage("{\"event\":\"command\",\"func\":\"pauseVideo\",\"args\":\"\"}", "*");
        }), $4afc1a8f9e4d93e8$var$t(n, "iframe[src*=\"player.vimeo.com/\"]").forEach((e)=>{
            !e.hasAttribute("data-ignore") && e.contentWindow && typeof e.contentWindow.postMessage == "function" && e.contentWindow.postMessage("{\"method\":\"pause\"}", "*");
        }), r.unloadIframes === !0 && $4afc1a8f9e4d93e8$var$t(n, "iframe[data-src]").forEach((e)=>{
            e.setAttribute("src", "about:blank"), e.removeAttribute("src");
        }));
    }
    isAllowedToPlayAudio() {
        return this.allowedToPlayAudio;
    }
    showPlayOrUnmuteButton() {
        let e = this.failedAudioPlaybackTargets.size, t = this.failedVideoPlaybackTargets.size, n = this.failedMutedVideoPlaybackTargets.size, r = "Play media";
        n > 0 ? r = "Play video" : t > 0 ? r = "Unmute video" : e > 0 && (r = "Play audio"), this.mediaPlayButton.textContent = r, this.Reveal.getRevealElement().appendChild(this.mediaPlayButton);
    }
    onAudioPlaybackNotAllowed(e) {
        this.failedAudioPlaybackTargets.add(e), this.showPlayOrUnmuteButton(e);
    }
    onVideoPlaybackNotAllowed(e) {
        this.failedVideoPlaybackTargets.add(e), this.showPlayOrUnmuteButton();
    }
    onMutedVideoPlaybackNotAllowed(e) {
        this.failedMutedVideoPlaybackTargets.add(e), this.showPlayOrUnmuteButton();
    }
    resetTemporarilyMutedMedia() {
        new Set([
            ...this.failedAudioPlaybackTargets,
            ...this.failedVideoPlaybackTargets,
            ...this.failedMutedVideoPlaybackTargets
        ]).forEach((e)=>{
            e.hasAttribute("data-muted-by-reveal") && (e.muted = !1, e.removeAttribute("data-muted-by-reveal"));
        });
    }
    clearMediaPlaybackErrors() {
        this.resetTemporarilyMutedMedia(), this.failedAudioPlaybackTargets.clear(), this.failedVideoPlaybackTargets.clear(), this.failedMutedVideoPlaybackTargets.clear(), this.mediaPlayButton && this.mediaPlayButton.parentNode && this.mediaPlayButton.remove();
    }
    preventIframeAutoFocus(e) {
        let t = e.target;
        if (t && this.Reveal.getConfig().preventIframeAutoFocus) {
            let e = 0, n = ()=>{
                document.activeElement === t ? document.activeElement.blur() : e < 1e3 && (e += 100, setTimeout(n, 100));
            };
            setTimeout(n, 100);
        }
    }
    afterSlideChanged() {
        this.clearMediaPlaybackErrors();
    }
}, $4afc1a8f9e4d93e8$var$C = ".slides section", $4afc1a8f9e4d93e8$var$w = ".slides>section", $4afc1a8f9e4d93e8$var$te = ".slides>section.present>section", $4afc1a8f9e4d93e8$var$T = ".backgrounds>.slide-background", $4afc1a8f9e4d93e8$var$E = /registerPlugin|registerKeyboardShortcut|addKeyBinding|addEventListener|showPreview|previewIframe/, $4afc1a8f9e4d93e8$var$ne = class {
    constructor(e){
        this.Reveal = e;
    }
    render() {
        this.element = document.createElement("div"), this.element.className = "slide-number", this.Reveal.getRevealElement().appendChild(this.element);
    }
    configure(e, t) {
        let n = "none";
        e.slideNumber && !this.Reveal.isPrintView() && (e.showSlideNumber === "all" || e.showSlideNumber === "speaker" && this.Reveal.isSpeakerNotes()) && (n = "block"), this.element.style.display = n;
    }
    update() {
        this.Reveal.getConfig().slideNumber && this.element && (this.element.innerHTML = this.getSlideNumber());
    }
    getSlideNumber(e = this.Reveal.getCurrentSlide()) {
        let t = this.Reveal.getConfig(), n, r = "h.v";
        if (typeof t.slideNumber == "function") n = t.slideNumber(e);
        else {
            typeof t.slideNumber == "string" && (r = t.slideNumber), !/c/.test(r) && this.Reveal.getHorizontalSlides().length === 1 && (r = "c");
            let i = e && e.dataset.visibility === "uncounted" ? 0 : 1;
            switch(n = [], r){
                case "c":
                    n.push(this.Reveal.getSlidePastCount(e) + i);
                    break;
                case "c/t":
                    n.push(this.Reveal.getSlidePastCount(e) + i, "/", this.Reveal.getTotalSlides());
                    break;
                default:
                    let t1 = this.Reveal.getIndices(e);
                    n.push(t1.h + i);
                    let a = r === "h/v" ? "/" : ".";
                    this.Reveal.isVerticalSlide(e) && n.push(a, t1.v + 1);
            }
        }
        let i = "#" + this.Reveal.location.getHash(e);
        return this.formatNumber(n[0], n[1], n[2], i);
    }
    formatNumber(e, t, n, r = "#" + this.Reveal.location.getHash()) {
        return typeof n == "number" && !isNaN(n) ? `<a href="${r}">
					<span class="slide-number-a">${e}</span>
					<span class="slide-number-delimiter">${t}</span>
					<span class="slide-number-b">${n}</span>
					</a>` : `<a href="${r}">
					<span class="slide-number-a">${e}</span>
					</a>`;
    }
    destroy() {
        this.element.remove();
    }
}, $4afc1a8f9e4d93e8$var$re = class {
    constructor(e){
        this.Reveal = e, this.onInput = this.onInput.bind(this), this.onBlur = this.onBlur.bind(this), this.onKeyDown = this.onKeyDown.bind(this);
    }
    render() {
        this.element = document.createElement("div"), this.element.className = "jump-to-slide", this.jumpInput = document.createElement("input"), this.jumpInput.type = "text", this.jumpInput.className = "jump-to-slide-input", this.jumpInput.placeholder = "Jump to slide", this.jumpInput.addEventListener("input", this.onInput), this.jumpInput.addEventListener("keydown", this.onKeyDown), this.jumpInput.addEventListener("blur", this.onBlur), this.element.appendChild(this.jumpInput);
    }
    show() {
        this.indicesOnShow = this.Reveal.getIndices(), this.Reveal.getRevealElement().appendChild(this.element), this.jumpInput.focus();
    }
    hide() {
        this.isVisible() && (this.element.remove(), this.jumpInput.value = "", clearTimeout(this.jumpTimeout), delete this.jumpTimeout);
    }
    isVisible() {
        return !!this.element.parentNode;
    }
    jump() {
        clearTimeout(this.jumpTimeout), delete this.jumpTimeout;
        let e = this.jumpInput.value.trim(""), t;
        if (/^\d+$/.test(e)) {
            let n = this.Reveal.getConfig().slideNumber;
            if (n === "c" || n === "c/t") {
                let n = this.Reveal.getSlides()[parseInt(e, 10) - 1];
                n && (t = this.Reveal.getIndices(n));
            }
        }
        return t || (/^\d+\.\d+$/.test(e) && (e = e.replace(".", "/")), t = this.Reveal.location.getIndicesFromHash(e, {
            oneBasedIndex: !0
        })), !t && /\S+/i.test(e) && e.length > 1 && (t = this.search(e)), t && e !== "" ? (this.Reveal.slide(t.h, t.v, t.f), !0) : (this.Reveal.slide(this.indicesOnShow.h, this.indicesOnShow.v, this.indicesOnShow.f), !1);
    }
    jumpAfter(e) {
        clearTimeout(this.jumpTimeout), this.jumpTimeout = setTimeout(()=>this.jump(), e);
    }
    search(e) {
        let t = RegExp("\\b" + e.trim() + "\\b", "i"), n = this.Reveal.getSlides().find((e)=>t.test(e.innerText));
        return n ? this.Reveal.getIndices(n) : null;
    }
    cancel() {
        this.Reveal.slide(this.indicesOnShow.h, this.indicesOnShow.v, this.indicesOnShow.f), this.hide();
    }
    confirm() {
        this.jump(), this.hide();
    }
    destroy() {
        this.jumpInput.removeEventListener("input", this.onInput), this.jumpInput.removeEventListener("keydown", this.onKeyDown), this.jumpInput.removeEventListener("blur", this.onBlur), this.element.remove();
    }
    onKeyDown(e) {
        e.keyCode === 13 ? this.confirm() : e.keyCode === 27 && (this.cancel(), e.stopImmediatePropagation());
    }
    onInput(e) {
        this.jumpAfter(200);
    }
    onBlur() {
        setTimeout(()=>this.hide(), 1);
    }
}, $4afc1a8f9e4d93e8$var$D = (e)=>{
    let t = e.match(/^#([0-9a-f]{3})$/i);
    if (t && t[1]) {
        let e = t[1];
        return {
            r: parseInt(e.charAt(0), 16) * 17,
            g: parseInt(e.charAt(1), 16) * 17,
            b: parseInt(e.charAt(2), 16) * 17
        };
    }
    let n = e.match(/^#([0-9a-f]{6})$/i);
    if (n && n[1]) {
        let e = n[1];
        return {
            r: parseInt(e.slice(0, 2), 16),
            g: parseInt(e.slice(2, 4), 16),
            b: parseInt(e.slice(4, 6), 16)
        };
    }
    let r = e.match(/^rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/i);
    if (r) return {
        r: parseInt(r[1], 10),
        g: parseInt(r[2], 10),
        b: parseInt(r[3], 10)
    };
    let i = e.match(/^rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d]+|[\d]*.[\d]+)\s*\)$/i);
    return i ? {
        r: parseInt(i[1], 10),
        g: parseInt(i[2], 10),
        b: parseInt(i[3], 10),
        a: parseFloat(i[4])
    } : null;
}, $4afc1a8f9e4d93e8$var$ie = (e)=>(typeof e == "string" && (e = $4afc1a8f9e4d93e8$var$D(e)), e ? (e.r * 299 + e.g * 587 + e.b * 114) / 1e3 : null), $4afc1a8f9e4d93e8$var$ae = class {
    constructor(e){
        this.Reveal = e;
    }
    render() {
        this.element = document.createElement("div"), this.element.className = "backgrounds", this.Reveal.getRevealElement().appendChild(this.element);
    }
    create() {
        this.element.innerHTML = "", this.element.classList.add("no-transition"), this.Reveal.getHorizontalSlides().forEach((e)=>{
            let n = this.createBackground(e, this.element);
            $4afc1a8f9e4d93e8$var$t(e, "section").forEach((e)=>{
                this.createBackground(e, n), n.classList.add("stack");
            });
        }), this.Reveal.getConfig().parallaxBackgroundImage ? (this.element.style.backgroundImage = "url(\"" + this.Reveal.getConfig().parallaxBackgroundImage + "\")", this.element.style.backgroundSize = this.Reveal.getConfig().parallaxBackgroundSize, this.element.style.backgroundRepeat = this.Reveal.getConfig().parallaxBackgroundRepeat, this.element.style.backgroundPosition = this.Reveal.getConfig().parallaxBackgroundPosition, setTimeout(()=>{
            this.Reveal.getRevealElement().classList.add("has-parallax-background");
        }, 1)) : (this.element.style.backgroundImage = "", this.Reveal.getRevealElement().classList.remove("has-parallax-background"));
    }
    createBackground(e, t) {
        let n = document.createElement("div");
        n.className = "slide-background " + e.className.replace(/present|past|future/, "");
        let r = document.createElement("div");
        return r.className = "slide-background-content", n.appendChild(r), t.appendChild(n), e.slideBackgroundElement = n, e.slideBackgroundContentElement = r, this.sync(e), n;
    }
    sync(e) {
        let t = e.slideBackgroundElement, n = e.slideBackgroundContentElement, r = {
            background: e.getAttribute("data-background"),
            backgroundSize: e.getAttribute("data-background-size"),
            backgroundImage: e.getAttribute("data-background-image"),
            backgroundVideo: e.getAttribute("data-background-video"),
            backgroundIframe: e.getAttribute("data-background-iframe"),
            backgroundColor: e.getAttribute("data-background-color"),
            backgroundGradient: e.getAttribute("data-background-gradient"),
            backgroundRepeat: e.getAttribute("data-background-repeat"),
            backgroundPosition: e.getAttribute("data-background-position"),
            backgroundTransition: e.getAttribute("data-background-transition"),
            backgroundOpacity: e.getAttribute("data-background-opacity")
        }, i = e.hasAttribute("data-preload");
        e.classList.remove("has-dark-background"), e.classList.remove("has-light-background"), t.removeAttribute("data-loaded"), t.removeAttribute("data-background-hash"), t.removeAttribute("data-background-size"), t.removeAttribute("data-background-transition"), t.style.backgroundColor = "", n.style.backgroundSize = "", n.style.backgroundRepeat = "", n.style.backgroundPosition = "", n.style.backgroundImage = "", n.style.opacity = "", n.innerHTML = "", r.background && (/^(http|file|\/\/)/gi.test(r.background) || /\.(svg|png|jpg|jpeg|gif|bmp|webp)([?#\s]|$)/gi.test(r.background) ? e.setAttribute("data-background-image", r.background) : t.style.background = r.background), (r.background || r.backgroundColor || r.backgroundGradient || r.backgroundImage || r.backgroundVideo || r.backgroundIframe) && t.setAttribute("data-background-hash", r.background + r.backgroundSize + r.backgroundImage + r.backgroundVideo + r.backgroundIframe + r.backgroundColor + r.backgroundGradient + r.backgroundRepeat + r.backgroundPosition + r.backgroundTransition + r.backgroundOpacity), r.backgroundSize && t.setAttribute("data-background-size", r.backgroundSize), r.backgroundColor && (t.style.backgroundColor = r.backgroundColor), r.backgroundGradient && (t.style.backgroundImage = r.backgroundGradient), r.backgroundTransition && t.setAttribute("data-background-transition", r.backgroundTransition), i && t.setAttribute("data-preload", ""), r.backgroundSize && (n.style.backgroundSize = r.backgroundSize), r.backgroundRepeat && (n.style.backgroundRepeat = r.backgroundRepeat), r.backgroundPosition && (n.style.backgroundPosition = r.backgroundPosition), r.backgroundOpacity && (n.style.opacity = r.backgroundOpacity);
        let a = this.getContrastClass(e);
        typeof a == "string" && e.classList.add(a);
    }
    getContrastClass(e) {
        let t = e.slideBackgroundElement, n = e.getAttribute("data-background-color");
        if (!n || !$4afc1a8f9e4d93e8$var$D(n)) {
            let e = window.getComputedStyle(t);
            e && e.backgroundColor && (n = e.backgroundColor);
        }
        if (n) {
            let e = $4afc1a8f9e4d93e8$var$D(n);
            if (e && e.a !== 0) return $4afc1a8f9e4d93e8$var$ie(n) < 128 ? "has-dark-background" : "has-light-background";
        }
        return null;
    }
    bubbleSlideContrastClassToElement(e, t) {
        [
            "has-light-background",
            "has-dark-background"
        ].forEach((n)=>{
            e.classList.contains(n) ? t.classList.add(n) : t.classList.remove(n);
        }, this);
    }
    update(e = !1) {
        let n = this.Reveal.getConfig(), r = this.Reveal.getCurrentSlide(), i = this.Reveal.getIndices(), a = null, o = n.rtl ? "future" : "past", s = n.rtl ? "past" : "future";
        if (Array.from(this.element.childNodes).forEach((n, r)=>{
            n.classList.remove("past", "present", "future"), r < i.h ? n.classList.add(o) : r > i.h ? n.classList.add(s) : (n.classList.add("present"), a = n), (e || r === i.h) && $4afc1a8f9e4d93e8$var$t(n, ".slide-background").forEach((e, t)=>{
                e.classList.remove("past", "present", "future");
                let n = typeof i.v == "number" ? i.v : 0;
                t < n ? e.classList.add("past") : t > n ? e.classList.add("future") : (e.classList.add("present"), r === i.h && (a = e));
            });
        }), this.previousBackground && !this.previousBackground.closest("body") && (this.previousBackground = null), a && this.previousBackground) {
            let e = this.previousBackground.getAttribute("data-background-hash"), t = a.getAttribute("data-background-hash");
            if (t && t === e && a !== this.previousBackground) {
                this.element.classList.add("no-transition");
                let e = a.querySelector("video"), t = this.previousBackground.querySelector("video");
                if (e && t) {
                    let n = e.parentNode;
                    t.parentNode.appendChild(e), n.appendChild(t);
                }
            }
        }
        let c = a !== this.previousBackground;
        if (c && this.previousBackground && this.Reveal.slideContent.stopEmbeddedContent(this.previousBackground, {
            unloadIframes: !this.Reveal.slideContent.shouldPreload(this.previousBackground)
        }), c && a) {
            this.Reveal.slideContent.startEmbeddedContent(a);
            let e = a.querySelector(".slide-background-content");
            if (e) {
                let t = e.style.backgroundImage || "";
                /\.gif/i.test(t) && (e.style.backgroundImage = "", window.getComputedStyle(e).opacity, e.style.backgroundImage = t);
            }
            this.previousBackground = a;
        }
        r && this.bubbleSlideContrastClassToElement(r, this.Reveal.getRevealElement()), setTimeout(()=>{
            this.element.classList.remove("no-transition");
        }, 10);
    }
    updateParallax() {
        let e = this.Reveal.getIndices();
        if (this.Reveal.getConfig().parallaxBackgroundImage) {
            let t = this.Reveal.getHorizontalSlides(), n = this.Reveal.getVerticalSlides(), r = this.element.style.backgroundSize.split(" "), i, a;
            r.length === 1 ? i = a = parseInt(r[0], 10) : (i = parseInt(r[0], 10), a = parseInt(r[1], 10));
            let o = this.element.offsetWidth, s = t.length, c, l;
            c = typeof this.Reveal.getConfig().parallaxBackgroundHorizontal == "number" ? this.Reveal.getConfig().parallaxBackgroundHorizontal : s > 1 ? (i - o) / (s - 1) : 0, l = c * e.h * -1;
            let u = this.element.offsetHeight, d = n.length, f, p;
            f = typeof this.Reveal.getConfig().parallaxBackgroundVertical == "number" ? this.Reveal.getConfig().parallaxBackgroundVertical : (a - u) / (d - 1), p = d > 0 ? f * e.v : 0, this.element.style.backgroundPosition = l + "px " + -p + "px";
        }
    }
    destroy() {
        this.element.remove();
    }
}, $4afc1a8f9e4d93e8$var$O = 0, $4afc1a8f9e4d93e8$var$oe = class {
    constructor(e){
        this.Reveal = e;
    }
    run(e, t) {
        this.reset();
        let n = this.Reveal.getSlides(), r = n.indexOf(t), i = n.indexOf(e);
        if (e && t && e.hasAttribute("data-auto-animate") && t.hasAttribute("data-auto-animate") && e.getAttribute("data-auto-animate-id") === t.getAttribute("data-auto-animate-id") && !(r > i ? t : e).hasAttribute("data-auto-animate-restart")) {
            this.autoAnimateStyleSheet = this.autoAnimateStyleSheet || $4afc1a8f9e4d93e8$var$l();
            let n = this.getAutoAnimateOptions(t);
            e.dataset.autoAnimate = "pending", t.dataset.autoAnimate = "pending", n.slideDirection = r > i ? "forward" : "backward";
            let a = e.style.display === "none";
            a && (e.style.display = this.Reveal.getConfig().display);
            let o = this.getAutoAnimatableElements(e, t).map((e)=>this.autoAnimateElements(e.from, e.to, e.options || {}, n, $4afc1a8f9e4d93e8$var$O++));
            if (a && (e.style.display = "none"), t.dataset.autoAnimateUnmatched !== "false" && this.Reveal.getConfig().autoAnimateUnmatched === !0) {
                let e = n.duration * .8, r = n.duration * .2;
                this.getUnmatchedAutoAnimateElements(t).forEach((e)=>{
                    let t = this.getAutoAnimateOptions(e, n), r = "unmatched";
                    (t.duration !== n.duration || t.delay !== n.delay) && (r = "unmatched-" + $4afc1a8f9e4d93e8$var$O++, o.push(`[data-auto-animate="running"] [data-auto-animate-target="${r}"] { transition: opacity ${t.duration}s ease ${t.delay}s; }`)), e.dataset.autoAnimateTarget = r;
                }, this), o.push(`[data-auto-animate="running"] [data-auto-animate-target="unmatched"] { transition: opacity ${e}s ease ${r}s; }`);
            }
            this.autoAnimateStyleSheet.innerHTML = o.join(""), requestAnimationFrame(()=>{
                this.autoAnimateStyleSheet && (getComputedStyle(this.autoAnimateStyleSheet).fontWeight, t.dataset.autoAnimate = "running");
            }), this.Reveal.dispatchEvent({
                type: "autoanimate",
                data: {
                    fromSlide: e,
                    toSlide: t,
                    sheet: this.autoAnimateStyleSheet
                }
            });
        }
    }
    reset() {
        $4afc1a8f9e4d93e8$var$t(this.Reveal.getRevealElement(), "[data-auto-animate]:not([data-auto-animate=\"\"])").forEach((e)=>{
            e.dataset.autoAnimate = "";
        }), $4afc1a8f9e4d93e8$var$t(this.Reveal.getRevealElement(), "[data-auto-animate-target]").forEach((e)=>{
            delete e.dataset.autoAnimateTarget;
        }), this.autoAnimateStyleSheet && this.autoAnimateStyleSheet.parentNode && (this.autoAnimateStyleSheet.parentNode.removeChild(this.autoAnimateStyleSheet), this.autoAnimateStyleSheet = null);
    }
    autoAnimateElements(e, t, n, r, i) {
        e.dataset.autoAnimateTarget = "", t.dataset.autoAnimateTarget = i;
        let a = this.getAutoAnimateOptions(t, r);
        n.delay !== void 0 && (a.delay = n.delay), n.duration !== void 0 && (a.duration = n.duration), n.easing !== void 0 && (a.easing = n.easing);
        let o = this.getAutoAnimatableProperties("from", e, n), s = this.getAutoAnimatableProperties("to", t, n);
        if (t.classList.contains("fragment") && delete s.styles.opacity, n.translate !== !1 || n.scale !== !1) {
            let e = this.Reveal.getScale(), t = {
                x: (o.x - s.x) / e,
                y: (o.y - s.y) / e,
                scaleX: o.width / s.width,
                scaleY: o.height / s.height
            };
            t.x = Math.round(t.x * 1e3) / 1e3, t.y = Math.round(t.y * 1e3) / 1e3, t.scaleX = Math.round(t.scaleX * 1e3) / 1e3, t.scaleX = Math.round(t.scaleX * 1e3) / 1e3;
            let r = n.translate !== !1 && (t.x !== 0 || t.y !== 0), i = n.scale !== !1 && (t.scaleX !== 0 || t.scaleY !== 0);
            if (r || i) {
                let e = [];
                r && e.push(`translate(${t.x}px, ${t.y}px)`), i && e.push(`scale(${t.scaleX}, ${t.scaleY})`), o.styles.transform = e.join(" "), o.styles["transform-origin"] = "top left", s.styles.transform = "none";
            }
        }
        for(let e in s.styles){
            let t = s.styles[e], n = o.styles[e];
            t === n ? delete s.styles[e] : (t.explicitValue === !0 && (s.styles[e] = t.value), n.explicitValue === !0 && (o.styles[e] = n.value));
        }
        let c = "", l = Object.keys(s.styles);
        if (l.length > 0) {
            o.styles.transition = "none", s.styles.transition = `all ${a.duration}s ${a.easing} ${a.delay}s`, s.styles["transition-property"] = l.join(", "), s.styles["will-change"] = l.join(", ");
            let e = Object.keys(o.styles).map((e)=>e + ": " + o.styles[e] + " !important;").join(""), t = Object.keys(s.styles).map((e)=>e + ": " + s.styles[e] + " !important;").join("");
            c = "[data-auto-animate-target=\"" + i + "\"] {" + e + "}[data-auto-animate=\"running\"] [data-auto-animate-target=\"" + i + "\"] {" + t + "}";
        }
        return c;
    }
    getAutoAnimateOptions(t, n) {
        let r = {
            easing: this.Reveal.getConfig().autoAnimateEasing,
            duration: this.Reveal.getConfig().autoAnimateDuration,
            delay: 0
        };
        if (r = $4afc1a8f9e4d93e8$var$e(r, n), t.parentNode) {
            let e = $4afc1a8f9e4d93e8$var$o(t.parentNode, "[data-auto-animate-target]");
            e && (r = this.getAutoAnimateOptions(e, r));
        }
        return t.dataset.autoAnimateEasing && (r.easing = t.dataset.autoAnimateEasing), t.dataset.autoAnimateDuration && (r.duration = parseFloat(t.dataset.autoAnimateDuration)), t.dataset.autoAnimateDelay && (r.delay = parseFloat(t.dataset.autoAnimateDelay)), r;
    }
    getAutoAnimatableProperties(e, t, n) {
        let r = this.Reveal.getConfig(), i = {
            styles: []
        };
        if (n.translate !== !1 || n.scale !== !1) {
            let e;
            if (typeof n.measure == "function") e = n.measure(t);
            else if (r.center) e = t.getBoundingClientRect();
            else {
                let n = this.Reveal.getScale();
                e = {
                    x: t.offsetLeft * n,
                    y: t.offsetTop * n,
                    width: t.offsetWidth * n,
                    height: t.offsetHeight * n
                };
            }
            i.x = e.x, i.y = e.y, i.width = e.width, i.height = e.height;
        }
        let a = getComputedStyle(t);
        return (n.styles || r.autoAnimateStyles).forEach((t)=>{
            let n;
            typeof t == "string" && (t = {
                property: t
            }), t.from !== void 0 && e === "from" ? n = {
                value: t.from,
                explicitValue: !0
            } : t.to !== void 0 && e === "to" ? n = {
                value: t.to,
                explicitValue: !0
            } : (t.property === "line-height" && (n = parseFloat(a["line-height"]) / parseFloat(a["font-size"])), isNaN(n) && (n = a[t.property])), n !== "" && (i.styles[t.property] = n);
        }), i;
    }
    getAutoAnimatableElements(e, t) {
        let n = (typeof this.Reveal.getConfig().autoAnimateMatcher == "function" ? this.Reveal.getConfig().autoAnimateMatcher : this.getAutoAnimatePairs).call(this, e, t), r = [];
        return n.filter((e, t)=>{
            if (r.indexOf(e.to) === -1) return r.push(e.to), !0;
        });
    }
    getAutoAnimatePairs(e, t) {
        let n = [], r = "h1, h2, h3, h4, h5, h6, p, li";
        return this.findAutoAnimateMatches(n, e, t, "[data-id]", (e)=>e.nodeName + ":::" + e.getAttribute("data-id")), this.findAutoAnimateMatches(n, e, t, r, (e)=>e.nodeName + ":::" + e.textContent.trim()), this.findAutoAnimateMatches(n, e, t, "img, video, iframe", (e)=>e.nodeName + ":::" + (e.getAttribute("src") || e.getAttribute("data-src"))), this.findAutoAnimateMatches(n, e, t, "pre", (e)=>e.nodeName + ":::" + e.textContent.trim()), n.forEach((e)=>{
            $4afc1a8f9e4d93e8$var$a(e.from, r) ? e.options = {
                scale: !1
            } : $4afc1a8f9e4d93e8$var$a(e.from, "pre") && (e.options = {
                scale: !1,
                styles: [
                    "width",
                    "height"
                ]
            }, this.findAutoAnimateMatches(n, e.from, e.to, ".hljs .hljs-ln-code", (e)=>e.textContent, {
                scale: !1,
                styles: [],
                measure: this.getLocalBoundingBox.bind(this)
            }), this.findAutoAnimateMatches(n, e.from, e.to, ".hljs .hljs-ln-numbers[data-line-number]", (e)=>e.getAttribute("data-line-number"), {
                scale: !1,
                styles: [
                    "width"
                ],
                measure: this.getLocalBoundingBox.bind(this)
            }));
        }, this), n;
    }
    getLocalBoundingBox(e) {
        let t = this.Reveal.getScale();
        return {
            x: Math.round(e.offsetLeft * t * 100) / 100,
            y: Math.round(e.offsetTop * t * 100) / 100,
            width: Math.round(e.offsetWidth * t * 100) / 100,
            height: Math.round(e.offsetHeight * t * 100) / 100
        };
    }
    findAutoAnimateMatches(e, t, n, r, i, a) {
        let o = {}, s = {};
        [].slice.call(t.querySelectorAll(r)).forEach((e, t)=>{
            let n = i(e);
            typeof n == "string" && n.length && (o[n] = o[n] || [], o[n].push(e));
        }), [].slice.call(n.querySelectorAll(r)).forEach((t, n)=>{
            let r = i(t);
            s[r] = s[r] || [], s[r].push(t);
            let c;
            if (o[r]) {
                let e = s[r].length - 1, t = o[r].length - 1;
                o[r][e] ? (c = o[r][e], o[r][e] = null) : o[r][t] && (c = o[r][t], o[r][t] = null);
            }
            c && e.push({
                from: c,
                to: t,
                options: a
            });
        });
    }
    getUnmatchedAutoAnimateElements(e) {
        return [].slice.call(e.children).reduce((e, t)=>{
            let n = t.querySelector("[data-auto-animate-target]");
            return !t.hasAttribute("data-auto-animate-target") && !n && e.push(t), t.querySelector("[data-auto-animate-target]") && (e = e.concat(this.getUnmatchedAutoAnimateElements(t))), e;
        }, []);
    }
}, $4afc1a8f9e4d93e8$var$k = 500, $4afc1a8f9e4d93e8$var$A = 4, $4afc1a8f9e4d93e8$var$se = 6, $4afc1a8f9e4d93e8$var$j = 8, $4afc1a8f9e4d93e8$var$ce = class {
    constructor(e){
        this.Reveal = e, this.active = !1, this.activatedCallbacks = [], this.onScroll = this.onScroll.bind(this);
    }
    activate() {
        if (this.active) return;
        let e = this.Reveal.getState();
        this.active = !0, this.slideHTMLBeforeActivation = this.Reveal.getSlidesElement().innerHTML;
        let n = $4afc1a8f9e4d93e8$var$t(this.Reveal.getRevealElement(), $4afc1a8f9e4d93e8$var$w), r = $4afc1a8f9e4d93e8$var$t(this.Reveal.getRevealElement(), $4afc1a8f9e4d93e8$var$T);
        this.viewportElement.classList.add("loading-scroll-mode", "reveal-scroll");
        let i, a = window.getComputedStyle(this.viewportElement);
        a && a.background && (i = a.background);
        let o = [], s = n[0].parentNode, c, l = (e, t, n, a)=>{
            let s;
            if (c && this.Reveal.shouldAutoAnimateBetween(c, e)) s = document.createElement("div"), s.className = "scroll-page-content scroll-auto-animate-page", s.style.display = "none", c.closest(".scroll-page-content").parentNode.appendChild(s);
            else {
                let e = document.createElement("div");
                if (e.className = "scroll-page", o.push(e), a && r.length > t) {
                    let n = r[t], a = window.getComputedStyle(n);
                    a && a.background ? e.style.background = a.background : i && (e.style.background = i);
                } else i && (e.style.background = i);
                let n = document.createElement("div");
                n.className = "scroll-page-sticky", e.appendChild(n), s = document.createElement("div"), s.className = "scroll-page-content", n.appendChild(s);
            }
            s.appendChild(e), e.classList.remove("past", "future"), e.setAttribute("data-index-h", t), e.setAttribute("data-index-v", n), e.slideBackgroundElement && (e.slideBackgroundElement.remove("past", "future"), s.insertBefore(e.slideBackgroundElement, e)), c = e;
        };
        n.forEach((e, t)=>{
            this.Reveal.isVerticalStack(e) ? e.querySelectorAll("section").forEach((e, n)=>{
                l(e, t, n, !0);
            }) : l(e, t, 0);
        }, this), this.createProgressBar(), $4afc1a8f9e4d93e8$var$t(this.Reveal.getRevealElement(), ".stack").forEach((e)=>e.remove()), o.forEach((e)=>s.appendChild(e)), this.Reveal.slideContent.layout(this.Reveal.getSlidesElement()), this.Reveal.layout(), this.Reveal.setState(e), this.activatedCallbacks.forEach((e)=>e()), this.activatedCallbacks = [], this.restoreScrollPosition(), this.viewportElement.classList.remove("loading-scroll-mode"), this.viewportElement.addEventListener("scroll", this.onScroll, {
            passive: !0
        });
    }
    deactivate() {
        if (!this.active) return;
        let e = this.Reveal.getState();
        this.active = !1, this.viewportElement.removeEventListener("scroll", this.onScroll), this.viewportElement.classList.remove("reveal-scroll"), this.removeProgressBar(), this.Reveal.getSlidesElement().innerHTML = this.slideHTMLBeforeActivation, this.Reveal.sync(), this.Reveal.setState(e), this.slideHTMLBeforeActivation = null;
    }
    toggle(e) {
        typeof e == "boolean" ? e ? this.activate() : this.deactivate() : this.isActive() ? this.deactivate() : this.activate();
    }
    isActive() {
        return this.active;
    }
    createProgressBar() {
        this.progressBar = document.createElement("div"), this.progressBar.className = "scrollbar", this.progressBarInner = document.createElement("div"), this.progressBarInner.className = "scrollbar-inner", this.progressBar.appendChild(this.progressBarInner), this.progressBarPlayhead = document.createElement("div"), this.progressBarPlayhead.className = "scrollbar-playhead", this.progressBarInner.appendChild(this.progressBarPlayhead), this.viewportElement.insertBefore(this.progressBar, this.viewportElement.firstChild);
        let e = (e)=>{
            let t = (e.clientY - this.progressBarInner.getBoundingClientRect().top) / this.progressBarHeight;
            t = Math.max(Math.min(t, 1), 0), this.viewportElement.scrollTop = t * (this.viewportElement.scrollHeight - this.viewportElement.offsetHeight);
        }, t = (n)=>{
            this.draggingProgressBar = !1, this.showProgressBar(), document.removeEventListener("mousemove", e), document.removeEventListener("mouseup", t);
        };
        this.progressBarInner.addEventListener("mousedown", (n)=>{
            n.preventDefault(), this.draggingProgressBar = !0, document.addEventListener("mousemove", e), document.addEventListener("mouseup", t), e(n);
        });
    }
    removeProgressBar() {
        this.progressBar && (this.progressBar.remove(), this.progressBar = null);
    }
    layout() {
        this.isActive() && (this.syncPages(), this.syncScrollPosition());
    }
    syncPages() {
        let e = this.Reveal.getConfig(), t = this.Reveal.getComputedSlideSize(window.innerWidth, window.innerHeight), n = this.Reveal.getScale(), r = e.scrollLayout === "compact", i = this.viewportElement.offsetHeight, a = t.height * n, o = r ? a : i;
        this.scrollTriggerHeight = r ? a : i, this.viewportElement.style.setProperty("--page-height", o + "px"), this.viewportElement.style.scrollSnapType = typeof e.scrollSnap == "string" ? `y ${e.scrollSnap}` : "", this.slideTriggers = [], this.pages = Array.from(this.Reveal.getRevealElement().querySelectorAll(".scroll-page")).map((n)=>{
            let a = this.createPage({
                pageElement: n,
                slideElement: n.querySelector("section"),
                stickyElement: n.querySelector(".scroll-page-sticky"),
                contentElement: n.querySelector(".scroll-page-content"),
                backgroundElement: n.querySelector(".slide-background"),
                autoAnimateElements: n.querySelectorAll(".scroll-auto-animate-page"),
                autoAnimatePages: []
            });
            a.pageElement.style.setProperty("--slide-height", e.center === !0 ? "auto" : t.height + "px"), this.slideTriggers.push({
                page: a,
                activate: ()=>this.activatePage(a),
                deactivate: ()=>this.deactivatePage(a)
            }), this.createFragmentTriggersForPage(a), a.autoAnimateElements.length > 0 && this.createAutoAnimateTriggersForPage(a);
            let s = Math.max(a.scrollTriggers.length - 1, 0);
            s += a.autoAnimatePages.reduce((e, t)=>e + Math.max(t.scrollTriggers.length - 1, 0), a.autoAnimatePages.length), a.pageElement.querySelectorAll(".scroll-snap-point").forEach((e)=>e.remove());
            for(let e = 0; e < s + 1; e++){
                let t = document.createElement("div");
                t.className = "scroll-snap-point", t.style.height = this.scrollTriggerHeight + "px", t.style.scrollSnapAlign = r ? "center" : "start", a.pageElement.appendChild(t), e === 0 && (t.style.marginTop = -this.scrollTriggerHeight + "px");
            }
            return r && a.scrollTriggers.length > 0 ? (a.pageHeight = i, a.pageElement.style.setProperty("--page-height", i + "px")) : (a.pageHeight = o, a.pageElement.style.removeProperty("--page-height")), a.scrollPadding = this.scrollTriggerHeight * s, a.totalHeight = a.pageHeight + a.scrollPadding, a.pageElement.style.setProperty("--page-scroll-padding", a.scrollPadding + "px"), s > 0 ? (a.stickyElement.style.position = "sticky", a.stickyElement.style.top = Math.max((i - a.pageHeight) / 2, 0) + "px") : (a.stickyElement.style.position = "relative", a.pageElement.style.scrollSnapAlign = a.pageHeight < i ? "center" : "start"), a;
        }), this.setTriggerRanges(), this.viewportElement.setAttribute("data-scrollbar", e.scrollProgress), e.scrollProgress && this.totalScrollTriggerCount > 1 ? (this.progressBar || this.createProgressBar(), this.syncProgressBar()) : this.removeProgressBar();
    }
    setTriggerRanges() {
        this.totalScrollTriggerCount = this.slideTriggers.reduce((e, t)=>e + Math.max(t.page.scrollTriggers.length, 1), 0);
        let e = 0;
        this.slideTriggers.forEach((t, n)=>{
            t.range = [
                e,
                e + Math.max(t.page.scrollTriggers.length, 1) / this.totalScrollTriggerCount
            ];
            let r = (t.range[1] - t.range[0]) / t.page.scrollTriggers.length;
            t.page.scrollTriggers.forEach((t, n)=>{
                t.range = [
                    e + n * r,
                    e + (n + 1) * r
                ];
            }), e = t.range[1];
        }), this.slideTriggers[this.slideTriggers.length - 1].range[1] = 1;
    }
    createFragmentTriggersForPage(e, t) {
        t = t || e.slideElement;
        let n = this.Reveal.fragments.sort(t.querySelectorAll(".fragment"), !0);
        return n.length && (e.fragments = this.Reveal.fragments.sort(t.querySelectorAll(".fragment:not(.disabled)")), e.scrollTriggers.push({
            activate: ()=>{
                this.Reveal.fragments.update(-1, e.fragments, t);
            }
        }), n.forEach((n, r)=>{
            e.scrollTriggers.push({
                activate: ()=>{
                    this.Reveal.fragments.update(r, e.fragments, t);
                }
            });
        })), e.scrollTriggers.length;
    }
    createAutoAnimateTriggersForPage(e) {
        e.autoAnimateElements.length > 0 && this.slideTriggers.push(...Array.from(e.autoAnimateElements).map((t, n)=>{
            let r = this.createPage({
                slideElement: t.querySelector("section"),
                contentElement: t,
                backgroundElement: t.querySelector(".slide-background")
            });
            return this.createFragmentTriggersForPage(r, r.slideElement), e.autoAnimatePages.push(r), {
                page: r,
                activate: ()=>this.activatePage(r),
                deactivate: ()=>this.deactivatePage(r)
            };
        }));
    }
    createPage(e) {
        return e.scrollTriggers = [], e.indexh = parseInt(e.slideElement.getAttribute("data-index-h"), 10), e.indexv = parseInt(e.slideElement.getAttribute("data-index-v"), 10), e;
    }
    syncProgressBar() {
        this.progressBarInner.querySelectorAll(".scrollbar-slide").forEach((e)=>e.remove());
        let e = this.viewportElement.scrollHeight, t = this.viewportElement.offsetHeight, n = t / e;
        this.progressBarHeight = this.progressBarInner.offsetHeight, this.playheadHeight = Math.max(n * this.progressBarHeight, $4afc1a8f9e4d93e8$var$j), this.progressBarScrollableHeight = this.progressBarHeight - this.playheadHeight;
        let r = t / e * this.progressBarHeight, i = Math.min(r / 8, $4afc1a8f9e4d93e8$var$A);
        this.progressBarPlayhead.style.height = this.playheadHeight - i + "px", r > $4afc1a8f9e4d93e8$var$se ? this.slideTriggers.forEach((e)=>{
            let { page: t } = e;
            t.progressBarSlide = document.createElement("div"), t.progressBarSlide.className = "scrollbar-slide", t.progressBarSlide.style.top = e.range[0] * this.progressBarHeight + "px", t.progressBarSlide.style.height = (e.range[1] - e.range[0]) * this.progressBarHeight - i + "px", t.progressBarSlide.classList.toggle("has-triggers", t.scrollTriggers.length > 0), this.progressBarInner.appendChild(t.progressBarSlide), t.scrollTriggerElements = t.scrollTriggers.map((n, r)=>{
                let a = document.createElement("div");
                return a.className = "scrollbar-trigger", a.style.top = (n.range[0] - e.range[0]) * this.progressBarHeight + "px", a.style.height = (n.range[1] - n.range[0]) * this.progressBarHeight - i + "px", t.progressBarSlide.appendChild(a), r === 0 && (a.style.display = "none"), a;
            });
        }) : this.pages.forEach((e)=>e.progressBarSlide = null);
    }
    syncScrollPosition() {
        let e = this.viewportElement.offsetHeight, t = e / this.viewportElement.scrollHeight, n = this.viewportElement.scrollTop, r = this.viewportElement.scrollHeight - e, i = Math.max(Math.min(n / r, 1), 0), a = Math.max(Math.min((n + e / 2) / this.viewportElement.scrollHeight, 1), 0), o;
        this.slideTriggers.forEach((e)=>{
            let { page: n } = e;
            i >= e.range[0] - t * 2 && i <= e.range[1] + t * 2 && !n.loaded ? (n.loaded = !0, this.Reveal.slideContent.load(n.slideElement)) : n.loaded && (n.loaded = !1, this.Reveal.slideContent.unload(n.slideElement)), i >= e.range[0] && i <= e.range[1] ? (this.activateTrigger(e), o = e.page) : e.active && this.deactivateTrigger(e);
        }), o && o.scrollTriggers.forEach((e)=>{
            a >= e.range[0] && a <= e.range[1] ? this.activateTrigger(e) : e.active && this.deactivateTrigger(e);
        }), this.setProgressBarValue(n / (this.viewportElement.scrollHeight - e));
    }
    setProgressBarValue(e) {
        this.progressBar && (this.progressBarPlayhead.style.transform = `translateY(${e * this.progressBarScrollableHeight}px)`, this.getAllPages().filter((e)=>e.progressBarSlide).forEach((e)=>{
            e.progressBarSlide.classList.toggle("active", e.active === !0), e.scrollTriggers.forEach((t, n)=>{
                e.scrollTriggerElements[n].classList.toggle("active", e.active === !0 && t.active === !0);
            });
        }), this.showProgressBar());
    }
    showProgressBar() {
        this.progressBar.classList.add("visible"), clearTimeout(this.hideProgressBarTimeout), this.Reveal.getConfig().scrollProgress === "auto" && !this.draggingProgressBar && (this.hideProgressBarTimeout = setTimeout(()=>{
            this.progressBar && this.progressBar.classList.remove("visible");
        }, $4afc1a8f9e4d93e8$var$k));
    }
    prev() {
        this.viewportElement.scrollTop -= this.scrollTriggerHeight;
    }
    next() {
        this.viewportElement.scrollTop += this.scrollTriggerHeight;
    }
    scrollToSlide(e) {
        if (!this.active) this.activatedCallbacks.push(()=>this.scrollToSlide(e));
        else {
            let t = this.getScrollTriggerBySlide(e);
            t && (this.viewportElement.scrollTop = t.range[0] * (this.viewportElement.scrollHeight - this.viewportElement.offsetHeight));
        }
    }
    storeScrollPosition() {
        clearTimeout(this.storeScrollPositionTimeout), this.storeScrollPositionTimeout = setTimeout(()=>{
            sessionStorage.setItem("reveal-scroll-top", this.viewportElement.scrollTop), sessionStorage.setItem("reveal-scroll-origin", location.origin + location.pathname), this.storeScrollPositionTimeout = null;
        }, 50);
    }
    restoreScrollPosition() {
        let e = sessionStorage.getItem("reveal-scroll-top"), t = sessionStorage.getItem("reveal-scroll-origin");
        e && t === location.origin + location.pathname && (this.viewportElement.scrollTop = parseInt(e, 10));
    }
    activatePage(e) {
        if (!e.active) {
            e.active = !0;
            let { slideElement: t, backgroundElement: n, contentElement: r, indexh: i, indexv: a } = e;
            r.style.display = "block", t.classList.add("present"), n && n.classList.add("present"), this.Reveal.setCurrentScrollPage(t, i, a), this.Reveal.backgrounds.bubbleSlideContrastClassToElement(t, this.viewportElement), Array.from(r.parentNode.querySelectorAll(".scroll-page-content")).forEach((e)=>{
                e !== r && (e.style.display = "none");
            });
        }
    }
    deactivatePage(e) {
        e.active && (e.active = !1, e.slideElement && e.slideElement.classList.remove("present"), e.backgroundElement && e.backgroundElement.classList.remove("present"));
    }
    activateTrigger(e) {
        e.active || (e.active = !0, e.activate());
    }
    deactivateTrigger(e) {
        e.active && (e.active = !1, e.deactivate && e.deactivate());
    }
    getSlideByIndices(e, t) {
        let n = this.getAllPages().find((n)=>n.indexh === e && n.indexv === t);
        return n ? n.slideElement : null;
    }
    getScrollTriggerBySlide(e) {
        return this.slideTriggers.find((t)=>t.page.slideElement === e);
    }
    getAllPages() {
        return this.pages.flatMap((e)=>[
                e,
                ...e.autoAnimatePages || []
            ]);
    }
    onScroll() {
        this.syncScrollPosition(), this.storeScrollPosition();
    }
    get viewportElement() {
        return this.Reveal.getViewportElement();
    }
};
//#endregion
//#region \0@oxc-project+runtime@0.124.0/helpers/asyncToGenerator.js
function $4afc1a8f9e4d93e8$var$M(e, t, n, r, i, a, o) {
    try {
        var s = e[a](o), c = s.value;
    } catch (e) {
        n(e);
        return;
    }
    s.done ? t(c) : Promise.resolve(c).then(r, i);
}
function $4afc1a8f9e4d93e8$var$N(e) {
    return function() {
        var t = this, n = arguments;
        return new Promise(function(r, i) {
            var a = e.apply(t, n);
            function o(e) {
                $4afc1a8f9e4d93e8$var$M(a, r, i, o, s, "next", e);
            }
            function s(e) {
                $4afc1a8f9e4d93e8$var$M(a, r, i, o, s, "throw", e);
            }
            o(void 0);
        });
    };
}
//#endregion
//#region js/controllers/printview.js
var $4afc1a8f9e4d93e8$var$le = class {
    constructor(e){
        this.Reveal = e;
    }
    activate() {
        var e = this;
        return $4afc1a8f9e4d93e8$var$N(function*() {
            let n = e.Reveal.getConfig(), r = $4afc1a8f9e4d93e8$var$t(e.Reveal.getRevealElement(), $4afc1a8f9e4d93e8$var$C), i = n.slideNumber && /all|print/i.test(n.showSlideNumber), a = e.Reveal.getComputedSlideSize(window.innerWidth, window.innerHeight), o = Math.floor(a.width * (1 + n.margin)), s = Math.floor(a.height * (1 + n.margin)), c = a.width, u = a.height;
            yield new Promise(requestAnimationFrame), $4afc1a8f9e4d93e8$var$l("@page{size:" + o + "px " + s + "px; margin: 0px;}"), $4afc1a8f9e4d93e8$var$l(".reveal section>img, .reveal section>video, .reveal section>iframe{max-width: " + c + "px; max-height:" + u + "px}"), document.documentElement.classList.add("reveal-print", "print-pdf"), document.body.style.width = o + "px", document.body.style.height = s + "px";
            let d = e.Reveal.getViewportElement(), f;
            if (d) {
                let e = window.getComputedStyle(d);
                e && e.background && (f = e.background);
            }
            yield new Promise(requestAnimationFrame), e.Reveal.layoutSlideContents(c, u), yield new Promise(requestAnimationFrame);
            let p = r.map((e)=>e.scrollHeight), m = [], h = r[0].parentNode, g = 1;
            r.forEach(function(e, r) {
                if (e.classList.contains("stack") === !1) {
                    let a = (o - c) / 2, l = (s - u) / 2, d = p[r], h = Math.max(Math.ceil(d / s), 1);
                    h = Math.min(h, n.pdfMaxPagesPerSlide), (h === 1 && n.center || e.classList.contains("center")) && (l = Math.max((s - d) / 2, 0));
                    let _ = document.createElement("div");
                    if (m.push(_), _.className = "pdf-page", _.style.height = (s + n.pdfPageHeightOffset) * h + "px", f && (_.style.background = f), _.appendChild(e), e.style.left = a + "px", e.style.top = l + "px", e.style.width = c + "px", this.Reveal.slideContent.layout(e), e.slideBackgroundElement && _.insertBefore(e.slideBackgroundElement, e), n.showNotes) {
                        let t = this.Reveal.getSlideNotes(e);
                        if (t) {
                            let e = typeof n.showNotes == "string" ? n.showNotes : "inline", r = document.createElement("div");
                            r.classList.add("speaker-notes"), r.classList.add("speaker-notes-pdf"), r.setAttribute("data-layout", e), r.innerHTML = t, e === "separate-page" ? m.push(r) : (r.style.left = "8px", r.style.bottom = "8px", r.style.width = o - 16 + "px", _.appendChild(r));
                        }
                    }
                    if (i) {
                        let e = document.createElement("div");
                        e.classList.add("slide-number"), e.classList.add("slide-number-pdf"), e.innerHTML = g++, _.appendChild(e);
                    }
                    if (n.pdfSeparateFragments) {
                        let e = this.Reveal.fragments.sort(_.querySelectorAll(".fragment"), !0), t;
                        e.forEach(function(e, n) {
                            t && t.forEach(function(e) {
                                e.classList.remove("current-fragment");
                            }), e.forEach(function(e) {
                                e.classList.add("visible", "current-fragment");
                            }, this);
                            let r = _.cloneNode(!0);
                            if (i) {
                                let e = r.querySelector(".slide-number-pdf"), t = n + 1;
                                e.innerHTML += "." + t;
                            }
                            m.push(r), t = e;
                        }, this), e.forEach(function(e) {
                            e.forEach(function(e) {
                                e.classList.remove("visible", "current-fragment");
                            });
                        });
                    } else $4afc1a8f9e4d93e8$var$t(_, ".fragment:not(.fade-out)").forEach(function(e) {
                        e.classList.add("visible");
                    });
                }
            }, e), yield new Promise(requestAnimationFrame), m.forEach((e)=>h.appendChild(e)), e.Reveal.slideContent.layout(e.Reveal.getSlidesElement()), e.Reveal.dispatchEvent({
                type: "pdf-ready"
            }), d.classList.remove("loading-scroll-mode");
        })();
    }
    isActive() {
        return this.Reveal.getConfig().view === "print";
    }
}, $4afc1a8f9e4d93e8$var$ue = class {
    constructor(e){
        this.Reveal = e;
    }
    configure(e, t) {
        e.fragments === !1 ? this.disable() : t.fragments === !1 && this.enable();
    }
    disable() {
        $4afc1a8f9e4d93e8$var$t(this.Reveal.getSlidesElement(), ".fragment").forEach((e)=>{
            e.classList.add("visible"), e.classList.remove("current-fragment");
        });
    }
    enable() {
        $4afc1a8f9e4d93e8$var$t(this.Reveal.getSlidesElement(), ".fragment").forEach((e)=>{
            e.classList.remove("visible"), e.classList.remove("current-fragment");
        });
    }
    availableRoutes() {
        let e = this.Reveal.getCurrentSlide();
        if (e && this.Reveal.getConfig().fragments) {
            let t = e.querySelectorAll(".fragment:not(.disabled)"), n = e.querySelectorAll(".fragment:not(.disabled):not(.visible)");
            return {
                prev: t.length - n.length > 0,
                next: !!n.length
            };
        } else return {
            prev: !1,
            next: !1
        };
    }
    sort(e, t = !1) {
        e = Array.from(e);
        let n = [], r = [], i = [];
        e.forEach((e)=>{
            if (e.hasAttribute("data-fragment-index")) {
                let t = parseInt(e.getAttribute("data-fragment-index"), 10);
                n[t] || (n[t] = []), n[t].push(e);
            } else r.push([
                e
            ]);
        }), n = n.concat(r);
        let a = 0;
        return n.forEach((e)=>{
            e.forEach((e)=>{
                i.push(e), e.setAttribute("data-fragment-index", a);
            }), a++;
        }), t === !0 ? n : i;
    }
    sortAll() {
        this.Reveal.getHorizontalSlides().forEach((e)=>{
            let n = $4afc1a8f9e4d93e8$var$t(e, "section");
            n.forEach((e, t)=>{
                this.sort(e.querySelectorAll(".fragment"));
            }, this), n.length === 0 && this.sort(e.querySelectorAll(".fragment"));
        });
    }
    update(e, t, n = this.Reveal.getCurrentSlide()) {
        let r = {
            shown: [],
            hidden: []
        };
        if (n && this.Reveal.getConfig().fragments && (t = t || this.sort(n.querySelectorAll(".fragment")), t.length)) {
            let i = 0;
            if (typeof e != "number") {
                let t = this.sort(n.querySelectorAll(".fragment.visible")).pop();
                t && (e = parseInt(t.getAttribute("data-fragment-index") || 0, 10));
            }
            Array.from(t).forEach((t, n)=>{
                if (t.hasAttribute("data-fragment-index") && (n = parseInt(t.getAttribute("data-fragment-index"), 10)), i = Math.max(i, n), n <= e) {
                    let i = t.classList.contains("visible");
                    t.classList.add("visible"), t.classList.remove("current-fragment"), n === e && (this.Reveal.announceStatus(this.Reveal.getStatusText(t)), t.classList.add("current-fragment"), this.Reveal.slideContent.startEmbeddedContent(t)), i || (r.shown.push(t), this.Reveal.dispatchEvent({
                        target: t,
                        type: "visible",
                        bubbles: !1
                    }));
                } else {
                    let e = t.classList.contains("visible");
                    t.classList.remove("visible"), t.classList.remove("current-fragment"), e && (this.Reveal.slideContent.stopEmbeddedContent(t), r.hidden.push(t), this.Reveal.dispatchEvent({
                        target: t,
                        type: "hidden",
                        bubbles: !1
                    }));
                }
            }), e = typeof e == "number" ? e : -1, e = Math.max(Math.min(e, i), -1), n.setAttribute("data-fragment", e);
        }
        return r.hidden.length && this.Reveal.dispatchEvent({
            type: "fragmenthidden",
            data: {
                fragment: r.hidden[0],
                fragments: r.hidden
            }
        }), r.shown.length && this.Reveal.dispatchEvent({
            type: "fragmentshown",
            data: {
                fragment: r.shown[0],
                fragments: r.shown
            }
        }), r;
    }
    sync(e = this.Reveal.getCurrentSlide()) {
        return this.sort(e.querySelectorAll(".fragment"));
    }
    goto(e, t = 0) {
        let n = this.Reveal.getCurrentSlide();
        if (n && this.Reveal.getConfig().fragments) {
            let r = this.sort(n.querySelectorAll(".fragment:not(.disabled)"));
            if (r.length) {
                if (typeof e != "number") {
                    let t = this.sort(n.querySelectorAll(".fragment:not(.disabled).visible")).pop();
                    e = t ? parseInt(t.getAttribute("data-fragment-index") || 0, 10) : -1;
                }
                e += t;
                let i = this.update(e, r);
                return this.Reveal.controls.update(), this.Reveal.progress.update(), this.Reveal.getConfig().fragmentInURL && this.Reveal.location.writeURL(), !!(i.shown.length || i.hidden.length);
            }
        }
        return !1;
    }
    next() {
        return this.goto(null, 1);
    }
    prev() {
        return this.goto(null, -1);
    }
}, $4afc1a8f9e4d93e8$var$de = class {
    constructor(e){
        this.Reveal = e, this.active = !1, this.onSlideClicked = this.onSlideClicked.bind(this);
    }
    activate() {
        if (this.Reveal.getConfig().overview && !this.Reveal.isScrollView() && !this.isActive()) {
            this.active = !0, this.Reveal.getRevealElement().classList.add("overview"), this.Reveal.cancelAutoSlide(), this.Reveal.getSlidesElement().appendChild(this.Reveal.getBackgroundsElement()), $4afc1a8f9e4d93e8$var$t(this.Reveal.getRevealElement(), $4afc1a8f9e4d93e8$var$C).forEach((e)=>{
                e.classList.contains("stack") || e.addEventListener("click", this.onSlideClicked, !0);
            });
            let e = this.Reveal.getComputedSlideSize();
            this.overviewSlideWidth = e.width + 70, this.overviewSlideHeight = e.height + 70, this.Reveal.getConfig().rtl && (this.overviewSlideWidth = -this.overviewSlideWidth), this.Reveal.updateSlidesVisibility(), this.layout(), this.update(), this.Reveal.layout();
            let n = this.Reveal.getIndices();
            this.Reveal.dispatchEvent({
                type: "overviewshown",
                data: {
                    indexh: n.h,
                    indexv: n.v,
                    currentSlide: this.Reveal.getCurrentSlide()
                }
            });
        }
    }
    layout() {
        this.Reveal.getHorizontalSlides().forEach((e, n)=>{
            e.setAttribute("data-index-h", n), $4afc1a8f9e4d93e8$var$i(e, "translate3d(" + n * this.overviewSlideWidth + "px, 0, 0)"), e.classList.contains("stack") && $4afc1a8f9e4d93e8$var$t(e, "section").forEach((e, t)=>{
                e.setAttribute("data-index-h", n), e.setAttribute("data-index-v", t), $4afc1a8f9e4d93e8$var$i(e, "translate3d(0, " + t * this.overviewSlideHeight + "px, 0)");
            });
        }), Array.from(this.Reveal.getBackgroundsElement().childNodes).forEach((e, n)=>{
            $4afc1a8f9e4d93e8$var$i(e, "translate3d(" + n * this.overviewSlideWidth + "px, 0, 0)"), $4afc1a8f9e4d93e8$var$t(e, ".slide-background").forEach((e, t)=>{
                $4afc1a8f9e4d93e8$var$i(e, "translate3d(0, " + t * this.overviewSlideHeight + "px, 0)");
            });
        });
    }
    update() {
        let e = Math.min(window.innerWidth, window.innerHeight), t = Math.max(e / 5, 150) / e, n = this.Reveal.getIndices();
        this.Reveal.transformSlides({
            overview: [
                "scale(" + t + ")",
                "translateX(" + -n.h * this.overviewSlideWidth + "px)",
                "translateY(" + -n.v * this.overviewSlideHeight + "px)"
            ].join(" ")
        });
    }
    deactivate() {
        if (this.Reveal.getConfig().overview) {
            this.active = !1, this.Reveal.getRevealElement().classList.remove("overview"), this.Reveal.getRevealElement().classList.add("overview-deactivating"), setTimeout(()=>{
                this.Reveal.getRevealElement().classList.remove("overview-deactivating");
            }, 1), this.Reveal.getRevealElement().appendChild(this.Reveal.getBackgroundsElement()), $4afc1a8f9e4d93e8$var$t(this.Reveal.getRevealElement(), $4afc1a8f9e4d93e8$var$C).forEach((e)=>{
                $4afc1a8f9e4d93e8$var$i(e, ""), e.removeEventListener("click", this.onSlideClicked, !0);
            }), $4afc1a8f9e4d93e8$var$t(this.Reveal.getBackgroundsElement(), ".slide-background").forEach((e)=>{
                $4afc1a8f9e4d93e8$var$i(e, "");
            }), this.Reveal.transformSlides({
                overview: ""
            });
            let e = this.Reveal.getIndices();
            this.Reveal.slide(e.h, e.v), this.Reveal.layout(), this.Reveal.cueAutoSlide(), this.Reveal.dispatchEvent({
                type: "overviewhidden",
                data: {
                    indexh: e.h,
                    indexv: e.v,
                    currentSlide: this.Reveal.getCurrentSlide()
                }
            });
        }
    }
    toggle(e) {
        typeof e == "boolean" ? e ? this.activate() : this.deactivate() : this.isActive() ? this.deactivate() : this.activate();
    }
    isActive() {
        return this.active;
    }
    onSlideClicked(e) {
        if (this.isActive()) {
            e.preventDefault();
            let t = e.target;
            for(; t && !t.nodeName.match(/section/gi);)t = t.parentNode;
            if (t && !t.classList.contains("disabled") && (this.deactivate(), t.nodeName.match(/section/gi))) {
                let e = parseInt(t.getAttribute("data-index-h"), 10), n = parseInt(t.getAttribute("data-index-v"), 10);
                this.Reveal.slide(e, n);
            }
        }
    }
}, $4afc1a8f9e4d93e8$var$fe = class {
    constructor(e){
        this.Reveal = e, this.shortcuts = {}, this.bindings = {}, this.onDocumentKeyDown = this.onDocumentKeyDown.bind(this);
    }
    configure(e, t) {
        e.navigationMode === "linear" ? (this.shortcuts["&#8594;  ,  &#8595;  ,  SPACE  ,  N  ,  L  ,  J"] = "Next slide", this.shortcuts["&#8592;  ,  &#8593;  ,  P  ,  H  ,  K"] = "Previous slide") : (this.shortcuts["N  ,  SPACE"] = "Next slide", this.shortcuts["P  ,  Shift SPACE"] = "Previous slide", this.shortcuts["&#8592;  ,  H"] = "Navigate left", this.shortcuts["&#8594;  ,  L"] = "Navigate right", this.shortcuts["&#8593;  ,  K"] = "Navigate up", this.shortcuts["&#8595;  ,  J"] = "Navigate down"), this.shortcuts["Alt + &#8592;/&#8593/&#8594;/&#8595;"] = "Navigate without fragments", this.shortcuts["Shift + &#8592;/&#8593/&#8594;/&#8595;"] = "Jump to first/last slide", this.shortcuts["B  ,  ."] = "Pause", this.shortcuts.F = "Fullscreen", this.shortcuts.G = "Jump to slide", this.shortcuts["ESC, O"] = "Slide overview";
    }
    bind() {
        document.addEventListener("keydown", this.onDocumentKeyDown, !1);
    }
    unbind() {
        document.removeEventListener("keydown", this.onDocumentKeyDown, !1);
    }
    addKeyBinding(e, t) {
        typeof e == "object" && e.keyCode ? this.bindings[e.keyCode] = {
            callback: t,
            key: e.key,
            description: e.description
        } : this.bindings[e] = {
            callback: t,
            key: null,
            description: null
        };
    }
    removeKeyBinding(e) {
        delete this.bindings[e];
    }
    triggerKey(e) {
        this.onDocumentKeyDown({
            keyCode: e
        });
    }
    registerKeyboardShortcut(e, t) {
        this.shortcuts[e] = t;
    }
    getShortcuts() {
        return this.shortcuts;
    }
    getBindings() {
        return this.bindings;
    }
    onDocumentKeyDown(e) {
        let t = this.Reveal.getConfig();
        if (typeof t.keyboardCondition == "function" && t.keyboardCondition(e) === !1 || t.keyboardCondition === "focused" && !this.Reveal.isFocused()) return !0;
        let n = e.keyCode, r = !this.Reveal.isAutoSliding();
        this.Reveal.onUserInput(e);
        let i = document.activeElement && document.activeElement.isContentEditable === !0, a = document.activeElement && document.activeElement.tagName && /input|textarea/i.test(document.activeElement.tagName), o = document.activeElement && document.activeElement.className && /speaker-notes/i.test(document.activeElement.className), c = !([
            32,
            37,
            38,
            39,
            40,
            63,
            78,
            80,
            191
        ].indexOf(e.keyCode) !== -1 && e.shiftKey || e.altKey) && (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey);
        if (i || a || o || c) return;
        let l = [
            66,
            86,
            190,
            191,
            112
        ], u;
        if (typeof t.keyboard == "object") for(u in t.keyboard)t.keyboard[u] === "togglePause" && l.push(parseInt(u, 10));
        if (this.Reveal.isOverlayOpen() && ![
            "Escape",
            "f",
            "c",
            "b",
            "."
        ].includes(e.key) || this.Reveal.isPaused() && l.indexOf(n) === -1) return !1;
        let d = t.navigationMode === "linear" || !this.Reveal.hasHorizontalSlides() || !this.Reveal.hasVerticalSlides(), f = !1;
        if (typeof t.keyboard == "object") {
            for(u in t.keyboard)if (parseInt(u, 10) === n) {
                let n = t.keyboard[u];
                typeof n == "function" ? n.apply(null, [
                    e
                ]) : typeof n == "string" && typeof this.Reveal[n] == "function" && this.Reveal[n].call(), f = !0;
            }
        }
        if (f === !1) {
            for(u in this.bindings)if (parseInt(u, 10) === n) {
                let t = this.bindings[u].callback;
                typeof t == "function" ? t.apply(null, [
                    e
                ]) : typeof t == "string" && typeof this.Reveal[t] == "function" && this.Reveal[t].call(), f = !0;
            }
        }
        f === !1 && (f = !0, n === 80 || n === 33 ? this.Reveal.prev({
            skipFragments: e.altKey
        }) : n === 78 || n === 34 ? this.Reveal.next({
            skipFragments: e.altKey
        }) : n === 72 || n === 37 ? e.shiftKey ? this.Reveal.slide(0) : !this.Reveal.overview.isActive() && d ? t.rtl ? this.Reveal.next({
            skipFragments: e.altKey
        }) : this.Reveal.prev({
            skipFragments: e.altKey
        }) : this.Reveal.left({
            skipFragments: e.altKey
        }) : n === 76 || n === 39 ? e.shiftKey ? this.Reveal.slide(this.Reveal.getHorizontalSlides().length - 1) : !this.Reveal.overview.isActive() && d ? t.rtl ? this.Reveal.prev({
            skipFragments: e.altKey
        }) : this.Reveal.next({
            skipFragments: e.altKey
        }) : this.Reveal.right({
            skipFragments: e.altKey
        }) : n === 75 || n === 38 ? e.shiftKey ? this.Reveal.slide(void 0, 0) : !this.Reveal.overview.isActive() && d ? this.Reveal.prev({
            skipFragments: e.altKey
        }) : this.Reveal.up({
            skipFragments: e.altKey
        }) : n === 74 || n === 40 ? e.shiftKey ? this.Reveal.slide(void 0, Number.MAX_VALUE) : !this.Reveal.overview.isActive() && d ? this.Reveal.next({
            skipFragments: e.altKey
        }) : this.Reveal.down({
            skipFragments: e.altKey
        }) : n === 36 ? this.Reveal.slide(0) : n === 35 ? this.Reveal.slide(this.Reveal.getHorizontalSlides().length - 1) : n === 32 ? (this.Reveal.overview.isActive() && this.Reveal.overview.deactivate(), e.shiftKey ? this.Reveal.prev({
            skipFragments: e.altKey
        }) : this.Reveal.next({
            skipFragments: e.altKey
        })) : [
            58,
            59,
            66,
            86,
            190
        ].includes(n) || n === 191 && !e.shiftKey ? this.Reveal.togglePause() : n === 70 ? $4afc1a8f9e4d93e8$var$s(t.embedded ? this.Reveal.getViewportElement() : document.documentElement) : n === 65 ? t.autoSlideStoppable && this.Reveal.toggleAutoSlide(r) : n === 71 ? t.jumpToSlide && this.Reveal.toggleJumpToSlide() : n === 67 && this.Reveal.isOverlayOpen() ? this.Reveal.closeOverlay() : (n === 63 || n === 191) && e.shiftKey || n === 112 ? this.Reveal.toggleHelp() : f = !1), f ? e.preventDefault && e.preventDefault() : n === 27 || n === 79 ? (this.Reveal.closeOverlay() === !1 && this.Reveal.overview.toggle(), e.preventDefault && e.preventDefault()) : n === 13 && this.Reveal.overview.isActive() && (this.Reveal.overview.deactivate(), e.preventDefault && e.preventDefault()), this.Reveal.cueAutoSlide();
    }
};
//#endregion
//#region \0@oxc-project+runtime@0.124.0/helpers/objectSpread2.js
function $4afc1a8f9e4d93e8$var$P(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
    }
    return n;
}
function $4afc1a8f9e4d93e8$var$F(e) {
    for(var t = 1; t < arguments.length; t++){
        var n = arguments[t] == null ? {} : arguments[t];
        t % 2 ? $4afc1a8f9e4d93e8$var$P(Object(n), !0).forEach(function(t) {
            $4afc1a8f9e4d93e8$var$S(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $4afc1a8f9e4d93e8$var$P(Object(n)).forEach(function(t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
    }
    return e;
}
//#endregion
//#region js/controllers/location.js
var $4afc1a8f9e4d93e8$var$pe = class {
    constructor(e){
        $4afc1a8f9e4d93e8$var$S(this, "MAX_REPLACE_STATE_FREQUENCY", 1e3), this.Reveal = e, this.writeURLTimeout = 0, this.replaceStateTimestamp = 0, this.onWindowHashChange = this.onWindowHashChange.bind(this);
    }
    bind() {
        window.addEventListener("hashchange", this.onWindowHashChange, !1);
    }
    unbind() {
        window.removeEventListener("hashchange", this.onWindowHashChange, !1);
    }
    getIndicesFromHash(e = window.location.hash, t = {}) {
        let n = e.replace(/^#\/?/, ""), r = n.split("/");
        if (!/^[0-9]*$/.test(r[0]) && n.length) {
            let e, t;
            /\/[-\d]+$/g.test(n) && (t = parseInt(n.split("/").pop(), 10), t = isNaN(t) ? void 0 : t, n = n.split("/").shift());
            try {
                let t = decodeURIComponent(n);
                e = (document.getElementById(t) || document.querySelector(`[data-id="${t}"]`)).closest(".slides section");
            } catch (e) {}
            if (e) return $4afc1a8f9e4d93e8$var$F($4afc1a8f9e4d93e8$var$F({}, this.Reveal.getIndices(e)), {}, {
                f: t
            });
        } else {
            let e = this.Reveal.getConfig(), n = e.hashOneBasedIndex || t.oneBasedIndex ? 1 : 0, i = parseInt(r[0], 10) - n || 0, a = parseInt(r[1], 10) - n || 0, o;
            return e.fragmentInURL && (o = parseInt(r[2], 10), isNaN(o) && (o = void 0)), {
                h: i,
                v: a,
                f: o
            };
        }
        return null;
    }
    readURL() {
        let e = this.Reveal.getIndices(), t = this.getIndicesFromHash();
        t ? (t.h !== e.h || t.v !== e.v || t.f !== void 0) && this.Reveal.slide(t.h, t.v, t.f) : this.Reveal.slide(e.h || 0, e.v || 0);
    }
    writeURL(e) {
        let t = this.Reveal.getConfig(), n = this.Reveal.getCurrentSlide();
        if (clearTimeout(this.writeURLTimeout), typeof e == "number") this.writeURLTimeout = setTimeout(this.writeURL, e);
        else if (n) {
            let e = this.getHash();
            t.history ? window.location.hash = e : t.hash && (e === "/" ? this.debouncedReplaceState(window.location.pathname + window.location.search) : this.debouncedReplaceState("#" + e));
        }
    }
    replaceState(e) {
        window.history.replaceState(null, null, e), this.replaceStateTimestamp = Date.now();
    }
    debouncedReplaceState(e) {
        clearTimeout(this.replaceStateTimeout), Date.now() - this.replaceStateTimestamp > this.MAX_REPLACE_STATE_FREQUENCY ? this.replaceState(e) : this.replaceStateTimeout = setTimeout(()=>this.replaceState(e), this.MAX_REPLACE_STATE_FREQUENCY);
    }
    getHash(e) {
        let t = "/", n = e || this.Reveal.getCurrentSlide(), r = n ? n.getAttribute("id") : null;
        r && (r = encodeURIComponent(r));
        let i = this.Reveal.getIndices(e);
        if (this.Reveal.getConfig().fragmentInURL || (i.f = void 0), typeof r == "string" && r.length) t = "/" + r, i.f >= 0 && (t += "/" + i.f);
        else {
            let e = +!!this.Reveal.getConfig().hashOneBasedIndex;
            (i.h > 0 || i.v > 0 || i.f >= 0) && (t += i.h + e), (i.v > 0 || i.f >= 0) && (t += "/" + (i.v + e)), i.f >= 0 && (t += "/" + i.f);
        }
        return t;
    }
    onWindowHashChange(e) {
        this.readURL();
    }
}, $4afc1a8f9e4d93e8$var$me = class {
    constructor(e){
        this.Reveal = e, this.onNavigateLeftClicked = this.onNavigateLeftClicked.bind(this), this.onNavigateRightClicked = this.onNavigateRightClicked.bind(this), this.onNavigateUpClicked = this.onNavigateUpClicked.bind(this), this.onNavigateDownClicked = this.onNavigateDownClicked.bind(this), this.onNavigatePrevClicked = this.onNavigatePrevClicked.bind(this), this.onNavigateNextClicked = this.onNavigateNextClicked.bind(this), this.onEnterFullscreen = this.onEnterFullscreen.bind(this);
    }
    render() {
        let e = this.Reveal.getConfig().rtl, n = this.Reveal.getRevealElement();
        this.element = document.createElement("aside"), this.element.className = "controls", this.element.innerHTML = `<button class="navigate-left" aria-label="${e ? "next slide" : "previous slide"}"><div class="controls-arrow"></div></button>
			<button class="navigate-right" aria-label="${e ? "previous slide" : "next slide"}"><div class="controls-arrow"></div></button>
			<button class="navigate-up" aria-label="above slide"><div class="controls-arrow"></div></button>
			<button class="navigate-down" aria-label="below slide"><div class="controls-arrow"></div></button>`, this.Reveal.getRevealElement().appendChild(this.element), this.controlsLeft = $4afc1a8f9e4d93e8$var$t(n, ".navigate-left"), this.controlsRight = $4afc1a8f9e4d93e8$var$t(n, ".navigate-right"), this.controlsUp = $4afc1a8f9e4d93e8$var$t(n, ".navigate-up"), this.controlsDown = $4afc1a8f9e4d93e8$var$t(n, ".navigate-down"), this.controlsPrev = $4afc1a8f9e4d93e8$var$t(n, ".navigate-prev"), this.controlsNext = $4afc1a8f9e4d93e8$var$t(n, ".navigate-next"), this.controlsFullscreen = $4afc1a8f9e4d93e8$var$t(n, ".enter-fullscreen"), this.controlsRightArrow = this.element.querySelector(".navigate-right"), this.controlsLeftArrow = this.element.querySelector(".navigate-left"), this.controlsDownArrow = this.element.querySelector(".navigate-down");
    }
    configure(e, t) {
        let n = e.controls === "speaker" || e.controls === "speaker-only";
        this.element.style.display = e.controls && (!n || this.Reveal.isSpeakerNotes()) ? "block" : "none", this.element.setAttribute("data-controls-layout", e.controlsLayout), this.element.setAttribute("data-controls-back-arrows", e.controlsBackArrows);
    }
    bind() {
        let e = [
            "touchstart",
            "click"
        ];
        $4afc1a8f9e4d93e8$var$_ && (e = [
            "touchend"
        ]), e.forEach((e)=>{
            this.controlsLeft.forEach((t)=>t.addEventListener(e, this.onNavigateLeftClicked, !1)), this.controlsRight.forEach((t)=>t.addEventListener(e, this.onNavigateRightClicked, !1)), this.controlsUp.forEach((t)=>t.addEventListener(e, this.onNavigateUpClicked, !1)), this.controlsDown.forEach((t)=>t.addEventListener(e, this.onNavigateDownClicked, !1)), this.controlsPrev.forEach((t)=>t.addEventListener(e, this.onNavigatePrevClicked, !1)), this.controlsNext.forEach((t)=>t.addEventListener(e, this.onNavigateNextClicked, !1)), this.controlsFullscreen.forEach((t)=>t.addEventListener(e, this.onEnterFullscreen, !1));
        });
    }
    unbind() {
        [
            "touchstart",
            "touchend",
            "click"
        ].forEach((e)=>{
            this.controlsLeft.forEach((t)=>t.removeEventListener(e, this.onNavigateLeftClicked, !1)), this.controlsRight.forEach((t)=>t.removeEventListener(e, this.onNavigateRightClicked, !1)), this.controlsUp.forEach((t)=>t.removeEventListener(e, this.onNavigateUpClicked, !1)), this.controlsDown.forEach((t)=>t.removeEventListener(e, this.onNavigateDownClicked, !1)), this.controlsPrev.forEach((t)=>t.removeEventListener(e, this.onNavigatePrevClicked, !1)), this.controlsNext.forEach((t)=>t.removeEventListener(e, this.onNavigateNextClicked, !1)), this.controlsFullscreen.forEach((t)=>t.removeEventListener(e, this.onEnterFullscreen, !1));
        });
    }
    update() {
        let e = this.Reveal.availableRoutes();
        [
            ...this.controlsLeft,
            ...this.controlsRight,
            ...this.controlsUp,
            ...this.controlsDown,
            ...this.controlsPrev,
            ...this.controlsNext
        ].forEach((e)=>{
            e.classList.remove("enabled", "fragmented"), e.setAttribute("disabled", "disabled");
        }), e.left && this.controlsLeft.forEach((e)=>{
            e.classList.add("enabled"), e.removeAttribute("disabled");
        }), e.right && this.controlsRight.forEach((e)=>{
            e.classList.add("enabled"), e.removeAttribute("disabled");
        }), e.up && this.controlsUp.forEach((e)=>{
            e.classList.add("enabled"), e.removeAttribute("disabled");
        }), e.down && this.controlsDown.forEach((e)=>{
            e.classList.add("enabled"), e.removeAttribute("disabled");
        }), (e.left || e.up) && this.controlsPrev.forEach((e)=>{
            e.classList.add("enabled"), e.removeAttribute("disabled");
        }), (e.right || e.down) && this.controlsNext.forEach((e)=>{
            e.classList.add("enabled"), e.removeAttribute("disabled");
        });
        let t = this.Reveal.getCurrentSlide();
        if (t) {
            let e = this.Reveal.fragments.availableRoutes();
            e.prev && this.controlsPrev.forEach((e)=>{
                e.classList.add("fragmented", "enabled"), e.removeAttribute("disabled");
            }), e.next && this.controlsNext.forEach((e)=>{
                e.classList.add("fragmented", "enabled"), e.removeAttribute("disabled");
            });
            let n = this.Reveal.isVerticalSlide(t), r = n && t.parentElement && t.parentElement.querySelectorAll(":scope > section").length > 1;
            n && r ? (e.prev && this.controlsUp.forEach((e)=>{
                e.classList.add("fragmented", "enabled"), e.removeAttribute("disabled");
            }), e.next && this.controlsDown.forEach((e)=>{
                e.classList.add("fragmented", "enabled"), e.removeAttribute("disabled");
            })) : (e.prev && this.controlsLeft.forEach((e)=>{
                e.classList.add("fragmented", "enabled"), e.removeAttribute("disabled");
            }), e.next && this.controlsRight.forEach((e)=>{
                e.classList.add("fragmented", "enabled"), e.removeAttribute("disabled");
            }));
        }
        if (this.Reveal.getConfig().controlsTutorial) {
            let t = this.Reveal.getIndices();
            !this.Reveal.hasNavigatedVertically() && e.down ? this.controlsDownArrow.classList.add("highlight") : (this.controlsDownArrow.classList.remove("highlight"), this.Reveal.getConfig().rtl ? !this.Reveal.hasNavigatedHorizontally() && e.left && t.v === 0 ? this.controlsLeftArrow.classList.add("highlight") : this.controlsLeftArrow.classList.remove("highlight") : !this.Reveal.hasNavigatedHorizontally() && e.right && t.v === 0 ? this.controlsRightArrow.classList.add("highlight") : this.controlsRightArrow.classList.remove("highlight"));
        }
    }
    destroy() {
        this.unbind(), this.element.remove();
    }
    onNavigateLeftClicked(e) {
        e.preventDefault(), this.Reveal.onUserInput(), this.Reveal.getConfig().navigationMode === "linear" ? this.Reveal.prev() : this.Reveal.left();
    }
    onNavigateRightClicked(e) {
        e.preventDefault(), this.Reveal.onUserInput(), this.Reveal.getConfig().navigationMode === "linear" ? this.Reveal.next() : this.Reveal.right();
    }
    onNavigateUpClicked(e) {
        e.preventDefault(), this.Reveal.onUserInput(), this.Reveal.up();
    }
    onNavigateDownClicked(e) {
        e.preventDefault(), this.Reveal.onUserInput(), this.Reveal.down();
    }
    onNavigatePrevClicked(e) {
        e.preventDefault(), this.Reveal.onUserInput(), this.Reveal.prev();
    }
    onNavigateNextClicked(e) {
        e.preventDefault(), this.Reveal.onUserInput(), this.Reveal.next();
    }
    onEnterFullscreen(e) {
        let t = this.Reveal.getConfig(), n = this.Reveal.getViewportElement();
        $4afc1a8f9e4d93e8$var$s(t.embedded ? n : n.parentElement);
    }
}, $4afc1a8f9e4d93e8$var$he = class {
    constructor(e){
        this.Reveal = e, this.onProgressClicked = this.onProgressClicked.bind(this);
    }
    render() {
        this.element = document.createElement("div"), this.element.className = "progress", this.Reveal.getRevealElement().appendChild(this.element), this.bar = document.createElement("span"), this.element.appendChild(this.bar);
    }
    configure(e, t) {
        this.element.style.display = e.progress ? "block" : "none";
    }
    bind() {
        this.Reveal.getConfig().progress && this.element && this.element.addEventListener("click", this.onProgressClicked, !1);
    }
    unbind() {
        this.Reveal.getConfig().progress && this.element && this.element.removeEventListener("click", this.onProgressClicked, !1);
    }
    update() {
        if (this.Reveal.getConfig().progress && this.bar) {
            let e = this.Reveal.getProgress();
            this.Reveal.getTotalSlides() < 2 && (e = 0), this.bar.style.transform = "scaleX(" + e + ")";
        }
    }
    getMaxWidth() {
        return this.Reveal.getRevealElement().offsetWidth;
    }
    onProgressClicked(e) {
        this.Reveal.onUserInput(e), e.preventDefault();
        let t = this.Reveal.getSlides(), n = t.length, r = Math.floor(e.clientX / this.getMaxWidth() * n);
        this.Reveal.getConfig().rtl && (r = n - r);
        let i = this.Reveal.getIndices(t[r]);
        this.Reveal.slide(i.h, i.v);
    }
    destroy() {
        this.element.remove();
    }
}, $4afc1a8f9e4d93e8$var$ge = class {
    constructor(e){
        this.Reveal = e, this.lastMouseWheelStep = 0, this.cursorHidden = !1, this.cursorInactiveTimeout = 0, this.onDocumentCursorActive = this.onDocumentCursorActive.bind(this), this.onDocumentMouseScroll = this.onDocumentMouseScroll.bind(this);
    }
    configure(e, t) {
        e.mouseWheel ? document.addEventListener("wheel", this.onDocumentMouseScroll, !1) : document.removeEventListener("wheel", this.onDocumentMouseScroll, !1), e.hideInactiveCursor ? (document.addEventListener("mousemove", this.onDocumentCursorActive, !1), document.addEventListener("mousedown", this.onDocumentCursorActive, !1)) : (this.showCursor(), document.removeEventListener("mousemove", this.onDocumentCursorActive, !1), document.removeEventListener("mousedown", this.onDocumentCursorActive, !1));
    }
    showCursor() {
        this.cursorHidden && (this.cursorHidden = !1, this.Reveal.getRevealElement().style.cursor = "");
    }
    hideCursor() {
        this.cursorHidden === !1 && (this.cursorHidden = !0, this.Reveal.getRevealElement().style.cursor = "none");
    }
    destroy() {
        this.showCursor(), document.removeEventListener("wheel", this.onDocumentMouseScroll, !1), document.removeEventListener("mousemove", this.onDocumentCursorActive, !1), document.removeEventListener("mousedown", this.onDocumentCursorActive, !1);
    }
    onDocumentCursorActive(e) {
        this.showCursor(), clearTimeout(this.cursorInactiveTimeout), this.cursorInactiveTimeout = setTimeout(this.hideCursor.bind(this), this.Reveal.getConfig().hideCursorTime);
    }
    onDocumentMouseScroll(e) {
        if (Date.now() - this.lastMouseWheelStep > 1e3) {
            this.lastMouseWheelStep = Date.now();
            let t = e.detail || -e.wheelDelta;
            t > 0 ? this.Reveal.next() : t < 0 && this.Reveal.prev();
        }
    }
}, $4afc1a8f9e4d93e8$var$_e = (e, t)=>{
    let n = document.createElement("script");
    n.type = "text/javascript", n.async = !1, n.defer = !1, n.src = e, typeof t == "function" && (n.onload = (e)=>{
        e.type === "load" && (n.onload = n.onerror = null, t());
    }, n.onerror = (e)=>{
        n.onload = n.onerror = null, t(/* @__PURE__ */ Error("Failed loading script: " + n.src + "\n" + e));
    });
    let r = document.querySelector("head");
    r && r.insertBefore(n, r.lastChild);
}, $4afc1a8f9e4d93e8$var$ve = class {
    constructor(e){
        this.Reveal = e, this.state = "idle", this.registeredPlugins = {}, this.asyncDependencies = [];
    }
    load(e, t) {
        return this.state = "loading", e.forEach(this.registerPlugin.bind(this)), new Promise((e)=>{
            let n = [], r = 0;
            if (t.forEach((e)=>{
                (!e.condition || e.condition()) && (e.async ? this.asyncDependencies.push(e) : n.push(e));
            }), n.length) {
                r = n.length;
                let t = (t)=>{
                    t && typeof t.callback == "function" && t.callback(), --r === 0 && this.initPlugins().then(e);
                };
                n.forEach((e)=>{
                    typeof e.id == "string" ? (this.registerPlugin(e), t(e)) : typeof e.src == "string" ? $4afc1a8f9e4d93e8$var$_e(e.src, ()=>t(e)) : (console.warn("Unrecognized plugin format", e), t());
                });
            } else this.initPlugins().then(e);
        });
    }
    initPlugins() {
        return new Promise((e)=>{
            let t = Object.values(this.registeredPlugins), n = t.length;
            if (n === 0) this.loadAsync().then(e);
            else {
                let r, i = ()=>{
                    --n === 0 ? this.loadAsync().then(e) : r();
                }, a = 0;
                r = ()=>{
                    let e = t[a++];
                    if (typeof e.init == "function") {
                        let t = e.init(this.Reveal);
                        t && typeof t.then == "function" ? t.then(i) : i();
                    } else i();
                }, r();
            }
        });
    }
    loadAsync() {
        return this.state = "loaded", this.asyncDependencies.length && this.asyncDependencies.forEach((e)=>{
            $4afc1a8f9e4d93e8$var$_e(e.src, e.callback);
        }), Promise.resolve();
    }
    registerPlugin(e) {
        arguments.length === 2 && typeof arguments[0] == "string" ? (e = arguments[1], e.id = arguments[0]) : typeof e == "function" && (e = e());
        let t = e.id;
        typeof t == "string" ? this.registeredPlugins[t] === void 0 ? (this.registeredPlugins[t] = e, this.state === "loaded" && typeof e.init == "function" && e.init(this.Reveal)) : console.warn("reveal.js: \"" + t + "\" plugin has already been registered") : console.warn("Unrecognized plugin format; can't find plugin.id", e);
    }
    hasPlugin(e) {
        return !!this.registeredPlugins[e];
    }
    getPlugin(e) {
        return this.registeredPlugins[e];
    }
    getRegisteredPlugins() {
        return this.registeredPlugins;
    }
    destroy() {
        Object.values(this.registeredPlugins).forEach((e)=>{
            typeof e.destroy == "function" && e.destroy();
        }), this.registeredPlugins = {}, this.asyncDependencies = [];
    }
}, $4afc1a8f9e4d93e8$var$ye = class {
    constructor(e){
        this.Reveal = e, this.onSlidesClicked = this.onSlidesClicked.bind(this), this.iframeTriggerSelector = null, this.mediaTriggerSelector = "[data-preview-image], [data-preview-video]", this.stateProps = [
            "previewIframe",
            "previewImage",
            "previewVideo",
            "previewFit"
        ], this.state = {};
    }
    update() {
        this.Reveal.getConfig().previewLinks ? this.iframeTriggerSelector = "a[href]:not([data-preview-link=false]), [data-preview-link]:not(a):not([data-preview-link=false])" : this.iframeTriggerSelector = "[data-preview-link]:not([data-preview-link=false])";
        let e = this.Reveal.getSlidesElement().querySelectorAll(this.iframeTriggerSelector).length > 0, t = this.Reveal.getSlidesElement().querySelectorAll(this.mediaTriggerSelector).length > 0;
        e || t ? this.Reveal.getSlidesElement().addEventListener("click", this.onSlidesClicked, !1) : this.Reveal.getSlidesElement().removeEventListener("click", this.onSlidesClicked, !1);
    }
    createOverlay(e) {
        this.dom = document.createElement("div"), this.dom.classList.add("r-overlay"), this.dom.classList.add(e), this.viewport = document.createElement("div"), this.viewport.classList.add("r-overlay-viewport"), this.dom.appendChild(this.viewport), this.Reveal.getRevealElement().appendChild(this.dom);
    }
    previewIframe(e) {
        this.close(), this.state = {
            previewIframe: e
        }, this.createOverlay("r-overlay-preview"), this.dom.dataset.state = "loading", this.viewport.innerHTML = `<header class="r-overlay-header">
				<a class="r-overlay-header-button r-overlay-external" href="${e}" target="_blank"><span class="icon"></span></a>
				<button class="r-overlay-header-button r-overlay-close"><span class="icon"></span></button>
			</header>
			<div class="r-overlay-spinner"></div>
			<div class="r-overlay-content">
				<iframe src="${e}"></iframe>
				<small class="r-overlay-content-inner">
					<span class="r-overlay-error x-frame-error">Unable to load iframe. This is likely due to the site's policy (x-frame-options).</span>
				</small>
			</div>`, this.dom.querySelector("iframe").addEventListener("load", (e)=>{
            this.dom.dataset.state = "loaded";
        }, !1), this.dom.querySelector(".r-overlay-close").addEventListener("click", (e)=>{
            this.close(), e.preventDefault();
        }, !1), this.dom.querySelector(".r-overlay-external").addEventListener("click", (e)=>{
            this.close();
        }, !1), this.Reveal.dispatchEvent({
            type: "previewiframe",
            data: {
                url: e
            }
        });
    }
    previewMedia(e, t, n) {
        if (t !== "image" && t !== "video") {
            console.warn("Please specify a valid media type to preview (image|video)");
            return;
        }
        this.close(), n = n || "scale-down", this.createOverlay("r-overlay-preview"), this.dom.dataset.state = "loading", this.dom.dataset.previewFit = n, this.viewport.innerHTML = "<header class=\"r-overlay-header\">\n				<button class=\"r-overlay-header-button r-overlay-close\">Esc <span class=\"icon\"></span></button>\n			</header>\n			<div class=\"r-overlay-spinner\"></div>\n			<div class=\"r-overlay-content\"></div>";
        let r = this.dom.querySelector(".r-overlay-content");
        if (t === "image") {
            this.state = {
                previewImage: e,
                previewFit: n
            };
            let t = document.createElement("img", {});
            t.src = e, r.appendChild(t), t.addEventListener("load", ()=>{
                this.dom.dataset.state = "loaded";
            }, !1), t.addEventListener("error", ()=>{
                this.dom.dataset.state = "error", r.innerHTML = "<span class=\"r-overlay-error\">Unable to load image.</span>";
            }, !1), this.dom.style.cursor = "zoom-out", this.dom.addEventListener("click", (e)=>{
                this.close();
            }, !1), this.Reveal.dispatchEvent({
                type: "previewimage",
                data: {
                    url: e
                }
            });
        } else if (t === "video") {
            this.state = {
                previewVideo: e,
                previewFit: n
            };
            let t = document.createElement("video");
            t.autoplay = this.dom.dataset.previewAutoplay !== "false", t.controls = this.dom.dataset.previewControls !== "false", t.loop = this.dom.dataset.previewLoop === "true", t.muted = this.dom.dataset.previewMuted === "true", t.playsInline = !0, t.src = e, r.appendChild(t), t.addEventListener("loadeddata", ()=>{
                this.dom.dataset.state = "loaded";
            }, !1), t.addEventListener("error", ()=>{
                this.dom.dataset.state = "error", r.innerHTML = "<span class=\"r-overlay-error\">Unable to load video.</span>";
            }, !1), this.Reveal.dispatchEvent({
                type: "previewvideo",
                data: {
                    url: e
                }
            });
        } else throw Error("Please specify a valid media type to preview");
        this.dom.querySelector(".r-overlay-close").addEventListener("click", (e)=>{
            this.close(), e.preventDefault();
        }, !1);
    }
    previewImage(e, t) {
        this.previewMedia(e, "image", t);
    }
    previewVideo(e, t) {
        this.previewMedia(e, "video", t);
    }
    toggleHelp(e) {
        typeof e == "boolean" ? e ? this.showHelp() : this.close() : this.dom ? this.close() : this.showHelp();
    }
    showHelp() {
        if (this.Reveal.getConfig().help) {
            this.close(), this.createOverlay("r-overlay-help");
            let e = "<p class=\"title\">Keyboard Shortcuts</p>", t = this.Reveal.keyboard.getShortcuts(), n = this.Reveal.keyboard.getBindings();
            e += "<table><th>KEY</th><th>ACTION</th>";
            for(let n in t)e += `<tr><td>${n}</td><td>${t[n]}</td></tr>`;
            for(let t in n)n[t].key && n[t].description && (e += `<tr><td>${n[t].key}</td><td>${n[t].description}</td></tr>`);
            e += "</table>", this.viewport.innerHTML = `
				<header class="r-overlay-header">
					<button class="r-overlay-header-button r-overlay-close">Esc <span class="icon"></span></button>
				</header>
				<div class="r-overlay-content">
					<div class="r-overlay-help-content">${e}</div>
				</div>
			`, this.dom.querySelector(".r-overlay-close").addEventListener("click", (e)=>{
                this.close(), e.preventDefault();
            }, !1), this.Reveal.dispatchEvent({
                type: "showhelp"
            });
        }
    }
    isOpen() {
        return !!this.dom;
    }
    close() {
        return this.dom ? (this.dom.remove(), this.dom = null, this.state = {}, this.Reveal.dispatchEvent({
            type: "closeoverlay"
        }), !0) : !1;
    }
    getState() {
        return this.state;
    }
    setState(e) {
        this.stateProps.every((t)=>this.state[t] === e[t]) || (e.previewIframe ? this.previewIframe(e.previewIframe) : e.previewImage ? this.previewImage(e.previewImage, e.previewFit) : e.previewVideo ? this.previewVideo(e.previewVideo, e.previewFit) : this.close());
    }
    onSlidesClicked(e) {
        let t = e.target, n = t.closest(this.iframeTriggerSelector), r = t.closest(this.mediaTriggerSelector);
        if (n) {
            if (e.metaKey || e.shiftKey || e.altKey) return;
            let t = n.getAttribute("data-preview-link"), r = typeof t == "string" && t.startsWith("http") ? t : n.getAttribute("href");
            r && (this.previewIframe(r), e.preventDefault());
        } else if (r) {
            if (r.hasAttribute("data-preview-image")) {
                let t = r.dataset.previewImage || r.getAttribute("src");
                t && (this.previewImage(t, r.dataset.previewFit), e.preventDefault());
            } else if (r.hasAttribute("data-preview-video")) {
                let t = r.dataset.previewVideo || r.getAttribute("src");
                if (!t) {
                    let e = r.querySelector("source");
                    e && (t = e.getAttribute("src"));
                }
                t && (this.previewVideo(t, r.dataset.previewFit), e.preventDefault());
            }
        }
    }
    destroy() {
        this.close();
    }
}, $4afc1a8f9e4d93e8$var$I = 40, $4afc1a8f9e4d93e8$var$be = class {
    constructor(e){
        this.Reveal = e, this.touchStartX = 0, this.touchStartY = 0, this.touchStartCount = 0, this.touchCaptured = !1, this.onPointerDown = this.onPointerDown.bind(this), this.onPointerMove = this.onPointerMove.bind(this), this.onPointerUp = this.onPointerUp.bind(this), this.onTouchStart = this.onTouchStart.bind(this), this.onTouchMove = this.onTouchMove.bind(this), this.onTouchEnd = this.onTouchEnd.bind(this);
    }
    bind() {
        let e = this.Reveal.getRevealElement();
        "onpointerdown" in window ? (e.addEventListener("pointerdown", this.onPointerDown, !1), e.addEventListener("pointermove", this.onPointerMove, !1), e.addEventListener("pointerup", this.onPointerUp, !1)) : window.navigator.msPointerEnabled ? (e.addEventListener("MSPointerDown", this.onPointerDown, !1), e.addEventListener("MSPointerMove", this.onPointerMove, !1), e.addEventListener("MSPointerUp", this.onPointerUp, !1)) : (e.addEventListener("touchstart", this.onTouchStart, !1), e.addEventListener("touchmove", this.onTouchMove, !1), e.addEventListener("touchend", this.onTouchEnd, !1));
    }
    unbind() {
        let e = this.Reveal.getRevealElement();
        e.removeEventListener("pointerdown", this.onPointerDown, !1), e.removeEventListener("pointermove", this.onPointerMove, !1), e.removeEventListener("pointerup", this.onPointerUp, !1), e.removeEventListener("MSPointerDown", this.onPointerDown, !1), e.removeEventListener("MSPointerMove", this.onPointerMove, !1), e.removeEventListener("MSPointerUp", this.onPointerUp, !1), e.removeEventListener("touchstart", this.onTouchStart, !1), e.removeEventListener("touchmove", this.onTouchMove, !1), e.removeEventListener("touchend", this.onTouchEnd, !1);
    }
    isSwipePrevented(e) {
        if ($4afc1a8f9e4d93e8$var$a(e, "video[controls], audio[controls]")) return !0;
        for(; e && typeof e.hasAttribute == "function";){
            if (e.hasAttribute("data-prevent-swipe")) return !0;
            e = e.parentNode;
        }
        return !1;
    }
    onTouchStart(e) {
        if (this.touchCaptured = !1, this.isSwipePrevented(e.target)) return !0;
        this.touchStartX = e.touches[0].clientX, this.touchStartY = e.touches[0].clientY, this.touchStartCount = e.touches.length;
    }
    onTouchMove(e) {
        if (this.isSwipePrevented(e.target)) return !0;
        let t = this.Reveal.getConfig();
        if (this.touchCaptured) $4afc1a8f9e4d93e8$var$_ && e.preventDefault();
        else {
            this.Reveal.onUserInput(e);
            let n = e.touches[0].clientX, r = e.touches[0].clientY;
            if (e.touches.length === 1 && this.touchStartCount !== 2) {
                let i = this.Reveal.availableRoutes({
                    includeFragments: !0
                }), a = n - this.touchStartX, o = r - this.touchStartY;
                a > $4afc1a8f9e4d93e8$var$I && Math.abs(a) > Math.abs(o) ? (this.touchCaptured = !0, t.navigationMode === "linear" ? t.rtl ? this.Reveal.next() : this.Reveal.prev() : this.Reveal.left()) : a < -$4afc1a8f9e4d93e8$var$I && Math.abs(a) > Math.abs(o) ? (this.touchCaptured = !0, t.navigationMode === "linear" ? t.rtl ? this.Reveal.prev() : this.Reveal.next() : this.Reveal.right()) : o > $4afc1a8f9e4d93e8$var$I && i.up ? (this.touchCaptured = !0, t.navigationMode === "linear" ? this.Reveal.prev() : this.Reveal.up()) : o < -$4afc1a8f9e4d93e8$var$I && i.down && (this.touchCaptured = !0, t.navigationMode === "linear" ? this.Reveal.next() : this.Reveal.down()), t.embedded ? (this.touchCaptured || this.Reveal.isVerticalSlide()) && e.preventDefault() : e.preventDefault();
            }
        }
    }
    onTouchEnd(e) {
        this.touchCaptured && !this.Reveal.slideContent.isAllowedToPlayAudio() && this.Reveal.startEmbeddedContent(this.Reveal.getCurrentSlide()), this.touchCaptured = !1;
    }
    onPointerDown(e) {
        (e.pointerType === e.MSPOINTER_TYPE_TOUCH || e.pointerType === "touch") && (e.touches = [
            {
                clientX: e.clientX,
                clientY: e.clientY
            }
        ], this.onTouchStart(e));
    }
    onPointerMove(e) {
        (e.pointerType === e.MSPOINTER_TYPE_TOUCH || e.pointerType === "touch") && (e.touches = [
            {
                clientX: e.clientX,
                clientY: e.clientY
            }
        ], this.onTouchMove(e));
    }
    onPointerUp(e) {
        (e.pointerType === e.MSPOINTER_TYPE_TOUCH || e.pointerType === "touch") && (e.touches = [
            {
                clientX: e.clientX,
                clientY: e.clientY
            }
        ], this.onTouchEnd(e));
    }
}, $4afc1a8f9e4d93e8$var$L = "focus", $4afc1a8f9e4d93e8$var$R = "blur", $4afc1a8f9e4d93e8$var$xe = class {
    constructor(e){
        this.Reveal = e, this.onRevealPointerDown = this.onRevealPointerDown.bind(this), this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
    }
    configure(e, t) {
        e.embedded ? this.blur() : (this.focus(), this.unbind());
    }
    bind() {
        this.Reveal.getConfig().embedded && this.Reveal.getRevealElement().addEventListener("pointerdown", this.onRevealPointerDown, !1);
    }
    unbind() {
        this.Reveal.getRevealElement().removeEventListener("pointerdown", this.onRevealPointerDown, !1), document.removeEventListener("pointerdown", this.onDocumentPointerDown, !1);
    }
    focus() {
        this.state !== $4afc1a8f9e4d93e8$var$L && (this.Reveal.getRevealElement().classList.add("focused"), document.addEventListener("pointerdown", this.onDocumentPointerDown, !1)), this.state = $4afc1a8f9e4d93e8$var$L;
    }
    blur() {
        this.state !== $4afc1a8f9e4d93e8$var$R && (this.Reveal.getRevealElement().classList.remove("focused"), document.removeEventListener("pointerdown", this.onDocumentPointerDown, !1)), this.state = $4afc1a8f9e4d93e8$var$R;
    }
    isFocused() {
        return this.state === $4afc1a8f9e4d93e8$var$L;
    }
    destroy() {
        this.Reveal.getRevealElement().classList.remove("focused");
    }
    onRevealPointerDown(e) {
        this.focus();
    }
    onDocumentPointerDown(e) {
        let t = $4afc1a8f9e4d93e8$var$o(e.target, ".reveal");
        (!t || t !== this.Reveal.getRevealElement()) && this.blur();
    }
}, $4afc1a8f9e4d93e8$var$Se = class {
    constructor(e){
        this.Reveal = e;
    }
    render() {
        this.element = document.createElement("div"), this.element.className = "speaker-notes", this.element.setAttribute("data-prevent-swipe", ""), this.element.setAttribute("tabindex", "0"), this.Reveal.getRevealElement().appendChild(this.element);
    }
    configure(e, t) {
        e.showNotes && this.element.setAttribute("data-layout", typeof e.showNotes == "string" ? e.showNotes : "inline");
    }
    update() {
        this.Reveal.getConfig().showNotes && this.element && this.Reveal.getCurrentSlide() && !this.Reveal.isScrollView() && !this.Reveal.isPrintView() && (this.element.innerHTML = this.getSlideNotes() || "<span class=\"notes-placeholder\">No notes on this slide.</span>");
    }
    updateVisibility() {
        this.Reveal.getConfig().showNotes && this.hasNotes() && !this.Reveal.isScrollView() && !this.Reveal.isPrintView() ? this.Reveal.getRevealElement().classList.add("show-notes") : this.Reveal.getRevealElement().classList.remove("show-notes");
    }
    hasNotes() {
        return this.Reveal.getSlidesElement().querySelectorAll("[data-notes], aside.notes").length > 0;
    }
    isSpeakerNotesWindow() {
        return !!window.location.search.match(/receiver/gi);
    }
    getSlideNotes(e = this.Reveal.getCurrentSlide()) {
        if (e.hasAttribute("data-notes")) return e.getAttribute("data-notes");
        let t = e.querySelectorAll("aside.notes");
        return t ? Array.from(t).map((e)=>e.innerHTML).join("\n") : null;
    }
    destroy() {
        this.element.remove();
    }
}, $4afc1a8f9e4d93e8$var$Ce = class {
    constructor(e, t){
        this.diameter = 100, this.diameter2 = this.diameter / 2, this.thickness = 6, this.playing = !1, this.progress = 0, this.progressOffset = 1, this.container = e, this.progressCheck = t, this.canvas = document.createElement("canvas"), this.canvas.className = "playback", this.canvas.width = this.diameter, this.canvas.height = this.diameter, this.canvas.style.width = this.diameter2 + "px", this.canvas.style.height = this.diameter2 + "px", this.context = this.canvas.getContext("2d"), this.container.appendChild(this.canvas), this.render();
    }
    setPlaying(e) {
        let t = this.playing;
        this.playing = e, !t && this.playing ? this.animate() : this.render();
    }
    animate() {
        let e = this.progress;
        this.progress = this.progressCheck(), e > .8 && this.progress < .2 && (this.progressOffset = this.progress), this.render(), this.playing && requestAnimationFrame(this.animate.bind(this));
    }
    render() {
        let e = this.playing ? this.progress : 0, t = this.diameter2 - this.thickness, n = this.diameter2, r = this.diameter2;
        this.progressOffset += (1 - this.progressOffset) * .1;
        let i = -Math.PI / 2 + Math.PI * 2 * e, a = -Math.PI / 2 + this.progressOffset * (Math.PI * 2);
        this.context.save(), this.context.clearRect(0, 0, this.diameter, this.diameter), this.context.beginPath(), this.context.arc(n, r, t + 4, 0, Math.PI * 2, !1), this.context.fillStyle = "rgba( 0, 0, 0, 0.4 )", this.context.fill(), this.context.beginPath(), this.context.arc(n, r, t, 0, Math.PI * 2, !1), this.context.lineWidth = this.thickness, this.context.strokeStyle = "rgba( 255, 255, 255, 0.2 )", this.context.stroke(), this.playing && (this.context.beginPath(), this.context.arc(n, r, t, a, i, !1), this.context.lineWidth = this.thickness, this.context.strokeStyle = "#fff", this.context.stroke()), this.context.translate(n - 14, r - 14), this.playing ? (this.context.fillStyle = "#fff", this.context.fillRect(0, 0, 10, 28), this.context.fillRect(18, 0, 10, 28)) : (this.context.beginPath(), this.context.translate(4, 0), this.context.moveTo(0, 0), this.context.lineTo(24, 14), this.context.lineTo(0, 28), this.context.fillStyle = "#fff", this.context.fill()), this.context.restore();
    }
    on(e, t) {
        this.canvas.addEventListener(e, t, !1);
    }
    off(e, t) {
        this.canvas.removeEventListener(e, t, !1);
    }
    destroy() {
        this.playing = !1, this.canvas.parentNode && this.container.removeChild(this.canvas);
    }
}, $4afc1a8f9e4d93e8$var$we = {
    width: 960,
    height: 700,
    margin: .04,
    minScale: .2,
    maxScale: 2,
    controls: !0,
    controlsTutorial: !0,
    controlsLayout: "bottom-right",
    controlsBackArrows: "faded",
    progress: !0,
    slideNumber: !1,
    showSlideNumber: "all",
    hashOneBasedIndex: !1,
    hash: !1,
    respondToHashChanges: !0,
    jumpToSlide: !0,
    history: !1,
    keyboard: !0,
    keyboardCondition: null,
    disableLayout: !1,
    overview: !0,
    center: !0,
    touch: !0,
    loop: !1,
    rtl: !1,
    navigationMode: "default",
    shuffle: !1,
    fragments: !0,
    fragmentInURL: !0,
    embedded: !1,
    help: !0,
    pause: !0,
    showNotes: !1,
    showHiddenSlides: !1,
    autoPlayMedia: null,
    preloadIframes: null,
    mouseWheel: !1,
    previewLinks: !1,
    viewDistance: 3,
    mobileViewDistance: 2,
    display: "block",
    hideInactiveCursor: !0,
    hideCursorTime: 5e3,
    sortFragmentsOnSync: !0,
    autoAnimate: !0,
    autoAnimateMatcher: null,
    autoAnimateEasing: "ease",
    autoAnimateDuration: 1,
    autoAnimateUnmatched: !0,
    autoAnimateStyles: [
        "opacity",
        "color",
        "background-color",
        "padding",
        "font-size",
        "line-height",
        "letter-spacing",
        "border-width",
        "border-color",
        "border-radius",
        "outline",
        "outline-offset"
    ],
    autoSlide: 0,
    autoSlideStoppable: !0,
    autoSlideMethod: null,
    defaultTiming: null,
    postMessage: !0,
    postMessageEvents: !1,
    focusBodyOnPageVisibilityChange: !0,
    transition: "slide",
    transitionSpeed: "default",
    backgroundTransition: "fade",
    parallaxBackgroundImage: "",
    parallaxBackgroundSize: "",
    parallaxBackgroundRepeat: "",
    parallaxBackgroundPosition: "",
    parallaxBackgroundHorizontal: null,
    parallaxBackgroundVertical: null,
    view: null,
    scrollLayout: "full",
    scrollSnap: "mandatory",
    scrollProgress: "auto",
    scrollActivationWidth: 435,
    pdfMaxPagesPerSlide: Infinity,
    pdfSeparateFragments: !0,
    pdfPageHeightOffset: -1,
    dependencies: [],
    plugins: []
}, $4afc1a8f9e4d93e8$var$Te = "6.0.1";
//#endregion
//#region js/reveal.js
function $4afc1a8f9e4d93e8$var$z(a, s) {
    arguments.length < 2 && (s = arguments[0], a = document.querySelector(".reveal"));
    let l = {}, f = {}, p = !1, m = !1, h, _, v, y, b = {
        hasNavigatedHorizontally: !1,
        hasNavigatedVertically: !1
    }, x = [], S = 1, T = {
        layout: "",
        overview: ""
    }, D = {}, ie = "idle", O = 0, k, A = 0, se = -1, j = !1, M = new $4afc1a8f9e4d93e8$var$ee(l), N = new $4afc1a8f9e4d93e8$var$ne(l), P = new $4afc1a8f9e4d93e8$var$re(l), _e = new $4afc1a8f9e4d93e8$var$oe(l), I = new $4afc1a8f9e4d93e8$var$ae(l), L = new $4afc1a8f9e4d93e8$var$ce(l), R = new $4afc1a8f9e4d93e8$var$le(l), z = new $4afc1a8f9e4d93e8$var$ue(l), B = new $4afc1a8f9e4d93e8$var$de(l), V = new $4afc1a8f9e4d93e8$var$fe(l), H = new $4afc1a8f9e4d93e8$var$pe(l), U = new $4afc1a8f9e4d93e8$var$me(l), W = new $4afc1a8f9e4d93e8$var$he(l), Ee = new $4afc1a8f9e4d93e8$var$ge(l), G = new $4afc1a8f9e4d93e8$var$ve(l), K = new $4afc1a8f9e4d93e8$var$ye(l), q = new $4afc1a8f9e4d93e8$var$xe(l), De = new $4afc1a8f9e4d93e8$var$be(l), J = new $4afc1a8f9e4d93e8$var$Se(l);
    function Oe(e) {
        if (!a) throw "Unable to find presentation root (<div class=\"reveal\">).";
        if (p) throw "Reveal.js has already been initialized.";
        if (p = !0, D.wrapper = a, D.slides = a.querySelector(".slides"), !D.slides) throw "Unable to find slides container (<div class=\"slides\">).";
        return f = $4afc1a8f9e4d93e8$var$F($4afc1a8f9e4d93e8$var$F($4afc1a8f9e4d93e8$var$F($4afc1a8f9e4d93e8$var$F($4afc1a8f9e4d93e8$var$F({}, $4afc1a8f9e4d93e8$var$we), f), s), e), $4afc1a8f9e4d93e8$var$u()), /print-pdf/gi.test(window.location.search) && (f.view = "print"), ke(), window.addEventListener("load", X, !1), G.load(f.plugins, f.dependencies).then(Ae), new Promise((e)=>l.on("ready", e));
    }
    function ke() {
        f.embedded === !0 ? D.viewport = $4afc1a8f9e4d93e8$var$o(a, ".reveal-viewport") || a : (D.viewport = document.body, document.documentElement.classList.add("reveal-full-page")), D.viewport.classList.add("reveal-viewport");
    }
    function Ae() {
        p !== !1 && (m = !0, Me(), Ne(), Be(), Re(), ze(), _t(), Ve(), I.update(!0), je(), H.readURL(), setTimeout(()=>{
            D.slides.classList.remove("no-transition"), D.wrapper.classList.add("ready"), Y({
                type: "ready",
                data: {
                    indexh: h,
                    indexv: _,
                    currentSlide: y
                }
            });
        }, 1));
    }
    function je() {
        let e = f.view === "print", t = f.view === "scroll" || f.view === "reader";
        (e || t) && (e ? Ue() : De.unbind(), D.viewport.classList.add("loading-scroll-mode"), e ? document.readyState === "complete" ? R.activate() : window.addEventListener("load", ()=>R.activate()) : L.activate());
    }
    function Me() {
        f.showHiddenSlides || $4afc1a8f9e4d93e8$var$t(D.wrapper, "section[data-visibility=\"hidden\"]").forEach((e)=>{
            let t = e.parentNode;
            t.childElementCount === 1 && /section/i.test(t.nodeName) ? t.remove() : e.remove();
        });
    }
    function Ne() {
        D.slides.classList.add("no-transition"), $4afc1a8f9e4d93e8$var$g ? D.wrapper.classList.add("no-hover") : D.wrapper.classList.remove("no-hover"), I.render(), N.render(), P.render(), U.render(), W.render(), J.render(), D.pauseOverlay = $4afc1a8f9e4d93e8$var$c(D.wrapper, "div", "pause-overlay", f.controls ? "<button class=\"resume-button\">Resume presentation</button>" : null), D.statusElement = Pe(), D.wrapper.setAttribute("role", "application");
    }
    function Pe() {
        let e = D.wrapper.querySelector(".aria-status");
        return e || (e = document.createElement("div"), e.style.position = "absolute", e.style.height = "1px", e.style.width = "1px", e.style.overflow = "hidden", e.style.clip = "rect( 1px, 1px, 1px, 1px )", e.classList.add("aria-status"), e.setAttribute("aria-live", "polite"), e.setAttribute("aria-atomic", "true"), D.wrapper.appendChild(e)), e;
    }
    function Fe(e) {
        D.statusElement.textContent = e;
    }
    function Ie(e) {
        let t = "";
        if (e.nodeType === 3) t += e.textContent.trim();
        else if (e.nodeType === 1) {
            let n = e.getAttribute("aria-hidden"), r = window.getComputedStyle(e).display === "none";
            if (n !== "true" && !r) {
                if (e.tagName === "IMG" || e.tagName === "VIDEO") {
                    let n = e.getAttribute("alt");
                    n && (t += Le(n));
                }
                Array.from(e.childNodes).forEach((e)=>{
                    t += Ie(e);
                }), [
                    "P",
                    "DIV",
                    "UL",
                    "OL",
                    "LI",
                    "H1",
                    "H2",
                    "H3",
                    "H4",
                    "H5",
                    "H6",
                    "BLOCKQUOTE"
                ].includes(e.tagName) && t.trim() !== "" && (t = Le(t));
            }
        }
        return t = t.trim(), t === "" ? "" : t + " ";
    }
    function Le(e) {
        let t = e.trim();
        return t === "" ? e : /[.!?]$/.test(t) ? t : t + ".";
    }
    function Re() {
        setInterval(()=>{
            (!L.isActive() && D.wrapper.scrollTop !== 0 || D.wrapper.scrollLeft !== 0) && (D.wrapper.scrollTop = 0, D.wrapper.scrollLeft = 0);
        }, 1e3);
    }
    function ze() {
        document.addEventListener("fullscreenchange", $t), document.addEventListener("webkitfullscreenchange", $t);
    }
    function Be() {
        f.postMessage && window.addEventListener("message", Jt, !1);
    }
    function Ve(t) {
        let r = $4afc1a8f9e4d93e8$var$F({}, f);
        if (typeof t == "object" && $4afc1a8f9e4d93e8$var$e(f, t), l.isReady() === !1) return;
        let i = D.wrapper.querySelectorAll($4afc1a8f9e4d93e8$var$C).length;
        D.wrapper.classList.remove(r.transition), D.wrapper.classList.add(f.transition), D.wrapper.setAttribute("data-transition-speed", f.transitionSpeed), D.wrapper.setAttribute("data-background-transition", f.backgroundTransition), D.viewport.style.setProperty("--slide-width", typeof f.width == "string" ? f.width : f.width + "px"), D.viewport.style.setProperty("--slide-height", typeof f.height == "string" ? f.height : f.height + "px"), f.shuffle && vt(), $4afc1a8f9e4d93e8$var$n(D.wrapper, "embedded", f.embedded), $4afc1a8f9e4d93e8$var$n(D.wrapper, "rtl", f.rtl), $4afc1a8f9e4d93e8$var$n(D.wrapper, "center", f.center), f.pause === !1 && st(), _e.reset(), k && (k.destroy(), k = null), i > 1 && f.autoSlide && f.autoSlideStoppable && (k = new $4afc1a8f9e4d93e8$var$Ce(D.wrapper, ()=>Math.min(Math.max((Date.now() - se) / O, 0), 1)), k.on("click", en), j = !1), f.navigationMode === "default" ? D.wrapper.removeAttribute("data-navigation-mode") : D.wrapper.setAttribute("data-navigation-mode", f.navigationMode), J.configure(f, r), q.configure(f, r), Ee.configure(f, r), U.configure(f, r), W.configure(f, r), V.configure(f, r), z.configure(f, r), N.configure(f, r), ht();
    }
    function He() {
        window.addEventListener("resize", Zt, !1), f.touch && De.bind(), f.keyboard && V.bind(), f.progress && W.bind(), f.respondToHashChanges && H.bind(), U.bind(), q.bind(), D.slides.addEventListener("click", Xt, !1), D.slides.addEventListener("transitionend", Yt, !1), D.pauseOverlay.addEventListener("click", st, !1), f.focusBodyOnPageVisibilityChange && document.addEventListener("visibilitychange", Qt, !1);
    }
    function Ue() {
        De.unbind(), q.unbind(), V.unbind(), U.unbind(), W.unbind(), H.unbind(), window.removeEventListener("resize", Zt, !1), D.slides.removeEventListener("click", Xt, !1), D.slides.removeEventListener("transitionend", Yt, !1), D.pauseOverlay.removeEventListener("click", st, !1);
    }
    function We() {
        p = !1, m !== !1 && (Ue(), Rt(), J.destroy(), q.destroy(), K.destroy(), G.destroy(), Ee.destroy(), U.destroy(), W.destroy(), I.destroy(), N.destroy(), P.destroy(), document.removeEventListener("fullscreenchange", $t), document.removeEventListener("webkitfullscreenchange", $t), document.removeEventListener("visibilitychange", Qt, !1), window.removeEventListener("message", Jt, !1), window.removeEventListener("load", X, !1), D.pauseOverlay && D.pauseOverlay.remove(), D.statusElement && D.statusElement.remove(), document.documentElement.classList.remove("reveal-full-page"), D.wrapper.classList.remove("ready", "center", "has-horizontal-slides", "has-vertical-slides"), D.wrapper.removeAttribute("data-transition-speed"), D.wrapper.removeAttribute("data-background-transition"), D.viewport.classList.remove("reveal-viewport"), D.viewport.style.removeProperty("--slide-width"), D.viewport.style.removeProperty("--slide-height"), D.slides.style.removeProperty("width"), D.slides.style.removeProperty("height"), D.slides.style.removeProperty("zoom"), D.slides.style.removeProperty("left"), D.slides.style.removeProperty("top"), D.slides.style.removeProperty("bottom"), D.slides.style.removeProperty("right"), D.slides.style.removeProperty("transform"), Array.from(D.wrapper.querySelectorAll($4afc1a8f9e4d93e8$var$C)).forEach((e)=>{
            e.style.removeProperty("display"), e.style.removeProperty("top"), e.removeAttribute("hidden"), e.removeAttribute("aria-hidden");
        }));
    }
    function Ge(e, t, n) {
        a.addEventListener(e, t, n);
    }
    function Ke(e, t, n) {
        a.removeEventListener(e, t, n);
    }
    function qe(e) {
        typeof e.layout == "string" && (T.layout = e.layout), typeof e.overview == "string" && (T.overview = e.overview), T.layout ? $4afc1a8f9e4d93e8$var$i(D.slides, T.layout + " " + T.overview) : $4afc1a8f9e4d93e8$var$i(D.slides, T.overview);
    }
    function Y({ target: t = D.wrapper, type: n, data: r, bubbles: i = !0 }) {
        let a = document.createEvent("HTMLEvents", 1, 2);
        return a.initEvent(n, i, !0), $4afc1a8f9e4d93e8$var$e(a, r), t.dispatchEvent(a), t === D.wrapper && Ye(n), a;
    }
    function Je(e) {
        Y({
            type: "slidechanged",
            data: {
                indexh: h,
                indexv: _,
                previousSlide: v,
                currentSlide: y,
                origin: e
            }
        });
    }
    function Ye(t, n) {
        if (f.postMessageEvents && window.parent !== window.self) {
            let r = {
                namespace: "reveal",
                eventName: t,
                state: Ft()
            };
            $4afc1a8f9e4d93e8$var$e(r, n), window.parent.postMessage(JSON.stringify(r), "*");
        }
    }
    function X() {
        if (D.wrapper && !R.isActive()) {
            let e = D.viewport.offsetWidth, t = D.viewport.offsetHeight;
            if (!f.disableLayout) {
                $4afc1a8f9e4d93e8$var$g && !f.embedded && document.documentElement.style.setProperty("--vh", window.innerHeight * .01 + "px");
                let n = L.isActive() ? Qe(e, t) : Qe(), r = S;
                Xe(f.width, f.height), D.slides.style.width = n.width + "px", D.slides.style.height = n.height + "px", S = Math.min(n.presentationWidth / n.width, n.presentationHeight / n.height), S = Math.max(S, f.minScale), S = Math.min(S, f.maxScale), S === 1 || L.isActive() ? (D.slides.style.zoom = "", D.slides.style.left = "", D.slides.style.top = "", D.slides.style.bottom = "", D.slides.style.right = "", qe({
                    layout: ""
                })) : (D.slides.style.zoom = "", D.slides.style.left = "50%", D.slides.style.top = "50%", D.slides.style.bottom = "auto", D.slides.style.right = "auto", qe({
                    layout: "translate(-50%, -50%) scale(" + S + ")"
                }));
                let i = Array.from(D.wrapper.querySelectorAll($4afc1a8f9e4d93e8$var$C));
                for(let e = 0, t = i.length; e < t; e++){
                    let t = i[e];
                    t.style.display !== "none" && (f.center || t.classList.contains("center") ? t.classList.contains("stack") ? t.style.top = 0 : t.style.top = Math.max((n.height - t.scrollHeight) / 2, 0) + "px" : t.style.top = "");
                }
                r !== S && Y({
                    type: "resize",
                    data: {
                        oldScale: r,
                        scale: S,
                        size: n
                    }
                });
            }
            Ze(), D.viewport.style.setProperty("--slide-scale", S), D.viewport.style.setProperty("--viewport-width", e + "px"), D.viewport.style.setProperty("--viewport-height", t + "px"), L.layout(), W.update(), I.updateParallax(), B.isActive() && B.update();
        }
    }
    function Xe(e, n) {
        $4afc1a8f9e4d93e8$var$t(D.slides, "section > .stretch, section > .r-stretch").forEach((t)=>{
            let r = $4afc1a8f9e4d93e8$var$d(t, n);
            if (/(img|video)/gi.test(t.nodeName)) {
                let n = t.naturalWidth || t.videoWidth, i = t.naturalHeight || t.videoHeight, a = Math.min(e / n, r / i);
                t.style.width = n * a + "px", t.style.height = i * a + "px";
            } else t.style.width = e + "px", t.style.height = r + "px";
        });
    }
    function Ze() {
        if (D.wrapper && !f.disableLayout && !R.isActive() && typeof f.scrollActivationWidth == "number" && f.view !== "scroll") {
            let e = Qe();
            e.presentationWidth > 0 && e.presentationWidth <= f.scrollActivationWidth ? L.isActive() || (I.create(), L.activate()) : L.isActive() && L.deactivate();
        }
    }
    function Qe(e, t) {
        let n = f.width, r = f.height;
        f.disableLayout && (n = D.slides.offsetWidth, r = D.slides.offsetHeight);
        let i = {
            width: n,
            height: r,
            presentationWidth: e || D.wrapper.offsetWidth,
            presentationHeight: t || D.wrapper.offsetHeight
        };
        return i.presentationWidth -= i.presentationWidth * f.margin, i.presentationHeight -= i.presentationHeight * f.margin, typeof i.width == "string" && /%$/.test(i.width) && (i.width = parseInt(i.width, 10) / 100 * i.presentationWidth), typeof i.height == "string" && /%$/.test(i.height) && (i.height = parseInt(i.height, 10) / 100 * i.presentationHeight), i;
    }
    function $e(e, t) {
        typeof e == "object" && typeof e.setAttribute == "function" && e.setAttribute("data-previous-indexv", t || 0);
    }
    function et(e) {
        if (typeof e == "object" && typeof e.setAttribute == "function" && e.classList.contains("stack")) {
            let t = e.hasAttribute("data-start-indexv") ? "data-start-indexv" : "data-previous-indexv";
            return parseInt(e.getAttribute(t) || 0, 10);
        }
        return 0;
    }
    function tt(e = y) {
        return e && e.parentNode && !!e.parentNode.nodeName.match(/section/i);
    }
    function nt(e = y) {
        return e.classList.contains(".stack") || e.querySelector("section") !== null;
    }
    function rt() {
        return y && tt(y) ? !y.nextElementSibling : !1;
    }
    function it() {
        return h === 0 && _ === 0;
    }
    function at() {
        return y ? !(y.nextElementSibling || tt(y) && y.parentNode.nextElementSibling) : !1;
    }
    function ot() {
        if (f.pause) {
            let e = D.wrapper.classList.contains("paused");
            Rt(), D.wrapper.classList.add("paused"), e === !1 && Y({
                type: "paused"
            });
        }
    }
    function st() {
        let e = D.wrapper.classList.contains("paused");
        D.wrapper.classList.remove("paused"), Lt(), e && Y({
            type: "resumed"
        });
    }
    function ct(e) {
        typeof e == "boolean" ? e ? ot() : st() : lt() ? st() : ot();
    }
    function lt() {
        return D.wrapper.classList.contains("paused");
    }
    function ut(e) {
        typeof e == "boolean" ? e ? P.show() : P.hide() : P.isVisible() ? P.hide() : P.show();
    }
    function dt(e) {
        typeof e == "boolean" ? e ? Bt() : zt() : j ? Bt() : zt();
    }
    function ft() {
        return !!(O && !j);
    }
    function Z(e, t, n, r) {
        if (Y({
            type: "beforeslidechange",
            data: {
                indexh: e === void 0 ? h : e,
                indexv: t === void 0 ? _ : t,
                origin: r
            }
        }).defaultPrevented) return;
        v = y;
        let i = D.wrapper.querySelectorAll($4afc1a8f9e4d93e8$var$w);
        if (L.isActive()) {
            let n = L.getSlideByIndices(e, t);
            n && L.scrollToSlide(n);
            return;
        }
        if (i.length === 0) return;
        t === void 0 && !B.isActive() && (t = et(i[e])), v && v.parentNode && v.parentNode.classList.contains("stack") && $e(v.parentNode, _);
        let o = x.concat();
        x.length = 0;
        let s = h || 0, c = _ || 0;
        h = yt($4afc1a8f9e4d93e8$var$w, e === void 0 ? h : e), _ = yt($4afc1a8f9e4d93e8$var$te, t === void 0 ? _ : t);
        let l = h !== s || _ !== c;
        l || (v = null);
        let u = i[h], d = u.querySelectorAll("section");
        a.classList.toggle("is-vertical-slide", d.length > 1), y = d[_] || u;
        let p = !1;
        l && v && y && !B.isActive() && (ie = "running", p = pt(v, y, s, c), p && D.slides.classList.add("disable-slide-transitions")), St(), X(), B.isActive() && B.update(), n !== void 0 && z.goto(n), v && v !== y && (v.classList.remove("present"), v.setAttribute("aria-hidden", "true"), it() && setTimeout(()=>{
            Ot().forEach((e)=>{
                $e(e, 0);
            });
        }, 0));
        stateLoop: for(let e = 0, t = x.length; e < t; e++){
            for(let t = 0; t < o.length; t++)if (o[t] === x[e]) {
                o.splice(t, 1);
                continue stateLoop;
            }
            D.viewport.classList.add(x[e]), Y({
                type: x[e]
            });
        }
        for(; o.length;)D.viewport.classList.remove(o.pop());
        l && (M.afterSlideChanged(), Je(r)), (l || !v) && (M.stopEmbeddedContent(v), M.startEmbeddedContent(y)), requestAnimationFrame(()=>{
            Fe(Ie(y));
        }), W.update(), U.update(), J.update(), I.update(), I.updateParallax(), N.update(), z.update(), H.writeURL(), Lt(), p && (setTimeout(()=>{
            D.slides.classList.remove("disable-slide-transitions");
        }, 0), f.autoAnimate && _e.run(v, y));
    }
    function pt(e, t, n, r) {
        return e.hasAttribute("data-auto-animate") && t.hasAttribute("data-auto-animate") && e.getAttribute("data-auto-animate-id") === t.getAttribute("data-auto-animate-id") && !(h > n || _ > r ? t : e).hasAttribute("data-auto-animate-restart");
    }
    function mt(e, t, n) {
        let r = h || 0;
        h = t, _ = n;
        let i = y !== e;
        v = y, y = e, y && v && f.autoAnimate && pt(v, y, r, _) && _e.run(v, y), i && (M.afterSlideChanged(), v && (M.stopEmbeddedContent(v), M.stopEmbeddedContent(v.slideBackgroundElement)), M.startEmbeddedContent(y), M.startEmbeddedContent(y.slideBackgroundElement)), requestAnimationFrame(()=>{
            Fe(Ie(y));
        }), Je();
    }
    function ht() {
        Ue(), He(), X(), O = f.autoSlide, Lt(), I.create(), H.writeURL(), f.sortFragmentsOnSync === !0 && z.sortAll(), h !== void 0 && (h = yt($4afc1a8f9e4d93e8$var$w, h), _ = yt($4afc1a8f9e4d93e8$var$te, _)), U.update(), W.update(), St(), J.update(), J.updateVisibility(), K.update(), I.update(!0), N.update(), M.formatEmbeddedContent(), f.autoPlayMedia === !1 ? M.stopEmbeddedContent(y, {
            unloadIframes: !1
        }) : M.startEmbeddedContent(y), B.isActive() && B.layout(), Y({
            type: "sync"
        });
    }
    function gt(e = y) {
        I.sync(e), z.sync(e), M.load(e), I.update(), J.update(), Y({
            type: "slidesync",
            data: {
                slide: e
            }
        });
    }
    function _t() {
        $().forEach((e)=>{
            $4afc1a8f9e4d93e8$var$t(e, "section").forEach((e, t)=>{
                t > 0 && (e.classList.remove("present"), e.classList.remove("past"), e.classList.add("future"), e.setAttribute("aria-hidden", "true"));
            });
        });
    }
    function vt(e = $()) {
        e.forEach((t, n)=>{
            let r = e[Math.floor(Math.random() * e.length)];
            r.parentNode === t.parentNode && t.parentNode.insertBefore(t, r);
            let i = t.querySelectorAll("section");
            i.length && vt(i);
        });
    }
    function yt(e, n) {
        let r = $4afc1a8f9e4d93e8$var$t(D.wrapper, e), i = r.length, a = L.isActive() || R.isActive(), o = !1, s = !1;
        if (i) {
            f.loop && (n >= i && (o = !0), n %= i, n < 0 && (n = i + n, s = !0)), n = Math.max(Math.min(n, i - 1), 0);
            for(let e = 0; e < i; e++){
                let t = r[e], i = f.rtl && !tt(t);
                if (t.classList.remove("past"), t.classList.remove("present"), t.classList.remove("future"), t.setAttribute("hidden", ""), t.setAttribute("aria-hidden", "true"), t.querySelector("section") && t.classList.add("stack"), a) {
                    t.classList.add("present");
                    continue;
                }
                e < n ? (t.classList.add(i ? "future" : "past"), f.fragments && bt(t)) : e > n ? (t.classList.add(i ? "past" : "future"), f.fragments && xt(t)) : e === n && f.fragments && (o ? xt(t) : s && bt(t));
            }
            let e = r[n], t = e.classList.contains("present");
            e.classList.add("present"), e.removeAttribute("hidden"), e.removeAttribute("aria-hidden"), t || Y({
                target: e,
                type: "visible",
                bubbles: !1
            });
            let c = e.getAttribute("data-state");
            c && (x = x.concat(c.split(" ")));
        } else n = 0;
        return n;
    }
    function bt(e) {
        $4afc1a8f9e4d93e8$var$t(e, ".fragment").forEach((e)=>{
            e.classList.add("visible"), e.classList.remove("current-fragment");
        });
    }
    function xt(e) {
        $4afc1a8f9e4d93e8$var$t(e, ".fragment.visible").forEach((e)=>{
            e.classList.remove("visible", "current-fragment");
        });
    }
    function St() {
        let e = $(), n = e.length, r, i;
        if (n && h !== void 0) {
            let a = B.isActive(), o = a ? 10 : f.viewDistance;
            $4afc1a8f9e4d93e8$var$g && (o = a ? 6 : f.mobileViewDistance), R.isActive() && (o = Number.MAX_VALUE);
            for(let s = 0; s < n; s++){
                let c = e[s], l = $4afc1a8f9e4d93e8$var$t(c, "section"), u = l.length;
                if (r = Math.abs((h || 0) - s) || 0, f.loop && (r = Math.abs(((h || 0) - s) % (n - o)) || 0), r < o ? M.load(c) : M.unload(c), u) {
                    let e = a ? 0 : et(c);
                    for(let t = 0; t < u; t++){
                        let n = l[t];
                        i = Math.abs(s === (h || 0) ? (_ || 0) - t : t - e), r + i < o ? M.load(n) : M.unload(n);
                    }
                }
            }
            At() ? D.wrapper.classList.add("has-vertical-slides") : D.wrapper.classList.remove("has-vertical-slides"), kt() ? D.wrapper.classList.add("has-horizontal-slides") : D.wrapper.classList.remove("has-horizontal-slides");
        }
    }
    function Q({ includeFragments: e = !1 } = {}) {
        let t = D.wrapper.querySelectorAll($4afc1a8f9e4d93e8$var$w), n = D.wrapper.querySelectorAll($4afc1a8f9e4d93e8$var$te), r = {
            left: h > 0,
            right: h < t.length - 1,
            up: _ > 0,
            down: _ < n.length - 1
        };
        if (f.loop && (t.length > 1 && (r.left = !0, r.right = !0), n.length > 1 && (r.up = !0, r.down = !0)), t.length > 1 && f.navigationMode === "linear" && (r.right = r.right || r.down, r.left = r.left || r.up), e === !0) {
            let e = z.availableRoutes();
            r.left = r.left || e.prev, r.up = r.up || e.prev, r.down = r.down || e.next, r.right = r.right || e.next;
        }
        if (f.rtl) {
            let e = r.left;
            r.left = r.right, r.right = e;
        }
        return r;
    }
    function Ct(e = y) {
        let t = $(), n = 0;
        mainLoop: for(let r = 0; r < t.length; r++){
            let i = t[r], a = i.querySelectorAll("section");
            for(let t = 0; t < a.length; t++){
                if (a[t] === e) break mainLoop;
                a[t].dataset.visibility !== "uncounted" && n++;
            }
            if (i === e) break;
            i.classList.contains("stack") === !1 && i.dataset.visibility !== "uncounted" && n++;
        }
        return n;
    }
    function wt() {
        let e = Mt(), t = Ct();
        if (y) {
            let e = y.querySelectorAll(".fragment");
            if (e.length > 0) {
                let n = y.querySelectorAll(".fragment.visible");
                t += n.length / e.length * .9;
            }
        }
        return Math.min(t / (e - 1), 1);
    }
    function Tt(e) {
        let n = h, r = _, i;
        if (e) {
            if (L.isActive()) n = parseInt(e.getAttribute("data-index-h"), 10), e.getAttribute("data-index-v") && (r = parseInt(e.getAttribute("data-index-v"), 10));
            else {
                let i = tt(e), a = i ? e.parentNode : e, o = $();
                n = Math.max(o.indexOf(a), 0), r = void 0, i && (r = Math.max($4afc1a8f9e4d93e8$var$t(e.parentNode, "section").indexOf(e), 0));
            }
        }
        if (!e && y && y.querySelectorAll(".fragment").length > 0) {
            let e = y.querySelector(".current-fragment");
            i = e && e.hasAttribute("data-fragment-index") ? parseInt(e.getAttribute("data-fragment-index"), 10) : y.querySelectorAll(".fragment.visible").length - 1;
        }
        return {
            h: n,
            v: r,
            f: i
        };
    }
    function Et() {
        return $4afc1a8f9e4d93e8$var$t(D.wrapper, $4afc1a8f9e4d93e8$var$C + ":not(.stack):not([data-visibility=\"uncounted\"])");
    }
    function $() {
        return $4afc1a8f9e4d93e8$var$t(D.wrapper, $4afc1a8f9e4d93e8$var$w);
    }
    function Dt() {
        return $4afc1a8f9e4d93e8$var$t(D.wrapper, ".slides>section>section");
    }
    function Ot() {
        return $4afc1a8f9e4d93e8$var$t(D.wrapper, $4afc1a8f9e4d93e8$var$w + ".stack");
    }
    function kt() {
        return $().length > 1;
    }
    function At() {
        return Dt().length > 1;
    }
    function jt() {
        return Et().map((e)=>{
            let t = {};
            for(let n = 0; n < e.attributes.length; n++){
                let r = e.attributes[n];
                t[r.name] = r.value;
            }
            return t;
        });
    }
    function Mt() {
        return Et().length;
    }
    function Nt(e, t) {
        let n = $()[e], r = n && n.querySelectorAll("section");
        return r && r.length && typeof t == "number" ? r ? r[t] : void 0 : n;
    }
    function Pt(e, t) {
        let n = typeof e == "number" ? Nt(e, t) : e;
        if (n) return n.slideBackgroundElement;
    }
    function Ft() {
        let e = Tt();
        return $4afc1a8f9e4d93e8$var$F({
            indexh: e.h,
            indexv: e.v,
            indexf: e.f,
            paused: lt(),
            overview: B.isActive()
        }, K.getState());
    }
    function It(e) {
        if (typeof e == "object") {
            Z($4afc1a8f9e4d93e8$var$r(e.indexh), $4afc1a8f9e4d93e8$var$r(e.indexv), $4afc1a8f9e4d93e8$var$r(e.indexf));
            let t = $4afc1a8f9e4d93e8$var$r(e.paused), n = $4afc1a8f9e4d93e8$var$r(e.overview);
            typeof t == "boolean" && t !== lt() && ct(t), typeof n == "boolean" && n !== B.isActive() && B.toggle(n), K.setState(e);
        }
    }
    function Lt() {
        if (Rt(), y && f.autoSlide !== !1) {
            let e = y.querySelector(".current-fragment[data-autoslide]"), n = e ? e.getAttribute("data-autoslide") : null, r = y.parentNode ? y.parentNode.getAttribute("data-autoslide") : null, i = y.getAttribute("data-autoslide");
            n ? O = parseInt(n, 10) : i ? O = parseInt(i, 10) : r ? O = parseInt(r, 10) : (O = f.autoSlide, y.querySelectorAll(".fragment").length === 0 && $4afc1a8f9e4d93e8$var$t(y, "video, audio").forEach((e)=>{
                e.hasAttribute("data-autoplay") && O && e.duration * 1e3 / e.playbackRate > O && (O = e.duration * 1e3 / e.playbackRate + 1e3);
            })), O && !j && !lt() && !B.isActive() && (!at() || z.availableRoutes().next || f.loop === !0) && (A = setTimeout(()=>{
                typeof f.autoSlideMethod == "function" ? f.autoSlideMethod() : Kt(), Lt();
            }, O), se = Date.now()), k && k.setPlaying(A !== -1);
        }
    }
    function Rt() {
        clearTimeout(A), A = -1;
    }
    function zt() {
        O && !j && (j = !0, Y({
            type: "autoslidepaused"
        }), clearTimeout(A), k && k.setPlaying(!1));
    }
    function Bt() {
        O && j && (j = !1, Y({
            type: "autoslideresumed"
        }), Lt());
    }
    function Vt({ skipFragments: e = !1 } = {}) {
        if (b.hasNavigatedHorizontally = !0, L.isActive()) return L.prev();
        f.rtl ? (B.isActive() || e || z.next() === !1) && Q().left && Z(h + 1, f.navigationMode === "grid" ? _ : void 0) : (B.isActive() || e || z.prev() === !1) && Q().left && Z(h - 1, f.navigationMode === "grid" ? _ : void 0);
    }
    function Ht({ skipFragments: e = !1 } = {}) {
        if (b.hasNavigatedHorizontally = !0, L.isActive()) return L.next();
        f.rtl ? (B.isActive() || e || z.prev() === !1) && Q().right && Z(h - 1, f.navigationMode === "grid" ? _ : void 0) : (B.isActive() || e || z.next() === !1) && Q().right && Z(h + 1, f.navigationMode === "grid" ? _ : void 0);
    }
    function Ut({ skipFragments: e = !1 } = {}) {
        if (L.isActive()) return L.prev();
        (B.isActive() || e || z.prev() === !1) && Q().up && Z(h, _ - 1);
    }
    function Wt({ skipFragments: e = !1 } = {}) {
        if (b.hasNavigatedVertically = !0, L.isActive()) return L.next();
        (B.isActive() || e || z.next() === !1) && Q().down && Z(h, _ + 1);
    }
    function Gt({ skipFragments: e = !1 } = {}) {
        if (L.isActive()) return L.prev();
        if (e || z.prev() === !1) {
            if (Q().up) Ut({
                skipFragments: e
            });
            else {
                let n;
                if (n = f.rtl ? $4afc1a8f9e4d93e8$var$t(D.wrapper, $4afc1a8f9e4d93e8$var$w + ".future").pop() : $4afc1a8f9e4d93e8$var$t(D.wrapper, $4afc1a8f9e4d93e8$var$w + ".past").pop(), n && n.classList.contains("stack")) {
                    let e = n.querySelectorAll("section").length - 1 || void 0;
                    Z(h - 1, e);
                } else f.rtl ? Ht({
                    skipFragments: e
                }) : Vt({
                    skipFragments: e
                });
            }
        }
    }
    function Kt({ skipFragments: e = !1 } = {}) {
        if (b.hasNavigatedHorizontally = !0, b.hasNavigatedVertically = !0, L.isActive()) return L.next();
        if (e || z.next() === !1) {
            let t = Q();
            t.down && t.right && f.loop && rt() && (t.down = !1), t.down ? Wt({
                skipFragments: e
            }) : f.rtl ? Vt({
                skipFragments: e
            }) : Ht({
                skipFragments: e
            });
        }
    }
    function qt(e) {
        f.autoSlideStoppable && zt();
    }
    function Jt(e) {
        let t = e.data;
        if (typeof t == "string" && t.charAt(0) === "{" && t.charAt(t.length - 1) === "}" && (t = JSON.parse(t), t.method && typeof l[t.method] == "function")) {
            if ($4afc1a8f9e4d93e8$var$E.test(t.method) === !1) {
                let e = l[t.method].apply(l, t.args);
                Ye("callback", {
                    method: t.method,
                    result: e
                });
            } else console.warn("reveal.js: \"" + t.method + "\" is is blacklisted from the postMessage API");
        }
    }
    function Yt(e) {
        ie === "running" && /section/gi.test(e.target.nodeName) && (ie = "idle", Y({
            type: "slidetransitionend",
            data: {
                indexh: h,
                indexv: _,
                previousSlide: v,
                currentSlide: y
            }
        }));
    }
    function Xt(e) {
        let t = $4afc1a8f9e4d93e8$var$o(e.target, "a[href^=\"#\"]");
        if (t) {
            let n = t.getAttribute("href"), r = H.getIndicesFromHash(n);
            r && (l.slide(r.h, r.v, r.f), e.preventDefault());
        }
    }
    function Zt(e) {
        X();
    }
    function Qt(e) {
        document.hidden === !1 && document.activeElement !== document.body && (typeof document.activeElement.blur == "function" && document.activeElement.blur(), document.body.focus());
    }
    function $t(e) {
        (document.fullscreenElement || document.webkitFullscreenElement) === D.wrapper && (e.stopImmediatePropagation(), setTimeout(()=>{
            l.layout(), l.focus.focus();
        }, 1));
    }
    function en(e) {
        at() && f.loop === !1 ? (Z(0, 0), Bt()) : j ? Bt() : zt();
    }
    let tn = {
        VERSION: $4afc1a8f9e4d93e8$var$Te,
        initialize: Oe,
        configure: Ve,
        destroy: We,
        sync: ht,
        syncSlide: gt,
        syncFragments: z.sync.bind(z),
        slide: Z,
        left: Vt,
        right: Ht,
        up: Ut,
        down: Wt,
        prev: Gt,
        next: Kt,
        navigateLeft: Vt,
        navigateRight: Ht,
        navigateUp: Ut,
        navigateDown: Wt,
        navigatePrev: Gt,
        navigateNext: Kt,
        navigateFragment: z.goto.bind(z),
        prevFragment: z.prev.bind(z),
        nextFragment: z.next.bind(z),
        on: Ge,
        off: Ke,
        addEventListener: Ge,
        removeEventListener: Ke,
        layout: X,
        shuffle: vt,
        availableRoutes: Q,
        availableFragments: z.availableRoutes.bind(z),
        toggleHelp: K.toggleHelp.bind(K),
        toggleOverview: B.toggle.bind(B),
        toggleScrollView: L.toggle.bind(L),
        togglePause: ct,
        toggleAutoSlide: dt,
        toggleJumpToSlide: ut,
        isFirstSlide: it,
        isLastSlide: at,
        isLastVerticalSlide: rt,
        isVerticalSlide: tt,
        isVerticalStack: nt,
        isPaused: lt,
        isAutoSliding: ft,
        isSpeakerNotes: J.isSpeakerNotesWindow.bind(J),
        isOverview: B.isActive.bind(B),
        isFocused: q.isFocused.bind(q),
        isOverlayOpen: K.isOpen.bind(K),
        isScrollView: L.isActive.bind(L),
        isPrintView: R.isActive.bind(R),
        isReady: ()=>m,
        loadSlide: M.load.bind(M),
        unloadSlide: M.unload.bind(M),
        startEmbeddedContent: ()=>M.startEmbeddedContent(y),
        stopEmbeddedContent: ()=>M.stopEmbeddedContent(y, {
                unloadIframes: !1
            }),
        previewIframe: K.previewIframe.bind(K),
        previewImage: K.previewImage.bind(K),
        previewVideo: K.previewVideo.bind(K),
        showPreview: K.previewIframe.bind(K),
        hidePreview: K.close.bind(K),
        addEventListeners: He,
        removeEventListeners: Ue,
        dispatchEvent: Y,
        getState: Ft,
        setState: It,
        getProgress: wt,
        getIndices: Tt,
        getSlidesAttributes: jt,
        getSlidePastCount: Ct,
        getTotalSlides: Mt,
        getSlide: Nt,
        getPreviousSlide: ()=>v,
        getCurrentSlide: ()=>y,
        getSlideBackground: Pt,
        getSlideNotes: J.getSlideNotes.bind(J),
        getSlides: Et,
        getHorizontalSlides: $,
        getVerticalSlides: Dt,
        hasHorizontalSlides: kt,
        hasVerticalSlides: At,
        hasNavigatedHorizontally: ()=>b.hasNavigatedHorizontally,
        hasNavigatedVertically: ()=>b.hasNavigatedVertically,
        shouldAutoAnimateBetween: pt,
        addKeyBinding: V.addKeyBinding.bind(V),
        removeKeyBinding: V.removeKeyBinding.bind(V),
        triggerKey: V.triggerKey.bind(V),
        registerKeyboardShortcut: V.registerKeyboardShortcut.bind(V),
        getComputedSlideSize: Qe,
        setCurrentScrollPage: mt,
        removeHiddenSlides: Me,
        getScale: ()=>S,
        getConfig: ()=>f,
        getQueryHash: $4afc1a8f9e4d93e8$var$u,
        getSlidePath: H.getHash.bind(H),
        getRevealElement: ()=>a,
        getSlidesElement: ()=>D.slides,
        getViewportElement: ()=>D.viewport,
        getBackgroundsElement: ()=>I.element,
        registerPlugin: G.registerPlugin.bind(G),
        hasPlugin: G.hasPlugin.bind(G),
        getPlugin: G.getPlugin.bind(G),
        getPlugins: G.getRegisteredPlugins.bind(G)
    };
    return $4afc1a8f9e4d93e8$var$e(l, $4afc1a8f9e4d93e8$var$F($4afc1a8f9e4d93e8$var$F({}, tn), {}, {
        announceStatus: Fe,
        getStatusText: Ie,
        focus: q,
        scroll: L,
        progress: W,
        controls: U,
        location: H,
        overview: B,
        keyboard: V,
        fragments: z,
        backgrounds: I,
        slideContent: M,
        slideNumber: N,
        onUserInput: qt,
        closeOverlay: K.close.bind(K),
        updateSlidesVisibility: St,
        layoutSlideContents: Xe,
        transformSlides: qe,
        cueAutoSlide: Lt,
        cancelAutoSlide: Rt
    })), tn;
}
//#endregion
//#region js/index.ts
var $4afc1a8f9e4d93e8$export$2e2bcd8739ae039 = $4afc1a8f9e4d93e8$var$z, $4afc1a8f9e4d93e8$var$V = [];
$4afc1a8f9e4d93e8$export$2e2bcd8739ae039.initialize = (e)=>{
    let t = document.querySelector(".reveal");
    if (!(t instanceof HTMLElement)) throw Error("Unable to find presentation root (<div class=\"reveal\">).");
    return Object.assign($4afc1a8f9e4d93e8$export$2e2bcd8739ae039, new $4afc1a8f9e4d93e8$var$z(t, e)), $4afc1a8f9e4d93e8$var$V.map((e)=>e($4afc1a8f9e4d93e8$export$2e2bcd8739ae039)), $4afc1a8f9e4d93e8$export$2e2bcd8739ae039.initialize();
}, [
    "configure",
    "on",
    "off",
    "addEventListener",
    "removeEventListener",
    "registerPlugin"
].forEach((e)=>{
    $4afc1a8f9e4d93e8$export$2e2bcd8739ae039[e] = (...t)=>{
        $4afc1a8f9e4d93e8$var$V.push((n)=>n[e].call(null, ...t));
    };
}), $4afc1a8f9e4d93e8$export$2e2bcd8739ae039.isReady = ()=>!1, $4afc1a8f9e4d93e8$export$2e2bcd8739ae039.VERSION = $4afc1a8f9e4d93e8$var$Te;


var $735d64c336cf34fc$exports = {};
(function(e, t) {
    "object" == `object` && "object" < `u` ? $735d64c336cf34fc$exports = t() : typeof define == `function` && define.amd ? define([], t) : (e = typeof globalThis < `u` ? globalThis : e || self, e.RevealHighlight = t());
})($735d64c336cf34fc$exports, function() {
    var e = Object.create, t = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty, o = (e, t)=>()=>(t || e((t = {
                exports: {}
            }).exports, t), t.exports), s = (e, i, o, s)=>{
        if (i && typeof i == `object` || typeof i == `function`) for(var c = r(i), l = 0, u = c.length, d; l < u; l++)d = c[l], !a.call(e, d) && d !== o && t(e, d, {
            get: ((e)=>i[e]).bind(null, d),
            enumerable: !(s = n(i, d)) || s.enumerable
        });
        return e;
    }, c = (n, r, a)=>(a = n == null ? {} : e(i(n)), s(r || !n || !n.__esModule ? t(a, `default`, {
            value: n,
            enumerable: !0
        }) : a, n)), l = o((e, t)=>{
        function n(e) {
            return e instanceof Map ? e.clear = e.delete = e.set = function() {
                throw Error(`map is read-only`);
            } : e instanceof Set && (e.add = e.clear = e.delete = function() {
                throw Error(`set is read-only`);
            }), Object.freeze(e), Object.getOwnPropertyNames(e).forEach((t)=>{
                let r = e[t], i = typeof r;
                (i === `object` || i === `function`) && !Object.isFrozen(r) && n(r);
            }), e;
        }
        var r = class {
            constructor(e){
                e.data === void 0 && (e.data = {}), this.data = e.data, this.isMatchIgnored = !1;
            }
            ignoreMatch() {
                this.isMatchIgnored = !0;
            }
        };
        function i(e) {
            return e.replace(/&/g, `&amp;`).replace(/</g, `&lt;`).replace(/>/g, `&gt;`).replace(/"/g, `&quot;`).replace(/'/g, `&#x27;`);
        }
        function a(e, ...t) {
            let n = Object.create(null);
            for(let t in e)n[t] = e[t];
            return t.forEach(function(e) {
                for(let t in e)n[t] = e[t];
            }), n;
        }
        var o = `</span>`, s = (e)=>!!e.scope, c = (e, { prefix: t })=>{
            if (e.startsWith(`language:`)) return e.replace(`language:`, `language-`);
            if (e.includes(`.`)) {
                let n = e.split(`.`);
                return [
                    `${t}${n.shift()}`,
                    ...n.map((e, t)=>`${e}${`_`.repeat(t + 1)}`)
                ].join(` `);
            }
            return `${t}${e}`;
        }, l = class {
            constructor(e, t){
                this.buffer = ``, this.classPrefix = t.classPrefix, e.walk(this);
            }
            addText(e) {
                this.buffer += i(e);
            }
            openNode(e) {
                if (!s(e)) return;
                let t = c(e.scope, {
                    prefix: this.classPrefix
                });
                this.span(t);
            }
            closeNode(e) {
                s(e) && (this.buffer += o);
            }
            value() {
                return this.buffer;
            }
            span(e) {
                this.buffer += `<span class="${e}">`;
            }
        }, u = (e = {})=>{
            let t = {
                children: []
            };
            return Object.assign(t, e), t;
        }, d = class e {
            constructor(){
                this.rootNode = u(), this.stack = [
                    this.rootNode
                ];
            }
            get top() {
                return this.stack[this.stack.length - 1];
            }
            get root() {
                return this.rootNode;
            }
            add(e) {
                this.top.children.push(e);
            }
            openNode(e) {
                let t = u({
                    scope: e
                });
                this.add(t), this.stack.push(t);
            }
            closeNode() {
                if (this.stack.length > 1) return this.stack.pop();
            }
            closeAllNodes() {
                for(; this.closeNode(););
            }
            toJSON() {
                return JSON.stringify(this.rootNode, null, 4);
            }
            walk(e) {
                return this.constructor._walk(e, this.rootNode);
            }
            static _walk(e, t) {
                return typeof t == `string` ? e.addText(t) : t.children && (e.openNode(t), t.children.forEach((t)=>this._walk(e, t)), e.closeNode(t)), e;
            }
            static _collapse(t) {
                typeof t != `string` && t.children && (t.children.every((e)=>typeof e == `string`) ? t.children = [
                    t.children.join(``)
                ] : t.children.forEach((t)=>{
                    e._collapse(t);
                }));
            }
        }, f = class extends d {
            constructor(e){
                super(), this.options = e;
            }
            addText(e) {
                e !== `` && this.add(e);
            }
            startScope(e) {
                this.openNode(e);
            }
            endScope() {
                this.closeNode();
            }
            __addSublanguage(e, t) {
                let n = e.root;
                t && (n.scope = `language:${t}`), this.add(n);
            }
            toHTML() {
                return new l(this, this.options).value();
            }
            finalize() {
                return this.closeAllNodes(), !0;
            }
        };
        function p(e) {
            return e ? typeof e == `string` ? e : e.source : null;
        }
        function m(e) {
            return _(`(?=`, e, `)`);
        }
        function h(e) {
            return _(`(?:`, e, `)*`);
        }
        function g(e) {
            return _(`(?:`, e, `)?`);
        }
        function _(...e) {
            return e.map((e)=>p(e)).join(``);
        }
        function v(e) {
            let t = e[e.length - 1];
            return typeof t == `object` && t.constructor === Object ? (e.splice(e.length - 1, 1), t) : {};
        }
        function y(...e) {
            return `(` + (v(e).capture ? `` : `?:`) + e.map((e)=>p(e)).join(`|`) + `)`;
        }
        function b(e) {
            return RegExp(e.toString() + `|`).exec(``).length - 1;
        }
        function x(e, t) {
            let n = e && e.exec(t);
            return n && n.index === 0;
        }
        var S = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
        function C(e, { joinWith: t }) {
            let n = 0;
            return e.map((e)=>{
                n += 1;
                let t = n, r = p(e), i = ``;
                for(; r.length > 0;){
                    let e = S.exec(r);
                    if (!e) {
                        i += r;
                        break;
                    }
                    i += r.substring(0, e.index), r = r.substring(e.index + e[0].length), e[0][0] === `\\` && e[1] ? i += `\\` + String(Number(e[1]) + t) : (i += e[0], e[0] === `(` && n++);
                }
                return i;
            }).map((e)=>`(${e})`).join(t);
        }
        var w = /\b\B/, T = `[a-zA-Z]\\w*`, E = `[a-zA-Z_]\\w*`, D = `\\b\\d+(\\.\\d+)?`, O = `(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)`, k = `\\b(0b[01]+)`, A = `!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~`, j = (e = {})=>{
            let t = /^#![ ]*\//;
            return e.binary && (e.begin = _(t, /.*\b/, e.binary, /\b.*/)), a({
                scope: `meta`,
                begin: t,
                end: /$/,
                relevance: 0,
                "on:begin": (e, t)=>{
                    e.index !== 0 && t.ignoreMatch();
                }
            }, e);
        }, M = {
            begin: `\\\\[\\s\\S]`,
            relevance: 0
        }, N = {
            scope: `string`,
            begin: `'`,
            end: `'`,
            illegal: `\\n`,
            contains: [
                M
            ]
        }, P = {
            scope: `string`,
            begin: `"`,
            end: `"`,
            illegal: `\\n`,
            contains: [
                M
            ]
        }, F = {
            begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
        }, I = function(e, t, n = {}) {
            let r = a({
                scope: `comment`,
                begin: e,
                end: t,
                contains: []
            }, n);
            r.contains.push({
                scope: `doctag`,
                begin: `[ ]*(?=(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):)`,
                end: /(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):/,
                excludeBegin: !0,
                relevance: 0
            });
            let i = y(`I`, `a`, `is`, `so`, `us`, `to`, `at`, `if`, `in`, `it`, `on`, /[A-Za-z]+['](d|ve|re|ll|t|s|n)/, /[A-Za-z]+[-][a-z]+/, /[A-Za-z][a-z]{2,}/);
            return r.contains.push({
                begin: _(/[ ]+/, `(`, i, /[.]?[:]?([.][ ]|[ ])/, `){3}`)
            }), r;
        }, L = I(`//`, `$`), R = I(`/\\*`, `\\*/`), z = I(`#`, `$`), B = {
            scope: `number`,
            begin: D,
            relevance: 0
        }, ee = {
            scope: `number`,
            begin: O,
            relevance: 0
        }, te = {
            scope: `number`,
            begin: k,
            relevance: 0
        }, V = {
            scope: `regexp`,
            begin: /\/(?=[^/\n]*\/)/,
            end: /\/[gimuy]*/,
            contains: [
                M,
                {
                    begin: /\[/,
                    end: /\]/,
                    relevance: 0,
                    contains: [
                        M
                    ]
                }
            ]
        }, ne = {
            scope: `title`,
            begin: T,
            relevance: 0
        }, H = {
            scope: `title`,
            begin: E,
            relevance: 0
        }, U = {
            begin: `\\.\\s*` + E,
            relevance: 0
        }, W = Object.freeze({
            __proto__: null,
            APOS_STRING_MODE: N,
            BACKSLASH_ESCAPE: M,
            BINARY_NUMBER_MODE: te,
            BINARY_NUMBER_RE: k,
            COMMENT: I,
            C_BLOCK_COMMENT_MODE: R,
            C_LINE_COMMENT_MODE: L,
            C_NUMBER_MODE: ee,
            C_NUMBER_RE: O,
            END_SAME_AS_BEGIN: function(e) {
                return Object.assign(e, {
                    "on:begin": (e, t)=>{
                        t.data._beginMatch = e[1];
                    },
                    "on:end": (e, t)=>{
                        t.data._beginMatch !== e[1] && t.ignoreMatch();
                    }
                });
            },
            HASH_COMMENT_MODE: z,
            IDENT_RE: T,
            MATCH_NOTHING_RE: w,
            METHOD_GUARD: U,
            NUMBER_MODE: B,
            NUMBER_RE: D,
            PHRASAL_WORDS_MODE: F,
            QUOTE_STRING_MODE: P,
            REGEXP_MODE: V,
            RE_STARTERS_RE: A,
            SHEBANG: j,
            TITLE_MODE: ne,
            UNDERSCORE_IDENT_RE: E,
            UNDERSCORE_TITLE_MODE: H
        });
        function G(e, t) {
            e.input[e.index - 1] === `.` && t.ignoreMatch();
        }
        function re(e, t) {
            e.className !== void 0 && (e.scope = e.className, delete e.className);
        }
        function ie(e, t) {
            t && e.beginKeywords && (e.begin = `\\b(` + e.beginKeywords.split(` `).join(`|`) + `)(?!\\.)(?=\\b|\\s)`, e.__beforeBegin = G, e.keywords = e.keywords || e.beginKeywords, delete e.beginKeywords, e.relevance === void 0 && (e.relevance = 0));
        }
        function K(e, t) {
            Array.isArray(e.illegal) && (e.illegal = y(...e.illegal));
        }
        function ae(e, t) {
            if (e.match) {
                if (e.begin || e.end) throw Error(`begin & end are not supported with match`);
                e.begin = e.match, delete e.match;
            }
        }
        function oe(e, t) {
            e.relevance === void 0 && (e.relevance = 1);
        }
        var se = (e, t)=>{
            if (!e.beforeMatch) return;
            if (e.starts) throw Error(`beforeMatch cannot be used with starts`);
            let n = Object.assign({}, e);
            Object.keys(e).forEach((t)=>{
                delete e[t];
            }), e.keywords = n.keywords, e.begin = _(n.beforeMatch, m(n.begin)), e.starts = {
                relevance: 0,
                contains: [
                    Object.assign(n, {
                        endsParent: !0
                    })
                ]
            }, e.relevance = 0, delete n.beforeMatch;
        }, ce = [
            `of`,
            `and`,
            `for`,
            `in`,
            `not`,
            `or`,
            `if`,
            `then`,
            `parent`,
            `list`,
            `value`
        ], le = `keyword`;
        function q(e, t, n = le) {
            let r = Object.create(null);
            return typeof e == `string` ? i(n, e.split(` `)) : Array.isArray(e) ? i(n, e) : Object.keys(e).forEach(function(n) {
                Object.assign(r, q(e[n], t, n));
            }), r;
            function i(e, n) {
                t && (n = n.map((e)=>e.toLowerCase())), n.forEach(function(t) {
                    let n = t.split(`|`);
                    r[n[0]] = [
                        e,
                        ue(n[0], n[1])
                    ];
                });
            }
        }
        function ue(e, t) {
            return t ? Number(t) : +!de(e);
        }
        function de(e) {
            return ce.includes(e.toLowerCase());
        }
        var fe = {}, J = (e)=>{
            console.error(e);
        }, pe = (e, ...t)=>{
            console.log(`WARN: ${e}`, ...t);
        }, Y = (e, t)=>{
            fe[`${e}/${t}`] || (console.log(`Deprecated as of ${e}. ${t}`), fe[`${e}/${t}`] = !0);
        }, X = Error();
        function me(e, t, { key: n }) {
            let r = 0, i = e[n], a = {}, o = {};
            for(let e = 1; e <= t.length; e++)o[e + r] = i[e], a[e + r] = !0, r += b(t[e - 1]);
            e[n] = o, e[n]._emit = a, e[n]._multi = !0;
        }
        function he(e) {
            if (Array.isArray(e.begin)) {
                if (e.skip || e.excludeBegin || e.returnBegin) throw J(`skip, excludeBegin, returnBegin not compatible with beginScope: {}`), X;
                if (typeof e.beginScope != `object` || e.beginScope === null) throw J(`beginScope must be object`), X;
                me(e, e.begin, {
                    key: `beginScope`
                }), e.begin = C(e.begin, {
                    joinWith: ``
                });
            }
        }
        function ge(e) {
            if (Array.isArray(e.end)) {
                if (e.skip || e.excludeEnd || e.returnEnd) throw J(`skip, excludeEnd, returnEnd not compatible with endScope: {}`), X;
                if (typeof e.endScope != `object` || e.endScope === null) throw J(`endScope must be object`), X;
                me(e, e.end, {
                    key: `endScope`
                }), e.end = C(e.end, {
                    joinWith: ``
                });
            }
        }
        function _e(e) {
            e.scope && typeof e.scope == `object` && e.scope !== null && (e.beginScope = e.scope, delete e.scope);
        }
        function ve(e) {
            _e(e), typeof e.beginScope == `string` && (e.beginScope = {
                _wrap: e.beginScope
            }), typeof e.endScope == `string` && (e.endScope = {
                _wrap: e.endScope
            }), he(e), ge(e);
        }
        function ye(e) {
            function t(t, n) {
                return new RegExp(p(t), `m` + (e.case_insensitive ? `i` : ``) + (e.unicodeRegex ? `u` : ``) + (n ? `g` : ``));
            }
            class n {
                constructor(){
                    this.matchIndexes = {}, this.regexes = [], this.matchAt = 1, this.position = 0;
                }
                addRule(e, t) {
                    t.position = this.position++, this.matchIndexes[this.matchAt] = t, this.regexes.push([
                        t,
                        e
                    ]), this.matchAt += b(e) + 1;
                }
                compile() {
                    this.regexes.length === 0 && (this.exec = ()=>null), this.matcherRe = t(C(this.regexes.map((e)=>e[1]), {
                        joinWith: `|`
                    }), !0), this.lastIndex = 0;
                }
                exec(e) {
                    this.matcherRe.lastIndex = this.lastIndex;
                    let t = this.matcherRe.exec(e);
                    if (!t) return null;
                    let n = t.findIndex((e, t)=>t > 0 && e !== void 0), r = this.matchIndexes[n];
                    return t.splice(0, n), Object.assign(t, r);
                }
            }
            class r {
                constructor(){
                    this.rules = [], this.multiRegexes = [], this.count = 0, this.lastIndex = 0, this.regexIndex = 0;
                }
                getMatcher(e) {
                    if (this.multiRegexes[e]) return this.multiRegexes[e];
                    let t = new n;
                    return this.rules.slice(e).forEach(([e, n])=>t.addRule(e, n)), t.compile(), this.multiRegexes[e] = t, t;
                }
                resumingScanAtSamePosition() {
                    return this.regexIndex !== 0;
                }
                considerAll() {
                    this.regexIndex = 0;
                }
                addRule(e, t) {
                    this.rules.push([
                        e,
                        t
                    ]), t.type === `begin` && this.count++;
                }
                exec(e) {
                    let t = this.getMatcher(this.regexIndex);
                    t.lastIndex = this.lastIndex;
                    let n = t.exec(e);
                    if (this.resumingScanAtSamePosition() && !(n && n.index === this.lastIndex)) {
                        let t = this.getMatcher(0);
                        t.lastIndex = this.lastIndex + 1, n = t.exec(e);
                    }
                    return n && (this.regexIndex += n.position + 1, this.regexIndex === this.count && this.considerAll()), n;
                }
            }
            function i(e) {
                let t = new r;
                return e.contains.forEach((e)=>t.addRule(e.begin, {
                        rule: e,
                        type: `begin`
                    })), e.terminatorEnd && t.addRule(e.terminatorEnd, {
                    type: `end`
                }), e.illegal && t.addRule(e.illegal, {
                    type: `illegal`
                }), t;
            }
            function o(n, r) {
                let a = n;
                if (n.isCompiled) return a;
                [
                    re,
                    ae,
                    ve,
                    se
                ].forEach((e)=>e(n, r)), e.compilerExtensions.forEach((e)=>e(n, r)), n.__beforeBegin = null, [
                    ie,
                    K,
                    oe
                ].forEach((e)=>e(n, r)), n.isCompiled = !0;
                let s = null;
                return typeof n.keywords == `object` && n.keywords.$pattern && (n.keywords = Object.assign({}, n.keywords), s = n.keywords.$pattern, delete n.keywords.$pattern), s ||= /\w+/, n.keywords &&= q(n.keywords, e.case_insensitive), a.keywordPatternRe = t(s, !0), r && (n.begin ||= /\B|\b/, a.beginRe = t(a.begin), !n.end && !n.endsWithParent && (n.end = /\B|\b/), n.end && (a.endRe = t(a.end)), a.terminatorEnd = p(a.end) || ``, n.endsWithParent && r.terminatorEnd && (a.terminatorEnd += (n.end ? `|` : ``) + r.terminatorEnd)), n.illegal && (a.illegalRe = t(n.illegal)), n.contains ||= [], n.contains = [].concat(...n.contains.map(function(e) {
                    return xe(e === `self` ? n : e);
                })), n.contains.forEach(function(e) {
                    o(e, a);
                }), n.starts && o(n.starts, r), a.matcher = i(a), a;
            }
            if (e.compilerExtensions ||= [], e.contains && e.contains.includes(`self`)) throw Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
            return e.classNameAliases = a(e.classNameAliases || {}), o(e);
        }
        function be(e) {
            return e ? e.endsWithParent || be(e.starts) : !1;
        }
        function xe(e) {
            return e.variants && !e.cachedVariants && (e.cachedVariants = e.variants.map(function(t) {
                return a(e, {
                    variants: null
                }, t);
            })), e.cachedVariants ? e.cachedVariants : be(e) ? a(e, {
                starts: e.starts ? a(e.starts) : null
            }) : Object.isFrozen(e) ? a(e) : e;
        }
        var Se = `11.11.1`, Ce = class extends Error {
            constructor(e, t){
                super(e), this.name = `HTMLInjectionError`, this.html = t;
            }
        }, we = i, Te = a, Ee = Symbol(`nomatch`), De = 7, Oe = function(e) {
            let t = Object.create(null), i = Object.create(null), a = [], o = !0, s = `Could not find the language '{}', did you forget to load/include a language module?`, c = {
                disableAutodetect: !0,
                name: `Plain text`,
                contains: []
            }, l = {
                ignoreUnescapedHTML: !1,
                throwUnescapedHTML: !1,
                noHighlightRe: /^(no-?highlight)$/i,
                languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
                classPrefix: `hljs-`,
                cssSelector: `pre code`,
                languages: null,
                __emitter: f
            };
            function u(e) {
                return l.noHighlightRe.test(e);
            }
            function d(e) {
                let t = e.className + ` `;
                t += e.parentNode ? e.parentNode.className : ``;
                let n = l.languageDetectRe.exec(t);
                if (n) {
                    let t = N(n[1]);
                    return t || (pe(s.replace(`{}`, n[1])), pe(`Falling back to no-highlight mode for this block.`, e)), t ? n[1] : `no-highlight`;
                }
                return t.split(/\s+/).find((e)=>u(e) || N(e));
            }
            function p(e, t, n) {
                let r = ``, i = ``;
                typeof t == `object` ? (r = e, n = t.ignoreIllegals, i = t.language) : (Y(`10.7.0`, `highlight(lang, code, ...args) has been deprecated.`), Y(`10.7.0`, `Please use highlight(code, options) instead.
https://github.com/highlightjs/highlight.js/issues/2277`), i = e, r = t), n === void 0 && (n = !0);
                let a = {
                    code: r,
                    language: i
                };
                z(`before:highlight`, a);
                let o = a.result ? a.result : v(a.language, a.code, n);
                return o.code = a.code, z(`after:highlight`, o), o;
            }
            function v(e, n, i, a) {
                let c = Object.create(null);
                function u(e, t) {
                    return e.keywords[t];
                }
                function d() {
                    if (!A.keywords) {
                        M.addText(P);
                        return;
                    }
                    let e = 0;
                    A.keywordPatternRe.lastIndex = 0;
                    let t = A.keywordPatternRe.exec(P), n = ``;
                    for(; t;){
                        n += P.substring(e, t.index);
                        let r = D.case_insensitive ? t[0].toLowerCase() : t[0], i = u(A, r);
                        if (i) {
                            let [e, a] = i;
                            if (M.addText(n), n = ``, c[r] = (c[r] || 0) + 1, c[r] <= De && (F += a), e.startsWith(`_`)) n += t[0];
                            else {
                                let n = D.classNameAliases[e] || e;
                                m(t[0], n);
                            }
                        } else n += t[0];
                        e = A.keywordPatternRe.lastIndex, t = A.keywordPatternRe.exec(P);
                    }
                    n += P.substring(e), M.addText(n);
                }
                function f() {
                    if (P === ``) return;
                    let e = null;
                    if (typeof A.subLanguage == `string`) {
                        if (!t[A.subLanguage]) {
                            M.addText(P);
                            return;
                        }
                        e = v(A.subLanguage, P, !0, j[A.subLanguage]), j[A.subLanguage] = e._top;
                    } else e = S(P, A.subLanguage.length ? A.subLanguage : null);
                    A.relevance > 0 && (F += e.relevance), M.__addSublanguage(e._emitter, e.language);
                }
                function p() {
                    A.subLanguage == null ? d() : f(), P = ``;
                }
                function m(e, t) {
                    e !== `` && (M.startScope(t), M.addText(e), M.endScope());
                }
                function h(e, t) {
                    let n = 1, r = t.length - 1;
                    for(; n <= r;){
                        if (!e._emit[n]) {
                            n++;
                            continue;
                        }
                        let r = D.classNameAliases[e[n]] || e[n], i = t[n];
                        r ? m(i, r) : (P = i, d(), P = ``), n++;
                    }
                }
                function g(e, t) {
                    return e.scope && typeof e.scope == `string` && M.openNode(D.classNameAliases[e.scope] || e.scope), e.beginScope && (e.beginScope._wrap ? (m(P, D.classNameAliases[e.beginScope._wrap] || e.beginScope._wrap), P = ``) : e.beginScope._multi && (h(e.beginScope, t), P = ``)), A = Object.create(e, {
                        parent: {
                            value: A
                        }
                    }), A;
                }
                function _(e, t, n) {
                    let i = x(e.endRe, n);
                    if (i) {
                        if (e[`on:end`]) {
                            let n = new r(e);
                            e[`on:end`](t, n), n.isMatchIgnored && (i = !1);
                        }
                        if (i) {
                            for(; e.endsParent && e.parent;)e = e.parent;
                            return e;
                        }
                    }
                    if (e.endsWithParent) return _(e.parent, t, n);
                }
                function y(e) {
                    return A.matcher.regexIndex === 0 ? (P += e[0], 1) : (R = !0, 0);
                }
                function b(e) {
                    let t = e[0], n = e.rule, i = new r(n), a = [
                        n.__beforeBegin,
                        n[`on:begin`]
                    ];
                    for (let n of a)if (n && (n(e, i), i.isMatchIgnored)) return y(t);
                    return n.skip ? P += t : (n.excludeBegin && (P += t), p(), !n.returnBegin && !n.excludeBegin && (P = t)), g(n, e), n.returnBegin ? 0 : t.length;
                }
                function C(e) {
                    let t = e[0], r = n.substring(e.index), i = _(A, e, r);
                    if (!i) return Ee;
                    let a = A;
                    A.endScope && A.endScope._wrap ? (p(), m(t, A.endScope._wrap)) : A.endScope && A.endScope._multi ? (p(), h(A.endScope, e)) : a.skip ? P += t : (a.returnEnd || a.excludeEnd || (P += t), p(), a.excludeEnd && (P = t));
                    do A.scope && M.closeNode(), !A.skip && !A.subLanguage && (F += A.relevance), A = A.parent;
                    while (A !== i.parent);
                    return i.starts && g(i.starts, e), a.returnEnd ? 0 : t.length;
                }
                function w() {
                    let e = [];
                    for(let t = A; t !== D; t = t.parent)t.scope && e.unshift(t.scope);
                    e.forEach((e)=>M.openNode(e));
                }
                let T = {};
                function E(t, r) {
                    let a = r && r[0];
                    if (P += t, a == null) return p(), 0;
                    if (T.type === `begin` && r.type === `end` && T.index === r.index && a === ``) {
                        if (P += n.slice(r.index, r.index + 1), !o) {
                            let t = Error(`0 width match regex (${e})`);
                            throw t.languageName = e, t.badRule = T.rule, t;
                        }
                        return 1;
                    }
                    if (T = r, r.type === `begin`) return b(r);
                    if (r.type === `illegal` && !i) {
                        let e = Error(`Illegal lexeme "` + a + `" for mode "` + (A.scope || `<unnamed>`) + `"`);
                        throw e.mode = A, e;
                    } else if (r.type === `end`) {
                        let e = C(r);
                        if (e !== Ee) return e;
                    }
                    if (r.type === `illegal` && a === ``) return P += `
`, 1;
                    if (L > 1e5 && L > r.index * 3) throw Error(`potential infinite loop, way more iterations than matches`);
                    return P += a, a.length;
                }
                let D = N(e);
                if (!D) throw J(s.replace(`{}`, e)), Error(`Unknown language: "` + e + `"`);
                let O = ye(D), k = ``, A = a || O, j = {}, M = new l.__emitter(l);
                w();
                let P = ``, F = 0, I = 0, L = 0, R = !1;
                try {
                    if (D.__emitTokens) D.__emitTokens(n, M);
                    else {
                        for(A.matcher.considerAll();;){
                            L++, R ? R = !1 : A.matcher.considerAll(), A.matcher.lastIndex = I;
                            let e = A.matcher.exec(n);
                            if (!e) break;
                            let t = E(n.substring(I, e.index), e);
                            I = e.index + t;
                        }
                        E(n.substring(I));
                    }
                    return M.finalize(), k = M.toHTML(), {
                        language: e,
                        value: k,
                        relevance: F,
                        illegal: !1,
                        _emitter: M,
                        _top: A
                    };
                } catch (t) {
                    if (t.message && t.message.includes(`Illegal`)) return {
                        language: e,
                        value: we(n),
                        illegal: !0,
                        relevance: 0,
                        _illegalBy: {
                            message: t.message,
                            index: I,
                            context: n.slice(I - 100, I + 100),
                            mode: t.mode,
                            resultSoFar: k
                        },
                        _emitter: M
                    };
                    if (o) return {
                        language: e,
                        value: we(n),
                        illegal: !1,
                        relevance: 0,
                        errorRaised: t,
                        _emitter: M,
                        _top: A
                    };
                    throw t;
                }
            }
            function b(e) {
                let t = {
                    value: we(e),
                    illegal: !1,
                    relevance: 0,
                    _top: c,
                    _emitter: new l.__emitter(l)
                };
                return t._emitter.addText(e), t;
            }
            function S(e, n) {
                n = n || l.languages || Object.keys(t);
                let r = b(e), i = n.filter(N).filter(F).map((t)=>v(t, e, !1));
                i.unshift(r);
                let [a, o] = i.sort((e, t)=>{
                    if (e.relevance !== t.relevance) return t.relevance - e.relevance;
                    if (e.language && t.language) {
                        if (N(e.language).supersetOf === t.language) return 1;
                        if (N(t.language).supersetOf === e.language) return -1;
                    }
                    return 0;
                }), s = a;
                return s.secondBest = o, s;
            }
            function C(e, t, n) {
                let r = t && i[t] || n;
                e.classList.add(`hljs`), e.classList.add(`language-${r}`);
            }
            function w(e) {
                let t = null, n = d(e);
                if (u(n)) return;
                if (z(`before:highlightElement`, {
                    el: e,
                    language: n
                }), e.dataset.highlighted) {
                    console.log("Element previously highlighted. To highlight again, first unset `dataset.highlighted`.", e);
                    return;
                }
                if (e.children.length > 0 && (l.ignoreUnescapedHTML || (console.warn(`One of your code blocks includes unescaped HTML. This is a potentially serious security risk.`), console.warn(`https://github.com/highlightjs/highlight.js/wiki/security`), console.warn(`The element with unescaped HTML:`), console.warn(e)), l.throwUnescapedHTML)) throw new Ce(`One of your code blocks includes unescaped HTML.`, e.innerHTML);
                t = e;
                let r = t.textContent, i = n ? p(r, {
                    language: n,
                    ignoreIllegals: !0
                }) : S(r);
                e.innerHTML = i.value, e.dataset.highlighted = `yes`, C(e, n, i.language), e.result = {
                    language: i.language,
                    re: i.relevance,
                    relevance: i.relevance
                }, i.secondBest && (e.secondBest = {
                    language: i.secondBest.language,
                    relevance: i.secondBest.relevance
                }), z(`after:highlightElement`, {
                    el: e,
                    result: i,
                    text: r
                });
            }
            function T(e) {
                l = Te(l, e);
            }
            let E = ()=>{
                k(), Y(`10.6.0`, `initHighlighting() deprecated.  Use highlightAll() now.`);
            };
            function D() {
                k(), Y(`10.6.0`, `initHighlightingOnLoad() deprecated.  Use highlightAll() now.`);
            }
            let O = !1;
            function k() {
                function e() {
                    k();
                }
                if (document.readyState === `loading`) {
                    O || window.addEventListener(`DOMContentLoaded`, e, !1), O = !0;
                    return;
                }
                document.querySelectorAll(l.cssSelector).forEach(w);
            }
            function A(n, r) {
                let i = null;
                try {
                    i = r(e);
                } catch (e) {
                    if (J(`Language definition for '{}' could not be registered.`.replace(`{}`, n)), o) J(e);
                    else throw e;
                    i = c;
                }
                i.name ||= n, t[n] = i, i.rawDefinition = r.bind(null, e), i.aliases && P(i.aliases, {
                    languageName: n
                });
            }
            function j(e) {
                delete t[e];
                for (let t of Object.keys(i))i[t] === e && delete i[t];
            }
            function M() {
                return Object.keys(t);
            }
            function N(e) {
                return e = (e || ``).toLowerCase(), t[e] || t[i[e]];
            }
            function P(e, { languageName: t }) {
                typeof e == `string` && (e = [
                    e
                ]), e.forEach((e)=>{
                    i[e.toLowerCase()] = t;
                });
            }
            function F(e) {
                let t = N(e);
                return t && !t.disableAutodetect;
            }
            function I(e) {
                e[`before:highlightBlock`] && !e[`before:highlightElement`] && (e[`before:highlightElement`] = (t)=>{
                    e[`before:highlightBlock`](Object.assign({
                        block: t.el
                    }, t));
                }), e[`after:highlightBlock`] && !e[`after:highlightElement`] && (e[`after:highlightElement`] = (t)=>{
                    e[`after:highlightBlock`](Object.assign({
                        block: t.el
                    }, t));
                });
            }
            function L(e) {
                I(e), a.push(e);
            }
            function R(e) {
                let t = a.indexOf(e);
                t !== -1 && a.splice(t, 1);
            }
            function z(e, t) {
                let n = e;
                a.forEach(function(e) {
                    e[n] && e[n](t);
                });
            }
            function B(e) {
                return Y(`10.7.0`, `highlightBlock will be removed entirely in v12.0`), Y(`10.7.0`, `Please use highlightElement now.`), w(e);
            }
            Object.assign(e, {
                highlight: p,
                highlightAuto: S,
                highlightAll: k,
                highlightElement: w,
                highlightBlock: B,
                configure: T,
                initHighlighting: E,
                initHighlightingOnLoad: D,
                registerLanguage: A,
                unregisterLanguage: j,
                listLanguages: M,
                getLanguage: N,
                registerAliases: P,
                autoDetection: F,
                inherit: Te,
                addPlugin: L,
                removePlugin: R
            }), e.debugMode = function() {
                o = !1;
            }, e.safeMode = function() {
                o = !0;
            }, e.versionString = Se, e.regex = {
                concat: _,
                lookahead: m,
                either: y,
                optional: g,
                anyNumberOfTimes: h
            };
            for(let e in W)typeof W[e] == `object` && n(W[e]);
            return Object.assign(e, W), e;
        }, Z = Oe({});
        Z.newInstance = ()=>Oe({}), t.exports = Z, Z.HighlightJS = Z, Z.default = Z;
    }), u = o((e, t)=>{
        function n(e) {
            let t = `[A-Za-z\u{410}-\u{42F}\u{430}-\u{44F}\u{451}\u{401}_][A-Za-z\u{410}-\u{42F}\u{430}-\u{44F}\u{451}\u{401}_0-9]+`, n = `\u{434}\u{430}\u{43B}\u{435}\u{435} \u{432}\u{43E}\u{437}\u{432}\u{440}\u{430}\u{442} \u{432}\u{44B}\u{437}\u{432}\u{430}\u{442}\u{44C}\u{438}\u{441}\u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{432}\u{44B}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{44C} \u{434}\u{43B}\u{44F} \u{435}\u{441}\u{43B}\u{438} \u{438} \u{438}\u{437} \u{438}\u{43B}\u{438} \u{438}\u{43D}\u{430}\u{447}\u{435} \u{438}\u{43D}\u{430}\u{447}\u{435}\u{435}\u{441}\u{43B}\u{438} \u{438}\u{441}\u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{43A}\u{430}\u{436}\u{434}\u{43E}\u{433}\u{43E} \u{43A}\u{43E}\u{43D}\u{435}\u{446}\u{435}\u{441}\u{43B}\u{438} \u{43A}\u{43E}\u{43D}\u{435}\u{446}\u{43F}\u{43E}\u{43F}\u{44B}\u{442}\u{43A}\u{438} \u{43A}\u{43E}\u{43D}\u{435}\u{446}\u{446}\u{438}\u{43A}\u{43B}\u{430} \u{43D}\u{435} \u{43D}\u{43E}\u{432}\u{44B}\u{439} \u{43F}\u{435}\u{440}\u{435}\u{439}\u{442}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{43C} \u{43F}\u{43E} \u{43F}\u{43E}\u{43A}\u{430} \u{43F}\u{43E}\u{43F}\u{44B}\u{442}\u{43A}\u{430} \u{43F}\u{440}\u{435}\u{440}\u{432}\u{430}\u{442}\u{44C} \u{43F}\u{440}\u{43E}\u{434}\u{43E}\u{43B}\u{436}\u{438}\u{442}\u{44C} \u{442}\u{43E}\u{433}\u{434}\u{430} \u{446}\u{438}\u{43A}\u{43B} \u{44D}\u{43A}\u{441}\u{43F}\u{43E}\u{440}\u{442} `, r = `null \u{438}\u{441}\u{442}\u{438}\u{43D}\u{430} \u{43B}\u{43E}\u{436}\u{44C} \u{43D}\u{435}\u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{43E}`, i = e.inherit(e.NUMBER_MODE), a = {
                className: `string`,
                begin: `"|\\|`,
                end: `"|$`,
                contains: [
                    {
                        begin: `""`
                    }
                ]
            }, o = {
                begin: `'`,
                end: `'`,
                excludeBegin: !0,
                excludeEnd: !0,
                contains: [
                    {
                        className: `number`,
                        begin: `\\d{4}([\\.\\\\/:-]?\\d{2}){0,5}`
                    }
                ]
            }, s = {
                match: /[;()+\-:=,]/,
                className: `punctuation`,
                relevance: 0
            }, c = e.inherit(e.C_LINE_COMMENT_MODE), l = {
                className: `meta`,
                begin: `#|&`,
                end: `$`,
                keywords: {
                    $pattern: t,
                    keyword: n + `\u{437}\u{430}\u{433}\u{440}\u{443}\u{437}\u{438}\u{442}\u{44C}\u{438}\u{437}\u{444}\u{430}\u{439}\u{43B}\u{430} \u{432}\u{435}\u{431}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442} \u{432}\u{43C}\u{435}\u{441}\u{442}\u{43E} \u{432}\u{43D}\u{435}\u{448}\u{43D}\u{435}\u{435}\u{441}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{435}\u{43D}\u{438}\u{435} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442} \u{43A}\u{43E}\u{43D}\u{435}\u{446}\u{43E}\u{431}\u{43B}\u{430}\u{441}\u{442}\u{438} \u{43C}\u{43E}\u{431}\u{438}\u{43B}\u{44C}\u{43D}\u{43E}\u{435}\u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442} \u{43C}\u{43E}\u{431}\u{438}\u{43B}\u{44C}\u{43D}\u{43E}\u{435}\u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{441}\u{435}\u{440}\u{432}\u{435}\u{440} \u{43D}\u{430}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{435} \u{43D}\u{430}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{435}\u{43D}\u{430}\u{441}\u{435}\u{440}\u{432}\u{435}\u{440}\u{435} \u{43D}\u{430}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{435}\u{43D}\u{430}\u{441}\u{435}\u{440}\u{432}\u{435}\u{440}\u{435}\u{431}\u{435}\u{437}\u{43A}\u{43E}\u{43D}\u{442}\u{435}\u{43A}\u{441}\u{442}\u{430} \u{43D}\u{430}\u{441}\u{435}\u{440}\u{432}\u{435}\u{440}\u{435} \u{43D}\u{430}\u{441}\u{435}\u{440}\u{432}\u{435}\u{440}\u{435}\u{431}\u{435}\u{437}\u{43A}\u{43E}\u{43D}\u{442}\u{435}\u{43A}\u{441}\u{442}\u{430} \u{43E}\u{431}\u{43B}\u{430}\u{441}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{434} \u{43F}\u{43E}\u{441}\u{43B}\u{435} \u{441}\u{435}\u{440}\u{432}\u{435}\u{440} \u{442}\u{43E}\u{43B}\u{441}\u{442}\u{44B}\u{439}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{43E}\u{431}\u{44B}\u{447}\u{43D}\u{43E}\u{435}\u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435} \u{442}\u{43E}\u{43B}\u{441}\u{442}\u{44B}\u{439}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{443}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{44F}\u{435}\u{43C}\u{43E}\u{435}\u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435} \u{442}\u{43E}\u{43D}\u{43A}\u{438}\u{439}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442} `
                },
                contains: [
                    c
                ]
            }, u = {
                className: `symbol`,
                begin: `~`,
                end: `;|:`,
                excludeEnd: !0
            }, d = {
                className: `function`,
                variants: [
                    {
                        begin: `\u{43F}\u{440}\u{43E}\u{446}\u{435}\u{434}\u{443}\u{440}\u{430}|\u{444}\u{443}\u{43D}\u{43A}\u{446}\u{438}\u{44F}`,
                        end: `\\)`,
                        keywords: `\u{43F}\u{440}\u{43E}\u{446}\u{435}\u{434}\u{443}\u{440}\u{430} \u{444}\u{443}\u{43D}\u{43A}\u{446}\u{438}\u{44F}`
                    },
                    {
                        begin: `\u{43A}\u{43E}\u{43D}\u{435}\u{446}\u{43F}\u{440}\u{43E}\u{446}\u{435}\u{434}\u{443}\u{440}\u{44B}|\u{43A}\u{43E}\u{43D}\u{435}\u{446}\u{444}\u{443}\u{43D}\u{43A}\u{446}\u{438}\u{438}`,
                        keywords: `\u{43A}\u{43E}\u{43D}\u{435}\u{446}\u{43F}\u{440}\u{43E}\u{446}\u{435}\u{434}\u{443}\u{440}\u{44B} \u{43A}\u{43E}\u{43D}\u{435}\u{446}\u{444}\u{443}\u{43D}\u{43A}\u{446}\u{438}\u{438}`
                    }
                ],
                contains: [
                    {
                        begin: `\\(`,
                        end: `\\)`,
                        endsParent: !0,
                        contains: [
                            {
                                className: `params`,
                                begin: t,
                                end: `,`,
                                excludeEnd: !0,
                                endsWithParent: !0,
                                keywords: {
                                    $pattern: t,
                                    keyword: `\u{437}\u{43D}\u{430}\u{447}`,
                                    literal: r
                                },
                                contains: [
                                    i,
                                    a,
                                    o
                                ]
                            },
                            c
                        ]
                    },
                    e.inherit(e.TITLE_MODE, {
                        begin: t
                    })
                ]
            };
            return {
                name: `1C:Enterprise`,
                case_insensitive: !0,
                keywords: {
                    $pattern: t,
                    keyword: n,
                    built_in: `\u{440}\u{430}\u{437}\u{434}\u{435}\u{43B}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446} \u{440}\u{430}\u{437}\u{434}\u{435}\u{43B}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{441}\u{442}\u{440}\u{43E}\u{43A} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{442}\u{430}\u{431}\u{443}\u{43B}\u{44F}\u{446}\u{438}\u{438} ansitooem oemtoansi \u{432}\u{432}\u{435}\u{441}\u{442}\u{438}\u{432}\u{438}\u{434}\u{441}\u{443}\u{431}\u{43A}\u{43E}\u{43D}\u{442}\u{43E} \u{432}\u{432}\u{435}\u{441}\u{442}\u{438}\u{43F}\u{435}\u{440}\u{435}\u{447}\u{438}\u{441}\u{43B}\u{435}\u{43D}\u{438}\u{435} \u{432}\u{432}\u{435}\u{441}\u{442}\u{438}\u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434} \u{432}\u{432}\u{435}\u{441}\u{442}\u{438}\u{43F}\u{43B}\u{430}\u{43D}\u{441}\u{447}\u{435}\u{442}\u{43E}\u{432} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{439}\u{43F}\u{43B}\u{430}\u{43D}\u{441}\u{447}\u{435}\u{442}\u{43E}\u{432} \u{434}\u{430}\u{442}\u{430}\u{433}\u{43E}\u{434} \u{434}\u{430}\u{442}\u{430}\u{43C}\u{435}\u{441}\u{44F}\u{446} \u{434}\u{430}\u{442}\u{430}\u{447}\u{438}\u{441}\u{43B}\u{43E} \u{437}\u{430}\u{433}\u{43E}\u{43B}\u{43E}\u{432}\u{43E}\u{43A}\u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{44B} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}\u{432}\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{443} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}\u{438}\u{437}\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{438} \u{43A}\u{430}\u{442}\u{430}\u{43B}\u{43E}\u{433}\u{438}\u{431} \u{43A}\u{430}\u{442}\u{430}\u{43B}\u{43E}\u{433}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F} \u{43A}\u{43E}\u{434}\u{441}\u{438}\u{43C}\u{432} \u{43A}\u{43E}\u{43D}\u{433}\u{43E}\u{434}\u{430} \u{43A}\u{43E}\u{43D}\u{435}\u{446}\u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}\u{430}\u{431}\u{438} \u{43A}\u{43E}\u{43D}\u{435}\u{446}\u{440}\u{430}\u{441}\u{441}\u{447}\u{438}\u{442}\u{430}\u{43D}\u{43D}\u{43E}\u{433}\u{43E}\u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}\u{430}\u{431}\u{438} \u{43A}\u{43E}\u{43D}\u{435}\u{446}\u{441}\u{442}\u{430}\u{43D}\u{434}\u{430}\u{440}\u{442}\u{43D}\u{43E}\u{433}\u{43E}\u{438}\u{43D}\u{442}\u{435}\u{440}\u{432}\u{430}\u{43B}\u{430} \u{43A}\u{43E}\u{43D}\u{43A}\u{432}\u{430}\u{440}\u{442}\u{430}\u{43B}\u{430} \u{43A}\u{43E}\u{43D}\u{43C}\u{435}\u{441}\u{44F}\u{446}\u{430} \u{43A}\u{43E}\u{43D}\u{43D}\u{435}\u{434}\u{435}\u{43B}\u{438} \u{43B}\u{43E}\u{433} \u{43B}\u{43E}\u{433}10 \u{43C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{435}\u{43A}\u{43E}\u{43B}\u{438}\u{447}\u{435}\u{441}\u{442}\u{432}\u{43E}\u{441}\u{443}\u{431}\u{43A}\u{43E}\u{43D}\u{442}\u{43E} \u{43D}\u{430}\u{437}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{438}\u{43D}\u{442}\u{435}\u{440}\u{444}\u{435}\u{439}\u{441}\u{430} \u{43D}\u{430}\u{437}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{43D}\u{430}\u{431}\u{43E}\u{440}\u{430}\u{43F}\u{440}\u{430}\u{432} \u{43D}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{438}\u{442}\u{44C}\u{432}\u{438}\u{434} \u{43D}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{438}\u{442}\u{44C}\u{441}\u{447}\u{435}\u{442} \u{43D}\u{430}\u{439}\u{442}\u{438}\u{441}\u{441}\u{44B}\u{43B}\u{43A}\u{438} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{43E}\u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}\u{430}\u{431}\u{438} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{43E}\u{441}\u{442}\u{430}\u{43D}\u{434}\u{430}\u{440}\u{442}\u{43D}\u{43E}\u{433}\u{43E}\u{438}\u{43D}\u{442}\u{435}\u{440}\u{432}\u{430}\u{43B}\u{430} \u{43D}\u{430}\u{447}\u{433}\u{43E}\u{434}\u{430} \u{43D}\u{430}\u{447}\u{43A}\u{432}\u{430}\u{440}\u{442}\u{430}\u{43B}\u{430} \u{43D}\u{430}\u{447}\u{43C}\u{435}\u{441}\u{44F}\u{446}\u{430} \u{43D}\u{430}\u{447}\u{43D}\u{435}\u{434}\u{435}\u{43B}\u{438} \u{43D}\u{43E}\u{43C}\u{435}\u{440}\u{434}\u{43D}\u{44F}\u{433}\u{43E}\u{434}\u{430} \u{43D}\u{43E}\u{43C}\u{435}\u{440}\u{434}\u{43D}\u{44F}\u{43D}\u{435}\u{434}\u{435}\u{43B}\u{438} \u{43D}\u{43E}\u{43C}\u{435}\u{440}\u{43D}\u{435}\u{434}\u{435}\u{43B}\u{438}\u{433}\u{43E}\u{434}\u{430} \u{43E}\u{431}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{43A}\u{430}\u{43E}\u{436}\u{438}\u{434}\u{430}\u{43D}\u{438}\u{44F} \u{43E}\u{441}\u{43D}\u{43E}\u{432}\u{43D}\u{43E}\u{439}\u{436}\u{443}\u{440}\u{43D}\u{430}\u{43B}\u{440}\u{430}\u{441}\u{447}\u{435}\u{442}\u{43E}\u{432} \u{43E}\u{441}\u{43D}\u{43E}\u{432}\u{43D}\u{43E}\u{439}\u{43F}\u{43B}\u{430}\u{43D}\u{441}\u{447}\u{435}\u{442}\u{43E}\u{432} \u{43E}\u{441}\u{43D}\u{43E}\u{432}\u{43D}\u{43E}\u{439}\u{44F}\u{437}\u{44B}\u{43A} \u{43E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{44C}\u{43E}\u{43A}\u{43D}\u{43E}\u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{439} \u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}\u{441}\u{442}\u{440} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{432}\u{440}\u{435}\u{43C}\u{44F}\u{442}\u{430} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{434}\u{430}\u{442}\u{443}\u{442}\u{430} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{442}\u{430} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{44F}\u{43E}\u{442}\u{431}\u{43E}\u{440}\u{430} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{43F}\u{43E}\u{437}\u{438}\u{446}\u{438}\u{44E}\u{442}\u{430} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{43F}\u{443}\u{441}\u{442}\u{43E}\u{435}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{442}\u{430} \u{43F}\u{440}\u{435}\u{444}\u{438}\u{43A}\u{441}\u{430}\u{432}\u{442}\u{43E}\u{43D}\u{443}\u{43C}\u{435}\u{440}\u{430}\u{446}\u{438}\u{438} \u{43F}\u{440}\u{43E}\u{43F}\u{438}\u{441}\u{44C} \u{43F}\u{443}\u{441}\u{442}\u{43E}\u{435}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{440}\u{430}\u{437}\u{43C} \u{440}\u{430}\u{437}\u{43E}\u{431}\u{440}\u{430}\u{442}\u{44C}\u{43F}\u{43E}\u{437}\u{438}\u{446}\u{438}\u{44E}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430} \u{440}\u{430}\u{441}\u{441}\u{447}\u{438}\u{442}\u{430}\u{442}\u{44C}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{44B}\u{43D}\u{430} \u{440}\u{430}\u{441}\u{441}\u{447}\u{438}\u{442}\u{430}\u{442}\u{44C}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{44B}\u{43F}\u{43E} \u{441}\u{438}\u{43C}\u{432} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C}\u{43E}\u{431}\u{44A}\u{435}\u{43A}\u{442} \u{441}\u{442}\u{430}\u{442}\u{443}\u{441}\u{432}\u{43E}\u{437}\u{432}\u{440}\u{430}\u{442}\u{430} \u{441}\u{442}\u{440}\u{43A}\u{43E}\u{43B}\u{438}\u{447}\u{435}\u{441}\u{442}\u{432}\u{43E}\u{441}\u{442}\u{440}\u{43E}\u{43A} \u{441}\u{444}\u{43E}\u{440}\u{43C}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C}\u{43F}\u{43E}\u{437}\u{438}\u{446}\u{438}\u{44E}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430} \u{441}\u{447}\u{435}\u{442}\u{43F}\u{43E}\u{43A}\u{43E}\u{434}\u{443} \u{442}\u{435}\u{43A}\u{443}\u{449}\u{435}\u{435}\u{432}\u{440}\u{435}\u{43C}\u{44F} \u{442}\u{438}\u{43F}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{44F} \u{442}\u{438}\u{43F}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{44F}\u{441}\u{442}\u{440} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{442}\u{430}\u{43D}\u{430} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{442}\u{430}\u{43F}\u{43E} \u{444}\u{438}\u{43A}\u{441}\u{448}\u{430}\u{431}\u{43B}\u{43E}\u{43D} \u{448}\u{430}\u{431}\u{43B}\u{43E}\u{43D} acos asin atan base64\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435} base64\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{430} cos exp log log10 pow sin sqrt tan xml\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435} xml\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{430} xml\u{442}\u{438}\u{43F} xml\u{442}\u{438}\u{43F}\u{437}\u{43D}\u{447} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{435}\u{43E}\u{43A}\u{43D}\u{43E} \u{431}\u{435}\u{437}\u{43E}\u{43F}\u{430}\u{441}\u{43D}\u{44B}\u{439}\u{440}\u{435}\u{436}\u{438}\u{43C} \u{431}\u{435}\u{437}\u{43E}\u{43F}\u{430}\u{441}\u{43D}\u{44B}\u{439}\u{440}\u{435}\u{436}\u{438}\u{43C}\u{440}\u{430}\u{437}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{44F}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{431}\u{443}\u{43B}\u{435}\u{432}\u{43E} \u{432}\u{432}\u{435}\u{441}\u{442}\u{438}\u{434}\u{430}\u{442}\u{443} \u{432}\u{432}\u{435}\u{441}\u{442}\u{438}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{432}\u{432}\u{435}\u{441}\u{442}\u{438}\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{443} \u{432}\u{432}\u{435}\u{441}\u{442}\u{438}\u{447}\u{438}\u{441}\u{43B}\u{43E} \u{432}\u{43E}\u{437}\u{43C}\u{43E}\u{436}\u{43D}\u{43E}\u{441}\u{442}\u{44C}\u{447}\u{442}\u{435}\u{43D}\u{438}\u{44F}xml \u{432}\u{43E}\u{43F}\u{440}\u{43E}\u{441} \u{432}\u{43E}\u{441}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{432}\u{440}\u{435}\u{433} \u{432}\u{44B}\u{433}\u{440}\u{443}\u{437}\u{438}\u{442}\u{44C}\u{436}\u{443}\u{440}\u{43D}\u{430}\u{43B}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{438} \u{432}\u{44B}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{44C}\u{43E}\u{431}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{43A}\u{443}\u{43E}\u{43F}\u{43E}\u{432}\u{435}\u{449}\u{435}\u{43D}\u{438}\u{44F} \u{432}\u{44B}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{44C}\u{43F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{43A}\u{443}\u{43F}\u{440}\u{430}\u{432}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{430} \u{432}\u{44B}\u{447}\u{438}\u{441}\u{43B}\u{438}\u{442}\u{44C} \u{433}\u{43E}\u{434} \u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{435}\u{444}\u{43E}\u{440}\u{43C}\u{44B}\u{432}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{434}\u{430}\u{442}\u{430} \u{434}\u{435}\u{43D}\u{44C} \u{434}\u{435}\u{43D}\u{44C}\u{433}\u{43E}\u{434}\u{430} \u{434}\u{435}\u{43D}\u{44C}\u{43D}\u{435}\u{434}\u{435}\u{43B}\u{438} \u{434}\u{43E}\u{431}\u{430}\u{432}\u{438}\u{442}\u{44C}\u{43C}\u{435}\u{441}\u{44F}\u{446} \u{437}\u{430}\u{431}\u{43B}\u{43E}\u{43A}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{435}\u{434}\u{43B}\u{44F}\u{440}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F} \u{437}\u{430}\u{431}\u{43B}\u{43E}\u{43A}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{443}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{438}\u{442}\u{44C}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{443}\u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{44B} \u{437}\u{430}\u{433}\u{440}\u{443}\u{437}\u{438}\u{442}\u{44C}\u{432}\u{43D}\u{435}\u{448}\u{43D}\u{44E}\u{44E}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{435}\u{43D}\u{442}\u{443} \u{437}\u{430}\u{43A}\u{440}\u{44B}\u{442}\u{44C}\u{441}\u{43F}\u{440}\u{430}\u{432}\u{43A}\u{443} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{430}\u{442}\u{44C}json \u{437}\u{430}\u{43F}\u{438}\u{441}\u{430}\u{442}\u{44C}xml \u{437}\u{430}\u{43F}\u{438}\u{441}\u{430}\u{442}\u{44C}\u{434}\u{430}\u{442}\u{443}json \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C}\u{436}\u{443}\u{440}\u{43D}\u{430}\u{43B}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{438} \u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{44C}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{44F}\u{441}\u{432}\u{43E}\u{439}\u{441}\u{442}\u{432} \u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{438}\u{442}\u{44C}\u{440}\u{430}\u{437}\u{440}\u{435}\u{448}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F} \u{437}\u{430}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{442}\u{44C}\u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435} \u{437}\u{430}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{442}\u{44C}\u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{443} \u{437}\u{430}\u{444}\u{438}\u{43A}\u{441}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C}\u{442}\u{440}\u{430}\u{43D}\u{437}\u{430}\u{43A}\u{446}\u{438}\u{44E} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}\u{432}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{435}\u{444}\u{43E}\u{440}\u{43C}\u{44B} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}\u{432}\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{443}\u{432}\u{43D}\u{443}\u{442}\u{440} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}\u{432}\u{444}\u{430}\u{439}\u{43B} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}\u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{43E} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}\u{438}\u{437}\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{438}\u{432}\u{43D}\u{443}\u{442}\u{440} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}\u{438}\u{437}\u{444}\u{430}\u{439}\u{43B}\u{430} \u{438}\u{437}xml\u{442}\u{438}\u{43F}\u{430} \u{438}\u{43C}\u{43F}\u{43E}\u{440}\u{442}\u{43C}\u{43E}\u{434}\u{435}\u{43B}\u{438}xdto \u{438}\u{43C}\u{44F}\u{43A}\u{43E}\u{43C}\u{43F}\u{44C}\u{44E}\u{442}\u{435}\u{440}\u{430} \u{438}\u{43C}\u{44F}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F} \u{438}\u{43D}\u{438}\u{446}\u{438}\u{430}\u{43B}\u{438}\u{437}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C}\u{43F}\u{440}\u{435}\u{434}\u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{43D}\u{44B}\u{435}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{435} \u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F}\u{43E}\u{431}\u{43E}\u{448}\u{438}\u{431}\u{43A}\u{435} \u{43A}\u{430}\u{442}\u{430}\u{43B}\u{43E}\u{433}\u{431}\u{438}\u{431}\u{43B}\u{438}\u{43E}\u{442}\u{435}\u{43A}\u{438}\u{43C}\u{43E}\u{431}\u{438}\u{43B}\u{44C}\u{43D}\u{43E}\u{433}\u{43E}\u{443}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{441}\u{442}\u{432}\u{430} \u{43A}\u{430}\u{442}\u{430}\u{43B}\u{43E}\u{433}\u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{43D}\u{44B}\u{445}\u{444}\u{430}\u{439}\u{43B}\u{43E}\u{432} \u{43A}\u{430}\u{442}\u{430}\u{43B}\u{43E}\u{433}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432} \u{43A}\u{430}\u{442}\u{430}\u{43B}\u{43E}\u{433}\u{43F}\u{440}\u{43E}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{43A}\u{43E}\u{434}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C}\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{443} \u{43A}\u{43E}\u{434}\u{43B}\u{43E}\u{43A}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}\u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{43E}\u{439}\u{431}\u{430}\u{437}\u{44B} \u{43A}\u{43E}\u{434}\u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{430} \u{43A}\u{43E}\u{43C}\u{430}\u{43D}\u{434}\u{430}\u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{44B} \u{43A}\u{43E}\u{43D}\u{435}\u{446}\u{433}\u{43E}\u{434}\u{430} \u{43A}\u{43E}\u{43D}\u{435}\u{446}\u{434}\u{43D}\u{44F} \u{43A}\u{43E}\u{43D}\u{435}\u{446}\u{43A}\u{432}\u{430}\u{440}\u{442}\u{430}\u{43B}\u{430} \u{43A}\u{43E}\u{43D}\u{435}\u{446}\u{43C}\u{435}\u{441}\u{44F}\u{446}\u{430} \u{43A}\u{43E}\u{43D}\u{435}\u{446}\u{43C}\u{438}\u{43D}\u{443}\u{442}\u{44B} \u{43A}\u{43E}\u{43D}\u{435}\u{446}\u{43D}\u{435}\u{434}\u{435}\u{43B}\u{438} \u{43A}\u{43E}\u{43D}\u{435}\u{446}\u{447}\u{430}\u{441}\u{430} \u{43A}\u{43E}\u{43D}\u{444}\u{438}\u{433}\u{443}\u{440}\u{430}\u{446}\u{438}\u{44F}\u{431}\u{430}\u{437}\u{44B}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{438}\u{437}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{430}\u{434}\u{438}\u{43D}\u{430}\u{43C}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{438} \u{43A}\u{43E}\u{43D}\u{444}\u{438}\u{433}\u{443}\u{440}\u{430}\u{446}\u{438}\u{44F}\u{438}\u{437}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{430} \u{43A}\u{43E}\u{43F}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{435}\u{444}\u{43E}\u{440}\u{43C}\u{44B} \u{43A}\u{43E}\u{43F}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C}\u{444}\u{430}\u{439}\u{43B} \u{43A}\u{440}\u{430}\u{442}\u{43A}\u{43E}\u{435}\u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{43E}\u{448}\u{438}\u{431}\u{43A}\u{438} \u{43B}\u{435}\u{432} \u{43C}\u{430}\u{43A}\u{441} \u{43C}\u{435}\u{441}\u{442}\u{43D}\u{43E}\u{435}\u{432}\u{440}\u{435}\u{43C}\u{44F} \u{43C}\u{435}\u{441}\u{44F}\u{446} \u{43C}\u{438}\u{43D} \u{43C}\u{438}\u{43D}\u{443}\u{442}\u{430} \u{43C}\u{43E}\u{43D}\u{43E}\u{43F}\u{43E}\u{43B}\u{44C}\u{43D}\u{44B}\u{439}\u{440}\u{435}\u{436}\u{438}\u{43C} \u{43D}\u{430}\u{439}\u{442}\u{438} \u{43D}\u{430}\u{439}\u{442}\u{438}\u{43D}\u{435}\u{434}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{43C}\u{44B}\u{435}\u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{44B}xml \u{43D}\u{430}\u{439}\u{442}\u{438}\u{43E}\u{43A}\u{43D}\u{43E}\u{43F}\u{43E}\u{43D}\u{430}\u{432}\u{438}\u{433}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{43E}\u{439}\u{441}\u{441}\u{44B}\u{43B}\u{43A}\u{435} \u{43D}\u{430}\u{439}\u{442}\u{438}\u{43F}\u{43E}\u{43C}\u{435}\u{447}\u{435}\u{43D}\u{43D}\u{44B}\u{435}\u{43D}\u{430}\u{443}\u{434}\u{430}\u{43B}\u{435}\u{43D}\u{438}\u{435} \u{43D}\u{430}\u{439}\u{442}\u{438}\u{43F}\u{43E}\u{441}\u{441}\u{44B}\u{43B}\u{43A}\u{430}\u{43C} \u{43D}\u{430}\u{439}\u{442}\u{438}\u{444}\u{430}\u{439}\u{43B}\u{44B} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{43E}\u{433}\u{43E}\u{434}\u{430} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{43E}\u{434}\u{43D}\u{44F} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{43E}\u{43A}\u{432}\u{430}\u{440}\u{442}\u{430}\u{43B}\u{430} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{43E}\u{43C}\u{435}\u{441}\u{44F}\u{446}\u{430} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{43E}\u{43C}\u{438}\u{43D}\u{443}\u{442}\u{44B} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{43E}\u{43D}\u{435}\u{434}\u{435}\u{43B}\u{438} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{43E}\u{447}\u{430}\u{441}\u{430} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C}\u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{440}\u{430}\u{437}\u{440}\u{435}\u{448}\u{435}\u{43D}\u{438}\u{44F}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C}\u{437}\u{430}\u{43F}\u{443}\u{441}\u{43A}\u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C}\u{43A}\u{43E}\u{43F}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{444}\u{430}\u{439}\u{43B}\u{430} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C}\u{43F}\u{435}\u{440}\u{435}\u{43C}\u{435}\u{449}\u{435}\u{43D}\u{438}\u{435}\u{444}\u{430}\u{439}\u{43B}\u{430} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C}\u{43F}\u{43E}\u{434}\u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{43D}\u{438}\u{435}\u{432}\u{43D}\u{435}\u{448}\u{43D}\u{435}\u{439}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{435}\u{43D}\u{442}\u{44B} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C}\u{43F}\u{43E}\u{434}\u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{43D}\u{438}\u{435}\u{440}\u{430}\u{441}\u{448}\u{438}\u{440}\u{435}\u{43D}\u{438}\u{44F}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}\u{441}\u{43A}\u{440}\u{438}\u{43F}\u{442}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{435}\u{439} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C}\u{43F}\u{43E}\u{434}\u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{43D}\u{438}\u{435}\u{440}\u{430}\u{441}\u{448}\u{438}\u{440}\u{435}\u{43D}\u{438}\u{44F}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}\u{441}\u{444}\u{430}\u{439}\u{43B}\u{430}\u{43C}\u{438} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C}\u{43F}\u{43E}\u{438}\u{441}\u{43A}\u{444}\u{430}\u{439}\u{43B}\u{43E}\u{432} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C}\u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D}\u{438}\u{435}\u{43A}\u{430}\u{442}\u{430}\u{43B}\u{43E}\u{433}\u{430}\u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{43D}\u{44B}\u{445}\u{444}\u{430}\u{439}\u{43B}\u{43E}\u{432} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C}\u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D}\u{438}\u{435}\u{43A}\u{430}\u{442}\u{430}\u{43B}\u{43E}\u{433}\u{430}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C}\u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D}\u{438}\u{435}\u{440}\u{430}\u{431}\u{43E}\u{447}\u{435}\u{433}\u{43E}\u{43A}\u{430}\u{442}\u{430}\u{43B}\u{43E}\u{433}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C}\u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D}\u{438}\u{435}\u{444}\u{430}\u{439}\u{43B}\u{43E}\u{432} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C}\u{43F}\u{43E}\u{43C}\u{435}\u{449}\u{435}\u{43D}\u{438}\u{435}\u{444}\u{430}\u{439}\u{43B}\u{430} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C}\u{43F}\u{43E}\u{43C}\u{435}\u{449}\u{435}\u{43D}\u{438}\u{435}\u{444}\u{430}\u{439}\u{43B}\u{43E}\u{432} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C}\u{441}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{438}\u{435}\u{434}\u{432}\u{43E}\u{438}\u{447}\u{43D}\u{44B}\u{445}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{438}\u{437}\u{444}\u{430}\u{439}\u{43B}\u{430} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C}\u{441}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{438}\u{435}\u{43A}\u{430}\u{442}\u{430}\u{43B}\u{43E}\u{433}\u{430} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C}\u{442}\u{440}\u{430}\u{43D}\u{437}\u{430}\u{43A}\u{446}\u{438}\u{44E} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C}\u{443}\u{434}\u{430}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{444}\u{430}\u{439}\u{43B}\u{43E}\u{432} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C}\u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43A}\u{443}\u{432}\u{43D}\u{435}\u{448}\u{43D}\u{435}\u{439}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{435}\u{43D}\u{442}\u{44B} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C}\u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43A}\u{443}\u{440}\u{430}\u{441}\u{448}\u{438}\u{440}\u{435}\u{43D}\u{438}\u{44F}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}\u{441}\u{43A}\u{440}\u{438}\u{43F}\u{442}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{435}\u{439} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C}\u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43A}\u{443}\u{440}\u{430}\u{441}\u{448}\u{438}\u{440}\u{435}\u{43D}\u{438}\u{44F}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}\u{441}\u{444}\u{430}\u{439}\u{43B}\u{430}\u{43C}\u{438} \u{43D}\u{435}\u{434}\u{435}\u{43B}\u{44F}\u{433}\u{43E}\u{434}\u{430} \u{43D}\u{435}\u{43E}\u{431}\u{445}\u{43E}\u{434}\u{438}\u{43C}\u{43E}\u{441}\u{442}\u{44C}\u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{438}\u{44F}\u{441}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{435}\u{43D}\u{438}\u{44F} \u{43D}\u{43E}\u{43C}\u{435}\u{440}\u{441}\u{435}\u{430}\u{43D}\u{441}\u{430}\u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{43E}\u{439}\u{431}\u{430}\u{437}\u{44B} \u{43D}\u{43E}\u{43C}\u{435}\u{440}\u{441}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{435}\u{43D}\u{438}\u{44F}\u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{43E}\u{439}\u{431}\u{430}\u{437}\u{44B} \u{43D}\u{440}\u{435}\u{433} \u{43D}\u{441}\u{442}\u{440} \u{43E}\u{431}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{438}\u{43D}\u{442}\u{435}\u{440}\u{444}\u{435}\u{439}\u{441} \u{43E}\u{431}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{43D}\u{443}\u{43C}\u{435}\u{440}\u{430}\u{446}\u{438}\u{44E}\u{43E}\u{431}\u{44A}\u{435}\u{43A}\u{442}\u{43E}\u{432} \u{43E}\u{431}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{43F}\u{43E}\u{432}\u{442}\u{43E}\u{440}\u{43D}\u{43E}\u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{443}\u{435}\u{43C}\u{44B}\u{435}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{44F} \u{43E}\u{431}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{43A}\u{430}\u{43F}\u{440}\u{435}\u{440}\u{44B}\u{432}\u{430}\u{43D}\u{438}\u{44F}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F} \u{43E}\u{431}\u{44A}\u{435}\u{434}\u{438}\u{43D}\u{438}\u{442}\u{44C}\u{444}\u{430}\u{439}\u{43B}\u{44B} \u{43E}\u{43A}\u{440} \u{43E}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{438}\u{435}\u{43E}\u{448}\u{438}\u{431}\u{43A}\u{438} \u{43E}\u{43F}\u{43E}\u{432}\u{435}\u{441}\u{442}\u{438}\u{442}\u{44C} \u{43E}\u{43F}\u{43E}\u{432}\u{435}\u{441}\u{442}\u{438}\u{442}\u{44C}\u{43E}\u{431}\u{438}\u{437}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{438}\u{438} \u{43E}\u{442}\u{43A}\u{43B}\u{44E}\u{447}\u{438}\u{442}\u{44C}\u{43E}\u{431}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{447}\u{438}\u{43A}\u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{430}\u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{435}\u{43A}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{430}\u{43B}\u{438}\u{446}\u{435}\u{43D}\u{437}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F} \u{43E}\u{442}\u{43A}\u{43B}\u{44E}\u{447}\u{438}\u{442}\u{44C}\u{43E}\u{431}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{447}\u{438}\u{43A}\u{43E}\u{436}\u{438}\u{434}\u{430}\u{43D}\u{438}\u{44F} \u{43E}\u{442}\u{43A}\u{43B}\u{44E}\u{447}\u{438}\u{442}\u{44C}\u{43E}\u{431}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{447}\u{438}\u{43A}\u{43E}\u{43F}\u{43E}\u{432}\u{435}\u{449}\u{435}\u{43D}\u{438}\u{44F} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44C}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44C}\u{438}\u{43D}\u{434}\u{435}\u{43A}\u{441}\u{441}\u{43F}\u{440}\u{430}\u{432}\u{43A}\u{438} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44C}\u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{43D}\u{438}\u{435}\u{441}\u{43F}\u{440}\u{430}\u{432}\u{43A}\u{438} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44C}\u{441}\u{43F}\u{440}\u{430}\u{432}\u{43A}\u{443} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44C}\u{444}\u{43E}\u{440}\u{43C}\u{443} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44C}\u{444}\u{43E}\u{440}\u{43C}\u{443}\u{43C}\u{43E}\u{434}\u{430}\u{43B}\u{44C}\u{43D}\u{43E} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C}\u{442}\u{440}\u{430}\u{43D}\u{437}\u{430}\u{43A}\u{446}\u{438}\u{44E} \u{43E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{44C}\u{436}\u{443}\u{440}\u{43D}\u{430}\u{43B}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{438} \u{43E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{44C}\u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{43A}\u{438}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F} \u{43E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{44C}\u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{44F} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{44B}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{430} \u{43F}\u{435}\u{440}\u{435}\u{439}\u{442}\u{438}\u{43F}\u{43E}\u{43D}\u{430}\u{432}\u{438}\u{433}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{43E}\u{439}\u{441}\u{441}\u{44B}\u{43B}\u{43A}\u{435} \u{43F}\u{435}\u{440}\u{435}\u{43C}\u{435}\u{441}\u{442}\u{438}\u{442}\u{44C}\u{444}\u{430}\u{439}\u{43B} \u{43F}\u{43E}\u{434}\u{43A}\u{43B}\u{44E}\u{447}\u{438}\u{442}\u{44C}\u{432}\u{43D}\u{435}\u{448}\u{43D}\u{44E}\u{44E}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{435}\u{43D}\u{442}\u{443} \u{43F}\u{43E}\u{434}\u{43A}\u{43B}\u{44E}\u{447}\u{438}\u{442}\u{44C}\u{43E}\u{431}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{447}\u{438}\u{43A}\u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{430}\u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{435}\u{43A}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{430}\u{43B}\u{438}\u{446}\u{435}\u{43D}\u{437}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F} \u{43F}\u{43E}\u{434}\u{43A}\u{43B}\u{44E}\u{447}\u{438}\u{442}\u{44C}\u{43E}\u{431}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{447}\u{438}\u{43A}\u{43E}\u{436}\u{438}\u{434}\u{430}\u{43D}\u{438}\u{44F} \u{43F}\u{43E}\u{434}\u{43A}\u{43B}\u{44E}\u{447}\u{438}\u{442}\u{44C}\u{43E}\u{431}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{447}\u{438}\u{43A}\u{43E}\u{43F}\u{43E}\u{432}\u{435}\u{449}\u{435}\u{43D}\u{438}\u{44F} \u{43F}\u{43E}\u{434}\u{43A}\u{43B}\u{44E}\u{447}\u{438}\u{442}\u{44C}\u{440}\u{430}\u{441}\u{448}\u{438}\u{440}\u{435}\u{43D}\u{438}\u{435}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}\u{441}\u{43A}\u{440}\u{438}\u{43F}\u{442}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{435}\u{439} \u{43F}\u{43E}\u{434}\u{43A}\u{43B}\u{44E}\u{447}\u{438}\u{442}\u{44C}\u{440}\u{430}\u{441}\u{448}\u{438}\u{440}\u{435}\u{43D}\u{438}\u{435}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}\u{441}\u{444}\u{430}\u{439}\u{43B}\u{430}\u{43C}\u{438} \u{43F}\u{43E}\u{434}\u{440}\u{43E}\u{431}\u{43D}\u{43E}\u{435}\u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{43E}\u{448}\u{438}\u{431}\u{43A}\u{438} \u{43F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{44C}\u{432}\u{432}\u{43E}\u{434}\u{434}\u{430}\u{442}\u{44B} \u{43F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{44C}\u{432}\u{432}\u{43E}\u{434}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{44F} \u{43F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{44C}\u{432}\u{432}\u{43E}\u{434}\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{438} \u{43F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{44C}\u{432}\u{432}\u{43E}\u{434}\u{447}\u{438}\u{441}\u{43B}\u{430} \u{43F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{44C}\u{432}\u{43E}\u{43F}\u{440}\u{43E}\u{441} \u{43F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{44C}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{43F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{44C}\u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44E}\u{43E}\u{431}\u{43E}\u{448}\u{438}\u{431}\u{43A}\u{435} \u{43F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{44C}\u{43D}\u{430}\u{43A}\u{430}\u{440}\u{442}\u{435} \u{43F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{44C}\u{43E}\u{43F}\u{43E}\u{432}\u{435}\u{449}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F} \u{43F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{44C}\u{43F}\u{440}\u{435}\u{434}\u{443}\u{43F}\u{440}\u{435}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{435} \u{43F}\u{43E}\u{43B}\u{43D}\u{43E}\u{435}\u{438}\u{43C}\u{44F}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}com\u{43E}\u{431}\u{44A}\u{435}\u{43A}\u{442} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}xml\u{442}\u{438}\u{43F} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{430}\u{434}\u{440}\u{435}\u{441}\u{43F}\u{43E}\u{43C}\u{435}\u{441}\u{442}\u{43E}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44E} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{431}\u{43B}\u{43E}\u{43A}\u{438}\u{440}\u{43E}\u{432}\u{43A}\u{443}\u{441}\u{435}\u{430}\u{43D}\u{441}\u{43E}\u{432} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{432}\u{440}\u{435}\u{43C}\u{44F}\u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{438}\u{44F}\u{441}\u{43F}\u{44F}\u{449}\u{435}\u{433}\u{43E}\u{441}\u{435}\u{430}\u{43D}\u{441}\u{430} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{432}\u{440}\u{435}\u{43C}\u{44F}\u{437}\u{430}\u{441}\u{44B}\u{43F}\u{430}\u{43D}\u{438}\u{44F}\u{43F}\u{430}\u{441}\u{441}\u{438}\u{432}\u{43D}\u{43E}\u{433}\u{43E}\u{441}\u{435}\u{430}\u{43D}\u{441}\u{430} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{432}\u{440}\u{435}\u{43C}\u{44F}\u{43E}\u{436}\u{438}\u{434}\u{430}\u{43D}\u{438}\u{44F}\u{431}\u{43B}\u{43E}\u{43A}\u{438}\u{440}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{435}\u{432}\u{44B}\u{431}\u{43E}\u{440}\u{430} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{434}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{439}\u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{430}\u{43B}\u{438}\u{446}\u{435}\u{43D}\u{437}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{434}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{43C}\u{44B}\u{435}\u{43A}\u{43E}\u{434}\u{44B}\u{43B}\u{43E}\u{43A}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{434}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{43C}\u{44B}\u{435}\u{447}\u{430}\u{441}\u{43E}\u{432}\u{44B}\u{435}\u{43F}\u{43E}\u{44F}\u{441}\u{430} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{437}\u{430}\u{433}\u{43E}\u{43B}\u{43E}\u{432}\u{43E}\u{43A}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{441}\u{43A}\u{43E}\u{433}\u{43E}\u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{437}\u{430}\u{433}\u{43E}\u{43B}\u{43E}\u{432}\u{43E}\u{43A}\u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{44F}\u{43E}\u{442}\u{431}\u{43E}\u{440}\u{430}\u{436}\u{443}\u{440}\u{43D}\u{430}\u{43B}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{438} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{438}\u{434}\u{435}\u{43D}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440}\u{43A}\u{43E}\u{43D}\u{444}\u{438}\u{433}\u{443}\u{440}\u{430}\u{446}\u{438}\u{438} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{438}\u{437}\u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{43D}\u{43E}\u{433}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{438}\u{43B}\u{438}\u{449}\u{430} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{438}\u{43C}\u{44F}\u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{43D}\u{43E}\u{433}\u{43E}\u{444}\u{430}\u{439}\u{43B}\u{430} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{438}\u{43C}\u{44F}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{430}\u{43B}\u{438}\u{446}\u{435}\u{43D}\u{437}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44E}\u{44D}\u{43A}\u{440}\u{430}\u{43D}\u{43E}\u{432}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{430} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{436}\u{443}\u{440}\u{43D}\u{430}\u{43B}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{438} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{441}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{44F}\u{436}\u{443}\u{440}\u{43D}\u{430}\u{43B}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{438} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{43A}\u{440}\u{430}\u{442}\u{43A}\u{438}\u{439}\u{437}\u{430}\u{433}\u{43E}\u{43B}\u{43E}\u{432}\u{43E}\u{43A}\u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{43C}\u{430}\u{43A}\u{435}\u{442}\u{43E}\u{444}\u{43E}\u{440}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{43C}\u{430}\u{441}\u{43A}\u{443}\u{432}\u{441}\u{435}\u{444}\u{430}\u{439}\u{43B}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{43C}\u{430}\u{441}\u{43A}\u{443}\u{432}\u{441}\u{435}\u{444}\u{430}\u{439}\u{43B}\u{44B}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{430} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{43C}\u{430}\u{441}\u{43A}\u{443}\u{432}\u{441}\u{435}\u{444}\u{430}\u{439}\u{43B}\u{44B}\u{441}\u{435}\u{440}\u{432}\u{435}\u{440}\u{430} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{43C}\u{435}\u{441}\u{442}\u{43E}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{43E}\u{430}\u{434}\u{440}\u{435}\u{441}\u{443} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{43C}\u{438}\u{43D}\u{438}\u{43C}\u{430}\u{43B}\u{44C}\u{43D}\u{443}\u{44E}\u{434}\u{43B}\u{438}\u{43D}\u{443}\u{43F}\u{430}\u{440}\u{43E}\u{43B}\u{435}\u{439}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{435}\u{439} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{43D}\u{430}\u{432}\u{438}\u{433}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{443}\u{44E}\u{441}\u{441}\u{44B}\u{43B}\u{43A}\u{443} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{43D}\u{430}\u{432}\u{438}\u{433}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{443}\u{44E}\u{441}\u{441}\u{44B}\u{43B}\u{43A}\u{443}\u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{43E}\u{439}\u{431}\u{430}\u{437}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{43E}\u{431}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{43A}\u{43E}\u{43D}\u{444}\u{438}\u{433}\u{443}\u{440}\u{430}\u{446}\u{438}\u{438}\u{431}\u{430}\u{437}\u{44B}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{43E}\u{431}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{440}\u{435}\u{434}\u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{43D}\u{44B}\u{445}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{43E}\u{439}\u{431}\u{430}\u{437}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{43E}\u{431}\u{449}\u{438}\u{439}\u{43C}\u{430}\u{43A}\u{435}\u{442} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{43E}\u{431}\u{449}\u{443}\u{44E}\u{444}\u{43E}\u{440}\u{43C}\u{443} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{43E}\u{43A}\u{43D}\u{430} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{43E}\u{43F}\u{435}\u{440}\u{430}\u{442}\u{438}\u{432}\u{43D}\u{443}\u{44E}\u{43E}\u{442}\u{43C}\u{435}\u{442}\u{43A}\u{443}\u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{43E}\u{442}\u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{43D}\u{438}\u{435}\u{431}\u{435}\u{437}\u{43E}\u{43F}\u{430}\u{441}\u{43D}\u{43E}\u{433}\u{43E}\u{440}\u{435}\u{436}\u{438}\u{43C}\u{430} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{44B}\u{444}\u{443}\u{43D}\u{43A}\u{446}\u{438}\u{43E}\u{43D}\u{430}\u{43B}\u{44C}\u{43D}\u{44B}\u{445}\u{43E}\u{43F}\u{446}\u{438}\u{439}\u{438}\u{43D}\u{442}\u{435}\u{440}\u{444}\u{435}\u{439}\u{441}\u{430} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{43F}\u{43E}\u{43B}\u{43D}\u{43E}\u{435}\u{438}\u{43C}\u{44F}\u{43F}\u{440}\u{435}\u{434}\u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{43D}\u{43E}\u{433}\u{43E}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{44F} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}\u{43D}\u{430}\u{432}\u{438}\u{433}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{44B}\u{445}\u{441}\u{441}\u{44B}\u{43B}\u{43E}\u{43A} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{43F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{43A}\u{443}\u{441}\u{43B}\u{43E}\u{436}\u{43D}\u{43E}\u{441}\u{442}\u{438}\u{43F}\u{430}\u{440}\u{43E}\u{43B}\u{435}\u{439}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{435}\u{439} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{440}\u{430}\u{437}\u{434}\u{435}\u{43B}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43F}\u{443}\u{442}\u{438} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{440}\u{430}\u{437}\u{434}\u{435}\u{43B}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43F}\u{443}\u{442}\u{438}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{430} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{440}\u{430}\u{437}\u{434}\u{435}\u{43B}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43F}\u{443}\u{442}\u{438}\u{441}\u{435}\u{440}\u{432}\u{435}\u{440}\u{430} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{441}\u{435}\u{430}\u{43D}\u{441}\u{44B}\u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{43E}\u{439}\u{431}\u{430}\u{437}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{441}\u{43A}\u{43E}\u{440}\u{43E}\u{441}\u{442}\u{44C}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{441}\u{43A}\u{43E}\u{433}\u{43E}\u{441}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{435}\u{43D}\u{438}\u{44F} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{441}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{435}\u{43D}\u{438}\u{44F}\u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{43E}\u{439}\u{431}\u{430}\u{437}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{44F}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44E} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{441}\u{43E}\u{43E}\u{442}\u{432}\u{435}\u{442}\u{441}\u{442}\u{432}\u{438}\u{435}\u{43E}\u{431}\u{44A}\u{435}\u{43A}\u{442}\u{430}\u{438}\u{444}\u{43E}\u{440}\u{43C}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{441}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{441}\u{442}\u{430}\u{43D}\u{434}\u{430}\u{440}\u{442}\u{43D}\u{43E}\u{433}\u{43E}\u{438}\u{43D}\u{442}\u{435}\u{440}\u{444}\u{435}\u{439}\u{441}\u{430}odata \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{441}\u{442}\u{440}\u{443}\u{43A}\u{442}\u{443}\u{440}\u{443}\u{445}\u{440}\u{430}\u{43D}\u{435}\u{43D}\u{438}\u{44F}\u{431}\u{430}\u{437}\u{44B}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{442}\u{435}\u{43A}\u{443}\u{449}\u{438}\u{439}\u{441}\u{435}\u{430}\u{43D}\u{441}\u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{43E}\u{439}\u{431}\u{430}\u{437}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{444}\u{430}\u{439}\u{43B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{444}\u{430}\u{439}\u{43B}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{444}\u{43E}\u{440}\u{43C}\u{443} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{444}\u{443}\u{43D}\u{43A}\u{446}\u{438}\u{43E}\u{43D}\u{430}\u{43B}\u{44C}\u{43D}\u{443}\u{44E}\u{43E}\u{43F}\u{446}\u{438}\u{44E} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{444}\u{443}\u{43D}\u{43A}\u{446}\u{438}\u{43E}\u{43D}\u{430}\u{43B}\u{44C}\u{43D}\u{443}\u{44E}\u{43E}\u{43F}\u{446}\u{438}\u{44E}\u{438}\u{43D}\u{442}\u{435}\u{440}\u{444}\u{435}\u{439}\u{441}\u{430} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{447}\u{430}\u{441}\u{43E}\u{432}\u{43E}\u{439}\u{43F}\u{43E}\u{44F}\u{441}\u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{43E}\u{439}\u{431}\u{430}\u{437}\u{44B} \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{438}\u{43E}\u{441} \u{43F}\u{43E}\u{43C}\u{435}\u{441}\u{442}\u{438}\u{442}\u{44C}\u{432}\u{43E}\u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{43D}\u{43E}\u{435}\u{445}\u{440}\u{430}\u{43D}\u{438}\u{43B}\u{438}\u{449}\u{435} \u{43F}\u{43E}\u{43C}\u{435}\u{441}\u{442}\u{438}\u{442}\u{44C}\u{444}\u{430}\u{439}\u{43B} \u{43F}\u{43E}\u{43C}\u{435}\u{441}\u{442}\u{438}\u{442}\u{44C}\u{444}\u{430}\u{439}\u{43B}\u{44B} \u{43F}\u{440}\u{430}\u{432} \u{43F}\u{440}\u{430}\u{432}\u{43E}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{430} \u{43F}\u{440}\u{435}\u{434}\u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{43D}\u{43E}\u{435}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{43A}\u{43E}\u{434}\u{430}\u{43B}\u{43E}\u{43A}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438} \u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}\u{430} \u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{430} \u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F} \u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{441}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{44F}\u{436}\u{443}\u{440}\u{43D}\u{430}\u{43B}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{438} \u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{447}\u{430}\u{441}\u{43E}\u{432}\u{43E}\u{433}\u{43E}\u{43F}\u{43E}\u{44F}\u{441}\u{430} \u{43F}\u{440}\u{435}\u{434}\u{443}\u{43F}\u{440}\u{435}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{435} \u{43F}\u{440}\u{435}\u{43A}\u{440}\u{430}\u{442}\u{438}\u{442}\u{44C}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{443}\u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{44B} \u{43F}\u{440}\u{438}\u{432}\u{438}\u{43B}\u{435}\u{433}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{44B}\u{439}\u{440}\u{435}\u{436}\u{438}\u{43C} \u{43F}\u{440}\u{43E}\u{434}\u{43E}\u{43B}\u{436}\u{438}\u{442}\u{44C}\u{432}\u{44B}\u{437}\u{43E}\u{432} \u{43F}\u{440}\u{43E}\u{447}\u{438}\u{442}\u{430}\u{442}\u{44C}json \u{43F}\u{440}\u{43E}\u{447}\u{438}\u{442}\u{430}\u{442}\u{44C}xml \u{43F}\u{440}\u{43E}\u{447}\u{438}\u{442}\u{430}\u{442}\u{44C}\u{434}\u{430}\u{442}\u{443}json \u{43F}\u{443}\u{441}\u{442}\u{430}\u{44F}\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{430} \u{440}\u{430}\u{431}\u{43E}\u{447}\u{438}\u{439}\u{43A}\u{430}\u{442}\u{430}\u{43B}\u{43E}\u{433}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F} \u{440}\u{430}\u{437}\u{431}\u{43B}\u{43E}\u{43A}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{435}\u{434}\u{43B}\u{44F}\u{440}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F} \u{440}\u{430}\u{437}\u{434}\u{435}\u{43B}\u{438}\u{442}\u{44C}\u{444}\u{430}\u{439}\u{43B} \u{440}\u{430}\u{437}\u{43E}\u{440}\u{432}\u{430}\u{442}\u{44C}\u{441}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{435}\u{43D}\u{438}\u{435}\u{441}\u{432}\u{43D}\u{435}\u{448}\u{43D}\u{438}\u{43C}\u{438}\u{441}\u{442}\u{43E}\u{447}\u{43D}\u{438}\u{43A}\u{43E}\u{43C}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{440}\u{430}\u{441}\u{43A}\u{43E}\u{434}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C}\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{443} \u{440}\u{43E}\u{43B}\u{44C}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430} \u{441}\u{435}\u{43A}\u{443}\u{43D}\u{434}\u{430} \u{441}\u{438}\u{433}\u{43D}\u{430}\u{43B} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B} \u{441}\u{43A}\u{43E}\u{43F}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C}\u{436}\u{443}\u{440}\u{43D}\u{430}\u{43B}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{438} \u{441}\u{43C}\u{435}\u{449}\u{435}\u{43D}\u{438}\u{435}\u{43B}\u{435}\u{442}\u{43D}\u{435}\u{433}\u{43E}\u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438} \u{441}\u{43C}\u{435}\u{449}\u{435}\u{43D}\u{438}\u{435}\u{441}\u{442}\u{430}\u{43D}\u{434}\u{430}\u{440}\u{442}\u{43D}\u{43E}\u{433}\u{43E}\u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438} \u{441}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{438}\u{442}\u{44C}\u{431}\u{443}\u{444}\u{435}\u{440}\u{44B}\u{434}\u{432}\u{43E}\u{438}\u{447}\u{43D}\u{44B}\u{445}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C}\u{43A}\u{430}\u{442}\u{430}\u{43B}\u{43E}\u{433} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C}\u{444}\u{430}\u{431}\u{440}\u{438}\u{43A}\u{443}xdto \u{441}\u{43E}\u{43A}\u{440}\u{43B} \u{441}\u{43E}\u{43A}\u{440}\u{43B}\u{43F} \u{441}\u{43E}\u{43A}\u{440}\u{43F} \u{441}\u{43E}\u{43E}\u{431}\u{449}\u{438}\u{442}\u{44C} \u{441}\u{43E}\u{441}\u{442}\u{43E}\u{44F}\u{43D}\u{438}\u{435} \u{441}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{438}\u{442}\u{44C}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{441}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{438}\u{442}\u{44C}\u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{43A}\u{438}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F} \u{441}\u{440}\u{435}\u{434} \u{441}\u{442}\u{440}\u{434}\u{43B}\u{438}\u{43D}\u{430} \u{441}\u{442}\u{440}\u{437}\u{430}\u{43A}\u{430}\u{43D}\u{447}\u{438}\u{432}\u{430}\u{435}\u{442}\u{441}\u{44F}\u{43D}\u{430} \u{441}\u{442}\u{440}\u{437}\u{430}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C} \u{441}\u{442}\u{440}\u{43D}\u{430}\u{439}\u{442}\u{438} \u{441}\u{442}\u{440}\u{43D}\u{430}\u{447}\u{438}\u{43D}\u{430}\u{435}\u{442}\u{441}\u{44F}\u{441} \u{441}\u{442}\u{440}\u{43E}\u{43A}\u{430} \u{441}\u{442}\u{440}\u{43E}\u{43A}\u{430}\u{441}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{435}\u{43D}\u{438}\u{44F}\u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{43E}\u{439}\u{431}\u{430}\u{437}\u{44B} \u{441}\u{442}\u{440}\u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{443} \u{441}\u{442}\u{440}\u{440}\u{430}\u{437}\u{434}\u{435}\u{43B}\u{438}\u{442}\u{44C} \u{441}\u{442}\u{440}\u{441}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{438}\u{442}\u{44C} \u{441}\u{442}\u{440}\u{441}\u{440}\u{430}\u{432}\u{43D}\u{438}\u{442}\u{44C} \u{441}\u{442}\u{440}\u{447}\u{438}\u{441}\u{43B}\u{43E}\u{432}\u{445}\u{43E}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{439} \u{441}\u{442}\u{440}\u{447}\u{438}\u{441}\u{43B}\u{43E}\u{441}\u{442}\u{440}\u{43E}\u{43A} \u{441}\u{442}\u{440}\u{448}\u{430}\u{431}\u{43B}\u{43E}\u{43D} \u{442}\u{435}\u{43A}\u{443}\u{449}\u{430}\u{44F}\u{434}\u{430}\u{442}\u{430} \u{442}\u{435}\u{43A}\u{443}\u{449}\u{430}\u{44F}\u{434}\u{430}\u{442}\u{430}\u{441}\u{435}\u{430}\u{43D}\u{441}\u{430} \u{442}\u{435}\u{43A}\u{443}\u{449}\u{430}\u{44F}\u{443}\u{43D}\u{438}\u{432}\u{435}\u{440}\u{441}\u{430}\u{43B}\u{44C}\u{43D}\u{430}\u{44F}\u{434}\u{430}\u{442}\u{430} \u{442}\u{435}\u{43A}\u{443}\u{449}\u{430}\u{44F}\u{443}\u{43D}\u{438}\u{432}\u{435}\u{440}\u{441}\u{430}\u{43B}\u{44C}\u{43D}\u{430}\u{44F}\u{434}\u{430}\u{442}\u{430}\u{432}\u{43C}\u{438}\u{43B}\u{43B}\u{438}\u{441}\u{435}\u{43A}\u{443}\u{43D}\u{434}\u{430}\u{445} \u{442}\u{435}\u{43A}\u{443}\u{449}\u{438}\u{439}\u{432}\u{430}\u{440}\u{438}\u{430}\u{43D}\u{442}\u{438}\u{43D}\u{442}\u{435}\u{440}\u{444}\u{435}\u{439}\u{441}\u{430}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{441}\u{43A}\u{43E}\u{433}\u{43E}\u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F} \u{442}\u{435}\u{43A}\u{443}\u{449}\u{438}\u{439}\u{432}\u{430}\u{440}\u{438}\u{430}\u{43D}\u{442}\u{43E}\u{441}\u{43D}\u{43E}\u{432}\u{43D}\u{43E}\u{433}\u{43E}\u{448}\u{440}\u{438}\u{444}\u{442}\u{430}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{441}\u{43A}\u{43E}\u{433}\u{43E}\u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F} \u{442}\u{435}\u{43A}\u{443}\u{449}\u{438}\u{439}\u{43A}\u{43E}\u{434}\u{43B}\u{43E}\u{43A}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438} \u{442}\u{435}\u{43A}\u{443}\u{449}\u{438}\u{439}\u{440}\u{435}\u{436}\u{438}\u{43C}\u{437}\u{430}\u{43F}\u{443}\u{441}\u{43A}\u{430} \u{442}\u{435}\u{43A}\u{443}\u{449}\u{438}\u{439}\u{44F}\u{437}\u{44B}\u{43A} \u{442}\u{435}\u{43A}\u{443}\u{449}\u{438}\u{439}\u{44F}\u{437}\u{44B}\u{43A}\u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{44B} \u{442}\u{438}\u{43F} \u{442}\u{438}\u{43F}\u{437}\u{43D}\u{447} \u{442}\u{440}\u{430}\u{43D}\u{437}\u{430}\u{43A}\u{446}\u{438}\u{44F}\u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{430} \u{442}\u{440}\u{435}\u{433} \u{443}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{435}\u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{43E}\u{439}\u{431}\u{430}\u{437}\u{44B} \u{443}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C}\u{438}\u{437}\u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{43D}\u{43E}\u{433}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{438}\u{43B}\u{438}\u{449}\u{430} \u{443}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C}\u{43E}\u{431}\u{44A}\u{435}\u{43A}\u{442}\u{44B} \u{443}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C}\u{444}\u{430}\u{439}\u{43B}\u{44B} \u{443}\u{43D}\u{438}\u{432}\u{435}\u{440}\u{441}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{435}\u{432}\u{440}\u{435}\u{43C}\u{44F} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{431}\u{435}\u{437}\u{43E}\u{43F}\u{430}\u{441}\u{43D}\u{44B}\u{439}\u{440}\u{435}\u{436}\u{438}\u{43C} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{431}\u{435}\u{437}\u{43E}\u{43F}\u{430}\u{441}\u{43D}\u{44B}\u{439}\u{440}\u{435}\u{436}\u{438}\u{43C}\u{440}\u{430}\u{437}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{44F}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{431}\u{43B}\u{43E}\u{43A}\u{438}\u{440}\u{43E}\u{432}\u{43A}\u{443}\u{441}\u{435}\u{430}\u{43D}\u{441}\u{43E}\u{432} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{432}\u{43D}\u{435}\u{448}\u{43D}\u{44E}\u{44E}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{435}\u{43D}\u{442}\u{443} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{432}\u{440}\u{435}\u{43C}\u{44F}\u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{438}\u{44F}\u{441}\u{43F}\u{44F}\u{449}\u{435}\u{433}\u{43E}\u{441}\u{435}\u{430}\u{43D}\u{441}\u{430} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{432}\u{440}\u{435}\u{43C}\u{44F}\u{437}\u{430}\u{441}\u{44B}\u{43F}\u{430}\u{43D}\u{438}\u{44F}\u{43F}\u{430}\u{441}\u{441}\u{438}\u{432}\u{43D}\u{43E}\u{433}\u{43E}\u{441}\u{435}\u{430}\u{43D}\u{441}\u{430} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{432}\u{440}\u{435}\u{43C}\u{44F}\u{43E}\u{436}\u{438}\u{434}\u{430}\u{43D}\u{438}\u{44F}\u{431}\u{43B}\u{43E}\u{43A}\u{438}\u{440}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{437}\u{430}\u{433}\u{43E}\u{43B}\u{43E}\u{432}\u{43E}\u{43A}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{441}\u{43A}\u{43E}\u{433}\u{43E}\u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{437}\u{430}\u{433}\u{43E}\u{43B}\u{43E}\u{432}\u{43E}\u{43A}\u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{44B} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{436}\u{443}\u{440}\u{43D}\u{430}\u{43B}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{438} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{441}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{44F}\u{436}\u{443}\u{440}\u{43D}\u{430}\u{43B}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{438} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{43A}\u{440}\u{430}\u{442}\u{43A}\u{438}\u{439}\u{437}\u{430}\u{433}\u{43E}\u{43B}\u{43E}\u{432}\u{43E}\u{43A}\u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{43C}\u{438}\u{43D}\u{438}\u{43C}\u{430}\u{43B}\u{44C}\u{43D}\u{443}\u{44E}\u{434}\u{43B}\u{438}\u{43D}\u{443}\u{43F}\u{430}\u{440}\u{43E}\u{43B}\u{435}\u{439}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{435}\u{439} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{43C}\u{43E}\u{43D}\u{43E}\u{43F}\u{43E}\u{43B}\u{44C}\u{43D}\u{44B}\u{439}\u{440}\u{435}\u{436}\u{438}\u{43C} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{43A}\u{438}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{430}\u{43B}\u{438}\u{446}\u{435}\u{43D}\u{437}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{43E}\u{431}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{440}\u{435}\u{434}\u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{43D}\u{44B}\u{445}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{43E}\u{439}\u{431}\u{430}\u{437}\u{44B} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{43E}\u{442}\u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{43D}\u{438}\u{435}\u{431}\u{435}\u{437}\u{43E}\u{43F}\u{430}\u{441}\u{43D}\u{43E}\u{433}\u{43E}\u{440}\u{435}\u{436}\u{438}\u{43C}\u{430} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{44B}\u{444}\u{443}\u{43D}\u{43A}\u{446}\u{438}\u{43E}\u{43D}\u{430}\u{43B}\u{44C}\u{43D}\u{44B}\u{445}\u{43E}\u{43F}\u{446}\u{438}\u{439}\u{438}\u{43D}\u{442}\u{435}\u{440}\u{444}\u{435}\u{439}\u{441}\u{430} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{43F}\u{440}\u{438}\u{432}\u{438}\u{43B}\u{435}\u{433}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{44B}\u{439}\u{440}\u{435}\u{436}\u{438}\u{43C} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{43F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{43A}\u{443}\u{441}\u{43B}\u{43E}\u{436}\u{43D}\u{43E}\u{441}\u{442}\u{438}\u{43F}\u{430}\u{440}\u{43E}\u{43B}\u{435}\u{439}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{435}\u{439} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{440}\u{430}\u{441}\u{448}\u{438}\u{440}\u{435}\u{43D}\u{438}\u{435}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}\u{441}\u{43A}\u{440}\u{438}\u{43F}\u{442}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{435}\u{439} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{440}\u{430}\u{441}\u{448}\u{438}\u{440}\u{435}\u{43D}\u{438}\u{435}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}\u{441}\u{444}\u{430}\u{439}\u{43B}\u{430}\u{43C}\u{438} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{441}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{435}\u{43D}\u{438}\u{435}\u{441}\u{432}\u{43D}\u{435}\u{448}\u{43D}\u{438}\u{43C}\u{438}\u{441}\u{442}\u{43E}\u{447}\u{43D}\u{438}\u{43A}\u{43E}\u{43C}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{441}\u{43E}\u{43E}\u{442}\u{432}\u{435}\u{442}\u{441}\u{442}\u{432}\u{438}\u{435}\u{43E}\u{431}\u{44A}\u{435}\u{43A}\u{442}\u{430}\u{438}\u{444}\u{43E}\u{440}\u{43C}\u{44B} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{441}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{441}\u{442}\u{430}\u{43D}\u{434}\u{430}\u{440}\u{442}\u{43D}\u{43E}\u{433}\u{43E}\u{438}\u{43D}\u{442}\u{435}\u{440}\u{444}\u{435}\u{439}\u{441}\u{430}odata \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{447}\u{430}\u{441}\u{43E}\u{432}\u{43E}\u{439}\u{43F}\u{43E}\u{44F}\u{441}\u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{43E}\u{439}\u{431}\u{430}\u{437}\u{44B} \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}\u{447}\u{430}\u{441}\u{43E}\u{432}\u{43E}\u{439}\u{43F}\u{43E}\u{44F}\u{441}\u{441}\u{435}\u{430}\u{43D}\u{441}\u{430} \u{444}\u{43E}\u{440}\u{43C}\u{430}\u{442} \u{446}\u{435}\u{43B} \u{447}\u{430}\u{441} \u{447}\u{430}\u{441}\u{43E}\u{432}\u{43E}\u{439}\u{43F}\u{43E}\u{44F}\u{441} \u{447}\u{430}\u{441}\u{43E}\u{432}\u{43E}\u{439}\u{43F}\u{43E}\u{44F}\u{441}\u{441}\u{435}\u{430}\u{43D}\u{441}\u{430} \u{447}\u{438}\u{441}\u{43B}\u{43E} \u{447}\u{438}\u{441}\u{43B}\u{43E}\u{43F}\u{440}\u{43E}\u{43F}\u{438}\u{441}\u{44C}\u{44E} \u{44D}\u{442}\u{43E}\u{430}\u{434}\u{440}\u{435}\u{441}\u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{43D}\u{43E}\u{433}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{438}\u{43B}\u{438}\u{449}\u{430} ws\u{441}\u{441}\u{44B}\u{43B}\u{43A}\u{438} \u{431}\u{438}\u{431}\u{43B}\u{438}\u{43E}\u{442}\u{435}\u{43A}\u{430}\u{43A}\u{430}\u{440}\u{442}\u{438}\u{43D}\u{43E}\u{43A} \u{431}\u{438}\u{431}\u{43B}\u{438}\u{43E}\u{442}\u{435}\u{43A}\u{430}\u{43C}\u{430}\u{43A}\u{435}\u{442}\u{43E}\u{432}\u{43E}\u{444}\u{43E}\u{440}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{431}\u{438}\u{431}\u{43B}\u{438}\u{43E}\u{442}\u{435}\u{43A}\u{430}\u{441}\u{442}\u{438}\u{43B}\u{435}\u{439} \u{431}\u{438}\u{437}\u{43D}\u{435}\u{441}\u{43F}\u{440}\u{43E}\u{446}\u{435}\u{441}\u{441}\u{44B} \u{432}\u{43D}\u{435}\u{448}\u{43D}\u{438}\u{435}\u{438}\u{441}\u{442}\u{43E}\u{447}\u{43D}\u{438}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{432}\u{43D}\u{435}\u{448}\u{43D}\u{438}\u{435}\u{43E}\u{431}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{43A}\u{438} \u{432}\u{43D}\u{435}\u{448}\u{43D}\u{438}\u{435}\u{43E}\u{442}\u{447}\u{435}\u{442}\u{44B} \u{432}\u{441}\u{442}\u{440}\u{43E}\u{435}\u{43D}\u{43D}\u{44B}\u{435}\u{43F}\u{43E}\u{43A}\u{443}\u{43F}\u{43A}\u{438} \u{433}\u{43B}\u{430}\u{432}\u{43D}\u{44B}\u{439}\u{438}\u{43D}\u{442}\u{435}\u{440}\u{444}\u{435}\u{439}\u{441} \u{433}\u{43B}\u{430}\u{432}\u{43D}\u{44B}\u{439}\u{441}\u{442}\u{438}\u{43B}\u{44C} \u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{44B} \u{434}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{44F}\u{435}\u{43C}\u{44B}\u{435}\u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{436}\u{443}\u{440}\u{43D}\u{430}\u{43B}\u{44B}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432} \u{437}\u{430}\u{434}\u{430}\u{447}\u{438} \u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F}\u{43E}\u{431}\u{438}\u{43D}\u{442}\u{435}\u{440}\u{43D}\u{435}\u{442}\u{441}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{435}\u{43D}\u{438}\u{438} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{440}\u{430}\u{431}\u{43E}\u{447}\u{435}\u{439}\u{434}\u{430}\u{442}\u{44B} \u{438}\u{441}\u{442}\u{43E}\u{440}\u{438}\u{44F}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F} \u{43A}\u{43E}\u{43D}\u{441}\u{442}\u{430}\u{43D}\u{442}\u{44B} \u{43A}\u{440}\u{438}\u{442}\u{435}\u{440}\u{438}\u{438}\u{43E}\u{442}\u{431}\u{43E}\u{440}\u{430} \u{43C}\u{435}\u{442}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{435} \u{43E}\u{431}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{43A}\u{438} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{440}\u{435}\u{43A}\u{43B}\u{430}\u{43C}\u{44B} \u{43E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{43A}\u{430}\u{434}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{44F}\u{435}\u{43C}\u{44B}\u{445}\u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{439} \u{43E}\u{442}\u{447}\u{435}\u{442}\u{44B} \u{43F}\u{430}\u{43D}\u{435}\u{43B}\u{44C}\u{437}\u{430}\u{434}\u{430}\u{447}\u{43E}\u{441} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{437}\u{430}\u{43F}\u{443}\u{441}\u{43A}\u{430} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{44B}\u{441}\u{435}\u{430}\u{43D}\u{441}\u{430} \u{43F}\u{435}\u{440}\u{435}\u{447}\u{438}\u{441}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{43F}\u{43B}\u{430}\u{43D}\u{44B}\u{432}\u{438}\u{434}\u{43E}\u{432}\u{440}\u{430}\u{441}\u{447}\u{435}\u{442}\u{430} \u{43F}\u{43B}\u{430}\u{43D}\u{44B}\u{432}\u{438}\u{434}\u{43E}\u{432}\u{445}\u{430}\u{440}\u{430}\u{43A}\u{442}\u{435}\u{440}\u{438}\u{441}\u{442}\u{438}\u{43A} \u{43F}\u{43B}\u{430}\u{43D}\u{44B}\u{43E}\u{431}\u{43C}\u{435}\u{43D}\u{430} \u{43F}\u{43B}\u{430}\u{43D}\u{44B}\u{441}\u{447}\u{435}\u{442}\u{43E}\u{432} \u{43F}\u{43E}\u{43B}\u{43D}\u{43E}\u{442}\u{435}\u{43A}\u{441}\u{442}\u{43E}\u{432}\u{44B}\u{439}\u{43F}\u{43E}\u{438}\u{441}\u{43A} \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{438}\u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{43E}\u{439}\u{431}\u{430}\u{437}\u{44B} \u{43F}\u{43E}\u{441}\u{43B}\u{435}\u{434}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438} \u{43F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{43A}\u{430}\u{432}\u{441}\u{442}\u{440}\u{43E}\u{435}\u{43D}\u{43D}\u{44B}\u{445}\u{43F}\u{43E}\u{43A}\u{443}\u{43F}\u{43E}\u{43A} \u{440}\u{430}\u{431}\u{43E}\u{447}\u{430}\u{44F}\u{434}\u{430}\u{442}\u{430} \u{440}\u{430}\u{441}\u{448}\u{438}\u{440}\u{435}\u{43D}\u{438}\u{44F}\u{43A}\u{43E}\u{43D}\u{444}\u{438}\u{433}\u{443}\u{440}\u{430}\u{446}\u{438}\u{438} \u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{44B}\u{431}\u{443}\u{445}\u{433}\u{430}\u{43B}\u{442}\u{435}\u{440}\u{438}\u{438} \u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{44B}\u{43D}\u{430}\u{43A}\u{43E}\u{43F}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{44B}\u{440}\u{430}\u{441}\u{447}\u{435}\u{442}\u{430} \u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{44B}\u{441}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{438}\u{439} \u{440}\u{435}\u{433}\u{43B}\u{430}\u{43C}\u{435}\u{43D}\u{442}\u{43D}\u{44B}\u{435}\u{437}\u{430}\u{434}\u{430}\u{43D}\u{438}\u{44F} \u{441}\u{435}\u{440}\u{438}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{442}\u{43E}\u{440}xdto \u{441}\u{43F}\u{440}\u{430}\u{432}\u{43E}\u{447}\u{43D}\u{438}\u{43A}\u{438} \u{441}\u{440}\u{435}\u{434}\u{441}\u{442}\u{432}\u{430}\u{433}\u{435}\u{43E}\u{43F}\u{43E}\u{437}\u{438}\u{446}\u{438}\u{43E}\u{43D}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F} \u{441}\u{440}\u{435}\u{434}\u{441}\u{442}\u{432}\u{430}\u{43A}\u{440}\u{438}\u{43F}\u{442}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{438} \u{441}\u{440}\u{435}\u{434}\u{441}\u{442}\u{432}\u{430}\u{43C}\u{443}\u{43B}\u{44C}\u{442}\u{438}\u{43C}\u{435}\u{434}\u{438}\u{430} \u{441}\u{440}\u{435}\u{434}\u{441}\u{442}\u{432}\u{430}\u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{44F}\u{440}\u{435}\u{43A}\u{43B}\u{430}\u{43C}\u{44B} \u{441}\u{440}\u{435}\u{434}\u{441}\u{442}\u{432}\u{430}\u{43F}\u{43E}\u{447}\u{442}\u{44B} \u{441}\u{440}\u{435}\u{434}\u{441}\u{442}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}\u{438}\u{438} \u{444}\u{430}\u{431}\u{440}\u{438}\u{43A}\u{430}xdto \u{444}\u{430}\u{439}\u{43B}\u{43E}\u{432}\u{44B}\u{435}\u{43F}\u{43E}\u{442}\u{43E}\u{43A}\u{438} \u{444}\u{43E}\u{43D}\u{43E}\u{432}\u{44B}\u{435}\u{437}\u{430}\u{434}\u{430}\u{43D}\u{438}\u{44F} \u{445}\u{440}\u{430}\u{43D}\u{438}\u{43B}\u{438}\u{449}\u{430}\u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{435}\u{43A} \u{445}\u{440}\u{430}\u{43D}\u{438}\u{43B}\u{438}\u{449}\u{435}\u{432}\u{430}\u{440}\u{438}\u{430}\u{43D}\u{442}\u{43E}\u{432}\u{43E}\u{442}\u{447}\u{435}\u{442}\u{43E}\u{432} \u{445}\u{440}\u{430}\u{43D}\u{438}\u{43B}\u{438}\u{449}\u{435}\u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{435}\u{43A}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{444}\u{43E}\u{440}\u{43C} \u{445}\u{440}\u{430}\u{43D}\u{438}\u{43B}\u{438}\u{449}\u{435}\u{43E}\u{431}\u{449}\u{438}\u{445}\u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{435}\u{43A} \u{445}\u{440}\u{430}\u{43D}\u{438}\u{43B}\u{438}\u{449}\u{435}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{441}\u{43A}\u{438}\u{445}\u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{435}\u{43A}\u{434}\u{438}\u{43D}\u{430}\u{43C}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{438}\u{445}\u{441}\u{43F}\u{438}\u{441}\u{43A}\u{43E}\u{432} \u{445}\u{440}\u{430}\u{43D}\u{438}\u{43B}\u{438}\u{449}\u{435}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{441}\u{43A}\u{438}\u{445}\u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{435}\u{43A}\u{43E}\u{442}\u{447}\u{435}\u{442}\u{43E}\u{432} \u{445}\u{440}\u{430}\u{43D}\u{438}\u{43B}\u{438}\u{449}\u{435}\u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{43D}\u{44B}\u{445}\u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{435}\u{43A} `,
                    class: `web\u{446}\u{432}\u{435}\u{442}\u{430} windows\u{446}\u{432}\u{435}\u{442}\u{430} windows\u{448}\u{440}\u{438}\u{444}\u{442}\u{44B} \u{431}\u{438}\u{431}\u{43B}\u{438}\u{43E}\u{442}\u{435}\u{43A}\u{430}\u{43A}\u{430}\u{440}\u{442}\u{438}\u{43D}\u{43E}\u{43A} \u{440}\u{430}\u{43C}\u{43A}\u{438}\u{441}\u{442}\u{438}\u{43B}\u{44F} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{44B} \u{446}\u{432}\u{435}\u{442}\u{430}\u{441}\u{442}\u{438}\u{43B}\u{44F} \u{448}\u{440}\u{438}\u{444}\u{442}\u{44B}\u{441}\u{442}\u{438}\u{43B}\u{44F} \u{430}\u{432}\u{442}\u{43E}\u{43C}\u{430}\u{442}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{43E}\u{435}\u{441}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{435}\u{43D}\u{438}\u{435}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{444}\u{43E}\u{440}\u{43C}\u{44B}\u{432}\u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{43A}\u{430}\u{445} \u{430}\u{432}\u{442}\u{43E}\u{43D}\u{443}\u{43C}\u{435}\u{440}\u{430}\u{446}\u{438}\u{44F}\u{432}\u{444}\u{43E}\u{440}\u{43C}\u{435} \u{430}\u{432}\u{442}\u{43E}\u{440}\u{430}\u{437}\u{434}\u{432}\u{438}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{441}\u{435}\u{440}\u{438}\u{439} \u{430}\u{43D}\u{438}\u{43C}\u{430}\u{446}\u{438}\u{44F}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{432}\u{430}\u{440}\u{438}\u{430}\u{43D}\u{442}\u{432}\u{44B}\u{440}\u{430}\u{432}\u{43D}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{44F}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432}\u{438}\u{437}\u{430}\u{433}\u{43E}\u{43B}\u{43E}\u{432}\u{43A}\u{43E}\u{432} \u{432}\u{430}\u{440}\u{438}\u{430}\u{43D}\u{442}\u{443}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}\u{432}\u{44B}\u{441}\u{43E}\u{442}\u{43E}\u{439}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{446}\u{44B} \u{432}\u{435}\u{440}\u{442}\u{438}\u{43A}\u{430}\u{43B}\u{44C}\u{43D}\u{430}\u{44F}\u{43F}\u{440}\u{43E}\u{43A}\u{440}\u{443}\u{442}\u{43A}\u{430}\u{444}\u{43E}\u{440}\u{43C}\u{44B} \u{432}\u{435}\u{440}\u{442}\u{438}\u{43A}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{435}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435} \u{432}\u{435}\u{440}\u{442}\u{438}\u{43A}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{435}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430} \u{432}\u{438}\u{434}\u{433}\u{440}\u{443}\u{43F}\u{43F}\u{44B}\u{444}\u{43E}\u{440}\u{43C}\u{44B} \u{432}\u{438}\u{434}\u{434}\u{435}\u{43A}\u{43E}\u{440}\u{430}\u{446}\u{438}\u{438}\u{444}\u{43E}\u{440}\u{43C}\u{44B} \u{432}\u{438}\u{434}\u{434}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{438}\u{44F}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{444}\u{43E}\u{440}\u{43C}\u{44B} \u{432}\u{438}\u{434}\u{438}\u{437}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{438}\u{44F}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{432}\u{438}\u{434}\u{43A}\u{43D}\u{43E}\u{43F}\u{43A}\u{438}\u{444}\u{43E}\u{440}\u{43C}\u{44B} \u{432}\u{438}\u{434}\u{43F}\u{435}\u{440}\u{435}\u{43A}\u{43B}\u{44E}\u{447}\u{430}\u{442}\u{435}\u{43B}\u{44F} \u{432}\u{438}\u{434}\u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{435}\u{439}\u{43A}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{435} \u{432}\u{438}\u{434}\u{43F}\u{43E}\u{43B}\u{44F}\u{444}\u{43E}\u{440}\u{43C}\u{44B} \u{432}\u{438}\u{434}\u{444}\u{43B}\u{430}\u{436}\u{43A}\u{430} \u{432}\u{43B}\u{438}\u{44F}\u{43D}\u{438}\u{435}\u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{430}\u{43D}\u{430}\u{43F}\u{443}\u{437}\u{44B}\u{440}\u{435}\u{43A}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{433}\u{43E}\u{440}\u{438}\u{437}\u{43E}\u{43D}\u{442}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{435}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435} \u{433}\u{43E}\u{440}\u{438}\u{437}\u{43E}\u{43D}\u{442}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{435}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430} \u{433}\u{440}\u{443}\u{43F}\u{43F}\u{438}\u{440}\u{43E}\u{432}\u{43A}\u{430}\u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{43E}\u{43A} \u{433}\u{440}\u{443}\u{43F}\u{43F}\u{438}\u{440}\u{43E}\u{432}\u{43A}\u{430}\u{43F}\u{43E}\u{434}\u{447}\u{438}\u{43D}\u{435}\u{43D}\u{43D}\u{44B}\u{445}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432}\u{444}\u{43E}\u{440}\u{43C}\u{44B} \u{433}\u{440}\u{443}\u{43F}\u{43F}\u{44B}\u{438}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{44B} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{435}\u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{44F} \u{434}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{439}\u{440}\u{435}\u{436}\u{438}\u{43C}\u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{44F} \u{434}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{43C}\u{44B}\u{435}\u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}\u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{44F} \u{438}\u{43D}\u{442}\u{435}\u{440}\u{432}\u{430}\u{43B}\u{43C}\u{435}\u{436}\u{434}\u{443}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{43C}\u{438}\u{444}\u{43E}\u{440}\u{43C}\u{44B} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{432}\u{44B}\u{432}\u{43E}\u{434}\u{430} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{43F}\u{43E}\u{43B}\u{43E}\u{441}\u{44B}\u{43F}\u{440}\u{43E}\u{43A}\u{440}\u{443}\u{442}\u{43A}\u{438} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{443}\u{435}\u{43C}\u{43E}\u{435}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}\u{442}\u{43E}\u{447}\u{43A}\u{438}\u{431}\u{438}\u{440}\u{436}\u{435}\u{432}\u{43E}\u{439}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{438}\u{441}\u{442}\u{43E}\u{440}\u{438}\u{44F}\u{432}\u{44B}\u{431}\u{43E}\u{440}\u{430}\u{43F}\u{440}\u{438}\u{432}\u{432}\u{43E}\u{434}\u{435} \u{438}\u{441}\u{442}\u{43E}\u{447}\u{43D}\u{438}\u{43A}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{439}\u{43E}\u{441}\u{438}\u{442}\u{43E}\u{447}\u{435}\u{43A}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{438}\u{441}\u{442}\u{43E}\u{447}\u{43D}\u{438}\u{43A}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{44F}\u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{430}\u{43F}\u{443}\u{437}\u{44B}\u{440}\u{44C}\u{43A}\u{430}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{43A}\u{430}\u{442}\u{435}\u{433}\u{43E}\u{440}\u{438}\u{44F}\u{433}\u{440}\u{443}\u{43F}\u{43F}\u{44B}\u{43A}\u{43E}\u{43C}\u{430}\u{43D}\u{434} \u{43C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{443}\u{43C}\u{441}\u{435}\u{440}\u{438}\u{439} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{435}\u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{434}\u{435}\u{440}\u{435}\u{432}\u{430} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{435}\u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{441}\u{43F}\u{438}\u{441}\u{43A}\u{430} \u{43E}\u{431}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{442}\u{435}\u{43A}\u{441}\u{442}\u{430}\u{440}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F} \u{43E}\u{440}\u{438}\u{435}\u{43D}\u{442}\u{430}\u{446}\u{438}\u{44F}\u{434}\u{435}\u{43D}\u{434}\u{440}\u{43E}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{43E}\u{440}\u{438}\u{435}\u{43D}\u{442}\u{430}\u{446}\u{438}\u{44F}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{43E}\u{440}\u{438}\u{435}\u{43D}\u{442}\u{430}\u{446}\u{438}\u{44F}\u{43C}\u{435}\u{442}\u{43E}\u{43A}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{43E}\u{440}\u{438}\u{435}\u{43D}\u{442}\u{430}\u{446}\u{438}\u{44F}\u{43C}\u{435}\u{442}\u{43E}\u{43A}\u{441}\u{432}\u{43E}\u{434}\u{43D}\u{43E}\u{439}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{43E}\u{440}\u{438}\u{435}\u{43D}\u{442}\u{430}\u{446}\u{438}\u{44F}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{444}\u{43E}\u{440}\u{43C}\u{44B} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{432}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{435} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{432}\u{43B}\u{435}\u{433}\u{435}\u{43D}\u{434}\u{435}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{433}\u{440}\u{443}\u{43F}\u{43F}\u{44B}\u{43A}\u{43D}\u{43E}\u{43F}\u{43E}\u{43A} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{437}\u{430}\u{433}\u{43E}\u{43B}\u{43E}\u{432}\u{43A}\u{430}\u{448}\u{43A}\u{430}\u{43B}\u{44B}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{439}\u{441}\u{432}\u{43E}\u{434}\u{43D}\u{43E}\u{439}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{44F}\u{438}\u{437}\u{43C}\u{435}\u{440}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{439}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{438}\u{43D}\u{442}\u{435}\u{440}\u{432}\u{430}\u{43B}\u{430}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B}\u{433}\u{430}\u{43D}\u{442}\u{430} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{43A}\u{43D}\u{43E}\u{43F}\u{43A}\u{438} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{43A}\u{43D}\u{43E}\u{43F}\u{43A}\u{438}\u{432}\u{44B}\u{431}\u{43E}\u{440}\u{430} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{43E}\u{431}\u{441}\u{443}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{439}\u{444}\u{43E}\u{440}\u{43C}\u{44B} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{43E}\u{431}\u{44B}\u{447}\u{43D}\u{43E}\u{439}\u{433}\u{440}\u{443}\u{43F}\u{43F}\u{44B} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{43E}\u{442}\u{440}\u{438}\u{446}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{445}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{439}\u{43F}\u{443}\u{437}\u{44B}\u{440}\u{44C}\u{43A}\u{43E}\u{432}\u{43E}\u{439}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{430}\u{43D}\u{435}\u{43B}\u{438}\u{43F}\u{43E}\u{438}\u{441}\u{43A}\u{430} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{43E}\u{434}\u{441}\u{43A}\u{430}\u{437}\u{43A}\u{438} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{440}\u{435}\u{434}\u{443}\u{43F}\u{440}\u{435}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{44F}\u{43F}\u{440}\u{438}\u{440}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{438} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{440}\u{430}\u{437}\u{43C}\u{435}\u{442}\u{43A}\u{438}\u{43F}\u{43E}\u{43B}\u{43E}\u{441}\u{44B}\u{440}\u{435}\u{433}\u{443}\u{43B}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{444}\u{43E}\u{440}\u{43C}\u{44B} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{446}\u{44B} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{442}\u{435}\u{43A}\u{441}\u{442}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{44F}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B}\u{433}\u{430}\u{43D}\u{442}\u{430} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{443}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}\u{43E}\u{431}\u{44B}\u{447}\u{43D}\u{43E}\u{439}\u{433}\u{440}\u{443}\u{43F}\u{43F}\u{44B} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{444}\u{438}\u{433}\u{443}\u{440}\u{44B}\u{43A}\u{43D}\u{43E}\u{43F}\u{43A}\u{438} \u{43F}\u{430}\u{43B}\u{438}\u{442}\u{440}\u{430}\u{446}\u{432}\u{435}\u{442}\u{43E}\u{432}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{43F}\u{43E}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{438}\u{435}\u{43E}\u{431}\u{44B}\u{447}\u{43D}\u{43E}\u{439}\u{433}\u{440}\u{443}\u{43F}\u{43F}\u{44B} \u{43F}\u{43E}\u{434}\u{434}\u{435}\u{440}\u{436}\u{43A}\u{430}\u{43C}\u{430}\u{441}\u{448}\u{442}\u{430}\u{431}\u{430}\u{434}\u{435}\u{43D}\u{434}\u{440}\u{43E}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{43F}\u{43E}\u{434}\u{434}\u{435}\u{440}\u{436}\u{43A}\u{430}\u{43C}\u{430}\u{441}\u{448}\u{442}\u{430}\u{431}\u{430}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B}\u{433}\u{430}\u{43D}\u{442}\u{430} \u{43F}\u{43E}\u{434}\u{434}\u{435}\u{440}\u{436}\u{43A}\u{430}\u{43C}\u{430}\u{441}\u{448}\u{442}\u{430}\u{431}\u{430}\u{441}\u{432}\u{43E}\u{434}\u{43D}\u{43E}\u{439}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{43F}\u{43E}\u{438}\u{441}\u{43A}\u{432}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{446}\u{435}\u{43F}\u{440}\u{438}\u{432}\u{432}\u{43E}\u{434}\u{435} \u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{437}\u{430}\u{433}\u{43E}\u{43B}\u{43E}\u{432}\u{43A}\u{430}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{444}\u{43E}\u{440}\u{43C}\u{44B} \u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{43A}\u{430}\u{440}\u{442}\u{438}\u{43D}\u{43A}\u{438}\u{43A}\u{43D}\u{43E}\u{43F}\u{43A}\u{438}\u{444}\u{43E}\u{440}\u{43C}\u{44B} \u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{43A}\u{430}\u{440}\u{442}\u{438}\u{43D}\u{43A}\u{438}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{433}\u{440}\u{430}\u{444}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{43E}\u{439}\u{441}\u{445}\u{435}\u{43C}\u{44B} \u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{43A}\u{43E}\u{43C}\u{430}\u{43D}\u{434}\u{43D}\u{43E}\u{439}\u{43F}\u{430}\u{43D}\u{435}\u{43B}\u{438}\u{444}\u{43E}\u{440}\u{43C}\u{44B} \u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{43A}\u{43E}\u{43C}\u{430}\u{43D}\u{434}\u{43D}\u{43E}\u{439}\u{43F}\u{430}\u{43D}\u{435}\u{43B}\u{438}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{444}\u{43E}\u{440}\u{43C}\u{44B} \u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{43E}\u{43F}\u{43E}\u{440}\u{43D}\u{43E}\u{439}\u{442}\u{43E}\u{447}\u{43A}\u{438}\u{43E}\u{442}\u{440}\u{438}\u{441}\u{43E}\u{432}\u{43A}\u{438} \u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{435}\u{439}\u{43A}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{435} \u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{435}\u{439}\u{448}\u{43A}\u{430}\u{43B}\u{44B}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{439}\u{438}\u{437}\u{43C}\u{435}\u{440}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{439}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{441}\u{43E}\u{441}\u{442}\u{43E}\u{44F}\u{43D}\u{438}\u{44F}\u{43F}\u{440}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440}\u{430} \u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{438}\u{43F}\u{43E}\u{438}\u{441}\u{43A}\u{430} \u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{442}\u{435}\u{43A}\u{441}\u{442}\u{430}\u{441}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{439}\u{43B}\u{438}\u{43D}\u{438}\u{438} \u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{443}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}\u{43F}\u{43E}\u{438}\u{441}\u{43A}\u{43E}\u{43C} \u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{448}\u{43A}\u{430}\u{43B}\u{44B}\u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438} \u{43F}\u{43E}\u{440}\u{44F}\u{434}\u{43E}\u{43A}\u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{44F}\u{442}\u{43E}\u{447}\u{435}\u{43A}\u{433}\u{43E}\u{440}\u{438}\u{437}\u{43E}\u{43D}\u{442}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{439}\u{433}\u{438}\u{441}\u{442}\u{43E}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{43F}\u{43E}\u{440}\u{44F}\u{434}\u{43E}\u{43A}\u{441}\u{435}\u{440}\u{438}\u{439}\u{432}\u{43B}\u{435}\u{433}\u{435}\u{43D}\u{434}\u{435}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{43A}\u{430}\u{440}\u{442}\u{438}\u{43D}\u{43A}\u{438} \u{440}\u{430}\u{441}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{437}\u{430}\u{433}\u{43E}\u{43B}\u{43E}\u{432}\u{43A}\u{430}\u{448}\u{43A}\u{430}\u{43B}\u{44B}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{440}\u{430}\u{441}\u{442}\u{44F}\u{433}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{43F}\u{43E}\u{432}\u{435}\u{440}\u{442}\u{438}\u{43A}\u{430}\u{43B}\u{438}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B}\u{433}\u{430}\u{43D}\u{442}\u{430} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{430}\u{432}\u{442}\u{43E}\u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{44F}\u{441}\u{43E}\u{441}\u{442}\u{43E}\u{44F}\u{43D}\u{438}\u{44F} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{432}\u{432}\u{43E}\u{434}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{446}\u{44B} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{432}\u{44B}\u{431}\u{43E}\u{440}\u{430}\u{43D}\u{435}\u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{43D}\u{43E}\u{433}\u{43E} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{432}\u{44B}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{44F}\u{434}\u{430}\u{442}\u{44B} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{432}\u{44B}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{44F}\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{438}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{446}\u{44B} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{432}\u{44B}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{44F}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{446}\u{44B} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{438}\u{437}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{438}\u{44F}\u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{430} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{438}\u{437}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{438}\u{44F}\u{441}\u{432}\u{44F}\u{437}\u{430}\u{43D}\u{43D}\u{43E}\u{433}\u{43E}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{44F} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}\u{434}\u{438}\u{430}\u{43B}\u{43E}\u{433}\u{430}\u{43F}\u{435}\u{447}\u{430}\u{442}\u{438} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}\u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{430}\u{43A}\u{43E}\u{43C}\u{430}\u{43D}\u{434}\u{44B} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{43C}\u{430}\u{441}\u{448}\u{442}\u{430}\u{431}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}\u{43F}\u{440}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440}\u{430} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{43E}\u{441}\u{43D}\u{43E}\u{432}\u{43D}\u{43E}\u{433}\u{43E}\u{43E}\u{43A}\u{43D}\u{430}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{441}\u{43A}\u{43E}\u{433}\u{43E}\u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{438}\u{44F}\u{43E}\u{43A}\u{43D}\u{430}\u{444}\u{43E}\u{440}\u{43C}\u{44B} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{44F}\u{432}\u{44B}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{44F}\u{433}\u{435}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{43E}\u{439}\u{441}\u{445}\u{435}\u{43C}\u{44B} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{44F}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{439}\u{441}\u{435}\u{440}\u{438}\u{438} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{43E}\u{442}\u{440}\u{438}\u{441}\u{43E}\u{432}\u{43A}\u{438}\u{441}\u{435}\u{442}\u{43A}\u{438}\u{433}\u{440}\u{430}\u{444}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{43E}\u{439}\u{441}\u{445}\u{435}\u{43C}\u{44B} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{43F}\u{43E}\u{43B}\u{443}\u{43F}\u{440}\u{43E}\u{437}\u{440}\u{430}\u{447}\u{43D}\u{43E}\u{441}\u{442}\u{438}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{43F}\u{440}\u{43E}\u{431}\u{435}\u{43B}\u{43E}\u{432}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{440}\u{430}\u{437}\u{43C}\u{435}\u{449}\u{435}\u{43D}\u{438}\u{44F}\u{43D}\u{430}\u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{435} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{440}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}\u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{43A}\u{438} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{441}\u{433}\u{43B}\u{430}\u{436}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{44F}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{441}\u{433}\u{43B}\u{430}\u{436}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{44F}\u{438}\u{43D}\u{434}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440}\u{430} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{441}\u{43F}\u{438}\u{441}\u{43A}\u{430}\u{437}\u{430}\u{434}\u{430}\u{447} \u{441}\u{43A}\u{432}\u{43E}\u{437}\u{43D}\u{43E}\u{435}\u{432}\u{44B}\u{440}\u{430}\u{432}\u{43D}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435} \u{441}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{435}\u{43D}\u{438}\u{435}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{444}\u{43E}\u{440}\u{43C}\u{44B}\u{432}\u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{43A}\u{430}\u{445} \u{441}\u{43F}\u{43E}\u{441}\u{43E}\u{431}\u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{438}\u{44F}\u{442}\u{435}\u{43A}\u{441}\u{442}\u{430}\u{437}\u{430}\u{433}\u{43E}\u{43B}\u{43E}\u{432}\u{43A}\u{430}\u{448}\u{43A}\u{430}\u{43B}\u{44B}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{441}\u{43F}\u{43E}\u{441}\u{43E}\u{431}\u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{44F}\u{43E}\u{433}\u{440}\u{430}\u{43D}\u{438}\u{447}\u{438}\u{432}\u{430}\u{44E}\u{449}\u{435}\u{433}\u{43E}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{44F}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{441}\u{442}\u{430}\u{43D}\u{434}\u{430}\u{440}\u{442}\u{43D}\u{430}\u{44F}\u{433}\u{440}\u{443}\u{43F}\u{43F}\u{430}\u{43A}\u{43E}\u{43C}\u{430}\u{43D}\u{434} \u{441}\u{442}\u{430}\u{43D}\u{434}\u{430}\u{440}\u{442}\u{43D}\u{43E}\u{435}\u{43E}\u{444}\u{43E}\u{440}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{435} \u{441}\u{442}\u{430}\u{442}\u{443}\u{441}\u{43E}\u{43F}\u{43E}\u{432}\u{435}\u{449}\u{435}\u{43D}\u{438}\u{44F}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F} \u{441}\u{442}\u{438}\u{43B}\u{44C}\u{441}\u{442}\u{440}\u{435}\u{43B}\u{43A}\u{438} \u{442}\u{438}\u{43F}\u{430}\u{43F}\u{43F}\u{440}\u{43E}\u{43A}\u{441}\u{438}\u{43C}\u{430}\u{446}\u{438}\u{438}\u{43B}\u{438}\u{43D}\u{438}\u{438}\u{442}\u{440}\u{435}\u{43D}\u{434}\u{430}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{442}\u{438}\u{43F}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{442}\u{438}\u{43F}\u{435}\u{434}\u{438}\u{43D}\u{438}\u{446}\u{44B}\u{448}\u{43A}\u{430}\u{43B}\u{44B}\u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438} \u{442}\u{438}\u{43F}\u{438}\u{43C}\u{43F}\u{43E}\u{440}\u{442}\u{430}\u{441}\u{435}\u{440}\u{438}\u{439}\u{441}\u{43B}\u{43E}\u{44F}\u{433}\u{435}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{43E}\u{439}\u{441}\u{445}\u{435}\u{43C}\u{44B} \u{442}\u{438}\u{43F}\u{43B}\u{438}\u{43D}\u{438}\u{438}\u{433}\u{435}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{43E}\u{439}\u{441}\u{445}\u{435}\u{43C}\u{44B} \u{442}\u{438}\u{43F}\u{43B}\u{438}\u{43D}\u{438}\u{438}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{442}\u{438}\u{43F}\u{43C}\u{430}\u{440}\u{43A}\u{435}\u{440}\u{430}\u{433}\u{435}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{43E}\u{439}\u{441}\u{445}\u{435}\u{43C}\u{44B} \u{442}\u{438}\u{43F}\u{43C}\u{430}\u{440}\u{43A}\u{435}\u{440}\u{430}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{442}\u{438}\u{43F}\u{43E}\u{431}\u{43B}\u{430}\u{441}\u{442}\u{438}\u{43E}\u{444}\u{43E}\u{440}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{442}\u{438}\u{43F}\u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}\u{438}\u{441}\u{442}\u{43E}\u{447}\u{43D}\u{438}\u{43A}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{433}\u{435}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{43E}\u{439}\u{441}\u{445}\u{435}\u{43C}\u{44B} \u{442}\u{438}\u{43F}\u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{44F}\u{441}\u{435}\u{440}\u{438}\u{438}\u{441}\u{43B}\u{43E}\u{44F}\u{433}\u{435}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{43E}\u{439}\u{441}\u{445}\u{435}\u{43C}\u{44B} \u{442}\u{438}\u{43F}\u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{44F}\u{442}\u{43E}\u{447}\u{435}\u{447}\u{43D}\u{43E}\u{433}\u{43E}\u{43E}\u{431}\u{44A}\u{435}\u{43A}\u{442}\u{430}\u{433}\u{435}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{43E}\u{439}\u{441}\u{445}\u{435}\u{43C}\u{44B} \u{442}\u{438}\u{43F}\u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{44F}\u{448}\u{43A}\u{430}\u{43B}\u{44B}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{43B}\u{435}\u{433}\u{435}\u{43D}\u{434}\u{44B}\u{433}\u{435}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{43E}\u{439}\u{441}\u{445}\u{435}\u{43C}\u{44B} \u{442}\u{438}\u{43F}\u{43F}\u{43E}\u{438}\u{441}\u{43A}\u{430}\u{43E}\u{431}\u{44A}\u{435}\u{43A}\u{442}\u{43E}\u{432}\u{433}\u{435}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{43E}\u{439}\u{441}\u{445}\u{435}\u{43C}\u{44B} \u{442}\u{438}\u{43F}\u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{446}\u{438}\u{438}\u{433}\u{435}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{43E}\u{439}\u{441}\u{445}\u{435}\u{43C}\u{44B} \u{442}\u{438}\u{43F}\u{440}\u{430}\u{437}\u{43C}\u{435}\u{449}\u{435}\u{43D}\u{438}\u{44F}\u{438}\u{437}\u{43C}\u{435}\u{440}\u{435}\u{43D}\u{438}\u{439} \u{442}\u{438}\u{43F}\u{440}\u{430}\u{437}\u{43C}\u{435}\u{449}\u{435}\u{43D}\u{438}\u{44F}\u{440}\u{435}\u{43A}\u{432}\u{438}\u{437}\u{438}\u{442}\u{43E}\u{432}\u{438}\u{437}\u{43C}\u{435}\u{440}\u{435}\u{43D}\u{438}\u{439} \u{442}\u{438}\u{43F}\u{440}\u{430}\u{43C}\u{43A}\u{438}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{443}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{442}\u{438}\u{43F}\u{441}\u{432}\u{43E}\u{434}\u{43D}\u{43E}\u{439}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{442}\u{438}\u{43F}\u{441}\u{432}\u{44F}\u{437}\u{438}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B}\u{433}\u{430}\u{43D}\u{442}\u{430} \u{442}\u{438}\u{43F}\u{441}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{435}\u{43D}\u{438}\u{44F}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{439}\u{43F}\u{43E}\u{441}\u{435}\u{440}\u{438}\u{44F}\u{43C}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{442}\u{438}\u{43F}\u{441}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{435}\u{43D}\u{438}\u{44F}\u{442}\u{43E}\u{447}\u{435}\u{43A}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{442}\u{438}\u{43F}\u{441}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{439}\u{43B}\u{438}\u{43D}\u{438}\u{438} \u{442}\u{438}\u{43F}\u{441}\u{442}\u{43E}\u{440}\u{43E}\u{43D}\u{44B}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{433}\u{440}\u{430}\u{444}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{43E}\u{439}\u{441}\u{445}\u{435}\u{43C}\u{44B} \u{442}\u{438}\u{43F}\u{444}\u{43E}\u{440}\u{43C}\u{44B}\u{43E}\u{442}\u{447}\u{435}\u{442}\u{430} \u{442}\u{438}\u{43F}\u{448}\u{43A}\u{430}\u{43B}\u{44B}\u{440}\u{430}\u{434}\u{430}\u{440}\u{43D}\u{43E}\u{439}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{444}\u{430}\u{43A}\u{442}\u{43E}\u{440}\u{43B}\u{438}\u{43D}\u{438}\u{438}\u{442}\u{440}\u{435}\u{43D}\u{434}\u{430}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B} \u{444}\u{438}\u{433}\u{443}\u{440}\u{430}\u{43A}\u{43D}\u{43E}\u{43F}\u{43A}\u{438} \u{444}\u{438}\u{433}\u{443}\u{440}\u{44B}\u{433}\u{440}\u{430}\u{444}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{43E}\u{439}\u{441}\u{445}\u{435}\u{43C}\u{44B} \u{444}\u{438}\u{43A}\u{441}\u{430}\u{446}\u{438}\u{44F}\u{432}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{446}\u{435} \u{444}\u{43E}\u{440}\u{43C}\u{430}\u{442}\u{434}\u{43D}\u{44F}\u{448}\u{43A}\u{430}\u{43B}\u{44B}\u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438} \u{444}\u{43E}\u{440}\u{43C}\u{430}\u{442}\u{43A}\u{430}\u{440}\u{442}\u{438}\u{43D}\u{43A}\u{438} \u{448}\u{438}\u{440}\u{438}\u{43D}\u{430}\u{43F}\u{43E}\u{434}\u{447}\u{438}\u{43D}\u{435}\u{43D}\u{43D}\u{44B}\u{445}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432}\u{444}\u{43E}\u{440}\u{43C}\u{44B} \u{432}\u{438}\u{434}\u{434}\u{432}\u{438}\u{436}\u{435}\u{43D}\u{438}\u{44F}\u{431}\u{443}\u{445}\u{433}\u{430}\u{43B}\u{442}\u{435}\u{440}\u{438}\u{438} \u{432}\u{438}\u{434}\u{434}\u{432}\u{438}\u{436}\u{435}\u{43D}\u{438}\u{44F}\u{43D}\u{430}\u{43A}\u{43E}\u{43F}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{432}\u{438}\u{434}\u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{440}\u{430}\u{441}\u{447}\u{435}\u{442}\u{430} \u{432}\u{438}\u{434}\u{441}\u{447}\u{435}\u{442}\u{430} \u{432}\u{438}\u{434}\u{442}\u{43E}\u{447}\u{43A}\u{438}\u{43C}\u{430}\u{440}\u{448}\u{440}\u{443}\u{442}\u{430}\u{431}\u{438}\u{437}\u{43D}\u{435}\u{441}\u{43F}\u{440}\u{43E}\u{446}\u{435}\u{441}\u{441}\u{430} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{430}\u{433}\u{440}\u{435}\u{433}\u{430}\u{442}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{43D}\u{430}\u{43A}\u{43E}\u{43F}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{433}\u{440}\u{443}\u{43F}\u{43F}\u{438}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{440}\u{435}\u{436}\u{438}\u{43C}\u{430}\u{43F}\u{440}\u{43E}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{438}\u{44F} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{441}\u{440}\u{435}\u{437}\u{430} \u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}\u{438}\u{447}\u{43D}\u{43E}\u{441}\u{442}\u{44C}\u{430}\u{433}\u{440}\u{435}\u{433}\u{430}\u{442}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{43D}\u{430}\u{43A}\u{43E}\u{43F}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{430}\u{432}\u{442}\u{43E}\u{432}\u{440}\u{435}\u{43C}\u{44F} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{437}\u{430}\u{43F}\u{438}\u{441}\u{438}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{43F}\u{440}\u{43E}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{438}\u{44F}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430} \u{430}\u{432}\u{442}\u{43E}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{44F}\u{438}\u{437}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{438}\u{439} \u{434}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{43C}\u{44B}\u{439}\u{43D}\u{43E}\u{43C}\u{435}\u{440}\u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{44F} \u{43E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{43A}\u{430}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D}\u{438}\u{435}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{440}\u{430}\u{441}\u{448}\u{438}\u{444}\u{440}\u{43E}\u{432}\u{43A}\u{438}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{447}\u{43D}\u{43E}\u{433}\u{43E}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430} \u{43E}\u{440}\u{438}\u{435}\u{43D}\u{442}\u{430}\u{446}\u{438}\u{44F}\u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{44B} \u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{438}\u{442}\u{43E}\u{433}\u{43E}\u{432}\u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{43E}\u{43A}\u{441}\u{432}\u{43E}\u{434}\u{43D}\u{43E}\u{439}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{446}\u{44B} \u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{438}\u{442}\u{43E}\u{433}\u{43E}\u{432}\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{441}\u{432}\u{43E}\u{434}\u{43D}\u{43E}\u{439}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{446}\u{44B} \u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{442}\u{435}\u{43A}\u{441}\u{442}\u{430}\u{43E}\u{442}\u{43D}\u{43E}\u{441}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{43A}\u{430}\u{440}\u{442}\u{438}\u{43D}\u{43A}\u{438} \u{440}\u{430}\u{441}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{437}\u{430}\u{433}\u{43E}\u{43B}\u{43E}\u{432}\u{43A}\u{430}\u{433}\u{440}\u{443}\u{43F}\u{43F}\u{438}\u{440}\u{43E}\u{432}\u{43A}\u{438}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{447}\u{43D}\u{43E}\u{433}\u{43E}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430} \u{441}\u{43F}\u{43E}\u{441}\u{43E}\u{431}\u{447}\u{442}\u{435}\u{43D}\u{438}\u{44F}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{439}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{447}\u{43D}\u{43E}\u{433}\u{43E}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430} \u{442}\u{438}\u{43F}\u{434}\u{432}\u{443}\u{441}\u{442}\u{43E}\u{440}\u{43E}\u{43D}\u{43D}\u{435}\u{439}\u{43F}\u{435}\u{447}\u{430}\u{442}\u{438} \u{442}\u{438}\u{43F}\u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{438}\u{44F}\u{43E}\u{431}\u{43B}\u{430}\u{441}\u{442}\u{438}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{447}\u{43D}\u{43E}\u{433}\u{43E}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430} \u{442}\u{438}\u{43F}\u{43A}\u{443}\u{440}\u{441}\u{43E}\u{440}\u{43E}\u{432}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{447}\u{43D}\u{43E}\u{433}\u{43E}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430} \u{442}\u{438}\u{43F}\u{43B}\u{438}\u{43D}\u{438}\u{438}\u{440}\u{438}\u{441}\u{443}\u{43D}\u{43A}\u{430}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{447}\u{43D}\u{43E}\u{433}\u{43E}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430} \u{442}\u{438}\u{43F}\u{43B}\u{438}\u{43D}\u{438}\u{438}\u{44F}\u{447}\u{435}\u{439}\u{43A}\u{438}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{447}\u{43D}\u{43E}\u{433}\u{43E}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430} \u{442}\u{438}\u{43F}\u{43D}\u{430}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}\u{43F}\u{435}\u{440}\u{435}\u{445}\u{43E}\u{434}\u{430}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{447}\u{43D}\u{43E}\u{433}\u{43E}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430} \u{442}\u{438}\u{43F}\u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{44F}\u{432}\u{44B}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{44F}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{447}\u{43D}\u{43E}\u{433}\u{43E}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430} \u{442}\u{438}\u{43F}\u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{44F}\u{43B}\u{438}\u{43D}\u{438}\u{439}\u{441}\u{432}\u{43E}\u{434}\u{43D}\u{43E}\u{439}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{446}\u{44B} \u{442}\u{438}\u{43F}\u{440}\u{430}\u{437}\u{43C}\u{435}\u{449}\u{435}\u{43D}\u{438}\u{44F}\u{442}\u{435}\u{43A}\u{441}\u{442}\u{430}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{447}\u{43D}\u{43E}\u{433}\u{43E}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430} \u{442}\u{438}\u{43F}\u{440}\u{438}\u{441}\u{443}\u{43D}\u{43A}\u{430}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{447}\u{43D}\u{43E}\u{433}\u{43E}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430} \u{442}\u{438}\u{43F}\u{441}\u{43C}\u{435}\u{449}\u{435}\u{43D}\u{438}\u{44F}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{447}\u{43D}\u{43E}\u{433}\u{43E}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430} \u{442}\u{438}\u{43F}\u{443}\u{437}\u{43E}\u{440}\u{430}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{447}\u{43D}\u{43E}\u{433}\u{43E}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430} \u{442}\u{438}\u{43F}\u{444}\u{430}\u{439}\u{43B}\u{430}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{447}\u{43D}\u{43E}\u{433}\u{43E}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430} \u{442}\u{43E}\u{447}\u{43D}\u{43E}\u{441}\u{442}\u{44C}\u{43F}\u{435}\u{447}\u{430}\u{442}\u{438} \u{447}\u{435}\u{440}\u{435}\u{434}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{440}\u{430}\u{441}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}\u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432}\u{43F}\u{43B}\u{430}\u{43D}\u{438}\u{440}\u{43E}\u{432}\u{449}\u{438}\u{43A}\u{430} \u{442}\u{438}\u{43F}\u{444}\u{430}\u{439}\u{43B}\u{430}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{43E}\u{433}\u{43E}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430} \u{43E}\u{431}\u{445}\u{43E}\u{434}\u{440}\u{435}\u{437}\u{443}\u{43B}\u{44C}\u{442}\u{430}\u{442}\u{430}\u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{430} \u{442}\u{438}\u{43F}\u{437}\u{430}\u{43F}\u{438}\u{441}\u{438}\u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{430} \u{432}\u{438}\u{434}\u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{438}\u{44F}\u{440}\u{430}\u{441}\u{448}\u{438}\u{444}\u{440}\u{43E}\u{432}\u{43A}\u{438}\u{43F}\u{43E}\u{441}\u{442}\u{440}\u{43E}\u{438}\u{442}\u{435}\u{43B}\u{44F}\u{43E}\u{442}\u{447}\u{435}\u{442}\u{430} \u{442}\u{438}\u{43F}\u{434}\u{43E}\u{431}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}\u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{439} \u{442}\u{438}\u{43F}\u{438}\u{437}\u{43C}\u{435}\u{440}\u{435}\u{43D}\u{438}\u{44F}\u{43F}\u{43E}\u{441}\u{442}\u{440}\u{43E}\u{438}\u{442}\u{435}\u{43B}\u{44F}\u{43E}\u{442}\u{447}\u{435}\u{442}\u{430} \u{442}\u{438}\u{43F}\u{440}\u{430}\u{437}\u{43C}\u{435}\u{449}\u{435}\u{43D}\u{438}\u{44F}\u{438}\u{442}\u{43E}\u{433}\u{43E}\u{432} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43A}\u{444}\u{430}\u{439}\u{43B}\u{443} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{434}\u{438}\u{430}\u{43B}\u{43E}\u{433}\u{430}\u{432}\u{44B}\u{431}\u{43E}\u{440}\u{430}\u{444}\u{430}\u{439}\u{43B}\u{430} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{438}\u{44F}\u{444}\u{430}\u{439}\u{43B}\u{430} \u{442}\u{438}\u{43F}\u{438}\u{437}\u{43C}\u{435}\u{440}\u{435}\u{43D}\u{438}\u{44F}\u{43F}\u{43E}\u{441}\u{442}\u{440}\u{43E}\u{438}\u{442}\u{435}\u{43B}\u{44F}\u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{430} \u{432}\u{438}\u{434}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{430}\u{43D}\u{430}\u{43B}\u{438}\u{437}\u{430} \u{43C}\u{435}\u{442}\u{43E}\u{434}\u{43A}\u{43B}\u{430}\u{441}\u{442}\u{435}\u{440}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438} \u{442}\u{438}\u{43F}\u{435}\u{434}\u{438}\u{43D}\u{438}\u{446}\u{44B}\u{438}\u{43D}\u{442}\u{435}\u{440}\u{432}\u{430}\u{43B}\u{430}\u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438}\u{430}\u{43D}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{442}\u{438}\u{43F}\u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{438}\u{44F}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{446}\u{44B}\u{440}\u{435}\u{437}\u{443}\u{43B}\u{44C}\u{442}\u{430}\u{442}\u{430}\u{430}\u{43D}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{442}\u{438}\u{43F}\u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}\u{447}\u{438}\u{441}\u{43B}\u{43E}\u{432}\u{44B}\u{445}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{439}\u{430}\u{43D}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{442}\u{438}\u{43F}\u{438}\u{441}\u{442}\u{43E}\u{447}\u{43D}\u{438}\u{43A}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{43F}\u{43E}\u{438}\u{441}\u{43A}\u{430}\u{430}\u{441}\u{441}\u{43E}\u{446}\u{438}\u{430}\u{446}\u{438}\u{439} \u{442}\u{438}\u{43F}\u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{43A}\u{438}\u{430}\u{43D}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{434}\u{435}\u{440}\u{435}\u{432}\u{43E}\u{440}\u{435}\u{448}\u{435}\u{43D}\u{438}\u{439} \u{442}\u{438}\u{43F}\u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{43A}\u{438}\u{430}\u{43D}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{43A}\u{43B}\u{430}\u{441}\u{442}\u{435}\u{440}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F} \u{442}\u{438}\u{43F}\u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{43A}\u{438}\u{430}\u{43D}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{43E}\u{431}\u{449}\u{430}\u{44F}\u{441}\u{442}\u{430}\u{442}\u{438}\u{441}\u{442}\u{438}\u{43A}\u{430} \u{442}\u{438}\u{43F}\u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{43A}\u{438}\u{430}\u{43D}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{43F}\u{43E}\u{438}\u{441}\u{43A}\u{430}\u{441}\u{441}\u{43E}\u{446}\u{438}\u{430}\u{446}\u{438}\u{439} \u{442}\u{438}\u{43F}\u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{43A}\u{438}\u{430}\u{43D}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{43F}\u{43E}\u{438}\u{441}\u{43A}\u{43F}\u{43E}\u{441}\u{43B}\u{435}\u{434}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{435}\u{439} \u{442}\u{438}\u{43F}\u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{43A}\u{438}\u{43C}\u{43E}\u{434}\u{435}\u{43B}\u{438}\u{43F}\u{440}\u{43E}\u{433}\u{43D}\u{43E}\u{437}\u{430} \u{442}\u{438}\u{43F}\u{43C}\u{435}\u{440}\u{44B}\u{440}\u{430}\u{441}\u{441}\u{442}\u{43E}\u{44F}\u{43D}\u{438}\u{44F}\u{430}\u{43D}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{442}\u{438}\u{43F}\u{43E}\u{442}\u{441}\u{435}\u{447}\u{435}\u{43D}\u{438}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{430}\u{441}\u{441}\u{43E}\u{446}\u{438}\u{430}\u{446}\u{438}\u{438} \u{442}\u{438}\u{43F}\u{43F}\u{43E}\u{43B}\u{44F}\u{430}\u{43D}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{442}\u{438}\u{43F}\u{441}\u{442}\u{430}\u{43D}\u{434}\u{430}\u{440}\u{442}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}\u{430}\u{43D}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{442}\u{438}\u{43F}\u{443}\u{43F}\u{43E}\u{440}\u{44F}\u{434}\u{43E}\u{447}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{430}\u{441}\u{441}\u{43E}\u{446}\u{438}\u{430}\u{446}\u{438}\u{438}\u{430}\u{43D}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{442}\u{438}\u{43F}\u{443}\u{43F}\u{43E}\u{440}\u{44F}\u{434}\u{43E}\u{447}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{44F}\u{448}\u{430}\u{431}\u{43B}\u{43E}\u{43D}\u{43E}\u{432}\u{43F}\u{43E}\u{441}\u{43B}\u{435}\u{434}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{435}\u{439}\u{430}\u{43D}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{442}\u{438}\u{43F}\u{443}\u{43F}\u{440}\u{43E}\u{449}\u{435}\u{43D}\u{438}\u{44F}\u{434}\u{435}\u{440}\u{435}\u{432}\u{430}\u{440}\u{435}\u{448}\u{435}\u{43D}\u{438}\u{439} ws\u{43D}\u{430}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{430} \u{432}\u{430}\u{440}\u{438}\u{430}\u{43D}\u{442}xpathxs \u{432}\u{430}\u{440}\u{438}\u{430}\u{43D}\u{442}\u{437}\u{430}\u{43F}\u{438}\u{441}\u{438}\u{434}\u{430}\u{442}\u{44B}json \u{432}\u{430}\u{440}\u{438}\u{430}\u{43D}\u{442}\u{43F}\u{440}\u{43E}\u{441}\u{442}\u{43E}\u{433}\u{43E}\u{442}\u{438}\u{43F}\u{430}xs \u{432}\u{438}\u{434}\u{433}\u{440}\u{443}\u{43F}\u{43F}\u{44B}\u{43C}\u{43E}\u{434}\u{435}\u{43B}\u{438}xs \u{432}\u{438}\u{434}\u{444}\u{430}\u{441}\u{435}\u{442}\u{430}xdto \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{435}\u{43F}\u{43E}\u{441}\u{442}\u{440}\u{43E}\u{438}\u{442}\u{435}\u{43B}\u{44F}dom \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43D}\u{43E}\u{441}\u{442}\u{44C}\u{43F}\u{440}\u{43E}\u{441}\u{442}\u{43E}\u{433}\u{43E}\u{442}\u{438}\u{43F}\u{430}xs \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43D}\u{43E}\u{441}\u{442}\u{44C}\u{441}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{43D}\u{43E}\u{433}\u{43E}\u{442}\u{438}\u{43F}\u{430}xs \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43D}\u{43E}\u{441}\u{442}\u{44C}\u{441}\u{445}\u{435}\u{43C}\u{44B}xs \u{437}\u{430}\u{43F}\u{440}\u{435}\u{449}\u{435}\u{43D}\u{43D}\u{44B}\u{435}\u{43F}\u{43E}\u{434}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43A}\u{438}xs \u{438}\u{441}\u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{43D}\u{438}\u{44F}\u{433}\u{440}\u{443}\u{43F}\u{43F}\u{43F}\u{43E}\u{434}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43A}\u{438}xs \u{43A}\u{430}\u{442}\u{435}\u{433}\u{43E}\u{440}\u{438}\u{44F}\u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}\u{430}\u{442}\u{440}\u{438}\u{431}\u{443}\u{442}\u{430}xs \u{43A}\u{430}\u{442}\u{435}\u{433}\u{43E}\u{440}\u{438}\u{44F}\u{43E}\u{433}\u{440}\u{430}\u{43D}\u{438}\u{447}\u{435}\u{43D}\u{438}\u{44F}\u{438}\u{434}\u{435}\u{43D}\u{442}\u{438}\u{447}\u{43D}\u{43E}\u{441}\u{442}\u{438}xs \u{43A}\u{430}\u{442}\u{435}\u{433}\u{43E}\u{440}\u{438}\u{44F}\u{43E}\u{433}\u{440}\u{430}\u{43D}\u{438}\u{447}\u{435}\u{43D}\u{438}\u{44F}\u{43F}\u{440}\u{43E}\u{441}\u{442}\u{440}\u{430}\u{43D}\u{441}\u{442}\u{432}\u{438}\u{43C}\u{435}\u{43D}xs \u{43C}\u{435}\u{442}\u{43E}\u{434}\u{43D}\u{430}\u{441}\u{43B}\u{435}\u{434}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}xs \u{43C}\u{43E}\u{434}\u{435}\u{43B}\u{44C}\u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{438}\u{43C}\u{43E}\u{433}\u{43E}xs \u{43D}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}\u{442}\u{438}\u{43F}\u{430}xml \u{43D}\u{435}\u{434}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{43C}\u{44B}\u{435}\u{43F}\u{43E}\u{434}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43A}\u{438}xs \u{43E}\u{431}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{43A}\u{430}\u{43F}\u{440}\u{43E}\u{431}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{445}\u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{43E}\u{432}xs \u{43E}\u{431}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{43A}\u{430}\u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{438}\u{43C}\u{43E}\u{433}\u{43E}xs \u{43E}\u{433}\u{440}\u{430}\u{43D}\u{438}\u{447}\u{435}\u{43D}\u{438}\u{435}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{44F}xs \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{44B}\u{43E}\u{442}\u{431}\u{43E}\u{440}\u{430}\u{443}\u{437}\u{43B}\u{43E}\u{432}dom \u{43F}\u{435}\u{440}\u{435}\u{43D}\u{43E}\u{441}\u{441}\u{442}\u{440}\u{43E}\u{43A}json \u{43F}\u{43E}\u{437}\u{438}\u{446}\u{438}\u{44F}\u{432}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{435}dom \u{43F}\u{440}\u{43E}\u{431}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{435}\u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{44B}xml \u{442}\u{438}\u{43F}\u{430}\u{442}\u{440}\u{438}\u{431}\u{443}\u{442}\u{430}xml \u{442}\u{438}\u{43F}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{44F}json \u{442}\u{438}\u{43F}\u{43A}\u{430}\u{43D}\u{43E}\u{43D}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{43E}\u{433}\u{43E}xml \u{442}\u{438}\u{43F}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{435}\u{43D}\u{442}\u{44B}xs \u{442}\u{438}\u{43F}\u{43F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{43A}\u{438}xml \u{442}\u{438}\u{43F}\u{440}\u{435}\u{437}\u{443}\u{43B}\u{44C}\u{442}\u{430}\u{442}\u{430}domxpath \u{442}\u{438}\u{43F}\u{443}\u{437}\u{43B}\u{430}dom \u{442}\u{438}\u{43F}\u{443}\u{437}\u{43B}\u{430}xml \u{444}\u{43E}\u{440}\u{43C}\u{430}xml \u{444}\u{43E}\u{440}\u{43C}\u{430}\u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}xs \u{444}\u{43E}\u{440}\u{43C}\u{430}\u{442}\u{434}\u{430}\u{442}\u{44B}json \u{44D}\u{43A}\u{440}\u{430}\u{43D}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{43E}\u{432}json \u{432}\u{438}\u{434}\u{441}\u{440}\u{430}\u{432}\u{43D}\u{435}\u{43D}\u{438}\u{44F}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{435}\u{43E}\u{431}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{43A}\u{438}\u{440}\u{430}\u{441}\u{448}\u{438}\u{444}\u{440}\u{43E}\u{432}\u{43A}\u{438}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{43D}\u{430}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{43A}\u{438}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{440}\u{430}\u{441}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{432}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{43D}\u{44B}\u{445}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432}\u{440}\u{435}\u{437}\u{443}\u{43B}\u{44C}\u{442}\u{430}\u{442}\u{430}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{440}\u{430}\u{441}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{438}\u{442}\u{43E}\u{433}\u{43E}\u{432}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{440}\u{430}\u{441}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{433}\u{440}\u{443}\u{43F}\u{43F}\u{438}\u{440}\u{43E}\u{432}\u{43A}\u{438}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{440}\u{430}\u{441}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{43E}\u{43B}\u{435}\u{439}\u{433}\u{440}\u{443}\u{43F}\u{43F}\u{438}\u{440}\u{43E}\u{432}\u{43A}\u{438}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{440}\u{430}\u{441}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{43E}\u{43B}\u{44F}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{440}\u{430}\u{441}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{440}\u{435}\u{43A}\u{432}\u{438}\u{437}\u{438}\u{442}\u{43E}\u{432}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{440}\u{430}\u{441}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{440}\u{435}\u{441}\u{443}\u{440}\u{441}\u{43E}\u{432}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{442}\u{438}\u{43F}\u{431}\u{443}\u{445}\u{433}\u{430}\u{43B}\u{442}\u{435}\u{440}\u{441}\u{43A}\u{43E}\u{433}\u{43E}\u{43E}\u{441}\u{442}\u{430}\u{442}\u{43A}\u{430}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{442}\u{438}\u{43F}\u{432}\u{44B}\u{432}\u{43E}\u{434}\u{430}\u{442}\u{435}\u{43A}\u{441}\u{442}\u{430}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{442}\u{438}\u{43F}\u{433}\u{440}\u{443}\u{43F}\u{43F}\u{438}\u{440}\u{43E}\u{432}\u{43A}\u{438}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{442}\u{438}\u{43F}\u{433}\u{440}\u{443}\u{43F}\u{43F}\u{44B}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432}\u{43E}\u{442}\u{431}\u{43E}\u{440}\u{430}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{442}\u{438}\u{43F}\u{434}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{438}\u{44F}\u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}\u{430}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{442}\u{438}\u{43F}\u{437}\u{430}\u{433}\u{43E}\u{43B}\u{43E}\u{432}\u{43A}\u{430}\u{43F}\u{43E}\u{43B}\u{435}\u{439}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{442}\u{438}\u{43F}\u{43C}\u{430}\u{43A}\u{435}\u{442}\u{430}\u{433}\u{440}\u{443}\u{43F}\u{43F}\u{438}\u{440}\u{43E}\u{432}\u{43A}\u{438}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{442}\u{438}\u{43F}\u{43C}\u{430}\u{43A}\u{435}\u{442}\u{430}\u{43E}\u{431}\u{43B}\u{430}\u{441}\u{442}\u{438}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{442}\u{438}\u{43F}\u{43E}\u{441}\u{442}\u{430}\u{442}\u{43A}\u{430}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{442}\u{438}\u{43F}\u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}\u{430}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{442}\u{438}\u{43F}\u{440}\u{430}\u{437}\u{43C}\u{435}\u{449}\u{435}\u{43D}\u{438}\u{44F}\u{442}\u{435}\u{43A}\u{441}\u{442}\u{430}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{442}\u{438}\u{43F}\u{441}\u{432}\u{44F}\u{437}\u{438}\u{43D}\u{430}\u{431}\u{43E}\u{440}\u{43E}\u{432}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{442}\u{438}\u{43F}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{440}\u{435}\u{437}\u{443}\u{43B}\u{44C}\u{442}\u{430}\u{442}\u{430}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{440}\u{430}\u{441}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{43B}\u{435}\u{433}\u{435}\u{43D}\u{434}\u{44B}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{44B}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{442}\u{438}\u{43F}\u{43F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{438}\u{44F}\u{43E}\u{442}\u{431}\u{43E}\u{440}\u{430}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{44F}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{43A}\u{438}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{44F}\u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{435}\u{43A}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{441}\u{43E}\u{441}\u{442}\u{43E}\u{44F}\u{43D}\u{438}\u{435}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{43A}\u{438}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{441}\u{43F}\u{43E}\u{441}\u{43E}\u{431}\u{432}\u{43E}\u{441}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}\u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{435}\u{43A}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{440}\u{435}\u{437}\u{443}\u{43B}\u{44C}\u{442}\u{430}\u{442}\u{430} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{430}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{430}\u{432}\u{442}\u{43E}\u{43F}\u{43E}\u{437}\u{438}\u{446}\u{438}\u{44F}\u{440}\u{435}\u{441}\u{443}\u{440}\u{441}\u{43E}\u{432}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{432}\u{430}\u{440}\u{438}\u{430}\u{43D}\u{442}\u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}\u{433}\u{440}\u{443}\u{43F}\u{43F}\u{438}\u{440}\u{43E}\u{432}\u{43A}\u{438}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{440}\u{430}\u{441}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{440}\u{435}\u{441}\u{443}\u{440}\u{441}\u{43E}\u{432}\u{432}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{435}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{444}\u{438}\u{43A}\u{441}\u{430}\u{446}\u{438}\u{44F}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{443}\u{441}\u{43B}\u{43E}\u{432}\u{43D}\u{43E}\u{433}\u{43E}\u{43E}\u{444}\u{43E}\u{440}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{432}\u{430}\u{436}\u{43D}\u{43E}\u{441}\u{442}\u{44C}\u{438}\u{43D}\u{442}\u{435}\u{440}\u{43D}\u{435}\u{442}\u{43F}\u{43E}\u{447}\u{442}\u{43E}\u{432}\u{43E}\u{433}\u{43E}\u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{44F} \u{43E}\u{431}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{43A}\u{430}\u{442}\u{435}\u{43A}\u{441}\u{442}\u{430}\u{438}\u{43D}\u{442}\u{435}\u{440}\u{43D}\u{435}\u{442}\u{43F}\u{43E}\u{447}\u{442}\u{43E}\u{432}\u{43E}\u{433}\u{43E}\u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{44F} \u{441}\u{43F}\u{43E}\u{441}\u{43E}\u{431}\u{43A}\u{43E}\u{434}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}\u{438}\u{43D}\u{442}\u{435}\u{440}\u{43D}\u{435}\u{442}\u{43F}\u{43E}\u{447}\u{442}\u{43E}\u{432}\u{43E}\u{433}\u{43E}\u{432}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F} \u{441}\u{43F}\u{43E}\u{441}\u{43E}\u{431}\u{43A}\u{43E}\u{434}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}\u{43D}\u{435}ascii\u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{43E}\u{432}\u{438}\u{43D}\u{442}\u{435}\u{440}\u{43D}\u{435}\u{442}\u{43F}\u{43E}\u{447}\u{442}\u{43E}\u{432}\u{43E}\u{433}\u{43E}\u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{44F} \u{442}\u{438}\u{43F}\u{442}\u{435}\u{43A}\u{441}\u{442}\u{430}\u{43F}\u{43E}\u{447}\u{442}\u{43E}\u{432}\u{43E}\u{433}\u{43E}\u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{44F} \u{43F}\u{440}\u{43E}\u{442}\u{43E}\u{43A}\u{43E}\u{43B}\u{438}\u{43D}\u{442}\u{435}\u{440}\u{43D}\u{435}\u{442}\u{43F}\u{43E}\u{447}\u{442}\u{44B} \u{441}\u{442}\u{430}\u{442}\u{443}\u{441}\u{440}\u{430}\u{437}\u{431}\u{43E}\u{440}\u{430}\u{43F}\u{43E}\u{447}\u{442}\u{43E}\u{432}\u{43E}\u{433}\u{43E}\u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{44F} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{442}\u{440}\u{430}\u{43D}\u{437}\u{430}\u{43A}\u{446}\u{438}\u{438}\u{437}\u{430}\u{43F}\u{438}\u{441}\u{438}\u{436}\u{443}\u{440}\u{43D}\u{430}\u{43B}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{438} \u{441}\u{442}\u{430}\u{442}\u{443}\u{441}\u{442}\u{440}\u{430}\u{43D}\u{437}\u{430}\u{43A}\u{446}\u{438}\u{438}\u{437}\u{430}\u{43F}\u{438}\u{441}\u{438}\u{436}\u{443}\u{440}\u{43D}\u{430}\u{43B}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{438} \u{443}\u{440}\u{43E}\u{432}\u{435}\u{43D}\u{44C}\u{436}\u{443}\u{440}\u{43D}\u{430}\u{43B}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{438} \u{440}\u{430}\u{441}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{445}\u{440}\u{430}\u{43D}\u{438}\u{43B}\u{438}\u{449}\u{430}\u{441}\u{435}\u{440}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{432}\u{43A}\u{440}\u{438}\u{43F}\u{442}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{438} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{432}\u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{43D}\u{438}\u{44F}\u{441}\u{435}\u{440}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{432}\u{43A}\u{440}\u{438}\u{43F}\u{442}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{438} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{43F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{43A}\u{438}\u{441}\u{435}\u{440}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{430}\u{43A}\u{440}\u{438}\u{43F}\u{442}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{438} \u{442}\u{438}\u{43F}\u{445}\u{440}\u{430}\u{43D}\u{438}\u{43B}\u{438}\u{449}\u{430}\u{441}\u{435}\u{440}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{432}\u{43A}\u{440}\u{438}\u{43F}\u{442}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{438} \u{43A}\u{43E}\u{434}\u{438}\u{440}\u{43E}\u{432}\u{43A}\u{430}\u{438}\u{43C}\u{435}\u{43D}\u{444}\u{430}\u{439}\u{43B}\u{43E}\u{432}\u{432}zip\u{444}\u{430}\u{439}\u{43B}\u{435} \u{43C}\u{435}\u{442}\u{43E}\u{434}\u{441}\u{436}\u{430}\u{442}\u{438}\u{44F}zip \u{43C}\u{435}\u{442}\u{43E}\u{434}\u{448}\u{438}\u{444}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}zip \u{440}\u{435}\u{436}\u{438}\u{43C}\u{432}\u{43E}\u{441}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}\u{43F}\u{443}\u{442}\u{435}\u{439}\u{444}\u{430}\u{439}\u{43B}\u{43E}\u{432}zip \u{440}\u{435}\u{436}\u{438}\u{43C}\u{43E}\u{431}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{43A}\u{438}\u{43F}\u{43E}\u{434}\u{43A}\u{430}\u{442}\u{430}\u{43B}\u{43E}\u{433}\u{43E}\u{432}zip \u{440}\u{435}\u{436}\u{438}\u{43C}\u{441}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{435}\u{43D}\u{438}\u{44F}\u{43F}\u{443}\u{442}\u{435}\u{439}zip \u{443}\u{440}\u{43E}\u{432}\u{435}\u{43D}\u{44C}\u{441}\u{436}\u{430}\u{442}\u{438}\u{44F}zip \u{437}\u{432}\u{443}\u{43A}\u{43E}\u{432}\u{43E}\u{435}\u{43E}\u{43F}\u{43E}\u{432}\u{435}\u{449}\u{435}\u{43D}\u{438}\u{435} \u{43D}\u{430}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{435}\u{440}\u{435}\u{445}\u{43E}\u{434}\u{430}\u{43A}\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{435} \u{43F}\u{43E}\u{437}\u{438}\u{446}\u{438}\u{44F}\u{432}\u{43F}\u{43E}\u{442}\u{43E}\u{43A}\u{435} \u{43F}\u{43E}\u{440}\u{44F}\u{434}\u{43E}\u{43A}\u{431}\u{430}\u{439}\u{442}\u{43E}\u{432} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{431}\u{43B}\u{43E}\u{43A}\u{438}\u{440}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{443}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}\u{431}\u{43B}\u{43E}\u{43A}\u{438}\u{440}\u{43E}\u{432}\u{43A}\u{43E}\u{439}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{441}\u{435}\u{440}\u{432}\u{438}\u{441}\u{432}\u{441}\u{442}\u{440}\u{43E}\u{435}\u{43D}\u{43D}\u{44B}\u{445}\u{43F}\u{43E}\u{43A}\u{443}\u{43F}\u{43E}\u{43A} \u{441}\u{43E}\u{441}\u{442}\u{43E}\u{44F}\u{43D}\u{438}\u{435}\u{444}\u{43E}\u{43D}\u{43E}\u{432}\u{43E}\u{433}\u{43E}\u{437}\u{430}\u{434}\u{430}\u{43D}\u{438}\u{44F} \u{442}\u{438}\u{43F}\u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{447}\u{438}\u{43A}\u{430}\u{434}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{44F}\u{435}\u{43C}\u{44B}\u{445}\u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{439} \u{443}\u{440}\u{43E}\u{432}\u{435}\u{43D}\u{44C}\u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}\u{437}\u{430}\u{449}\u{438}\u{449}\u{435}\u{43D}\u{43D}\u{43E}\u{433}\u{43E}\u{441}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{435}\u{43D}\u{438}\u{44F}ftp \u{43D}\u{430}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{43E}\u{440}\u{44F}\u{434}\u{43A}\u{430}\u{441}\u{445}\u{435}\u{43C}\u{44B}\u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{430} \u{442}\u{438}\u{43F}\u{434}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{438}\u{44F}\u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}\u{430}\u{43C}\u{438}\u{441}\u{445}\u{435}\u{43C}\u{44B}\u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{430} \u{442}\u{438}\u{43F}\u{43A}\u{43E}\u{43D}\u{442}\u{440}\u{43E}\u{43B}\u{44C}\u{43D}\u{43E}\u{439}\u{442}\u{43E}\u{447}\u{43A}\u{438}\u{441}\u{445}\u{435}\u{43C}\u{44B}\u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{430} \u{442}\u{438}\u{43F}\u{43E}\u{431}\u{44A}\u{435}\u{434}\u{438}\u{43D}\u{435}\u{43D}\u{438}\u{44F}\u{441}\u{445}\u{435}\u{43C}\u{44B}\u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{430} \u{442}\u{438}\u{43F}\u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{430}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{43E}\u{439}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{446}\u{44B}\u{441}\u{445}\u{435}\u{43C}\u{44B}\u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{430} \u{442}\u{438}\u{43F}\u{441}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{435}\u{43D}\u{438}\u{44F}\u{441}\u{445}\u{435}\u{43C}\u{44B}\u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{430} http\u{43C}\u{435}\u{442}\u{43E}\u{434} \u{430}\u{432}\u{442}\u{43E}\u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{43E}\u{431}\u{449}\u{435}\u{433}\u{43E}\u{440}\u{435}\u{43A}\u{432}\u{438}\u{437}\u{438}\u{442}\u{430} \u{430}\u{432}\u{442}\u{43E}\u{43F}\u{440}\u{435}\u{444}\u{438}\u{43A}\u{441}\u{43D}\u{43E}\u{43C}\u{435}\u{440}\u{430}\u{437}\u{430}\u{434}\u{430}\u{447}\u{438} \u{432}\u{430}\u{440}\u{438}\u{430}\u{43D}\u{442}\u{432}\u{441}\u{442}\u{440}\u{43E}\u{435}\u{43D}\u{43D}\u{43E}\u{433}\u{43E}\u{44F}\u{437}\u{44B}\u{43A}\u{430} \u{432}\u{438}\u{434}\u{438}\u{435}\u{440}\u{430}\u{440}\u{445}\u{438}\u{438} \u{432}\u{438}\u{434}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{43D}\u{430}\u{43A}\u{43E}\u{43F}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{432}\u{438}\u{434}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{446}\u{44B}\u{432}\u{43D}\u{435}\u{448}\u{43D}\u{435}\u{433}\u{43E}\u{438}\u{441}\u{442}\u{43E}\u{447}\u{43D}\u{438}\u{43A}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C}\u{434}\u{432}\u{438}\u{436}\u{435}\u{43D}\u{438}\u{439}\u{43F}\u{440}\u{438}\u{43F}\u{440}\u{43E}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{438}\u{438} \u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{43E}\u{441}\u{43B}\u{435}\u{434}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{435}\u{439} \u{438}\u{43D}\u{434}\u{435}\u{43A}\u{441}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{431}\u{430}\u{437}\u{44B}\u{43F}\u{43B}\u{430}\u{43D}\u{430}\u{432}\u{438}\u{434}\u{43E}\u{432}\u{440}\u{430}\u{441}\u{447}\u{435}\u{442}\u{430} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{431}\u{44B}\u{441}\u{442}\u{440}\u{43E}\u{433}\u{43E}\u{432}\u{44B}\u{431}\u{43E}\u{440}\u{430} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{43E}\u{431}\u{449}\u{435}\u{433}\u{43E}\u{440}\u{435}\u{43A}\u{432}\u{438}\u{437}\u{438}\u{442}\u{430} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{43F}\u{43E}\u{434}\u{447}\u{438}\u{43D}\u{435}\u{43D}\u{438}\u{44F} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{43F}\u{43E}\u{43B}\u{43D}\u{43E}\u{442}\u{435}\u{43A}\u{441}\u{442}\u{43E}\u{432}\u{43E}\u{433}\u{43E}\u{43F}\u{43E}\u{438}\u{441}\u{43A}\u{430} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{440}\u{430}\u{437}\u{434}\u{435}\u{43B}\u{44F}\u{435}\u{43C}\u{44B}\u{445}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{43E}\u{431}\u{449}\u{435}\u{433}\u{43E}\u{440}\u{435}\u{43A}\u{432}\u{438}\u{437}\u{438}\u{442}\u{430} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{440}\u{435}\u{43A}\u{432}\u{438}\u{437}\u{438}\u{442}\u{430} \u{43D}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}\u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}\u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F} \u{43D}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}\u{440}\u{430}\u{441}\u{448}\u{438}\u{440}\u{435}\u{43D}\u{438}\u{44F}\u{43A}\u{43E}\u{43D}\u{444}\u{438}\u{433}\u{443}\u{440}\u{430}\u{446}\u{438}\u{438} \u{43D}\u{430}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{435}\u{440}\u{435}\u{434}\u{430}\u{447}\u{438} \u{43E}\u{431}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{440}\u{435}\u{434}\u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{43D}\u{44B}\u{445}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{43E}\u{43F}\u{435}\u{440}\u{430}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{435}\u{43F}\u{440}\u{43E}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{438}\u{435} \u{43E}\u{441}\u{43D}\u{43E}\u{432}\u{43D}\u{43E}\u{435}\u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{432}\u{438}\u{434}\u{430}\u{440}\u{430}\u{441}\u{447}\u{435}\u{442}\u{430} \u{43E}\u{441}\u{43D}\u{43E}\u{432}\u{43D}\u{43E}\u{435}\u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{432}\u{438}\u{434}\u{430}\u{445}\u{430}\u{440}\u{430}\u{43A}\u{442}\u{435}\u{440}\u{438}\u{441}\u{442}\u{438}\u{43A}\u{438} \u{43E}\u{441}\u{43D}\u{43E}\u{432}\u{43D}\u{43E}\u{435}\u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{437}\u{430}\u{434}\u{430}\u{447}\u{438} \u{43E}\u{441}\u{43D}\u{43E}\u{432}\u{43D}\u{43E}\u{435}\u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{43B}\u{430}\u{43D}\u{430}\u{43E}\u{431}\u{43C}\u{435}\u{43D}\u{430} \u{43E}\u{441}\u{43D}\u{43E}\u{432}\u{43D}\u{43E}\u{435}\u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{441}\u{43F}\u{440}\u{430}\u{432}\u{43E}\u{447}\u{43D}\u{438}\u{43A}\u{430} \u{43E}\u{441}\u{43D}\u{43E}\u{432}\u{43D}\u{43E}\u{435}\u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{441}\u{447}\u{435}\u{442}\u{430} \u{43F}\u{435}\u{440}\u{435}\u{43C}\u{435}\u{449}\u{435}\u{43D}\u{438}\u{435}\u{433}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{44B}\u{43F}\u{440}\u{438}\u{43F}\u{440}\u{43E}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{438}\u{438} \u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}\u{438}\u{447}\u{43D}\u{43E}\u{441}\u{442}\u{44C}\u{43D}\u{43E}\u{43C}\u{435}\u{440}\u{430}\u{431}\u{438}\u{437}\u{43D}\u{435}\u{441}\u{43F}\u{440}\u{43E}\u{446}\u{435}\u{441}\u{441}\u{430} \u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}\u{438}\u{447}\u{43D}\u{43E}\u{441}\u{442}\u{44C}\u{43D}\u{43E}\u{43C}\u{435}\u{440}\u{430}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430} \u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}\u{438}\u{447}\u{43D}\u{43E}\u{441}\u{442}\u{44C}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{440}\u{430}\u{441}\u{447}\u{435}\u{442}\u{430} \u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}\u{438}\u{447}\u{43D}\u{43E}\u{441}\u{442}\u{44C}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{441}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{438}\u{439} \u{43F}\u{43E}\u{432}\u{442}\u{43E}\u{440}\u{43D}\u{43E}\u{435}\u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{432}\u{43E}\u{437}\u{432}\u{440}\u{430}\u{449}\u{430}\u{435}\u{43C}\u{44B}\u{445}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{439} \u{43F}\u{43E}\u{43B}\u{43D}\u{43E}\u{442}\u{435}\u{43A}\u{441}\u{442}\u{43E}\u{432}\u{44B}\u{439}\u{43F}\u{43E}\u{438}\u{441}\u{43A}\u{43F}\u{440}\u{438}\u{432}\u{432}\u{43E}\u{434}\u{435}\u{43F}\u{43E}\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{435} \u{43F}\u{440}\u{438}\u{43D}\u{430}\u{434}\u{43B}\u{435}\u{436}\u{43D}\u{43E}\u{441}\u{442}\u{44C}\u{43E}\u{431}\u{44A}\u{435}\u{43A}\u{442}\u{430} \u{43F}\u{440}\u{43E}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{438}\u{435} \u{440}\u{430}\u{437}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{430}\u{443}\u{442}\u{435}\u{43D}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{446}\u{438}\u{438}\u{43E}\u{431}\u{449}\u{435}\u{433}\u{43E}\u{440}\u{435}\u{43A}\u{432}\u{438}\u{437}\u{438}\u{442}\u{430} \u{440}\u{430}\u{437}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{43E}\u{431}\u{449}\u{435}\u{433}\u{43E}\u{440}\u{435}\u{43A}\u{432}\u{438}\u{437}\u{438}\u{442}\u{430} \u{440}\u{430}\u{437}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{440}\u{430}\u{441}\u{448}\u{438}\u{440}\u{435}\u{43D}\u{438}\u{439}\u{43A}\u{43E}\u{43D}\u{444}\u{438}\u{433}\u{443}\u{440}\u{430}\u{446}\u{438}\u{438}\u{43E}\u{431}\u{449}\u{435}\u{433}\u{43E}\u{440}\u{435}\u{43A}\u{432}\u{438}\u{437}\u{438}\u{442}\u{430} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{430}\u{432}\u{442}\u{43E}\u{43D}\u{443}\u{43C}\u{435}\u{440}\u{430}\u{446}\u{438}\u{438}\u{43E}\u{431}\u{44A}\u{435}\u{43A}\u{442}\u{43E}\u{432} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{437}\u{430}\u{43F}\u{438}\u{441}\u{438}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}\u{43C}\u{43E}\u{434}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}\u{441}\u{438}\u{43D}\u{445}\u{440}\u{43E}\u{43D}\u{43D}\u{44B}\u{445}\u{432}\u{44B}\u{437}\u{43E}\u{432}\u{43E}\u{432}\u{440}\u{430}\u{441}\u{448}\u{438}\u{440}\u{435}\u{43D}\u{438}\u{439}\u{43F}\u{43B}\u{430}\u{442}\u{444}\u{43E}\u{440}\u{43C}\u{44B}\u{438}\u{432}\u{43D}\u{435}\u{448}\u{43D}\u{438}\u{445}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{435}\u{43D}\u{442} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{43F}\u{43E}\u{432}\u{442}\u{43E}\u{440}\u{43D}\u{43E}\u{433}\u{43E}\u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}\u{441}\u{435}\u{430}\u{43D}\u{441}\u{43E}\u{432} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D}\u{438}\u{44F}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{432}\u{44B}\u{431}\u{43E}\u{440}\u{430}\u{43F}\u{440}\u{438}\u{432}\u{432}\u{43E}\u{434}\u{435}\u{43F}\u{43E}\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{435} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{441}\u{43E}\u{432}\u{43C}\u{435}\u{441}\u{442}\u{438}\u{43C}\u{43E}\u{441}\u{442}\u{438} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{441}\u{43E}\u{432}\u{43C}\u{435}\u{441}\u{442}\u{438}\u{43C}\u{43E}\u{441}\u{442}\u{438}\u{438}\u{43D}\u{442}\u{435}\u{440}\u{444}\u{435}\u{439}\u{441}\u{430} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{443}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}\u{431}\u{43B}\u{43E}\u{43A}\u{438}\u{440}\u{43E}\u{432}\u{43A}\u{43E}\u{439}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{43F}\u{43E}\u{443}\u{43C}\u{43E}\u{43B}\u{447}\u{430}\u{43D}\u{438}\u{44E} \u{441}\u{435}\u{440}\u{438}\u{438}\u{43A}\u{43E}\u{434}\u{43E}\u{432}\u{43F}\u{43B}\u{430}\u{43D}\u{430}\u{432}\u{438}\u{434}\u{43E}\u{432}\u{445}\u{430}\u{440}\u{430}\u{43A}\u{442}\u{435}\u{440}\u{438}\u{441}\u{442}\u{438}\u{43A} \u{441}\u{435}\u{440}\u{438}\u{438}\u{43A}\u{43E}\u{434}\u{43E}\u{432}\u{43F}\u{43B}\u{430}\u{43D}\u{430}\u{441}\u{447}\u{435}\u{442}\u{43E}\u{432} \u{441}\u{435}\u{440}\u{438}\u{438}\u{43A}\u{43E}\u{434}\u{43E}\u{432}\u{441}\u{43F}\u{440}\u{430}\u{432}\u{43E}\u{447}\u{43D}\u{438}\u{43A}\u{430} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{438}\u{435}\u{43F}\u{440}\u{438}\u{432}\u{432}\u{43E}\u{434}\u{435} \u{441}\u{43F}\u{43E}\u{441}\u{43E}\u{431}\u{432}\u{44B}\u{431}\u{43E}\u{440}\u{430} \u{441}\u{43F}\u{43E}\u{441}\u{43E}\u{431}\u{43F}\u{43E}\u{438}\u{441}\u{43A}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{438}\u{43F}\u{440}\u{438}\u{432}\u{432}\u{43E}\u{434}\u{435}\u{43F}\u{43E}\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{435} \u{441}\u{43F}\u{43E}\u{441}\u{43E}\u{431}\u{440}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F} \u{442}\u{438}\u{43F}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{446}\u{44B}\u{432}\u{43D}\u{435}\u{448}\u{43D}\u{435}\u{433}\u{43E}\u{438}\u{441}\u{442}\u{43E}\u{447}\u{43D}\u{438}\u{43A}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{442}\u{438}\u{43F}\u{43A}\u{43E}\u{434}\u{430}\u{43F}\u{43B}\u{430}\u{43D}\u{430}\u{432}\u{438}\u{434}\u{43E}\u{432}\u{440}\u{430}\u{441}\u{447}\u{435}\u{442}\u{430} \u{442}\u{438}\u{43F}\u{43A}\u{43E}\u{434}\u{430}\u{441}\u{43F}\u{440}\u{430}\u{432}\u{43E}\u{447}\u{43D}\u{438}\u{43A}\u{430} \u{442}\u{438}\u{43F}\u{43C}\u{430}\u{43A}\u{435}\u{442}\u{430} \u{442}\u{438}\u{43F}\u{43D}\u{43E}\u{43C}\u{435}\u{440}\u{430}\u{431}\u{438}\u{437}\u{43D}\u{435}\u{441}\u{43F}\u{440}\u{43E}\u{446}\u{435}\u{441}\u{441}\u{430} \u{442}\u{438}\u{43F}\u{43D}\u{43E}\u{43C}\u{435}\u{440}\u{430}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430} \u{442}\u{438}\u{43F}\u{43D}\u{43E}\u{43C}\u{435}\u{440}\u{430}\u{437}\u{430}\u{434}\u{430}\u{447}\u{438} \u{442}\u{438}\u{43F}\u{444}\u{43E}\u{440}\u{43C}\u{44B} \u{443}\u{434}\u{430}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{434}\u{432}\u{438}\u{436}\u{435}\u{43D}\u{438}\u{439} \u{432}\u{430}\u{436}\u{43D}\u{43E}\u{441}\u{442}\u{44C}\u{43F}\u{440}\u{43E}\u{431}\u{43B}\u{435}\u{43C}\u{44B}\u{43F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{438}\u{44F}\u{440}\u{430}\u{441}\u{448}\u{438}\u{440}\u{435}\u{43D}\u{438}\u{44F}\u{43A}\u{43E}\u{43D}\u{444}\u{438}\u{433}\u{443}\u{440}\u{430}\u{446}\u{438}\u{438} \u{432}\u{430}\u{440}\u{438}\u{430}\u{43D}\u{442}\u{438}\u{43D}\u{442}\u{435}\u{440}\u{444}\u{435}\u{439}\u{441}\u{430}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{441}\u{43A}\u{43E}\u{433}\u{43E}\u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F} \u{432}\u{430}\u{440}\u{438}\u{430}\u{43D}\u{442}\u{43C}\u{430}\u{441}\u{448}\u{442}\u{430}\u{431}\u{430}\u{444}\u{43E}\u{440}\u{43C}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{441}\u{43A}\u{43E}\u{433}\u{43E}\u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F} \u{432}\u{430}\u{440}\u{438}\u{430}\u{43D}\u{442}\u{43E}\u{441}\u{43D}\u{43E}\u{432}\u{43D}\u{43E}\u{433}\u{43E}\u{448}\u{440}\u{438}\u{444}\u{442}\u{430}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{441}\u{43A}\u{43E}\u{433}\u{43E}\u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F} \u{432}\u{430}\u{440}\u{438}\u{430}\u{43D}\u{442}\u{441}\u{442}\u{430}\u{43D}\u{434}\u{430}\u{440}\u{442}\u{43D}\u{43E}\u{433}\u{43E}\u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}\u{430} \u{432}\u{430}\u{440}\u{438}\u{430}\u{43D}\u{442}\u{441}\u{442}\u{430}\u{43D}\u{434}\u{430}\u{440}\u{442}\u{43D}\u{43E}\u{439}\u{434}\u{430}\u{442}\u{44B}\u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{432}\u{438}\u{434}\u{433}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{44B} \u{432}\u{438}\u{434}\u{43A}\u{430}\u{440}\u{442}\u{438}\u{43D}\u{43A}\u{438} \u{432}\u{438}\u{434}\u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{44F}\u{43F}\u{43E}\u{43B}\u{43D}\u{43E}\u{442}\u{435}\u{43A}\u{441}\u{442}\u{43E}\u{432}\u{43E}\u{433}\u{43E}\u{43F}\u{43E}\u{438}\u{441}\u{43A}\u{430} \u{432}\u{438}\u{434}\u{440}\u{430}\u{43C}\u{43A}\u{438} \u{432}\u{438}\u{434}\u{441}\u{440}\u{430}\u{432}\u{43D}\u{435}\u{43D}\u{438}\u{44F} \u{432}\u{438}\u{434}\u{446}\u{432}\u{435}\u{442}\u{430} \u{432}\u{438}\u{434}\u{447}\u{438}\u{441}\u{43B}\u{43E}\u{432}\u{43E}\u{433}\u{43E}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{44F} \u{432}\u{438}\u{434}\u{448}\u{440}\u{438}\u{444}\u{442}\u{430} \u{434}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{43C}\u{430}\u{44F}\u{434}\u{43B}\u{438}\u{43D}\u{430} \u{434}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{43C}\u{44B}\u{439}\u{437}\u{43D}\u{430}\u{43A} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}byteordermark \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{43C}\u{435}\u{442}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{43F}\u{43E}\u{43B}\u{43D}\u{43E}\u{442}\u{435}\u{43A}\u{441}\u{442}\u{43E}\u{432}\u{43E}\u{433}\u{43E}\u{43F}\u{43E}\u{438}\u{441}\u{43A}\u{430} \u{438}\u{441}\u{442}\u{43E}\u{447}\u{43D}\u{438}\u{43A}\u{440}\u{430}\u{441}\u{448}\u{438}\u{440}\u{435}\u{43D}\u{438}\u{439}\u{43A}\u{43E}\u{43D}\u{444}\u{438}\u{433}\u{443}\u{440}\u{430}\u{446}\u{438}\u{438} \u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448}\u{430} \u{43A}\u{43E}\u{434}\u{432}\u{43E}\u{437}\u{432}\u{440}\u{430}\u{442}\u{430}\u{434}\u{438}\u{430}\u{43B}\u{43E}\u{433}\u{430} \u{43A}\u{43E}\u{434}\u{438}\u{440}\u{43E}\u{432}\u{43A}\u{430}xbase \u{43A}\u{43E}\u{434}\u{438}\u{440}\u{43E}\u{432}\u{43A}\u{430}\u{442}\u{435}\u{43A}\u{441}\u{442}\u{430} \u{43D}\u{430}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{43E}\u{438}\u{441}\u{43A}\u{430} \u{43D}\u{430}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{43A}\u{438} \u{43E}\u{431}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{440}\u{435}\u{434}\u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{43D}\u{44B}\u{445}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{43E}\u{431}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{440}\u{438}\u{438}\u{437}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{438}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{430}\u{43D}\u{435}\u{43B}\u{438}\u{440}\u{430}\u{437}\u{434}\u{435}\u{43B}\u{43E}\u{432} \u{43F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{43A}\u{430}\u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{438}\u{44F} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{434}\u{438}\u{430}\u{43B}\u{43E}\u{433}\u{430}\u{432}\u{43E}\u{43F}\u{440}\u{43E}\u{441} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{437}\u{430}\u{43F}\u{443}\u{441}\u{43A}\u{430}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{441}\u{43A}\u{43E}\u{433}\u{43E}\u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{43E}\u{43A}\u{440}\u{443}\u{433}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{438}\u{44F}\u{444}\u{43E}\u{440}\u{43C}\u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F} \u{440}\u{435}\u{436}\u{438}\u{43C}\u{43F}\u{43E}\u{43B}\u{43D}\u{43E}\u{442}\u{435}\u{43A}\u{441}\u{442}\u{43E}\u{432}\u{43E}\u{433}\u{43E}\u{43F}\u{43E}\u{438}\u{441}\u{43A}\u{430} \u{441}\u{43A}\u{43E}\u{440}\u{43E}\u{441}\u{442}\u{44C}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{441}\u{43A}\u{43E}\u{433}\u{43E}\u{441}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{435}\u{43D}\u{438}\u{44F} \u{441}\u{43E}\u{441}\u{442}\u{43E}\u{44F}\u{43D}\u{438}\u{435}\u{432}\u{43D}\u{435}\u{448}\u{43D}\u{435}\u{433}\u{43E}\u{438}\u{441}\u{442}\u{43E}\u{447}\u{43D}\u{438}\u{43A}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{441}\u{43E}\u{441}\u{442}\u{43E}\u{44F}\u{43D}\u{438}\u{435}\u{43E}\u{431}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}\u{43A}\u{43E}\u{43D}\u{444}\u{438}\u{433}\u{443}\u{440}\u{430}\u{446}\u{438}\u{438}\u{431}\u{430}\u{437}\u{44B}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{441}\u{43F}\u{43E}\u{441}\u{43E}\u{431}\u{432}\u{44B}\u{431}\u{43E}\u{440}\u{430}\u{441}\u{435}\u{440}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{430}windows \u{441}\u{43F}\u{43E}\u{441}\u{43E}\u{431}\u{43A}\u{43E}\u{434}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{438} \u{441}\u{442}\u{430}\u{442}\u{443}\u{441}\u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{44F} \u{442}\u{438}\u{43F}\u{432}\u{43D}\u{435}\u{448}\u{43D}\u{435}\u{439}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{435}\u{43D}\u{442}\u{44B} \u{442}\u{438}\u{43F}\u{43F}\u{43B}\u{430}\u{442}\u{444}\u{43E}\u{440}\u{43C}\u{44B} \u{442}\u{438}\u{43F}\u{43F}\u{43E}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{438}\u{44F}\u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448}\u{438}enter \u{442}\u{438}\u{43F}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{438}\u{43E}\u{432}\u{44B}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{438}\u{438}\u{43E}\u{431}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}\u{43A}\u{43E}\u{43D}\u{444}\u{438}\u{433}\u{443}\u{440}\u{430}\u{446}\u{438}\u{438}\u{431}\u{430}\u{437}\u{44B}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{443}\u{440}\u{43E}\u{432}\u{435}\u{43D}\u{44C}\u{438}\u{437}\u{43E}\u{43B}\u{44F}\u{446}\u{438}\u{438}\u{442}\u{440}\u{430}\u{43D}\u{437}\u{430}\u{43A}\u{446}\u{438}\u{439} \u{445}\u{435}\u{448}\u{444}\u{443}\u{43D}\u{43A}\u{446}\u{438}\u{44F} \u{447}\u{430}\u{441}\u{442}\u{438}\u{434}\u{430}\u{442}\u{44B}`,
                    type: `com\u{43E}\u{431}\u{44A}\u{435}\u{43A}\u{442} ftp\u{441}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{435}\u{43D}\u{438}\u{435} http\u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441} http\u{441}\u{435}\u{440}\u{432}\u{438}\u{441}\u{43E}\u{442}\u{432}\u{435}\u{442} http\u{441}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{435}\u{43D}\u{438}\u{435} ws\u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{44F} ws\u{43F}\u{440}\u{43E}\u{43A}\u{441}\u{438} xbase \u{430}\u{43D}\u{430}\u{43B}\u{438}\u{437}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{430}\u{43D}\u{43D}\u{43E}\u{442}\u{430}\u{446}\u{438}\u{44F}xs \u{431}\u{43B}\u{43E}\u{43A}\u{438}\u{440}\u{43E}\u{432}\u{43A}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{431}\u{443}\u{444}\u{435}\u{440}\u{434}\u{432}\u{43E}\u{438}\u{447}\u{43D}\u{44B}\u{445}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{432}\u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{43D}\u{438}\u{435}xs \u{432}\u{44B}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{433}\u{435}\u{43D}\u{435}\u{440}\u{430}\u{442}\u{43E}\u{440}\u{441}\u{43B}\u{443}\u{447}\u{430}\u{439}\u{43D}\u{44B}\u{445}\u{447}\u{438}\u{441}\u{435}\u{43B} \u{433}\u{435}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{430}\u{44F}\u{441}\u{445}\u{435}\u{43C}\u{430} \u{433}\u{435}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{438}\u{435}\u{43A}\u{43E}\u{43E}\u{440}\u{434}\u{438}\u{43D}\u{430}\u{442}\u{44B} \u{433}\u{440}\u{430}\u{444}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{430}\u{44F}\u{441}\u{445}\u{435}\u{43C}\u{430} \u{433}\u{440}\u{443}\u{43F}\u{43F}\u{430}\u{43C}\u{43E}\u{434}\u{435}\u{43B}\u{438}xs \u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{435}\u{440}\u{430}\u{441}\u{448}\u{438}\u{444}\u{440}\u{43E}\u{432}\u{43A}\u{438}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{434}\u{432}\u{43E}\u{438}\u{447}\u{43D}\u{44B}\u{435}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{435} \u{434}\u{435}\u{43D}\u{434}\u{440}\u{43E}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{430} \u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{430} \u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{430}\u{433}\u{430}\u{43D}\u{442}\u{430} \u{434}\u{438}\u{430}\u{43B}\u{43E}\u{433}\u{432}\u{44B}\u{431}\u{43E}\u{440}\u{430}\u{444}\u{430}\u{439}\u{43B}\u{430} \u{434}\u{438}\u{430}\u{43B}\u{43E}\u{433}\u{432}\u{44B}\u{431}\u{43E}\u{440}\u{430}\u{446}\u{432}\u{435}\u{442}\u{430} \u{434}\u{438}\u{430}\u{43B}\u{43E}\u{433}\u{432}\u{44B}\u{431}\u{43E}\u{440}\u{430}\u{448}\u{440}\u{438}\u{444}\u{442}\u{430} \u{434}\u{438}\u{430}\u{43B}\u{43E}\u{433}\u{440}\u{430}\u{441}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{438}\u{44F}\u{440}\u{435}\u{433}\u{43B}\u{430}\u{43C}\u{435}\u{43D}\u{442}\u{43D}\u{43E}\u{433}\u{43E}\u{437}\u{430}\u{434}\u{430}\u{43D}\u{438}\u{44F} \u{434}\u{438}\u{430}\u{43B}\u{43E}\u{433}\u{440}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}\u{441}\u{442}\u{430}\u{43D}\u{434}\u{430}\u{440}\u{442}\u{43D}\u{43E}\u{433}\u{43E}\u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}\u{430} \u{434}\u{438}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D} \u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}dom \u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}html \u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{446}\u{438}\u{44F}xs \u{434}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{44F}\u{435}\u{43C}\u{43E}\u{435}\u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{435} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C}dom \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C}fastinfoset \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C}html \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C}json \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C}xml \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C}zip\u{444}\u{430}\u{439}\u{43B}\u{430} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C}\u{442}\u{435}\u{43A}\u{441}\u{442}\u{430} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C}\u{443}\u{437}\u{43B}\u{43E}\u{432}dom \u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441} \u{437}\u{430}\u{449}\u{438}\u{449}\u{435}\u{43D}\u{43D}\u{43E}\u{435}\u{441}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{435}\u{43D}\u{438}\u{435}openssl \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{44F}\u{43F}\u{43E}\u{43B}\u{435}\u{439}\u{440}\u{430}\u{441}\u{448}\u{438}\u{444}\u{440}\u{43E}\u{432}\u{43A}\u{438}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{438}\u{437}\u{432}\u{43B}\u{435}\u{447}\u{435}\u{43D}\u{438}\u{435}\u{442}\u{435}\u{43A}\u{441}\u{442}\u{430} \u{438}\u{43C}\u{43F}\u{43E}\u{440}\u{442}xs \u{438}\u{43D}\u{442}\u{435}\u{440}\u{43D}\u{435}\u{442}\u{43F}\u{43E}\u{447}\u{442}\u{430} \u{438}\u{43D}\u{442}\u{435}\u{440}\u{43D}\u{435}\u{442}\u{43F}\u{43E}\u{447}\u{442}\u{43E}\u{432}\u{43E}\u{435}\u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{435} \u{438}\u{43D}\u{442}\u{435}\u{440}\u{43D}\u{435}\u{442}\u{43F}\u{43E}\u{447}\u{442}\u{43E}\u{432}\u{44B}\u{439}\u{43F}\u{440}\u{43E}\u{444}\u{438}\u{43B}\u{44C} \u{438}\u{43D}\u{442}\u{435}\u{440}\u{43D}\u{435}\u{442}\u{43F}\u{440}\u{43E}\u{43A}\u{441}\u{438} \u{438}\u{43D}\u{442}\u{435}\u{440}\u{43D}\u{435}\u{442}\u{441}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{435}\u{43D}\u{438}\u{435} \u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F}\u{434}\u{43B}\u{44F}\u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}xs \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{430}\u{442}\u{440}\u{438}\u{431}\u{443}\u{442}\u{430}xs \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{441}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{44F}\u{436}\u{443}\u{440}\u{43D}\u{430}\u{43B}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{438} \u{438}\u{441}\u{442}\u{43E}\u{447}\u{43D}\u{438}\u{43A}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{44B}\u{445}\u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{435}\u{43A}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{438}\u{442}\u{435}\u{440}\u{430}\u{442}\u{43E}\u{440}\u{443}\u{437}\u{43B}\u{43E}\u{432}dom \u{43A}\u{430}\u{440}\u{442}\u{438}\u{43D}\u{43A}\u{430} \u{43A}\u{432}\u{430}\u{43B}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440}\u{44B}\u{434}\u{430}\u{442}\u{44B} \u{43A}\u{432}\u{430}\u{43B}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440}\u{44B}\u{434}\u{432}\u{43E}\u{438}\u{447}\u{43D}\u{44B}\u{445}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{43A}\u{432}\u{430}\u{43B}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440}\u{44B}\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{438} \u{43A}\u{432}\u{430}\u{43B}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440}\u{44B}\u{447}\u{438}\u{441}\u{43B}\u{430} \u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{449}\u{438}\u{43A}\u{43C}\u{430}\u{43A}\u{435}\u{442}\u{430}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{449}\u{438}\u{43A}\u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{435}\u{43A}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{43A}\u{43E}\u{43D}\u{441}\u{442}\u{440}\u{443}\u{43A}\u{442}\u{43E}\u{440}\u{43C}\u{430}\u{43A}\u{435}\u{442}\u{430}\u{43E}\u{444}\u{43E}\u{440}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{43A}\u{43E}\u{43D}\u{441}\u{442}\u{440}\u{443}\u{43A}\u{442}\u{43E}\u{440}\u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{435}\u{43A}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{43A}\u{43E}\u{43D}\u{441}\u{442}\u{440}\u{443}\u{43A}\u{442}\u{43E}\u{440}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{442}\u{43D}\u{43E}\u{439}\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{438} \u{43B}\u{438}\u{43D}\u{438}\u{44F} \u{43C}\u{430}\u{43A}\u{435}\u{442}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{43C}\u{430}\u{43A}\u{435}\u{442}\u{43E}\u{431}\u{43B}\u{430}\u{441}\u{442}\u{438}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{43C}\u{430}\u{43A}\u{435}\u{442}\u{43E}\u{444}\u{43E}\u{440}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{43C}\u{430}\u{441}\u{43A}\u{430}xs \u{43C}\u{435}\u{43D}\u{435}\u{434}\u{436}\u{435}\u{440}\u{43A}\u{440}\u{438}\u{43F}\u{442}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{438} \u{43D}\u{430}\u{431}\u{43E}\u{440}\u{441}\u{445}\u{435}\u{43C}xml \u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{43A}\u{438}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{43A}\u{438}\u{441}\u{435}\u{440}\u{438}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}json \u{43E}\u{431}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{43A}\u{430}\u{43A}\u{430}\u{440}\u{442}\u{438}\u{43D}\u{43E}\u{43A} \u{43E}\u{431}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{43A}\u{430}\u{440}\u{430}\u{441}\u{448}\u{438}\u{444}\u{440}\u{43E}\u{432}\u{43A}\u{438}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{43E}\u{431}\u{445}\u{43E}\u{434}\u{434}\u{435}\u{440}\u{435}\u{432}\u{430}dom \u{43E}\u{431}\u{44A}\u{44F}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{430}\u{442}\u{440}\u{438}\u{431}\u{443}\u{442}\u{430}xs \u{43E}\u{431}\u{44A}\u{44F}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{43D}\u{43E}\u{442}\u{430}\u{446}\u{438}\u{438}xs \u{43E}\u{431}\u{44A}\u{44F}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}xs \u{43E}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{438}\u{435}\u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}\u{441}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{44F}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{436}\u{443}\u{440}\u{43D}\u{430}\u{43B}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{438} \u{43E}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{438}\u{435}\u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}\u{441}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{44F}\u{43E}\u{442}\u{43A}\u{430}\u{437}\u{432}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{435}\u{436}\u{443}\u{440}\u{43D}\u{430}\u{43B}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{438} \u{43E}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{438}\u{435}\u{43E}\u{431}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{43A}\u{438}\u{440}\u{430}\u{441}\u{448}\u{438}\u{444}\u{440}\u{43E}\u{432}\u{43A}\u{438}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{43E}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{438}\u{435}\u{43F}\u{435}\u{440}\u{435}\u{434}\u{430}\u{432}\u{430}\u{435}\u{43C}\u{43E}\u{433}\u{43E}\u{444}\u{430}\u{439}\u{43B}\u{430} \u{43E}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{438}\u{435}\u{442}\u{438}\u{43F}\u{43E}\u{432} \u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{433}\u{440}\u{443}\u{43F}\u{43F}\u{44B}\u{430}\u{442}\u{440}\u{438}\u{431}\u{443}\u{442}\u{43E}\u{432}xs \u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{433}\u{440}\u{443}\u{43F}\u{43F}\u{44B}\u{43C}\u{43E}\u{434}\u{435}\u{43B}\u{438}xs \u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{43E}\u{433}\u{440}\u{430}\u{43D}\u{438}\u{447}\u{435}\u{43D}\u{438}\u{44F}\u{438}\u{434}\u{435}\u{43D}\u{442}\u{438}\u{447}\u{43D}\u{43E}\u{441}\u{442}\u{438}xs \u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{440}\u{43E}\u{441}\u{442}\u{43E}\u{433}\u{43E}\u{442}\u{438}\u{43F}\u{430}xs \u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{441}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{43D}\u{43E}\u{433}\u{43E}\u{442}\u{438}\u{43F}\u{430}xs \u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{442}\u{438}\u{43F}\u{430}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430}dom \u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{44F}xpathxs \u{43E}\u{442}\u{431}\u{43E}\u{440}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{43F}\u{430}\u{43A}\u{435}\u{442}\u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{430}\u{435}\u{43C}\u{44B}\u{445}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{432}\u{44B}\u{431}\u{43E}\u{440}\u{430} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{44B}\u{437}\u{430}\u{43F}\u{438}\u{441}\u{438}json \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{44B}\u{437}\u{430}\u{43F}\u{438}\u{441}\u{438}xml \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{44B}\u{447}\u{442}\u{435}\u{43D}\u{438}\u{44F}xml \u{43F}\u{435}\u{440}\u{435}\u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{435}xs \u{43F}\u{43B}\u{430}\u{43D}\u{438}\u{440}\u{43E}\u{432}\u{449}\u{438}\u{43A} \u{43F}\u{43E}\u{43B}\u{435}\u{430}\u{43D}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{43F}\u{43E}\u{43B}\u{435}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{43F}\u{43E}\u{441}\u{442}\u{440}\u{43E}\u{438}\u{442}\u{435}\u{43B}\u{44C}dom \u{43F}\u{43E}\u{441}\u{442}\u{440}\u{43E}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{430} \u{43F}\u{43E}\u{441}\u{442}\u{440}\u{43E}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43E}\u{442}\u{447}\u{435}\u{442}\u{430} \u{43F}\u{43E}\u{441}\u{442}\u{440}\u{43E}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43E}\u{442}\u{447}\u{435}\u{442}\u{430}\u{430}\u{43D}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{43F}\u{43E}\u{441}\u{442}\u{440}\u{43E}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{441}\u{445}\u{435}\u{43C}xml \u{43F}\u{43E}\u{442}\u{43E}\u{43A} \u{43F}\u{43E}\u{442}\u{43E}\u{43A}\u{432}\u{43F}\u{430}\u{43C}\u{44F}\u{442}\u{438} \u{43F}\u{43E}\u{447}\u{442}\u{430} \u{43F}\u{43E}\u{447}\u{442}\u{43E}\u{432}\u{43E}\u{435}\u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{435} \u{43F}\u{440}\u{435}\u{43E}\u{431}\u{440}\u{430}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}xsl \u{43F}\u{440}\u{435}\u{43E}\u{431}\u{440}\u{430}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{43A}\u{43A}\u{430}\u{43D}\u{43E}\u{43D}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{43E}\u{43C}\u{443}xml \u{43F}\u{440}\u{43E}\u{446}\u{435}\u{441}\u{441}\u{43E}\u{440}\u{432}\u{44B}\u{432}\u{43E}\u{434}\u{430}\u{440}\u{435}\u{437}\u{443}\u{43B}\u{44C}\u{442}\u{430}\u{442}\u{430}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{432}\u{43A}\u{43E}\u{43B}\u{43B}\u{435}\u{43A}\u{446}\u{438}\u{44E}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{439} \u{43F}\u{440}\u{43E}\u{446}\u{435}\u{441}\u{441}\u{43E}\u{440}\u{432}\u{44B}\u{432}\u{43E}\u{434}\u{430}\u{440}\u{435}\u{437}\u{443}\u{43B}\u{44C}\u{442}\u{430}\u{442}\u{430}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{432}\u{442}\u{430}\u{431}\u{43B}\u{438}\u{447}\u{43D}\u{44B}\u{439}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442} \u{43F}\u{440}\u{43E}\u{446}\u{435}\u{441}\u{441}\u{43E}\u{440}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{440}\u{430}\u{437}\u{44B}\u{43C}\u{435}\u{43D}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{43F}\u{440}\u{43E}\u{441}\u{442}\u{440}\u{430}\u{43D}\u{441}\u{442}\u{432}\u{438}\u{43C}\u{435}\u{43D}dom \u{440}\u{430}\u{43C}\u{43A}\u{430} \u{440}\u{430}\u{441}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{438}\u{435}\u{440}\u{435}\u{433}\u{43B}\u{430}\u{43C}\u{435}\u{43D}\u{442}\u{43D}\u{43E}\u{433}\u{43E}\u{437}\u{430}\u{434}\u{430}\u{43D}\u{438}\u{44F} \u{440}\u{430}\u{441}\u{448}\u{438}\u{440}\u{435}\u{43D}\u{43D}\u{43E}\u{435}\u{438}\u{43C}\u{44F}xml \u{440}\u{435}\u{437}\u{443}\u{43B}\u{44C}\u{442}\u{430}\u{442}\u{447}\u{442}\u{435}\u{43D}\u{438}\u{44F}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{441}\u{432}\u{43E}\u{434}\u{43D}\u{430}\u{44F}\u{434}\u{438}\u{430}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{430} \u{441}\u{432}\u{44F}\u{437}\u{44C}\u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{430}\u{432}\u{44B}\u{431}\u{43E}\u{440}\u{430} \u{441}\u{432}\u{44F}\u{437}\u{44C}\u{43F}\u{43E}\u{442}\u{438}\u{43F}\u{443} \u{441}\u{432}\u{44F}\u{437}\u{44C}\u{43F}\u{43E}\u{442}\u{438}\u{43F}\u{443}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{441}\u{435}\u{440}\u{438}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{442}\u{43E}\u{440}xdto \u{441}\u{435}\u{440}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{430}windows \u{441}\u{435}\u{440}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{430}\u{444}\u{430}\u{439}\u{43B} \u{441}\u{435}\u{440}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{43A}\u{440}\u{438}\u{43F}\u{442}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{438} \u{441}\u{435}\u{440}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{44B}\u{443}\u{434}\u{43E}\u{441}\u{442}\u{43E}\u{432}\u{435}\u{440}\u{44F}\u{44E}\u{449}\u{438}\u{445}\u{446}\u{435}\u{43D}\u{442}\u{440}\u{43E}\u{432}windows \u{441}\u{435}\u{440}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{44B}\u{443}\u{434}\u{43E}\u{441}\u{442}\u{43E}\u{432}\u{435}\u{440}\u{44F}\u{44E}\u{449}\u{438}\u{445}\u{446}\u{435}\u{43D}\u{442}\u{440}\u{43E}\u{432}\u{444}\u{430}\u{439}\u{43B} \u{441}\u{436}\u{430}\u{442}\u{438}\u{435}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{43D}\u{430}\u{44F}\u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F} \u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{435}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44E} \u{441}\u{43E}\u{447}\u{435}\u{442}\u{430}\u{43D}\u{438}\u{435}\u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448} \u{441}\u{440}\u{430}\u{432}\u{43D}\u{435}\u{43D}\u{438}\u{435}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{439} \u{441}\u{442}\u{430}\u{43D}\u{434}\u{430}\u{440}\u{442}\u{43D}\u{430}\u{44F}\u{434}\u{430}\u{442}\u{430}\u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{441}\u{442}\u{430}\u{43D}\u{434}\u{430}\u{440}\u{442}\u{43D}\u{44B}\u{439}\u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434} \u{441}\u{445}\u{435}\u{43C}\u{430}xml \u{441}\u{445}\u{435}\u{43C}\u{430}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{442}\u{430}\u{431}\u{43B}\u{438}\u{447}\u{43D}\u{44B}\u{439}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442} \u{442}\u{435}\u{43A}\u{441}\u{442}\u{43E}\u{432}\u{44B}\u{439}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442} \u{442}\u{435}\u{441}\u{442}\u{438}\u{440}\u{443}\u{435}\u{43C}\u{43E}\u{435}\u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435} \u{442}\u{438}\u{43F}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}xml \u{443}\u{43D}\u{438}\u{43A}\u{430}\u{43B}\u{44C}\u{43D}\u{44B}\u{439}\u{438}\u{434}\u{435}\u{43D}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440} \u{444}\u{430}\u{431}\u{440}\u{438}\u{43A}\u{430}xdto \u{444}\u{430}\u{439}\u{43B} \u{444}\u{430}\u{439}\u{43B}\u{43E}\u{432}\u{44B}\u{439}\u{43F}\u{43E}\u{442}\u{43E}\u{43A} \u{444}\u{430}\u{441}\u{435}\u{442}\u{434}\u{43B}\u{438}\u{43D}\u{44B}xs \u{444}\u{430}\u{441}\u{435}\u{442}\u{43A}\u{43E}\u{43B}\u{438}\u{447}\u{435}\u{441}\u{442}\u{432}\u{430}\u{440}\u{430}\u{437}\u{440}\u{44F}\u{434}\u{43E}\u{432}\u{434}\u{440}\u{43E}\u{431}\u{43D}\u{43E}\u{439}\u{447}\u{430}\u{441}\u{442}\u{438}xs \u{444}\u{430}\u{441}\u{435}\u{442}\u{43C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{433}\u{43E}\u{432}\u{43A}\u{43B}\u{44E}\u{447}\u{430}\u{44E}\u{449}\u{435}\u{433}\u{43E}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{44F}xs \u{444}\u{430}\u{441}\u{435}\u{442}\u{43C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{433}\u{43E}\u{438}\u{441}\u{43A}\u{43B}\u{44E}\u{447}\u{430}\u{44E}\u{449}\u{435}\u{433}\u{43E}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{44F}xs \u{444}\u{430}\u{441}\u{435}\u{442}\u{43C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{439}\u{434}\u{43B}\u{438}\u{43D}\u{44B}xs \u{444}\u{430}\u{441}\u{435}\u{442}\u{43C}\u{438}\u{43D}\u{438}\u{43C}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{433}\u{43E}\u{432}\u{43A}\u{43B}\u{44E}\u{447}\u{430}\u{44E}\u{449}\u{435}\u{433}\u{43E}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{44F}xs \u{444}\u{430}\u{441}\u{435}\u{442}\u{43C}\u{438}\u{43D}\u{438}\u{43C}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{433}\u{43E}\u{438}\u{441}\u{43A}\u{43B}\u{44E}\u{447}\u{430}\u{44E}\u{449}\u{435}\u{433}\u{43E}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{44F}xs \u{444}\u{430}\u{441}\u{435}\u{442}\u{43C}\u{438}\u{43D}\u{438}\u{43C}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{439}\u{434}\u{43B}\u{438}\u{43D}\u{44B}xs \u{444}\u{430}\u{441}\u{435}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{437}\u{446}\u{430}xs \u{444}\u{430}\u{441}\u{435}\u{442}\u{43E}\u{431}\u{449}\u{435}\u{433}\u{43E}\u{43A}\u{43E}\u{43B}\u{438}\u{447}\u{435}\u{441}\u{442}\u{432}\u{430}\u{440}\u{430}\u{437}\u{440}\u{44F}\u{434}\u{43E}\u{432}xs \u{444}\u{430}\u{441}\u{435}\u{442}\u{43F}\u{435}\u{440}\u{435}\u{447}\u{438}\u{441}\u{43B}\u{435}\u{43D}\u{438}\u{44F}xs \u{444}\u{430}\u{441}\u{435}\u{442}\u{43F}\u{440}\u{43E}\u{431}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{445}\u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{43E}\u{432}xs \u{444}\u{438}\u{43B}\u{44C}\u{442}\u{440}\u{443}\u{437}\u{43B}\u{43E}\u{432}dom \u{444}\u{43E}\u{440}\u{43C}\u{430}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{430}\u{44F}\u{441}\u{442}\u{440}\u{43E}\u{43A}\u{430} \u{444}\u{43E}\u{440}\u{43C}\u{430}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{44B}\u{439}\u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442} \u{444}\u{440}\u{430}\u{433}\u{43C}\u{435}\u{43D}\u{442}xs \u{445}\u{435}\u{448}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{445}\u{440}\u{430}\u{43D}\u{438}\u{43B}\u{438}\u{449}\u{435}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{44F} \u{446}\u{432}\u{435}\u{442} \u{447}\u{442}\u{435}\u{43D}\u{438}\u{435}fastinfoset \u{447}\u{442}\u{435}\u{43D}\u{438}\u{435}html \u{447}\u{442}\u{435}\u{43D}\u{438}\u{435}json \u{447}\u{442}\u{435}\u{43D}\u{438}\u{435}xml \u{447}\u{442}\u{435}\u{43D}\u{438}\u{435}zip\u{444}\u{430}\u{439}\u{43B}\u{430} \u{447}\u{442}\u{435}\u{43D}\u{438}\u{435}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{447}\u{442}\u{435}\u{43D}\u{438}\u{435}\u{442}\u{435}\u{43A}\u{441}\u{442}\u{430} \u{447}\u{442}\u{435}\u{43D}\u{438}\u{435}\u{443}\u{437}\u{43B}\u{43E}\u{432}dom \u{448}\u{440}\u{438}\u{444}\u{442} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{440}\u{435}\u{437}\u{443}\u{43B}\u{44C}\u{442}\u{430}\u{442}\u{430}\u{43A}\u{43E}\u{43C}\u{43F}\u{43E}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} comsafearray \u{434}\u{435}\u{440}\u{435}\u{432}\u{43E}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{439} \u{43C}\u{430}\u{441}\u{441}\u{438}\u{432} \u{441}\u{43E}\u{43E}\u{442}\u{432}\u{435}\u{442}\u{441}\u{442}\u{432}\u{438}\u{435} \u{441}\u{43F}\u{438}\u{441}\u{43E}\u{43A}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{439} \u{441}\u{442}\u{440}\u{443}\u{43A}\u{442}\u{443}\u{440}\u{430} \u{442}\u{430}\u{431}\u{43B}\u{438}\u{446}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{439} \u{444}\u{438}\u{43A}\u{441}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{430}\u{44F}\u{441}\u{442}\u{440}\u{443}\u{43A}\u{442}\u{443}\u{440}\u{430} \u{444}\u{438}\u{43A}\u{441}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{43E}\u{435}\u{441}\u{43E}\u{43E}\u{442}\u{432}\u{435}\u{442}\u{441}\u{442}\u{432}\u{438}\u{435} \u{444}\u{438}\u{43A}\u{441}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{44B}\u{439}\u{43C}\u{430}\u{441}\u{441}\u{438}\u{432} `,
                    literal: r
                },
                contains: [
                    l,
                    d,
                    c,
                    u,
                    i,
                    a,
                    o,
                    s
                ]
            };
        }
        t.exports = n;
    }), d = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = /^[a-zA-Z][a-zA-Z0-9-]*/, r = [
                `ALPHA`,
                `BIT`,
                `CHAR`,
                `CR`,
                `CRLF`,
                `CTL`,
                `DIGIT`,
                `DQUOTE`,
                `HEXDIG`,
                `HTAB`,
                `LF`,
                `LWSP`,
                `OCTET`,
                `SP`,
                `VCHAR`,
                `WSP`
            ], i = e.COMMENT(/;/, /$/);
            return {
                name: `Augmented Backus-Naur Form`,
                illegal: /[!@#$^&',?+~`|:]/,
                keywords: r,
                contains: [
                    {
                        scope: `operator`,
                        match: /=\/?/
                    },
                    {
                        scope: `attribute`,
                        match: t.concat(n, /(?=\s*=)/)
                    },
                    i,
                    {
                        scope: `symbol`,
                        match: /%b[0-1]+(-[0-1]+|(\.[0-1]+)+)?/
                    },
                    {
                        scope: `symbol`,
                        match: /%d[0-9]+(-[0-9]+|(\.[0-9]+)+)?/
                    },
                    {
                        scope: `symbol`,
                        match: /%x[0-9A-F]+(-[0-9A-F]+|(\.[0-9A-F]+)+)?/
                    },
                    {
                        scope: `symbol`,
                        match: /%[si](?=".*")/
                    },
                    e.QUOTE_STRING_MODE,
                    e.NUMBER_MODE
                ]
            };
        }
        t.exports = n;
    }), f = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = [
                `GET`,
                `POST`,
                `HEAD`,
                `PUT`,
                `DELETE`,
                `CONNECT`,
                `OPTIONS`,
                `PATCH`,
                `TRACE`
            ];
            return {
                name: `Apache Access Log`,
                contains: [
                    {
                        className: `number`,
                        begin: /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}(:\d{1,5})?\b/,
                        relevance: 5
                    },
                    {
                        className: `number`,
                        begin: /\b\d+\b/,
                        relevance: 0
                    },
                    {
                        className: `string`,
                        begin: t.concat(/"/, t.either(...n)),
                        end: /"/,
                        keywords: n,
                        illegal: /\n/,
                        relevance: 5,
                        contains: [
                            {
                                begin: /HTTP\/[12]\.\d'/,
                                relevance: 5
                            }
                        ]
                    },
                    {
                        className: `string`,
                        begin: /\[\d[^\]\n]{8,}\]/,
                        illegal: /\n/,
                        relevance: 1
                    },
                    {
                        className: `string`,
                        begin: /\[/,
                        end: /\]/,
                        illegal: /\n/,
                        relevance: 0
                    },
                    {
                        className: `string`,
                        begin: /"Mozilla\/\d\.\d \(/,
                        end: /"/,
                        illegal: /\n/,
                        relevance: 3
                    },
                    {
                        className: `string`,
                        begin: /"/,
                        end: /"/,
                        illegal: /\n/,
                        relevance: 0
                    }
                ]
            };
        }
        t.exports = n;
    }), p = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = /[a-zA-Z_$][a-zA-Z0-9_$]*/, r = t.concat(n, t.concat(`(\\.`, n, `)*`)), i = /([*]|[a-zA-Z_$][a-zA-Z0-9_$]*)/, a = {
                className: `rest_arg`,
                begin: /[.]{3}/,
                end: n,
                relevance: 10
            };
            return {
                name: `ActionScript`,
                aliases: [
                    `as`
                ],
                keywords: {
                    keyword: `as.break.case.catch.class.const.continue.default.delete.do.dynamic.each.else.extends.final.finally.for.function.get.if.implements.import.in.include.instanceof.interface.internal.is.namespace.native.new.override.package.private.protected.public.return.set.static.super.switch.this.throw.try.typeof.use.var.void.while.with`.split(`.`),
                    literal: [
                        `true`,
                        `false`,
                        `null`,
                        `undefined`
                    ]
                },
                contains: [
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE,
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    e.C_NUMBER_MODE,
                    {
                        match: [
                            /\bpackage/,
                            /\s+/,
                            r
                        ],
                        className: {
                            1: `keyword`,
                            3: `title.class`
                        }
                    },
                    {
                        match: [
                            /\b(?:class|interface|extends|implements)/,
                            /\s+/,
                            n
                        ],
                        className: {
                            1: `keyword`,
                            3: `title.class`
                        }
                    },
                    {
                        className: `meta`,
                        beginKeywords: `import include`,
                        end: /;/,
                        keywords: {
                            keyword: `import include`
                        }
                    },
                    {
                        beginKeywords: `function`,
                        end: /[{;]/,
                        excludeEnd: !0,
                        illegal: /\S/,
                        contains: [
                            e.inherit(e.TITLE_MODE, {
                                className: `title.function`
                            }),
                            {
                                className: `params`,
                                begin: /\(/,
                                end: /\)/,
                                contains: [
                                    e.APOS_STRING_MODE,
                                    e.QUOTE_STRING_MODE,
                                    e.C_LINE_COMMENT_MODE,
                                    e.C_BLOCK_COMMENT_MODE,
                                    a
                                ]
                            },
                            {
                                begin: t.concat(/:\s*/, i)
                            }
                        ]
                    },
                    e.METHOD_GUARD
                ],
                illegal: /#/
            };
        }
        t.exports = n;
    }), m = o((e, t)=>{
        function n(e) {
            let t = `\\d(_|\\d)*`;
            t, t, t;
            let n = `[A-Za-z](_?[A-Za-z0-9.])*`, r = `[]\\{\\}%#'"`, i = e.COMMENT(`--`, `$`), a = {
                begin: `\\s+:\\s+`,
                end: `\\s*(:=|;|\\)|=>|$)`,
                illegal: r,
                contains: [
                    {
                        beginKeywords: `loop for declare others`,
                        endsParent: !0
                    },
                    {
                        className: `keyword`,
                        beginKeywords: `not null constant access function procedure in out aliased exception`
                    },
                    {
                        className: `type`,
                        begin: n,
                        endsParent: !0,
                        relevance: 0
                    }
                ]
            };
            return {
                name: `Ada`,
                case_insensitive: !0,
                keywords: {
                    keyword: `abort.else.new.return.abs.elsif.not.reverse.abstract.end.accept.entry.select.access.exception.of.separate.aliased.exit.or.some.all.others.subtype.and.for.out.synchronized.array.function.overriding.at.tagged.generic.package.task.begin.goto.pragma.terminate.body.private.then.if.procedure.type.case.in.protected.constant.interface.is.raise.use.declare.range.delay.limited.record.when.delta.loop.rem.while.digits.renames.with.do.mod.requeue.xor`.split(`.`),
                    literal: [
                        `True`,
                        `False`
                    ]
                },
                contains: [
                    i,
                    {
                        className: `string`,
                        begin: /"/,
                        end: /"/,
                        contains: [
                            {
                                begin: /""/,
                                relevance: 0
                            }
                        ]
                    },
                    {
                        className: `string`,
                        begin: /'.'/
                    },
                    {
                        className: `number`,
                        begin: `\\b(\\d(_|\\d)*#\\w+(\\.\\w+)?#([eE][-+]?\\d(_|\\d)*)?|\\d(_|\\d)*(\\.\\d(_|\\d)*)?([eE][-+]?\\d(_|\\d)*)?)`,
                        relevance: 0
                    },
                    {
                        className: `symbol`,
                        begin: `'` + n
                    },
                    {
                        className: `title`,
                        begin: `(\\bwith\\s+)?(\\bprivate\\s+)?\\bpackage\\s+(\\bbody\\s+)?`,
                        end: `(is|$)`,
                        keywords: `package body`,
                        excludeBegin: !0,
                        excludeEnd: !0,
                        illegal: r
                    },
                    {
                        begin: `(\\b(with|overriding)\\s+)?\\b(function|procedure)\\s+`,
                        end: `(\\bis|\\bwith|\\brenames|\\)\\s*;)`,
                        keywords: `overriding function procedure with is renames return`,
                        returnBegin: !0,
                        contains: [
                            i,
                            {
                                className: `title`,
                                begin: `(\\bwith\\s+)?\\b(function|procedure)\\s+`,
                                end: `(\\(|\\s+|$)`,
                                excludeBegin: !0,
                                excludeEnd: !0,
                                illegal: r
                            },
                            a,
                            {
                                className: `type`,
                                begin: `\\breturn\\s+`,
                                end: `(\\s+|;|$)`,
                                keywords: `return`,
                                excludeBegin: !0,
                                excludeEnd: !0,
                                endsParent: !0,
                                illegal: r
                            }
                        ]
                    },
                    {
                        className: `type`,
                        begin: `\\b(sub)?type\\s+`,
                        end: `\\s+`,
                        keywords: `type`,
                        excludeBegin: !0,
                        illegal: r
                    },
                    a
                ]
            };
        }
        t.exports = n;
    }), h = o((e, t)=>{
        function n(e) {
            let t = {
                className: `built_in`,
                begin: `\\b(void|bool|int8|int16|int32|int64|int|uint8|uint16|uint32|uint64|uint|string|ref|array|double|float|auto|dictionary)`
            }, n = {
                className: `symbol`,
                begin: `[a-zA-Z0-9_]+@`
            }, r = {
                className: `keyword`,
                begin: `<`,
                end: `>`,
                contains: [
                    t,
                    n
                ]
            };
            return t.contains = [
                r
            ], n.contains = [
                r
            ], {
                name: `AngelScript`,
                aliases: [
                    `asc`
                ],
                keywords: `for.in|0.break.continue.while.do|0.return.if.else.case.switch.namespace.is.cast.or.and.xor.not.get|0.in.inout|10.out.override.set|0.private.public.const.default|0.final.shared.external.mixin|10.enum.typedef.funcdef.this.super.import.from.interface.abstract|0.try.catch.protected.explicit.property`.split(`.`),
                illegal: `(^using\\s+[A-Za-z0-9_\\.]+;$|\\bfunction\\s*[^\\(])`,
                contains: [
                    {
                        className: `string`,
                        begin: `'`,
                        end: `'`,
                        illegal: `\\n`,
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ],
                        relevance: 0
                    },
                    {
                        className: `string`,
                        begin: `"""`,
                        end: `"""`
                    },
                    {
                        className: `string`,
                        begin: `"`,
                        end: `"`,
                        illegal: `\\n`,
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ],
                        relevance: 0
                    },
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    {
                        className: `string`,
                        begin: `^\\s*\\[`,
                        end: `\\]`
                    },
                    {
                        beginKeywords: `interface namespace`,
                        end: /\{/,
                        illegal: `[;.\\-]`,
                        contains: [
                            {
                                className: `symbol`,
                                begin: `[a-zA-Z0-9_]+`
                            }
                        ]
                    },
                    {
                        beginKeywords: `class`,
                        end: /\{/,
                        illegal: `[;.\\-]`,
                        contains: [
                            {
                                className: `symbol`,
                                begin: `[a-zA-Z0-9_]+`,
                                contains: [
                                    {
                                        begin: `[:,]\\s*`,
                                        contains: [
                                            {
                                                className: `symbol`,
                                                begin: `[a-zA-Z0-9_]+`
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    t,
                    n,
                    {
                        className: `literal`,
                        begin: `\\b(null|true|false)`
                    },
                    {
                        className: `number`,
                        relevance: 0,
                        begin: `(-?)(\\b0[xXbBoOdD][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?f?|\\.\\d+f?)([eE][-+]?\\d+f?)?)`
                    }
                ]
            };
        }
        t.exports = n;
    }), g = o((e, t)=>{
        function n(e) {
            let t = {
                className: `number`,
                begin: /[$%]\d+/
            }, n = {
                className: `number`,
                begin: /\b\d+/
            }, r = {
                className: `number`,
                begin: /\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}(:\d{1,5})?/
            };
            return {
                name: `Apache config`,
                aliases: [
                    `apacheconf`
                ],
                case_insensitive: !0,
                contains: [
                    e.HASH_COMMENT_MODE,
                    {
                        className: `section`,
                        begin: /<\/?/,
                        end: />/,
                        contains: [
                            r,
                            {
                                className: `number`,
                                begin: /:\d{1,5}/
                            },
                            e.inherit(e.QUOTE_STRING_MODE, {
                                relevance: 0
                            })
                        ]
                    },
                    {
                        className: `attribute`,
                        begin: /\w+/,
                        relevance: 0,
                        keywords: {
                            _: [
                                `order`,
                                `deny`,
                                `allow`,
                                `setenv`,
                                `rewriterule`,
                                `rewriteengine`,
                                `rewritecond`,
                                `documentroot`,
                                `sethandler`,
                                `errordocument`,
                                `loadmodule`,
                                `options`,
                                `header`,
                                `listen`,
                                `serverroot`,
                                `servername`
                            ]
                        },
                        starts: {
                            end: /$/,
                            relevance: 0,
                            keywords: {
                                literal: `on off all deny allow`
                            },
                            contains: [
                                {
                                    scope: `punctuation`,
                                    match: /\\\n/
                                },
                                {
                                    className: `meta`,
                                    begin: /\s\[/,
                                    end: /\]$/
                                },
                                {
                                    className: `variable`,
                                    begin: /[\$%]\{/,
                                    end: /\}/,
                                    contains: [
                                        `self`,
                                        t
                                    ]
                                },
                                r,
                                n,
                                e.QUOTE_STRING_MODE
                            ]
                        }
                    }
                ],
                illegal: /\S/
            };
        }
        t.exports = n;
    }), _ = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = e.inherit(e.QUOTE_STRING_MODE, {
                illegal: null
            }), r = {
                className: `params`,
                begin: /\(/,
                end: /\)/,
                contains: [
                    `self`,
                    e.C_NUMBER_MODE,
                    n
                ]
            }, i = e.COMMENT(/--/, /$/), a = [
                i,
                e.COMMENT(/\(\*/, /\*\)/, {
                    contains: [
                        `self`,
                        i
                    ]
                }),
                e.HASH_COMMENT_MODE
            ];
            return {
                name: `AppleScript`,
                aliases: [
                    `osascript`
                ],
                keywords: {
                    keyword: `about above after against and around as at back before beginning behind below beneath beside between but by considering contain contains continue copy div does eighth else end equal equals error every exit fifth first for fourth from front get given global if ignoring in into is it its last local me middle mod my ninth not of on onto or over prop property put ref reference repeat returning script second set seventh since sixth some tell tenth that the|0 then third through thru timeout times to transaction try until where while whose with without`,
                    literal: `AppleScript false linefeed return pi quote result space tab true`,
                    built_in: `alias application boolean class constant date file integer list number real record string text activate beep count delay launch log offset read round run say summarize write character characters contents day frontmost id item length month name|0 paragraph paragraphs rest reverse running time version weekday word words year`
                },
                contains: [
                    n,
                    e.C_NUMBER_MODE,
                    {
                        className: `built_in`,
                        begin: t.concat(/\b/, t.either(/clipboard info/, /the clipboard/, /info for/, /list (disks|folder)/, /mount volume/, /path to/, /(close|open for) access/, /(get|set) eof/, /current date/, /do shell script/, /get volume settings/, /random number/, /set volume/, /system attribute/, /system info/, /time to GMT/, /(load|run|store) script/, /scripting components/, /ASCII (character|number)/, /localized string/, /choose (application|color|file|file name|folder|from list|remote application|URL)/, /display (alert|dialog)/), /\b/)
                    },
                    {
                        className: `built_in`,
                        begin: /^\s*return\b/
                    },
                    {
                        className: `literal`,
                        begin: /\b(text item delimiters|current application|missing value)\b/
                    },
                    {
                        className: `keyword`,
                        begin: t.concat(/\b/, t.either(/apart from/, /aside from/, /instead of/, /out of/, /greater than/, /isn't|(doesn't|does not) (equal|come before|come after|contain)/, /(greater|less) than( or equal)?/, /(starts?|ends|begins?) with/, /contained by/, /comes (before|after)/, /a (ref|reference)/, /POSIX (file|path)/, /(date|time) string/, /quoted form/), /\b/)
                    },
                    {
                        beginKeywords: `on`,
                        illegal: /[${=;\n]/,
                        contains: [
                            e.UNDERSCORE_TITLE_MODE,
                            r
                        ]
                    },
                    ...a
                ],
                illegal: /\/\/|->|=>|\[\[/
            };
        }
        t.exports = n;
    }), v = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = `[A-Za-z_][0-9A-Za-z_]*`, r = {
                keyword: [
                    `break`,
                    `case`,
                    `catch`,
                    `continue`,
                    `debugger`,
                    `do`,
                    `else`,
                    `export`,
                    `for`,
                    `function`,
                    `if`,
                    `import`,
                    `in`,
                    `new`,
                    `of`,
                    `return`,
                    `switch`,
                    `try`,
                    `var`,
                    `void`,
                    `while`
                ],
                literal: [
                    `BackSlash`,
                    `DoubleQuote`,
                    `ForwardSlash`,
                    `Infinity`,
                    `NaN`,
                    `NewLine`,
                    `PI`,
                    `SingleQuote`,
                    `Tab`,
                    `TextFormatting`,
                    `false`,
                    `null`,
                    `true`,
                    `undefined`
                ],
                built_in: `Abs.Acos.All.Angle.Any.Area.AreaGeodetic.Array.Asin.Atan.Atan2.Attachments.Average.Back.Bearing.Boolean.Buffer.BufferGeodetic.Ceil.Centroid.ChangeTimeZone.Clip.Concatenate.Console.Constrain.Contains.ConvertDirection.ConvexHull.Cos.Count.Crosses.Cut.Date|0.DateAdd.DateDiff.DateOnly.Day.Decode.DefaultValue.Densify.DensifyGeodetic.Dictionary.Difference.Disjoint.Distance.DistanceGeodetic.DistanceToCoordinate.Distinct.Domain.DomainCode.DomainName.EnvelopeIntersects.Equals.Erase.Exp.Expects.Extent.Feature.FeatureInFilter.FeatureSet.FeatureSetByAssociation.FeatureSetById.FeatureSetByName.FeatureSetByPortalItem.FeatureSetByRelationshipClass.FeatureSetByRelationshipName.Filter.FilterBySubtypeCode.Find.First|0.Floor.FromCharCode.FromCodePoint.FromJSON.Front.GdbVersion.Generalize.Geometry.GetEnvironment.GetFeatureSet.GetFeatureSetInfo.GetUser.GroupBy.Guid.HasKey.HasValue.Hash.Hour.IIf.ISOMonth.ISOWeek.ISOWeekday.ISOYear.Includes.IndexOf.Insert.Intersection.Intersects.IsEmpty.IsNan.IsSelfIntersecting.IsSimple.KnowledgeGraphByPortalItem.Left|0.Length.Length3D.LengthGeodetic.Log.Lower.Map.Max.Mean.MeasureToCoordinate.Mid.Millisecond.Min.Minute.Month.MultiPartToSinglePart.Multipoint.NearestCoordinate.NearestVertex.NextSequenceValue.None.Now.Number.Offset.OrderBy.Overlaps.Point.PointToCoordinate.Polygon.Polyline.Pop.Portal.Pow.Proper.Push.QueryGraph.Random.Reduce.Relate.Replace.Resize.Reverse.Right|0.RingIsClockwise.Rotate.Round.Schema.Second.SetGeometry.Simplify.Sin.Slice.Sort.Splice.Split.Sqrt.StandardizeFilename.StandardizeGuid.Stdev.SubtypeCode.SubtypeName.Subtypes.Sum.SymmetricDifference.Tan.Text.Time.TimeZone.TimeZoneOffset.Timestamp.ToCharCode.ToCodePoint.ToHex.ToLocal.ToUTC.Today.Top|0.Touches.TrackAccelerationAt.TrackAccelerationWindow.TrackCurrentAcceleration.TrackCurrentDistance.TrackCurrentSpeed.TrackCurrentTime.TrackDistanceAt.TrackDistanceWindow.TrackDuration.TrackFieldWindow.TrackGeometryWindow.TrackIndex.TrackSpeedAt.TrackSpeedWindow.TrackStartTime.TrackWindow.Trim.TypeOf.Union.Upper.UrlEncode.Variance.Week.Weekday.When|0.Within.Year|0`.split(`.`)
            }, i = {
                className: `symbol`,
                begin: `\\$` + t.either(...`aggregatedFeatures.analytic.config.datapoint.datastore.editcontext.feature.featureSet.feedfeature.fencefeature.fencenotificationtype.graph.join.layer.locationupdate.map.measure.measure.originalFeature.record.reference.rowindex.sourcedatastore.sourcefeature.sourcelayer.target.targetdatastore.targetfeature.targetlayer.userInput.value.variables.view`.split(`.`))
            }, a = {
                className: `number`,
                variants: [
                    {
                        begin: `\\b(0[bB][01]+)`
                    },
                    {
                        begin: `\\b(0[oO][0-7]+)`
                    },
                    {
                        begin: e.C_NUMBER_RE
                    }
                ],
                relevance: 0
            }, o = {
                className: `subst`,
                begin: `\\$\\{`,
                end: `\\}`,
                keywords: r,
                contains: []
            }, s = {
                className: `string`,
                begin: "`",
                end: "`",
                contains: [
                    e.BACKSLASH_ESCAPE,
                    o
                ]
            };
            o.contains = [
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE,
                s,
                a,
                e.REGEXP_MODE
            ];
            let c = o.contains.concat([
                e.C_BLOCK_COMMENT_MODE,
                e.C_LINE_COMMENT_MODE
            ]);
            return {
                name: `ArcGIS Arcade`,
                case_insensitive: !0,
                keywords: r,
                contains: [
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE,
                    s,
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    i,
                    a,
                    {
                        begin: /[{,]\s*/,
                        relevance: 0,
                        contains: [
                            {
                                begin: n + `\\s*:`,
                                returnBegin: !0,
                                relevance: 0,
                                contains: [
                                    {
                                        className: `attr`,
                                        begin: n,
                                        relevance: 0
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        begin: `(` + e.RE_STARTERS_RE + `|\\b(return)\\b)\\s*`,
                        keywords: `return`,
                        contains: [
                            e.C_LINE_COMMENT_MODE,
                            e.C_BLOCK_COMMENT_MODE,
                            e.REGEXP_MODE,
                            {
                                className: `function`,
                                begin: `(\\(.*?\\)|` + n + `)\\s*=>`,
                                returnBegin: !0,
                                end: `\\s*=>`,
                                contains: [
                                    {
                                        className: `params`,
                                        variants: [
                                            {
                                                begin: n
                                            },
                                            {
                                                begin: /\(\s*\)/
                                            },
                                            {
                                                begin: /\(/,
                                                end: /\)/,
                                                excludeBegin: !0,
                                                excludeEnd: !0,
                                                keywords: r,
                                                contains: c
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        relevance: 0
                    },
                    {
                        beginKeywords: `function`,
                        end: /\{/,
                        excludeEnd: !0,
                        contains: [
                            e.inherit(e.TITLE_MODE, {
                                className: `title.function`,
                                begin: n
                            }),
                            {
                                className: `params`,
                                begin: /\(/,
                                end: /\)/,
                                excludeBegin: !0,
                                excludeEnd: !0,
                                contains: c
                            }
                        ],
                        illegal: /\[|%/
                    },
                    {
                        begin: /\$[(.]/
                    }
                ],
                illegal: /#(?!!)/
            };
        }
        t.exports = n;
    }), y = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = e.COMMENT(`//`, `$`, {
                contains: [
                    {
                        begin: /\\\n/
                    }
                ]
            }), r = `decltype\\(auto\\)`, i = `[a-zA-Z_]\\w*::`, a = `(?!struct)(` + r + `|` + t.optional(i) + `[a-zA-Z_]\\w*` + t.optional(`<[^<>]+>`) + `)`, o = {
                className: `type`,
                begin: `\\b[a-z\\d_]*_t\\b`
            }, s = {
                className: `string`,
                variants: [
                    {
                        begin: `(u8?|U|L)?"`,
                        end: `"`,
                        illegal: `\\n`,
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ]
                    },
                    {
                        begin: `(u8?|U|L)?'(\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)|.)`,
                        end: `'`,
                        illegal: `.`
                    },
                    e.END_SAME_AS_BEGIN({
                        begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
                        end: /\)([^()\\ ]{0,16})"/
                    })
                ]
            }, c = {
                className: `number`,
                variants: [
                    {
                        begin: `[+-]?(?:(?:[0-9](?:'?[0-9])*\\.(?:[0-9](?:'?[0-9])*)?|\\.[0-9](?:'?[0-9])*)(?:[Ee][+-]?[0-9](?:'?[0-9])*)?|[0-9](?:'?[0-9])*[Ee][+-]?[0-9](?:'?[0-9])*|0[Xx](?:[0-9A-Fa-f](?:'?[0-9A-Fa-f])*(?:\\.(?:[0-9A-Fa-f](?:'?[0-9A-Fa-f])*)?)?|\\.[0-9A-Fa-f](?:'?[0-9A-Fa-f])*)[Pp][+-]?[0-9](?:'?[0-9])*)(?:[Ff](?:16|32|64|128)?|(BF|bf)16|[Ll]|)`
                    },
                    {
                        begin: `[+-]?\\b(?:0[Bb][01](?:'?[01])*|0[Xx][0-9A-Fa-f](?:'?[0-9A-Fa-f])*|0(?:'?[0-7])*|[1-9](?:'?[0-9])*)(?:[Uu](?:LL?|ll?)|[Uu][Zz]?|(?:LL?|ll?)[Uu]?|[Zz][Uu]|)`
                    }
                ],
                relevance: 0
            }, l = {
                className: `meta`,
                begin: /#\s*[a-z]+\b/,
                end: /$/,
                keywords: {
                    keyword: `if else elif endif define undef warning error line pragma _Pragma ifdef ifndef include`
                },
                contains: [
                    {
                        begin: /\\\n/,
                        relevance: 0
                    },
                    e.inherit(s, {
                        className: `string`
                    }),
                    {
                        className: `string`,
                        begin: /<.*?>/
                    },
                    n,
                    e.C_BLOCK_COMMENT_MODE
                ]
            }, u = {
                className: `title`,
                begin: t.optional(i) + e.IDENT_RE,
                relevance: 0
            }, d = t.optional(i) + e.IDENT_RE + `\\s*\\(`, f = `alignas.alignof.and.and_eq.asm.atomic_cancel.atomic_commit.atomic_noexcept.auto.bitand.bitor.break.case.catch.class.co_await.co_return.co_yield.compl.concept.const_cast|10.consteval.constexpr.constinit.continue.decltype.default.delete.do.dynamic_cast|10.else.enum.explicit.export.extern.false.final.for.friend.goto.if.import.inline.module.mutable.namespace.new.noexcept.not.not_eq.nullptr.operator.or.or_eq.override.private.protected.public.reflexpr.register.reinterpret_cast|10.requires.return.sizeof.static_assert.static_cast|10.struct.switch.synchronized.template.this.thread_local.throw.transaction_safe.transaction_safe_dynamic.true.try.typedef.typeid.typename.union.using.virtual.volatile.while.xor.xor_eq`.split(`.`), p = [
                `bool`,
                `char`,
                `char16_t`,
                `char32_t`,
                `char8_t`,
                `double`,
                `float`,
                `int`,
                `long`,
                `short`,
                `void`,
                `wchar_t`,
                `unsigned`,
                `signed`,
                `const`,
                `static`
            ], m = `any.auto_ptr.barrier.binary_semaphore.bitset.complex.condition_variable.condition_variable_any.counting_semaphore.deque.false_type.flat_map.flat_set.future.imaginary.initializer_list.istringstream.jthread.latch.lock_guard.multimap.multiset.mutex.optional.ostringstream.packaged_task.pair.promise.priority_queue.queue.recursive_mutex.recursive_timed_mutex.scoped_lock.set.shared_future.shared_lock.shared_mutex.shared_timed_mutex.shared_ptr.stack.string_view.stringstream.timed_mutex.thread.true_type.tuple.unique_lock.unique_ptr.unordered_map.unordered_multimap.unordered_multiset.unordered_set.variant.vector.weak_ptr.wstring.wstring_view`.split(`.`), h = `abort.abs.acos.apply.as_const.asin.atan.atan2.calloc.ceil.cerr.cin.clog.cos.cosh.cout.declval.endl.exchange.exit.exp.fabs.floor.fmod.forward.fprintf.fputs.free.frexp.fscanf.future.invoke.isalnum.isalpha.iscntrl.isdigit.isgraph.islower.isprint.ispunct.isspace.isupper.isxdigit.labs.launder.ldexp.log.log10.make_pair.make_shared.make_shared_for_overwrite.make_tuple.make_unique.malloc.memchr.memcmp.memcpy.memset.modf.move.pow.printf.putchar.puts.realloc.scanf.sin.sinh.snprintf.sprintf.sqrt.sscanf.std.stderr.stdin.stdout.strcat.strchr.strcmp.strcpy.strcspn.strlen.strncat.strncmp.strncpy.strpbrk.strrchr.strspn.strstr.swap.tan.tanh.terminate.to_underlying.tolower.toupper.vfprintf.visit.vprintf.vsprintf`.split(`.`), g = {
                type: p,
                keyword: f,
                literal: [
                    `NULL`,
                    `false`,
                    `nullopt`,
                    `nullptr`,
                    `true`
                ],
                built_in: [
                    `_Pragma`
                ],
                _type_hints: m
            }, _ = {
                className: `function.dispatch`,
                relevance: 0,
                keywords: {
                    _hint: h
                },
                begin: t.concat(/\b/, /(?!decltype)/, /(?!if)/, /(?!for)/, /(?!switch)/, /(?!while)/, e.IDENT_RE, t.lookahead(/(<[^<>]+>|)\s*\(/))
            }, v = [
                _,
                l,
                o,
                n,
                e.C_BLOCK_COMMENT_MODE,
                c,
                s
            ], y = {
                variants: [
                    {
                        begin: /=/,
                        end: /;/
                    },
                    {
                        begin: /\(/,
                        end: /\)/
                    },
                    {
                        beginKeywords: `new throw return else`,
                        end: /;/
                    }
                ],
                keywords: g,
                contains: v.concat([
                    {
                        begin: /\(/,
                        end: /\)/,
                        keywords: g,
                        contains: v.concat([
                            `self`
                        ]),
                        relevance: 0
                    }
                ]),
                relevance: 0
            }, b = {
                className: `function`,
                begin: `(` + a + `[\\*&\\s]+)+` + d,
                returnBegin: !0,
                end: /[{;=]/,
                excludeEnd: !0,
                keywords: g,
                illegal: /[^\w\s\*&:<>.]/,
                contains: [
                    {
                        begin: r,
                        keywords: g,
                        relevance: 0
                    },
                    {
                        begin: d,
                        returnBegin: !0,
                        contains: [
                            u
                        ],
                        relevance: 0
                    },
                    {
                        begin: /::/,
                        relevance: 0
                    },
                    {
                        begin: /:/,
                        endsWithParent: !0,
                        contains: [
                            s,
                            c
                        ]
                    },
                    {
                        relevance: 0,
                        match: /,/
                    },
                    {
                        className: `params`,
                        begin: /\(/,
                        end: /\)/,
                        keywords: g,
                        relevance: 0,
                        contains: [
                            n,
                            e.C_BLOCK_COMMENT_MODE,
                            s,
                            c,
                            o,
                            {
                                begin: /\(/,
                                end: /\)/,
                                keywords: g,
                                relevance: 0,
                                contains: [
                                    `self`,
                                    n,
                                    e.C_BLOCK_COMMENT_MODE,
                                    s,
                                    c,
                                    o
                                ]
                            }
                        ]
                    },
                    o,
                    n,
                    e.C_BLOCK_COMMENT_MODE,
                    l
                ]
            };
            return {
                name: `C++`,
                aliases: [
                    `cc`,
                    `c++`,
                    `h++`,
                    `hpp`,
                    `hh`,
                    `hxx`,
                    `cxx`
                ],
                keywords: g,
                illegal: `</`,
                classNameAliases: {
                    "function.dispatch": `built_in`
                },
                contains: [].concat(y, b, _, v, [
                    l,
                    {
                        begin: `\\b(deque|list|queue|priority_queue|pair|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array|tuple|optional|variant|function|flat_map|flat_set)\\s*<(?!<)`,
                        end: `>`,
                        keywords: g,
                        contains: [
                            `self`,
                            o
                        ]
                    },
                    {
                        begin: e.IDENT_RE + `::`,
                        keywords: g
                    },
                    {
                        match: [
                            /\b(?:enum(?:\s+(?:class|struct))?|class|struct|union)/,
                            /\s+/,
                            /\w+/
                        ],
                        className: {
                            1: `keyword`,
                            3: `title.class`
                        }
                    }
                ])
            };
        }
        function r(e) {
            let t = {
                type: [
                    `boolean`,
                    `byte`,
                    `word`,
                    `String`
                ],
                built_in: `KeyboardController.MouseController.SoftwareSerial.EthernetServer.EthernetClient.LiquidCrystal.RobotControl.GSMVoiceCall.EthernetUDP.EsploraTFT.HttpClient.RobotMotor.WiFiClient.GSMScanner.FileSystem.Scheduler.GSMServer.YunClient.YunServer.IPAddress.GSMClient.GSMModem.Keyboard.Ethernet.Console.GSMBand.Esplora.Stepper.Process.WiFiUDP.GSM_SMS.Mailbox.USBHost.Firmata.PImage.Client.Server.GSMPIN.FileIO.Bridge.Serial.EEPROM.Stream.Mouse.Audio.Servo.File.Task.GPRS.WiFi.Wire.TFT.GSM.SPI.SD`.split(`.`),
                _hints: `setup.loop.runShellCommandAsynchronously.analogWriteResolution.retrieveCallingNumber.printFirmwareVersion.analogReadResolution.sendDigitalPortPair.noListenOnLocalhost.readJoystickButton.setFirmwareVersion.readJoystickSwitch.scrollDisplayRight.getVoiceCallStatus.scrollDisplayLeft.writeMicroseconds.delayMicroseconds.beginTransmission.getSignalStrength.runAsynchronously.getAsynchronously.listenOnLocalhost.getCurrentCarrier.readAccelerometer.messageAvailable.sendDigitalPorts.lineFollowConfig.countryNameWrite.runShellCommand.readStringUntil.rewindDirectory.readTemperature.setClockDivider.readLightSensor.endTransmission.analogReference.detachInterrupt.countryNameRead.attachInterrupt.encryptionType.readBytesUntil.robotNameWrite.readMicrophone.robotNameRead.cityNameWrite.userNameWrite.readJoystickY.readJoystickX.mouseReleased.openNextFile.scanNetworks.noInterrupts.digitalWrite.beginSpeaker.mousePressed.isActionDone.mouseDragged.displayLogos.noAutoscroll.addParameter.remoteNumber.getModifiers.keyboardRead.userNameRead.waitContinue.processInput.parseCommand.printVersion.readNetworks.writeMessage.blinkVersion.cityNameRead.readMessage.setDataMode.parsePacket.isListening.setBitOrder.beginPacket.isDirectory.motorsWrite.drawCompass.digitalRead.clearScreen.serialEvent.rightToLeft.setTextSize.leftToRight.requestFrom.keyReleased.compassRead.analogWrite.interrupts.WiFiServer.disconnect.playMelody.parseFloat.autoscroll.getPINUsed.setPINUsed.setTimeout.sendAnalog.readSlider.analogRead.beginWrite.createChar.motorsStop.keyPressed.tempoWrite.readButton.subnetMask.debugPrint.macAddress.writeGreen.randomSeed.attachGPRS.readString.sendString.remotePort.releaseAll.mouseMoved.background.getXChange.getYChange.answerCall.getResult.voiceCall.endPacket.constrain.getSocket.writeJSON.getButton.available.connected.findUntil.readBytes.exitValue.readGreen.writeBlue.startLoop.IPAddress.isPressed.sendSysex.pauseMode.gatewayIP.setCursor.getOemKey.tuneWrite.noDisplay.loadImage.switchPIN.onRequest.onReceive.changePIN.playFile.noBuffer.parseInt.overflow.checkPIN.knobRead.beginTFT.bitClear.updateIR.bitWrite.position.writeRGB.highByte.writeRed.setSpeed.readBlue.noStroke.remoteIP.transfer.shutdown.hangCall.beginSMS.endWrite.attached.maintain.noCursor.checkReg.checkPUK.shiftOut.isValid.shiftIn.pulseIn.connect.println.localIP.pinMode.getIMEI.display.noBlink.process.getBand.running.beginSD.drawBMP.lowByte.setBand.release.bitRead.prepare.pointTo.readRed.setMode.noFill.remove.listen.stroke.detach.attach.noTone.exists.buffer.height.bitSet.circle.config.cursor.random.IRread.setDNS.endSMS.getKey.micros.millis.begin.print.write.ready.flush.width.isPIN.blink.clear.press.mkdir.rmdir.close.point.yield.image.BSSID.click.delay.read.text.move.peek.beep.rect.line.open.seek.fill.size.turn.stop.home.find.step.tone.sqrt.RSSI.SSID.end.bit.tan.cos.sin.pow.map.abs.max.min.get.run.put`.split(`.`),
                literal: [
                    `DIGITAL_MESSAGE`,
                    `FIRMATA_STRING`,
                    `ANALOG_MESSAGE`,
                    `REPORT_DIGITAL`,
                    `REPORT_ANALOG`,
                    `INPUT_PULLUP`,
                    `SET_PIN_MODE`,
                    `INTERNAL2V56`,
                    `SYSTEM_RESET`,
                    `LED_BUILTIN`,
                    `INTERNAL1V1`,
                    `SYSEX_START`,
                    `INTERNAL`,
                    `EXTERNAL`,
                    `DEFAULT`,
                    `OUTPUT`,
                    `INPUT`,
                    `HIGH`,
                    `LOW`
                ]
            }, r = n(e), i = r.keywords;
            return i.type = [
                ...i.type,
                ...t.type
            ], i.literal = [
                ...i.literal,
                ...t.literal
            ], i.built_in = [
                ...i.built_in,
                ...t.built_in
            ], i._hints = t._hints, r.name = `Arduino`, r.aliases = [
                `ino`
            ], r.supersetOf = `cpp`, r;
        }
        t.exports = r;
    }), b = o((e, t)=>{
        function n(e) {
            let t = {
                variants: [
                    e.COMMENT(`^[ \\t]*(?=#)`, `$`, {
                        relevance: 0,
                        excludeBegin: !0
                    }),
                    e.COMMENT(`[;@]`, `$`, {
                        relevance: 0
                    }),
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE
                ]
            };
            return {
                name: `ARM Assembly`,
                case_insensitive: !0,
                aliases: [
                    `arm`
                ],
                keywords: {
                    $pattern: `\\.?` + e.IDENT_RE,
                    meta: `.2byte .4byte .align .ascii .asciz .balign .byte .code .data .else .end .endif .endm .endr .equ .err .exitm .extern .global .hword .if .ifdef .ifndef .include .irp .long .macro .rept .req .section .set .skip .space .text .word .arm .thumb .code16 .code32 .force_thumb .thumb_func .ltorg ALIAS ALIGN ARM AREA ASSERT ATTR CN CODE CODE16 CODE32 COMMON CP DATA DCB DCD DCDU DCDO DCFD DCFDU DCI DCQ DCQU DCW DCWU DN ELIF ELSE END ENDFUNC ENDIF ENDP ENTRY EQU EXPORT EXPORTAS EXTERN FIELD FILL FUNCTION GBLA GBLL GBLS GET GLOBAL IF IMPORT INCBIN INCLUDE INFO KEEP LCLA LCLL LCLS LTORG MACRO MAP MEND MEXIT NOFP OPT PRESERVE8 PROC QN READONLY RELOC REQUIRE REQUIRE8 RLIST FN ROUT SETA SETL SETS SN SPACE SUBT THUMB THUMBX TTL WHILE WEND `,
                    built_in: `r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 w0 w1 w2 w3 w4 w5 w6 w7 w8 w9 w10 w11 w12 w13 w14 w15 w16 w17 w18 w19 w20 w21 w22 w23 w24 w25 w26 w27 w28 w29 w30 x0 x1 x2 x3 x4 x5 x6 x7 x8 x9 x10 x11 x12 x13 x14 x15 x16 x17 x18 x19 x20 x21 x22 x23 x24 x25 x26 x27 x28 x29 x30 pc lr sp ip sl sb fp a1 a2 a3 a4 v1 v2 v3 v4 v5 v6 v7 v8 f0 f1 f2 f3 f4 f5 f6 f7 p0 p1 p2 p3 p4 p5 p6 p7 p8 p9 p10 p11 p12 p13 p14 p15 c0 c1 c2 c3 c4 c5 c6 c7 c8 c9 c10 c11 c12 c13 c14 c15 q0 q1 q2 q3 q4 q5 q6 q7 q8 q9 q10 q11 q12 q13 q14 q15 cpsr_c cpsr_x cpsr_s cpsr_f cpsr_cx cpsr_cxs cpsr_xs cpsr_xsf cpsr_sf cpsr_cxsf spsr_c spsr_x spsr_s spsr_f spsr_cx spsr_cxs spsr_xs spsr_xsf spsr_sf spsr_cxsf s0 s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 d0 d1 d2 d3 d4 d5 d6 d7 d8 d9 d10 d11 d12 d13 d14 d15 d16 d17 d18 d19 d20 d21 d22 d23 d24 d25 d26 d27 d28 d29 d30 d31 {PC} {VAR} {TRUE} {FALSE} {OPT} {CONFIG} {ENDIAN} {CODESIZE} {CPU} {FPU} {ARCHITECTURE} {PCSTOREOFFSET} {ARMASM_VERSION} {INTER} {ROPI} {RWPI} {SWST} {NOSWST} . @`
                },
                contains: [
                    {
                        className: `keyword`,
                        begin: `\\b(adc|(qd?|sh?|u[qh]?)?add(8|16)?|usada?8|(q|sh?|u[qh]?)?(as|sa)x|and|adrl?|sbc|rs[bc]|asr|b[lx]?|blx|bxj|cbn?z|tb[bh]|bic|bfc|bfi|[su]bfx|bkpt|cdp2?|clz|clrex|cmp|cmn|cpsi[ed]|cps|setend|dbg|dmb|dsb|eor|isb|it[te]{0,3}|lsl|lsr|ror|rrx|ldm(([id][ab])|f[ds])?|ldr((s|ex)?[bhd])?|movt?|mvn|mra|mar|mul|[us]mull|smul[bwt][bt]|smu[as]d|smmul|smmla|mla|umlaal|smlal?([wbt][bt]|d)|mls|smlsl?[ds]|smc|svc|sev|mia([bt]{2}|ph)?|mrr?c2?|mcrr2?|mrs|msr|orr|orn|pkh(tb|bt)|rbit|rev(16|sh)?|sel|[su]sat(16)?|nop|pop|push|rfe([id][ab])?|stm([id][ab])?|str(ex)?[bhd]?|(qd?)?sub|(sh?|q|u[qh]?)?sub(8|16)|[su]xt(a?h|a?b(16)?)|srs([id][ab])?|swpb?|swi|smi|tst|teq|wfe|wfi|yield)(eq|ne|cs|cc|mi|pl|vs|vc|hi|ls|ge|lt|gt|le|al|hs|lo)?[sptrx]?(?=\\s)`
                    },
                    t,
                    e.QUOTE_STRING_MODE,
                    {
                        className: `string`,
                        begin: `'`,
                        end: `[^\\\\]'`,
                        relevance: 0
                    },
                    {
                        className: `title`,
                        begin: `\\|`,
                        end: `\\|`,
                        illegal: `\\n`,
                        relevance: 0
                    },
                    {
                        className: `number`,
                        variants: [
                            {
                                begin: `[#$=]?0x[0-9a-f]+`
                            },
                            {
                                begin: `[#$=]?0b[01]+`
                            },
                            {
                                begin: `[#$=]\\d+`
                            },
                            {
                                begin: `\\b\\d+`
                            }
                        ],
                        relevance: 0
                    },
                    {
                        className: `symbol`,
                        variants: [
                            {
                                begin: `^[ \\t]*[a-z_\\.\\$][a-z0-9_\\.\\$]+:`
                            },
                            {
                                begin: `^[a-z_\\.\\$][a-z0-9_\\.\\$]+`
                            },
                            {
                                begin: `[=#]\\w+`
                            }
                        ],
                        relevance: 0
                    }
                ]
            };
        }
        t.exports = n;
    }), x = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = t.concat(/[\p{L}_]/u, t.optional(/[\p{L}0-9_.-]*:/u), /[\p{L}0-9_.-]*/u), r = /[\p{L}0-9._:-]+/u, i = {
                className: `symbol`,
                begin: /&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;/
            }, a = {
                begin: /\s/,
                contains: [
                    {
                        className: `keyword`,
                        begin: /#?[a-z_][a-z1-9_-]+/,
                        illegal: /\n/
                    }
                ]
            }, o = e.inherit(a, {
                begin: /\(/,
                end: /\)/
            }), s = e.inherit(e.APOS_STRING_MODE, {
                className: `string`
            }), c = e.inherit(e.QUOTE_STRING_MODE, {
                className: `string`
            }), l = {
                endsWithParent: !0,
                illegal: /</,
                relevance: 0,
                contains: [
                    {
                        className: `attr`,
                        begin: r,
                        relevance: 0
                    },
                    {
                        begin: /=\s*/,
                        relevance: 0,
                        contains: [
                            {
                                className: `string`,
                                endsParent: !0,
                                variants: [
                                    {
                                        begin: /"/,
                                        end: /"/,
                                        contains: [
                                            i
                                        ]
                                    },
                                    {
                                        begin: /'/,
                                        end: /'/,
                                        contains: [
                                            i
                                        ]
                                    },
                                    {
                                        begin: /[^\s"'=<>`]+/
                                    }
                                ]
                            }
                        ]
                    }
                ]
            };
            return {
                name: `HTML, XML`,
                aliases: [
                    `html`,
                    `xhtml`,
                    `rss`,
                    `atom`,
                    `xjb`,
                    `xsd`,
                    `xsl`,
                    `plist`,
                    `wsf`,
                    `svg`
                ],
                case_insensitive: !0,
                unicodeRegex: !0,
                contains: [
                    {
                        className: `meta`,
                        begin: /<![a-z]/,
                        end: />/,
                        relevance: 10,
                        contains: [
                            a,
                            c,
                            s,
                            o,
                            {
                                begin: /\[/,
                                end: /\]/,
                                contains: [
                                    {
                                        className: `meta`,
                                        begin: /<![a-z]/,
                                        end: />/,
                                        contains: [
                                            a,
                                            o,
                                            c,
                                            s
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    e.COMMENT(/<!--/, /-->/, {
                        relevance: 10
                    }),
                    {
                        begin: /<!\[CDATA\[/,
                        end: /\]\]>/,
                        relevance: 10
                    },
                    i,
                    {
                        className: `meta`,
                        end: /\?>/,
                        variants: [
                            {
                                begin: /<\?xml/,
                                relevance: 10,
                                contains: [
                                    c
                                ]
                            },
                            {
                                begin: /<\?[a-z][a-z0-9]+/
                            }
                        ]
                    },
                    {
                        className: `tag`,
                        begin: /<style(?=\s|>)/,
                        end: />/,
                        keywords: {
                            name: `style`
                        },
                        contains: [
                            l
                        ],
                        starts: {
                            end: /<\/style>/,
                            returnEnd: !0,
                            subLanguage: [
                                `css`,
                                `xml`
                            ]
                        }
                    },
                    {
                        className: `tag`,
                        begin: /<script(?=\s|>)/,
                        end: />/,
                        keywords: {
                            name: `script`
                        },
                        contains: [
                            l
                        ],
                        starts: {
                            end: /<\/script>/,
                            returnEnd: !0,
                            subLanguage: [
                                `javascript`,
                                `handlebars`,
                                `xml`
                            ]
                        }
                    },
                    {
                        className: `tag`,
                        begin: /<>|<\/>/
                    },
                    {
                        className: `tag`,
                        begin: t.concat(/</, t.lookahead(t.concat(n, t.either(/\/>/, />/, /\s/)))),
                        end: /\/?>/,
                        contains: [
                            {
                                className: `name`,
                                begin: n,
                                relevance: 0,
                                starts: l
                            }
                        ]
                    },
                    {
                        className: `tag`,
                        begin: t.concat(/<\//, t.lookahead(t.concat(n, />/))),
                        contains: [
                            {
                                className: `name`,
                                begin: n,
                                relevance: 0
                            },
                            {
                                begin: />/,
                                relevance: 0,
                                endsParent: !0
                            }
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), S = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = {
                begin: `^'{3,}[ \\t]*$`,
                relevance: 10
            }, r = [
                {
                    begin: /\\[*_`]/
                },
                {
                    begin: /\\\\\*{2}[^\n]*?\*{2}/
                },
                {
                    begin: /\\\\_{2}[^\n]*_{2}/
                },
                {
                    begin: /\\\\`{2}[^\n]*`{2}/
                },
                {
                    begin: /[:;}][*_`](?![*_`])/
                }
            ], i = [
                {
                    className: `strong`,
                    begin: /\*{2}([^\n]+?)\*{2}/
                },
                {
                    className: `strong`,
                    begin: t.concat(/\*\*/, /((\*(?!\*)|\\[^\n]|[^*\n\\])+\n)+/, /(\*(?!\*)|\\[^\n]|[^*\n\\])*/, /\*\*/),
                    relevance: 0
                },
                {
                    className: `strong`,
                    begin: /\B\*(\S|\S[^\n]*?\S)\*(?!\w)/
                },
                {
                    className: `strong`,
                    begin: /\*[^\s]([^\n]+\n)+([^\n]+)\*/
                }
            ], a = [
                {
                    className: `emphasis`,
                    begin: /_{2}([^\n]+?)_{2}/
                },
                {
                    className: `emphasis`,
                    begin: t.concat(/__/, /((_(?!_)|\\[^\n]|[^_\n\\])+\n)+/, /(_(?!_)|\\[^\n]|[^_\n\\])*/, /__/),
                    relevance: 0
                },
                {
                    className: `emphasis`,
                    begin: /\b_(\S|\S[^\n]*?\S)_(?!\w)/
                },
                {
                    className: `emphasis`,
                    begin: /_[^\s]([^\n]+\n)+([^\n]+)_/
                },
                {
                    className: `emphasis`,
                    begin: `\\B'(?!['\\s])`,
                    end: `(\\n{2}|')`,
                    contains: [
                        {
                            begin: `\\\\'\\w`,
                            relevance: 0
                        }
                    ],
                    relevance: 0
                }
            ];
            return {
                name: `AsciiDoc`,
                aliases: [
                    `adoc`
                ],
                contains: [
                    e.COMMENT(`^/{4,}\\n`, `\\n/{4,}$`, {
                        relevance: 10
                    }),
                    e.COMMENT(`^//`, `$`, {
                        relevance: 0
                    }),
                    {
                        className: `title`,
                        begin: `^\\.\\w.*$`
                    },
                    {
                        begin: `^[=\\*]{4,}\\n`,
                        end: `\\n^[=\\*]{4,}$`,
                        relevance: 10
                    },
                    {
                        className: `section`,
                        relevance: 10,
                        variants: [
                            {
                                begin: `^(={1,6})[ 	].+?([ 	]\\1)?$`
                            },
                            {
                                begin: `^[^\\[\\]\\n]+?\\n[=\\-~\\^\\+]{2,}$`
                            }
                        ]
                    },
                    {
                        className: `meta`,
                        begin: `^:.+?:`,
                        end: `\\s`,
                        excludeEnd: !0,
                        relevance: 10
                    },
                    {
                        className: `meta`,
                        begin: `^\\[.+?\\]$`,
                        relevance: 0
                    },
                    {
                        className: `quote`,
                        begin: `^_{4,}\\n`,
                        end: `\\n_{4,}$`,
                        relevance: 10
                    },
                    {
                        className: `code`,
                        begin: `^[\\-\\.]{4,}\\n`,
                        end: `\\n[\\-\\.]{4,}$`,
                        relevance: 10
                    },
                    {
                        begin: `^\\+{4,}\\n`,
                        end: `\\n\\+{4,}$`,
                        contains: [
                            {
                                begin: `<`,
                                end: `>`,
                                subLanguage: `xml`,
                                relevance: 0
                            }
                        ],
                        relevance: 10
                    },
                    {
                        className: `bullet`,
                        begin: `^(\\*+|-+|\\.+|[^\\n]+?::)\\s+`
                    },
                    {
                        className: `symbol`,
                        begin: `^(NOTE|TIP|IMPORTANT|WARNING|CAUTION):\\s+`,
                        relevance: 10
                    },
                    ...r,
                    ...i,
                    ...a,
                    {
                        className: `string`,
                        variants: [
                            {
                                begin: "``.+?''"
                            },
                            {
                                begin: "`.+?'"
                            }
                        ]
                    },
                    {
                        className: `code`,
                        begin: /`{2}/,
                        end: /(\n{2}|`{2})/
                    },
                    {
                        className: `code`,
                        begin: "(`.+?`|\\+.+?\\+)",
                        relevance: 0
                    },
                    {
                        className: `code`,
                        begin: `^[ \\t]`,
                        end: `$`,
                        relevance: 0
                    },
                    n,
                    {
                        begin: `(link:)?(http|https|ftp|file|irc|image:?):\\S+?\\[[^[]*?\\]`,
                        returnBegin: !0,
                        contains: [
                            {
                                begin: `(link|image:?):`,
                                relevance: 0
                            },
                            {
                                className: `link`,
                                begin: `\\w`,
                                end: `[^\\[]+`,
                                relevance: 0
                            },
                            {
                                className: `string`,
                                begin: `\\[`,
                                end: `\\]`,
                                excludeBegin: !0,
                                excludeEnd: !0,
                                relevance: 0
                            }
                        ],
                        relevance: 10
                    }
                ]
            };
        }
        t.exports = n;
    }), C = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = `false.synchronized.int.abstract.float.private.char.boolean.static.null.if.const.for.true.while.long.throw.strictfp.finally.protected.import.native.final.return.void.enum.else.extends.implements.break.transient.new.catch.instanceof.byte.super.volatile.case.assert.short.package.default.double.public.try.this.switch.continue.throws.privileged.aspectOf.adviceexecution.proceed.cflowbelow.cflow.initialization.preinitialization.staticinitialization.withincode.target.within.execution.getWithinTypeName.handler.thisJoinPoint.thisJoinPointStaticPart.thisEnclosingJoinPointStaticPart.declare.parents.warning.error.soft.precedence.thisAspectInstance`.split(`.`), r = [
                `get`,
                `set`,
                `args`,
                `call`
            ];
            return {
                name: `AspectJ`,
                keywords: n,
                illegal: /<\/|#/,
                contains: [
                    e.COMMENT(/\/\*\*/, /\*\//, {
                        relevance: 0,
                        contains: [
                            {
                                begin: /\w+@/,
                                relevance: 0
                            },
                            {
                                className: `doctag`,
                                begin: /@[A-Za-z]+/
                            }
                        ]
                    }),
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE,
                    {
                        className: `class`,
                        beginKeywords: `aspect`,
                        end: /[{;=]/,
                        excludeEnd: !0,
                        illegal: /[:;"\[\]]/,
                        contains: [
                            {
                                beginKeywords: `extends implements pertypewithin perthis pertarget percflowbelow percflow issingleton`
                            },
                            e.UNDERSCORE_TITLE_MODE,
                            {
                                begin: /\([^\)]*/,
                                end: /[)]+/,
                                keywords: n.concat(r),
                                excludeEnd: !1
                            }
                        ]
                    },
                    {
                        className: `class`,
                        beginKeywords: `class interface`,
                        end: /[{;=]/,
                        excludeEnd: !0,
                        relevance: 0,
                        keywords: `class interface`,
                        illegal: /[:"\[\]]/,
                        contains: [
                            {
                                beginKeywords: `extends implements`
                            },
                            e.UNDERSCORE_TITLE_MODE
                        ]
                    },
                    {
                        beginKeywords: `pointcut after before around throwing returning`,
                        end: /[)]/,
                        excludeEnd: !1,
                        illegal: /["\[\]]/,
                        contains: [
                            {
                                begin: t.concat(e.UNDERSCORE_IDENT_RE, /\s*\(/),
                                returnBegin: !0,
                                contains: [
                                    e.UNDERSCORE_TITLE_MODE
                                ]
                            }
                        ]
                    },
                    {
                        begin: /[:]/,
                        returnBegin: !0,
                        end: /[{;]/,
                        relevance: 0,
                        excludeEnd: !1,
                        keywords: n,
                        illegal: /["\[\]]/,
                        contains: [
                            {
                                begin: t.concat(e.UNDERSCORE_IDENT_RE, /\s*\(/),
                                keywords: n.concat(r),
                                relevance: 0
                            },
                            e.QUOTE_STRING_MODE
                        ]
                    },
                    {
                        beginKeywords: `new throw`,
                        relevance: 0
                    },
                    {
                        className: `function`,
                        begin: /\w+ +\w+(\.\w+)?\s*\([^\)]*\)\s*((throws)[\w\s,]+)?[\{;]/,
                        returnBegin: !0,
                        end: /[{;=]/,
                        keywords: n,
                        excludeEnd: !0,
                        contains: [
                            {
                                begin: t.concat(e.UNDERSCORE_IDENT_RE, /\s*\(/),
                                returnBegin: !0,
                                relevance: 0,
                                contains: [
                                    e.UNDERSCORE_TITLE_MODE
                                ]
                            },
                            {
                                className: `params`,
                                begin: /\(/,
                                end: /\)/,
                                relevance: 0,
                                keywords: n,
                                contains: [
                                    e.APOS_STRING_MODE,
                                    e.QUOTE_STRING_MODE,
                                    e.C_NUMBER_MODE,
                                    e.C_BLOCK_COMMENT_MODE
                                ]
                            },
                            e.C_LINE_COMMENT_MODE,
                            e.C_BLOCK_COMMENT_MODE
                        ]
                    },
                    e.C_NUMBER_MODE,
                    {
                        className: `meta`,
                        begin: /@[A-Za-z]+/
                    }
                ]
            };
        }
        t.exports = n;
    }), w = o((e, t)=>{
        function n(e) {
            let t = {
                begin: "`[\\s\\S]"
            };
            return {
                name: `AutoHotkey`,
                case_insensitive: !0,
                aliases: [
                    `ahk`
                ],
                keywords: {
                    keyword: `Break Continue Critical Exit ExitApp Gosub Goto New OnExit Pause return SetBatchLines SetTimer Suspend Thread Throw Until ahk_id ahk_class ahk_pid ahk_exe ahk_group`,
                    literal: `true false NOT AND OR`,
                    built_in: `ComSpec Clipboard ClipboardAll ErrorLevel`
                },
                contains: [
                    t,
                    e.inherit(e.QUOTE_STRING_MODE, {
                        contains: [
                            t
                        ]
                    }),
                    e.COMMENT(`;`, `$`, {
                        relevance: 0
                    }),
                    e.C_BLOCK_COMMENT_MODE,
                    {
                        className: `number`,
                        begin: e.NUMBER_RE,
                        relevance: 0
                    },
                    {
                        className: `variable`,
                        begin: `%[a-zA-Z0-9#_$@]+%`
                    },
                    {
                        className: `built_in`,
                        begin: `^\\s*\\w+\\s*(,|%)`
                    },
                    {
                        className: `title`,
                        variants: [
                            {
                                begin: `^[^\\n";]+::(?!=)`
                            },
                            {
                                begin: `^[^\\n";]+:(?!=)`,
                                relevance: 0
                            }
                        ]
                    },
                    {
                        className: `meta`,
                        begin: `^\\s*#\\w+`,
                        end: `$`,
                        relevance: 0
                    },
                    {
                        className: `built_in`,
                        begin: `A_[a-zA-Z0-9]+`
                    },
                    {
                        begin: `,\\s*,`
                    }
                ]
            };
        }
        t.exports = n;
    }), T = o((e, t)=>{
        function n(e) {
            let t = [
                `EndRegion`,
                `forcedef`,
                `forceref`,
                `ignorefunc`,
                `include`,
                `include-once`,
                `NoTrayIcon`,
                `OnAutoItStartRegister`,
                `pragma`,
                `Region`,
                `RequireAdmin`,
                `Tidy_Off`,
                `Tidy_On`,
                `Tidy_Parameters`
            ], n = {
                variants: [
                    e.COMMENT(`;`, `$`, {
                        relevance: 0
                    }),
                    e.COMMENT(`#cs`, `#ce`),
                    e.COMMENT(`#comments-start`, `#comments-end`)
                ]
            }, r = {
                begin: `\\$[A-z0-9_]+`
            }, i = {
                className: `string`,
                variants: [
                    {
                        begin: /"/,
                        end: /"/,
                        contains: [
                            {
                                begin: /""/,
                                relevance: 0
                            }
                        ]
                    },
                    {
                        begin: /'/,
                        end: /'/,
                        contains: [
                            {
                                begin: /''/,
                                relevance: 0
                            }
                        ]
                    }
                ]
            }, a = {
                variants: [
                    e.BINARY_NUMBER_MODE,
                    e.C_NUMBER_MODE
                ]
            };
            return {
                name: `AutoIt`,
                case_insensitive: !0,
                illegal: /\/\*/,
                keywords: {
                    keyword: `ByRef Case Const ContinueCase ContinueLoop Dim Do Else ElseIf EndFunc EndIf EndSelect EndSwitch EndWith Enum Exit ExitLoop For Func Global If In Local Next ReDim Return Select Static Step Switch Then To Until Volatile WEnd While With`,
                    built_in: `Abs ACos AdlibRegister AdlibUnRegister Asc AscW ASin Assign ATan AutoItSetOption AutoItWinGetTitle AutoItWinSetTitle Beep Binary BinaryLen BinaryMid BinaryToString BitAND BitNOT BitOR BitRotate BitShift BitXOR BlockInput Break Call CDTray Ceiling Chr ChrW ClipGet ClipPut ConsoleRead ConsoleWrite ConsoleWriteError ControlClick ControlCommand ControlDisable ControlEnable ControlFocus ControlGetFocus ControlGetHandle ControlGetPos ControlGetText ControlHide ControlListView ControlMove ControlSend ControlSetText ControlShow ControlTreeView Cos Dec DirCopy DirCreate DirGetSize DirMove DirRemove DllCall DllCallAddress DllCallbackFree DllCallbackGetPtr DllCallbackRegister DllClose DllOpen DllStructCreate DllStructGetData DllStructGetPtr DllStructGetSize DllStructSetData DriveGetDrive DriveGetFileSystem DriveGetLabel DriveGetSerial DriveGetType DriveMapAdd DriveMapDel DriveMapGet DriveSetLabel DriveSpaceFree DriveSpaceTotal DriveStatus EnvGet EnvSet EnvUpdate Eval Execute Exp FileChangeDir FileClose FileCopy FileCreateNTFSLink FileCreateShortcut FileDelete FileExists FileFindFirstFile FileFindNextFile FileFlush FileGetAttrib FileGetEncoding FileGetLongName FileGetPos FileGetShortcut FileGetShortName FileGetSize FileGetTime FileGetVersion FileInstall FileMove FileOpen FileOpenDialog FileRead FileReadLine FileReadToArray FileRecycle FileRecycleEmpty FileSaveDialog FileSelectFolder FileSetAttrib FileSetEnd FileSetPos FileSetTime FileWrite FileWriteLine Floor FtpSetProxy FuncName GUICreate GUICtrlCreateAvi GUICtrlCreateButton GUICtrlCreateCheckbox GUICtrlCreateCombo GUICtrlCreateContextMenu GUICtrlCreateDate GUICtrlCreateDummy GUICtrlCreateEdit GUICtrlCreateGraphic GUICtrlCreateGroup GUICtrlCreateIcon GUICtrlCreateInput GUICtrlCreateLabel GUICtrlCreateList GUICtrlCreateListView GUICtrlCreateListViewItem GUICtrlCreateMenu GUICtrlCreateMenuItem GUICtrlCreateMonthCal GUICtrlCreateObj GUICtrlCreatePic GUICtrlCreateProgress GUICtrlCreateRadio GUICtrlCreateSlider GUICtrlCreateTab GUICtrlCreateTabItem GUICtrlCreateTreeView GUICtrlCreateTreeViewItem GUICtrlCreateUpdown GUICtrlDelete GUICtrlGetHandle GUICtrlGetState GUICtrlRead GUICtrlRecvMsg GUICtrlRegisterListViewSort GUICtrlSendMsg GUICtrlSendToDummy GUICtrlSetBkColor GUICtrlSetColor GUICtrlSetCursor GUICtrlSetData GUICtrlSetDefBkColor GUICtrlSetDefColor GUICtrlSetFont GUICtrlSetGraphic GUICtrlSetImage GUICtrlSetLimit GUICtrlSetOnEvent GUICtrlSetPos GUICtrlSetResizing GUICtrlSetState GUICtrlSetStyle GUICtrlSetTip GUIDelete GUIGetCursorInfo GUIGetMsg GUIGetStyle GUIRegisterMsg GUISetAccelerators GUISetBkColor GUISetCoord GUISetCursor GUISetFont GUISetHelp GUISetIcon GUISetOnEvent GUISetState GUISetStyle GUIStartGroup GUISwitch Hex HotKeySet HttpSetProxy HttpSetUserAgent HWnd InetClose InetGet InetGetInfo InetGetSize InetRead IniDelete IniRead IniReadSection IniReadSectionNames IniRenameSection IniWrite IniWriteSection InputBox Int IsAdmin IsArray IsBinary IsBool IsDeclared IsDllStruct IsFloat IsFunc IsHWnd IsInt IsKeyword IsNumber IsObj IsPtr IsString Log MemGetStats Mod MouseClick MouseClickDrag MouseDown MouseGetCursor MouseGetPos MouseMove MouseUp MouseWheel MsgBox Number ObjCreate ObjCreateInterface ObjEvent ObjGet ObjName OnAutoItExitRegister OnAutoItExitUnRegister Ping PixelChecksum PixelGetColor PixelSearch ProcessClose ProcessExists ProcessGetStats ProcessList ProcessSetPriority ProcessWait ProcessWaitClose ProgressOff ProgressOn ProgressSet Ptr Random RegDelete RegEnumKey RegEnumVal RegRead RegWrite Round Run RunAs RunAsWait RunWait Send SendKeepActive SetError SetExtended ShellExecute ShellExecuteWait Shutdown Sin Sleep SoundPlay SoundSetWaveVolume SplashImageOn SplashOff SplashTextOn Sqrt SRandom StatusbarGetText StderrRead StdinWrite StdioClose StdoutRead String StringAddCR StringCompare StringFormat StringFromASCIIArray StringInStr StringIsAlNum StringIsAlpha StringIsASCII StringIsDigit StringIsFloat StringIsInt StringIsLower StringIsSpace StringIsUpper StringIsXDigit StringLeft StringLen StringLower StringMid StringRegExp StringRegExpReplace StringReplace StringReverse StringRight StringSplit StringStripCR StringStripWS StringToASCIIArray StringToBinary StringTrimLeft StringTrimRight StringUpper Tan TCPAccept TCPCloseSocket TCPConnect TCPListen TCPNameToIP TCPRecv TCPSend TCPShutdown, UDPShutdown TCPStartup, UDPStartup TimerDiff TimerInit ToolTip TrayCreateItem TrayCreateMenu TrayGetMsg TrayItemDelete TrayItemGetHandle TrayItemGetState TrayItemGetText TrayItemSetOnEvent TrayItemSetState TrayItemSetText TraySetClick TraySetIcon TraySetOnEvent TraySetPauseIcon TraySetState TraySetToolTip TrayTip UBound UDPBind UDPCloseSocket UDPOpen UDPRecv UDPSend VarGetType WinActivate WinActive WinClose WinExists WinFlash WinGetCaretPos WinGetClassList WinGetClientSize WinGetHandle WinGetPos WinGetProcess WinGetState WinGetText WinGetTitle WinKill WinList WinMenuSelectItem WinMinimizeAll WinMinimizeAllUndo WinMove WinSetOnTop WinSetState WinSetTitle WinSetTrans WinWait WinWaitActive WinWaitClose WinWaitNotActive`,
                    literal: `True False And Null Not Or Default`
                },
                contains: [
                    n,
                    r,
                    i,
                    a,
                    {
                        className: `meta`,
                        begin: `#`,
                        end: `$`,
                        keywords: {
                            keyword: t
                        },
                        contains: [
                            {
                                begin: /\\\n/,
                                relevance: 0
                            },
                            {
                                beginKeywords: `include`,
                                keywords: {
                                    keyword: `include`
                                },
                                end: `$`,
                                contains: [
                                    i,
                                    {
                                        className: `string`,
                                        variants: [
                                            {
                                                begin: `<`,
                                                end: `>`
                                            },
                                            {
                                                begin: /"/,
                                                end: /"/,
                                                contains: [
                                                    {
                                                        begin: /""/,
                                                        relevance: 0
                                                    }
                                                ]
                                            },
                                            {
                                                begin: /'/,
                                                end: /'/,
                                                contains: [
                                                    {
                                                        begin: /''/,
                                                        relevance: 0
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            i,
                            n
                        ]
                    },
                    {
                        className: `symbol`,
                        begin: `@[A-z0-9_]+`
                    },
                    {
                        beginKeywords: `Func`,
                        end: `$`,
                        illegal: `\\$|\\[|%`,
                        contains: [
                            e.inherit(e.UNDERSCORE_TITLE_MODE, {
                                className: `title.function`
                            }),
                            {
                                className: `params`,
                                begin: `\\(`,
                                end: `\\)`,
                                contains: [
                                    r,
                                    i,
                                    a
                                ]
                            }
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), E = o((e, t)=>{
        function n(e) {
            return {
                name: `AVR Assembly`,
                case_insensitive: !0,
                keywords: {
                    $pattern: `\\.?` + e.IDENT_RE,
                    keyword: `adc add adiw and andi asr bclr bld brbc brbs brcc brcs break breq brge brhc brhs brid brie brlo brlt brmi brne brpl brsh brtc brts brvc brvs bset bst call cbi cbr clc clh cli cln clr cls clt clv clz com cp cpc cpi cpse dec eicall eijmp elpm eor fmul fmuls fmulsu icall ijmp in inc jmp ld ldd ldi lds lpm lsl lsr mov movw mul muls mulsu neg nop or ori out pop push rcall ret reti rjmp rol ror sbc sbr sbrc sbrs sec seh sbi sbci sbic sbis sbiw sei sen ser ses set sev sez sleep spm st std sts sub subi swap tst wdr`,
                    built_in: `r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 r16 r17 r18 r19 r20 r21 r22 r23 r24 r25 r26 r27 r28 r29 r30 r31 x|0 xh xl y|0 yh yl z|0 zh zl ucsr1c udr1 ucsr1a ucsr1b ubrr1l ubrr1h ucsr0c ubrr0h tccr3c tccr3a tccr3b tcnt3h tcnt3l ocr3ah ocr3al ocr3bh ocr3bl ocr3ch ocr3cl icr3h icr3l etimsk etifr tccr1c ocr1ch ocr1cl twcr twdr twar twsr twbr osccal xmcra xmcrb eicra spmcsr spmcr portg ddrg ping portf ddrf sreg sph spl xdiv rampz eicrb eimsk gimsk gicr eifr gifr timsk tifr mcucr mcucsr tccr0 tcnt0 ocr0 assr tccr1a tccr1b tcnt1h tcnt1l ocr1ah ocr1al ocr1bh ocr1bl icr1h icr1l tccr2 tcnt2 ocr2 ocdr wdtcr sfior eearh eearl eedr eecr porta ddra pina portb ddrb pinb portc ddrc pinc portd ddrd pind spdr spsr spcr udr0 ucsr0a ucsr0b ubrr0l acsr admux adcsr adch adcl porte ddre pine pinf`,
                    meta: `.byte .cseg .db .def .device .dseg .dw .endmacro .equ .eseg .exit .include .list .listmac .macro .nolist .org .set`
                },
                contains: [
                    e.C_BLOCK_COMMENT_MODE,
                    e.COMMENT(`;`, `$`, {
                        relevance: 0
                    }),
                    e.C_NUMBER_MODE,
                    e.BINARY_NUMBER_MODE,
                    {
                        className: `number`,
                        begin: `\\b(\\$[a-zA-Z0-9]+|0o[0-7]+)`
                    },
                    e.QUOTE_STRING_MODE,
                    {
                        className: `string`,
                        begin: `'`,
                        end: `[^\\\\]'`,
                        illegal: `[^\\\\][^']`
                    },
                    {
                        className: `symbol`,
                        begin: `^[A-Za-z0-9_.$]+:`
                    },
                    {
                        className: `meta`,
                        begin: `#`,
                        end: `$`
                    },
                    {
                        className: `subst`,
                        begin: `@[0-9]+`
                    }
                ]
            };
        }
        t.exports = n;
    }), D = o((e, t)=>{
        function n(e) {
            return {
                name: `Awk`,
                keywords: {
                    keyword: `BEGIN END if else while do for in break continue delete next nextfile function func exit|10`
                },
                contains: [
                    {
                        className: `variable`,
                        variants: [
                            {
                                begin: /\$[\w\d#@][\w\d_]*/
                            },
                            {
                                begin: /\$\{(.*?)\}/
                            }
                        ]
                    },
                    {
                        className: `string`,
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ],
                        variants: [
                            {
                                begin: /(u|b)?r?'''/,
                                end: /'''/,
                                relevance: 10
                            },
                            {
                                begin: /(u|b)?r?"""/,
                                end: /"""/,
                                relevance: 10
                            },
                            {
                                begin: /(u|r|ur)'/,
                                end: /'/,
                                relevance: 10
                            },
                            {
                                begin: /(u|r|ur)"/,
                                end: /"/,
                                relevance: 10
                            },
                            {
                                begin: /(b|br)'/,
                                end: /'/
                            },
                            {
                                begin: /(b|br)"/,
                                end: /"/
                            },
                            e.APOS_STRING_MODE,
                            e.QUOTE_STRING_MODE
                        ]
                    },
                    e.REGEXP_MODE,
                    e.HASH_COMMENT_MODE,
                    e.NUMBER_MODE
                ]
            };
        }
        t.exports = n;
    }), O = o((e, t)=>{
        function n(e) {
            let t = e.UNDERSCORE_IDENT_RE, n = {
                keyword: `abstract.as.asc.avg.break.breakpoint.by.byref.case.catch.changecompany.class.client.client.common.const.continue.count.crosscompany.delegate.delete_from.desc.display.div.do.edit.else.eventhandler.exists.extends.final.finally.firstfast.firstonly.firstonly1.firstonly10.firstonly100.firstonly1000.flush.for.forceliterals.forcenestedloop.forceplaceholders.forceselectorder.forupdate.from.generateonly.group.hint.if.implements.in.index.insert_recordset.interface.internal.is.join.like.maxof.minof.mod.namespace.new.next.nofetch.notexists.optimisticlock.order.outer.pessimisticlock.print.private.protected.public.readonly.repeatableread.retry.return.reverse.select.server.setting.static.sum.super.switch.this.throw.try.ttsabort.ttsbegin.ttscommit.unchecked.update_recordset.using.validtimestate.void.where.while`.split(`.`),
                built_in: [
                    `anytype`,
                    `boolean`,
                    `byte`,
                    `char`,
                    `container`,
                    `date`,
                    `double`,
                    `enum`,
                    `guid`,
                    `int`,
                    `int64`,
                    `long`,
                    `real`,
                    `short`,
                    `str`,
                    `utcdatetime`,
                    `var`
                ],
                literal: [
                    `default`,
                    `false`,
                    `null`,
                    `true`
                ]
            }, r = {
                variants: [
                    {
                        match: [
                            /(class|interface)\s+/,
                            t,
                            /\s+(extends|implements)\s+/,
                            t
                        ]
                    },
                    {
                        match: [
                            /class\s+/,
                            t
                        ]
                    }
                ],
                scope: {
                    2: `title.class`,
                    4: `title.class.inherited`
                },
                keywords: n
            };
            return {
                name: `X++`,
                aliases: [
                    `x++`
                ],
                keywords: n,
                contains: [
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE,
                    e.C_NUMBER_MODE,
                    {
                        className: `meta`,
                        begin: `#`,
                        end: `$`
                    },
                    r
                ]
            };
        }
        t.exports = n;
    }), k = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = {}, r = {
                begin: /\$\{/,
                end: /\}/,
                contains: [
                    `self`,
                    {
                        begin: /:-/,
                        contains: [
                            n
                        ]
                    }
                ]
            };
            Object.assign(n, {
                className: `variable`,
                variants: [
                    {
                        begin: t.concat(/\$[\w\d#@][\w\d_]*/, `(?![\\w\\d])(?![$])`)
                    },
                    r
                ]
            });
            let i = {
                className: `subst`,
                begin: /\$\(/,
                end: /\)/,
                contains: [
                    e.BACKSLASH_ESCAPE
                ]
            }, a = e.inherit(e.COMMENT(), {
                match: [
                    /(^|\s)/,
                    /#.*$/
                ],
                scope: {
                    2: `comment`
                }
            }), o = {
                begin: /<<-?\s*(?=\w+)/,
                starts: {
                    contains: [
                        e.END_SAME_AS_BEGIN({
                            begin: /(\w+)/,
                            end: /(\w+)/,
                            className: `string`
                        })
                    ]
                }
            }, s = {
                className: `string`,
                begin: /"/,
                end: /"/,
                contains: [
                    e.BACKSLASH_ESCAPE,
                    n,
                    i
                ]
            };
            i.contains.push(s);
            let c = {
                match: /\\"/
            }, l = {
                className: `string`,
                begin: /'/,
                end: /'/
            }, u = {
                match: /\\'/
            }, d = {
                begin: /\$?\(\(/,
                end: /\)\)/,
                contains: [
                    {
                        begin: /\d+#[0-9a-f]+/,
                        className: `number`
                    },
                    e.NUMBER_MODE,
                    n
                ]
            }, f = e.SHEBANG({
                binary: `(${[
                    `fish`,
                    `bash`,
                    `zsh`,
                    `sh`,
                    `csh`,
                    `ksh`,
                    `tcsh`,
                    `dash`,
                    `scsh`
                ].join(`|`)})`,
                relevance: 10
            }), p = {
                className: `function`,
                begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
                returnBegin: !0,
                contains: [
                    e.inherit(e.TITLE_MODE, {
                        begin: /\w[\w\d_]*/
                    })
                ],
                relevance: 0
            }, m = [
                `if`,
                `then`,
                `else`,
                `elif`,
                `fi`,
                `time`,
                `for`,
                `while`,
                `until`,
                `in`,
                `do`,
                `done`,
                `case`,
                `esac`,
                `coproc`,
                `function`,
                `select`
            ], h = [
                `true`,
                `false`
            ], g = {
                match: /(\/[a-z._-]+)+/
            }, _ = [
                `break`,
                `cd`,
                `continue`,
                `eval`,
                `exec`,
                `exit`,
                `export`,
                `getopts`,
                `hash`,
                `pwd`,
                `readonly`,
                `return`,
                `shift`,
                `test`,
                `times`,
                `trap`,
                `umask`,
                `unset`
            ], v = [
                `alias`,
                `bind`,
                `builtin`,
                `caller`,
                `command`,
                `declare`,
                `echo`,
                `enable`,
                `help`,
                `let`,
                `local`,
                `logout`,
                `mapfile`,
                `printf`,
                `read`,
                `readarray`,
                `source`,
                `sudo`,
                `type`,
                `typeset`,
                `ulimit`,
                `unalias`
            ], y = `autoload.bg.bindkey.bye.cap.chdir.clone.comparguments.compcall.compctl.compdescribe.compfiles.compgroups.compquote.comptags.comptry.compvalues.dirs.disable.disown.echotc.echoti.emulate.fc.fg.float.functions.getcap.getln.history.integer.jobs.kill.limit.log.noglob.popd.print.pushd.pushln.rehash.sched.setcap.setopt.stat.suspend.ttyctl.unfunction.unhash.unlimit.unsetopt.vared.wait.whence.where.which.zcompile.zformat.zftp.zle.zmodload.zparseopts.zprof.zpty.zregexparse.zsocket.zstyle.ztcp`.split(`.`), b = `chcon.chgrp.chown.chmod.cp.dd.df.dir.dircolors.ln.ls.mkdir.mkfifo.mknod.mktemp.mv.realpath.rm.rmdir.shred.sync.touch.truncate.vdir.b2sum.base32.base64.cat.cksum.comm.csplit.cut.expand.fmt.fold.head.join.md5sum.nl.numfmt.od.paste.ptx.pr.sha1sum.sha224sum.sha256sum.sha384sum.sha512sum.shuf.sort.split.sum.tac.tail.tr.tsort.unexpand.uniq.wc.arch.basename.chroot.date.dirname.du.echo.env.expr.factor.groups.hostid.id.link.logname.nice.nohup.nproc.pathchk.pinky.printenv.printf.pwd.readlink.runcon.seq.sleep.stat.stdbuf.stty.tee.test.timeout.tty.uname.unlink.uptime.users.who.whoami.yes`.split(`.`);
            return {
                name: `Bash`,
                aliases: [
                    `sh`,
                    `zsh`
                ],
                keywords: {
                    $pattern: /\b[a-z][a-z0-9._-]+\b/,
                    keyword: m,
                    literal: h,
                    built_in: [
                        ..._,
                        ...v,
                        `set`,
                        `shopt`,
                        ...y,
                        ...b
                    ]
                },
                contains: [
                    f,
                    e.SHEBANG(),
                    p,
                    d,
                    a,
                    o,
                    g,
                    s,
                    c,
                    l,
                    u,
                    n
                ]
            };
        }
        t.exports = n;
    }), A = o((e, t)=>{
        function n(e) {
            return {
                name: `BASIC`,
                case_insensitive: !0,
                illegal: `^.`,
                keywords: {
                    $pattern: `[a-zA-Z][a-zA-Z0-9_$%!#]*`,
                    keyword: `ABS.ASC.AND.ATN.AUTO|0.BEEP.BLOAD|10.BSAVE|10.CALL.CALLS.CDBL.CHAIN.CHDIR.CHR$|10.CINT.CIRCLE.CLEAR.CLOSE.CLS.COLOR.COM.COMMON.CONT.COS.CSNG.CSRLIN.CVD.CVI.CVS.DATA.DATE$.DEFDBL.DEFINT.DEFSNG.DEFSTR.DEF|0.SEG.USR.DELETE.DIM.DRAW.EDIT.END.ENVIRON.ENVIRON$.EOF.EQV.ERASE.ERDEV.ERDEV$.ERL.ERR.ERROR.EXP.FIELD.FILES.FIX.FOR|0.FRE.GET.GOSUB|10.GOTO.HEX$.IF.THEN.ELSE|0.INKEY$.INP.INPUT.INPUT#.INPUT$.INSTR.IMP.INT.IOCTL.IOCTL$.KEY.ON.OFF.LIST.KILL.LEFT$.LEN.LET.LINE.LLIST.LOAD.LOC.LOCATE.LOF.LOG.LPRINT.USING.LSET.MERGE.MID$.MKDIR.MKD$.MKI$.MKS$.MOD.NAME.NEW.NEXT.NOISE.NOT.OCT$.ON.OR.PEN.PLAY.STRIG.OPEN.OPTION.BASE.OUT.PAINT.PALETTE.PCOPY.PEEK.PMAP.POINT.POKE.POS.PRINT.PRINT].PSET.PRESET.PUT.RANDOMIZE.READ.REM.RENUM.RESET|0.RESTORE.RESUME.RETURN|0.RIGHT$.RMDIR.RND.RSET.RUN.SAVE.SCREEN.SGN.SHELL.SIN.SOUND.SPACE$.SPC.SQR.STEP.STICK.STOP.STR$.STRING$.SWAP.SYSTEM.TAB.TAN.TIME$.TIMER.TROFF.TRON.TO.USR.VAL.VARPTR.VARPTR$.VIEW.WAIT.WHILE.WEND.WIDTH.WINDOW.WRITE.XOR`.split(`.`)
                },
                contains: [
                    {
                        scope: `string`,
                        begin: /"/,
                        end: /"|$/,
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ]
                    },
                    e.COMMENT(`REM`, `$`, {
                        relevance: 10
                    }),
                    e.COMMENT(`'`, `$`, {
                        relevance: 0
                    }),
                    {
                        className: `symbol`,
                        begin: `^[0-9]+ `,
                        relevance: 10
                    },
                    {
                        className: `number`,
                        begin: `\\b\\d+(\\.\\d+)?([edED]\\d+)?[#!]?`,
                        relevance: 0
                    },
                    {
                        className: `number`,
                        begin: `(&[hH][0-9a-fA-F]{1,4})`
                    },
                    {
                        className: `number`,
                        begin: `(&[oO][0-7]{1,6})`
                    }
                ]
            };
        }
        t.exports = n;
    }), j = o((e, t)=>{
        function n(e) {
            return {
                name: `Backus\u{2013}Naur Form`,
                contains: [
                    {
                        className: `attribute`,
                        begin: /</,
                        end: />/
                    },
                    {
                        begin: /::=/,
                        end: /$/,
                        contains: [
                            {
                                begin: /</,
                                end: />/
                            },
                            e.C_LINE_COMMENT_MODE,
                            e.C_BLOCK_COMMENT_MODE,
                            e.APOS_STRING_MODE,
                            e.QUOTE_STRING_MODE
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), M = o((e, t)=>{
        function n(e) {
            let t = {
                className: `literal`,
                begin: /[+-]+/,
                relevance: 0
            };
            return {
                name: `Brainfuck`,
                aliases: [
                    `bf`
                ],
                contains: [
                    e.COMMENT(/[^\[\]\.,\+\-<> \r\n]/, /[\[\]\.,\+\-<> \r\n]/, {
                        contains: [
                            {
                                match: /[ ]+[^\[\]\.,\+\-<> \r\n]/,
                                relevance: 0
                            }
                        ],
                        returnEnd: !0,
                        relevance: 0
                    }),
                    {
                        className: `title`,
                        begin: `[\\[\\]]`,
                        relevance: 0
                    },
                    {
                        className: `string`,
                        begin: `[\\.,]`,
                        relevance: 0
                    },
                    {
                        begin: /(?=\+\+|--)/,
                        contains: [
                            t
                        ]
                    },
                    t
                ]
            };
        }
        t.exports = n;
    }), N = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = e.COMMENT(`//`, `$`, {
                contains: [
                    {
                        begin: /\\\n/
                    }
                ]
            }), r = `decltype\\(auto\\)`, i = `[a-zA-Z_]\\w*::`, a = `(` + r + `|` + t.optional(i) + `[a-zA-Z_]\\w*` + t.optional(`<[^<>]+>`) + `)`, o = {
                className: `type`,
                variants: [
                    {
                        begin: `\\b[a-z\\d_]*_t\\b`
                    },
                    {
                        match: /\batomic_[a-z]{3,6}\b/
                    }
                ]
            }, s = {
                className: `string`,
                variants: [
                    {
                        begin: `(u8?|U|L)?"`,
                        end: `"`,
                        illegal: `\\n`,
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ]
                    },
                    {
                        begin: `(u8?|U|L)?'(\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)|.)`,
                        end: `'`,
                        illegal: `.`
                    },
                    e.END_SAME_AS_BEGIN({
                        begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
                        end: /\)([^()\\ ]{0,16})"/
                    })
                ]
            }, c = {
                className: `number`,
                variants: [
                    {
                        match: /\b(0b[01']+)/
                    },
                    {
                        match: /(-?)\b([\d']+(\.[\d']*)?|\.[\d']+)((ll|LL|l|L)(u|U)?|(u|U)(ll|LL|l|L)?|f|F|b|B)/
                    },
                    {
                        match: /(-?)\b(0[xX][a-fA-F0-9]+(?:'[a-fA-F0-9]+)*(?:\.[a-fA-F0-9]*(?:'[a-fA-F0-9]*)*)?(?:[pP][-+]?[0-9]+)?(l|L)?(u|U)?)/
                    },
                    {
                        match: /(-?)\b\d+(?:'\d+)*(?:\.\d*(?:'\d*)*)?(?:[eE][-+]?\d+)?/
                    }
                ],
                relevance: 0
            }, l = {
                className: `meta`,
                begin: /#\s*[a-z]+\b/,
                end: /$/,
                keywords: {
                    keyword: `if else elif endif define undef warning error line pragma _Pragma ifdef ifndef elifdef elifndef include`
                },
                contains: [
                    {
                        begin: /\\\n/,
                        relevance: 0
                    },
                    e.inherit(s, {
                        className: `string`
                    }),
                    {
                        className: `string`,
                        begin: /<.*?>/
                    },
                    n,
                    e.C_BLOCK_COMMENT_MODE
                ]
            }, u = {
                className: `title`,
                begin: t.optional(i) + e.IDENT_RE,
                relevance: 0
            }, d = t.optional(i) + e.IDENT_RE + `\\s*\\(`, f = {
                keyword: `asm.auto.break.case.continue.default.do.else.enum.extern.for.fortran.goto.if.inline.register.restrict.return.sizeof.typeof.typeof_unqual.struct.switch.typedef.union.volatile.while._Alignas._Alignof._Atomic._Generic._Noreturn._Static_assert._Thread_local.alignas.alignof.noreturn.static_assert.thread_local._Pragma`.split(`.`),
                type: `float.double.signed.unsigned.int.short.long.char.void._Bool._BitInt._Complex._Imaginary._Decimal32._Decimal64._Decimal96._Decimal128._Decimal64x._Decimal128x._Float16._Float32._Float64._Float128._Float32x._Float64x._Float128x.const.static.constexpr.complex.bool.imaginary`.split(`.`),
                literal: `true false NULL`,
                built_in: `std string wstring cin cout cerr clog stdin stdout stderr stringstream istringstream ostringstream auto_ptr deque list queue stack vector map set pair bitset multiset multimap unordered_set unordered_map unordered_multiset unordered_multimap priority_queue make_pair array shared_ptr abort terminate abs acos asin atan2 atan calloc ceil cosh cos exit exp fabs floor fmod fprintf fputs free frexp fscanf future isalnum isalpha iscntrl isdigit isgraph islower isprint ispunct isspace isupper isxdigit tolower toupper labs ldexp log10 log malloc realloc memchr memcmp memcpy memset modf pow printf putchar puts scanf sinh sin snprintf sprintf sqrt sscanf strcat strchr strcmp strcpy strcspn strlen strncat strncmp strncpy strpbrk strrchr strspn strstr tanh tan vfprintf vprintf vsprintf endl initializer_list unique_ptr`
            }, p = [
                l,
                o,
                n,
                e.C_BLOCK_COMMENT_MODE,
                c,
                s
            ], m = {
                variants: [
                    {
                        begin: /=/,
                        end: /;/
                    },
                    {
                        begin: /\(/,
                        end: /\)/
                    },
                    {
                        beginKeywords: `new throw return else`,
                        end: /;/
                    }
                ],
                keywords: f,
                contains: p.concat([
                    {
                        begin: /\(/,
                        end: /\)/,
                        keywords: f,
                        contains: p.concat([
                            `self`
                        ]),
                        relevance: 0
                    }
                ]),
                relevance: 0
            }, h = {
                begin: `(` + a + `[\\*&\\s]+)+` + d,
                returnBegin: !0,
                end: /[{;=]/,
                excludeEnd: !0,
                keywords: f,
                illegal: /[^\w\s\*&:<>.]/,
                contains: [
                    {
                        begin: r,
                        keywords: f,
                        relevance: 0
                    },
                    {
                        begin: d,
                        returnBegin: !0,
                        contains: [
                            e.inherit(u, {
                                className: `title.function`
                            })
                        ],
                        relevance: 0
                    },
                    {
                        relevance: 0,
                        match: /,/
                    },
                    {
                        className: `params`,
                        begin: /\(/,
                        end: /\)/,
                        keywords: f,
                        relevance: 0,
                        contains: [
                            n,
                            e.C_BLOCK_COMMENT_MODE,
                            s,
                            c,
                            o,
                            {
                                begin: /\(/,
                                end: /\)/,
                                keywords: f,
                                relevance: 0,
                                contains: [
                                    `self`,
                                    n,
                                    e.C_BLOCK_COMMENT_MODE,
                                    s,
                                    c,
                                    o
                                ]
                            }
                        ]
                    },
                    o,
                    n,
                    e.C_BLOCK_COMMENT_MODE,
                    l
                ]
            };
            return {
                name: `C`,
                aliases: [
                    `h`
                ],
                keywords: f,
                disableAutodetect: !0,
                illegal: `</`,
                contains: [].concat(m, h, p, [
                    l,
                    {
                        begin: e.IDENT_RE + `::`,
                        keywords: f
                    },
                    {
                        className: `class`,
                        beginKeywords: `enum class struct union`,
                        end: /[{;:<>=]/,
                        contains: [
                            {
                                beginKeywords: `final class struct`
                            },
                            e.TITLE_MODE
                        ]
                    }
                ]),
                exports: {
                    preprocessor: l,
                    strings: s,
                    keywords: f
                }
            };
        }
        t.exports = n;
    }), P = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = `div.mod.in.and.or.not.xor.asserterror.begin.case.do.downto.else.end.exit.for.local.if.of.repeat.then.to.until.while.with.var`.split(`.`), r = [
                e.C_LINE_COMMENT_MODE,
                e.COMMENT(/\{/, /\}/, {
                    relevance: 0
                }),
                e.COMMENT(/\(\*/, /\*\)/, {
                    relevance: 10
                })
            ], i = {
                className: `string`,
                begin: /'/,
                end: /'/,
                contains: [
                    {
                        begin: /''/
                    }
                ]
            }, a = {
                className: `string`,
                begin: /(#\d+)+/
            }, o = {
                className: `number`,
                begin: `\\b\\d+(\\.\\d+)?(DT|D|T)`,
                relevance: 0
            }, s = {
                className: `string`,
                begin: `"`,
                end: `"`
            }, c = {
                match: [
                    /procedure/,
                    /\s+/,
                    /[a-zA-Z_][\w@]*/,
                    /\s*/
                ],
                scope: {
                    1: `keyword`,
                    3: `title.function`
                },
                contains: [
                    {
                        className: `params`,
                        begin: /\(/,
                        end: /\)/,
                        keywords: n,
                        contains: [
                            i,
                            a,
                            e.NUMBER_MODE
                        ]
                    },
                    ...r
                ]
            }, l = {
                match: [
                    /OBJECT/,
                    /\s+/,
                    t.either(`Table`, `Form`, `Report`, `Dataport`, `Codeunit`, `XMLport`, `MenuSuite`, `Page`, `Query`),
                    /\s+/,
                    /\d+/,
                    /\s+(?=[^\s])/,
                    /.*/,
                    /$/
                ],
                relevance: 3,
                scope: {
                    1: `keyword`,
                    3: `type`,
                    5: `number`,
                    7: `title`
                }
            };
            return {
                name: `C/AL`,
                case_insensitive: !0,
                keywords: {
                    keyword: n,
                    literal: `false true`
                },
                illegal: /\/\*/,
                contains: [
                    {
                        match: /[\w]+(?=\=)/,
                        scope: `attribute`,
                        relevance: 0
                    },
                    i,
                    a,
                    o,
                    s,
                    e.NUMBER_MODE,
                    l,
                    c
                ]
            };
        }
        t.exports = n;
    }), F = o((e, t)=>{
        function n(e) {
            let t = [
                `struct`,
                `enum`,
                `interface`,
                `union`,
                `group`,
                `import`,
                `using`,
                `const`,
                `annotation`,
                `extends`,
                `in`,
                `of`,
                `on`,
                `as`,
                `with`,
                `from`,
                `fixed`
            ], n = [
                `Void`,
                `Bool`,
                `Int8`,
                `Int16`,
                `Int32`,
                `Int64`,
                `UInt8`,
                `UInt16`,
                `UInt32`,
                `UInt64`,
                `Float32`,
                `Float64`,
                `Text`,
                `Data`,
                `AnyPointer`,
                `AnyStruct`,
                `Capability`,
                `List`
            ], r = [
                `true`,
                `false`
            ], i = {
                variants: [
                    {
                        match: [
                            /(struct|enum|interface)/,
                            /\s+/,
                            e.IDENT_RE
                        ]
                    },
                    {
                        match: [
                            /extends/,
                            /\s*\(/,
                            e.IDENT_RE,
                            /\s*\)/
                        ]
                    }
                ],
                scope: {
                    1: `keyword`,
                    3: `title.class`
                }
            };
            return {
                name: `Cap\u{2019}n Proto`,
                aliases: [
                    `capnp`
                ],
                keywords: {
                    keyword: t,
                    type: n,
                    literal: r
                },
                contains: [
                    e.QUOTE_STRING_MODE,
                    e.NUMBER_MODE,
                    e.HASH_COMMENT_MODE,
                    {
                        className: `meta`,
                        begin: /@0x[\w\d]{16};/,
                        illegal: /\n/
                    },
                    {
                        className: `symbol`,
                        begin: /@\d+\b/
                    },
                    i
                ]
            };
        }
        t.exports = n;
    }), I = o((e, t)=>{
        function n(e) {
            let t = `assembly.module.package.import.alias.class.interface.object.given.value.assign.void.function.new.of.extends.satisfies.abstracts.in.out.return.break.continue.throw.assert.dynamic.if.else.switch.case.for.while.try.catch.finally.then.let.this.outer.super.is.exists.nonempty`.split(`.`), n = [
                `shared`,
                `abstract`,
                `formal`,
                `default`,
                `actual`,
                `variable`,
                `late`,
                `native`,
                `deprecated`,
                `final`,
                `sealed`,
                `annotation`,
                `suppressWarnings`,
                `small`
            ], r = [
                `doc`,
                `by`,
                `license`,
                `see`,
                `throws`,
                `tagged`
            ], i = {
                className: `subst`,
                excludeBegin: !0,
                excludeEnd: !0,
                begin: /``/,
                end: /``/,
                keywords: t,
                relevance: 10
            }, a = [
                {
                    className: `string`,
                    begin: `"""`,
                    end: `"""`,
                    relevance: 10
                },
                {
                    className: `string`,
                    begin: `"`,
                    end: `"`,
                    contains: [
                        i
                    ]
                },
                {
                    className: `string`,
                    begin: `'`,
                    end: `'`
                },
                {
                    className: `number`,
                    begin: `#[0-9a-fA-F_]+|\\$[01_]+|[0-9_]+(?:\\.[0-9_](?:[eE][+-]?\\d+)?)?[kMGTPmunpf]?`,
                    relevance: 0
                }
            ];
            return i.contains = a, {
                name: `Ceylon`,
                keywords: {
                    keyword: t.concat(n),
                    meta: r
                },
                illegal: `\\$[^01]|#[^0-9a-fA-F]`,
                contains: [
                    e.C_LINE_COMMENT_MODE,
                    e.COMMENT(`/\\*`, `\\*/`, {
                        contains: [
                            `self`
                        ]
                    }),
                    {
                        className: `meta`,
                        begin: `@[a-z]\\w*(?::"[^"]*")?`
                    }
                ].concat(a)
            };
        }
        t.exports = n;
    }), L = o((e, t)=>{
        function n(e) {
            return {
                name: `Clean`,
                aliases: [
                    `icl`,
                    `dcl`
                ],
                keywords: {
                    keyword: `if.let.in.with.where.case.of.class.instance.otherwise.implementation.definition.system.module.from.import.qualified.as.special.code.inline.foreign.export.ccall.stdcall.generic.derive.infix.infixl.infixr`.split(`.`),
                    built_in: `Int Real Char Bool`,
                    literal: `True False`
                },
                contains: [
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE,
                    e.C_NUMBER_MODE,
                    {
                        begin: `->|<-[|:]?|#!?|>>=|\\{\\||\\|\\}|:==|=:|<>`
                    }
                ]
            };
        }
        t.exports = n;
    }), R = o((e, t)=>{
        function n(e) {
            let t = `[#]?[a-zA-Z_\\-!.?+*=<>&'][a-zA-Z_\\-!.?+*=<>&'0-9/;:$#]*`, n = `def defonce defprotocol defstruct defmulti defmethod defn- defn defmacro deftype defrecord`, r = {
                $pattern: t,
                built_in: n + ` cond apply if-not if-let if not not= =|0 <|0 >|0 <=|0 >=|0 ==|0 +|0 /|0 *|0 -|0 rem quot neg? pos? delay? symbol? keyword? true? false? integer? empty? coll? list? set? ifn? fn? associative? sequential? sorted? counted? reversible? number? decimal? class? distinct? isa? float? rational? reduced? ratio? odd? even? char? seq? vector? string? map? nil? contains? zero? instance? not-every? not-any? libspec? -> ->> .. . inc compare do dotimes mapcat take remove take-while drop letfn drop-last take-last drop-while while intern condp case reduced cycle split-at split-with repeat replicate iterate range merge zipmap declare line-seq sort comparator sort-by dorun doall nthnext nthrest partition eval doseq await await-for let agent atom send send-off release-pending-sends add-watch mapv filterv remove-watch agent-error restart-agent set-error-handler error-handler set-error-mode! error-mode shutdown-agents quote var fn loop recur throw try monitor-enter monitor-exit macroexpand macroexpand-1 for dosync and or when when-not when-let comp juxt partial sequence memoize constantly complement identity assert peek pop doto proxy first rest cons cast coll last butlast sigs reify second ffirst fnext nfirst nnext meta with-meta ns in-ns create-ns import refer keys select-keys vals key val rseq name namespace promise into transient persistent! conj! assoc! dissoc! pop! disj! use class type num float double short byte boolean bigint biginteger bigdec print-method print-dup throw-if printf format load compile get-in update-in pr pr-on newline flush read slurp read-line subvec with-open memfn time re-find re-groups rand-int rand mod locking assert-valid-fdecl alias resolve ref deref refset swap! reset! set-validator! compare-and-set! alter-meta! reset-meta! commute get-validator alter ref-set ref-history-count ref-min-history ref-max-history ensure sync io! new next conj set! to-array future future-call into-array aset gen-class reduce map filter find empty hash-map hash-set sorted-map sorted-map-by sorted-set sorted-set-by vec vector seq flatten reverse assoc dissoc list disj get union difference intersection extend extend-type extend-protocol int nth delay count concat chunk chunk-buffer chunk-append chunk-first chunk-rest max min dec unchecked-inc-int unchecked-inc unchecked-dec-inc unchecked-dec unchecked-negate unchecked-add-int unchecked-add unchecked-subtract-int unchecked-subtract chunk-next chunk-cons chunked-seq? prn vary-meta lazy-seq spread list* str find-keyword keyword symbol gensym force rationalize`
            }, i = {
                begin: t,
                relevance: 0
            }, a = {
                scope: `number`,
                relevance: 0,
                variants: [
                    {
                        match: /[-+]?0[xX][0-9a-fA-F]+N?/
                    },
                    {
                        match: /[-+]?0[0-7]+N?/
                    },
                    {
                        match: /[-+]?[1-9][0-9]?[rR][0-9a-zA-Z]+N?/
                    },
                    {
                        match: /[-+]?[0-9]+\/[0-9]+N?/
                    },
                    {
                        match: /[-+]?[0-9]+((\.[0-9]*([eE][+-]?[0-9]+)?M?)|([eE][+-]?[0-9]+M?|M))/
                    },
                    {
                        match: /[-+]?([1-9][0-9]*|0)N?/
                    }
                ]
            }, o = {
                scope: `character`,
                variants: [
                    {
                        match: /\\o[0-3]?[0-7]{1,2}/
                    },
                    {
                        match: /\\u[0-9a-fA-F]{4}/
                    },
                    {
                        match: /\\(newline|space|tab|formfeed|backspace|return)/
                    },
                    {
                        match: /\\\S/,
                        relevance: 0
                    }
                ]
            }, s = {
                scope: `regex`,
                begin: /#"/,
                end: /"/,
                contains: [
                    e.BACKSLASH_ESCAPE
                ]
            }, c = e.inherit(e.QUOTE_STRING_MODE, {
                illegal: null
            }), l = {
                scope: `punctuation`,
                match: /,/,
                relevance: 0
            }, u = e.COMMENT(`;`, `$`, {
                relevance: 0
            }), d = {
                className: `literal`,
                begin: /\b(true|false|nil)\b/
            }, f = {
                begin: `\\[|(#::?` + t + `)?\\{`,
                end: `[\\]\\}]`,
                relevance: 0
            }, p = {
                className: `symbol`,
                begin: `[:]{1,2}` + t
            }, m = {
                begin: `\\(`,
                end: `\\)`
            }, h = {
                endsWithParent: !0,
                relevance: 0
            }, g = {
                keywords: r,
                className: `name`,
                begin: t,
                relevance: 0,
                starts: h
            }, _ = [
                l,
                m,
                o,
                s,
                c,
                u,
                p,
                f,
                a,
                d,
                i
            ];
            return m.contains = [
                {
                    beginKeywords: n,
                    keywords: {
                        $pattern: t,
                        keyword: n
                    },
                    end: `(\\[|#|\\d|"|:|\\{|\\)|\\(|$)`,
                    contains: [
                        {
                            className: `title`,
                            begin: t,
                            relevance: 0,
                            excludeEnd: !0,
                            endsParent: !0
                        }
                    ].concat(_)
                },
                g,
                h
            ], h.contains = _, f.contains = _, {
                name: `Clojure`,
                aliases: [
                    `clj`,
                    `edn`
                ],
                illegal: /\S/,
                contains: [
                    l,
                    m,
                    o,
                    s,
                    c,
                    u,
                    p,
                    f,
                    a,
                    d
                ]
            };
        }
        t.exports = n;
    }), z = o((e, t)=>{
        function n(e) {
            return {
                name: `Clojure REPL`,
                contains: [
                    {
                        className: `meta.prompt`,
                        begin: /^([\w.-]+|\s*#_)?=>/,
                        starts: {
                            end: /$/,
                            subLanguage: `clojure`
                        }
                    }
                ]
            };
        }
        t.exports = n;
    }), B = o((e, t)=>{
        function n(e) {
            return {
                name: `CMake`,
                aliases: [
                    `cmake.in`
                ],
                case_insensitive: !0,
                keywords: {
                    keyword: `break cmake_host_system_information cmake_minimum_required cmake_parse_arguments cmake_policy configure_file continue elseif else endforeach endfunction endif endmacro endwhile execute_process file find_file find_library find_package find_path find_program foreach function get_cmake_property get_directory_property get_filename_component get_property if include include_guard list macro mark_as_advanced math message option return separate_arguments set_directory_properties set_property set site_name string unset variable_watch while add_compile_definitions add_compile_options add_custom_command add_custom_target add_definitions add_dependencies add_executable add_library add_link_options add_subdirectory add_test aux_source_directory build_command create_test_sourcelist define_property enable_language enable_testing export fltk_wrap_ui get_source_file_property get_target_property get_test_property include_directories include_external_msproject include_regular_expression install link_directories link_libraries load_cache project qt_wrap_cpp qt_wrap_ui remove_definitions set_source_files_properties set_target_properties set_tests_properties source_group target_compile_definitions target_compile_features target_compile_options target_include_directories target_link_directories target_link_libraries target_link_options target_sources try_compile try_run ctest_build ctest_configure ctest_coverage ctest_empty_binary_directory ctest_memcheck ctest_read_custom_files ctest_run_script ctest_sleep ctest_start ctest_submit ctest_test ctest_update ctest_upload build_name exec_program export_library_dependencies install_files install_programs install_targets load_command make_directory output_required_files remove subdir_depends subdirs use_mangled_mesa utility_source variable_requires write_file qt5_use_modules qt5_use_package qt5_wrap_cpp on off true false and or not command policy target test exists is_newer_than is_directory is_symlink is_absolute matches less greater equal less_equal greater_equal strless strgreater strequal strless_equal strgreater_equal version_less version_greater version_equal version_less_equal version_greater_equal in_list defined`
                },
                contains: [
                    {
                        className: `variable`,
                        begin: /\$\{/,
                        end: /\}/
                    },
                    e.COMMENT(/#\[\[/, /]]/),
                    e.HASH_COMMENT_MODE,
                    e.QUOTE_STRING_MODE,
                    e.NUMBER_MODE
                ]
            };
        }
        t.exports = n;
    }), ee = o((e, t)=>{
        var n = `as.in.of.if.for.while.finally.var.new.function.do.return.void.else.break.catch.instanceof.with.throw.case.default.try.switch.continue.typeof.delete.let.yield.const.class.debugger.async.await.static.import.from.export.extends.using`.split(`.`), r = [
            `true`,
            `false`,
            `null`,
            `undefined`,
            `NaN`,
            `Infinity`
        ], i = [
            `setInterval`,
            `setTimeout`,
            `clearInterval`,
            `clearTimeout`,
            `require`,
            `exports`,
            `eval`,
            `isFinite`,
            `isNaN`,
            `parseFloat`,
            `parseInt`,
            `decodeURI`,
            `decodeURIComponent`,
            `encodeURI`,
            `encodeURIComponent`,
            `escape`,
            `unescape`
        ].concat(`Object.Function.Boolean.Symbol.Math.Date.Number.BigInt.String.RegExp.Array.Float32Array.Float64Array.Int8Array.Uint8Array.Uint8ClampedArray.Int16Array.Int32Array.Uint16Array.Uint32Array.BigInt64Array.BigUint64Array.Set.Map.WeakSet.WeakMap.ArrayBuffer.SharedArrayBuffer.Atomics.DataView.JSON.Promise.Generator.GeneratorFunction.AsyncFunction.Reflect.Proxy.Intl.WebAssembly`.split(`.`), [
            `Error`,
            `EvalError`,
            `InternalError`,
            `RangeError`,
            `ReferenceError`,
            `SyntaxError`,
            `TypeError`,
            `URIError`
        ]);
        function a(e) {
            let t = {
                keyword: n.concat([
                    `then`,
                    `unless`,
                    `until`,
                    `loop`,
                    `by`,
                    `when`,
                    `and`,
                    `or`,
                    `is`,
                    `isnt`,
                    `not`
                ]).filter(((e)=>(t)=>!e.includes(t))([
                    `var`,
                    `const`,
                    `let`,
                    `function`,
                    `static`
                ])),
                literal: r.concat([
                    `yes`,
                    `no`,
                    `on`,
                    `off`
                ]),
                built_in: i.concat([
                    `npm`,
                    `print`
                ])
            }, a = `[A-Za-z$_][0-9A-Za-z$_]*`, o = {
                className: `subst`,
                begin: /#\{/,
                end: /\}/,
                keywords: t
            }, s = [
                e.BINARY_NUMBER_MODE,
                e.inherit(e.C_NUMBER_MODE, {
                    starts: {
                        end: `(\\s*/)?`,
                        relevance: 0
                    }
                }),
                {
                    className: `string`,
                    variants: [
                        {
                            begin: /'''/,
                            end: /'''/,
                            contains: [
                                e.BACKSLASH_ESCAPE
                            ]
                        },
                        {
                            begin: /'/,
                            end: /'/,
                            contains: [
                                e.BACKSLASH_ESCAPE
                            ]
                        },
                        {
                            begin: /"""/,
                            end: /"""/,
                            contains: [
                                e.BACKSLASH_ESCAPE,
                                o
                            ]
                        },
                        {
                            begin: /"/,
                            end: /"/,
                            contains: [
                                e.BACKSLASH_ESCAPE,
                                o
                            ]
                        }
                    ]
                },
                {
                    className: `regexp`,
                    variants: [
                        {
                            begin: `///`,
                            end: `///`,
                            contains: [
                                o,
                                e.HASH_COMMENT_MODE
                            ]
                        },
                        {
                            begin: `//[gim]{0,3}(?=\\W)`,
                            relevance: 0
                        },
                        {
                            begin: /\/(?![ *]).*?(?![\\]).\/[gim]{0,3}(?=\W)/
                        }
                    ]
                },
                {
                    begin: `@` + a
                },
                {
                    subLanguage: `javascript`,
                    excludeBegin: !0,
                    excludeEnd: !0,
                    variants: [
                        {
                            begin: "```",
                            end: "```"
                        },
                        {
                            begin: "`",
                            end: "`"
                        }
                    ]
                }
            ];
            o.contains = s;
            let c = e.inherit(e.TITLE_MODE, {
                begin: a
            }), l = {
                className: `params`,
                begin: `\\([^\\(]`,
                returnBegin: !0,
                contains: [
                    {
                        begin: /\(/,
                        end: /\)/,
                        keywords: t,
                        contains: [
                            `self`
                        ].concat(s)
                    }
                ]
            }, u = {
                variants: [
                    {
                        match: [
                            /class\s+/,
                            a,
                            /\s+extends\s+/,
                            a
                        ]
                    },
                    {
                        match: [
                            /class\s+/,
                            a
                        ]
                    }
                ],
                scope: {
                    2: `title.class`,
                    4: `title.class.inherited`
                },
                keywords: t
            };
            return {
                name: `CoffeeScript`,
                aliases: [
                    `coffee`,
                    `cson`,
                    `iced`
                ],
                keywords: t,
                illegal: /\/\*/,
                contains: [
                    ...s,
                    e.COMMENT(`###`, `###`),
                    e.HASH_COMMENT_MODE,
                    {
                        className: `function`,
                        begin: `^\\s*` + a + `\\s*=\\s*(\\(.*\\)\\s*)?\\B[-=]>`,
                        end: `[-=]>`,
                        returnBegin: !0,
                        contains: [
                            c,
                            l
                        ]
                    },
                    {
                        begin: /[:\(,=]\s*/,
                        relevance: 0,
                        contains: [
                            {
                                className: `function`,
                                begin: `(\\(.*\\)\\s*)?\\B[-=]>`,
                                end: `[-=]>`,
                                returnBegin: !0,
                                contains: [
                                    l
                                ]
                            }
                        ]
                    },
                    u,
                    {
                        begin: a + `:`,
                        end: `:`,
                        returnBegin: !0,
                        returnEnd: !0,
                        relevance: 0
                    }
                ]
            };
        }
        t.exports = a;
    }), te = o((e, t)=>{
        function n(e) {
            return {
                name: `Coq`,
                keywords: {
                    keyword: `_|0.as.at.cofix.else.end.exists.exists2.fix.for.forall.fun.if.IF.in.let.match.mod.Prop.return.Set.then.Type.using.where.with.Abort.About.Add.Admit.Admitted.All.Arguments.Assumptions.Axiom.Back.BackTo.Backtrack.Bind.Blacklist.Canonical.Cd.Check.Class.Classes.Close.Coercion.Coercions.CoFixpoint.CoInductive.Collection.Combined.Compute.Conjecture.Conjectures.Constant.constr.Constraint.Constructors.Context.Corollary.CreateHintDb.Cut.Declare.Defined.Definition.Delimit.Dependencies.Dependent.Derive.Drop.eauto.End.Equality.Eval.Example.Existential.Existentials.Existing.Export.exporting.Extern.Extract.Extraction.Fact.Field.Fields.File.Fixpoint.Focus.for.From.Function.Functional.Generalizable.Global.Goal.Grab.Grammar.Graph.Guarded.Heap.Hint.HintDb.Hints.Hypotheses.Hypothesis.ident.Identity.If.Immediate.Implicit.Import.Include.Inductive.Infix.Info.Initial.Inline.Inspect.Instance.Instances.Intro.Intros.Inversion.Inversion_clear.Language.Left.Lemma.Let.Libraries.Library.Load.LoadPath.Local.Locate.Ltac.ML.Mode.Module.Modules.Monomorphic.Morphism.Next.NoInline.Notation.Obligation.Obligations.Opaque.Open.Optimize.Options.Parameter.Parameters.Parametric.Path.Paths.pattern.Polymorphic.Preterm.Print.Printing.Program.Projections.Proof.Proposition.Pwd.Qed.Quit.Rec.Record.Recursive.Redirect.Relation.Remark.Remove.Require.Reserved.Reset.Resolve.Restart.Rewrite.Right.Ring.Rings.Save.Scheme.Scope.Scopes.Script.Search.SearchAbout.SearchHead.SearchPattern.SearchRewrite.Section.Separate.Set.Setoid.Show.Solve.Sorted.Step.Strategies.Strategy.Structure.SubClass.Table.Tables.Tactic.Term.Test.Theorem.Time.Timeout.Transparent.Type.Typeclasses.Types.Undelimit.Undo.Unfocus.Unfocused.Unfold.Universe.Universes.Unset.Unshelve.using.Variable.Variables.Variant.Verbose.Visibility.where.with`.split(`.`),
                    built_in: `abstract.absurd.admit.after.apply.as.assert.assumption.at.auto.autorewrite.autounfold.before.bottom.btauto.by.case.case_eq.cbn.cbv.change.classical_left.classical_right.clear.clearbody.cofix.compare.compute.congruence.constr_eq.constructor.contradict.contradiction.cut.cutrewrite.cycle.decide.decompose.dependent.destruct.destruction.dintuition.discriminate.discrR.do.double.dtauto.eapply.eassumption.eauto.ecase.econstructor.edestruct.ediscriminate.eelim.eexact.eexists.einduction.einjection.eleft.elim.elimtype.enough.equality.erewrite.eright.esimplify_eq.esplit.evar.exact.exactly_once.exfalso.exists.f_equal.fail.field.field_simplify.field_simplify_eq.first.firstorder.fix.fold.fourier.functional.generalize.generalizing.gfail.give_up.has_evar.hnf.idtac.in.induction.injection.instantiate.intro.intro_pattern.intros.intuition.inversion.inversion_clear.is_evar.is_var.lapply.lazy.left.lia.lra.move.native_compute.nia.nsatz.omega.once.pattern.pose.progress.proof.psatz.quote.record.red.refine.reflexivity.remember.rename.repeat.replace.revert.revgoals.rewrite.rewrite_strat.right.ring.ring_simplify.rtauto.set.setoid_reflexivity.setoid_replace.setoid_rewrite.setoid_symmetry.setoid_transitivity.shelve.shelve_unifiable.simpl.simple.simplify_eq.solve.specialize.split.split_Rabs.split_Rmult.stepl.stepr.subst.sum.swap.symmetry.tactic.tauto.time.timeout.top.transitivity.trivial.try.tryif.unfold.unify.until.using.vm_compute.with`.split(`.`)
                },
                contains: [
                    e.QUOTE_STRING_MODE,
                    e.COMMENT(`\\(\\*`, `\\*\\)`),
                    e.C_NUMBER_MODE,
                    {
                        className: `type`,
                        excludeBegin: !0,
                        begin: `\\|\\s*`,
                        end: `\\w+`
                    },
                    {
                        begin: /[-=]>/
                    }
                ]
            };
        }
        t.exports = n;
    }), V = o((e, t)=>{
        function n(e) {
            return {
                name: `Cach\xe9 Object Script`,
                case_insensitive: !0,
                aliases: [
                    `cls`
                ],
                keywords: `property parameter class classmethod clientmethod extends as break catch close continue do d|0 else elseif for goto halt hang h|0 if job j|0 kill k|0 lock l|0 merge new open quit q|0 read r|0 return set s|0 tcommit throw trollback try tstart use view while write w|0 xecute x|0 zkill znspace zn ztrap zwrite zw zzdump zzwrite print zbreak zinsert zload zprint zremove zsave zzprint mv mvcall mvcrt mvdim mvprint zquit zsync ascii`,
                contains: [
                    {
                        className: `number`,
                        begin: `\\b(\\d+(\\.\\d*)?|\\.\\d+)`,
                        relevance: 0
                    },
                    {
                        className: `string`,
                        variants: [
                            {
                                begin: `"`,
                                end: `"`,
                                contains: [
                                    {
                                        begin: `""`,
                                        relevance: 0
                                    }
                                ]
                            }
                        ]
                    },
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    {
                        className: `comment`,
                        begin: /;/,
                        end: `$`,
                        relevance: 0
                    },
                    {
                        className: `built_in`,
                        begin: /(?:\$\$?|\.\.)\^?[a-zA-Z]+/
                    },
                    {
                        className: `built_in`,
                        begin: /\$\$\$[a-zA-Z]+/
                    },
                    {
                        className: `built_in`,
                        begin: /%[a-z]+(?:\.[a-z]+)*/
                    },
                    {
                        className: `symbol`,
                        begin: /\^%?[a-zA-Z][\w]*/
                    },
                    {
                        className: `keyword`,
                        begin: /##class|##super|#define|#dim/
                    },
                    {
                        begin: /&sql\(/,
                        end: /\)/,
                        excludeBegin: !0,
                        excludeEnd: !0,
                        subLanguage: `sql`
                    },
                    {
                        begin: /&(js|jscript|javascript)</,
                        end: />/,
                        excludeBegin: !0,
                        excludeEnd: !0,
                        subLanguage: `javascript`
                    },
                    {
                        begin: /&html<\s*</,
                        end: />\s*>/,
                        subLanguage: `xml`
                    }
                ]
            };
        }
        t.exports = n;
    }), ne = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = e.COMMENT(`//`, `$`, {
                contains: [
                    {
                        begin: /\\\n/
                    }
                ]
            }), r = `decltype\\(auto\\)`, i = `[a-zA-Z_]\\w*::`, a = `(?!struct)(` + r + `|` + t.optional(i) + `[a-zA-Z_]\\w*` + t.optional(`<[^<>]+>`) + `)`, o = {
                className: `type`,
                begin: `\\b[a-z\\d_]*_t\\b`
            }, s = {
                className: `string`,
                variants: [
                    {
                        begin: `(u8?|U|L)?"`,
                        end: `"`,
                        illegal: `\\n`,
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ]
                    },
                    {
                        begin: `(u8?|U|L)?'(\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)|.)`,
                        end: `'`,
                        illegal: `.`
                    },
                    e.END_SAME_AS_BEGIN({
                        begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
                        end: /\)([^()\\ ]{0,16})"/
                    })
                ]
            }, c = {
                className: `number`,
                variants: [
                    {
                        begin: `[+-]?(?:(?:[0-9](?:'?[0-9])*\\.(?:[0-9](?:'?[0-9])*)?|\\.[0-9](?:'?[0-9])*)(?:[Ee][+-]?[0-9](?:'?[0-9])*)?|[0-9](?:'?[0-9])*[Ee][+-]?[0-9](?:'?[0-9])*|0[Xx](?:[0-9A-Fa-f](?:'?[0-9A-Fa-f])*(?:\\.(?:[0-9A-Fa-f](?:'?[0-9A-Fa-f])*)?)?|\\.[0-9A-Fa-f](?:'?[0-9A-Fa-f])*)[Pp][+-]?[0-9](?:'?[0-9])*)(?:[Ff](?:16|32|64|128)?|(BF|bf)16|[Ll]|)`
                    },
                    {
                        begin: `[+-]?\\b(?:0[Bb][01](?:'?[01])*|0[Xx][0-9A-Fa-f](?:'?[0-9A-Fa-f])*|0(?:'?[0-7])*|[1-9](?:'?[0-9])*)(?:[Uu](?:LL?|ll?)|[Uu][Zz]?|(?:LL?|ll?)[Uu]?|[Zz][Uu]|)`
                    }
                ],
                relevance: 0
            }, l = {
                className: `meta`,
                begin: /#\s*[a-z]+\b/,
                end: /$/,
                keywords: {
                    keyword: `if else elif endif define undef warning error line pragma _Pragma ifdef ifndef include`
                },
                contains: [
                    {
                        begin: /\\\n/,
                        relevance: 0
                    },
                    e.inherit(s, {
                        className: `string`
                    }),
                    {
                        className: `string`,
                        begin: /<.*?>/
                    },
                    n,
                    e.C_BLOCK_COMMENT_MODE
                ]
            }, u = {
                className: `title`,
                begin: t.optional(i) + e.IDENT_RE,
                relevance: 0
            }, d = t.optional(i) + e.IDENT_RE + `\\s*\\(`, f = `alignas.alignof.and.and_eq.asm.atomic_cancel.atomic_commit.atomic_noexcept.auto.bitand.bitor.break.case.catch.class.co_await.co_return.co_yield.compl.concept.const_cast|10.consteval.constexpr.constinit.continue.decltype.default.delete.do.dynamic_cast|10.else.enum.explicit.export.extern.false.final.for.friend.goto.if.import.inline.module.mutable.namespace.new.noexcept.not.not_eq.nullptr.operator.or.or_eq.override.private.protected.public.reflexpr.register.reinterpret_cast|10.requires.return.sizeof.static_assert.static_cast|10.struct.switch.synchronized.template.this.thread_local.throw.transaction_safe.transaction_safe_dynamic.true.try.typedef.typeid.typename.union.using.virtual.volatile.while.xor.xor_eq`.split(`.`), p = [
                `bool`,
                `char`,
                `char16_t`,
                `char32_t`,
                `char8_t`,
                `double`,
                `float`,
                `int`,
                `long`,
                `short`,
                `void`,
                `wchar_t`,
                `unsigned`,
                `signed`,
                `const`,
                `static`
            ], m = `any.auto_ptr.barrier.binary_semaphore.bitset.complex.condition_variable.condition_variable_any.counting_semaphore.deque.false_type.flat_map.flat_set.future.imaginary.initializer_list.istringstream.jthread.latch.lock_guard.multimap.multiset.mutex.optional.ostringstream.packaged_task.pair.promise.priority_queue.queue.recursive_mutex.recursive_timed_mutex.scoped_lock.set.shared_future.shared_lock.shared_mutex.shared_timed_mutex.shared_ptr.stack.string_view.stringstream.timed_mutex.thread.true_type.tuple.unique_lock.unique_ptr.unordered_map.unordered_multimap.unordered_multiset.unordered_set.variant.vector.weak_ptr.wstring.wstring_view`.split(`.`), h = `abort.abs.acos.apply.as_const.asin.atan.atan2.calloc.ceil.cerr.cin.clog.cos.cosh.cout.declval.endl.exchange.exit.exp.fabs.floor.fmod.forward.fprintf.fputs.free.frexp.fscanf.future.invoke.isalnum.isalpha.iscntrl.isdigit.isgraph.islower.isprint.ispunct.isspace.isupper.isxdigit.labs.launder.ldexp.log.log10.make_pair.make_shared.make_shared_for_overwrite.make_tuple.make_unique.malloc.memchr.memcmp.memcpy.memset.modf.move.pow.printf.putchar.puts.realloc.scanf.sin.sinh.snprintf.sprintf.sqrt.sscanf.std.stderr.stdin.stdout.strcat.strchr.strcmp.strcpy.strcspn.strlen.strncat.strncmp.strncpy.strpbrk.strrchr.strspn.strstr.swap.tan.tanh.terminate.to_underlying.tolower.toupper.vfprintf.visit.vprintf.vsprintf`.split(`.`), g = {
                type: p,
                keyword: f,
                literal: [
                    `NULL`,
                    `false`,
                    `nullopt`,
                    `nullptr`,
                    `true`
                ],
                built_in: [
                    `_Pragma`
                ],
                _type_hints: m
            }, _ = {
                className: `function.dispatch`,
                relevance: 0,
                keywords: {
                    _hint: h
                },
                begin: t.concat(/\b/, /(?!decltype)/, /(?!if)/, /(?!for)/, /(?!switch)/, /(?!while)/, e.IDENT_RE, t.lookahead(/(<[^<>]+>|)\s*\(/))
            }, v = [
                _,
                l,
                o,
                n,
                e.C_BLOCK_COMMENT_MODE,
                c,
                s
            ], y = {
                variants: [
                    {
                        begin: /=/,
                        end: /;/
                    },
                    {
                        begin: /\(/,
                        end: /\)/
                    },
                    {
                        beginKeywords: `new throw return else`,
                        end: /;/
                    }
                ],
                keywords: g,
                contains: v.concat([
                    {
                        begin: /\(/,
                        end: /\)/,
                        keywords: g,
                        contains: v.concat([
                            `self`
                        ]),
                        relevance: 0
                    }
                ]),
                relevance: 0
            }, b = {
                className: `function`,
                begin: `(` + a + `[\\*&\\s]+)+` + d,
                returnBegin: !0,
                end: /[{;=]/,
                excludeEnd: !0,
                keywords: g,
                illegal: /[^\w\s\*&:<>.]/,
                contains: [
                    {
                        begin: r,
                        keywords: g,
                        relevance: 0
                    },
                    {
                        begin: d,
                        returnBegin: !0,
                        contains: [
                            u
                        ],
                        relevance: 0
                    },
                    {
                        begin: /::/,
                        relevance: 0
                    },
                    {
                        begin: /:/,
                        endsWithParent: !0,
                        contains: [
                            s,
                            c
                        ]
                    },
                    {
                        relevance: 0,
                        match: /,/
                    },
                    {
                        className: `params`,
                        begin: /\(/,
                        end: /\)/,
                        keywords: g,
                        relevance: 0,
                        contains: [
                            n,
                            e.C_BLOCK_COMMENT_MODE,
                            s,
                            c,
                            o,
                            {
                                begin: /\(/,
                                end: /\)/,
                                keywords: g,
                                relevance: 0,
                                contains: [
                                    `self`,
                                    n,
                                    e.C_BLOCK_COMMENT_MODE,
                                    s,
                                    c,
                                    o
                                ]
                            }
                        ]
                    },
                    o,
                    n,
                    e.C_BLOCK_COMMENT_MODE,
                    l
                ]
            };
            return {
                name: `C++`,
                aliases: [
                    `cc`,
                    `c++`,
                    `h++`,
                    `hpp`,
                    `hh`,
                    `hxx`,
                    `cxx`
                ],
                keywords: g,
                illegal: `</`,
                classNameAliases: {
                    "function.dispatch": `built_in`
                },
                contains: [].concat(y, b, _, v, [
                    l,
                    {
                        begin: `\\b(deque|list|queue|priority_queue|pair|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array|tuple|optional|variant|function|flat_map|flat_set)\\s*<(?!<)`,
                        end: `>`,
                        keywords: g,
                        contains: [
                            `self`,
                            o
                        ]
                    },
                    {
                        begin: e.IDENT_RE + `::`,
                        keywords: g
                    },
                    {
                        match: [
                            /\b(?:enum(?:\s+(?:class|struct))?|class|struct|union)/,
                            /\s+/,
                            /\w+/
                        ],
                        className: {
                            1: `keyword`,
                            3: `title.class`
                        }
                    }
                ])
            };
        }
        t.exports = n;
    }), H = o((e, t)=>{
        function n(e) {
            let t = `group clone ms master location colocation order fencing_topology rsc_ticket acl_target acl_group user role tag xml`;
            return {
                name: `crmsh`,
                aliases: [
                    `crm`,
                    `pcmk`
                ],
                case_insensitive: !0,
                keywords: {
                    keyword: `params meta operations op rule attributes utilization read write deny defined not_defined in_range date spec in ref reference attribute type xpath version and or lt gt tag lte gte eq ne \\ number string`,
                    literal: `Master Started Slave Stopped start promote demote stop monitor true false`
                },
                contains: [
                    e.HASH_COMMENT_MODE,
                    {
                        beginKeywords: `node`,
                        starts: {
                            end: `\\s*([\\w_-]+:)?`,
                            starts: {
                                className: `title`,
                                end: `\\s*[\\$\\w_][\\w_-]*`
                            }
                        }
                    },
                    {
                        beginKeywords: `primitive rsc_template`,
                        starts: {
                            className: `title`,
                            end: `\\s*[\\$\\w_][\\w_-]*`,
                            starts: {
                                end: `\\s*@?[\\w_][\\w_\\.:-]*`
                            }
                        }
                    },
                    {
                        begin: `\\b(` + t.split(` `).join(`|`) + `)\\s+`,
                        keywords: t,
                        starts: {
                            className: `title`,
                            end: `[\\$\\w_][\\w_-]*`
                        }
                    },
                    {
                        beginKeywords: `property rsc_defaults op_defaults`,
                        starts: {
                            className: `title`,
                            end: `\\s*([\\w_-]+:)?`
                        }
                    },
                    e.QUOTE_STRING_MODE,
                    {
                        className: `meta`,
                        begin: `(ocf|systemd|service|lsb):[\\w_:-]+`,
                        relevance: 0
                    },
                    {
                        className: `number`,
                        begin: `\\b\\d+(\\.\\d+)?(ms|s|h|m)?`,
                        relevance: 0
                    },
                    {
                        className: `literal`,
                        begin: `[-]?(infinity|inf)`,
                        relevance: 0
                    },
                    {
                        className: `attr`,
                        begin: /([A-Za-z$_#][\w_-]+)=/,
                        relevance: 0
                    },
                    {
                        className: `tag`,
                        begin: `</?`,
                        end: `/?>`,
                        relevance: 0
                    }
                ]
            };
        }
        t.exports = n;
    }), U = o((e, t)=>{
        function n(e) {
            let t = `(_?[ui](8|16|32|64|128))?`, n = `[a-zA-Z_]\\w*[!?=]?|[-+~]@|<<|>>|[=!]~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~|]|//|//=|&[-+*]=?|&\\*\\*|\\[\\][=?]?`, r = `[A-Za-z_]\\w*(::\\w+)*(\\?|!)?`, i = {
                $pattern: `[a-zA-Z_]\\w*[!?=]?`,
                keyword: `abstract alias annotation as as? asm begin break case class def do else elsif end ensure enum extend for fun if include instance_sizeof is_a? lib macro module next nil? of out pointerof private protected rescue responds_to? return require select self sizeof struct super then type typeof union uninitialized unless until verbatim when while with yield __DIR__ __END_LINE__ __FILE__ __LINE__`,
                literal: `false nil true`
            }, a = {
                className: `subst`,
                begin: /#\{/,
                end: /\}/,
                keywords: i
            }, o = {
                className: `variable`,
                begin: `(\\$\\W)|((\\$|@@?)(\\w+))(?=[^@$?])(?![A-Za-z])(?![@$?'])`
            }, s = {
                className: `template-variable`,
                variants: [
                    {
                        begin: `\\{\\{`,
                        end: `\\}\\}`
                    },
                    {
                        begin: `\\{%`,
                        end: `%\\}`
                    }
                ],
                keywords: i
            };
            function c(e, t) {
                let n = [
                    {
                        begin: e,
                        end: t
                    }
                ];
                return n[0].contains = n, n;
            }
            let l = {
                className: `string`,
                contains: [
                    e.BACKSLASH_ESCAPE,
                    a
                ],
                variants: [
                    {
                        begin: /'/,
                        end: /'/
                    },
                    {
                        begin: /"/,
                        end: /"/
                    },
                    {
                        begin: /`/,
                        end: /`/
                    },
                    {
                        begin: `%[Qwi]?\\(`,
                        end: `\\)`,
                        contains: c(`\\(`, `\\)`)
                    },
                    {
                        begin: `%[Qwi]?\\[`,
                        end: `\\]`,
                        contains: c(`\\[`, `\\]`)
                    },
                    {
                        begin: `%[Qwi]?\\{`,
                        end: /\}/,
                        contains: c(/\{/, /\}/)
                    },
                    {
                        begin: `%[Qwi]?<`,
                        end: `>`,
                        contains: c(`<`, `>`)
                    },
                    {
                        begin: `%[Qwi]?\\|`,
                        end: `\\|`
                    },
                    {
                        begin: /<<-\w+$/,
                        end: /^\s*\w+$/
                    }
                ],
                relevance: 0
            }, u = {
                className: `string`,
                variants: [
                    {
                        begin: `%q\\(`,
                        end: `\\)`,
                        contains: c(`\\(`, `\\)`)
                    },
                    {
                        begin: `%q\\[`,
                        end: `\\]`,
                        contains: c(`\\[`, `\\]`)
                    },
                    {
                        begin: `%q\\{`,
                        end: /\}/,
                        contains: c(/\{/, /\}/)
                    },
                    {
                        begin: `%q<`,
                        end: `>`,
                        contains: c(`<`, `>`)
                    },
                    {
                        begin: `%q\\|`,
                        end: `\\|`
                    },
                    {
                        begin: /<<-'\w+'$/,
                        end: /^\s*\w+$/
                    }
                ],
                relevance: 0
            }, d = {
                begin: `(?!%\\})(` + e.RE_STARTERS_RE + `|\\n|\\b(case|if|select|unless|until|when|while)\\b)\\s*`,
                keywords: `case if select unless until when while`,
                contains: [
                    {
                        className: `regexp`,
                        contains: [
                            e.BACKSLASH_ESCAPE,
                            a
                        ],
                        variants: [
                            {
                                begin: `//[a-z]*`,
                                relevance: 0
                            },
                            {
                                begin: `/(?!\\/)`,
                                end: `/[a-z]*`
                            }
                        ]
                    }
                ],
                relevance: 0
            }, f = [
                s,
                l,
                u,
                {
                    className: `regexp`,
                    contains: [
                        e.BACKSLASH_ESCAPE,
                        a
                    ],
                    variants: [
                        {
                            begin: `%r\\(`,
                            end: `\\)`,
                            contains: c(`\\(`, `\\)`)
                        },
                        {
                            begin: `%r\\[`,
                            end: `\\]`,
                            contains: c(`\\[`, `\\]`)
                        },
                        {
                            begin: `%r\\{`,
                            end: /\}/,
                            contains: c(/\{/, /\}/)
                        },
                        {
                            begin: `%r<`,
                            end: `>`,
                            contains: c(`<`, `>`)
                        },
                        {
                            begin: `%r\\|`,
                            end: `\\|`
                        }
                    ],
                    relevance: 0
                },
                d,
                {
                    className: `meta`,
                    begin: `@\\[`,
                    end: `\\]`,
                    contains: [
                        e.inherit(e.QUOTE_STRING_MODE, {
                            className: `string`
                        })
                    ]
                },
                o,
                e.HASH_COMMENT_MODE,
                {
                    className: `class`,
                    beginKeywords: `class module struct`,
                    end: `$|;`,
                    illegal: /=/,
                    contains: [
                        e.HASH_COMMENT_MODE,
                        e.inherit(e.TITLE_MODE, {
                            begin: r
                        }),
                        {
                            begin: `<`
                        }
                    ]
                },
                {
                    className: `class`,
                    beginKeywords: `lib enum union`,
                    end: `$|;`,
                    illegal: /=/,
                    contains: [
                        e.HASH_COMMENT_MODE,
                        e.inherit(e.TITLE_MODE, {
                            begin: r
                        })
                    ]
                },
                {
                    beginKeywords: `annotation`,
                    end: `$|;`,
                    illegal: /=/,
                    contains: [
                        e.HASH_COMMENT_MODE,
                        e.inherit(e.TITLE_MODE, {
                            begin: r
                        })
                    ],
                    relevance: 2
                },
                {
                    className: `function`,
                    beginKeywords: `def`,
                    end: /\B\b/,
                    contains: [
                        e.inherit(e.TITLE_MODE, {
                            begin: n,
                            endsParent: !0
                        })
                    ]
                },
                {
                    className: `function`,
                    beginKeywords: `fun macro`,
                    end: /\B\b/,
                    contains: [
                        e.inherit(e.TITLE_MODE, {
                            begin: n,
                            endsParent: !0
                        })
                    ],
                    relevance: 2
                },
                {
                    className: `symbol`,
                    begin: e.UNDERSCORE_IDENT_RE + `(!|\\?)?:`,
                    relevance: 0
                },
                {
                    className: `symbol`,
                    begin: `:`,
                    contains: [
                        l,
                        {
                            begin: n
                        }
                    ],
                    relevance: 0
                },
                {
                    className: `number`,
                    variants: [
                        {
                            begin: `\\b0b([01_]+)` + t
                        },
                        {
                            begin: `\\b0o([0-7_]+)` + t
                        },
                        {
                            begin: `\\b0x([A-Fa-f0-9_]+)` + t
                        },
                        {
                            begin: `\\b([1-9][0-9_]*[0-9]|[0-9])(\\.[0-9][0-9_]*)?([eE]_?[-+]?[0-9_]*)?(_?f(32|64))?(?!_)`
                        },
                        {
                            begin: `\\b([1-9][0-9_]*|0)` + t
                        }
                    ],
                    relevance: 0
                }
            ];
            return a.contains = f, s.contains = f.slice(1), {
                name: `Crystal`,
                aliases: [
                    `cr`
                ],
                keywords: i,
                contains: f
            };
        }
        t.exports = n;
    }), W = o((e, t)=>{
        function n(e) {
            let t = [
                `bool`,
                `byte`,
                `char`,
                `decimal`,
                `delegate`,
                `double`,
                `dynamic`,
                `enum`,
                `float`,
                `int`,
                `long`,
                `nint`,
                `nuint`,
                `object`,
                `sbyte`,
                `short`,
                `string`,
                `ulong`,
                `uint`,
                `ushort`
            ], n = [
                `public`,
                `private`,
                `protected`,
                `static`,
                `internal`,
                `protected`,
                `abstract`,
                `async`,
                `extern`,
                `override`,
                `unsafe`,
                `virtual`,
                `new`,
                `sealed`,
                `partial`
            ], r = {
                keyword: `abstract.as.base.break.case.catch.class.const.continue.do.else.event.explicit.extern.finally.fixed.for.foreach.goto.if.implicit.in.interface.internal.is.lock.namespace.new.operator.out.override.params.private.protected.public.readonly.record.ref.return.scoped.sealed.sizeof.stackalloc.static.struct.switch.this.throw.try.typeof.unchecked.unsafe.using.virtual.void.volatile.while`.split(`.`).concat(`add.alias.and.ascending.args.async.await.by.descending.dynamic.equals.file.from.get.global.group.init.into.join.let.nameof.not.notnull.on.or.orderby.partial.record.remove.required.scoped.select.set.unmanaged.value|0.var.when.where.with.yield`.split(`.`)),
                built_in: t,
                literal: [
                    `default`,
                    `false`,
                    `null`,
                    `true`
                ]
            }, i = e.inherit(e.TITLE_MODE, {
                begin: `[a-zA-Z](\\.?\\w)*`
            }), a = {
                className: `number`,
                variants: [
                    {
                        begin: `\\b(0b[01']+)`
                    },
                    {
                        begin: `(-?)\\b([\\d']+(\\.[\\d']*)?|\\.[\\d']+)(u|U|l|L|ul|UL|f|F|b|B)`
                    },
                    {
                        begin: `(-?)(\\b0[xX][a-fA-F0-9']+|(\\b[\\d']+(\\.[\\d']*)?|\\.[\\d']+)([eE][-+]?[\\d']+)?)`
                    }
                ],
                relevance: 0
            }, o = {
                className: `string`,
                begin: /"""("*)(?!")(.|\n)*?"""\1/,
                relevance: 1
            }, s = {
                className: `string`,
                begin: `@"`,
                end: `"`,
                contains: [
                    {
                        begin: `""`
                    }
                ]
            }, c = e.inherit(s, {
                illegal: /\n/
            }), l = {
                className: `subst`,
                begin: /\{/,
                end: /\}/,
                keywords: r
            }, u = e.inherit(l, {
                illegal: /\n/
            }), d = {
                className: `string`,
                begin: /\$"/,
                end: `"`,
                illegal: /\n/,
                contains: [
                    {
                        begin: /\{\{/
                    },
                    {
                        begin: /\}\}/
                    },
                    e.BACKSLASH_ESCAPE,
                    u
                ]
            }, f = {
                className: `string`,
                begin: /\$@"/,
                end: `"`,
                contains: [
                    {
                        begin: /\{\{/
                    },
                    {
                        begin: /\}\}/
                    },
                    {
                        begin: `""`
                    },
                    l
                ]
            }, p = e.inherit(f, {
                illegal: /\n/,
                contains: [
                    {
                        begin: /\{\{/
                    },
                    {
                        begin: /\}\}/
                    },
                    {
                        begin: `""`
                    },
                    u
                ]
            });
            l.contains = [
                f,
                d,
                s,
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE,
                a,
                e.C_BLOCK_COMMENT_MODE
            ], u.contains = [
                p,
                d,
                c,
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE,
                a,
                e.inherit(e.C_BLOCK_COMMENT_MODE, {
                    illegal: /\n/
                })
            ];
            let m = {
                variants: [
                    o,
                    f,
                    d,
                    s,
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE
                ]
            }, h = {
                begin: `<`,
                end: `>`,
                contains: [
                    {
                        beginKeywords: `in out`
                    },
                    i
                ]
            }, g = e.IDENT_RE + `(<` + e.IDENT_RE + `(\\s*,\\s*` + e.IDENT_RE + `)*>)?(\\[\\])?`, _ = {
                begin: `@` + e.IDENT_RE,
                relevance: 0
            };
            return {
                name: `C#`,
                aliases: [
                    `cs`,
                    `c#`
                ],
                keywords: r,
                illegal: /::/,
                contains: [
                    e.COMMENT(`///`, `$`, {
                        returnBegin: !0,
                        contains: [
                            {
                                className: `doctag`,
                                variants: [
                                    {
                                        begin: `///`,
                                        relevance: 0
                                    },
                                    {
                                        begin: `<!--|-->`
                                    },
                                    {
                                        begin: `</?`,
                                        end: `>`
                                    }
                                ]
                            }
                        ]
                    }),
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    {
                        className: `meta`,
                        begin: `#`,
                        end: `$`,
                        keywords: {
                            keyword: `if else elif endif define undef warning error line region endregion pragma checksum`
                        }
                    },
                    m,
                    a,
                    {
                        beginKeywords: `class interface`,
                        relevance: 0,
                        end: /[{;=]/,
                        illegal: /[^\s:,]/,
                        contains: [
                            {
                                beginKeywords: `where class`
                            },
                            i,
                            h,
                            e.C_LINE_COMMENT_MODE,
                            e.C_BLOCK_COMMENT_MODE
                        ]
                    },
                    {
                        beginKeywords: `namespace`,
                        relevance: 0,
                        end: /[{;=]/,
                        illegal: /[^\s:]/,
                        contains: [
                            i,
                            e.C_LINE_COMMENT_MODE,
                            e.C_BLOCK_COMMENT_MODE
                        ]
                    },
                    {
                        beginKeywords: `record`,
                        relevance: 0,
                        end: /[{;=]/,
                        illegal: /[^\s:]/,
                        contains: [
                            i,
                            h,
                            e.C_LINE_COMMENT_MODE,
                            e.C_BLOCK_COMMENT_MODE
                        ]
                    },
                    {
                        className: `meta`,
                        begin: `^\\s*\\[(?=[\\w])`,
                        excludeBegin: !0,
                        end: `\\]`,
                        excludeEnd: !0,
                        contains: [
                            {
                                className: `string`,
                                begin: /"/,
                                end: /"/
                            }
                        ]
                    },
                    {
                        beginKeywords: `new return throw await else`,
                        relevance: 0
                    },
                    {
                        className: `function`,
                        begin: `(` + g + `\\s+)+` + e.IDENT_RE + `\\s*(<[^=]+>\\s*)?\\(`,
                        returnBegin: !0,
                        end: /\s*[{;=]/,
                        excludeEnd: !0,
                        keywords: r,
                        contains: [
                            {
                                beginKeywords: n.join(` `),
                                relevance: 0
                            },
                            {
                                begin: e.IDENT_RE + `\\s*(<[^=]+>\\s*)?\\(`,
                                returnBegin: !0,
                                contains: [
                                    e.TITLE_MODE,
                                    h
                                ],
                                relevance: 0
                            },
                            {
                                match: /\(\)/
                            },
                            {
                                className: `params`,
                                begin: /\(/,
                                end: /\)/,
                                excludeBegin: !0,
                                excludeEnd: !0,
                                keywords: r,
                                relevance: 0,
                                contains: [
                                    m,
                                    a,
                                    e.C_BLOCK_COMMENT_MODE
                                ]
                            },
                            e.C_LINE_COMMENT_MODE,
                            e.C_BLOCK_COMMENT_MODE
                        ]
                    },
                    _
                ]
            };
        }
        t.exports = n;
    }), G = o((e, t)=>{
        function n(e) {
            return {
                name: `CSP`,
                case_insensitive: !1,
                keywords: {
                    $pattern: `[a-zA-Z][a-zA-Z0-9_-]*`,
                    keyword: [
                        `base-uri`,
                        `child-src`,
                        `connect-src`,
                        `default-src`,
                        `font-src`,
                        `form-action`,
                        `frame-ancestors`,
                        `frame-src`,
                        `img-src`,
                        `manifest-src`,
                        `media-src`,
                        `object-src`,
                        `plugin-types`,
                        `report-uri`,
                        `sandbox`,
                        `script-src`,
                        `style-src`,
                        `trusted-types`,
                        `unsafe-hashes`,
                        `worker-src`
                    ]
                },
                contains: [
                    {
                        className: `string`,
                        begin: `'`,
                        end: `'`
                    },
                    {
                        className: `attribute`,
                        begin: `^Content`,
                        end: `:`,
                        excludeEnd: !0
                    }
                ]
            };
        }
        t.exports = n;
    }), re = o((e, t)=>{
        var n = (e)=>({
                IMPORTANT: {
                    scope: `meta`,
                    begin: `!important`
                },
                BLOCK_COMMENT: e.C_BLOCK_COMMENT_MODE,
                HEXCOLOR: {
                    scope: `number`,
                    begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/
                },
                FUNCTION_DISPATCH: {
                    className: `built_in`,
                    begin: /[\w-]+(?=\()/
                },
                ATTRIBUTE_SELECTOR_MODE: {
                    scope: `selector-attr`,
                    begin: /\[/,
                    end: /\]/,
                    illegal: `$`,
                    contains: [
                        e.APOS_STRING_MODE,
                        e.QUOTE_STRING_MODE
                    ]
                },
                CSS_NUMBER_MODE: {
                    scope: `number`,
                    begin: e.NUMBER_RE + `(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?`,
                    relevance: 0
                },
                CSS_VARIABLE: {
                    className: `attr`,
                    begin: /--[A-Za-z_][A-Za-z0-9_-]*/
                }
            }), r = `a.abbr.address.article.aside.audio.b.blockquote.body.button.canvas.caption.cite.code.dd.del.details.dfn.div.dl.dt.em.fieldset.figcaption.figure.footer.form.h1.h2.h3.h4.h5.h6.header.hgroup.html.i.iframe.img.input.ins.kbd.label.legend.li.main.mark.menu.nav.object.ol.optgroup.option.p.picture.q.quote.samp.section.select.source.span.strong.summary.sup.table.tbody.td.textarea.tfoot.th.thead.time.tr.ul.var.video`.split(`.`), i = `defs.g.marker.mask.pattern.svg.switch.symbol.feBlend.feColorMatrix.feComponentTransfer.feComposite.feConvolveMatrix.feDiffuseLighting.feDisplacementMap.feFlood.feGaussianBlur.feImage.feMerge.feMorphology.feOffset.feSpecularLighting.feTile.feTurbulence.linearGradient.radialGradient.stop.circle.ellipse.image.line.path.polygon.polyline.rect.text.use.textPath.tspan.foreignObject.clipPath`.split(`.`), a = [
            ...r,
            ...i
        ], o = `any-hover.any-pointer.aspect-ratio.color.color-gamut.color-index.device-aspect-ratio.device-height.device-width.display-mode.forced-colors.grid.height.hover.inverted-colors.monochrome.orientation.overflow-block.overflow-inline.pointer.prefers-color-scheme.prefers-contrast.prefers-reduced-motion.prefers-reduced-transparency.resolution.scan.scripting.update.width.min-width.max-width.min-height.max-height`.split(`.`).sort().reverse(), s = `active.any-link.blank.checked.current.default.defined.dir.disabled.drop.empty.enabled.first.first-child.first-of-type.fullscreen.future.focus.focus-visible.focus-within.has.host.host-context.hover.indeterminate.in-range.invalid.is.lang.last-child.last-of-type.left.link.local-link.not.nth-child.nth-col.nth-last-child.nth-last-col.nth-last-of-type.nth-of-type.only-child.only-of-type.optional.out-of-range.past.placeholder-shown.read-only.read-write.required.right.root.scope.target.target-within.user-invalid.valid.visited.where`.split(`.`).sort().reverse(), c = [
            `after`,
            `backdrop`,
            `before`,
            `cue`,
            `cue-region`,
            `first-letter`,
            `first-line`,
            `grammar-error`,
            `marker`,
            `part`,
            `placeholder`,
            `selection`,
            `slotted`,
            `spelling-error`
        ].sort().reverse(), l = `accent-color.align-content.align-items.align-self.alignment-baseline.all.anchor-name.animation.animation-composition.animation-delay.animation-direction.animation-duration.animation-fill-mode.animation-iteration-count.animation-name.animation-play-state.animation-range.animation-range-end.animation-range-start.animation-timeline.animation-timing-function.appearance.aspect-ratio.backdrop-filter.backface-visibility.background.background-attachment.background-blend-mode.background-clip.background-color.background-image.background-origin.background-position.background-position-x.background-position-y.background-repeat.background-size.baseline-shift.block-size.border.border-block.border-block-color.border-block-end.border-block-end-color.border-block-end-style.border-block-end-width.border-block-start.border-block-start-color.border-block-start-style.border-block-start-width.border-block-style.border-block-width.border-bottom.border-bottom-color.border-bottom-left-radius.border-bottom-right-radius.border-bottom-style.border-bottom-width.border-collapse.border-color.border-end-end-radius.border-end-start-radius.border-image.border-image-outset.border-image-repeat.border-image-slice.border-image-source.border-image-width.border-inline.border-inline-color.border-inline-end.border-inline-end-color.border-inline-end-style.border-inline-end-width.border-inline-start.border-inline-start-color.border-inline-start-style.border-inline-start-width.border-inline-style.border-inline-width.border-left.border-left-color.border-left-style.border-left-width.border-radius.border-right.border-right-color.border-right-style.border-right-width.border-spacing.border-start-end-radius.border-start-start-radius.border-style.border-top.border-top-color.border-top-left-radius.border-top-right-radius.border-top-style.border-top-width.border-width.bottom.box-align.box-decoration-break.box-direction.box-flex.box-flex-group.box-lines.box-ordinal-group.box-orient.box-pack.box-shadow.box-sizing.break-after.break-before.break-inside.caption-side.caret-color.clear.clip.clip-path.clip-rule.color.color-interpolation.color-interpolation-filters.color-profile.color-rendering.color-scheme.column-count.column-fill.column-gap.column-rule.column-rule-color.column-rule-style.column-rule-width.column-span.column-width.columns.contain.contain-intrinsic-block-size.contain-intrinsic-height.contain-intrinsic-inline-size.contain-intrinsic-size.contain-intrinsic-width.container.container-name.container-type.content.content-visibility.counter-increment.counter-reset.counter-set.cue.cue-after.cue-before.cursor.cx.cy.direction.display.dominant-baseline.empty-cells.enable-background.field-sizing.fill.fill-opacity.fill-rule.filter.flex.flex-basis.flex-direction.flex-flow.flex-grow.flex-shrink.flex-wrap.float.flood-color.flood-opacity.flow.font.font-display.font-family.font-feature-settings.font-kerning.font-language-override.font-optical-sizing.font-palette.font-size.font-size-adjust.font-smooth.font-smoothing.font-stretch.font-style.font-synthesis.font-synthesis-position.font-synthesis-small-caps.font-synthesis-style.font-synthesis-weight.font-variant.font-variant-alternates.font-variant-caps.font-variant-east-asian.font-variant-emoji.font-variant-ligatures.font-variant-numeric.font-variant-position.font-variation-settings.font-weight.forced-color-adjust.gap.glyph-orientation-horizontal.glyph-orientation-vertical.grid.grid-area.grid-auto-columns.grid-auto-flow.grid-auto-rows.grid-column.grid-column-end.grid-column-start.grid-gap.grid-row.grid-row-end.grid-row-start.grid-template.grid-template-areas.grid-template-columns.grid-template-rows.hanging-punctuation.height.hyphenate-character.hyphenate-limit-chars.hyphens.icon.image-orientation.image-rendering.image-resolution.ime-mode.initial-letter.initial-letter-align.inline-size.inset.inset-area.inset-block.inset-block-end.inset-block-start.inset-inline.inset-inline-end.inset-inline-start.isolation.justify-content.justify-items.justify-self.kerning.left.letter-spacing.lighting-color.line-break.line-height.line-height-step.list-style.list-style-image.list-style-position.list-style-type.margin.margin-block.margin-block-end.margin-block-start.margin-bottom.margin-inline.margin-inline-end.margin-inline-start.margin-left.margin-right.margin-top.margin-trim.marker.marker-end.marker-mid.marker-start.marks.mask.mask-border.mask-border-mode.mask-border-outset.mask-border-repeat.mask-border-slice.mask-border-source.mask-border-width.mask-clip.mask-composite.mask-image.mask-mode.mask-origin.mask-position.mask-repeat.mask-size.mask-type.masonry-auto-flow.math-depth.math-shift.math-style.max-block-size.max-height.max-inline-size.max-width.min-block-size.min-height.min-inline-size.min-width.mix-blend-mode.nav-down.nav-index.nav-left.nav-right.nav-up.none.normal.object-fit.object-position.offset.offset-anchor.offset-distance.offset-path.offset-position.offset-rotate.opacity.order.orphans.outline.outline-color.outline-offset.outline-style.outline-width.overflow.overflow-anchor.overflow-block.overflow-clip-margin.overflow-inline.overflow-wrap.overflow-x.overflow-y.overlay.overscroll-behavior.overscroll-behavior-block.overscroll-behavior-inline.overscroll-behavior-x.overscroll-behavior-y.padding.padding-block.padding-block-end.padding-block-start.padding-bottom.padding-inline.padding-inline-end.padding-inline-start.padding-left.padding-right.padding-top.page.page-break-after.page-break-before.page-break-inside.paint-order.pause.pause-after.pause-before.perspective.perspective-origin.place-content.place-items.place-self.pointer-events.position.position-anchor.position-visibility.print-color-adjust.quotes.r.resize.rest.rest-after.rest-before.right.rotate.row-gap.ruby-align.ruby-position.scale.scroll-behavior.scroll-margin.scroll-margin-block.scroll-margin-block-end.scroll-margin-block-start.scroll-margin-bottom.scroll-margin-inline.scroll-margin-inline-end.scroll-margin-inline-start.scroll-margin-left.scroll-margin-right.scroll-margin-top.scroll-padding.scroll-padding-block.scroll-padding-block-end.scroll-padding-block-start.scroll-padding-bottom.scroll-padding-inline.scroll-padding-inline-end.scroll-padding-inline-start.scroll-padding-left.scroll-padding-right.scroll-padding-top.scroll-snap-align.scroll-snap-stop.scroll-snap-type.scroll-timeline.scroll-timeline-axis.scroll-timeline-name.scrollbar-color.scrollbar-gutter.scrollbar-width.shape-image-threshold.shape-margin.shape-outside.shape-rendering.speak.speak-as.src.stop-color.stop-opacity.stroke.stroke-dasharray.stroke-dashoffset.stroke-linecap.stroke-linejoin.stroke-miterlimit.stroke-opacity.stroke-width.tab-size.table-layout.text-align.text-align-all.text-align-last.text-anchor.text-combine-upright.text-decoration.text-decoration-color.text-decoration-line.text-decoration-skip.text-decoration-skip-ink.text-decoration-style.text-decoration-thickness.text-emphasis.text-emphasis-color.text-emphasis-position.text-emphasis-style.text-indent.text-justify.text-orientation.text-overflow.text-rendering.text-shadow.text-size-adjust.text-transform.text-underline-offset.text-underline-position.text-wrap.text-wrap-mode.text-wrap-style.timeline-scope.top.touch-action.transform.transform-box.transform-origin.transform-style.transition.transition-behavior.transition-delay.transition-duration.transition-property.transition-timing-function.translate.unicode-bidi.user-modify.user-select.vector-effect.vertical-align.view-timeline.view-timeline-axis.view-timeline-inset.view-timeline-name.view-transition-name.visibility.voice-balance.voice-duration.voice-family.voice-pitch.voice-range.voice-rate.voice-stress.voice-volume.white-space.white-space-collapse.widows.width.will-change.word-break.word-spacing.word-wrap.writing-mode.x.y.z-index.zoom`.split(`.`).sort().reverse();
        function u(e) {
            let t = e.regex, r = n(e), i = {
                begin: /-(webkit|moz|ms|o)-(?=[a-z])/
            }, u = /@-?\w[\w]*(-\w+)*/, d = [
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE
            ];
            return {
                name: `CSS`,
                case_insensitive: !0,
                illegal: /[=|'\$]/,
                keywords: {
                    keyframePosition: `from to`
                },
                classNameAliases: {
                    keyframePosition: `selector-tag`
                },
                contains: [
                    r.BLOCK_COMMENT,
                    i,
                    r.CSS_NUMBER_MODE,
                    {
                        className: `selector-id`,
                        begin: /#[A-Za-z0-9_-]+/,
                        relevance: 0
                    },
                    {
                        className: `selector-class`,
                        begin: `\\.[a-zA-Z-][a-zA-Z0-9_-]*`,
                        relevance: 0
                    },
                    r.ATTRIBUTE_SELECTOR_MODE,
                    {
                        className: `selector-pseudo`,
                        variants: [
                            {
                                begin: `:(` + s.join(`|`) + `)`
                            },
                            {
                                begin: `:(:)?(` + c.join(`|`) + `)`
                            }
                        ]
                    },
                    r.CSS_VARIABLE,
                    {
                        className: `attribute`,
                        begin: `\\b(` + l.join(`|`) + `)\\b`
                    },
                    {
                        begin: /:/,
                        end: /[;}{]/,
                        contains: [
                            r.BLOCK_COMMENT,
                            r.HEXCOLOR,
                            r.IMPORTANT,
                            r.CSS_NUMBER_MODE,
                            ...d,
                            {
                                begin: /(url|data-uri)\(/,
                                end: /\)/,
                                relevance: 0,
                                keywords: {
                                    built_in: `url data-uri`
                                },
                                contains: [
                                    ...d,
                                    {
                                        className: `string`,
                                        begin: /[^)]/,
                                        endsWithParent: !0,
                                        excludeEnd: !0
                                    }
                                ]
                            },
                            r.FUNCTION_DISPATCH
                        ]
                    },
                    {
                        begin: t.lookahead(/@/),
                        end: `[{;]`,
                        relevance: 0,
                        illegal: /:/,
                        contains: [
                            {
                                className: `keyword`,
                                begin: u
                            },
                            {
                                begin: /\s/,
                                endsWithParent: !0,
                                excludeEnd: !0,
                                relevance: 0,
                                keywords: {
                                    $pattern: /[a-z-]+/,
                                    keyword: `and or not only`,
                                    attribute: o.join(` `)
                                },
                                contains: [
                                    {
                                        begin: /[a-z-]+(?=:)/,
                                        className: `attribute`
                                    },
                                    ...d,
                                    r.CSS_NUMBER_MODE
                                ]
                            }
                        ]
                    },
                    {
                        className: `selector-tag`,
                        begin: `\\b(` + a.join(`|`) + `)\\b`
                    }
                ]
            };
        }
        t.exports = u;
    }), ie = o((e, t)=>{
        function n(e) {
            let t = {
                $pattern: e.UNDERSCORE_IDENT_RE,
                keyword: `abstract alias align asm assert auto body break byte case cast catch class const continue debug default delete deprecated do else enum export extern final finally for foreach foreach_reverse|10 goto if immutable import in inout int interface invariant is lazy macro mixin module new nothrow out override package pragma private protected public pure ref return scope shared static struct super switch synchronized template this throw try typedef typeid typeof union unittest version void volatile while with __FILE__ __LINE__ __gshared|10 __thread __traits __DATE__ __EOF__ __TIME__ __TIMESTAMP__ __VENDOR__ __VERSION__`,
                built_in: `bool cdouble cent cfloat char creal dchar delegate double dstring float function idouble ifloat ireal long real short string ubyte ucent uint ulong ushort wchar wstring`,
                literal: `false null true`
            }, n = `(0|[1-9][\\d_]*|\\d[\\d_]*|[\\d_]+?\\d)`, r = `([\\da-fA-F][\\da-fA-F_]*|_[\\da-fA-F][\\da-fA-F_]*)`;
            r, n, n, r;
            let i = `\\\\(['"\\?\\\\abfnrtv]|u[\\dA-Fa-f]{4}|[0-7]{1,3}|x[\\dA-Fa-f]{2}|U[\\dA-Fa-f]{8})|&[a-zA-Z\\d]{2,};`, a = {
                className: `number`,
                begin: `\\b((0|[1-9][\\d_]*)|0[bB][01_]+|0[xX]([\\da-fA-F][\\da-fA-F_]*|_[\\da-fA-F][\\da-fA-F_]*))(L|u|U|Lu|LU|uL|UL)?`,
                relevance: 0
            }, o = {
                className: `number`,
                begin: `\\b(((0[xX](([\\da-fA-F][\\da-fA-F_]*|_[\\da-fA-F][\\da-fA-F_]*)\\.([\\da-fA-F][\\da-fA-F_]*|_[\\da-fA-F][\\da-fA-F_]*)|\\.?([\\da-fA-F][\\da-fA-F_]*|_[\\da-fA-F][\\da-fA-F_]*))[pP][+-]?(0|[1-9][\\d_]*|\\d[\\d_]*|[\\d_]+?\\d))|((0|[1-9][\\d_]*|\\d[\\d_]*|[\\d_]+?\\d)(\\.\\d*|([eE][+-]?(0|[1-9][\\d_]*|\\d[\\d_]*|[\\d_]+?\\d)))|\\d+\\.(0|[1-9][\\d_]*|\\d[\\d_]*|[\\d_]+?\\d)|\\.(0|[1-9][\\d_]*)([eE][+-]?(0|[1-9][\\d_]*|\\d[\\d_]*|[\\d_]+?\\d))?))([fF]|L|i|[fF]i|Li)?|((0|[1-9][\\d_]*)|0[bB][01_]+|0[xX]([\\da-fA-F][\\da-fA-F_]*|_[\\da-fA-F][\\da-fA-F_]*))(i|[fF]i|Li))`,
                relevance: 0
            }, s = {
                className: `string`,
                begin: `'(` + i + `|.)`,
                end: `'`,
                illegal: `.`
            }, c = {
                className: `string`,
                begin: `"`,
                contains: [
                    {
                        begin: i,
                        relevance: 0
                    }
                ],
                end: `"[cwd]?`
            }, l = {
                className: `string`,
                begin: `[rq]"`,
                end: `"[cwd]?`,
                relevance: 5
            }, u = {
                className: `string`,
                begin: "`",
                end: "`[cwd]?"
            }, d = {
                className: `string`,
                begin: `x"[\\da-fA-F\\s\\n\\r]*"[cwd]?`,
                relevance: 10
            }, f = {
                className: `string`,
                begin: `q"\\{`,
                end: `\\}"`
            }, p = {
                className: `meta`,
                begin: `^#!`,
                end: `$`,
                relevance: 5
            }, m = {
                className: `meta`,
                begin: `#(line)`,
                end: `$`,
                relevance: 5
            }, h = {
                className: `keyword`,
                begin: `@[a-zA-Z_][a-zA-Z_\\d]*`
            }, g = e.COMMENT(`\\/\\+`, `\\+\\/`, {
                contains: [
                    `self`
                ],
                relevance: 10
            });
            return {
                name: `D`,
                keywords: t,
                contains: [
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    g,
                    d,
                    c,
                    l,
                    u,
                    f,
                    o,
                    a,
                    s,
                    p,
                    m,
                    h
                ]
            };
        }
        t.exports = n;
    }), K = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = {
                begin: /<\/?[A-Za-z_]/,
                end: `>`,
                subLanguage: `xml`,
                relevance: 0
            }, r = {
                begin: `^[-\\*]{3,}`,
                end: `$`
            }, i = {
                className: `code`,
                variants: [
                    {
                        begin: "(`{3,})[^`](.|\\n)*?\\1`*[ ]*"
                    },
                    {
                        begin: `(~{3,})[^~](.|\\n)*?\\1~*[ ]*`
                    },
                    {
                        begin: "```",
                        end: "```+[ ]*$"
                    },
                    {
                        begin: `~~~`,
                        end: `~~~+[ ]*$`
                    },
                    {
                        begin: "`.+?`"
                    },
                    {
                        begin: `(?=^( {4}|\\t))`,
                        contains: [
                            {
                                begin: `^( {4}|\\t)`,
                                end: `(\\n)$`
                            }
                        ],
                        relevance: 0
                    }
                ]
            }, a = {
                className: `bullet`,
                begin: `^[ 	]*([*+-]|(\\d+\\.))(?=\\s+)`,
                end: `\\s+`,
                excludeEnd: !0
            }, o = {
                begin: /^\[[^\n]+\]:/,
                returnBegin: !0,
                contains: [
                    {
                        className: `symbol`,
                        begin: /\[/,
                        end: /\]/,
                        excludeBegin: !0,
                        excludeEnd: !0
                    },
                    {
                        className: `link`,
                        begin: /:\s*/,
                        end: /$/,
                        excludeBegin: !0
                    }
                ]
            }, s = {
                variants: [
                    {
                        begin: /\[.+?\]\[.*?\]/,
                        relevance: 0
                    },
                    {
                        begin: /\[.+?\]\(((data|javascript|mailto):|(?:http|ftp)s?:\/\/).*?\)/,
                        relevance: 2
                    },
                    {
                        begin: t.concat(/\[.+?\]\(/, /[A-Za-z][A-Za-z0-9+.-]*/, /:\/\/.*?\)/),
                        relevance: 2
                    },
                    {
                        begin: /\[.+?\]\([./?&#].*?\)/,
                        relevance: 1
                    },
                    {
                        begin: /\[.*?\]\(.*?\)/,
                        relevance: 0
                    }
                ],
                returnBegin: !0,
                contains: [
                    {
                        match: /\[(?=\])/
                    },
                    {
                        className: `string`,
                        relevance: 0,
                        begin: `\\[`,
                        end: `\\]`,
                        excludeBegin: !0,
                        returnEnd: !0
                    },
                    {
                        className: `link`,
                        relevance: 0,
                        begin: `\\]\\(`,
                        end: `\\)`,
                        excludeBegin: !0,
                        excludeEnd: !0
                    },
                    {
                        className: `symbol`,
                        relevance: 0,
                        begin: `\\]\\[`,
                        end: `\\]`,
                        excludeBegin: !0,
                        excludeEnd: !0
                    }
                ]
            }, c = {
                className: `strong`,
                contains: [],
                variants: [
                    {
                        begin: /_{2}(?!\s)/,
                        end: /_{2}/
                    },
                    {
                        begin: /\*{2}(?!\s)/,
                        end: /\*{2}/
                    }
                ]
            }, l = {
                className: `emphasis`,
                contains: [],
                variants: [
                    {
                        begin: /\*(?![*\s])/,
                        end: /\*/
                    },
                    {
                        begin: /_(?![_\s])/,
                        end: /_/,
                        relevance: 0
                    }
                ]
            }, u = e.inherit(c, {
                contains: []
            }), d = e.inherit(l, {
                contains: []
            });
            c.contains.push(d), l.contains.push(u);
            let f = [
                n,
                s
            ];
            return [
                c,
                l,
                u,
                d
            ].forEach((e)=>{
                e.contains = e.contains.concat(f);
            }), f = f.concat(c, l), {
                name: `Markdown`,
                aliases: [
                    `md`,
                    `mkdown`,
                    `mkd`
                ],
                contains: [
                    {
                        className: `section`,
                        variants: [
                            {
                                begin: `^#{1,6}`,
                                end: `$`,
                                contains: f
                            },
                            {
                                begin: `(?=^.+?\\n[=-]{2,}$)`,
                                contains: [
                                    {
                                        begin: `^[=-]*$`
                                    },
                                    {
                                        begin: `^`,
                                        end: `\\n`,
                                        contains: f
                                    }
                                ]
                            }
                        ]
                    },
                    n,
                    a,
                    c,
                    l,
                    {
                        className: `quote`,
                        begin: `^>\\s+`,
                        contains: f,
                        end: `$`
                    },
                    i,
                    r,
                    s,
                    o,
                    {
                        scope: `literal`,
                        match: /&([a-zA-Z0-9]+|#[0-9]{1,7}|#[Xx][0-9a-fA-F]{1,6});/
                    }
                ]
            };
        }
        t.exports = n;
    }), ae = o((e, t)=>{
        function n(e) {
            let t = {
                className: `subst`,
                variants: [
                    {
                        begin: `\\$[A-Za-z0-9_]+`
                    }
                ]
            }, n = {
                className: `subst`,
                variants: [
                    {
                        begin: /\$\{/,
                        end: /\}/
                    }
                ],
                keywords: `true false null this is new super`
            }, r = {
                className: `number`,
                relevance: 0,
                variants: [
                    {
                        match: /\b[0-9][0-9_]*(\.[0-9][0-9_]*)?([eE][+-]?[0-9][0-9_]*)?\b/
                    },
                    {
                        match: /\b0[xX][0-9A-Fa-f][0-9A-Fa-f_]*\b/
                    }
                ]
            }, i = {
                className: `string`,
                variants: [
                    {
                        begin: `r'''`,
                        end: `'''`
                    },
                    {
                        begin: `r"""`,
                        end: `"""`
                    },
                    {
                        begin: `r'`,
                        end: `'`,
                        illegal: `\\n`
                    },
                    {
                        begin: `r"`,
                        end: `"`,
                        illegal: `\\n`
                    },
                    {
                        begin: `'''`,
                        end: `'''`,
                        contains: [
                            e.BACKSLASH_ESCAPE,
                            t,
                            n
                        ]
                    },
                    {
                        begin: `"""`,
                        end: `"""`,
                        contains: [
                            e.BACKSLASH_ESCAPE,
                            t,
                            n
                        ]
                    },
                    {
                        begin: `'`,
                        end: `'`,
                        illegal: `\\n`,
                        contains: [
                            e.BACKSLASH_ESCAPE,
                            t,
                            n
                        ]
                    },
                    {
                        begin: `"`,
                        end: `"`,
                        illegal: `\\n`,
                        contains: [
                            e.BACKSLASH_ESCAPE,
                            t,
                            n
                        ]
                    }
                ]
            };
            n.contains = [
                r,
                i
            ];
            let a = `Comparable.DateTime.Duration.Function.Iterable.Iterator.List.Map.Match.Object.Pattern.RegExp.Set.Stopwatch.String.StringBuffer.StringSink.Symbol.Type.Uri.bool.double.int.num.Element.ElementList`.split(`.`), o = a.map((e)=>`${e}?`);
            return {
                name: `Dart`,
                keywords: {
                    keyword: `abstract.as.assert.async.await.base.break.case.catch.class.const.continue.covariant.default.deferred.do.dynamic.else.enum.export.extends.extension.external.factory.false.final.finally.for.Function.get.hide.if.implements.import.in.interface.is.late.library.mixin.new.null.on.operator.part.required.rethrow.return.sealed.set.show.static.super.switch.sync.this.throw.true.try.typedef.var.void.when.while.with.yield`.split(`.`),
                    built_in: a.concat(o).concat([
                        `Never`,
                        `Null`,
                        `dynamic`,
                        `print`,
                        `document`,
                        `querySelector`,
                        `querySelectorAll`,
                        `window`
                    ]),
                    $pattern: /[A-Za-z][A-Za-z0-9_]*\??/
                },
                contains: [
                    i,
                    e.COMMENT(/\/\*\*(?!\/)/, /\*\//, {
                        subLanguage: `markdown`,
                        relevance: 0
                    }),
                    e.COMMENT(/\/{3,} ?/, /$/, {
                        contains: [
                            {
                                subLanguage: `markdown`,
                                begin: `.`,
                                end: `$`,
                                relevance: 0
                            }
                        ]
                    }),
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    {
                        className: `class`,
                        beginKeywords: `class interface`,
                        end: /\{/,
                        excludeEnd: !0,
                        contains: [
                            {
                                beginKeywords: `extends implements`
                            },
                            e.UNDERSCORE_TITLE_MODE
                        ]
                    },
                    r,
                    {
                        className: `meta`,
                        begin: `@[A-Za-z]+`
                    },
                    {
                        begin: `=>`
                    }
                ]
            };
        }
        t.exports = n;
    }), oe = o((e, t)=>{
        function n(e) {
            let t = `exports.register.file.shl.array.record.property.for.mod.while.set.ally.label.uses.raise.not.stored.class.safecall.var.interface.or.private.static.exit.index.inherited.to.else.stdcall.override.shr.asm.far.resourcestring.finalization.packed.virtual.out.and.protected.library.do.xorwrite.goto.near.function.end.div.overload.object.unit.begin.string.on.inline.repeat.until.destructor.write.message.program.with.read.initialization.except.default.nil.if.case.cdecl.in.downto.threadvar.of.try.pascal.const.external.constructor.type.public.then.implementation.finally.published.procedure.absolute.reintroduce.operator.as.is.abstract.alias.assembler.bitpacked.break.continue.cppdecl.cvar.enumerator.experimental.platform.deprecated.unimplemented.dynamic.export.far16.forward.generic.helper.implements.interrupt.iochecks.local.name.nodefault.noreturn.nostackframe.oldfpccall.otherwise.saveregisters.softfloat.specialize.strict.unaligned.varargs`.split(`.`), n = [
                e.C_LINE_COMMENT_MODE,
                e.COMMENT(/\{/, /\}/, {
                    relevance: 0
                }),
                e.COMMENT(/\(\*/, /\*\)/, {
                    relevance: 10
                })
            ], r = {
                className: `meta`,
                variants: [
                    {
                        begin: /\{\$/,
                        end: /\}/
                    },
                    {
                        begin: /\(\*\$/,
                        end: /\*\)/
                    }
                ]
            }, i = {
                className: `string`,
                begin: /'/,
                end: /'/,
                contains: [
                    {
                        begin: /''/
                    }
                ]
            }, a = {
                className: `number`,
                relevance: 0,
                variants: [
                    {
                        match: /\b\d[\d_]*(\.\d[\d_]*)?/
                    },
                    {
                        match: /\$[\dA-Fa-f_]+/
                    },
                    {
                        match: /\$/,
                        relevance: 0
                    },
                    {
                        match: /&[0-7][0-7_]*/
                    },
                    {
                        match: /%[01_]+/
                    },
                    {
                        match: /%/,
                        relevance: 0
                    }
                ]
            }, o = {
                className: `string`,
                variants: [
                    {
                        match: /#\d[\d_]*/
                    },
                    {
                        match: /#\$[\dA-Fa-f][\dA-Fa-f_]*/
                    },
                    {
                        match: /#&[0-7][0-7_]*/
                    },
                    {
                        match: /#%[01][01_]*/
                    }
                ]
            };
            return {
                name: `Delphi`,
                aliases: [
                    `dpr`,
                    `dfm`,
                    `pas`,
                    `pascal`
                ],
                case_insensitive: !0,
                keywords: t,
                illegal: /"|\$[G-Zg-z]|\/\*|<\/|\|/,
                contains: [
                    i,
                    o,
                    a,
                    {
                        begin: e.IDENT_RE + `\\s*=\\s*class\\s*\\(`,
                        returnBegin: !0,
                        contains: [
                            e.TITLE_MODE
                        ]
                    },
                    {
                        className: `function`,
                        beginKeywords: `function constructor destructor procedure`,
                        end: /[:;]/,
                        keywords: `function constructor|10 destructor|10 procedure|10`,
                        contains: [
                            e.TITLE_MODE,
                            {
                                className: `params`,
                                begin: /\(/,
                                end: /\)/,
                                keywords: t,
                                contains: [
                                    i,
                                    o,
                                    r
                                ].concat(n)
                            },
                            r
                        ].concat(n)
                    },
                    r
                ].concat(n)
            };
        }
        t.exports = n;
    }), se = o((e, t)=>{
        function n(e) {
            let t = e.regex;
            return {
                name: `Diff`,
                aliases: [
                    `patch`
                ],
                contains: [
                    {
                        className: `meta`,
                        relevance: 10,
                        match: t.either(/^@@ +-\d+,\d+ +\+\d+,\d+ +@@/, /^\*\*\* +\d+,\d+ +\*\*\*\*$/, /^--- +\d+,\d+ +----$/)
                    },
                    {
                        className: `comment`,
                        variants: [
                            {
                                begin: t.either(/Index: /, /^index/, /={3,}/, /^-{3}/, /^\*{3} /, /^\+{3}/, /^diff --git/),
                                end: /$/
                            },
                            {
                                match: /^\*{15}$/
                            }
                        ]
                    },
                    {
                        className: `addition`,
                        begin: /^\+/,
                        end: /$/
                    },
                    {
                        className: `deletion`,
                        begin: /^-/,
                        end: /$/
                    },
                    {
                        className: `addition`,
                        begin: /^!/,
                        end: /$/
                    }
                ]
            };
        }
        t.exports = n;
    }), ce = o((e, t)=>{
        function n(e) {
            let t = {
                begin: /\|[A-Za-z]+:?/,
                keywords: {
                    name: `truncatewords removetags linebreaksbr yesno get_digit timesince random striptags filesizeformat escape linebreaks length_is ljust rjust cut urlize fix_ampersands title floatformat capfirst pprint divisibleby add make_list unordered_list urlencode timeuntil urlizetrunc wordcount stringformat linenumbers slice date dictsort dictsortreversed default_if_none pluralize lower join center default truncatewords_html upper length phone2numeric wordwrap time addslashes slugify first escapejs force_escape iriencode last safe safeseq truncatechars localize unlocalize localtime utc timezone`
                },
                contains: [
                    e.QUOTE_STRING_MODE,
                    e.APOS_STRING_MODE
                ]
            };
            return {
                name: `Django`,
                aliases: [
                    `jinja`
                ],
                case_insensitive: !0,
                subLanguage: `xml`,
                contains: [
                    e.COMMENT(/\{%\s*comment\s*%\}/, /\{%\s*endcomment\s*%\}/),
                    e.COMMENT(/\{#/, /#\}/),
                    {
                        className: `template-tag`,
                        begin: /\{%/,
                        end: /%\}/,
                        contains: [
                            {
                                className: `name`,
                                begin: /\w+/,
                                keywords: {
                                    name: `comment endcomment load templatetag ifchanged endifchanged if endif firstof for endfor ifnotequal endifnotequal widthratio extends include spaceless endspaceless regroup ifequal endifequal ssi now with cycle url filter endfilter debug block endblock else autoescape endautoescape csrf_token empty elif endwith static trans blocktrans endblocktrans get_static_prefix get_media_prefix plural get_current_language language get_available_languages get_current_language_bidi get_language_info get_language_info_list localize endlocalize localtime endlocaltime timezone endtimezone get_current_timezone verbatim`
                                },
                                starts: {
                                    endsWithParent: !0,
                                    keywords: `in by as`,
                                    contains: [
                                        t
                                    ],
                                    relevance: 0
                                }
                            }
                        ]
                    },
                    {
                        className: `template-variable`,
                        begin: /\{\{/,
                        end: /\}\}/,
                        contains: [
                            t
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), le = o((e, t)=>{
        function n(e) {
            return {
                name: `DNS Zone`,
                aliases: [
                    `bind`,
                    `zone`
                ],
                keywords: `IN.A.AAAA.AFSDB.APL.CAA.CDNSKEY.CDS.CERT.CNAME.DHCID.DLV.DNAME.DNSKEY.DS.HIP.IPSECKEY.KEY.KX.LOC.MX.NAPTR.NS.NSEC.NSEC3.NSEC3PARAM.PTR.RRSIG.RP.SIG.SOA.SRV.SSHFP.TA.TKEY.TLSA.TSIG.TXT`.split(`.`),
                contains: [
                    e.COMMENT(`;`, `$`, {
                        relevance: 0
                    }),
                    {
                        className: `meta`,
                        begin: /^\$(TTL|GENERATE|INCLUDE|ORIGIN)\b/
                    },
                    {
                        className: `number`,
                        begin: `((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:)))\\b`
                    },
                    {
                        className: `number`,
                        begin: `((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\b`
                    },
                    e.inherit(e.NUMBER_MODE, {
                        begin: /\b\d+[dhwm]?/
                    })
                ]
            };
        }
        t.exports = n;
    }), q = o((e, t)=>{
        function n(e) {
            return {
                name: `Dockerfile`,
                aliases: [
                    `docker`
                ],
                case_insensitive: !0,
                keywords: [
                    `from`,
                    `maintainer`,
                    `expose`,
                    `env`,
                    `arg`,
                    `user`,
                    `onbuild`,
                    `stopsignal`
                ],
                contains: [
                    e.HASH_COMMENT_MODE,
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE,
                    e.NUMBER_MODE,
                    {
                        beginKeywords: `run cmd entrypoint volume add copy workdir label healthcheck shell`,
                        starts: {
                            end: /[^\\]$/,
                            subLanguage: `bash`
                        }
                    }
                ],
                illegal: `</`
            };
        }
        t.exports = n;
    }), ue = o((e, t)=>{
        function n(e) {
            let t = e.COMMENT(/^\s*@?rem\b/, /$/, {
                relevance: 10
            });
            return {
                name: `Batch file (DOS)`,
                aliases: [
                    `bat`,
                    `cmd`
                ],
                case_insensitive: !0,
                illegal: /\/\*/,
                keywords: {
                    keyword: [
                        `if`,
                        `else`,
                        `goto`,
                        `for`,
                        `in`,
                        `do`,
                        `call`,
                        `exit`,
                        `not`,
                        `exist`,
                        `errorlevel`,
                        `defined`,
                        `equ`,
                        `neq`,
                        `lss`,
                        `leq`,
                        `gtr`,
                        `geq`
                    ],
                    built_in: `prn.nul.lpt3.lpt2.lpt1.con.com4.com3.com2.com1.aux.shift.cd.dir.echo.setlocal.endlocal.set.pause.copy.append.assoc.at.attrib.break.cacls.cd.chcp.chdir.chkdsk.chkntfs.cls.cmd.color.comp.compact.convert.date.dir.diskcomp.diskcopy.doskey.erase.fs.find.findstr.format.ftype.graftabl.help.keyb.label.md.mkdir.mode.more.move.path.pause.print.popd.pushd.promt.rd.recover.rem.rename.replace.restore.rmdir.shift.sort.start.subst.time.title.tree.type.ver.verify.vol.ping.net.ipconfig.taskkill.xcopy.ren.del`.split(`.`)
                },
                contains: [
                    {
                        className: `variable`,
                        begin: /%%[^ ]|%[^ ]+?%|![^ ]+?!/
                    },
                    {
                        className: `function`,
                        begin: `^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)`,
                        end: `goto:eof`,
                        contains: [
                            e.inherit(e.TITLE_MODE, {
                                begin: `([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*`
                            }),
                            t
                        ]
                    },
                    {
                        className: `number`,
                        begin: `\\b\\d+`,
                        relevance: 0
                    },
                    t
                ]
            };
        }
        t.exports = n;
    }), de = o((e, t)=>{
        function n(e) {
            return {
                keywords: `dsconfig`,
                contains: [
                    {
                        className: `keyword`,
                        begin: `^dsconfig`,
                        end: /\s/,
                        excludeEnd: !0,
                        relevance: 10
                    },
                    {
                        className: `built_in`,
                        begin: /(list|create|get|set|delete)-(\w+)/,
                        end: /\s/,
                        excludeEnd: !0,
                        illegal: `!@#$%^&*()`,
                        relevance: 10
                    },
                    {
                        className: `built_in`,
                        begin: /--(\w+)/,
                        end: /\s/,
                        excludeEnd: !0
                    },
                    {
                        className: `string`,
                        begin: /"/,
                        end: /"/
                    },
                    {
                        className: `string`,
                        begin: /'/,
                        end: /'/
                    },
                    {
                        className: `string`,
                        begin: /[\w\-?]+:\w+/,
                        end: /\W/,
                        relevance: 0
                    },
                    {
                        className: `string`,
                        begin: /\w+(\-\w+)*/,
                        end: /(?=\W)/,
                        relevance: 0
                    },
                    e.HASH_COMMENT_MODE
                ]
            };
        }
        t.exports = n;
    }), fe = o((e, t)=>{
        function n(e) {
            let t = {
                className: `string`,
                variants: [
                    e.inherit(e.QUOTE_STRING_MODE, {
                        begin: `((u8?|U)|L)?"`
                    }),
                    {
                        begin: `(u8?|U)?R"`,
                        end: `"`,
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ]
                    },
                    {
                        begin: `'\\\\?.`,
                        end: `'`,
                        illegal: `.`
                    }
                ]
            }, n = {
                className: `number`,
                variants: [
                    {
                        begin: `\\b(\\d+(\\.\\d*)?|\\.\\d+)(u|U|l|L|ul|UL|f|F)`
                    },
                    {
                        begin: e.C_NUMBER_RE
                    }
                ],
                relevance: 0
            }, r = {
                className: `meta`,
                begin: `#`,
                end: `$`,
                keywords: {
                    keyword: `if else elif endif define undef ifdef ifndef`
                },
                contains: [
                    {
                        begin: /\\\n/,
                        relevance: 0
                    },
                    {
                        beginKeywords: `include`,
                        end: `$`,
                        keywords: {
                            keyword: `include`
                        },
                        contains: [
                            e.inherit(t, {
                                className: `string`
                            }),
                            {
                                className: `string`,
                                begin: `<`,
                                end: `>`,
                                illegal: `\\n`
                            }
                        ]
                    },
                    t,
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE
                ]
            }, i = {
                className: `variable`,
                begin: /&[a-z\d_]*\b/
            };
            return {
                name: `Device Tree`,
                contains: [
                    {
                        className: `title.class`,
                        begin: /^\/(?=\s*\{)/,
                        relevance: 10
                    },
                    i,
                    {
                        className: `keyword`,
                        begin: `/[a-z][a-z\\d-]*/`
                    },
                    {
                        className: `symbol`,
                        begin: `^\\s*[a-zA-Z_][a-zA-Z\\d_]*:`
                    },
                    {
                        className: `title.class`,
                        begin: /[a-zA-Z_][a-zA-Z\d_@-]*(?=\s\{)/,
                        relevance: .2
                    },
                    {
                        relevance: 0,
                        match: [
                            /[a-z][a-z-,]+/,
                            /\s*/,
                            /=/
                        ],
                        scope: {
                            1: `attr`,
                            3: `operator`
                        }
                    },
                    {
                        match: /[a-z][a-z-,]+(?=;)/,
                        relevance: 0,
                        scope: `attr`
                    },
                    {
                        className: `params`,
                        relevance: 0,
                        begin: `<`,
                        end: `>`,
                        contains: [
                            n,
                            i
                        ]
                    },
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    n,
                    t,
                    r,
                    {
                        scope: `punctuation`,
                        relevance: 0,
                        match: /\};|[;{}]/
                    },
                    {
                        begin: e.IDENT_RE + `::`,
                        keywords: ``
                    }
                ]
            };
        }
        t.exports = n;
    }), J = o((e, t)=>{
        function n(e) {
            return {
                name: `Dust`,
                aliases: [
                    `dst`
                ],
                case_insensitive: !0,
                subLanguage: `xml`,
                contains: [
                    {
                        className: `template-tag`,
                        begin: /\{[#\/]/,
                        end: /\}/,
                        illegal: /;/,
                        contains: [
                            {
                                className: `name`,
                                begin: /[a-zA-Z\.-]+/,
                                starts: {
                                    endsWithParent: !0,
                                    relevance: 0,
                                    contains: [
                                        e.QUOTE_STRING_MODE
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        className: `template-variable`,
                        begin: /\{/,
                        end: /\}/,
                        illegal: /;/,
                        keywords: `if eq ne lt lte gt gte select default math sep`
                    }
                ]
            };
        }
        t.exports = n;
    }), pe = o((e, t)=>{
        function n(e) {
            let t = e.COMMENT(/\(\*/, /\*\)/);
            return {
                name: `Extended Backus-Naur Form`,
                illegal: /\S/,
                contains: [
                    t,
                    {
                        className: `attribute`,
                        begin: /^[ ]*[a-zA-Z]+([\s_-]+[a-zA-Z]+)*/
                    },
                    {
                        begin: /=/,
                        end: /[.;]/,
                        contains: [
                            t,
                            {
                                className: `meta`,
                                begin: /\?.*\?/
                            },
                            {
                                className: `string`,
                                variants: [
                                    e.APOS_STRING_MODE,
                                    e.QUOTE_STRING_MODE,
                                    {
                                        begin: "`",
                                        end: "`"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), Y = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = `[a-zA-Z_][a-zA-Z0-9_.]*(!|\\?)?`, r = {
                $pattern: n,
                keyword: `after.alias.and.case.catch.cond.defstruct.defguard.do.else.end.fn.for.if.import.in.not.or.quote.raise.receive.require.reraise.rescue.try.unless.unquote.unquote_splicing.use.when.with|0`.split(`.`),
                literal: [
                    `false`,
                    `nil`,
                    `true`
                ]
            }, i = {
                className: `subst`,
                begin: /#\{/,
                end: /\}/,
                keywords: r
            }, a = {
                className: `number`,
                begin: `(\\b0o[0-7_]+)|(\\b0b[01_]+)|(\\b0x[0-9a-fA-F_]+)|(-?\\b[0-9][0-9_]*(\\.[0-9_]+([eE][-+]?[0-9]+)?)?)`,
                relevance: 0
            }, o = {
                match: /\\[\s\S]/,
                scope: `char.escape`,
                relevance: 0
            }, s = `[/|([{<"']`, c = [
                {
                    begin: /"/,
                    end: /"/
                },
                {
                    begin: /'/,
                    end: /'/
                },
                {
                    begin: /\//,
                    end: /\//
                },
                {
                    begin: /\|/,
                    end: /\|/
                },
                {
                    begin: /\(/,
                    end: /\)/
                },
                {
                    begin: /\[/,
                    end: /\]/
                },
                {
                    begin: /\{/,
                    end: /\}/
                },
                {
                    begin: /</,
                    end: />/
                }
            ], l = (e)=>({
                    scope: `char.escape`,
                    begin: t.concat(/\\/, e),
                    relevance: 0
                }), u = {
                className: `string`,
                begin: `~[a-z](?=` + s + `)`,
                contains: c.map((t)=>e.inherit(t, {
                        contains: [
                            l(t.end),
                            o,
                            i
                        ]
                    }))
            }, d = {
                className: `string`,
                begin: `~[A-Z](?=` + s + `)`,
                contains: c.map((t)=>e.inherit(t, {
                        contains: [
                            l(t.end)
                        ]
                    }))
            }, f = {
                className: `regex`,
                variants: [
                    {
                        begin: `~r(?=` + s + `)`,
                        contains: c.map((n)=>e.inherit(n, {
                                end: t.concat(n.end, /[uismxfU]{0,7}/),
                                contains: [
                                    l(n.end),
                                    o,
                                    i
                                ]
                            }))
                    },
                    {
                        begin: `~R(?=` + s + `)`,
                        contains: c.map((n)=>e.inherit(n, {
                                end: t.concat(n.end, /[uismxfU]{0,7}/),
                                contains: [
                                    l(n.end)
                                ]
                            }))
                    }
                ]
            }, p = {
                className: `string`,
                contains: [
                    e.BACKSLASH_ESCAPE,
                    i
                ],
                variants: [
                    {
                        begin: /"""/,
                        end: /"""/
                    },
                    {
                        begin: /'''/,
                        end: /'''/
                    },
                    {
                        begin: /~S"""/,
                        end: /"""/,
                        contains: []
                    },
                    {
                        begin: /~S"/,
                        end: /"/,
                        contains: []
                    },
                    {
                        begin: /~S'''/,
                        end: /'''/,
                        contains: []
                    },
                    {
                        begin: /~S'/,
                        end: /'/,
                        contains: []
                    },
                    {
                        begin: /'/,
                        end: /'/
                    },
                    {
                        begin: /"/,
                        end: /"/
                    }
                ]
            }, m = {
                className: `function`,
                beginKeywords: `def defp defmacro defmacrop`,
                end: /\B\b/,
                contains: [
                    e.inherit(e.TITLE_MODE, {
                        begin: n,
                        endsParent: !0
                    })
                ]
            }, h = e.inherit(m, {
                className: `class`,
                beginKeywords: `defimpl defmodule defprotocol defrecord`,
                end: /\bdo\b|$|;/
            }), g = [
                p,
                f,
                d,
                u,
                e.HASH_COMMENT_MODE,
                h,
                m,
                {
                    begin: `::`
                },
                {
                    className: `symbol`,
                    begin: `:(?![\\s:])`,
                    contains: [
                        p,
                        {
                            begin: "[a-zA-Z_]\\w*[!?=]?|[-+~]@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?"
                        }
                    ],
                    relevance: 0
                },
                {
                    className: `symbol`,
                    begin: n + `:(?!:)`,
                    relevance: 0
                },
                {
                    className: `title.class`,
                    begin: /(\b[A-Z][a-zA-Z0-9_]+)/,
                    relevance: 0
                },
                a,
                {
                    className: `variable`,
                    begin: `(\\$\\W)|((\\$|@@?)(\\w+))`
                }
            ];
            return i.contains = g, {
                name: `Elixir`,
                aliases: [
                    `ex`,
                    `exs`
                ],
                keywords: r,
                contains: g
            };
        }
        t.exports = n;
    }), X = o((e, t)=>{
        function n(e) {
            let t = {
                variants: [
                    e.COMMENT(`--`, `$`),
                    e.COMMENT(/\{-/, /-\}/, {
                        contains: [
                            `self`
                        ]
                    })
                ]
            }, n = {
                className: `type`,
                begin: `\\b[A-Z][\\w']*`,
                relevance: 0
            }, r = {
                begin: `\\(`,
                end: `\\)`,
                illegal: `"`,
                contains: [
                    {
                        className: `type`,
                        begin: `\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?`
                    },
                    t
                ]
            }, i = {
                begin: /\{/,
                end: /\}/,
                contains: r.contains
            };
            return {
                name: `Elm`,
                keywords: [
                    `let`,
                    `in`,
                    `if`,
                    `then`,
                    `else`,
                    `case`,
                    `of`,
                    `where`,
                    `module`,
                    `import`,
                    `exposing`,
                    `type`,
                    `alias`,
                    `as`,
                    `infix`,
                    `infixl`,
                    `infixr`,
                    `port`,
                    `effect`,
                    `command`,
                    `subscription`
                ],
                contains: [
                    {
                        beginKeywords: `port effect module`,
                        end: `exposing`,
                        keywords: `port effect module where command subscription exposing`,
                        contains: [
                            r,
                            t
                        ],
                        illegal: `\\W\\.|;`
                    },
                    {
                        begin: `import`,
                        end: `$`,
                        keywords: `import as exposing`,
                        contains: [
                            r,
                            t
                        ],
                        illegal: `\\W\\.|;`
                    },
                    {
                        begin: `type`,
                        end: `$`,
                        keywords: `type alias`,
                        contains: [
                            n,
                            r,
                            i,
                            t
                        ]
                    },
                    {
                        beginKeywords: `infix infixl infixr`,
                        end: `$`,
                        contains: [
                            e.C_NUMBER_MODE,
                            t
                        ]
                    },
                    {
                        begin: `port`,
                        end: `$`,
                        keywords: `port`,
                        contains: [
                            t
                        ]
                    },
                    {
                        className: `string`,
                        begin: `'\\\\?.`,
                        end: `'`,
                        illegal: `.`
                    },
                    e.QUOTE_STRING_MODE,
                    e.C_NUMBER_MODE,
                    n,
                    e.inherit(e.TITLE_MODE, {
                        begin: `^[_a-z][\\w']*`
                    }),
                    t,
                    {
                        begin: `->|<-`
                    }
                ],
                illegal: /;/
            };
        }
        t.exports = n;
    }), me = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = "([a-zA-Z_]\\w*[!?=]?|[-+~]@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?)", r = t.either(/\b([A-Z]+[a-z0-9]+)+/, /\b([A-Z]+[a-z0-9]+)+[A-Z]+/), i = t.concat(r, /(::\w+)*/), a = {
                "variable.constant": [
                    `__FILE__`,
                    `__LINE__`,
                    `__ENCODING__`
                ],
                "variable.language": [
                    `self`,
                    `super`
                ],
                keyword: [
                    `alias`,
                    `and`,
                    `begin`,
                    `BEGIN`,
                    `break`,
                    `case`,
                    `class`,
                    `defined`,
                    `do`,
                    `else`,
                    `elsif`,
                    `end`,
                    `END`,
                    `ensure`,
                    `for`,
                    `if`,
                    `in`,
                    `module`,
                    `next`,
                    `not`,
                    `or`,
                    `redo`,
                    `require`,
                    `rescue`,
                    `retry`,
                    `return`,
                    `then`,
                    `undef`,
                    `unless`,
                    `until`,
                    `when`,
                    `while`,
                    `yield`,
                    `include`,
                    `extend`,
                    `prepend`,
                    `public`,
                    `private`,
                    `protected`,
                    `raise`,
                    `throw`
                ],
                built_in: [
                    `proc`,
                    `lambda`,
                    `attr_accessor`,
                    `attr_reader`,
                    `attr_writer`,
                    `define_method`,
                    `private_constant`,
                    `module_function`
                ],
                literal: [
                    `true`,
                    `false`,
                    `nil`
                ]
            }, o = {
                className: `doctag`,
                begin: `@[A-Za-z]+`
            }, s = {
                begin: `#<`,
                end: `>`
            }, c = [
                e.COMMENT(`#`, `$`, {
                    contains: [
                        o
                    ]
                }),
                e.COMMENT(`^=begin`, `^=end`, {
                    contains: [
                        o
                    ],
                    relevance: 10
                }),
                e.COMMENT(`^__END__`, e.MATCH_NOTHING_RE)
            ], l = {
                className: `subst`,
                begin: /#\{/,
                end: /\}/,
                keywords: a
            }, u = {
                className: `string`,
                contains: [
                    e.BACKSLASH_ESCAPE,
                    l
                ],
                variants: [
                    {
                        begin: /'/,
                        end: /'/
                    },
                    {
                        begin: /"/,
                        end: /"/
                    },
                    {
                        begin: /`/,
                        end: /`/
                    },
                    {
                        begin: /%[qQwWx]?\(/,
                        end: /\)/
                    },
                    {
                        begin: /%[qQwWx]?\[/,
                        end: /\]/
                    },
                    {
                        begin: /%[qQwWx]?\{/,
                        end: /\}/
                    },
                    {
                        begin: /%[qQwWx]?</,
                        end: />/
                    },
                    {
                        begin: /%[qQwWx]?\//,
                        end: /\//
                    },
                    {
                        begin: /%[qQwWx]?%/,
                        end: /%/
                    },
                    {
                        begin: /%[qQwWx]?-/,
                        end: /-/
                    },
                    {
                        begin: /%[qQwWx]?\|/,
                        end: /\|/
                    },
                    {
                        begin: /\B\?(\\\d{1,3})/
                    },
                    {
                        begin: /\B\?(\\x[A-Fa-f0-9]{1,2})/
                    },
                    {
                        begin: /\B\?(\\u\{?[A-Fa-f0-9]{1,6}\}?)/
                    },
                    {
                        begin: /\B\?(\\M-\\C-|\\M-\\c|\\c\\M-|\\M-|\\C-\\M-)[\x20-\x7e]/
                    },
                    {
                        begin: /\B\?\\(c|C-)[\x20-\x7e]/
                    },
                    {
                        begin: /\B\?\\?\S/
                    },
                    {
                        begin: t.concat(/<<[-~]?'?/, t.lookahead(/(\w+)(?=\W)[^\n]*\n(?:[^\n]*\n)*?\s*\1\b/)),
                        contains: [
                            e.END_SAME_AS_BEGIN({
                                begin: /(\w+)/,
                                end: /(\w+)/,
                                contains: [
                                    e.BACKSLASH_ESCAPE,
                                    l
                                ]
                            })
                        ]
                    }
                ]
            }, d = `[0-9](_?[0-9])*`, f = {
                className: `number`,
                relevance: 0,
                variants: [
                    {
                        begin: `\\b([1-9](_?[0-9])*|0)(\\.(${d}))?([eE][+-]?(${d})|r)?i?\\b`
                    },
                    {
                        begin: `\\b0[dD][0-9](_?[0-9])*r?i?\\b`
                    },
                    {
                        begin: `\\b0[bB][0-1](_?[0-1])*r?i?\\b`
                    },
                    {
                        begin: `\\b0[oO][0-7](_?[0-7])*r?i?\\b`
                    },
                    {
                        begin: `\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*r?i?\\b`
                    },
                    {
                        begin: `\\b0(_?[0-7])+r?i?\\b`
                    }
                ]
            }, p = {
                variants: [
                    {
                        match: /\(\)/
                    },
                    {
                        className: `params`,
                        begin: /\(/,
                        end: /(?=\))/,
                        excludeBegin: !0,
                        endsParent: !0,
                        keywords: a
                    }
                ]
            }, m = [
                u,
                {
                    variants: [
                        {
                            match: [
                                /class\s+/,
                                i,
                                /\s+<\s+/,
                                i
                            ]
                        },
                        {
                            match: [
                                /\b(class|module)\s+/,
                                i
                            ]
                        }
                    ],
                    scope: {
                        2: `title.class`,
                        4: `title.class.inherited`
                    },
                    keywords: a
                },
                {
                    match: [
                        /(include|extend)\s+/,
                        i
                    ],
                    scope: {
                        2: `title.class`
                    },
                    keywords: a
                },
                {
                    relevance: 0,
                    match: [
                        i,
                        /\.new[. (]/
                    ],
                    scope: {
                        1: `title.class`
                    }
                },
                {
                    relevance: 0,
                    match: /\b[A-Z][A-Z_0-9]+\b/,
                    className: `variable.constant`
                },
                {
                    relevance: 0,
                    match: r,
                    scope: `title.class`
                },
                {
                    match: [
                        /def/,
                        /\s+/,
                        n
                    ],
                    scope: {
                        1: `keyword`,
                        3: `title.function`
                    },
                    contains: [
                        p
                    ]
                },
                {
                    begin: e.IDENT_RE + `::`
                },
                {
                    className: `symbol`,
                    begin: e.UNDERSCORE_IDENT_RE + `(!|\\?)?:`,
                    relevance: 0
                },
                {
                    className: `symbol`,
                    begin: `:(?!\\s)`,
                    contains: [
                        u,
                        {
                            begin: n
                        }
                    ],
                    relevance: 0
                },
                f,
                {
                    className: `variable`,
                    begin: `(\\$\\W)|((\\$|@@?)(\\w+))(?=[^@$?])(?![A-Za-z])(?![@$?'])`
                },
                {
                    className: `params`,
                    begin: /\|(?!=)/,
                    end: /\|/,
                    excludeBegin: !0,
                    excludeEnd: !0,
                    relevance: 0,
                    keywords: a
                },
                {
                    begin: `(` + e.RE_STARTERS_RE + `|unless)\\s*`,
                    keywords: `unless`,
                    contains: [
                        {
                            className: `regexp`,
                            contains: [
                                e.BACKSLASH_ESCAPE,
                                l
                            ],
                            illegal: /\n/,
                            variants: [
                                {
                                    begin: `/`,
                                    end: `/[a-z]*`
                                },
                                {
                                    begin: /%r\{/,
                                    end: /\}[a-z]*/
                                },
                                {
                                    begin: `%r\\(`,
                                    end: `\\)[a-z]*`
                                },
                                {
                                    begin: `%r!`,
                                    end: `![a-z]*`
                                },
                                {
                                    begin: `%r\\[`,
                                    end: `\\][a-z]*`
                                }
                            ]
                        }
                    ].concat(s, c),
                    relevance: 0
                }
            ].concat(s, c);
            l.contains = m, p.contains = m;
            let h = [
                {
                    begin: /^\s*=>/,
                    starts: {
                        end: `$`,
                        contains: m
                    }
                },
                {
                    className: `meta.prompt`,
                    begin: `^([>?]>|[\\w#]+\\(\\w+\\):\\d+:\\d+[>*]|(\\w+-)?\\d+\\.\\d+\\.\\d+(p\\d+)?[^\\d][^>]+>)(?=[ ])`,
                    starts: {
                        end: `$`,
                        keywords: a,
                        contains: m
                    }
                }
            ];
            return c.unshift(s), {
                name: `Ruby`,
                aliases: [
                    `rb`,
                    `gemspec`,
                    `podspec`,
                    `thor`,
                    `irb`
                ],
                keywords: a,
                illegal: /\/\*/,
                contains: [
                    e.SHEBANG({
                        binary: `ruby`
                    })
                ].concat(h, c, m)
            };
        }
        t.exports = n;
    }), he = o((e, t)=>{
        function n(e) {
            return {
                name: `ERB`,
                subLanguage: `xml`,
                contains: [
                    e.COMMENT(`<%#`, `%>`),
                    {
                        begin: `<%[%=-]?`,
                        end: `[%-]?%>`,
                        subLanguage: `ruby`,
                        excludeBegin: !0,
                        excludeEnd: !0
                    }
                ]
            };
        }
        t.exports = n;
    }), ge = o((e, t)=>{
        function n(e) {
            let t = e.regex;
            return {
                name: `Erlang REPL`,
                keywords: {
                    built_in: `spawn spawn_link self`,
                    keyword: `after and andalso|10 band begin bnot bor bsl bsr bxor case catch cond div end fun if let not of or orelse|10 query receive rem try when xor`
                },
                contains: [
                    {
                        className: `meta.prompt`,
                        begin: `^[0-9]+> `,
                        relevance: 10
                    },
                    e.COMMENT(`%`, `$`),
                    {
                        className: `number`,
                        begin: `\\b(\\d+(_\\d+)*#[a-fA-F0-9]+(_[a-fA-F0-9]+)*|\\d+(_\\d+)*(\\.\\d+(_\\d+)*)?([eE][-+]?\\d+)?)`,
                        relevance: 0
                    },
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE,
                    {
                        begin: t.concat(/\?(::)?/, /([A-Z]\w*)/, /((::)[A-Z]\w*)*/)
                    },
                    {
                        begin: `->`
                    },
                    {
                        begin: `ok`
                    },
                    {
                        begin: `!`
                    },
                    {
                        begin: `(\\b[a-z'][a-zA-Z0-9_']*:[a-z'][a-zA-Z0-9_']*)|(\\b[a-z'][a-zA-Z0-9_']*)`,
                        relevance: 0
                    },
                    {
                        begin: `[A-Z][a-zA-Z0-9_']*`,
                        relevance: 0
                    }
                ]
            };
        }
        t.exports = n;
    }), _e = o((e, t)=>{
        function n(e) {
            let t = `[a-z'][a-zA-Z0-9_']*`, n = `(` + t + `:[a-z'][a-zA-Z0-9_']*|[a-z'][a-zA-Z0-9_']*)`, r = {
                keyword: `after and andalso|10 band begin bnot bor bsl bzr bxor case catch cond div end fun if let not of orelse|10 query receive rem try when xor maybe else`,
                literal: `false true`
            }, i = e.COMMENT(`%`, `$`), a = {
                className: `number`,
                begin: `\\b(\\d+(_\\d+)*#[a-fA-F0-9]+(_[a-fA-F0-9]+)*|\\d+(_\\d+)*(\\.\\d+(_\\d+)*)?([eE][-+]?\\d+)?)`,
                relevance: 0
            }, o = {
                begin: `fun\\s+` + t + `/\\d+`
            }, s = {
                begin: n + `\\(`,
                end: `\\)`,
                returnBegin: !0,
                relevance: 0,
                contains: [
                    {
                        begin: n,
                        relevance: 0
                    },
                    {
                        begin: `\\(`,
                        end: `\\)`,
                        endsWithParent: !0,
                        returnEnd: !0,
                        relevance: 0
                    }
                ]
            }, c = {
                begin: /\{/,
                end: /\}/,
                relevance: 0
            }, l = {
                begin: `\\b_([A-Z][A-Za-z0-9_]*)?`,
                relevance: 0
            }, u = {
                begin: `[A-Z][a-zA-Z0-9_]*`,
                relevance: 0
            }, d = {
                begin: `#` + e.UNDERSCORE_IDENT_RE,
                relevance: 0,
                returnBegin: !0,
                contains: [
                    {
                        begin: `#` + e.UNDERSCORE_IDENT_RE,
                        relevance: 0
                    },
                    {
                        begin: /\{/,
                        end: /\}/,
                        relevance: 0
                    }
                ]
            }, f = {
                scope: `string`,
                match: /\$(\\([^0-9]|[0-9]{1,3}|)|.)/
            }, p = {
                scope: `string`,
                match: /"""("*)(?!")[\s\S]*?"""\1/
            }, m = {
                scope: `string`,
                contains: [
                    e.BACKSLASH_ESCAPE
                ],
                variants: [
                    {
                        match: /~\w?"""("*)(?!")[\s\S]*?"""\1/
                    },
                    {
                        begin: /~\w?\(/,
                        end: /\)/
                    },
                    {
                        begin: /~\w?\[/,
                        end: /\]/
                    },
                    {
                        begin: /~\w?{/,
                        end: /}/
                    },
                    {
                        begin: /~\w?</,
                        end: />/
                    },
                    {
                        begin: /~\w?\//,
                        end: /\//
                    },
                    {
                        begin: /~\w?\|/,
                        end: /\|/
                    },
                    {
                        begin: /~\w?'/,
                        end: /'/
                    },
                    {
                        begin: /~\w?"/,
                        end: /"/
                    },
                    {
                        begin: /~\w?`/,
                        end: /`/
                    },
                    {
                        begin: /~\w?#/,
                        end: /#/
                    }
                ]
            }, h = {
                beginKeywords: `fun receive if try case maybe`,
                end: `end`,
                keywords: r
            };
            h.contains = [
                i,
                o,
                e.inherit(e.APOS_STRING_MODE, {
                    className: ``
                }),
                h,
                s,
                m,
                p,
                e.QUOTE_STRING_MODE,
                a,
                c,
                l,
                u,
                d,
                f
            ];
            let g = [
                i,
                o,
                h,
                s,
                m,
                p,
                e.QUOTE_STRING_MODE,
                a,
                c,
                l,
                u,
                d,
                f
            ];
            s.contains[1].contains = g, c.contains = g, d.contains[1].contains = g;
            let _ = [
                `-module`,
                `-record`,
                `-undef`,
                `-export`,
                `-ifdef`,
                `-ifndef`,
                `-author`,
                `-copyright`,
                `-doc`,
                `-moduledoc`,
                `-vsn`,
                `-import`,
                `-include`,
                `-include_lib`,
                `-compile`,
                `-define`,
                `-else`,
                `-endif`,
                `-file`,
                `-behaviour`,
                `-behavior`,
                `-spec`,
                `-on_load`,
                `-nifs`
            ], v = {
                className: `params`,
                begin: `\\(`,
                end: `\\)`,
                contains: g
            };
            return {
                name: `Erlang`,
                aliases: [
                    `erl`
                ],
                keywords: r,
                illegal: `(</|\\*=|\\+=|-=|/\\*|\\*/|\\(\\*|\\*\\))`,
                contains: [
                    {
                        className: `function`,
                        begin: `^` + t + `\\s*\\(`,
                        end: `->`,
                        returnBegin: !0,
                        illegal: `\\(|#|//|/\\*|\\\\|:|;`,
                        contains: [
                            v,
                            e.inherit(e.TITLE_MODE, {
                                begin: t
                            })
                        ],
                        starts: {
                            end: `;|\\.`,
                            keywords: r,
                            contains: g
                        }
                    },
                    i,
                    {
                        begin: `^-`,
                        end: `\\.`,
                        relevance: 0,
                        excludeEnd: !0,
                        returnBegin: !0,
                        keywords: {
                            $pattern: `-` + e.IDENT_RE,
                            keyword: _.map((e)=>`${e}|1.5`).join(` `)
                        },
                        contains: [
                            v,
                            m,
                            p,
                            e.QUOTE_STRING_MODE
                        ]
                    },
                    a,
                    m,
                    p,
                    e.QUOTE_STRING_MODE,
                    d,
                    l,
                    u,
                    c,
                    f,
                    {
                        begin: /\.$/
                    }
                ]
            };
        }
        t.exports = n;
    }), ve = o((e, t)=>{
        function n(e) {
            return {
                name: `Excel formulae`,
                aliases: [
                    `xlsx`,
                    `xls`
                ],
                case_insensitive: !0,
                keywords: {
                    $pattern: /[a-zA-Z][\w\.]*/,
                    built_in: `ABS,ACCRINT,ACCRINTM,ACOS,ACOSH,ACOT,ACOTH,AGGREGATE,ADDRESS,AMORDEGRC,AMORLINC,AND,ARABIC,AREAS,ARRAYTOTEXT,ASC,ASIN,ASINH,ATAN,ATAN2,ATANH,AVEDEV,AVERAGE,AVERAGEA,AVERAGEIF,AVERAGEIFS,BAHTTEXT,BASE,BESSELI,BESSELJ,BESSELK,BESSELY,BETADIST,BETA.DIST,BETAINV,BETA.INV,BIN2DEC,BIN2HEX,BIN2OCT,BINOMDIST,BINOM.DIST,BINOM.DIST.RANGE,BINOM.INV,BITAND,BITLSHIFT,BITOR,BITRSHIFT,BITXOR,BYCOL,BYROW,CALL,CEILING,CEILING.MATH,CEILING.PRECISE,CELL,CHAR,CHIDIST,CHIINV,CHITEST,CHISQ.DIST,CHISQ.DIST.RT,CHISQ.INV,CHISQ.INV.RT,CHISQ.TEST,CHOOSE,CHOOSECOLS,CHOOSEROWS,CLEAN,CODE,COLUMN,COLUMNS,COMBIN,COMBINA,COMPLEX,CONCAT,CONCATENATE,CONFIDENCE,CONFIDENCE.NORM,CONFIDENCE.T,CONVERT,CORREL,COS,COSH,COT,COTH,COUNT,COUNTA,COUNTBLANK,COUNTIF,COUNTIFS,COUPDAYBS,COUPDAYS,COUPDAYSNC,COUPNCD,COUPNUM,COUPPCD,COVAR,COVARIANCE.P,COVARIANCE.S,CRITBINOM,CSC,CSCH,CUBEKPIMEMBER,CUBEMEMBER,CUBEMEMBERPROPERTY,CUBERANKEDMEMBER,CUBESET,CUBESETCOUNT,CUBEVALUE,CUMIPMT,CUMPRINC,DATE,DATEDIF,DATEVALUE,DAVERAGE,DAY,DAYS,DAYS360,DB,DBCS,DCOUNT,DCOUNTA,DDB,DEC2BIN,DEC2HEX,DEC2OCT,DECIMAL,DEGREES,DELTA,DEVSQ,DGET,DISC,DMAX,DMIN,DOLLAR,DOLLARDE,DOLLARFR,DPRODUCT,DROP,DSTDEV,DSTDEVP,DSUM,DURATION,DVAR,DVARP,EDATE,EFFECT,ENCODEURL,EOMONTH,ERF,ERF.PRECISE,ERFC,ERFC.PRECISE,ERROR.TYPE,EUROCONVERT,EVEN,EXACT,EXP,EXPAND,EXPON.DIST,EXPONDIST,FACT,FACTDOUBLE,FALSE,F.DIST,FDIST,F.DIST.RT,FILTER,FILTERXML,FIND,FINDB,F.INV,F.INV.RT,FINV,FISHER,FISHERINV,FIXED,FLOOR,FLOOR.MATH,FLOOR.PRECISE,FORECAST,FORECAST.ETS,FORECAST.ETS.CONFINT,FORECAST.ETS.SEASONALITY,FORECAST.ETS.STAT,FORECAST.LINEAR,FORMULATEXT,FREQUENCY,F.TEST,FTEST,FV,FVSCHEDULE,GAMMA,GAMMA.DIST,GAMMADIST,GAMMA.INV,GAMMAINV,GAMMALN,GAMMALN.PRECISE,GAUSS,GCD,GEOMEAN,GESTEP,GETPIVOTDATA,GROWTH,HARMEAN,HEX2BIN,HEX2DEC,HEX2OCT,HLOOKUP,HOUR,HSTACK,HYPERLINK,HYPGEOM.DIST,HYPGEOMDIST,IF,IFERROR,IFNA,IFS,IMABS,IMAGE,IMAGINARY,IMARGUMENT,IMCONJUGATE,IMCOS,IMCOSH,IMCOT,IMCSC,IMCSCH,IMDIV,IMEXP,IMLN,IMLOG10,IMLOG2,IMPOWER,IMPRODUCT,IMREAL,IMSEC,IMSECH,IMSIN,IMSINH,IMSQRT,IMSUB,IMSUM,IMTAN,INDEX,INDIRECT,INFO,INT,INTERCEPT,INTRATE,IPMT,IRR,ISBLANK,ISERR,ISERROR,ISEVEN,ISFORMULA,ISLOGICAL,ISNA,ISNONTEXT,ISNUMBER,ISODD,ISOMITTED,ISREF,ISTEXT,ISO.CEILING,ISOWEEKNUM,ISPMT,JIS,KURT,LAMBDA,LARGE,LCM,LEFT,LEFTB,LEN,LENB,LET,LINEST,LN,LOG,LOG10,LOGEST,LOGINV,LOGNORM.DIST,LOGNORMDIST,LOGNORM.INV,LOOKUP,LOWER,MAKEARRAY,MAP,MATCH,MAX,MAXA,MAXIFS,MDETERM,MDURATION,MEDIAN,MID,MIDB,MIN,MINIFS,MINA,MINUTE,MINVERSE,MIRR,MMULT,MOD,MODE,MODE.MULT,MODE.SNGL,MONTH,MROUND,MULTINOMIAL,MUNIT,N,NA,NEGBINOM.DIST,NEGBINOMDIST,NETWORKDAYS,NETWORKDAYS.INTL,NOMINAL,NORM.DIST,NORMDIST,NORMINV,NORM.INV,NORM.S.DIST,NORMSDIST,NORM.S.INV,NORMSINV,NOT,NOW,NPER,NPV,NUMBERVALUE,OCT2BIN,OCT2DEC,OCT2HEX,ODD,ODDFPRICE,ODDFYIELD,ODDLPRICE,ODDLYIELD,OFFSET,OR,PDURATION,PEARSON,PERCENTILE.EXC,PERCENTILE.INC,PERCENTILE,PERCENTRANK.EXC,PERCENTRANK.INC,PERCENTRANK,PERMUT,PERMUTATIONA,PHI,PHONETIC,PI,PMT,POISSON.DIST,POISSON,POWER,PPMT,PRICE,PRICEDISC,PRICEMAT,PROB,PRODUCT,PROPER,PV,QUARTILE,QUARTILE.EXC,QUARTILE.INC,QUOTIENT,RADIANS,RAND,RANDARRAY,RANDBETWEEN,RANK.AVG,RANK.EQ,RANK,RATE,RECEIVED,REDUCE,REGISTER.ID,REPLACE,REPLACEB,REPT,RIGHT,RIGHTB,ROMAN,ROUND,ROUNDDOWN,ROUNDUP,ROW,ROWS,RRI,RSQ,RTD,SCAN,SEARCH,SEARCHB,SEC,SECH,SECOND,SEQUENCE,SERIESSUM,SHEET,SHEETS,SIGN,SIN,SINH,SKEW,SKEW.P,SLN,SLOPE,SMALL,SORT,SORTBY,SQRT,SQRTPI,SQL.REQUEST,STANDARDIZE,STOCKHISTORY,STDEV,STDEV.P,STDEV.S,STDEVA,STDEVP,STDEVPA,STEYX,SUBSTITUTE,SUBTOTAL,SUM,SUMIF,SUMIFS,SUMPRODUCT,SUMSQ,SUMX2MY2,SUMX2PY2,SUMXMY2,SWITCH,SYD,T,TAN,TANH,TAKE,TBILLEQ,TBILLPRICE,TBILLYIELD,T.DIST,T.DIST.2T,T.DIST.RT,TDIST,TEXT,TEXTAFTER,TEXTBEFORE,TEXTJOIN,TEXTSPLIT,TIME,TIMEVALUE,T.INV,T.INV.2T,TINV,TOCOL,TOROW,TODAY,TRANSPOSE,TREND,TRIM,TRIMMEAN,TRUE,TRUNC,T.TEST,TTEST,TYPE,UNICHAR,UNICODE,UNIQUE,UPPER,VALUE,VALUETOTEXT,VAR,VAR.P,VAR.S,VARA,VARP,VARPA,VDB,VLOOKUP,VSTACK,WEBSERVICE,WEEKDAY,WEEKNUM,WEIBULL,WEIBULL.DIST,WORKDAY,WORKDAY.INTL,WRAPCOLS,WRAPROWS,XIRR,XLOOKUP,XMATCH,XNPV,XOR,YEAR,YEARFRAC,YIELD,YIELDDISC,YIELDMAT,Z.TEST,ZTEST`.split(`,`)
                },
                contains: [
                    {
                        begin: /^=/,
                        end: /[^=]/,
                        returnEnd: !0,
                        illegal: /=/,
                        relevance: 10
                    },
                    {
                        className: `symbol`,
                        begin: /\b[A-Z]{1,2}\d+\b/,
                        end: /[^\d]/,
                        excludeEnd: !0,
                        relevance: 0
                    },
                    {
                        className: `symbol`,
                        begin: /[A-Z]{0,2}\d*:[A-Z]{0,2}\d*/,
                        relevance: 0
                    },
                    e.BACKSLASH_ESCAPE,
                    e.QUOTE_STRING_MODE,
                    {
                        className: `number`,
                        begin: e.NUMBER_RE + `(%)?`,
                        relevance: 0
                    },
                    e.COMMENT(/\bN\(/, /\)/, {
                        excludeBegin: !0,
                        excludeEnd: !0,
                        illegal: /\n/
                    })
                ]
            };
        }
        t.exports = n;
    }), ye = o((e, t)=>{
        function n(e) {
            return {
                name: `FIX`,
                contains: [
                    {
                        begin: /[^\u2401\u0001]+/,
                        end: /[\u2401\u0001]/,
                        excludeEnd: !0,
                        returnBegin: !0,
                        returnEnd: !1,
                        contains: [
                            {
                                begin: /([^\u2401\u0001=]+)/,
                                end: /=([^\u2401\u0001=]+)/,
                                returnEnd: !0,
                                returnBegin: !1,
                                className: `attr`
                            },
                            {
                                begin: /=/,
                                end: /([\u2401\u0001])/,
                                excludeEnd: !0,
                                excludeBegin: !0,
                                className: `string`
                            }
                        ]
                    }
                ],
                case_insensitive: !0
            };
        }
        t.exports = n;
    }), be = o((e, t)=>{
        function n(e) {
            return {
                name: `Flix`,
                keywords: {
                    keyword: [
                        `case`,
                        `class`,
                        `def`,
                        `else`,
                        `enum`,
                        `if`,
                        `impl`,
                        `import`,
                        `in`,
                        `lat`,
                        `rel`,
                        `index`,
                        `let`,
                        `match`,
                        `namespace`,
                        `switch`,
                        `type`,
                        `yield`,
                        `with`
                    ],
                    literal: [
                        `true`,
                        `false`
                    ]
                },
                contains: [
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    {
                        className: `string`,
                        begin: /'(.|\\[xXuU][a-zA-Z0-9]+)'/
                    },
                    {
                        className: `string`,
                        variants: [
                            {
                                begin: `"`,
                                end: `"`
                            }
                        ]
                    },
                    {
                        className: `function`,
                        beginKeywords: `def`,
                        end: /[:={\[(\n;]/,
                        excludeEnd: !0,
                        contains: [
                            {
                                className: `title`,
                                relevance: 0,
                                begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/
                            }
                        ]
                    },
                    e.C_NUMBER_MODE
                ]
            };
        }
        t.exports = n;
    }), xe = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = {
                className: `params`,
                begin: `\\(`,
                end: `\\)`
            }, r = {
                variants: [
                    e.COMMENT(`!`, `$`, {
                        relevance: 0
                    }),
                    e.COMMENT(`^C[ ]`, `$`, {
                        relevance: 0
                    }),
                    e.COMMENT(`^C$`, `$`, {
                        relevance: 0
                    })
                ]
            }, i = /(_[a-z_\d]+)?/, a = /([de][+-]?\d+)?/, o = {
                className: `number`,
                variants: [
                    {
                        begin: t.concat(/\b\d+/, /\.(\d*)/, a, i)
                    },
                    {
                        begin: t.concat(/\b\d+/, a, i)
                    },
                    {
                        begin: t.concat(/\.\d+/, a, i)
                    }
                ],
                relevance: 0
            }, s = {
                className: `function`,
                beginKeywords: `subroutine function program`,
                illegal: "[${=\\n]",
                contains: [
                    e.UNDERSCORE_TITLE_MODE,
                    n
                ]
            };
            return {
                name: `Fortran`,
                case_insensitive: !0,
                aliases: [
                    `f90`,
                    `f95`
                ],
                keywords: {
                    $pattern: /\b[a-z][a-z0-9_]+\b|\.[a-z][a-z0-9_]+\./,
                    keyword: `kind,do,concurrent,local,shared,while,private,call,intrinsic,where,elsewhere,type,endtype,endmodule,endselect,endinterface,end,enddo,endif,if,forall,endforall,only,contains,default,return,stop,then,block,endblock,endassociate,public,subroutine|10,function,program,.and.,.or.,.not.,.le.,.eq.,.ge.,.gt.,.lt.,goto,save,else,use,module,select,case,access,blank,direct,exist,file,fmt,form,formatted,iostat,name,named,nextrec,number,opened,rec,recl,sequential,status,unformatted,unit,continue,format,pause,cycle,exit,c_null_char,c_alert,c_backspace,c_form_feed,flush,wait,decimal,round,iomsg,synchronous,nopass,non_overridable,pass,protected,volatile,abstract,extends,import,non_intrinsic,value,deferred,generic,final,enumerator,class,associate,bind,enum,c_int,c_short,c_long,c_long_long,c_signed_char,c_size_t,c_int8_t,c_int16_t,c_int32_t,c_int64_t,c_int_least8_t,c_int_least16_t,c_int_least32_t,c_int_least64_t,c_int_fast8_t,c_int_fast16_t,c_int_fast32_t,c_int_fast64_t,c_intmax_t,C_intptr_t,c_float,c_double,c_long_double,c_float_complex,c_double_complex,c_long_double_complex,c_bool,c_char,c_null_ptr,c_null_funptr,c_new_line,c_carriage_return,c_horizontal_tab,c_vertical_tab,iso_c_binding,c_loc,c_funloc,c_associated,c_f_pointer,c_ptr,c_funptr,iso_fortran_env,character_storage_size,error_unit,file_storage_size,input_unit,iostat_end,iostat_eor,numeric_storage_size,output_unit,c_f_procpointer,ieee_arithmetic,ieee_support_underflow_control,ieee_get_underflow_mode,ieee_set_underflow_mode,newunit,contiguous,recursive,pad,position,action,delim,readwrite,eor,advance,nml,interface,procedure,namelist,include,sequence,elemental,pure,impure,integer,real,character,complex,logical,codimension,dimension,allocatable|10,parameter,external,implicit|10,none,double,precision,assign,intent,optional,pointer,target,in,out,common,equivalence,data`.split(`,`),
                    literal: [
                        `.False.`,
                        `.True.`
                    ],
                    built_in: `alog.alog10.amax0.amax1.amin0.amin1.amod.cabs.ccos.cexp.clog.csin.csqrt.dabs.dacos.dasin.datan.datan2.dcos.dcosh.ddim.dexp.dint.dlog.dlog10.dmax1.dmin1.dmod.dnint.dsign.dsin.dsinh.dsqrt.dtan.dtanh.float.iabs.idim.idint.idnint.ifix.isign.max0.max1.min0.min1.sngl.algama.cdabs.cdcos.cdexp.cdlog.cdsin.cdsqrt.cqabs.cqcos.cqexp.cqlog.cqsin.cqsqrt.dcmplx.dconjg.derf.derfc.dfloat.dgamma.dimag.dlgama.iqint.qabs.qacos.qasin.qatan.qatan2.qcmplx.qconjg.qcos.qcosh.qdim.qerf.qerfc.qexp.qgamma.qimag.qlgama.qlog.qlog10.qmax1.qmin1.qmod.qnint.qsign.qsin.qsinh.qsqrt.qtan.qtanh.abs.acos.aimag.aint.anint.asin.atan.atan2.char.cmplx.conjg.cos.cosh.exp.ichar.index.int.log.log10.max.min.nint.sign.sin.sinh.sqrt.tan.tanh.print.write.dim.lge.lgt.lle.llt.mod.nullify.allocate.deallocate.adjustl.adjustr.all.allocated.any.associated.bit_size.btest.ceiling.count.cshift.date_and_time.digits.dot_product.eoshift.epsilon.exponent.floor.fraction.huge.iand.ibclr.ibits.ibset.ieor.ior.ishft.ishftc.lbound.len_trim.matmul.maxexponent.maxloc.maxval.merge.minexponent.minloc.minval.modulo.mvbits.nearest.pack.present.product.radix.random_number.random_seed.range.repeat.reshape.rrspacing.scale.scan.selected_int_kind.selected_real_kind.set_exponent.shape.size.spacing.spread.sum.system_clock.tiny.transpose.trim.ubound.unpack.verify.achar.iachar.transfer.dble.entry.dprod.cpu_time.command_argument_count.get_command.get_command_argument.get_environment_variable.is_iostat_end.ieee_arithmetic.ieee_support_underflow_control.ieee_get_underflow_mode.ieee_set_underflow_mode.is_iostat_eor.move_alloc.new_line.selected_char_kind.same_type_as.extends_type_of.acosh.asinh.atanh.bessel_j0.bessel_j1.bessel_jn.bessel_y0.bessel_y1.bessel_yn.erf.erfc.erfc_scaled.gamma.log_gamma.hypot.norm2.atomic_define.atomic_ref.execute_command_line.leadz.trailz.storage_size.merge_bits.bge.bgt.ble.blt.dshiftl.dshiftr.findloc.iall.iany.iparity.image_index.lcobound.ucobound.maskl.maskr.num_images.parity.popcnt.poppar.shifta.shiftl.shiftr.this_image.sync.change.team.co_broadcast.co_max.co_min.co_sum.co_reduce`.split(`.`)
                },
                illegal: /\/\*/,
                contains: [
                    {
                        className: `string`,
                        relevance: 0,
                        variants: [
                            e.APOS_STRING_MODE,
                            e.QUOTE_STRING_MODE
                        ]
                    },
                    s,
                    {
                        begin: /^C\s*=(?!=)/,
                        relevance: 0
                    },
                    r,
                    o
                ]
            };
        }
        t.exports = n;
    }), Se = o((e, t)=>{
        function n(e) {
            return new RegExp(e.replace(/[-/\\^$*+?.()|[\]{}]/g, `\\$&`), `m`);
        }
        function r(e) {
            return e ? typeof e == `string` ? e : e.source : null;
        }
        function i(e) {
            return a(`(?=`, e, `)`);
        }
        function a(...e) {
            return e.map((e)=>r(e)).join(``);
        }
        function o(e) {
            let t = e[e.length - 1];
            return typeof t == `object` && t.constructor === Object ? (e.splice(e.length - 1, 1), t) : {};
        }
        function s(...e) {
            return `(` + (o(e).capture ? `` : `?:`) + e.map((e)=>r(e)).join(`|`) + `)`;
        }
        function c(e) {
            let t = `abstract.and.as.assert.base.begin.class.default.delegate.do.done.downcast.downto.elif.else.end.exception.extern.finally.fixed.for.fun.function.global.if.in.inherit.inline.interface.internal.lazy.let.match.member.module.mutable.namespace.new.of.open.or.override.private.public.rec.return.static.struct.then.to.try.type.upcast.use.val.void.when.while.with.yield`.split(`.`), r = {
                scope: `keyword`,
                match: /\b(yield|return|let|do|match|use)!/
            }, o = [
                `if`,
                `else`,
                `endif`,
                `line`,
                `nowarn`,
                `light`,
                `r`,
                `i`,
                `I`,
                `load`,
                `time`,
                `help`,
                `quit`
            ], c = [
                `true`,
                `false`,
                `null`,
                `Some`,
                `None`,
                `Ok`,
                `Error`,
                `infinity`,
                `infinityf`,
                `nan`,
                `nanf`
            ], l = [
                `__LINE__`,
                `__SOURCE_DIRECTORY__`,
                `__SOURCE_FILE__`
            ], u = `bool.byte.sbyte.int8.int16.int32.uint8.uint16.uint32.int.uint.int64.uint64.nativeint.unativeint.decimal.float.double.float32.single.char.string.unit.bigint.option.voption.list.array.seq.byref.exn.inref.nativeptr.obj.outref.voidptr.Result`.split(`.`), d = {
                keyword: t,
                literal: c,
                built_in: `not.ref.raise.reraise.dict.readOnlyDict.set.get.enum.sizeof.typeof.typedefof.nameof.nullArg.invalidArg.invalidOp.id.fst.snd.ignore.lock.using.box.unbox.tryUnbox.printf.printfn.sprintf.eprintf.eprintfn.fprintf.fprintfn.failwith.failwithf`.split(`.`),
                "variable.constant": l
            }, f = {
                variants: [
                    e.COMMENT(/\(\*(?!\))/, /\*\)/, {
                        contains: [
                            `self`
                        ]
                    }),
                    e.C_LINE_COMMENT_MODE
                ]
            }, p = /[a-zA-Z_](\w|')*/, m = {
                scope: `variable`,
                begin: /``/,
                end: /``/
            }, h = /\B('|\^)/, g = {
                scope: `symbol`,
                variants: [
                    {
                        match: a(h, /``.*?``/)
                    },
                    {
                        match: a(h, e.UNDERSCORE_IDENT_RE)
                    }
                ],
                relevance: 0
            }, _ = function({ includeEqual: e }) {
                let t;
                t = e ? `!%&*+-/<=>@^|~?` : `!%&*+-/<>@^|~?`;
                let r = a(`[`, ...Array.from(t).map(n), `]`), o = s(r, /\./);
                return {
                    scope: `operator`,
                    match: s(s(a(a(o, i(o)), o, `*`), a(r, `+`)), /:\?>/, /:\?/, /:>/, /:=/, /::?/, /\$/),
                    relevance: 0
                };
            }, v = _({
                includeEqual: !0
            }), y = _({
                includeEqual: !1
            }), b = function(t, n) {
                return {
                    begin: a(t, i(a(/\s*/, s(/\w/, /'/, /\^/, /#/, /``/, /\(/, /{\|/)))),
                    beginScope: n,
                    end: i(s(/\n/, /=/)),
                    relevance: 0,
                    keywords: e.inherit(d, {
                        type: u
                    }),
                    contains: [
                        f,
                        g,
                        e.inherit(m, {
                            scope: null
                        }),
                        y
                    ]
                };
            }, x = b(/:/, `operator`), S = b(/\bof\b/, `keyword`), C = {
                begin: [
                    /(^|\s+)/,
                    /type/,
                    /\s+/,
                    p
                ],
                beginScope: {
                    2: `keyword`,
                    4: `title.class`
                },
                end: i(/\(|=|$/),
                keywords: d,
                contains: [
                    f,
                    e.inherit(m, {
                        scope: null
                    }),
                    g,
                    {
                        scope: `operator`,
                        match: /<|>/
                    },
                    x
                ]
            }, w = {
                scope: `computation-expression`,
                match: /\b[_a-z]\w*(?=\s*\{)/
            }, T = {
                begin: [
                    /^\s*/,
                    a(/#/, s(...o)),
                    /\b/
                ],
                beginScope: {
                    2: `meta`
                },
                end: i(/\s|$/)
            }, E = {
                variants: [
                    e.BINARY_NUMBER_MODE,
                    e.C_NUMBER_MODE
                ]
            }, D = {
                scope: `string`,
                begin: /"/,
                end: /"/,
                contains: [
                    e.BACKSLASH_ESCAPE
                ]
            }, O = {
                scope: `string`,
                begin: /@"/,
                end: /"/,
                contains: [
                    {
                        match: /""/
                    },
                    e.BACKSLASH_ESCAPE
                ]
            }, k = {
                scope: `string`,
                begin: /"""/,
                end: /"""/,
                relevance: 2
            }, A = {
                scope: `subst`,
                begin: /\{/,
                end: /\}/,
                keywords: d
            }, j = {
                scope: `string`,
                begin: /\$"/,
                end: /"/,
                contains: [
                    {
                        match: /\{\{/
                    },
                    {
                        match: /\}\}/
                    },
                    e.BACKSLASH_ESCAPE,
                    A
                ]
            }, M = {
                scope: `string`,
                begin: /(\$@|@\$)"/,
                end: /"/,
                contains: [
                    {
                        match: /\{\{/
                    },
                    {
                        match: /\}\}/
                    },
                    {
                        match: /""/
                    },
                    e.BACKSLASH_ESCAPE,
                    A
                ]
            }, N = {
                scope: `string`,
                begin: /\$"""/,
                end: /"""/,
                contains: [
                    {
                        match: /\{\{/
                    },
                    {
                        match: /\}\}/
                    },
                    A
                ],
                relevance: 2
            }, P = {
                scope: `string`,
                match: a(/'/, s(/[^\\']/, /\\(?:.|\d{3}|x[a-fA-F\d]{2}|u[a-fA-F\d]{4}|U[a-fA-F\d]{8})/), /'/)
            };
            return A.contains = [
                M,
                j,
                O,
                D,
                P,
                r,
                f,
                m,
                x,
                w,
                T,
                E,
                g,
                v
            ], {
                name: `F#`,
                aliases: [
                    `fs`,
                    `f#`
                ],
                keywords: d,
                illegal: /\/\*/,
                classNameAliases: {
                    "computation-expression": `keyword`
                },
                contains: [
                    r,
                    {
                        variants: [
                            N,
                            M,
                            j,
                            k,
                            O,
                            D,
                            P
                        ]
                    },
                    f,
                    m,
                    C,
                    {
                        scope: `meta`,
                        begin: /\[</,
                        end: />\]/,
                        relevance: 2,
                        contains: [
                            m,
                            k,
                            O,
                            D,
                            P,
                            E
                        ]
                    },
                    S,
                    x,
                    w,
                    T,
                    E,
                    g,
                    v
                ]
            };
        }
        t.exports = c;
    }), Ce = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = {
                keyword: `abort acronym acronyms alias all and assign binary card diag display else eq file files for free ge gt if integer le loop lt maximizing minimizing model models ne negative no not option options or ord positive prod put putpage puttl repeat sameas semicont semiint smax smin solve sos1 sos2 sum system table then until using while xor yes`,
                literal: `eps inf na`,
                built_in: `abs arccos arcsin arctan arctan2 Beta betaReg binomial ceil centropy cos cosh cvPower div div0 eDist entropy errorf execSeed exp fact floor frac gamma gammaReg log logBeta logGamma log10 log2 mapVal max min mod ncpCM ncpF ncpVUpow ncpVUsin normal pi poly power randBinomial randLinear randTriangle round rPower sigmoid sign signPower sin sinh slexp sllog10 slrec sqexp sqlog10 sqr sqrec sqrt tan tanh trunc uniform uniformInt vcPower bool_and bool_eqv bool_imp bool_not bool_or bool_xor ifThen rel_eq rel_ge rel_gt rel_le rel_lt rel_ne gday gdow ghour gleap gmillisec gminute gmonth gsecond gyear jdate jnow jstart jtime errorLevel execError gamsRelease gamsVersion handleCollect handleDelete handleStatus handleSubmit heapFree heapLimit heapSize jobHandle jobKill jobStatus jobTerminate licenseLevel licenseStatus maxExecError sleep timeClose timeComp timeElapsed timeExec timeStart`
            }, r = {
                className: `params`,
                begin: /\(/,
                end: /\)/,
                excludeBegin: !0,
                excludeEnd: !0
            }, i = {
                className: `symbol`,
                variants: [
                    {
                        begin: /=[lgenxc]=/
                    },
                    {
                        begin: /\$/
                    }
                ]
            }, a = {
                className: `comment`,
                variants: [
                    {
                        begin: `'`,
                        end: `'`
                    },
                    {
                        begin: `"`,
                        end: `"`
                    }
                ],
                illegal: `\\n`,
                contains: [
                    e.BACKSLASH_ESCAPE
                ]
            }, o = {
                begin: `/`,
                end: `/`,
                keywords: n,
                contains: [
                    a,
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    e.QUOTE_STRING_MODE,
                    e.APOS_STRING_MODE,
                    e.C_NUMBER_MODE
                ]
            }, s = /[a-z0-9&#*=?@\\><:,()$[\]_.{}!+%^-]+/, c = {
                begin: /[a-z][a-z0-9_]*(\([a-z0-9_, ]*\))?[ \t]+/,
                excludeBegin: !0,
                end: `$`,
                endsWithParent: !0,
                contains: [
                    a,
                    o,
                    {
                        className: `comment`,
                        begin: t.concat(s, t.anyNumberOfTimes(t.concat(/[ ]+/, s))),
                        relevance: 0
                    }
                ]
            };
            return {
                name: `GAMS`,
                aliases: [
                    `gms`
                ],
                case_insensitive: !0,
                keywords: n,
                contains: [
                    e.COMMENT(/^\$ontext/, /^\$offtext/),
                    {
                        className: `meta`,
                        begin: `^\\$[a-z0-9]+`,
                        end: `$`,
                        returnBegin: !0,
                        contains: [
                            {
                                className: `keyword`,
                                begin: `^\\$[a-z0-9]+`
                            }
                        ]
                    },
                    e.COMMENT(`^\\*`, `$`),
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    e.QUOTE_STRING_MODE,
                    e.APOS_STRING_MODE,
                    {
                        beginKeywords: `set sets parameter parameters variable variables scalar scalars equation equations`,
                        end: `;`,
                        contains: [
                            e.COMMENT(`^\\*`, `$`),
                            e.C_LINE_COMMENT_MODE,
                            e.C_BLOCK_COMMENT_MODE,
                            e.QUOTE_STRING_MODE,
                            e.APOS_STRING_MODE,
                            o,
                            c
                        ]
                    },
                    {
                        beginKeywords: `table`,
                        end: `;`,
                        returnBegin: !0,
                        contains: [
                            {
                                beginKeywords: `table`,
                                end: `$`,
                                contains: [
                                    c
                                ]
                            },
                            e.COMMENT(`^\\*`, `$`),
                            e.C_LINE_COMMENT_MODE,
                            e.C_BLOCK_COMMENT_MODE,
                            e.QUOTE_STRING_MODE,
                            e.APOS_STRING_MODE,
                            e.C_NUMBER_MODE
                        ]
                    },
                    {
                        className: `function`,
                        begin: /^[a-z][a-z0-9_,\-+' ()$]+\.{2}/,
                        returnBegin: !0,
                        contains: [
                            {
                                className: `title`,
                                begin: /^[a-z0-9_]+/
                            },
                            r,
                            i
                        ]
                    },
                    e.C_NUMBER_MODE,
                    i
                ]
            };
        }
        t.exports = n;
    }), we = o((e, t)=>{
        function n(e) {
            let t = {
                keyword: `bool break call callexe checkinterrupt clear clearg closeall cls comlog compile continue create debug declare delete disable dlibrary dllcall do dos ed edit else elseif enable end endfor endif endp endo errorlog errorlogat expr external fn for format goto gosub graph if keyword let lib library line load loadarray loadexe loadf loadk loadm loadp loads loadx local locate loopnextindex lprint lpwidth lshow matrix msym ndpclex new open output outwidth plot plotsym pop prcsn print printdos proc push retp return rndcon rndmod rndmult rndseed run save saveall screen scroll setarray show sparse stop string struct system trace trap threadfor threadendfor threadbegin threadjoin threadstat threadend until use while winprint ne ge le gt lt and xor or not eq eqv`,
                built_in: `abs acf aconcat aeye amax amean AmericanBinomCall AmericanBinomCall_Greeks AmericanBinomCall_ImpVol AmericanBinomPut AmericanBinomPut_Greeks AmericanBinomPut_ImpVol AmericanBSCall AmericanBSCall_Greeks AmericanBSCall_ImpVol AmericanBSPut AmericanBSPut_Greeks AmericanBSPut_ImpVol amin amult annotationGetDefaults annotationSetBkd annotationSetFont annotationSetLineColor annotationSetLineStyle annotationSetLineThickness annualTradingDays arccos arcsin areshape arrayalloc arrayindex arrayinit arraytomat asciiload asclabel astd astds asum atan atan2 atranspose axmargin balance band bandchol bandcholsol bandltsol bandrv bandsolpd bar base10 begwind besselj bessely beta box boxcox cdfBeta cdfBetaInv cdfBinomial cdfBinomialInv cdfBvn cdfBvn2 cdfBvn2e cdfCauchy cdfCauchyInv cdfChic cdfChii cdfChinc cdfChincInv cdfExp cdfExpInv cdfFc cdfFnc cdfFncInv cdfGam cdfGenPareto cdfHyperGeo cdfLaplace cdfLaplaceInv cdfLogistic cdfLogisticInv cdfmControlCreate cdfMvn cdfMvn2e cdfMvnce cdfMvne cdfMvt2e cdfMvtce cdfMvte cdfN cdfN2 cdfNc cdfNegBinomial cdfNegBinomialInv cdfNi cdfPoisson cdfPoissonInv cdfRayleigh cdfRayleighInv cdfTc cdfTci cdfTnc cdfTvn cdfWeibull cdfWeibullInv cdir ceil ChangeDir chdir chiBarSquare chol choldn cholsol cholup chrs close code cols colsf combinate combinated complex con cond conj cons ConScore contour conv convertsatostr convertstrtosa corrm corrms corrvc corrx corrxs cos cosh counts countwts crossprd crout croutp csrcol csrlin csvReadM csvReadSA cumprodc cumsumc curve cvtos datacreate datacreatecomplex datalist dataload dataloop dataopen datasave date datestr datestring datestrymd dayinyr dayofweek dbAddDatabase dbClose dbCommit dbCreateQuery dbExecQuery dbGetConnectOptions dbGetDatabaseName dbGetDriverName dbGetDrivers dbGetHostName dbGetLastErrorNum dbGetLastErrorText dbGetNumericalPrecPolicy dbGetPassword dbGetPort dbGetTableHeaders dbGetTables dbGetUserName dbHasFeature dbIsDriverAvailable dbIsOpen dbIsOpenError dbOpen dbQueryBindValue dbQueryClear dbQueryCols dbQueryExecPrepared dbQueryFetchAllM dbQueryFetchAllSA dbQueryFetchOneM dbQueryFetchOneSA dbQueryFinish dbQueryGetBoundValue dbQueryGetBoundValues dbQueryGetField dbQueryGetLastErrorNum dbQueryGetLastErrorText dbQueryGetLastInsertID dbQueryGetLastQuery dbQueryGetPosition dbQueryIsActive dbQueryIsForwardOnly dbQueryIsNull dbQueryIsSelect dbQueryIsValid dbQueryPrepare dbQueryRows dbQuerySeek dbQuerySeekFirst dbQuerySeekLast dbQuerySeekNext dbQuerySeekPrevious dbQuerySetForwardOnly dbRemoveDatabase dbRollback dbSetConnectOptions dbSetDatabaseName dbSetHostName dbSetNumericalPrecPolicy dbSetPort dbSetUserName dbTransaction DeleteFile delif delrows denseToSp denseToSpRE denToZero design det detl dfft dffti diag diagrv digamma doswin DOSWinCloseall DOSWinOpen dotfeq dotfeqmt dotfge dotfgemt dotfgt dotfgtmt dotfle dotflemt dotflt dotfltmt dotfne dotfnemt draw drop dsCreate dstat dstatmt dstatmtControlCreate dtdate dtday dttime dttodtv dttostr dttoutc dtvnormal dtvtodt dtvtoutc dummy dummybr dummydn eig eigh eighv eigv elapsedTradingDays endwind envget eof eqSolve eqSolvemt eqSolvemtControlCreate eqSolvemtOutCreate eqSolveset erf erfc erfccplx erfcplx error etdays ethsec etstr EuropeanBinomCall EuropeanBinomCall_Greeks EuropeanBinomCall_ImpVol EuropeanBinomPut EuropeanBinomPut_Greeks EuropeanBinomPut_ImpVol EuropeanBSCall EuropeanBSCall_Greeks EuropeanBSCall_ImpVol EuropeanBSPut EuropeanBSPut_Greeks EuropeanBSPut_ImpVol exctsmpl exec execbg exp extern eye fcheckerr fclearerr feq feqmt fflush fft ffti fftm fftmi fftn fge fgemt fgets fgetsa fgetsat fgetst fgt fgtmt fileinfo filesa fle flemt floor flt fltmt fmod fne fnemt fonts fopen formatcv formatnv fputs fputst fseek fstrerror ftell ftocv ftos ftostrC gamma gammacplx gammaii gausset gdaAppend gdaCreate gdaDStat gdaDStatMat gdaGetIndex gdaGetName gdaGetNames gdaGetOrders gdaGetType gdaGetTypes gdaGetVarInfo gdaIsCplx gdaLoad gdaPack gdaRead gdaReadByIndex gdaReadSome gdaReadSparse gdaReadStruct gdaReportVarInfo gdaSave gdaUpdate gdaUpdateAndPack gdaVars gdaWrite gdaWrite32 gdaWriteSome getarray getdims getf getGAUSShome getmatrix getmatrix4D getname getnamef getNextTradingDay getNextWeekDay getnr getorders getpath getPreviousTradingDay getPreviousWeekDay getRow getscalar3D getscalar4D getTrRow getwind glm gradcplx gradMT gradMTm gradMTT gradMTTm gradp graphprt graphset hasimag header headermt hess hessMT hessMTg hessMTgw hessMTm hessMTmw hessMTT hessMTTg hessMTTgw hessMTTm hessMTw hessp hist histf histp hsec imag indcv indexcat indices indices2 indicesf indicesfn indnv indsav integrate1d integrateControlCreate intgrat2 intgrat3 inthp1 inthp2 inthp3 inthp4 inthpControlCreate intquad1 intquad2 intquad3 intrleav intrleavsa intrsect intsimp inv invpd invswp iscplx iscplxf isden isinfnanmiss ismiss key keyav keyw lag lag1 lagn lapEighb lapEighi lapEighvb lapEighvi lapgEig lapgEigh lapgEighv lapgEigv lapgSchur lapgSvdcst lapgSvds lapgSvdst lapSvdcusv lapSvds lapSvdusv ldlp ldlsol linSolve listwise ln lncdfbvn lncdfbvn2 lncdfmvn lncdfn lncdfn2 lncdfnc lnfact lngammacplx lnpdfmvn lnpdfmvt lnpdfn lnpdft loadd loadstruct loadwind loess loessmt loessmtControlCreate log loglog logx logy lower lowmat lowmat1 ltrisol lu lusol machEpsilon make makevars makewind margin matalloc matinit mattoarray maxbytes maxc maxindc maxv maxvec mbesselei mbesselei0 mbesselei1 mbesseli mbesseli0 mbesseli1 meanc median mergeby mergevar minc minindc minv miss missex missrv moment momentd movingave movingaveExpwgt movingaveWgt nextindex nextn nextnevn nextwind ntos null null1 numCombinations ols olsmt olsmtControlCreate olsqr olsqr2 olsqrmt ones optn optnevn orth outtyp pacf packedToSp packr parse pause pdfCauchy pdfChi pdfExp pdfGenPareto pdfHyperGeo pdfLaplace pdfLogistic pdfn pdfPoisson pdfRayleigh pdfWeibull pi pinv pinvmt plotAddArrow plotAddBar plotAddBox plotAddHist plotAddHistF plotAddHistP plotAddPolar plotAddScatter plotAddShape plotAddTextbox plotAddTS plotAddXY plotArea plotBar plotBox plotClearLayout plotContour plotCustomLayout plotGetDefaults plotHist plotHistF plotHistP plotLayout plotLogLog plotLogX plotLogY plotOpenWindow plotPolar plotSave plotScatter plotSetAxesPen plotSetBar plotSetBarFill plotSetBarStacked plotSetBkdColor plotSetFill plotSetGrid plotSetLegend plotSetLineColor plotSetLineStyle plotSetLineSymbol plotSetLineThickness plotSetNewWindow plotSetTitle plotSetWhichYAxis plotSetXAxisShow plotSetXLabel plotSetXRange plotSetXTicInterval plotSetXTicLabel plotSetYAxisShow plotSetYLabel plotSetYRange plotSetZAxisShow plotSetZLabel plotSurface plotTS plotXY polar polychar polyeval polygamma polyint polymake polymat polymroot polymult polyroot pqgwin previousindex princomp printfm printfmt prodc psi putarray putf putvals pvCreate pvGetIndex pvGetParNames pvGetParVector pvLength pvList pvPack pvPacki pvPackm pvPackmi pvPacks pvPacksi pvPacksm pvPacksmi pvPutParVector pvTest pvUnpack QNewton QNewtonmt QNewtonmtControlCreate QNewtonmtOutCreate QNewtonSet QProg QProgmt QProgmtInCreate qqr qqre qqrep qr qre qrep qrsol qrtsol qtyr qtyre qtyrep quantile quantiled qyr qyre qyrep qz rank rankindx readr real reclassify reclassifyCuts recode recserar recsercp recserrc rerun rescale reshape rets rev rfft rffti rfftip rfftn rfftnp rfftp rndBernoulli rndBeta rndBinomial rndCauchy rndChiSquare rndCon rndCreateState rndExp rndGamma rndGeo rndGumbel rndHyperGeo rndi rndKMbeta rndKMgam rndKMi rndKMn rndKMnb rndKMp rndKMu rndKMvm rndLaplace rndLCbeta rndLCgam rndLCi rndLCn rndLCnb rndLCp rndLCu rndLCvm rndLogNorm rndMTu rndMVn rndMVt rndn rndnb rndNegBinomial rndp rndPoisson rndRayleigh rndStateSkip rndu rndvm rndWeibull rndWishart rotater round rows rowsf rref sampleData satostrC saved saveStruct savewind scale scale3d scalerr scalinfnanmiss scalmiss schtoc schur searchsourcepath seekr select selif seqa seqm setdif setdifsa setvars setvwrmode setwind shell shiftr sin singleindex sinh sleep solpd sortc sortcc sortd sorthc sorthcc sortind sortindc sortmc sortr sortrc spBiconjGradSol spChol spConjGradSol spCreate spDenseSubmat spDiagRvMat spEigv spEye spLDL spline spLU spNumNZE spOnes spreadSheetReadM spreadSheetReadSA spreadSheetWrite spScale spSubmat spToDense spTrTDense spTScalar spZeros sqpSolve sqpSolveMT sqpSolveMTControlCreate sqpSolveMTlagrangeCreate sqpSolveMToutCreate sqpSolveSet sqrt statements stdc stdsc stocv stof strcombine strindx strlen strput strrindx strsect strsplit strsplitPad strtodt strtof strtofcplx strtriml strtrimr strtrunc strtruncl strtruncpad strtruncr submat subscat substute subvec sumc sumr surface svd svd1 svd2 svdcusv svds svdusv sysstate tab tan tanh tempname time timedt timestr timeutc title tkf2eps tkf2ps tocart todaydt toeplitz token topolar trapchk trigamma trimr trunc type typecv typef union unionsa uniqindx uniqindxsa unique uniquesa upmat upmat1 upper utctodt utctodtv utrisol vals varCovMS varCovXS varget vargetl varmall varmares varput varputl vartypef vcm vcms vcx vcxs vec vech vecr vector vget view viewxyz vlist vnamecv volume vput vread vtypecv wait waitc walkindex where window writer xlabel xlsGetSheetCount xlsGetSheetSize xlsGetSheetTypes xlsMakeRange xlsReadM xlsReadSA xlsWrite xlsWriteM xlsWriteSA xpnd xtics xy xyz ylabel ytics zeros zeta zlabel ztics cdfEmpirical dot h5create h5open h5read h5readAttribute h5write h5writeAttribute ldl plotAddErrorBar plotAddSurface plotCDFEmpirical plotSetColormap plotSetContourLabels plotSetLegendFont plotSetTextInterpreter plotSetXTicCount plotSetYTicCount plotSetZLevels powerm strjoin sylvester strtrim`,
                literal: `DB_AFTER_LAST_ROW DB_ALL_TABLES DB_BATCH_OPERATIONS DB_BEFORE_FIRST_ROW DB_BLOB DB_EVENT_NOTIFICATIONS DB_FINISH_QUERY DB_HIGH_PRECISION DB_LAST_INSERT_ID DB_LOW_PRECISION_DOUBLE DB_LOW_PRECISION_INT32 DB_LOW_PRECISION_INT64 DB_LOW_PRECISION_NUMBERS DB_MULTIPLE_RESULT_SETS DB_NAMED_PLACEHOLDERS DB_POSITIONAL_PLACEHOLDERS DB_PREPARED_QUERIES DB_QUERY_SIZE DB_SIMPLE_LOCKING DB_SYSTEM_TABLES DB_TABLES DB_TRANSACTIONS DB_UNICODE DB_VIEWS __STDIN __STDOUT __STDERR __FILE_DIR`
            }, n = e.COMMENT(`@`, `@`), r = {
                className: `meta`,
                begin: `#`,
                end: `$`,
                keywords: {
                    keyword: `define definecs|10 undef ifdef ifndef iflight ifdllcall ifmac ifos2win ifunix else endif lineson linesoff srcfile srcline`
                },
                contains: [
                    {
                        begin: /\\\n/,
                        relevance: 0
                    },
                    {
                        beginKeywords: `include`,
                        end: `$`,
                        keywords: {
                            keyword: `include`
                        },
                        contains: [
                            {
                                className: `string`,
                                begin: `"`,
                                end: `"`,
                                illegal: `\\n`
                            }
                        ]
                    },
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    n
                ]
            }, i = {
                begin: /\bstruct\s+/,
                end: /\s/,
                keywords: `struct`,
                contains: [
                    {
                        className: `type`,
                        begin: e.UNDERSCORE_IDENT_RE,
                        relevance: 0
                    }
                ]
            }, a = [
                {
                    className: `params`,
                    begin: /\(/,
                    end: /\)/,
                    excludeBegin: !0,
                    excludeEnd: !0,
                    endsWithParent: !0,
                    relevance: 0,
                    contains: [
                        {
                            className: `literal`,
                            begin: /\.\.\./
                        },
                        e.C_NUMBER_MODE,
                        e.C_BLOCK_COMMENT_MODE,
                        n,
                        i
                    ]
                }
            ], o = {
                className: `title`,
                begin: e.UNDERSCORE_IDENT_RE,
                relevance: 0
            }, s = function(t, r, i) {
                let s = e.inherit({
                    className: `function`,
                    beginKeywords: t,
                    end: r,
                    excludeEnd: !0,
                    contains: [].concat(a)
                }, {});
                return s.contains.push(o), s.contains.push(e.C_NUMBER_MODE), s.contains.push(e.C_BLOCK_COMMENT_MODE), s.contains.push(n), s;
            }, c = {
                className: `built_in`,
                begin: `\\b(` + t.built_in.split(` `).join(`|`) + `)\\b`
            }, l = {
                className: `string`,
                begin: `"`,
                end: `"`,
                contains: [
                    e.BACKSLASH_ESCAPE
                ],
                relevance: 0
            }, u = {
                begin: e.UNDERSCORE_IDENT_RE + `\\s*\\(`,
                returnBegin: !0,
                keywords: t,
                relevance: 0,
                contains: [
                    {
                        beginKeywords: t.keyword
                    },
                    c,
                    {
                        className: `built_in`,
                        begin: e.UNDERSCORE_IDENT_RE,
                        relevance: 0
                    }
                ]
            }, d = {
                begin: /\(/,
                end: /\)/,
                relevance: 0,
                keywords: {
                    built_in: t.built_in,
                    literal: t.literal
                },
                contains: [
                    e.C_NUMBER_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    n,
                    c,
                    u,
                    l,
                    `self`
                ]
            };
            return u.contains.push(d), {
                name: `GAUSS`,
                aliases: [
                    `gss`
                ],
                case_insensitive: !0,
                keywords: t,
                illegal: /(\{[%#]|[%#]\}| <- )/,
                contains: [
                    e.C_NUMBER_MODE,
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    n,
                    l,
                    r,
                    {
                        className: `keyword`,
                        begin: /\bexternal (matrix|string|array|sparse matrix|struct|proc|keyword|fn)/
                    },
                    s(`proc keyword`, `;`),
                    s(`fn`, `=`),
                    {
                        beginKeywords: `for threadfor`,
                        end: /;/,
                        relevance: 0,
                        contains: [
                            e.C_BLOCK_COMMENT_MODE,
                            n,
                            d
                        ]
                    },
                    {
                        variants: [
                            {
                                begin: e.UNDERSCORE_IDENT_RE + `\\.` + e.UNDERSCORE_IDENT_RE
                            },
                            {
                                begin: e.UNDERSCORE_IDENT_RE + `\\s*=`
                            }
                        ],
                        relevance: 0
                    },
                    u,
                    i
                ]
            };
        }
        t.exports = n;
    }), Te = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = {
                $pattern: /[A-Z]+|%/,
                keyword: [
                    `THEN`,
                    `ELSE`,
                    `ENDIF`,
                    `IF`,
                    `GOTO`,
                    `DO`,
                    `WHILE`,
                    `WH`,
                    `END`,
                    `CALL`,
                    `SUB`,
                    `ENDSUB`,
                    `EQ`,
                    `NE`,
                    `LT`,
                    `GT`,
                    `LE`,
                    `GE`,
                    `AND`,
                    `OR`,
                    `XOR`,
                    `%`
                ],
                built_in: [
                    `ATAN`,
                    `ABS`,
                    `ACOS`,
                    `ASIN`,
                    `COS`,
                    `EXP`,
                    `FIX`,
                    `FUP`,
                    `ROUND`,
                    `LN`,
                    `SIN`,
                    `SQRT`,
                    `TAN`,
                    `EXISTS`
                ]
            }, r = /\b/;
            function i(e, t) {
                if (e.index === 0) return;
                let n = e.input[e.index - 1];
                n >= `0` && n <= `9` || n !== `_` && t.ignoreMatch();
            }
            let a = /[+-]?((\.\d+)|(\d+)(\.\d*)?)/, o = /[GM]\s*\d+(\.\d+)?/, s = /T\s*\d+/, c = /O\s*\d+/, l = /O<.+>/, u = /[ABCUVWXYZ]\s*/, d = /[FHIJKPQRS]\s*/;
            return {
                name: `G-code (ISO 6983)`,
                aliases: [
                    `nc`
                ],
                case_insensitive: !0,
                disableAutodetect: !0,
                keywords: n,
                contains: [
                    e.COMMENT(/\(/, /\)/),
                    e.COMMENT(/;/, /$/),
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE,
                    e.C_NUMBER_MODE,
                    {
                        scope: `title.function`,
                        variants: [
                            {
                                match: t.concat(r, o)
                            },
                            {
                                begin: o,
                                "on:begin": i
                            },
                            {
                                match: t.concat(r, s)
                            },
                            {
                                begin: s,
                                "on:begin": i
                            }
                        ]
                    },
                    {
                        scope: `symbol`,
                        variants: [
                            {
                                match: t.concat(r, c)
                            },
                            {
                                begin: c,
                                "on:begin": i
                            },
                            {
                                match: t.concat(r, l)
                            },
                            {
                                begin: l,
                                "on:begin": i
                            },
                            {
                                match: /\*\s*\d+\s*$/
                            }
                        ]
                    },
                    {
                        scope: `operator`,
                        match: /^N\s*\d+/
                    },
                    {
                        scope: `variable`,
                        match: /-?#\s*\d+/
                    },
                    {
                        scope: `property`,
                        variants: [
                            {
                                match: t.concat(r, u, a)
                            },
                            {
                                begin: t.concat(u, a),
                                "on:begin": i
                            }
                        ]
                    },
                    {
                        scope: `params`,
                        variants: [
                            {
                                match: t.concat(r, d, a)
                            },
                            {
                                begin: t.concat(d, a),
                                "on:begin": i
                            }
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), Ee = o((e, t)=>{
        function n(e) {
            return {
                name: `Gherkin`,
                aliases: [
                    `feature`
                ],
                keywords: `Feature Background Ability Business Need Scenario Scenarios Scenario Outline Scenario Template Examples Given And Then But When`,
                contains: [
                    {
                        className: `symbol`,
                        begin: `\\*`,
                        relevance: 0
                    },
                    {
                        className: `meta`,
                        begin: `@[^@\\s]+`
                    },
                    {
                        begin: `\\|`,
                        end: `\\|\\w*$`,
                        contains: [
                            {
                                className: `string`,
                                begin: `[^|]+`
                            }
                        ]
                    },
                    {
                        className: `variable`,
                        begin: `<`,
                        end: `>`
                    },
                    e.HASH_COMMENT_MODE,
                    {
                        className: `string`,
                        begin: `"""`,
                        end: `"""`
                    },
                    e.QUOTE_STRING_MODE
                ]
            };
        }
        t.exports = n;
    }), De = o((e, t)=>{
        function n(e) {
            return {
                name: `GLSL`,
                keywords: {
                    keyword: `break continue discard do else for if return while switch case default attribute binding buffer ccw centroid centroid varying coherent column_major const cw depth_any depth_greater depth_less depth_unchanged early_fragment_tests equal_spacing flat fractional_even_spacing fractional_odd_spacing highp in index inout invariant invocations isolines layout line_strip lines lines_adjacency local_size_x local_size_y local_size_z location lowp max_vertices mediump noperspective offset origin_upper_left out packed patch pixel_center_integer point_mode points precise precision quads r11f_g11f_b10f r16 r16_snorm r16f r16i r16ui r32f r32i r32ui r8 r8_snorm r8i r8ui readonly restrict rg16 rg16_snorm rg16f rg16i rg16ui rg32f rg32i rg32ui rg8 rg8_snorm rg8i rg8ui rgb10_a2 rgb10_a2ui rgba16 rgba16_snorm rgba16f rgba16i rgba16ui rgba32f rgba32i rgba32ui rgba8 rgba8_snorm rgba8i rgba8ui row_major sample shared smooth std140 std430 stream triangle_strip triangles triangles_adjacency uniform varying vertices volatile writeonly`,
                    type: `atomic_uint bool bvec2 bvec3 bvec4 dmat2 dmat2x2 dmat2x3 dmat2x4 dmat3 dmat3x2 dmat3x3 dmat3x4 dmat4 dmat4x2 dmat4x3 dmat4x4 double dvec2 dvec3 dvec4 float iimage1D iimage1DArray iimage2D iimage2DArray iimage2DMS iimage2DMSArray iimage2DRect iimage3D iimageBuffer iimageCube iimageCubeArray image1D image1DArray image2D image2DArray image2DMS image2DMSArray image2DRect image3D imageBuffer imageCube imageCubeArray int isampler1D isampler1DArray isampler2D isampler2DArray isampler2DMS isampler2DMSArray isampler2DRect isampler3D isamplerBuffer isamplerCube isamplerCubeArray ivec2 ivec3 ivec4 mat2 mat2x2 mat2x3 mat2x4 mat3 mat3x2 mat3x3 mat3x4 mat4 mat4x2 mat4x3 mat4x4 sampler1D sampler1DArray sampler1DArrayShadow sampler1DShadow sampler2D sampler2DArray sampler2DArrayShadow sampler2DMS sampler2DMSArray sampler2DRect sampler2DRectShadow sampler2DShadow sampler3D samplerBuffer samplerCube samplerCubeArray samplerCubeArrayShadow samplerCubeShadow image1D uimage1DArray uimage2D uimage2DArray uimage2DMS uimage2DMSArray uimage2DRect uimage3D uimageBuffer uimageCube uimageCubeArray uint usampler1D usampler1DArray usampler2D usampler2DArray usampler2DMS usampler2DMSArray usampler2DRect usampler3D samplerBuffer usamplerCube usamplerCubeArray uvec2 uvec3 uvec4 vec2 vec3 vec4 void`,
                    built_in: `gl_MaxAtomicCounterBindings gl_MaxAtomicCounterBufferSize gl_MaxClipDistances gl_MaxClipPlanes gl_MaxCombinedAtomicCounterBuffers gl_MaxCombinedAtomicCounters gl_MaxCombinedImageUniforms gl_MaxCombinedImageUnitsAndFragmentOutputs gl_MaxCombinedTextureImageUnits gl_MaxComputeAtomicCounterBuffers gl_MaxComputeAtomicCounters gl_MaxComputeImageUniforms gl_MaxComputeTextureImageUnits gl_MaxComputeUniformComponents gl_MaxComputeWorkGroupCount gl_MaxComputeWorkGroupSize gl_MaxDrawBuffers gl_MaxFragmentAtomicCounterBuffers gl_MaxFragmentAtomicCounters gl_MaxFragmentImageUniforms gl_MaxFragmentInputComponents gl_MaxFragmentInputVectors gl_MaxFragmentUniformComponents gl_MaxFragmentUniformVectors gl_MaxGeometryAtomicCounterBuffers gl_MaxGeometryAtomicCounters gl_MaxGeometryImageUniforms gl_MaxGeometryInputComponents gl_MaxGeometryOutputComponents gl_MaxGeometryOutputVertices gl_MaxGeometryTextureImageUnits gl_MaxGeometryTotalOutputComponents gl_MaxGeometryUniformComponents gl_MaxGeometryVaryingComponents gl_MaxImageSamples gl_MaxImageUnits gl_MaxLights gl_MaxPatchVertices gl_MaxProgramTexelOffset gl_MaxTessControlAtomicCounterBuffers gl_MaxTessControlAtomicCounters gl_MaxTessControlImageUniforms gl_MaxTessControlInputComponents gl_MaxTessControlOutputComponents gl_MaxTessControlTextureImageUnits gl_MaxTessControlTotalOutputComponents gl_MaxTessControlUniformComponents gl_MaxTessEvaluationAtomicCounterBuffers gl_MaxTessEvaluationAtomicCounters gl_MaxTessEvaluationImageUniforms gl_MaxTessEvaluationInputComponents gl_MaxTessEvaluationOutputComponents gl_MaxTessEvaluationTextureImageUnits gl_MaxTessEvaluationUniformComponents gl_MaxTessGenLevel gl_MaxTessPatchComponents gl_MaxTextureCoords gl_MaxTextureImageUnits gl_MaxTextureUnits gl_MaxVaryingComponents gl_MaxVaryingFloats gl_MaxVaryingVectors gl_MaxVertexAtomicCounterBuffers gl_MaxVertexAtomicCounters gl_MaxVertexAttribs gl_MaxVertexImageUniforms gl_MaxVertexOutputComponents gl_MaxVertexOutputVectors gl_MaxVertexTextureImageUnits gl_MaxVertexUniformComponents gl_MaxVertexUniformVectors gl_MaxViewports gl_MinProgramTexelOffset gl_BackColor gl_BackLightModelProduct gl_BackLightProduct gl_BackMaterial gl_BackSecondaryColor gl_ClipDistance gl_ClipPlane gl_ClipVertex gl_Color gl_DepthRange gl_EyePlaneQ gl_EyePlaneR gl_EyePlaneS gl_EyePlaneT gl_Fog gl_FogCoord gl_FogFragCoord gl_FragColor gl_FragCoord gl_FragData gl_FragDepth gl_FrontColor gl_FrontFacing gl_FrontLightModelProduct gl_FrontLightProduct gl_FrontMaterial gl_FrontSecondaryColor gl_GlobalInvocationID gl_InstanceID gl_InvocationID gl_Layer gl_LightModel gl_LightSource gl_LocalInvocationID gl_LocalInvocationIndex gl_ModelViewMatrix gl_ModelViewMatrixInverse gl_ModelViewMatrixInverseTranspose gl_ModelViewMatrixTranspose gl_ModelViewProjectionMatrix gl_ModelViewProjectionMatrixInverse gl_ModelViewProjectionMatrixInverseTranspose gl_ModelViewProjectionMatrixTranspose gl_MultiTexCoord0 gl_MultiTexCoord1 gl_MultiTexCoord2 gl_MultiTexCoord3 gl_MultiTexCoord4 gl_MultiTexCoord5 gl_MultiTexCoord6 gl_MultiTexCoord7 gl_Normal gl_NormalMatrix gl_NormalScale gl_NumSamples gl_NumWorkGroups gl_ObjectPlaneQ gl_ObjectPlaneR gl_ObjectPlaneS gl_ObjectPlaneT gl_PatchVerticesIn gl_Point gl_PointCoord gl_PointSize gl_Position gl_PrimitiveID gl_PrimitiveIDIn gl_ProjectionMatrix gl_ProjectionMatrixInverse gl_ProjectionMatrixInverseTranspose gl_ProjectionMatrixTranspose gl_SampleID gl_SampleMask gl_SampleMaskIn gl_SamplePosition gl_SecondaryColor gl_TessCoord gl_TessLevelInner gl_TessLevelOuter gl_TexCoord gl_TextureEnvColor gl_TextureMatrix gl_TextureMatrixInverse gl_TextureMatrixInverseTranspose gl_TextureMatrixTranspose gl_Vertex gl_VertexID gl_ViewportIndex gl_WorkGroupID gl_WorkGroupSize gl_in gl_out EmitStreamVertex EmitVertex EndPrimitive EndStreamPrimitive abs acos acosh all any asin asinh atan atanh atomicAdd atomicAnd atomicCompSwap atomicCounter atomicCounterDecrement atomicCounterIncrement atomicExchange atomicMax atomicMin atomicOr atomicXor barrier bitCount bitfieldExtract bitfieldInsert bitfieldReverse ceil clamp cos cosh cross dFdx dFdy degrees determinant distance dot equal exp exp2 faceforward findLSB findMSB floatBitsToInt floatBitsToUint floor fma fract frexp ftransform fwidth greaterThan greaterThanEqual groupMemoryBarrier imageAtomicAdd imageAtomicAnd imageAtomicCompSwap imageAtomicExchange imageAtomicMax imageAtomicMin imageAtomicOr imageAtomicXor imageLoad imageSize imageStore imulExtended intBitsToFloat interpolateAtCentroid interpolateAtOffset interpolateAtSample inverse inversesqrt isinf isnan ldexp length lessThan lessThanEqual log log2 matrixCompMult max memoryBarrier memoryBarrierAtomicCounter memoryBarrierBuffer memoryBarrierImage memoryBarrierShared min mix mod modf noise1 noise2 noise3 noise4 normalize not notEqual outerProduct packDouble2x32 packHalf2x16 packSnorm2x16 packSnorm4x8 packUnorm2x16 packUnorm4x8 pow radians reflect refract round roundEven shadow1D shadow1DLod shadow1DProj shadow1DProjLod shadow2D shadow2DLod shadow2DProj shadow2DProjLod sign sin sinh smoothstep sqrt step tan tanh texelFetch texelFetchOffset texture texture1D texture1DLod texture1DProj texture1DProjLod texture2D texture2DLod texture2DProj texture2DProjLod texture3D texture3DLod texture3DProj texture3DProjLod textureCube textureCubeLod textureGather textureGatherOffset textureGatherOffsets textureGrad textureGradOffset textureLod textureLodOffset textureOffset textureProj textureProjGrad textureProjGradOffset textureProjLod textureProjLodOffset textureProjOffset textureQueryLevels textureQueryLod textureSize transpose trunc uaddCarry uintBitsToFloat umulExtended unpackDouble2x32 unpackHalf2x16 unpackSnorm2x16 unpackSnorm4x8 unpackUnorm2x16 unpackUnorm4x8 usubBorrow`,
                    literal: `true false`
                },
                illegal: `"`,
                contains: [
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    e.C_NUMBER_MODE,
                    {
                        className: `meta`,
                        begin: `#`,
                        end: `$`
                    }
                ]
            };
        }
        t.exports = n;
    }), Oe = o((e, t)=>{
        function n(e) {
            return {
                name: `GML`,
                case_insensitive: !1,
                keywords: {
                    keyword: `#endregion.#macro.#region.and.begin.break.case.constructor.continue.default.delete.div.do.else.end.enum.exit.for.function.globalvar.if.mod.new.not.or.repeat.return.static.switch.then.until.var.while.with.xor`.split(`.`),
                    built_in: `abs.alarm_get.alarm_set.angle_difference.animcurve_channel_evaluate.animcurve_channel_new.animcurve_create.animcurve_destroy.animcurve_exists.animcurve_get.animcurve_get_channel.animcurve_get_channel_index.animcurve_point_new.ansi_char.application_get_position.application_surface_draw_enable.application_surface_enable.application_surface_is_enabled.arccos.arcsin.arctan.arctan2.array_all.array_any.array_concat.array_contains.array_contains_ext.array_copy.array_copy_while.array_create.array_create_ext.array_delete.array_equals.array_filter.array_filter_ext.array_find_index.array_first.array_foreach.array_get.array_get_index.array_insert.array_intersection.array_last.array_length.array_map.array_map_ext.array_pop.array_push.array_reduce.array_resize.array_reverse.array_reverse_ext.array_set.array_shuffle.array_shuffle_ext.array_sort.array_union.array_unique.array_unique_ext.asset_add_tags.asset_clear_tags.asset_get_ids.asset_get_index.asset_get_tags.asset_get_type.asset_has_any_tag.asset_has_tags.asset_remove_tags.audio_bus_clear_emitters.audio_bus_create.audio_bus_get_emitters.audio_channel_num.audio_create_buffer_sound.audio_create_play_queue.audio_create_stream.audio_create_sync_group.audio_debug.audio_destroy_stream.audio_destroy_sync_group.audio_effect_create.audio_emitter_bus.audio_emitter_create.audio_emitter_exists.audio_emitter_falloff.audio_emitter_free.audio_emitter_gain.audio_emitter_get_bus.audio_emitter_get_gain.audio_emitter_get_listener_mask.audio_emitter_get_pitch.audio_emitter_get_vx.audio_emitter_get_vy.audio_emitter_get_vz.audio_emitter_get_x.audio_emitter_get_y.audio_emitter_get_z.audio_emitter_pitch.audio_emitter_position.audio_emitter_set_listener_mask.audio_emitter_velocity.audio_exists.audio_falloff_set_model.audio_free_buffer_sound.audio_free_play_queue.audio_get_listener_count.audio_get_listener_info.audio_get_listener_mask.audio_get_master_gain.audio_get_name.audio_get_recorder_count.audio_get_recorder_info.audio_get_type.audio_group_get_assets.audio_group_get_gain.audio_group_is_loaded.audio_group_load.audio_group_load_progress.audio_group_name.audio_group_set_gain.audio_group_stop_all.audio_group_unload.audio_is_paused.audio_is_playing.audio_listener_get_data.audio_listener_orientation.audio_listener_position.audio_listener_set_orientation.audio_listener_set_position.audio_listener_set_velocity.audio_listener_velocity.audio_master_gain.audio_pause_all.audio_pause_sound.audio_pause_sync_group.audio_play_in_sync_group.audio_play_sound.audio_play_sound_at.audio_play_sound_ext.audio_play_sound_on.audio_queue_sound.audio_resume_all.audio_resume_sound.audio_resume_sync_group.audio_set_listener_mask.audio_set_master_gain.audio_sound_gain.audio_sound_get_audio_group.audio_sound_get_gain.audio_sound_get_listener_mask.audio_sound_get_loop.audio_sound_get_loop_end.audio_sound_get_loop_start.audio_sound_get_pitch.audio_sound_get_track_position.audio_sound_is_playable.audio_sound_length.audio_sound_loop.audio_sound_loop_end.audio_sound_loop_start.audio_sound_pitch.audio_sound_set_listener_mask.audio_sound_set_track_position.audio_start_recording.audio_start_sync_group.audio_stop_all.audio_stop_recording.audio_stop_sound.audio_stop_sync_group.audio_sync_group_debug.audio_sync_group_get_track_pos.audio_sync_group_is_paused.audio_sync_group_is_playing.audio_system_is_available.audio_system_is_initialised.base64_decode.base64_encode.bool.browser_input_capture.buffer_async_group_begin.buffer_async_group_end.buffer_async_group_option.buffer_base64_decode.buffer_base64_decode_ext.buffer_base64_encode.buffer_compress.buffer_copy.buffer_copy_from_vertex_buffer.buffer_copy_stride.buffer_crc32.buffer_create.buffer_create_from_vertex_buffer.buffer_create_from_vertex_buffer_ext.buffer_decompress.buffer_delete.buffer_exists.buffer_fill.buffer_get_address.buffer_get_alignment.buffer_get_size.buffer_get_surface.buffer_get_type.buffer_load.buffer_load_async.buffer_load_ext.buffer_load_partial.buffer_md5.buffer_peek.buffer_poke.buffer_read.buffer_resize.buffer_save.buffer_save_async.buffer_save_ext.buffer_seek.buffer_set_surface.buffer_set_used_size.buffer_sha1.buffer_sizeof.buffer_tell.buffer_write.call_cancel.call_later.camera_apply.camera_copy_transforms.camera_create.camera_create_view.camera_destroy.camera_get_active.camera_get_begin_script.camera_get_default.camera_get_end_script.camera_get_proj_mat.camera_get_update_script.camera_get_view_angle.camera_get_view_border_x.camera_get_view_border_y.camera_get_view_height.camera_get_view_mat.camera_get_view_speed_x.camera_get_view_speed_y.camera_get_view_target.camera_get_view_width.camera_get_view_x.camera_get_view_y.camera_set_begin_script.camera_set_default.camera_set_end_script.camera_set_proj_mat.camera_set_update_script.camera_set_view_angle.camera_set_view_border.camera_set_view_mat.camera_set_view_pos.camera_set_view_size.camera_set_view_speed.camera_set_view_target.ceil.choose.chr.clamp.clickable_add.clickable_add_ext.clickable_change.clickable_change_ext.clickable_delete.clickable_exists.clickable_set_style.clipboard_get_text.clipboard_has_text.clipboard_set_text.cloud_file_save.cloud_string_save.cloud_synchronise.code_is_compiled.collision_circle.collision_circle_list.collision_ellipse.collision_ellipse_list.collision_line.collision_line_list.collision_point.collision_point_list.collision_rectangle.collision_rectangle_list.color_get_blue.color_get_green.color_get_hue.color_get_red.color_get_saturation.color_get_value.colour_get_blue.colour_get_green.colour_get_hue.colour_get_red.colour_get_saturation.colour_get_value.cos.darccos.darcsin.darctan.darctan2.date_compare_date.date_compare_datetime.date_compare_time.date_create_datetime.date_current_datetime.date_date_of.date_date_string.date_datetime_string.date_day_span.date_days_in_month.date_days_in_year.date_get_day.date_get_day_of_year.date_get_hour.date_get_hour_of_year.date_get_minute.date_get_minute_of_year.date_get_month.date_get_second.date_get_second_of_year.date_get_timezone.date_get_week.date_get_weekday.date_get_year.date_hour_span.date_inc_day.date_inc_hour.date_inc_minute.date_inc_month.date_inc_second.date_inc_week.date_inc_year.date_is_today.date_leap_year.date_minute_span.date_month_span.date_second_span.date_set_timezone.date_time_of.date_time_string.date_valid_datetime.date_week_span.date_year_span.db_to_lin.dbg_add_font_glyphs.dbg_button.dbg_checkbox.dbg_color.dbg_colour.dbg_drop_down.dbg_same_line.dbg_section.dbg_section_delete.dbg_section_exists.dbg_slider.dbg_slider_int.dbg_sprite.dbg_text.dbg_text_input.dbg_view.dbg_view_delete.dbg_view_exists.dbg_watch.dcos.debug_event.debug_get_callstack.degtorad.device_get_tilt_x.device_get_tilt_y.device_get_tilt_z.device_is_keypad_open.device_mouse_check_button.device_mouse_check_button_pressed.device_mouse_check_button_released.device_mouse_dbclick_enable.device_mouse_raw_x.device_mouse_raw_y.device_mouse_x.device_mouse_x_to_gui.device_mouse_y.device_mouse_y_to_gui.directory_create.directory_destroy.directory_exists.display_get_dpi_x.display_get_dpi_y.display_get_frequency.display_get_gui_height.display_get_gui_width.display_get_height.display_get_orientation.display_get_sleep_margin.display_get_timing_method.display_get_width.display_mouse_get_x.display_mouse_get_y.display_mouse_set.display_reset.display_set_gui_maximise.display_set_gui_maximize.display_set_gui_size.display_set_sleep_margin.display_set_timing_method.display_set_ui_visibility.distance_to_object.distance_to_point.dot_product.dot_product_3d.dot_product_3d_normalised.dot_product_3d_normalized.dot_product_normalised.dot_product_normalized.draw_arrow.draw_button.draw_circle.draw_circle_color.draw_circle_colour.draw_clear.draw_clear_alpha.draw_ellipse.draw_ellipse_color.draw_ellipse_colour.draw_enable_drawevent.draw_enable_skeleton_blendmodes.draw_enable_swf_aa.draw_flush.draw_get_alpha.draw_get_color.draw_get_colour.draw_get_enable_skeleton_blendmodes.draw_get_font.draw_get_halign.draw_get_lighting.draw_get_swf_aa_level.draw_get_valign.draw_getpixel.draw_getpixel_ext.draw_healthbar.draw_highscore.draw_light_define_ambient.draw_light_define_direction.draw_light_define_point.draw_light_enable.draw_light_get.draw_light_get_ambient.draw_line.draw_line_color.draw_line_colour.draw_line_width.draw_line_width_color.draw_line_width_colour.draw_path.draw_point.draw_point_color.draw_point_colour.draw_primitive_begin.draw_primitive_begin_texture.draw_primitive_end.draw_rectangle.draw_rectangle_color.draw_rectangle_colour.draw_roundrect.draw_roundrect_color.draw_roundrect_color_ext.draw_roundrect_colour.draw_roundrect_colour_ext.draw_roundrect_ext.draw_self.draw_set_alpha.draw_set_circle_precision.draw_set_color.draw_set_colour.draw_set_font.draw_set_halign.draw_set_lighting.draw_set_swf_aa_level.draw_set_valign.draw_skeleton.draw_skeleton_collision.draw_skeleton_instance.draw_skeleton_time.draw_sprite.draw_sprite_ext.draw_sprite_general.draw_sprite_part.draw_sprite_part_ext.draw_sprite_pos.draw_sprite_stretched.draw_sprite_stretched_ext.draw_sprite_tiled.draw_sprite_tiled_ext.draw_surface.draw_surface_ext.draw_surface_general.draw_surface_part.draw_surface_part_ext.draw_surface_stretched.draw_surface_stretched_ext.draw_surface_tiled.draw_surface_tiled_ext.draw_text.draw_text_color.draw_text_colour.draw_text_ext.draw_text_ext_color.draw_text_ext_colour.draw_text_ext_transformed.draw_text_ext_transformed_color.draw_text_ext_transformed_colour.draw_text_transformed.draw_text_transformed_color.draw_text_transformed_colour.draw_texture_flush.draw_tile.draw_tilemap.draw_triangle.draw_triangle_color.draw_triangle_colour.draw_vertex.draw_vertex_color.draw_vertex_colour.draw_vertex_texture.draw_vertex_texture_color.draw_vertex_texture_colour.ds_exists.ds_grid_add.ds_grid_add_disk.ds_grid_add_grid_region.ds_grid_add_region.ds_grid_clear.ds_grid_copy.ds_grid_create.ds_grid_destroy.ds_grid_get.ds_grid_get_disk_max.ds_grid_get_disk_mean.ds_grid_get_disk_min.ds_grid_get_disk_sum.ds_grid_get_max.ds_grid_get_mean.ds_grid_get_min.ds_grid_get_sum.ds_grid_height.ds_grid_multiply.ds_grid_multiply_disk.ds_grid_multiply_grid_region.ds_grid_multiply_region.ds_grid_read.ds_grid_resize.ds_grid_set.ds_grid_set_disk.ds_grid_set_grid_region.ds_grid_set_region.ds_grid_shuffle.ds_grid_sort.ds_grid_to_mp_grid.ds_grid_value_disk_exists.ds_grid_value_disk_x.ds_grid_value_disk_y.ds_grid_value_exists.ds_grid_value_x.ds_grid_value_y.ds_grid_width.ds_grid_write.ds_list_add.ds_list_clear.ds_list_copy.ds_list_create.ds_list_delete.ds_list_destroy.ds_list_empty.ds_list_find_index.ds_list_find_value.ds_list_insert.ds_list_is_list.ds_list_is_map.ds_list_mark_as_list.ds_list_mark_as_map.ds_list_read.ds_list_replace.ds_list_set.ds_list_shuffle.ds_list_size.ds_list_sort.ds_list_write.ds_map_add.ds_map_add_list.ds_map_add_map.ds_map_clear.ds_map_copy.ds_map_create.ds_map_delete.ds_map_destroy.ds_map_empty.ds_map_exists.ds_map_find_first.ds_map_find_last.ds_map_find_next.ds_map_find_previous.ds_map_find_value.ds_map_is_list.ds_map_is_map.ds_map_keys_to_array.ds_map_read.ds_map_replace.ds_map_replace_list.ds_map_replace_map.ds_map_secure_load.ds_map_secure_load_buffer.ds_map_secure_save.ds_map_secure_save_buffer.ds_map_set.ds_map_size.ds_map_values_to_array.ds_map_write.ds_priority_add.ds_priority_change_priority.ds_priority_clear.ds_priority_copy.ds_priority_create.ds_priority_delete_max.ds_priority_delete_min.ds_priority_delete_value.ds_priority_destroy.ds_priority_empty.ds_priority_find_max.ds_priority_find_min.ds_priority_find_priority.ds_priority_read.ds_priority_size.ds_priority_write.ds_queue_clear.ds_queue_copy.ds_queue_create.ds_queue_dequeue.ds_queue_destroy.ds_queue_empty.ds_queue_enqueue.ds_queue_head.ds_queue_read.ds_queue_size.ds_queue_tail.ds_queue_write.ds_set_precision.ds_stack_clear.ds_stack_copy.ds_stack_create.ds_stack_destroy.ds_stack_empty.ds_stack_pop.ds_stack_push.ds_stack_read.ds_stack_size.ds_stack_top.ds_stack_write.dsin.dtan.effect_clear.effect_create_above.effect_create_below.effect_create_depth.effect_create_layer.environment_get_variable.event_inherited.event_perform.event_perform_async.event_perform_object.event_user.exception_unhandled_handler.exp.extension_exists.extension_get_option_count.extension_get_option_names.extension_get_option_value.extension_get_options.extension_get_version.external_call.external_define.external_free.file_attributes.file_bin_close.file_bin_open.file_bin_position.file_bin_read_byte.file_bin_rewrite.file_bin_seek.file_bin_size.file_bin_write_byte.file_copy.file_delete.file_exists.file_find_close.file_find_first.file_find_next.file_rename.file_text_close.file_text_eof.file_text_eoln.file_text_open_append.file_text_open_from_string.file_text_open_read.file_text_open_write.file_text_read_real.file_text_read_string.file_text_readln.file_text_write_real.file_text_write_string.file_text_writeln.filename_change_ext.filename_dir.filename_drive.filename_ext.filename_name.filename_path.floor.font_add.font_add_enable_aa.font_add_get_enable_aa.font_add_sprite.font_add_sprite_ext.font_cache_glyph.font_delete.font_enable_effects.font_enable_sdf.font_exists.font_get_bold.font_get_first.font_get_fontname.font_get_info.font_get_italic.font_get_last.font_get_name.font_get_sdf_enabled.font_get_sdf_spread.font_get_size.font_get_texture.font_get_uvs.font_replace_sprite.font_replace_sprite_ext.font_sdf_spread.font_set_cache_size.frac.fx_create.fx_get_name.fx_get_parameter.fx_get_parameter_names.fx_get_parameters.fx_get_single_layer.fx_set_parameter.fx_set_parameters.fx_set_single_layer.game_change.game_end.game_get_speed.game_load.game_load_buffer.game_restart.game_save.game_save_buffer.game_set_speed.gamepad_axis_count.gamepad_axis_value.gamepad_button_check.gamepad_button_check_pressed.gamepad_button_check_released.gamepad_button_count.gamepad_button_value.gamepad_get_axis_deadzone.gamepad_get_button_threshold.gamepad_get_description.gamepad_get_device_count.gamepad_get_guid.gamepad_get_mapping.gamepad_get_option.gamepad_hat_count.gamepad_hat_value.gamepad_is_connected.gamepad_is_supported.gamepad_remove_mapping.gamepad_set_axis_deadzone.gamepad_set_button_threshold.gamepad_set_color.gamepad_set_colour.gamepad_set_option.gamepad_set_vibration.gamepad_test_mapping.gc_collect.gc_enable.gc_get_stats.gc_get_target_frame_time.gc_is_enabled.gc_target_frame_time.gesture_double_tap_distance.gesture_double_tap_time.gesture_drag_distance.gesture_drag_time.gesture_flick_speed.gesture_get_double_tap_distance.gesture_get_double_tap_time.gesture_get_drag_distance.gesture_get_drag_time.gesture_get_flick_speed.gesture_get_pinch_angle_away.gesture_get_pinch_angle_towards.gesture_get_pinch_distance.gesture_get_rotate_angle.gesture_get_rotate_time.gesture_get_tap_count.gesture_pinch_angle_away.gesture_pinch_angle_towards.gesture_pinch_distance.gesture_rotate_angle.gesture_rotate_time.gesture_tap_count.get_integer.get_integer_async.get_login_async.get_open_filename.get_open_filename_ext.get_save_filename.get_save_filename_ext.get_string.get_string_async.get_timer.gif_add_surface.gif_open.gif_save.gif_save_buffer.gml_pragma.gml_release_mode.gpu_get_alphatestenable.gpu_get_alphatestref.gpu_get_blendenable.gpu_get_blendmode.gpu_get_blendmode_dest.gpu_get_blendmode_destalpha.gpu_get_blendmode_ext.gpu_get_blendmode_ext_sepalpha.gpu_get_blendmode_src.gpu_get_blendmode_srcalpha.gpu_get_colorwriteenable.gpu_get_colourwriteenable.gpu_get_cullmode.gpu_get_depth.gpu_get_fog.gpu_get_state.gpu_get_tex_filter.gpu_get_tex_filter_ext.gpu_get_tex_max_aniso.gpu_get_tex_max_aniso_ext.gpu_get_tex_max_mip.gpu_get_tex_max_mip_ext.gpu_get_tex_min_mip.gpu_get_tex_min_mip_ext.gpu_get_tex_mip_bias.gpu_get_tex_mip_bias_ext.gpu_get_tex_mip_enable.gpu_get_tex_mip_enable_ext.gpu_get_tex_mip_filter.gpu_get_tex_mip_filter_ext.gpu_get_tex_repeat.gpu_get_tex_repeat_ext.gpu_get_texfilter.gpu_get_texfilter_ext.gpu_get_texrepeat.gpu_get_texrepeat_ext.gpu_get_zfunc.gpu_get_ztestenable.gpu_get_zwriteenable.gpu_pop_state.gpu_push_state.gpu_set_alphatestenable.gpu_set_alphatestref.gpu_set_blendenable.gpu_set_blendmode.gpu_set_blendmode_ext.gpu_set_blendmode_ext_sepalpha.gpu_set_colorwriteenable.gpu_set_colourwriteenable.gpu_set_cullmode.gpu_set_depth.gpu_set_fog.gpu_set_state.gpu_set_tex_filter.gpu_set_tex_filter_ext.gpu_set_tex_max_aniso.gpu_set_tex_max_aniso_ext.gpu_set_tex_max_mip.gpu_set_tex_max_mip_ext.gpu_set_tex_min_mip.gpu_set_tex_min_mip_ext.gpu_set_tex_mip_bias.gpu_set_tex_mip_bias_ext.gpu_set_tex_mip_enable.gpu_set_tex_mip_enable_ext.gpu_set_tex_mip_filter.gpu_set_tex_mip_filter_ext.gpu_set_tex_repeat.gpu_set_tex_repeat_ext.gpu_set_texfilter.gpu_set_texfilter_ext.gpu_set_texrepeat.gpu_set_texrepeat_ext.gpu_set_zfunc.gpu_set_ztestenable.gpu_set_zwriteenable.handle_parse.highscore_add.highscore_clear.highscore_name.highscore_value.http_get.http_get_file.http_get_request_crossorigin.http_post_string.http_request.http_set_request_crossorigin.iap_acquire.iap_activate.iap_consume.iap_enumerate_products.iap_product_details.iap_purchase_details.iap_restore_all.iap_status.ini_close.ini_key_delete.ini_key_exists.ini_open.ini_open_from_string.ini_read_real.ini_read_string.ini_section_delete.ini_section_exists.ini_write_real.ini_write_string.instance_activate_all.instance_activate_layer.instance_activate_object.instance_activate_region.instance_change.instance_copy.instance_create_depth.instance_create_layer.instance_deactivate_all.instance_deactivate_layer.instance_deactivate_object.instance_deactivate_region.instance_destroy.instance_exists.instance_find.instance_furthest.instance_id_get.instance_nearest.instance_number.instance_place.instance_place_list.instance_position.instance_position_list.instanceof.int64.io_clear.irandom.irandom_range.is_array.is_bool.is_callable.is_debug_overlay_open.is_handle.is_infinity.is_instanceof.is_int32.is_int64.is_keyboard_used_debug_overlay.is_method.is_mouse_over_debug_overlay.is_nan.is_numeric.is_ptr.is_real.is_string.is_struct.is_undefined.json_decode.json_encode.json_parse.json_stringify.keyboard_check.keyboard_check_direct.keyboard_check_pressed.keyboard_check_released.keyboard_clear.keyboard_get_map.keyboard_get_numlock.keyboard_key_press.keyboard_key_release.keyboard_set_map.keyboard_set_numlock.keyboard_unset_map.keyboard_virtual_height.keyboard_virtual_hide.keyboard_virtual_show.keyboard_virtual_status.layer_add_instance.layer_background_alpha.layer_background_blend.layer_background_change.layer_background_create.layer_background_destroy.layer_background_exists.layer_background_get_alpha.layer_background_get_blend.layer_background_get_htiled.layer_background_get_id.layer_background_get_index.layer_background_get_speed.layer_background_get_sprite.layer_background_get_stretch.layer_background_get_visible.layer_background_get_vtiled.layer_background_get_xscale.layer_background_get_yscale.layer_background_htiled.layer_background_index.layer_background_speed.layer_background_sprite.layer_background_stretch.layer_background_visible.layer_background_vtiled.layer_background_xscale.layer_background_yscale.layer_clear_fx.layer_create.layer_depth.layer_destroy.layer_destroy_instances.layer_element_move.layer_enable_fx.layer_exists.layer_force_draw_depth.layer_fx_is_enabled.layer_get_all.layer_get_all_elements.layer_get_depth.layer_get_element_layer.layer_get_element_type.layer_get_forced_depth.layer_get_fx.layer_get_hspeed.layer_get_id.layer_get_id_at_depth.layer_get_name.layer_get_script_begin.layer_get_script_end.layer_get_shader.layer_get_target_room.layer_get_visible.layer_get_vspeed.layer_get_x.layer_get_y.layer_has_instance.layer_hspeed.layer_instance_get_instance.layer_is_draw_depth_forced.layer_reset_target_room.layer_script_begin.layer_script_end.layer_sequence_angle.layer_sequence_create.layer_sequence_destroy.layer_sequence_exists.layer_sequence_get_angle.layer_sequence_get_headdir.layer_sequence_get_headpos.layer_sequence_get_instance.layer_sequence_get_length.layer_sequence_get_sequence.layer_sequence_get_speedscale.layer_sequence_get_x.layer_sequence_get_xscale.layer_sequence_get_y.layer_sequence_get_yscale.layer_sequence_headdir.layer_sequence_headpos.layer_sequence_is_finished.layer_sequence_is_paused.layer_sequence_pause.layer_sequence_play.layer_sequence_speedscale.layer_sequence_x.layer_sequence_xscale.layer_sequence_y.layer_sequence_yscale.layer_set_fx.layer_set_target_room.layer_set_visible.layer_shader.layer_sprite_alpha.layer_sprite_angle.layer_sprite_blend.layer_sprite_change.layer_sprite_create.layer_sprite_destroy.layer_sprite_exists.layer_sprite_get_alpha.layer_sprite_get_angle.layer_sprite_get_blend.layer_sprite_get_id.layer_sprite_get_index.layer_sprite_get_speed.layer_sprite_get_sprite.layer_sprite_get_x.layer_sprite_get_xscale.layer_sprite_get_y.layer_sprite_get_yscale.layer_sprite_index.layer_sprite_speed.layer_sprite_x.layer_sprite_xscale.layer_sprite_y.layer_sprite_yscale.layer_tile_alpha.layer_tile_blend.layer_tile_change.layer_tile_create.layer_tile_destroy.layer_tile_exists.layer_tile_get_alpha.layer_tile_get_blend.layer_tile_get_region.layer_tile_get_sprite.layer_tile_get_visible.layer_tile_get_x.layer_tile_get_xscale.layer_tile_get_y.layer_tile_get_yscale.layer_tile_region.layer_tile_visible.layer_tile_x.layer_tile_xscale.layer_tile_y.layer_tile_yscale.layer_tilemap_create.layer_tilemap_destroy.layer_tilemap_exists.layer_tilemap_get_id.layer_vspeed.layer_x.layer_y.lengthdir_x.lengthdir_y.lerp.lin_to_db.ln.load_csv.log10.log2.logn.make_color_hsv.make_color_rgb.make_colour_hsv.make_colour_rgb.math_get_epsilon.math_set_epsilon.matrix_build.matrix_build_identity.matrix_build_lookat.matrix_build_projection_ortho.matrix_build_projection_perspective.matrix_build_projection_perspective_fov.matrix_get.matrix_multiply.matrix_set.matrix_stack_clear.matrix_stack_is_empty.matrix_stack_pop.matrix_stack_push.matrix_stack_set.matrix_stack_top.matrix_transform_vertex.max.md5_file.md5_string_unicode.md5_string_utf8.mean.median.merge_color.merge_colour.method.method_call.method_get_index.method_get_self.min.motion_add.motion_set.mouse_check_button.mouse_check_button_pressed.mouse_check_button_released.mouse_clear.mouse_wheel_down.mouse_wheel_up.move_and_collide.move_bounce_all.move_bounce_solid.move_contact_all.move_contact_solid.move_outside_all.move_outside_solid.move_random.move_snap.move_towards_point.move_wrap.mp_grid_add_cell.mp_grid_add_instances.mp_grid_add_rectangle.mp_grid_clear_all.mp_grid_clear_cell.mp_grid_clear_rectangle.mp_grid_create.mp_grid_destroy.mp_grid_draw.mp_grid_get_cell.mp_grid_path.mp_grid_to_ds_grid.mp_linear_path.mp_linear_path_object.mp_linear_step.mp_linear_step_object.mp_potential_path.mp_potential_path_object.mp_potential_settings.mp_potential_step.mp_potential_step_object.nameof.network_connect.network_connect_async.network_connect_raw.network_connect_raw_async.network_create_server.network_create_server_raw.network_create_socket.network_create_socket_ext.network_destroy.network_resolve.network_send_broadcast.network_send_packet.network_send_raw.network_send_udp.network_send_udp_raw.network_set_config.network_set_timeout.object_exists.object_get_mask.object_get_name.object_get_parent.object_get_persistent.object_get_physics.object_get_solid.object_get_sprite.object_get_visible.object_is_ancestor.object_set_mask.object_set_persistent.object_set_solid.object_set_sprite.object_set_visible.ord.os_check_permission.os_get_config.os_get_info.os_get_language.os_get_region.os_is_network_connected.os_is_paused.os_lock_orientation.os_powersave_enable.os_request_permission.os_set_orientation_lock.parameter_count.parameter_string.part_emitter_burst.part_emitter_clear.part_emitter_create.part_emitter_delay.part_emitter_destroy.part_emitter_destroy_all.part_emitter_enable.part_emitter_exists.part_emitter_interval.part_emitter_region.part_emitter_relative.part_emitter_stream.part_particles_burst.part_particles_clear.part_particles_count.part_particles_create.part_particles_create_color.part_particles_create_colour.part_system_angle.part_system_automatic_draw.part_system_automatic_update.part_system_clear.part_system_color.part_system_colour.part_system_create.part_system_create_layer.part_system_depth.part_system_destroy.part_system_draw_order.part_system_drawit.part_system_exists.part_system_get_info.part_system_get_layer.part_system_global_space.part_system_layer.part_system_position.part_system_update.part_type_alpha1.part_type_alpha2.part_type_alpha3.part_type_blend.part_type_clear.part_type_color1.part_type_color2.part_type_color3.part_type_color_hsv.part_type_color_mix.part_type_color_rgb.part_type_colour1.part_type_colour2.part_type_colour3.part_type_colour_hsv.part_type_colour_mix.part_type_colour_rgb.part_type_create.part_type_death.part_type_destroy.part_type_direction.part_type_exists.part_type_gravity.part_type_life.part_type_orientation.part_type_scale.part_type_shape.part_type_size.part_type_size_x.part_type_size_y.part_type_speed.part_type_sprite.part_type_step.part_type_subimage.particle_exists.particle_get_info.path_add.path_add_point.path_append.path_assign.path_change_point.path_clear_points.path_delete.path_delete_point.path_duplicate.path_end.path_exists.path_flip.path_get_closed.path_get_kind.path_get_length.path_get_name.path_get_number.path_get_point_speed.path_get_point_x.path_get_point_y.path_get_precision.path_get_speed.path_get_x.path_get_y.path_insert_point.path_mirror.path_rescale.path_reverse.path_rotate.path_set_closed.path_set_kind.path_set_precision.path_shift.path_start.physics_apply_angular_impulse.physics_apply_force.physics_apply_impulse.physics_apply_local_force.physics_apply_local_impulse.physics_apply_torque.physics_draw_debug.physics_fixture_add_point.physics_fixture_bind.physics_fixture_bind_ext.physics_fixture_create.physics_fixture_delete.physics_fixture_set_angular_damping.physics_fixture_set_awake.physics_fixture_set_box_shape.physics_fixture_set_chain_shape.physics_fixture_set_circle_shape.physics_fixture_set_collision_group.physics_fixture_set_density.physics_fixture_set_edge_shape.physics_fixture_set_friction.physics_fixture_set_kinematic.physics_fixture_set_linear_damping.physics_fixture_set_polygon_shape.physics_fixture_set_restitution.physics_fixture_set_sensor.physics_get_density.physics_get_friction.physics_get_restitution.physics_joint_delete.physics_joint_distance_create.physics_joint_enable_motor.physics_joint_friction_create.physics_joint_gear_create.physics_joint_get_value.physics_joint_prismatic_create.physics_joint_pulley_create.physics_joint_revolute_create.physics_joint_rope_create.physics_joint_set_value.physics_joint_weld_create.physics_joint_wheel_create.physics_mass_properties.physics_particle_count.physics_particle_create.physics_particle_delete.physics_particle_delete_region_box.physics_particle_delete_region_circle.physics_particle_delete_region_poly.physics_particle_draw.physics_particle_draw_ext.physics_particle_get_damping.physics_particle_get_data.physics_particle_get_data_particle.physics_particle_get_density.physics_particle_get_gravity_scale.physics_particle_get_group_flags.physics_particle_get_max_count.physics_particle_get_radius.physics_particle_group_add_point.physics_particle_group_begin.physics_particle_group_box.physics_particle_group_circle.physics_particle_group_count.physics_particle_group_delete.physics_particle_group_end.physics_particle_group_get_ang_vel.physics_particle_group_get_angle.physics_particle_group_get_centre_x.physics_particle_group_get_centre_y.physics_particle_group_get_data.physics_particle_group_get_inertia.physics_particle_group_get_mass.physics_particle_group_get_vel_x.physics_particle_group_get_vel_y.physics_particle_group_get_x.physics_particle_group_get_y.physics_particle_group_join.physics_particle_group_polygon.physics_particle_set_category_flags.physics_particle_set_damping.physics_particle_set_density.physics_particle_set_flags.physics_particle_set_gravity_scale.physics_particle_set_group_flags.physics_particle_set_max_count.physics_particle_set_radius.physics_pause_enable.physics_remove_fixture.physics_set_density.physics_set_friction.physics_set_restitution.physics_test_overlap.physics_world_create.physics_world_draw_debug.physics_world_gravity.physics_world_update_iterations.physics_world_update_speed.place_empty.place_free.place_meeting.place_snapped.point_direction.point_distance.point_distance_3d.point_in_circle.point_in_rectangle.point_in_triangle.position_change.position_destroy.position_empty.position_meeting.power.ptr.radtodeg.random.random_get_seed.random_range.random_set_seed.randomise.randomize.real.rectangle_in_circle.rectangle_in_rectangle.rectangle_in_triangle.ref_create.rollback_chat.rollback_create_game.rollback_define_extra_network_latency.rollback_define_input.rollback_define_input_frame_delay.rollback_define_mock_input.rollback_define_player.rollback_display_events.rollback_get_info.rollback_get_input.rollback_get_player_prefs.rollback_join_game.rollback_leave_game.rollback_set_player_prefs.rollback_start_game.rollback_sync_on_frame.rollback_use_late_join.rollback_use_manual_start.rollback_use_player_prefs.rollback_use_random_input.room_add.room_assign.room_duplicate.room_exists.room_get_camera.room_get_info.room_get_name.room_get_viewport.room_goto.room_goto_next.room_goto_previous.room_instance_add.room_instance_clear.room_next.room_previous.room_restart.room_set_camera.room_set_height.room_set_persistent.room_set_view_enabled.room_set_viewport.room_set_width.round.scheduler_resolution_get.scheduler_resolution_set.screen_save.screen_save_part.script_execute.script_execute_ext.script_exists.script_get_name.sequence_create.sequence_destroy.sequence_exists.sequence_get.sequence_get_objects.sequence_instance_override_object.sequence_keyframe_new.sequence_keyframedata_new.sequence_track_new.sha1_file.sha1_string_unicode.sha1_string_utf8.shader_current.shader_enable_corner_id.shader_get_name.shader_get_sampler_index.shader_get_uniform.shader_is_compiled.shader_reset.shader_set.shader_set_uniform_f.shader_set_uniform_f_array.shader_set_uniform_f_buffer.shader_set_uniform_i.shader_set_uniform_i_array.shader_set_uniform_matrix.shader_set_uniform_matrix_array.shaders_are_supported.shop_leave_rating.show_debug_message.show_debug_message_ext.show_debug_overlay.show_error.show_message.show_message_async.show_question.show_question_async.sign.sin.skeleton_animation_clear.skeleton_animation_get.skeleton_animation_get_duration.skeleton_animation_get_event_frames.skeleton_animation_get_ext.skeleton_animation_get_frame.skeleton_animation_get_frames.skeleton_animation_get_position.skeleton_animation_is_finished.skeleton_animation_is_looping.skeleton_animation_list.skeleton_animation_mix.skeleton_animation_set.skeleton_animation_set_ext.skeleton_animation_set_frame.skeleton_animation_set_position.skeleton_attachment_create.skeleton_attachment_create_color.skeleton_attachment_create_colour.skeleton_attachment_destroy.skeleton_attachment_exists.skeleton_attachment_get.skeleton_attachment_replace.skeleton_attachment_replace_color.skeleton_attachment_replace_colour.skeleton_attachment_set.skeleton_bone_data_get.skeleton_bone_data_set.skeleton_bone_list.skeleton_bone_state_get.skeleton_bone_state_set.skeleton_collision_draw_set.skeleton_find_slot.skeleton_get_bounds.skeleton_get_minmax.skeleton_get_num_bounds.skeleton_skin_create.skeleton_skin_get.skeleton_skin_list.skeleton_skin_set.skeleton_slot_alpha_get.skeleton_slot_color_get.skeleton_slot_color_set.skeleton_slot_colour_get.skeleton_slot_colour_set.skeleton_slot_data.skeleton_slot_data_instance.skeleton_slot_list.sprite_add.sprite_add_ext.sprite_add_from_surface.sprite_assign.sprite_collision_mask.sprite_create_from_surface.sprite_delete.sprite_duplicate.sprite_exists.sprite_flush.sprite_flush_multi.sprite_get_bbox_bottom.sprite_get_bbox_left.sprite_get_bbox_mode.sprite_get_bbox_right.sprite_get_bbox_top.sprite_get_height.sprite_get_info.sprite_get_name.sprite_get_nineslice.sprite_get_number.sprite_get_speed.sprite_get_speed_type.sprite_get_texture.sprite_get_tpe.sprite_get_uvs.sprite_get_width.sprite_get_xoffset.sprite_get_yoffset.sprite_merge.sprite_nineslice_create.sprite_prefetch.sprite_prefetch_multi.sprite_replace.sprite_save.sprite_save_strip.sprite_set_alpha_from_sprite.sprite_set_bbox.sprite_set_bbox_mode.sprite_set_cache_size.sprite_set_cache_size_ext.sprite_set_nineslice.sprite_set_offset.sprite_set_speed.sqr.sqrt.static_get.static_set.string.string_byte_at.string_byte_length.string_char_at.string_concat.string_concat_ext.string_copy.string_count.string_delete.string_digits.string_ends_with.string_ext.string_foreach.string_format.string_hash_to_newline.string_height.string_height_ext.string_insert.string_join.string_join_ext.string_last_pos.string_last_pos_ext.string_length.string_letters.string_lettersdigits.string_lower.string_ord_at.string_pos.string_pos_ext.string_repeat.string_replace.string_replace_all.string_set_byte_at.string_split.string_split_ext.string_starts_with.string_trim.string_trim_end.string_trim_start.string_upper.string_width.string_width_ext.struct_exists.struct_foreach.struct_get.struct_get_from_hash.struct_get_names.struct_names_count.struct_remove.struct_set.struct_set_from_hash.surface_copy.surface_copy_part.surface_create.surface_create_ext.surface_depth_disable.surface_exists.surface_format_is_supported.surface_free.surface_get_depth_disable.surface_get_format.surface_get_height.surface_get_target.surface_get_target_ext.surface_get_texture.surface_get_width.surface_getpixel.surface_getpixel_ext.surface_reset_target.surface_resize.surface_save.surface_save_part.surface_set_target.surface_set_target_ext.tag_get_asset_ids.tag_get_assets.tan.texture_debug_messages.texture_flush.texture_get_height.texture_get_texel_height.texture_get_texel_width.texture_get_uvs.texture_get_width.texture_global_scale.texture_is_ready.texture_prefetch.texture_set_stage.texturegroup_get_fonts.texturegroup_get_names.texturegroup_get_sprites.texturegroup_get_status.texturegroup_get_textures.texturegroup_get_tilesets.texturegroup_load.texturegroup_set_mode.texturegroup_unload.tile_get_empty.tile_get_flip.tile_get_index.tile_get_mirror.tile_get_rotate.tile_set_empty.tile_set_flip.tile_set_index.tile_set_mirror.tile_set_rotate.tilemap_clear.tilemap_get.tilemap_get_at_pixel.tilemap_get_cell_x_at_pixel.tilemap_get_cell_y_at_pixel.tilemap_get_frame.tilemap_get_global_mask.tilemap_get_height.tilemap_get_mask.tilemap_get_tile_height.tilemap_get_tile_width.tilemap_get_tileset.tilemap_get_width.tilemap_get_x.tilemap_get_y.tilemap_set.tilemap_set_at_pixel.tilemap_set_global_mask.tilemap_set_height.tilemap_set_mask.tilemap_set_width.tilemap_tileset.tilemap_x.tilemap_y.tileset_get_info.tileset_get_name.tileset_get_texture.tileset_get_uvs.time_bpm_to_seconds.time_seconds_to_bpm.time_source_create.time_source_destroy.time_source_exists.time_source_get_children.time_source_get_parent.time_source_get_period.time_source_get_reps_completed.time_source_get_reps_remaining.time_source_get_state.time_source_get_time_remaining.time_source_get_units.time_source_pause.time_source_reconfigure.time_source_reset.time_source_resume.time_source_start.time_source_stop.timeline_add.timeline_clear.timeline_delete.timeline_exists.timeline_get_name.timeline_max_moment.timeline_moment_add_script.timeline_moment_clear.timeline_size.typeof.url_get_domain.url_open.url_open_ext.url_open_full.uwp_device_touchscreen_available.uwp_livetile_badge_clear.uwp_livetile_badge_notification.uwp_livetile_notification_begin.uwp_livetile_notification_end.uwp_livetile_notification_expiry.uwp_livetile_notification_image_add.uwp_livetile_notification_secondary_begin.uwp_livetile_notification_tag.uwp_livetile_notification_template_add.uwp_livetile_notification_text_add.uwp_livetile_queue_enable.uwp_livetile_tile_clear.uwp_secondarytile_badge_clear.uwp_secondarytile_badge_notification.uwp_secondarytile_delete.uwp_secondarytile_pin.uwp_secondarytile_tile_clear.variable_clone.variable_get_hash.variable_global_exists.variable_global_get.variable_global_set.variable_instance_exists.variable_instance_get.variable_instance_get_names.variable_instance_names_count.variable_instance_set.variable_struct_exists.variable_struct_get.variable_struct_get_names.variable_struct_names_count.variable_struct_remove.variable_struct_set.vertex_argb.vertex_begin.vertex_color.vertex_colour.vertex_create_buffer.vertex_create_buffer_ext.vertex_create_buffer_from_buffer.vertex_create_buffer_from_buffer_ext.vertex_delete_buffer.vertex_end.vertex_float1.vertex_float2.vertex_float3.vertex_float4.vertex_format_add_color.vertex_format_add_colour.vertex_format_add_custom.vertex_format_add_normal.vertex_format_add_position.vertex_format_add_position_3d.vertex_format_add_texcoord.vertex_format_begin.vertex_format_delete.vertex_format_end.vertex_format_get_info.vertex_freeze.vertex_get_buffer_size.vertex_get_number.vertex_normal.vertex_position.vertex_position_3d.vertex_submit.vertex_submit_ext.vertex_texcoord.vertex_ubyte4.vertex_update_buffer_from_buffer.vertex_update_buffer_from_vertex.video_close.video_draw.video_enable_loop.video_get_duration.video_get_format.video_get_position.video_get_status.video_get_volume.video_is_looping.video_open.video_pause.video_resume.video_seek_to.video_set_volume.view_get_camera.view_get_hport.view_get_surface_id.view_get_visible.view_get_wport.view_get_xport.view_get_yport.view_set_camera.view_set_hport.view_set_surface_id.view_set_visible.view_set_wport.view_set_xport.view_set_yport.virtual_key_add.virtual_key_delete.virtual_key_hide.virtual_key_show.wallpaper_set_config.wallpaper_set_subscriptions.weak_ref_alive.weak_ref_any_alive.weak_ref_create.window_center.window_device.window_enable_borderless_fullscreen.window_get_borderless_fullscreen.window_get_caption.window_get_color.window_get_colour.window_get_cursor.window_get_fullscreen.window_get_height.window_get_showborder.window_get_visible_rects.window_get_width.window_get_x.window_get_y.window_handle.window_has_focus.window_mouse_get_delta_x.window_mouse_get_delta_y.window_mouse_get_locked.window_mouse_get_x.window_mouse_get_y.window_mouse_set.window_mouse_set_locked.window_set_caption.window_set_color.window_set_colour.window_set_cursor.window_set_fullscreen.window_set_max_height.window_set_max_width.window_set_min_height.window_set_min_width.window_set_position.window_set_rectangle.window_set_showborder.window_set_size.window_view_mouse_get_x.window_view_mouse_get_y.window_views_mouse_get_x.window_views_mouse_get_y.winphone_tile_background_color.winphone_tile_background_colour.zip_add_file.zip_create.zip_save.zip_unzip.zip_unzip_async`.split(`.`),
                    symbol: `AudioEffect.AudioEffectType.AudioLFOType.GM_build_date.GM_build_type.GM_is_sandboxed.GM_project_filename.GM_runtime_version.GM_version.NaN._GMFILE_._GMFUNCTION_._GMLINE_.alignmentH.alignmentV.all.animcurvetype_bezier.animcurvetype_catmullrom.animcurvetype_linear.asset_animationcurve.asset_font.asset_object.asset_path.asset_room.asset_script.asset_sequence.asset_shader.asset_sound.asset_sprite.asset_tiles.asset_timeline.asset_unknown.audio_3D.audio_bus_main.audio_falloff_exponent_distance.audio_falloff_exponent_distance_clamped.audio_falloff_exponent_distance_scaled.audio_falloff_inverse_distance.audio_falloff_inverse_distance_clamped.audio_falloff_inverse_distance_scaled.audio_falloff_linear_distance.audio_falloff_linear_distance_clamped.audio_falloff_none.audio_mono.audio_stereo.bboxkind_diamond.bboxkind_ellipse.bboxkind_precise.bboxkind_rectangular.bboxmode_automatic.bboxmode_fullimage.bboxmode_manual.bm_add.bm_dest_alpha.bm_dest_color.bm_dest_colour.bm_inv_dest_alpha.bm_inv_dest_color.bm_inv_dest_colour.bm_inv_src_alpha.bm_inv_src_color.bm_inv_src_colour.bm_max.bm_normal.bm_one.bm_src_alpha.bm_src_alpha_sat.bm_src_color.bm_src_colour.bm_subtract.bm_zero.browser_chrome.browser_edge.browser_firefox.browser_ie.browser_ie_mobile.browser_not_a_browser.browser_opera.browser_safari.browser_safari_mobile.browser_tizen.browser_unknown.browser_windows_store.buffer_bool.buffer_f16.buffer_f32.buffer_f64.buffer_fast.buffer_fixed.buffer_grow.buffer_s16.buffer_s32.buffer_s8.buffer_seek_end.buffer_seek_relative.buffer_seek_start.buffer_string.buffer_text.buffer_u16.buffer_u32.buffer_u64.buffer_u8.buffer_vbuffer.buffer_wrap.c_aqua.c_black.c_blue.c_dkgray.c_dkgrey.c_fuchsia.c_gray.c_green.c_grey.c_lime.c_ltgray.c_ltgrey.c_maroon.c_navy.c_olive.c_orange.c_purple.c_red.c_silver.c_teal.c_white.c_yellow.cache_directory.characterSpacing.cmpfunc_always.cmpfunc_equal.cmpfunc_greater.cmpfunc_greaterequal.cmpfunc_less.cmpfunc_lessequal.cmpfunc_never.cmpfunc_notequal.coreColor.coreColour.cr_appstart.cr_arrow.cr_beam.cr_cross.cr_default.cr_drag.cr_handpoint.cr_hourglass.cr_none.cr_size_all.cr_size_nesw.cr_size_ns.cr_size_nwse.cr_size_we.cr_uparrow.cull_clockwise.cull_counterclockwise.cull_noculling.device_emulator.device_ios_ipad.device_ios_ipad_retina.device_ios_iphone.device_ios_iphone5.device_ios_iphone6.device_ios_iphone6plus.device_ios_iphone_retina.device_ios_unknown.device_tablet.display_landscape.display_landscape_flipped.display_portrait.display_portrait_flipped.dll_cdecl.dll_stdcall.dropShadowEnabled.dropShadowEnabled.ds_type_grid.ds_type_list.ds_type_map.ds_type_priority.ds_type_queue.ds_type_stack.ef_cloud.ef_ellipse.ef_explosion.ef_firework.ef_flare.ef_rain.ef_ring.ef_smoke.ef_smokeup.ef_snow.ef_spark.ef_star.effectsEnabled.effectsEnabled.ev_alarm.ev_animation_end.ev_animation_event.ev_animation_update.ev_async_audio_playback.ev_async_audio_playback_ended.ev_async_audio_recording.ev_async_dialog.ev_async_push_notification.ev_async_save_load.ev_async_save_load.ev_async_social.ev_async_system_event.ev_async_web.ev_async_web_cloud.ev_async_web_iap.ev_async_web_image_load.ev_async_web_networking.ev_async_web_steam.ev_audio_playback.ev_audio_playback_ended.ev_audio_recording.ev_boundary.ev_boundary_view0.ev_boundary_view1.ev_boundary_view2.ev_boundary_view3.ev_boundary_view4.ev_boundary_view5.ev_boundary_view6.ev_boundary_view7.ev_broadcast_message.ev_cleanup.ev_collision.ev_create.ev_destroy.ev_dialog_async.ev_draw.ev_draw_begin.ev_draw_end.ev_draw_normal.ev_draw_post.ev_draw_pre.ev_end_of_path.ev_game_end.ev_game_start.ev_gesture.ev_gesture_double_tap.ev_gesture_drag_end.ev_gesture_drag_start.ev_gesture_dragging.ev_gesture_flick.ev_gesture_pinch_end.ev_gesture_pinch_in.ev_gesture_pinch_out.ev_gesture_pinch_start.ev_gesture_rotate_end.ev_gesture_rotate_start.ev_gesture_rotating.ev_gesture_tap.ev_global_gesture_double_tap.ev_global_gesture_drag_end.ev_global_gesture_drag_start.ev_global_gesture_dragging.ev_global_gesture_flick.ev_global_gesture_pinch_end.ev_global_gesture_pinch_in.ev_global_gesture_pinch_out.ev_global_gesture_pinch_start.ev_global_gesture_rotate_end.ev_global_gesture_rotate_start.ev_global_gesture_rotating.ev_global_gesture_tap.ev_global_left_button.ev_global_left_press.ev_global_left_release.ev_global_middle_button.ev_global_middle_press.ev_global_middle_release.ev_global_right_button.ev_global_right_press.ev_global_right_release.ev_gui.ev_gui_begin.ev_gui_end.ev_joystick1_button1.ev_joystick1_button2.ev_joystick1_button3.ev_joystick1_button4.ev_joystick1_button5.ev_joystick1_button6.ev_joystick1_button7.ev_joystick1_button8.ev_joystick1_down.ev_joystick1_left.ev_joystick1_right.ev_joystick1_up.ev_joystick2_button1.ev_joystick2_button2.ev_joystick2_button3.ev_joystick2_button4.ev_joystick2_button5.ev_joystick2_button6.ev_joystick2_button7.ev_joystick2_button8.ev_joystick2_down.ev_joystick2_left.ev_joystick2_right.ev_joystick2_up.ev_keyboard.ev_keypress.ev_keyrelease.ev_left_button.ev_left_press.ev_left_release.ev_middle_button.ev_middle_press.ev_middle_release.ev_mouse.ev_mouse_enter.ev_mouse_leave.ev_mouse_wheel_down.ev_mouse_wheel_up.ev_no_button.ev_no_more_health.ev_no_more_lives.ev_other.ev_outside.ev_outside_view0.ev_outside_view1.ev_outside_view2.ev_outside_view3.ev_outside_view4.ev_outside_view5.ev_outside_view6.ev_outside_view7.ev_pre_create.ev_push_notification.ev_right_button.ev_right_press.ev_right_release.ev_room_end.ev_room_start.ev_social.ev_step.ev_step_begin.ev_step_end.ev_step_normal.ev_system_event.ev_trigger.ev_user0.ev_user1.ev_user10.ev_user11.ev_user12.ev_user13.ev_user14.ev_user15.ev_user2.ev_user3.ev_user4.ev_user5.ev_user6.ev_user7.ev_user8.ev_user9.ev_web_async.ev_web_cloud.ev_web_iap.ev_web_image_load.ev_web_networking.ev_web_sound_load.ev_web_steam.fa_archive.fa_bottom.fa_center.fa_directory.fa_hidden.fa_left.fa_middle.fa_none.fa_readonly.fa_right.fa_sysfile.fa_top.fa_volumeid.false.frameSizeX.frameSizeY.gamespeed_fps.gamespeed_microseconds.global.glowColor.glowColour.glowEnabled.glowEnabled.glowEnd.glowStart.gp_axis_acceleration_x.gp_axis_acceleration_y.gp_axis_acceleration_z.gp_axis_angular_velocity_x.gp_axis_angular_velocity_y.gp_axis_angular_velocity_z.gp_axis_orientation_w.gp_axis_orientation_x.gp_axis_orientation_y.gp_axis_orientation_z.gp_axislh.gp_axislv.gp_axisrh.gp_axisrv.gp_face1.gp_face2.gp_face3.gp_face4.gp_padd.gp_padl.gp_padr.gp_padu.gp_select.gp_shoulderl.gp_shoulderlb.gp_shoulderr.gp_shoulderrb.gp_start.gp_stickl.gp_stickr.iap_available.iap_canceled.iap_ev_consume.iap_ev_product.iap_ev_purchase.iap_ev_restore.iap_ev_storeload.iap_failed.iap_purchased.iap_refunded.iap_status_available.iap_status_loading.iap_status_processing.iap_status_restoring.iap_status_unavailable.iap_status_uninitialised.iap_storeload_failed.iap_storeload_ok.iap_unavailable.infinity.kbv_autocapitalize_characters.kbv_autocapitalize_none.kbv_autocapitalize_sentences.kbv_autocapitalize_words.kbv_returnkey_continue.kbv_returnkey_default.kbv_returnkey_done.kbv_returnkey_emergency.kbv_returnkey_go.kbv_returnkey_google.kbv_returnkey_join.kbv_returnkey_next.kbv_returnkey_route.kbv_returnkey_search.kbv_returnkey_send.kbv_returnkey_yahoo.kbv_type_ascii.kbv_type_default.kbv_type_email.kbv_type_numbers.kbv_type_phone.kbv_type_phone_name.kbv_type_url.layerelementtype_background.layerelementtype_instance.layerelementtype_oldtilemap.layerelementtype_particlesystem.layerelementtype_sequence.layerelementtype_sprite.layerelementtype_tile.layerelementtype_tilemap.layerelementtype_undefined.leaderboard_type_number.leaderboard_type_time_mins_secs.lighttype_dir.lighttype_point.lineSpacing.m_axisx.m_axisx_gui.m_axisy.m_axisy_gui.m_scroll_down.m_scroll_up.matrix_projection.matrix_view.matrix_world.mb_any.mb_left.mb_middle.mb_none.mb_right.mb_side1.mb_side2.mip_markedonly.mip_off.mip_on.network_config_avoid_time_wait.network_config_connect_timeout.network_config_disable_multicast.network_config_disable_reliable_udp.network_config_enable_multicast.network_config_enable_reliable_udp.network_config_use_non_blocking_socket.network_config_websocket_protocol.network_connect_active.network_connect_blocking.network_connect_nonblocking.network_connect_none.network_connect_passive.network_send_binary.network_send_text.network_socket_bluetooth.network_socket_tcp.network_socket_udp.network_socket_ws.network_socket_wss.network_type_connect.network_type_data.network_type_disconnect.network_type_down.network_type_non_blocking_connect.network_type_up.network_type_up_failed.nineslice_blank.nineslice_bottom.nineslice_center.nineslice_centre.nineslice_hide.nineslice_left.nineslice_mirror.nineslice_repeat.nineslice_right.nineslice_stretch.nineslice_top.noone.of_challenge_lose.of_challenge_tie.of_challenge_win.os_android.os_gdk.os_gxgames.os_ios.os_linux.os_macosx.os_operagx.os_permission_denied.os_permission_denied_dont_request.os_permission_granted.os_ps3.os_ps4.os_ps5.os_psvita.os_switch.os_tvos.os_unknown.os_uwp.os_win8native.os_windows.os_winphone.os_xboxone.os_xboxseriesxs.other.outlineColor.outlineColour.outlineDist.outlineEnabled.outlineEnabled.paragraphSpacing.path_action_continue.path_action_restart.path_action_reverse.path_action_stop.phy_debug_render_aabb.phy_debug_render_collision_pairs.phy_debug_render_coms.phy_debug_render_core_shapes.phy_debug_render_joints.phy_debug_render_obb.phy_debug_render_shapes.phy_joint_anchor_1_x.phy_joint_anchor_1_y.phy_joint_anchor_2_x.phy_joint_anchor_2_y.phy_joint_angle.phy_joint_angle_limits.phy_joint_damping_ratio.phy_joint_frequency.phy_joint_length_1.phy_joint_length_2.phy_joint_lower_angle_limit.phy_joint_max_force.phy_joint_max_length.phy_joint_max_motor_force.phy_joint_max_motor_torque.phy_joint_max_torque.phy_joint_motor_force.phy_joint_motor_speed.phy_joint_motor_torque.phy_joint_reaction_force_x.phy_joint_reaction_force_y.phy_joint_reaction_torque.phy_joint_speed.phy_joint_translation.phy_joint_upper_angle_limit.phy_particle_data_flag_category.phy_particle_data_flag_color.phy_particle_data_flag_colour.phy_particle_data_flag_position.phy_particle_data_flag_typeflags.phy_particle_data_flag_velocity.phy_particle_flag_colormixing.phy_particle_flag_colourmixing.phy_particle_flag_elastic.phy_particle_flag_powder.phy_particle_flag_spring.phy_particle_flag_tensile.phy_particle_flag_viscous.phy_particle_flag_wall.phy_particle_flag_water.phy_particle_flag_zombie.phy_particle_group_flag_rigid.phy_particle_group_flag_solid.pi.pointer_invalid.pointer_null.pr_linelist.pr_linestrip.pr_pointlist.pr_trianglefan.pr_trianglelist.pr_trianglestrip.ps_distr_gaussian.ps_distr_invgaussian.ps_distr_linear.ps_mode_burst.ps_mode_stream.ps_shape_diamond.ps_shape_ellipse.ps_shape_line.ps_shape_rectangle.pt_shape_circle.pt_shape_cloud.pt_shape_disk.pt_shape_explosion.pt_shape_flare.pt_shape_line.pt_shape_pixel.pt_shape_ring.pt_shape_smoke.pt_shape_snow.pt_shape_spark.pt_shape_sphere.pt_shape_square.pt_shape_star.rollback_chat_message.rollback_connect_error.rollback_connect_info.rollback_connected_to_peer.rollback_connection_rejected.rollback_disconnected_from_peer.rollback_end_game.rollback_game_full.rollback_game_info.rollback_game_interrupted.rollback_game_resumed.rollback_high_latency.rollback_player_prefs.rollback_protocol_rejected.rollback_synchronized_with_peer.rollback_synchronizing_with_peer.self.seqaudiokey_loop.seqaudiokey_oneshot.seqdir_left.seqdir_right.seqinterpolation_assign.seqinterpolation_lerp.seqplay_loop.seqplay_oneshot.seqplay_pingpong.seqtextkey_bottom.seqtextkey_center.seqtextkey_justify.seqtextkey_left.seqtextkey_middle.seqtextkey_right.seqtextkey_top.seqtracktype_audio.seqtracktype_bool.seqtracktype_clipmask.seqtracktype_clipmask_mask.seqtracktype_clipmask_subject.seqtracktype_color.seqtracktype_colour.seqtracktype_empty.seqtracktype_graphic.seqtracktype_group.seqtracktype_instance.seqtracktype_message.seqtracktype_moment.seqtracktype_particlesystem.seqtracktype_real.seqtracktype_sequence.seqtracktype_spriteframes.seqtracktype_string.seqtracktype_text.shadowColor.shadowColour.shadowOffsetX.shadowOffsetY.shadowSoftness.sprite_add_ext_error_cancelled.sprite_add_ext_error_decompressfailed.sprite_add_ext_error_loadfailed.sprite_add_ext_error_setupfailed.sprite_add_ext_error_spritenotfound.sprite_add_ext_error_unknown.spritespeed_framespergameframe.spritespeed_framespersecond.surface_r16float.surface_r32float.surface_r8unorm.surface_rg8unorm.surface_rgba16float.surface_rgba32float.surface_rgba4unorm.surface_rgba8unorm.texturegroup_status_fetched.texturegroup_status_loaded.texturegroup_status_loading.texturegroup_status_unloaded.tf_anisotropic.tf_linear.tf_point.thickness.tile_flip.tile_index_mask.tile_mirror.tile_rotate.time_source_expire_after.time_source_expire_nearest.time_source_game.time_source_global.time_source_state_active.time_source_state_initial.time_source_state_paused.time_source_state_stopped.time_source_units_frames.time_source_units_seconds.timezone_local.timezone_utc.tm_countvsyncs.tm_sleep.tm_systemtiming.true.ty_real.ty_string.undefined.vertex_type_color.vertex_type_colour.vertex_type_float1.vertex_type_float2.vertex_type_float3.vertex_type_float4.vertex_type_ubyte4.vertex_usage_binormal.vertex_usage_blendindices.vertex_usage_blendweight.vertex_usage_color.vertex_usage_colour.vertex_usage_depth.vertex_usage_fog.vertex_usage_normal.vertex_usage_position.vertex_usage_psize.vertex_usage_sample.vertex_usage_tangent.vertex_usage_texcoord.video_format_rgba.video_format_yuv.video_status_closed.video_status_paused.video_status_playing.video_status_preparing.vk_add.vk_alt.vk_anykey.vk_backspace.vk_control.vk_decimal.vk_delete.vk_divide.vk_down.vk_end.vk_enter.vk_escape.vk_f1.vk_f10.vk_f11.vk_f12.vk_f2.vk_f3.vk_f4.vk_f5.vk_f6.vk_f7.vk_f8.vk_f9.vk_home.vk_insert.vk_lalt.vk_lcontrol.vk_left.vk_lshift.vk_multiply.vk_nokey.vk_numpad0.vk_numpad1.vk_numpad2.vk_numpad3.vk_numpad4.vk_numpad5.vk_numpad6.vk_numpad7.vk_numpad8.vk_numpad9.vk_pagedown.vk_pageup.vk_pause.vk_printscreen.vk_ralt.vk_rcontrol.vk_return.vk_right.vk_rshift.vk_shift.vk_space.vk_subtract.vk_tab.vk_up.wallpaper_config.wallpaper_subscription_data.wrap`.split(`.`),
                    "variable.language": `alarm.application_surface.argument.argument0.argument1.argument2.argument3.argument4.argument5.argument6.argument7.argument8.argument9.argument10.argument11.argument12.argument13.argument14.argument15.argument_count.async_load.background_color.background_colour.background_showcolor.background_showcolour.bbox_bottom.bbox_left.bbox_right.bbox_top.browser_height.browser_width.colour?ColourTrack.current_day.current_hour.current_minute.current_month.current_second.current_time.current_weekday.current_year.cursor_sprite.debug_mode.delta_time.depth.direction.display_aa.drawn_by_sequence.event_action.event_data.event_number.event_object.event_type.font_texture_page_size.fps.fps_real.friction.game_display_name.game_id.game_project_name.game_save_id.gravity.gravity_direction.health.hspeed.iap_data.id.image_alpha.image_angle.image_blend.image_index.image_number.image_speed.image_xscale.image_yscale.in_collision_tree.in_sequence.instance_count.instance_id.keyboard_key.keyboard_lastchar.keyboard_lastkey.keyboard_string.layer.lives.longMessage.managed.mask_index.message.mouse_button.mouse_lastbutton.mouse_x.mouse_y.object_index.os_browser.os_device.os_type.os_version.path_endaction.path_index.path_orientation.path_position.path_positionprevious.path_scale.path_speed.persistent.phy_active.phy_angular_damping.phy_angular_velocity.phy_bullet.phy_col_normal_x.phy_col_normal_y.phy_collision_points.phy_collision_x.phy_collision_y.phy_com_x.phy_com_y.phy_dynamic.phy_fixed_rotation.phy_inertia.phy_kinematic.phy_linear_damping.phy_linear_velocity_x.phy_linear_velocity_y.phy_mass.phy_position_x.phy_position_xprevious.phy_position_y.phy_position_yprevious.phy_rotation.phy_sleeping.phy_speed.phy_speed_x.phy_speed_y.player_avatar_sprite.player_avatar_url.player_id.player_local.player_type.player_user_id.program_directory.rollback_api_server.rollback_confirmed_frame.rollback_current_frame.rollback_event_id.rollback_event_param.rollback_game_running.room.room_first.room_height.room_last.room_persistent.room_speed.room_width.score.script.sequence_instance.solid.speed.sprite_height.sprite_index.sprite_width.sprite_xoffset.sprite_yoffset.stacktrace.temp_directory.timeline_index.timeline_loop.timeline_position.timeline_running.timeline_speed.view_camera.view_current.view_enabled.view_hport.view_surface_id.view_visible.view_wport.view_xport.view_yport.visible.vspeed.webgl_enabled.working_directory.x.xprevious.xstart.y.yprevious.ystart`.split(`.`)
                },
                contains: [
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE,
                    e.C_NUMBER_MODE
                ]
            };
        }
        t.exports = n;
    }), Z = o((e, t)=>{
        function n(e) {
            let t = {
                keyword: [
                    `break`,
                    `case`,
                    `chan`,
                    `const`,
                    `continue`,
                    `default`,
                    `defer`,
                    `else`,
                    `fallthrough`,
                    `for`,
                    `func`,
                    `go`,
                    `goto`,
                    `if`,
                    `import`,
                    `interface`,
                    `map`,
                    `package`,
                    `range`,
                    `return`,
                    `select`,
                    `struct`,
                    `switch`,
                    `type`,
                    `var`
                ],
                type: [
                    `bool`,
                    `byte`,
                    `complex64`,
                    `complex128`,
                    `error`,
                    `float32`,
                    `float64`,
                    `int8`,
                    `int16`,
                    `int32`,
                    `int64`,
                    `string`,
                    `uint8`,
                    `uint16`,
                    `uint32`,
                    `uint64`,
                    `int`,
                    `uint`,
                    `uintptr`,
                    `rune`
                ],
                literal: [
                    `true`,
                    `false`,
                    `iota`,
                    `nil`
                ],
                built_in: [
                    `append`,
                    `cap`,
                    `close`,
                    `complex`,
                    `copy`,
                    `imag`,
                    `len`,
                    `make`,
                    `new`,
                    `panic`,
                    `print`,
                    `println`,
                    `real`,
                    `recover`,
                    `delete`
                ]
            };
            return {
                name: `Go`,
                aliases: [
                    `golang`
                ],
                keywords: t,
                illegal: `</`,
                contains: [
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    {
                        className: `string`,
                        variants: [
                            e.QUOTE_STRING_MODE,
                            e.APOS_STRING_MODE,
                            {
                                begin: "`",
                                end: "`"
                            }
                        ]
                    },
                    {
                        className: `number`,
                        variants: [
                            {
                                match: /-?\b0[xX]\.[a-fA-F0-9](_?[a-fA-F0-9])*[pP][+-]?\d(_?\d)*i?/,
                                relevance: 0
                            },
                            {
                                match: /-?\b0[xX](_?[a-fA-F0-9])+((\.([a-fA-F0-9](_?[a-fA-F0-9])*)?)?[pP][+-]?\d(_?\d)*)?i?/,
                                relevance: 0
                            },
                            {
                                match: /-?\b0[oO](_?[0-7])*i?/,
                                relevance: 0
                            },
                            {
                                match: /-?\.\d(_?\d)*([eE][+-]?\d(_?\d)*)?i?/,
                                relevance: 0
                            },
                            {
                                match: /-?\b\d(_?\d)*(\.(\d(_?\d)*)?)?([eE][+-]?\d(_?\d)*)?i?/,
                                relevance: 0
                            }
                        ]
                    },
                    {
                        begin: /:=/
                    },
                    {
                        className: `function`,
                        beginKeywords: `func`,
                        end: `\\s*(\\{|$)`,
                        excludeEnd: !0,
                        contains: [
                            e.TITLE_MODE,
                            {
                                className: `params`,
                                begin: /\(/,
                                end: /\)/,
                                endsParent: !0,
                                keywords: t,
                                illegal: /["']/
                            }
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), ke = o((e, t)=>{
        function n(e) {
            return {
                name: `Golo`,
                keywords: {
                    keyword: `println.readln.print.import.module.function.local.return.let.var.while.for.foreach.times.in.case.when.match.with.break.continue.augment.augmentation.each.find.filter.reduce.if.then.else.otherwise.try.catch.finally.raise.throw.orIfNull.DynamicObject|10.DynamicVariable.struct.Observable.map.set.vector.list.array`.split(`.`),
                    literal: [
                        `true`,
                        `false`,
                        `null`
                    ]
                },
                contains: [
                    e.HASH_COMMENT_MODE,
                    e.QUOTE_STRING_MODE,
                    e.C_NUMBER_MODE,
                    {
                        className: `meta`,
                        begin: `@[A-Za-z]+`
                    }
                ]
            };
        }
        t.exports = n;
    }), Ae = o((e, t)=>{
        function n(e) {
            return {
                name: `Gradle`,
                case_insensitive: !0,
                keywords: `task.project.allprojects.subprojects.artifacts.buildscript.configurations.dependencies.repositories.sourceSets.description.delete.from.into.include.exclude.source.classpath.destinationDir.includes.options.sourceCompatibility.targetCompatibility.group.flatDir.doLast.doFirst.flatten.todir.fromdir.ant.def.abstract.break.case.catch.continue.default.do.else.extends.final.finally.for.if.implements.instanceof.native.new.private.protected.public.return.static.switch.synchronized.throw.throws.transient.try.volatile.while.strictfp.package.import.false.null.super.this.true.antlrtask.checkstyle.codenarc.copy.boolean.byte.char.class.double.float.int.interface.long.short.void.compile.runTime.file.fileTree.abs.any.append.asList.asWritable.call.collect.compareTo.count.div.dump.each.eachByte.eachFile.eachLine.every.find.findAll.flatten.getAt.getErr.getIn.getOut.getText.grep.immutable.inject.inspect.intersect.invokeMethods.isCase.join.leftShift.minus.multiply.newInputStream.newOutputStream.newPrintWriter.newReader.newWriter.next.plus.pop.power.previous.print.println.push.putAt.read.readBytes.readLines.reverse.reverseEach.round.size.sort.splitEachLine.step.subMap.times.toInteger.toList.tokenize.upto.waitForOrKill.withPrintWriter.withReader.withStream.withWriter.withWriterAppend.write.writeLine`.split(`.`),
                contains: [
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE,
                    e.NUMBER_MODE,
                    e.REGEXP_MODE
                ]
            };
        }
        t.exports = n;
    }), je = o((e, t)=>{
        function n(e) {
            let t = e.regex;
            return {
                name: `GraphQL`,
                aliases: [
                    `gql`
                ],
                case_insensitive: !0,
                disableAutodetect: !1,
                keywords: {
                    keyword: [
                        `query`,
                        `mutation`,
                        `subscription`,
                        `type`,
                        `input`,
                        `schema`,
                        `directive`,
                        `interface`,
                        `union`,
                        `scalar`,
                        `fragment`,
                        `enum`,
                        `on`
                    ],
                    literal: [
                        `true`,
                        `false`,
                        `null`
                    ]
                },
                contains: [
                    e.HASH_COMMENT_MODE,
                    e.QUOTE_STRING_MODE,
                    e.NUMBER_MODE,
                    {
                        scope: `punctuation`,
                        match: /[.]{3}/,
                        relevance: 0
                    },
                    {
                        scope: `punctuation`,
                        begin: /[\!\(\)\:\=\[\]\{\|\}]{1}/,
                        relevance: 0
                    },
                    {
                        scope: `variable`,
                        begin: /\$/,
                        end: /\W/,
                        excludeEnd: !0,
                        relevance: 0
                    },
                    {
                        scope: `meta`,
                        match: /@\w+/,
                        excludeEnd: !0
                    },
                    {
                        scope: `symbol`,
                        begin: t.concat(/[_A-Za-z][_0-9A-Za-z]*/, t.lookahead(/\s*:/)),
                        relevance: 0
                    }
                ],
                illegal: [
                    /[;<']/,
                    /BEGIN/
                ]
            };
        }
        t.exports = n;
    }), Me = o((e, t)=>{
        function n(e, t = {}) {
            return t.variants = e, t;
        }
        function r(e) {
            let t = e.regex, r = `[A-Za-z0-9_$]+`, i = n([
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                e.COMMENT(`/\\*\\*`, `\\*/`, {
                    relevance: 0,
                    contains: [
                        {
                            begin: /\w+@/,
                            relevance: 0
                        },
                        {
                            className: `doctag`,
                            begin: `@[A-Za-z]+`
                        }
                    ]
                })
            ]), a = {
                className: `regexp`,
                begin: /~?\/[^\/\n]+\//,
                contains: [
                    e.BACKSLASH_ESCAPE
                ]
            }, o = n([
                e.BINARY_NUMBER_MODE,
                e.C_NUMBER_MODE
            ]), s = n([
                {
                    begin: /"""/,
                    end: /"""/
                },
                {
                    begin: /'''/,
                    end: /'''/
                },
                {
                    begin: `\\$/`,
                    end: `/\\$`,
                    relevance: 10
                },
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE
            ], {
                className: `string`
            }), c = {
                match: [
                    /(class|interface|trait|enum|record|extends|implements)/,
                    /\s+/,
                    e.UNDERSCORE_IDENT_RE
                ],
                scope: {
                    1: `keyword`,
                    3: `title.class`
                }
            };
            return {
                name: `Groovy`,
                keywords: {
                    "variable.language": `this super`,
                    literal: `true false null`,
                    type: [
                        `byte`,
                        `short`,
                        `char`,
                        `int`,
                        `long`,
                        `boolean`,
                        `float`,
                        `double`,
                        `void`
                    ],
                    keyword: `def.as.in.assert.trait.abstract.static.volatile.transient.public.private.protected.synchronized.final.class.interface.enum.if.else.for.while.switch.case.break.default.continue.throw.throws.try.catch.finally.implements.extends.new.import.package.return.instanceof.var`.split(`.`)
                },
                contains: [
                    e.SHEBANG({
                        binary: `groovy`,
                        relevance: 10
                    }),
                    i,
                    s,
                    a,
                    o,
                    c,
                    {
                        className: `meta`,
                        begin: `@[A-Za-z]+`,
                        relevance: 0
                    },
                    {
                        className: `attr`,
                        begin: r + `[ 	]*:`,
                        relevance: 0
                    },
                    {
                        begin: /\?/,
                        end: /:/,
                        relevance: 0,
                        contains: [
                            i,
                            s,
                            a,
                            o,
                            `self`
                        ]
                    },
                    {
                        className: `symbol`,
                        begin: `^[ 	]*` + t.lookahead(r + `:`),
                        excludeBegin: !0,
                        end: r + `:`,
                        relevance: 0
                    }
                ],
                illegal: /#|<\//
            };
        }
        t.exports = r;
    }), Ne = o((e, t)=>{
        function n(e) {
            return {
                name: `HAML`,
                case_insensitive: !0,
                contains: [
                    {
                        className: `meta`,
                        begin: `^!!!( (5|1\\.1|Strict|Frameset|Basic|Mobile|RDFa|XML\\b.*))?$`,
                        relevance: 10
                    },
                    e.COMMENT(`^\\s*(!=#|=#|-#|/).*$`, null, {
                        relevance: 0
                    }),
                    {
                        begin: `^\\s*(-|=|!=)(?!#)`,
                        end: /$/,
                        subLanguage: `ruby`,
                        excludeBegin: !0,
                        excludeEnd: !0
                    },
                    {
                        className: `tag`,
                        begin: `^\\s*%`,
                        contains: [
                            {
                                className: `selector-tag`,
                                begin: `\\w+`
                            },
                            {
                                className: `selector-id`,
                                begin: `#[\\w-]+`
                            },
                            {
                                className: `selector-class`,
                                begin: `\\.[\\w-]+`
                            },
                            {
                                begin: /\{\s*/,
                                end: /\s*\}/,
                                contains: [
                                    {
                                        begin: `:\\w+\\s*=>`,
                                        end: `,\\s+`,
                                        returnBegin: !0,
                                        endsWithParent: !0,
                                        contains: [
                                            {
                                                className: `attr`,
                                                begin: `:\\w+`
                                            },
                                            e.APOS_STRING_MODE,
                                            e.QUOTE_STRING_MODE,
                                            {
                                                begin: `\\w+`,
                                                relevance: 0
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                begin: `\\(\\s*`,
                                end: `\\s*\\)`,
                                excludeEnd: !0,
                                contains: [
                                    {
                                        begin: `\\w+\\s*=`,
                                        end: `\\s+`,
                                        returnBegin: !0,
                                        endsWithParent: !0,
                                        contains: [
                                            {
                                                className: `attr`,
                                                begin: `\\w+`,
                                                relevance: 0
                                            },
                                            e.APOS_STRING_MODE,
                                            e.QUOTE_STRING_MODE,
                                            {
                                                begin: `\\w+`,
                                                relevance: 0
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        begin: `^\\s*[=~]\\s*`
                    },
                    {
                        begin: /#\{/,
                        end: /\}/,
                        subLanguage: `ruby`,
                        excludeBegin: !0,
                        excludeEnd: !0
                    }
                ]
            };
        }
        t.exports = n;
    }), Pe = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = {
                $pattern: /[\w.\/]+/,
                built_in: `action.bindattr.collection.component.concat.debugger.each.each-in.get.hash.if.in.input.link-to.loc.log.lookup.mut.outlet.partial.query-params.render.template.textarea.unbound.unless.view.with.yield`.split(`.`)
            }, r = {
                $pattern: /[\w.\/]+/,
                literal: [
                    `true`,
                    `false`,
                    `undefined`,
                    `null`
                ]
            }, i = /""|"[^"]+"/, a = /''|'[^']+'/, o = /\[\]|\[[^\]]+\]/, s = /[^\s!"#%&'()*+,.\/;<=>@\[\\\]^`{|}~]+/, c = /(\.|\/)/, l = t.either(i, a, o, s), u = t.concat(t.optional(/\.|\.\/|\//), l, t.anyNumberOfTimes(t.concat(c, l))), d = t.concat(`(`, o, `|`, s, `)(?==)`), f = {
                begin: u
            }, p = e.inherit(f, {
                keywords: r
            }), m = {
                begin: /\(/,
                end: /\)/
            }, h = {
                className: `attr`,
                begin: d,
                relevance: 0,
                starts: {
                    begin: /=/,
                    end: /=/,
                    starts: {
                        contains: [
                            e.NUMBER_MODE,
                            e.QUOTE_STRING_MODE,
                            e.APOS_STRING_MODE,
                            p,
                            m
                        ]
                    }
                }
            }, g = {
                contains: [
                    e.NUMBER_MODE,
                    e.QUOTE_STRING_MODE,
                    e.APOS_STRING_MODE,
                    {
                        begin: /as\s+\|/,
                        keywords: {
                            keyword: `as`
                        },
                        end: /\|/,
                        contains: [
                            {
                                begin: /\w+/
                            }
                        ]
                    },
                    h,
                    p,
                    m
                ],
                returnEnd: !0
            };
            m.contains = [
                e.inherit(f, {
                    className: `name`,
                    keywords: n,
                    starts: e.inherit(g, {
                        end: /\)/
                    })
                })
            ];
            let _ = e.inherit(f, {
                keywords: n,
                className: `name`,
                starts: e.inherit(g, {
                    end: /\}\}/
                })
            }), v = e.inherit(f, {
                keywords: n,
                className: `name`
            }), y = e.inherit(f, {
                className: `name`,
                keywords: n,
                starts: e.inherit(g, {
                    end: /\}\}/
                })
            });
            return {
                name: `Handlebars`,
                aliases: [
                    `hbs`,
                    `html.hbs`,
                    `html.handlebars`,
                    `htmlbars`
                ],
                case_insensitive: !0,
                subLanguage: `xml`,
                contains: [
                    {
                        begin: /\\\{\{/,
                        skip: !0
                    },
                    {
                        begin: /\\\\(?=\{\{)/,
                        skip: !0
                    },
                    e.COMMENT(/\{\{!--/, /--\}\}/),
                    e.COMMENT(/\{\{!/, /\}\}/),
                    {
                        className: `template-tag`,
                        begin: /\{\{\{\{(?!\/)/,
                        end: /\}\}\}\}/,
                        contains: [
                            _
                        ],
                        starts: {
                            end: /\{\{\{\{\//,
                            returnEnd: !0,
                            subLanguage: `xml`
                        }
                    },
                    {
                        className: `template-tag`,
                        begin: /\{\{\{\{\//,
                        end: /\}\}\}\}/,
                        contains: [
                            v
                        ]
                    },
                    {
                        className: `template-tag`,
                        begin: /\{\{#/,
                        end: /\}\}/,
                        contains: [
                            _
                        ]
                    },
                    {
                        className: `template-tag`,
                        begin: /\{\{(?=else\}\})/,
                        end: /\}\}/,
                        keywords: `else`
                    },
                    {
                        className: `template-tag`,
                        begin: /\{\{(?=else if)/,
                        end: /\}\}/,
                        keywords: `else if`
                    },
                    {
                        className: `template-tag`,
                        begin: /\{\{\//,
                        end: /\}\}/,
                        contains: [
                            v
                        ]
                    },
                    {
                        className: `template-variable`,
                        begin: /\{\{\{/,
                        end: /\}\}\}/,
                        contains: [
                            y
                        ]
                    },
                    {
                        className: `template-variable`,
                        begin: /\{\{/,
                        end: /\}\}/,
                        contains: [
                            y
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), Fe = o((e, t)=>{
        function n(e) {
            let t = `([0-9]_*)+`, n = `([0-9a-fA-F]_*)+`, r = `([!#$%&*+.\\/<=>?@\\\\^~-]|(?!([(),;\\[\\]\`|{}]|[_:"']))(\\p{S}|\\p{P}))`, i = {
                variants: [
                    e.COMMENT(`--+`, `$`),
                    e.COMMENT(/\{-/, /-\}/, {
                        contains: [
                            `self`
                        ]
                    })
                ]
            }, a = {
                className: `meta`,
                begin: /\{-#/,
                end: /#-\}/
            }, o = {
                className: `meta`,
                begin: `^#`,
                end: `$`
            }, s = {
                className: `type`,
                begin: `\\b[A-Z][\\w']*`,
                relevance: 0
            }, c = {
                begin: `\\(`,
                end: `\\)`,
                illegal: `"`,
                contains: [
                    a,
                    o,
                    {
                        className: `type`,
                        begin: `\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?`
                    },
                    e.inherit(e.TITLE_MODE, {
                        begin: `[_a-z][\\w']*`
                    }),
                    i
                ]
            }, l = {
                begin: /\{/,
                end: /\}/,
                contains: c.contains
            }, u = {
                className: `number`,
                relevance: 0,
                variants: [
                    {
                        match: `\\b(${t})(\\.(${t}))?([eE][+-]?(${t}))?\\b`
                    },
                    {
                        match: `\\b0[xX]_*(${n})(\\.(${n}))?([pP][+-]?(${t}))?\\b`
                    },
                    {
                        match: `\\b0[oO](([0-7]_*)+)\\b`
                    },
                    {
                        match: `\\b0[bB](([01]_*)+)\\b`
                    }
                ]
            };
            return {
                name: `Haskell`,
                aliases: [
                    `hs`
                ],
                keywords: `let in if then else case of where do module import hiding qualified type data newtype deriving class instance as default infix infixl infixr foreign export ccall stdcall cplusplus jvm dotnet safe unsafe family forall mdo proc rec`,
                unicodeRegex: !0,
                contains: [
                    {
                        beginKeywords: `module`,
                        end: `where`,
                        keywords: `module where`,
                        contains: [
                            c,
                            i
                        ],
                        illegal: `\\W\\.|;`
                    },
                    {
                        begin: `\\bimport\\b`,
                        end: `$`,
                        keywords: `import qualified as hiding`,
                        contains: [
                            c,
                            i
                        ],
                        illegal: `\\W\\.|;`
                    },
                    {
                        className: `class`,
                        begin: `^(\\s*)?(class|instance)\\b`,
                        end: `where`,
                        keywords: `class family instance where`,
                        contains: [
                            s,
                            c,
                            i
                        ]
                    },
                    {
                        className: `class`,
                        begin: `\\b(data|(new)?type)\\b`,
                        end: `$`,
                        keywords: `data family type newtype deriving`,
                        contains: [
                            a,
                            s,
                            c,
                            l,
                            i
                        ]
                    },
                    {
                        beginKeywords: `default`,
                        end: `$`,
                        contains: [
                            s,
                            c,
                            i
                        ]
                    },
                    {
                        beginKeywords: `infix infixl infixr`,
                        end: `$`,
                        contains: [
                            e.C_NUMBER_MODE,
                            i
                        ]
                    },
                    {
                        begin: `\\bforeign\\b`,
                        end: `$`,
                        keywords: `foreign import export ccall stdcall cplusplus jvm dotnet safe unsafe`,
                        contains: [
                            s,
                            e.QUOTE_STRING_MODE,
                            i
                        ]
                    },
                    {
                        className: `meta`,
                        begin: `#!\\/usr\\/bin\\/env runhaskell`,
                        end: `$`
                    },
                    a,
                    o,
                    {
                        scope: `string`,
                        begin: /'(?=\\?.')/,
                        end: /'/,
                        contains: [
                            {
                                scope: `char.escape`,
                                match: /\\./
                            }
                        ]
                    },
                    e.QUOTE_STRING_MODE,
                    u,
                    s,
                    e.inherit(e.TITLE_MODE, {
                        begin: `^[_a-z][\\w']*`
                    }),
                    {
                        begin: `(?!-)${r}--+|--+(?!-)${r}`
                    },
                    i,
                    {
                        begin: `->|<-`
                    }
                ]
            };
        }
        t.exports = n;
    }), Ie = o((e, t)=>{
        function n(e) {
            return {
                name: `Haxe`,
                aliases: [
                    `hx`
                ],
                keywords: {
                    keyword: `abstract break case cast catch continue default do dynamic else enum extern final for function here if import in inline is macro never new override package private get set public return static super switch this throw trace try typedef untyped using var while Int Float String Bool Dynamic Void Array `,
                    built_in: `trace this`,
                    literal: `true false null _`
                },
                contains: [
                    {
                        className: `string`,
                        begin: `'`,
                        end: `'`,
                        contains: [
                            e.BACKSLASH_ESCAPE,
                            {
                                className: `subst`,
                                begin: /\$\{/,
                                end: /\}/
                            },
                            {
                                className: `subst`,
                                begin: /\$/,
                                end: /\W\}/
                            }
                        ]
                    },
                    e.QUOTE_STRING_MODE,
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    {
                        className: `number`,
                        begin: /(-?)(\b0[xX][a-fA-F0-9_]+|(\b\d+(\.[\d_]*)?|\.[\d_]+)(([eE][-+]?\d+)|i32|u32|i64|f64)?)/,
                        relevance: 0
                    },
                    {
                        className: `variable`,
                        begin: `\\$[a-zA-Z_$][a-zA-Z0-9_$]*`
                    },
                    {
                        className: `meta`,
                        begin: /@:?/,
                        end: /\(|$/,
                        excludeEnd: !0
                    },
                    {
                        className: `meta`,
                        begin: `#`,
                        end: `$`,
                        keywords: {
                            keyword: `if else elseif end error`
                        }
                    },
                    {
                        className: `type`,
                        begin: /:[ \t]*/,
                        end: /[^A-Za-z0-9_ \t\->]/,
                        excludeBegin: !0,
                        excludeEnd: !0,
                        relevance: 0
                    },
                    {
                        className: `type`,
                        begin: /:[ \t]*/,
                        end: /\W/,
                        excludeBegin: !0,
                        excludeEnd: !0
                    },
                    {
                        className: `type`,
                        beginKeywords: `new`,
                        end: /\W/,
                        excludeBegin: !0,
                        excludeEnd: !0
                    },
                    {
                        className: `title.class`,
                        beginKeywords: `enum`,
                        end: /\{/,
                        contains: [
                            e.TITLE_MODE
                        ]
                    },
                    {
                        className: `title.class`,
                        begin: `\\babstract\\b(?=\\s*` + e.IDENT_RE + `\\s*\\()`,
                        end: /[\{$]/,
                        contains: [
                            {
                                className: `type`,
                                begin: /\(/,
                                end: /\)/,
                                excludeBegin: !0,
                                excludeEnd: !0
                            },
                            {
                                className: `type`,
                                begin: /from +/,
                                end: /\W/,
                                excludeBegin: !0,
                                excludeEnd: !0
                            },
                            {
                                className: `type`,
                                begin: /to +/,
                                end: /\W/,
                                excludeBegin: !0,
                                excludeEnd: !0
                            },
                            e.TITLE_MODE
                        ],
                        keywords: {
                            keyword: `abstract from to`
                        }
                    },
                    {
                        className: `title.class`,
                        begin: /\b(class|interface) +/,
                        end: /[\{$]/,
                        excludeEnd: !0,
                        keywords: `class interface`,
                        contains: [
                            {
                                className: `keyword`,
                                begin: /\b(extends|implements) +/,
                                keywords: `extends implements`,
                                contains: [
                                    {
                                        className: `type`,
                                        begin: e.IDENT_RE,
                                        relevance: 0
                                    }
                                ]
                            },
                            e.TITLE_MODE
                        ]
                    },
                    {
                        className: `title.function`,
                        beginKeywords: `function`,
                        end: /\(/,
                        excludeEnd: !0,
                        illegal: /\S/,
                        contains: [
                            e.TITLE_MODE
                        ]
                    }
                ],
                illegal: /<\//
            };
        }
        t.exports = n;
    }), Le = o((e, t)=>{
        function n(e) {
            return {
                name: `HSP`,
                case_insensitive: !0,
                keywords: {
                    $pattern: /[\w._]+/,
                    keyword: `goto gosub return break repeat loop continue wait await dim sdim foreach dimtype dup dupptr end stop newmod delmod mref run exgoto on mcall assert logmes newlab resume yield onexit onerror onkey onclick oncmd exist delete mkdir chdir dirlist bload bsave bcopy memfile if else poke wpoke lpoke getstr chdpm memexpand memcpy memset notesel noteadd notedel noteload notesave randomize noteunsel noteget split strrep setease button chgdisp exec dialog mmload mmplay mmstop mci pset pget syscolor mes print title pos circle cls font sysfont objsize picload color palcolor palette redraw width gsel gcopy gzoom gmode bmpsave hsvcolor getkey listbox chkbox combox input mesbox buffer screen bgscr mouse objsel groll line clrobj boxf objprm objmode stick grect grotate gsquare gradf objimage objskip objenable celload celdiv celput newcom querycom delcom cnvstow comres axobj winobj sendmsg comevent comevarg sarrayconv callfunc cnvwtos comevdisp libptr system hspstat hspver stat cnt err strsize looplev sublev iparam wparam lparam refstr refdval int rnd strlen length length2 length3 length4 vartype gettime peek wpeek lpeek varptr varuse noteinfo instr abs limit getease str strmid strf getpath strtrim sin cos tan atan sqrt double absf expf logf limitf powf geteasef mousex mousey mousew hwnd hinstance hdc ginfo objinfo dirinfo sysinfo thismod __hspver__ __hsp30__ __date__ __time__ __line__ __file__ _debug __hspdef__ and or xor not screen_normal screen_palette screen_hide screen_fixedsize screen_tool screen_frame gmode_gdi gmode_mem gmode_rgb0 gmode_alpha gmode_rgb0alpha gmode_add gmode_sub gmode_pixela ginfo_mx ginfo_my ginfo_act ginfo_sel ginfo_wx1 ginfo_wy1 ginfo_wx2 ginfo_wy2 ginfo_vx ginfo_vy ginfo_sizex ginfo_sizey ginfo_winx ginfo_winy ginfo_mesx ginfo_mesy ginfo_r ginfo_g ginfo_b ginfo_paluse ginfo_dispx ginfo_dispy ginfo_cx ginfo_cy ginfo_intid ginfo_newid ginfo_sx ginfo_sy objinfo_mode objinfo_bmscr objinfo_hwnd notemax notesize dir_cur dir_exe dir_win dir_sys dir_cmdline dir_desktop dir_mydoc dir_tv font_normal font_bold font_italic font_underline font_strikeout font_antialias objmode_normal objmode_guifont objmode_usefont gsquare_grad msgothic msmincho do until while wend for next _break _continue switch case default swbreak swend ddim ldim alloc m_pi rad2deg deg2rad ease_linear ease_quad_in ease_quad_out ease_quad_inout ease_cubic_in ease_cubic_out ease_cubic_inout ease_quartic_in ease_quartic_out ease_quartic_inout ease_bounce_in ease_bounce_out ease_bounce_inout ease_shake_in ease_shake_out ease_shake_inout ease_loop`
                },
                contains: [
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    e.QUOTE_STRING_MODE,
                    e.APOS_STRING_MODE,
                    {
                        className: `string`,
                        begin: /\{"/,
                        end: /"\}/,
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ]
                    },
                    e.COMMENT(`;`, `$`, {
                        relevance: 0
                    }),
                    {
                        className: `meta`,
                        begin: `#`,
                        end: `$`,
                        keywords: {
                            keyword: `addion cfunc cmd cmpopt comfunc const defcfunc deffunc define else endif enum epack func global if ifdef ifndef include modcfunc modfunc modinit modterm module pack packopt regcmd runtime undef usecom uselib`
                        },
                        contains: [
                            e.inherit(e.QUOTE_STRING_MODE, {
                                className: `string`
                            }),
                            e.NUMBER_MODE,
                            e.C_NUMBER_MODE,
                            e.C_LINE_COMMENT_MODE,
                            e.C_BLOCK_COMMENT_MODE
                        ]
                    },
                    {
                        className: `symbol`,
                        begin: `^\\*(\\w+|@)`
                    },
                    e.NUMBER_MODE,
                    e.C_NUMBER_MODE
                ]
            };
        }
        t.exports = n;
    }), Re = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = `HTTP/([32]|1\\.[01])`, r = {
                className: `attribute`,
                begin: t.concat(`^`, /[A-Za-z][A-Za-z0-9-]*/, `(?=\\:\\s)`),
                starts: {
                    contains: [
                        {
                            className: `punctuation`,
                            begin: /: /,
                            relevance: 0,
                            starts: {
                                end: `$`,
                                relevance: 0
                            }
                        }
                    ]
                }
            }, i = [
                r,
                {
                    begin: `\\n\\n`,
                    starts: {
                        subLanguage: [],
                        endsWithParent: !0
                    }
                }
            ];
            return {
                name: `HTTP`,
                aliases: [
                    `https`
                ],
                illegal: /\S/,
                contains: [
                    {
                        begin: `^(?=` + n + ` \\d{3})`,
                        end: /$/,
                        contains: [
                            {
                                className: `meta`,
                                begin: n
                            },
                            {
                                className: `number`,
                                begin: `\\b\\d{3}\\b`
                            }
                        ],
                        starts: {
                            end: /\b\B/,
                            illegal: /\S/,
                            contains: i
                        }
                    },
                    {
                        begin: `(?=^[A-Z]+ (.*?) ` + n + `$)`,
                        end: /$/,
                        contains: [
                            {
                                className: `string`,
                                begin: ` `,
                                end: ` `,
                                excludeBegin: !0,
                                excludeEnd: !0
                            },
                            {
                                className: `meta`,
                                begin: n
                            },
                            {
                                className: `keyword`,
                                begin: `[A-Z]+`
                            }
                        ],
                        starts: {
                            end: /\b\B/,
                            illegal: /\S/,
                            contains: i
                        }
                    },
                    e.inherit(r, {
                        relevance: 0
                    })
                ]
            };
        }
        t.exports = n;
    }), ze = o((e, t)=>{
        function n(e) {
            let t = `[a-zA-Z_\\-!.?+*=<>&#'][a-zA-Z_\\-!.?+*=<>&#'0-9/;:]*`, n = {
                $pattern: t,
                built_in: `!= % %= & &= * ** **= *= *map + += , --build-class-- --import-- -= . / // //= /= < << <<= <= = > >= >> >>= @ @= ^ ^= abs accumulate all and any ap-compose ap-dotimes ap-each ap-each-while ap-filter ap-first ap-if ap-last ap-map ap-map-when ap-pipe ap-reduce ap-reject apply as-> ascii assert assoc bin break butlast callable calling-module-name car case cdr chain chr coll? combinations compile compress cond cons cons? continue count curry cut cycle dec def default-method defclass defmacro defmacro-alias defmacro/g! defmain defmethod defmulti defn defn-alias defnc defnr defreader defseq del delattr delete-route dict-comp dir disassemble dispatch-reader-macro distinct divmod do doto drop drop-last drop-while empty? end-sequence eval eval-and-compile eval-when-compile even? every? except exec filter first flatten float? fn fnc fnr for for* format fraction genexpr gensym get getattr global globals group-by hasattr hash hex id identity if if* if-not if-python2 import in inc input instance? integer integer-char? integer? interleave interpose is is-coll is-cons is-empty is-even is-every is-float is-instance is-integer is-integer-char is-iterable is-iterator is-keyword is-neg is-none is-not is-numeric is-odd is-pos is-string is-symbol is-zero isinstance islice issubclass iter iterable? iterate iterator? keyword keyword? lambda last len let lif lif-not list* list-comp locals loop macro-error macroexpand macroexpand-1 macroexpand-all map max merge-with method-decorator min multi-decorator multicombinations name neg? next none? nonlocal not not-in not? nth numeric? oct odd? open or ord partition permutations pos? post-route postwalk pow prewalk print product profile/calls profile/cpu put-route quasiquote quote raise range read read-str recursive-replace reduce remove repeat repeatedly repr require rest round route route-with-methods rwm second seq set-comp setattr setv some sorted string string? sum switch symbol? take take-nth take-while tee try unless unquote unquote-splicing vars walk when while with with* with-decorator with-gensyms xi xor yield yield-from zero? zip zip-longest | |= ~`
            }, r = {
                begin: t,
                relevance: 0
            }, i = {
                className: `number`,
                begin: `[-+]?\\d+(\\.\\d+)?`,
                relevance: 0
            }, a = e.inherit(e.QUOTE_STRING_MODE, {
                illegal: null
            }), o = e.COMMENT(`;`, `$`, {
                relevance: 0
            }), s = {
                className: `literal`,
                begin: /\b([Tt]rue|[Ff]alse|nil|None)\b/
            }, c = {
                begin: `[\\[\\{]`,
                end: `[\\]\\}]`,
                relevance: 0
            }, l = {
                className: `comment`,
                begin: `\\^` + t
            }, u = e.COMMENT(`\\^\\{`, `\\}`), d = {
                className: `symbol`,
                begin: `[:]{1,2}` + t
            }, f = {
                begin: `\\(`,
                end: `\\)`
            }, p = {
                endsWithParent: !0,
                relevance: 0
            }, m = {
                className: `name`,
                relevance: 0,
                keywords: n,
                begin: t,
                starts: p
            }, h = [
                f,
                a,
                l,
                u,
                o,
                d,
                c,
                i,
                s,
                r
            ];
            return f.contains = [
                e.COMMENT(`comment`, ``),
                m,
                p
            ], p.contains = h, c.contains = h, {
                name: `Hy`,
                aliases: [
                    `hylang`
                ],
                illegal: /\S/,
                contains: [
                    e.SHEBANG(),
                    f,
                    a,
                    l,
                    u,
                    o,
                    d,
                    c,
                    i,
                    s
                ]
            };
        }
        t.exports = n;
    }), Be = o((e, t)=>{
        function n(e) {
            return {
                name: `Inform 7`,
                aliases: [
                    `i7`
                ],
                case_insensitive: !0,
                keywords: {
                    keyword: `thing room person man woman animal container supporter backdrop door scenery open closed locked inside gender is are say understand kind of rule`
                },
                contains: [
                    {
                        className: `string`,
                        begin: `"`,
                        end: `"`,
                        relevance: 0,
                        contains: [
                            {
                                className: `subst`,
                                begin: `\\[`,
                                end: `\\]`
                            }
                        ]
                    },
                    {
                        className: `section`,
                        begin: /^(Volume|Book|Part|Chapter|Section|Table)\b/,
                        end: `$`
                    },
                    {
                        begin: /^(Check|Carry out|Report|Instead of|To|Rule|When|Before|After)\b/,
                        end: `:`,
                        contains: [
                            {
                                begin: `\\(This`,
                                end: `\\)`
                            }
                        ]
                    },
                    {
                        className: `comment`,
                        begin: `\\[`,
                        end: `\\]`,
                        contains: [
                            `self`
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), Ve = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = {
                className: `number`,
                relevance: 0,
                variants: [
                    {
                        begin: /([+-]+)?[\d]+_[\d_]+/
                    },
                    {
                        begin: e.NUMBER_RE
                    }
                ]
            }, r = e.COMMENT();
            r.variants = [
                {
                    begin: /;/,
                    end: /$/
                },
                {
                    begin: /#/,
                    end: /$/
                }
            ];
            let i = {
                className: `variable`,
                variants: [
                    {
                        begin: /\$[\w\d"][\w\d_]*/
                    },
                    {
                        begin: /\$\{(.*?)\}/
                    }
                ]
            }, a = {
                className: `literal`,
                begin: /\bon|off|true|false|yes|no\b/
            }, o = {
                className: `string`,
                contains: [
                    e.BACKSLASH_ESCAPE
                ],
                variants: [
                    {
                        begin: `'''`,
                        end: `'''`,
                        relevance: 10
                    },
                    {
                        begin: `"""`,
                        end: `"""`,
                        relevance: 10
                    },
                    {
                        begin: `"`,
                        end: `"`
                    },
                    {
                        begin: `'`,
                        end: `'`
                    }
                ]
            }, s = {
                begin: /\[/,
                end: /\]/,
                contains: [
                    r,
                    a,
                    i,
                    o,
                    n,
                    `self`
                ],
                relevance: 0
            }, c = t.either(/[A-Za-z0-9_-]+/, /"(\\"|[^"])*"/, /'[^']*'/);
            return {
                name: `TOML, also INI`,
                aliases: [
                    `toml`
                ],
                case_insensitive: !0,
                illegal: /\S/,
                contains: [
                    r,
                    {
                        className: `section`,
                        begin: /\[+/,
                        end: /\]+/
                    },
                    {
                        begin: t.concat(c, `(\\s*\\.\\s*`, c, `)*`, t.lookahead(/\s*=\s*[^#\s]/)),
                        className: `attr`,
                        starts: {
                            end: /$/,
                            contains: [
                                r,
                                s,
                                a,
                                i,
                                o,
                                n
                            ]
                        }
                    }
                ]
            };
        }
        t.exports = n;
    }), He = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = {
                className: `params`,
                begin: `\\(`,
                end: `\\)`
            }, r = /(_[a-z_\d]+)?/, i = /([de][+-]?\d+)?/, a = {
                className: `number`,
                variants: [
                    {
                        begin: t.concat(/\b\d+/, /\.(\d*)/, i, r)
                    },
                    {
                        begin: t.concat(/\b\d+/, i, r)
                    },
                    {
                        begin: t.concat(/\.\d+/, i, r)
                    }
                ],
                relevance: 0
            };
            return {
                name: `IRPF90`,
                case_insensitive: !0,
                keywords: {
                    literal: `.False. .True.`,
                    keyword: `kind do while private call intrinsic where elsewhere type endtype endmodule endselect endinterface end enddo endif if forall endforall only contains default return stop then public subroutine|10 function program .and. .or. .not. .le. .eq. .ge. .gt. .lt. goto save else use module select case access blank direct exist file fmt form formatted iostat name named nextrec number opened rec recl sequential status unformatted unit continue format pause cycle exit c_null_char c_alert c_backspace c_form_feed flush wait decimal round iomsg synchronous nopass non_overridable pass protected volatile abstract extends import non_intrinsic value deferred generic final enumerator class associate bind enum c_int c_short c_long c_long_long c_signed_char c_size_t c_int8_t c_int16_t c_int32_t c_int64_t c_int_least8_t c_int_least16_t c_int_least32_t c_int_least64_t c_int_fast8_t c_int_fast16_t c_int_fast32_t c_int_fast64_t c_intmax_t C_intptr_t c_float c_double c_long_double c_float_complex c_double_complex c_long_double_complex c_bool c_char c_null_ptr c_null_funptr c_new_line c_carriage_return c_horizontal_tab c_vertical_tab iso_c_binding c_loc c_funloc c_associated  c_f_pointer c_ptr c_funptr iso_fortran_env character_storage_size error_unit file_storage_size input_unit iostat_end iostat_eor numeric_storage_size output_unit c_f_procpointer ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode newunit contiguous recursive pad position action delim readwrite eor advance nml interface procedure namelist include sequence elemental pure integer real character complex logical dimension allocatable|10 parameter external implicit|10 none double precision assign intent optional pointer target in out common equivalence data begin_provider &begin_provider end_provider begin_shell end_shell begin_template end_template subst assert touch soft_touch provide no_dep free irp_if irp_else irp_endif irp_write irp_read`,
                    built_in: `alog alog10 amax0 amax1 amin0 amin1 amod cabs ccos cexp clog csin csqrt dabs dacos dasin datan datan2 dcos dcosh ddim dexp dint dlog dlog10 dmax1 dmin1 dmod dnint dsign dsin dsinh dsqrt dtan dtanh float iabs idim idint idnint ifix isign max0 max1 min0 min1 sngl algama cdabs cdcos cdexp cdlog cdsin cdsqrt cqabs cqcos cqexp cqlog cqsin cqsqrt dcmplx dconjg derf derfc dfloat dgamma dimag dlgama iqint qabs qacos qasin qatan qatan2 qcmplx qconjg qcos qcosh qdim qerf qerfc qexp qgamma qimag qlgama qlog qlog10 qmax1 qmin1 qmod qnint qsign qsin qsinh qsqrt qtan qtanh abs acos aimag aint anint asin atan atan2 char cmplx conjg cos cosh exp ichar index int log log10 max min nint sign sin sinh sqrt tan tanh print write dim lge lgt lle llt mod nullify allocate deallocate adjustl adjustr all allocated any associated bit_size btest ceiling count cshift date_and_time digits dot_product eoshift epsilon exponent floor fraction huge iand ibclr ibits ibset ieor ior ishft ishftc lbound len_trim matmul maxexponent maxloc maxval merge minexponent minloc minval modulo mvbits nearest pack present product radix random_number random_seed range repeat reshape rrspacing scale scan selected_int_kind selected_real_kind set_exponent shape size spacing spread sum system_clock tiny transpose trim ubound unpack verify achar iachar transfer dble entry dprod cpu_time command_argument_count get_command get_command_argument get_environment_variable is_iostat_end ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode is_iostat_eor move_alloc new_line selected_char_kind same_type_as extends_type_of acosh asinh atanh bessel_j0 bessel_j1 bessel_jn bessel_y0 bessel_y1 bessel_yn erf erfc erfc_scaled gamma log_gamma hypot norm2 atomic_define atomic_ref execute_command_line leadz trailz storage_size merge_bits bge bgt ble blt dshiftl dshiftr findloc iall iany iparity image_index lcobound ucobound maskl maskr num_images parity popcnt poppar shifta shiftl shiftr this_image IRP_ALIGN irp_here`
                },
                illegal: /\/\*/,
                contains: [
                    e.inherit(e.APOS_STRING_MODE, {
                        className: `string`,
                        relevance: 0
                    }),
                    e.inherit(e.QUOTE_STRING_MODE, {
                        className: `string`,
                        relevance: 0
                    }),
                    {
                        className: `function`,
                        beginKeywords: `subroutine function program`,
                        illegal: "[${=\\n]",
                        contains: [
                            e.UNDERSCORE_TITLE_MODE,
                            n
                        ]
                    },
                    e.COMMENT(`!`, `$`, {
                        relevance: 0
                    }),
                    e.COMMENT(`begin_doc`, `end_doc`, {
                        relevance: 10
                    }),
                    a
                ]
            };
        }
        t.exports = n;
    }), Ue = o((e, t)=>{
        function n(e) {
            let t = `[A-Za-z\u{410}-\u{42F}\u{430}-\u{44F}\u{451}\u{401}_!][A-Za-z\u{410}-\u{42F}\u{430}-\u{44F}\u{451}\u{401}_0-9]*`, n = {
                className: `number`,
                begin: e.NUMBER_RE,
                relevance: 0
            }, r = {
                className: `string`,
                variants: [
                    {
                        begin: `"`,
                        end: `"`
                    },
                    {
                        begin: `'`,
                        end: `'`
                    }
                ]
            }, i = {
                className: `doctag`,
                begin: `\\b(?:TODO|DONE|BEGIN|END|STUB|CHG|FIXME|NOTE|BUG|XXX)\\b`,
                relevance: 0
            }, a = {
                variants: [
                    {
                        className: `comment`,
                        begin: `//`,
                        end: `$`,
                        relevance: 0,
                        contains: [
                            e.PHRASAL_WORDS_MODE,
                            i
                        ]
                    },
                    {
                        className: `comment`,
                        begin: `/\\*`,
                        end: `\\*/`,
                        relevance: 0,
                        contains: [
                            e.PHRASAL_WORDS_MODE,
                            i
                        ]
                    }
                ]
            }, o = {
                $pattern: t,
                keyword: `and \u{438} else \u{438}\u{43D}\u{430}\u{447}\u{435} endexcept endfinally endforeach \u{43A}\u{43E}\u{43D}\u{435}\u{446}\u{432}\u{441}\u{435} endif \u{43A}\u{43E}\u{43D}\u{435}\u{446}\u{435}\u{441}\u{43B}\u{438} endwhile \u{43A}\u{43E}\u{43D}\u{435}\u{446}\u{43F}\u{43E}\u{43A}\u{430} except exitfor finally foreach \u{432}\u{441}\u{435} if \u{435}\u{441}\u{43B}\u{438} in \u{432} not \u{43D}\u{435} or \u{438}\u{43B}\u{438} try while \u{43F}\u{43E}\u{43A}\u{430} `,
                built_in: `SYSRES_CONST_ACCES_RIGHT_TYPE_EDIT SYSRES_CONST_ACCES_RIGHT_TYPE_FULL SYSRES_CONST_ACCES_RIGHT_TYPE_VIEW SYSRES_CONST_ACCESS_MODE_REQUISITE_CODE SYSRES_CONST_ACCESS_NO_ACCESS_VIEW SYSRES_CONST_ACCESS_NO_ACCESS_VIEW_CODE SYSRES_CONST_ACCESS_RIGHTS_ADD_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_ADD_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_CHANGE_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_CHANGE_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_DELETE_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_DELETE_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_EXECUTE_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_EXECUTE_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_NO_ACCESS_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_NO_ACCESS_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_RATIFY_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_RATIFY_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_VIEW SYSRES_CONST_ACCESS_RIGHTS_VIEW_CODE SYSRES_CONST_ACCESS_RIGHTS_VIEW_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_VIEW_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_TYPE_CHANGE SYSRES_CONST_ACCESS_TYPE_CHANGE_CODE SYSRES_CONST_ACCESS_TYPE_EXISTS SYSRES_CONST_ACCESS_TYPE_EXISTS_CODE SYSRES_CONST_ACCESS_TYPE_FULL SYSRES_CONST_ACCESS_TYPE_FULL_CODE SYSRES_CONST_ACCESS_TYPE_VIEW SYSRES_CONST_ACCESS_TYPE_VIEW_CODE SYSRES_CONST_ACTION_TYPE_ABORT SYSRES_CONST_ACTION_TYPE_ACCEPT SYSRES_CONST_ACTION_TYPE_ACCESS_RIGHTS SYSRES_CONST_ACTION_TYPE_ADD_ATTACHMENT SYSRES_CONST_ACTION_TYPE_CHANGE_CARD SYSRES_CONST_ACTION_TYPE_CHANGE_KIND SYSRES_CONST_ACTION_TYPE_CHANGE_STORAGE SYSRES_CONST_ACTION_TYPE_CONTINUE SYSRES_CONST_ACTION_TYPE_COPY SYSRES_CONST_ACTION_TYPE_CREATE SYSRES_CONST_ACTION_TYPE_CREATE_VERSION SYSRES_CONST_ACTION_TYPE_DELETE SYSRES_CONST_ACTION_TYPE_DELETE_ATTACHMENT SYSRES_CONST_ACTION_TYPE_DELETE_VERSION SYSRES_CONST_ACTION_TYPE_DISABLE_DELEGATE_ACCESS_RIGHTS SYSRES_CONST_ACTION_TYPE_ENABLE_DELEGATE_ACCESS_RIGHTS SYSRES_CONST_ACTION_TYPE_ENCRYPTION_BY_CERTIFICATE SYSRES_CONST_ACTION_TYPE_ENCRYPTION_BY_CERTIFICATE_AND_PASSWORD SYSRES_CONST_ACTION_TYPE_ENCRYPTION_BY_PASSWORD SYSRES_CONST_ACTION_TYPE_EXPORT_WITH_LOCK SYSRES_CONST_ACTION_TYPE_EXPORT_WITHOUT_LOCK SYSRES_CONST_ACTION_TYPE_IMPORT_WITH_UNLOCK SYSRES_CONST_ACTION_TYPE_IMPORT_WITHOUT_UNLOCK SYSRES_CONST_ACTION_TYPE_LIFE_CYCLE_STAGE SYSRES_CONST_ACTION_TYPE_LOCK SYSRES_CONST_ACTION_TYPE_LOCK_FOR_SERVER SYSRES_CONST_ACTION_TYPE_LOCK_MODIFY SYSRES_CONST_ACTION_TYPE_MARK_AS_READED SYSRES_CONST_ACTION_TYPE_MARK_AS_UNREADED SYSRES_CONST_ACTION_TYPE_MODIFY SYSRES_CONST_ACTION_TYPE_MODIFY_CARD SYSRES_CONST_ACTION_TYPE_MOVE_TO_ARCHIVE SYSRES_CONST_ACTION_TYPE_OFF_ENCRYPTION SYSRES_CONST_ACTION_TYPE_PASSWORD_CHANGE SYSRES_CONST_ACTION_TYPE_PERFORM SYSRES_CONST_ACTION_TYPE_RECOVER_FROM_LOCAL_COPY SYSRES_CONST_ACTION_TYPE_RESTART SYSRES_CONST_ACTION_TYPE_RESTORE_FROM_ARCHIVE SYSRES_CONST_ACTION_TYPE_REVISION SYSRES_CONST_ACTION_TYPE_SEND_BY_MAIL SYSRES_CONST_ACTION_TYPE_SIGN SYSRES_CONST_ACTION_TYPE_START SYSRES_CONST_ACTION_TYPE_UNLOCK SYSRES_CONST_ACTION_TYPE_UNLOCK_FROM_SERVER SYSRES_CONST_ACTION_TYPE_VERSION_STATE SYSRES_CONST_ACTION_TYPE_VERSION_VISIBILITY SYSRES_CONST_ACTION_TYPE_VIEW SYSRES_CONST_ACTION_TYPE_VIEW_SHADOW_COPY SYSRES_CONST_ACTION_TYPE_WORKFLOW_DESCRIPTION_MODIFY SYSRES_CONST_ACTION_TYPE_WRITE_HISTORY SYSRES_CONST_ACTIVE_VERSION_STATE_PICK_VALUE SYSRES_CONST_ADD_REFERENCE_MODE_NAME SYSRES_CONST_ADDITION_REQUISITE_CODE SYSRES_CONST_ADDITIONAL_PARAMS_REQUISITE_CODE SYSRES_CONST_ADITIONAL_JOB_END_DATE_REQUISITE_NAME SYSRES_CONST_ADITIONAL_JOB_READ_REQUISITE_NAME SYSRES_CONST_ADITIONAL_JOB_START_DATE_REQUISITE_NAME SYSRES_CONST_ADITIONAL_JOB_STATE_REQUISITE_NAME SYSRES_CONST_ADMINISTRATION_HISTORY_ADDING_USER_TO_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_ADDING_USER_TO_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_COMP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_COMP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_USER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_USER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_CREATION SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_CREATION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_DELETION SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_DELETION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_COMP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_COMP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_FROM_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_FROM_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_RESTRICTION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_RESTRICTION_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_PRIVILEGE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_PRIVILEGE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_RIGHTS_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_RIGHTS_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_IS_MAIN_SERVER_CHANGED_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_IS_MAIN_SERVER_CHANGED_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_IS_PUBLIC_CHANGED_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_IS_PUBLIC_CHANGED_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_RESTRICTION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_RESTRICTION_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_PRIVILEGE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_PRIVILEGE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_RIGHTS_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_RIGHTS_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_CREATION SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_CREATION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_DELETION SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_DELETION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_CATEGORY_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_CATEGORY_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_COMP_TITLE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_COMP_TITLE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_FULL_NAME_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_FULL_NAME_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_PARENT_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_PARENT_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_AUTH_TYPE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_AUTH_TYPE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_LOGIN_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_LOGIN_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_STATUS_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_STATUS_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_USER_PASSWORD_CHANGE SYSRES_CONST_ADMINISTRATION_HISTORY_USER_PASSWORD_CHANGE_ACTION SYSRES_CONST_ALL_ACCEPT_CONDITION_RUS SYSRES_CONST_ALL_USERS_GROUP SYSRES_CONST_ALL_USERS_GROUP_NAME SYSRES_CONST_ALL_USERS_SERVER_GROUP_NAME SYSRES_CONST_ALLOWED_ACCESS_TYPE_CODE SYSRES_CONST_ALLOWED_ACCESS_TYPE_NAME SYSRES_CONST_APP_VIEWER_TYPE_REQUISITE_CODE SYSRES_CONST_APPROVING_SIGNATURE_NAME SYSRES_CONST_APPROVING_SIGNATURE_REQUISITE_CODE SYSRES_CONST_ASSISTANT_SUBSTITUE_TYPE SYSRES_CONST_ASSISTANT_SUBSTITUE_TYPE_CODE SYSRES_CONST_ATTACH_TYPE_COMPONENT_TOKEN SYSRES_CONST_ATTACH_TYPE_DOC SYSRES_CONST_ATTACH_TYPE_EDOC SYSRES_CONST_ATTACH_TYPE_FOLDER SYSRES_CONST_ATTACH_TYPE_JOB SYSRES_CONST_ATTACH_TYPE_REFERENCE SYSRES_CONST_ATTACH_TYPE_TASK SYSRES_CONST_AUTH_ENCODED_PASSWORD SYSRES_CONST_AUTH_ENCODED_PASSWORD_CODE SYSRES_CONST_AUTH_NOVELL SYSRES_CONST_AUTH_PASSWORD SYSRES_CONST_AUTH_PASSWORD_CODE SYSRES_CONST_AUTH_WINDOWS SYSRES_CONST_AUTHENTICATING_SIGNATURE_NAME SYSRES_CONST_AUTHENTICATING_SIGNATURE_REQUISITE_CODE SYSRES_CONST_AUTO_ENUM_METHOD_FLAG SYSRES_CONST_AUTO_NUMERATION_CODE SYSRES_CONST_AUTO_STRONG_ENUM_METHOD_FLAG SYSRES_CONST_AUTOTEXT_NAME_REQUISITE_CODE SYSRES_CONST_AUTOTEXT_TEXT_REQUISITE_CODE SYSRES_CONST_AUTOTEXT_USAGE_ALL SYSRES_CONST_AUTOTEXT_USAGE_ALL_CODE SYSRES_CONST_AUTOTEXT_USAGE_SIGN SYSRES_CONST_AUTOTEXT_USAGE_SIGN_CODE SYSRES_CONST_AUTOTEXT_USAGE_WORK SYSRES_CONST_AUTOTEXT_USAGE_WORK_CODE SYSRES_CONST_AUTOTEXT_USE_ANYWHERE_CODE SYSRES_CONST_AUTOTEXT_USE_ON_SIGNING_CODE SYSRES_CONST_AUTOTEXT_USE_ON_WORK_CODE SYSRES_CONST_BEGIN_DATE_REQUISITE_CODE SYSRES_CONST_BLACK_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_BLUE_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_BTN_PART SYSRES_CONST_CALCULATED_ROLE_TYPE_CODE SYSRES_CONST_CALL_TYPE_VARIABLE_BUTTON_VALUE SYSRES_CONST_CALL_TYPE_VARIABLE_PROGRAM_VALUE SYSRES_CONST_CANCEL_MESSAGE_FUNCTION_RESULT SYSRES_CONST_CARD_PART SYSRES_CONST_CARD_REFERENCE_MODE_NAME SYSRES_CONST_CERTIFICATE_TYPE_REQUISITE_ENCRYPT_VALUE SYSRES_CONST_CERTIFICATE_TYPE_REQUISITE_SIGN_AND_ENCRYPT_VALUE SYSRES_CONST_CERTIFICATE_TYPE_REQUISITE_SIGN_VALUE SYSRES_CONST_CHECK_PARAM_VALUE_DATE_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_FLOAT_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_INTEGER_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_PICK_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_REEFRENCE_PARAM_TYPE SYSRES_CONST_CLOSED_RECORD_FLAG_VALUE_FEMININE SYSRES_CONST_CLOSED_RECORD_FLAG_VALUE_MASCULINE SYSRES_CONST_CODE_COMPONENT_TYPE_ADMIN SYSRES_CONST_CODE_COMPONENT_TYPE_DEVELOPER SYSRES_CONST_CODE_COMPONENT_TYPE_DOCS SYSRES_CONST_CODE_COMPONENT_TYPE_EDOC_CARDS SYSRES_CONST_CODE_COMPONENT_TYPE_EXTERNAL_EXECUTABLE SYSRES_CONST_CODE_COMPONENT_TYPE_OTHER SYSRES_CONST_CODE_COMPONENT_TYPE_REFERENCE SYSRES_CONST_CODE_COMPONENT_TYPE_REPORT SYSRES_CONST_CODE_COMPONENT_TYPE_SCRIPT SYSRES_CONST_CODE_COMPONENT_TYPE_URL SYSRES_CONST_CODE_REQUISITE_ACCESS SYSRES_CONST_CODE_REQUISITE_CODE SYSRES_CONST_CODE_REQUISITE_COMPONENT SYSRES_CONST_CODE_REQUISITE_DESCRIPTION SYSRES_CONST_CODE_REQUISITE_EXCLUDE_COMPONENT SYSRES_CONST_CODE_REQUISITE_RECORD SYSRES_CONST_COMMENT_REQ_CODE SYSRES_CONST_COMMON_SETTINGS_REQUISITE_CODE SYSRES_CONST_COMP_CODE_GRD SYSRES_CONST_COMPONENT_GROUP_TYPE_REQUISITE_CODE SYSRES_CONST_COMPONENT_TYPE_ADMIN_COMPONENTS SYSRES_CONST_COMPONENT_TYPE_DEVELOPER_COMPONENTS SYSRES_CONST_COMPONENT_TYPE_DOCS SYSRES_CONST_COMPONENT_TYPE_EDOC_CARDS SYSRES_CONST_COMPONENT_TYPE_EDOCS SYSRES_CONST_COMPONENT_TYPE_EXTERNAL_EXECUTABLE SYSRES_CONST_COMPONENT_TYPE_OTHER SYSRES_CONST_COMPONENT_TYPE_REFERENCE_TYPES SYSRES_CONST_COMPONENT_TYPE_REFERENCES SYSRES_CONST_COMPONENT_TYPE_REPORTS SYSRES_CONST_COMPONENT_TYPE_SCRIPTS SYSRES_CONST_COMPONENT_TYPE_URL SYSRES_CONST_COMPONENTS_REMOTE_SERVERS_VIEW_CODE SYSRES_CONST_CONDITION_BLOCK_DESCRIPTION SYSRES_CONST_CONST_FIRM_STATUS_COMMON SYSRES_CONST_CONST_FIRM_STATUS_INDIVIDUAL SYSRES_CONST_CONST_NEGATIVE_VALUE SYSRES_CONST_CONST_POSITIVE_VALUE SYSRES_CONST_CONST_SERVER_STATUS_DONT_REPLICATE SYSRES_CONST_CONST_SERVER_STATUS_REPLICATE SYSRES_CONST_CONTENTS_REQUISITE_CODE SYSRES_CONST_DATA_TYPE_BOOLEAN SYSRES_CONST_DATA_TYPE_DATE SYSRES_CONST_DATA_TYPE_FLOAT SYSRES_CONST_DATA_TYPE_INTEGER SYSRES_CONST_DATA_TYPE_PICK SYSRES_CONST_DATA_TYPE_REFERENCE SYSRES_CONST_DATA_TYPE_STRING SYSRES_CONST_DATA_TYPE_TEXT SYSRES_CONST_DATA_TYPE_VARIANT SYSRES_CONST_DATE_CLOSE_REQ_CODE SYSRES_CONST_DATE_FORMAT_DATE_ONLY_CHAR SYSRES_CONST_DATE_OPEN_REQ_CODE SYSRES_CONST_DATE_REQUISITE SYSRES_CONST_DATE_REQUISITE_CODE SYSRES_CONST_DATE_REQUISITE_NAME SYSRES_CONST_DATE_REQUISITE_TYPE SYSRES_CONST_DATE_TYPE_CHAR SYSRES_CONST_DATETIME_FORMAT_VALUE SYSRES_CONST_DEA_ACCESS_RIGHTS_ACTION_CODE SYSRES_CONST_DESCRIPTION_LOCALIZE_ID_REQUISITE_CODE SYSRES_CONST_DESCRIPTION_REQUISITE_CODE SYSRES_CONST_DET1_PART SYSRES_CONST_DET2_PART SYSRES_CONST_DET3_PART SYSRES_CONST_DET4_PART SYSRES_CONST_DET5_PART SYSRES_CONST_DET6_PART SYSRES_CONST_DETAIL_DATASET_KEY_REQUISITE_CODE SYSRES_CONST_DETAIL_PICK_REQUISITE_CODE SYSRES_CONST_DETAIL_REQ_CODE SYSRES_CONST_DO_NOT_USE_ACCESS_TYPE_CODE SYSRES_CONST_DO_NOT_USE_ACCESS_TYPE_NAME SYSRES_CONST_DO_NOT_USE_ON_VIEW_ACCESS_TYPE_CODE SYSRES_CONST_DO_NOT_USE_ON_VIEW_ACCESS_TYPE_NAME SYSRES_CONST_DOCUMENT_STORAGES_CODE SYSRES_CONST_DOCUMENT_TEMPLATES_TYPE_NAME SYSRES_CONST_DOUBLE_REQUISITE_CODE SYSRES_CONST_EDITOR_CLOSE_FILE_OBSERV_TYPE_CODE SYSRES_CONST_EDITOR_CLOSE_PROCESS_OBSERV_TYPE_CODE SYSRES_CONST_EDITOR_TYPE_REQUISITE_CODE SYSRES_CONST_EDITORS_APPLICATION_NAME_REQUISITE_CODE SYSRES_CONST_EDITORS_CREATE_SEVERAL_PROCESSES_REQUISITE_CODE SYSRES_CONST_EDITORS_EXTENSION_REQUISITE_CODE SYSRES_CONST_EDITORS_OBSERVER_BY_PROCESS_TYPE SYSRES_CONST_EDITORS_REFERENCE_CODE SYSRES_CONST_EDITORS_REPLACE_SPEC_CHARS_REQUISITE_CODE SYSRES_CONST_EDITORS_USE_PLUGINS_REQUISITE_CODE SYSRES_CONST_EDITORS_VIEW_DOCUMENT_OPENED_TO_EDIT_CODE SYSRES_CONST_EDOC_CARD_TYPE_REQUISITE_CODE SYSRES_CONST_EDOC_CARD_TYPES_LINK_REQUISITE_CODE SYSRES_CONST_EDOC_CERTIFICATE_AND_PASSWORD_ENCODE_CODE SYSRES_CONST_EDOC_CERTIFICATE_ENCODE_CODE SYSRES_CONST_EDOC_DATE_REQUISITE_CODE SYSRES_CONST_EDOC_KIND_REFERENCE_CODE SYSRES_CONST_EDOC_KINDS_BY_TEMPLATE_ACTION_CODE SYSRES_CONST_EDOC_MANAGE_ACCESS_CODE SYSRES_CONST_EDOC_NONE_ENCODE_CODE SYSRES_CONST_EDOC_NUMBER_REQUISITE_CODE SYSRES_CONST_EDOC_PASSWORD_ENCODE_CODE SYSRES_CONST_EDOC_READONLY_ACCESS_CODE SYSRES_CONST_EDOC_SHELL_LIFE_TYPE_VIEW_VALUE SYSRES_CONST_EDOC_SIZE_RESTRICTION_PRIORITY_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_CHECK_ACCESS_RIGHTS_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_COMPUTER_NAME_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_DATABASE_NAME_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_EDIT_IN_STORAGE_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_LOCAL_PATH_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_SHARED_SOURCE_NAME_REQUISITE_CODE SYSRES_CONST_EDOC_TEMPLATE_REQUISITE_CODE SYSRES_CONST_EDOC_TYPES_REFERENCE_CODE SYSRES_CONST_EDOC_VERSION_ACTIVE_STAGE_CODE SYSRES_CONST_EDOC_VERSION_DESIGN_STAGE_CODE SYSRES_CONST_EDOC_VERSION_OBSOLETE_STAGE_CODE SYSRES_CONST_EDOC_WRITE_ACCES_CODE SYSRES_CONST_EDOCUMENT_CARD_REQUISITES_REFERENCE_CODE_SELECTED_REQUISITE SYSRES_CONST_ENCODE_CERTIFICATE_TYPE_CODE SYSRES_CONST_END_DATE_REQUISITE_CODE SYSRES_CONST_ENUMERATION_TYPE_REQUISITE_CODE SYSRES_CONST_EXECUTE_ACCESS_RIGHTS_TYPE_CODE SYSRES_CONST_EXECUTIVE_FILE_STORAGE_TYPE SYSRES_CONST_EXIST_CONST SYSRES_CONST_EXIST_VALUE SYSRES_CONST_EXPORT_LOCK_TYPE_ASK SYSRES_CONST_EXPORT_LOCK_TYPE_WITH_LOCK SYSRES_CONST_EXPORT_LOCK_TYPE_WITHOUT_LOCK SYSRES_CONST_EXPORT_VERSION_TYPE_ASK SYSRES_CONST_EXPORT_VERSION_TYPE_LAST SYSRES_CONST_EXPORT_VERSION_TYPE_LAST_ACTIVE SYSRES_CONST_EXTENSION_REQUISITE_CODE SYSRES_CONST_FILTER_NAME_REQUISITE_CODE SYSRES_CONST_FILTER_REQUISITE_CODE SYSRES_CONST_FILTER_TYPE_COMMON_CODE SYSRES_CONST_FILTER_TYPE_COMMON_NAME SYSRES_CONST_FILTER_TYPE_USER_CODE SYSRES_CONST_FILTER_TYPE_USER_NAME SYSRES_CONST_FILTER_VALUE_REQUISITE_NAME SYSRES_CONST_FLOAT_NUMBER_FORMAT_CHAR SYSRES_CONST_FLOAT_REQUISITE_TYPE SYSRES_CONST_FOLDER_AUTHOR_VALUE SYSRES_CONST_FOLDER_KIND_ANY_OBJECTS SYSRES_CONST_FOLDER_KIND_COMPONENTS SYSRES_CONST_FOLDER_KIND_EDOCS SYSRES_CONST_FOLDER_KIND_JOBS SYSRES_CONST_FOLDER_KIND_TASKS SYSRES_CONST_FOLDER_TYPE_COMMON SYSRES_CONST_FOLDER_TYPE_COMPONENT SYSRES_CONST_FOLDER_TYPE_FAVORITES SYSRES_CONST_FOLDER_TYPE_INBOX SYSRES_CONST_FOLDER_TYPE_OUTBOX SYSRES_CONST_FOLDER_TYPE_QUICK_LAUNCH SYSRES_CONST_FOLDER_TYPE_SEARCH SYSRES_CONST_FOLDER_TYPE_SHORTCUTS SYSRES_CONST_FOLDER_TYPE_USER SYSRES_CONST_FROM_DICTIONARY_ENUM_METHOD_FLAG SYSRES_CONST_FULL_SUBSTITUTE_TYPE SYSRES_CONST_FULL_SUBSTITUTE_TYPE_CODE SYSRES_CONST_FUNCTION_CANCEL_RESULT SYSRES_CONST_FUNCTION_CATEGORY_SYSTEM SYSRES_CONST_FUNCTION_CATEGORY_USER SYSRES_CONST_FUNCTION_FAILURE_RESULT SYSRES_CONST_FUNCTION_SAVE_RESULT SYSRES_CONST_GENERATED_REQUISITE SYSRES_CONST_GREEN_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_GROUP_ACCOUNT_TYPE_VALUE_CODE SYSRES_CONST_GROUP_CATEGORY_NORMAL_CODE SYSRES_CONST_GROUP_CATEGORY_NORMAL_NAME SYSRES_CONST_GROUP_CATEGORY_SERVICE_CODE SYSRES_CONST_GROUP_CATEGORY_SERVICE_NAME SYSRES_CONST_GROUP_COMMON_CATEGORY_FIELD_VALUE SYSRES_CONST_GROUP_FULL_NAME_REQUISITE_CODE SYSRES_CONST_GROUP_NAME_REQUISITE_CODE SYSRES_CONST_GROUP_RIGHTS_T_REQUISITE_CODE SYSRES_CONST_GROUP_SERVER_CODES_REQUISITE_CODE SYSRES_CONST_GROUP_SERVER_NAME_REQUISITE_CODE SYSRES_CONST_GROUP_SERVICE_CATEGORY_FIELD_VALUE SYSRES_CONST_GROUP_USER_REQUISITE_CODE SYSRES_CONST_GROUPS_REFERENCE_CODE SYSRES_CONST_GROUPS_REQUISITE_CODE SYSRES_CONST_HIDDEN_MODE_NAME SYSRES_CONST_HIGH_LVL_REQUISITE_CODE SYSRES_CONST_HISTORY_ACTION_CREATE_CODE SYSRES_CONST_HISTORY_ACTION_DELETE_CODE SYSRES_CONST_HISTORY_ACTION_EDIT_CODE SYSRES_CONST_HOUR_CHAR SYSRES_CONST_ID_REQUISITE_CODE SYSRES_CONST_IDSPS_REQUISITE_CODE SYSRES_CONST_IMAGE_MODE_COLOR SYSRES_CONST_IMAGE_MODE_GREYSCALE SYSRES_CONST_IMAGE_MODE_MONOCHROME SYSRES_CONST_IMPORTANCE_HIGH SYSRES_CONST_IMPORTANCE_LOW SYSRES_CONST_IMPORTANCE_NORMAL SYSRES_CONST_IN_DESIGN_VERSION_STATE_PICK_VALUE SYSRES_CONST_INCOMING_WORK_RULE_TYPE_CODE SYSRES_CONST_INT_REQUISITE SYSRES_CONST_INT_REQUISITE_TYPE SYSRES_CONST_INTEGER_NUMBER_FORMAT_CHAR SYSRES_CONST_INTEGER_TYPE_CHAR SYSRES_CONST_IS_GENERATED_REQUISITE_NEGATIVE_VALUE SYSRES_CONST_IS_PUBLIC_ROLE_REQUISITE_CODE SYSRES_CONST_IS_REMOTE_USER_NEGATIVE_VALUE SYSRES_CONST_IS_REMOTE_USER_POSITIVE_VALUE SYSRES_CONST_IS_STORED_REQUISITE_NEGATIVE_VALUE SYSRES_CONST_IS_STORED_REQUISITE_STORED_VALUE SYSRES_CONST_ITALIC_LIFE_CYCLE_STAGE_DRAW_STYLE SYSRES_CONST_JOB_BLOCK_DESCRIPTION SYSRES_CONST_JOB_KIND_CONTROL_JOB SYSRES_CONST_JOB_KIND_JOB SYSRES_CONST_JOB_KIND_NOTICE SYSRES_CONST_JOB_STATE_ABORTED SYSRES_CONST_JOB_STATE_COMPLETE SYSRES_CONST_JOB_STATE_WORKING SYSRES_CONST_KIND_REQUISITE_CODE SYSRES_CONST_KIND_REQUISITE_NAME SYSRES_CONST_KINDS_CREATE_SHADOW_COPIES_REQUISITE_CODE SYSRES_CONST_KINDS_DEFAULT_EDOC_LIFE_STAGE_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_ALL_TEPLATES_ALLOWED_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_ALLOW_LIFE_CYCLE_STAGE_CHANGING_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_ALLOW_MULTIPLE_ACTIVE_VERSIONS_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_SHARE_ACCES_RIGHTS_BY_DEFAULT_CODE SYSRES_CONST_KINDS_EDOC_TEMPLATE_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_TYPE_REQUISITE_CODE SYSRES_CONST_KINDS_SIGNERS_REQUISITES_CODE SYSRES_CONST_KOD_INPUT_TYPE SYSRES_CONST_LAST_UPDATE_DATE_REQUISITE_CODE SYSRES_CONST_LIFE_CYCLE_START_STAGE_REQUISITE_CODE SYSRES_CONST_LILAC_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_LINK_OBJECT_KIND_COMPONENT SYSRES_CONST_LINK_OBJECT_KIND_DOCUMENT SYSRES_CONST_LINK_OBJECT_KIND_EDOC SYSRES_CONST_LINK_OBJECT_KIND_FOLDER SYSRES_CONST_LINK_OBJECT_KIND_JOB SYSRES_CONST_LINK_OBJECT_KIND_REFERENCE SYSRES_CONST_LINK_OBJECT_KIND_TASK SYSRES_CONST_LINK_REF_TYPE_REQUISITE_CODE SYSRES_CONST_LIST_REFERENCE_MODE_NAME SYSRES_CONST_LOCALIZATION_DICTIONARY_MAIN_VIEW_CODE SYSRES_CONST_MAIN_VIEW_CODE SYSRES_CONST_MANUAL_ENUM_METHOD_FLAG SYSRES_CONST_MASTER_COMP_TYPE_REQUISITE_CODE SYSRES_CONST_MASTER_TABLE_REC_ID_REQUISITE_CODE SYSRES_CONST_MAXIMIZED_MODE_NAME SYSRES_CONST_ME_VALUE SYSRES_CONST_MESSAGE_ATTENTION_CAPTION SYSRES_CONST_MESSAGE_CONFIRMATION_CAPTION SYSRES_CONST_MESSAGE_ERROR_CAPTION SYSRES_CONST_MESSAGE_INFORMATION_CAPTION SYSRES_CONST_MINIMIZED_MODE_NAME SYSRES_CONST_MINUTE_CHAR SYSRES_CONST_MODULE_REQUISITE_CODE SYSRES_CONST_MONITORING_BLOCK_DESCRIPTION SYSRES_CONST_MONTH_FORMAT_VALUE SYSRES_CONST_NAME_LOCALIZE_ID_REQUISITE_CODE SYSRES_CONST_NAME_REQUISITE_CODE SYSRES_CONST_NAME_SINGULAR_REQUISITE_CODE SYSRES_CONST_NAMEAN_INPUT_TYPE SYSRES_CONST_NEGATIVE_PICK_VALUE SYSRES_CONST_NEGATIVE_VALUE SYSRES_CONST_NO SYSRES_CONST_NO_PICK_VALUE SYSRES_CONST_NO_SIGNATURE_REQUISITE_CODE SYSRES_CONST_NO_VALUE SYSRES_CONST_NONE_ACCESS_RIGHTS_TYPE_CODE SYSRES_CONST_NONOPERATING_RECORD_FLAG_VALUE SYSRES_CONST_NONOPERATING_RECORD_FLAG_VALUE_MASCULINE SYSRES_CONST_NORMAL_ACCESS_RIGHTS_TYPE_CODE SYSRES_CONST_NORMAL_LIFE_CYCLE_STAGE_DRAW_STYLE SYSRES_CONST_NORMAL_MODE_NAME SYSRES_CONST_NOT_ALLOWED_ACCESS_TYPE_CODE SYSRES_CONST_NOT_ALLOWED_ACCESS_TYPE_NAME SYSRES_CONST_NOTE_REQUISITE_CODE SYSRES_CONST_NOTICE_BLOCK_DESCRIPTION SYSRES_CONST_NUM_REQUISITE SYSRES_CONST_NUM_STR_REQUISITE_CODE SYSRES_CONST_NUMERATION_AUTO_NOT_STRONG SYSRES_CONST_NUMERATION_AUTO_STRONG SYSRES_CONST_NUMERATION_FROM_DICTONARY SYSRES_CONST_NUMERATION_MANUAL SYSRES_CONST_NUMERIC_TYPE_CHAR SYSRES_CONST_NUMREQ_REQUISITE_CODE SYSRES_CONST_OBSOLETE_VERSION_STATE_PICK_VALUE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE_CODE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE_FEMININE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE_MASCULINE SYSRES_CONST_OPTIONAL_FORM_COMP_REQCODE_PREFIX SYSRES_CONST_ORANGE_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_ORIGINALREF_REQUISITE_CODE SYSRES_CONST_OURFIRM_REF_CODE SYSRES_CONST_OURFIRM_REQUISITE_CODE SYSRES_CONST_OURFIRM_VAR SYSRES_CONST_OUTGOING_WORK_RULE_TYPE_CODE SYSRES_CONST_PICK_NEGATIVE_RESULT SYSRES_CONST_PICK_POSITIVE_RESULT SYSRES_CONST_PICK_REQUISITE SYSRES_CONST_PICK_REQUISITE_TYPE SYSRES_CONST_PICK_TYPE_CHAR SYSRES_CONST_PLAN_STATUS_REQUISITE_CODE SYSRES_CONST_PLATFORM_VERSION_COMMENT SYSRES_CONST_PLUGINS_SETTINGS_DESCRIPTION_REQUISITE_CODE SYSRES_CONST_POSITIVE_PICK_VALUE SYSRES_CONST_POWER_TO_CREATE_ACTION_CODE SYSRES_CONST_POWER_TO_SIGN_ACTION_CODE SYSRES_CONST_PRIORITY_REQUISITE_CODE SYSRES_CONST_QUALIFIED_TASK_TYPE SYSRES_CONST_QUALIFIED_TASK_TYPE_CODE SYSRES_CONST_RECSTAT_REQUISITE_CODE SYSRES_CONST_RED_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_REF_ID_T_REF_TYPE_REQUISITE_CODE SYSRES_CONST_REF_REQUISITE SYSRES_CONST_REF_REQUISITE_TYPE SYSRES_CONST_REF_REQUISITES_REFERENCE_CODE_SELECTED_REQUISITE SYSRES_CONST_REFERENCE_RECORD_HISTORY_CREATE_ACTION_CODE SYSRES_CONST_REFERENCE_RECORD_HISTORY_DELETE_ACTION_CODE SYSRES_CONST_REFERENCE_RECORD_HISTORY_MODIFY_ACTION_CODE SYSRES_CONST_REFERENCE_TYPE_CHAR SYSRES_CONST_REFERENCE_TYPE_REQUISITE_NAME SYSRES_CONST_REFERENCES_ADD_PARAMS_REQUISITE_CODE SYSRES_CONST_REFERENCES_DISPLAY_REQUISITE_REQUISITE_CODE SYSRES_CONST_REMOTE_SERVER_STATUS_WORKING SYSRES_CONST_REMOTE_SERVER_TYPE_MAIN SYSRES_CONST_REMOTE_SERVER_TYPE_SECONDARY SYSRES_CONST_REMOTE_USER_FLAG_VALUE_CODE SYSRES_CONST_REPORT_APP_EDITOR_INTERNAL SYSRES_CONST_REPORT_BASE_REPORT_ID_REQUISITE_CODE SYSRES_CONST_REPORT_BASE_REPORT_REQUISITE_CODE SYSRES_CONST_REPORT_SCRIPT_REQUISITE_CODE SYSRES_CONST_REPORT_TEMPLATE_REQUISITE_CODE SYSRES_CONST_REPORT_VIEWER_CODE_REQUISITE_CODE SYSRES_CONST_REQ_ALLOW_COMPONENT_DEFAULT_VALUE SYSRES_CONST_REQ_ALLOW_RECORD_DEFAULT_VALUE SYSRES_CONST_REQ_ALLOW_SERVER_COMPONENT_DEFAULT_VALUE SYSRES_CONST_REQ_MODE_AVAILABLE_CODE SYSRES_CONST_REQ_MODE_EDIT_CODE SYSRES_CONST_REQ_MODE_HIDDEN_CODE SYSRES_CONST_REQ_MODE_NOT_AVAILABLE_CODE SYSRES_CONST_REQ_MODE_VIEW_CODE SYSRES_CONST_REQ_NUMBER_REQUISITE_CODE SYSRES_CONST_REQ_SECTION_VALUE SYSRES_CONST_REQ_TYPE_VALUE SYSRES_CONST_REQUISITE_FORMAT_BY_UNIT SYSRES_CONST_REQUISITE_FORMAT_DATE_FULL SYSRES_CONST_REQUISITE_FORMAT_DATE_TIME SYSRES_CONST_REQUISITE_FORMAT_LEFT SYSRES_CONST_REQUISITE_FORMAT_RIGHT SYSRES_CONST_REQUISITE_FORMAT_WITHOUT_UNIT SYSRES_CONST_REQUISITE_NUMBER_REQUISITE_CODE SYSRES_CONST_REQUISITE_SECTION_ACTIONS SYSRES_CONST_REQUISITE_SECTION_BUTTON SYSRES_CONST_REQUISITE_SECTION_BUTTONS SYSRES_CONST_REQUISITE_SECTION_CARD SYSRES_CONST_REQUISITE_SECTION_TABLE SYSRES_CONST_REQUISITE_SECTION_TABLE10 SYSRES_CONST_REQUISITE_SECTION_TABLE11 SYSRES_CONST_REQUISITE_SECTION_TABLE12 SYSRES_CONST_REQUISITE_SECTION_TABLE13 SYSRES_CONST_REQUISITE_SECTION_TABLE14 SYSRES_CONST_REQUISITE_SECTION_TABLE15 SYSRES_CONST_REQUISITE_SECTION_TABLE16 SYSRES_CONST_REQUISITE_SECTION_TABLE17 SYSRES_CONST_REQUISITE_SECTION_TABLE18 SYSRES_CONST_REQUISITE_SECTION_TABLE19 SYSRES_CONST_REQUISITE_SECTION_TABLE2 SYSRES_CONST_REQUISITE_SECTION_TABLE20 SYSRES_CONST_REQUISITE_SECTION_TABLE21 SYSRES_CONST_REQUISITE_SECTION_TABLE22 SYSRES_CONST_REQUISITE_SECTION_TABLE23 SYSRES_CONST_REQUISITE_SECTION_TABLE24 SYSRES_CONST_REQUISITE_SECTION_TABLE3 SYSRES_CONST_REQUISITE_SECTION_TABLE4 SYSRES_CONST_REQUISITE_SECTION_TABLE5 SYSRES_CONST_REQUISITE_SECTION_TABLE6 SYSRES_CONST_REQUISITE_SECTION_TABLE7 SYSRES_CONST_REQUISITE_SECTION_TABLE8 SYSRES_CONST_REQUISITE_SECTION_TABLE9 SYSRES_CONST_REQUISITES_PSEUDOREFERENCE_REQUISITE_NUMBER_REQUISITE_CODE SYSRES_CONST_RIGHT_ALIGNMENT_CODE SYSRES_CONST_ROLES_REFERENCE_CODE SYSRES_CONST_ROUTE_STEP_AFTER_RUS SYSRES_CONST_ROUTE_STEP_AND_CONDITION_RUS SYSRES_CONST_ROUTE_STEP_OR_CONDITION_RUS SYSRES_CONST_ROUTE_TYPE_COMPLEX SYSRES_CONST_ROUTE_TYPE_PARALLEL SYSRES_CONST_ROUTE_TYPE_SERIAL SYSRES_CONST_SBDATASETDESC_NEGATIVE_VALUE SYSRES_CONST_SBDATASETDESC_POSITIVE_VALUE SYSRES_CONST_SBVIEWSDESC_POSITIVE_VALUE SYSRES_CONST_SCRIPT_BLOCK_DESCRIPTION SYSRES_CONST_SEARCH_BY_TEXT_REQUISITE_CODE SYSRES_CONST_SEARCHES_COMPONENT_CONTENT SYSRES_CONST_SEARCHES_CRITERIA_ACTION_NAME SYSRES_CONST_SEARCHES_EDOC_CONTENT SYSRES_CONST_SEARCHES_FOLDER_CONTENT SYSRES_CONST_SEARCHES_JOB_CONTENT SYSRES_CONST_SEARCHES_REFERENCE_CODE SYSRES_CONST_SEARCHES_TASK_CONTENT SYSRES_CONST_SECOND_CHAR SYSRES_CONST_SECTION_REQUISITE_ACTIONS_VALUE SYSRES_CONST_SECTION_REQUISITE_CARD_VALUE SYSRES_CONST_SECTION_REQUISITE_CODE SYSRES_CONST_SECTION_REQUISITE_DETAIL_1_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_2_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_3_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_4_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_5_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_6_VALUE SYSRES_CONST_SELECT_REFERENCE_MODE_NAME SYSRES_CONST_SELECT_TYPE_SELECTABLE SYSRES_CONST_SELECT_TYPE_SELECTABLE_ONLY_CHILD SYSRES_CONST_SELECT_TYPE_SELECTABLE_WITH_CHILD SYSRES_CONST_SELECT_TYPE_UNSLECTABLE SYSRES_CONST_SERVER_TYPE_MAIN SYSRES_CONST_SERVICE_USER_CATEGORY_FIELD_VALUE SYSRES_CONST_SETTINGS_USER_REQUISITE_CODE SYSRES_CONST_SIGNATURE_AND_ENCODE_CERTIFICATE_TYPE_CODE SYSRES_CONST_SIGNATURE_CERTIFICATE_TYPE_CODE SYSRES_CONST_SINGULAR_TITLE_REQUISITE_CODE SYSRES_CONST_SQL_SERVER_AUTHENTIFICATION_FLAG_VALUE_CODE SYSRES_CONST_SQL_SERVER_ENCODE_AUTHENTIFICATION_FLAG_VALUE_CODE SYSRES_CONST_STANDART_ROUTE_REFERENCE_CODE SYSRES_CONST_STANDART_ROUTE_REFERENCE_COMMENT_REQUISITE_CODE SYSRES_CONST_STANDART_ROUTES_GROUPS_REFERENCE_CODE SYSRES_CONST_STATE_REQ_NAME SYSRES_CONST_STATE_REQUISITE_ACTIVE_VALUE SYSRES_CONST_STATE_REQUISITE_CLOSED_VALUE SYSRES_CONST_STATE_REQUISITE_CODE SYSRES_CONST_STATIC_ROLE_TYPE_CODE SYSRES_CONST_STATUS_PLAN_DEFAULT_VALUE SYSRES_CONST_STATUS_VALUE_AUTOCLEANING SYSRES_CONST_STATUS_VALUE_BLUE_SQUARE SYSRES_CONST_STATUS_VALUE_COMPLETE SYSRES_CONST_STATUS_VALUE_GREEN_SQUARE SYSRES_CONST_STATUS_VALUE_ORANGE_SQUARE SYSRES_CONST_STATUS_VALUE_PURPLE_SQUARE SYSRES_CONST_STATUS_VALUE_RED_SQUARE SYSRES_CONST_STATUS_VALUE_SUSPEND SYSRES_CONST_STATUS_VALUE_YELLOW_SQUARE SYSRES_CONST_STDROUTE_SHOW_TO_USERS_REQUISITE_CODE SYSRES_CONST_STORAGE_TYPE_FILE SYSRES_CONST_STORAGE_TYPE_SQL_SERVER SYSRES_CONST_STR_REQUISITE SYSRES_CONST_STRIKEOUT_LIFE_CYCLE_STAGE_DRAW_STYLE SYSRES_CONST_STRING_FORMAT_LEFT_ALIGN_CHAR SYSRES_CONST_STRING_FORMAT_RIGHT_ALIGN_CHAR SYSRES_CONST_STRING_REQUISITE_CODE SYSRES_CONST_STRING_REQUISITE_TYPE SYSRES_CONST_STRING_TYPE_CHAR SYSRES_CONST_SUBSTITUTES_PSEUDOREFERENCE_CODE SYSRES_CONST_SUBTASK_BLOCK_DESCRIPTION SYSRES_CONST_SYSTEM_SETTING_CURRENT_USER_PARAM_VALUE SYSRES_CONST_SYSTEM_SETTING_EMPTY_VALUE_PARAM_VALUE SYSRES_CONST_SYSTEM_VERSION_COMMENT SYSRES_CONST_TASK_ACCESS_TYPE_ALL SYSRES_CONST_TASK_ACCESS_TYPE_ALL_MEMBERS SYSRES_CONST_TASK_ACCESS_TYPE_MANUAL SYSRES_CONST_TASK_ENCODE_TYPE_CERTIFICATION SYSRES_CONST_TASK_ENCODE_TYPE_CERTIFICATION_AND_PASSWORD SYSRES_CONST_TASK_ENCODE_TYPE_NONE SYSRES_CONST_TASK_ENCODE_TYPE_PASSWORD SYSRES_CONST_TASK_ROUTE_ALL_CONDITION SYSRES_CONST_TASK_ROUTE_AND_CONDITION SYSRES_CONST_TASK_ROUTE_OR_CONDITION SYSRES_CONST_TASK_STATE_ABORTED SYSRES_CONST_TASK_STATE_COMPLETE SYSRES_CONST_TASK_STATE_CONTINUED SYSRES_CONST_TASK_STATE_CONTROL SYSRES_CONST_TASK_STATE_INIT SYSRES_CONST_TASK_STATE_WORKING SYSRES_CONST_TASK_TITLE SYSRES_CONST_TASK_TYPES_GROUPS_REFERENCE_CODE SYSRES_CONST_TASK_TYPES_REFERENCE_CODE SYSRES_CONST_TEMPLATES_REFERENCE_CODE SYSRES_CONST_TEST_DATE_REQUISITE_NAME SYSRES_CONST_TEST_DEV_DATABASE_NAME SYSRES_CONST_TEST_DEV_SYSTEM_CODE SYSRES_CONST_TEST_EDMS_DATABASE_NAME SYSRES_CONST_TEST_EDMS_MAIN_CODE SYSRES_CONST_TEST_EDMS_MAIN_DB_NAME SYSRES_CONST_TEST_EDMS_SECOND_CODE SYSRES_CONST_TEST_EDMS_SECOND_DB_NAME SYSRES_CONST_TEST_EDMS_SYSTEM_CODE SYSRES_CONST_TEST_NUMERIC_REQUISITE_NAME SYSRES_CONST_TEXT_REQUISITE SYSRES_CONST_TEXT_REQUISITE_CODE SYSRES_CONST_TEXT_REQUISITE_TYPE SYSRES_CONST_TEXT_TYPE_CHAR SYSRES_CONST_TYPE_CODE_REQUISITE_CODE SYSRES_CONST_TYPE_REQUISITE_CODE SYSRES_CONST_UNDEFINED_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_UNITS_SECTION_ID_REQUISITE_CODE SYSRES_CONST_UNITS_SECTION_REQUISITE_CODE SYSRES_CONST_UNOPERATING_RECORD_FLAG_VALUE_CODE SYSRES_CONST_UNSTORED_DATA_REQUISITE_CODE SYSRES_CONST_UNSTORED_DATA_REQUISITE_NAME SYSRES_CONST_USE_ACCESS_TYPE_CODE SYSRES_CONST_USE_ACCESS_TYPE_NAME SYSRES_CONST_USER_ACCOUNT_TYPE_VALUE_CODE SYSRES_CONST_USER_ADDITIONAL_INFORMATION_REQUISITE_CODE SYSRES_CONST_USER_AND_GROUP_ID_FROM_PSEUDOREFERENCE_REQUISITE_CODE SYSRES_CONST_USER_CATEGORY_NORMAL SYSRES_CONST_USER_CERTIFICATE_REQUISITE_CODE SYSRES_CONST_USER_CERTIFICATE_STATE_REQUISITE_CODE SYSRES_CONST_USER_CERTIFICATE_SUBJECT_NAME_REQUISITE_CODE SYSRES_CONST_USER_CERTIFICATE_THUMBPRINT_REQUISITE_CODE SYSRES_CONST_USER_COMMON_CATEGORY SYSRES_CONST_USER_COMMON_CATEGORY_CODE SYSRES_CONST_USER_FULL_NAME_REQUISITE_CODE SYSRES_CONST_USER_GROUP_TYPE_REQUISITE_CODE SYSRES_CONST_USER_LOGIN_REQUISITE_CODE SYSRES_CONST_USER_REMOTE_CONTROLLER_REQUISITE_CODE SYSRES_CONST_USER_REMOTE_SYSTEM_REQUISITE_CODE SYSRES_CONST_USER_RIGHTS_T_REQUISITE_CODE SYSRES_CONST_USER_SERVER_NAME_REQUISITE_CODE SYSRES_CONST_USER_SERVICE_CATEGORY SYSRES_CONST_USER_SERVICE_CATEGORY_CODE SYSRES_CONST_USER_STATUS_ADMINISTRATOR_CODE SYSRES_CONST_USER_STATUS_ADMINISTRATOR_NAME SYSRES_CONST_USER_STATUS_DEVELOPER_CODE SYSRES_CONST_USER_STATUS_DEVELOPER_NAME SYSRES_CONST_USER_STATUS_DISABLED_CODE SYSRES_CONST_USER_STATUS_DISABLED_NAME SYSRES_CONST_USER_STATUS_SYSTEM_DEVELOPER_CODE SYSRES_CONST_USER_STATUS_USER_CODE SYSRES_CONST_USER_STATUS_USER_NAME SYSRES_CONST_USER_STATUS_USER_NAME_DEPRECATED SYSRES_CONST_USER_TYPE_FIELD_VALUE_USER SYSRES_CONST_USER_TYPE_REQUISITE_CODE SYSRES_CONST_USERS_CONTROLLER_REQUISITE_CODE SYSRES_CONST_USERS_IS_MAIN_SERVER_REQUISITE_CODE SYSRES_CONST_USERS_REFERENCE_CODE SYSRES_CONST_USERS_REGISTRATION_CERTIFICATES_ACTION_NAME SYSRES_CONST_USERS_REQUISITE_CODE SYSRES_CONST_USERS_SYSTEM_REQUISITE_CODE SYSRES_CONST_USERS_USER_ACCESS_RIGHTS_TYPR_REQUISITE_CODE SYSRES_CONST_USERS_USER_AUTHENTICATION_REQUISITE_CODE SYSRES_CONST_USERS_USER_COMPONENT_REQUISITE_CODE SYSRES_CONST_USERS_USER_GROUP_REQUISITE_CODE SYSRES_CONST_USERS_VIEW_CERTIFICATES_ACTION_NAME SYSRES_CONST_VIEW_DEFAULT_CODE SYSRES_CONST_VIEW_DEFAULT_NAME SYSRES_CONST_VIEWER_REQUISITE_CODE SYSRES_CONST_WAITING_BLOCK_DESCRIPTION SYSRES_CONST_WIZARD_FORM_LABEL_TEST_STRING  SYSRES_CONST_WIZARD_QUERY_PARAM_HEIGHT_ETALON_STRING SYSRES_CONST_WIZARD_REFERENCE_COMMENT_REQUISITE_CODE SYSRES_CONST_WORK_RULES_DESCRIPTION_REQUISITE_CODE SYSRES_CONST_WORK_TIME_CALENDAR_REFERENCE_CODE SYSRES_CONST_WORK_WORKFLOW_HARD_ROUTE_TYPE_VALUE SYSRES_CONST_WORK_WORKFLOW_HARD_ROUTE_TYPE_VALUE_CODE SYSRES_CONST_WORK_WORKFLOW_HARD_ROUTE_TYPE_VALUE_CODE_RUS SYSRES_CONST_WORK_WORKFLOW_SOFT_ROUTE_TYPE_VALUE_CODE_RUS SYSRES_CONST_WORKFLOW_ROUTE_TYPR_HARD SYSRES_CONST_WORKFLOW_ROUTE_TYPR_SOFT SYSRES_CONST_XML_ENCODING SYSRES_CONST_XREC_STAT_REQUISITE_CODE SYSRES_CONST_XRECID_FIELD_NAME SYSRES_CONST_YES SYSRES_CONST_YES_NO_2_REQUISITE_CODE SYSRES_CONST_YES_NO_REQUISITE_CODE SYSRES_CONST_YES_NO_T_REF_TYPE_REQUISITE_CODE SYSRES_CONST_YES_PICK_VALUE SYSRES_CONST_YES_VALUE CR FALSE nil NO_VALUE NULL TAB TRUE YES_VALUE ADMINISTRATORS_GROUP_NAME CUSTOMIZERS_GROUP_NAME DEVELOPERS_GROUP_NAME SERVICE_USERS_GROUP_NAME DECISION_BLOCK_FIRST_OPERAND_PROPERTY DECISION_BLOCK_NAME_PROPERTY DECISION_BLOCK_OPERATION_PROPERTY DECISION_BLOCK_RESULT_TYPE_PROPERTY DECISION_BLOCK_SECOND_OPERAND_PROPERTY ANY_FILE_EXTENTION COMPRESSED_DOCUMENT_EXTENSION EXTENDED_DOCUMENT_EXTENSION SHORT_COMPRESSED_DOCUMENT_EXTENSION SHORT_EXTENDED_DOCUMENT_EXTENSION JOB_BLOCK_ABORT_DEADLINE_PROPERTY JOB_BLOCK_AFTER_FINISH_EVENT JOB_BLOCK_AFTER_QUERY_PARAMETERS_EVENT JOB_BLOCK_ATTACHMENT_PROPERTY JOB_BLOCK_ATTACHMENTS_RIGHTS_GROUP_PROPERTY JOB_BLOCK_ATTACHMENTS_RIGHTS_TYPE_PROPERTY JOB_BLOCK_BEFORE_QUERY_PARAMETERS_EVENT JOB_BLOCK_BEFORE_START_EVENT JOB_BLOCK_CREATED_JOBS_PROPERTY JOB_BLOCK_DEADLINE_PROPERTY JOB_BLOCK_EXECUTION_RESULTS_PROPERTY JOB_BLOCK_IS_PARALLEL_PROPERTY JOB_BLOCK_IS_RELATIVE_ABORT_DEADLINE_PROPERTY JOB_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY JOB_BLOCK_JOB_TEXT_PROPERTY JOB_BLOCK_NAME_PROPERTY JOB_BLOCK_NEED_SIGN_ON_PERFORM_PROPERTY JOB_BLOCK_PERFORMER_PROPERTY JOB_BLOCK_RELATIVE_ABORT_DEADLINE_TYPE_PROPERTY JOB_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY JOB_BLOCK_SUBJECT_PROPERTY ENGLISH_LANGUAGE_CODE RUSSIAN_LANGUAGE_CODE smHidden smMaximized smMinimized smNormal wmNo wmYes COMPONENT_TOKEN_LINK_KIND DOCUMENT_LINK_KIND EDOCUMENT_LINK_KIND FOLDER_LINK_KIND JOB_LINK_KIND REFERENCE_LINK_KIND TASK_LINK_KIND COMPONENT_TOKEN_LOCK_TYPE EDOCUMENT_VERSION_LOCK_TYPE MONITOR_BLOCK_AFTER_FINISH_EVENT MONITOR_BLOCK_BEFORE_START_EVENT MONITOR_BLOCK_DEADLINE_PROPERTY MONITOR_BLOCK_INTERVAL_PROPERTY MONITOR_BLOCK_INTERVAL_TYPE_PROPERTY MONITOR_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY MONITOR_BLOCK_NAME_PROPERTY MONITOR_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY MONITOR_BLOCK_SEARCH_SCRIPT_PROPERTY NOTICE_BLOCK_AFTER_FINISH_EVENT NOTICE_BLOCK_ATTACHMENT_PROPERTY NOTICE_BLOCK_ATTACHMENTS_RIGHTS_GROUP_PROPERTY NOTICE_BLOCK_ATTACHMENTS_RIGHTS_TYPE_PROPERTY NOTICE_BLOCK_BEFORE_START_EVENT NOTICE_BLOCK_CREATED_NOTICES_PROPERTY NOTICE_BLOCK_DEADLINE_PROPERTY NOTICE_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY NOTICE_BLOCK_NAME_PROPERTY NOTICE_BLOCK_NOTICE_TEXT_PROPERTY NOTICE_BLOCK_PERFORMER_PROPERTY NOTICE_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY NOTICE_BLOCK_SUBJECT_PROPERTY dseAfterCancel dseAfterClose dseAfterDelete dseAfterDeleteOutOfTransaction dseAfterInsert dseAfterOpen dseAfterScroll dseAfterUpdate dseAfterUpdateOutOfTransaction dseBeforeCancel dseBeforeClose dseBeforeDelete dseBeforeDetailUpdate dseBeforeInsert dseBeforeOpen dseBeforeUpdate dseOnAnyRequisiteChange dseOnCloseRecord dseOnDeleteError dseOnOpenRecord dseOnPrepareUpdate dseOnUpdateError dseOnUpdateRatifiedRecord dseOnValidDelete dseOnValidUpdate reOnChange reOnChangeValues SELECTION_BEGIN_ROUTE_EVENT SELECTION_END_ROUTE_EVENT CURRENT_PERIOD_IS_REQUIRED PREVIOUS_CARD_TYPE_NAME SHOW_RECORD_PROPERTIES_FORM ACCESS_RIGHTS_SETTING_DIALOG_CODE ADMINISTRATOR_USER_CODE ANALYTIC_REPORT_TYPE asrtHideLocal asrtHideRemote CALCULATED_ROLE_TYPE_CODE COMPONENTS_REFERENCE_DEVELOPER_VIEW_CODE DCTS_TEST_PROTOCOLS_FOLDER_PATH E_EDOC_VERSION_ALREADY_APPROVINGLY_SIGNED E_EDOC_VERSION_ALREADY_APPROVINGLY_SIGNED_BY_USER E_EDOC_VERSION_ALREDY_SIGNED E_EDOC_VERSION_ALREDY_SIGNED_BY_USER EDOC_TYPES_CODE_REQUISITE_FIELD_NAME EDOCUMENTS_ALIAS_NAME FILES_FOLDER_PATH FILTER_OPERANDS_DELIMITER FILTER_OPERATIONS_DELIMITER FORMCARD_NAME FORMLIST_NAME GET_EXTENDED_DOCUMENT_EXTENSION_CREATION_MODE GET_EXTENDED_DOCUMENT_EXTENSION_IMPORT_MODE INTEGRATED_REPORT_TYPE IS_BUILDER_APPLICATION_ROLE IS_BUILDER_APPLICATION_ROLE2 IS_BUILDER_USERS ISBSYSDEV LOG_FOLDER_PATH mbCancel mbNo mbNoToAll mbOK mbYes mbYesToAll MEMORY_DATASET_DESRIPTIONS_FILENAME mrNo mrNoToAll mrYes mrYesToAll MULTIPLE_SELECT_DIALOG_CODE NONOPERATING_RECORD_FLAG_FEMININE NONOPERATING_RECORD_FLAG_MASCULINE OPERATING_RECORD_FLAG_FEMININE OPERATING_RECORD_FLAG_MASCULINE PROFILING_SETTINGS_COMMON_SETTINGS_CODE_VALUE PROGRAM_INITIATED_LOOKUP_ACTION ratDelete ratEdit ratInsert REPORT_TYPE REQUIRED_PICK_VALUES_VARIABLE rmCard rmList SBRTE_PROGID_DEV SBRTE_PROGID_RELEASE STATIC_ROLE_TYPE_CODE SUPPRESS_EMPTY_TEMPLATE_CREATION SYSTEM_USER_CODE UPDATE_DIALOG_DATASET USED_IN_OBJECT_HINT_PARAM USER_INITIATED_LOOKUP_ACTION USER_NAME_FORMAT USER_SELECTION_RESTRICTIONS WORKFLOW_TEST_PROTOCOLS_FOLDER_PATH ELS_SUBTYPE_CONTROL_NAME ELS_FOLDER_KIND_CONTROL_NAME REPEAT_PROCESS_CURRENT_OBJECT_EXCEPTION_NAME PRIVILEGE_COMPONENT_FULL_ACCESS PRIVILEGE_DEVELOPMENT_EXPORT PRIVILEGE_DEVELOPMENT_IMPORT PRIVILEGE_DOCUMENT_DELETE PRIVILEGE_ESD PRIVILEGE_FOLDER_DELETE PRIVILEGE_MANAGE_ACCESS_RIGHTS PRIVILEGE_MANAGE_REPLICATION PRIVILEGE_MANAGE_SESSION_SERVER PRIVILEGE_OBJECT_FULL_ACCESS PRIVILEGE_OBJECT_VIEW PRIVILEGE_RESERVE_LICENSE PRIVILEGE_SYSTEM_CUSTOMIZE PRIVILEGE_SYSTEM_DEVELOP PRIVILEGE_SYSTEM_INSTALL PRIVILEGE_TASK_DELETE PRIVILEGE_USER_PLUGIN_SETTINGS_CUSTOMIZE PRIVILEGES_PSEUDOREFERENCE_CODE ACCESS_TYPES_PSEUDOREFERENCE_CODE ALL_AVAILABLE_COMPONENTS_PSEUDOREFERENCE_CODE ALL_AVAILABLE_PRIVILEGES_PSEUDOREFERENCE_CODE ALL_REPLICATE_COMPONENTS_PSEUDOREFERENCE_CODE AVAILABLE_DEVELOPERS_COMPONENTS_PSEUDOREFERENCE_CODE COMPONENTS_PSEUDOREFERENCE_CODE FILTRATER_SETTINGS_CONFLICTS_PSEUDOREFERENCE_CODE GROUPS_PSEUDOREFERENCE_CODE RECEIVE_PROTOCOL_PSEUDOREFERENCE_CODE REFERENCE_REQUISITE_PSEUDOREFERENCE_CODE REFERENCE_REQUISITES_PSEUDOREFERENCE_CODE REFTYPES_PSEUDOREFERENCE_CODE REPLICATION_SEANCES_DIARY_PSEUDOREFERENCE_CODE SEND_PROTOCOL_PSEUDOREFERENCE_CODE SUBSTITUTES_PSEUDOREFERENCE_CODE SYSTEM_SETTINGS_PSEUDOREFERENCE_CODE UNITS_PSEUDOREFERENCE_CODE USERS_PSEUDOREFERENCE_CODE VIEWERS_PSEUDOREFERENCE_CODE CERTIFICATE_TYPE_ENCRYPT CERTIFICATE_TYPE_SIGN CERTIFICATE_TYPE_SIGN_AND_ENCRYPT STORAGE_TYPE_FILE STORAGE_TYPE_NAS_CIFS STORAGE_TYPE_SAPERION STORAGE_TYPE_SQL_SERVER COMPTYPE2_REQUISITE_DOCUMENTS_VALUE COMPTYPE2_REQUISITE_TASKS_VALUE COMPTYPE2_REQUISITE_FOLDERS_VALUE COMPTYPE2_REQUISITE_REFERENCES_VALUE SYSREQ_CODE SYSREQ_COMPTYPE2 SYSREQ_CONST_AVAILABLE_FOR_WEB SYSREQ_CONST_COMMON_CODE SYSREQ_CONST_COMMON_VALUE SYSREQ_CONST_FIRM_CODE SYSREQ_CONST_FIRM_STATUS SYSREQ_CONST_FIRM_VALUE SYSREQ_CONST_SERVER_STATUS SYSREQ_CONTENTS SYSREQ_DATE_OPEN SYSREQ_DATE_CLOSE SYSREQ_DESCRIPTION SYSREQ_DESCRIPTION_LOCALIZE_ID SYSREQ_DOUBLE SYSREQ_EDOC_ACCESS_TYPE SYSREQ_EDOC_AUTHOR SYSREQ_EDOC_CREATED SYSREQ_EDOC_DELEGATE_RIGHTS_REQUISITE_CODE SYSREQ_EDOC_EDITOR SYSREQ_EDOC_ENCODE_TYPE SYSREQ_EDOC_ENCRYPTION_PLUGIN_NAME SYSREQ_EDOC_ENCRYPTION_PLUGIN_VERSION SYSREQ_EDOC_EXPORT_DATE SYSREQ_EDOC_EXPORTER SYSREQ_EDOC_KIND SYSREQ_EDOC_LIFE_STAGE_NAME SYSREQ_EDOC_LOCKED_FOR_SERVER_CODE SYSREQ_EDOC_MODIFIED SYSREQ_EDOC_NAME SYSREQ_EDOC_NOTE SYSREQ_EDOC_QUALIFIED_ID SYSREQ_EDOC_SESSION_KEY SYSREQ_EDOC_SESSION_KEY_ENCRYPTION_PLUGIN_NAME SYSREQ_EDOC_SESSION_KEY_ENCRYPTION_PLUGIN_VERSION SYSREQ_EDOC_SIGNATURE_TYPE SYSREQ_EDOC_SIGNED SYSREQ_EDOC_STORAGE SYSREQ_EDOC_STORAGES_ARCHIVE_STORAGE SYSREQ_EDOC_STORAGES_CHECK_RIGHTS SYSREQ_EDOC_STORAGES_COMPUTER_NAME SYSREQ_EDOC_STORAGES_EDIT_IN_STORAGE SYSREQ_EDOC_STORAGES_EXECUTIVE_STORAGE SYSREQ_EDOC_STORAGES_FUNCTION SYSREQ_EDOC_STORAGES_INITIALIZED SYSREQ_EDOC_STORAGES_LOCAL_PATH SYSREQ_EDOC_STORAGES_SAPERION_DATABASE_NAME SYSREQ_EDOC_STORAGES_SEARCH_BY_TEXT SYSREQ_EDOC_STORAGES_SERVER_NAME SYSREQ_EDOC_STORAGES_SHARED_SOURCE_NAME SYSREQ_EDOC_STORAGES_TYPE SYSREQ_EDOC_TEXT_MODIFIED SYSREQ_EDOC_TYPE_ACT_CODE SYSREQ_EDOC_TYPE_ACT_DESCRIPTION SYSREQ_EDOC_TYPE_ACT_DESCRIPTION_LOCALIZE_ID SYSREQ_EDOC_TYPE_ACT_ON_EXECUTE SYSREQ_EDOC_TYPE_ACT_ON_EXECUTE_EXISTS SYSREQ_EDOC_TYPE_ACT_SECTION SYSREQ_EDOC_TYPE_ADD_PARAMS SYSREQ_EDOC_TYPE_COMMENT SYSREQ_EDOC_TYPE_EVENT_TEXT SYSREQ_EDOC_TYPE_NAME_IN_SINGULAR SYSREQ_EDOC_TYPE_NAME_IN_SINGULAR_LOCALIZE_ID SYSREQ_EDOC_TYPE_NAME_LOCALIZE_ID SYSREQ_EDOC_TYPE_NUMERATION_METHOD SYSREQ_EDOC_TYPE_PSEUDO_REQUISITE_CODE SYSREQ_EDOC_TYPE_REQ_CODE SYSREQ_EDOC_TYPE_REQ_DESCRIPTION SYSREQ_EDOC_TYPE_REQ_DESCRIPTION_LOCALIZE_ID SYSREQ_EDOC_TYPE_REQ_IS_LEADING SYSREQ_EDOC_TYPE_REQ_IS_REQUIRED SYSREQ_EDOC_TYPE_REQ_NUMBER SYSREQ_EDOC_TYPE_REQ_ON_CHANGE SYSREQ_EDOC_TYPE_REQ_ON_CHANGE_EXISTS SYSREQ_EDOC_TYPE_REQ_ON_SELECT SYSREQ_EDOC_TYPE_REQ_ON_SELECT_KIND SYSREQ_EDOC_TYPE_REQ_SECTION SYSREQ_EDOC_TYPE_VIEW_CARD SYSREQ_EDOC_TYPE_VIEW_CODE SYSREQ_EDOC_TYPE_VIEW_COMMENT SYSREQ_EDOC_TYPE_VIEW_IS_MAIN SYSREQ_EDOC_TYPE_VIEW_NAME SYSREQ_EDOC_TYPE_VIEW_NAME_LOCALIZE_ID SYSREQ_EDOC_VERSION_AUTHOR SYSREQ_EDOC_VERSION_CRC SYSREQ_EDOC_VERSION_DATA SYSREQ_EDOC_VERSION_EDITOR SYSREQ_EDOC_VERSION_EXPORT_DATE SYSREQ_EDOC_VERSION_EXPORTER SYSREQ_EDOC_VERSION_HIDDEN SYSREQ_EDOC_VERSION_LIFE_STAGE SYSREQ_EDOC_VERSION_MODIFIED SYSREQ_EDOC_VERSION_NOTE SYSREQ_EDOC_VERSION_SIGNATURE_TYPE SYSREQ_EDOC_VERSION_SIGNED SYSREQ_EDOC_VERSION_SIZE SYSREQ_EDOC_VERSION_SOURCE SYSREQ_EDOC_VERSION_TEXT_MODIFIED SYSREQ_EDOCKIND_DEFAULT_VERSION_STATE_CODE SYSREQ_FOLDER_KIND SYSREQ_FUNC_CATEGORY SYSREQ_FUNC_COMMENT SYSREQ_FUNC_GROUP SYSREQ_FUNC_GROUP_COMMENT SYSREQ_FUNC_GROUP_NUMBER SYSREQ_FUNC_HELP SYSREQ_FUNC_PARAM_DEF_VALUE SYSREQ_FUNC_PARAM_IDENT SYSREQ_FUNC_PARAM_NUMBER SYSREQ_FUNC_PARAM_TYPE SYSREQ_FUNC_TEXT SYSREQ_GROUP_CATEGORY SYSREQ_ID SYSREQ_LAST_UPDATE SYSREQ_LEADER_REFERENCE SYSREQ_LINE_NUMBER SYSREQ_MAIN_RECORD_ID SYSREQ_NAME SYSREQ_NAME_LOCALIZE_ID SYSREQ_NOTE SYSREQ_ORIGINAL_RECORD SYSREQ_OUR_FIRM SYSREQ_PROFILING_SETTINGS_BATCH_LOGING SYSREQ_PROFILING_SETTINGS_BATCH_SIZE SYSREQ_PROFILING_SETTINGS_PROFILING_ENABLED SYSREQ_PROFILING_SETTINGS_SQL_PROFILING_ENABLED SYSREQ_PROFILING_SETTINGS_START_LOGGED SYSREQ_RECORD_STATUS SYSREQ_REF_REQ_FIELD_NAME SYSREQ_REF_REQ_FORMAT SYSREQ_REF_REQ_GENERATED SYSREQ_REF_REQ_LENGTH SYSREQ_REF_REQ_PRECISION SYSREQ_REF_REQ_REFERENCE SYSREQ_REF_REQ_SECTION SYSREQ_REF_REQ_STORED SYSREQ_REF_REQ_TOKENS SYSREQ_REF_REQ_TYPE SYSREQ_REF_REQ_VIEW SYSREQ_REF_TYPE_ACT_CODE SYSREQ_REF_TYPE_ACT_DESCRIPTION SYSREQ_REF_TYPE_ACT_DESCRIPTION_LOCALIZE_ID SYSREQ_REF_TYPE_ACT_ON_EXECUTE SYSREQ_REF_TYPE_ACT_ON_EXECUTE_EXISTS SYSREQ_REF_TYPE_ACT_SECTION SYSREQ_REF_TYPE_ADD_PARAMS SYSREQ_REF_TYPE_COMMENT SYSREQ_REF_TYPE_COMMON_SETTINGS SYSREQ_REF_TYPE_DISPLAY_REQUISITE_NAME SYSREQ_REF_TYPE_EVENT_TEXT SYSREQ_REF_TYPE_MAIN_LEADING_REF SYSREQ_REF_TYPE_NAME_IN_SINGULAR SYSREQ_REF_TYPE_NAME_IN_SINGULAR_LOCALIZE_ID SYSREQ_REF_TYPE_NAME_LOCALIZE_ID SYSREQ_REF_TYPE_NUMERATION_METHOD SYSREQ_REF_TYPE_REQ_CODE SYSREQ_REF_TYPE_REQ_DESCRIPTION SYSREQ_REF_TYPE_REQ_DESCRIPTION_LOCALIZE_ID SYSREQ_REF_TYPE_REQ_IS_CONTROL SYSREQ_REF_TYPE_REQ_IS_FILTER SYSREQ_REF_TYPE_REQ_IS_LEADING SYSREQ_REF_TYPE_REQ_IS_REQUIRED SYSREQ_REF_TYPE_REQ_NUMBER SYSREQ_REF_TYPE_REQ_ON_CHANGE SYSREQ_REF_TYPE_REQ_ON_CHANGE_EXISTS SYSREQ_REF_TYPE_REQ_ON_SELECT SYSREQ_REF_TYPE_REQ_ON_SELECT_KIND SYSREQ_REF_TYPE_REQ_SECTION SYSREQ_REF_TYPE_VIEW_CARD SYSREQ_REF_TYPE_VIEW_CODE SYSREQ_REF_TYPE_VIEW_COMMENT SYSREQ_REF_TYPE_VIEW_IS_MAIN SYSREQ_REF_TYPE_VIEW_NAME SYSREQ_REF_TYPE_VIEW_NAME_LOCALIZE_ID SYSREQ_REFERENCE_TYPE_ID SYSREQ_STATE SYSREQ_STAT\u{415} SYSREQ_SYSTEM_SETTINGS_VALUE SYSREQ_TYPE SYSREQ_UNIT SYSREQ_UNIT_ID SYSREQ_USER_GROUPS_GROUP_FULL_NAME SYSREQ_USER_GROUPS_GROUP_NAME SYSREQ_USER_GROUPS_GROUP_SERVER_NAME SYSREQ_USERS_ACCESS_RIGHTS SYSREQ_USERS_AUTHENTICATION SYSREQ_USERS_CATEGORY SYSREQ_USERS_COMPONENT SYSREQ_USERS_COMPONENT_USER_IS_PUBLIC SYSREQ_USERS_DOMAIN SYSREQ_USERS_FULL_USER_NAME SYSREQ_USERS_GROUP SYSREQ_USERS_IS_MAIN_SERVER SYSREQ_USERS_LOGIN SYSREQ_USERS_REFERENCE_USER_IS_PUBLIC SYSREQ_USERS_STATUS SYSREQ_USERS_USER_CERTIFICATE SYSREQ_USERS_USER_CERTIFICATE_INFO SYSREQ_USERS_USER_CERTIFICATE_PLUGIN_NAME SYSREQ_USERS_USER_CERTIFICATE_PLUGIN_VERSION SYSREQ_USERS_USER_CERTIFICATE_STATE SYSREQ_USERS_USER_CERTIFICATE_SUBJECT_NAME SYSREQ_USERS_USER_CERTIFICATE_THUMBPRINT SYSREQ_USERS_USER_DEFAULT_CERTIFICATE SYSREQ_USERS_USER_DESCRIPTION SYSREQ_USERS_USER_GLOBAL_NAME SYSREQ_USERS_USER_LOGIN SYSREQ_USERS_USER_MAIN_SERVER SYSREQ_USERS_USER_TYPE SYSREQ_WORK_RULES_FOLDER_ID RESULT_VAR_NAME RESULT_VAR_NAME_ENG AUTO_NUMERATION_RULE_ID CANT_CHANGE_ID_REQUISITE_RULE_ID CANT_CHANGE_OURFIRM_REQUISITE_RULE_ID CHECK_CHANGING_REFERENCE_RECORD_USE_RULE_ID CHECK_CODE_REQUISITE_RULE_ID CHECK_DELETING_REFERENCE_RECORD_USE_RULE_ID CHECK_FILTRATER_CHANGES_RULE_ID CHECK_RECORD_INTERVAL_RULE_ID CHECK_REFERENCE_INTERVAL_RULE_ID CHECK_REQUIRED_DATA_FULLNESS_RULE_ID CHECK_REQUIRED_REQUISITES_FULLNESS_RULE_ID MAKE_RECORD_UNRATIFIED_RULE_ID RESTORE_AUTO_NUMERATION_RULE_ID SET_FIRM_CONTEXT_FROM_RECORD_RULE_ID SET_FIRST_RECORD_IN_LIST_FORM_RULE_ID SET_IDSPS_VALUE_RULE_ID SET_NEXT_CODE_VALUE_RULE_ID SET_OURFIRM_BOUNDS_RULE_ID SET_OURFIRM_REQUISITE_RULE_ID SCRIPT_BLOCK_AFTER_FINISH_EVENT SCRIPT_BLOCK_BEFORE_START_EVENT SCRIPT_BLOCK_EXECUTION_RESULTS_PROPERTY SCRIPT_BLOCK_NAME_PROPERTY SCRIPT_BLOCK_SCRIPT_PROPERTY SUBTASK_BLOCK_ABORT_DEADLINE_PROPERTY SUBTASK_BLOCK_AFTER_FINISH_EVENT SUBTASK_BLOCK_ASSIGN_PARAMS_EVENT SUBTASK_BLOCK_ATTACHMENTS_PROPERTY SUBTASK_BLOCK_ATTACHMENTS_RIGHTS_GROUP_PROPERTY SUBTASK_BLOCK_ATTACHMENTS_RIGHTS_TYPE_PROPERTY SUBTASK_BLOCK_BEFORE_START_EVENT SUBTASK_BLOCK_CREATED_TASK_PROPERTY SUBTASK_BLOCK_CREATION_EVENT SUBTASK_BLOCK_DEADLINE_PROPERTY SUBTASK_BLOCK_IMPORTANCE_PROPERTY SUBTASK_BLOCK_INITIATOR_PROPERTY SUBTASK_BLOCK_IS_RELATIVE_ABORT_DEADLINE_PROPERTY SUBTASK_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY SUBTASK_BLOCK_JOBS_TYPE_PROPERTY SUBTASK_BLOCK_NAME_PROPERTY SUBTASK_BLOCK_PARALLEL_ROUTE_PROPERTY SUBTASK_BLOCK_PERFORMERS_PROPERTY SUBTASK_BLOCK_RELATIVE_ABORT_DEADLINE_TYPE_PROPERTY SUBTASK_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY SUBTASK_BLOCK_REQUIRE_SIGN_PROPERTY SUBTASK_BLOCK_STANDARD_ROUTE_PROPERTY SUBTASK_BLOCK_START_EVENT SUBTASK_BLOCK_STEP_CONTROL_PROPERTY SUBTASK_BLOCK_SUBJECT_PROPERTY SUBTASK_BLOCK_TASK_CONTROL_PROPERTY SUBTASK_BLOCK_TEXT_PROPERTY SUBTASK_BLOCK_UNLOCK_ATTACHMENTS_ON_STOP_PROPERTY SUBTASK_BLOCK_USE_STANDARD_ROUTE_PROPERTY SUBTASK_BLOCK_WAIT_FOR_TASK_COMPLETE_PROPERTY SYSCOMP_CONTROL_JOBS SYSCOMP_FOLDERS SYSCOMP_JOBS SYSCOMP_NOTICES SYSCOMP_TASKS SYSDLG_CREATE_EDOCUMENT SYSDLG_CREATE_EDOCUMENT_VERSION SYSDLG_CURRENT_PERIOD SYSDLG_EDIT_FUNCTION_HELP SYSDLG_EDOCUMENT_KINDS_FOR_TEMPLATE SYSDLG_EXPORT_MULTIPLE_EDOCUMENTS SYSDLG_EXPORT_SINGLE_EDOCUMENT SYSDLG_IMPORT_EDOCUMENT SYSDLG_MULTIPLE_SELECT SYSDLG_SETUP_ACCESS_RIGHTS SYSDLG_SETUP_DEFAULT_RIGHTS SYSDLG_SETUP_FILTER_CONDITION SYSDLG_SETUP_SIGN_RIGHTS SYSDLG_SETUP_TASK_OBSERVERS SYSDLG_SETUP_TASK_ROUTE SYSDLG_SETUP_USERS_LIST SYSDLG_SIGN_EDOCUMENT SYSDLG_SIGN_MULTIPLE_EDOCUMENTS SYSREF_ACCESS_RIGHTS_TYPES SYSREF_ADMINISTRATION_HISTORY SYSREF_ALL_AVAILABLE_COMPONENTS SYSREF_ALL_AVAILABLE_PRIVILEGES SYSREF_ALL_REPLICATING_COMPONENTS SYSREF_AVAILABLE_DEVELOPERS_COMPONENTS SYSREF_CALENDAR_EVENTS SYSREF_COMPONENT_TOKEN_HISTORY SYSREF_COMPONENT_TOKENS SYSREF_COMPONENTS SYSREF_CONSTANTS SYSREF_DATA_RECEIVE_PROTOCOL SYSREF_DATA_SEND_PROTOCOL SYSREF_DIALOGS SYSREF_DIALOGS_REQUISITES SYSREF_EDITORS SYSREF_EDOC_CARDS SYSREF_EDOC_TYPES SYSREF_EDOCUMENT_CARD_REQUISITES SYSREF_EDOCUMENT_CARD_TYPES SYSREF_EDOCUMENT_CARD_TYPES_REFERENCE SYSREF_EDOCUMENT_CARDS SYSREF_EDOCUMENT_HISTORY SYSREF_EDOCUMENT_KINDS SYSREF_EDOCUMENT_REQUISITES SYSREF_EDOCUMENT_SIGNATURES SYSREF_EDOCUMENT_TEMPLATES SYSREF_EDOCUMENT_TEXT_STORAGES SYSREF_EDOCUMENT_VIEWS SYSREF_FILTERER_SETUP_CONFLICTS SYSREF_FILTRATER_SETTING_CONFLICTS SYSREF_FOLDER_HISTORY SYSREF_FOLDERS SYSREF_FUNCTION_GROUPS SYSREF_FUNCTION_PARAMS SYSREF_FUNCTIONS SYSREF_JOB_HISTORY SYSREF_LINKS SYSREF_LOCALIZATION_DICTIONARY SYSREF_LOCALIZATION_LANGUAGES SYSREF_MODULES SYSREF_PRIVILEGES SYSREF_RECORD_HISTORY SYSREF_REFERENCE_REQUISITES SYSREF_REFERENCE_TYPE_VIEWS SYSREF_REFERENCE_TYPES SYSREF_REFERENCES SYSREF_REFERENCES_REQUISITES SYSREF_REMOTE_SERVERS SYSREF_REPLICATION_SESSIONS_LOG SYSREF_REPLICATION_SESSIONS_PROTOCOL SYSREF_REPORTS SYSREF_ROLES SYSREF_ROUTE_BLOCK_GROUPS SYSREF_ROUTE_BLOCKS SYSREF_SCRIPTS SYSREF_SEARCHES SYSREF_SERVER_EVENTS SYSREF_SERVER_EVENTS_HISTORY SYSREF_STANDARD_ROUTE_GROUPS SYSREF_STANDARD_ROUTES SYSREF_STATUSES SYSREF_SYSTEM_SETTINGS SYSREF_TASK_HISTORY SYSREF_TASK_KIND_GROUPS SYSREF_TASK_KINDS SYSREF_TASK_RIGHTS SYSREF_TASK_SIGNATURES SYSREF_TASKS SYSREF_UNITS SYSREF_USER_GROUPS SYSREF_USER_GROUPS_REFERENCE SYSREF_USER_SUBSTITUTION SYSREF_USERS SYSREF_USERS_REFERENCE SYSREF_VIEWERS SYSREF_WORKING_TIME_CALENDARS ACCESS_RIGHTS_TABLE_NAME EDMS_ACCESS_TABLE_NAME EDOC_TYPES_TABLE_NAME TEST_DEV_DB_NAME TEST_DEV_SYSTEM_CODE TEST_EDMS_DB_NAME TEST_EDMS_MAIN_CODE TEST_EDMS_MAIN_DB_NAME TEST_EDMS_SECOND_CODE TEST_EDMS_SECOND_DB_NAME TEST_EDMS_SYSTEM_CODE TEST_ISB5_MAIN_CODE TEST_ISB5_SECOND_CODE TEST_SQL_SERVER_2005_NAME TEST_SQL_SERVER_NAME ATTENTION_CAPTION cbsCommandLinks cbsDefault CONFIRMATION_CAPTION ERROR_CAPTION INFORMATION_CAPTION mrCancel mrOk EDOC_VERSION_ACTIVE_STAGE_CODE EDOC_VERSION_DESIGN_STAGE_CODE EDOC_VERSION_OBSOLETE_STAGE_CODE cpDataEnciphermentEnabled cpDigitalSignatureEnabled cpID cpIssuer cpPluginVersion cpSerial cpSubjectName cpSubjSimpleName cpValidFromDate cpValidToDate ISBL_SYNTAX NO_SYNTAX XML_SYNTAX WAIT_BLOCK_AFTER_FINISH_EVENT WAIT_BLOCK_BEFORE_START_EVENT WAIT_BLOCK_DEADLINE_PROPERTY WAIT_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY WAIT_BLOCK_NAME_PROPERTY WAIT_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY SYSRES_COMMON SYSRES_CONST SYSRES_MBFUNC SYSRES_SBDATA SYSRES_SBGUI SYSRES_SBINTF SYSRES_SBREFDSC SYSRES_SQLERRORS SYSRES_SYSCOMP atUser atGroup atRole aemEnabledAlways aemDisabledAlways aemEnabledOnBrowse aemEnabledOnEdit aemDisabledOnBrowseEmpty apBegin apEnd alLeft alRight asmNever asmNoButCustomize asmAsLastTime asmYesButCustomize asmAlways cirCommon cirRevoked ctSignature ctEncode ctSignatureEncode clbUnchecked clbChecked clbGrayed ceISB ceAlways ceNever ctDocument ctReference ctScript ctUnknown ctReport ctDialog ctFunction ctFolder ctEDocument ctTask ctJob ctNotice ctControlJob cfInternal cfDisplay ciUnspecified ciWrite ciRead ckFolder ckEDocument ckTask ckJob ckComponentToken ckAny ckReference ckScript ckReport ckDialog ctISBLEditor ctBevel ctButton ctCheckListBox ctComboBox ctComboEdit ctGrid ctDBCheckBox ctDBComboBox ctDBEdit ctDBEllipsis ctDBMemo ctDBNavigator ctDBRadioGroup ctDBStatusLabel ctEdit ctGroupBox ctInplaceHint ctMemo ctPanel ctListBox ctRadioButton ctRichEdit ctTabSheet ctWebBrowser ctImage ctHyperLink ctLabel ctDBMultiEllipsis ctRibbon ctRichView ctInnerPanel ctPanelGroup ctBitButton cctDate cctInteger cctNumeric cctPick cctReference cctString cctText cltInternal cltPrimary cltGUI dseBeforeOpen dseAfterOpen dseBeforeClose dseAfterClose dseOnValidDelete dseBeforeDelete dseAfterDelete dseAfterDeleteOutOfTransaction dseOnDeleteError dseBeforeInsert dseAfterInsert dseOnValidUpdate dseBeforeUpdate dseOnUpdateRatifiedRecord dseAfterUpdate dseAfterUpdateOutOfTransaction dseOnUpdateError dseAfterScroll dseOnOpenRecord dseOnCloseRecord dseBeforeCancel dseAfterCancel dseOnUpdateDeadlockError dseBeforeDetailUpdate dseOnPrepareUpdate dseOnAnyRequisiteChange dssEdit dssInsert dssBrowse dssInActive dftDate dftShortDate dftDateTime dftTimeStamp dotDays dotHours dotMinutes dotSeconds dtkndLocal dtkndUTC arNone arView arEdit arFull ddaView ddaEdit emLock emEdit emSign emExportWithLock emImportWithUnlock emChangeVersionNote emOpenForModify emChangeLifeStage emDelete emCreateVersion emImport emUnlockExportedWithLock emStart emAbort emReInit emMarkAsReaded emMarkAsUnreaded emPerform emAccept emResume emChangeRights emEditRoute emEditObserver emRecoveryFromLocalCopy emChangeWorkAccessType emChangeEncodeTypeToCertificate emChangeEncodeTypeToPassword emChangeEncodeTypeToNone emChangeEncodeTypeToCertificatePassword emChangeStandardRoute emGetText emOpenForView emMoveToStorage emCreateObject emChangeVersionHidden emDeleteVersion emChangeLifeCycleStage emApprovingSign emExport emContinue emLockFromEdit emUnLockForEdit emLockForServer emUnlockFromServer emDelegateAccessRights emReEncode ecotFile ecotProcess eaGet eaCopy eaCreate eaCreateStandardRoute edltAll edltNothing edltQuery essmText essmCard esvtLast esvtLastActive esvtSpecified edsfExecutive edsfArchive edstSQLServer edstFile edvstNone edvstEDocumentVersionCopy edvstFile edvstTemplate edvstScannedFile vsDefault vsDesign vsActive vsObsolete etNone etCertificate etPassword etCertificatePassword ecException ecWarning ecInformation estAll estApprovingOnly evtLast evtLastActive evtQuery fdtString fdtNumeric fdtInteger fdtDate fdtText fdtUnknown fdtWideString fdtLargeInteger ftInbox ftOutbox ftFavorites ftCommonFolder ftUserFolder ftComponents ftQuickLaunch ftShortcuts ftSearch grhAuto grhX1 grhX2 grhX3 hltText hltRTF hltHTML iffBMP iffJPEG iffMultiPageTIFF iffSinglePageTIFF iffTIFF iffPNG im8bGrayscale im24bRGB im1bMonochrome itBMP itJPEG itWMF itPNG ikhInformation ikhWarning ikhError ikhNoIcon icUnknown icScript icFunction icIntegratedReport icAnalyticReport icDataSetEventHandler icActionHandler icFormEventHandler icLookUpEventHandler icRequisiteChangeEventHandler icBeforeSearchEventHandler icRoleCalculation icSelectRouteEventHandler icBlockPropertyCalculation icBlockQueryParamsEventHandler icChangeSearchResultEventHandler icBlockEventHandler icSubTaskInitEventHandler icEDocDataSetEventHandler icEDocLookUpEventHandler icEDocActionHandler icEDocFormEventHandler icEDocRequisiteChangeEventHandler icStructuredConversionRule icStructuredConversionEventBefore icStructuredConversionEventAfter icWizardEventHandler icWizardFinishEventHandler icWizardStepEventHandler icWizardStepFinishEventHandler icWizardActionEnableEventHandler icWizardActionExecuteEventHandler icCreateJobsHandler icCreateNoticesHandler icBeforeLookUpEventHandler icAfterLookUpEventHandler icTaskAbortEventHandler icWorkflowBlockActionHandler icDialogDataSetEventHandler icDialogActionHandler icDialogLookUpEventHandler icDialogRequisiteChangeEventHandler icDialogFormEventHandler icDialogValidCloseEventHandler icBlockFormEventHandler icTaskFormEventHandler icReferenceMethod icEDocMethod icDialogMethod icProcessMessageHandler isShow isHide isByUserSettings jkJob jkNotice jkControlJob jtInner jtLeft jtRight jtFull jtCross lbpAbove lbpBelow lbpLeft lbpRight eltPerConnection eltPerUser sfcUndefined sfcBlack sfcGreen sfcRed sfcBlue sfcOrange sfcLilac sfsItalic sfsStrikeout sfsNormal ldctStandardRoute ldctWizard ldctScript ldctFunction ldctRouteBlock ldctIntegratedReport ldctAnalyticReport ldctReferenceType ldctEDocumentType ldctDialog ldctServerEvents mrcrtNone mrcrtUser mrcrtMaximal mrcrtCustom vtEqual vtGreaterOrEqual vtLessOrEqual vtRange rdYesterday rdToday rdTomorrow rdThisWeek rdThisMonth rdThisYear rdNextMonth rdNextWeek rdLastWeek rdLastMonth rdWindow rdFile rdPrinter rdtString rdtNumeric rdtInteger rdtDate rdtReference rdtAccount rdtText rdtPick rdtUnknown rdtLargeInteger rdtDocument reOnChange reOnChangeValues ttGlobal ttLocal ttUser ttSystem ssmBrowse ssmSelect ssmMultiSelect ssmBrowseModal smSelect smLike smCard stNone stAuthenticating stApproving sctString sctStream sstAnsiSort sstNaturalSort svtEqual svtContain soatString soatNumeric soatInteger soatDatetime soatReferenceRecord soatText soatPick soatBoolean soatEDocument soatAccount soatIntegerCollection soatNumericCollection soatStringCollection soatPickCollection soatDatetimeCollection soatBooleanCollection soatReferenceRecordCollection soatEDocumentCollection soatAccountCollection soatContents soatUnknown tarAbortByUser tarAbortByWorkflowException tvtAllWords tvtExactPhrase tvtAnyWord usNone usCompleted usRedSquare usBlueSquare usYellowSquare usGreenSquare usOrangeSquare usPurpleSquare usFollowUp utUnknown utUser utDeveloper utAdministrator utSystemDeveloper utDisconnected btAnd btDetailAnd btOr btNotOr btOnly vmView vmSelect vmNavigation vsmSingle vsmMultiple vsmMultipleCheck vsmNoSelection wfatPrevious wfatNext wfatCancel wfatFinish wfepUndefined wfepText3 wfepText6 wfepText9 wfepSpinEdit wfepDropDown wfepRadioGroup wfepFlag wfepText12 wfepText15 wfepText18 wfepText21 wfepText24 wfepText27 wfepText30 wfepRadioGroupColumn1 wfepRadioGroupColumn2 wfepRadioGroupColumn3 wfetQueryParameter wfetText wfetDelimiter wfetLabel wptString wptInteger wptNumeric wptBoolean wptDateTime wptPick wptText wptUser wptUserList wptEDocumentInfo wptEDocumentInfoList wptReferenceRecordInfo wptReferenceRecordInfoList wptFolderInfo wptTaskInfo wptContents wptFileName wptDate wsrComplete wsrGoNext wsrGoPrevious wsrCustom wsrCancel wsrGoFinal wstForm wstEDocument wstTaskCard wstReferenceRecordCard wstFinal waAll waPerformers waManual wsbStart wsbFinish wsbNotice wsbStep wsbDecision wsbWait wsbMonitor wsbScript wsbConnector wsbSubTask wsbLifeCycleStage wsbPause wdtInteger wdtFloat wdtString wdtPick wdtDateTime wdtBoolean wdtTask wdtJob wdtFolder wdtEDocument wdtReferenceRecord wdtUser wdtGroup wdtRole wdtIntegerCollection wdtFloatCollection wdtStringCollection wdtPickCollection wdtDateTimeCollection wdtBooleanCollection wdtTaskCollection wdtJobCollection wdtFolderCollection wdtEDocumentCollection wdtReferenceRecordCollection wdtUserCollection wdtGroupCollection wdtRoleCollection wdtContents wdtUserList wdtSearchDescription wdtDeadLine wdtPickSet wdtAccountCollection wiLow wiNormal wiHigh wrtSoft wrtHard wsInit wsRunning wsDone wsControlled wsAborted wsContinued wtmFull wtmFromCurrent wtmOnlyCurrent `,
                class: `AltState Application CallType ComponentTokens CreatedJobs CreatedNotices ControlState DialogResult Dialogs EDocuments EDocumentVersionSource Folders GlobalIDs Job Jobs InputValue LookUpReference LookUpRequisiteNames LookUpSearch Object ParentComponent Processes References Requisite ReportName Reports Result Scripts Searches SelectedAttachments SelectedItems SelectMode Sender ServerEvents ServiceFactory ShiftState SubTask SystemDialogs Tasks Wizard Wizards Work \u{412}\u{44B}\u{437}\u{43E}\u{432}\u{421}\u{43F}\u{43E}\u{441}\u{43E}\u{431} \u{418}\u{43C}\u{44F}\u{41E}\u{442}\u{447}\u{435}\u{442}\u{430} \u{420}\u{435}\u{43A}\u{432}\u{417}\u{43D}\u{430}\u{447} `,
                literal: `null true false nil `
            }, s = {
                begin: `\\.\\s*` + e.UNDERSCORE_IDENT_RE,
                keywords: o,
                relevance: 0
            }, c = {
                className: `type`,
                begin: `:[ \\t]*(` + `IApplication IAccessRights IAccountRepository IAccountSelectionRestrictions IAction IActionList IAdministrationHistoryDescription IAnchors IApplication IArchiveInfo IAttachment IAttachmentList ICheckListBox ICheckPointedList IColumn IComponent IComponentDescription IComponentToken IComponentTokenFactory IComponentTokenInfo ICompRecordInfo IConnection IContents IControl IControlJob IControlJobInfo IControlList ICrypto ICrypto2 ICustomJob ICustomJobInfo ICustomListBox ICustomObjectWizardStep ICustomWork ICustomWorkInfo IDataSet IDataSetAccessInfo IDataSigner IDateCriterion IDateRequisite IDateRequisiteDescription IDateValue IDeaAccessRights IDeaObjectInfo IDevelopmentComponentLock IDialog IDialogFactory IDialogPickRequisiteItems IDialogsFactory IDICSFactory IDocRequisite IDocumentInfo IDualListDialog IECertificate IECertificateInfo IECertificates IEditControl IEditorForm IEdmsExplorer IEdmsObject IEdmsObjectDescription IEdmsObjectFactory IEdmsObjectInfo IEDocument IEDocumentAccessRights IEDocumentDescription IEDocumentEditor IEDocumentFactory IEDocumentInfo IEDocumentStorage IEDocumentVersion IEDocumentVersionListDialog IEDocumentVersionSource IEDocumentWizardStep IEDocVerSignature IEDocVersionState IEnabledMode IEncodeProvider IEncrypter IEvent IEventList IException IExternalEvents IExternalHandler IFactory IField IFileDialog IFolder IFolderDescription IFolderDialog IFolderFactory IFolderInfo IForEach IForm IFormTitle IFormWizardStep IGlobalIDFactory IGlobalIDInfo IGrid IHasher IHistoryDescription IHyperLinkControl IImageButton IImageControl IInnerPanel IInplaceHint IIntegerCriterion IIntegerList IIntegerRequisite IIntegerValue IISBLEditorForm IJob IJobDescription IJobFactory IJobForm IJobInfo ILabelControl ILargeIntegerCriterion ILargeIntegerRequisite ILargeIntegerValue ILicenseInfo ILifeCycleStage IList IListBox ILocalIDInfo ILocalization ILock IMemoryDataSet IMessagingFactory IMetadataRepository INotice INoticeInfo INumericCriterion INumericRequisite INumericValue IObject IObjectDescription IObjectImporter IObjectInfo IObserver IPanelGroup IPickCriterion IPickProperty IPickRequisite IPickRequisiteDescription IPickRequisiteItem IPickRequisiteItems IPickValue IPrivilege IPrivilegeList IProcess IProcessFactory IProcessMessage IProgress IProperty IPropertyChangeEvent IQuery IReference IReferenceCriterion IReferenceEnabledMode IReferenceFactory IReferenceHistoryDescription IReferenceInfo IReferenceRecordCardWizardStep IReferenceRequisiteDescription IReferencesFactory IReferenceValue IRefRequisite IReport IReportFactory IRequisite IRequisiteDescription IRequisiteDescriptionList IRequisiteFactory IRichEdit IRouteStep IRule IRuleList ISchemeBlock IScript IScriptFactory ISearchCriteria ISearchCriterion ISearchDescription ISearchFactory ISearchFolderInfo ISearchForObjectDescription ISearchResultRestrictions ISecuredContext ISelectDialog IServerEvent IServerEventFactory IServiceDialog IServiceFactory ISignature ISignProvider ISignProvider2 ISignProvider3 ISimpleCriterion IStringCriterion IStringList IStringRequisite IStringRequisiteDescription IStringValue ISystemDialogsFactory ISystemInfo ITabSheet ITask ITaskAbortReasonInfo ITaskCardWizardStep ITaskDescription ITaskFactory ITaskInfo ITaskRoute ITextCriterion ITextRequisite ITextValue ITreeListSelectDialog IUser IUserList IValue IView IWebBrowserControl IWizard IWizardAction IWizardFactory IWizardFormElement IWizardParam IWizardPickParam IWizardReferenceParam IWizardStep IWorkAccessRights IWorkDescription IWorkflowAskableParam IWorkflowAskableParams IWorkflowBlock IWorkflowBlockResult IWorkflowEnabledMode IWorkflowParam IWorkflowPickParam IWorkflowReferenceParam IWorkState IWorkTreeCustomNode IWorkTreeJobNode IWorkTreeTaskNode IXMLEditorForm SBCrypto`.replace(/\s/g, `|`) + `)`,
                end: `[ \\t]*=`,
                excludeEnd: !0
            }, l = {
                className: `variable`,
                keywords: o,
                begin: t,
                relevance: 0,
                contains: [
                    c,
                    s
                ]
            }, u = `[A-Za-z\u{410}-\u{42F}\u{430}-\u{44F}\u{451}\u{401}_][A-Za-z\u{410}-\u{42F}\u{430}-\u{44F}\u{451}\u{401}_0-9]*\\(`;
            return {
                name: `ISBL`,
                case_insensitive: !0,
                keywords: o,
                illegal: `\\$|\\?|%|,|;$|~|#|@|</`,
                contains: [
                    {
                        className: `function`,
                        begin: u,
                        end: `\\)$`,
                        returnBegin: !0,
                        keywords: o,
                        illegal: `[\\[\\]\\|\\$\\?%,~#@]`,
                        contains: [
                            {
                                className: `title`,
                                keywords: {
                                    $pattern: t,
                                    built_in: `AddSubString AdjustLineBreaks AmountInWords Analysis ArrayDimCount ArrayHighBound ArrayLowBound ArrayOf ArrayReDim Assert Assigned BeginOfMonth BeginOfPeriod BuildProfilingOperationAnalysis CallProcedure CanReadFile CArrayElement CDataSetRequisite ChangeDate ChangeReferenceDataset Char CharPos CheckParam CheckParamValue CompareStrings ConstantExists ControlState ConvertDateStr Copy CopyFile CreateArray CreateCachedReference CreateConnection CreateDialog CreateDualListDialog CreateEditor CreateException CreateFile CreateFolderDialog CreateInputDialog CreateLinkFile CreateList CreateLock CreateMemoryDataSet CreateObject CreateOpenDialog CreateProgress CreateQuery CreateReference CreateReport CreateSaveDialog CreateScript CreateSQLPivotFunction CreateStringList CreateTreeListSelectDialog CSelectSQL CSQL CSubString CurrentUserID CurrentUserName CurrentVersion DataSetLocateEx DateDiff DateTimeDiff DateToStr DayOfWeek DeleteFile DirectoryExists DisableCheckAccessRights DisableCheckFullShowingRestriction DisableMassTaskSendingRestrictions DropTable DupeString EditText EnableCheckAccessRights EnableCheckFullShowingRestriction EnableMassTaskSendingRestrictions EndOfMonth EndOfPeriod ExceptionExists ExceptionsOff ExceptionsOn Execute ExecuteProcess Exit ExpandEnvironmentVariables ExtractFileDrive ExtractFileExt ExtractFileName ExtractFilePath ExtractParams FileExists FileSize FindFile FindSubString FirmContext ForceDirectories Format FormatDate FormatNumeric FormatSQLDate FormatString FreeException GetComponent GetComponentLaunchParam GetConstant GetLastException GetReferenceRecord GetRefTypeByRefID GetTableID GetTempFolder IfThen In IndexOf InputDialog InputDialogEx InteractiveMode IsFileLocked IsGraphicFile IsNumeric Length LoadString LoadStringFmt LocalTimeToUTC LowerCase Max MessageBox MessageBoxEx MimeDecodeBinary MimeDecodeString MimeEncodeBinary MimeEncodeString Min MoneyInWords MoveFile NewID Now OpenFile Ord Precision Raise ReadCertificateFromFile ReadFile ReferenceCodeByID ReferenceNumber ReferenceRequisiteMode ReferenceRequisiteValue RegionDateSettings RegionNumberSettings RegionTimeSettings RegRead RegWrite RenameFile Replace Round SelectServerCode SelectSQL ServerDateTime SetConstant SetManagedFolderFieldsState ShowConstantsInputDialog ShowMessage Sleep Split SQL SQL2XLSTAB SQLProfilingSendReport StrToDate SubString SubStringCount SystemSetting Time TimeDiff Today Transliterate Trim UpperCase UserStatus UTCToLocalTime ValidateXML VarIsClear VarIsEmpty VarIsNull WorkTimeDiff WriteFile WriteFileEx WriteObjectHistory \u{410}\u{43D}\u{430}\u{43B}\u{438}\u{437} \u{411}\u{430}\u{437}\u{430}\u{414}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{411}\u{43B}\u{43E}\u{43A}\u{415}\u{441}\u{442}\u{44C} \u{411}\u{43B}\u{43E}\u{43A}\u{415}\u{441}\u{442}\u{44C}\u{420}\u{430}\u{441}\u{448} \u{411}\u{43B}\u{43E}\u{43A}\u{418}\u{43D}\u{444}\u{43E} \u{411}\u{43B}\u{43E}\u{43A}\u{421}\u{43D}\u{44F}\u{442}\u{44C} \u{411}\u{43B}\u{43E}\u{43A}\u{421}\u{43D}\u{44F}\u{442}\u{44C}\u{420}\u{430}\u{441}\u{448} \u{411}\u{43B}\u{43E}\u{43A}\u{423}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C} \u{412}\u{432}\u{43E}\u{434} \u{412}\u{432}\u{43E}\u{434}\u{41C}\u{435}\u{43D}\u{44E} \u{412}\u{435}\u{434}\u{421} \u{412}\u{435}\u{434}\u{421}\u{43F}\u{440} \u{412}\u{435}\u{440}\u{445}\u{43D}\u{44F}\u{44F}\u{413}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{430}\u{41C}\u{430}\u{441}\u{441}\u{438}\u{432}\u{430} \u{412}\u{43D}\u{435}\u{448}\u{41F}\u{440}\u{43E}\u{433}\u{440} \u{412}\u{43E}\u{441}\u{441}\u{442} \u{412}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{43D}\u{430}\u{44F}\u{41F}\u{430}\u{43F}\u{43A}\u{430} \u{412}\u{440}\u{435}\u{43C}\u{44F} \u{412}\u{44B}\u{431}\u{43E}\u{440}SQL \u{412}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C}\u{417}\u{430}\u{43F}\u{438}\u{441}\u{44C} \u{412}\u{44B}\u{434}\u{435}\u{43B}\u{438}\u{442}\u{44C}\u{421}\u{442}\u{440} \u{412}\u{44B}\u{437}\u{432}\u{430}\u{442}\u{44C} \u{412}\u{44B}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{44C} \u{412}\u{44B}\u{43F}\u{41F}\u{440}\u{43E}\u{433}\u{440} \u{413}\u{440}\u{430}\u{444}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{438}\u{439}\u{424}\u{430}\u{439}\u{43B} \u{413}\u{440}\u{443}\u{43F}\u{43F}\u{430}\u{414}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E} \u{414}\u{430}\u{442}\u{430}\u{412}\u{440}\u{435}\u{43C}\u{44F}\u{421}\u{435}\u{440}\u{432} \u{414}\u{435}\u{43D}\u{44C}\u{41D}\u{435}\u{434}\u{435}\u{43B}\u{438} \u{414}\u{438}\u{430}\u{43B}\u{43E}\u{433}\u{414}\u{430}\u{41D}\u{435}\u{442} \u{414}\u{43B}\u{438}\u{43D}\u{430}\u{421}\u{442}\u{440} \u{414}\u{43E}\u{431}\u{41F}\u{43E}\u{434}\u{441}\u{442}\u{440} \u{415}\u{41F}\u{443}\u{441}\u{442}\u{43E} \u{415}\u{441}\u{43B}\u{438}\u{422}\u{43E} \u{415}\u{427}\u{438}\u{441}\u{43B}\u{43E} \u{417}\u{430}\u{43C}\u{41F}\u{43E}\u{434}\u{441}\u{442}\u{440} \u{417}\u{430}\u{43F}\u{438}\u{441}\u{44C}\u{421}\u{43F}\u{440}\u{430}\u{432}\u{43E}\u{447}\u{43D}\u{438}\u{43A}\u{430} \u{417}\u{43D}\u{430}\u{447}\u{41F}\u{43E}\u{43B}\u{44F}\u{421}\u{43F}\u{440} \u{418}\u{414}\u{422}\u{438}\u{43F}\u{421}\u{43F}\u{440} \u{418}\u{437}\u{432}\u{43B}\u{435}\u{447}\u{44C}\u{414}\u{438}\u{441}\u{43A} \u{418}\u{437}\u{432}\u{43B}\u{435}\u{447}\u{44C}\u{418}\u{43C}\u{44F}\u{424}\u{430}\u{439}\u{43B}\u{430} \u{418}\u{437}\u{432}\u{43B}\u{435}\u{447}\u{44C}\u{41F}\u{443}\u{442}\u{44C} \u{418}\u{437}\u{432}\u{43B}\u{435}\u{447}\u{44C}\u{420}\u{430}\u{441}\u{448}\u{438}\u{440}\u{435}\u{43D}\u{438}\u{435} \u{418}\u{437}\u{43C}\u{414}\u{430}\u{442} \u{418}\u{437}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C}\u{420}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{41C}\u{430}\u{441}\u{441}\u{438}\u{432}\u{430} \u{418}\u{437}\u{43C}\u{435}\u{440}\u{435}\u{43D}\u{438}\u{439}\u{41C}\u{430}\u{441}\u{441}\u{438}\u{432}\u{430} \u{418}\u{43C}\u{44F}\u{41E}\u{440}\u{433} \u{418}\u{43C}\u{44F}\u{41F}\u{43E}\u{43B}\u{44F}\u{421}\u{43F}\u{440} \u{418}\u{43D}\u{434}\u{435}\u{43A}\u{441} \u{418}\u{43D}\u{434}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440}\u{417}\u{430}\u{43A}\u{440}\u{44B}\u{442}\u{44C} \u{418}\u{43D}\u{434}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440}\u{41E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44C} \u{418}\u{43D}\u{434}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440}\u{428}\u{430}\u{433} \u{418}\u{43D}\u{442}\u{435}\u{440}\u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{44B}\u{439}\u{420}\u{435}\u{436}\u{438}\u{43C} \u{418}\u{442}\u{43E}\u{433}\u{422}\u{431}\u{43B}\u{421}\u{43F}\u{440} \u{41A}\u{43E}\u{434}\u{412}\u{438}\u{434}\u{412}\u{435}\u{434}\u{421}\u{43F}\u{440} \u{41A}\u{43E}\u{434}\u{412}\u{438}\u{434}\u{421}\u{43F}\u{440}\u{41F}\u{43E}\u{418}\u{414} \u{41A}\u{43E}\u{434}\u{41F}\u{43E}Analit \u{41A}\u{43E}\u{434}\u{421}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{430} \u{41A}\u{43E}\u{434}\u{421}\u{43F}\u{440} \u{41A}\u{43E}\u{43B}\u{41F}\u{43E}\u{434}\u{441}\u{442}\u{440} \u{41A}\u{43E}\u{43B}\u{41F}\u{440}\u{43E}\u{43F} \u{41A}\u{43E}\u{43D}\u{41C}\u{435}\u{441} \u{41A}\u{43E}\u{43D}\u{441}\u{442} \u{41A}\u{43E}\u{43D}\u{441}\u{442}\u{415}\u{441}\u{442}\u{44C} \u{41A}\u{43E}\u{43D}\u{441}\u{442}\u{417}\u{43D}\u{430}\u{447} \u{41A}\u{43E}\u{43D}\u{422}\u{440}\u{430}\u{43D} \u{41A}\u{43E}\u{43F}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C}\u{424}\u{430}\u{439}\u{43B} \u{41A}\u{43E}\u{43F}\u{438}\u{44F}\u{421}\u{442}\u{440} \u{41A}\u{41F}\u{435}\u{440}\u{438}\u{43E}\u{434} \u{41A}\u{421}\u{442}\u{440}\u{422}\u{431}\u{43B}\u{421}\u{43F}\u{440} \u{41C}\u{430}\u{43A}\u{441} \u{41C}\u{430}\u{43A}\u{441}\u{421}\u{442}\u{440}\u{422}\u{431}\u{43B}\u{421}\u{43F}\u{440} \u{41C}\u{430}\u{441}\u{441}\u{438}\u{432} \u{41C}\u{435}\u{43D}\u{44E} \u{41C}\u{435}\u{43D}\u{44E}\u{420}\u{430}\u{441}\u{448} \u{41C}\u{438}\u{43D} \u{41D}\u{430}\u{431}\u{43E}\u{440}\u{414}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{41D}\u{430}\u{439}\u{442}\u{438}\u{420}\u{430}\u{441}\u{448} \u{41D}\u{430}\u{438}\u{43C}\u{412}\u{438}\u{434}\u{421}\u{43F}\u{440} \u{41D}\u{430}\u{438}\u{43C}\u{41F}\u{43E}Analit \u{41D}\u{430}\u{438}\u{43C}\u{421}\u{43F}\u{440} \u{41D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{438}\u{442}\u{44C}\u{41F}\u{435}\u{440}\u{435}\u{432}\u{43E}\u{434}\u{44B}\u{421}\u{442}\u{440}\u{43E}\u{43A} \u{41D}\u{430}\u{447}\u{41C}\u{435}\u{441} \u{41D}\u{430}\u{447}\u{422}\u{440}\u{430}\u{43D} \u{41D}\u{438}\u{436}\u{43D}\u{44F}\u{44F}\u{413}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{430}\u{41C}\u{430}\u{441}\u{441}\u{438}\u{432}\u{430} \u{41D}\u{43E}\u{43C}\u{435}\u{440}\u{421}\u{43F}\u{440} \u{41D}\u{41F}\u{435}\u{440}\u{438}\u{43E}\u{434} \u{41E}\u{43A}\u{43D}\u{43E} \u{41E}\u{43A}\u{440} \u{41E}\u{43A}\u{440}\u{443}\u{436}\u{435}\u{43D}\u{438}\u{435} \u{41E}\u{442}\u{43B}\u{418}\u{43D}\u{444}\u{414}\u{43E}\u{431}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{41E}\u{442}\u{43B}\u{418}\u{43D}\u{444}\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{41E}\u{442}\u{447}\u{435}\u{442} \u{41E}\u{442}\u{447}\u{435}\u{442}\u{410}\u{43D}\u{430}\u{43B} \u{41E}\u{442}\u{447}\u{435}\u{442}\u{418}\u{43D}\u{442} \u{41F}\u{430}\u{43F}\u{43A}\u{430}\u{421}\u{443}\u{449}\u{435}\u{441}\u{442}\u{432}\u{443}\u{435}\u{442} \u{41F}\u{430}\u{443}\u{437}\u{430} \u{41F}\u{412}\u{44B}\u{431}\u{43E}\u{440}SQL \u{41F}\u{435}\u{440}\u{435}\u{438}\u{43C}\u{435}\u{43D}\u{43E}\u{432}\u{430}\u{442}\u{44C}\u{424}\u{430}\u{439}\u{43B} \u{41F}\u{435}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{43D}\u{44B}\u{435} \u{41F}\u{435}\u{440}\u{435}\u{43C}\u{435}\u{441}\u{442}\u{438}\u{442}\u{44C}\u{424}\u{430}\u{439}\u{43B} \u{41F}\u{43E}\u{434}\u{441}\u{442}\u{440} \u{41F}\u{43E}\u{438}\u{441}\u{43A}\u{41F}\u{43E}\u{434}\u{441}\u{442}\u{440} \u{41F}\u{43E}\u{438}\u{441}\u{43A}\u{421}\u{442}\u{440} \u{41F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C}\u{418}\u{414}\u{422}\u{430}\u{431}\u{43B}\u{438}\u{446}\u{44B} \u{41F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{414}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E} \u{41F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{418}\u{414} \u{41F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{418}\u{43C}\u{44F} \u{41F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{421}\u{442}\u{430}\u{442}\u{443}\u{441} \u{41F}\u{440}\u{435}\u{440}\u{432}\u{430}\u{442}\u{44C} \u{41F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{438}\u{442}\u{44C}\u{41F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440} \u{41F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{438}\u{442}\u{44C}\u{41F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{417}\u{43D}\u{430}\u{447} \u{41F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{438}\u{442}\u{44C}\u{423}\u{441}\u{43B}\u{43E}\u{432}\u{438}\u{435} \u{420}\u{430}\u{437}\u{431}\u{421}\u{442}\u{440} \u{420}\u{430}\u{437}\u{43D}\u{412}\u{440}\u{435}\u{43C}\u{44F} \u{420}\u{430}\u{437}\u{43D}\u{414}\u{430}\u{442} \u{420}\u{430}\u{437}\u{43D}\u{414}\u{430}\u{442}\u{430}\u{412}\u{440}\u{435}\u{43C}\u{44F} \u{420}\u{430}\u{437}\u{43D}\u{420}\u{430}\u{431}\u{412}\u{440}\u{435}\u{43C}\u{44F} \u{420}\u{435}\u{433}\u{423}\u{441}\u{442}\u{412}\u{440}\u{435}\u{43C} \u{420}\u{435}\u{433}\u{423}\u{441}\u{442}\u{414}\u{430}\u{442} \u{420}\u{435}\u{433}\u{423}\u{441}\u{442}\u{427}\u{441}\u{43B} \u{420}\u{435}\u{434}\u{422}\u{435}\u{43A}\u{441}\u{442} \u{420}\u{435}\u{435}\u{441}\u{442}\u{440}\u{417}\u{430}\u{43F}\u{438}\u{441}\u{44C} \u{420}\u{435}\u{435}\u{441}\u{442}\u{440}\u{421}\u{43F}\u{438}\u{441}\u{43E}\u{43A}\u{418}\u{43C}\u{435}\u{43D}\u{41F}\u{430}\u{440}\u{430}\u{43C} \u{420}\u{435}\u{435}\u{441}\u{442}\u{440}\u{427}\u{442}\u{435}\u{43D}\u{438}\u{435} \u{420}\u{435}\u{43A}\u{432}\u{421}\u{43F}\u{440} \u{420}\u{435}\u{43A}\u{432}\u{421}\u{43F}\u{440}\u{41F}\u{440} \u{421}\u{435}\u{433}\u{43E}\u{434}\u{43D}\u{44F} \u{421}\u{435}\u{439}\u{447}\u{430}\u{441} \u{421}\u{435}\u{440}\u{432}\u{435}\u{440} \u{421}\u{435}\u{440}\u{432}\u{435}\u{440}\u{41F}\u{440}\u{43E}\u{446}\u{435}\u{441}\u{441}\u{418}\u{414} \u{421}\u{435}\u{440}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{424}\u{430}\u{439}\u{43B}\u{421}\u{447}\u{438}\u{442}\u{430}\u{442}\u{44C} \u{421}\u{436}\u{41F}\u{440}\u{43E}\u{431} \u{421}\u{438}\u{43C}\u{432}\u{43E}\u{43B} \u{421}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{430}\u{414}\u{438}\u{440}\u{435}\u{43A}\u{442}\u{443}\u{43C}\u{41A}\u{43E}\u{434} \u{421}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{430}\u{418}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F} \u{421}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{430}\u{41A}\u{43E}\u{434} \u{421}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{438}\u{442} \u{421}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{435}\u{43D}\u{438}\u{435}\u{417}\u{430}\u{43A}\u{440}\u{44B}\u{442}\u{44C} \u{421}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{435}\u{43D}\u{438}\u{435}\u{41E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44C} \u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C}\u{414}\u{438}\u{430}\u{43B}\u{43E}\u{433} \u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C}\u{414}\u{438}\u{430}\u{43B}\u{43E}\u{433}\u{412}\u{44B}\u{431}\u{43E}\u{440}\u{430}\u{418}\u{437}\u{414}\u{432}\u{443}\u{445}\u{421}\u{43F}\u{438}\u{441}\u{43A}\u{43E}\u{432} \u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C}\u{414}\u{438}\u{430}\u{43B}\u{43E}\u{433}\u{412}\u{44B}\u{431}\u{43E}\u{440}\u{430}\u{41F}\u{430}\u{43F}\u{43A}\u{438} \u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C}\u{414}\u{438}\u{430}\u{43B}\u{43E}\u{433}\u{41E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{438}\u{44F}\u{424}\u{430}\u{439}\u{43B}\u{430} \u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C}\u{414}\u{438}\u{430}\u{43B}\u{43E}\u{433}\u{421}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{435}\u{43D}\u{438}\u{44F}\u{424}\u{430}\u{439}\u{43B}\u{430} \u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C}\u{417}\u{430}\u{43F}\u{440}\u{43E}\u{441} \u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C}\u{418}\u{43D}\u{434}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440} \u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C}\u{418}\u{441}\u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C}\u{41A}\u{44D}\u{448}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{44B}\u{439}\u{421}\u{43F}\u{440}\u{430}\u{432}\u{43E}\u{447}\u{43D}\u{438}\u{43A} \u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C}\u{41C}\u{430}\u{441}\u{441}\u{438}\u{432} \u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C}\u{41D}\u{430}\u{431}\u{43E}\u{440}\u{414}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C}\u{41E}\u{431}\u{44A}\u{435}\u{43A}\u{442} \u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C}\u{41E}\u{442}\u{447}\u{435}\u{442} \u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C}\u{41F}\u{430}\u{43F}\u{43A}\u{443} \u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C}\u{420}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{43E}\u{440} \u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C}\u{421}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{435}\u{43D}\u{438}\u{435} \u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C}\u{421}\u{43F}\u{438}\u{441}\u{43E}\u{43A} \u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C}\u{421}\u{43F}\u{438}\u{441}\u{43E}\u{43A}\u{421}\u{442}\u{440}\u{43E}\u{43A} \u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C}\u{421}\u{43F}\u{440}\u{430}\u{432}\u{43E}\u{447}\u{43D}\u{438}\u{43A} \u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C}\u{421}\u{446}\u{435}\u{43D}\u{430}\u{440}\u{438}\u{439} \u{421}\u{43E}\u{437}\u{434}\u{421}\u{43F}\u{440} \u{421}\u{43E}\u{441}\u{442}\u{421}\u{43F}\u{440} \u{421}\u{43E}\u{445}\u{440} \u{421}\u{43E}\u{445}\u{440}\u{421}\u{43F}\u{440} \u{421}\u{43F}\u{438}\u{441}\u{43E}\u{43A}\u{421}\u{438}\u{441}\u{442}\u{435}\u{43C} \u{421}\u{43F}\u{440} \u{421}\u{43F}\u{440}\u{430}\u{432}\u{43E}\u{447}\u{43D}\u{438}\u{43A} \u{421}\u{43F}\u{440}\u{411}\u{43B}\u{43E}\u{43A}\u{415}\u{441}\u{442}\u{44C} \u{421}\u{43F}\u{440}\u{411}\u{43B}\u{43E}\u{43A}\u{421}\u{43D}\u{44F}\u{442}\u{44C} \u{421}\u{43F}\u{440}\u{411}\u{43B}\u{43E}\u{43A}\u{421}\u{43D}\u{44F}\u{442}\u{44C}\u{420}\u{430}\u{441}\u{448} \u{421}\u{43F}\u{440}\u{411}\u{43B}\u{43E}\u{43A}\u{423}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C} \u{421}\u{43F}\u{440}\u{418}\u{437}\u{43C}\u{41D}\u{430}\u{431}\u{414}\u{430}\u{43D} \u{421}\u{43F}\u{440}\u{41A}\u{43E}\u{434} \u{421}\u{43F}\u{440}\u{41D}\u{43E}\u{43C}\u{435}\u{440} \u{421}\u{43F}\u{440}\u{41E}\u{431}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C} \u{421}\u{43F}\u{440}\u{41E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44C} \u{421}\u{43F}\u{440}\u{41E}\u{442}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C} \u{421}\u{43F}\u{440}\u{41F}\u{430}\u{440}\u{430}\u{43C} \u{421}\u{43F}\u{440}\u{41F}\u{43E}\u{43B}\u{435}\u{417}\u{43D}\u{430}\u{447} \u{421}\u{43F}\u{440}\u{41F}\u{43E}\u{43B}\u{435}\u{418}\u{43C}\u{44F} \u{421}\u{43F}\u{440}\u{420}\u{435}\u{43A}\u{432} \u{421}\u{43F}\u{440}\u{420}\u{435}\u{43A}\u{432}\u{412}\u{432}\u{435}\u{434}\u{417}\u{43D} \u{421}\u{43F}\u{440}\u{420}\u{435}\u{43A}\u{432}\u{41D}\u{43E}\u{432}\u{44B}\u{435} \u{421}\u{43F}\u{440}\u{420}\u{435}\u{43A}\u{432}\u{41F}\u{440} \u{421}\u{43F}\u{440}\u{420}\u{435}\u{43A}\u{432}\u{41F}\u{440}\u{435}\u{434}\u{417}\u{43D} \u{421}\u{43F}\u{440}\u{420}\u{435}\u{43A}\u{432}\u{420}\u{435}\u{436}\u{438}\u{43C} \u{421}\u{43F}\u{440}\u{420}\u{435}\u{43A}\u{432}\u{422}\u{438}\u{43F}\u{422}\u{435}\u{43A}\u{441}\u{442} \u{421}\u{43F}\u{440}\u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C} \u{421}\u{43F}\u{440}\u{421}\u{43E}\u{441}\u{442} \u{421}\u{43F}\u{440}\u{421}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{438}\u{442}\u{44C} \u{421}\u{43F}\u{440}\u{422}\u{431}\u{43B}\u{418}\u{442}\u{43E}\u{433} \u{421}\u{43F}\u{440}\u{422}\u{431}\u{43B}\u{421}\u{442}\u{440} \u{421}\u{43F}\u{440}\u{422}\u{431}\u{43B}\u{421}\u{442}\u{440}\u{41A}\u{43E}\u{43B} \u{421}\u{43F}\u{440}\u{422}\u{431}\u{43B}\u{421}\u{442}\u{440}\u{41C}\u{430}\u{43A}\u{441} \u{421}\u{43F}\u{440}\u{422}\u{431}\u{43B}\u{421}\u{442}\u{440}\u{41C}\u{438}\u{43D} \u{421}\u{43F}\u{440}\u{422}\u{431}\u{43B}\u{421}\u{442}\u{440}\u{41F}\u{440}\u{435}\u{434} \u{421}\u{43F}\u{440}\u{422}\u{431}\u{43B}\u{421}\u{442}\u{440}\u{421}\u{43B}\u{435}\u{434} \u{421}\u{43F}\u{440}\u{422}\u{431}\u{43B}\u{421}\u{442}\u{440}\u{421}\u{43E}\u{437}\u{434} \u{421}\u{43F}\u{440}\u{422}\u{431}\u{43B}\u{421}\u{442}\u{440}\u{423}\u{434} \u{421}\u{43F}\u{440}\u{422}\u{435}\u{43A}\u{41F}\u{440}\u{435}\u{434}\u{441}\u{442} \u{421}\u{43F}\u{440}\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{421}\u{440}\u{430}\u{432}\u{43D}\u{438}\u{442}\u{44C}\u{421}\u{442}\u{440} \u{421}\u{442}\u{440}\u{412}\u{435}\u{440}\u{445}\u{420}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440} \u{421}\u{442}\u{440}\u{41D}\u{438}\u{436}\u{43D}\u{420}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440} \u{421}\u{442}\u{440}\u{422}\u{431}\u{43B}\u{421}\u{43F}\u{440} \u{421}\u{443}\u{43C}\u{41F}\u{440}\u{43E}\u{43F} \u{421}\u{446}\u{435}\u{43D}\u{430}\u{440}\u{438}\u{439} \u{421}\u{446}\u{435}\u{43D}\u{430}\u{440}\u{438}\u{439}\u{41F}\u{430}\u{440}\u{430}\u{43C} \u{422}\u{435}\u{43A}\u{412}\u{435}\u{440}\u{441}\u{438}\u{44F} \u{422}\u{435}\u{43A}\u{41E}\u{440}\u{433} \u{422}\u{43E}\u{447}\u{43D} \u{422}\u{440}\u{430}\u{43D} \u{422}\u{440}\u{430}\u{43D}\u{441}\u{43B}\u{438}\u{442}\u{435}\u{440}\u{430}\u{446}\u{438}\u{44F} \u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C}\u{422}\u{430}\u{431}\u{43B}\u{438}\u{446}\u{443} \u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C}\u{424}\u{430}\u{439}\u{43B} \u{423}\u{434}\u{421}\u{43F}\u{440} \u{423}\u{434}\u{421}\u{442}\u{440}\u{422}\u{431}\u{43B}\u{421}\u{43F}\u{440} \u{423}\u{441}\u{442} \u{423}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43A}\u{438}\u{41A}\u{43E}\u{43D}\u{441}\u{442}\u{430}\u{43D}\u{442} \u{424}\u{430}\u{439}\u{43B}\u{410}\u{442}\u{440}\u{438}\u{431}\u{443}\u{442}\u{421}\u{447}\u{438}\u{442}\u{430}\u{442}\u{44C} \u{424}\u{430}\u{439}\u{43B}\u{410}\u{442}\u{440}\u{438}\u{431}\u{443}\u{442}\u{423}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C} \u{424}\u{430}\u{439}\u{43B}\u{412}\u{440}\u{435}\u{43C}\u{44F} \u{424}\u{430}\u{439}\u{43B}\u{412}\u{440}\u{435}\u{43C}\u{44F}\u{423}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C} \u{424}\u{430}\u{439}\u{43B}\u{412}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C} \u{424}\u{430}\u{439}\u{43B}\u{417}\u{430}\u{43D}\u{44F}\u{442} \u{424}\u{430}\u{439}\u{43B}\u{417}\u{430}\u{43F}\u{438}\u{441}\u{430}\u{442}\u{44C} \u{424}\u{430}\u{439}\u{43B}\u{418}\u{441}\u{43A}\u{430}\u{442}\u{44C} \u{424}\u{430}\u{439}\u{43B}\u{41A}\u{43E}\u{43F}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{424}\u{430}\u{439}\u{43B}\u{41C}\u{43E}\u{436}\u{43D}\u{43E}\u{427}\u{438}\u{442}\u{430}\u{442}\u{44C} \u{424}\u{430}\u{439}\u{43B}\u{41E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44C} \u{424}\u{430}\u{439}\u{43B}\u{41F}\u{435}\u{440}\u{435}\u{438}\u{43C}\u{435}\u{43D}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{424}\u{430}\u{439}\u{43B}\u{41F}\u{435}\u{440}\u{435}\u{43A}\u{43E}\u{434}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{424}\u{430}\u{439}\u{43B}\u{41F}\u{435}\u{440}\u{435}\u{43C}\u{435}\u{441}\u{442}\u{438}\u{442}\u{44C} \u{424}\u{430}\u{439}\u{43B}\u{41F}\u{440}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440}\u{435}\u{442}\u{44C} \u{424}\u{430}\u{439}\u{43B}\u{420}\u{430}\u{437}\u{43C}\u{435}\u{440} \u{424}\u{430}\u{439}\u{43B}\u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C} \u{424}\u{430}\u{439}\u{43B}\u{421}\u{441}\u{44B}\u{43B}\u{43A}\u{430}\u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C} \u{424}\u{430}\u{439}\u{43B}\u{421}\u{443}\u{449}\u{435}\u{441}\u{442}\u{432}\u{443}\u{435}\u{442} \u{424}\u{430}\u{439}\u{43B}\u{421}\u{447}\u{438}\u{442}\u{430}\u{442}\u{44C} \u{424}\u{430}\u{439}\u{43B}\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{424}\u{43C}\u{442}SQL\u{414}\u{430}\u{442} \u{424}\u{43C}\u{442}\u{414}\u{430}\u{442} \u{424}\u{43C}\u{442}\u{421}\u{442}\u{440} \u{424}\u{43C}\u{442}\u{427}\u{441}\u{43B} \u{424}\u{43E}\u{440}\u{43C}\u{430}\u{442} \u{426}\u{41C}\u{430}\u{441}\u{441}\u{438}\u{432}\u{42D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442} \u{426}\u{41D}\u{430}\u{431}\u{43E}\u{440}\u{414}\u{430}\u{43D}\u{43D}\u{44B}\u{445}\u{420}\u{435}\u{43A}\u{432}\u{438}\u{437}\u{438}\u{442} \u{426}\u{41F}\u{43E}\u{434}\u{441}\u{442}\u{440} `
                                },
                                begin: u,
                                end: `\\(`,
                                returnBegin: !0,
                                excludeEnd: !0
                            },
                            s,
                            l,
                            r,
                            n,
                            a
                        ]
                    },
                    c,
                    s,
                    l,
                    r,
                    n,
                    a
                ]
            };
        }
        t.exports = n;
    }), We = o((e, t)=>{
        var n = `[0-9](_*[0-9])*`, r = `\\.(${n})`, i = `[0-9a-fA-F](_*[0-9a-fA-F])*`, a = {
            className: `number`,
            variants: [
                {
                    begin: `(\\b(${n})((${r})|\\.)?|(${r}))[eE][+-]?(${n})[fFdD]?\\b`
                },
                {
                    begin: `\\b(${n})((${r})[fFdD]?\\b|\\.([fFdD]\\b)?)`
                },
                {
                    begin: `(${r})[fFdD]?\\b`
                },
                {
                    begin: `\\b(${n})[fFdD]\\b`
                },
                {
                    begin: `\\b0[xX]((${i})\\.?|(${i})?\\.(${i}))[pP][+-]?(${n})[fFdD]?\\b`
                },
                {
                    begin: `\\b(0|[1-9](_*[0-9])*)[lL]?\\b`
                },
                {
                    begin: `\\b0[xX](${i})[lL]?\\b`
                },
                {
                    begin: `\\b0(_*[0-7])*[lL]?\\b`
                },
                {
                    begin: `\\b0[bB][01](_*[01])*[lL]?\\b`
                }
            ],
            relevance: 0
        };
        function o(e, t, n) {
            return n === -1 ? `` : e.replace(t, (r)=>o(e, t, n - 1));
        }
        function s(e) {
            let t = e.regex, n = `[\xc0-\u{2B8}a-zA-Z_$][\xc0-\u{2B8}a-zA-Z_$0-9]*`, r = n + o(`(?:<` + n + `~~~(?:\\s*,\\s*[\xc0-\u{2B8}a-zA-Z_$][\xc0-\u{2B8}a-zA-Z_$0-9]*~~~)*>)?`, /~~~/g, 2), i = {
                keyword: `synchronized.abstract.private.var.static.if.const .for.while.strictfp.finally.protected.import.native.final.void.enum.else.break.transient.catch.instanceof.volatile.case.assert.package.default.public.try.switch.continue.throws.protected.public.private.module.requires.exports.do.sealed.yield.permits.goto.when`.split(`.`),
                literal: [
                    `false`,
                    `true`,
                    `null`
                ],
                type: [
                    `char`,
                    `boolean`,
                    `long`,
                    `float`,
                    `int`,
                    `byte`,
                    `short`,
                    `double`
                ],
                built_in: [
                    `super`,
                    `this`
                ]
            }, s = {
                className: `meta`,
                begin: `@` + n,
                contains: [
                    {
                        begin: /\(/,
                        end: /\)/,
                        contains: [
                            `self`
                        ]
                    }
                ]
            }, c = {
                className: `params`,
                begin: /\(/,
                end: /\)/,
                keywords: i,
                relevance: 0,
                contains: [
                    e.C_BLOCK_COMMENT_MODE
                ],
                endsParent: !0
            };
            return {
                name: `Java`,
                aliases: [
                    `jsp`
                ],
                keywords: i,
                illegal: /<\/|#/,
                contains: [
                    e.COMMENT(`/\\*\\*`, `\\*/`, {
                        relevance: 0,
                        contains: [
                            {
                                begin: /\w+@/,
                                relevance: 0
                            },
                            {
                                className: `doctag`,
                                begin: `@[A-Za-z]+`
                            }
                        ]
                    }),
                    {
                        begin: /import java\.[a-z]+\./,
                        keywords: `import`,
                        relevance: 2
                    },
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    {
                        begin: /"""/,
                        end: /"""/,
                        className: `string`,
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ]
                    },
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE,
                    {
                        match: [
                            /\b(?:class|interface|enum|extends|implements|new)/,
                            /\s+/,
                            n
                        ],
                        className: {
                            1: `keyword`,
                            3: `title.class`
                        }
                    },
                    {
                        match: /non-sealed/,
                        scope: `keyword`
                    },
                    {
                        begin: [
                            t.concat(/(?!else)/, n),
                            /\s+/,
                            n,
                            /\s+/,
                            /=(?!=)/
                        ],
                        className: {
                            1: `type`,
                            3: `variable`,
                            5: `operator`
                        }
                    },
                    {
                        begin: [
                            /record/,
                            /\s+/,
                            n
                        ],
                        className: {
                            1: `keyword`,
                            3: `title.class`
                        },
                        contains: [
                            c,
                            e.C_LINE_COMMENT_MODE,
                            e.C_BLOCK_COMMENT_MODE
                        ]
                    },
                    {
                        beginKeywords: `new throw return else`,
                        relevance: 0
                    },
                    {
                        begin: [
                            `(?:` + r + `\\s+)`,
                            e.UNDERSCORE_IDENT_RE,
                            /\s*(?=\()/
                        ],
                        className: {
                            2: `title.function`
                        },
                        keywords: i,
                        contains: [
                            {
                                className: `params`,
                                begin: /\(/,
                                end: /\)/,
                                keywords: i,
                                relevance: 0,
                                contains: [
                                    s,
                                    e.APOS_STRING_MODE,
                                    e.QUOTE_STRING_MODE,
                                    a,
                                    e.C_BLOCK_COMMENT_MODE
                                ]
                            },
                            e.C_LINE_COMMENT_MODE,
                            e.C_BLOCK_COMMENT_MODE
                        ]
                    },
                    a,
                    s
                ]
            };
        }
        t.exports = s;
    }), Ge = o((e, t)=>{
        var n = `[A-Za-z$_][0-9A-Za-z$_]*`, r = `as.in.of.if.for.while.finally.var.new.function.do.return.void.else.break.catch.instanceof.with.throw.case.default.try.switch.continue.typeof.delete.let.yield.const.class.debugger.async.await.static.import.from.export.extends.using`.split(`.`), i = [
            `true`,
            `false`,
            `null`,
            `undefined`,
            `NaN`,
            `Infinity`
        ], a = `Object.Function.Boolean.Symbol.Math.Date.Number.BigInt.String.RegExp.Array.Float32Array.Float64Array.Int8Array.Uint8Array.Uint8ClampedArray.Int16Array.Int32Array.Uint16Array.Uint32Array.BigInt64Array.BigUint64Array.Set.Map.WeakSet.WeakMap.ArrayBuffer.SharedArrayBuffer.Atomics.DataView.JSON.Promise.Generator.GeneratorFunction.AsyncFunction.Reflect.Proxy.Intl.WebAssembly`.split(`.`), o = [
            `Error`,
            `EvalError`,
            `InternalError`,
            `RangeError`,
            `ReferenceError`,
            `SyntaxError`,
            `TypeError`,
            `URIError`
        ], s = [
            `setInterval`,
            `setTimeout`,
            `clearInterval`,
            `clearTimeout`,
            `require`,
            `exports`,
            `eval`,
            `isFinite`,
            `isNaN`,
            `parseFloat`,
            `parseInt`,
            `decodeURI`,
            `decodeURIComponent`,
            `encodeURI`,
            `encodeURIComponent`,
            `escape`,
            `unescape`
        ], c = [
            `arguments`,
            `this`,
            `super`,
            `console`,
            `window`,
            `document`,
            `localStorage`,
            `sessionStorage`,
            `module`,
            `global`
        ], l = [].concat(s, a, o);
        function u(e) {
            let t = e.regex, u = (e, { after: t })=>{
                let n = `</` + e[0].slice(1);
                return e.input.indexOf(n, t) !== -1;
            }, d = n, f = {
                begin: `<>`,
                end: `</>`
            }, p = /<[A-Za-z0-9\\._:-]+\s*\/>/, m = {
                begin: /<[A-Za-z0-9\\._:-]+/,
                end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
                isTrulyOpeningTag: (e, t)=>{
                    let n = e[0].length + e.index, r = e.input[n];
                    if (r === `<` || r === `,`) {
                        t.ignoreMatch();
                        return;
                    }
                    r === `>` && (u(e, {
                        after: n
                    }) || t.ignoreMatch());
                    let i, a = e.input.substring(n);
                    if (i = a.match(/^\s*=/)) {
                        t.ignoreMatch();
                        return;
                    }
                    if ((i = a.match(/^\s+extends\s+/)) && i.index === 0) {
                        t.ignoreMatch();
                        return;
                    }
                }
            }, h = {
                $pattern: n,
                keyword: r,
                literal: i,
                built_in: l,
                "variable.language": c
            }, g = `[0-9](_?[0-9])*`, _ = `\\.(${g})`, v = `0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*`, y = {
                className: `number`,
                variants: [
                    {
                        begin: `(\\b(${v})((${_})|\\.)?|(${_}))[eE][+-]?(${g})\\b`
                    },
                    {
                        begin: `\\b(${v})\\b((${_})\\b|\\.)?|(${_})\\b`
                    },
                    {
                        begin: `\\b(0|[1-9](_?[0-9])*)n\\b`
                    },
                    {
                        begin: `\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b`
                    },
                    {
                        begin: `\\b0[bB][0-1](_?[0-1])*n?\\b`
                    },
                    {
                        begin: `\\b0[oO][0-7](_?[0-7])*n?\\b`
                    },
                    {
                        begin: `\\b0[0-7]+n?\\b`
                    }
                ],
                relevance: 0
            }, b = {
                className: `subst`,
                begin: `\\$\\{`,
                end: `\\}`,
                keywords: h,
                contains: []
            }, x = {
                begin: ".?html`",
                end: ``,
                starts: {
                    end: "`",
                    returnEnd: !1,
                    contains: [
                        e.BACKSLASH_ESCAPE,
                        b
                    ],
                    subLanguage: `xml`
                }
            }, S = {
                begin: ".?css`",
                end: ``,
                starts: {
                    end: "`",
                    returnEnd: !1,
                    contains: [
                        e.BACKSLASH_ESCAPE,
                        b
                    ],
                    subLanguage: `css`
                }
            }, C = {
                begin: ".?gql`",
                end: ``,
                starts: {
                    end: "`",
                    returnEnd: !1,
                    contains: [
                        e.BACKSLASH_ESCAPE,
                        b
                    ],
                    subLanguage: `graphql`
                }
            }, w = {
                className: `string`,
                begin: "`",
                end: "`",
                contains: [
                    e.BACKSLASH_ESCAPE,
                    b
                ]
            }, T = {
                className: `comment`,
                variants: [
                    e.COMMENT(/\/\*\*(?!\/)/, `\\*/`, {
                        relevance: 0,
                        contains: [
                            {
                                begin: `(?=@[A-Za-z]+)`,
                                relevance: 0,
                                contains: [
                                    {
                                        className: `doctag`,
                                        begin: `@[A-Za-z]+`
                                    },
                                    {
                                        className: `type`,
                                        begin: `\\{`,
                                        end: `\\}`,
                                        excludeEnd: !0,
                                        excludeBegin: !0,
                                        relevance: 0
                                    },
                                    {
                                        className: `variable`,
                                        begin: d + `(?=\\s*(-)|$)`,
                                        endsParent: !0,
                                        relevance: 0
                                    },
                                    {
                                        begin: /(?=[^\n])\s/,
                                        relevance: 0
                                    }
                                ]
                            }
                        ]
                    }),
                    e.C_BLOCK_COMMENT_MODE,
                    e.C_LINE_COMMENT_MODE
                ]
            }, E = [
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE,
                x,
                S,
                C,
                w,
                {
                    match: /\$\d+/
                },
                y
            ];
            b.contains = E.concat({
                begin: /\{/,
                end: /\}/,
                keywords: h,
                contains: [
                    `self`
                ].concat(E)
            });
            let D = [].concat(T, b.contains), O = D.concat([
                {
                    begin: /(\s*)\(/,
                    end: /\)/,
                    keywords: h,
                    contains: [
                        `self`
                    ].concat(D)
                }
            ]), k = {
                className: `params`,
                begin: /(\s*)\(/,
                end: /\)/,
                excludeBegin: !0,
                excludeEnd: !0,
                keywords: h,
                contains: O
            }, A = {
                variants: [
                    {
                        match: [
                            /class/,
                            /\s+/,
                            d,
                            /\s+/,
                            /extends/,
                            /\s+/,
                            t.concat(d, `(`, t.concat(/\./, d), `)*`)
                        ],
                        scope: {
                            1: `keyword`,
                            3: `title.class`,
                            5: `keyword`,
                            7: `title.class.inherited`
                        }
                    },
                    {
                        match: [
                            /class/,
                            /\s+/,
                            d
                        ],
                        scope: {
                            1: `keyword`,
                            3: `title.class`
                        }
                    }
                ]
            }, j = {
                relevance: 0,
                match: t.either(/\bJSON/, /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/, /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/, /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/),
                className: `title.class`,
                keywords: {
                    _: [
                        ...a,
                        ...o
                    ]
                }
            }, M = {
                label: `use_strict`,
                className: `meta`,
                relevance: 10,
                begin: /^\s*['"]use (strict|asm)['"]/
            }, N = {
                variants: [
                    {
                        match: [
                            /function/,
                            /\s+/,
                            d,
                            /(?=\s*\()/
                        ]
                    },
                    {
                        match: [
                            /function/,
                            /\s*(?=\()/
                        ]
                    }
                ],
                className: {
                    1: `keyword`,
                    3: `title.function`
                },
                label: `func.def`,
                contains: [
                    k
                ],
                illegal: /%/
            }, P = {
                relevance: 0,
                match: /\b[A-Z][A-Z_0-9]+\b/,
                className: `variable.constant`
            };
            function F(e) {
                return t.concat(`(?!`, e.join(`|`), `)`);
            }
            let I = {
                match: t.concat(/\b/, F([
                    ...s,
                    `super`,
                    `import`
                ].map((e)=>`${e}\\s*\\(`)), d, t.lookahead(/\s*\(/)),
                className: `title.function`,
                relevance: 0
            }, L = {
                begin: t.concat(/\./, t.lookahead(t.concat(d, /(?![0-9A-Za-z$_(])/))),
                end: d,
                excludeBegin: !0,
                keywords: `prototype`,
                className: `property`,
                relevance: 0
            }, R = {
                match: [
                    /get|set/,
                    /\s+/,
                    d,
                    /(?=\()/
                ],
                className: {
                    1: `keyword`,
                    3: `title.function`
                },
                contains: [
                    {
                        begin: /\(\)/
                    },
                    k
                ]
            }, z = `(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|` + e.UNDERSCORE_IDENT_RE + `)\\s*=>`, B = {
                match: [
                    /const|var|let/,
                    /\s+/,
                    d,
                    /\s*/,
                    /=\s*/,
                    /(async\s*)?/,
                    t.lookahead(z)
                ],
                keywords: `async`,
                className: {
                    1: `keyword`,
                    3: `title.function`
                },
                contains: [
                    k
                ]
            };
            return {
                name: `JavaScript`,
                aliases: [
                    `js`,
                    `jsx`,
                    `mjs`,
                    `cjs`
                ],
                keywords: h,
                exports: {
                    PARAMS_CONTAINS: O,
                    CLASS_REFERENCE: j
                },
                illegal: /#(?![$_A-z])/,
                contains: [
                    e.SHEBANG({
                        label: `shebang`,
                        binary: `node`,
                        relevance: 5
                    }),
                    M,
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE,
                    x,
                    S,
                    C,
                    w,
                    T,
                    {
                        match: /\$\d+/
                    },
                    y,
                    j,
                    {
                        scope: `attr`,
                        match: d + t.lookahead(`:`),
                        relevance: 0
                    },
                    B,
                    {
                        begin: `(` + e.RE_STARTERS_RE + `|\\b(case|return|throw)\\b)\\s*`,
                        keywords: `return throw case`,
                        relevance: 0,
                        contains: [
                            T,
                            e.REGEXP_MODE,
                            {
                                className: `function`,
                                begin: z,
                                returnBegin: !0,
                                end: `\\s*=>`,
                                contains: [
                                    {
                                        className: `params`,
                                        variants: [
                                            {
                                                begin: e.UNDERSCORE_IDENT_RE,
                                                relevance: 0
                                            },
                                            {
                                                className: null,
                                                begin: /\(\s*\)/,
                                                skip: !0
                                            },
                                            {
                                                begin: /(\s*)\(/,
                                                end: /\)/,
                                                excludeBegin: !0,
                                                excludeEnd: !0,
                                                keywords: h,
                                                contains: O
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                begin: /,/,
                                relevance: 0
                            },
                            {
                                match: /\s+/,
                                relevance: 0
                            },
                            {
                                variants: [
                                    {
                                        begin: f.begin,
                                        end: f.end
                                    },
                                    {
                                        match: p
                                    },
                                    {
                                        begin: m.begin,
                                        "on:begin": m.isTrulyOpeningTag,
                                        end: m.end
                                    }
                                ],
                                subLanguage: `xml`,
                                contains: [
                                    {
                                        begin: m.begin,
                                        end: m.end,
                                        skip: !0,
                                        contains: [
                                            `self`
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    N,
                    {
                        beginKeywords: `while if switch catch for`
                    },
                    {
                        begin: `\\b(?!function)` + e.UNDERSCORE_IDENT_RE + `\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{`,
                        returnBegin: !0,
                        label: `func.def`,
                        contains: [
                            k,
                            e.inherit(e.TITLE_MODE, {
                                begin: d,
                                className: `title.function`
                            })
                        ]
                    },
                    {
                        match: /\.\.\./,
                        relevance: 0
                    },
                    L,
                    {
                        match: `\\$` + d,
                        relevance: 0
                    },
                    {
                        match: [
                            /\bconstructor(?=\s*\()/
                        ],
                        className: {
                            1: `title.function`
                        },
                        contains: [
                            k
                        ]
                    },
                    I,
                    P,
                    A,
                    R,
                    {
                        match: /\$[(.]/
                    }
                ]
            };
        }
        t.exports = u;
    }), Ke = o((e, t)=>{
        function n(e) {
            return {
                name: `JBoss CLI`,
                aliases: [
                    `wildfly-cli`
                ],
                keywords: {
                    $pattern: `[a-z-]+`,
                    keyword: `alias batch cd clear command connect connection-factory connection-info data-source deploy deployment-info deployment-overlay echo echo-dmr help history if jdbc-driver-info jms-queue|20 jms-topic|20 ls patch pwd quit read-attribute read-operation reload rollout-plan run-batch set shutdown try unalias undeploy unset version xa-data-source`,
                    literal: `true false`
                },
                contains: [
                    e.HASH_COMMENT_MODE,
                    e.QUOTE_STRING_MODE,
                    {
                        className: `params`,
                        begin: /--[\w\-=\/]+/
                    },
                    {
                        className: `function`,
                        begin: /:[\w\-.]+/,
                        relevance: 0
                    },
                    {
                        className: `string`,
                        begin: /\B([\/.])[\w\-.\/=]+/
                    },
                    {
                        className: `params`,
                        begin: /\(/,
                        end: /\)/,
                        contains: [
                            {
                                begin: /[\w-]+ *=/,
                                returnBegin: !0,
                                relevance: 0,
                                contains: [
                                    {
                                        className: `attr`,
                                        begin: /[\w-]+/
                                    }
                                ]
                            }
                        ],
                        relevance: 0
                    }
                ]
            };
        }
        t.exports = n;
    }), qe = o((e, t)=>{
        function n(e) {
            let t = {
                className: `attr`,
                begin: /"(\\.|[^\\"\r\n])*"(?=\s*:)/,
                relevance: 1.01
            }, n = {
                match: /[{}[\],:]/,
                className: `punctuation`,
                relevance: 0
            }, r = [
                `true`,
                `false`,
                `null`
            ], i = {
                scope: `literal`,
                beginKeywords: r.join(` `)
            };
            return {
                name: `JSON`,
                aliases: [
                    `jsonc`
                ],
                keywords: {
                    literal: r
                },
                contains: [
                    t,
                    n,
                    e.QUOTE_STRING_MODE,
                    i,
                    e.C_NUMBER_MODE,
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE
                ],
                illegal: `\\S`
            };
        }
        t.exports = n;
    }), Je = o((e, t)=>{
        function n(e) {
            let t = `[A-Za-z_\\u00A1-\\uFFFF][A-Za-z_0-9\\u00A1-\\uFFFF]*`, n = {
                $pattern: t,
                keyword: `baremodule.begin.break.catch.ccall.const.continue.do.else.elseif.end.export.false.finally.for.function.global.if.import.in.isa.let.local.macro.module.quote.return.true.try.using.where.while`.split(`.`),
                literal: `ARGS.C_NULL.DEPOT_PATH.ENDIAN_BOM.ENV.Inf.Inf16.Inf32.Inf64.InsertionSort.LOAD_PATH.MergeSort.NaN.NaN16.NaN32.NaN64.PROGRAM_FILE.QuickSort.RoundDown.RoundFromZero.RoundNearest.RoundNearestTiesAway.RoundNearestTiesUp.RoundToZero.RoundUp.VERSION|0.devnull.false.im.missing.nothing.pi.stderr.stdin.stdout.true.undef.\u{3C0}.\u{212F}`.split(`.`),
                built_in: `AbstractArray.AbstractChannel.AbstractChar.AbstractDict.AbstractDisplay.AbstractFloat.AbstractIrrational.AbstractMatrix.AbstractRange.AbstractSet.AbstractString.AbstractUnitRange.AbstractVecOrMat.AbstractVector.Any.ArgumentError.Array.AssertionError.BigFloat.BigInt.BitArray.BitMatrix.BitSet.BitVector.Bool.BoundsError.CapturedException.CartesianIndex.CartesianIndices.Cchar.Cdouble.Cfloat.Channel.Char.Cint.Cintmax_t.Clong.Clonglong.Cmd.Colon.Complex.ComplexF16.ComplexF32.ComplexF64.CompositeException.Condition.Cptrdiff_t.Cshort.Csize_t.Cssize_t.Cstring.Cuchar.Cuint.Cuintmax_t.Culong.Culonglong.Cushort.Cvoid.Cwchar_t.Cwstring.DataType.DenseArray.DenseMatrix.DenseVecOrMat.DenseVector.Dict.DimensionMismatch.Dims.DivideError.DomainError.EOFError.Enum.ErrorException.Exception.ExponentialBackOff.Expr.Float16.Float32.Float64.Function.GlobalRef.HTML.IO.IOBuffer.IOContext.IOStream.IdDict.IndexCartesian.IndexLinear.IndexStyle.InexactError.InitError.Int.Int128.Int16.Int32.Int64.Int8.Integer.InterruptException.InvalidStateException.Irrational.KeyError.LinRange.LineNumberNode.LinearIndices.LoadError.MIME.Matrix.Method.MethodError.Missing.MissingException.Module.NTuple.NamedTuple.Nothing.Number.OrdinalRange.OutOfMemoryError.OverflowError.Pair.PartialQuickSort.PermutedDimsArray.Pipe.ProcessFailedException.Ptr.QuoteNode.Rational.RawFD.ReadOnlyMemoryError.Real.ReentrantLock.Ref.Regex.RegexMatch.RoundingMode.SegmentationFault.Set.Signed.Some.StackOverflowError.StepRange.StepRangeLen.StridedArray.StridedMatrix.StridedVecOrMat.StridedVector.String.StringIndexError.SubArray.SubString.SubstitutionString.Symbol.SystemError.Task.TaskFailedException.Text.TextDisplay.Timer.Tuple.Type.TypeError.TypeVar.UInt.UInt128.UInt16.UInt32.UInt64.UInt8.UndefInitializer.UndefKeywordError.UndefRefError.UndefVarError.Union.UnionAll.UnitRange.Unsigned.Val.Vararg.VecElement.VecOrMat.Vector.VersionNumber.WeakKeyDict.WeakRef`.split(`.`)
            }, r = {
                keywords: n,
                illegal: /<\//
            }, i = {
                className: `number`,
                begin: /(\b0x[\d_]*(\.[\d_]*)?|0x\.\d[\d_]*)p[-+]?\d+|\b0[box][a-fA-F0-9][a-fA-F0-9_]*|(\b\d[\d_]*(\.[\d_]*)?|\.\d[\d_]*)([eEfF][-+]?\d+)?/,
                relevance: 0
            }, a = {
                className: `string`,
                begin: /'(.|\\[xXuU][a-zA-Z0-9]+)'/
            }, o = {
                className: `subst`,
                begin: /\$\(/,
                end: /\)/,
                keywords: n
            }, s = {
                className: `variable`,
                begin: `\\$` + t
            }, c = {
                className: `string`,
                contains: [
                    e.BACKSLASH_ESCAPE,
                    o,
                    s
                ],
                variants: [
                    {
                        begin: /\w*"""/,
                        end: /"""\w*/,
                        relevance: 10
                    },
                    {
                        begin: /\w*"/,
                        end: /"\w*/
                    }
                ]
            }, l = {
                className: `string`,
                contains: [
                    e.BACKSLASH_ESCAPE,
                    o,
                    s
                ],
                begin: "`",
                end: "`"
            }, u = {
                className: `meta`,
                begin: `@` + t
            };
            return r.name = `Julia`, r.contains = [
                i,
                a,
                c,
                l,
                u,
                {
                    className: `comment`,
                    variants: [
                        {
                            begin: `#=`,
                            end: `=#`,
                            relevance: 10
                        },
                        {
                            begin: `#`,
                            end: `$`
                        }
                    ]
                },
                e.HASH_COMMENT_MODE,
                {
                    className: `keyword`,
                    begin: `\\b(((abstract|primitive)\\s+)type|(mutable\\s+)?struct)\\b`
                },
                {
                    begin: /<:/
                }
            ], o.contains = r.contains, r;
        }
        t.exports = n;
    }), Ye = o((e, t)=>{
        function n(e) {
            return {
                name: `Julia REPL`,
                contains: [
                    {
                        className: `meta.prompt`,
                        begin: /^julia>/,
                        relevance: 10,
                        starts: {
                            end: /^(?![ ]{6})/,
                            subLanguage: `julia`
                        }
                    }
                ],
                aliases: [
                    `jldoctest`
                ]
            };
        }
        t.exports = n;
    }), Xe = o((e, t)=>{
        var n = `[0-9](_*[0-9])*`, r = `\\.(${n})`, i = `[0-9a-fA-F](_*[0-9a-fA-F])*`, a = {
            className: `number`,
            variants: [
                {
                    begin: `(\\b(${n})((${r})|\\.)?|(${r}))[eE][+-]?(${n})[fFdD]?\\b`
                },
                {
                    begin: `\\b(${n})((${r})[fFdD]?\\b|\\.([fFdD]\\b)?)`
                },
                {
                    begin: `(${r})[fFdD]?\\b`
                },
                {
                    begin: `\\b(${n})[fFdD]\\b`
                },
                {
                    begin: `\\b0[xX]((${i})\\.?|(${i})?\\.(${i}))[pP][+-]?(${n})[fFdD]?\\b`
                },
                {
                    begin: `\\b(0|[1-9](_*[0-9])*)[lL]?\\b`
                },
                {
                    begin: `\\b0[xX](${i})[lL]?\\b`
                },
                {
                    begin: `\\b0(_*[0-7])*[lL]?\\b`
                },
                {
                    begin: `\\b0[bB][01](_*[01])*[lL]?\\b`
                }
            ],
            relevance: 0
        };
        function o(e) {
            let t = {
                keyword: `abstract as val var vararg get set class object open private protected public noinline crossinline dynamic final enum if else do while for when throw try catch finally import package is in fun override companion reified inline lateinit init interface annotation data sealed internal infix operator out by constructor super tailrec where const inner suspend typealias external expect actual`,
                built_in: `Byte Short Char Int Long Boolean Float Double Void Unit Nothing`,
                literal: `true false null`
            }, n = {
                className: `keyword`,
                begin: /\b(break|continue|return|this)\b/,
                starts: {
                    contains: [
                        {
                            className: `symbol`,
                            begin: /@\w+/
                        }
                    ]
                }
            }, r = {
                className: `symbol`,
                begin: e.UNDERSCORE_IDENT_RE + `@`
            }, i = {
                className: `subst`,
                begin: /\$\{/,
                end: /\}/,
                contains: [
                    e.C_NUMBER_MODE
                ]
            }, o = {
                className: `variable`,
                begin: `\\$` + e.UNDERSCORE_IDENT_RE
            }, s = {
                className: `string`,
                variants: [
                    {
                        begin: `"""`,
                        end: `"""(?=[^"])`,
                        contains: [
                            o,
                            i
                        ]
                    },
                    {
                        begin: `'`,
                        end: `'`,
                        illegal: /\n/,
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ]
                    },
                    {
                        begin: `"`,
                        end: `"`,
                        illegal: /\n/,
                        contains: [
                            e.BACKSLASH_ESCAPE,
                            o,
                            i
                        ]
                    }
                ]
            };
            i.contains.push(s);
            let c = {
                className: `meta`,
                begin: `@(?:file|property|field|get|set|receiver|param|setparam|delegate)\\s*:(?:\\s*` + e.UNDERSCORE_IDENT_RE + `)?`
            }, l = {
                className: `meta`,
                begin: `@` + e.UNDERSCORE_IDENT_RE,
                contains: [
                    {
                        begin: /\(/,
                        end: /\)/,
                        contains: [
                            e.inherit(s, {
                                className: `string`
                            }),
                            `self`
                        ]
                    }
                ]
            }, u = a, d = e.COMMENT(`/\\*`, `\\*/`, {
                contains: [
                    e.C_BLOCK_COMMENT_MODE
                ]
            }), f = {
                variants: [
                    {
                        className: `type`,
                        begin: e.UNDERSCORE_IDENT_RE
                    },
                    {
                        begin: /\(/,
                        end: /\)/,
                        contains: []
                    }
                ]
            }, p = f;
            return p.variants[1].contains = [
                f
            ], f.variants[1].contains = [
                p
            ], {
                name: `Kotlin`,
                aliases: [
                    `kt`,
                    `kts`
                ],
                keywords: t,
                contains: [
                    e.COMMENT(`/\\*\\*`, `\\*/`, {
                        relevance: 0,
                        contains: [
                            {
                                className: `doctag`,
                                begin: `@[A-Za-z]+`
                            }
                        ]
                    }),
                    e.C_LINE_COMMENT_MODE,
                    d,
                    n,
                    r,
                    c,
                    l,
                    {
                        className: `function`,
                        beginKeywords: `fun`,
                        end: `[(]|$`,
                        returnBegin: !0,
                        excludeEnd: !0,
                        keywords: t,
                        relevance: 5,
                        contains: [
                            {
                                begin: e.UNDERSCORE_IDENT_RE + `\\s*\\(`,
                                returnBegin: !0,
                                relevance: 0,
                                contains: [
                                    e.UNDERSCORE_TITLE_MODE
                                ]
                            },
                            {
                                className: `type`,
                                begin: /</,
                                end: />/,
                                keywords: `reified`,
                                relevance: 0
                            },
                            {
                                className: `params`,
                                begin: /\(/,
                                end: /\)/,
                                endsParent: !0,
                                keywords: t,
                                relevance: 0,
                                contains: [
                                    {
                                        begin: /:/,
                                        end: /[=,\/]/,
                                        endsWithParent: !0,
                                        contains: [
                                            f,
                                            e.C_LINE_COMMENT_MODE,
                                            d
                                        ],
                                        relevance: 0
                                    },
                                    e.C_LINE_COMMENT_MODE,
                                    d,
                                    c,
                                    l,
                                    s,
                                    e.C_NUMBER_MODE
                                ]
                            },
                            d
                        ]
                    },
                    {
                        begin: [
                            /class|interface|trait/,
                            /\s+/,
                            e.UNDERSCORE_IDENT_RE
                        ],
                        beginScope: {
                            3: `title.class`
                        },
                        keywords: `class interface trait`,
                        end: /[:\{(]|$/,
                        excludeEnd: !0,
                        illegal: `extends implements`,
                        contains: [
                            {
                                beginKeywords: `public protected internal private constructor`
                            },
                            e.UNDERSCORE_TITLE_MODE,
                            {
                                className: `type`,
                                begin: /</,
                                end: />/,
                                excludeBegin: !0,
                                excludeEnd: !0,
                                relevance: 0
                            },
                            {
                                className: `type`,
                                begin: /[,:]\s*/,
                                end: /[<\(,){\s]|$/,
                                excludeBegin: !0,
                                returnEnd: !0
                            },
                            c,
                            l
                        ]
                    },
                    s,
                    {
                        className: `meta`,
                        begin: `^#!/usr/bin/env`,
                        end: `$`,
                        illegal: `
`
                    },
                    u
                ]
            };
        }
        t.exports = o;
    }), Ze = o((e, t)=>{
        function n(e) {
            let t = `[a-zA-Z_][\\w.]*`, n = `<\\?(lasso(script)?|=)`, r = `\\]|\\?>`, i = {
                $pattern: t + `|&[lg]t;`,
                literal: `true false none minimal full all void and or not bw nbw ew new cn ncn lt lte gt gte eq neq rx nrx ft`,
                built_in: `array date decimal duration integer map pair string tag xml null boolean bytes keyword list locale queue set stack staticarray local var variable global data self inherited currentcapture givenblock`,
                keyword: `cache database_names database_schemanames database_tablenames define_tag define_type email_batch encode_set html_comment handle handle_error header if inline iterate ljax_target link link_currentaction link_currentgroup link_currentrecord link_detail link_firstgroup link_firstrecord link_lastgroup link_lastrecord link_nextgroup link_nextrecord link_prevgroup link_prevrecord log loop namespace_using output_none portal private protect records referer referrer repeating resultset rows search_args search_arguments select sort_args sort_arguments thread_atomic value_list while abort case else fail_if fail_ifnot fail if_empty if_false if_null if_true loop_abort loop_continue loop_count params params_up return return_value run_children soap_definetag soap_lastrequest soap_lastresponse tag_name ascending average by define descending do equals frozen group handle_failure import in into join let match max min on order parent protected provide public require returnhome skip split_thread sum take thread to trait type where with yield yieldhome`
            }, a = e.COMMENT(`<!--`, `-->`, {
                relevance: 0
            }), o = {
                className: `meta`,
                begin: `\\[noprocess\\]`,
                starts: {
                    end: `\\[/noprocess\\]`,
                    returnEnd: !0,
                    contains: [
                        a
                    ]
                }
            }, s = {
                className: `meta`,
                begin: `\\[/noprocess|` + n
            }, c = {
                className: `symbol`,
                begin: `'` + t + `'`
            }, l = [
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                e.inherit(e.C_NUMBER_MODE, {
                    begin: e.C_NUMBER_RE + `|(-?infinity|NaN)\\b`
                }),
                e.inherit(e.APOS_STRING_MODE, {
                    illegal: null
                }),
                e.inherit(e.QUOTE_STRING_MODE, {
                    illegal: null
                }),
                {
                    className: `string`,
                    begin: "`",
                    end: "`"
                },
                {
                    variants: [
                        {
                            begin: `[#$]` + t
                        },
                        {
                            begin: `#`,
                            end: `\\d+`,
                            illegal: `\\W`
                        }
                    ]
                },
                {
                    className: `type`,
                    begin: `::\\s*`,
                    end: t,
                    illegal: `\\W`
                },
                {
                    className: `params`,
                    variants: [
                        {
                            begin: `-(?!infinity)` + t,
                            relevance: 0
                        },
                        {
                            begin: `(\\.\\.\\.)`
                        }
                    ]
                },
                {
                    begin: /(->|\.)\s*/,
                    relevance: 0,
                    contains: [
                        c
                    ]
                },
                {
                    className: `class`,
                    beginKeywords: `define`,
                    returnEnd: !0,
                    end: `\\(|=>`,
                    contains: [
                        e.inherit(e.TITLE_MODE, {
                            begin: t + `(=(?!>))?|[-+*/%](?!>)`
                        })
                    ]
                }
            ];
            return {
                name: `Lasso`,
                aliases: [
                    `ls`,
                    `lassoscript`
                ],
                case_insensitive: !0,
                keywords: i,
                contains: [
                    {
                        className: `meta`,
                        begin: r,
                        relevance: 0,
                        starts: {
                            end: `\\[|` + n,
                            returnEnd: !0,
                            relevance: 0,
                            contains: [
                                a
                            ]
                        }
                    },
                    o,
                    s,
                    {
                        className: `meta`,
                        begin: `\\[no_square_brackets`,
                        starts: {
                            end: `\\[/no_square_brackets\\]`,
                            keywords: i,
                            contains: [
                                {
                                    className: `meta`,
                                    begin: r,
                                    relevance: 0,
                                    starts: {
                                        end: `\\[noprocess\\]|` + n,
                                        returnEnd: !0,
                                        contains: [
                                            a
                                        ]
                                    }
                                },
                                o,
                                s
                            ].concat(l)
                        }
                    },
                    {
                        className: `meta`,
                        begin: `\\[`,
                        relevance: 0
                    },
                    {
                        className: `meta`,
                        begin: `^#!`,
                        end: `lasso9$`,
                        relevance: 10
                    }
                ].concat(l)
            };
        }
        t.exports = n;
    }), Qe = o((e, t)=>{
        function n(e) {
            let t = e.regex.either(...[
                `(?:NeedsTeXFormat|RequirePackage|GetIdInfo)`,
                `Provides(?:Expl)?(?:Package|Class|File)`,
                `(?:DeclareOption|ProcessOptions)`,
                `(?:documentclass|usepackage|input|include)`,
                `makeat(?:letter|other)`,
                `ExplSyntax(?:On|Off)`,
                `(?:new|renew|provide)?command`,
                `(?:re)newenvironment`,
                `(?:New|Renew|Provide|Declare)(?:Expandable)?DocumentCommand`,
                `(?:New|Renew|Provide|Declare)DocumentEnvironment`,
                `(?:(?:e|g|x)?def|let)`,
                `(?:begin|end)`,
                `(?:part|chapter|(?:sub){0,2}section|(?:sub)?paragraph)`,
                `caption`,
                `(?:label|(?:eq|page|name)?ref|(?:paren|foot|super)?cite)`,
                `(?:alpha|beta|[Gg]amma|[Dd]elta|(?:var)?epsilon|zeta|eta|[Tt]heta|vartheta)`,
                `(?:iota|(?:var)?kappa|[Ll]ambda|mu|nu|[Xx]i|[Pp]i|varpi|(?:var)rho)`,
                `(?:[Ss]igma|varsigma|tau|[Uu]psilon|[Pp]hi|varphi|chi|[Pp]si|[Oo]mega)`,
                `(?:frac|sum|prod|lim|infty|times|sqrt|leq|geq|left|right|middle|[bB]igg?)`,
                `(?:[lr]angle|q?quad|[lcvdi]?dots|d?dot|hat|tilde|bar)`
            ].map((e)=>e + `(?![a-zA-Z@:_])`)), n = new RegExp([
                `(?:__)?[a-zA-Z]{2,}_[a-zA-Z](?:_?[a-zA-Z])+:[a-zA-Z]*`,
                `[lgc]__?[a-zA-Z](?:_?[a-zA-Z])*_[a-zA-Z]{2,}`,
                `[qs]__?[a-zA-Z](?:_?[a-zA-Z])+`,
                `use(?:_i)?:[a-zA-Z]*`,
                `(?:else|fi|or):`,
                `(?:if|cs|exp):w`,
                `(?:hbox|vbox):n`,
                `::[a-zA-Z]_unbraced`,
                `::[a-zA-Z:]`
            ].map((e)=>e + `(?![a-zA-Z:_])`).join(`|`)), r = [
                {
                    begin: /[a-zA-Z@]+/
                },
                {
                    begin: /[^a-zA-Z@]?/
                }
            ], i = [
                {
                    begin: /\^{6}[0-9a-f]{6}/
                },
                {
                    begin: /\^{5}[0-9a-f]{5}/
                },
                {
                    begin: /\^{4}[0-9a-f]{4}/
                },
                {
                    begin: /\^{3}[0-9a-f]{3}/
                },
                {
                    begin: /\^{2}[0-9a-f]{2}/
                },
                {
                    begin: /\^{2}[\u0000-\u007f]/
                }
            ], a = [
                {
                    className: `keyword`,
                    begin: /\\/,
                    relevance: 0,
                    contains: [
                        {
                            endsParent: !0,
                            begin: t
                        },
                        {
                            endsParent: !0,
                            begin: n
                        },
                        {
                            endsParent: !0,
                            variants: i
                        },
                        {
                            endsParent: !0,
                            relevance: 0,
                            variants: r
                        }
                    ]
                },
                {
                    className: `params`,
                    relevance: 0,
                    begin: /#+\d?/
                },
                {
                    variants: i
                },
                {
                    className: `built_in`,
                    relevance: 0,
                    begin: /[$&^_]/
                },
                {
                    className: `meta`,
                    begin: /% ?!(T[eE]X|tex|BIB|bib)/,
                    end: `$`,
                    relevance: 10
                },
                e.COMMENT(`%`, `$`, {
                    relevance: 0
                })
            ], o = {
                begin: /\{/,
                end: /\}/,
                relevance: 0,
                contains: [
                    `self`,
                    ...a
                ]
            }, s = e.inherit(o, {
                relevance: 0,
                endsParent: !0,
                contains: [
                    o,
                    ...a
                ]
            }), c = {
                begin: /\[/,
                end: /\]/,
                endsParent: !0,
                relevance: 0,
                contains: [
                    o,
                    ...a
                ]
            }, l = {
                begin: /\s+/,
                relevance: 0
            }, u = [
                s
            ], d = [
                c
            ], f = function(e, t) {
                return {
                    contains: [
                        l
                    ],
                    starts: {
                        relevance: 0,
                        contains: e,
                        starts: t
                    }
                };
            }, p = function(e, t) {
                return {
                    begin: `\\\\` + e + `(?![a-zA-Z@:_])`,
                    keywords: {
                        $pattern: /\\[a-zA-Z]+/,
                        keyword: `\\` + e
                    },
                    relevance: 0,
                    contains: [
                        l
                    ],
                    starts: t
                };
            }, m = function(t, n) {
                return e.inherit({
                    begin: `\\\\begin(?=[ 	]*(\\r?\\n[ 	]*)?\\{` + t + `\\})`,
                    keywords: {
                        $pattern: /\\[a-zA-Z]+/,
                        keyword: `\\begin`
                    },
                    relevance: 0
                }, f(u, n));
            }, h = (t = `string`)=>e.END_SAME_AS_BEGIN({
                    className: t,
                    begin: /(.|\r?\n)/,
                    end: /(.|\r?\n)/,
                    excludeBegin: !0,
                    excludeEnd: !0,
                    endsParent: !0
                }), g = function(e) {
                return {
                    className: `string`,
                    end: `(?=\\\\end\\{` + e + `\\})`
                };
            }, _ = (e = `string`)=>({
                    relevance: 0,
                    begin: /\{/,
                    starts: {
                        endsParent: !0,
                        contains: [
                            {
                                className: e,
                                end: /(?=\})/,
                                endsParent: !0,
                                contains: [
                                    {
                                        begin: /\{/,
                                        end: /\}/,
                                        relevance: 0,
                                        contains: [
                                            `self`
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                });
            return {
                name: `LaTeX`,
                aliases: [
                    `tex`
                ],
                contains: [
                    ...[
                        `verb`,
                        `lstinline`
                    ].map((e)=>p(e, {
                            contains: [
                                h()
                            ]
                        })),
                    p(`mint`, f(u, {
                        contains: [
                            h()
                        ]
                    })),
                    p(`mintinline`, f(u, {
                        contains: [
                            _(),
                            h()
                        ]
                    })),
                    p(`url`, {
                        contains: [
                            _(`link`),
                            _(`link`)
                        ]
                    }),
                    p(`hyperref`, {
                        contains: [
                            _(`link`)
                        ]
                    }),
                    p(`href`, f(d, {
                        contains: [
                            _(`link`)
                        ]
                    })),
                    ...[].concat(...[
                        ``,
                        `\\*`
                    ].map((e)=>[
                            m(`verbatim` + e, g(`verbatim` + e)),
                            m(`filecontents` + e, f(u, g(`filecontents` + e))),
                            ...[
                                ``,
                                `B`,
                                `L`
                            ].map((t)=>m(t + `Verbatim` + e, f(d, g(t + `Verbatim` + e))))
                        ])),
                    m(`minted`, f(d, f(u, g(`minted`)))),
                    ...a
                ]
            };
        }
        t.exports = n;
    }), $e = o((e, t)=>{
        function n(e) {
            return {
                name: `LDIF`,
                contains: [
                    {
                        className: `attribute`,
                        match: `^dn(?=:)`,
                        relevance: 10
                    },
                    {
                        className: `attribute`,
                        match: `^\\w+(?=:)`
                    },
                    {
                        className: `literal`,
                        match: `^-`
                    },
                    e.HASH_COMMENT_MODE
                ]
            };
        }
        t.exports = n;
    }), et = o((e, t)=>{
        function n(e) {
            let t = /([A-Za-z_][A-Za-z_0-9]*)?/, n = {
                scope: `params`,
                begin: /\(/,
                end: /\)(?=\:?)/,
                endsParent: !0,
                relevance: 7,
                contains: [
                    {
                        scope: `string`,
                        begin: `"`,
                        end: `"`
                    },
                    {
                        scope: `keyword`,
                        match: [
                            `true`,
                            `false`,
                            `in`
                        ].join(`|`)
                    },
                    {
                        scope: `variable`,
                        match: /[A-Za-z_][A-Za-z_0-9]*/
                    },
                    {
                        scope: `operator`,
                        match: /\+|\-|\*|\/|\%|\=\=|\=|\!|\>|\<|\&\&|\|\|/
                    }
                ]
            }, r = {
                match: [
                    t,
                    /(?=\()/
                ],
                scope: {
                    1: `keyword`
                },
                contains: [
                    n
                ]
            };
            return n.contains.unshift(r), {
                name: `Leaf`,
                contains: [
                    {
                        match: [
                            /#+/,
                            t,
                            /(?=\()/
                        ],
                        scope: {
                            1: `punctuation`,
                            2: `keyword`
                        },
                        starts: {
                            contains: [
                                {
                                    match: /\:/,
                                    scope: `punctuation`
                                }
                            ]
                        },
                        contains: [
                            n
                        ]
                    },
                    {
                        match: [
                            /#+/,
                            t,
                            /:?/
                        ],
                        scope: {
                            1: `punctuation`,
                            2: `keyword`,
                            3: `punctuation`
                        }
                    }
                ]
            };
        }
        t.exports = n;
    }), tt = o((e, t)=>{
        var n = (e)=>({
                IMPORTANT: {
                    scope: `meta`,
                    begin: `!important`
                },
                BLOCK_COMMENT: e.C_BLOCK_COMMENT_MODE,
                HEXCOLOR: {
                    scope: `number`,
                    begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/
                },
                FUNCTION_DISPATCH: {
                    className: `built_in`,
                    begin: /[\w-]+(?=\()/
                },
                ATTRIBUTE_SELECTOR_MODE: {
                    scope: `selector-attr`,
                    begin: /\[/,
                    end: /\]/,
                    illegal: `$`,
                    contains: [
                        e.APOS_STRING_MODE,
                        e.QUOTE_STRING_MODE
                    ]
                },
                CSS_NUMBER_MODE: {
                    scope: `number`,
                    begin: e.NUMBER_RE + `(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?`,
                    relevance: 0
                },
                CSS_VARIABLE: {
                    className: `attr`,
                    begin: /--[A-Za-z_][A-Za-z0-9_-]*/
                }
            }), r = `a.abbr.address.article.aside.audio.b.blockquote.body.button.canvas.caption.cite.code.dd.del.details.dfn.div.dl.dt.em.fieldset.figcaption.figure.footer.form.h1.h2.h3.h4.h5.h6.header.hgroup.html.i.iframe.img.input.ins.kbd.label.legend.li.main.mark.menu.nav.object.ol.optgroup.option.p.picture.q.quote.samp.section.select.source.span.strong.summary.sup.table.tbody.td.textarea.tfoot.th.thead.time.tr.ul.var.video`.split(`.`), i = `defs.g.marker.mask.pattern.svg.switch.symbol.feBlend.feColorMatrix.feComponentTransfer.feComposite.feConvolveMatrix.feDiffuseLighting.feDisplacementMap.feFlood.feGaussianBlur.feImage.feMerge.feMorphology.feOffset.feSpecularLighting.feTile.feTurbulence.linearGradient.radialGradient.stop.circle.ellipse.image.line.path.polygon.polyline.rect.text.use.textPath.tspan.foreignObject.clipPath`.split(`.`), a = [
            ...r,
            ...i
        ], o = `any-hover.any-pointer.aspect-ratio.color.color-gamut.color-index.device-aspect-ratio.device-height.device-width.display-mode.forced-colors.grid.height.hover.inverted-colors.monochrome.orientation.overflow-block.overflow-inline.pointer.prefers-color-scheme.prefers-contrast.prefers-reduced-motion.prefers-reduced-transparency.resolution.scan.scripting.update.width.min-width.max-width.min-height.max-height`.split(`.`).sort().reverse(), s = `active.any-link.blank.checked.current.default.defined.dir.disabled.drop.empty.enabled.first.first-child.first-of-type.fullscreen.future.focus.focus-visible.focus-within.has.host.host-context.hover.indeterminate.in-range.invalid.is.lang.last-child.last-of-type.left.link.local-link.not.nth-child.nth-col.nth-last-child.nth-last-col.nth-last-of-type.nth-of-type.only-child.only-of-type.optional.out-of-range.past.placeholder-shown.read-only.read-write.required.right.root.scope.target.target-within.user-invalid.valid.visited.where`.split(`.`).sort().reverse(), c = [
            `after`,
            `backdrop`,
            `before`,
            `cue`,
            `cue-region`,
            `first-letter`,
            `first-line`,
            `grammar-error`,
            `marker`,
            `part`,
            `placeholder`,
            `selection`,
            `slotted`,
            `spelling-error`
        ].sort().reverse(), l = `accent-color.align-content.align-items.align-self.alignment-baseline.all.anchor-name.animation.animation-composition.animation-delay.animation-direction.animation-duration.animation-fill-mode.animation-iteration-count.animation-name.animation-play-state.animation-range.animation-range-end.animation-range-start.animation-timeline.animation-timing-function.appearance.aspect-ratio.backdrop-filter.backface-visibility.background.background-attachment.background-blend-mode.background-clip.background-color.background-image.background-origin.background-position.background-position-x.background-position-y.background-repeat.background-size.baseline-shift.block-size.border.border-block.border-block-color.border-block-end.border-block-end-color.border-block-end-style.border-block-end-width.border-block-start.border-block-start-color.border-block-start-style.border-block-start-width.border-block-style.border-block-width.border-bottom.border-bottom-color.border-bottom-left-radius.border-bottom-right-radius.border-bottom-style.border-bottom-width.border-collapse.border-color.border-end-end-radius.border-end-start-radius.border-image.border-image-outset.border-image-repeat.border-image-slice.border-image-source.border-image-width.border-inline.border-inline-color.border-inline-end.border-inline-end-color.border-inline-end-style.border-inline-end-width.border-inline-start.border-inline-start-color.border-inline-start-style.border-inline-start-width.border-inline-style.border-inline-width.border-left.border-left-color.border-left-style.border-left-width.border-radius.border-right.border-right-color.border-right-style.border-right-width.border-spacing.border-start-end-radius.border-start-start-radius.border-style.border-top.border-top-color.border-top-left-radius.border-top-right-radius.border-top-style.border-top-width.border-width.bottom.box-align.box-decoration-break.box-direction.box-flex.box-flex-group.box-lines.box-ordinal-group.box-orient.box-pack.box-shadow.box-sizing.break-after.break-before.break-inside.caption-side.caret-color.clear.clip.clip-path.clip-rule.color.color-interpolation.color-interpolation-filters.color-profile.color-rendering.color-scheme.column-count.column-fill.column-gap.column-rule.column-rule-color.column-rule-style.column-rule-width.column-span.column-width.columns.contain.contain-intrinsic-block-size.contain-intrinsic-height.contain-intrinsic-inline-size.contain-intrinsic-size.contain-intrinsic-width.container.container-name.container-type.content.content-visibility.counter-increment.counter-reset.counter-set.cue.cue-after.cue-before.cursor.cx.cy.direction.display.dominant-baseline.empty-cells.enable-background.field-sizing.fill.fill-opacity.fill-rule.filter.flex.flex-basis.flex-direction.flex-flow.flex-grow.flex-shrink.flex-wrap.float.flood-color.flood-opacity.flow.font.font-display.font-family.font-feature-settings.font-kerning.font-language-override.font-optical-sizing.font-palette.font-size.font-size-adjust.font-smooth.font-smoothing.font-stretch.font-style.font-synthesis.font-synthesis-position.font-synthesis-small-caps.font-synthesis-style.font-synthesis-weight.font-variant.font-variant-alternates.font-variant-caps.font-variant-east-asian.font-variant-emoji.font-variant-ligatures.font-variant-numeric.font-variant-position.font-variation-settings.font-weight.forced-color-adjust.gap.glyph-orientation-horizontal.glyph-orientation-vertical.grid.grid-area.grid-auto-columns.grid-auto-flow.grid-auto-rows.grid-column.grid-column-end.grid-column-start.grid-gap.grid-row.grid-row-end.grid-row-start.grid-template.grid-template-areas.grid-template-columns.grid-template-rows.hanging-punctuation.height.hyphenate-character.hyphenate-limit-chars.hyphens.icon.image-orientation.image-rendering.image-resolution.ime-mode.initial-letter.initial-letter-align.inline-size.inset.inset-area.inset-block.inset-block-end.inset-block-start.inset-inline.inset-inline-end.inset-inline-start.isolation.justify-content.justify-items.justify-self.kerning.left.letter-spacing.lighting-color.line-break.line-height.line-height-step.list-style.list-style-image.list-style-position.list-style-type.margin.margin-block.margin-block-end.margin-block-start.margin-bottom.margin-inline.margin-inline-end.margin-inline-start.margin-left.margin-right.margin-top.margin-trim.marker.marker-end.marker-mid.marker-start.marks.mask.mask-border.mask-border-mode.mask-border-outset.mask-border-repeat.mask-border-slice.mask-border-source.mask-border-width.mask-clip.mask-composite.mask-image.mask-mode.mask-origin.mask-position.mask-repeat.mask-size.mask-type.masonry-auto-flow.math-depth.math-shift.math-style.max-block-size.max-height.max-inline-size.max-width.min-block-size.min-height.min-inline-size.min-width.mix-blend-mode.nav-down.nav-index.nav-left.nav-right.nav-up.none.normal.object-fit.object-position.offset.offset-anchor.offset-distance.offset-path.offset-position.offset-rotate.opacity.order.orphans.outline.outline-color.outline-offset.outline-style.outline-width.overflow.overflow-anchor.overflow-block.overflow-clip-margin.overflow-inline.overflow-wrap.overflow-x.overflow-y.overlay.overscroll-behavior.overscroll-behavior-block.overscroll-behavior-inline.overscroll-behavior-x.overscroll-behavior-y.padding.padding-block.padding-block-end.padding-block-start.padding-bottom.padding-inline.padding-inline-end.padding-inline-start.padding-left.padding-right.padding-top.page.page-break-after.page-break-before.page-break-inside.paint-order.pause.pause-after.pause-before.perspective.perspective-origin.place-content.place-items.place-self.pointer-events.position.position-anchor.position-visibility.print-color-adjust.quotes.r.resize.rest.rest-after.rest-before.right.rotate.row-gap.ruby-align.ruby-position.scale.scroll-behavior.scroll-margin.scroll-margin-block.scroll-margin-block-end.scroll-margin-block-start.scroll-margin-bottom.scroll-margin-inline.scroll-margin-inline-end.scroll-margin-inline-start.scroll-margin-left.scroll-margin-right.scroll-margin-top.scroll-padding.scroll-padding-block.scroll-padding-block-end.scroll-padding-block-start.scroll-padding-bottom.scroll-padding-inline.scroll-padding-inline-end.scroll-padding-inline-start.scroll-padding-left.scroll-padding-right.scroll-padding-top.scroll-snap-align.scroll-snap-stop.scroll-snap-type.scroll-timeline.scroll-timeline-axis.scroll-timeline-name.scrollbar-color.scrollbar-gutter.scrollbar-width.shape-image-threshold.shape-margin.shape-outside.shape-rendering.speak.speak-as.src.stop-color.stop-opacity.stroke.stroke-dasharray.stroke-dashoffset.stroke-linecap.stroke-linejoin.stroke-miterlimit.stroke-opacity.stroke-width.tab-size.table-layout.text-align.text-align-all.text-align-last.text-anchor.text-combine-upright.text-decoration.text-decoration-color.text-decoration-line.text-decoration-skip.text-decoration-skip-ink.text-decoration-style.text-decoration-thickness.text-emphasis.text-emphasis-color.text-emphasis-position.text-emphasis-style.text-indent.text-justify.text-orientation.text-overflow.text-rendering.text-shadow.text-size-adjust.text-transform.text-underline-offset.text-underline-position.text-wrap.text-wrap-mode.text-wrap-style.timeline-scope.top.touch-action.transform.transform-box.transform-origin.transform-style.transition.transition-behavior.transition-delay.transition-duration.transition-property.transition-timing-function.translate.unicode-bidi.user-modify.user-select.vector-effect.vertical-align.view-timeline.view-timeline-axis.view-timeline-inset.view-timeline-name.view-transition-name.visibility.voice-balance.voice-duration.voice-family.voice-pitch.voice-range.voice-rate.voice-stress.voice-volume.white-space.white-space-collapse.widows.width.will-change.word-break.word-spacing.word-wrap.writing-mode.x.y.z-index.zoom`.split(`.`).sort().reverse(), u = s.concat(c).sort().reverse();
        function d(e) {
            let t = n(e), r = u, i = `[\\w-]+`, d = `(` + i + `|@\\{[\\w-]+\\})`, f = [], p = [], m = function(e) {
                return {
                    className: `string`,
                    begin: `~?` + e + `.*?` + e
                };
            }, h = function(e, t, n) {
                return {
                    className: e,
                    begin: t,
                    relevance: n
                };
            }, g = {
                $pattern: /[a-z-]+/,
                keyword: `and or not only`,
                attribute: o.join(` `)
            }, _ = {
                begin: `\\(`,
                end: `\\)`,
                contains: p,
                keywords: g,
                relevance: 0
            };
            p.push(e.C_LINE_COMMENT_MODE, e.C_BLOCK_COMMENT_MODE, m(`'`), m(`"`), t.CSS_NUMBER_MODE, {
                begin: `(url|data-uri)\\(`,
                starts: {
                    className: `string`,
                    end: `[\\)\\n]`,
                    excludeEnd: !0
                }
            }, t.HEXCOLOR, _, h(`variable`, `@@?` + i, 10), h(`variable`, `@\\{` + i + `\\}`), h(`built_in`, "~?`[^`]*?`"), {
                className: `attribute`,
                begin: i + `\\s*:`,
                end: `:`,
                returnBegin: !0,
                excludeEnd: !0
            }, t.IMPORTANT, {
                beginKeywords: `and not`
            }, t.FUNCTION_DISPATCH);
            let v = p.concat({
                begin: /\{/,
                end: /\}/,
                contains: f
            }), y = {
                beginKeywords: `when`,
                endsWithParent: !0,
                contains: [
                    {
                        beginKeywords: `and not`
                    }
                ].concat(p)
            }, b = {
                begin: d + `\\s*:`,
                returnBegin: !0,
                end: /[;}]/,
                relevance: 0,
                contains: [
                    {
                        begin: /-(webkit|moz|ms|o)-/
                    },
                    t.CSS_VARIABLE,
                    {
                        className: `attribute`,
                        begin: `\\b(` + l.join(`|`) + `)\\b`,
                        end: /(?=:)/,
                        starts: {
                            endsWithParent: !0,
                            illegal: `[<=$]`,
                            relevance: 0,
                            contains: p
                        }
                    }
                ]
            }, x = {
                className: `keyword`,
                begin: `@(import|media|charset|font-face|(-[a-z]+-)?keyframes|supports|document|namespace|page|viewport|host)\\b`,
                starts: {
                    end: `[;{}]`,
                    keywords: g,
                    returnEnd: !0,
                    contains: p,
                    relevance: 0
                }
            }, S = {
                className: `variable`,
                variants: [
                    {
                        begin: `@` + i + `\\s*:`,
                        relevance: 15
                    },
                    {
                        begin: `@` + i
                    }
                ],
                starts: {
                    end: `[;}]`,
                    returnEnd: !0,
                    contains: v
                }
            }, C = {
                variants: [
                    {
                        begin: `[\\.#:&\\[>]`,
                        end: `[;{}]`
                    },
                    {
                        begin: d,
                        end: /\{/
                    }
                ],
                returnBegin: !0,
                returnEnd: !0,
                illegal: `[<='$"]`,
                relevance: 0,
                contains: [
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    y,
                    h(`keyword`, `all\\b`),
                    h(`variable`, `@\\{` + i + `\\}`),
                    {
                        begin: `\\b(` + a.join(`|`) + `)\\b`,
                        className: `selector-tag`
                    },
                    t.CSS_NUMBER_MODE,
                    h(`selector-tag`, d, 0),
                    h(`selector-id`, `#` + d),
                    h(`selector-class`, `\\.` + d, 0),
                    h(`selector-tag`, `&`, 0),
                    t.ATTRIBUTE_SELECTOR_MODE,
                    {
                        className: `selector-pseudo`,
                        begin: `:(` + s.join(`|`) + `)`
                    },
                    {
                        className: `selector-pseudo`,
                        begin: `:(:)?(` + c.join(`|`) + `)`
                    },
                    {
                        begin: /\(/,
                        end: /\)/,
                        relevance: 0,
                        contains: v
                    },
                    {
                        begin: `!important`
                    },
                    t.FUNCTION_DISPATCH
                ]
            }, w = {
                begin: `[\\w-]+:(:)?(${r.join(`|`)})`,
                returnBegin: !0,
                contains: [
                    C
                ]
            };
            return f.push(e.C_LINE_COMMENT_MODE, e.C_BLOCK_COMMENT_MODE, x, S, w, b, C, y, t.FUNCTION_DISPATCH), {
                name: `Less`,
                case_insensitive: !0,
                illegal: `[=>'/<($"]`,
                contains: f
            };
        }
        t.exports = d;
    }), nt = o((e, t)=>{
        function n(e) {
            let t = `[a-zA-Z_\\-+\\*\\/<=>&#][a-zA-Z0-9_\\-+*\\/<=>&#!]*`, n = `\\|[^]*?\\|`, r = `(-|\\+)?\\d+(\\.\\d+|\\/\\d+)?((d|e|f|l|s|D|E|F|L|S)(\\+|-)?\\d+)?`, i = {
                className: `literal`,
                begin: `\\b(t{1}|nil)\\b`
            }, a = {
                className: `number`,
                variants: [
                    {
                        begin: r,
                        relevance: 0
                    },
                    {
                        begin: `#(b|B)[0-1]+(/[0-1]+)?`
                    },
                    {
                        begin: `#(o|O)[0-7]+(/[0-7]+)?`
                    },
                    {
                        begin: `#(x|X)[0-9a-fA-F]+(/[0-9a-fA-F]+)?`
                    },
                    {
                        begin: `#(c|C)\\(` + r + ` +(-|\\+)?\\d+(\\.\\d+|\\/\\d+)?((d|e|f|l|s|D|E|F|L|S)(\\+|-)?\\d+)?`,
                        end: `\\)`
                    }
                ]
            }, o = e.inherit(e.QUOTE_STRING_MODE, {
                illegal: null
            }), s = e.COMMENT(`;`, `$`, {
                relevance: 0
            }), c = {
                begin: `\\*`,
                end: `\\*`
            }, l = {
                className: `symbol`,
                begin: `[:&]` + t
            }, u = {
                begin: t,
                relevance: 0
            }, d = {
                begin: n
            }, f = {
                contains: [
                    a,
                    o,
                    c,
                    l,
                    {
                        begin: `\\(`,
                        end: `\\)`,
                        contains: [
                            `self`,
                            i,
                            o,
                            a,
                            u
                        ]
                    },
                    u
                ],
                variants: [
                    {
                        begin: "['`]\\(",
                        end: `\\)`
                    },
                    {
                        begin: `\\(quote `,
                        end: `\\)`,
                        keywords: {
                            name: `quote`
                        }
                    },
                    {
                        begin: `'` + n
                    }
                ]
            }, p = {
                variants: [
                    {
                        begin: `'` + t
                    },
                    {
                        begin: `#'` + t + `(::[a-zA-Z_\\-+\\*\\/<=>&#][a-zA-Z0-9_\\-+*\\/<=>&#!]*)*`
                    }
                ]
            }, m = {
                begin: `\\(\\s*`,
                end: `\\)`
            }, h = {
                endsWithParent: !0,
                relevance: 0
            };
            return m.contains = [
                {
                    className: `name`,
                    variants: [
                        {
                            begin: t,
                            relevance: 0
                        },
                        {
                            begin: n
                        }
                    ]
                },
                h
            ], h.contains = [
                f,
                p,
                m,
                i,
                a,
                o,
                s,
                c,
                l,
                d,
                u
            ], {
                name: `Lisp`,
                illegal: /\S/,
                contains: [
                    a,
                    e.SHEBANG(),
                    i,
                    o,
                    s,
                    f,
                    p,
                    m,
                    u
                ]
            };
        }
        t.exports = n;
    }), rt = o((e, t)=>{
        function n(e) {
            let t = {
                className: `variable`,
                variants: [
                    {
                        begin: `\\b([gtps][A-Z]{1}[a-zA-Z0-9]*)(\\[.+\\])?(?:\\s*?)`
                    },
                    {
                        begin: `\\$_[A-Z]+`
                    }
                ],
                relevance: 0
            }, n = [
                e.C_BLOCK_COMMENT_MODE,
                e.HASH_COMMENT_MODE,
                e.COMMENT(`--`, `$`),
                e.COMMENT(`[^:]//`, `$`)
            ], r = e.inherit(e.TITLE_MODE, {
                variants: [
                    {
                        begin: `\\b_*rig[A-Z][A-Za-z0-9_\\-]*`
                    },
                    {
                        begin: `\\b_[a-z0-9\\-]+`
                    }
                ]
            }), i = e.inherit(e.TITLE_MODE, {
                begin: `\\b([A-Za-z0-9_\\-]+)\\b`
            });
            return {
                name: `LiveCode`,
                case_insensitive: !1,
                keywords: {
                    keyword: `$_COOKIE $_FILES $_GET $_GET_BINARY $_GET_RAW $_POST $_POST_BINARY $_POST_RAW $_SESSION $_SERVER codepoint codepoints segment segments codeunit codeunits sentence sentences trueWord trueWords paragraph after byte bytes english the until http forever descending using line real8 with seventh for stdout finally element word words fourth before black ninth sixth characters chars stderr uInt1 uInt1s uInt2 uInt2s stdin string lines relative rel any fifth items from middle mid at else of catch then third it file milliseconds seconds second secs sec int1 int1s int4 int4s internet int2 int2s normal text item last long detailed effective uInt4 uInt4s repeat end repeat URL in try into switch to words https token binfile each tenth as ticks tick system real4 by dateItems without char character ascending eighth whole dateTime numeric short first ftp integer abbreviated abbr abbrev private case while if div mod wrap and or bitAnd bitNot bitOr bitXor among not in a an within contains ends with begins the keys of keys`,
                    literal: `SIX TEN FORMFEED NINE ZERO NONE SPACE FOUR FALSE COLON CRLF PI COMMA ENDOFFILE EOF EIGHT FIVE QUOTE EMPTY ONE TRUE RETURN CR LINEFEED RIGHT BACKSLASH NULL SEVEN TAB THREE TWO six ten formfeed nine zero none space four false colon crlf pi comma endoffile eof eight five quote empty one true return cr linefeed right backslash null seven tab three two RIVERSION RISTATE FILE_READ_MODE FILE_WRITE_MODE FILE_WRITE_MODE DIR_WRITE_MODE FILE_READ_UMASK FILE_WRITE_UMASK DIR_READ_UMASK DIR_WRITE_UMASK`,
                    built_in: `put abs acos aliasReference annuity arrayDecode arrayEncode asin atan atan2 average avg avgDev base64Decode base64Encode baseConvert binaryDecode binaryEncode byteOffset byteToNum cachedURL cachedURLs charToNum cipherNames codepointOffset codepointProperty codepointToNum codeunitOffset commandNames compound compress constantNames cos date dateFormat decompress difference directories diskSpace DNSServers exp exp1 exp2 exp10 extents files flushEvents folders format functionNames geometricMean global globals hasMemory harmonicMean hostAddress hostAddressToName hostName hostNameToAddress isNumber ISOToMac itemOffset keys len length libURLErrorData libUrlFormData libURLftpCommand libURLLastHTTPHeaders libURLLastRHHeaders libUrlMultipartFormAddPart libUrlMultipartFormData libURLVersion lineOffset ln ln1 localNames log log2 log10 longFilePath lower macToISO matchChunk matchText matrixMultiply max md5Digest median merge messageAuthenticationCode messageDigest millisec millisecs millisecond milliseconds min monthNames nativeCharToNum normalizeText num number numToByte numToChar numToCodepoint numToNativeChar offset open openfiles openProcesses openProcessIDs openSockets paragraphOffset paramCount param params peerAddress pendingMessages platform popStdDev populationStandardDeviation populationVariance popVariance processID random randomBytes replaceText result revCreateXMLTree revCreateXMLTreeFromFile revCurrentRecord revCurrentRecordIsFirst revCurrentRecordIsLast revDatabaseColumnCount revDatabaseColumnIsNull revDatabaseColumnLengths revDatabaseColumnNames revDatabaseColumnNamed revDatabaseColumnNumbered revDatabaseColumnTypes revDatabaseConnectResult revDatabaseCursors revDatabaseID revDatabaseTableNames revDatabaseType revDataFromQuery revdb_closeCursor revdb_columnbynumber revdb_columncount revdb_columnisnull revdb_columnlengths revdb_columnnames revdb_columntypes revdb_commit revdb_connect revdb_connections revdb_connectionerr revdb_currentrecord revdb_cursorconnection revdb_cursorerr revdb_cursors revdb_dbtype revdb_disconnect revdb_execute revdb_iseof revdb_isbof revdb_movefirst revdb_movelast revdb_movenext revdb_moveprev revdb_query revdb_querylist revdb_recordcount revdb_rollback revdb_tablenames revGetDatabaseDriverPath revNumberOfRecords revOpenDatabase revOpenDatabases revQueryDatabase revQueryDatabaseBlob revQueryResult revQueryIsAtStart revQueryIsAtEnd revUnixFromMacPath revXMLAttribute revXMLAttributes revXMLAttributeValues revXMLChildContents revXMLChildNames revXMLCreateTreeFromFileWithNamespaces revXMLCreateTreeWithNamespaces revXMLDataFromXPathQuery revXMLEvaluateXPath revXMLFirstChild revXMLMatchingNode revXMLNextSibling revXMLNodeContents revXMLNumberOfChildren revXMLParent revXMLPreviousSibling revXMLRootNode revXMLRPC_CreateRequest revXMLRPC_Documents revXMLRPC_Error revXMLRPC_GetHost revXMLRPC_GetMethod revXMLRPC_GetParam revXMLText revXMLRPC_Execute revXMLRPC_GetParamCount revXMLRPC_GetParamNode revXMLRPC_GetParamType revXMLRPC_GetPath revXMLRPC_GetPort revXMLRPC_GetProtocol revXMLRPC_GetRequest revXMLRPC_GetResponse revXMLRPC_GetSocket revXMLTree revXMLTrees revXMLValidateDTD revZipDescribeItem revZipEnumerateItems revZipOpenArchives round sampVariance sec secs seconds sentenceOffset sha1Digest shell shortFilePath sin specialFolderPath sqrt standardDeviation statRound stdDev sum sysError systemVersion tan tempName textDecode textEncode tick ticks time to tokenOffset toLower toUpper transpose truewordOffset trunc uniDecode uniEncode upper URLDecode URLEncode URLStatus uuid value variableNames variance version waitDepth weekdayNames wordOffset xsltApplyStylesheet xsltApplyStylesheetFromFile xsltLoadStylesheet xsltLoadStylesheetFromFile add breakpoint cancel clear local variable file word line folder directory URL close socket process combine constant convert create new alias folder directory decrypt delete variable word line folder directory URL dispatch divide do encrypt filter get include intersect kill libURLDownloadToFile libURLFollowHttpRedirects libURLftpUpload libURLftpUploadFile libURLresetAll libUrlSetAuthCallback libURLSetDriver libURLSetCustomHTTPHeaders libUrlSetExpect100 libURLSetFTPListCommand libURLSetFTPMode libURLSetFTPStopTime libURLSetStatusCallback load extension loadedExtensions multiply socket prepare process post seek rel relative read from process rename replace require resetAll resolve revAddXMLNode revAppendXML revCloseCursor revCloseDatabase revCommitDatabase revCopyFile revCopyFolder revCopyXMLNode revDeleteFolder revDeleteXMLNode revDeleteAllXMLTrees revDeleteXMLTree revExecuteSQL revGoURL revInsertXMLNode revMoveFolder revMoveToFirstRecord revMoveToLastRecord revMoveToNextRecord revMoveToPreviousRecord revMoveToRecord revMoveXMLNode revPutIntoXMLNode revRollBackDatabase revSetDatabaseDriverPath revSetXMLAttribute revXMLRPC_AddParam revXMLRPC_DeleteAllDocuments revXMLAddDTD revXMLRPC_Free revXMLRPC_FreeAll revXMLRPC_DeleteDocument revXMLRPC_DeleteParam revXMLRPC_SetHost revXMLRPC_SetMethod revXMLRPC_SetPort revXMLRPC_SetProtocol revXMLRPC_SetSocket revZipAddItemWithData revZipAddItemWithFile revZipAddUncompressedItemWithData revZipAddUncompressedItemWithFile revZipCancel revZipCloseArchive revZipDeleteItem revZipExtractItemToFile revZipExtractItemToVariable revZipSetProgressCallback revZipRenameItem revZipReplaceItemWithData revZipReplaceItemWithFile revZipOpenArchive send set sort split start stop subtract symmetric union unload vectorDotProduct wait write`
                },
                contains: [
                    t,
                    {
                        className: `keyword`,
                        begin: `\\bend\\sif\\b`
                    },
                    {
                        className: `function`,
                        beginKeywords: `function`,
                        end: `$`,
                        contains: [
                            t,
                            i,
                            e.APOS_STRING_MODE,
                            e.QUOTE_STRING_MODE,
                            e.BINARY_NUMBER_MODE,
                            e.C_NUMBER_MODE,
                            r
                        ]
                    },
                    {
                        className: `function`,
                        begin: `\\bend\\s+`,
                        end: `$`,
                        keywords: `end`,
                        contains: [
                            i,
                            r
                        ],
                        relevance: 0
                    },
                    {
                        beginKeywords: `command on`,
                        end: `$`,
                        contains: [
                            t,
                            i,
                            e.APOS_STRING_MODE,
                            e.QUOTE_STRING_MODE,
                            e.BINARY_NUMBER_MODE,
                            e.C_NUMBER_MODE,
                            r
                        ]
                    },
                    {
                        className: `meta`,
                        variants: [
                            {
                                begin: `<\\?(rev|lc|livecode)`,
                                relevance: 10
                            },
                            {
                                begin: `<\\?`
                            },
                            {
                                begin: `\\?>`
                            }
                        ]
                    },
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE,
                    e.BINARY_NUMBER_MODE,
                    e.C_NUMBER_MODE,
                    r
                ].concat(n),
                illegal: `;$|^\\[|^=|&|\\{`
            };
        }
        t.exports = n;
    }), it = o((e, t)=>{
        var n = `as.in.of.if.for.while.finally.var.new.function.do.return.void.else.break.catch.instanceof.with.throw.case.default.try.switch.continue.typeof.delete.let.yield.const.class.debugger.async.await.static.import.from.export.extends.using`.split(`.`), r = [
            `true`,
            `false`,
            `null`,
            `undefined`,
            `NaN`,
            `Infinity`
        ], i = [
            `setInterval`,
            `setTimeout`,
            `clearInterval`,
            `clearTimeout`,
            `require`,
            `exports`,
            `eval`,
            `isFinite`,
            `isNaN`,
            `parseFloat`,
            `parseInt`,
            `decodeURI`,
            `decodeURIComponent`,
            `encodeURI`,
            `encodeURIComponent`,
            `escape`,
            `unescape`
        ].concat(`Object.Function.Boolean.Symbol.Math.Date.Number.BigInt.String.RegExp.Array.Float32Array.Float64Array.Int8Array.Uint8Array.Uint8ClampedArray.Int16Array.Int32Array.Uint16Array.Uint32Array.BigInt64Array.BigUint64Array.Set.Map.WeakSet.WeakMap.ArrayBuffer.SharedArrayBuffer.Atomics.DataView.JSON.Promise.Generator.GeneratorFunction.AsyncFunction.Reflect.Proxy.Intl.WebAssembly`.split(`.`), [
            `Error`,
            `EvalError`,
            `InternalError`,
            `RangeError`,
            `ReferenceError`,
            `SyntaxError`,
            `TypeError`,
            `URIError`
        ]);
        function a(e) {
            let t = {
                keyword: n.concat(`then.unless.until.loop.of.by.when.and.or.is.isnt.not.it.that.otherwise.from.to.til.fallthrough.case.enum.native.list.map.__hasProp.__extends.__slice.__bind.__indexOf`.split(`.`)),
                literal: r.concat([
                    `yes`,
                    `no`,
                    `on`,
                    `off`,
                    `it`,
                    `that`,
                    `void`
                ]),
                built_in: i.concat([
                    `npm`,
                    `print`
                ])
            }, a = `[A-Za-z$_](?:-[0-9A-Za-z$_]|[0-9A-Za-z$_])*`, o = e.inherit(e.TITLE_MODE, {
                begin: a
            }), s = {
                className: `subst`,
                begin: /#\{/,
                end: /\}/,
                keywords: t
            }, c = {
                className: `subst`,
                begin: /#[A-Za-z$_]/,
                end: /(?:-[0-9A-Za-z$_]|[0-9A-Za-z$_])*/,
                keywords: t
            }, l = [
                e.BINARY_NUMBER_MODE,
                {
                    className: `number`,
                    begin: `(\\b0[xX][a-fA-F0-9_]+)|(\\b\\d(\\d|_\\d)*(\\.(\\d(\\d|_\\d)*)?)?(_*[eE]([-+]\\d(_\\d|\\d)*)?)?[_a-z]*)`,
                    relevance: 0,
                    starts: {
                        end: `(\\s*/)?`,
                        relevance: 0
                    }
                },
                {
                    className: `string`,
                    variants: [
                        {
                            begin: /'''/,
                            end: /'''/,
                            contains: [
                                e.BACKSLASH_ESCAPE
                            ]
                        },
                        {
                            begin: /'/,
                            end: /'/,
                            contains: [
                                e.BACKSLASH_ESCAPE
                            ]
                        },
                        {
                            begin: /"""/,
                            end: /"""/,
                            contains: [
                                e.BACKSLASH_ESCAPE,
                                s,
                                c
                            ]
                        },
                        {
                            begin: /"/,
                            end: /"/,
                            contains: [
                                e.BACKSLASH_ESCAPE,
                                s,
                                c
                            ]
                        },
                        {
                            begin: /\\/,
                            end: /(\s|$)/,
                            excludeEnd: !0
                        }
                    ]
                },
                {
                    className: `regexp`,
                    variants: [
                        {
                            begin: `//`,
                            end: `//[gim]*`,
                            contains: [
                                s,
                                e.HASH_COMMENT_MODE
                            ]
                        },
                        {
                            begin: /\/(?![ *])(\\.|[^\\\n])*?\/[gim]*(?=\W)/
                        }
                    ]
                },
                {
                    begin: `@` + a
                },
                {
                    begin: "``",
                    end: "``",
                    excludeBegin: !0,
                    excludeEnd: !0,
                    subLanguage: `javascript`
                }
            ];
            s.contains = l;
            let u = {
                className: `params`,
                begin: `\\(`,
                returnBegin: !0,
                contains: [
                    {
                        begin: /\(/,
                        end: /\)/,
                        keywords: t,
                        contains: [
                            `self`
                        ].concat(l)
                    }
                ]
            }, d = {
                begin: `(#=>|=>|\\|>>|-?->|!->)`
            }, f = {
                variants: [
                    {
                        match: [
                            /class\s+/,
                            a,
                            /\s+extends\s+/,
                            a
                        ]
                    },
                    {
                        match: [
                            /class\s+/,
                            a
                        ]
                    }
                ],
                scope: {
                    2: `title.class`,
                    4: `title.class.inherited`
                },
                keywords: t
            };
            return {
                name: `LiveScript`,
                aliases: [
                    `ls`
                ],
                keywords: t,
                illegal: /\/\*/,
                contains: l.concat([
                    e.COMMENT(`\\/\\*`, `\\*\\/`),
                    e.HASH_COMMENT_MODE,
                    d,
                    {
                        className: `function`,
                        contains: [
                            o,
                            u
                        ],
                        returnBegin: !0,
                        variants: [
                            {
                                begin: `(` + a + `\\s*(?:=|:=)\\s*)?(\\(.*\\)\\s*)?\\B->\\*?`,
                                end: `->\\*?`
                            },
                            {
                                begin: `(` + a + `\\s*(?:=|:=)\\s*)?!?(\\(.*\\)\\s*)?\\B[-~]{1,2}>\\*?`,
                                end: `[-~]{1,2}>\\*?`
                            },
                            {
                                begin: `(` + a + `\\s*(?:=|:=)\\s*)?(\\(.*\\)\\s*)?\\B!?[-~]{1,2}>\\*?`,
                                end: `!?[-~]{1,2}>\\*?`
                            }
                        ]
                    },
                    f,
                    {
                        begin: a + `:`,
                        end: `:`,
                        returnBegin: !0,
                        returnEnd: !0,
                        relevance: 0
                    }
                ])
            };
        }
        t.exports = a;
    }), at = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = /([-a-zA-Z$._][\w$.-]*)/, r = {
                className: `type`,
                begin: /\bi\d+(?=\s|\b)/
            }, i = {
                className: `operator`,
                relevance: 0,
                begin: /=/
            }, a = {
                className: `punctuation`,
                relevance: 0,
                begin: /,/
            }, o = {
                className: `number`,
                variants: [
                    {
                        begin: /[su]?0[xX][KMLHR]?[a-fA-F0-9]+/
                    },
                    {
                        begin: /[-+]?\d+(?:[.]\d+)?(?:[eE][-+]?\d+(?:[.]\d+)?)?/
                    }
                ],
                relevance: 0
            }, s = {
                className: `symbol`,
                variants: [
                    {
                        begin: /^\s*[a-z]+:/
                    }
                ],
                relevance: 0
            }, c = {
                className: `variable`,
                variants: [
                    {
                        begin: t.concat(/%/, n)
                    },
                    {
                        begin: /%\d+/
                    },
                    {
                        begin: /#\d+/
                    }
                ]
            }, l = {
                className: `title`,
                variants: [
                    {
                        begin: t.concat(/@/, n)
                    },
                    {
                        begin: /@\d+/
                    },
                    {
                        begin: t.concat(/!/, n)
                    },
                    {
                        begin: t.concat(/!\d+/, n)
                    },
                    {
                        begin: /!\d+/
                    }
                ]
            };
            return {
                name: `LLVM IR`,
                keywords: {
                    keyword: `begin end true false declare define global constant private linker_private internal available_externally linkonce linkonce_odr weak weak_odr appending dllimport dllexport common default hidden protected extern_weak external thread_local zeroinitializer undef null to tail target triple datalayout volatile nuw nsw nnan ninf nsz arcp fast exact inbounds align addrspace section alias module asm sideeffect gc dbg linker_private_weak attributes blockaddress initialexec localdynamic localexec prefix unnamed_addr ccc fastcc coldcc x86_stdcallcc x86_fastcallcc arm_apcscc arm_aapcscc arm_aapcs_vfpcc ptx_device ptx_kernel intel_ocl_bicc msp430_intrcc spir_func spir_kernel x86_64_sysvcc x86_64_win64cc x86_thiscallcc cc c signext zeroext inreg sret nounwind noreturn noalias nocapture byval nest readnone readonly inlinehint noinline alwaysinline optsize ssp sspreq noredzone noimplicitfloat naked builtin cold nobuiltin noduplicate nonlazybind optnone returns_twice sanitize_address sanitize_memory sanitize_thread sspstrong uwtable returned type opaque eq ne slt sgt sle sge ult ugt ule uge oeq one olt ogt ole oge ord uno ueq une x acq_rel acquire alignstack atomic catch cleanup filter inteldialect max min monotonic nand personality release seq_cst singlethread umax umin unordered xchg add fadd sub fsub mul fmul udiv sdiv fdiv urem srem frem shl lshr ashr and or xor icmp fcmp phi call trunc zext sext fptrunc fpext uitofp sitofp fptoui fptosi inttoptr ptrtoint bitcast addrspacecast select va_arg ret br switch invoke unwind unreachable indirectbr landingpad resume malloc alloca free load store getelementptr extractelement insertelement shufflevector getresult extractvalue insertvalue atomicrmw cmpxchg fence argmemonly`,
                    type: `void half bfloat float double fp128 x86_fp80 ppc_fp128 x86_amx x86_mmx ptr label token metadata opaque`
                },
                contains: [
                    r,
                    e.COMMENT(/;\s*$/, null, {
                        relevance: 0
                    }),
                    e.COMMENT(/;/, /$/),
                    {
                        className: `string`,
                        begin: /"/,
                        end: /"/,
                        contains: [
                            {
                                className: `char.escape`,
                                match: /\\\d\d/
                            }
                        ]
                    },
                    l,
                    a,
                    i,
                    c,
                    s,
                    o
                ]
            };
        }
        t.exports = n;
    }), ot = o((e, t)=>{
        function n(e) {
            let t = {
                className: `string`,
                begin: `"`,
                end: `"`,
                contains: [
                    {
                        className: `subst`,
                        begin: /\\[tn"\\]/
                    }
                ]
            }, n = {
                className: `number`,
                relevance: 0,
                begin: e.C_NUMBER_RE
            };
            return {
                name: `LSL (Linden Scripting Language)`,
                illegal: `:`,
                contains: [
                    t,
                    {
                        className: `comment`,
                        variants: [
                            e.COMMENT(`//`, `$`),
                            e.COMMENT(`/\\*`, `\\*/`)
                        ],
                        relevance: 0
                    },
                    n,
                    {
                        className: `section`,
                        variants: [
                            {
                                begin: `\\b(state|default)\\b`
                            },
                            {
                                begin: `\\b(state_(entry|exit)|touch(_(start|end))?|(land_)?collision(_(start|end))?|timer|listen|(no_)?sensor|control|(not_)?at_(rot_)?target|money|email|experience_permissions(_denied)?|run_time_permissions|changed|attach|dataserver|moving_(start|end)|link_message|(on|object)_rez|remote_data|http_re(sponse|quest)|path_update|transaction_result)\\b`
                            }
                        ]
                    },
                    {
                        className: `built_in`,
                        begin: `\\b(ll(AgentInExperience|(Create|DataSize|Delete|KeyCount|Keys|Read|Update)KeyValue|GetExperience(Details|ErrorMessage)|ReturnObjectsBy(ID|Owner)|Json(2List|[GS]etValue|ValueType)|Sin|Cos|Tan|Atan2|Sqrt|Pow|Abs|Fabs|Frand|Floor|Ceil|Round|Vec(Mag|Norm|Dist)|Rot(Between|2(Euler|Fwd|Left|Up))|(Euler|Axes)2Rot|Whisper|(Region|Owner)?Say|Shout|Listen(Control|Remove)?|Sensor(Repeat|Remove)?|Detected(Name|Key|Owner|Type|Pos|Vel|Grab|Rot|Group|LinkNumber)|Die|Ground|Wind|([GS]et)(AnimationOverride|MemoryLimit|PrimMediaParams|ParcelMusicURL|Object(Desc|Name)|PhysicsMaterial|Status|Scale|Color|Alpha|Texture|Pos|Rot|Force|Torque)|ResetAnimationOverride|(Scale|Offset|Rotate)Texture|(Rot)?Target(Remove)?|(Stop)?MoveToTarget|Apply(Rotational)?Impulse|Set(KeyframedMotion|ContentType|RegionPos|(Angular)?Velocity|Buoyancy|HoverHeight|ForceAndTorque|TimerEvent|ScriptState|Damage|TextureAnim|Sound(Queueing|Radius)|Vehicle(Type|(Float|Vector|Rotation)Param)|(Touch|Sit)?Text|Camera(Eye|At)Offset|PrimitiveParams|ClickAction|Link(Alpha|Color|PrimitiveParams(Fast)?|Texture(Anim)?|Camera|Media)|RemoteScriptAccessPin|PayPrice|LocalRot)|ScaleByFactor|Get((Max|Min)ScaleFactor|ClosestNavPoint|StaticPath|SimStats|Env|PrimitiveParams|Link(PrimitiveParams|Number(OfSides)?|Key|Name|Media)|HTTPHeader|FreeURLs|Object(Details|PermMask|PrimCount)|Parcel(MaxPrims|Details|Prim(Count|Owners))|Attached(List)?|(SPMax|Free|Used)Memory|Region(Name|TimeDilation|FPS|Corner|AgentCount)|Root(Position|Rotation)|UnixTime|(Parcel|Region)Flags|(Wall|GMT)clock|SimulatorHostname|BoundingBox|GeometricCenter|Creator|NumberOf(Prims|NotecardLines|Sides)|Animation(List)?|(Camera|Local)(Pos|Rot)|Vel|Accel|Omega|Time(stamp|OfDay)|(Object|CenterOf)?Mass|MassMKS|Energy|Owner|(Owner)?Key|SunDirection|Texture(Offset|Scale|Rot)|Inventory(Number|Name|Key|Type|Creator|PermMask)|Permissions(Key)?|StartParameter|List(Length|EntryType)|Date|Agent(Size|Info|Language|List)|LandOwnerAt|NotecardLine|Script(Name|State))|(Get|Reset|GetAndReset)Time|PlaySound(Slave)?|LoopSound(Master|Slave)?|(Trigger|Stop|Preload)Sound|((Get|Delete)Sub|Insert)String|To(Upper|Lower)|Give(InventoryList|Money)|RezObject|(Stop)?LookAt|Sleep|CollisionFilter|(Take|Release)Controls|DetachFromAvatar|AttachToAvatar(Temp)?|InstantMessage|(GetNext)?Email|StopHover|MinEventDelay|RotLookAt|String(Length|Trim)|(Start|Stop)Animation|TargetOmega|Request(Experience)?Permissions|(Create|Break)Link|BreakAllLinks|(Give|Remove)Inventory|Water|PassTouches|Request(Agent|Inventory)Data|TeleportAgent(Home|GlobalCoords)?|ModifyLand|CollisionSound|ResetScript|MessageLinked|PushObject|PassCollisions|AxisAngle2Rot|Rot2(Axis|Angle)|A(cos|sin)|AngleBetween|AllowInventoryDrop|SubStringIndex|List2(CSV|Integer|Json|Float|String|Key|Vector|Rot|List(Strided)?)|DeleteSubList|List(Statistics|Sort|Randomize|(Insert|Find|Replace)List)|EdgeOfWorld|AdjustSoundVolume|Key2Name|TriggerSoundLimited|EjectFromLand|(CSV|ParseString)2List|OverMyLand|SameGroup|UnSit|Ground(Slope|Normal|Contour)|GroundRepel|(Set|Remove)VehicleFlags|SitOnLink|(AvatarOn)?(Link)?SitTarget|Script(Danger|Profiler)|Dialog|VolumeDetect|ResetOtherScript|RemoteLoadScriptPin|(Open|Close)RemoteDataChannel|SendRemoteData|RemoteDataReply|(Integer|String)ToBase64|XorBase64|Log(10)?|Base64To(String|Integer)|ParseStringKeepNulls|RezAtRoot|RequestSimulatorData|ForceMouselook|(Load|Release|(E|Une)scape)URL|ParcelMedia(CommandList|Query)|ModPow|MapDestination|(RemoveFrom|AddTo|Reset)Land(Pass|Ban)List|(Set|Clear)CameraParams|HTTP(Request|Response)|TextBox|DetectedTouch(UV|Face|Pos|(N|Bin)ormal|ST)|(MD5|SHA1|DumpList2)String|Request(Secure)?URL|Clear(Prim|Link)Media|(Link)?ParticleSystem|(Get|Request)(Username|DisplayName)|RegionSayTo|CastRay|GenerateKey|TransferLindenDollars|ManageEstateAccess|(Create|Delete)Character|ExecCharacterCmd|Evade|FleeFrom|NavigateTo|PatrolPoints|Pursue|UpdateCharacter|WanderWithin))\\b`
                    },
                    {
                        className: `literal`,
                        variants: [
                            {
                                begin: `\\b(PI|TWO_PI|PI_BY_TWO|DEG_TO_RAD|RAD_TO_DEG|SQRT2)\\b`
                            },
                            {
                                begin: `\\b(XP_ERROR_(EXPERIENCES_DISABLED|EXPERIENCE_(DISABLED|SUSPENDED)|INVALID_(EXPERIENCE|PARAMETERS)|KEY_NOT_FOUND|MATURITY_EXCEEDED|NONE|NOT_(FOUND|PERMITTED(_LAND)?)|NO_EXPERIENCE|QUOTA_EXCEEDED|RETRY_UPDATE|STORAGE_EXCEPTION|STORE_DISABLED|THROTTLED|UNKNOWN_ERROR)|JSON_APPEND|STATUS_(PHYSICS|ROTATE_[XYZ]|PHANTOM|SANDBOX|BLOCK_GRAB(_OBJECT)?|(DIE|RETURN)_AT_EDGE|CAST_SHADOWS|OK|MALFORMED_PARAMS|TYPE_MISMATCH|BOUNDS_ERROR|NOT_(FOUND|SUPPORTED)|INTERNAL_ERROR|WHITELIST_FAILED)|AGENT(_(BY_(LEGACY_|USER)NAME|FLYING|ATTACHMENTS|SCRIPTED|MOUSELOOK|SITTING|ON_OBJECT|AWAY|WALKING|IN_AIR|TYPING|CROUCHING|BUSY|ALWAYS_RUN|AUTOPILOT|LIST_(PARCEL(_OWNER)?|REGION)))?|CAMERA_(PITCH|DISTANCE|BEHINDNESS_(ANGLE|LAG)|(FOCUS|POSITION)(_(THRESHOLD|LOCKED|LAG))?|FOCUS_OFFSET|ACTIVE)|ANIM_ON|LOOP|REVERSE|PING_PONG|SMOOTH|ROTATE|SCALE|ALL_SIDES|LINK_(ROOT|SET|ALL_(OTHERS|CHILDREN)|THIS)|ACTIVE|PASS(IVE|_(ALWAYS|IF_NOT_HANDLED|NEVER))|SCRIPTED|CONTROL_(FWD|BACK|(ROT_)?(LEFT|RIGHT)|UP|DOWN|(ML_)?LBUTTON)|PERMISSION_(RETURN_OBJECTS|DEBIT|OVERRIDE_ANIMATIONS|SILENT_ESTATE_MANAGEMENT|TAKE_CONTROLS|TRIGGER_ANIMATION|ATTACH|CHANGE_LINKS|(CONTROL|TRACK)_CAMERA|TELEPORT)|INVENTORY_(TEXTURE|SOUND|OBJECT|SCRIPT|LANDMARK|CLOTHING|NOTECARD|BODYPART|ANIMATION|GESTURE|ALL|NONE)|CHANGED_(INVENTORY|COLOR|SHAPE|SCALE|TEXTURE|LINK|ALLOWED_DROP|OWNER|REGION(_START)?|TELEPORT|MEDIA)|OBJECT_(CLICK_ACTION|HOVER_HEIGHT|LAST_OWNER_ID|(PHYSICS|SERVER|STREAMING)_COST|UNKNOWN_DETAIL|CHARACTER_TIME|PHANTOM|PHYSICS|TEMP_(ATTACHED|ON_REZ)|NAME|DESC|POS|PRIM_(COUNT|EQUIVALENCE)|RETURN_(PARCEL(_OWNER)?|REGION)|REZZER_KEY|ROO?T|VELOCITY|OMEGA|OWNER|GROUP(_TAG)?|CREATOR|ATTACHED_(POINT|SLOTS_AVAILABLE)|RENDER_WEIGHT|(BODY_SHAPE|PATHFINDING)_TYPE|(RUNNING|TOTAL)_SCRIPT_COUNT|TOTAL_INVENTORY_COUNT|SCRIPT_(MEMORY|TIME))|TYPE_(INTEGER|FLOAT|STRING|KEY|VECTOR|ROTATION|INVALID)|(DEBUG|PUBLIC)_CHANNEL|ATTACH_(AVATAR_CENTER|CHEST|HEAD|BACK|PELVIS|MOUTH|CHIN|NECK|NOSE|BELLY|[LR](SHOULDER|HAND|FOOT|EAR|EYE|[UL](ARM|LEG)|HIP)|(LEFT|RIGHT)_PEC|HUD_(CENTER_[12]|TOP_(RIGHT|CENTER|LEFT)|BOTTOM(_(RIGHT|LEFT))?)|[LR]HAND_RING1|TAIL_(BASE|TIP)|[LR]WING|FACE_(JAW|[LR]EAR|[LR]EYE|TOUNGE)|GROIN|HIND_[LR]FOOT)|LAND_(LEVEL|RAISE|LOWER|SMOOTH|NOISE|REVERT)|DATA_(ONLINE|NAME|BORN|SIM_(POS|STATUS|RATING)|PAYINFO)|PAYMENT_INFO_(ON_FILE|USED)|REMOTE_DATA_(CHANNEL|REQUEST|REPLY)|PSYS_(PART_(BF_(ZERO|ONE(_MINUS_(DEST_COLOR|SOURCE_(ALPHA|COLOR)))?|DEST_COLOR|SOURCE_(ALPHA|COLOR))|BLEND_FUNC_(DEST|SOURCE)|FLAGS|(START|END)_(COLOR|ALPHA|SCALE|GLOW)|MAX_AGE|(RIBBON|WIND|INTERP_(COLOR|SCALE)|BOUNCE|FOLLOW_(SRC|VELOCITY)|TARGET_(POS|LINEAR)|EMISSIVE)_MASK)|SRC_(MAX_AGE|PATTERN|ANGLE_(BEGIN|END)|BURST_(RATE|PART_COUNT|RADIUS|SPEED_(MIN|MAX))|ACCEL|TEXTURE|TARGET_KEY|OMEGA|PATTERN_(DROP|EXPLODE|ANGLE(_CONE(_EMPTY)?)?)))|VEHICLE_(REFERENCE_FRAME|TYPE_(NONE|SLED|CAR|BOAT|AIRPLANE|BALLOON)|(LINEAR|ANGULAR)_(FRICTION_TIMESCALE|MOTOR_DIRECTION)|LINEAR_MOTOR_OFFSET|HOVER_(HEIGHT|EFFICIENCY|TIMESCALE)|BUOYANCY|(LINEAR|ANGULAR)_(DEFLECTION_(EFFICIENCY|TIMESCALE)|MOTOR_(DECAY_)?TIMESCALE)|VERTICAL_ATTRACTION_(EFFICIENCY|TIMESCALE)|BANKING_(EFFICIENCY|MIX|TIMESCALE)|FLAG_(NO_DEFLECTION_UP|LIMIT_(ROLL_ONLY|MOTOR_UP)|HOVER_((WATER|TERRAIN|UP)_ONLY|GLOBAL_HEIGHT)|MOUSELOOK_(STEER|BANK)|CAMERA_DECOUPLED))|PRIM_(ALLOW_UNSIT|ALPHA_MODE(_(BLEND|EMISSIVE|MASK|NONE))?|NORMAL|SPECULAR|TYPE(_(BOX|CYLINDER|PRISM|SPHERE|TORUS|TUBE|RING|SCULPT))?|HOLE_(DEFAULT|CIRCLE|SQUARE|TRIANGLE)|MATERIAL(_(STONE|METAL|GLASS|WOOD|FLESH|PLASTIC|RUBBER))?|SHINY_(NONE|LOW|MEDIUM|HIGH)|BUMP_(NONE|BRIGHT|DARK|WOOD|BARK|BRICKS|CHECKER|CONCRETE|TILE|STONE|DISKS|GRAVEL|BLOBS|SIDING|LARGETILE|STUCCO|SUCTION|WEAVE)|TEXGEN_(DEFAULT|PLANAR)|SCRIPTED_SIT_ONLY|SCULPT_(TYPE_(SPHERE|TORUS|PLANE|CYLINDER|MASK)|FLAG_(MIRROR|INVERT))|PHYSICS(_(SHAPE_(CONVEX|NONE|PRIM|TYPE)))?|(POS|ROT)_LOCAL|SLICE|TEXT|FLEXIBLE|POINT_LIGHT|TEMP_ON_REZ|PHANTOM|POSITION|SIT_TARGET|SIZE|ROTATION|TEXTURE|NAME|OMEGA|DESC|LINK_TARGET|COLOR|BUMP_SHINY|FULLBRIGHT|TEXGEN|GLOW|MEDIA_(ALT_IMAGE_ENABLE|CONTROLS|(CURRENT|HOME)_URL|AUTO_(LOOP|PLAY|SCALE|ZOOM)|FIRST_CLICK_INTERACT|(WIDTH|HEIGHT)_PIXELS|WHITELIST(_ENABLE)?|PERMS_(INTERACT|CONTROL)|PARAM_MAX|CONTROLS_(STANDARD|MINI)|PERM_(NONE|OWNER|GROUP|ANYONE)|MAX_(URL_LENGTH|WHITELIST_(SIZE|COUNT)|(WIDTH|HEIGHT)_PIXELS)))|MASK_(BASE|OWNER|GROUP|EVERYONE|NEXT)|PERM_(TRANSFER|MODIFY|COPY|MOVE|ALL)|PARCEL_(MEDIA_COMMAND_(STOP|PAUSE|PLAY|LOOP|TEXTURE|URL|TIME|AGENT|UNLOAD|AUTO_ALIGN|TYPE|SIZE|DESC|LOOP_SET)|FLAG_(ALLOW_(FLY|(GROUP_)?SCRIPTS|LANDMARK|TERRAFORM|DAMAGE|CREATE_(GROUP_)?OBJECTS)|USE_(ACCESS_(GROUP|LIST)|BAN_LIST|LAND_PASS_LIST)|LOCAL_SOUND_ONLY|RESTRICT_PUSHOBJECT|ALLOW_(GROUP|ALL)_OBJECT_ENTRY)|COUNT_(TOTAL|OWNER|GROUP|OTHER|SELECTED|TEMP)|DETAILS_(NAME|DESC|OWNER|GROUP|AREA|ID|SEE_AVATARS))|LIST_STAT_(MAX|MIN|MEAN|MEDIAN|STD_DEV|SUM(_SQUARES)?|NUM_COUNT|GEOMETRIC_MEAN|RANGE)|PAY_(HIDE|DEFAULT)|REGION_FLAG_(ALLOW_DAMAGE|FIXED_SUN|BLOCK_TERRAFORM|SANDBOX|DISABLE_(COLLISIONS|PHYSICS)|BLOCK_FLY|ALLOW_DIRECT_TELEPORT|RESTRICT_PUSHOBJECT)|HTTP_(METHOD|MIMETYPE|BODY_(MAXLENGTH|TRUNCATED)|CUSTOM_HEADER|PRAGMA_NO_CACHE|VERBOSE_THROTTLE|VERIFY_CERT)|SIT_(INVALID_(AGENT|LINK_OBJECT)|NO(T_EXPERIENCE|_(ACCESS|EXPERIENCE_PERMISSION|SIT_TARGET)))|STRING_(TRIM(_(HEAD|TAIL))?)|CLICK_ACTION_(NONE|TOUCH|SIT|BUY|PAY|OPEN(_MEDIA)?|PLAY|ZOOM)|TOUCH_INVALID_FACE|PROFILE_(NONE|SCRIPT_MEMORY)|RC_(DATA_FLAGS|DETECT_PHANTOM|GET_(LINK_NUM|NORMAL|ROOT_KEY)|MAX_HITS|REJECT_(TYPES|AGENTS|(NON)?PHYSICAL|LAND))|RCERR_(CAST_TIME_EXCEEDED|SIM_PERF_LOW|UNKNOWN)|ESTATE_ACCESS_(ALLOWED_(AGENT|GROUP)_(ADD|REMOVE)|BANNED_AGENT_(ADD|REMOVE))|DENSITY|FRICTION|RESTITUTION|GRAVITY_MULTIPLIER|KFM_(COMMAND|CMD_(PLAY|STOP|PAUSE)|MODE|FORWARD|LOOP|PING_PONG|REVERSE|DATA|ROTATION|TRANSLATION)|ERR_(GENERIC|PARCEL_PERMISSIONS|MALFORMED_PARAMS|RUNTIME_PERMISSIONS|THROTTLED)|CHARACTER_(CMD_((SMOOTH_)?STOP|JUMP)|DESIRED_(TURN_)?SPEED|RADIUS|STAY_WITHIN_PARCEL|LENGTH|ORIENTATION|ACCOUNT_FOR_SKIPPED_FRAMES|AVOIDANCE_MODE|TYPE(_([ABCD]|NONE))?|MAX_(DECEL|TURN_RADIUS|(ACCEL|SPEED)))|PURSUIT_(OFFSET|FUZZ_FACTOR|GOAL_TOLERANCE|INTERCEPT)|REQUIRE_LINE_OF_SIGHT|FORCE_DIRECT_PATH|VERTICAL|HORIZONTAL|AVOID_(CHARACTERS|DYNAMIC_OBSTACLES|NONE)|PU_(EVADE_(HIDDEN|SPOTTED)|FAILURE_(DYNAMIC_PATHFINDING_DISABLED|INVALID_(GOAL|START)|NO_(NAVMESH|VALID_DESTINATION)|OTHER|TARGET_GONE|(PARCEL_)?UNREACHABLE)|(GOAL|SLOWDOWN_DISTANCE)_REACHED)|TRAVERSAL_TYPE(_(FAST|NONE|SLOW))?|CONTENT_TYPE_(ATOM|FORM|HTML|JSON|LLSD|RSS|TEXT|XHTML|XML)|GCNP_(RADIUS|STATIC)|(PATROL|WANDER)_PAUSE_AT_WAYPOINTS|OPT_(AVATAR|CHARACTER|EXCLUSION_VOLUME|LEGACY_LINKSET|MATERIAL_VOLUME|OTHER|STATIC_OBSTACLE|WALKABLE)|SIM_STAT_PCT_CHARS_STEPPED)\\b`
                            },
                            {
                                begin: `\\b(FALSE|TRUE)\\b`
                            },
                            {
                                begin: `\\b(ZERO_ROTATION)\\b`
                            },
                            {
                                begin: `\\b(EOF|JSON_(ARRAY|DELETE|FALSE|INVALID|NULL|NUMBER|OBJECT|STRING|TRUE)|NULL_KEY|TEXTURE_(BLANK|DEFAULT|MEDIA|PLYWOOD|TRANSPARENT)|URL_REQUEST_(GRANTED|DENIED))\\b`
                            },
                            {
                                begin: `\\b(ZERO_VECTOR|TOUCH_INVALID_(TEXCOORD|VECTOR))\\b`
                            }
                        ]
                    },
                    {
                        className: `type`,
                        begin: `\\b(integer|float|string|key|vector|quaternion|rotation|list)\\b`
                    }
                ]
            };
        }
        t.exports = n;
    }), st = o((e, t)=>{
        function n(e) {
            let t = `\\[=*\\[`, n = `\\]=*\\]`, r = {
                begin: t,
                end: n,
                contains: [
                    `self`
                ]
            }, i = [
                e.COMMENT(`--(?!` + t + `)`, `$`),
                e.COMMENT(`--` + t, n, {
                    contains: [
                        r
                    ],
                    relevance: 10
                })
            ];
            return {
                name: `Lua`,
                aliases: [
                    `pluto`
                ],
                keywords: {
                    $pattern: e.UNDERSCORE_IDENT_RE,
                    literal: `true false nil`,
                    keyword: `and break do else elseif end for goto if in local not or repeat return then until while`,
                    built_in: `_G _ENV _VERSION __index __newindex __mode __call __metatable __tostring __len __gc __add __sub __mul __div __mod __pow __concat __unm __eq __lt __le assert collectgarbage dofile error getfenv getmetatable ipairs load loadfile loadstring module next pairs pcall print rawequal rawget rawset require select setfenv setmetatable tonumber tostring type unpack xpcall arg self coroutine resume yield status wrap create running debug getupvalue debug sethook getmetatable gethook setmetatable setlocal traceback setfenv getinfo setupvalue getlocal getregistry getfenv io lines write close flush open output type read stderr stdin input stdout popen tmpfile math log max acos huge ldexp pi cos tanh pow deg tan cosh sinh random randomseed frexp ceil floor rad abs sqrt modf asin min mod fmod log10 atan2 exp sin atan os exit setlocale date getenv difftime remove time clock tmpname rename execute package preload loadlib loaded loaders cpath config path seeall string sub upper len gfind rep find match char dump gmatch reverse byte format gsub lower table setn insert getn foreachi maxn foreach concat sort remove`
                },
                contains: i.concat([
                    {
                        className: `function`,
                        beginKeywords: `function`,
                        end: `\\)`,
                        contains: [
                            e.inherit(e.TITLE_MODE, {
                                begin: `([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*`
                            }),
                            {
                                className: `params`,
                                begin: `\\(`,
                                endsWithParent: !0,
                                contains: i
                            }
                        ].concat(i)
                    },
                    e.C_NUMBER_MODE,
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE,
                    {
                        className: `string`,
                        begin: t,
                        end: n,
                        contains: [
                            r
                        ],
                        relevance: 5
                    }
                ])
            };
        }
        t.exports = n;
    }), ct = o((e, t)=>{
        function n(e) {
            let t = {
                className: `variable`,
                variants: [
                    {
                        begin: `\\$\\(` + e.UNDERSCORE_IDENT_RE + `\\)`,
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ]
                    },
                    {
                        begin: /\$[@%<?\^\+\*]/
                    }
                ]
            }, n = {
                className: `string`,
                begin: /"/,
                end: /"/,
                contains: [
                    e.BACKSLASH_ESCAPE,
                    t
                ]
            }, r = {
                className: `variable`,
                begin: /\$\([\w-]+\s/,
                end: /\)/,
                keywords: {
                    built_in: `subst patsubst strip findstring filter filter-out sort word wordlist firstword lastword dir notdir suffix basename addsuffix addprefix join wildcard realpath abspath error warning shell origin flavor foreach if or and call eval file value`
                },
                contains: [
                    t,
                    n
                ]
            }, i = {
                begin: `^` + e.UNDERSCORE_IDENT_RE + `\\s*(?=[:+?]?=)`
            }, a = {
                className: `meta`,
                begin: /^\.PHONY:/,
                end: /$/,
                keywords: {
                    $pattern: /[\.\w]+/,
                    keyword: `.PHONY`
                }
            }, o = {
                className: `section`,
                begin: /^[^\s]+:/,
                end: /$/,
                contains: [
                    t
                ]
            };
            return {
                name: `Makefile`,
                aliases: [
                    `mk`,
                    `mak`,
                    `make`
                ],
                keywords: {
                    $pattern: /[\w-]+/,
                    keyword: `define endef undefine ifdef ifndef ifeq ifneq else endif include -include sinclude override export unexport private vpath`
                },
                contains: [
                    e.HASH_COMMENT_MODE,
                    t,
                    n,
                    r,
                    i,
                    a,
                    o
                ]
            };
        }
        t.exports = n;
    }), lt = o((e, t)=>{
        var n = `AASTriangle.AbelianGroup.Abort.AbortKernels.AbortProtect.AbortScheduledTask.Above.Abs.AbsArg.AbsArgPlot.Absolute.AbsoluteCorrelation.AbsoluteCorrelationFunction.AbsoluteCurrentValue.AbsoluteDashing.AbsoluteFileName.AbsoluteOptions.AbsolutePointSize.AbsoluteThickness.AbsoluteTime.AbsoluteTiming.AcceptanceThreshold.AccountingForm.Accumulate.Accuracy.AccuracyGoal.AcousticAbsorbingValue.AcousticImpedanceValue.AcousticNormalVelocityValue.AcousticPDEComponent.AcousticPressureCondition.AcousticRadiationValue.AcousticSoundHardValue.AcousticSoundSoftCondition.ActionDelay.ActionMenu.ActionMenuBox.ActionMenuBoxOptions.Activate.Active.ActiveClassification.ActiveClassificationObject.ActiveItem.ActivePrediction.ActivePredictionObject.ActiveStyle.AcyclicGraphQ.AddOnHelpPath.AddSides.AddTo.AddToSearchIndex.AddUsers.AdjacencyGraph.AdjacencyList.AdjacencyMatrix.AdjacentMeshCells.Adjugate.AdjustmentBox.AdjustmentBoxOptions.AdjustTimeSeriesForecast.AdministrativeDivisionData.AffineHalfSpace.AffineSpace.AffineStateSpaceModel.AffineTransform.After.AggregatedEntityClass.AggregationLayer.AircraftData.AirportData.AirPressureData.AirSoundAttenuation.AirTemperatureData.AiryAi.AiryAiPrime.AiryAiZero.AiryBi.AiryBiPrime.AiryBiZero.AlgebraicIntegerQ.AlgebraicNumber.AlgebraicNumberDenominator.AlgebraicNumberNorm.AlgebraicNumberPolynomial.AlgebraicNumberTrace.AlgebraicRules.AlgebraicRulesData.Algebraics.AlgebraicUnitQ.Alignment.AlignmentMarker.AlignmentPoint.All.AllowAdultContent.AllowChatServices.AllowedCloudExtraParameters.AllowedCloudParameterExtensions.AllowedDimensions.AllowedFrequencyRange.AllowedHeads.AllowGroupClose.AllowIncomplete.AllowInlineCells.AllowKernelInitialization.AllowLooseGrammar.AllowReverseGroupClose.AllowScriptLevelChange.AllowVersionUpdate.AllTrue.Alphabet.AlphabeticOrder.AlphabeticSort.AlphaChannel.AlternateImage.AlternatingFactorial.AlternatingGroup.AlternativeHypothesis.Alternatives.AltitudeMethod.AmbientLight.AmbiguityFunction.AmbiguityList.Analytic.AnatomyData.AnatomyForm.AnatomyPlot3D.AnatomySkinStyle.AnatomyStyling.AnchoredSearch.And.AndersonDarlingTest.AngerJ.AngleBisector.AngleBracket.AnglePath.AnglePath3D.AngleVector.AngularGauge.Animate.AnimatedImage.AnimationCycleOffset.AnimationCycleRepetitions.AnimationDirection.AnimationDisplayTime.AnimationRate.AnimationRepetitions.AnimationRunning.AnimationRunTime.AnimationTimeIndex.AnimationVideo.Animator.AnimatorBox.AnimatorBoxOptions.AnimatorElements.Annotate.Annotation.AnnotationDelete.AnnotationKeys.AnnotationRules.AnnotationValue.Annuity.AnnuityDue.Annulus.AnomalyDetection.AnomalyDetector.AnomalyDetectorFunction.Anonymous.Antialiasing.Antihermitian.AntihermitianMatrixQ.Antisymmetric.AntisymmetricMatrixQ.Antonyms.AnyOrder.AnySubset.AnyTrue.Apart.ApartSquareFree.APIFunction.Appearance.AppearanceElements.AppearanceRules.AppellF1.Append.AppendCheck.AppendLayer.AppendTo.Application.Apply.ApplyReaction.ApplySides.ApplyTo.ArcCos.ArcCosh.ArcCot.ArcCoth.ArcCsc.ArcCsch.ArcCurvature.ARCHProcess.ArcLength.ArcSec.ArcSech.ArcSin.ArcSinDistribution.ArcSinh.ArcTan.ArcTanh.Area.Arg.ArgMax.ArgMin.ArgumentCountQ.ArgumentsOptions.ARIMAProcess.ArithmeticGeometricMean.ARMAProcess.Around.AroundReplace.ARProcess.Array.ArrayComponents.ArrayDepth.ArrayFilter.ArrayFlatten.ArrayMesh.ArrayPad.ArrayPlot.ArrayPlot3D.ArrayQ.ArrayReduce.ArrayResample.ArrayReshape.ArrayRules.Arrays.Arrow.Arrow3DBox.ArrowBox.Arrowheads.ASATriangle.Ask.AskAppend.AskConfirm.AskDisplay.AskedQ.AskedValue.AskFunction.AskState.AskTemplateDisplay.AspectRatio.AspectRatioFixed.Assert.AssessmentFunction.AssessmentResultObject.AssociateTo.Association.AssociationFormat.AssociationMap.AssociationQ.AssociationThread.AssumeDeterministic.Assuming.Assumptions.AstroAngularSeparation.AstroBackground.AstroCenter.AstroDistance.AstroGraphics.AstroGridLines.AstroGridLinesStyle.AstronomicalData.AstroPosition.AstroProjection.AstroRange.AstroRangePadding.AstroReferenceFrame.AstroStyling.AstroZoomLevel.Asymptotic.AsymptoticDSolveValue.AsymptoticEqual.AsymptoticEquivalent.AsymptoticExpectation.AsymptoticGreater.AsymptoticGreaterEqual.AsymptoticIntegrate.AsymptoticLess.AsymptoticLessEqual.AsymptoticOutputTracker.AsymptoticProbability.AsymptoticProduct.AsymptoticRSolveValue.AsymptoticSolve.AsymptoticSum.Asynchronous.AsynchronousTaskObject.AsynchronousTasks.Atom.AtomCoordinates.AtomCount.AtomDiagramCoordinates.AtomLabels.AtomLabelStyle.AtomList.AtomQ.AttachCell.AttachedCell.AttentionLayer.Attributes.Audio.AudioAmplify.AudioAnnotate.AudioAnnotationLookup.AudioBlockMap.AudioCapture.AudioChannelAssignment.AudioChannelCombine.AudioChannelMix.AudioChannels.AudioChannelSeparate.AudioData.AudioDelay.AudioDelete.AudioDevice.AudioDistance.AudioEncoding.AudioFade.AudioFrequencyShift.AudioGenerator.AudioIdentify.AudioInputDevice.AudioInsert.AudioInstanceQ.AudioIntervals.AudioJoin.AudioLabel.AudioLength.AudioLocalMeasurements.AudioLooping.AudioLoudness.AudioMeasurements.AudioNormalize.AudioOutputDevice.AudioOverlay.AudioPad.AudioPan.AudioPartition.AudioPause.AudioPitchShift.AudioPlay.AudioPlot.AudioQ.AudioRecord.AudioReplace.AudioResample.AudioReverb.AudioReverse.AudioSampleRate.AudioSpectralMap.AudioSpectralTransformation.AudioSplit.AudioStop.AudioStream.AudioStreams.AudioTimeStretch.AudioTrackApply.AudioTrackSelection.AudioTrim.AudioType.AugmentedPolyhedron.AugmentedSymmetricPolynomial.Authenticate.Authentication.AuthenticationDialog.AutoAction.Autocomplete.AutocompletionFunction.AutoCopy.AutocorrelationTest.AutoDelete.AutoEvaluateEvents.AutoGeneratedPackage.AutoIndent.AutoIndentSpacings.AutoItalicWords.AutoloadPath.AutoMatch.Automatic.AutomaticImageSize.AutoMultiplicationSymbol.AutoNumberFormatting.AutoOpenNotebooks.AutoOpenPalettes.AutoOperatorRenderings.AutoQuoteCharacters.AutoRefreshed.AutoRemove.AutorunSequencing.AutoScaling.AutoScroll.AutoSpacing.AutoStyleOptions.AutoStyleWords.AutoSubmitting.Axes.AxesEdge.AxesLabel.AxesOrigin.AxesStyle.AxiomaticTheory.Axis.Axis3DBox.Axis3DBoxOptions.AxisBox.AxisBoxOptions.AxisLabel.AxisObject.AxisStyle.BabyMonsterGroupB.Back.BackFaceColor.BackFaceGlowColor.BackFaceOpacity.BackFaceSpecularColor.BackFaceSpecularExponent.BackFaceSurfaceAppearance.BackFaceTexture.Background.BackgroundAppearance.BackgroundTasksSettings.Backslash.Backsubstitution.Backward.Ball.Band.BandpassFilter.BandstopFilter.BarabasiAlbertGraphDistribution.BarChart.BarChart3D.BarcodeImage.BarcodeRecognize.BaringhausHenzeTest.BarLegend.BarlowProschanImportance.BarnesG.BarOrigin.BarSpacing.BartlettHannWindow.BartlettWindow.BaseDecode.BaseEncode.BaseForm.Baseline.BaselinePosition.BaseStyle.BasicRecurrentLayer.BatchNormalizationLayer.BatchSize.BatesDistribution.BattleLemarieWavelet.BayesianMaximization.BayesianMaximizationObject.BayesianMinimization.BayesianMinimizationObject.Because.BeckmannDistribution.Beep.Before.Begin.BeginDialogPacket.BeginPackage.BellB.BellY.Below.BenfordDistribution.BeniniDistribution.BenktanderGibratDistribution.BenktanderWeibullDistribution.BernoulliB.BernoulliDistribution.BernoulliGraphDistribution.BernoulliProcess.BernsteinBasis.BesagL.BesselFilterModel.BesselI.BesselJ.BesselJZero.BesselK.BesselY.BesselYZero.Beta.BetaBinomialDistribution.BetaDistribution.BetaNegativeBinomialDistribution.BetaPrimeDistribution.BetaRegularized.Between.BetweennessCentrality.Beveled.BeveledPolyhedron.BezierCurve.BezierCurve3DBox.BezierCurve3DBoxOptions.BezierCurveBox.BezierCurveBoxOptions.BezierFunction.BilateralFilter.BilateralLaplaceTransform.BilateralZTransform.Binarize.BinaryDeserialize.BinaryDistance.BinaryFormat.BinaryImageQ.BinaryRead.BinaryReadList.BinarySerialize.BinaryWrite.BinCounts.BinLists.BinnedVariogramList.Binomial.BinomialDistribution.BinomialPointProcess.BinomialProcess.BinormalDistribution.BiorthogonalSplineWavelet.BioSequence.BioSequenceBackTranslateList.BioSequenceComplement.BioSequenceInstances.BioSequenceModify.BioSequencePlot.BioSequenceQ.BioSequenceReverseComplement.BioSequenceTranscribe.BioSequenceTranslate.BipartiteGraphQ.BiquadraticFilterModel.BirnbaumImportance.BirnbaumSaundersDistribution.BitAnd.BitClear.BitGet.BitLength.BitNot.BitOr.BitRate.BitSet.BitShiftLeft.BitShiftRight.BitXor.BiweightLocation.BiweightMidvariance.Black.BlackmanHarrisWindow.BlackmanNuttallWindow.BlackmanWindow.Blank.BlankForm.BlankNullSequence.BlankSequence.Blend.Block.BlockchainAddressData.BlockchainBase.BlockchainBlockData.BlockchainContractValue.BlockchainData.BlockchainGet.BlockchainKeyEncode.BlockchainPut.BlockchainTokenData.BlockchainTransaction.BlockchainTransactionData.BlockchainTransactionSign.BlockchainTransactionSubmit.BlockDiagonalMatrix.BlockLowerTriangularMatrix.BlockMap.BlockRandom.BlockUpperTriangularMatrix.BlomqvistBeta.BlomqvistBetaTest.Blue.Blur.Blurring.BodePlot.BohmanWindow.Bold.Bond.BondCount.BondLabels.BondLabelStyle.BondList.BondQ.Bookmarks.Boole.BooleanConsecutiveFunction.BooleanConvert.BooleanCountingFunction.BooleanFunction.BooleanGraph.BooleanMaxterms.BooleanMinimize.BooleanMinterms.BooleanQ.BooleanRegion.Booleans.BooleanStrings.BooleanTable.BooleanVariables.BorderDimensions.BorelTannerDistribution.Bottom.BottomHatTransform.BoundaryDiscretizeGraphics.BoundaryDiscretizeRegion.BoundaryMesh.BoundaryMeshRegion.BoundaryMeshRegionQ.BoundaryStyle.BoundedRegionQ.BoundingRegion.Bounds.Box.BoxBaselineShift.BoxData.BoxDimensions.Boxed.Boxes.BoxForm.BoxFormFormatTypes.BoxFrame.BoxID.BoxMargins.BoxMatrix.BoxObject.BoxRatios.BoxRotation.BoxRotationPoint.BoxStyle.BoxWhiskerChart.Bra.BracketingBar.BraKet.BrayCurtisDistance.BreadthFirstScan.Break.BridgeData.BrightnessEqualize.BroadcastStationData.Brown.BrownForsytheTest.BrownianBridgeProcess.BrowserCategory.BSplineBasis.BSplineCurve.BSplineCurve3DBox.BSplineCurve3DBoxOptions.BSplineCurveBox.BSplineCurveBoxOptions.BSplineFunction.BSplineSurface.BSplineSurface3DBox.BSplineSurface3DBoxOptions.BubbleChart.BubbleChart3D.BubbleScale.BubbleSizes.BuckyballGraph.BuildCompiledComponent.BuildingData.BulletGauge.BusinessDayQ.ButterflyGraph.ButterworthFilterModel.Button.ButtonBar.ButtonBox.ButtonBoxOptions.ButtonCell.ButtonContents.ButtonData.ButtonEvaluator.ButtonExpandable.ButtonFrame.ButtonFunction.ButtonMargins.ButtonMinHeight.ButtonNote.ButtonNotebook.ButtonSource.ButtonStyle.ButtonStyleMenuListing.Byte.ByteArray.ByteArrayFormat.ByteArrayFormatQ.ByteArrayQ.ByteArrayToString.ByteCount.ByteOrdering.C.CachedValue.CacheGraphics.CachePersistence.CalendarConvert.CalendarData.CalendarType.Callout.CalloutMarker.CalloutStyle.CallPacket.CanberraDistance.Cancel.CancelButton.CandlestickChart.CanonicalGraph.CanonicalizePolygon.CanonicalizePolyhedron.CanonicalizeRegion.CanonicalName.CanonicalWarpingCorrespondence.CanonicalWarpingDistance.CantorMesh.CantorStaircase.Canvas.Cap.CapForm.CapitalDifferentialD.Capitalize.CapsuleShape.CaptureRunning.CaputoD.CardinalBSplineBasis.CarlemanLinearize.CarlsonRC.CarlsonRD.CarlsonRE.CarlsonRF.CarlsonRG.CarlsonRJ.CarlsonRK.CarlsonRM.CarmichaelLambda.CaseOrdering.Cases.CaseSensitive.Cashflow.Casoratian.Cast.Catalan.CatalanNumber.Catch.CategoricalDistribution.Catenate.CatenateLayer.CauchyDistribution.CauchyMatrix.CauchyPointProcess.CauchyWindow.CayleyGraph.CDF.CDFDeploy.CDFInformation.CDFWavelet.Ceiling.CelestialSystem.Cell.CellAutoOverwrite.CellBaseline.CellBoundingBox.CellBracketOptions.CellChangeTimes.CellContents.CellContext.CellDingbat.CellDingbatMargin.CellDynamicExpression.CellEditDuplicate.CellElementsBoundingBox.CellElementSpacings.CellEpilog.CellEvaluationDuplicate.CellEvaluationFunction.CellEvaluationLanguage.CellEventActions.CellFrame.CellFrameColor.CellFrameLabelMargins.CellFrameLabels.CellFrameMargins.CellFrameStyle.CellGroup.CellGroupData.CellGrouping.CellGroupingRules.CellHorizontalScrolling.CellID.CellInsertionPointCell.CellLabel.CellLabelAutoDelete.CellLabelMargins.CellLabelPositioning.CellLabelStyle.CellLabelTemplate.CellMargins.CellObject.CellOpen.CellPrint.CellProlog.Cells.CellSize.CellStyle.CellTags.CellTrayPosition.CellTrayWidgets.CellularAutomaton.CensoredDistribution.Censoring.Center.CenterArray.CenterDot.CenteredInterval.CentralFeature.CentralMoment.CentralMomentGeneratingFunction.Cepstrogram.CepstrogramArray.CepstrumArray.CForm.ChampernowneNumber.ChangeOptions.ChannelBase.ChannelBrokerAction.ChannelDatabin.ChannelHistoryLength.ChannelListen.ChannelListener.ChannelListeners.ChannelListenerWait.ChannelObject.ChannelPreSendFunction.ChannelReceiverFunction.ChannelSend.ChannelSubscribers.ChanVeseBinarize.Character.CharacterCounts.CharacterEncoding.CharacterEncodingsPath.CharacteristicFunction.CharacteristicPolynomial.CharacterName.CharacterNormalize.CharacterRange.Characters.ChartBaseStyle.ChartElementData.ChartElementDataFunction.ChartElementFunction.ChartElements.ChartLabels.ChartLayout.ChartLegends.ChartStyle.Chebyshev1FilterModel.Chebyshev2FilterModel.ChebyshevDistance.ChebyshevT.ChebyshevU.Check.CheckAbort.CheckAll.CheckArguments.Checkbox.CheckboxBar.CheckboxBox.CheckboxBoxOptions.ChemicalConvert.ChemicalData.ChemicalFormula.ChemicalInstance.ChemicalReaction.ChessboardDistance.ChiDistribution.ChineseRemainder.ChiSquareDistribution.ChoiceButtons.ChoiceDialog.CholeskyDecomposition.Chop.ChromaticityPlot.ChromaticityPlot3D.ChromaticPolynomial.Circle.CircleBox.CircleDot.CircleMinus.CirclePlus.CirclePoints.CircleThrough.CircleTimes.CirculantGraph.CircularArcThrough.CircularOrthogonalMatrixDistribution.CircularQuaternionMatrixDistribution.CircularRealMatrixDistribution.CircularSymplecticMatrixDistribution.CircularUnitaryMatrixDistribution.Circumsphere.CityData.ClassifierFunction.ClassifierInformation.ClassifierMeasurements.ClassifierMeasurementsObject.Classify.ClassPriors.Clear.ClearAll.ClearAttributes.ClearCookies.ClearPermissions.ClearSystemCache.ClebschGordan.ClickPane.ClickToCopy.ClickToCopyEnabled.Clip.ClipboardNotebook.ClipFill.ClippingStyle.ClipPlanes.ClipPlanesStyle.ClipRange.Clock.ClockGauge.ClockwiseContourIntegral.Close.Closed.CloseKernels.ClosenessCentrality.Closing.ClosingAutoSave.ClosingEvent.CloudAccountData.CloudBase.CloudConnect.CloudConnections.CloudDeploy.CloudDirectory.CloudDisconnect.CloudEvaluate.CloudExport.CloudExpression.CloudExpressions.CloudFunction.CloudGet.CloudImport.CloudLoggingData.CloudObject.CloudObjectInformation.CloudObjectInformationData.CloudObjectNameFormat.CloudObjects.CloudObjectURLType.CloudPublish.CloudPut.CloudRenderingMethod.CloudSave.CloudShare.CloudSubmit.CloudSymbol.CloudUnshare.CloudUserID.ClusterClassify.ClusterDissimilarityFunction.ClusteringComponents.ClusteringMeasurements.ClusteringTree.CMYKColor.Coarse.CodeAssistOptions.Coefficient.CoefficientArrays.CoefficientDomain.CoefficientList.CoefficientRules.CoifletWavelet.Collect.CollinearPoints.Colon.ColonForm.ColorBalance.ColorCombine.ColorConvert.ColorCoverage.ColorData.ColorDataFunction.ColorDetect.ColorDistance.ColorFunction.ColorFunctionBinning.ColorFunctionScaling.Colorize.ColorNegate.ColorOutput.ColorProfileData.ColorQ.ColorQuantize.ColorReplace.ColorRules.ColorSelectorSettings.ColorSeparate.ColorSetter.ColorSetterBox.ColorSetterBoxOptions.ColorSlider.ColorsNear.ColorSpace.ColorToneMapping.Column.ColumnAlignments.ColumnBackgrounds.ColumnForm.ColumnLines.ColumnsEqual.ColumnSpacings.ColumnWidths.CombinatorB.CombinatorC.CombinatorI.CombinatorK.CombinatorS.CombinatorW.CombinatorY.CombinedEntityClass.CombinerFunction.CometData.CommonDefaultFormatTypes.Commonest.CommonestFilter.CommonName.CommonUnits.CommunityBoundaryStyle.CommunityGraphPlot.CommunityLabels.CommunityRegionStyle.CompanyData.CompatibleUnitQ.CompilationOptions.CompilationTarget.Compile.Compiled.CompiledCodeFunction.CompiledComponent.CompiledExpressionDeclaration.CompiledFunction.CompiledLayer.CompilerCallback.CompilerEnvironment.CompilerEnvironmentAppend.CompilerEnvironmentAppendTo.CompilerEnvironmentObject.CompilerOptions.Complement.ComplementedEntityClass.CompleteGraph.CompleteGraphQ.CompleteIntegral.CompleteKaryTree.CompletionsListPacket.Complex.ComplexArrayPlot.ComplexContourPlot.Complexes.ComplexExpand.ComplexInfinity.ComplexityFunction.ComplexListPlot.ComplexPlot.ComplexPlot3D.ComplexRegionPlot.ComplexStreamPlot.ComplexVectorPlot.ComponentMeasurements.ComponentwiseContextMenu.Compose.ComposeList.ComposeSeries.CompositeQ.Composition.CompoundElement.CompoundExpression.CompoundPoissonDistribution.CompoundPoissonProcess.CompoundRenewalProcess.Compress.CompressedData.CompressionLevel.ComputeUncertainty.ConcaveHullMesh.Condition.ConditionalExpression.Conditioned.Cone.ConeBox.ConfidenceLevel.ConfidenceRange.ConfidenceTransform.ConfigurationPath.Confirm.ConfirmAssert.ConfirmBy.ConfirmMatch.ConfirmQuiet.ConformationMethod.ConformAudio.ConformImages.Congruent.ConicGradientFilling.ConicHullRegion.ConicHullRegion3DBox.ConicHullRegion3DBoxOptions.ConicHullRegionBox.ConicHullRegionBoxOptions.ConicOptimization.Conjugate.ConjugateTranspose.Conjunction.Connect.ConnectedComponents.ConnectedGraphComponents.ConnectedGraphQ.ConnectedMeshComponents.ConnectedMoleculeComponents.ConnectedMoleculeQ.ConnectionSettings.ConnectLibraryCallbackFunction.ConnectSystemModelComponents.ConnectSystemModelController.ConnesWindow.ConoverTest.ConservativeConvectionPDETerm.ConsoleMessage.Constant.ConstantArray.ConstantArrayLayer.ConstantImage.ConstantPlusLayer.ConstantRegionQ.Constants.ConstantTimesLayer.ConstellationData.ConstrainedMax.ConstrainedMin.Construct.Containing.ContainsAll.ContainsAny.ContainsExactly.ContainsNone.ContainsOnly.ContentDetectorFunction.ContentFieldOptions.ContentLocationFunction.ContentObject.ContentPadding.ContentsBoundingBox.ContentSelectable.ContentSize.Context.ContextMenu.Contexts.ContextToFileName.Continuation.Continue.ContinuedFraction.ContinuedFractionK.ContinuousAction.ContinuousMarkovProcess.ContinuousTask.ContinuousTimeModelQ.ContinuousWaveletData.ContinuousWaveletTransform.ContourDetect.ContourGraphics.ContourIntegral.ContourLabels.ContourLines.ContourPlot.ContourPlot3D.Contours.ContourShading.ContourSmoothing.ContourStyle.ContraharmonicMean.ContrastiveLossLayer.Control.ControlActive.ControlAlignment.ControlGroupContentsBox.ControllabilityGramian.ControllabilityMatrix.ControllableDecomposition.ControllableModelQ.ControllerDuration.ControllerInformation.ControllerInformationData.ControllerLinking.ControllerManipulate.ControllerMethod.ControllerPath.ControllerState.ControlPlacement.ControlsRendering.ControlType.ConvectionPDETerm.Convergents.ConversionOptions.ConversionRules.ConvertToPostScript.ConvertToPostScriptPacket.ConvexHullMesh.ConvexHullRegion.ConvexOptimization.ConvexPolygonQ.ConvexPolyhedronQ.ConvexRegionQ.ConvolutionLayer.Convolve.ConwayGroupCo1.ConwayGroupCo2.ConwayGroupCo3.CookieFunction.Cookies.CoordinateBoundingBox.CoordinateBoundingBoxArray.CoordinateBounds.CoordinateBoundsArray.CoordinateChartData.CoordinatesToolOptions.CoordinateTransform.CoordinateTransformData.CoplanarPoints.CoprimeQ.Coproduct.CopulaDistribution.Copyable.CopyDatabin.CopyDirectory.CopyFile.CopyFunction.CopyTag.CopyToClipboard.CoreNilpotentDecomposition.CornerFilter.CornerNeighbors.Correlation.CorrelationDistance.CorrelationFunction.CorrelationTest.Cos.Cosh.CoshIntegral.CosineDistance.CosineWindow.CosIntegral.Cot.Coth.CoulombF.CoulombG.CoulombH1.CoulombH2.Count.CountDistinct.CountDistinctBy.CounterAssignments.CounterBox.CounterBoxOptions.CounterClockwiseContourIntegral.CounterEvaluator.CounterFunction.CounterIncrements.CounterStyle.CounterStyleMenuListing.CountRoots.CountryData.Counts.CountsBy.Covariance.CovarianceEstimatorFunction.CovarianceFunction.CoxianDistribution.CoxIngersollRossProcess.CoxModel.CoxModelFit.CramerVonMisesTest.CreateArchive.CreateCellID.CreateChannel.CreateCloudExpression.CreateCompilerEnvironment.CreateDatabin.CreateDataStructure.CreateDataSystemModel.CreateDialog.CreateDirectory.CreateDocument.CreateFile.CreateIntermediateDirectories.CreateLicenseEntitlement.CreateManagedLibraryExpression.CreateNotebook.CreatePacletArchive.CreatePalette.CreatePermissionsGroup.CreateScheduledTask.CreateSearchIndex.CreateSystemModel.CreateTemporary.CreateTypeInstance.CreateUUID.CreateWindow.CriterionFunction.CriticalityFailureImportance.CriticalitySuccessImportance.CriticalSection.Cross.CrossEntropyLossLayer.CrossingCount.CrossingDetect.CrossingPolygon.CrossMatrix.Csc.Csch.CSGRegion.CSGRegionQ.CSGRegionTree.CTCLossLayer.Cube.CubeRoot.Cubics.Cuboid.CuboidBox.CuboidBoxOptions.Cumulant.CumulantGeneratingFunction.CumulativeFeatureImpactPlot.Cup.CupCap.Curl.CurlyDoubleQuote.CurlyQuote.CurrencyConvert.CurrentDate.CurrentImage.CurrentNotebookImage.CurrentScreenImage.CurrentValue.Curry.CurryApplied.CurvatureFlowFilter.CurveClosed.Cyan.CycleGraph.CycleIndexPolynomial.Cycles.CyclicGroup.Cyclotomic.Cylinder.CylinderBox.CylinderBoxOptions.CylindricalDecomposition.CylindricalDecompositionFunction.D.DagumDistribution.DamData.DamerauLevenshteinDistance.DampingFactor.Darker.Dashed.Dashing.DatabaseConnect.DatabaseDisconnect.DatabaseReference.Databin.DatabinAdd.DatabinRemove.Databins.DatabinSubmit.DatabinUpload.DataCompression.DataDistribution.DataRange.DataReversed.Dataset.DatasetDisplayPanel.DatasetTheme.DataStructure.DataStructureQ.Date.DateBounds.Dated.DateDelimiters.DateDifference.DatedUnit.DateFormat.DateFunction.DateGranularity.DateHistogram.DateInterval.DateList.DateListLogPlot.DateListPlot.DateListStepPlot.DateObject.DateObjectQ.DateOverlapsQ.DatePattern.DatePlus.DateRange.DateReduction.DateScale.DateSelect.DateString.DateTicksFormat.DateValue.DateWithinQ.DaubechiesWavelet.DavisDistribution.DawsonF.DayCount.DayCountConvention.DayHemisphere.DaylightQ.DayMatchQ.DayName.DayNightTerminator.DayPlus.DayRange.DayRound.DeBruijnGraph.DeBruijnSequence.Debug.DebugTag.Decapitalize.Decimal.DecimalForm.DeclareCompiledComponent.DeclareKnownSymbols.DeclarePackage.Decompose.DeconvolutionLayer.Decrement.Decrypt.DecryptFile.DedekindEta.DeepSpaceProbeData.Default.Default2DTool.Default3DTool.DefaultAttachedCellStyle.DefaultAxesStyle.DefaultBaseStyle.DefaultBoxStyle.DefaultButton.DefaultColor.DefaultControlPlacement.DefaultDockedCellStyle.DefaultDuplicateCellStyle.DefaultDuration.DefaultElement.DefaultFaceGridsStyle.DefaultFieldHintStyle.DefaultFont.DefaultFontProperties.DefaultFormatType.DefaultFrameStyle.DefaultFrameTicksStyle.DefaultGridLinesStyle.DefaultInlineFormatType.DefaultInputFormatType.DefaultLabelStyle.DefaultMenuStyle.DefaultNaturalLanguage.DefaultNewCellStyle.DefaultNewInlineCellStyle.DefaultNotebook.DefaultOptions.DefaultOutputFormatType.DefaultPrintPrecision.DefaultStyle.DefaultStyleDefinitions.DefaultTextFormatType.DefaultTextInlineFormatType.DefaultTicksStyle.DefaultTooltipStyle.DefaultValue.DefaultValues.Defer.DefineExternal.DefineInputStreamMethod.DefineOutputStreamMethod.DefineResourceFunction.Definition.Degree.DegreeCentrality.DegreeGraphDistribution.DegreeLexicographic.DegreeReverseLexicographic.DEigensystem.DEigenvalues.Deinitialization.Del.DelaunayMesh.Delayed.Deletable.Delete.DeleteAdjacentDuplicates.DeleteAnomalies.DeleteBorderComponents.DeleteCases.DeleteChannel.DeleteCloudExpression.DeleteContents.DeleteDirectory.DeleteDuplicates.DeleteDuplicatesBy.DeleteElements.DeleteFile.DeleteMissing.DeleteObject.DeletePermissionsKey.DeleteSearchIndex.DeleteSmallComponents.DeleteStopwords.DeleteWithContents.DeletionWarning.DelimitedArray.DelimitedSequence.Delimiter.DelimiterAutoMatching.DelimiterFlashTime.DelimiterMatching.Delimiters.DeliveryFunction.Dendrogram.Denominator.DensityGraphics.DensityHistogram.DensityPlot.DensityPlot3D.DependentVariables.Deploy.Deployed.Depth.DepthFirstScan.Derivative.DerivativeFilter.DerivativePDETerm.DerivedKey.DescriptorStateSpace.DesignMatrix.DestroyAfterEvaluation.Det.DeviceClose.DeviceConfigure.DeviceExecute.DeviceExecuteAsynchronous.DeviceObject.DeviceOpen.DeviceOpenQ.DeviceRead.DeviceReadBuffer.DeviceReadLatest.DeviceReadList.DeviceReadTimeSeries.Devices.DeviceStreams.DeviceWrite.DeviceWriteBuffer.DGaussianWavelet.DiacriticalPositioning.Diagonal.DiagonalizableMatrixQ.DiagonalMatrix.DiagonalMatrixQ.Dialog.DialogIndent.DialogInput.DialogLevel.DialogNotebook.DialogProlog.DialogReturn.DialogSymbols.Diamond.DiamondMatrix.DiceDissimilarity.DictionaryLookup.DictionaryWordQ.DifferenceDelta.DifferenceOrder.DifferenceQuotient.DifferenceRoot.DifferenceRootReduce.Differences.DifferentialD.DifferentialRoot.DifferentialRootReduce.DifferentiatorFilter.DiffusionPDETerm.DiggleGatesPointProcess.DiggleGrattonPointProcess.DigitalSignature.DigitBlock.DigitBlockMinimum.DigitCharacter.DigitCount.DigitQ.DihedralAngle.DihedralGroup.Dilation.DimensionalCombinations.DimensionalMeshComponents.DimensionReduce.DimensionReducerFunction.DimensionReduction.Dimensions.DiracComb.DiracDelta.DirectedEdge.DirectedEdges.DirectedGraph.DirectedGraphQ.DirectedInfinity.Direction.DirectionalLight.Directive.Directory.DirectoryName.DirectoryQ.DirectoryStack.DirichletBeta.DirichletCharacter.DirichletCondition.DirichletConvolve.DirichletDistribution.DirichletEta.DirichletL.DirichletLambda.DirichletTransform.DirichletWindow.DisableConsolePrintPacket.DisableFormatting.DiscreteAsymptotic.DiscreteChirpZTransform.DiscreteConvolve.DiscreteDelta.DiscreteHadamardTransform.DiscreteIndicator.DiscreteInputOutputModel.DiscreteLimit.DiscreteLQEstimatorGains.DiscreteLQRegulatorGains.DiscreteLyapunovSolve.DiscreteMarkovProcess.DiscreteMaxLimit.DiscreteMinLimit.DiscretePlot.DiscretePlot3D.DiscreteRatio.DiscreteRiccatiSolve.DiscreteShift.DiscreteTimeModelQ.DiscreteUniformDistribution.DiscreteVariables.DiscreteWaveletData.DiscreteWaveletPacketTransform.DiscreteWaveletTransform.DiscretizeGraphics.DiscretizeRegion.Discriminant.DisjointQ.Disjunction.Disk.DiskBox.DiskBoxOptions.DiskMatrix.DiskSegment.Dispatch.DispatchQ.DispersionEstimatorFunction.Display.DisplayAllSteps.DisplayEndPacket.DisplayForm.DisplayFunction.DisplayPacket.DisplayRules.DisplayString.DisplayTemporary.DisplayWith.DisplayWithRef.DisplayWithVariable.DistanceFunction.DistanceMatrix.DistanceTransform.Distribute.Distributed.DistributedContexts.DistributeDefinitions.DistributionChart.DistributionDomain.DistributionFitTest.DistributionParameterAssumptions.DistributionParameterQ.Dithering.Div.Divergence.Divide.DivideBy.Dividers.DivideSides.Divisible.Divisors.DivisorSigma.DivisorSum.DMSList.DMSString.Do.DockedCell.DockedCells.DocumentGenerator.DocumentGeneratorInformation.DocumentGeneratorInformationData.DocumentGenerators.DocumentNotebook.DocumentWeightingRules.Dodecahedron.DomainRegistrationInformation.DominantColors.DominatorTreeGraph.DominatorVertexList.DOSTextFormat.Dot.DotDashed.DotEqual.DotLayer.DotPlusLayer.Dotted.DoubleBracketingBar.DoubleContourIntegral.DoubleDownArrow.DoubleLeftArrow.DoubleLeftRightArrow.DoubleLeftTee.DoubleLongLeftArrow.DoubleLongLeftRightArrow.DoubleLongRightArrow.DoubleRightArrow.DoubleRightTee.DoubleUpArrow.DoubleUpDownArrow.DoubleVerticalBar.DoublyInfinite.Down.DownArrow.DownArrowBar.DownArrowUpArrow.DownLeftRightVector.DownLeftTeeVector.DownLeftVector.DownLeftVectorBar.DownRightTeeVector.DownRightVector.DownRightVectorBar.Downsample.DownTee.DownTeeArrow.DownValues.DownValuesFunction.DragAndDrop.DrawBackFaces.DrawEdges.DrawFrontFaces.DrawHighlighted.DrazinInverse.Drop.DropoutLayer.DropShadowing.DSolve.DSolveChangeVariables.DSolveValue.Dt.DualLinearProgramming.DualPlanarGraph.DualPolyhedron.DualSystemsModel.DumpGet.DumpSave.DuplicateFreeQ.Duration.Dynamic.DynamicBox.DynamicBoxOptions.DynamicEvaluationTimeout.DynamicGeoGraphics.DynamicImage.DynamicLocation.DynamicModule.DynamicModuleBox.DynamicModuleBoxOptions.DynamicModuleParent.DynamicModuleValues.DynamicName.DynamicNamespace.DynamicReference.DynamicSetting.DynamicUpdating.DynamicWrapper.DynamicWrapperBox.DynamicWrapperBoxOptions.E.EarthImpactData.EarthquakeData.EccentricityCentrality.Echo.EchoEvaluation.EchoFunction.EchoLabel.EchoTiming.EclipseType.EdgeAdd.EdgeBetweennessCentrality.EdgeCapacity.EdgeCapForm.EdgeChromaticNumber.EdgeColor.EdgeConnectivity.EdgeContract.EdgeCost.EdgeCount.EdgeCoverQ.EdgeCycleMatrix.EdgeDashing.EdgeDelete.EdgeDetect.EdgeForm.EdgeIndex.EdgeJoinForm.EdgeLabeling.EdgeLabels.EdgeLabelStyle.EdgeList.EdgeOpacity.EdgeQ.EdgeRenderingFunction.EdgeRules.EdgeShapeFunction.EdgeStyle.EdgeTaggedGraph.EdgeTaggedGraphQ.EdgeTags.EdgeThickness.EdgeTransitiveGraphQ.EdgeValueRange.EdgeValueSizes.EdgeWeight.EdgeWeightedGraphQ.Editable.EditButtonSettings.EditCellTagsSettings.EditDistance.EffectiveInterest.Eigensystem.Eigenvalues.EigenvectorCentrality.Eigenvectors.Element.ElementData.ElementwiseLayer.ElidedForms.Eliminate.EliminationOrder.Ellipsoid.EllipticE.EllipticExp.EllipticExpPrime.EllipticF.EllipticFilterModel.EllipticK.EllipticLog.EllipticNomeQ.EllipticPi.EllipticReducedHalfPeriods.EllipticTheta.EllipticThetaPrime.EmbedCode.EmbeddedHTML.EmbeddedService.EmbeddedSQLEntityClass.EmbeddedSQLExpression.EmbeddingLayer.EmbeddingObject.EmitSound.EmphasizeSyntaxErrors.EmpiricalDistribution.Empty.EmptyGraphQ.EmptyRegion.EmptySpaceF.EnableConsolePrintPacket.Enabled.Enclose.Encode.Encrypt.EncryptedObject.EncryptFile.End.EndAdd.EndDialogPacket.EndOfBuffer.EndOfFile.EndOfLine.EndOfString.EndPackage.EngineEnvironment.EngineeringForm.Enter.EnterExpressionPacket.EnterTextPacket.Entity.EntityClass.EntityClassList.EntityCopies.EntityFunction.EntityGroup.EntityInstance.EntityList.EntityPrefetch.EntityProperties.EntityProperty.EntityPropertyClass.EntityRegister.EntityStore.EntityStores.EntityTypeName.EntityUnregister.EntityValue.Entropy.EntropyFilter.Environment.Epilog.EpilogFunction.Equal.EqualColumns.EqualRows.EqualTilde.EqualTo.EquatedTo.Equilibrium.EquirippleFilterKernel.Equivalent.Erf.Erfc.Erfi.ErlangB.ErlangC.ErlangDistribution.Erosion.ErrorBox.ErrorBoxOptions.ErrorNorm.ErrorPacket.ErrorsDialogSettings.EscapeRadius.EstimatedBackground.EstimatedDistribution.EstimatedPointNormals.EstimatedPointProcess.EstimatedProcess.EstimatedVariogramModel.EstimatorGains.EstimatorRegulator.EuclideanDistance.EulerAngles.EulerCharacteristic.EulerE.EulerGamma.EulerianGraphQ.EulerMatrix.EulerPhi.Evaluatable.Evaluate.Evaluated.EvaluatePacket.EvaluateScheduledTask.EvaluationBox.EvaluationCell.EvaluationCompletionAction.EvaluationData.EvaluationElements.EvaluationEnvironment.EvaluationMode.EvaluationMonitor.EvaluationNotebook.EvaluationObject.EvaluationOrder.EvaluationPrivileges.EvaluationRateLimit.Evaluator.EvaluatorNames.EvenQ.EventData.EventEvaluator.EventHandler.EventHandlerTag.EventLabels.EventSeries.ExactBlackmanWindow.ExactNumberQ.ExactRootIsolation.ExampleData.Except.ExcludedContexts.ExcludedForms.ExcludedLines.ExcludedPhysicalQuantities.ExcludePods.Exclusions.ExclusionsStyle.Exists.Exit.ExitDialog.ExoplanetData.Exp.Expand.ExpandAll.ExpandDenominator.ExpandFileName.ExpandNumerator.Expectation.ExpectationE.ExpectedValue.ExpGammaDistribution.ExpIntegralE.ExpIntegralEi.ExpirationDate.Exponent.ExponentFunction.ExponentialDistribution.ExponentialFamily.ExponentialGeneratingFunction.ExponentialMovingAverage.ExponentialPowerDistribution.ExponentPosition.ExponentStep.Export.ExportAutoReplacements.ExportByteArray.ExportForm.ExportPacket.ExportString.Expression.ExpressionCell.ExpressionGraph.ExpressionPacket.ExpressionTree.ExpressionUUID.ExpToTrig.ExtendedEntityClass.ExtendedGCD.Extension.ExtentElementFunction.ExtentMarkers.ExtentSize.ExternalBundle.ExternalCall.ExternalDataCharacterEncoding.ExternalEvaluate.ExternalFunction.ExternalFunctionName.ExternalIdentifier.ExternalObject.ExternalOptions.ExternalSessionObject.ExternalSessions.ExternalStorageBase.ExternalStorageDownload.ExternalStorageGet.ExternalStorageObject.ExternalStoragePut.ExternalStorageUpload.ExternalTypeSignature.ExternalValue.Extract.ExtractArchive.ExtractLayer.ExtractPacletArchive.ExtremeValueDistribution.FaceAlign.FaceForm.FaceGrids.FaceGridsStyle.FaceRecognize.FacialFeatures.Factor.FactorComplete.Factorial.Factorial2.FactorialMoment.FactorialMomentGeneratingFunction.FactorialPower.FactorInteger.FactorList.FactorSquareFree.FactorSquareFreeList.FactorTerms.FactorTermsList.Fail.Failure.FailureAction.FailureDistribution.FailureQ.False.FareySequence.FARIMAProcess.FeatureDistance.FeatureExtract.FeatureExtraction.FeatureExtractor.FeatureExtractorFunction.FeatureImpactPlot.FeatureNames.FeatureNearest.FeatureSpacePlot.FeatureSpacePlot3D.FeatureTypes.FeatureValueDependencyPlot.FeatureValueImpactPlot.FEDisableConsolePrintPacket.FeedbackLinearize.FeedbackSector.FeedbackSectorStyle.FeedbackType.FEEnableConsolePrintPacket.FetalGrowthData.Fibonacci.Fibonorial.FieldCompletionFunction.FieldHint.FieldHintStyle.FieldMasked.FieldSize.File.FileBaseName.FileByteCount.FileConvert.FileDate.FileExistsQ.FileExtension.FileFormat.FileFormatProperties.FileFormatQ.FileHandler.FileHash.FileInformation.FileName.FileNameDepth.FileNameDialogSettings.FileNameDrop.FileNameForms.FileNameJoin.FileNames.FileNameSetter.FileNameSplit.FileNameTake.FileNameToFormatList.FilePrint.FileSize.FileSystemMap.FileSystemScan.FileSystemTree.FileTemplate.FileTemplateApply.FileType.FilledCurve.FilledCurveBox.FilledCurveBoxOptions.FilledTorus.FillForm.Filling.FillingStyle.FillingTransform.FilteredEntityClass.FilterRules.FinancialBond.FinancialData.FinancialDerivative.FinancialIndicator.Find.FindAnomalies.FindArgMax.FindArgMin.FindChannels.FindClique.FindClusters.FindCookies.FindCurvePath.FindCycle.FindDevices.FindDistribution.FindDistributionParameters.FindDivisions.FindEdgeColoring.FindEdgeCover.FindEdgeCut.FindEdgeIndependentPaths.FindEquationalProof.FindEulerianCycle.FindExternalEvaluators.FindFaces.FindFile.FindFit.FindFormula.FindFundamentalCycles.FindGeneratingFunction.FindGeoLocation.FindGeometricConjectures.FindGeometricTransform.FindGraphCommunities.FindGraphIsomorphism.FindGraphPartition.FindHamiltonianCycle.FindHamiltonianPath.FindHiddenMarkovStates.FindImageText.FindIndependentEdgeSet.FindIndependentVertexSet.FindInstance.FindIntegerNullVector.FindIsomers.FindIsomorphicSubgraph.FindKClan.FindKClique.FindKClub.FindKPlex.FindLibrary.FindLinearRecurrence.FindList.FindMatchingColor.FindMaximum.FindMaximumCut.FindMaximumFlow.FindMaxValue.FindMeshDefects.FindMinimum.FindMinimumCostFlow.FindMinimumCut.FindMinValue.FindMoleculeSubstructure.FindPath.FindPeaks.FindPermutation.FindPlanarColoring.FindPointProcessParameters.FindPostmanTour.FindProcessParameters.FindRegionTransform.FindRepeat.FindRoot.FindSequenceFunction.FindSettings.FindShortestPath.FindShortestTour.FindSpanningTree.FindSubgraphIsomorphism.FindSystemModelEquilibrium.FindTextualAnswer.FindThreshold.FindTransientRepeat.FindVertexColoring.FindVertexCover.FindVertexCut.FindVertexIndependentPaths.Fine.FinishDynamic.FiniteAbelianGroupCount.FiniteGroupCount.FiniteGroupData.First.FirstCase.FirstPassageTimeDistribution.FirstPosition.FischerGroupFi22.FischerGroupFi23.FischerGroupFi24Prime.FisherHypergeometricDistribution.FisherRatioTest.FisherZDistribution.Fit.FitAll.FitRegularization.FittedModel.FixedOrder.FixedPoint.FixedPointList.FlashSelection.Flat.FlatShading.Flatten.FlattenAt.FlattenLayer.FlatTopWindow.FlightData.FlipView.Floor.FlowPolynomial.Fold.FoldList.FoldPair.FoldPairList.FoldWhile.FoldWhileList.FollowRedirects.Font.FontColor.FontFamily.FontForm.FontName.FontOpacity.FontPostScriptName.FontProperties.FontReencoding.FontSize.FontSlant.FontSubstitutions.FontTracking.FontVariations.FontWeight.For.ForAll.ForAllType.ForceVersionInstall.Format.FormatRules.FormatType.FormatTypeAutoConvert.FormatValues.FormBox.FormBoxOptions.FormControl.FormFunction.FormLayoutFunction.FormObject.FormPage.FormProtectionMethod.FormTheme.FormulaData.FormulaLookup.FortranForm.Forward.ForwardBackward.ForwardCloudCredentials.Fourier.FourierCoefficient.FourierCosCoefficient.FourierCosSeries.FourierCosTransform.FourierDCT.FourierDCTFilter.FourierDCTMatrix.FourierDST.FourierDSTMatrix.FourierMatrix.FourierParameters.FourierSequenceTransform.FourierSeries.FourierSinCoefficient.FourierSinSeries.FourierSinTransform.FourierTransform.FourierTrigSeries.FoxH.FoxHReduce.FractionalBrownianMotionProcess.FractionalD.FractionalGaussianNoiseProcess.FractionalPart.FractionBox.FractionBoxOptions.FractionLine.Frame.FrameBox.FrameBoxOptions.Framed.FrameInset.FrameLabel.Frameless.FrameListVideo.FrameMargins.FrameRate.FrameStyle.FrameTicks.FrameTicksStyle.FRatioDistribution.FrechetDistribution.FreeQ.FrenetSerretSystem.FrequencySamplingFilterKernel.FresnelC.FresnelF.FresnelG.FresnelS.Friday.FrobeniusNumber.FrobeniusSolve.FromAbsoluteTime.FromCharacterCode.FromCoefficientRules.FromContinuedFraction.FromDate.FromDateString.FromDigits.FromDMS.FromEntity.FromJulianDate.FromLetterNumber.FromPolarCoordinates.FromRawPointer.FromRomanNumeral.FromSphericalCoordinates.FromUnixTime.Front.FrontEndDynamicExpression.FrontEndEventActions.FrontEndExecute.FrontEndObject.FrontEndResource.FrontEndResourceString.FrontEndStackSize.FrontEndToken.FrontEndTokenExecute.FrontEndValueCache.FrontEndVersion.FrontFaceColor.FrontFaceGlowColor.FrontFaceOpacity.FrontFaceSpecularColor.FrontFaceSpecularExponent.FrontFaceSurfaceAppearance.FrontFaceTexture.Full.FullAxes.FullDefinition.FullForm.FullGraphics.FullInformationOutputRegulator.FullOptions.FullRegion.FullSimplify.Function.FunctionAnalytic.FunctionBijective.FunctionCompile.FunctionCompileExport.FunctionCompileExportByteArray.FunctionCompileExportLibrary.FunctionCompileExportString.FunctionContinuous.FunctionConvexity.FunctionDeclaration.FunctionDiscontinuities.FunctionDomain.FunctionExpand.FunctionInjective.FunctionInterpolation.FunctionLayer.FunctionMeromorphic.FunctionMonotonicity.FunctionPeriod.FunctionPoles.FunctionRange.FunctionSign.FunctionSingularities.FunctionSpace.FunctionSurjective.FussellVeselyImportance.GaborFilter.GaborMatrix.GaborWavelet.GainMargins.GainPhaseMargins.GalaxyData.GalleryView.Gamma.GammaDistribution.GammaRegularized.GapPenalty.GARCHProcess.GatedRecurrentLayer.Gather.GatherBy.GaugeFaceElementFunction.GaugeFaceStyle.GaugeFrameElementFunction.GaugeFrameSize.GaugeFrameStyle.GaugeLabels.GaugeMarkers.GaugeStyle.GaussianFilter.GaussianIntegers.GaussianMatrix.GaussianOrthogonalMatrixDistribution.GaussianSymplecticMatrixDistribution.GaussianUnitaryMatrixDistribution.GaussianWindow.GCD.GegenbauerC.General.GeneralizedLinearModelFit.GenerateAsymmetricKeyPair.GenerateConditions.GeneratedAssetFormat.GeneratedAssetLocation.GeneratedCell.GeneratedCellStyles.GeneratedDocumentBinding.GenerateDerivedKey.GenerateDigitalSignature.GenerateDocument.GeneratedParameters.GeneratedQuantityMagnitudes.GenerateFileSignature.GenerateHTTPResponse.GenerateSecuredAuthenticationKey.GenerateSymmetricKey.GeneratingFunction.GeneratorDescription.GeneratorHistoryLength.GeneratorOutputType.Generic.GenericCylindricalDecomposition.GenomeData.GenomeLookup.GeoAntipode.GeoArea.GeoArraySize.GeoBackground.GeoBoundary.GeoBoundingBox.GeoBounds.GeoBoundsRegion.GeoBoundsRegionBoundary.GeoBubbleChart.GeoCenter.GeoCircle.GeoContourPlot.GeoDensityPlot.GeodesicClosing.GeodesicDilation.GeodesicErosion.GeodesicOpening.GeodesicPolyhedron.GeoDestination.GeodesyData.GeoDirection.GeoDisk.GeoDisplacement.GeoDistance.GeoDistanceList.GeoElevationData.GeoEntities.GeoGraphics.GeoGraphPlot.GeoGraphValuePlot.GeogravityModelData.GeoGridDirectionDifference.GeoGridLines.GeoGridLinesStyle.GeoGridPosition.GeoGridRange.GeoGridRangePadding.GeoGridUnitArea.GeoGridUnitDistance.GeoGridVector.GeoGroup.GeoHemisphere.GeoHemisphereBoundary.GeoHistogram.GeoIdentify.GeoImage.GeoLabels.GeoLength.GeoListPlot.GeoLocation.GeologicalPeriodData.GeomagneticModelData.GeoMarker.GeometricAssertion.GeometricBrownianMotionProcess.GeometricDistribution.GeometricMean.GeometricMeanFilter.GeometricOptimization.GeometricScene.GeometricStep.GeometricStylingRules.GeometricTest.GeometricTransformation.GeometricTransformation3DBox.GeometricTransformation3DBoxOptions.GeometricTransformationBox.GeometricTransformationBoxOptions.GeoModel.GeoNearest.GeoOrientationData.GeoPath.GeoPolygon.GeoPosition.GeoPositionENU.GeoPositionXYZ.GeoProjection.GeoProjectionData.GeoRange.GeoRangePadding.GeoRegionValuePlot.GeoResolution.GeoScaleBar.GeoServer.GeoSmoothHistogram.GeoStreamPlot.GeoStyling.GeoStylingImageFunction.GeoVariant.GeoVector.GeoVectorENU.GeoVectorPlot.GeoVectorXYZ.GeoVisibleRegion.GeoVisibleRegionBoundary.GeoWithinQ.GeoZoomLevel.GestureHandler.GestureHandlerTag.Get.GetContext.GetEnvironment.GetFileName.GetLinebreakInformationPacket.GibbsPointProcess.Glaisher.GlobalClusteringCoefficient.GlobalPreferences.GlobalSession.Glow.GoldenAngle.GoldenRatio.GompertzMakehamDistribution.GoochShading.GoodmanKruskalGamma.GoodmanKruskalGammaTest.Goto.GouraudShading.Grad.Gradient.GradientFilter.GradientFittedMesh.GradientOrientationFilter.GrammarApply.GrammarRules.GrammarToken.Graph.Graph3D.GraphAssortativity.GraphAutomorphismGroup.GraphCenter.GraphComplement.GraphData.GraphDensity.GraphDiameter.GraphDifference.GraphDisjointUnion.GraphDistance.GraphDistanceMatrix.GraphEmbedding.GraphHighlight.GraphHighlightStyle.GraphHub.Graphics.Graphics3D.Graphics3DBox.Graphics3DBoxOptions.GraphicsArray.GraphicsBaseline.GraphicsBox.GraphicsBoxOptions.GraphicsColor.GraphicsColumn.GraphicsComplex.GraphicsComplex3DBox.GraphicsComplex3DBoxOptions.GraphicsComplexBox.GraphicsComplexBoxOptions.GraphicsContents.GraphicsData.GraphicsGrid.GraphicsGridBox.GraphicsGroup.GraphicsGroup3DBox.GraphicsGroup3DBoxOptions.GraphicsGroupBox.GraphicsGroupBoxOptions.GraphicsGrouping.GraphicsHighlightColor.GraphicsRow.GraphicsSpacing.GraphicsStyle.GraphIntersection.GraphJoin.GraphLayerLabels.GraphLayers.GraphLayerStyle.GraphLayout.GraphLinkEfficiency.GraphPeriphery.GraphPlot.GraphPlot3D.GraphPower.GraphProduct.GraphPropertyDistribution.GraphQ.GraphRadius.GraphReciprocity.GraphRoot.GraphStyle.GraphSum.GraphTree.GraphUnion.Gray.GrayLevel.Greater.GreaterEqual.GreaterEqualLess.GreaterEqualThan.GreaterFullEqual.GreaterGreater.GreaterLess.GreaterSlantEqual.GreaterThan.GreaterTilde.GreekStyle.Green.GreenFunction.Grid.GridBaseline.GridBox.GridBoxAlignment.GridBoxBackground.GridBoxDividers.GridBoxFrame.GridBoxItemSize.GridBoxItemStyle.GridBoxOptions.GridBoxSpacings.GridCreationSettings.GridDefaultElement.GridElementStyleOptions.GridFrame.GridFrameMargins.GridGraph.GridLines.GridLinesStyle.GridVideo.GroebnerBasis.GroupActionBase.GroupBy.GroupCentralizer.GroupElementFromWord.GroupElementPosition.GroupElementQ.GroupElements.GroupElementToWord.GroupGenerators.Groupings.GroupMultiplicationTable.GroupOpenerColor.GroupOpenerInsideFrame.GroupOrbits.GroupOrder.GroupPageBreakWithin.GroupSetwiseStabilizer.GroupStabilizer.GroupStabilizerChain.GroupTogetherGrouping.GroupTogetherNestedGrouping.GrowCutComponents.Gudermannian.GuidedFilter.GumbelDistribution.HaarWavelet.HadamardMatrix.HalfLine.HalfNormalDistribution.HalfPlane.HalfSpace.HalftoneShading.HamiltonianGraphQ.HammingDistance.HammingWindow.HandlerFunctions.HandlerFunctionsKeys.HankelH1.HankelH2.HankelMatrix.HankelTransform.HannPoissonWindow.HannWindow.HaradaNortonGroupHN.HararyGraph.HardcorePointProcess.HarmonicMean.HarmonicMeanFilter.HarmonicNumber.Hash.HatchFilling.HatchShading.Haversine.HazardFunction.Head.HeadCompose.HeaderAlignment.HeaderBackground.HeaderDisplayFunction.HeaderLines.Headers.HeaderSize.HeaderStyle.Heads.HeatFluxValue.HeatInsulationValue.HeatOutflowValue.HeatRadiationValue.HeatSymmetryValue.HeatTemperatureCondition.HeatTransferPDEComponent.HeatTransferValue.HeavisideLambda.HeavisidePi.HeavisideTheta.HeldGroupHe.HeldPart.HelmholtzPDEComponent.HelpBrowserLookup.HelpBrowserNotebook.HelpBrowserSettings.HelpViewerSettings.Here.HermiteDecomposition.HermiteH.Hermitian.HermitianMatrixQ.HessenbergDecomposition.Hessian.HeunB.HeunBPrime.HeunC.HeunCPrime.HeunD.HeunDPrime.HeunG.HeunGPrime.HeunT.HeunTPrime.HexadecimalCharacter.Hexahedron.HexahedronBox.HexahedronBoxOptions.HiddenItems.HiddenMarkovProcess.HiddenSurface.Highlighted.HighlightGraph.HighlightImage.HighlightMesh.HighlightString.HighpassFilter.HigmanSimsGroupHS.HilbertCurve.HilbertFilter.HilbertMatrix.Histogram.Histogram3D.HistogramDistribution.HistogramList.HistogramPointDensity.HistogramTransform.HistogramTransformInterpolation.HistoricalPeriodData.HitMissTransform.HITSCentrality.HjorthDistribution.HodgeDual.HoeffdingD.HoeffdingDTest.Hold.HoldAll.HoldAllComplete.HoldComplete.HoldFirst.HoldForm.HoldPattern.HoldRest.HolidayCalendar.HomeDirectory.HomePage.Horizontal.HorizontalForm.HorizontalGauge.HorizontalScrollPosition.HornerForm.HostLookup.HotellingTSquareDistribution.HoytDistribution.HTMLSave.HTTPErrorResponse.HTTPRedirect.HTTPRequest.HTTPRequestData.HTTPResponse.Hue.HumanGrowthData.HumpDownHump.HumpEqual.HurwitzLerchPhi.HurwitzZeta.HyperbolicDistribution.HypercubeGraph.HyperexponentialDistribution.Hyperfactorial.Hypergeometric0F1.Hypergeometric0F1Regularized.Hypergeometric1F1.Hypergeometric1F1Regularized.Hypergeometric2F1.Hypergeometric2F1Regularized.HypergeometricDistribution.HypergeometricPFQ.HypergeometricPFQRegularized.HypergeometricU.Hyperlink.HyperlinkAction.HyperlinkCreationSettings.Hyperplane.Hyphenation.HyphenationOptions.HypoexponentialDistribution.HypothesisTestData.I.IconData.Iconize.IconizedObject.IconRules.Icosahedron.Identity.IdentityMatrix.If.IfCompiled.IgnoreCase.IgnoreDiacritics.IgnoreIsotopes.IgnorePunctuation.IgnoreSpellCheck.IgnoreStereochemistry.IgnoringInactive.Im.Image.Image3D.Image3DProjection.Image3DSlices.ImageAccumulate.ImageAdd.ImageAdjust.ImageAlign.ImageApply.ImageApplyIndexed.ImageAspectRatio.ImageAssemble.ImageAugmentationLayer.ImageBoundingBoxes.ImageCache.ImageCacheValid.ImageCapture.ImageCaptureFunction.ImageCases.ImageChannels.ImageClip.ImageCollage.ImageColorSpace.ImageCompose.ImageContainsQ.ImageContents.ImageConvolve.ImageCooccurrence.ImageCorners.ImageCorrelate.ImageCorrespondingPoints.ImageCrop.ImageData.ImageDeconvolve.ImageDemosaic.ImageDifference.ImageDimensions.ImageDisplacements.ImageDistance.ImageEditMode.ImageEffect.ImageExposureCombine.ImageFeatureTrack.ImageFileApply.ImageFileFilter.ImageFileScan.ImageFilter.ImageFocusCombine.ImageForestingComponents.ImageFormattingWidth.ImageForwardTransformation.ImageGraphics.ImageHistogram.ImageIdentify.ImageInstanceQ.ImageKeypoints.ImageLabels.ImageLegends.ImageLevels.ImageLines.ImageMargins.ImageMarker.ImageMarkers.ImageMeasurements.ImageMesh.ImageMultiply.ImageOffset.ImagePad.ImagePadding.ImagePartition.ImagePeriodogram.ImagePerspectiveTransformation.ImagePosition.ImagePreviewFunction.ImagePyramid.ImagePyramidApply.ImageQ.ImageRangeCache.ImageRecolor.ImageReflect.ImageRegion.ImageResize.ImageResolution.ImageRestyle.ImageRotate.ImageRotated.ImageSaliencyFilter.ImageScaled.ImageScan.ImageSize.ImageSizeAction.ImageSizeCache.ImageSizeMultipliers.ImageSizeRaw.ImageStitch.ImageSubtract.ImageTake.ImageTransformation.ImageTrim.ImageType.ImageValue.ImageValuePositions.ImageVectorscopePlot.ImageWaveformPlot.ImagingDevice.ImplicitD.ImplicitRegion.Implies.Import.ImportAutoReplacements.ImportByteArray.ImportedObject.ImportOptions.ImportString.ImprovementImportance.In.Inactivate.Inactive.InactiveStyle.IncidenceGraph.IncidenceList.IncidenceMatrix.IncludeAromaticBonds.IncludeConstantBasis.IncludedContexts.IncludeDefinitions.IncludeDirectories.IncludeFileExtension.IncludeGeneratorTasks.IncludeHydrogens.IncludeInflections.IncludeMetaInformation.IncludePods.IncludeQuantities.IncludeRelatedTables.IncludeSingularSolutions.IncludeSingularTerm.IncludeWindowTimes.Increment.IndefiniteMatrixQ.Indent.IndentingNewlineSpacings.IndentMaxFraction.IndependenceTest.IndependentEdgeSetQ.IndependentPhysicalQuantity.IndependentUnit.IndependentUnitDimension.IndependentVertexSetQ.Indeterminate.IndeterminateThreshold.IndexCreationOptions.Indexed.IndexEdgeTaggedGraph.IndexGraph.IndexTag.Inequality.InertEvaluate.InertExpression.InexactNumberQ.InexactNumbers.InfiniteFuture.InfiniteLine.InfiniteLineThrough.InfinitePast.InfinitePlane.Infinity.Infix.InflationAdjust.InflationMethod.Information.InformationData.InformationDataGrid.Inherited.InheritScope.InhomogeneousPoissonPointProcess.InhomogeneousPoissonProcess.InitialEvaluationHistory.Initialization.InitializationCell.InitializationCellEvaluation.InitializationCellWarning.InitializationObject.InitializationObjects.InitializationValue.Initialize.InitialSeeding.InlineCounterAssignments.InlineCounterIncrements.InlineRules.Inner.InnerPolygon.InnerPolyhedron.Inpaint.Input.InputAliases.InputAssumptions.InputAutoReplacements.InputField.InputFieldBox.InputFieldBoxOptions.InputForm.InputGrouping.InputNamePacket.InputNotebook.InputPacket.InputPorts.InputSettings.InputStream.InputString.InputStringPacket.InputToBoxFormPacket.Insert.InsertionFunction.InsertionPointObject.InsertLinebreaks.InsertResults.Inset.Inset3DBox.Inset3DBoxOptions.InsetBox.InsetBoxOptions.Insphere.Install.InstallService.InstanceNormalizationLayer.InString.Integer.IntegerDigits.IntegerExponent.IntegerLength.IntegerName.IntegerPart.IntegerPartitions.IntegerQ.IntegerReverse.Integers.IntegerString.Integral.Integrate.IntegrateChangeVariables.Interactive.InteractiveTradingChart.InterfaceSwitched.Interlaced.Interleaving.InternallyBalancedDecomposition.InterpolatingFunction.InterpolatingPolynomial.Interpolation.InterpolationOrder.InterpolationPoints.InterpolationPrecision.Interpretation.InterpretationBox.InterpretationBoxOptions.InterpretationFunction.Interpreter.InterpretTemplate.InterquartileRange.Interrupt.InterruptSettings.IntersectedEntityClass.IntersectingQ.Intersection.Interval.IntervalIntersection.IntervalMarkers.IntervalMarkersStyle.IntervalMemberQ.IntervalSlider.IntervalUnion.Into.Inverse.InverseBetaRegularized.InverseBilateralLaplaceTransform.InverseBilateralZTransform.InverseCDF.InverseChiSquareDistribution.InverseContinuousWaveletTransform.InverseDistanceTransform.InverseEllipticNomeQ.InverseErf.InverseErfc.InverseFourier.InverseFourierCosTransform.InverseFourierSequenceTransform.InverseFourierSinTransform.InverseFourierTransform.InverseFunction.InverseFunctions.InverseGammaDistribution.InverseGammaRegularized.InverseGaussianDistribution.InverseGudermannian.InverseHankelTransform.InverseHaversine.InverseImagePyramid.InverseJacobiCD.InverseJacobiCN.InverseJacobiCS.InverseJacobiDC.InverseJacobiDN.InverseJacobiDS.InverseJacobiNC.InverseJacobiND.InverseJacobiNS.InverseJacobiSC.InverseJacobiSD.InverseJacobiSN.InverseLaplaceTransform.InverseMellinTransform.InversePermutation.InverseRadon.InverseRadonTransform.InverseSeries.InverseShortTimeFourier.InverseSpectrogram.InverseSurvivalFunction.InverseTransformedRegion.InverseWaveletTransform.InverseWeierstrassP.InverseWishartMatrixDistribution.InverseZTransform.Invisible.InvisibleApplication.InvisibleTimes.IPAddress.IrreduciblePolynomialQ.IslandData.IsolatingInterval.IsomorphicGraphQ.IsomorphicSubgraphQ.IsotopeData.Italic.Item.ItemAspectRatio.ItemBox.ItemBoxOptions.ItemDisplayFunction.ItemSize.ItemStyle.ItoProcess.JaccardDissimilarity.JacobiAmplitude.Jacobian.JacobiCD.JacobiCN.JacobiCS.JacobiDC.JacobiDN.JacobiDS.JacobiEpsilon.JacobiNC.JacobiND.JacobiNS.JacobiP.JacobiSC.JacobiSD.JacobiSN.JacobiSymbol.JacobiZeta.JacobiZN.JankoGroupJ1.JankoGroupJ2.JankoGroupJ3.JankoGroupJ4.JarqueBeraALMTest.JohnsonDistribution.Join.JoinAcross.Joined.JoinedCurve.JoinedCurveBox.JoinedCurveBoxOptions.JoinForm.JordanDecomposition.JordanModelDecomposition.JulianDate.JuliaSetBoettcher.JuliaSetIterationCount.JuliaSetPlot.JuliaSetPoints.K.KagiChart.KaiserBesselWindow.KaiserWindow.KalmanEstimator.KalmanFilter.KarhunenLoeveDecomposition.KaryTree.KatzCentrality.KCoreComponents.KDistribution.KEdgeConnectedComponents.KEdgeConnectedGraphQ.KeepExistingVersion.KelvinBei.KelvinBer.KelvinKei.KelvinKer.KendallTau.KendallTauTest.KernelConfiguration.KernelExecute.KernelFunction.KernelMixtureDistribution.KernelObject.Kernels.Ket.Key.KeyCollisionFunction.KeyComplement.KeyDrop.KeyDropFrom.KeyExistsQ.KeyFreeQ.KeyIntersection.KeyMap.KeyMemberQ.KeypointStrength.Keys.KeySelect.KeySort.KeySortBy.KeyTake.KeyUnion.KeyValueMap.KeyValuePattern.Khinchin.KillProcess.KirchhoffGraph.KirchhoffMatrix.KleinInvariantJ.KnapsackSolve.KnightTourGraph.KnotData.KnownUnitQ.KochCurve.KolmogorovSmirnovTest.KroneckerDelta.KroneckerModelDecomposition.KroneckerProduct.KroneckerSymbol.KuiperTest.KumaraswamyDistribution.Kurtosis.KuwaharaFilter.KVertexConnectedComponents.KVertexConnectedGraphQ.LABColor.Label.Labeled.LabeledSlider.LabelingFunction.LabelingSize.LabelStyle.LabelVisibility.LaguerreL.LakeData.LambdaComponents.LambertW.LameC.LameCPrime.LameEigenvalueA.LameEigenvalueB.LameS.LameSPrime.LaminaData.LanczosWindow.LandauDistribution.Language.LanguageCategory.LanguageData.LanguageIdentify.LanguageOptions.LaplaceDistribution.LaplaceTransform.Laplacian.LaplacianFilter.LaplacianGaussianFilter.LaplacianPDETerm.Large.Larger.Last.Latitude.LatitudeLongitude.LatticeData.LatticeReduce.Launch.LaunchKernels.LayeredGraphPlot.LayeredGraphPlot3D.LayerSizeFunction.LayoutInformation.LCHColor.LCM.LeaderSize.LeafCount.LeapVariant.LeapYearQ.LearnDistribution.LearnedDistribution.LearningRate.LearningRateMultipliers.LeastSquares.LeastSquaresFilterKernel.Left.LeftArrow.LeftArrowBar.LeftArrowRightArrow.LeftDownTeeVector.LeftDownVector.LeftDownVectorBar.LeftRightArrow.LeftRightVector.LeftTee.LeftTeeArrow.LeftTeeVector.LeftTriangle.LeftTriangleBar.LeftTriangleEqual.LeftUpDownVector.LeftUpTeeVector.LeftUpVector.LeftUpVectorBar.LeftVector.LeftVectorBar.LegendAppearance.Legended.LegendFunction.LegendLabel.LegendLayout.LegendMargins.LegendMarkers.LegendMarkerSize.LegendreP.LegendreQ.LegendreType.Length.LengthWhile.LerchPhi.Less.LessEqual.LessEqualGreater.LessEqualThan.LessFullEqual.LessGreater.LessLess.LessSlantEqual.LessThan.LessTilde.LetterCharacter.LetterCounts.LetterNumber.LetterQ.Level.LeveneTest.LeviCivitaTensor.LevyDistribution.Lexicographic.LexicographicOrder.LexicographicSort.LibraryDataType.LibraryFunction.LibraryFunctionDeclaration.LibraryFunctionError.LibraryFunctionInformation.LibraryFunctionLoad.LibraryFunctionUnload.LibraryLoad.LibraryUnload.LicenseEntitlementObject.LicenseEntitlements.LicenseID.LicensingSettings.LiftingFilterData.LiftingWaveletTransform.LightBlue.LightBrown.LightCyan.Lighter.LightGray.LightGreen.Lighting.LightingAngle.LightMagenta.LightOrange.LightPink.LightPurple.LightRed.LightSources.LightYellow.Likelihood.Limit.LimitsPositioning.LimitsPositioningTokens.LindleyDistribution.Line.Line3DBox.Line3DBoxOptions.LinearFilter.LinearFractionalOptimization.LinearFractionalTransform.LinearGradientFilling.LinearGradientImage.LinearizingTransformationData.LinearLayer.LinearModelFit.LinearOffsetFunction.LinearOptimization.LinearProgramming.LinearRecurrence.LinearSolve.LinearSolveFunction.LineBox.LineBoxOptions.LineBreak.LinebreakAdjustments.LineBreakChart.LinebreakSemicolonWeighting.LineBreakWithin.LineColor.LineGraph.LineIndent.LineIndentMaxFraction.LineIntegralConvolutionPlot.LineIntegralConvolutionScale.LineLegend.LineOpacity.LineSpacing.LineWrapParts.LinkActivate.LinkClose.LinkConnect.LinkConnectedQ.LinkCreate.LinkError.LinkFlush.LinkFunction.LinkHost.LinkInterrupt.LinkLaunch.LinkMode.LinkObject.LinkOpen.LinkOptions.LinkPatterns.LinkProtocol.LinkRankCentrality.LinkRead.LinkReadHeld.LinkReadyQ.Links.LinkService.LinkWrite.LinkWriteHeld.LiouvilleLambda.List.Listable.ListAnimate.ListContourPlot.ListContourPlot3D.ListConvolve.ListCorrelate.ListCurvePathPlot.ListDeconvolve.ListDensityPlot.ListDensityPlot3D.Listen.ListFormat.ListFourierSequenceTransform.ListInterpolation.ListLineIntegralConvolutionPlot.ListLinePlot.ListLinePlot3D.ListLogLinearPlot.ListLogLogPlot.ListLogPlot.ListPicker.ListPickerBox.ListPickerBoxBackground.ListPickerBoxOptions.ListPlay.ListPlot.ListPlot3D.ListPointPlot3D.ListPolarPlot.ListQ.ListSliceContourPlot3D.ListSliceDensityPlot3D.ListSliceVectorPlot3D.ListStepPlot.ListStreamDensityPlot.ListStreamPlot.ListStreamPlot3D.ListSurfacePlot3D.ListVectorDensityPlot.ListVectorDisplacementPlot.ListVectorDisplacementPlot3D.ListVectorPlot.ListVectorPlot3D.ListZTransform.Literal.LiteralSearch.LiteralType.LoadCompiledComponent.LocalAdaptiveBinarize.LocalCache.LocalClusteringCoefficient.LocalEvaluate.LocalizeDefinitions.LocalizeVariables.LocalObject.LocalObjects.LocalResponseNormalizationLayer.LocalSubmit.LocalSymbol.LocalTime.LocalTimeZone.LocationEquivalenceTest.LocationTest.Locator.LocatorAutoCreate.LocatorBox.LocatorBoxOptions.LocatorCentering.LocatorPane.LocatorPaneBox.LocatorPaneBoxOptions.LocatorRegion.Locked.Log.Log10.Log2.LogBarnesG.LogGamma.LogGammaDistribution.LogicalExpand.LogIntegral.LogisticDistribution.LogisticSigmoid.LogitModelFit.LogLikelihood.LogLinearPlot.LogLogisticDistribution.LogLogPlot.LogMultinormalDistribution.LogNormalDistribution.LogPlot.LogRankTest.LogSeriesDistribution.LongEqual.Longest.LongestCommonSequence.LongestCommonSequencePositions.LongestCommonSubsequence.LongestCommonSubsequencePositions.LongestMatch.LongestOrderedSequence.LongForm.Longitude.LongLeftArrow.LongLeftRightArrow.LongRightArrow.LongShortTermMemoryLayer.Lookup.Loopback.LoopFreeGraphQ.Looping.LossFunction.LowerCaseQ.LowerLeftArrow.LowerRightArrow.LowerTriangularize.LowerTriangularMatrix.LowerTriangularMatrixQ.LowpassFilter.LQEstimatorGains.LQGRegulator.LQOutputRegulatorGains.LQRegulatorGains.LUBackSubstitution.LucasL.LuccioSamiComponents.LUDecomposition.LunarEclipse.LUVColor.LyapunovSolve.LyonsGroupLy.MachineID.MachineName.MachineNumberQ.MachinePrecision.MacintoshSystemPageSetup.Magenta.Magnification.Magnify.MailAddressValidation.MailExecute.MailFolder.MailItem.MailReceiverFunction.MailResponseFunction.MailSearch.MailServerConnect.MailServerConnection.MailSettings.MainSolve.MaintainDynamicCaches.Majority.MakeBoxes.MakeExpression.MakeRules.ManagedLibraryExpressionID.ManagedLibraryExpressionQ.MandelbrotSetBoettcher.MandelbrotSetDistance.MandelbrotSetIterationCount.MandelbrotSetMemberQ.MandelbrotSetPlot.MangoldtLambda.ManhattanDistance.Manipulate.Manipulator.MannedSpaceMissionData.MannWhitneyTest.MantissaExponent.Manual.Map.MapAll.MapApply.MapAt.MapIndexed.MAProcess.MapThread.MarchenkoPasturDistribution.MarcumQ.MardiaCombinedTest.MardiaKurtosisTest.MardiaSkewnessTest.MarginalDistribution.MarkovProcessProperties.Masking.MassConcentrationCondition.MassFluxValue.MassImpermeableBoundaryValue.MassOutflowValue.MassSymmetryValue.MassTransferValue.MassTransportPDEComponent.MatchingDissimilarity.MatchLocalNameQ.MatchLocalNames.MatchQ.Material.MaterialShading.MaternPointProcess.MathematicalFunctionData.MathematicaNotation.MathieuC.MathieuCharacteristicA.MathieuCharacteristicB.MathieuCharacteristicExponent.MathieuCPrime.MathieuGroupM11.MathieuGroupM12.MathieuGroupM22.MathieuGroupM23.MathieuGroupM24.MathieuS.MathieuSPrime.MathMLForm.MathMLText.Matrices.MatrixExp.MatrixForm.MatrixFunction.MatrixLog.MatrixNormalDistribution.MatrixPlot.MatrixPower.MatrixPropertyDistribution.MatrixQ.MatrixRank.MatrixTDistribution.Max.MaxBend.MaxCellMeasure.MaxColorDistance.MaxDate.MaxDetect.MaxDisplayedChildren.MaxDuration.MaxExtraBandwidths.MaxExtraConditions.MaxFeatureDisplacement.MaxFeatures.MaxFilter.MaximalBy.Maximize.MaxItems.MaxIterations.MaxLimit.MaxMemoryUsed.MaxMixtureKernels.MaxOverlapFraction.MaxPlotPoints.MaxPoints.MaxRecursion.MaxStableDistribution.MaxStepFraction.MaxSteps.MaxStepSize.MaxTrainingRounds.MaxValue.MaxwellDistribution.MaxWordGap.McLaughlinGroupMcL.Mean.MeanAbsoluteLossLayer.MeanAround.MeanClusteringCoefficient.MeanDegreeConnectivity.MeanDeviation.MeanFilter.MeanGraphDistance.MeanNeighborDegree.MeanPointDensity.MeanShift.MeanShiftFilter.MeanSquaredLossLayer.Median.MedianDeviation.MedianFilter.MedicalTestData.Medium.MeijerG.MeijerGReduce.MeixnerDistribution.MellinConvolve.MellinTransform.MemberQ.MemoryAvailable.MemoryConstrained.MemoryConstraint.MemoryInUse.MengerMesh.Menu.MenuAppearance.MenuCommandKey.MenuEvaluator.MenuItem.MenuList.MenuPacket.MenuSortingValue.MenuStyle.MenuView.Merge.MergeDifferences.MergingFunction.MersennePrimeExponent.MersennePrimeExponentQ.Mesh.MeshCellCentroid.MeshCellCount.MeshCellHighlight.MeshCellIndex.MeshCellLabel.MeshCellMarker.MeshCellMeasure.MeshCellQuality.MeshCells.MeshCellShapeFunction.MeshCellStyle.MeshConnectivityGraph.MeshCoordinates.MeshFunctions.MeshPrimitives.MeshQualityGoal.MeshRange.MeshRefinementFunction.MeshRegion.MeshRegionQ.MeshShading.MeshStyle.Message.MessageDialog.MessageList.MessageName.MessageObject.MessageOptions.MessagePacket.Messages.MessagesNotebook.MetaCharacters.MetaInformation.MeteorShowerData.Method.MethodOptions.MexicanHatWavelet.MeyerWavelet.Midpoint.MIMETypeToFormatList.Min.MinColorDistance.MinDate.MinDetect.MineralData.MinFilter.MinimalBy.MinimalPolynomial.MinimalStateSpaceModel.Minimize.MinimumTimeIncrement.MinIntervalSize.MinkowskiQuestionMark.MinLimit.MinMax.MinorPlanetData.Minors.MinPointSeparation.MinRecursion.MinSize.MinStableDistribution.Minus.MinusPlus.MinValue.Missing.MissingBehavior.MissingDataMethod.MissingDataRules.MissingQ.MissingString.MissingStyle.MissingValuePattern.MissingValueSynthesis.MittagLefflerE.MixedFractionParts.MixedGraphQ.MixedMagnitude.MixedRadix.MixedRadixQuantity.MixedUnit.MixtureDistribution.Mod.Modal.Mode.ModelPredictiveController.Modular.ModularInverse.ModularLambda.Module.Modulus.MoebiusMu.Molecule.MoleculeAlign.MoleculeContainsQ.MoleculeDraw.MoleculeEquivalentQ.MoleculeFreeQ.MoleculeGraph.MoleculeMatchQ.MoleculeMaximumCommonSubstructure.MoleculeModify.MoleculeName.MoleculePattern.MoleculePlot.MoleculePlot3D.MoleculeProperty.MoleculeQ.MoleculeRecognize.MoleculeSubstructureCount.MoleculeValue.Moment.MomentConvert.MomentEvaluate.MomentGeneratingFunction.MomentOfInertia.Monday.Monitor.MonomialList.MonomialOrder.MonsterGroupM.MoonPhase.MoonPosition.MorletWavelet.MorphologicalBinarize.MorphologicalBranchPoints.MorphologicalComponents.MorphologicalEulerNumber.MorphologicalGraph.MorphologicalPerimeter.MorphologicalTransform.MortalityData.Most.MountainData.MouseAnnotation.MouseAppearance.MouseAppearanceTag.MouseButtons.Mouseover.MousePointerNote.MousePosition.MovieData.MovingAverage.MovingMap.MovingMedian.MoyalDistribution.MultiaxisArrangement.Multicolumn.MultiedgeStyle.MultigraphQ.MultilaunchWarning.MultiLetterItalics.MultiLetterStyle.MultilineFunction.Multinomial.MultinomialDistribution.MultinormalDistribution.MultiplicativeOrder.Multiplicity.MultiplySides.MultiscriptBoxOptions.Multiselection.MultivariateHypergeometricDistribution.MultivariatePoissonDistribution.MultivariateTDistribution.N.NakagamiDistribution.NameQ.Names.NamespaceBox.NamespaceBoxOptions.Nand.NArgMax.NArgMin.NBernoulliB.NBodySimulation.NBodySimulationData.NCache.NCaputoD.NDEigensystem.NDEigenvalues.NDSolve.NDSolveValue.Nearest.NearestFunction.NearestMeshCells.NearestNeighborG.NearestNeighborGraph.NearestTo.NebulaData.NeedlemanWunschSimilarity.Needs.Negative.NegativeBinomialDistribution.NegativeDefiniteMatrixQ.NegativeIntegers.NegativelyOrientedPoints.NegativeMultinomialDistribution.NegativeRationals.NegativeReals.NegativeSemidefiniteMatrixQ.NeighborhoodData.NeighborhoodGraph.Nest.NestedGreaterGreater.NestedLessLess.NestedScriptRules.NestGraph.NestList.NestTree.NestWhile.NestWhileList.NetAppend.NetArray.NetArrayLayer.NetBidirectionalOperator.NetChain.NetDecoder.NetDelete.NetDrop.NetEncoder.NetEvaluationMode.NetExternalObject.NetExtract.NetFlatten.NetFoldOperator.NetGANOperator.NetGraph.NetInformation.NetInitialize.NetInsert.NetInsertSharedArrays.NetJoin.NetMapOperator.NetMapThreadOperator.NetMeasurements.NetModel.NetNestOperator.NetPairEmbeddingOperator.NetPort.NetPortGradient.NetPrepend.NetRename.NetReplace.NetReplacePart.NetSharedArray.NetStateObject.NetTake.NetTrain.NetTrainResultsObject.NetUnfold.NetworkPacketCapture.NetworkPacketRecording.NetworkPacketRecordingDuring.NetworkPacketTrace.NeumannValue.NevilleThetaC.NevilleThetaD.NevilleThetaN.NevilleThetaS.NewPrimitiveStyle.NExpectation.Next.NextCell.NextDate.NextPrime.NextScheduledTaskTime.NeymanScottPointProcess.NFractionalD.NHoldAll.NHoldFirst.NHoldRest.NicholsGridLines.NicholsPlot.NightHemisphere.NIntegrate.NMaximize.NMaxValue.NMinimize.NMinValue.NominalScale.NominalVariables.NonAssociative.NoncentralBetaDistribution.NoncentralChiSquareDistribution.NoncentralFRatioDistribution.NoncentralStudentTDistribution.NonCommutativeMultiply.NonConstants.NondimensionalizationTransform.None.NoneTrue.NonlinearModelFit.NonlinearStateSpaceModel.NonlocalMeansFilter.NonNegative.NonNegativeIntegers.NonNegativeRationals.NonNegativeReals.NonPositive.NonPositiveIntegers.NonPositiveRationals.NonPositiveReals.Nor.NorlundB.Norm.Normal.NormalDistribution.NormalGrouping.NormalizationLayer.Normalize.Normalized.NormalizedSquaredEuclideanDistance.NormalMatrixQ.NormalsFunction.NormFunction.Not.NotCongruent.NotCupCap.NotDoubleVerticalBar.Notebook.NotebookApply.NotebookAutoSave.NotebookBrowseDirectory.NotebookClose.NotebookConvertSettings.NotebookCreate.NotebookDefault.NotebookDelete.NotebookDirectory.NotebookDynamicExpression.NotebookEvaluate.NotebookEventActions.NotebookFileName.NotebookFind.NotebookGet.NotebookImport.NotebookInformation.NotebookInterfaceObject.NotebookLocate.NotebookObject.NotebookOpen.NotebookPath.NotebookPrint.NotebookPut.NotebookRead.Notebooks.NotebookSave.NotebookSelection.NotebooksMenu.NotebookTemplate.NotebookWrite.NotElement.NotEqualTilde.NotExists.NotGreater.NotGreaterEqual.NotGreaterFullEqual.NotGreaterGreater.NotGreaterLess.NotGreaterSlantEqual.NotGreaterTilde.Nothing.NotHumpDownHump.NotHumpEqual.NotificationFunction.NotLeftTriangle.NotLeftTriangleBar.NotLeftTriangleEqual.NotLess.NotLessEqual.NotLessFullEqual.NotLessGreater.NotLessLess.NotLessSlantEqual.NotLessTilde.NotNestedGreaterGreater.NotNestedLessLess.NotPrecedes.NotPrecedesEqual.NotPrecedesSlantEqual.NotPrecedesTilde.NotReverseElement.NotRightTriangle.NotRightTriangleBar.NotRightTriangleEqual.NotSquareSubset.NotSquareSubsetEqual.NotSquareSuperset.NotSquareSupersetEqual.NotSubset.NotSubsetEqual.NotSucceeds.NotSucceedsEqual.NotSucceedsSlantEqual.NotSucceedsTilde.NotSuperset.NotSupersetEqual.NotTilde.NotTildeEqual.NotTildeFullEqual.NotTildeTilde.NotVerticalBar.Now.NoWhitespace.NProbability.NProduct.NProductFactors.NRoots.NSolve.NSolveValues.NSum.NSumTerms.NuclearExplosionData.NuclearReactorData.Null.NullRecords.NullSpace.NullWords.Number.NumberCompose.NumberDecompose.NumberDigit.NumberExpand.NumberFieldClassNumber.NumberFieldDiscriminant.NumberFieldFundamentalUnits.NumberFieldIntegralBasis.NumberFieldNormRepresentatives.NumberFieldRegulator.NumberFieldRootsOfUnity.NumberFieldSignature.NumberForm.NumberFormat.NumberLinePlot.NumberMarks.NumberMultiplier.NumberPadding.NumberPoint.NumberQ.NumberSeparator.NumberSigns.NumberString.Numerator.NumeratorDenominator.NumericalOrder.NumericalSort.NumericArray.NumericArrayQ.NumericArrayType.NumericFunction.NumericQ.NuttallWindow.NValues.NyquistGridLines.NyquistPlot.O.ObjectExistsQ.ObservabilityGramian.ObservabilityMatrix.ObservableDecomposition.ObservableModelQ.OceanData.Octahedron.OddQ.Off.Offset.OLEData.On.ONanGroupON.Once.OneIdentity.Opacity.OpacityFunction.OpacityFunctionScaling.Open.OpenAppend.Opener.OpenerBox.OpenerBoxOptions.OpenerView.OpenFunctionInspectorPacket.Opening.OpenRead.OpenSpecialOptions.OpenTemporary.OpenWrite.Operate.OperatingSystem.OperatorApplied.OptimumFlowData.Optional.OptionalElement.OptionInspectorSettings.OptionQ.Options.OptionsPacket.OptionsPattern.OptionValue.OptionValueBox.OptionValueBoxOptions.Or.Orange.Order.OrderDistribution.OrderedQ.Ordering.OrderingBy.OrderingLayer.Orderless.OrderlessPatternSequence.OrdinalScale.OrnsteinUhlenbeckProcess.Orthogonalize.OrthogonalMatrixQ.Out.Outer.OuterPolygon.OuterPolyhedron.OutputAutoOverwrite.OutputControllabilityMatrix.OutputControllableModelQ.OutputForm.OutputFormData.OutputGrouping.OutputMathEditExpression.OutputNamePacket.OutputPorts.OutputResponse.OutputSizeLimit.OutputStream.Over.OverBar.OverDot.Overflow.OverHat.Overlaps.Overlay.OverlayBox.OverlayBoxOptions.OverlayVideo.Overscript.OverscriptBox.OverscriptBoxOptions.OverTilde.OverVector.OverwriteTarget.OwenT.OwnValues.Package.PackingMethod.PackPaclet.PacletDataRebuild.PacletDirectoryAdd.PacletDirectoryLoad.PacletDirectoryRemove.PacletDirectoryUnload.PacletDisable.PacletEnable.PacletFind.PacletFindRemote.PacletInformation.PacletInstall.PacletInstallSubmit.PacletNewerQ.PacletObject.PacletObjectQ.PacletSite.PacletSiteObject.PacletSiteRegister.PacletSites.PacletSiteUnregister.PacletSiteUpdate.PacletSymbol.PacletUninstall.PacletUpdate.PaddedForm.Padding.PaddingLayer.PaddingSize.PadeApproximant.PadLeft.PadRight.PageBreakAbove.PageBreakBelow.PageBreakWithin.PageFooterLines.PageFooters.PageHeaderLines.PageHeaders.PageHeight.PageRankCentrality.PageTheme.PageWidth.Pagination.PairCorrelationG.PairedBarChart.PairedHistogram.PairedSmoothHistogram.PairedTTest.PairedZTest.PaletteNotebook.PalettePath.PalettesMenuSettings.PalindromeQ.Pane.PaneBox.PaneBoxOptions.Panel.PanelBox.PanelBoxOptions.Paneled.PaneSelector.PaneSelectorBox.PaneSelectorBoxOptions.PaperWidth.ParabolicCylinderD.ParagraphIndent.ParagraphSpacing.ParallelArray.ParallelAxisPlot.ParallelCombine.ParallelDo.Parallelepiped.ParallelEvaluate.Parallelization.Parallelize.ParallelKernels.ParallelMap.ParallelNeeds.Parallelogram.ParallelProduct.ParallelSubmit.ParallelSum.ParallelTable.ParallelTry.Parameter.ParameterEstimator.ParameterMixtureDistribution.ParameterVariables.ParametricConvexOptimization.ParametricFunction.ParametricNDSolve.ParametricNDSolveValue.ParametricPlot.ParametricPlot3D.ParametricRampLayer.ParametricRegion.ParentBox.ParentCell.ParentConnect.ParentDirectory.ParentEdgeLabel.ParentEdgeLabelFunction.ParentEdgeLabelStyle.ParentEdgeShapeFunction.ParentEdgeStyle.ParentEdgeStyleFunction.ParentForm.Parenthesize.ParentList.ParentNotebook.ParetoDistribution.ParetoPickandsDistribution.ParkData.Part.PartBehavior.PartialCorrelationFunction.PartialD.ParticleAcceleratorData.ParticleData.Partition.PartitionGranularity.PartitionsP.PartitionsQ.PartLayer.PartOfSpeech.PartProtection.ParzenWindow.PascalDistribution.PassEventsDown.PassEventsUp.Paste.PasteAutoQuoteCharacters.PasteBoxFormInlineCells.PasteButton.Path.PathGraph.PathGraphQ.Pattern.PatternFilling.PatternReaction.PatternSequence.PatternTest.PauliMatrix.PaulWavelet.Pause.PausedTime.PDF.PeakDetect.PeanoCurve.PearsonChiSquareTest.PearsonCorrelationTest.PearsonDistribution.PenttinenPointProcess.PercentForm.PerfectNumber.PerfectNumberQ.PerformanceGoal.Perimeter.PeriodicBoundaryCondition.PeriodicInterpolation.Periodogram.PeriodogramArray.Permanent.Permissions.PermissionsGroup.PermissionsGroupMemberQ.PermissionsGroups.PermissionsKey.PermissionsKeys.PermutationCycles.PermutationCyclesQ.PermutationGroup.PermutationLength.PermutationList.PermutationListQ.PermutationMatrix.PermutationMax.PermutationMin.PermutationOrder.PermutationPower.PermutationProduct.PermutationReplace.Permutations.PermutationSupport.Permute.PeronaMalikFilter.Perpendicular.PerpendicularBisector.PersistenceLocation.PersistenceTime.PersistentObject.PersistentObjects.PersistentSymbol.PersistentValue.PersonData.PERTDistribution.PetersenGraph.PhaseMargins.PhaseRange.PhongShading.PhysicalSystemData.Pi.Pick.PickedElements.PickMode.PIDData.PIDDerivativeFilter.PIDFeedforward.PIDTune.Piecewise.PiecewiseExpand.PieChart.PieChart3D.PillaiTrace.PillaiTraceTest.PingTime.Pink.PitchRecognize.Pivoting.PixelConstrained.PixelValue.PixelValuePositions.Placed.Placeholder.PlaceholderLayer.PlaceholderReplace.Plain.PlanarAngle.PlanarFaceList.PlanarGraph.PlanarGraphQ.PlanckRadiationLaw.PlaneCurveData.PlanetaryMoonData.PlanetData.PlantData.Play.PlaybackSettings.PlayRange.Plot.Plot3D.Plot3Matrix.PlotDivision.PlotJoined.PlotLabel.PlotLabels.PlotLayout.PlotLegends.PlotMarkers.PlotPoints.PlotRange.PlotRangeClipping.PlotRangeClipPlanesStyle.PlotRangePadding.PlotRegion.PlotStyle.PlotTheme.Pluralize.Plus.PlusMinus.Pochhammer.PodStates.PodWidth.Point.Point3DBox.Point3DBoxOptions.PointBox.PointBoxOptions.PointCountDistribution.PointDensity.PointDensityFunction.PointFigureChart.PointLegend.PointLight.PointProcessEstimator.PointProcessFitTest.PointProcessParameterAssumptions.PointProcessParameterQ.PointSize.PointStatisticFunction.PointValuePlot.PoissonConsulDistribution.PoissonDistribution.PoissonPDEComponent.PoissonPointProcess.PoissonProcess.PoissonWindow.PolarAxes.PolarAxesOrigin.PolarGridLines.PolarPlot.PolarTicks.PoleZeroMarkers.PolyaAeppliDistribution.PolyGamma.Polygon.Polygon3DBox.Polygon3DBoxOptions.PolygonalNumber.PolygonAngle.PolygonBox.PolygonBoxOptions.PolygonCoordinates.PolygonDecomposition.PolygonHoleScale.PolygonIntersections.PolygonScale.Polyhedron.PolyhedronAngle.PolyhedronBox.PolyhedronBoxOptions.PolyhedronCoordinates.PolyhedronData.PolyhedronDecomposition.PolyhedronGenus.PolyLog.PolynomialExpressionQ.PolynomialExtendedGCD.PolynomialForm.PolynomialGCD.PolynomialLCM.PolynomialMod.PolynomialQ.PolynomialQuotient.PolynomialQuotientRemainder.PolynomialReduce.PolynomialRemainder.Polynomials.PolynomialSumOfSquaresList.PoolingLayer.PopupMenu.PopupMenuBox.PopupMenuBoxOptions.PopupView.PopupWindow.Position.PositionIndex.PositionLargest.PositionSmallest.Positive.PositiveDefiniteMatrixQ.PositiveIntegers.PositivelyOrientedPoints.PositiveRationals.PositiveReals.PositiveSemidefiniteMatrixQ.PossibleZeroQ.Postfix.PostScript.Power.PowerDistribution.PowerExpand.PowerMod.PowerModList.PowerRange.PowerSpectralDensity.PowersRepresentations.PowerSymmetricPolynomial.Precedence.PrecedenceForm.Precedes.PrecedesEqual.PrecedesSlantEqual.PrecedesTilde.Precision.PrecisionGoal.PreDecrement.Predict.PredictionRoot.PredictorFunction.PredictorInformation.PredictorMeasurements.PredictorMeasurementsObject.PreemptProtect.PreferencesPath.PreferencesSettings.Prefix.PreIncrement.Prepend.PrependLayer.PrependTo.PreprocessingRules.PreserveColor.PreserveImageOptions.Previous.PreviousCell.PreviousDate.PriceGraphDistribution.PrimaryPlaceholder.Prime.PrimeNu.PrimeOmega.PrimePi.PrimePowerQ.PrimeQ.Primes.PrimeZetaP.PrimitivePolynomialQ.PrimitiveRoot.PrimitiveRootList.PrincipalComponents.PrincipalValue.Print.PrintableASCIIQ.PrintAction.PrintForm.PrintingCopies.PrintingOptions.PrintingPageRange.PrintingStartingPageNumber.PrintingStyleEnvironment.Printout3D.Printout3DPreviewer.PrintPrecision.PrintTemporary.Prism.PrismBox.PrismBoxOptions.PrivateCellOptions.PrivateEvaluationOptions.PrivateFontOptions.PrivateFrontEndOptions.PrivateKey.PrivateNotebookOptions.PrivatePaths.Probability.ProbabilityDistribution.ProbabilityPlot.ProbabilityPr.ProbabilityScalePlot.ProbitModelFit.ProcessConnection.ProcessDirectory.ProcessEnvironment.Processes.ProcessEstimator.ProcessInformation.ProcessObject.ProcessParameterAssumptions.ProcessParameterQ.ProcessStateDomain.ProcessStatus.ProcessTimeDomain.Product.ProductDistribution.ProductLog.ProgressIndicator.ProgressIndicatorBox.ProgressIndicatorBoxOptions.ProgressReporting.Projection.Prolog.PromptForm.ProofObject.PropagateAborts.Properties.Property.PropertyList.PropertyValue.Proportion.Proportional.Protect.Protected.ProteinData.Pruning.PseudoInverse.PsychrometricPropertyData.PublicKey.PublisherID.PulsarData.PunctuationCharacter.Purple.Put.PutAppend.Pyramid.PyramidBox.PyramidBoxOptions.QBinomial.QFactorial.QGamma.QHypergeometricPFQ.QnDispersion.QPochhammer.QPolyGamma.QRDecomposition.QuadraticIrrationalQ.QuadraticOptimization.Quantile.QuantilePlot.Quantity.QuantityArray.QuantityDistribution.QuantityForm.QuantityMagnitude.QuantityQ.QuantityUnit.QuantityVariable.QuantityVariableCanonicalUnit.QuantityVariableDimensions.QuantityVariableIdentifier.QuantityVariablePhysicalQuantity.Quartics.QuartileDeviation.Quartiles.QuartileSkewness.Query.QuestionGenerator.QuestionInterface.QuestionObject.QuestionSelector.QueueingNetworkProcess.QueueingProcess.QueueProperties.Quiet.QuietEcho.Quit.Quotient.QuotientRemainder.RadialAxisPlot.RadialGradientFilling.RadialGradientImage.RadialityCentrality.RadicalBox.RadicalBoxOptions.RadioButton.RadioButtonBar.RadioButtonBox.RadioButtonBoxOptions.Radon.RadonTransform.RamanujanTau.RamanujanTauL.RamanujanTauTheta.RamanujanTauZ.Ramp.Random.RandomArrayLayer.RandomChoice.RandomColor.RandomComplex.RandomDate.RandomEntity.RandomFunction.RandomGeneratorState.RandomGeoPosition.RandomGraph.RandomImage.RandomInstance.RandomInteger.RandomPermutation.RandomPoint.RandomPointConfiguration.RandomPolygon.RandomPolyhedron.RandomPrime.RandomReal.RandomSample.RandomSeed.RandomSeeding.RandomTime.RandomTree.RandomVariate.RandomWalkProcess.RandomWord.Range.RangeFilter.RangeSpecification.RankedMax.RankedMin.RarerProbability.Raster.Raster3D.Raster3DBox.Raster3DBoxOptions.RasterArray.RasterBox.RasterBoxOptions.Rasterize.RasterSize.Rational.RationalExpressionQ.RationalFunctions.Rationalize.Rationals.Ratios.RawArray.RawBoxes.RawData.RawMedium.RayleighDistribution.Re.ReactionBalance.ReactionBalancedQ.ReactionPDETerm.Read.ReadByteArray.ReadLine.ReadList.ReadProtected.ReadString.Real.RealAbs.RealBlockDiagonalForm.RealDigits.RealExponent.Reals.RealSign.Reap.RebuildPacletData.RecalibrationFunction.RecognitionPrior.RecognitionThreshold.ReconstructionMesh.Record.RecordLists.RecordSeparators.Rectangle.RectangleBox.RectangleBoxOptions.RectangleChart.RectangleChart3D.RectangularRepeatingElement.RecurrenceFilter.RecurrenceTable.RecurringDigitsForm.Red.Reduce.RefBox.ReferenceLineStyle.ReferenceMarkers.ReferenceMarkerStyle.Refine.ReflectionMatrix.ReflectionTransform.Refresh.RefreshRate.Region.RegionBinarize.RegionBoundary.RegionBoundaryStyle.RegionBounds.RegionCentroid.RegionCongruent.RegionConvert.RegionDifference.RegionDilation.RegionDimension.RegionDisjoint.RegionDistance.RegionDistanceFunction.RegionEmbeddingDimension.RegionEqual.RegionErosion.RegionFillingStyle.RegionFit.RegionFunction.RegionImage.RegionIntersection.RegionMeasure.RegionMember.RegionMemberFunction.RegionMoment.RegionNearest.RegionNearestFunction.RegionPlot.RegionPlot3D.RegionProduct.RegionQ.RegionResize.RegionSimilar.RegionSize.RegionSymmetricDifference.RegionUnion.RegionWithin.RegisterExternalEvaluator.RegularExpression.Regularization.RegularlySampledQ.RegularPolygon.ReIm.ReImLabels.ReImPlot.ReImStyle.Reinstall.RelationalDatabase.RelationGraph.Release.ReleaseHold.ReliabilityDistribution.ReliefImage.ReliefPlot.RemoteAuthorizationCaching.RemoteBatchJobAbort.RemoteBatchJobObject.RemoteBatchJobs.RemoteBatchMapSubmit.RemoteBatchSubmissionEnvironment.RemoteBatchSubmit.RemoteConnect.RemoteConnectionObject.RemoteEvaluate.RemoteFile.RemoteInputFiles.RemoteKernelObject.RemoteProviderSettings.RemoteRun.RemoteRunProcess.RemovalConditions.Remove.RemoveAlphaChannel.RemoveAsynchronousTask.RemoveAudioStream.RemoveBackground.RemoveChannelListener.RemoveChannelSubscribers.Removed.RemoveDiacritics.RemoveInputStreamMethod.RemoveOutputStreamMethod.RemoveProperty.RemoveScheduledTask.RemoveUsers.RemoveVideoStream.RenameDirectory.RenameFile.RenderAll.RenderingOptions.RenewalProcess.RenkoChart.RepairMesh.Repeated.RepeatedNull.RepeatedString.RepeatedTiming.RepeatingElement.Replace.ReplaceAll.ReplaceAt.ReplaceHeldPart.ReplaceImageValue.ReplaceList.ReplacePart.ReplacePixelValue.ReplaceRepeated.ReplicateLayer.RequiredPhysicalQuantities.Resampling.ResamplingAlgorithmData.ResamplingMethod.Rescale.RescalingTransform.ResetDirectory.ResetScheduledTask.ReshapeLayer.Residue.ResidueSum.ResizeLayer.Resolve.ResolveContextAliases.ResourceAcquire.ResourceData.ResourceFunction.ResourceObject.ResourceRegister.ResourceRemove.ResourceSearch.ResourceSubmissionObject.ResourceSubmit.ResourceSystemBase.ResourceSystemPath.ResourceUpdate.ResourceVersion.ResponseForm.Rest.RestartInterval.Restricted.Resultant.ResumePacket.Return.ReturnCreatesNewCell.ReturnEntersInput.ReturnExpressionPacket.ReturnInputFormPacket.ReturnPacket.ReturnReceiptFunction.ReturnTextPacket.Reverse.ReverseApplied.ReverseBiorthogonalSplineWavelet.ReverseElement.ReverseEquilibrium.ReverseGraph.ReverseSort.ReverseSortBy.ReverseUpEquilibrium.RevolutionAxis.RevolutionPlot3D.RGBColor.RiccatiSolve.RiceDistribution.RidgeFilter.RiemannR.RiemannSiegelTheta.RiemannSiegelZ.RiemannXi.Riffle.Right.RightArrow.RightArrowBar.RightArrowLeftArrow.RightComposition.RightCosetRepresentative.RightDownTeeVector.RightDownVector.RightDownVectorBar.RightTee.RightTeeArrow.RightTeeVector.RightTriangle.RightTriangleBar.RightTriangleEqual.RightUpDownVector.RightUpTeeVector.RightUpVector.RightUpVectorBar.RightVector.RightVectorBar.RipleyK.RipleyRassonRegion.RiskAchievementImportance.RiskReductionImportance.RobustConvexOptimization.RogersTanimotoDissimilarity.RollPitchYawAngles.RollPitchYawMatrix.RomanNumeral.Root.RootApproximant.RootIntervals.RootLocusPlot.RootMeanSquare.RootOfUnityQ.RootReduce.Roots.RootSum.RootTree.Rotate.RotateLabel.RotateLeft.RotateRight.RotationAction.RotationBox.RotationBoxOptions.RotationMatrix.RotationTransform.Round.RoundImplies.RoundingRadius.Row.RowAlignments.RowBackgrounds.RowBox.RowHeights.RowLines.RowMinHeight.RowReduce.RowsEqual.RowSpacings.RSolve.RSolveValue.RudinShapiro.RudvalisGroupRu.Rule.RuleCondition.RuleDelayed.RuleForm.RulePlot.RulerUnits.RulesTree.Run.RunProcess.RunScheduledTask.RunThrough.RuntimeAttributes.RuntimeOptions.RussellRaoDissimilarity.SameAs.SameQ.SameTest.SameTestProperties.SampledEntityClass.SampleDepth.SampledSoundFunction.SampledSoundList.SampleRate.SamplingPeriod.SARIMAProcess.SARMAProcess.SASTriangle.SatelliteData.SatisfiabilityCount.SatisfiabilityInstances.SatisfiableQ.Saturday.Save.Saveable.SaveAutoDelete.SaveConnection.SaveDefinitions.SavitzkyGolayMatrix.SawtoothWave.Scale.Scaled.ScaleDivisions.ScaledMousePosition.ScaleOrigin.ScalePadding.ScaleRanges.ScaleRangeStyle.ScalingFunctions.ScalingMatrix.ScalingTransform.Scan.ScheduledTask.ScheduledTaskActiveQ.ScheduledTaskInformation.ScheduledTaskInformationData.ScheduledTaskObject.ScheduledTasks.SchurDecomposition.ScientificForm.ScientificNotationThreshold.ScorerGi.ScorerGiPrime.ScorerHi.ScorerHiPrime.ScreenRectangle.ScreenStyleEnvironment.ScriptBaselineShifts.ScriptForm.ScriptLevel.ScriptMinSize.ScriptRules.ScriptSizeMultipliers.Scrollbars.ScrollingOptions.ScrollPosition.SearchAdjustment.SearchIndexObject.SearchIndices.SearchQueryString.SearchResultObject.Sec.Sech.SechDistribution.SecondOrderConeOptimization.SectionGrouping.SectorChart.SectorChart3D.SectorOrigin.SectorSpacing.SecuredAuthenticationKey.SecuredAuthenticationKeys.SecurityCertificate.SeedRandom.Select.Selectable.SelectComponents.SelectedCells.SelectedNotebook.SelectFirst.Selection.SelectionAnimate.SelectionCell.SelectionCellCreateCell.SelectionCellDefaultStyle.SelectionCellParentStyle.SelectionCreateCell.SelectionDebuggerTag.SelectionEvaluate.SelectionEvaluateCreateCell.SelectionMove.SelectionPlaceholder.SelectWithContents.SelfLoops.SelfLoopStyle.SemanticImport.SemanticImportString.SemanticInterpretation.SemialgebraicComponentInstances.SemidefiniteOptimization.SendMail.SendMessage.Sequence.SequenceAlignment.SequenceAttentionLayer.SequenceCases.SequenceCount.SequenceFold.SequenceFoldList.SequenceForm.SequenceHold.SequenceIndicesLayer.SequenceLastLayer.SequenceMostLayer.SequencePosition.SequencePredict.SequencePredictorFunction.SequenceReplace.SequenceRestLayer.SequenceReverseLayer.SequenceSplit.Series.SeriesCoefficient.SeriesData.SeriesTermGoal.ServiceConnect.ServiceDisconnect.ServiceExecute.ServiceObject.ServiceRequest.ServiceResponse.ServiceSubmit.SessionSubmit.SessionTime.Set.SetAccuracy.SetAlphaChannel.SetAttributes.Setbacks.SetCloudDirectory.SetCookies.SetDelayed.SetDirectory.SetEnvironment.SetFileDate.SetFileFormatProperties.SetOptions.SetOptionsPacket.SetPermissions.SetPrecision.SetProperty.SetSecuredAuthenticationKey.SetSelectedNotebook.SetSharedFunction.SetSharedVariable.SetStreamPosition.SetSystemModel.SetSystemOptions.Setter.SetterBar.SetterBox.SetterBoxOptions.Setting.SetUsers.Shading.Shallow.ShannonWavelet.ShapiroWilkTest.Share.SharingList.Sharpen.ShearingMatrix.ShearingTransform.ShellRegion.ShenCastanMatrix.ShiftedGompertzDistribution.ShiftRegisterSequence.Short.ShortDownArrow.Shortest.ShortestMatch.ShortestPathFunction.ShortLeftArrow.ShortRightArrow.ShortTimeFourier.ShortTimeFourierData.ShortUpArrow.Show.ShowAutoConvert.ShowAutoSpellCheck.ShowAutoStyles.ShowCellBracket.ShowCellLabel.ShowCellTags.ShowClosedCellArea.ShowCodeAssist.ShowContents.ShowControls.ShowCursorTracker.ShowGroupOpenCloseIcon.ShowGroupOpener.ShowInvisibleCharacters.ShowPageBreaks.ShowPredictiveInterface.ShowSelection.ShowShortBoxForm.ShowSpecialCharacters.ShowStringCharacters.ShowSyntaxStyles.ShrinkingDelay.ShrinkWrapBoundingBox.SiderealTime.SiegelTheta.SiegelTukeyTest.SierpinskiCurve.SierpinskiMesh.Sign.Signature.SignedRankTest.SignedRegionDistance.SignificanceLevel.SignPadding.SignTest.SimilarityRules.SimpleGraph.SimpleGraphQ.SimplePolygonQ.SimplePolyhedronQ.Simplex.Simplify.Sin.Sinc.SinghMaddalaDistribution.SingleEvaluation.SingleLetterItalics.SingleLetterStyle.SingularValueDecomposition.SingularValueList.SingularValuePlot.SingularValues.Sinh.SinhIntegral.SinIntegral.SixJSymbol.Skeleton.SkeletonTransform.SkellamDistribution.Skewness.SkewNormalDistribution.SkinStyle.Skip.SliceContourPlot3D.SliceDensityPlot3D.SliceDistribution.SliceVectorPlot3D.Slider.Slider2D.Slider2DBox.Slider2DBoxOptions.SliderBox.SliderBoxOptions.SlideShowVideo.SlideView.Slot.SlotSequence.Small.SmallCircle.Smaller.SmithDecomposition.SmithDelayCompensator.SmithWatermanSimilarity.SmoothDensityHistogram.SmoothHistogram.SmoothHistogram3D.SmoothKernelDistribution.SmoothPointDensity.SnDispersion.Snippet.SnippetsVideo.SnubPolyhedron.SocialMediaData.Socket.SocketConnect.SocketListen.SocketListener.SocketObject.SocketOpen.SocketReadMessage.SocketReadyQ.Sockets.SocketWaitAll.SocketWaitNext.SoftmaxLayer.SokalSneathDissimilarity.SolarEclipse.SolarSystemFeatureData.SolarTime.SolidAngle.SolidBoundaryLoadValue.SolidData.SolidDisplacementCondition.SolidFixedCondition.SolidMechanicsPDEComponent.SolidMechanicsStrain.SolidMechanicsStress.SolidRegionQ.Solve.SolveAlways.SolveDelayed.SolveValues.Sort.SortBy.SortedBy.SortedEntityClass.Sound.SoundAndGraphics.SoundNote.SoundVolume.SourceLink.SourcePDETerm.Sow.Space.SpaceCurveData.SpaceForm.Spacer.Spacings.Span.SpanAdjustments.SpanCharacterRounding.SpanFromAbove.SpanFromBoth.SpanFromLeft.SpanLineThickness.SpanMaxSize.SpanMinSize.SpanningCharacters.SpanSymmetric.SparseArray.SparseArrayQ.SpatialBinnedPointData.SpatialBoundaryCorrection.SpatialEstimate.SpatialEstimatorFunction.SpatialGraphDistribution.SpatialJ.SpatialMedian.SpatialNoiseLevel.SpatialObservationRegionQ.SpatialPointData.SpatialPointSelect.SpatialRandomnessTest.SpatialTransformationLayer.SpatialTrendFunction.Speak.SpeakerMatchQ.SpearmanRankTest.SpearmanRho.SpeciesData.SpecificityGoal.SpectralLineData.Spectrogram.SpectrogramArray.Specularity.SpeechCases.SpeechInterpreter.SpeechRecognize.SpeechSynthesize.SpellingCorrection.SpellingCorrectionList.SpellingDictionaries.SpellingDictionariesPath.SpellingOptions.Sphere.SphereBox.SphereBoxOptions.SpherePoints.SphericalBesselJ.SphericalBesselY.SphericalHankelH1.SphericalHankelH2.SphericalHarmonicY.SphericalPlot3D.SphericalRegion.SphericalShell.SpheroidalEigenvalue.SpheroidalJoiningFactor.SpheroidalPS.SpheroidalPSPrime.SpheroidalQS.SpheroidalQSPrime.SpheroidalRadialFactor.SpheroidalS1.SpheroidalS1Prime.SpheroidalS2.SpheroidalS2Prime.Splice.SplicedDistribution.SplineClosed.SplineDegree.SplineKnots.SplineWeights.Split.SplitBy.SpokenString.SpotLight.Sqrt.SqrtBox.SqrtBoxOptions.Square.SquaredEuclideanDistance.SquareFreeQ.SquareIntersection.SquareMatrixQ.SquareRepeatingElement.SquaresR.SquareSubset.SquareSubsetEqual.SquareSuperset.SquareSupersetEqual.SquareUnion.SquareWave.SSSTriangle.StabilityMargins.StabilityMarginsStyle.StableDistribution.Stack.StackBegin.StackComplete.StackedDateListPlot.StackedListPlot.StackInhibit.StadiumShape.StandardAtmosphereData.StandardDeviation.StandardDeviationFilter.StandardForm.Standardize.Standardized.StandardOceanData.StandbyDistribution.Star.StarClusterData.StarData.StarGraph.StartAsynchronousTask.StartExternalSession.StartingStepSize.StartOfLine.StartOfString.StartProcess.StartScheduledTask.StartupSound.StartWebSession.StateDimensions.StateFeedbackGains.StateOutputEstimator.StateResponse.StateSpaceModel.StateSpaceRealization.StateSpaceTransform.StateTransformationLinearize.StationaryDistribution.StationaryWaveletPacketTransform.StationaryWaveletTransform.StatusArea.StatusCentrality.StepMonitor.StereochemistryElements.StieltjesGamma.StippleShading.StirlingS1.StirlingS2.StopAsynchronousTask.StoppingPowerData.StopScheduledTask.StrataVariables.StratonovichProcess.StraussHardcorePointProcess.StraussPointProcess.StreamColorFunction.StreamColorFunctionScaling.StreamDensityPlot.StreamMarkers.StreamPlot.StreamPlot3D.StreamPoints.StreamPosition.Streams.StreamScale.StreamStyle.StrictInequalities.String.StringBreak.StringByteCount.StringCases.StringContainsQ.StringCount.StringDelete.StringDrop.StringEndsQ.StringExpression.StringExtract.StringForm.StringFormat.StringFormatQ.StringFreeQ.StringInsert.StringJoin.StringLength.StringMatchQ.StringPadLeft.StringPadRight.StringPart.StringPartition.StringPosition.StringQ.StringRepeat.StringReplace.StringReplaceList.StringReplacePart.StringReverse.StringRiffle.StringRotateLeft.StringRotateRight.StringSkeleton.StringSplit.StringStartsQ.StringTake.StringTakeDrop.StringTemplate.StringToByteArray.StringToStream.StringTrim.StripBoxes.StripOnInput.StripStyleOnPaste.StripWrapperBoxes.StrokeForm.Struckthrough.StructuralImportance.StructuredArray.StructuredArrayHeadQ.StructuredSelection.StruveH.StruveL.Stub.StudentTDistribution.Style.StyleBox.StyleBoxAutoDelete.StyleData.StyleDefinitions.StyleForm.StyleHints.StyleKeyMapping.StyleMenuListing.StyleNameDialogSettings.StyleNames.StylePrint.StyleSheetPath.Subdivide.Subfactorial.Subgraph.SubMinus.SubPlus.SubresultantPolynomialRemainders.SubresultantPolynomials.Subresultants.Subscript.SubscriptBox.SubscriptBoxOptions.Subscripted.Subsequences.Subset.SubsetCases.SubsetCount.SubsetEqual.SubsetMap.SubsetPosition.SubsetQ.SubsetReplace.Subsets.SubStar.SubstitutionSystem.Subsuperscript.SubsuperscriptBox.SubsuperscriptBoxOptions.SubtitleEncoding.SubtitleTrackSelection.Subtract.SubtractFrom.SubtractSides.SubValues.Succeeds.SucceedsEqual.SucceedsSlantEqual.SucceedsTilde.Success.SuchThat.Sum.SumConvergence.SummationLayer.Sunday.SunPosition.Sunrise.Sunset.SuperDagger.SuperMinus.SupernovaData.SuperPlus.Superscript.SuperscriptBox.SuperscriptBoxOptions.Superset.SupersetEqual.SuperStar.Surd.SurdForm.SurfaceAppearance.SurfaceArea.SurfaceColor.SurfaceData.SurfaceGraphics.SurvivalDistribution.SurvivalFunction.SurvivalModel.SurvivalModelFit.SuspendPacket.SuzukiDistribution.SuzukiGroupSuz.SwatchLegend.Switch.Symbol.SymbolName.SymletWavelet.Symmetric.SymmetricDifference.SymmetricGroup.SymmetricKey.SymmetricMatrixQ.SymmetricPolynomial.SymmetricReduction.Symmetrize.SymmetrizedArray.SymmetrizedArrayRules.SymmetrizedDependentComponents.SymmetrizedIndependentComponents.SymmetrizedReplacePart.SynchronousInitialization.SynchronousUpdating.Synonyms.Syntax.SyntaxForm.SyntaxInformation.SyntaxLength.SyntaxPacket.SyntaxQ.SynthesizeMissingValues.SystemCredential.SystemCredentialData.SystemCredentialKey.SystemCredentialKeys.SystemCredentialStoreObject.SystemDialogInput.SystemException.SystemGet.SystemHelpPath.SystemInformation.SystemInformationData.SystemInstall.SystemModel.SystemModeler.SystemModelExamples.SystemModelLinearize.SystemModelMeasurements.SystemModelParametricSimulate.SystemModelPlot.SystemModelProgressReporting.SystemModelReliability.SystemModels.SystemModelSimulate.SystemModelSimulateSensitivity.SystemModelSimulationData.SystemOpen.SystemOptions.SystemProcessData.SystemProcesses.SystemsConnectionsModel.SystemsModelControllerData.SystemsModelDelay.SystemsModelDelayApproximate.SystemsModelDelete.SystemsModelDimensions.SystemsModelExtract.SystemsModelFeedbackConnect.SystemsModelLabels.SystemsModelLinearity.SystemsModelMerge.SystemsModelOrder.SystemsModelParallelConnect.SystemsModelSeriesConnect.SystemsModelStateFeedbackConnect.SystemsModelVectorRelativeOrders.SystemStub.SystemTest.Tab.TabFilling.Table.TableAlignments.TableDepth.TableDirections.TableForm.TableHeadings.TableSpacing.TableView.TableViewBox.TableViewBoxAlignment.TableViewBoxBackground.TableViewBoxHeaders.TableViewBoxItemSize.TableViewBoxItemStyle.TableViewBoxOptions.TabSpacings.TabView.TabViewBox.TabViewBoxOptions.TagBox.TagBoxNote.TagBoxOptions.TaggingRules.TagSet.TagSetDelayed.TagStyle.TagUnset.Take.TakeDrop.TakeLargest.TakeLargestBy.TakeList.TakeSmallest.TakeSmallestBy.TakeWhile.Tally.Tan.Tanh.TargetDevice.TargetFunctions.TargetSystem.TargetUnits.TaskAbort.TaskExecute.TaskObject.TaskRemove.TaskResume.Tasks.TaskSuspend.TaskWait.TautologyQ.TelegraphProcess.TemplateApply.TemplateArgBox.TemplateBox.TemplateBoxOptions.TemplateEvaluate.TemplateExpression.TemplateIf.TemplateObject.TemplateSequence.TemplateSlot.TemplateSlotSequence.TemplateUnevaluated.TemplateVerbatim.TemplateWith.TemporalData.TemporalRegularity.Temporary.TemporaryVariable.TensorContract.TensorDimensions.TensorExpand.TensorProduct.TensorQ.TensorRank.TensorReduce.TensorSymmetry.TensorTranspose.TensorWedge.TerminatedEvaluation.TernaryListPlot.TernaryPlotCorners.TestID.TestReport.TestReportObject.TestResultObject.Tetrahedron.TetrahedronBox.TetrahedronBoxOptions.TeXForm.TeXSave.Text.Text3DBox.Text3DBoxOptions.TextAlignment.TextBand.TextBoundingBox.TextBox.TextCases.TextCell.TextClipboardType.TextContents.TextData.TextElement.TextForm.TextGrid.TextJustification.TextLine.TextPacket.TextParagraph.TextPosition.TextRecognize.TextSearch.TextSearchReport.TextSentences.TextString.TextStructure.TextStyle.TextTranslation.Texture.TextureCoordinateFunction.TextureCoordinateScaling.TextWords.Therefore.ThermodynamicData.ThermometerGauge.Thick.Thickness.Thin.Thinning.ThisLink.ThomasPointProcess.ThompsonGroupTh.Thread.Threaded.ThreadingLayer.ThreeJSymbol.Threshold.Through.Throw.ThueMorse.Thumbnail.Thursday.TickDirection.TickLabelOrientation.TickLabelPositioning.TickLabels.TickLengths.TickPositions.Ticks.TicksStyle.TideData.Tilde.TildeEqual.TildeFullEqual.TildeTilde.TimeConstrained.TimeConstraint.TimeDirection.TimeFormat.TimeGoal.TimelinePlot.TimeObject.TimeObjectQ.TimeRemaining.Times.TimesBy.TimeSeries.TimeSeriesAggregate.TimeSeriesForecast.TimeSeriesInsert.TimeSeriesInvertibility.TimeSeriesMap.TimeSeriesMapThread.TimeSeriesModel.TimeSeriesModelFit.TimeSeriesResample.TimeSeriesRescale.TimeSeriesShift.TimeSeriesThread.TimeSeriesWindow.TimeSystem.TimeSystemConvert.TimeUsed.TimeValue.TimeWarpingCorrespondence.TimeWarpingDistance.TimeZone.TimeZoneConvert.TimeZoneOffset.Timing.Tiny.TitleGrouping.TitsGroupT.ToBoxes.ToCharacterCode.ToColor.ToContinuousTimeModel.ToDate.Today.ToDiscreteTimeModel.ToEntity.ToeplitzMatrix.ToExpression.ToFileName.Together.Toggle.ToggleFalse.Toggler.TogglerBar.TogglerBox.TogglerBoxOptions.ToHeldExpression.ToInvertibleTimeSeries.TokenWords.Tolerance.ToLowerCase.Tomorrow.ToNumberField.TooBig.Tooltip.TooltipBox.TooltipBoxOptions.TooltipDelay.TooltipStyle.ToonShading.Top.TopHatTransform.ToPolarCoordinates.TopologicalSort.ToRadicals.ToRawPointer.ToRules.Torus.TorusGraph.ToSphericalCoordinates.ToString.Total.TotalHeight.TotalLayer.TotalVariationFilter.TotalWidth.TouchPosition.TouchscreenAutoZoom.TouchscreenControlPlacement.ToUpperCase.TourVideo.Tr.Trace.TraceAbove.TraceAction.TraceBackward.TraceDepth.TraceDialog.TraceForward.TraceInternal.TraceLevel.TraceOff.TraceOn.TraceOriginal.TracePrint.TraceScan.TrackCellChangeTimes.TrackedSymbols.TrackingFunction.TracyWidomDistribution.TradingChart.TraditionalForm.TraditionalFunctionNotation.TraditionalNotation.TraditionalOrder.TrainImageContentDetector.TrainingProgressCheckpointing.TrainingProgressFunction.TrainingProgressMeasurements.TrainingProgressReporting.TrainingStoppingCriterion.TrainingUpdateSchedule.TrainTextContentDetector.TransferFunctionCancel.TransferFunctionExpand.TransferFunctionFactor.TransferFunctionModel.TransferFunctionPoles.TransferFunctionTransform.TransferFunctionZeros.TransformationClass.TransformationFunction.TransformationFunctions.TransformationMatrix.TransformedDistribution.TransformedField.TransformedProcess.TransformedRegion.TransitionDirection.TransitionDuration.TransitionEffect.TransitiveClosureGraph.TransitiveReductionGraph.Translate.TranslationOptions.TranslationTransform.Transliterate.Transparent.TransparentColor.Transpose.TransposeLayer.TrapEnterKey.TrapSelection.TravelDirections.TravelDirectionsData.TravelDistance.TravelDistanceList.TravelMethod.TravelTime.Tree.TreeCases.TreeChildren.TreeCount.TreeData.TreeDelete.TreeDepth.TreeElementCoordinates.TreeElementLabel.TreeElementLabelFunction.TreeElementLabelStyle.TreeElementShape.TreeElementShapeFunction.TreeElementSize.TreeElementSizeFunction.TreeElementStyle.TreeElementStyleFunction.TreeExpression.TreeExtract.TreeFold.TreeForm.TreeGraph.TreeGraphQ.TreeInsert.TreeLayout.TreeLeafCount.TreeLeafQ.TreeLeaves.TreeLevel.TreeMap.TreeMapAt.TreeOutline.TreePlot.TreePosition.TreeQ.TreeReplacePart.TreeRules.TreeScan.TreeSelect.TreeSize.TreeTraversalOrder.TrendStyle.Triangle.TriangleCenter.TriangleConstruct.TriangleMeasurement.TriangleWave.TriangularDistribution.TriangulateMesh.Trig.TrigExpand.TrigFactor.TrigFactorList.Trigger.TrigReduce.TrigToExp.TrimmedMean.TrimmedVariance.TropicalStormData.True.TrueQ.TruncatedDistribution.TruncatedPolyhedron.TsallisQExponentialDistribution.TsallisQGaussianDistribution.TTest.Tube.TubeBezierCurveBox.TubeBezierCurveBoxOptions.TubeBox.TubeBoxOptions.TubeBSplineCurveBox.TubeBSplineCurveBoxOptions.Tuesday.TukeyLambdaDistribution.TukeyWindow.TunnelData.Tuples.TuranGraph.TuringMachine.TuttePolynomial.TwoWayRule.Typed.TypeDeclaration.TypeEvaluate.TypeHint.TypeOf.TypeSpecifier.UnateQ.Uncompress.UnconstrainedParameters.Undefined.UnderBar.Underflow.Underlined.Underoverscript.UnderoverscriptBox.UnderoverscriptBoxOptions.Underscript.UnderscriptBox.UnderscriptBoxOptions.UnderseaFeatureData.UndirectedEdge.UndirectedGraph.UndirectedGraphQ.UndoOptions.UndoTrackedVariables.Unequal.UnequalTo.Unevaluated.UniformDistribution.UniformGraphDistribution.UniformPolyhedron.UniformSumDistribution.Uninstall.Union.UnionedEntityClass.UnionPlus.Unique.UniqueElements.UnitaryMatrixQ.UnitBox.UnitConvert.UnitDimensions.Unitize.UnitRootTest.UnitSimplify.UnitStep.UnitSystem.UnitTriangle.UnitVector.UnitVectorLayer.UnityDimensions.UniverseModelData.UniversityData.UnixTime.UnlabeledTree.UnmanageObject.Unprotect.UnregisterExternalEvaluator.UnsameQ.UnsavedVariables.Unset.UnsetShared.Until.UntrackedVariables.Up.UpArrow.UpArrowBar.UpArrowDownArrow.Update.UpdateDynamicObjects.UpdateDynamicObjectsSynchronous.UpdateInterval.UpdatePacletSites.UpdateSearchIndex.UpDownArrow.UpEquilibrium.UpperCaseQ.UpperLeftArrow.UpperRightArrow.UpperTriangularize.UpperTriangularMatrix.UpperTriangularMatrixQ.Upsample.UpSet.UpSetDelayed.UpTee.UpTeeArrow.UpTo.UpValues.URL.URLBuild.URLDecode.URLDispatcher.URLDownload.URLDownloadSubmit.URLEncode.URLExecute.URLExpand.URLFetch.URLFetchAsynchronous.URLParse.URLQueryDecode.URLQueryEncode.URLRead.URLResponseTime.URLSave.URLSaveAsynchronous.URLShorten.URLSubmit.UseEmbeddedLibrary.UseGraphicsRange.UserDefinedWavelet.Using.UsingFrontEnd.UtilityFunction.V2Get.ValenceErrorHandling.ValenceFilling.ValidationLength.ValidationSet.ValueBox.ValueBoxOptions.ValueDimensions.ValueForm.ValuePreprocessingFunction.ValueQ.Values.ValuesData.VandermondeMatrix.Variables.Variance.VarianceEquivalenceTest.VarianceEstimatorFunction.VarianceGammaDistribution.VarianceGammaPointProcess.VarianceTest.VariogramFunction.VariogramModel.VectorAngle.VectorAround.VectorAspectRatio.VectorColorFunction.VectorColorFunctionScaling.VectorDensityPlot.VectorDisplacementPlot.VectorDisplacementPlot3D.VectorGlyphData.VectorGreater.VectorGreaterEqual.VectorLess.VectorLessEqual.VectorMarkers.VectorPlot.VectorPlot3D.VectorPoints.VectorQ.VectorRange.Vectors.VectorScale.VectorScaling.VectorSizes.VectorStyle.Vee.Verbatim.Verbose.VerificationTest.VerifyConvergence.VerifyDerivedKey.VerifyDigitalSignature.VerifyFileSignature.VerifyInterpretation.VerifySecurityCertificates.VerifySolutions.VerifyTestAssumptions.VersionedPreferences.VertexAdd.VertexCapacity.VertexChromaticNumber.VertexColors.VertexComponent.VertexConnectivity.VertexContract.VertexCoordinateRules.VertexCoordinates.VertexCorrelationSimilarity.VertexCosineSimilarity.VertexCount.VertexCoverQ.VertexDataCoordinates.VertexDegree.VertexDelete.VertexDiceSimilarity.VertexEccentricity.VertexInComponent.VertexInComponentGraph.VertexInDegree.VertexIndex.VertexJaccardSimilarity.VertexLabeling.VertexLabels.VertexLabelStyle.VertexList.VertexNormals.VertexOutComponent.VertexOutComponentGraph.VertexOutDegree.VertexQ.VertexRenderingFunction.VertexReplace.VertexShape.VertexShapeFunction.VertexSize.VertexStyle.VertexTextureCoordinates.VertexTransitiveGraphQ.VertexWeight.VertexWeightedGraphQ.Vertical.VerticalBar.VerticalForm.VerticalGauge.VerticalSeparator.VerticalSlider.VerticalTilde.Video.VideoCapture.VideoCombine.VideoDelete.VideoEncoding.VideoExtractFrames.VideoFrameList.VideoFrameMap.VideoGenerator.VideoInsert.VideoIntervals.VideoJoin.VideoMap.VideoMapList.VideoMapTimeSeries.VideoPadding.VideoPause.VideoPlay.VideoQ.VideoRecord.VideoReplace.VideoScreenCapture.VideoSplit.VideoStop.VideoStream.VideoStreams.VideoTimeStretch.VideoTrackSelection.VideoTranscode.VideoTransparency.VideoTrim.ViewAngle.ViewCenter.ViewMatrix.ViewPoint.ViewPointSelectorSettings.ViewPort.ViewProjection.ViewRange.ViewVector.ViewVertical.VirtualGroupData.Visible.VisibleCell.VoiceStyleData.VoigtDistribution.VolcanoData.Volume.VonMisesDistribution.VoronoiMesh.WaitAll.WaitAsynchronousTask.WaitNext.WaitUntil.WakebyDistribution.WalleniusHypergeometricDistribution.WaringYuleDistribution.WarpingCorrespondence.WarpingDistance.WatershedComponents.WatsonUSquareTest.WattsStrogatzGraphDistribution.WaveletBestBasis.WaveletFilterCoefficients.WaveletImagePlot.WaveletListPlot.WaveletMapIndexed.WaveletMatrixPlot.WaveletPhi.WaveletPsi.WaveletScale.WaveletScalogram.WaveletThreshold.WavePDEComponent.WeaklyConnectedComponents.WeaklyConnectedGraphComponents.WeaklyConnectedGraphQ.WeakStationarity.WeatherData.WeatherForecastData.WebAudioSearch.WebColumn.WebElementObject.WeberE.WebExecute.WebImage.WebImageSearch.WebItem.WebPageMetaInformation.WebRow.WebSearch.WebSessionObject.WebSessions.WebWindowObject.Wedge.Wednesday.WeibullDistribution.WeierstrassE1.WeierstrassE2.WeierstrassE3.WeierstrassEta1.WeierstrassEta2.WeierstrassEta3.WeierstrassHalfPeriods.WeierstrassHalfPeriodW1.WeierstrassHalfPeriodW2.WeierstrassHalfPeriodW3.WeierstrassInvariantG2.WeierstrassInvariantG3.WeierstrassInvariants.WeierstrassP.WeierstrassPPrime.WeierstrassSigma.WeierstrassZeta.WeightedAdjacencyGraph.WeightedAdjacencyMatrix.WeightedData.WeightedGraphQ.Weights.WelchWindow.WheelGraph.WhenEvent.Which.While.White.WhiteNoiseProcess.WhitePoint.Whitespace.WhitespaceCharacter.WhittakerM.WhittakerW.WholeCellGroupOpener.WienerFilter.WienerProcess.WignerD.WignerSemicircleDistribution.WikidataData.WikidataSearch.WikipediaData.WikipediaSearch.WilksW.WilksWTest.WindDirectionData.WindingCount.WindingPolygon.WindowClickSelect.WindowElements.WindowFloating.WindowFrame.WindowFrameElements.WindowMargins.WindowMovable.WindowOpacity.WindowPersistentStyles.WindowSelected.WindowSize.WindowStatusArea.WindowTitle.WindowToolbars.WindowWidth.WindSpeedData.WindVectorData.WinsorizedMean.WinsorizedVariance.WishartMatrixDistribution.With.WithCleanup.WithLock.WolframAlpha.WolframAlphaDate.WolframAlphaQuantity.WolframAlphaResult.WolframCloudSettings.WolframLanguageData.Word.WordBoundary.WordCharacter.WordCloud.WordCount.WordCounts.WordData.WordDefinition.WordFrequency.WordFrequencyData.WordList.WordOrientation.WordSearch.WordSelectionFunction.WordSeparators.WordSpacings.WordStem.WordTranslation.WorkingPrecision.WrapAround.Write.WriteLine.WriteString.Wronskian.XMLElement.XMLObject.XMLTemplate.Xnor.Xor.XYZColor.Yellow.Yesterday.YuleDissimilarity.ZernikeR.ZeroSymmetric.ZeroTest.ZeroWidthTimes.Zeta.ZetaZero.ZIPCodeData.ZipfDistribution.ZoomCenter.ZoomFactor.ZTest.ZTransform.$Aborted.$ActivationGroupID.$ActivationKey.$ActivationUserRegistered.$AddOnsDirectory.$AllowDataUpdates.$AllowExternalChannelFunctions.$AllowInternet.$AssertFunction.$Assumptions.$AsynchronousTask.$AudioDecoders.$AudioEncoders.$AudioInputDevices.$AudioOutputDevices.$BaseDirectory.$BasePacletsDirectory.$BatchInput.$BatchOutput.$BlockchainBase.$BoxForms.$ByteOrdering.$CacheBaseDirectory.$Canceled.$ChannelBase.$CharacterEncoding.$CharacterEncodings.$CloudAccountName.$CloudBase.$CloudConnected.$CloudConnection.$CloudCreditsAvailable.$CloudEvaluation.$CloudExpressionBase.$CloudObjectNameFormat.$CloudObjectURLType.$CloudRootDirectory.$CloudSymbolBase.$CloudUserID.$CloudUserUUID.$CloudVersion.$CloudVersionNumber.$CloudWolframEngineVersionNumber.$CommandLine.$CompilationTarget.$CompilerEnvironment.$ConditionHold.$ConfiguredKernels.$Context.$ContextAliases.$ContextPath.$ControlActiveSetting.$Cookies.$CookieStore.$CreationDate.$CryptographicEllipticCurveNames.$CurrentLink.$CurrentTask.$CurrentWebSession.$DataStructures.$DateStringFormat.$DefaultAudioInputDevice.$DefaultAudioOutputDevice.$DefaultFont.$DefaultFrontEnd.$DefaultImagingDevice.$DefaultKernels.$DefaultLocalBase.$DefaultLocalKernel.$DefaultMailbox.$DefaultNetworkInterface.$DefaultPath.$DefaultProxyRules.$DefaultRemoteBatchSubmissionEnvironment.$DefaultRemoteKernel.$DefaultSystemCredentialStore.$Display.$DisplayFunction.$DistributedContexts.$DynamicEvaluation.$Echo.$EmbedCodeEnvironments.$EmbeddableServices.$EntityStores.$Epilog.$EvaluationCloudBase.$EvaluationCloudObject.$EvaluationEnvironment.$ExportFormats.$ExternalIdentifierTypes.$ExternalStorageBase.$Failed.$FinancialDataSource.$FontFamilies.$FormatType.$FrontEnd.$FrontEndSession.$GeneratedAssetLocation.$GeoEntityTypes.$GeoLocation.$GeoLocationCity.$GeoLocationCountry.$GeoLocationPrecision.$GeoLocationSource.$HistoryLength.$HomeDirectory.$HTMLExportRules.$HTTPCookies.$HTTPRequest.$IgnoreEOF.$ImageFormattingWidth.$ImageResolution.$ImagingDevice.$ImagingDevices.$ImportFormats.$IncomingMailSettings.$InitialDirectory.$Initialization.$InitializationContexts.$Input.$InputFileName.$InputStreamMethods.$Inspector.$InstallationDate.$InstallationDirectory.$InterfaceEnvironment.$InterpreterTypes.$IterationLimit.$KernelCount.$KernelID.$Language.$LaunchDirectory.$LibraryPath.$LicenseExpirationDate.$LicenseID.$LicenseProcesses.$LicenseServer.$LicenseSubprocesses.$LicenseType.$Line.$Linked.$LinkSupported.$LoadedFiles.$LocalBase.$LocalSymbolBase.$MachineAddresses.$MachineDomain.$MachineDomains.$MachineEpsilon.$MachineID.$MachineName.$MachinePrecision.$MachineType.$MaxDisplayedChildren.$MaxExtraPrecision.$MaxLicenseProcesses.$MaxLicenseSubprocesses.$MaxMachineNumber.$MaxNumber.$MaxPiecewiseCases.$MaxPrecision.$MaxRootDegree.$MessageGroups.$MessageList.$MessagePrePrint.$Messages.$MinMachineNumber.$MinNumber.$MinorReleaseNumber.$MinPrecision.$MobilePhone.$ModuleNumber.$NetworkConnected.$NetworkInterfaces.$NetworkLicense.$NewMessage.$NewSymbol.$NotebookInlineStorageLimit.$Notebooks.$NoValue.$NumberMarks.$Off.$OperatingSystem.$Output.$OutputForms.$OutputSizeLimit.$OutputStreamMethods.$Packages.$ParentLink.$ParentProcessID.$PasswordFile.$PatchLevelID.$Path.$PathnameSeparator.$PerformanceGoal.$Permissions.$PermissionsGroupBase.$PersistenceBase.$PersistencePath.$PipeSupported.$PlotTheme.$Post.$Pre.$PreferencesDirectory.$PreInitialization.$PrePrint.$PreRead.$PrintForms.$PrintLiteral.$Printout3DPreviewer.$ProcessID.$ProcessorCount.$ProcessorType.$ProductInformation.$ProgramName.$ProgressReporting.$PublisherID.$RandomGeneratorState.$RandomState.$RecursionLimit.$RegisteredDeviceClasses.$RegisteredUserName.$ReleaseNumber.$RequesterAddress.$RequesterCloudUserID.$RequesterCloudUserUUID.$RequesterWolframID.$RequesterWolframUUID.$ResourceSystemBase.$ResourceSystemPath.$RootDirectory.$ScheduledTask.$ScriptCommandLine.$ScriptInputString.$SecuredAuthenticationKeyTokens.$ServiceCreditsAvailable.$Services.$SessionID.$SetParentLink.$SharedFunctions.$SharedVariables.$SoundDisplay.$SoundDisplayFunction.$SourceLink.$SSHAuthentication.$SubtitleDecoders.$SubtitleEncoders.$SummaryBoxDataSizeLimit.$SuppressInputFormHeads.$SynchronousEvaluation.$SyntaxHandler.$System.$SystemCharacterEncoding.$SystemCredentialStore.$SystemID.$SystemMemory.$SystemShell.$SystemTimeZone.$SystemWordLength.$TargetSystems.$TemplatePath.$TemporaryDirectory.$TemporaryPrefix.$TestFileName.$TextStyle.$TimedOut.$TimeUnit.$TimeZone.$TimeZoneEntity.$TopDirectory.$TraceOff.$TraceOn.$TracePattern.$TracePostAction.$TracePreAction.$UnitSystem.$Urgent.$UserAddOnsDirectory.$UserAgentLanguages.$UserAgentMachine.$UserAgentName.$UserAgentOperatingSystem.$UserAgentString.$UserAgentVersion.$UserBaseDirectory.$UserBasePacletsDirectory.$UserDocumentsDirectory.$Username.$UserName.$UserURLBase.$Version.$VersionNumber.$VideoDecoders.$VideoEncoders.$VoiceStyles.$WolframDocumentsDirectory.$WolframID.$WolframUUID`.split(`.`);
        function r(e) {
            let t = e.regex, r = t.either(t.concat(/([2-9]|[1-2]\d|[3][0-5])\^\^/, /(\w*\.\w+|\w+\.\w*|\w+)/), /(\d*\.\d+|\d+\.\d*|\d+)/), i = t.either(/``[+-]?(\d*\.\d+|\d+\.\d*|\d+)/, /`([+-]?(\d*\.\d+|\d+\.\d*|\d+))?/), a = {
                className: `number`,
                relevance: 0,
                begin: t.concat(r, t.optional(i), t.optional(/\*\^[+-]?\d+/))
            }, o = /[a-zA-Z$][a-zA-Z0-9$]*/, s = new Set(n), c = {
                variants: [
                    {
                        className: `builtin-symbol`,
                        begin: o,
                        "on:begin": (e, t)=>{
                            s.has(e[0]) || t.ignoreMatch();
                        }
                    },
                    {
                        className: `symbol`,
                        relevance: 0,
                        begin: o
                    }
                ]
            }, l = {
                className: `named-character`,
                begin: /\\\[[$a-zA-Z][$a-zA-Z0-9]+\]/
            }, u = {
                className: `operator`,
                relevance: 0,
                begin: /[+\-*/,;.:@~=><&|_`'^?!%]+/
            }, d = {
                className: `pattern`,
                relevance: 0,
                begin: /([a-zA-Z$][a-zA-Z0-9$]*)?_+([a-zA-Z$][a-zA-Z0-9$]*)?/
            }, f = {
                className: `slot`,
                relevance: 0,
                begin: /#[a-zA-Z$][a-zA-Z0-9$]*|#+[0-9]?/
            }, p = {
                className: `brace`,
                relevance: 0,
                begin: /[[\](){}]/
            }, m = {
                className: `message-name`,
                relevance: 0,
                begin: t.concat(`::`, o)
            };
            return {
                name: `Mathematica`,
                aliases: [
                    `mma`,
                    `wl`
                ],
                classNameAliases: {
                    brace: `punctuation`,
                    pattern: `type`,
                    slot: `type`,
                    symbol: `variable`,
                    "named-character": `variable`,
                    "builtin-symbol": `built_in`,
                    "message-name": `string`
                },
                contains: [
                    e.COMMENT(/\(\*/, /\*\)/, {
                        contains: [
                            `self`
                        ]
                    }),
                    d,
                    f,
                    m,
                    c,
                    l,
                    e.QUOTE_STRING_MODE,
                    a,
                    u,
                    p
                ]
            };
        }
        t.exports = r;
    }), ut = o((e, t)=>{
        function n(e) {
            let t = `('|\\.')+`, n = {
                relevance: 0,
                contains: [
                    {
                        begin: t
                    }
                ]
            };
            return {
                name: `Matlab`,
                keywords: {
                    keyword: `arguments break case catch classdef continue else elseif end enumeration events for function global if methods otherwise parfor persistent properties return spmd switch try while`,
                    built_in: `sin sind sinh asin asind asinh cos cosd cosh acos acosd acosh tan tand tanh atan atand atan2 atanh sec secd sech asec asecd asech csc cscd csch acsc acscd acsch cot cotd coth acot acotd acoth hypot exp expm1 log log1p log10 log2 pow2 realpow reallog realsqrt sqrt nthroot nextpow2 abs angle complex conj imag real unwrap isreal cplxpair fix floor ceil round mod rem sign airy besselj bessely besselh besseli besselk beta betainc betaln ellipj ellipke erf erfc erfcx erfinv expint gamma gammainc gammaln psi legendre cross dot factor isprime primes gcd lcm rat rats perms nchoosek factorial cart2sph cart2pol pol2cart sph2cart hsv2rgb rgb2hsv zeros ones eye repmat rand randn linspace logspace freqspace meshgrid accumarray size length ndims numel disp isempty isequal isequalwithequalnans cat reshape diag blkdiag tril triu fliplr flipud flipdim rot90 find sub2ind ind2sub bsxfun ndgrid permute ipermute shiftdim circshift squeeze isscalar isvector ans eps realmax realmin pi i|0 inf nan isnan isinf isfinite j|0 why compan gallery hadamard hankel hilb invhilb magic pascal rosser toeplitz vander wilkinson max min nanmax nanmin mean nanmean type table readtable writetable sortrows sort figure plot plot3 scatter scatter3 cellfun legend intersect ismember procrustes hold num2cell `
                },
                illegal: `(//|"|#|/\\*|\\s+/\\w+)`,
                contains: [
                    {
                        className: `function`,
                        beginKeywords: `function`,
                        end: `$`,
                        contains: [
                            e.UNDERSCORE_TITLE_MODE,
                            {
                                className: `params`,
                                variants: [
                                    {
                                        begin: `\\(`,
                                        end: `\\)`
                                    },
                                    {
                                        begin: `\\[`,
                                        end: `\\]`
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        className: `built_in`,
                        begin: /true|false/,
                        relevance: 0,
                        starts: n
                    },
                    {
                        begin: `[a-zA-Z][a-zA-Z_0-9]*` + t,
                        relevance: 0
                    },
                    {
                        className: `number`,
                        begin: e.C_NUMBER_RE,
                        relevance: 0,
                        starts: n
                    },
                    {
                        className: `string`,
                        begin: `'`,
                        end: `'`,
                        contains: [
                            {
                                begin: `''`
                            }
                        ]
                    },
                    {
                        begin: /\]|\}|\)/,
                        relevance: 0,
                        starts: n
                    },
                    {
                        className: `string`,
                        begin: `"`,
                        end: `"`,
                        contains: [
                            {
                                begin: `""`
                            }
                        ],
                        starts: n
                    },
                    e.COMMENT(`^\\s*%\\{\\s*$`, `^\\s*%\\}\\s*$`),
                    e.COMMENT(`%`, `$`)
                ]
            };
        }
        t.exports = n;
    }), dt = o((e, t)=>{
        function n(e) {
            return {
                name: `Maxima`,
                keywords: {
                    $pattern: `[A-Za-z_%][0-9A-Za-z_%]*`,
                    keyword: `if then else elseif for thru do while unless step in and or not`,
                    literal: `true false unknown inf minf ind und %e %i %pi %phi %gamma`,
                    built_in: ` abasep abs absint absolute_real_time acos acosh acot acoth acsc acsch activate addcol add_edge add_edges addmatrices addrow add_vertex add_vertices adjacency_matrix adjoin adjoint af agd airy airy_ai airy_bi airy_dai airy_dbi algsys alg_type alias allroots alphacharp alphanumericp amortization %and annuity_fv annuity_pv antid antidiff AntiDifference append appendfile apply apply1 apply2 applyb1 apropos args arit_amortization arithmetic arithsum array arrayapply arrayinfo arraymake arraysetapply ascii asec asech asin asinh askinteger asksign assoc assoc_legendre_p assoc_legendre_q assume assume_external_byte_order asympa at atan atan2 atanh atensimp atom atvalue augcoefmatrix augmented_lagrangian_method av average_degree backtrace bars barsplot barsplot_description base64 base64_decode bashindices batch batchload bc2 bdvac belln benefit_cost bern bernpoly bernstein_approx bernstein_expand bernstein_poly bessel bessel_i bessel_j bessel_k bessel_simplify bessel_y beta beta_incomplete beta_incomplete_generalized beta_incomplete_regularized bezout bfallroots bffac bf_find_root bf_fmin_cobyla bfhzeta bfloat bfloatp bfpsi bfpsi0 bfzeta biconnected_components bimetric binomial bipartition block blockmatrixp bode_gain bode_phase bothcoef box boxplot boxplot_description break bug_report build_info|10 buildq build_sample burn cabs canform canten cardinality carg cartan cartesian_product catch cauchy_matrix cbffac cdf_bernoulli cdf_beta cdf_binomial cdf_cauchy cdf_chi2 cdf_continuous_uniform cdf_discrete_uniform cdf_exp cdf_f cdf_gamma cdf_general_finite_discrete cdf_geometric cdf_gumbel cdf_hypergeometric cdf_laplace cdf_logistic cdf_lognormal cdf_negative_binomial cdf_noncentral_chi2 cdf_noncentral_student_t cdf_normal cdf_pareto cdf_poisson cdf_rank_sum cdf_rayleigh cdf_signed_rank cdf_student_t cdf_weibull cdisplay ceiling central_moment cequal cequalignore cf cfdisrep cfexpand cgeodesic cgreaterp cgreaterpignore changename changevar chaosgame charat charfun charfun2 charlist charp charpoly chdir chebyshev_t chebyshev_u checkdiv check_overlaps chinese cholesky christof chromatic_index chromatic_number cint circulant_graph clear_edge_weight clear_rules clear_vertex_label clebsch_gordan clebsch_graph clessp clesspignore close closefile cmetric coeff coefmatrix cograd col collapse collectterms columnop columnspace columnswap columnvector combination combine comp2pui compare compfile compile compile_file complement_graph complete_bipartite_graph complete_graph complex_number_p components compose_functions concan concat conjugate conmetderiv connected_components connect_vertices cons constant constantp constituent constvalue cont2part content continuous_freq contortion contour_plot contract contract_edge contragrad contrib_ode convert coord copy copy_file copy_graph copylist copymatrix cor cos cosh cot coth cov cov1 covdiff covect covers crc24sum create_graph create_list csc csch csetup cspline ctaylor ct_coordsys ctransform ctranspose cube_graph cuboctahedron_graph cunlisp cv cycle_digraph cycle_graph cylindrical days360 dblint deactivate declare declare_constvalue declare_dimensions declare_fundamental_dimensions declare_fundamental_units declare_qty declare_translated declare_unit_conversion declare_units declare_weights decsym defcon define define_alt_display define_variable defint defmatch defrule defstruct deftaylor degree_sequence del delete deleten delta demo demoivre denom depends derivdegree derivlist describe desolve determinant dfloat dgauss_a dgauss_b dgeev dgemm dgeqrf dgesv dgesvd diag diagmatrix diag_matrix diagmatrixp diameter diff digitcharp dimacs_export dimacs_import dimension dimensionless dimensions dimensions_as_list direct directory discrete_freq disjoin disjointp disolate disp dispcon dispform dispfun dispJordan display disprule dispterms distrib divide divisors divsum dkummer_m dkummer_u dlange dodecahedron_graph dotproduct dotsimp dpart draw draw2d draw3d drawdf draw_file draw_graph dscalar echelon edge_coloring edge_connectivity edges eigens_by_jacobi eigenvalues eigenvectors eighth einstein eivals eivects elapsed_real_time elapsed_run_time ele2comp ele2polynome ele2pui elem elementp elevation_grid elim elim_allbut eliminate eliminate_using ellipse elliptic_e elliptic_ec elliptic_eu elliptic_f elliptic_kc elliptic_pi ematrix empty_graph emptyp endcons entermatrix entertensor entier equal equalp equiv_classes erf erfc erf_generalized erfi errcatch error errormsg errors euler ev eval_string evenp every evolution evolution2d evundiff example exp expand expandwrt expandwrt_factored expint expintegral_chi expintegral_ci expintegral_e expintegral_e1 expintegral_ei expintegral_e_simplify expintegral_li expintegral_shi expintegral_si explicit explose exponentialize express expt exsec extdiff extract_linear_equations extremal_subset ezgcd %f f90 facsum factcomb factor factorfacsum factorial factorout factorsum facts fast_central_elements fast_linsolve fasttimes featurep fernfale fft fib fibtophi fifth filename_merge file_search file_type fillarray findde find_root find_root_abs find_root_error find_root_rel first fix flatten flength float floatnump floor flower_snark flush flush1deriv flushd flushnd flush_output fmin_cobyla forget fortran fourcos fourexpand fourier fourier_elim fourint fourintcos fourintsin foursimp foursin fourth fposition frame_bracket freeof freshline fresnel_c fresnel_s from_adjacency_matrix frucht_graph full_listify fullmap fullmapl fullratsimp fullratsubst fullsetify funcsolve fundamental_dimensions fundamental_units fundef funmake funp fv g0 g1 gamma gamma_greek gamma_incomplete gamma_incomplete_generalized gamma_incomplete_regularized gauss gauss_a gauss_b gaussprob gcd gcdex gcdivide gcfac gcfactor gd generalized_lambert_w genfact gen_laguerre genmatrix gensym geo_amortization geo_annuity_fv geo_annuity_pv geomap geometric geometric_mean geosum get getcurrentdirectory get_edge_weight getenv get_lu_factors get_output_stream_string get_pixel get_plot_option get_tex_environment get_tex_environment_default get_vertex_label gfactor gfactorsum ggf girth global_variances gn gnuplot_close gnuplot_replot gnuplot_reset gnuplot_restart gnuplot_start go Gosper GosperSum gr2d gr3d gradef gramschmidt graph6_decode graph6_encode graph6_export graph6_import graph_center graph_charpoly graph_eigenvalues graph_flow graph_order graph_periphery graph_product graph_size graph_union great_rhombicosidodecahedron_graph great_rhombicuboctahedron_graph grid_graph grind grobner_basis grotzch_graph hamilton_cycle hamilton_path hankel hankel_1 hankel_2 harmonic harmonic_mean hav heawood_graph hermite hessian hgfred hilbertmap hilbert_matrix hipow histogram histogram_description hodge horner hypergeometric i0 i1 %ibes ic1 ic2 ic_convert ichr1 ichr2 icosahedron_graph icosidodecahedron_graph icurvature ident identfor identity idiff idim idummy ieqn %if ifactors iframes ifs igcdex igeodesic_coords ilt image imagpart imetric implicit implicit_derivative implicit_plot indexed_tensor indices induced_subgraph inferencep inference_result infix info_display init_atensor init_ctensor in_neighbors innerproduct inpart inprod inrt integerp integer_partitions integrate intersect intersection intervalp intopois intosum invariant1 invariant2 inverse_fft inverse_jacobi_cd inverse_jacobi_cn inverse_jacobi_cs inverse_jacobi_dc inverse_jacobi_dn inverse_jacobi_ds inverse_jacobi_nc inverse_jacobi_nd inverse_jacobi_ns inverse_jacobi_sc inverse_jacobi_sd inverse_jacobi_sn invert invert_by_adjoint invert_by_lu inv_mod irr is is_biconnected is_bipartite is_connected is_digraph is_edge_in_graph is_graph is_graph_or_digraph ishow is_isomorphic isolate isomorphism is_planar isqrt isreal_p is_sconnected is_tree is_vertex_in_graph items_inference %j j0 j1 jacobi jacobian jacobi_cd jacobi_cn jacobi_cs jacobi_dc jacobi_dn jacobi_ds jacobi_nc jacobi_nd jacobi_ns jacobi_p jacobi_sc jacobi_sd jacobi_sn JF jn join jordan julia julia_set julia_sin %k kdels kdelta kill killcontext kostka kron_delta kronecker_product kummer_m kummer_u kurtosis kurtosis_bernoulli kurtosis_beta kurtosis_binomial kurtosis_chi2 kurtosis_continuous_uniform kurtosis_discrete_uniform kurtosis_exp kurtosis_f kurtosis_gamma kurtosis_general_finite_discrete kurtosis_geometric kurtosis_gumbel kurtosis_hypergeometric kurtosis_laplace kurtosis_logistic kurtosis_lognormal kurtosis_negative_binomial kurtosis_noncentral_chi2 kurtosis_noncentral_student_t kurtosis_normal kurtosis_pareto kurtosis_poisson kurtosis_rayleigh kurtosis_student_t kurtosis_weibull label labels lagrange laguerre lambda lambert_w laplace laplacian_matrix last lbfgs lc2kdt lcharp lc_l lcm lc_u ldefint ldisp ldisplay legendre_p legendre_q leinstein length let letrules letsimp levi_civita lfreeof lgtreillis lhs li liediff limit Lindstedt linear linearinterpol linear_program linear_regression line_graph linsolve listarray list_correlations listify list_matrix_entries list_nc_monomials listoftens listofvars listp lmax lmin load loadfile local locate_matrix_entry log logcontract log_gamma lopow lorentz_gauge lowercasep lpart lratsubst lreduce lriemann lsquares_estimates lsquares_estimates_approximate lsquares_estimates_exact lsquares_mse lsquares_residual_mse lsquares_residuals lsum ltreillis lu_backsub lucas lu_factor %m macroexpand macroexpand1 make_array makebox makefact makegamma make_graph make_level_picture makelist makeOrders make_poly_continent make_poly_country make_polygon make_random_state make_rgb_picture makeset make_string_input_stream make_string_output_stream make_transform mandelbrot mandelbrot_set map mapatom maplist matchdeclare matchfix mat_cond mat_fullunblocker mat_function mathml_display mat_norm matrix matrixmap matrixp matrix_size mattrace mat_trace mat_unblocker max max_clique max_degree max_flow maximize_lp max_independent_set max_matching maybe md5sum mean mean_bernoulli mean_beta mean_binomial mean_chi2 mean_continuous_uniform mean_deviation mean_discrete_uniform mean_exp mean_f mean_gamma mean_general_finite_discrete mean_geometric mean_gumbel mean_hypergeometric mean_laplace mean_logistic mean_lognormal mean_negative_binomial mean_noncentral_chi2 mean_noncentral_student_t mean_normal mean_pareto mean_poisson mean_rayleigh mean_student_t mean_weibull median median_deviation member mesh metricexpandall mgf1_sha1 min min_degree min_edge_cut minfactorial minimalPoly minimize_lp minimum_spanning_tree minor minpack_lsquares minpack_solve min_vertex_cover min_vertex_cut mkdir mnewton mod mode_declare mode_identity ModeMatrix moebius mon2schur mono monomial_dimensions multibernstein_poly multi_display_for_texinfo multi_elem multinomial multinomial_coeff multi_orbit multiplot_mode multi_pui multsym multthru mycielski_graph nary natural_unit nc_degree ncexpt ncharpoly negative_picture neighbors new newcontext newdet new_graph newline newton new_variable next_prime nicedummies niceindices ninth nofix nonarray noncentral_moment nonmetricity nonnegintegerp nonscalarp nonzeroandfreeof notequal nounify nptetrad npv nroots nterms ntermst nthroot nullity nullspace num numbered_boundaries numberp number_to_octets num_distinct_partitions numerval numfactor num_partitions nusum nzeta nzetai nzetar octets_to_number octets_to_oid odd_girth oddp ode2 ode_check odelin oid_to_octets op opena opena_binary openr openr_binary openw openw_binary operatorp opsubst optimize %or orbit orbits ordergreat ordergreatp orderless orderlessp orthogonal_complement orthopoly_recur orthopoly_weight outermap out_neighbors outofpois pade parabolic_cylinder_d parametric parametric_surface parg parGosper parse_string parse_timedate part part2cont partfrac partition partition_set partpol path_digraph path_graph pathname_directory pathname_name pathname_type pdf_bernoulli pdf_beta pdf_binomial pdf_cauchy pdf_chi2 pdf_continuous_uniform pdf_discrete_uniform pdf_exp pdf_f pdf_gamma pdf_general_finite_discrete pdf_geometric pdf_gumbel pdf_hypergeometric pdf_laplace pdf_logistic pdf_lognormal pdf_negative_binomial pdf_noncentral_chi2 pdf_noncentral_student_t pdf_normal pdf_pareto pdf_poisson pdf_rank_sum pdf_rayleigh pdf_signed_rank pdf_student_t pdf_weibull pearson_skewness permanent permut permutation permutations petersen_graph petrov pickapart picture_equalp picturep piechart piechart_description planar_embedding playback plog plot2d plot3d plotdf ploteq plsquares pochhammer points poisdiff poisexpt poisint poismap poisplus poissimp poissubst poistimes poistrim polar polarform polartorect polar_to_xy poly_add poly_buchberger poly_buchberger_criterion poly_colon_ideal poly_content polydecomp poly_depends_p poly_elimination_ideal poly_exact_divide poly_expand poly_expt poly_gcd polygon poly_grobner poly_grobner_equal poly_grobner_member poly_grobner_subsetp poly_ideal_intersection poly_ideal_polysaturation poly_ideal_polysaturation1 poly_ideal_saturation poly_ideal_saturation1 poly_lcm poly_minimization polymod poly_multiply polynome2ele polynomialp poly_normal_form poly_normalize poly_normalize_list poly_polysaturation_extension poly_primitive_part poly_pseudo_divide poly_reduced_grobner poly_reduction poly_saturation_extension poly_s_polynomial poly_subtract polytocompanion pop postfix potential power_mod powerseries powerset prefix prev_prime primep primes principal_components print printf printfile print_graph printpois printprops prodrac product properties propvars psi psubst ptriangularize pui pui2comp pui2ele pui2polynome pui_direct puireduc push put pv qput qrange qty quad_control quad_qag quad_qagi quad_qagp quad_qags quad_qawc quad_qawf quad_qawo quad_qaws quadrilateral quantile quantile_bernoulli quantile_beta quantile_binomial quantile_cauchy quantile_chi2 quantile_continuous_uniform quantile_discrete_uniform quantile_exp quantile_f quantile_gamma quantile_general_finite_discrete quantile_geometric quantile_gumbel quantile_hypergeometric quantile_laplace quantile_logistic quantile_lognormal quantile_negative_binomial quantile_noncentral_chi2 quantile_noncentral_student_t quantile_normal quantile_pareto quantile_poisson quantile_rayleigh quantile_student_t quantile_weibull quartile_skewness quit qunit quotient racah_v racah_w radcan radius random random_bernoulli random_beta random_binomial random_bipartite_graph random_cauchy random_chi2 random_continuous_uniform random_digraph random_discrete_uniform random_exp random_f random_gamma random_general_finite_discrete random_geometric random_graph random_graph1 random_gumbel random_hypergeometric random_laplace random_logistic random_lognormal random_negative_binomial random_network random_noncentral_chi2 random_noncentral_student_t random_normal random_pareto random_permutation random_poisson random_rayleigh random_regular_graph random_student_t random_tournament random_tree random_weibull range rank rat ratcoef ratdenom ratdiff ratdisrep ratexpand ratinterpol rational rationalize ratnumer ratnump ratp ratsimp ratsubst ratvars ratweight read read_array read_binary_array read_binary_list read_binary_matrix readbyte readchar read_hashed_array readline read_list read_matrix read_nested_list readonly read_xpm real_imagpart_to_conjugate realpart realroots rearray rectangle rectform rectform_log_if_constant recttopolar rediff reduce_consts reduce_order region region_boundaries region_boundaries_plus rem remainder remarray rembox remcomps remcon remcoord remfun remfunction remlet remove remove_constvalue remove_dimensions remove_edge remove_fundamental_dimensions remove_fundamental_units remove_plot_option remove_vertex rempart remrule remsym remvalue rename rename_file reset reset_displays residue resolvante resolvante_alternee1 resolvante_bipartite resolvante_diedrale resolvante_klein resolvante_klein3 resolvante_produit_sym resolvante_unitaire resolvante_vierer rest resultant return reveal reverse revert revert2 rgb2level rhs ricci riemann rinvariant risch rk rmdir rncombine romberg room rootscontract round row rowop rowswap rreduce run_testsuite %s save saving scalarp scaled_bessel_i scaled_bessel_i0 scaled_bessel_i1 scalefactors scanmap scatterplot scatterplot_description scene schur2comp sconcat scopy scsimp scurvature sdowncase sec sech second sequal sequalignore set_alt_display setdifference set_draw_defaults set_edge_weight setelmx setequalp setify setp set_partitions set_plot_option set_prompt set_random_state set_tex_environment set_tex_environment_default setunits setup_autoload set_up_dot_simplifications set_vertex_label seventh sexplode sf sha1sum sha256sum shortest_path shortest_weighted_path show showcomps showratvars sierpinskiale sierpinskimap sign signum similaritytransform simp_inequality simplify_sum simplode simpmetderiv simtran sin sinh sinsert sinvertcase sixth skewness skewness_bernoulli skewness_beta skewness_binomial skewness_chi2 skewness_continuous_uniform skewness_discrete_uniform skewness_exp skewness_f skewness_gamma skewness_general_finite_discrete skewness_geometric skewness_gumbel skewness_hypergeometric skewness_laplace skewness_logistic skewness_lognormal skewness_negative_binomial skewness_noncentral_chi2 skewness_noncentral_student_t skewness_normal skewness_pareto skewness_poisson skewness_rayleigh skewness_student_t skewness_weibull slength smake small_rhombicosidodecahedron_graph small_rhombicuboctahedron_graph smax smin smismatch snowmap snub_cube_graph snub_dodecahedron_graph solve solve_rec solve_rec_rat some somrac sort sparse6_decode sparse6_encode sparse6_export sparse6_import specint spherical spherical_bessel_j spherical_bessel_y spherical_hankel1 spherical_hankel2 spherical_harmonic spherical_to_xyz splice split sposition sprint sqfr sqrt sqrtdenest sremove sremovefirst sreverse ssearch ssort sstatus ssubst ssubstfirst staircase standardize standardize_inverse_trig starplot starplot_description status std std1 std_bernoulli std_beta std_binomial std_chi2 std_continuous_uniform std_discrete_uniform std_exp std_f std_gamma std_general_finite_discrete std_geometric std_gumbel std_hypergeometric std_laplace std_logistic std_lognormal std_negative_binomial std_noncentral_chi2 std_noncentral_student_t std_normal std_pareto std_poisson std_rayleigh std_student_t std_weibull stemplot stirling stirling1 stirling2 strim striml strimr string stringout stringp strong_components struve_h struve_l sublis sublist sublist_indices submatrix subsample subset subsetp subst substinpart subst_parallel substpart substring subvar subvarp sum sumcontract summand_to_rec supcase supcontext symbolp symmdifference symmetricp system take_channel take_inference tan tanh taylor taylorinfo taylorp taylor_simplifier taytorat tcl_output tcontract tellrat tellsimp tellsimpafter tentex tenth test_mean test_means_difference test_normality test_proportion test_proportions_difference test_rank_sum test_sign test_signed_rank test_variance test_variance_ratio tex tex1 tex_display texput %th third throw time timedate timer timer_info tldefint tlimit todd_coxeter toeplitz tokens to_lisp topological_sort to_poly to_poly_solve totaldisrep totalfourier totient tpartpol trace tracematrix trace_options transform_sample translate translate_file transpose treefale tree_reduce treillis treinat triangle triangularize trigexpand trigrat trigreduce trigsimp trunc truncate truncated_cube_graph truncated_dodecahedron_graph truncated_icosahedron_graph truncated_tetrahedron_graph tr_warnings_get tube tutte_graph ueivects uforget ultraspherical underlying_graph undiff union unique uniteigenvectors unitp units unit_step unitvector unorder unsum untellrat untimer untrace uppercasep uricci uriemann uvect vandermonde_matrix var var1 var_bernoulli var_beta var_binomial var_chi2 var_continuous_uniform var_discrete_uniform var_exp var_f var_gamma var_general_finite_discrete var_geometric var_gumbel var_hypergeometric var_laplace var_logistic var_lognormal var_negative_binomial var_noncentral_chi2 var_noncentral_student_t var_normal var_pareto var_poisson var_rayleigh var_student_t var_weibull vector vectorpotential vectorsimp verbify vers vertex_coloring vertex_connectivity vertex_degree vertex_distance vertex_eccentricity vertex_in_degree vertex_out_degree vertices vertices_to_cycle vertices_to_path %w weyl wheel_graph wiener_index wigner_3j wigner_6j wigner_9j with_stdout write_binary_data writebyte write_data writefile wronskian xreduce xthru %y Zeilberger zeroequiv zerofor zeromatrix zeromatrixp zeta zgeev zheev zlange zn_add_table zn_carmichael_lambda zn_characteristic_factors zn_determinant zn_factor_generators zn_invert_by_lu zn_log zn_mult_table absboxchar activecontexts adapt_depth additive adim aform algebraic algepsilon algexact aliases allbut all_dotsimp_denoms allocation allsym alphabetic animation antisymmetric arrays askexp assume_pos assume_pos_pred assumescalar asymbol atomgrad atrig1 axes axis_3d axis_bottom axis_left axis_right axis_top azimuth background background_color backsubst berlefact bernstein_explicit besselexpand beta_args_sum_to_integer beta_expand bftorat bftrunc bindtest border boundaries_array box boxchar breakup %c capping cauchysum cbrange cbtics center cflength cframe_flag cnonmet_flag color color_bar color_bar_tics colorbox columns commutative complex cone context contexts contour contour_levels cosnpiflag ctaypov ctaypt ctayswitch ctayvar ct_coords ctorsion_flag ctrgsimp cube current_let_rule_package cylinder data_file_name debugmode decreasing default_let_rule_package delay dependencies derivabbrev derivsubst detout diagmetric diff dim dimensions dispflag display2d|10 display_format_internal distribute_over doallmxops domain domxexpt domxmxops domxnctimes dontfactor doscmxops doscmxplus dot0nscsimp dot0simp dot1simp dotassoc dotconstrules dotdistrib dotexptsimp dotident dotscrules draw_graph_program draw_realpart edge_color edge_coloring edge_partition edge_type edge_width %edispflag elevation %emode endphi endtheta engineering_format_floats enhanced3d %enumer epsilon_lp erfflag erf_representation errormsg error_size error_syms error_type %e_to_numlog eval even evenfun evflag evfun ev_point expandwrt_denom expintexpand expintrep expon expop exptdispflag exptisolate exptsubst facexpand facsum_combine factlim factorflag factorial_expand factors_only fb feature features file_name file_output_append file_search_demo file_search_lisp file_search_maxima|10 file_search_tests file_search_usage file_type_lisp file_type_maxima|10 fill_color fill_density filled_func fixed_vertices flipflag float2bf font font_size fortindent fortspaces fpprec fpprintprec functions gamma_expand gammalim gdet genindex gensumnum GGFCFMAX GGFINFINITY globalsolve gnuplot_command gnuplot_curve_styles gnuplot_curve_titles gnuplot_default_term_command gnuplot_dumb_term_command gnuplot_file_args gnuplot_file_name gnuplot_out_file gnuplot_pdf_term_command gnuplot_pm3d gnuplot_png_term_command gnuplot_postamble gnuplot_preamble gnuplot_ps_term_command gnuplot_svg_term_command gnuplot_term gnuplot_view_args Gosper_in_Zeilberger gradefs grid grid2d grind halfangles head_angle head_both head_length head_type height hypergeometric_representation %iargs ibase icc1 icc2 icounter idummyx ieqnprint ifb ifc1 ifc2 ifg ifgi ifr iframe_bracket_form ifri igeowedge_flag ikt1 ikt2 imaginary inchar increasing infeval infinity inflag infolists inm inmc1 inmc2 intanalysis integer integervalued integrate_use_rootsof integration_constant integration_constant_counter interpolate_color intfaclim ip_grid ip_grid_in irrational isolate_wrt_times iterations itr julia_parameter %k1 %k2 keepfloat key key_pos kinvariant kt label label_alignment label_orientation labels lassociative lbfgs_ncorrections lbfgs_nfeval_max leftjust legend letrat let_rule_packages lfg lg lhospitallim limsubst linear linear_solver linechar linel|10 linenum line_type linewidth line_width linsolve_params linsolvewarn lispdisp listarith listconstvars listdummyvars lmxchar load_pathname loadprint logabs logarc logcb logconcoeffp logexpand lognegint logsimp logx logx_secondary logy logy_secondary logz lriem m1pbranch macroexpansion macros mainvar manual_demo maperror mapprint matrix_element_add matrix_element_mult matrix_element_transpose maxapplydepth maxapplyheight maxima_tempdir|10 maxima_userdir|10 maxnegex MAX_ORD maxposex maxpsifracdenom maxpsifracnum maxpsinegint maxpsiposint maxtayorder mesh_lines_color method mod_big_prime mode_check_errorp mode_checkp mode_check_warnp mod_test mod_threshold modular_linear_solver modulus multiplicative multiplicities myoptions nary negdistrib negsumdispflag newline newtonepsilon newtonmaxiter nextlayerfactor niceindicespref nm nmc noeval nolabels nonegative_lp noninteger nonscalar noun noundisp nouns np npi nticks ntrig numer numer_pbranch obase odd oddfun opacity opproperties opsubst optimprefix optionset orientation origin orthopoly_returns_intervals outative outchar packagefile palette partswitch pdf_file pfeformat phiresolution %piargs piece pivot_count_sx pivot_max_sx plot_format plot_options plot_realpart png_file pochhammer_max_index points pointsize point_size points_joined point_type poislim poisson poly_coefficient_ring poly_elimination_order polyfactor poly_grobner_algorithm poly_grobner_debug poly_monomial_order poly_primary_elimination_order poly_return_term_list poly_secondary_elimination_order poly_top_reduction_only posfun position powerdisp pred prederror primep_number_of_tests product_use_gamma program programmode promote_float_to_bigfloat prompt proportional_axes props psexpand ps_file radexpand radius radsubstflag rassociative ratalgdenom ratchristof ratdenomdivide rateinstein ratepsilon ratfac rational ratmx ratprint ratriemann ratsimpexpons ratvarswitch ratweights ratweyl ratwtlvl real realonly redraw refcheck resolution restart resultant ric riem rmxchar %rnum_list rombergabs rombergit rombergmin rombergtol rootsconmode rootsepsilon run_viewer same_xy same_xyz savedef savefactors scalar scalarmatrixp scale scale_lp setcheck setcheckbreak setval show_edge_color show_edges show_edge_type show_edge_width show_id show_label showtime show_vertex_color show_vertex_size show_vertex_type show_vertices show_weight simp simplified_output simplify_products simpproduct simpsum sinnpiflag solvedecomposes solveexplicit solvefactors solvenullwarn solveradcan solvetrigwarn space sparse sphere spring_embedding_depth sqrtdispflag stardisp startphi starttheta stats_numer stringdisp structures style sublis_apply_lambda subnumsimp sumexpand sumsplitfact surface surface_hide svg_file symmetric tab taylordepth taylor_logexpand taylor_order_coefficients taylor_truncate_polynomials tensorkill terminal testsuite_files thetaresolution timer_devalue title tlimswitch tr track transcompile transform transform_xy translate_fast_arrays transparent transrun tr_array_as_ref tr_bound_function_applyp tr_file_tty_messagesp tr_float_can_branch_complex tr_function_call_default trigexpandplus trigexpandtimes triginverses trigsign trivial_solutions tr_numer tr_optimize_max_loop tr_semicompile tr_state_vars tr_warn_bad_function_calls tr_warn_fexpr tr_warn_meval tr_warn_mode tr_warn_undeclared tr_warn_undefined_variable tstep ttyoff tube_extremes ufg ug %unitexpand unit_vectors uric uriem use_fast_arrays user_preamble usersetunits values vect_cross verbose vertex_color vertex_coloring vertex_partition vertex_size vertex_type view warnings weyl width windowname windowtitle wired_surface wireframe xaxis xaxis_color xaxis_secondary xaxis_type xaxis_width xlabel xlabel_secondary xlength xrange xrange_secondary xtics xtics_axis xtics_rotate xtics_rotate_secondary xtics_secondary xtics_secondary_axis xu_grid x_voxel xy_file xyplane xy_scale yaxis yaxis_color yaxis_secondary yaxis_type yaxis_width ylabel ylabel_secondary ylength yrange yrange_secondary ytics ytics_axis ytics_rotate ytics_rotate_secondary ytics_secondary ytics_secondary_axis yv_grid y_voxel yx_ratio zaxis zaxis_color zaxis_type zaxis_width zeroa zerob zerobern zeta%pi zlabel zlabel_rotate zlength zmin zn_primroot_limit zn_primroot_pretest`,
                    symbol: `_ __ %|0 %%|0`
                },
                contains: [
                    {
                        className: `comment`,
                        begin: `/\\*`,
                        end: `\\*/`,
                        contains: [
                            `self`
                        ]
                    },
                    e.QUOTE_STRING_MODE,
                    {
                        className: `number`,
                        relevance: 0,
                        variants: [
                            {
                                begin: `\\b(\\d+|\\d+\\.|\\.\\d+|\\d+\\.\\d+)[Ee][-+]?\\d+\\b`
                            },
                            {
                                begin: `\\b(\\d+|\\d+\\.|\\.\\d+|\\d+\\.\\d+)[Bb][-+]?\\d+\\b`,
                                relevance: 10
                            },
                            {
                                begin: `\\b(\\.\\d+|\\d+\\.\\d+)\\b`
                            },
                            {
                                begin: `\\b(\\d+|0[0-9A-Za-z]+)\\.?\\b`
                            }
                        ]
                    }
                ],
                illegal: /@/
            };
        }
        t.exports = n;
    }), ft = o((e, t)=>{
        function n(e) {
            return {
                name: `MEL`,
                keywords: `int float string vector matrix if else switch case default while do for in break continue global proc return about abs addAttr addAttributeEditorNodeHelp addDynamic addNewShelfTab addPP addPanelCategory addPrefixToName advanceToNextDrivenKey affectedNet affects aimConstraint air alias aliasAttr align alignCtx alignCurve alignSurface allViewFit ambientLight angle angleBetween animCone animCurveEditor animDisplay animView annotate appendStringArray applicationName applyAttrPreset applyTake arcLenDimContext arcLengthDimension arclen arrayMapper art3dPaintCtx artAttrCtx artAttrPaintVertexCtx artAttrSkinPaintCtx artAttrTool artBuildPaintMenu artFluidAttrCtx artPuttyCtx artSelectCtx artSetPaintCtx artUserPaintCtx assignCommand assignInputDevice assignViewportFactories attachCurve attachDeviceAttr attachSurface attrColorSliderGrp attrCompatibility attrControlGrp attrEnumOptionMenu attrEnumOptionMenuGrp attrFieldGrp attrFieldSliderGrp attrNavigationControlGrp attrPresetEditWin attributeExists attributeInfo attributeMenu attributeQuery autoKeyframe autoPlace bakeClip bakeFluidShading bakePartialHistory bakeResults bakeSimulation basename basenameEx batchRender bessel bevel bevelPlus binMembership bindSkin blend2 blendShape blendShapeEditor blendShapePanel blendTwoAttr blindDataType boneLattice boundary boxDollyCtx boxZoomCtx bufferCurve buildBookmarkMenu buildKeyframeMenu button buttonManip CBG cacheFile cacheFileCombine cacheFileMerge cacheFileTrack camera cameraView canCreateManip canvas capitalizeString catch catchQuiet ceil changeSubdivComponentDisplayLevel changeSubdivRegion channelBox character characterMap characterOutlineEditor characterize chdir checkBox checkBoxGrp checkDefaultRenderGlobals choice circle circularFillet clamp clear clearCache clip clipEditor clipEditorCurrentTimeCtx clipSchedule clipSchedulerOutliner clipTrimBefore closeCurve closeSurface cluster cmdFileOutput cmdScrollFieldExecuter cmdScrollFieldReporter cmdShell coarsenSubdivSelectionList collision color colorAtPoint colorEditor colorIndex colorIndexSliderGrp colorSliderButtonGrp colorSliderGrp columnLayout commandEcho commandLine commandPort compactHairSystem componentEditor compositingInterop computePolysetVolume condition cone confirmDialog connectAttr connectControl connectDynamic connectJoint connectionInfo constrain constrainValue constructionHistory container containsMultibyte contextInfo control convertFromOldLayers convertIffToPsd convertLightmap convertSolidTx convertTessellation convertUnit copyArray copyFlexor copyKey copySkinWeights cos cpButton cpCache cpClothSet cpCollision cpConstraint cpConvClothToMesh cpForces cpGetSolverAttr cpPanel cpProperty cpRigidCollisionFilter cpSeam cpSetEdit cpSetSolverAttr cpSolver cpSolverTypes cpTool cpUpdateClothUVs createDisplayLayer createDrawCtx createEditor createLayeredPsdFile createMotionField createNewShelf createNode createRenderLayer createSubdivRegion cross crossProduct ctxAbort ctxCompletion ctxEditMode ctxTraverse currentCtx currentTime currentTimeCtx currentUnit curve curveAddPtCtx curveCVCtx curveEPCtx curveEditorCtx curveIntersect curveMoveEPCtx curveOnSurface curveSketchCtx cutKey cycleCheck cylinder dagPose date defaultLightListCheckBox defaultNavigation defineDataServer defineVirtualDevice deformer deg_to_rad delete deleteAttr deleteShadingGroupsAndMaterials deleteShelfTab deleteUI deleteUnusedBrushes delrandstr detachCurve detachDeviceAttr detachSurface deviceEditor devicePanel dgInfo dgdirty dgeval dgtimer dimWhen directKeyCtx directionalLight dirmap dirname disable disconnectAttr disconnectJoint diskCache displacementToPoly displayAffected displayColor displayCull displayLevelOfDetail displayPref displayRGBColor displaySmoothness displayStats displayString displaySurface distanceDimContext distanceDimension doBlur dolly dollyCtx dopeSheetEditor dot dotProduct doubleProfileBirailSurface drag dragAttrContext draggerContext dropoffLocator duplicate duplicateCurve duplicateSurface dynCache dynControl dynExport dynExpression dynGlobals dynPaintEditor dynParticleCtx dynPref dynRelEdPanel dynRelEditor dynamicLoad editAttrLimits editDisplayLayerGlobals editDisplayLayerMembers editRenderLayerAdjustment editRenderLayerGlobals editRenderLayerMembers editor editorTemplate effector emit emitter enableDevice encodeString endString endsWith env equivalent equivalentTol erf error eval evalDeferred evalEcho event exactWorldBoundingBox exclusiveLightCheckBox exec executeForEachObject exists exp expression expressionEditorListen extendCurve extendSurface extrude fcheck fclose feof fflush fgetline fgetword file fileBrowserDialog fileDialog fileExtension fileInfo filetest filletCurve filter filterCurve filterExpand filterStudioImport findAllIntersections findAnimCurves findKeyframe findMenuItem findRelatedSkinCluster finder firstParentOf fitBspline flexor floatEq floatField floatFieldGrp floatScrollBar floatSlider floatSlider2 floatSliderButtonGrp floatSliderGrp floor flow fluidCacheInfo fluidEmitter fluidVoxelInfo flushUndo fmod fontDialog fopen formLayout format fprint frameLayout fread freeFormFillet frewind fromNativePath fwrite gamma gauss geometryConstraint getApplicationVersionAsFloat getAttr getClassification getDefaultBrush getFileList getFluidAttr getInputDeviceRange getMayaPanelTypes getModifiers getPanel getParticleAttr getPluginResource getenv getpid glRender glRenderEditor globalStitch gmatch goal gotoBindPose grabColor gradientControl gradientControlNoAttr graphDollyCtx graphSelectContext graphTrackCtx gravity grid gridLayout group groupObjectsByName HfAddAttractorToAS HfAssignAS HfBuildEqualMap HfBuildFurFiles HfBuildFurImages HfCancelAFR HfConnectASToHF HfCreateAttractor HfDeleteAS HfEditAS HfPerformCreateAS HfRemoveAttractorFromAS HfSelectAttached HfSelectAttractors HfUnAssignAS hardenPointCurve hardware hardwareRenderPanel headsUpDisplay headsUpMessage help helpLine hermite hide hilite hitTest hotBox hotkey hotkeyCheck hsv_to_rgb hudButton hudSlider hudSliderButton hwReflectionMap hwRender hwRenderLoad hyperGraph hyperPanel hyperShade hypot iconTextButton iconTextCheckBox iconTextRadioButton iconTextRadioCollection iconTextScrollList iconTextStaticLabel ikHandle ikHandleCtx ikHandleDisplayScale ikSolver ikSplineHandleCtx ikSystem ikSystemInfo ikfkDisplayMethod illustratorCurves image imfPlugins inheritTransform insertJoint insertJointCtx insertKeyCtx insertKnotCurve insertKnotSurface instance instanceable instancer intField intFieldGrp intScrollBar intSlider intSliderGrp interToUI internalVar intersect iprEngine isAnimCurve isConnected isDirty isParentOf isSameObject isTrue isValidObjectName isValidString isValidUiName isolateSelect itemFilter itemFilterAttr itemFilterRender itemFilterType joint jointCluster jointCtx jointDisplayScale jointLattice keyTangent keyframe keyframeOutliner keyframeRegionCurrentTimeCtx keyframeRegionDirectKeyCtx keyframeRegionDollyCtx keyframeRegionInsertKeyCtx keyframeRegionMoveKeyCtx keyframeRegionScaleKeyCtx keyframeRegionSelectKeyCtx keyframeRegionSetKeyCtx keyframeRegionTrackCtx keyframeStats lassoContext lattice latticeDeformKeyCtx launch launchImageEditor layerButton layeredShaderPort layeredTexturePort layout layoutDialog lightList lightListEditor lightListPanel lightlink lineIntersection linearPrecision linstep listAnimatable listAttr listCameras listConnections listDeviceAttachments listHistory listInputDeviceAxes listInputDeviceButtons listInputDevices listMenuAnnotation listNodeTypes listPanelCategories listRelatives listSets listTransforms listUnselected listerEditor loadFluid loadNewShelf loadPlugin loadPluginLanguageResources loadPrefObjects localizedPanelLabel lockNode loft log longNameOf lookThru ls lsThroughFilter lsType lsUI Mayatomr mag makeIdentity makeLive makePaintable makeRoll makeSingleSurface makeTubeOn makebot manipMoveContext manipMoveLimitsCtx manipOptions manipRotateContext manipRotateLimitsCtx manipScaleContext manipScaleLimitsCtx marker match max memory menu menuBarLayout menuEditor menuItem menuItemToShelf menuSet menuSetPref messageLine min minimizeApp mirrorJoint modelCurrentTimeCtx modelEditor modelPanel mouse movIn movOut move moveIKtoFK moveKeyCtx moveVertexAlongDirection multiProfileBirailSurface mute nParticle nameCommand nameField namespace namespaceInfo newPanelItems newton nodeCast nodeIconButton nodeOutliner nodePreset nodeType noise nonLinear normalConstraint normalize nurbsBoolean nurbsCopyUVSet nurbsCube nurbsEditUV nurbsPlane nurbsSelect nurbsSquare nurbsToPoly nurbsToPolygonsPref nurbsToSubdiv nurbsToSubdivPref nurbsUVSet nurbsViewDirectionVector objExists objectCenter objectLayer objectType objectTypeUI obsoleteProc oceanNurbsPreviewPlane offsetCurve offsetCurveOnSurface offsetSurface openGLExtension openMayaPref optionMenu optionMenuGrp optionVar orbit orbitCtx orientConstraint outlinerEditor outlinerPanel overrideModifier paintEffectsDisplay pairBlend palettePort paneLayout panel panelConfiguration panelHistory paramDimContext paramDimension paramLocator parent parentConstraint particle particleExists particleInstancer particleRenderInfo partition pasteKey pathAnimation pause pclose percent performanceOptions pfxstrokes pickWalk picture pixelMove planarSrf plane play playbackOptions playblast plugAttr plugNode pluginInfo pluginResourceUtil pointConstraint pointCurveConstraint pointLight pointMatrixMult pointOnCurve pointOnSurface pointPosition poleVectorConstraint polyAppend polyAppendFacetCtx polyAppendVertex polyAutoProjection polyAverageNormal polyAverageVertex polyBevel polyBlendColor polyBlindData polyBoolOp polyBridgeEdge polyCacheMonitor polyCheck polyChipOff polyClipboard polyCloseBorder polyCollapseEdge polyCollapseFacet polyColorBlindData polyColorDel polyColorPerVertex polyColorSet polyCompare polyCone polyCopyUV polyCrease polyCreaseCtx polyCreateFacet polyCreateFacetCtx polyCube polyCut polyCutCtx polyCylinder polyCylindricalProjection polyDelEdge polyDelFacet polyDelVertex polyDuplicateAndConnect polyDuplicateEdge polyEditUV polyEditUVShell polyEvaluate polyExtrudeEdge polyExtrudeFacet polyExtrudeVertex polyFlipEdge polyFlipUV polyForceUV polyGeoSampler polyHelix polyInfo polyInstallAction polyLayoutUV polyListComponentConversion polyMapCut polyMapDel polyMapSew polyMapSewMove polyMergeEdge polyMergeEdgeCtx polyMergeFacet polyMergeFacetCtx polyMergeUV polyMergeVertex polyMirrorFace polyMoveEdge polyMoveFacet polyMoveFacetUV polyMoveUV polyMoveVertex polyNormal polyNormalPerVertex polyNormalizeUV polyOptUvs polyOptions polyOutput polyPipe polyPlanarProjection polyPlane polyPlatonicSolid polyPoke polyPrimitive polyPrism polyProjection polyPyramid polyQuad polyQueryBlindData polyReduce polySelect polySelectConstraint polySelectConstraintMonitor polySelectCtx polySelectEditCtx polySeparate polySetToFaceNormal polySewEdge polyShortestPathCtx polySmooth polySoftEdge polySphere polySphericalProjection polySplit polySplitCtx polySplitEdge polySplitRing polySplitVertex polyStraightenUVBorder polySubdivideEdge polySubdivideFacet polyToSubdiv polyTorus polyTransfer polyTriangulate polyUVSet polyUnite polyWedgeFace popen popupMenu pose pow preloadRefEd print progressBar progressWindow projFileViewer projectCurve projectTangent projectionContext projectionManip promptDialog propModCtx propMove psdChannelOutliner psdEditTextureFile psdExport psdTextureFile putenv pwd python querySubdiv quit rad_to_deg radial radioButton radioButtonGrp radioCollection radioMenuItemCollection rampColorPort rand randomizeFollicles randstate rangeControl readTake rebuildCurve rebuildSurface recordAttr recordDevice redo reference referenceEdit referenceQuery refineSubdivSelectionList refresh refreshAE registerPluginResource rehash reloadImage removeJoint removeMultiInstance removePanelCategory rename renameAttr renameSelectionList renameUI render renderGlobalsNode renderInfo renderLayerButton renderLayerParent renderLayerPostProcess renderLayerUnparent renderManip renderPartition renderQualityNode renderSettings renderThumbnailUpdate renderWindowEditor renderWindowSelectContext renderer reorder reorderDeformers requires reroot resampleFluid resetAE resetPfxToPolyCamera resetTool resolutionNode retarget reverseCurve reverseSurface revolve rgb_to_hsv rigidBody rigidSolver roll rollCtx rootOf rot rotate rotationInterpolation roundConstantRadius rowColumnLayout rowLayout runTimeCommand runup sampleImage saveAllShelves saveAttrPreset saveFluid saveImage saveInitialState saveMenu savePrefObjects savePrefs saveShelf saveToolSettings scale scaleBrushBrightness scaleComponents scaleConstraint scaleKey scaleKeyCtx sceneEditor sceneUIReplacement scmh scriptCtx scriptEditorInfo scriptJob scriptNode scriptTable scriptToShelf scriptedPanel scriptedPanelType scrollField scrollLayout sculpt searchPathArray seed selLoadSettings select selectContext selectCurveCV selectKey selectKeyCtx selectKeyframeRegionCtx selectMode selectPref selectPriority selectType selectedNodes selectionConnection separator setAttr setAttrEnumResource setAttrMapping setAttrNiceNameResource setConstraintRestPosition setDefaultShadingGroup setDrivenKeyframe setDynamic setEditCtx setEditor setFluidAttr setFocus setInfinity setInputDeviceMapping setKeyCtx setKeyPath setKeyframe setKeyframeBlendshapeTargetWts setMenuMode setNodeNiceNameResource setNodeTypeFlag setParent setParticleAttr setPfxToPolyCamera setPluginResource setProject setStampDensity setStartupMessage setState setToolTo setUITemplate setXformManip sets shadingConnection shadingGeometryRelCtx shadingLightRelCtx shadingNetworkCompare shadingNode shapeCompare shelfButton shelfLayout shelfTabLayout shellField shortNameOf showHelp showHidden showManipCtx showSelectionInTitle showShadingGroupAttrEditor showWindow sign simplify sin singleProfileBirailSurface size sizeBytes skinCluster skinPercent smoothCurve smoothTangentSurface smoothstep snap2to2 snapKey snapMode snapTogetherCtx snapshot soft softMod softModCtx sort sound soundControl source spaceLocator sphere sphrand spotLight spotLightPreviewPort spreadSheetEditor spring sqrt squareSurface srtContext stackTrace startString startsWith stitchAndExplodeShell stitchSurface stitchSurfacePoints strcmp stringArrayCatenate stringArrayContains stringArrayCount stringArrayInsertAtIndex stringArrayIntersector stringArrayRemove stringArrayRemoveAtIndex stringArrayRemoveDuplicates stringArrayRemoveExact stringArrayToString stringToStringArray strip stripPrefixFromName stroke subdAutoProjection subdCleanTopology subdCollapse subdDuplicateAndConnect subdEditUV subdListComponentConversion subdMapCut subdMapSewMove subdMatchTopology subdMirror subdToBlind subdToPoly subdTransferUVsToCache subdiv subdivCrease subdivDisplaySmoothness substitute substituteAllString substituteGeometry substring surface surfaceSampler surfaceShaderList swatchDisplayPort switchTable symbolButton symbolCheckBox sysFile system tabLayout tan tangentConstraint texLatticeDeformContext texManipContext texMoveContext texMoveUVShellContext texRotateContext texScaleContext texSelectContext texSelectShortestPathCtx texSmudgeUVContext texWinToolCtx text textCurves textField textFieldButtonGrp textFieldGrp textManip textScrollList textToShelf textureDisplacePlane textureHairColor texturePlacementContext textureWindow threadCount threePointArcCtx timeControl timePort timerX toNativePath toggle toggleAxis toggleWindowVisibility tokenize tokenizeList tolerance tolower toolButton toolCollection toolDropped toolHasOptions toolPropertyWindow torus toupper trace track trackCtx transferAttributes transformCompare transformLimits translator trim trunc truncateFluidCache truncateHairCache tumble tumbleCtx turbulence twoPointArcCtx uiRes uiTemplate unassignInputDevice undo undoInfo ungroup uniform unit unloadPlugin untangleUV untitledFileName untrim upAxis updateAE userCtx uvLink uvSnapshot validateShelfName vectorize view2dToolCtx viewCamera viewClipPlane viewFit viewHeadOn viewLookAt viewManip viewPlace viewSet visor volumeAxis vortex waitCursor warning webBrowser webBrowserPrefs whatIs window windowPref wire wireContext workspace wrinkle wrinkleContext writeTake xbmLangPathList xform`,
                illegal: `</`,
                contains: [
                    e.C_NUMBER_MODE,
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE,
                    {
                        className: `string`,
                        begin: "`",
                        end: "`",
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ]
                    },
                    {
                        begin: /[$%@](\^\w\b|#\w+|[^\s\w{]|\{\w+\}|\w+)/
                    },
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE
                ]
            };
        }
        t.exports = n;
    }), pt = o((e, t)=>{
        function n(e) {
            let t = {
                keyword: `module use_module import_module include_module end_module initialise mutable initialize finalize finalise interface implementation pred mode func type inst solver any_pred any_func is semidet det nondet multi erroneous failure cc_nondet cc_multi typeclass instance where pragma promise external trace atomic or_else require_complete_switch require_det require_semidet require_multi require_nondet require_cc_multi require_cc_nondet require_erroneous require_failure`,
                meta: `inline no_inline type_spec source_file fact_table obsolete memo loop_check minimal_model terminates does_not_terminate check_termination promise_equivalent_clauses foreign_proc foreign_decl foreign_code foreign_type foreign_import_module foreign_export_enum foreign_export foreign_enum may_call_mercury will_not_call_mercury thread_safe not_thread_safe maybe_thread_safe promise_pure promise_semipure tabled_for_io local untrailed trailed attach_to_io_state can_pass_as_mercury_type stable will_not_throw_exception may_modify_trail will_not_modify_trail may_duplicate may_not_duplicate affects_liveness does_not_affect_liveness doesnt_affect_liveness no_sharing unknown_sharing sharing`,
                built_in: `some all not if then else true fail false try catch catch_any semidet_true semidet_false semidet_fail impure_true impure semipure`
            }, n = e.COMMENT(`%`, `$`), r = {
                className: `number`,
                begin: `0'.\\|0[box][0-9a-fA-F]*`
            }, i = e.inherit(e.APOS_STRING_MODE, {
                relevance: 0
            }), a = e.inherit(e.QUOTE_STRING_MODE, {
                relevance: 0
            });
            return a.contains = a.contains.slice(), a.contains.push({
                className: `subst`,
                begin: `\\\\[abfnrtv]\\|\\\\x[0-9a-fA-F]*\\\\\\|%[-+# *.0-9]*[dioxXucsfeEgGp]`,
                relevance: 0
            }), {
                name: `Mercury`,
                aliases: [
                    `m`,
                    `moo`
                ],
                keywords: t,
                contains: [
                    {
                        className: `built_in`,
                        variants: [
                            {
                                begin: `<=>`
                            },
                            {
                                begin: `<=`,
                                relevance: 0
                            },
                            {
                                begin: `=>`,
                                relevance: 0
                            },
                            {
                                begin: `/\\\\`
                            },
                            {
                                begin: `\\\\/`
                            }
                        ]
                    },
                    {
                        className: `built_in`,
                        variants: [
                            {
                                begin: `:-\\|-->`
                            },
                            {
                                begin: `=`,
                                relevance: 0
                            }
                        ]
                    },
                    n,
                    e.C_BLOCK_COMMENT_MODE,
                    r,
                    e.NUMBER_MODE,
                    i,
                    a,
                    {
                        begin: /:-/
                    },
                    {
                        begin: /\.$/
                    }
                ]
            };
        }
        t.exports = n;
    }), mt = o((e, t)=>{
        function n(e) {
            return {
                name: `MIPS Assembly`,
                case_insensitive: !0,
                aliases: [
                    `mips`
                ],
                keywords: {
                    $pattern: `\\.?` + e.IDENT_RE,
                    meta: `.2byte .4byte .align .ascii .asciz .balign .byte .code .data .else .end .endif .endm .endr .equ .err .exitm .extern .global .hword .if .ifdef .ifndef .include .irp .long .macro .rept .req .section .set .skip .space .text .word .ltorg `,
                    built_in: `$0 $1 $2 $3 $4 $5 $6 $7 $8 $9 $10 $11 $12 $13 $14 $15 $16 $17 $18 $19 $20 $21 $22 $23 $24 $25 $26 $27 $28 $29 $30 $31 zero at v0 v1 a0 a1 a2 a3 a4 a5 a6 a7 t0 t1 t2 t3 t4 t5 t6 t7 t8 t9 s0 s1 s2 s3 s4 s5 s6 s7 s8 k0 k1 gp sp fp ra $f0 $f1 $f2 $f2 $f4 $f5 $f6 $f7 $f8 $f9 $f10 $f11 $f12 $f13 $f14 $f15 $f16 $f17 $f18 $f19 $f20 $f21 $f22 $f23 $f24 $f25 $f26 $f27 $f28 $f29 $f30 $f31 Context Random EntryLo0 EntryLo1 Context PageMask Wired EntryHi HWREna BadVAddr Count Compare SR IntCtl SRSCtl SRSMap Cause EPC PRId EBase Config Config1 Config2 Config3 LLAddr Debug DEPC DESAVE CacheErr ECC ErrorEPC TagLo DataLo TagHi DataHi WatchLo WatchHi PerfCtl PerfCnt `
                },
                contains: [
                    {
                        className: `keyword`,
                        begin: `\\b(addi?u?|andi?|b(al)?|beql?|bgez(al)?l?|bgtzl?|blezl?|bltz(al)?l?|bnel?|cl[oz]|divu?|ext|ins|j(al)?|jalr(\\.hb)?|jr(\\.hb)?|lbu?|lhu?|ll|lui|lw[lr]?|maddu?|mfhi|mflo|movn|movz|move|msubu?|mthi|mtlo|mul|multu?|nop|nor|ori?|rotrv?|sb|sc|se[bh]|sh|sllv?|slti?u?|srav?|srlv?|subu?|sw[lr]?|xori?|wsbh|abs\\.[sd]|add\\.[sd]|alnv.ps|bc1[ft]l?|c\\.(s?f|un|u?eq|[ou]lt|[ou]le|ngle?|seq|l[et]|ng[et])\\.[sd]|(ceil|floor|round|trunc)\\.[lw]\\.[sd]|cfc1|cvt\\.d\\.[lsw]|cvt\\.l\\.[dsw]|cvt\\.ps\\.s|cvt\\.s\\.[dlw]|cvt\\.s\\.p[lu]|cvt\\.w\\.[dls]|div\\.[ds]|ldx?c1|luxc1|lwx?c1|madd\\.[sd]|mfc1|mov[fntz]?\\.[ds]|msub\\.[sd]|mth?c1|mul\\.[ds]|neg\\.[ds]|nmadd\\.[ds]|nmsub\\.[ds]|p[lu][lu]\\.ps|recip\\.fmt|r?sqrt\\.[ds]|sdx?c1|sub\\.[ds]|suxc1|swx?c1|break|cache|d?eret|[de]i|ehb|mfc0|mtc0|pause|prefx?|rdhwr|rdpgpr|sdbbp|ssnop|synci?|syscall|teqi?|tgei?u?|tlb(p|r|w[ir])|tlti?u?|tnei?|wait|wrpgpr)`,
                        end: `\\s`
                    },
                    e.COMMENT(`[;#](?!\\s*$)`, `$`),
                    e.C_BLOCK_COMMENT_MODE,
                    e.QUOTE_STRING_MODE,
                    {
                        className: `string`,
                        begin: `'`,
                        end: `[^\\\\]'`,
                        relevance: 0
                    },
                    {
                        className: `title`,
                        begin: `\\|`,
                        end: `\\|`,
                        illegal: `\\n`,
                        relevance: 0
                    },
                    {
                        className: `number`,
                        variants: [
                            {
                                begin: `0x[0-9a-f]+`
                            },
                            {
                                begin: `\\b-?\\d+`
                            }
                        ],
                        relevance: 0
                    },
                    {
                        className: `symbol`,
                        variants: [
                            {
                                begin: `^\\s*[a-z_\\.\\$][a-z0-9_\\.\\$]+:`
                            },
                            {
                                begin: `^\\s*[0-9]+:`
                            },
                            {
                                begin: `[0-9]+[bf]`
                            }
                        ],
                        relevance: 0
                    }
                ],
                illegal: /\//
            };
        }
        t.exports = n;
    }), ht = o((e, t)=>{
        function n(e) {
            return {
                name: `Mizar`,
                keywords: `environ vocabularies notations constructors definitions registrations theorems schemes requirements begin end definition registration cluster existence pred func defpred deffunc theorem proof let take assume then thus hence ex for st holds consider reconsider such that and in provided of as from be being by means equals implies iff redefine define now not or attr is mode suppose per cases set thesis contradiction scheme reserve struct correctness compatibility coherence symmetry assymetry reflexivity irreflexivity connectedness uniqueness commutativity idempotence involutiveness projectivity`,
                contains: [
                    e.COMMENT(`::`, `$`)
                ]
            };
        }
        t.exports = n;
    }), gt = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = `abs.accept.alarm.and.atan2.bind.binmode.bless.break.caller.chdir.chmod.chomp.chop.chown.chr.chroot.class.close.closedir.connect.continue.cos.crypt.dbmclose.dbmopen.defined.delete.die.do.dump.each.else.elsif.endgrent.endhostent.endnetent.endprotoent.endpwent.endservent.eof.eval.exec.exists.exit.exp.fcntl.field.fileno.flock.for.foreach.fork.format.formline.getc.getgrent.getgrgid.getgrnam.gethostbyaddr.gethostbyname.gethostent.getlogin.getnetbyaddr.getnetbyname.getnetent.getpeername.getpgrp.getpriority.getprotobyname.getprotobynumber.getprotoent.getpwent.getpwnam.getpwuid.getservbyname.getservbyport.getservent.getsockname.getsockopt.given.glob.gmtime.goto.grep.gt.hex.if.index.int.ioctl.join.keys.kill.last.lc.lcfirst.length.link.listen.local.localtime.log.lstat.lt.ma.map.method.mkdir.msgctl.msgget.msgrcv.msgsnd.my.ne.next.no.not.oct.open.opendir.or.ord.our.pack.package.pipe.pop.pos.print.printf.prototype.push.q|0.qq.quotemeta.qw.qx.rand.read.readdir.readline.readlink.readpipe.recv.redo.ref.rename.require.reset.return.reverse.rewinddir.rindex.rmdir.say.scalar.seek.seekdir.select.semctl.semget.semop.send.setgrent.sethostent.setnetent.setpgrp.setpriority.setprotoent.setpwent.setservent.setsockopt.shift.shmctl.shmget.shmread.shmwrite.shutdown.sin.sleep.socket.socketpair.sort.splice.split.sprintf.sqrt.srand.stat.state.study.sub.substr.symlink.syscall.sysopen.sysread.sysseek.system.syswrite.tell.telldir.tie.tied.time.times.tr.truncate.uc.ucfirst.umask.undef.unless.unlink.unpack.unshift.untie.until.use.utime.values.vec.wait.waitpid.wantarray.warn.when.while.write.x|0.xor.y|0`.split(`.`), r = /[dualxmsipngr]{0,12}/, i = {
                $pattern: /[\w.]+/,
                keyword: n.join(` `)
            }, a = {
                className: `subst`,
                begin: `[$@]\\{`,
                end: `\\}`,
                keywords: i
            }, o = {
                begin: /->\{/,
                end: /\}/
            }, s = {
                scope: `attr`,
                match: /\s+:\s*\w+(\s*\(.*?\))?/
            }, c = {
                scope: `variable`,
                variants: [
                    {
                        begin: /\$\d/
                    },
                    {
                        begin: t.concat(/[$%@](?!")(\^\w\b|#\w+(::\w+)*|\{\w+\}|\w+(::\w*)*)/, `(?![A-Za-z])(?![@$%])`)
                    },
                    {
                        begin: /[$%@](?!")[^\s\w{=]|\$=/,
                        relevance: 0
                    }
                ],
                contains: [
                    s
                ]
            }, l = {
                className: `number`,
                variants: [
                    {
                        match: /0?\.[0-9][0-9_]+\b/
                    },
                    {
                        match: /\bv?(0|[1-9][0-9_]*(\.[0-9_]+)?|[1-9][0-9_]*)\b/
                    },
                    {
                        match: /\b0[0-7][0-7_]*\b/
                    },
                    {
                        match: /\b0x[0-9a-fA-F][0-9a-fA-F_]*\b/
                    },
                    {
                        match: /\b0b[0-1][0-1_]*\b/
                    }
                ],
                relevance: 0
            }, u = [
                e.BACKSLASH_ESCAPE,
                a,
                c
            ], d = [
                /!/,
                /\//,
                /\|/,
                /\?/,
                /'/,
                /"/,
                /#/
            ], f = (e, n, i = `\\1`)=>{
                let a = i === `\\1` ? i : t.concat(i, n);
                return t.concat(t.concat(`(?:`, e, `)`), n, /(?:\\.|[^\\\/])*?/, a, /(?:\\.|[^\\\/])*?/, i, r);
            }, p = (e, n, i)=>t.concat(t.concat(`(?:`, e, `)`), n, /(?:\\.|[^\\\/])*?/, i, r), m = [
                c,
                e.HASH_COMMENT_MODE,
                e.COMMENT(/^=\w/, /=cut/, {
                    endsWithParent: !0
                }),
                o,
                {
                    className: `string`,
                    contains: u,
                    variants: [
                        {
                            begin: `q[qwxr]?\\s*\\(`,
                            end: `\\)`,
                            relevance: 5
                        },
                        {
                            begin: `q[qwxr]?\\s*\\[`,
                            end: `\\]`,
                            relevance: 5
                        },
                        {
                            begin: `q[qwxr]?\\s*\\{`,
                            end: `\\}`,
                            relevance: 5
                        },
                        {
                            begin: `q[qwxr]?\\s*\\|`,
                            end: `\\|`,
                            relevance: 5
                        },
                        {
                            begin: `q[qwxr]?\\s*<`,
                            end: `>`,
                            relevance: 5
                        },
                        {
                            begin: `qw\\s+q`,
                            end: `q`,
                            relevance: 5
                        },
                        {
                            begin: `'`,
                            end: `'`,
                            contains: [
                                e.BACKSLASH_ESCAPE
                            ]
                        },
                        {
                            begin: `"`,
                            end: `"`
                        },
                        {
                            begin: "`",
                            end: "`",
                            contains: [
                                e.BACKSLASH_ESCAPE
                            ]
                        },
                        {
                            begin: /\{\w+\}/,
                            relevance: 0
                        },
                        {
                            begin: `-?\\w+\\s*=>`,
                            relevance: 0
                        }
                    ]
                },
                l,
                {
                    begin: `(\\/\\/|` + e.RE_STARTERS_RE + `|\\b(split|return|print|reverse|grep)\\b)\\s*`,
                    keywords: `split return print reverse grep`,
                    relevance: 0,
                    contains: [
                        e.HASH_COMMENT_MODE,
                        {
                            className: `regexp`,
                            variants: [
                                {
                                    begin: f(`s|tr|y`, t.either(...d, {
                                        capture: !0
                                    }))
                                },
                                {
                                    begin: f(`s|tr|y`, `\\(`, `\\)`)
                                },
                                {
                                    begin: f(`s|tr|y`, `\\[`, `\\]`)
                                },
                                {
                                    begin: f(`s|tr|y`, `\\{`, `\\}`)
                                }
                            ],
                            relevance: 2
                        },
                        {
                            className: `regexp`,
                            variants: [
                                {
                                    begin: /(m|qr)\/\//,
                                    relevance: 0
                                },
                                {
                                    begin: p(`(?:m|qr)?`, /\//, /\//)
                                },
                                {
                                    begin: p(`m|qr`, t.either(...d, {
                                        capture: !0
                                    }), /\1/)
                                },
                                {
                                    begin: p(`m|qr`, /\(/, /\)/)
                                },
                                {
                                    begin: p(`m|qr`, /\[/, /\]/)
                                },
                                {
                                    begin: p(`m|qr`, /\{/, /\}/)
                                }
                            ]
                        }
                    ]
                },
                {
                    className: `function`,
                    beginKeywords: `sub method`,
                    end: `(\\s*\\(.*?\\))?[;{]`,
                    excludeEnd: !0,
                    relevance: 5,
                    contains: [
                        e.TITLE_MODE,
                        s
                    ]
                },
                {
                    className: `class`,
                    beginKeywords: `class`,
                    end: `[;{]`,
                    excludeEnd: !0,
                    relevance: 5,
                    contains: [
                        e.TITLE_MODE,
                        s,
                        l
                    ]
                },
                {
                    begin: `-\\w\\b`,
                    relevance: 0
                },
                {
                    begin: `^__DATA__$`,
                    end: `^__END__$`,
                    subLanguage: `mojolicious`,
                    contains: [
                        {
                            begin: `^@@.*`,
                            end: `$`,
                            className: `comment`
                        }
                    ]
                }
            ];
            return a.contains = m, o.contains = m, {
                name: `Perl`,
                aliases: [
                    `pl`,
                    `pm`
                ],
                keywords: i,
                contains: m
            };
        }
        t.exports = n;
    }), _t = o((e, t)=>{
        function n(e) {
            return {
                name: `Mojolicious`,
                subLanguage: `xml`,
                contains: [
                    {
                        className: `meta`,
                        begin: `^__(END|DATA)__$`
                    },
                    {
                        begin: `^\\s*%{1,2}={0,2}`,
                        end: `$`,
                        subLanguage: `perl`
                    },
                    {
                        begin: `<%{1,2}={0,2}`,
                        end: `={0,1}%>`,
                        subLanguage: `perl`,
                        excludeBegin: !0,
                        excludeEnd: !0
                    }
                ]
            };
        }
        t.exports = n;
    }), vt = o((e, t)=>{
        function n(e) {
            let t = {
                className: `number`,
                relevance: 0,
                variants: [
                    {
                        begin: `[$][a-fA-F0-9]+`
                    },
                    e.NUMBER_MODE
                ]
            }, n = {
                variants: [
                    {
                        match: [
                            /(function|method)/,
                            /\s+/,
                            e.UNDERSCORE_IDENT_RE
                        ]
                    }
                ],
                scope: {
                    1: `keyword`,
                    3: `title.function`
                }
            }, r = {
                variants: [
                    {
                        match: [
                            /(class|interface|extends|implements)/,
                            /\s+/,
                            e.UNDERSCORE_IDENT_RE
                        ]
                    }
                ],
                scope: {
                    1: `keyword`,
                    3: `title.class`
                }
            };
            return {
                name: `Monkey`,
                case_insensitive: !0,
                keywords: {
                    keyword: `public.private.property.continue.exit.extern.new.try.catch.eachin.not.abstract.final.select.case.default.const.local.global.field.end.if.then.else.elseif.endif.while.wend.repeat.until.forever.for.to.step.next.return.module.inline.throw.import.and.or.shl.shr.mod`.split(`.`),
                    built_in: `DebugLog.DebugStop.Error.Print.ACos.ACosr.ASin.ASinr.ATan.ATan2.ATan2r.ATanr.Abs.Abs.Ceil.Clamp.Clamp.Cos.Cosr.Exp.Floor.Log.Max.Max.Min.Min.Pow.Sgn.Sgn.Sin.Sinr.Sqrt.Tan.Tanr.Seed.PI.HALFPI.TWOPI`.split(`.`),
                    literal: [
                        `true`,
                        `false`,
                        `null`
                    ]
                },
                illegal: /\/\*/,
                contains: [
                    e.COMMENT(`#rem`, `#end`),
                    e.COMMENT(`'`, `$`, {
                        relevance: 0
                    }),
                    n,
                    r,
                    {
                        className: `variable.language`,
                        begin: /\b(self|super)\b/
                    },
                    {
                        className: `meta`,
                        begin: /\s*#/,
                        end: `$`,
                        keywords: {
                            keyword: `if else elseif endif end then`
                        }
                    },
                    {
                        match: [
                            /^\s*/,
                            /strict\b/
                        ],
                        scope: {
                            2: `meta`
                        }
                    },
                    {
                        beginKeywords: `alias`,
                        end: `=`,
                        contains: [
                            e.UNDERSCORE_TITLE_MODE
                        ]
                    },
                    e.QUOTE_STRING_MODE,
                    t
                ]
            };
        }
        t.exports = n;
    }), yt = o((e, t)=>{
        function n(e) {
            let t = {
                keyword: `if then not for in while do return else elseif break continue switch and or unless when class extends super local import export from using`,
                literal: `true false nil`,
                built_in: `_G _VERSION assert collectgarbage dofile error getfenv getmetatable ipairs load loadfile loadstring module next pairs pcall print rawequal rawget rawset require select setfenv setmetatable tonumber tostring type unpack xpcall coroutine debug io math os package string table`
            }, n = `[A-Za-z$_][0-9A-Za-z$_]*`, r = {
                className: `subst`,
                begin: /#\{/,
                end: /\}/,
                keywords: t
            }, i = [
                e.inherit(e.C_NUMBER_MODE, {
                    starts: {
                        end: `(\\s*/)?`,
                        relevance: 0
                    }
                }),
                {
                    className: `string`,
                    variants: [
                        {
                            begin: /'/,
                            end: /'/,
                            contains: [
                                e.BACKSLASH_ESCAPE
                            ]
                        },
                        {
                            begin: /"/,
                            end: /"/,
                            contains: [
                                e.BACKSLASH_ESCAPE,
                                r
                            ]
                        }
                    ]
                },
                {
                    className: `built_in`,
                    begin: `@__` + e.IDENT_RE
                },
                {
                    begin: `@` + e.IDENT_RE
                },
                {
                    begin: e.IDENT_RE + `\\\\` + e.IDENT_RE
                }
            ];
            r.contains = i;
            let a = e.inherit(e.TITLE_MODE, {
                begin: n
            }), o = {
                className: `params`,
                begin: `\\([^\\(]`,
                returnBegin: !0,
                contains: [
                    {
                        begin: /\(/,
                        end: /\)/,
                        keywords: t,
                        contains: [
                            `self`
                        ].concat(i)
                    }
                ]
            };
            return {
                name: `MoonScript`,
                aliases: [
                    `moon`
                ],
                keywords: t,
                illegal: /\/\*/,
                contains: i.concat([
                    e.COMMENT(`--`, `$`),
                    {
                        className: `function`,
                        begin: `^\\s*` + n + `\\s*=\\s*(\\(.*\\)\\s*)?\\B[-=]>`,
                        end: `[-=]>`,
                        returnBegin: !0,
                        contains: [
                            a,
                            o
                        ]
                    },
                    {
                        begin: /[\(,:=]\s*/,
                        relevance: 0,
                        contains: [
                            {
                                className: `function`,
                                begin: `(\\(.*\\)\\s*)?\\B[-=]>`,
                                end: `[-=]>`,
                                returnBegin: !0,
                                contains: [
                                    o
                                ]
                            }
                        ]
                    },
                    {
                        className: `class`,
                        beginKeywords: `class`,
                        end: `$`,
                        illegal: /[:="\[\]]/,
                        contains: [
                            {
                                beginKeywords: `extends`,
                                endsWithParent: !0,
                                illegal: /[:="\[\]]/,
                                contains: [
                                    a
                                ]
                            },
                            a
                        ]
                    },
                    {
                        className: `name`,
                        begin: n + `:`,
                        end: `:`,
                        returnBegin: !0,
                        returnEnd: !0,
                        relevance: 0
                    }
                ])
            };
        }
        t.exports = n;
    }), bt = o((e, t)=>{
        function n(e) {
            return {
                name: `N1QL`,
                case_insensitive: !0,
                contains: [
                    {
                        beginKeywords: `build create index delete drop explain infer|10 insert merge prepare select update upsert|10`,
                        end: /;/,
                        keywords: {
                            keyword: `all.alter.analyze.and.any.array.as.asc.begin.between.binary.boolean.break.bucket.build.by.call.case.cast.cluster.collate.collection.commit.connect.continue.correlate.cover.create.database.dataset.datastore.declare.decrement.delete.derived.desc.describe.distinct.do.drop.each.element.else.end.every.except.exclude.execute.exists.explain.fetch.first.flatten.for.force.from.function.grant.group.gsi.having.if.ignore.ilike.in.include.increment.index.infer.inline.inner.insert.intersect.into.is.join.key.keys.keyspace.known.last.left.let.letting.like.limit.lsm.map.mapping.matched.materialized.merge.minus.namespace.nest.not.number.object.offset.on.option.or.order.outer.over.parse.partition.password.path.pool.prepare.primary.private.privilege.procedure.public.raw.realm.reduce.rename.return.returning.revoke.right.role.rollback.satisfies.schema.select.self.semi.set.show.some.start.statistics.string.system.then.to.transaction.trigger.truncate.under.union.unique.unknown.unnest.unset.update.upsert.use.user.using.validate.value.valued.values.via.view.when.where.while.with.within.work.xor`.split(`.`),
                            literal: [
                                `true`,
                                `false`,
                                `null`,
                                `missing|5`
                            ],
                            built_in: `array_agg.array_append.array_concat.array_contains.array_count.array_distinct.array_ifnull.array_length.array_max.array_min.array_position.array_prepend.array_put.array_range.array_remove.array_repeat.array_replace.array_reverse.array_sort.array_sum.avg.count.max.min.sum.greatest.least.ifmissing.ifmissingornull.ifnull.missingif.nullif.ifinf.ifnan.ifnanorinf.naninf.neginfif.posinfif.clock_millis.clock_str.date_add_millis.date_add_str.date_diff_millis.date_diff_str.date_part_millis.date_part_str.date_trunc_millis.date_trunc_str.duration_to_str.millis.str_to_millis.millis_to_str.millis_to_utc.millis_to_zone_name.now_millis.now_str.str_to_duration.str_to_utc.str_to_zone_name.decode_json.encode_json.encoded_size.poly_length.base64.base64_encode.base64_decode.meta.uuid.abs.acos.asin.atan.atan2.ceil.cos.degrees.e.exp.ln.log.floor.pi.power.radians.random.round.sign.sin.sqrt.tan.trunc.object_length.object_names.object_pairs.object_inner_pairs.object_values.object_inner_values.object_add.object_put.object_remove.object_unwrap.regexp_contains.regexp_like.regexp_position.regexp_replace.contains.initcap.length.lower.ltrim.position.repeat.replace.rtrim.split.substr.title.trim.upper.isarray.isatom.isboolean.isnumber.isobject.isstring.type.toarray.toatom.toboolean.tonumber.toobject.tostring`.split(`.`)
                        },
                        contains: [
                            {
                                className: `string`,
                                begin: `'`,
                                end: `'`,
                                contains: [
                                    e.BACKSLASH_ESCAPE
                                ]
                            },
                            {
                                className: `string`,
                                begin: `"`,
                                end: `"`,
                                contains: [
                                    e.BACKSLASH_ESCAPE
                                ]
                            },
                            {
                                className: `symbol`,
                                begin: "`",
                                end: "`",
                                contains: [
                                    e.BACKSLASH_ESCAPE
                                ]
                            },
                            e.C_NUMBER_MODE,
                            e.C_BLOCK_COMMENT_MODE
                        ]
                    },
                    e.C_BLOCK_COMMENT_MODE
                ]
            };
        }
        t.exports = n;
    }), xt = o((e, t)=>{
        function n(e) {
            return {
                name: `Nested Text`,
                aliases: [
                    `nt`
                ],
                contains: [
                    e.inherit(e.HASH_COMMENT_MODE, {
                        begin: /^\s*(?=#)/,
                        excludeBegin: !0
                    }),
                    {
                        variants: [
                            {
                                match: [
                                    /^\s*/,
                                    /-/,
                                    /[ ]/,
                                    /.*$/
                                ]
                            },
                            {
                                match: [
                                    /^\s*/,
                                    /-$/
                                ]
                            }
                        ],
                        className: {
                            2: `bullet`,
                            4: `string`
                        }
                    },
                    {
                        match: [
                            /^\s*/,
                            />/,
                            /[ ]/,
                            /.*$/
                        ],
                        className: {
                            2: `punctuation`,
                            4: `string`
                        }
                    },
                    {
                        match: [
                            /^\s*(?=\S)/,
                            /[^:]+/,
                            /:\s*/,
                            /$/
                        ],
                        className: {
                            2: `attribute`,
                            3: `punctuation`
                        }
                    },
                    {
                        match: [
                            /^\s*(?=\S)/,
                            /[^:]*[^: ]/,
                            /[ ]*:/,
                            /[ ]/,
                            /.*$/
                        ],
                        className: {
                            2: `attribute`,
                            3: `punctuation`,
                            5: `string`
                        }
                    }
                ]
            };
        }
        t.exports = n;
    }), St = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = {
                className: `variable`,
                variants: [
                    {
                        begin: /\$\d+/
                    },
                    {
                        begin: /\$\{\w+\}/
                    },
                    {
                        begin: t.concat(/[$@]/, e.UNDERSCORE_IDENT_RE)
                    }
                ]
            }, r = {
                endsWithParent: !0,
                keywords: {
                    $pattern: /[a-z_]{2,}|\/dev\/poll/,
                    literal: [
                        `on`,
                        `off`,
                        `yes`,
                        `no`,
                        `true`,
                        `false`,
                        `none`,
                        `blocked`,
                        `debug`,
                        `info`,
                        `notice`,
                        `warn`,
                        `error`,
                        `crit`,
                        `select`,
                        `break`,
                        `last`,
                        `permanent`,
                        `redirect`,
                        `kqueue`,
                        `rtsig`,
                        `epoll`,
                        `poll`,
                        `/dev/poll`
                    ]
                },
                relevance: 0,
                illegal: `=>`,
                contains: [
                    e.HASH_COMMENT_MODE,
                    {
                        className: `string`,
                        contains: [
                            e.BACKSLASH_ESCAPE,
                            n
                        ],
                        variants: [
                            {
                                begin: /"/,
                                end: /"/
                            },
                            {
                                begin: /'/,
                                end: /'/
                            }
                        ]
                    },
                    {
                        begin: `([a-z]+):/`,
                        end: `\\s`,
                        endsWithParent: !0,
                        excludeEnd: !0,
                        contains: [
                            n
                        ]
                    },
                    {
                        className: `regexp`,
                        contains: [
                            e.BACKSLASH_ESCAPE,
                            n
                        ],
                        variants: [
                            {
                                begin: `\\s\\^`,
                                end: `\\s|\\{|;`,
                                returnEnd: !0
                            },
                            {
                                begin: `~\\*?\\s+`,
                                end: `\\s|\\{|;`,
                                returnEnd: !0
                            },
                            {
                                begin: `\\*(\\.[a-z\\-]+)+`
                            },
                            {
                                begin: `([a-z\\-]+\\.)+\\*`
                            }
                        ]
                    },
                    {
                        className: `number`,
                        begin: `\\b\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}(:\\d{1,5})?\\b`
                    },
                    {
                        className: `number`,
                        begin: `\\b\\d+[kKmMgGdshdwy]?\\b`,
                        relevance: 0
                    },
                    n
                ]
            };
            return {
                name: `Nginx config`,
                aliases: [
                    `nginxconf`
                ],
                contains: [
                    e.HASH_COMMENT_MODE,
                    {
                        beginKeywords: `upstream location`,
                        end: /;|\{/,
                        contains: r.contains,
                        keywords: {
                            section: `upstream location`
                        }
                    },
                    {
                        className: `section`,
                        begin: t.concat(e.UNDERSCORE_IDENT_RE + t.lookahead(/\s+\{/)),
                        relevance: 0
                    },
                    {
                        begin: t.lookahead(e.UNDERSCORE_IDENT_RE + `\\s`),
                        end: `;|\\{`,
                        contains: [
                            {
                                className: `attribute`,
                                begin: e.UNDERSCORE_IDENT_RE,
                                starts: r
                            }
                        ],
                        relevance: 0
                    }
                ],
                illegal: `[^\\s\\}\\{]`
            };
        }
        t.exports = n;
    }), Ct = o((e, t)=>{
        function n(e) {
            return {
                name: `Nim`,
                keywords: {
                    keyword: `addr.and.as.asm.bind.block.break.case.cast.concept.const.continue.converter.defer.discard.distinct.div.do.elif.else.end.enum.except.export.finally.for.from.func.generic.guarded.if.import.in.include.interface.is.isnot.iterator.let.macro.method.mixin.mod.nil.not.notin.object.of.or.out.proc.ptr.raise.ref.return.shared.shl.shr.static.template.try.tuple.type.using.var.when.while.with.without.xor.yield`.split(`.`),
                    literal: [
                        `true`,
                        `false`
                    ],
                    type: `int.int8.int16.int32.int64.uint.uint8.uint16.uint32.uint64.float.float32.float64.bool.char.string.cstring.pointer.expr.stmt.void.auto.any.range.array.openarray.varargs.seq.set.clong.culong.cchar.cschar.cshort.cint.csize.clonglong.cfloat.cdouble.clongdouble.cuchar.cushort.cuint.culonglong.cstringarray.semistatic`.split(`.`),
                    built_in: [
                        `stdin`,
                        `stdout`,
                        `stderr`,
                        `result`
                    ]
                },
                contains: [
                    {
                        className: `meta`,
                        begin: /\{\./,
                        end: /\.\}/,
                        relevance: 10
                    },
                    {
                        className: `string`,
                        begin: /[a-zA-Z]\w*"/,
                        end: /"/,
                        contains: [
                            {
                                begin: /""/
                            }
                        ]
                    },
                    {
                        className: `string`,
                        begin: /([a-zA-Z]\w*)?"""/,
                        end: /"""/
                    },
                    e.QUOTE_STRING_MODE,
                    {
                        className: `type`,
                        begin: /\b[A-Z]\w+\b/,
                        relevance: 0
                    },
                    {
                        className: `number`,
                        relevance: 0,
                        variants: [
                            {
                                begin: /\b(0[xX][0-9a-fA-F][_0-9a-fA-F]*)('?[iIuU](8|16|32|64))?/
                            },
                            {
                                begin: /\b(0o[0-7][_0-7]*)('?[iIuUfF](8|16|32|64))?/
                            },
                            {
                                begin: /\b(0(b|B)[01][_01]*)('?[iIuUfF](8|16|32|64))?/
                            },
                            {
                                begin: /\b(\d[_\d]*)('?[iIuUfF](8|16|32|64))?/
                            }
                        ]
                    },
                    e.HASH_COMMENT_MODE
                ]
            };
        }
        t.exports = n;
    }), wt = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = {
                keyword: [
                    `assert`,
                    `else`,
                    `if`,
                    `in`,
                    `inherit`,
                    `let`,
                    `or`,
                    `rec`,
                    `then`,
                    `with`
                ],
                literal: [
                    `true`,
                    `false`,
                    `null`
                ],
                built_in: [
                    `abort`,
                    `baseNameOf`,
                    `builtins`,
                    `derivation`,
                    `derivationStrict`,
                    `dirOf`,
                    `fetchGit`,
                    `fetchMercurial`,
                    `fetchTarball`,
                    `fetchTree`,
                    `fromTOML`,
                    `import`,
                    `isNull`,
                    `map`,
                    `placeholder`,
                    `removeAttrs`,
                    `scopedImport`,
                    `throw`,
                    `toString`
                ]
            }, r = {
                scope: `built_in`,
                match: t.either(...`abort.add.addDrvOutputDependencies.addErrorContext.all.any.appendContext.attrNames.attrValues.baseNameOf.bitAnd.bitOr.bitXor.break.builtins.catAttrs.ceil.compareVersions.concatLists.concatMap.concatStringsSep.convertHash.currentSystem.currentTime.deepSeq.derivation.derivationStrict.dirOf.div.elem.elemAt.false.fetchGit.fetchMercurial.fetchTarball.fetchTree.fetchurl.filter.filterSource.findFile.flakeRefToString.floor.foldl'.fromJSON.fromTOML.functionArgs.genList.genericClosure.getAttr.getContext.getEnv.getFlake.groupBy.hasAttr.hasContext.hashFile.hashString.head.import.intersectAttrs.isAttrs.isBool.isFloat.isFunction.isInt.isList.isNull.isPath.isString.langVersion.length.lessThan.listToAttrs.map.mapAttrs.match.mul.nixPath.nixVersion.null.parseDrvName.parseFlakeRef.partition.path.pathExists.placeholder.readDir.readFile.readFileType.removeAttrs.replaceStrings.scopedImport.seq.sort.split.splitVersion.storeDir.storePath.stringLength.sub.substring.tail.throw.toFile.toJSON.toPath.toString.toXML.trace.traceVerbose.true.tryEval.typeOf.unsafeDiscardOutputDependency.unsafeDiscardStringContext.unsafeGetAttrPos.warn.zipAttrsWith`.split(`.`).map((e)=>`builtins\\.${e}`)),
                relevance: 10
            }, i = `[A-Za-z_][A-Za-z0-9_'-]*`, a = {
                scope: `symbol`,
                match: RegExp(`<${i}(/${i})*>`)
            }, o = `[A-Za-z0-9_\\+\\.-]+`, s = {
                scope: `symbol`,
                match: RegExp(`(\\.\\.|\\.|~)?/(${o})?(/${o})*(?=[\\s;])`)
            }, c = t.either(`==`, `=`, `\\+\\+`, `\\+`, `<=`, `<\\|`, `<`, `>=`, `>`, `->`, `//`, `/`, `!=`, `!`, `\\|\\|`, `\\|>`, `\\?`, `\\*`, `&&`), l = {
                scope: `operator`,
                match: t.concat(c, /(?!-)/),
                relevance: 0
            }, u = {
                scope: `number`,
                match: RegExp(`${e.NUMBER_RE}(?!-)`),
                relevance: 0
            }, d = {
                variants: [
                    {
                        scope: `operator`,
                        beforeMatch: /\s/,
                        begin: /-(?!>)/
                    },
                    {
                        begin: [
                            RegExp(`${e.NUMBER_RE}`),
                            /-/,
                            /(?!>)/
                        ],
                        beginScope: {
                            1: `number`,
                            2: `operator`
                        }
                    },
                    {
                        begin: [
                            c,
                            /-/,
                            /(?!>)/
                        ],
                        beginScope: {
                            1: `operator`,
                            2: `operator`
                        }
                    }
                ],
                relevance: 0
            }, f = {
                beforeMatch: /(^|\{|;)\s*/,
                begin: RegExp(`${i}(\\.${i})*\\s*=(?!=)`),
                returnBegin: !0,
                relevance: 0,
                contains: [
                    {
                        scope: `attr`,
                        match: RegExp(`${i}(\\.${i})*(?=\\s*=)`),
                        relevance: .2
                    }
                ]
            }, p = {
                scope: `char.escape`,
                match: /\\\$/
            }, m = {
                scope: `char.escape`,
                match: /''\$/
            }, h = {
                scope: `subst`,
                begin: /\$\{/,
                end: /\}/,
                keywords: n
            }, g = {
                scope: `char.escape`,
                match: /'''/
            }, _ = {
                scope: `char.escape`,
                match: /\\(?!\$)./
            }, v = {
                scope: `string`,
                variants: [
                    {
                        begin: `''`,
                        end: `''`,
                        contains: [
                            m,
                            h,
                            g,
                            _
                        ]
                    },
                    {
                        begin: `"`,
                        end: `"`,
                        contains: [
                            p,
                            h,
                            _
                        ]
                    }
                ]
            }, y = {
                scope: `params`,
                match: RegExp(`${i}\\s*:(?=\\s)`)
            }, b = [
                u,
                e.HASH_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                e.COMMENT(/\/\*\*(?!\/)/, /\*\//, {
                    subLanguage: `markdown`,
                    relevance: 0
                }),
                r,
                v,
                a,
                s,
                y,
                f,
                d,
                l
            ];
            return h.contains = b, {
                name: `Nix`,
                aliases: [
                    `nixos`
                ],
                keywords: n,
                contains: b.concat([
                    {
                        scope: `meta.prompt`,
                        match: /^nix-repl>(?=\s)/,
                        relevance: 10
                    },
                    {
                        scope: `meta`,
                        beforeMatch: /\s+/,
                        begin: /:([a-z]+|\?)/
                    }
                ])
            };
        }
        t.exports = n;
    }), Tt = o((e, t)=>{
        function n(e) {
            return {
                name: `Node REPL`,
                contains: [
                    {
                        className: `meta.prompt`,
                        starts: {
                            end: / |$/,
                            starts: {
                                end: `$`,
                                subLanguage: `javascript`
                            }
                        },
                        variants: [
                            {
                                begin: /^>(?=[ ]|$)/
                            },
                            {
                                begin: /^\.\.\.(?=[ ]|$)/
                            }
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), Et = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = `ADMINTOOLS.APPDATA.CDBURN_AREA.CMDLINE.COMMONFILES32.COMMONFILES64.COMMONFILES.COOKIES.DESKTOP.DOCUMENTS.EXEDIR.EXEFILE.EXEPATH.FAVORITES.FONTS.HISTORY.HWNDPARENT.INSTDIR.INTERNET_CACHE.LANGUAGE.LOCALAPPDATA.MUSIC.NETHOOD.OUTDIR.PICTURES.PLUGINSDIR.PRINTHOOD.PROFILE.PROGRAMFILES32.PROGRAMFILES64.PROGRAMFILES.QUICKLAUNCH.RECENT.RESOURCES_LOCALIZED.RESOURCES.SENDTO.SMPROGRAMS.SMSTARTUP.STARTMENU.SYSDIR.TEMP.TEMPLATES.VIDEOS.WINDIR`.split(`.`), r = `ARCHIVE.FILE_ATTRIBUTE_ARCHIVE.FILE_ATTRIBUTE_NORMAL.FILE_ATTRIBUTE_OFFLINE.FILE_ATTRIBUTE_READONLY.FILE_ATTRIBUTE_SYSTEM.FILE_ATTRIBUTE_TEMPORARY.HKCR.HKCU.HKDD.HKEY_CLASSES_ROOT.HKEY_CURRENT_CONFIG.HKEY_CURRENT_USER.HKEY_DYN_DATA.HKEY_LOCAL_MACHINE.HKEY_PERFORMANCE_DATA.HKEY_USERS.HKLM.HKPD.HKU.IDABORT.IDCANCEL.IDIGNORE.IDNO.IDOK.IDRETRY.IDYES.MB_ABORTRETRYIGNORE.MB_DEFBUTTON1.MB_DEFBUTTON2.MB_DEFBUTTON3.MB_DEFBUTTON4.MB_ICONEXCLAMATION.MB_ICONINFORMATION.MB_ICONQUESTION.MB_ICONSTOP.MB_OK.MB_OKCANCEL.MB_RETRYCANCEL.MB_RIGHT.MB_RTLREADING.MB_SETFOREGROUND.MB_TOPMOST.MB_USERICON.MB_YESNO.NORMAL.OFFLINE.READONLY.SHCTX.SHELL_CONTEXT.SYSTEM|TEMPORARY`.split(`.`), i = `addincludedir.addplugindir.appendfile.assert.cd.define.delfile.echo.else.endif.error.execute.finalize.getdllversion.gettlbversion.if.ifdef.ifmacrodef.ifmacrondef.ifndef.include.insertmacro.macro.macroend.makensis.packhdr.searchparse.searchreplace.system.tempfile.undef.uninstfinalize.verbose.warning`.split(`.`), a = {
                className: `variable.constant`,
                begin: t.concat(/\$/, t.either(...n))
            }, o = {
                className: `variable`,
                begin: /\$+\{[\!\w.:-]+\}/
            }, s = {
                className: `variable`,
                begin: /\$+\w[\w\.]*/,
                illegal: /\(\)\{\}/
            }, c = {
                className: `variable`,
                begin: /\$+\([\w^.:!-]+\)/
            }, l = {
                className: `params`,
                begin: t.either(...r)
            }, u = {
                className: `keyword`,
                begin: t.concat(/!/, t.either(...i))
            }, d = {
                className: `char.escape`,
                begin: /\$(\\[nrt]|\$)/
            }, f = {
                className: `title.function`,
                begin: /\w+::\w+/
            }, p = {
                className: `string`,
                variants: [
                    {
                        begin: `"`,
                        end: `"`
                    },
                    {
                        begin: `'`,
                        end: `'`
                    },
                    {
                        begin: "`",
                        end: "`"
                    }
                ],
                illegal: /\n/,
                contains: [
                    d,
                    a,
                    o,
                    s,
                    c
                ]
            }, m = `Abort.AddBrandingImage.AddSize.AllowRootDirInstall.AllowSkipFiles.AutoCloseWindow.BGFont.BGGradient.BrandingText.BringToFront.Call.CallInstDLL.Caption.ChangeUI.CheckBitmap.ClearErrors.CompletedText.ComponentText.CopyFiles.CRCCheck.CreateDirectory.CreateFont.CreateShortCut.Delete.DeleteINISec.DeleteINIStr.DeleteRegKey.DeleteRegValue.DetailPrint.DetailsButtonText.DirText.DirVar.DirVerify.EnableWindow.EnumRegKey.EnumRegValue.Exch.Exec.ExecShell.ExecShellWait.ExecWait.ExpandEnvStrings.File.FileBufSize.FileClose.FileErrorText.FileOpen.FileRead.FileReadByte.FileReadUTF16LE.FileReadWord.FileWriteUTF16LE.FileSeek.FileWrite.FileWriteByte.FileWriteWord.FindClose.FindFirst.FindNext.FindWindow.FlushINI.GetCurInstType.GetCurrentAddress.GetDlgItem.GetDLLVersion.GetDLLVersionLocal.GetErrorLevel.GetFileTime.GetFileTimeLocal.GetFullPathName.GetFunctionAddress.GetInstDirError.GetKnownFolderPath.GetLabelAddress.GetTempFileName.GetWinVer.Goto.HideWindow.Icon.IfAbort.IfErrors.IfFileExists.IfRebootFlag.IfRtlLanguage.IfShellVarContextAll.IfSilent.InitPluginsDir.InstallButtonText.InstallColors.InstallDir.InstallDirRegKey.InstProgressFlags.InstType.InstTypeGetText.InstTypeSetText.Int64Cmp.Int64CmpU.Int64Fmt.IntCmp.IntCmpU.IntFmt.IntOp.IntPtrCmp.IntPtrCmpU.IntPtrOp.IsWindow.LangString.LicenseBkColor.LicenseData.LicenseForceSelection.LicenseLangString.LicenseText.LoadAndSetImage.LoadLanguageFile.LockWindow.LogSet.LogText.ManifestDPIAware.ManifestLongPathAware.ManifestMaxVersionTested.ManifestSupportedOS.MessageBox.MiscButtonText.Name|0.Nop.OutFile.Page.PageCallbacks.PEAddResource.PEDllCharacteristics.PERemoveResource.PESubsysVer.Pop.Push.Quit.ReadEnvStr.ReadINIStr.ReadRegDWORD.ReadRegStr.Reboot.RegDLL.Rename.RequestExecutionLevel.ReserveFile.Return.RMDir.SearchPath.SectionGetFlags.SectionGetInstTypes.SectionGetSize.SectionGetText.SectionIn.SectionSetFlags.SectionSetInstTypes.SectionSetSize.SectionSetText.SendMessage.SetAutoClose.SetBrandingImage.SetCompress.SetCompressor.SetCompressorDictSize.SetCtlColors.SetCurInstType.SetDatablockOptimize.SetDateSave.SetDetailsPrint.SetDetailsView.SetErrorLevel.SetErrors.SetFileAttributes.SetFont.SetOutPath.SetOverwrite.SetRebootFlag.SetRegView.SetShellVarContext.SetSilent.ShowInstDetails.ShowUninstDetails.ShowWindow.SilentInstall.SilentUnInstall.Sleep.SpaceTexts.StrCmp.StrCmpS.StrCpy.StrLen.SubCaption.Unicode.UninstallButtonText.UninstallCaption.UninstallIcon.UninstallSubCaption.UninstallText.UninstPage.UnRegDLL.Var.VIAddVersionKey.VIFileVersion.VIProductVersion.WindowIcon.WriteINIStr.WriteRegBin.WriteRegDWORD.WriteRegExpandStr.WriteRegMultiStr.WriteRegNone.WriteRegStr.WriteUninstaller.XPStyle`.split(`.`), h = `admin,all,auto,both,bottom,bzip2,colored,components,current,custom,directory,false,force,hide,highest,ifdiff,ifnewer,instfiles,lastused,leave,left,license,listonly,lzma,nevershow,none,normal,notset,off,on,open,print,right,show,silent,silentlog,smooth,textonly,top,true,try,un.components,un.custom,un.directory,un.instfiles,un.license,uninstConfirm,user,Win10,Win7,Win8,WinVista,zlib`.split(`,`), g = {
                match: [
                    /Function/,
                    /\s+/,
                    t.concat(/(\.)?/, e.IDENT_RE)
                ],
                scope: {
                    1: `keyword`,
                    3: `title.function`
                }
            };
            return {
                name: `NSIS`,
                case_insensitive: !0,
                keywords: {
                    keyword: m,
                    literal: h
                },
                contains: [
                    e.HASH_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    e.COMMENT(`;`, `$`, {
                        relevance: 0
                    }),
                    {
                        match: [
                            /Var/,
                            /\s+/,
                            /(?:\/GLOBAL\s+)?/,
                            /[A-Za-z][\w.]*/
                        ],
                        scope: {
                            1: `keyword`,
                            3: `params`,
                            4: `variable`
                        }
                    },
                    g,
                    {
                        beginKeywords: `Function PageEx Section SectionGroup FunctionEnd SectionEnd`
                    },
                    p,
                    u,
                    o,
                    s,
                    c,
                    l,
                    f,
                    e.NUMBER_MODE
                ]
            };
        }
        t.exports = n;
    }), Dt = o((e, t)=>{
        function n(e) {
            let t = {
                className: `built_in`,
                begin: `\\b(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)\\w+`
            }, n = /[a-zA-Z@][a-zA-Z0-9_]*/, r = {
                "variable.language": [
                    `this`,
                    `super`
                ],
                $pattern: n,
                keyword: `while.export.sizeof.typedef.const.struct.for.union.volatile.static.mutable.if.do.return.goto.enum.else.break.extern.asm.case.default.register.explicit.typename.switch.continue.inline.readonly.assign.readwrite.self.@synchronized.id.typeof.nonatomic.IBOutlet.IBAction.strong.weak.copy.in.out.inout.bycopy.byref.oneway.__strong.__weak.__block.__autoreleasing.@private.@protected.@public.@try.@property.@end.@throw.@catch.@finally.@autoreleasepool.@synthesize.@dynamic.@selector.@optional.@required.@encode.@package.@import.@defs.@compatibility_alias.__bridge.__bridge_transfer.__bridge_retained.__bridge_retain.__covariant.__contravariant.__kindof._Nonnull._Nullable._Null_unspecified.__FUNCTION__.__PRETTY_FUNCTION__.__attribute__.getter.setter.retain.unsafe_unretained.nonnull.nullable.null_unspecified.null_resettable.class.instancetype.NS_DESIGNATED_INITIALIZER.NS_UNAVAILABLE.NS_REQUIRES_SUPER.NS_RETURNS_INNER_POINTER.NS_INLINE.NS_AVAILABLE.NS_DEPRECATED.NS_ENUM.NS_OPTIONS.NS_SWIFT_UNAVAILABLE.NS_ASSUME_NONNULL_BEGIN.NS_ASSUME_NONNULL_END.NS_REFINED_FOR_SWIFT.NS_SWIFT_NAME.NS_SWIFT_NOTHROW.NS_DURING.NS_HANDLER.NS_ENDHANDLER.NS_VALUERETURN.NS_VOIDRETURN`.split(`.`),
                literal: [
                    `false`,
                    `true`,
                    `FALSE`,
                    `TRUE`,
                    `nil`,
                    `YES`,
                    `NO`,
                    `NULL`
                ],
                built_in: [
                    `dispatch_once_t`,
                    `dispatch_queue_t`,
                    `dispatch_sync`,
                    `dispatch_async`,
                    `dispatch_once`
                ],
                type: [
                    `int`,
                    `float`,
                    `char`,
                    `unsigned`,
                    `signed`,
                    `short`,
                    `long`,
                    `double`,
                    `wchar_t`,
                    `unichar`,
                    `void`,
                    `bool`,
                    `BOOL`,
                    `id|0`,
                    `_Bool`
                ]
            }, i = {
                $pattern: n,
                keyword: [
                    `@interface`,
                    `@class`,
                    `@protocol`,
                    `@implementation`
                ]
            };
            return {
                name: `Objective-C`,
                aliases: [
                    `mm`,
                    `objc`,
                    `obj-c`,
                    `obj-c++`,
                    `objective-c++`
                ],
                keywords: r,
                illegal: `</`,
                contains: [
                    t,
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    e.C_NUMBER_MODE,
                    e.QUOTE_STRING_MODE,
                    e.APOS_STRING_MODE,
                    {
                        className: `string`,
                        variants: [
                            {
                                begin: `@"`,
                                end: `"`,
                                illegal: `\\n`,
                                contains: [
                                    e.BACKSLASH_ESCAPE
                                ]
                            }
                        ]
                    },
                    {
                        className: `meta`,
                        begin: /#\s*[a-z]+\b/,
                        end: /$/,
                        keywords: {
                            keyword: `if else elif endif define undef warning error line pragma ifdef ifndef include`
                        },
                        contains: [
                            {
                                begin: /\\\n/,
                                relevance: 0
                            },
                            e.inherit(e.QUOTE_STRING_MODE, {
                                className: `string`
                            }),
                            {
                                className: `string`,
                                begin: /<.*?>/,
                                end: /$/,
                                illegal: `\\n`
                            },
                            e.C_LINE_COMMENT_MODE,
                            e.C_BLOCK_COMMENT_MODE
                        ]
                    },
                    {
                        className: `class`,
                        begin: `(` + i.keyword.join(`|`) + `)\\b`,
                        end: /(\{|$)/,
                        excludeEnd: !0,
                        keywords: i,
                        contains: [
                            e.UNDERSCORE_TITLE_MODE
                        ]
                    },
                    {
                        begin: `\\.` + e.UNDERSCORE_IDENT_RE,
                        relevance: 0
                    }
                ]
            };
        }
        t.exports = n;
    }), Ot = o((e, t)=>{
        function n(e) {
            return {
                name: `OCaml`,
                aliases: [
                    `ml`
                ],
                keywords: {
                    $pattern: `[a-z_]\\w*!?`,
                    keyword: `and as assert asr begin class constraint do done downto else end exception external for fun function functor if in include inherit! inherit initializer land lazy let lor lsl lsr lxor match method!|10 method mod module mutable new object of open! open or private rec sig struct then to try type val! val virtual when while with parser value`,
                    built_in: `array bool bytes char exn|5 float int int32 int64 list lazy_t|5 nativeint|5 string unit in_channel out_channel ref`,
                    literal: `true false`
                },
                illegal: /\/\/|>>/,
                contains: [
                    {
                        className: `literal`,
                        begin: `\\[(\\|\\|)?\\]|\\(\\)`,
                        relevance: 0
                    },
                    e.COMMENT(`\\(\\*`, `\\*\\)`, {
                        contains: [
                            `self`
                        ]
                    }),
                    {
                        className: `symbol`,
                        begin: `'[A-Za-z_](?!')[\\w']*`
                    },
                    {
                        className: `type`,
                        begin: "`[A-Z][\\w']*"
                    },
                    {
                        className: `type`,
                        begin: `\\b[A-Z][\\w']*`,
                        relevance: 0
                    },
                    {
                        begin: `[a-z_]\\w*'[\\w']*`,
                        relevance: 0
                    },
                    e.inherit(e.APOS_STRING_MODE, {
                        className: `string`,
                        relevance: 0
                    }),
                    e.inherit(e.QUOTE_STRING_MODE, {
                        illegal: null
                    }),
                    {
                        className: `number`,
                        begin: `\\b(0[xX][a-fA-F0-9_]+[Lln]?|0[oO][0-7_]+[Lln]?|0[bB][01_]+[Lln]?|[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)`,
                        relevance: 0
                    },
                    {
                        begin: /->/
                    }
                ]
            };
        }
        t.exports = n;
    }), kt = o((e, t)=>{
        function n(e) {
            let t = {
                className: `keyword`,
                begin: `\\$(f[asn]|t|vp[rtd]|children)`
            }, n = {
                className: `literal`,
                begin: `false|true|PI|undef`
            }, r = {
                className: `number`,
                begin: `\\b\\d+(\\.\\d+)?(e-?\\d+)?`,
                relevance: 0
            }, i = e.inherit(e.QUOTE_STRING_MODE, {
                illegal: null
            }), a = {
                className: `meta`,
                keywords: {
                    keyword: `include use`
                },
                begin: `include|use <`,
                end: `>`
            }, o = {
                className: `params`,
                begin: `\\(`,
                end: `\\)`,
                contains: [
                    `self`,
                    r,
                    i,
                    t,
                    n
                ]
            }, s = {
                begin: `[*!#%]`,
                relevance: 0
            }, c = {
                className: `function`,
                beginKeywords: `module function`,
                end: /=|\{/,
                contains: [
                    o,
                    e.UNDERSCORE_TITLE_MODE
                ]
            };
            return {
                name: `OpenSCAD`,
                aliases: [
                    `scad`
                ],
                keywords: {
                    keyword: `function module include use for intersection_for if else \\%`,
                    literal: `false true PI undef`,
                    built_in: `circle square polygon text sphere cube cylinder polyhedron translate rotate scale resize mirror multmatrix color offset hull minkowski union difference intersection abs sign sin cos tan acos asin atan atan2 floor round ceil ln log pow sqrt exp rands min max concat lookup str chr search version version_num norm cross parent_module echo import import_dxf dxf_linear_extrude linear_extrude rotate_extrude surface projection render children dxf_cross dxf_dim let assign`
                },
                contains: [
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    r,
                    a,
                    i,
                    t,
                    s,
                    c
                ]
            };
        }
        t.exports = n;
    }), At = o((e, t)=>{
        function n(e) {
            let t = {
                $pattern: /\.?\w+/,
                keyword: `abstract add and array as asc aspect assembly async begin break block by case class concat const copy constructor continue create default delegate desc distinct div do downto dynamic each else empty end ensure enum equals event except exit extension external false final finalize finalizer finally flags for forward from function future global group has if implementation implements implies in index inherited inline interface into invariants is iterator join locked locking loop matching method mod module namespace nested new nil not notify nullable of old on operator or order out override parallel params partial pinned private procedure property protected public queryable raise read readonly record reintroduce remove repeat require result reverse sealed select self sequence set shl shr skip static step soft take then to true try tuple type union unit unsafe until uses using var virtual raises volatile where while with write xor yield await mapped deprecated stdcall cdecl pascal register safecall overload library platform reference packed strict published autoreleasepool selector strong weak unretained`
            }, n = e.COMMENT(/\{/, /\}/, {
                relevance: 0
            }), r = e.COMMENT(`\\(\\*`, `\\*\\)`, {
                relevance: 10
            }), i = {
                className: `string`,
                begin: `'`,
                end: `'`,
                contains: [
                    {
                        begin: `''`
                    }
                ]
            }, a = {
                className: `string`,
                begin: `(#\\d+)+`
            }, o = {
                beginKeywords: `function constructor destructor procedure method`,
                end: `[:;]`,
                keywords: `function constructor|10 destructor|10 procedure|10 method|10`,
                contains: [
                    e.inherit(e.TITLE_MODE, {
                        scope: `title.function`
                    }),
                    {
                        className: `params`,
                        begin: `\\(`,
                        end: `\\)`,
                        keywords: t,
                        contains: [
                            i,
                            a
                        ]
                    },
                    n,
                    r
                ]
            };
            return {
                name: `Oxygene`,
                case_insensitive: !0,
                keywords: t,
                illegal: `("|\\$[G-Zg-z]|\\/\\*|</|=>|->)`,
                contains: [
                    n,
                    r,
                    e.C_LINE_COMMENT_MODE,
                    i,
                    a,
                    e.NUMBER_MODE,
                    o,
                    {
                        scope: `punctuation`,
                        match: /;/,
                        relevance: 0
                    }
                ]
            };
        }
        t.exports = n;
    }), jt = o((e, t)=>{
        function n(e) {
            let t = e.COMMENT(/\{/, /\}/, {
                contains: [
                    `self`
                ]
            });
            return {
                name: `Parser3`,
                subLanguage: `xml`,
                relevance: 0,
                contains: [
                    e.COMMENT(`^#`, `$`),
                    e.COMMENT(/\^rem\{/, /\}/, {
                        relevance: 10,
                        contains: [
                            t
                        ]
                    }),
                    {
                        className: `meta`,
                        begin: `^@(?:BASE|USE|CLASS|OPTIONS)$`,
                        relevance: 10
                    },
                    {
                        className: `title`,
                        begin: `@[\\w\\-]+\\[[\\w^;\\-]*\\](?:\\[[\\w^;\\-]*\\])?(?:.*)$`
                    },
                    {
                        className: `variable`,
                        begin: /\$\{?[\w\-.:]+\}?/
                    },
                    {
                        className: `keyword`,
                        begin: /\^[\w\-.:]+/
                    },
                    {
                        className: `number`,
                        begin: `\\^#[0-9a-fA-F]+`
                    },
                    e.C_NUMBER_MODE
                ]
            };
        }
        t.exports = n;
    }), Mt = o((e, t)=>{
        function n(e) {
            return {
                name: `Packet Filter config`,
                aliases: [
                    `pf.conf`
                ],
                keywords: {
                    $pattern: /[a-z0-9_<>-]+/,
                    built_in: `block match pass load anchor|5 antispoof|10 set table`,
                    keyword: `in out log quick on rdomain inet inet6 proto from port os to route allow-opts divert-packet divert-reply divert-to flags group icmp-type icmp6-type label once probability recieved-on rtable prio queue tos tag tagged user keep fragment for os drop af-to|10 binat-to|10 nat-to|10 rdr-to|10 bitmask least-stats random round-robin source-hash static-port dup-to reply-to route-to parent bandwidth default min max qlimit block-policy debug fingerprints hostid limit loginterface optimization reassemble ruleset-optimization basic none profile skip state-defaults state-policy timeout const counters persist no modulate synproxy state|5 floating if-bound no-sync pflow|10 sloppy source-track global rule max-src-nodes max-src-states max-src-conn max-src-conn-rate overload flush scrub|5 max-mss min-ttl no-df|10 random-id`,
                    literal: `all any no-route self urpf-failed egress|5 unknown`
                },
                contains: [
                    e.HASH_COMMENT_MODE,
                    e.NUMBER_MODE,
                    e.QUOTE_STRING_MODE,
                    {
                        className: `variable`,
                        begin: /\$[\w\d#@][\w\d_]*/,
                        relevance: 0
                    },
                    {
                        className: `variable`,
                        begin: /<(?!\/)/,
                        end: />/
                    }
                ]
            };
        }
        t.exports = n;
    }), Nt = o((e, t)=>{
        function n(e) {
            let t = e.COMMENT(`--`, `$`), n = `\\$([a-zA-Z_]?|[a-zA-Z_][a-zA-Z_0-9]*)\\$`, r = `BIGINT INT8 BIGSERIAL SERIAL8 BIT VARYING VARBIT BOOLEAN BOOL BOX BYTEA CHARACTER CHAR VARCHAR CIDR CIRCLE DATE DOUBLE PRECISION FLOAT8 FLOAT INET INTEGER INT INT4 INTERVAL JSON JSONB LINE LSEG|10 MACADDR MACADDR8 MONEY NUMERIC DEC DECIMAL PATH POINT POLYGON REAL FLOAT4 SMALLINT INT2 SMALLSERIAL|10 SERIAL2|10 SERIAL|10 SERIAL4|10 TEXT TIME ZONE TIMETZ|10 TIMESTAMP TIMESTAMPTZ|10 TSQUERY|10 TSVECTOR|10 TXID_SNAPSHOT|10 UUID XML NATIONAL NCHAR INT4RANGE|10 INT8RANGE|10 NUMRANGE|10 TSRANGE|10 TSTZRANGE|10 DATERANGE|10 ANYELEMENT ANYARRAY ANYNONARRAY ANYENUM ANYRANGE CSTRING INTERNAL RECORD PG_DDL_COMMAND VOID UNKNOWN OPAQUE REFCURSOR NAME OID REGPROC|10 REGPROCEDURE|10 REGOPER|10 REGOPERATOR|10 REGCLASS|10 REGTYPE|10 REGROLE|10 REGNAMESPACE|10 REGCONFIG|10 REGDICTIONARY|10`.split(` `).map(function(e) {
                return e.split(`|`)[0];
            }).join(`|`), i = `ARRAY_AGG AVG BIT_AND BIT_OR BOOL_AND BOOL_OR COUNT EVERY JSON_AGG JSONB_AGG JSON_OBJECT_AGG JSONB_OBJECT_AGG MAX MIN MODE STRING_AGG SUM XMLAGG CORR COVAR_POP COVAR_SAMP REGR_AVGX REGR_AVGY REGR_COUNT REGR_INTERCEPT REGR_R2 REGR_SLOPE REGR_SXX REGR_SXY REGR_SYY STDDEV STDDEV_POP STDDEV_SAMP VARIANCE VAR_POP VAR_SAMP PERCENTILE_CONT PERCENTILE_DISC ROW_NUMBER RANK DENSE_RANK PERCENT_RANK CUME_DIST NTILE LAG LEAD FIRST_VALUE LAST_VALUE NTH_VALUE NUM_NONNULLS NUM_NULLS ABS CBRT CEIL CEILING DEGREES DIV EXP FLOOR LN LOG MOD PI POWER RADIANS ROUND SCALE SIGN SQRT TRUNC WIDTH_BUCKET RANDOM SETSEED ACOS ACOSD ASIN ASIND ATAN ATAND ATAN2 ATAN2D COS COSD COT COTD SIN SIND TAN TAND BIT_LENGTH CHAR_LENGTH CHARACTER_LENGTH LOWER OCTET_LENGTH OVERLAY POSITION SUBSTRING TREAT TRIM UPPER ASCII BTRIM CHR CONCAT CONCAT_WS CONVERT CONVERT_FROM CONVERT_TO DECODE ENCODE INITCAP LEFT LENGTH LPAD LTRIM MD5 PARSE_IDENT PG_CLIENT_ENCODING QUOTE_IDENT|10 QUOTE_LITERAL|10 QUOTE_NULLABLE|10 REGEXP_MATCH REGEXP_MATCHES REGEXP_REPLACE REGEXP_SPLIT_TO_ARRAY REGEXP_SPLIT_TO_TABLE REPEAT REPLACE REVERSE RIGHT RPAD RTRIM SPLIT_PART STRPOS SUBSTR TO_ASCII TO_HEX TRANSLATE OCTET_LENGTH GET_BIT GET_BYTE SET_BIT SET_BYTE TO_CHAR TO_DATE TO_NUMBER TO_TIMESTAMP AGE CLOCK_TIMESTAMP|10 DATE_PART DATE_TRUNC ISFINITE JUSTIFY_DAYS JUSTIFY_HOURS JUSTIFY_INTERVAL MAKE_DATE MAKE_INTERVAL|10 MAKE_TIME MAKE_TIMESTAMP|10 MAKE_TIMESTAMPTZ|10 NOW STATEMENT_TIMESTAMP|10 TIMEOFDAY TRANSACTION_TIMESTAMP|10 ENUM_FIRST ENUM_LAST ENUM_RANGE AREA CENTER DIAMETER HEIGHT ISCLOSED ISOPEN NPOINTS PCLOSE POPEN RADIUS WIDTH BOX BOUND_BOX CIRCLE LINE LSEG PATH POLYGON ABBREV BROADCAST HOST HOSTMASK MASKLEN NETMASK NETWORK SET_MASKLEN TEXT INET_SAME_FAMILY INET_MERGE MACADDR8_SET7BIT ARRAY_TO_TSVECTOR GET_CURRENT_TS_CONFIG NUMNODE PLAINTO_TSQUERY PHRASETO_TSQUERY WEBSEARCH_TO_TSQUERY QUERYTREE SETWEIGHT STRIP TO_TSQUERY TO_TSVECTOR JSON_TO_TSVECTOR JSONB_TO_TSVECTOR TS_DELETE TS_FILTER TS_HEADLINE TS_RANK TS_RANK_CD TS_REWRITE TSQUERY_PHRASE TSVECTOR_TO_ARRAY TSVECTOR_UPDATE_TRIGGER TSVECTOR_UPDATE_TRIGGER_COLUMN XMLCOMMENT XMLCONCAT XMLELEMENT XMLFOREST XMLPI XMLROOT XMLEXISTS XML_IS_WELL_FORMED XML_IS_WELL_FORMED_DOCUMENT XML_IS_WELL_FORMED_CONTENT XPATH XPATH_EXISTS XMLTABLE XMLNAMESPACES TABLE_TO_XML TABLE_TO_XMLSCHEMA TABLE_TO_XML_AND_XMLSCHEMA QUERY_TO_XML QUERY_TO_XMLSCHEMA QUERY_TO_XML_AND_XMLSCHEMA CURSOR_TO_XML CURSOR_TO_XMLSCHEMA SCHEMA_TO_XML SCHEMA_TO_XMLSCHEMA SCHEMA_TO_XML_AND_XMLSCHEMA DATABASE_TO_XML DATABASE_TO_XMLSCHEMA DATABASE_TO_XML_AND_XMLSCHEMA XMLATTRIBUTES TO_JSON TO_JSONB ARRAY_TO_JSON ROW_TO_JSON JSON_BUILD_ARRAY JSONB_BUILD_ARRAY JSON_BUILD_OBJECT JSONB_BUILD_OBJECT JSON_OBJECT JSONB_OBJECT JSON_ARRAY_LENGTH JSONB_ARRAY_LENGTH JSON_EACH JSONB_EACH JSON_EACH_TEXT JSONB_EACH_TEXT JSON_EXTRACT_PATH JSONB_EXTRACT_PATH JSON_OBJECT_KEYS JSONB_OBJECT_KEYS JSON_POPULATE_RECORD JSONB_POPULATE_RECORD JSON_POPULATE_RECORDSET JSONB_POPULATE_RECORDSET JSON_ARRAY_ELEMENTS JSONB_ARRAY_ELEMENTS JSON_ARRAY_ELEMENTS_TEXT JSONB_ARRAY_ELEMENTS_TEXT JSON_TYPEOF JSONB_TYPEOF JSON_TO_RECORD JSONB_TO_RECORD JSON_TO_RECORDSET JSONB_TO_RECORDSET JSON_STRIP_NULLS JSONB_STRIP_NULLS JSONB_SET JSONB_INSERT JSONB_PRETTY CURRVAL LASTVAL NEXTVAL SETVAL COALESCE NULLIF GREATEST LEAST ARRAY_APPEND ARRAY_CAT ARRAY_NDIMS ARRAY_DIMS ARRAY_FILL ARRAY_LENGTH ARRAY_LOWER ARRAY_POSITION ARRAY_POSITIONS ARRAY_PREPEND ARRAY_REMOVE ARRAY_REPLACE ARRAY_TO_STRING ARRAY_UPPER CARDINALITY STRING_TO_ARRAY UNNEST ISEMPTY LOWER_INC UPPER_INC LOWER_INF UPPER_INF RANGE_MERGE GENERATE_SERIES GENERATE_SUBSCRIPTS CURRENT_DATABASE CURRENT_QUERY CURRENT_SCHEMA|10 CURRENT_SCHEMAS|10 INET_CLIENT_ADDR INET_CLIENT_PORT INET_SERVER_ADDR INET_SERVER_PORT ROW_SECURITY_ACTIVE FORMAT_TYPE TO_REGCLASS TO_REGPROC TO_REGPROCEDURE TO_REGOPER TO_REGOPERATOR TO_REGTYPE TO_REGNAMESPACE TO_REGROLE COL_DESCRIPTION OBJ_DESCRIPTION SHOBJ_DESCRIPTION TXID_CURRENT TXID_CURRENT_IF_ASSIGNED TXID_CURRENT_SNAPSHOT TXID_SNAPSHOT_XIP TXID_SNAPSHOT_XMAX TXID_SNAPSHOT_XMIN TXID_VISIBLE_IN_SNAPSHOT TXID_STATUS CURRENT_SETTING SET_CONFIG BRIN_SUMMARIZE_NEW_VALUES BRIN_SUMMARIZE_RANGE BRIN_DESUMMARIZE_RANGE GIN_CLEAN_PENDING_LIST SUPPRESS_REDUNDANT_UPDATES_TRIGGER LO_FROM_BYTEA LO_PUT LO_GET LO_CREAT LO_CREATE LO_UNLINK LO_IMPORT LO_EXPORT LOREAD LOWRITE GROUPING CAST`.split(` `).map(function(e) {
                return e.split(`|`)[0];
            }).join(`|`);
            return {
                name: `PostgreSQL`,
                aliases: [
                    `postgres`,
                    `postgresql`
                ],
                supersetOf: `sql`,
                case_insensitive: !0,
                keywords: {
                    keyword: `ABORT ALTER ANALYZE BEGIN CALL CHECKPOINT|10 CLOSE CLUSTER COMMENT COMMIT COPY CREATE DEALLOCATE DECLARE DELETE DISCARD DO DROP END EXECUTE EXPLAIN FETCH GRANT IMPORT INSERT LISTEN LOAD LOCK MOVE NOTIFY PREPARE REASSIGN|10 REFRESH REINDEX RELEASE RESET REVOKE ROLLBACK SAVEPOINT SECURITY SELECT SET SHOW START TRUNCATE UNLISTEN|10 UPDATE VACUUM|10 VALUES AGGREGATE COLLATION CONVERSION|10 DATABASE DEFAULT PRIVILEGES DOMAIN TRIGGER EXTENSION FOREIGN WRAPPER|10 TABLE FUNCTION GROUP LANGUAGE LARGE OBJECT MATERIALIZED VIEW OPERATOR CLASS FAMILY POLICY PUBLICATION|10 ROLE RULE SCHEMA SEQUENCE SERVER STATISTICS SUBSCRIPTION SYSTEM TABLESPACE CONFIGURATION DICTIONARY PARSER TEMPLATE TYPE USER MAPPING PREPARED ACCESS METHOD CAST AS TRANSFORM TRANSACTION OWNED TO INTO SESSION AUTHORIZATION INDEX PROCEDURE ASSERTION ALL ANALYSE AND ANY ARRAY ASC ASYMMETRIC|10 BOTH CASE CHECK COLLATE COLUMN CONCURRENTLY|10 CONSTRAINT CROSS DEFERRABLE RANGE DESC DISTINCT ELSE EXCEPT FOR FREEZE|10 FROM FULL HAVING ILIKE IN INITIALLY INNER INTERSECT IS ISNULL JOIN LATERAL LEADING LIKE LIMIT NATURAL NOT NOTNULL NULL OFFSET ON ONLY OR ORDER OUTER OVERLAPS PLACING PRIMARY REFERENCES RETURNING SIMILAR SOME SYMMETRIC TABLESAMPLE THEN TRAILING UNION UNIQUE USING VARIADIC|10 VERBOSE WHEN WHERE WINDOW WITH BY RETURNS INOUT OUT SETOF|10 IF STRICT CURRENT CONTINUE OWNER LOCATION OVER PARTITION WITHIN BETWEEN ESCAPE EXTERNAL INVOKER DEFINER WORK RENAME VERSION CONNECTION CONNECT TABLES TEMP TEMPORARY FUNCTIONS SEQUENCES TYPES SCHEMAS OPTION CASCADE RESTRICT ADD ADMIN EXISTS VALID VALIDATE ENABLE DISABLE REPLICA|10 ALWAYS PASSING COLUMNS PATH REF VALUE OVERRIDING IMMUTABLE STABLE VOLATILE BEFORE AFTER EACH ROW PROCEDURAL ROUTINE NO HANDLER VALIDATOR OPTIONS STORAGE OIDS|10 WITHOUT INHERIT DEPENDS CALLED INPUT LEAKPROOF|10 COST ROWS NOWAIT SEARCH UNTIL ENCRYPTED|10 PASSWORD CONFLICT|10 INSTEAD INHERITS CHARACTERISTICS WRITE CURSOR ALSO STATEMENT SHARE EXCLUSIVE INLINE ISOLATION REPEATABLE READ COMMITTED SERIALIZABLE UNCOMMITTED LOCAL GLOBAL SQL PROCEDURES RECURSIVE SNAPSHOT ROLLUP CUBE TRUSTED|10 INCLUDE FOLLOWING PRECEDING UNBOUNDED RANGE GROUPS UNENCRYPTED|10 SYSID FORMAT DELIMITER HEADER QUOTE ENCODING FILTER OFF FORCE_QUOTE FORCE_NOT_NULL FORCE_NULL COSTS BUFFERS TIMING SUMMARY DISABLE_PAGE_SKIPPING RESTART CYCLE GENERATED IDENTITY DEFERRED IMMEDIATE LEVEL LOGGED UNLOGGED OF NOTHING NONE EXCLUDE ATTRIBUTE USAGE ROUTINES TRUE FALSE NAN INFINITY ALIAS BEGIN CONSTANT DECLARE END EXCEPTION RETURN PERFORM|10 RAISE GET DIAGNOSTICS STACKED|10 FOREACH LOOP ELSIF EXIT WHILE REVERSE SLICE DEBUG LOG INFO NOTICE WARNING ASSERT OPEN SUPERUSER NOSUPERUSER CREATEDB NOCREATEDB CREATEROLE NOCREATEROLE INHERIT NOINHERIT LOGIN NOLOGIN REPLICATION NOREPLICATION BYPASSRLS NOBYPASSRLS `,
                    built_in: `CURRENT_TIME CURRENT_TIMESTAMP CURRENT_USER CURRENT_CATALOG|10 CURRENT_DATE LOCALTIME LOCALTIMESTAMP CURRENT_ROLE|10 CURRENT_SCHEMA|10 SESSION_USER PUBLIC FOUND NEW OLD TG_NAME|10 TG_WHEN|10 TG_LEVEL|10 TG_OP|10 TG_RELID|10 TG_RELNAME|10 TG_TABLE_NAME|10 TG_TABLE_SCHEMA|10 TG_NARGS|10 TG_ARGV|10 TG_EVENT|10 TG_TAG|10 ROW_COUNT RESULT_OID|10 PG_CONTEXT|10 RETURNED_SQLSTATE COLUMN_NAME CONSTRAINT_NAME PG_DATATYPE_NAME|10 MESSAGE_TEXT TABLE_NAME SCHEMA_NAME PG_EXCEPTION_DETAIL|10 PG_EXCEPTION_HINT|10 PG_EXCEPTION_CONTEXT|10 SQLSTATE SQLERRM|10 SUCCESSFUL_COMPLETION WARNING DYNAMIC_RESULT_SETS_RETURNED IMPLICIT_ZERO_BIT_PADDING NULL_VALUE_ELIMINATED_IN_SET_FUNCTION PRIVILEGE_NOT_GRANTED PRIVILEGE_NOT_REVOKED STRING_DATA_RIGHT_TRUNCATION DEPRECATED_FEATURE NO_DATA NO_ADDITIONAL_DYNAMIC_RESULT_SETS_RETURNED SQL_STATEMENT_NOT_YET_COMPLETE CONNECTION_EXCEPTION CONNECTION_DOES_NOT_EXIST CONNECTION_FAILURE SQLCLIENT_UNABLE_TO_ESTABLISH_SQLCONNECTION SQLSERVER_REJECTED_ESTABLISHMENT_OF_SQLCONNECTION TRANSACTION_RESOLUTION_UNKNOWN PROTOCOL_VIOLATION TRIGGERED_ACTION_EXCEPTION FEATURE_NOT_SUPPORTED INVALID_TRANSACTION_INITIATION LOCATOR_EXCEPTION INVALID_LOCATOR_SPECIFICATION INVALID_GRANTOR INVALID_GRANT_OPERATION INVALID_ROLE_SPECIFICATION DIAGNOSTICS_EXCEPTION STACKED_DIAGNOSTICS_ACCESSED_WITHOUT_ACTIVE_HANDLER CASE_NOT_FOUND CARDINALITY_VIOLATION DATA_EXCEPTION ARRAY_SUBSCRIPT_ERROR CHARACTER_NOT_IN_REPERTOIRE DATETIME_FIELD_OVERFLOW DIVISION_BY_ZERO ERROR_IN_ASSIGNMENT ESCAPE_CHARACTER_CONFLICT INDICATOR_OVERFLOW INTERVAL_FIELD_OVERFLOW INVALID_ARGUMENT_FOR_LOGARITHM INVALID_ARGUMENT_FOR_NTILE_FUNCTION INVALID_ARGUMENT_FOR_NTH_VALUE_FUNCTION INVALID_ARGUMENT_FOR_POWER_FUNCTION INVALID_ARGUMENT_FOR_WIDTH_BUCKET_FUNCTION INVALID_CHARACTER_VALUE_FOR_CAST INVALID_DATETIME_FORMAT INVALID_ESCAPE_CHARACTER INVALID_ESCAPE_OCTET INVALID_ESCAPE_SEQUENCE NONSTANDARD_USE_OF_ESCAPE_CHARACTER INVALID_INDICATOR_PARAMETER_VALUE INVALID_PARAMETER_VALUE INVALID_REGULAR_EXPRESSION INVALID_ROW_COUNT_IN_LIMIT_CLAUSE INVALID_ROW_COUNT_IN_RESULT_OFFSET_CLAUSE INVALID_TABLESAMPLE_ARGUMENT INVALID_TABLESAMPLE_REPEAT INVALID_TIME_ZONE_DISPLACEMENT_VALUE INVALID_USE_OF_ESCAPE_CHARACTER MOST_SPECIFIC_TYPE_MISMATCH NULL_VALUE_NOT_ALLOWED NULL_VALUE_NO_INDICATOR_PARAMETER NUMERIC_VALUE_OUT_OF_RANGE SEQUENCE_GENERATOR_LIMIT_EXCEEDED STRING_DATA_LENGTH_MISMATCH STRING_DATA_RIGHT_TRUNCATION SUBSTRING_ERROR TRIM_ERROR UNTERMINATED_C_STRING ZERO_LENGTH_CHARACTER_STRING FLOATING_POINT_EXCEPTION INVALID_TEXT_REPRESENTATION INVALID_BINARY_REPRESENTATION BAD_COPY_FILE_FORMAT UNTRANSLATABLE_CHARACTER NOT_AN_XML_DOCUMENT INVALID_XML_DOCUMENT INVALID_XML_CONTENT INVALID_XML_COMMENT INVALID_XML_PROCESSING_INSTRUCTION INTEGRITY_CONSTRAINT_VIOLATION RESTRICT_VIOLATION NOT_NULL_VIOLATION FOREIGN_KEY_VIOLATION UNIQUE_VIOLATION CHECK_VIOLATION EXCLUSION_VIOLATION INVALID_CURSOR_STATE INVALID_TRANSACTION_STATE ACTIVE_SQL_TRANSACTION BRANCH_TRANSACTION_ALREADY_ACTIVE HELD_CURSOR_REQUIRES_SAME_ISOLATION_LEVEL INAPPROPRIATE_ACCESS_MODE_FOR_BRANCH_TRANSACTION INAPPROPRIATE_ISOLATION_LEVEL_FOR_BRANCH_TRANSACTION NO_ACTIVE_SQL_TRANSACTION_FOR_BRANCH_TRANSACTION READ_ONLY_SQL_TRANSACTION SCHEMA_AND_DATA_STATEMENT_MIXING_NOT_SUPPORTED NO_ACTIVE_SQL_TRANSACTION IN_FAILED_SQL_TRANSACTION IDLE_IN_TRANSACTION_SESSION_TIMEOUT INVALID_SQL_STATEMENT_NAME TRIGGERED_DATA_CHANGE_VIOLATION INVALID_AUTHORIZATION_SPECIFICATION INVALID_PASSWORD DEPENDENT_PRIVILEGE_DESCRIPTORS_STILL_EXIST DEPENDENT_OBJECTS_STILL_EXIST INVALID_TRANSACTION_TERMINATION SQL_ROUTINE_EXCEPTION FUNCTION_EXECUTED_NO_RETURN_STATEMENT MODIFYING_SQL_DATA_NOT_PERMITTED PROHIBITED_SQL_STATEMENT_ATTEMPTED READING_SQL_DATA_NOT_PERMITTED INVALID_CURSOR_NAME EXTERNAL_ROUTINE_EXCEPTION CONTAINING_SQL_NOT_PERMITTED MODIFYING_SQL_DATA_NOT_PERMITTED PROHIBITED_SQL_STATEMENT_ATTEMPTED READING_SQL_DATA_NOT_PERMITTED EXTERNAL_ROUTINE_INVOCATION_EXCEPTION INVALID_SQLSTATE_RETURNED NULL_VALUE_NOT_ALLOWED TRIGGER_PROTOCOL_VIOLATED SRF_PROTOCOL_VIOLATED EVENT_TRIGGER_PROTOCOL_VIOLATED SAVEPOINT_EXCEPTION INVALID_SAVEPOINT_SPECIFICATION INVALID_CATALOG_NAME INVALID_SCHEMA_NAME TRANSACTION_ROLLBACK TRANSACTION_INTEGRITY_CONSTRAINT_VIOLATION SERIALIZATION_FAILURE STATEMENT_COMPLETION_UNKNOWN DEADLOCK_DETECTED SYNTAX_ERROR_OR_ACCESS_RULE_VIOLATION SYNTAX_ERROR INSUFFICIENT_PRIVILEGE CANNOT_COERCE GROUPING_ERROR WINDOWING_ERROR INVALID_RECURSION INVALID_FOREIGN_KEY INVALID_NAME NAME_TOO_LONG RESERVED_NAME DATATYPE_MISMATCH INDETERMINATE_DATATYPE COLLATION_MISMATCH INDETERMINATE_COLLATION WRONG_OBJECT_TYPE GENERATED_ALWAYS UNDEFINED_COLUMN UNDEFINED_FUNCTION UNDEFINED_TABLE UNDEFINED_PARAMETER UNDEFINED_OBJECT DUPLICATE_COLUMN DUPLICATE_CURSOR DUPLICATE_DATABASE DUPLICATE_FUNCTION DUPLICATE_PREPARED_STATEMENT DUPLICATE_SCHEMA DUPLICATE_TABLE DUPLICATE_ALIAS DUPLICATE_OBJECT AMBIGUOUS_COLUMN AMBIGUOUS_FUNCTION AMBIGUOUS_PARAMETER AMBIGUOUS_ALIAS INVALID_COLUMN_REFERENCE INVALID_COLUMN_DEFINITION INVALID_CURSOR_DEFINITION INVALID_DATABASE_DEFINITION INVALID_FUNCTION_DEFINITION INVALID_PREPARED_STATEMENT_DEFINITION INVALID_SCHEMA_DEFINITION INVALID_TABLE_DEFINITION INVALID_OBJECT_DEFINITION WITH_CHECK_OPTION_VIOLATION INSUFFICIENT_RESOURCES DISK_FULL OUT_OF_MEMORY TOO_MANY_CONNECTIONS CONFIGURATION_LIMIT_EXCEEDED PROGRAM_LIMIT_EXCEEDED STATEMENT_TOO_COMPLEX TOO_MANY_COLUMNS TOO_MANY_ARGUMENTS OBJECT_NOT_IN_PREREQUISITE_STATE OBJECT_IN_USE CANT_CHANGE_RUNTIME_PARAM LOCK_NOT_AVAILABLE OPERATOR_INTERVENTION QUERY_CANCELED ADMIN_SHUTDOWN CRASH_SHUTDOWN CANNOT_CONNECT_NOW DATABASE_DROPPED SYSTEM_ERROR IO_ERROR UNDEFINED_FILE DUPLICATE_FILE SNAPSHOT_TOO_OLD CONFIG_FILE_ERROR LOCK_FILE_EXISTS FDW_ERROR FDW_COLUMN_NAME_NOT_FOUND FDW_DYNAMIC_PARAMETER_VALUE_NEEDED FDW_FUNCTION_SEQUENCE_ERROR FDW_INCONSISTENT_DESCRIPTOR_INFORMATION FDW_INVALID_ATTRIBUTE_VALUE FDW_INVALID_COLUMN_NAME FDW_INVALID_COLUMN_NUMBER FDW_INVALID_DATA_TYPE FDW_INVALID_DATA_TYPE_DESCRIPTORS FDW_INVALID_DESCRIPTOR_FIELD_IDENTIFIER FDW_INVALID_HANDLE FDW_INVALID_OPTION_INDEX FDW_INVALID_OPTION_NAME FDW_INVALID_STRING_LENGTH_OR_BUFFER_LENGTH FDW_INVALID_STRING_FORMAT FDW_INVALID_USE_OF_NULL_POINTER FDW_TOO_MANY_HANDLES FDW_OUT_OF_MEMORY FDW_NO_SCHEMAS FDW_OPTION_NAME_NOT_FOUND FDW_REPLY_HANDLE FDW_SCHEMA_NOT_FOUND FDW_TABLE_NOT_FOUND FDW_UNABLE_TO_CREATE_EXECUTION FDW_UNABLE_TO_CREATE_REPLY FDW_UNABLE_TO_ESTABLISH_CONNECTION PLPGSQL_ERROR RAISE_EXCEPTION NO_DATA_FOUND TOO_MANY_ROWS ASSERT_FAILURE INTERNAL_ERROR DATA_CORRUPTED INDEX_CORRUPTED `
                },
                illegal: /:==|\W\s*\(\*|(^|\s)\$[a-z]|\{\{|[a-z]:\s*$|\.\.\.|TO:|DO:/,
                contains: [
                    {
                        className: `keyword`,
                        variants: [
                            {
                                begin: /\bTEXT\s*SEARCH\b/
                            },
                            {
                                begin: /\b(PRIMARY|FOREIGN|FOR(\s+NO)?)\s+KEY\b/
                            },
                            {
                                begin: /\bPARALLEL\s+(UNSAFE|RESTRICTED|SAFE)\b/
                            },
                            {
                                begin: /\bSTORAGE\s+(PLAIN|EXTERNAL|EXTENDED|MAIN)\b/
                            },
                            {
                                begin: /\bMATCH\s+(FULL|PARTIAL|SIMPLE)\b/
                            },
                            {
                                begin: /\bNULLS\s+(FIRST|LAST)\b/
                            },
                            {
                                begin: /\bEVENT\s+TRIGGER\b/
                            },
                            {
                                begin: /\b(MAPPING|OR)\s+REPLACE\b/
                            },
                            {
                                begin: /\b(FROM|TO)\s+(PROGRAM|STDIN|STDOUT)\b/
                            },
                            {
                                begin: /\b(SHARE|EXCLUSIVE)\s+MODE\b/
                            },
                            {
                                begin: /\b(LEFT|RIGHT)\s+(OUTER\s+)?JOIN\b/
                            },
                            {
                                begin: /\b(FETCH|MOVE)\s+(NEXT|PRIOR|FIRST|LAST|ABSOLUTE|RELATIVE|FORWARD|BACKWARD)\b/
                            },
                            {
                                begin: /\bPRESERVE\s+ROWS\b/
                            },
                            {
                                begin: /\bDISCARD\s+PLANS\b/
                            },
                            {
                                begin: /\bREFERENCING\s+(OLD|NEW)\b/
                            },
                            {
                                begin: /\bSKIP\s+LOCKED\b/
                            },
                            {
                                begin: /\bGROUPING\s+SETS\b/
                            },
                            {
                                begin: /\b(BINARY|INSENSITIVE|SCROLL|NO\s+SCROLL)\s+(CURSOR|FOR)\b/
                            },
                            {
                                begin: /\b(WITH|WITHOUT)\s+HOLD\b/
                            },
                            {
                                begin: /\bWITH\s+(CASCADED|LOCAL)\s+CHECK\s+OPTION\b/
                            },
                            {
                                begin: /\bEXCLUDE\s+(TIES|NO\s+OTHERS)\b/
                            },
                            {
                                begin: /\bFORMAT\s+(TEXT|XML|JSON|YAML)\b/
                            },
                            {
                                begin: /\bSET\s+((SESSION|LOCAL)\s+)?NAMES\b/
                            },
                            {
                                begin: /\bIS\s+(NOT\s+)?UNKNOWN\b/
                            },
                            {
                                begin: /\bSECURITY\s+LABEL\b/
                            },
                            {
                                begin: /\bSTANDALONE\s+(YES|NO|NO\s+VALUE)\b/
                            },
                            {
                                begin: /\bWITH\s+(NO\s+)?DATA\b/
                            },
                            {
                                begin: /\b(FOREIGN|SET)\s+DATA\b/
                            },
                            {
                                begin: /\bSET\s+(CATALOG|CONSTRAINTS)\b/
                            },
                            {
                                begin: /\b(WITH|FOR)\s+ORDINALITY\b/
                            },
                            {
                                begin: /\bIS\s+(NOT\s+)?DOCUMENT\b/
                            },
                            {
                                begin: /\bXML\s+OPTION\s+(DOCUMENT|CONTENT)\b/
                            },
                            {
                                begin: /\b(STRIP|PRESERVE)\s+WHITESPACE\b/
                            },
                            {
                                begin: /\bNO\s+(ACTION|MAXVALUE|MINVALUE)\b/
                            },
                            {
                                begin: /\bPARTITION\s+BY\s+(RANGE|LIST|HASH)\b/
                            },
                            {
                                begin: /\bAT\s+TIME\s+ZONE\b/
                            },
                            {
                                begin: /\bGRANTED\s+BY\b/
                            },
                            {
                                begin: /\bRETURN\s+(QUERY|NEXT)\b/
                            },
                            {
                                begin: /\b(ATTACH|DETACH)\s+PARTITION\b/
                            },
                            {
                                begin: /\bFORCE\s+ROW\s+LEVEL\s+SECURITY\b/
                            },
                            {
                                begin: /\b(INCLUDING|EXCLUDING)\s+(COMMENTS|CONSTRAINTS|DEFAULTS|IDENTITY|INDEXES|STATISTICS|STORAGE|ALL)\b/
                            },
                            {
                                begin: /\bAS\s+(ASSIGNMENT|IMPLICIT|PERMISSIVE|RESTRICTIVE|ENUM|RANGE)\b/
                            }
                        ]
                    },
                    {
                        begin: /\b(FORMAT|FAMILY|VERSION)\s*\(/
                    },
                    {
                        begin: /\bINCLUDE\s*\(/,
                        keywords: `INCLUDE`
                    },
                    {
                        begin: /\bRANGE(?!\s*(BETWEEN|UNBOUNDED|CURRENT|[-0-9]+))/
                    },
                    {
                        begin: /\b(VERSION|OWNER|TEMPLATE|TABLESPACE|CONNECTION\s+LIMIT|PROCEDURE|RESTRICT|JOIN|PARSER|COPY|START|END|COLLATION|INPUT|ANALYZE|STORAGE|LIKE|DEFAULT|DELIMITER|ENCODING|COLUMN|CONSTRAINT|TABLE|SCHEMA)\s*=/
                    },
                    {
                        begin: /\b(PG_\w+?|HAS_[A-Z_]+_PRIVILEGE)\b/,
                        relevance: 10
                    },
                    {
                        begin: /\bEXTRACT\s*\(/,
                        end: /\bFROM\b/,
                        returnEnd: !0,
                        keywords: {
                            type: `CENTURY DAY DECADE DOW DOY EPOCH HOUR ISODOW ISOYEAR MICROSECONDS MILLENNIUM MILLISECONDS MINUTE MONTH QUARTER SECOND TIMEZONE TIMEZONE_HOUR TIMEZONE_MINUTE WEEK YEAR`
                        }
                    },
                    {
                        begin: /\b(XMLELEMENT|XMLPI)\s*\(\s*NAME/,
                        keywords: {
                            keyword: `NAME`
                        }
                    },
                    {
                        begin: /\b(XMLPARSE|XMLSERIALIZE)\s*\(\s*(DOCUMENT|CONTENT)/,
                        keywords: {
                            keyword: `DOCUMENT CONTENT`
                        }
                    },
                    {
                        beginKeywords: `CACHE INCREMENT MAXVALUE MINVALUE`,
                        end: e.C_NUMBER_RE,
                        returnEnd: !0,
                        keywords: `BY CACHE INCREMENT MAXVALUE MINVALUE`
                    },
                    {
                        className: `type`,
                        begin: /\b(WITH|WITHOUT)\s+TIME\s+ZONE\b/
                    },
                    {
                        className: `type`,
                        begin: /\bINTERVAL\s+(YEAR|MONTH|DAY|HOUR|MINUTE|SECOND)(\s+TO\s+(MONTH|HOUR|MINUTE|SECOND))?\b/
                    },
                    {
                        begin: /\bRETURNS\s+(LANGUAGE_HANDLER|TRIGGER|EVENT_TRIGGER|FDW_HANDLER|INDEX_AM_HANDLER|TSM_HANDLER)\b/,
                        keywords: {
                            keyword: `RETURNS`,
                            type: `LANGUAGE_HANDLER TRIGGER EVENT_TRIGGER FDW_HANDLER INDEX_AM_HANDLER TSM_HANDLER`
                        }
                    },
                    {
                        begin: `\\b(` + i + `)\\s*\\(`
                    },
                    {
                        begin: `\\.(` + r + `)\\b`
                    },
                    {
                        begin: `\\b(` + r + `)\\s+PATH\\b`,
                        keywords: {
                            keyword: `PATH`,
                            type: `BIGINT INT8 BIGSERIAL SERIAL8 BIT VARYING VARBIT BOOLEAN BOOL BOX BYTEA CHARACTER CHAR VARCHAR CIDR CIRCLE DATE DOUBLE PRECISION FLOAT8 FLOAT INET INTEGER INT INT4 INTERVAL JSON JSONB LINE LSEG|10 MACADDR MACADDR8 MONEY NUMERIC DEC DECIMAL POINT POLYGON REAL FLOAT4 SMALLINT INT2 SMALLSERIAL|10 SERIAL2|10 SERIAL|10 SERIAL4|10 TEXT TIME ZONE TIMETZ|10 TIMESTAMP TIMESTAMPTZ|10 TSQUERY|10 TSVECTOR|10 TXID_SNAPSHOT|10 UUID XML NATIONAL NCHAR INT4RANGE|10 INT8RANGE|10 NUMRANGE|10 TSRANGE|10 TSTZRANGE|10 DATERANGE|10 ANYELEMENT ANYARRAY ANYNONARRAY ANYENUM ANYRANGE CSTRING INTERNAL RECORD PG_DDL_COMMAND VOID UNKNOWN OPAQUE REFCURSOR NAME OID REGPROC|10 REGPROCEDURE|10 REGOPER|10 REGOPERATOR|10 REGCLASS|10 REGTYPE|10 REGROLE|10 REGNAMESPACE|10 REGCONFIG|10 REGDICTIONARY|10 `
                        }
                    },
                    {
                        className: `type`,
                        begin: `\\b(` + r + `)\\b`
                    },
                    {
                        className: `string`,
                        begin: `'`,
                        end: `'`,
                        contains: [
                            {
                                begin: `''`
                            }
                        ]
                    },
                    {
                        className: `string`,
                        begin: `(e|E|u&|U&)'`,
                        end: `'`,
                        contains: [
                            {
                                begin: `\\\\.`
                            }
                        ],
                        relevance: 10
                    },
                    e.END_SAME_AS_BEGIN({
                        begin: n,
                        end: n,
                        contains: [
                            {
                                subLanguage: [
                                    `pgsql`,
                                    `perl`,
                                    `python`,
                                    `tcl`,
                                    `r`,
                                    `lua`,
                                    `java`,
                                    `php`,
                                    `ruby`,
                                    `bash`,
                                    `scheme`,
                                    `xml`,
                                    `json`
                                ],
                                endsWithParent: !0
                            }
                        ]
                    }),
                    {
                        begin: `"`,
                        end: `"`,
                        contains: [
                            {
                                begin: `""`
                            }
                        ]
                    },
                    e.C_NUMBER_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    t,
                    {
                        className: `meta`,
                        variants: [
                            {
                                begin: `%(ROW)?TYPE`,
                                relevance: 10
                            },
                            {
                                begin: `\\$\\d+`
                            },
                            {
                                begin: `^#\\w`,
                                end: `$`
                            }
                        ]
                    },
                    {
                        className: `symbol`,
                        begin: `<<\\s*[a-zA-Z_][a-zA-Z_0-9$]*\\s*>>`,
                        relevance: 10
                    }
                ]
            };
        }
        t.exports = n;
    }), Pt = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = /(?![A-Za-z0-9])(?![$])/, r = t.concat(/[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/, n), i = t.concat(/(\\?[A-Z][a-z0-9_\x7f-\xff]+|\\?[A-Z]+(?=[A-Z][a-z0-9_\x7f-\xff])){1,}/, n), a = t.concat(/[A-Z]+/, n), o = {
                scope: `variable`,
                match: `\\$+` + r
            }, s = {
                scope: `meta`,
                variants: [
                    {
                        begin: /<\?php/,
                        relevance: 10
                    },
                    {
                        begin: /<\?=/
                    },
                    {
                        begin: /<\?/,
                        relevance: .1
                    },
                    {
                        begin: /\?>/
                    }
                ]
            }, c = {
                scope: `subst`,
                variants: [
                    {
                        begin: /\$\w+/
                    },
                    {
                        begin: /\{\$/,
                        end: /\}/
                    }
                ]
            }, l = e.inherit(e.APOS_STRING_MODE, {
                illegal: null
            }), u = e.inherit(e.QUOTE_STRING_MODE, {
                illegal: null,
                contains: e.QUOTE_STRING_MODE.contains.concat(c)
            }), d = {
                begin: /<<<[ \t]*(?:(\w+)|"(\w+)")\n/,
                end: /[ \t]*(\w+)\b/,
                contains: e.QUOTE_STRING_MODE.contains.concat(c),
                "on:begin": (e, t)=>{
                    t.data._beginMatch = e[1] || e[2];
                },
                "on:end": (e, t)=>{
                    t.data._beginMatch !== e[1] && t.ignoreMatch();
                }
            }, f = e.END_SAME_AS_BEGIN({
                begin: /<<<[ \t]*'(\w+)'\n/,
                end: /[ \t]*(\w+)\b/
            }), p = `[ 	
]`, m = {
                scope: `string`,
                variants: [
                    u,
                    l,
                    d,
                    f
                ]
            }, h = {
                scope: `number`,
                variants: [
                    {
                        begin: `\\b0[bB][01]+(?:_[01]+)*\\b`
                    },
                    {
                        begin: `\\b0[oO][0-7]+(?:_[0-7]+)*\\b`
                    },
                    {
                        begin: `\\b0[xX][\\da-fA-F]+(?:_[\\da-fA-F]+)*\\b`
                    },
                    {
                        begin: `(?:\\b\\d+(?:_\\d+)*(\\.(?:\\d+(?:_\\d+)*))?|\\B\\.\\d+)(?:[eE][+-]?\\d+)?`
                    }
                ],
                relevance: 0
            }, g = [
                `false`,
                `null`,
                `true`
            ], _ = `__CLASS__.__DIR__.__FILE__.__FUNCTION__.__COMPILER_HALT_OFFSET__.__LINE__.__METHOD__.__NAMESPACE__.__TRAIT__.die.echo.exit.include.include_once.print.require.require_once.array.abstract.and.as.binary.bool.boolean.break.callable.case.catch.class.clone.const.continue.declare.default.do.double.else.elseif.empty.enddeclare.endfor.endforeach.endif.endswitch.endwhile.enum.eval.extends.final.finally.float.for.foreach.from.global.goto.if.implements.instanceof.insteadof.int.integer.interface.isset.iterable.list.match|0.mixed.new.never.object.or.private.protected.public.readonly.real.return.string.switch.throw.trait.try.unset.use.var.void.while.xor.yield`.split(`.`), v = `Error|0.AppendIterator.ArgumentCountError.ArithmeticError.ArrayIterator.ArrayObject.AssertionError.BadFunctionCallException.BadMethodCallException.CachingIterator.CallbackFilterIterator.CompileError.Countable.DirectoryIterator.DivisionByZeroError.DomainException.EmptyIterator.ErrorException.Exception.FilesystemIterator.FilterIterator.GlobIterator.InfiniteIterator.InvalidArgumentException.IteratorIterator.LengthException.LimitIterator.LogicException.MultipleIterator.NoRewindIterator.OutOfBoundsException.OutOfRangeException.OuterIterator.OverflowException.ParentIterator.ParseError.RangeException.RecursiveArrayIterator.RecursiveCachingIterator.RecursiveCallbackFilterIterator.RecursiveDirectoryIterator.RecursiveFilterIterator.RecursiveIterator.RecursiveIteratorIterator.RecursiveRegexIterator.RecursiveTreeIterator.RegexIterator.RuntimeException.SeekableIterator.SplDoublyLinkedList.SplFileInfo.SplFileObject.SplFixedArray.SplHeap.SplMaxHeap.SplMinHeap.SplObjectStorage.SplObserver.SplPriorityQueue.SplQueue.SplStack.SplSubject.SplTempFileObject.TypeError.UnderflowException.UnexpectedValueException.UnhandledMatchError.ArrayAccess.BackedEnum.Closure.Fiber.Generator.Iterator.IteratorAggregate.Serializable.Stringable.Throwable.Traversable.UnitEnum.WeakReference.WeakMap.Directory.__PHP_Incomplete_Class.parent.php_user_filter.self.static.stdClass`.split(`.`), y = {
                keyword: _,
                literal: ((e)=>{
                    let t = [];
                    return e.forEach((e)=>{
                        t.push(e), e.toLowerCase() === e ? t.push(e.toUpperCase()) : t.push(e.toLowerCase());
                    }), t;
                })(g),
                built_in: v
            }, b = (e)=>e.map((e)=>e.replace(/\|\d+$/, ``)), x = {
                variants: [
                    {
                        match: [
                            /new/,
                            t.concat(p, `+`),
                            t.concat(`(?!`, b(v).join(`\\b|`), `\\b)`),
                            i
                        ],
                        scope: {
                            1: `keyword`,
                            4: `title.class`
                        }
                    }
                ]
            }, S = t.concat(r, `\\b(?!\\()`), C = {
                variants: [
                    {
                        match: [
                            t.concat(/::/, t.lookahead(/(?!class\b)/)),
                            S
                        ],
                        scope: {
                            2: `variable.constant`
                        }
                    },
                    {
                        match: [
                            /::/,
                            /class/
                        ],
                        scope: {
                            2: `variable.language`
                        }
                    },
                    {
                        match: [
                            i,
                            t.concat(/::/, t.lookahead(/(?!class\b)/)),
                            S
                        ],
                        scope: {
                            1: `title.class`,
                            3: `variable.constant`
                        }
                    },
                    {
                        match: [
                            i,
                            t.concat(`::`, t.lookahead(/(?!class\b)/))
                        ],
                        scope: {
                            1: `title.class`
                        }
                    },
                    {
                        match: [
                            i,
                            /::/,
                            /class/
                        ],
                        scope: {
                            1: `title.class`,
                            3: `variable.language`
                        }
                    }
                ]
            }, w = {
                scope: `attr`,
                match: t.concat(r, t.lookahead(`:`), t.lookahead(/(?!::)/))
            }, T = {
                relevance: 0,
                begin: /\(/,
                end: /\)/,
                keywords: y,
                contains: [
                    w,
                    o,
                    C,
                    e.C_BLOCK_COMMENT_MODE,
                    m,
                    h,
                    x
                ]
            }, E = {
                relevance: 0,
                match: [
                    /\b/,
                    t.concat(`(?!fn\\b|function\\b|`, b(_).join(`\\b|`), `|`, b(v).join(`\\b|`), `\\b)`),
                    r,
                    t.concat(p, `*`),
                    t.lookahead(/(?=\()/)
                ],
                scope: {
                    3: `title.function.invoke`
                },
                contains: [
                    T
                ]
            };
            T.contains.push(E);
            let D = [
                w,
                C,
                e.C_BLOCK_COMMENT_MODE,
                m,
                h,
                x
            ], O = {
                begin: t.concat(/#\[\s*\\?/, t.either(i, a)),
                beginScope: `meta`,
                end: /]/,
                endScope: `meta`,
                keywords: {
                    literal: g,
                    keyword: [
                        `new`,
                        `array`
                    ]
                },
                contains: [
                    {
                        begin: /\[/,
                        end: /]/,
                        keywords: {
                            literal: g,
                            keyword: [
                                `new`,
                                `array`
                            ]
                        },
                        contains: [
                            `self`,
                            ...D
                        ]
                    },
                    ...D,
                    {
                        scope: `meta`,
                        variants: [
                            {
                                match: i
                            },
                            {
                                match: a
                            }
                        ]
                    }
                ]
            };
            return {
                case_insensitive: !1,
                keywords: y,
                contains: [
                    O,
                    e.HASH_COMMENT_MODE,
                    e.COMMENT(`//`, `$`),
                    e.COMMENT(`/\\*`, `\\*/`, {
                        contains: [
                            {
                                scope: `doctag`,
                                match: `@[A-Za-z]+`
                            }
                        ]
                    }),
                    {
                        match: /__halt_compiler\(\);/,
                        keywords: `__halt_compiler`,
                        starts: {
                            scope: `comment`,
                            end: e.MATCH_NOTHING_RE,
                            contains: [
                                {
                                    match: /\?>/,
                                    scope: `meta`,
                                    endsParent: !0
                                }
                            ]
                        }
                    },
                    s,
                    {
                        scope: `variable.language`,
                        match: /\$this\b/
                    },
                    o,
                    E,
                    C,
                    {
                        match: [
                            /const/,
                            /\s/,
                            r
                        ],
                        scope: {
                            1: `keyword`,
                            3: `variable.constant`
                        }
                    },
                    x,
                    {
                        scope: `function`,
                        relevance: 0,
                        beginKeywords: `fn function`,
                        end: /[;{]/,
                        excludeEnd: !0,
                        illegal: `[$%\\[]`,
                        contains: [
                            {
                                beginKeywords: `use`
                            },
                            e.UNDERSCORE_TITLE_MODE,
                            {
                                begin: `=>`,
                                endsParent: !0
                            },
                            {
                                scope: `params`,
                                begin: `\\(`,
                                end: `\\)`,
                                excludeBegin: !0,
                                excludeEnd: !0,
                                keywords: y,
                                contains: [
                                    `self`,
                                    O,
                                    o,
                                    C,
                                    e.C_BLOCK_COMMENT_MODE,
                                    m,
                                    h
                                ]
                            }
                        ]
                    },
                    {
                        scope: `class`,
                        variants: [
                            {
                                beginKeywords: `enum`,
                                illegal: /[($"]/
                            },
                            {
                                beginKeywords: `class interface trait`,
                                illegal: /[:($"]/
                            }
                        ],
                        relevance: 0,
                        end: /\{/,
                        excludeEnd: !0,
                        contains: [
                            {
                                beginKeywords: `extends implements`
                            },
                            e.UNDERSCORE_TITLE_MODE
                        ]
                    },
                    {
                        beginKeywords: `namespace`,
                        relevance: 0,
                        end: `;`,
                        illegal: /[.']/,
                        contains: [
                            e.inherit(e.UNDERSCORE_TITLE_MODE, {
                                scope: `title.class`
                            })
                        ]
                    },
                    {
                        beginKeywords: `use`,
                        relevance: 0,
                        end: `;`,
                        contains: [
                            {
                                match: /\b(as|const|function)\b/,
                                scope: `keyword`
                            },
                            e.UNDERSCORE_TITLE_MODE
                        ]
                    },
                    m,
                    h
                ]
            };
        }
        t.exports = n;
    }), Ft = o((e, t)=>{
        function n(e) {
            return {
                name: `PHP template`,
                subLanguage: `xml`,
                contains: [
                    {
                        begin: /<\?(php|=)?/,
                        end: /\?>/,
                        subLanguage: `php`,
                        contains: [
                            {
                                begin: `/\\*`,
                                end: `\\*/`,
                                skip: !0
                            },
                            {
                                begin: `b"`,
                                end: `"`,
                                skip: !0
                            },
                            {
                                begin: `b'`,
                                end: `'`,
                                skip: !0
                            },
                            e.inherit(e.APOS_STRING_MODE, {
                                illegal: null,
                                className: null,
                                contains: null,
                                skip: !0
                            }),
                            e.inherit(e.QUOTE_STRING_MODE, {
                                illegal: null,
                                className: null,
                                contains: null,
                                skip: !0
                            })
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), It = o((e, t)=>{
        function n(e) {
            return {
                name: `Plain text`,
                aliases: [
                    `text`,
                    `txt`
                ],
                disableAutodetect: !0
            };
        }
        t.exports = n;
    }), Lt = o((e, t)=>{
        function n(e) {
            return {
                name: `Pony`,
                keywords: {
                    keyword: `actor addressof and as be break class compile_error compile_intrinsic consume continue delegate digestof do else elseif embed end error for fun if ifdef in interface is isnt lambda let match new not object or primitive recover repeat return struct then trait try type until use var where while with xor`,
                    meta: `iso val tag trn box ref`,
                    literal: `this false true`
                },
                contains: [
                    {
                        className: `type`,
                        begin: `\\b_?[A-Z][\\w]*`,
                        relevance: 0
                    },
                    {
                        className: `string`,
                        begin: `"""`,
                        end: `"""`,
                        relevance: 10
                    },
                    {
                        className: `string`,
                        begin: `"`,
                        end: `"`,
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ]
                    },
                    {
                        className: `string`,
                        begin: `'`,
                        end: `'`,
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ],
                        relevance: 0
                    },
                    {
                        begin: e.IDENT_RE + `'`,
                        relevance: 0
                    },
                    {
                        className: `number`,
                        begin: `(-?)(\\b0[xX][a-fA-F0-9]+|\\b0[bB][01]+|(\\b\\d+(_\\d+)?(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)`,
                        relevance: 0
                    },
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE
                ]
            };
        }
        t.exports = n;
    }), Rt = o((e, t)=>{
        function n(e) {
            let t = [
                `string`,
                `char`,
                `byte`,
                `int`,
                `long`,
                `bool`,
                `decimal`,
                `single`,
                `double`,
                `DateTime`,
                `xml`,
                `array`,
                `hashtable`,
                `void`
            ], n = {
                $pattern: /-?[A-z\.\-]+\b/,
                keyword: `if else foreach return do while until elseif begin for trap data dynamicparam end break throw param continue finally in switch exit filter try process catch hidden static parameter`,
                built_in: `ac asnp cat cd CFS chdir clc clear clhy cli clp cls clv cnsn compare copy cp cpi cpp curl cvpa dbp del diff dir dnsn ebp echo|0 epal epcsv epsn erase etsn exsn fc fhx fl ft fw gal gbp gc gcb gci gcm gcs gdr gerr ghy gi gin gjb gl gm gmo gp gps gpv group gsn gsnp gsv gtz gu gv gwmi h history icm iex ihy ii ipal ipcsv ipmo ipsn irm ise iwmi iwr kill lp ls man md measure mi mount move mp mv nal ndr ni nmo npssc nsn nv ogv oh popd ps pushd pwd r rbp rcjb rcsn rd rdr ren ri rjb rm rmdir rmo rni rnp rp rsn rsnp rujb rv rvpa rwmi sajb sal saps sasv sbp sc scb select set shcm si sl sleep sls sort sp spjb spps spsv start stz sujb sv swmi tee trcm type wget where wjb write`
            }, r = /\w[\w\d]*((-)[\w\d]+)*/, i = {
                begin: "`[\\s\\S]",
                relevance: 0
            }, a = {
                className: `variable`,
                variants: [
                    {
                        begin: /\$\B/
                    },
                    {
                        className: `keyword`,
                        begin: /\$this/
                    },
                    {
                        begin: /\$[\w\d][\w\d_:]*/
                    }
                ]
            }, o = {
                className: `literal`,
                begin: /\$(null|true|false)\b/
            }, s = {
                className: `string`,
                variants: [
                    {
                        begin: /"/,
                        end: /"/
                    },
                    {
                        begin: /@"/,
                        end: /^"@/
                    }
                ],
                contains: [
                    i,
                    a,
                    {
                        className: `variable`,
                        begin: /\$[A-z]/,
                        end: /[^A-z]/
                    }
                ]
            }, c = {
                className: `string`,
                variants: [
                    {
                        begin: /'/,
                        end: /'/
                    },
                    {
                        begin: /@'/,
                        end: /^'@/
                    }
                ]
            }, l = e.inherit(e.COMMENT(null, null), {
                variants: [
                    {
                        begin: /#/,
                        end: /$/
                    },
                    {
                        begin: /<#/,
                        end: /#>/
                    }
                ],
                contains: [
                    {
                        className: `doctag`,
                        variants: [
                            {
                                begin: /\.(synopsis|description|example|inputs|outputs|notes|link|component|role|functionality)/
                            },
                            {
                                begin: /\.(parameter|forwardhelptargetname|forwardhelpcategory|remotehelprunspace|externalhelp)\s+\S+/
                            }
                        ]
                    }
                ]
            }), u = {
                className: `built_in`,
                variants: [
                    {
                        begin: `(Add|Clear|Close|Copy|Enter|Exit|Find|Format|Get|Hide|Join|Lock|Move|New|Open|Optimize|Pop|Push|Redo|Remove|Rename|Reset|Resize|Search|Select|Set|Show|Skip|Split|Step|Switch|Undo|Unlock|Watch|Backup|Checkpoint|Compare|Compress|Convert|ConvertFrom|ConvertTo|Dismount|Edit|Expand|Export|Group|Import|Initialize|Limit|Merge|Mount|Out|Publish|Restore|Save|Sync|Unpublish|Update|Approve|Assert|Build|Complete|Confirm|Deny|Deploy|Disable|Enable|Install|Invoke|Register|Request|Restart|Resume|Start|Stop|Submit|Suspend|Uninstall|Unregister|Wait|Debug|Measure|Ping|Repair|Resolve|Test|Trace|Connect|Disconnect|Read|Receive|Send|Write|Block|Grant|Protect|Revoke|Unblock|Unprotect|Use|ForEach|Sort|Tee|Where)+(-)[\\w\\d]+`
                    }
                ]
            }, d = {
                className: `class`,
                beginKeywords: `class enum`,
                end: /\s*[{]/,
                excludeEnd: !0,
                relevance: 0,
                contains: [
                    e.TITLE_MODE
                ]
            }, f = {
                className: `function`,
                begin: /function\s+/,
                end: /\s*\{|$/,
                excludeEnd: !0,
                returnBegin: !0,
                relevance: 0,
                contains: [
                    {
                        begin: `function`,
                        relevance: 0,
                        className: `keyword`
                    },
                    {
                        className: `title`,
                        begin: r,
                        relevance: 0
                    },
                    {
                        begin: /\(/,
                        end: /\)/,
                        className: `params`,
                        relevance: 0,
                        contains: [
                            a
                        ]
                    }
                ]
            }, p = {
                begin: /using\s/,
                end: /$/,
                returnBegin: !0,
                contains: [
                    s,
                    c,
                    {
                        className: `keyword`,
                        begin: /(using|assembly|command|module|namespace|type)/
                    }
                ]
            }, m = {
                variants: [
                    {
                        className: `operator`,
                        begin: `(-and|-as|-band|-bnot|-bor|-bxor|-casesensitive|-ccontains|-ceq|-cge|-cgt|-cle|-clike|-clt|-cmatch|-cne|-cnotcontains|-cnotlike|-cnotmatch|-contains|-creplace|-csplit|-eq|-exact|-f|-file|-ge|-gt|-icontains|-ieq|-ige|-igt|-ile|-ilike|-ilt|-imatch|-in|-ine|-inotcontains|-inotlike|-inotmatch|-ireplace|-is|-isnot|-isplit|-join|-le|-like|-lt|-match|-ne|-not|-notcontains|-notin|-notlike|-notmatch|-or|-regex|-replace|-shl|-shr|-split|-wildcard|-xor)\\b`
                    },
                    {
                        className: `literal`,
                        begin: /(-){1,2}[\w\d-]+/,
                        relevance: 0
                    }
                ]
            }, h = {
                className: `selector-tag`,
                begin: /@\B/,
                relevance: 0
            }, g = {
                className: `function`,
                begin: /\[.*\]\s*[\w]+[ ]??\(/,
                end: /$/,
                returnBegin: !0,
                relevance: 0,
                contains: [
                    {
                        className: `keyword`,
                        begin: `(${n.keyword.toString().replace(/\s/g, `|`)})\\b`,
                        endsParent: !0,
                        relevance: 0
                    },
                    e.inherit(e.TITLE_MODE, {
                        endsParent: !0
                    })
                ]
            }, _ = [
                g,
                l,
                i,
                e.NUMBER_MODE,
                s,
                c,
                u,
                a,
                o,
                h
            ], v = {
                begin: /\[/,
                end: /\]/,
                excludeBegin: !0,
                excludeEnd: !0,
                relevance: 0,
                contains: [
                    `self`
                ].concat(_, {
                    begin: `(` + t.join(`|`) + `)`,
                    className: `built_in`,
                    relevance: 0
                }, {
                    className: `type`,
                    begin: /[\.\w\d]+/,
                    relevance: 0
                })
            };
            return g.contains.unshift(v), {
                name: `PowerShell`,
                aliases: [
                    `pwsh`,
                    `ps`,
                    `ps1`
                ],
                case_insensitive: !0,
                keywords: n,
                contains: _.concat(d, f, p, m, v)
            };
        }
        t.exports = n;
    }), zt = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = `displayHeight.displayWidth.mouseY.mouseX.mousePressed.pmouseX.pmouseY.key.keyCode.pixels.focused.frameCount.frameRate.height.width.size.createGraphics.beginDraw.createShape.loadShape.PShape.arc.ellipse.line.point.quad.rect.triangle.bezier.bezierDetail.bezierPoint.bezierTangent.curve.curveDetail.curvePoint.curveTangent.curveTightness.shape.shapeMode.beginContour.beginShape.bezierVertex.curveVertex.endContour.endShape.quadraticVertex.vertex.ellipseMode.noSmooth.rectMode.smooth.strokeCap.strokeJoin.strokeWeight.mouseClicked.mouseDragged.mouseMoved.mousePressed.mouseReleased.mouseWheel.keyPressed.keyPressedkeyReleased.keyTyped.print.println.save.saveFrame.day.hour.millis.minute.month.second.year.background.clear.colorMode.fill.noFill.noStroke.stroke.alpha.blue.brightness.color.green.hue.lerpColor.red.saturation.modelX.modelY.modelZ.screenX.screenY.screenZ.ambient.emissive.shininess.specular.add.createImage.beginCamera.camera.endCamera.frustum.ortho.perspective.printCamera.printProjection.cursor.frameRate.noCursor.exit.loop.noLoop.popStyle.pushStyle.redraw.binary.boolean.byte.char.float.hex.int.str.unbinary.unhex.join.match.matchAll.nf.nfc.nfp.nfs.split.splitTokens.trim.append.arrayCopy.concat.expand.reverse.shorten.sort.splice.subset.box.sphere.sphereDetail.createInput.createReader.loadBytes.loadJSONArray.loadJSONObject.loadStrings.loadTable.loadXML.open.parseXML.saveTable.selectFolder.selectInput.beginRaw.beginRecord.createOutput.createWriter.endRaw.endRecord.PrintWritersaveBytes.saveJSONArray.saveJSONObject.saveStream.saveStrings.saveXML.selectOutput.popMatrix.printMatrix.pushMatrix.resetMatrix.rotate.rotateX.rotateY.rotateZ.scale.shearX.shearY.translate.ambientLight.directionalLight.lightFalloff.lights.lightSpecular.noLights.normal.pointLight.spotLight.image.imageMode.loadImage.noTint.requestImage.tint.texture.textureMode.textureWrap.blend.copy.filter.get.loadPixels.set.updatePixels.blendMode.loadShader.PShaderresetShader.shader.createFont.loadFont.text.textFont.textAlign.textLeading.textMode.textSize.textWidth.textAscent.textDescent.abs.ceil.constrain.dist.exp.floor.lerp.log.mag.map.max.min.norm.pow.round.sq.sqrt.acos.asin.atan.atan2.cos.degrees.radians.sin.tan.noise.noiseDetail.noiseSeed.random.randomGaussian.randomSeed`.split(`.`), r = e.IDENT_RE, i = {
                variants: [
                    {
                        match: t.concat(t.either(...n), t.lookahead(/\s*\(/)),
                        className: `built_in`
                    },
                    {
                        relevance: 0,
                        match: t.concat(/\b(?!for|if|while)/, r, t.lookahead(/\s*\(/)),
                        className: `title.function`
                    }
                ]
            }, a = {
                match: [
                    /new\s+/,
                    r
                ],
                className: {
                    1: `keyword`,
                    2: `class.title`
                }
            }, o = {
                relevance: 0,
                match: [
                    /\./,
                    r
                ],
                className: {
                    2: `property`
                }
            }, s = {
                variants: [
                    {
                        match: [
                            /class/,
                            /\s+/,
                            r,
                            /\s+/,
                            /extends/,
                            /\s+/,
                            r
                        ]
                    },
                    {
                        match: [
                            /class/,
                            /\s+/,
                            r
                        ]
                    }
                ],
                className: {
                    1: `keyword`,
                    3: `title.class`,
                    5: `keyword`,
                    7: `title.class.inherited`
                }
            }, c = [
                `boolean`,
                `byte`,
                `char`,
                `color`,
                `double`,
                `float`,
                `int`,
                `long`,
                `short`
            ], l = [
                `BufferedReader`,
                `PVector`,
                `PFont`,
                `PImage`,
                `PGraphics`,
                `HashMap`,
                `String`,
                `Array`,
                `FloatDict`,
                `ArrayList`,
                `FloatList`,
                `IntDict`,
                `IntList`,
                `JSONArray`,
                `JSONObject`,
                `Object`,
                `StringDict`,
                `StringList`,
                `Table`,
                `TableRow`,
                `XML`
            ];
            return {
                name: `Processing`,
                aliases: [
                    `pde`
                ],
                keywords: {
                    keyword: [
                        ...`abstract.assert.break.case.catch.const.continue.default.else.enum.final.finally.for.if.import.instanceof.long.native.new.package.private.private.protected.protected.public.public.return.static.strictfp.switch.synchronized.throw.throws.transient.try.void.volatile.while`.split(`.`)
                    ],
                    literal: `P2D P3D HALF_PI PI QUARTER_PI TAU TWO_PI null true false`,
                    title: `setup draw`,
                    variable: `super this`,
                    built_in: [
                        ...n,
                        ...l
                    ],
                    type: c
                },
                contains: [
                    s,
                    a,
                    i,
                    o,
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE,
                    e.C_NUMBER_MODE
                ]
            };
        }
        t.exports = n;
    }), Bt = o((e, t)=>{
        function n(e) {
            return {
                name: `Python profiler`,
                contains: [
                    e.C_NUMBER_MODE,
                    {
                        begin: `[a-zA-Z_][\\da-zA-Z_]+\\.[\\da-zA-Z_]{1,3}`,
                        end: `:`,
                        excludeEnd: !0
                    },
                    {
                        begin: `(ncalls|tottime|cumtime)`,
                        end: `$`,
                        keywords: `ncalls tottime|10 cumtime|10 filename`,
                        relevance: 10
                    },
                    {
                        begin: `function calls`,
                        end: `$`,
                        contains: [
                            e.C_NUMBER_MODE
                        ],
                        relevance: 10
                    },
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE,
                    {
                        className: `string`,
                        begin: `\\(`,
                        end: `\\)$`,
                        excludeBegin: !0,
                        excludeEnd: !0,
                        relevance: 0
                    }
                ]
            };
        }
        t.exports = n;
    }), Vt = o((e, t)=>{
        function n(e) {
            let t = {
                begin: /[a-z][A-Za-z0-9_]*/,
                relevance: 0
            }, n = {
                className: `symbol`,
                variants: [
                    {
                        begin: /[A-Z][a-zA-Z0-9_]*/
                    },
                    {
                        begin: /_[A-Za-z0-9_]*/
                    }
                ],
                relevance: 0
            }, r = {
                begin: /\(/,
                end: /\)/,
                relevance: 0
            }, i = {
                begin: /\[/,
                end: /\]/
            }, a = {
                className: `comment`,
                begin: /%/,
                end: /$/,
                contains: [
                    e.PHRASAL_WORDS_MODE
                ]
            }, o = {
                className: `string`,
                begin: /`/,
                end: /`/,
                contains: [
                    e.BACKSLASH_ESCAPE
                ]
            }, s = [
                t,
                n,
                r,
                {
                    begin: /:-/
                },
                i,
                a,
                e.C_BLOCK_COMMENT_MODE,
                e.QUOTE_STRING_MODE,
                e.APOS_STRING_MODE,
                o,
                {
                    className: `string`,
                    begin: /0'(\\'|.)/
                },
                {
                    className: `string`,
                    begin: /0'\\s/
                },
                e.C_NUMBER_MODE
            ];
            return r.contains = s, i.contains = s, {
                name: `Prolog`,
                contains: s.concat([
                    {
                        begin: /\.$/
                    }
                ])
            };
        }
        t.exports = n;
    }), Ht = o((e, t)=>{
        function n(e) {
            let t = `[ \\t\\f]*`, n = t + `[:=][ \\t\\f]*`;
            n;
            let r = `([^\\\\:= \\t\\f\\n]|\\\\.)+`;
            return {
                name: `.properties`,
                disableAutodetect: !0,
                case_insensitive: !0,
                illegal: /\S/,
                contains: [
                    e.COMMENT(`^\\s*[!#]`, `$`),
                    {
                        returnBegin: !0,
                        variants: [
                            {
                                begin: r + n
                            },
                            {
                                begin: r + `[ \\t\\f]+`
                            }
                        ],
                        contains: [
                            {
                                className: `attr`,
                                begin: r,
                                endsParent: !0
                            }
                        ],
                        starts: {
                            end: `([ \\t\\f]*[:=][ \\t\\f]*|[ \\t\\f]+)`,
                            relevance: 0,
                            starts: {
                                className: `string`,
                                end: /$/,
                                relevance: 0,
                                contains: [
                                    {
                                        begin: `\\\\\\\\`
                                    },
                                    {
                                        begin: `\\\\\\n`
                                    }
                                ]
                            }
                        }
                    },
                    {
                        className: `attr`,
                        begin: r + t + `$`
                    }
                ]
            };
        }
        t.exports = n;
    }), Ut = o((e, t)=>{
        function n(e) {
            let t = [
                `package`,
                `import`,
                `option`,
                `optional`,
                `required`,
                `repeated`,
                `group`,
                `oneof`
            ], n = [
                `double`,
                `float`,
                `int32`,
                `int64`,
                `uint32`,
                `uint64`,
                `sint32`,
                `sint64`,
                `fixed32`,
                `fixed64`,
                `sfixed32`,
                `sfixed64`,
                `bool`,
                `string`,
                `bytes`
            ], r = {
                match: [
                    /(message|enum|service)\s+/,
                    e.IDENT_RE
                ],
                scope: {
                    1: `keyword`,
                    2: `title.class`
                }
            };
            return {
                name: `Protocol Buffers`,
                aliases: [
                    `proto`
                ],
                keywords: {
                    keyword: t,
                    type: n,
                    literal: [
                        `true`,
                        `false`
                    ]
                },
                contains: [
                    e.QUOTE_STRING_MODE,
                    e.NUMBER_MODE,
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    r,
                    {
                        className: `function`,
                        beginKeywords: `rpc`,
                        end: /[{;]/,
                        excludeEnd: !0,
                        keywords: `rpc returns`
                    },
                    {
                        begin: /^\s*[A-Z_]+(?=\s*=[^\n]+;$)/
                    }
                ]
            };
        }
        t.exports = n;
    }), Wt = o((e, t)=>{
        function n(e) {
            let t = {
                keyword: `and case default else elsif false if in import enherits node or true undef unless main settings $string `,
                literal: `alias audit before loglevel noop require subscribe tag owner ensure group mode name|0 changes context force incl lens load_path onlyif provider returns root show_diff type_check en_address ip_address realname command environment hour monute month monthday special target weekday creates cwd ogoutput refresh refreshonly tries try_sleep umask backup checksum content ctime force ignore links mtime purge recurse recurselimit replace selinux_ignore_defaults selrange selrole seltype seluser source souirce_permissions sourceselect validate_cmd validate_replacement allowdupe attribute_membership auth_membership forcelocal gid ia_load_module members system host_aliases ip allowed_trunk_vlans description device_url duplex encapsulation etherchannel native_vlan speed principals allow_root auth_class auth_type authenticate_user k_of_n mechanisms rule session_owner shared options device fstype enable hasrestart directory present absent link atboot blockdevice device dump pass remounts poller_tag use message withpath adminfile allow_virtual allowcdrom category configfiles flavor install_options instance package_settings platform responsefile status uninstall_options vendor unless_system_user unless_uid binary control flags hasstatus manifest pattern restart running start stop allowdupe auths expiry gid groups home iterations key_membership keys managehome membership password password_max_age password_min_age profile_membership profiles project purge_ssh_keys role_membership roles salt shell uid baseurl cost descr enabled enablegroups exclude failovermethod gpgcheck gpgkey http_caching include includepkgs keepalive metadata_expire metalink mirrorlist priority protect proxy proxy_password proxy_username repo_gpgcheck s3_enabled skip_if_unavailable sslcacert sslclientcert sslclientkey sslverify mounted`,
                built_in: `architecture augeasversion blockdevices boardmanufacturer boardproductname boardserialnumber cfkey dhcp_servers domain ec2_ ec2_userdata facterversion filesystems ldom fqdn gid hardwareisa hardwaremodel hostname id|0 interfaces ipaddress ipaddress_ ipaddress6 ipaddress6_ iphostnumber is_virtual kernel kernelmajversion kernelrelease kernelversion kernelrelease kernelversion lsbdistcodename lsbdistdescription lsbdistid lsbdistrelease lsbmajdistrelease lsbminordistrelease lsbrelease macaddress macaddress_ macosx_buildversion macosx_productname macosx_productversion macosx_productverson_major macosx_productversion_minor manufacturer memoryfree memorysize netmask metmask_ network_ operatingsystem operatingsystemmajrelease operatingsystemrelease osfamily partitions path physicalprocessorcount processor processorcount productname ps puppetversion rubysitedir rubyversion selinux selinux_config_mode selinux_config_policy selinux_current_mode selinux_current_mode selinux_enforced selinux_policyversion serialnumber sp_ sshdsakey sshecdsakey sshrsakey swapencrypted swapfree swapsize timezone type uniqueid uptime uptime_days uptime_hours uptime_seconds uuid virtual vlans xendomains zfs_version zonenae zones zpool_version`
            }, n = e.COMMENT(`#`, `$`), r = `([A-Za-z_]|::)(\\w|::)*`, i = e.inherit(e.TITLE_MODE, {
                begin: r
            }), a = {
                className: `variable`,
                begin: `\\$` + r
            }, o = {
                className: `string`,
                contains: [
                    e.BACKSLASH_ESCAPE,
                    a
                ],
                variants: [
                    {
                        begin: /'/,
                        end: /'/
                    },
                    {
                        begin: /"/,
                        end: /"/
                    }
                ]
            };
            return {
                name: `Puppet`,
                aliases: [
                    `pp`
                ],
                contains: [
                    n,
                    a,
                    o,
                    {
                        beginKeywords: `class`,
                        end: `\\{|;`,
                        illegal: /=/,
                        contains: [
                            i,
                            n
                        ]
                    },
                    {
                        beginKeywords: `define`,
                        end: /\{/,
                        contains: [
                            {
                                className: `section`,
                                begin: e.IDENT_RE,
                                endsParent: !0
                            }
                        ]
                    },
                    {
                        begin: e.IDENT_RE + `\\s+\\{`,
                        returnBegin: !0,
                        end: /\S/,
                        contains: [
                            {
                                className: `keyword`,
                                begin: e.IDENT_RE,
                                relevance: .2
                            },
                            {
                                begin: /\{/,
                                end: /\}/,
                                keywords: t,
                                relevance: 0,
                                contains: [
                                    o,
                                    n,
                                    {
                                        begin: `[a-zA-Z_]+\\s*=>`,
                                        returnBegin: !0,
                                        end: `=>`,
                                        contains: [
                                            {
                                                className: `attr`,
                                                begin: e.IDENT_RE
                                            }
                                        ]
                                    },
                                    {
                                        className: `number`,
                                        begin: `(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b`,
                                        relevance: 0
                                    },
                                    a
                                ]
                            }
                        ],
                        relevance: 0
                    }
                ]
            };
        }
        t.exports = n;
    }), Gt = o((e, t)=>{
        function n(e) {
            return {
                name: `PureBASIC`,
                aliases: [
                    `pb`,
                    `pbi`
                ],
                keywords: `Align And Array As Break CallDebugger Case CompilerCase CompilerDefault CompilerElse CompilerElseIf CompilerEndIf CompilerEndSelect CompilerError CompilerIf CompilerSelect CompilerWarning Continue Data DataSection Debug DebugLevel Declare DeclareC DeclareCDLL DeclareDLL DeclareModule Default Define Dim DisableASM DisableDebugger DisableExplicit Else ElseIf EnableASM EnableDebugger EnableExplicit End EndDataSection EndDeclareModule EndEnumeration EndIf EndImport EndInterface EndMacro EndModule EndProcedure EndSelect EndStructure EndStructureUnion EndWith Enumeration EnumerationBinary Extends FakeReturn For ForEach ForEver Global Gosub Goto If Import ImportC IncludeBinary IncludeFile IncludePath Interface List Macro MacroExpandedCount Map Module NewList NewMap Next Not Or Procedure ProcedureC ProcedureCDLL ProcedureDLL ProcedureReturn Protected Prototype PrototypeC ReDim Read Repeat Restore Return Runtime Select Shared Static Step Structure StructureUnion Swap Threaded To UndefineMacro Until Until  UnuseModule UseModule Wend While With XIncludeFile XOr`,
                contains: [
                    e.COMMENT(`;`, `$`, {
                        relevance: 0
                    }),
                    {
                        className: `function`,
                        begin: `\\b(Procedure|Declare)(C|CDLL|DLL)?\\b`,
                        end: `\\(`,
                        excludeEnd: !0,
                        returnBegin: !0,
                        contains: [
                            {
                                className: `keyword`,
                                begin: `(Procedure|Declare)(C|CDLL|DLL)?`,
                                excludeEnd: !0
                            },
                            {
                                className: `type`,
                                begin: `\\.\\w*`
                            },
                            e.UNDERSCORE_TITLE_MODE
                        ]
                    },
                    {
                        className: `string`,
                        begin: `(~)?"`,
                        end: `"`,
                        illegal: `\\n`
                    },
                    {
                        className: `symbol`,
                        begin: `#[a-zA-Z_]\\w*\\$?`
                    }
                ]
            };
        }
        t.exports = n;
    }), Kt = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = /[\p{XID_Start}_]\p{XID_Continue}*/u, r = `and.as.assert.async.await.break.case.class.continue.def.del.elif.else.except.finally.for.from.global.if.import.in.is.lambda.match.nonlocal|10.not.or.pass.raise.return.try.while.with.yield`.split(`.`), i = {
                $pattern: /[A-Za-z]\w+|__\w+__/,
                keyword: r,
                built_in: `__import__.abs.all.any.ascii.bin.bool.breakpoint.bytearray.bytes.callable.chr.classmethod.compile.complex.delattr.dict.dir.divmod.enumerate.eval.exec.filter.float.format.frozenset.getattr.globals.hasattr.hash.help.hex.id.input.int.isinstance.issubclass.iter.len.list.locals.map.max.memoryview.min.next.object.oct.open.ord.pow.print.property.range.repr.reversed.round.set.setattr.slice.sorted.staticmethod.str.sum.super.tuple.type.vars.zip`.split(`.`),
                literal: [
                    `__debug__`,
                    `Ellipsis`,
                    `False`,
                    `None`,
                    `NotImplemented`,
                    `True`
                ],
                type: [
                    `Any`,
                    `Callable`,
                    `Coroutine`,
                    `Dict`,
                    `List`,
                    `Literal`,
                    `Generic`,
                    `Optional`,
                    `Sequence`,
                    `Set`,
                    `Tuple`,
                    `Type`,
                    `Union`
                ]
            }, a = {
                className: `meta`,
                begin: /^(>>>|\.\.\.) /
            }, o = {
                className: `subst`,
                begin: /\{/,
                end: /\}/,
                keywords: i,
                illegal: /#/
            }, s = {
                begin: /\{\{/,
                relevance: 0
            }, c = {
                className: `string`,
                contains: [
                    e.BACKSLASH_ESCAPE
                ],
                variants: [
                    {
                        begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?'''/,
                        end: /'''/,
                        contains: [
                            e.BACKSLASH_ESCAPE,
                            a
                        ],
                        relevance: 10
                    },
                    {
                        begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?"""/,
                        end: /"""/,
                        contains: [
                            e.BACKSLASH_ESCAPE,
                            a
                        ],
                        relevance: 10
                    },
                    {
                        begin: /([fF][rR]|[rR][fF]|[fF])'''/,
                        end: /'''/,
                        contains: [
                            e.BACKSLASH_ESCAPE,
                            a,
                            s,
                            o
                        ]
                    },
                    {
                        begin: /([fF][rR]|[rR][fF]|[fF])"""/,
                        end: /"""/,
                        contains: [
                            e.BACKSLASH_ESCAPE,
                            a,
                            s,
                            o
                        ]
                    },
                    {
                        begin: /([uU]|[rR])'/,
                        end: /'/,
                        relevance: 10
                    },
                    {
                        begin: /([uU]|[rR])"/,
                        end: /"/,
                        relevance: 10
                    },
                    {
                        begin: /([bB]|[bB][rR]|[rR][bB])'/,
                        end: /'/
                    },
                    {
                        begin: /([bB]|[bB][rR]|[rR][bB])"/,
                        end: /"/
                    },
                    {
                        begin: /([fF][rR]|[rR][fF]|[fF])'/,
                        end: /'/,
                        contains: [
                            e.BACKSLASH_ESCAPE,
                            s,
                            o
                        ]
                    },
                    {
                        begin: /([fF][rR]|[rR][fF]|[fF])"/,
                        end: /"/,
                        contains: [
                            e.BACKSLASH_ESCAPE,
                            s,
                            o
                        ]
                    },
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE
                ]
            }, l = `[0-9](_?[0-9])*`, u = `(\\b(${l}))?\\.(${l})|\\b(${l})\\.`, d = `\\b|${r.join(`|`)}`, f = {
                className: `number`,
                relevance: 0,
                variants: [
                    {
                        begin: `(\\b(${l})|(${u}))[eE][+-]?(${l})[jJ]?(?=${d})`
                    },
                    {
                        begin: `(${u})[jJ]?`
                    },
                    {
                        begin: `\\b([1-9](_?[0-9])*|0+(_?0)*)[lLjJ]?(?=${d})`
                    },
                    {
                        begin: `\\b0[bB](_?[01])+[lL]?(?=${d})`
                    },
                    {
                        begin: `\\b0[oO](_?[0-7])+[lL]?(?=${d})`
                    },
                    {
                        begin: `\\b0[xX](_?[0-9a-fA-F])+[lL]?(?=${d})`
                    },
                    {
                        begin: `\\b(${l})[jJ](?=${d})`
                    }
                ]
            }, p = {
                className: `comment`,
                begin: t.lookahead(/# type:/),
                end: /$/,
                keywords: i,
                contains: [
                    {
                        begin: /# type:/
                    },
                    {
                        begin: /#/,
                        end: /\b\B/,
                        endsWithParent: !0
                    }
                ]
            }, m = {
                className: `params`,
                variants: [
                    {
                        className: ``,
                        begin: /\(\s*\)/,
                        skip: !0
                    },
                    {
                        begin: /\(/,
                        end: /\)/,
                        excludeBegin: !0,
                        excludeEnd: !0,
                        keywords: i,
                        contains: [
                            `self`,
                            a,
                            f,
                            c,
                            e.HASH_COMMENT_MODE
                        ]
                    }
                ]
            };
            return o.contains = [
                c,
                f,
                a
            ], {
                name: `Python`,
                aliases: [
                    `py`,
                    `gyp`,
                    `ipython`
                ],
                unicodeRegex: !0,
                keywords: i,
                illegal: /(<\/|\?)|=>/,
                contains: [
                    a,
                    f,
                    {
                        scope: `variable.language`,
                        match: /\bself\b/
                    },
                    {
                        beginKeywords: `if`,
                        relevance: 0
                    },
                    {
                        match: /\bor\b/,
                        scope: `keyword`
                    },
                    c,
                    p,
                    e.HASH_COMMENT_MODE,
                    {
                        match: [
                            /\bdef/,
                            /\s+/,
                            n
                        ],
                        scope: {
                            1: `keyword`,
                            3: `title.function`
                        },
                        contains: [
                            m
                        ]
                    },
                    {
                        variants: [
                            {
                                match: [
                                    /\bclass/,
                                    /\s+/,
                                    n,
                                    /\s*/,
                                    /\(\s*/,
                                    n,
                                    /\s*\)/
                                ]
                            },
                            {
                                match: [
                                    /\bclass/,
                                    /\s+/,
                                    n
                                ]
                            }
                        ],
                        scope: {
                            1: `keyword`,
                            3: `title.class`,
                            6: `title.class.inherited`
                        }
                    },
                    {
                        className: `meta`,
                        begin: /^[\t ]*@/,
                        end: /(?=#)|$/,
                        contains: [
                            f,
                            m,
                            c
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), qt = o((e, t)=>{
        function n(e) {
            return {
                aliases: [
                    `pycon`
                ],
                contains: [
                    {
                        className: `meta.prompt`,
                        starts: {
                            end: / |$/,
                            starts: {
                                end: `$`,
                                subLanguage: `python`
                            }
                        },
                        variants: [
                            {
                                begin: /^>>>(?=[ ]|$)/
                            },
                            {
                                begin: /^\.\.\.(?=[ ]|$)/
                            }
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), Jt = o((e, t)=>{
        function n(e) {
            return {
                name: `Q`,
                aliases: [
                    `k`,
                    `kdb`
                ],
                keywords: {
                    $pattern: /(`?)[A-Za-z0-9_]+\b/,
                    keyword: `do while select delete by update from`,
                    literal: `0b 1b`,
                    built_in: `neg not null string reciprocal floor ceiling signum mod xbar xlog and or each scan over prior mmu lsq inv md5 ltime gtime count first var dev med cov cor all any rand sums prds mins maxs fills deltas ratios avgs differ prev next rank reverse iasc idesc asc desc msum mcount mavg mdev xrank mmin mmax xprev rotate distinct group where flip type key til get value attr cut set upsert raze union inter except cross sv vs sublist enlist read0 read1 hopen hclose hdel hsym hcount peach system ltrim rtrim trim lower upper ssr view tables views cols xcols keys xkey xcol xasc xdesc fkeys meta lj aj aj0 ij pj asof uj ww wj wj1 fby xgroup ungroup ej save load rsave rload show csv parse eval min max avg wavg wsum sin cos tan sum`,
                    type: "`float `double int `timestamp `timespan `datetime `time `boolean `symbol `char `byte `short `long `real `month `date `minute `second `guid"
                },
                contains: [
                    e.C_LINE_COMMENT_MODE,
                    e.QUOTE_STRING_MODE,
                    e.C_NUMBER_MODE
                ]
            };
        }
        t.exports = n;
    }), Yt = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = {
                keyword: `in of on if for while finally var new function do return void else break catch instanceof with throw case default try this switch continue typeof delete let yield const export super debugger as async await import`,
                literal: `true false null undefined NaN Infinity`,
                built_in: `eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent encodeURI encodeURIComponent escape unescape Object Function Boolean Error EvalError InternalError RangeError ReferenceError StopIteration SyntaxError TypeError URIError Number Math Date String RegExp Array Float32Array Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require module console window document Symbol Set Map WeakSet WeakMap Proxy Reflect Behavior bool color coordinate date double enumeration font geocircle georectangle geoshape int list matrix4x4 parent point quaternion real rect size string url variant vector2d vector3d vector4d Promise`
            }, r = `[a-zA-Z_][a-zA-Z0-9\\._]*`, i = {
                className: `keyword`,
                begin: `\\bproperty\\b`,
                starts: {
                    className: `string`,
                    end: `(:|=|;|,|//|/\\*|$)`,
                    returnEnd: !0
                }
            }, a = {
                className: `keyword`,
                begin: `\\bsignal\\b`,
                starts: {
                    className: `string`,
                    end: `(\\(|:|=|;|,|//|/\\*|$)`,
                    returnEnd: !0
                }
            }, o = {
                className: `attribute`,
                begin: `\\bid\\s*:`,
                starts: {
                    className: `string`,
                    end: r,
                    returnEnd: !1
                }
            }, s = {
                begin: r + `\\s*:`,
                returnBegin: !0,
                contains: [
                    {
                        className: `attribute`,
                        begin: r,
                        end: `\\s*:`,
                        excludeEnd: !0,
                        relevance: 0
                    }
                ],
                relevance: 0
            }, c = {
                begin: t.concat(r, /\s*\{/),
                end: /\{/,
                returnBegin: !0,
                relevance: 0,
                contains: [
                    e.inherit(e.TITLE_MODE, {
                        begin: r
                    })
                ]
            };
            return {
                name: `QML`,
                aliases: [
                    `qt`
                ],
                case_insensitive: !1,
                keywords: n,
                contains: [
                    {
                        className: `meta`,
                        begin: /^\s*['"]use (strict|asm)['"]/
                    },
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE,
                    {
                        className: `string`,
                        begin: "`",
                        end: "`",
                        contains: [
                            e.BACKSLASH_ESCAPE,
                            {
                                className: `subst`,
                                begin: `\\$\\{`,
                                end: `\\}`
                            }
                        ]
                    },
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    {
                        className: `number`,
                        variants: [
                            {
                                begin: `\\b(0[bB][01]+)`
                            },
                            {
                                begin: `\\b(0[oO][0-7]+)`
                            },
                            {
                                begin: e.C_NUMBER_RE
                            }
                        ],
                        relevance: 0
                    },
                    {
                        begin: `(` + e.RE_STARTERS_RE + `|\\b(case|return|throw)\\b)\\s*`,
                        keywords: `return throw case`,
                        contains: [
                            e.C_LINE_COMMENT_MODE,
                            e.C_BLOCK_COMMENT_MODE,
                            e.REGEXP_MODE,
                            {
                                begin: /</,
                                end: />\s*[);\]]/,
                                relevance: 0,
                                subLanguage: `xml`
                            }
                        ],
                        relevance: 0
                    },
                    a,
                    i,
                    {
                        className: `function`,
                        beginKeywords: `function`,
                        end: /\{/,
                        excludeEnd: !0,
                        contains: [
                            e.inherit(e.TITLE_MODE, {
                                begin: /[A-Za-z$_][0-9A-Za-z$_]*/
                            }),
                            {
                                className: `params`,
                                begin: /\(/,
                                end: /\)/,
                                excludeBegin: !0,
                                excludeEnd: !0,
                                contains: [
                                    e.C_LINE_COMMENT_MODE,
                                    e.C_BLOCK_COMMENT_MODE
                                ]
                            }
                        ],
                        illegal: /\[|%/
                    },
                    {
                        begin: `\\.` + e.IDENT_RE,
                        relevance: 0
                    },
                    o,
                    s,
                    c
                ],
                illegal: /#/
            };
        }
        t.exports = n;
    }), Xt = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = /(?:(?:[a-zA-Z]|\.[._a-zA-Z])[._a-zA-Z0-9]*)|\.(?!\d)/, r = t.either(/0[xX][0-9a-fA-F]+\.[0-9a-fA-F]*[pP][+-]?\d+i?/, /0[xX][0-9a-fA-F]+(?:[pP][+-]?\d+)?[Li]?/, /(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?[Li]?/), i = /[=!<>:]=|\|\||&&|:::?|<-|<<-|->>|->|\|>|[-+*\/?!$&|:<=>@^~]|\*\*/, a = t.either(/[()]/, /[{}]/, /\[\[/, /[[\]]/, /\\/, /,/);
            return {
                name: `R`,
                keywords: {
                    $pattern: n,
                    keyword: `function if in break next repeat else for while`,
                    literal: `NULL NA TRUE FALSE Inf NaN NA_integer_|10 NA_real_|10 NA_character_|10 NA_complex_|10`,
                    built_in: `LETTERS letters month.abb month.name pi T F abs acos acosh all any anyNA Arg as.call as.character as.complex as.double as.environment as.integer as.logical as.null.default as.numeric as.raw asin asinh atan atanh attr attributes baseenv browser c call ceiling class Conj cos cosh cospi cummax cummin cumprod cumsum digamma dim dimnames emptyenv exp expression floor forceAndCall gamma gc.time globalenv Im interactive invisible is.array is.atomic is.call is.character is.complex is.double is.environment is.expression is.finite is.function is.infinite is.integer is.language is.list is.logical is.matrix is.na is.name is.nan is.null is.numeric is.object is.pairlist is.raw is.recursive is.single is.symbol lazyLoadDBfetch length lgamma list log max min missing Mod names nargs nzchar oldClass on.exit pos.to.env proc.time prod quote range Re rep retracemem return round seq_along seq_len seq.int sign signif sin sinh sinpi sqrt standardGeneric substitute sum switch tan tanh tanpi tracemem trigamma trunc unclass untracemem UseMethod xtfrm`
                },
                contains: [
                    e.COMMENT(/#'/, /$/, {
                        contains: [
                            {
                                scope: `doctag`,
                                match: /@examples/,
                                starts: {
                                    end: t.lookahead(t.either(/\n^#'\s*(?=@[a-zA-Z]+)/, /\n^(?!#')/)),
                                    endsParent: !0
                                }
                            },
                            {
                                scope: `doctag`,
                                begin: `@param`,
                                end: /$/,
                                contains: [
                                    {
                                        scope: `variable`,
                                        variants: [
                                            {
                                                match: n
                                            },
                                            {
                                                match: /`(?:\\.|[^`\\])+`/
                                            }
                                        ],
                                        endsParent: !0
                                    }
                                ]
                            },
                            {
                                scope: `doctag`,
                                match: /@[a-zA-Z]+/
                            },
                            {
                                scope: `keyword`,
                                match: /\\[a-zA-Z]+/
                            }
                        ]
                    }),
                    e.HASH_COMMENT_MODE,
                    {
                        scope: `string`,
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ],
                        variants: [
                            e.END_SAME_AS_BEGIN({
                                begin: /[rR]"(-*)\(/,
                                end: /\)(-*)"/
                            }),
                            e.END_SAME_AS_BEGIN({
                                begin: /[rR]"(-*)\{/,
                                end: /\}(-*)"/
                            }),
                            e.END_SAME_AS_BEGIN({
                                begin: /[rR]"(-*)\[/,
                                end: /\](-*)"/
                            }),
                            e.END_SAME_AS_BEGIN({
                                begin: /[rR]'(-*)\(/,
                                end: /\)(-*)'/
                            }),
                            e.END_SAME_AS_BEGIN({
                                begin: /[rR]'(-*)\{/,
                                end: /\}(-*)'/
                            }),
                            e.END_SAME_AS_BEGIN({
                                begin: /[rR]'(-*)\[/,
                                end: /\](-*)'/
                            }),
                            {
                                begin: `"`,
                                end: `"`,
                                relevance: 0
                            },
                            {
                                begin: `'`,
                                end: `'`,
                                relevance: 0
                            }
                        ]
                    },
                    {
                        relevance: 0,
                        variants: [
                            {
                                scope: {
                                    1: `operator`,
                                    2: `number`
                                },
                                match: [
                                    i,
                                    r
                                ]
                            },
                            {
                                scope: {
                                    1: `operator`,
                                    2: `number`
                                },
                                match: [
                                    /%[^%]*%/,
                                    r
                                ]
                            },
                            {
                                scope: {
                                    1: `punctuation`,
                                    2: `number`
                                },
                                match: [
                                    a,
                                    r
                                ]
                            },
                            {
                                scope: {
                                    2: `number`
                                },
                                match: [
                                    /[^a-zA-Z0-9._]|^/,
                                    r
                                ]
                            }
                        ]
                    },
                    {
                        scope: {
                            3: `operator`
                        },
                        match: [
                            n,
                            /\s+/,
                            /<-/,
                            /\s+/
                        ]
                    },
                    {
                        scope: `operator`,
                        relevance: 0,
                        variants: [
                            {
                                match: i
                            },
                            {
                                match: /%[^%]*%/
                            }
                        ]
                    },
                    {
                        scope: `punctuation`,
                        relevance: 0,
                        match: a
                    },
                    {
                        begin: "`",
                        end: "`",
                        contains: [
                            {
                                begin: /\\./
                            }
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), Zt = o((e, t)=>{
        function n(e) {
            return {
                name: `ReasonML`,
                aliases: [
                    `re`
                ],
                keywords: {
                    $pattern: /[a-z_]\w*!?/,
                    keyword: `and.as.asr.assert.begin.class.constraint.do.done.downto.else.end.esfun.exception.external.for.fun.function.functor.if.in.include.inherit.initializer.land.lazy.let.lor.lsl.lsr.lxor.mod.module.mutable.new.nonrec.object.of.open.or.pri.pub.rec.sig.struct.switch.then.to.try.type.val.virtual.when.while.with`.split(`.`),
                    built_in: [
                        `array`,
                        `bool`,
                        `bytes`,
                        `char`,
                        `exn|5`,
                        `float`,
                        `int`,
                        `int32`,
                        `int64`,
                        `list`,
                        `lazy_t|5`,
                        `nativeint|5`,
                        `ref`,
                        `string`,
                        `unit`
                    ],
                    literal: [
                        `true`,
                        `false`
                    ]
                },
                illegal: /(:-|:=|\$\{|\+=)/,
                contains: [
                    {
                        scope: `literal`,
                        match: /\[(\|\|)?\]|\(\)/,
                        relevance: 0
                    },
                    e.C_LINE_COMMENT_MODE,
                    e.COMMENT(/\/\*/, /\*\//, {
                        illegal: /^(#,\/\/)/
                    }),
                    {
                        scope: `symbol`,
                        match: /\'[A-Za-z_](?!\')[\w\']*/
                    },
                    {
                        scope: `type`,
                        match: /`[A-Z][\w\']*/
                    },
                    {
                        scope: `type`,
                        match: /\b[A-Z][\w\']*/,
                        relevance: 0
                    },
                    {
                        match: /[a-z_]\w*\'[\w\']*/,
                        relevance: 0
                    },
                    {
                        scope: `operator`,
                        match: /\s+(\|\||\+[\+\.]?|\*[\*\/\.]?|\/[\.]?|\.\.\.|\|>|&&|===?)\s+/,
                        relevance: 0
                    },
                    e.inherit(e.APOS_STRING_MODE, {
                        scope: `string`,
                        relevance: 0
                    }),
                    e.inherit(e.QUOTE_STRING_MODE, {
                        illegal: null
                    }),
                    {
                        scope: `number`,
                        variants: [
                            {
                                match: /\b0[xX][a-fA-F0-9_]+[Lln]?/
                            },
                            {
                                match: /\b0[oO][0-7_]+[Lln]?/
                            },
                            {
                                match: /\b0[bB][01_]+[Lln]?/
                            },
                            {
                                match: /\b[0-9][0-9_]*([Lln]|(\.[0-9_]*)?([eE][-+]?[0-9_]+)?)/
                            }
                        ],
                        relevance: 0
                    }
                ]
            };
        }
        t.exports = n;
    }), Qt = o((e, t)=>{
        function n(e) {
            return {
                name: `RenderMan RIB`,
                keywords: `ArchiveRecord AreaLightSource Atmosphere Attribute AttributeBegin AttributeEnd Basis Begin Blobby Bound Clipping ClippingPlane Color ColorSamples ConcatTransform Cone CoordinateSystem CoordSysTransform CropWindow Curves Cylinder DepthOfField Detail DetailRange Disk Displacement Display End ErrorHandler Exposure Exterior Format FrameAspectRatio FrameBegin FrameEnd GeneralPolygon GeometricApproximation Geometry Hider Hyperboloid Identity Illuminate Imager Interior LightSource MakeCubeFaceEnvironment MakeLatLongEnvironment MakeShadow MakeTexture Matte MotionBegin MotionEnd NuPatch ObjectBegin ObjectEnd ObjectInstance Opacity Option Orientation Paraboloid Patch PatchMesh Perspective PixelFilter PixelSamples PixelVariance Points PointsGeneralPolygons PointsPolygons Polygon Procedural Projection Quantize ReadArchive RelativeDetail ReverseOrientation Rotate Scale ScreenWindow ShadingInterpolation ShadingRate Shutter Sides Skew SolidBegin SolidEnd Sphere SubdivisionMesh Surface TextureCoordinates Torus Transform TransformBegin TransformEnd TransformPoints Translate TrimCurve WorldBegin WorldEnd`,
                illegal: `</`,
                contains: [
                    e.HASH_COMMENT_MODE,
                    e.C_NUMBER_MODE,
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE
                ]
            };
        }
        t.exports = n;
    }), $t = o((e, t)=>{
        function n(e) {
            let t = `[a-zA-Z-_][^\\n{]+\\{`, n = {
                className: `attribute`,
                begin: /[a-zA-Z-_]+/,
                end: /\s*:/,
                excludeEnd: !0,
                starts: {
                    end: `;`,
                    relevance: 0,
                    contains: [
                        {
                            className: `variable`,
                            begin: /\.[a-zA-Z-_]+/
                        },
                        {
                            className: `keyword`,
                            begin: /\(optional\)/
                        }
                    ]
                }
            };
            return {
                name: `Roboconf`,
                aliases: [
                    `graph`,
                    `instances`
                ],
                case_insensitive: !0,
                keywords: `import`,
                contains: [
                    {
                        begin: `^facet ` + t,
                        end: /\}/,
                        keywords: `facet`,
                        contains: [
                            n,
                            e.HASH_COMMENT_MODE
                        ]
                    },
                    {
                        begin: `^\\s*instance of ` + t,
                        end: /\}/,
                        keywords: `name count channels instance-data instance-state instance of`,
                        illegal: /\S/,
                        contains: [
                            `self`,
                            n,
                            e.HASH_COMMENT_MODE
                        ]
                    },
                    {
                        begin: `^` + t,
                        end: /\}/,
                        contains: [
                            n,
                            e.HASH_COMMENT_MODE
                        ]
                    },
                    e.HASH_COMMENT_MODE
                ]
            };
        }
        t.exports = n;
    }), en = o((e, t)=>{
        function n(e) {
            let t = `foreach do while for if from to step else on-error and or not in`, n = `true false yes no nothing nil null`, r = {
                className: `variable`,
                variants: [
                    {
                        begin: /\$[\w\d#@][\w\d_]*/
                    },
                    {
                        begin: /\$\{(.*?)\}/
                    }
                ]
            }, i = {
                className: `string`,
                begin: /"/,
                end: /"/,
                contains: [
                    e.BACKSLASH_ESCAPE,
                    r,
                    {
                        className: `variable`,
                        begin: /\$\(/,
                        end: /\)/,
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ]
                    }
                ]
            }, a = {
                className: `string`,
                begin: /'/,
                end: /'/
            };
            return {
                name: `MikroTik RouterOS script`,
                aliases: [
                    `mikrotik`
                ],
                case_insensitive: !0,
                keywords: {
                    $pattern: /:?[\w-]+/,
                    literal: n,
                    keyword: t + ` :` + t.split(` `).join(` :`) + ` :` + `global local beep delay put len typeof pick log time set find environment terminal error execute parse resolve toarray tobool toid toip toip6 tonum tostr totime`.split(` `).join(` :`)
                },
                contains: [
                    {
                        variants: [
                            {
                                begin: /\/\*/,
                                end: /\*\//
                            },
                            {
                                begin: /\/\//,
                                end: /$/
                            },
                            {
                                begin: /<\//,
                                end: />/
                            }
                        ],
                        illegal: /./
                    },
                    e.COMMENT(`^#`, `$`),
                    i,
                    a,
                    r,
                    {
                        begin: /[\w-]+=([^\s{}[\]()>]+)/,
                        relevance: 0,
                        returnBegin: !0,
                        contains: [
                            {
                                className: `attribute`,
                                begin: /[^=]+/
                            },
                            {
                                begin: /=/,
                                endsWithParent: !0,
                                relevance: 0,
                                contains: [
                                    i,
                                    a,
                                    r,
                                    {
                                        className: `literal`,
                                        begin: `\\b(` + n.split(` `).join(`|`) + `)\\b`
                                    },
                                    {
                                        begin: /("[^"]*"|[^\s{}[\]]+)/
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        className: `number`,
                        begin: /\*[0-9a-fA-F]+/
                    },
                    {
                        begin: `\\b(` + `add remove enable disable set get print export edit find run debug error info warning`.split(` `).join(`|`) + `)([\\s[(\\]|])`,
                        returnBegin: !0,
                        contains: [
                            {
                                className: `built_in`,
                                begin: /\w+/
                            }
                        ]
                    },
                    {
                        className: `built_in`,
                        variants: [
                            {
                                begin: `(\\.\\./|/|\\s)((` + `traffic-flow traffic-generator firewall scheduler aaa accounting address-list address align area bandwidth-server bfd bgp bridge client clock community config connection console customer default dhcp-client dhcp-server discovery dns e-mail ethernet filter firmware gps graphing group hardware health hotspot identity igmp-proxy incoming instance interface ip ipsec ipv6 irq l2tp-server lcd ldp logging mac-server mac-winbox mangle manual mirror mme mpls nat nd neighbor network note ntp ospf ospf-v3 ovpn-server page peer pim ping policy pool port ppp pppoe-client pptp-server prefix profile proposal proxy queue radius resource rip ripng route routing screen script security-profiles server service service-port settings shares smb sms sniffer snmp snooper socks sstp-server system tool tracking type upgrade upnp user-manager users user vlan secret vrrp watchdog web-access wireless pptp pppoe lan wan layer7-protocol lease simple raw`.split(` `).join(`|`) + `);?\\s)+`
                            },
                            {
                                begin: /\.\./,
                                relevance: 0
                            }
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), tn = o((e, t)=>{
        function n(e) {
            let t = `abs.acos.ambient.area.asin.atan.atmosphere.attribute.calculatenormal.ceil.cellnoise.clamp.comp.concat.cos.degrees.depth.Deriv.diffuse.distance.Du.Dv.environment.exp.faceforward.filterstep.floor.format.fresnel.incident.length.lightsource.log.match.max.min.mod.noise.normalize.ntransform.opposite.option.phong.pnoise.pow.printf.ptlined.radians.random.reflect.refract.renderinfo.round.setcomp.setxcomp.setycomp.setzcomp.shadow.sign.sin.smoothstep.specular.specularbrdf.spline.sqrt.step.tan.texture.textureinfo.trace.transform.vtransform.xcomp.ycomp.zcomp`.split(`.`), n = [
                `matrix`,
                `float`,
                `color`,
                `point`,
                `normal`,
                `vector`
            ], r = [
                `while`,
                `for`,
                `if`,
                `do`,
                `return`,
                `else`,
                `break`,
                `extern`,
                `continue`
            ], i = {
                match: [
                    /(surface|displacement|light|volume|imager)/,
                    /\s+/,
                    e.IDENT_RE
                ],
                scope: {
                    1: `keyword`,
                    3: `title.class`
                }
            };
            return {
                name: `RenderMan RSL`,
                keywords: {
                    keyword: r,
                    built_in: t,
                    type: n
                },
                illegal: `</`,
                contains: [
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    e.QUOTE_STRING_MODE,
                    e.APOS_STRING_MODE,
                    e.C_NUMBER_MODE,
                    {
                        className: `meta`,
                        begin: `#`,
                        end: `$`
                    },
                    i,
                    {
                        beginKeywords: `illuminate illuminance gather`,
                        end: `\\(`
                    }
                ]
            };
        }
        t.exports = n;
    }), nn = o((e, t)=>{
        function n(e) {
            return {
                name: `Oracle Rules Language`,
                keywords: {
                    keyword: `BILL_PERIOD BILL_START BILL_STOP RS_EFFECTIVE_START RS_EFFECTIVE_STOP RS_JURIS_CODE RS_OPCO_CODE INTDADDATTRIBUTE|5 INTDADDVMSG|5 INTDBLOCKOP|5 INTDBLOCKOPNA|5 INTDCLOSE|5 INTDCOUNT|5 INTDCOUNTSTATUSCODE|5 INTDCREATEMASK|5 INTDCREATEDAYMASK|5 INTDCREATEFACTORMASK|5 INTDCREATEHANDLE|5 INTDCREATEOVERRIDEDAYMASK|5 INTDCREATEOVERRIDEMASK|5 INTDCREATESTATUSCODEMASK|5 INTDCREATETOUPERIOD|5 INTDDELETE|5 INTDDIPTEST|5 INTDEXPORT|5 INTDGETERRORCODE|5 INTDGETERRORMESSAGE|5 INTDISEQUAL|5 INTDJOIN|5 INTDLOAD|5 INTDLOADACTUALCUT|5 INTDLOADDATES|5 INTDLOADHIST|5 INTDLOADLIST|5 INTDLOADLISTDATES|5 INTDLOADLISTENERGY|5 INTDLOADLISTHIST|5 INTDLOADRELATEDCHANNEL|5 INTDLOADSP|5 INTDLOADSTAGING|5 INTDLOADUOM|5 INTDLOADUOMDATES|5 INTDLOADUOMHIST|5 INTDLOADVERSION|5 INTDOPEN|5 INTDREADFIRST|5 INTDREADNEXT|5 INTDRECCOUNT|5 INTDRELEASE|5 INTDREPLACE|5 INTDROLLAVG|5 INTDROLLPEAK|5 INTDSCALAROP|5 INTDSCALE|5 INTDSETATTRIBUTE|5 INTDSETDSTPARTICIPANT|5 INTDSETSTRING|5 INTDSETVALUE|5 INTDSETVALUESTATUS|5 INTDSHIFTSTARTTIME|5 INTDSMOOTH|5 INTDSORT|5 INTDSPIKETEST|5 INTDSUBSET|5 INTDTOU|5 INTDTOURELEASE|5 INTDTOUVALUE|5 INTDUPDATESTATS|5 INTDVALUE|5 STDEV INTDDELETEEX|5 INTDLOADEXACTUAL|5 INTDLOADEXCUT|5 INTDLOADEXDATES|5 INTDLOADEX|5 INTDLOADEXRELATEDCHANNEL|5 INTDSAVEEX|5 MVLOAD|5 MVLOADACCT|5 MVLOADACCTDATES|5 MVLOADACCTHIST|5 MVLOADDATES|5 MVLOADHIST|5 MVLOADLIST|5 MVLOADLISTDATES|5 MVLOADLISTHIST|5 IF FOR NEXT DONE SELECT END CALL ABORT CLEAR CHANNEL FACTOR LIST NUMBER OVERRIDE SET WEEK DISTRIBUTIONNODE ELSE WHEN THEN OTHERWISE IENUM CSV INCLUDE LEAVE RIDER SAVE DELETE NOVALUE SECTION WARN SAVE_UPDATE DETERMINANT LABEL REPORT REVENUE EACH IN FROM TOTAL CHARGE BLOCK AND OR CSV_FILE RATE_CODE AUXILIARY_DEMAND UIDACCOUNT RS BILL_PERIOD_SELECT HOURS_PER_MONTH INTD_ERROR_STOP SEASON_SCHEDULE_NAME ACCOUNTFACTOR ARRAYUPPERBOUND CALLSTOREDPROC GETADOCONNECTION GETCONNECT GETDATASOURCE GETQUALIFIER GETUSERID HASVALUE LISTCOUNT LISTOP LISTUPDATE LISTVALUE PRORATEFACTOR RSPRORATE SETBINPATH SETDBMONITOR WQ_OPEN BILLINGHOURS DATE DATEFROMFLOAT DATETIMEFROMSTRING DATETIMETOSTRING DATETOFLOAT DAY DAYDIFF DAYNAME DBDATETIME HOUR MINUTE MONTH MONTHDIFF MONTHHOURS MONTHNAME ROUNDDATE SAMEWEEKDAYLASTYEAR SECOND WEEKDAY WEEKDIFF YEAR YEARDAY YEARSTR COMPSUM HISTCOUNT HISTMAX HISTMIN HISTMINNZ HISTVALUE MAXNRANGE MAXRANGE MINRANGE COMPIKVA COMPKVA COMPKVARFROMKQKW COMPLF IDATTR FLAG LF2KW LF2KWH MAXKW POWERFACTOR READING2USAGE AVGSEASON MAXSEASON MONTHLYMERGE SEASONVALUE SUMSEASON ACCTREADDATES ACCTTABLELOAD CONFIGADD CONFIGGET CREATEOBJECT CREATEREPORT EMAILCLIENT EXPBLKMDMUSAGE EXPMDMUSAGE EXPORT_USAGE FACTORINEFFECT GETUSERSPECIFIEDSTOP INEFFECT ISHOLIDAY RUNRATE SAVE_PROFILE SETREPORTTITLE USEREXIT WATFORRUNRATE TO TABLE ACOS ASIN ATAN ATAN2 BITAND CEIL COS COSECANT COSH COTANGENT DIVQUOT DIVREM EXP FABS FLOOR FMOD FREPM FREXPN LOG LOG10 MAX MAXN MIN MINNZ MODF POW ROUND ROUND2VALUE ROUNDINT SECANT SIN SINH SQROOT TAN TANH FLOAT2STRING FLOAT2STRINGNC INSTR LEFT LEN LTRIM MID RIGHT RTRIM STRING STRINGNC TOLOWER TOUPPER TRIM NUMDAYS READ_DATE STAGING`,
                    built_in: `IDENTIFIER OPTIONS XML_ELEMENT XML_OP XML_ELEMENT_OF DOMDOCCREATE DOMDOCLOADFILE DOMDOCLOADXML DOMDOCSAVEFILE DOMDOCGETROOT DOMDOCADDPI DOMNODEGETNAME DOMNODEGETTYPE DOMNODEGETVALUE DOMNODEGETCHILDCT DOMNODEGETFIRSTCHILD DOMNODEGETSIBLING DOMNODECREATECHILDELEMENT DOMNODESETATTRIBUTE DOMNODEGETCHILDELEMENTCT DOMNODEGETFIRSTCHILDELEMENT DOMNODEGETSIBLINGELEMENT DOMNODEGETATTRIBUTECT DOMNODEGETATTRIBUTEI DOMNODEGETATTRIBUTEBYNAME DOMNODEGETBYNAME`
                },
                contains: [
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE,
                    e.C_NUMBER_MODE,
                    {
                        className: `literal`,
                        variants: [
                            {
                                begin: `#\\s+`,
                                relevance: 0
                            },
                            {
                                begin: `#[a-zA-Z .]+`
                            }
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), rn = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = /(r#)?/, r = t.concat(n, e.UNDERSCORE_IDENT_RE), i = t.concat(n, e.IDENT_RE), a = {
                className: `title.function.invoke`,
                relevance: 0,
                begin: t.concat(/\b/, /(?!let|for|while|if|else|match\b)/, i, t.lookahead(/\s*\(/))
            }, o = `([ui](8|16|32|64|128|size)|f(32|64))?`, s = `abstract.as.async.await.become.box.break.const.continue.crate.do.dyn.else.enum.extern.false.final.fn.for.if.impl.in.let.loop.macro.match.mod.move.mut.override.priv.pub.ref.return.self.Self.static.struct.super.trait.true.try.type.typeof.union.unsafe.unsized.use.virtual.where.while.yield`.split(`.`), c = [
                `true`,
                `false`,
                `Some`,
                `None`,
                `Ok`,
                `Err`
            ], l = `drop .Copy.Send.Sized.Sync.Drop.Fn.FnMut.FnOnce.ToOwned.Clone.Debug.PartialEq.PartialOrd.Eq.Ord.AsRef.AsMut.Into.From.Default.Iterator.Extend.IntoIterator.DoubleEndedIterator.ExactSizeIterator.SliceConcatExt.ToString.assert!.assert_eq!.bitflags!.bytes!.cfg!.col!.concat!.concat_idents!.debug_assert!.debug_assert_eq!.env!.eprintln!.panic!.file!.format!.format_args!.include_bytes!.include_str!.line!.local_data_key!.module_path!.option_env!.print!.println!.select!.stringify!.try!.unimplemented!.unreachable!.vec!.write!.writeln!.macro_rules!.assert_ne!.debug_assert_ne!`.split(`.`), u = [
                `i8`,
                `i16`,
                `i32`,
                `i64`,
                `i128`,
                `isize`,
                `u8`,
                `u16`,
                `u32`,
                `u64`,
                `u128`,
                `usize`,
                `f32`,
                `f64`,
                `str`,
                `char`,
                `bool`,
                `Box`,
                `Option`,
                `Result`,
                `String`,
                `Vec`
            ];
            return {
                name: `Rust`,
                aliases: [
                    `rs`
                ],
                keywords: {
                    $pattern: e.IDENT_RE + `!?`,
                    type: u,
                    keyword: s,
                    literal: c,
                    built_in: l
                },
                illegal: `</`,
                contains: [
                    e.C_LINE_COMMENT_MODE,
                    e.COMMENT(`/\\*`, `\\*/`, {
                        contains: [
                            `self`
                        ]
                    }),
                    e.inherit(e.QUOTE_STRING_MODE, {
                        begin: /b?"/,
                        illegal: null
                    }),
                    {
                        className: `symbol`,
                        begin: /'[a-zA-Z_][a-zA-Z0-9_]*(?!')/
                    },
                    {
                        scope: `string`,
                        variants: [
                            {
                                begin: /b?r(#*)"(.|\n)*?"\1(?!#)/
                            },
                            {
                                begin: /b?'/,
                                end: /'/,
                                contains: [
                                    {
                                        scope: `char.escape`,
                                        match: /\\('|\w|x\w{2}|u\w{4}|U\w{8})/
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        className: `number`,
                        variants: [
                            {
                                begin: `\\b0b([01_]+)` + o
                            },
                            {
                                begin: `\\b0o([0-7_]+)` + o
                            },
                            {
                                begin: `\\b0x([A-Fa-f0-9_]+)` + o
                            },
                            {
                                begin: `\\b(\\d[\\d_]*(\\.[0-9_]+)?([eE][+-]?[0-9_]+)?)` + o
                            }
                        ],
                        relevance: 0
                    },
                    {
                        begin: [
                            /fn/,
                            /\s+/,
                            r
                        ],
                        className: {
                            1: `keyword`,
                            3: `title.function`
                        }
                    },
                    {
                        className: `meta`,
                        begin: `#!?\\[`,
                        end: `\\]`,
                        contains: [
                            {
                                className: `string`,
                                begin: /"/,
                                end: /"/,
                                contains: [
                                    e.BACKSLASH_ESCAPE
                                ]
                            }
                        ]
                    },
                    {
                        begin: [
                            /let/,
                            /\s+/,
                            /(?:mut\s+)?/,
                            r
                        ],
                        className: {
                            1: `keyword`,
                            3: `keyword`,
                            4: `variable`
                        }
                    },
                    {
                        begin: [
                            /for/,
                            /\s+/,
                            r,
                            /\s+/,
                            /in/
                        ],
                        className: {
                            1: `keyword`,
                            3: `variable`,
                            5: `keyword`
                        }
                    },
                    {
                        begin: [
                            /type/,
                            /\s+/,
                            r
                        ],
                        className: {
                            1: `keyword`,
                            3: `title.class`
                        }
                    },
                    {
                        begin: [
                            /(?:trait|enum|struct|union|impl|for)/,
                            /\s+/,
                            r
                        ],
                        className: {
                            1: `keyword`,
                            3: `title.class`
                        }
                    },
                    {
                        begin: e.IDENT_RE + `::`,
                        keywords: {
                            keyword: `Self`,
                            built_in: l,
                            type: u
                        }
                    },
                    {
                        className: `punctuation`,
                        begin: `->`
                    },
                    a
                ]
            };
        }
        t.exports = n;
    }), an = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = `do.if.then.else.end.until.while.abort.array.attrib.by.call.cards.cards4.catname.continue.datalines.datalines4.delete.delim.delimiter.display.dm.drop.endsas.error.file.filename.footnote.format.goto.in.infile.informat.input.keep.label.leave.length.libname.link.list.lostcard.merge.missing.modify.options.output.out.page.put.redirect.remove.rename.replace.retain.return.select.set.skip.startsas.stop.title.update.waitsas.where.window.x|0.systask.add.and.alter.as.cascade.check.create.delete.describe.distinct.drop.foreign.from.group.having.index.insert.into.in.key.like.message.modify.msgtype.not.null.on.or.order.primary.references.reset.restrict.select.set.table.unique.update.validate.view.where`.split(`.`), r = `abs.addr.airy.arcos.arsin.atan.attrc.attrn.band.betainv.blshift.bnot.bor.brshift.bxor.byte.cdf.ceil.cexist.cinv.close.cnonct.collate.compbl.compound.compress.cos.cosh.css.curobs.cv.daccdb.daccdbsl.daccsl.daccsyd.dacctab.dairy.date.datejul.datepart.datetime.day.dclose.depdb.depdbsl.depdbsl.depsl.depsl.depsyd.depsyd.deptab.deptab.dequote.dhms.dif.digamma.dim.dinfo.dnum.dopen.doptname.doptnum.dread.dropnote.dsname.erf.erfc.exist.exp.fappend.fclose.fcol.fdelete.fetch.fetchobs.fexist.fget.fileexist.filename.fileref.finfo.finv.fipname.fipnamel.fipstate.floor.fnonct.fnote.fopen.foptname.foptnum.fpoint.fpos.fput.fread.frewind.frlen.fsep.fuzz.fwrite.gaminv.gamma.getoption.getvarc.getvarn.hbound.hms.hosthelp.hour.ibessel.index.indexc.indexw.input.inputc.inputn.int.intck.intnx.intrr.irr.jbessel.juldate.kurtosis.lag.lbound.left.length.lgamma.libname.libref.log.log10.log2.logpdf.logpmf.logsdf.lowcase.max.mdy.mean.min.minute.mod.month.mopen.mort.n.netpv.nmiss.normal.note.npv.open.ordinal.pathname.pdf.peek.peekc.pmf.point.poisson.poke.probbeta.probbnml.probchi.probf.probgam.probhypr.probit.probnegb.probnorm.probt.put.putc.putn.qtr.quote.ranbin.rancau.ranexp.rangam.range.rank.rannor.ranpoi.rantbl.rantri.ranuni.repeat.resolve.reverse.rewind.right.round.saving.scan.sdf.second.sign.sin.sinh.skewness.soundex.spedis.sqrt.std.stderr.stfips.stname.stnamel.substr.sum.symget.sysget.sysmsg.sysprod.sysrc.system.tan.tanh.time.timepart.tinv.tnonct.today.translate.tranwrd.trigamma.trim.trimn.trunc.uniform.upcase.uss.var.varfmt.varinfmt.varlabel.varlen.varname.varnum.varray.varrayx.vartype.verify.vformat.vformatd.vformatdx.vformatn.vformatnx.vformatw.vformatwx.vformatx.vinarray.vinarrayx.vinformat.vinformatd.vinformatdx.vinformatn.vinformatnx.vinformatw.vinformatwx.vinformatx.vlabel.vlabelx.vlength.vlengthx.vname.vnamex.vtype.vtypex.weekday.year.yyq.zipfips.zipname.zipnamel.zipstate`.split(`.`);
            return {
                name: `SAS`,
                case_insensitive: !0,
                keywords: {
                    literal: [
                        `null`,
                        `missing`,
                        `_all_`,
                        `_automatic_`,
                        `_character_`,
                        `_infile_`,
                        `_n_`,
                        `_name_`,
                        `_null_`,
                        `_numeric_`,
                        `_user_`,
                        `_webout_`
                    ],
                    keyword: n
                },
                contains: [
                    {
                        className: `keyword`,
                        begin: /^\s*(proc [\w\d_]+|data|run|quit)[\s;]/
                    },
                    {
                        className: `variable`,
                        begin: /&[a-zA-Z_&][a-zA-Z0-9_]*\.?/
                    },
                    {
                        begin: [
                            /^\s*/,
                            /datalines;|cards;/,
                            /(?:.*\n)+/,
                            /^\s*;\s*$/
                        ],
                        className: {
                            2: `keyword`,
                            3: `string`
                        }
                    },
                    {
                        begin: [
                            /%mend|%macro/,
                            /\s+/,
                            /[a-zA-Z_&][a-zA-Z0-9_]*/
                        ],
                        className: {
                            1: `built_in`,
                            3: `title.function`
                        }
                    },
                    {
                        className: `built_in`,
                        begin: `%` + t.either(...`bquote.nrbquote.cmpres.qcmpres.compstor.datatyp.display.do.else.end.eval.global.goto.if.index.input.keydef.label.left.length.let.local.lowcase.macro.mend.nrbquote.nrquote.nrstr.put.qcmpres.qleft.qlowcase.qscan.qsubstr.qsysfunc.qtrim.quote.qupcase.scan.str.substr.superq.syscall.sysevalf.sysexec.sysfunc.sysget.syslput.sysprod.sysrc.sysrput.then.to.trim.unquote.until.upcase.verify.while.window`.split(`.`))
                    },
                    {
                        className: `title.function`,
                        begin: /%[a-zA-Z_][a-zA-Z_0-9]*/
                    },
                    {
                        className: `meta`,
                        begin: t.either(...r) + `(?=\\()`
                    },
                    {
                        className: `string`,
                        variants: [
                            e.APOS_STRING_MODE,
                            e.QUOTE_STRING_MODE
                        ]
                    },
                    e.COMMENT(`\\*`, `;`),
                    e.C_BLOCK_COMMENT_MODE
                ]
            };
        }
        t.exports = n;
    }), on = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = {
                className: `meta`,
                begin: `@[A-Za-z]+`
            }, r = {
                className: `subst`,
                variants: [
                    {
                        begin: `\\$[A-Za-z0-9_]+`
                    },
                    {
                        begin: /\$\{/,
                        end: /\}/
                    }
                ]
            }, i = {
                className: `string`,
                variants: [
                    {
                        begin: `"""`,
                        end: `"""`
                    },
                    {
                        begin: `"`,
                        end: `"`,
                        illegal: `\\n`,
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ]
                    },
                    {
                        begin: `[a-z]+"`,
                        end: `"`,
                        illegal: `\\n`,
                        contains: [
                            e.BACKSLASH_ESCAPE,
                            r
                        ]
                    },
                    {
                        className: `string`,
                        begin: `[a-z]+"""`,
                        end: `"""`,
                        contains: [
                            r
                        ],
                        relevance: 10
                    }
                ]
            }, a = {
                className: `type`,
                begin: `\\b[A-Z][A-Za-z0-9_]*`,
                relevance: 0
            }, o = {
                className: `title`,
                begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/,
                relevance: 0
            }, s = {
                className: `class`,
                beginKeywords: `class object trait type`,
                end: /[:={\[\n;]/,
                excludeEnd: !0,
                contains: [
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    {
                        beginKeywords: `extends with`,
                        relevance: 10
                    },
                    {
                        begin: /\[/,
                        end: /\]/,
                        excludeBegin: !0,
                        excludeEnd: !0,
                        relevance: 0,
                        contains: [
                            a,
                            e.C_LINE_COMMENT_MODE,
                            e.C_BLOCK_COMMENT_MODE
                        ]
                    },
                    {
                        className: `params`,
                        begin: /\(/,
                        end: /\)/,
                        excludeBegin: !0,
                        excludeEnd: !0,
                        relevance: 0,
                        contains: [
                            a,
                            e.C_LINE_COMMENT_MODE,
                            e.C_BLOCK_COMMENT_MODE
                        ]
                    },
                    o
                ]
            }, c = {
                className: `function`,
                beginKeywords: `def`,
                end: t.lookahead(/[:={\[(\n;]/),
                contains: [
                    o
                ]
            }, l = {
                begin: [
                    /^\s*/,
                    `extension`,
                    /\s+(?=[[(])/
                ],
                beginScope: {
                    2: `keyword`
                }
            }, u = {
                begin: [
                    /^\s*/,
                    /end/,
                    /\s+/,
                    /(extension\b)?/
                ],
                beginScope: {
                    2: `keyword`,
                    4: `keyword`
                }
            }, d = [
                {
                    match: /\.inline\b/
                },
                {
                    begin: /\binline(?=\s)/,
                    keywords: `inline`
                }
            ], f = {
                begin: [
                    /\(\s*/,
                    /using/,
                    /\s+(?!\))/
                ],
                beginScope: {
                    2: `keyword`
                }
            };
            return {
                name: `Scala`,
                keywords: {
                    literal: `true false null`,
                    keyword: `type yield lazy override def with val var sealed abstract private trait object if then forSome for while do throw finally protected extends import final return else break new catch super class case package default try this match continue throws implicit export enum given transparent`
                },
                contains: [
                    {
                        begin: [
                            `//>`,
                            /\s+/,
                            /using/,
                            /\s+/,
                            /\S+/
                        ],
                        beginScope: {
                            1: `comment`,
                            3: `keyword`,
                            5: `type`
                        },
                        end: /$/,
                        contains: [
                            {
                                className: `string`,
                                begin: /\S+/
                            }
                        ]
                    },
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    i,
                    a,
                    c,
                    s,
                    e.C_NUMBER_MODE,
                    l,
                    u,
                    ...d,
                    f,
                    n
                ]
            };
        }
        t.exports = n;
    }), sn = o((e, t)=>{
        function n(e) {
            let t = `[^\\(\\)\\[\\]\\{\\}",'\`;#|\\\\\\s]+`, n = `(-|\\+)?\\d+([./]\\d+)?`;
            n;
            let r = {
                $pattern: t,
                built_in: "case-lambda call/cc class define-class exit-handler field import inherit init-field interface let*-values let-values let/ec mixin opt-lambda override protect provide public rename require require-for-syntax syntax syntax-case syntax-error unit/sig unless when with-syntax and begin call-with-current-continuation call-with-input-file call-with-output-file case cond define define-syntax delay do dynamic-wind else for-each if lambda let let* let-syntax letrec letrec-syntax map or syntax-rules ' * + , ,@ - ... / ; < <= = => > >= ` abs acos angle append apply asin assoc assq assv atan boolean? caar cadr call-with-input-file call-with-output-file call-with-values car cdddar cddddr cdr ceiling char->integer char-alphabetic? char-ci<=? char-ci<? char-ci=? char-ci>=? char-ci>? char-downcase char-lower-case? char-numeric? char-ready? char-upcase char-upper-case? char-whitespace? char<=? char<? char=? char>=? char>? char? close-input-port close-output-port complex? cons cos current-input-port current-output-port denominator display eof-object? eq? equal? eqv? eval even? exact->inexact exact? exp expt floor force gcd imag-part inexact->exact inexact? input-port? integer->char integer? interaction-environment lcm length list list->string list->vector list-ref list-tail list? load log magnitude make-polar make-rectangular make-string make-vector max member memq memv min modulo negative? newline not null-environment null? number->string number? numerator odd? open-input-file open-output-file output-port? pair? peek-char port? positive? procedure? quasiquote quote quotient rational? rationalize read read-char real-part real? remainder reverse round scheme-report-environment set! set-car! set-cdr! sin sqrt string string->list string->number string->symbol string-append string-ci<=? string-ci<? string-ci=? string-ci>=? string-ci>? string-copy string-fill! string-length string-ref string-set! string<=? string<? string=? string>=? string>? string? substring symbol->string symbol? tan transcript-off transcript-on truncate values vector vector->list vector-fill! vector-length vector-ref vector-set! with-input-from-file with-output-to-file write write-char zero?"
            }, i = {
                className: `literal`,
                begin: `(#t|#f|#\\\\` + t + `|#\\\\.)`
            }, a = {
                className: `number`,
                variants: [
                    {
                        begin: n,
                        relevance: 0
                    },
                    {
                        begin: `(-|\\+)?\\d+([./]\\d+)?[+\\-](-|\\+)?\\d+([./]\\d+)?i`,
                        relevance: 0
                    },
                    {
                        begin: `#b[0-1]+(/[0-1]+)?`
                    },
                    {
                        begin: `#o[0-7]+(/[0-7]+)?`
                    },
                    {
                        begin: `#x[0-9a-f]+(/[0-9a-f]+)?`
                    }
                ]
            }, o = e.QUOTE_STRING_MODE, s = [
                e.COMMENT(`;`, `$`, {
                    relevance: 0
                }),
                e.COMMENT(`#\\|`, `\\|#`)
            ], c = {
                begin: t,
                relevance: 0
            }, l = {
                className: `symbol`,
                begin: `'` + t
            }, u = {
                endsWithParent: !0,
                relevance: 0
            }, d = {
                variants: [
                    {
                        begin: /'/
                    },
                    {
                        begin: "`"
                    }
                ],
                contains: [
                    {
                        begin: `\\(`,
                        end: `\\)`,
                        contains: [
                            `self`,
                            i,
                            o,
                            a,
                            c,
                            l
                        ]
                    }
                ]
            }, f = {
                className: `name`,
                relevance: 0,
                begin: t,
                keywords: r
            }, p = {
                variants: [
                    {
                        begin: `\\(`,
                        end: `\\)`
                    },
                    {
                        begin: `\\[`,
                        end: `\\]`
                    }
                ],
                contains: [
                    {
                        begin: /lambda/,
                        endsWithParent: !0,
                        returnBegin: !0,
                        contains: [
                            f,
                            {
                                endsParent: !0,
                                variants: [
                                    {
                                        begin: /\(/,
                                        end: /\)/
                                    },
                                    {
                                        begin: /\[/,
                                        end: /\]/
                                    }
                                ],
                                contains: [
                                    c
                                ]
                            }
                        ]
                    },
                    f,
                    u
                ]
            };
            return u.contains = [
                i,
                a,
                o,
                c,
                l,
                d,
                p
            ].concat(s), {
                name: `Scheme`,
                aliases: [
                    `scm`
                ],
                illegal: /\S/,
                contains: [
                    e.SHEBANG(),
                    a,
                    o,
                    l,
                    d,
                    p
                ].concat(s)
            };
        }
        t.exports = n;
    }), cn = o((e, t)=>{
        function n(e) {
            let t = [
                e.C_NUMBER_MODE,
                {
                    className: `string`,
                    begin: `'|"`,
                    end: `'|"`,
                    contains: [
                        e.BACKSLASH_ESCAPE,
                        {
                            begin: `''`
                        }
                    ]
                }
            ];
            return {
                name: `Scilab`,
                aliases: [
                    `sci`
                ],
                keywords: {
                    $pattern: /%?\w+/,
                    keyword: `abort break case clear catch continue do elseif else endfunction end for function global if pause return resume select try then while`,
                    literal: `%f %F %t %T %pi %eps %inf %nan %e %i %z %s`,
                    built_in: `abs and acos asin atan ceil cd chdir clearglobal cosh cos cumprod deff disp error exec execstr exists exp eye gettext floor fprintf fread fsolve imag isdef isempty isinfisnan isvector lasterror length load linspace list listfiles log10 log2 log max min msprintf mclose mopen ones or pathconvert poly printf prod pwd rand real round sinh sin size gsort sprintf sqrt strcat strcmps tring sum system tanh tan type typename warning zeros matrix`
                },
                illegal: `("|#|/\\*|\\s+/\\w+)`,
                contains: [
                    {
                        className: `function`,
                        beginKeywords: `function`,
                        end: `$`,
                        contains: [
                            e.UNDERSCORE_TITLE_MODE,
                            {
                                className: `params`,
                                begin: `\\(`,
                                end: `\\)`
                            }
                        ]
                    },
                    {
                        begin: `[a-zA-Z_][a-zA-Z_0-9]*[\\.']+`,
                        relevance: 0
                    },
                    {
                        begin: `\\[`,
                        end: `\\][\\.']*`,
                        relevance: 0,
                        contains: t
                    },
                    e.COMMENT(`//`, `$`)
                ].concat(t)
            };
        }
        t.exports = n;
    }), ln = o((e, t)=>{
        var n = (e)=>({
                IMPORTANT: {
                    scope: `meta`,
                    begin: `!important`
                },
                BLOCK_COMMENT: e.C_BLOCK_COMMENT_MODE,
                HEXCOLOR: {
                    scope: `number`,
                    begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/
                },
                FUNCTION_DISPATCH: {
                    className: `built_in`,
                    begin: /[\w-]+(?=\()/
                },
                ATTRIBUTE_SELECTOR_MODE: {
                    scope: `selector-attr`,
                    begin: /\[/,
                    end: /\]/,
                    illegal: `$`,
                    contains: [
                        e.APOS_STRING_MODE,
                        e.QUOTE_STRING_MODE
                    ]
                },
                CSS_NUMBER_MODE: {
                    scope: `number`,
                    begin: e.NUMBER_RE + `(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?`,
                    relevance: 0
                },
                CSS_VARIABLE: {
                    className: `attr`,
                    begin: /--[A-Za-z_][A-Za-z0-9_-]*/
                }
            }), r = `a.abbr.address.article.aside.audio.b.blockquote.body.button.canvas.caption.cite.code.dd.del.details.dfn.div.dl.dt.em.fieldset.figcaption.figure.footer.form.h1.h2.h3.h4.h5.h6.header.hgroup.html.i.iframe.img.input.ins.kbd.label.legend.li.main.mark.menu.nav.object.ol.optgroup.option.p.picture.q.quote.samp.section.select.source.span.strong.summary.sup.table.tbody.td.textarea.tfoot.th.thead.time.tr.ul.var.video`.split(`.`), i = `defs.g.marker.mask.pattern.svg.switch.symbol.feBlend.feColorMatrix.feComponentTransfer.feComposite.feConvolveMatrix.feDiffuseLighting.feDisplacementMap.feFlood.feGaussianBlur.feImage.feMerge.feMorphology.feOffset.feSpecularLighting.feTile.feTurbulence.linearGradient.radialGradient.stop.circle.ellipse.image.line.path.polygon.polyline.rect.text.use.textPath.tspan.foreignObject.clipPath`.split(`.`), a = [
            ...r,
            ...i
        ], o = `any-hover.any-pointer.aspect-ratio.color.color-gamut.color-index.device-aspect-ratio.device-height.device-width.display-mode.forced-colors.grid.height.hover.inverted-colors.monochrome.orientation.overflow-block.overflow-inline.pointer.prefers-color-scheme.prefers-contrast.prefers-reduced-motion.prefers-reduced-transparency.resolution.scan.scripting.update.width.min-width.max-width.min-height.max-height`.split(`.`).sort().reverse(), s = `active.any-link.blank.checked.current.default.defined.dir.disabled.drop.empty.enabled.first.first-child.first-of-type.fullscreen.future.focus.focus-visible.focus-within.has.host.host-context.hover.indeterminate.in-range.invalid.is.lang.last-child.last-of-type.left.link.local-link.not.nth-child.nth-col.nth-last-child.nth-last-col.nth-last-of-type.nth-of-type.only-child.only-of-type.optional.out-of-range.past.placeholder-shown.read-only.read-write.required.right.root.scope.target.target-within.user-invalid.valid.visited.where`.split(`.`).sort().reverse(), c = [
            `after`,
            `backdrop`,
            `before`,
            `cue`,
            `cue-region`,
            `first-letter`,
            `first-line`,
            `grammar-error`,
            `marker`,
            `part`,
            `placeholder`,
            `selection`,
            `slotted`,
            `spelling-error`
        ].sort().reverse(), l = `accent-color.align-content.align-items.align-self.alignment-baseline.all.anchor-name.animation.animation-composition.animation-delay.animation-direction.animation-duration.animation-fill-mode.animation-iteration-count.animation-name.animation-play-state.animation-range.animation-range-end.animation-range-start.animation-timeline.animation-timing-function.appearance.aspect-ratio.backdrop-filter.backface-visibility.background.background-attachment.background-blend-mode.background-clip.background-color.background-image.background-origin.background-position.background-position-x.background-position-y.background-repeat.background-size.baseline-shift.block-size.border.border-block.border-block-color.border-block-end.border-block-end-color.border-block-end-style.border-block-end-width.border-block-start.border-block-start-color.border-block-start-style.border-block-start-width.border-block-style.border-block-width.border-bottom.border-bottom-color.border-bottom-left-radius.border-bottom-right-radius.border-bottom-style.border-bottom-width.border-collapse.border-color.border-end-end-radius.border-end-start-radius.border-image.border-image-outset.border-image-repeat.border-image-slice.border-image-source.border-image-width.border-inline.border-inline-color.border-inline-end.border-inline-end-color.border-inline-end-style.border-inline-end-width.border-inline-start.border-inline-start-color.border-inline-start-style.border-inline-start-width.border-inline-style.border-inline-width.border-left.border-left-color.border-left-style.border-left-width.border-radius.border-right.border-right-color.border-right-style.border-right-width.border-spacing.border-start-end-radius.border-start-start-radius.border-style.border-top.border-top-color.border-top-left-radius.border-top-right-radius.border-top-style.border-top-width.border-width.bottom.box-align.box-decoration-break.box-direction.box-flex.box-flex-group.box-lines.box-ordinal-group.box-orient.box-pack.box-shadow.box-sizing.break-after.break-before.break-inside.caption-side.caret-color.clear.clip.clip-path.clip-rule.color.color-interpolation.color-interpolation-filters.color-profile.color-rendering.color-scheme.column-count.column-fill.column-gap.column-rule.column-rule-color.column-rule-style.column-rule-width.column-span.column-width.columns.contain.contain-intrinsic-block-size.contain-intrinsic-height.contain-intrinsic-inline-size.contain-intrinsic-size.contain-intrinsic-width.container.container-name.container-type.content.content-visibility.counter-increment.counter-reset.counter-set.cue.cue-after.cue-before.cursor.cx.cy.direction.display.dominant-baseline.empty-cells.enable-background.field-sizing.fill.fill-opacity.fill-rule.filter.flex.flex-basis.flex-direction.flex-flow.flex-grow.flex-shrink.flex-wrap.float.flood-color.flood-opacity.flow.font.font-display.font-family.font-feature-settings.font-kerning.font-language-override.font-optical-sizing.font-palette.font-size.font-size-adjust.font-smooth.font-smoothing.font-stretch.font-style.font-synthesis.font-synthesis-position.font-synthesis-small-caps.font-synthesis-style.font-synthesis-weight.font-variant.font-variant-alternates.font-variant-caps.font-variant-east-asian.font-variant-emoji.font-variant-ligatures.font-variant-numeric.font-variant-position.font-variation-settings.font-weight.forced-color-adjust.gap.glyph-orientation-horizontal.glyph-orientation-vertical.grid.grid-area.grid-auto-columns.grid-auto-flow.grid-auto-rows.grid-column.grid-column-end.grid-column-start.grid-gap.grid-row.grid-row-end.grid-row-start.grid-template.grid-template-areas.grid-template-columns.grid-template-rows.hanging-punctuation.height.hyphenate-character.hyphenate-limit-chars.hyphens.icon.image-orientation.image-rendering.image-resolution.ime-mode.initial-letter.initial-letter-align.inline-size.inset.inset-area.inset-block.inset-block-end.inset-block-start.inset-inline.inset-inline-end.inset-inline-start.isolation.justify-content.justify-items.justify-self.kerning.left.letter-spacing.lighting-color.line-break.line-height.line-height-step.list-style.list-style-image.list-style-position.list-style-type.margin.margin-block.margin-block-end.margin-block-start.margin-bottom.margin-inline.margin-inline-end.margin-inline-start.margin-left.margin-right.margin-top.margin-trim.marker.marker-end.marker-mid.marker-start.marks.mask.mask-border.mask-border-mode.mask-border-outset.mask-border-repeat.mask-border-slice.mask-border-source.mask-border-width.mask-clip.mask-composite.mask-image.mask-mode.mask-origin.mask-position.mask-repeat.mask-size.mask-type.masonry-auto-flow.math-depth.math-shift.math-style.max-block-size.max-height.max-inline-size.max-width.min-block-size.min-height.min-inline-size.min-width.mix-blend-mode.nav-down.nav-index.nav-left.nav-right.nav-up.none.normal.object-fit.object-position.offset.offset-anchor.offset-distance.offset-path.offset-position.offset-rotate.opacity.order.orphans.outline.outline-color.outline-offset.outline-style.outline-width.overflow.overflow-anchor.overflow-block.overflow-clip-margin.overflow-inline.overflow-wrap.overflow-x.overflow-y.overlay.overscroll-behavior.overscroll-behavior-block.overscroll-behavior-inline.overscroll-behavior-x.overscroll-behavior-y.padding.padding-block.padding-block-end.padding-block-start.padding-bottom.padding-inline.padding-inline-end.padding-inline-start.padding-left.padding-right.padding-top.page.page-break-after.page-break-before.page-break-inside.paint-order.pause.pause-after.pause-before.perspective.perspective-origin.place-content.place-items.place-self.pointer-events.position.position-anchor.position-visibility.print-color-adjust.quotes.r.resize.rest.rest-after.rest-before.right.rotate.row-gap.ruby-align.ruby-position.scale.scroll-behavior.scroll-margin.scroll-margin-block.scroll-margin-block-end.scroll-margin-block-start.scroll-margin-bottom.scroll-margin-inline.scroll-margin-inline-end.scroll-margin-inline-start.scroll-margin-left.scroll-margin-right.scroll-margin-top.scroll-padding.scroll-padding-block.scroll-padding-block-end.scroll-padding-block-start.scroll-padding-bottom.scroll-padding-inline.scroll-padding-inline-end.scroll-padding-inline-start.scroll-padding-left.scroll-padding-right.scroll-padding-top.scroll-snap-align.scroll-snap-stop.scroll-snap-type.scroll-timeline.scroll-timeline-axis.scroll-timeline-name.scrollbar-color.scrollbar-gutter.scrollbar-width.shape-image-threshold.shape-margin.shape-outside.shape-rendering.speak.speak-as.src.stop-color.stop-opacity.stroke.stroke-dasharray.stroke-dashoffset.stroke-linecap.stroke-linejoin.stroke-miterlimit.stroke-opacity.stroke-width.tab-size.table-layout.text-align.text-align-all.text-align-last.text-anchor.text-combine-upright.text-decoration.text-decoration-color.text-decoration-line.text-decoration-skip.text-decoration-skip-ink.text-decoration-style.text-decoration-thickness.text-emphasis.text-emphasis-color.text-emphasis-position.text-emphasis-style.text-indent.text-justify.text-orientation.text-overflow.text-rendering.text-shadow.text-size-adjust.text-transform.text-underline-offset.text-underline-position.text-wrap.text-wrap-mode.text-wrap-style.timeline-scope.top.touch-action.transform.transform-box.transform-origin.transform-style.transition.transition-behavior.transition-delay.transition-duration.transition-property.transition-timing-function.translate.unicode-bidi.user-modify.user-select.vector-effect.vertical-align.view-timeline.view-timeline-axis.view-timeline-inset.view-timeline-name.view-transition-name.visibility.voice-balance.voice-duration.voice-family.voice-pitch.voice-range.voice-rate.voice-stress.voice-volume.white-space.white-space-collapse.widows.width.will-change.word-break.word-spacing.word-wrap.writing-mode.x.y.z-index.zoom`.split(`.`).sort().reverse();
        function u(e) {
            let t = n(e), r = c, i = s, u = `@[a-z-]+`, d = {
                className: `variable`,
                begin: `(\\$[a-zA-Z-][a-zA-Z0-9_-]*)\\b`,
                relevance: 0
            };
            return {
                name: `SCSS`,
                case_insensitive: !0,
                illegal: `[=/|']`,
                contains: [
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    t.CSS_NUMBER_MODE,
                    {
                        className: `selector-id`,
                        begin: `#[A-Za-z0-9_-]+`,
                        relevance: 0
                    },
                    {
                        className: `selector-class`,
                        begin: `\\.[A-Za-z0-9_-]+`,
                        relevance: 0
                    },
                    t.ATTRIBUTE_SELECTOR_MODE,
                    {
                        className: `selector-tag`,
                        begin: `\\b(` + a.join(`|`) + `)\\b`,
                        relevance: 0
                    },
                    {
                        className: `selector-pseudo`,
                        begin: `:(` + i.join(`|`) + `)`
                    },
                    {
                        className: `selector-pseudo`,
                        begin: `:(:)?(` + r.join(`|`) + `)`
                    },
                    d,
                    {
                        begin: /\(/,
                        end: /\)/,
                        contains: [
                            t.CSS_NUMBER_MODE
                        ]
                    },
                    t.CSS_VARIABLE,
                    {
                        className: `attribute`,
                        begin: `\\b(` + l.join(`|`) + `)\\b`
                    },
                    {
                        begin: `\\b(whitespace|wait|w-resize|visible|vertical-text|vertical-ideographic|uppercase|upper-roman|upper-alpha|underline|transparent|top|thin|thick|text|text-top|text-bottom|tb-rl|table-header-group|table-footer-group|sw-resize|super|strict|static|square|solid|small-caps|separate|se-resize|scroll|s-resize|rtl|row-resize|ridge|right|repeat|repeat-y|repeat-x|relative|progress|pointer|overline|outside|outset|oblique|nowrap|not-allowed|normal|none|nw-resize|no-repeat|no-drop|newspaper|ne-resize|n-resize|move|middle|medium|ltr|lr-tb|lowercase|lower-roman|lower-alpha|loose|list-item|line|line-through|line-edge|lighter|left|keep-all|justify|italic|inter-word|inter-ideograph|inside|inset|inline|inline-block|inherit|inactive|ideograph-space|ideograph-parenthesis|ideograph-numeric|ideograph-alpha|horizontal|hidden|help|hand|groove|fixed|ellipsis|e-resize|double|dotted|distribute|distribute-space|distribute-letter|distribute-all-lines|disc|disabled|default|decimal|dashed|crosshair|collapse|col-resize|circle|char|center|capitalize|break-word|break-all|bottom|both|bolder|bold|block|bidi-override|below|baseline|auto|always|all-scroll|absolute|table|table-cell)\\b`
                    },
                    {
                        begin: /:/,
                        end: /[;}{]/,
                        relevance: 0,
                        contains: [
                            t.BLOCK_COMMENT,
                            d,
                            t.HEXCOLOR,
                            t.CSS_NUMBER_MODE,
                            e.QUOTE_STRING_MODE,
                            e.APOS_STRING_MODE,
                            t.IMPORTANT,
                            t.FUNCTION_DISPATCH
                        ]
                    },
                    {
                        begin: `@(page|font-face)`,
                        keywords: {
                            $pattern: u,
                            keyword: `@page @font-face`
                        }
                    },
                    {
                        begin: `@`,
                        end: `[{;]`,
                        returnBegin: !0,
                        keywords: {
                            $pattern: /[a-z-]+/,
                            keyword: `and or not only`,
                            attribute: o.join(` `)
                        },
                        contains: [
                            {
                                begin: u,
                                className: `keyword`
                            },
                            {
                                begin: /[a-z-]+(?=:)/,
                                className: `attribute`
                            },
                            d,
                            e.QUOTE_STRING_MODE,
                            e.APOS_STRING_MODE,
                            t.HEXCOLOR,
                            t.CSS_NUMBER_MODE
                        ]
                    },
                    t.FUNCTION_DISPATCH
                ]
            };
        }
        t.exports = u;
    }), un = o((e, t)=>{
        function n(e) {
            return {
                name: `Shell Session`,
                aliases: [
                    `console`,
                    `shellsession`
                ],
                contains: [
                    {
                        className: `meta.prompt`,
                        begin: /^\s{0,3}[/~\w\d[\]()@-]*[>%$#][ ]?/,
                        starts: {
                            end: /[^\\](?=\s*$)/,
                            subLanguage: `bash`
                        }
                    }
                ]
            };
        }
        t.exports = n;
    }), dn = o((e, t)=>{
        function n(e) {
            let t = `add.and.cmp.cmpg.cmpl.const.div.double.float.goto.if.int.long.move.mul.neg.new.nop.not.or.rem.return.shl.shr.sput.sub.throw.ushr.xor`.split(`.`);
            return {
                name: `Smali`,
                contains: [
                    {
                        className: `string`,
                        begin: `"`,
                        end: `"`,
                        relevance: 0
                    },
                    e.COMMENT(`#`, `$`, {
                        relevance: 0
                    }),
                    {
                        className: `keyword`,
                        variants: [
                            {
                                begin: `\\s*\\.end\\s[a-zA-Z0-9]*`
                            },
                            {
                                begin: `^[ ]*\\.[a-zA-Z]*`,
                                relevance: 0
                            },
                            {
                                begin: `\\s:[a-zA-Z_0-9]*`,
                                relevance: 0
                            },
                            {
                                begin: `\\s(` + [
                                    `transient`,
                                    `constructor`,
                                    `abstract`,
                                    `final`,
                                    `synthetic`,
                                    `public`,
                                    `private`,
                                    `protected`,
                                    `static`,
                                    `bridge`,
                                    `system`
                                ].join(`|`) + `)`
                            }
                        ]
                    },
                    {
                        className: `built_in`,
                        variants: [
                            {
                                begin: `\\s(` + t.join(`|`) + `)\\s`
                            },
                            {
                                begin: `\\s(` + t.join(`|`) + `)((-|/)[a-zA-Z0-9]+)+\\s`,
                                relevance: 10
                            },
                            {
                                begin: `\\s(` + [
                                    `aget`,
                                    `aput`,
                                    `array`,
                                    `check`,
                                    `execute`,
                                    `fill`,
                                    `filled`,
                                    `goto/16`,
                                    `goto/32`,
                                    `iget`,
                                    `instance`,
                                    `invoke`,
                                    `iput`,
                                    `monitor`,
                                    `packed`,
                                    `sget`,
                                    `sparse`
                                ].join(`|`) + `)((-|/)[a-zA-Z0-9]+)*\\s`,
                                relevance: 10
                            }
                        ]
                    },
                    {
                        className: `class`,
                        begin: `L[^(;:
]*;`,
                        relevance: 0
                    },
                    {
                        begin: `[vp][0-9]+`
                    }
                ]
            };
        }
        t.exports = n;
    }), fn = o((e, t)=>{
        function n(e) {
            let t = `[a-z][a-zA-Z0-9_]*`, n = {
                className: `string`,
                begin: `\\$.{1}`
            }, r = {
                className: `symbol`,
                begin: `#` + e.UNDERSCORE_IDENT_RE
            };
            return {
                name: `Smalltalk`,
                aliases: [
                    `st`
                ],
                keywords: [
                    `self`,
                    `super`,
                    `nil`,
                    `true`,
                    `false`,
                    `thisContext`
                ],
                contains: [
                    e.COMMENT(`"`, `"`),
                    e.APOS_STRING_MODE,
                    {
                        className: `type`,
                        begin: `\\b[A-Z][A-Za-z0-9_]*`,
                        relevance: 0
                    },
                    {
                        begin: t + `:`,
                        relevance: 0
                    },
                    e.C_NUMBER_MODE,
                    r,
                    n,
                    {
                        begin: `\\|[ ]*` + t + `([ ]+[a-z][a-zA-Z0-9_]*)*[ ]*\\|`,
                        returnBegin: !0,
                        end: /\|/,
                        illegal: /\S/,
                        contains: [
                            {
                                begin: `(\\|[ ]*)?` + t
                            }
                        ]
                    },
                    {
                        begin: `#\\(`,
                        end: `\\)`,
                        contains: [
                            e.APOS_STRING_MODE,
                            n,
                            e.C_NUMBER_MODE,
                            r
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), pn = o((e, t)=>{
        function n(e) {
            return {
                name: `SML (Standard ML)`,
                aliases: [
                    `ml`
                ],
                keywords: {
                    $pattern: `[a-z_]\\w*!?`,
                    keyword: `abstype and andalso as case datatype do else end eqtype exception fn fun functor handle if in include infix infixr let local nonfix of op open orelse raise rec sharing sig signature struct structure then type val with withtype where while`,
                    built_in: `array bool char exn int list option order real ref string substring vector unit word`,
                    literal: `true false NONE SOME LESS EQUAL GREATER nil`
                },
                illegal: /\/\/|>>/,
                contains: [
                    {
                        className: `literal`,
                        begin: /\[(\|\|)?\]|\(\)/,
                        relevance: 0
                    },
                    e.COMMENT(`\\(\\*`, `\\*\\)`, {
                        contains: [
                            `self`
                        ]
                    }),
                    {
                        className: `symbol`,
                        begin: `'[A-Za-z_](?!')[\\w']*`
                    },
                    {
                        className: `type`,
                        begin: "`[A-Z][\\w']*"
                    },
                    {
                        className: `type`,
                        begin: `\\b[A-Z][\\w']*`,
                        relevance: 0
                    },
                    {
                        begin: `[a-z_]\\w*'[\\w']*`
                    },
                    e.inherit(e.APOS_STRING_MODE, {
                        className: `string`,
                        relevance: 0
                    }),
                    e.inherit(e.QUOTE_STRING_MODE, {
                        illegal: null
                    }),
                    {
                        className: `number`,
                        begin: `\\b(0[xX][a-fA-F0-9_]+[Lln]?|0[oO][0-7_]+[Lln]?|0[bB][01_]+[Lln]?|[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)`,
                        relevance: 0
                    },
                    {
                        begin: /[-=]>/
                    }
                ]
            };
        }
        t.exports = n;
    }), mn = o((e, t)=>{
        function n(e) {
            let t = {
                className: `variable`,
                begin: /\b_+[a-zA-Z]\w*/
            }, n = {
                className: `title`,
                begin: /[a-zA-Z][a-zA-Z_0-9]*_fnc_[a-zA-Z_0-9]+/
            }, r = {
                className: `string`,
                variants: [
                    {
                        begin: `"`,
                        end: `"`,
                        contains: [
                            {
                                begin: `""`,
                                relevance: 0
                            }
                        ]
                    },
                    {
                        begin: `'`,
                        end: `'`,
                        contains: [
                            {
                                begin: `''`,
                                relevance: 0
                            }
                        ]
                    }
                ]
            }, i = `break.breakWith.breakOut.breakTo.case.catch.continue.continueWith.default.do.else.exit.exitWith.for.forEach.from.if.local.private.switch.step.then.throw.to.try.waitUntil.while.with`.split(`.`), a = `blufor.civilian.configNull.controlNull.displayNull.diaryRecordNull.east.endl.false.grpNull.independent.lineBreak.locationNull.nil.objNull.opfor.pi.resistance.scriptNull.sideAmbientLife.sideEmpty.sideEnemy.sideFriendly.sideLogic.sideUnknown.taskNull.teamMemberNull.true.west`.split(`.`), o = `abs.accTime.acos.action.actionIDs.actionKeys.actionKeysEx.actionKeysImages.actionKeysNames.actionKeysNamesArray.actionName.actionParams.activateAddons.activatedAddons.activateKey.activeTitleEffectParams.add3DENConnection.add3DENEventHandler.add3DENLayer.addAction.addBackpack.addBackpackCargo.addBackpackCargoGlobal.addBackpackGlobal.addBinocularItem.addCamShake.addCuratorAddons.addCuratorCameraArea.addCuratorEditableObjects.addCuratorEditingArea.addCuratorPoints.addEditorObject.addEventHandler.addForce.addForceGeneratorRTD.addGoggles.addGroupIcon.addHandgunItem.addHeadgear.addItem.addItemCargo.addItemCargoGlobal.addItemPool.addItemToBackpack.addItemToUniform.addItemToVest.addLiveStats.addMagazine.addMagazineAmmoCargo.addMagazineCargo.addMagazineCargoGlobal.addMagazineGlobal.addMagazinePool.addMagazines.addMagazineTurret.addMenu.addMenuItem.addMissionEventHandler.addMPEventHandler.addMusicEventHandler.addonFiles.addOwnedMine.addPlayerScores.addPrimaryWeaponItem.addPublicVariableEventHandler.addRating.addResources.addScore.addScoreSide.addSecondaryWeaponItem.addSwitchableUnit.addTeamMember.addToRemainsCollector.addTorque.addUniform.addUserActionEventHandler.addVehicle.addVest.addWaypoint.addWeapon.addWeaponCargo.addWeaponCargoGlobal.addWeaponGlobal.addWeaponItem.addWeaponPool.addWeaponTurret.addWeaponWithAttachmentsCargo.addWeaponWithAttachmentsCargoGlobal.admin.agent.agents.AGLToASL.aimedAtTarget.aimPos.airDensityCurveRTD.airDensityRTD.airplaneThrottle.airportSide.AISFinishHeal.alive.all3DENEntities.allActiveTitleEffects.allAddonsInfo.allAirports.allControls.allCurators.allCutLayers.allDead.allDeadMen.allDiaryRecords.allDiarySubjects.allDisplays.allEnv3DSoundSources.allGroups.allLODs.allMapMarkers.allMines.allMissionObjects.allObjects.allow3DMode.allowCrewInImmobile.allowCuratorLogicIgnoreAreas.allowDamage.allowDammage.allowedService.allowFileOperations.allowFleeing.allowGetIn.allowService.allowSprint.allPlayers.allSimpleObjects.allSites.allTurrets.allUnits.allUnitsUAV.allUsers.allVariables.ambientTemperature.ammo.ammoOnPylon.and.animate.animateBay.animateDoor.animatePylon.animateSource.animationNames.animationPhase.animationSourcePhase.animationState.apertureParams.append.apply.armoryPoints.arrayIntersect.asin.ASLToAGL.ASLToATL.assert.assignAsCargo.assignAsCargoIndex.assignAsCommander.assignAsDriver.assignAsGunner.assignAsTurret.assignCurator.assignedCargo.assignedCommander.assignedDriver.assignedGroup.assignedGunner.assignedItems.assignedTarget.assignedTeam.assignedVehicle.assignedVehicleRole.assignedVehicles.assignItem.assignTeam.assignToAirport.atan.atan2.atg.ATLToASL.attachedObject.attachedObjects.attachedTo.attachObject.attachTo.attackEnabled.awake.backpack.backpackCargo.backpackContainer.backpackItems.backpackMagazines.backpackSpaceFor.behaviour.benchmark.bezierInterpolation.binocular.binocularItems.binocularMagazine.boundingBox.boundingBoxReal.boundingCenter.brakesDisabled.briefingName.buildingExit.buildingPos.buldozer_EnableRoadDiag.buldozer_IsEnabledRoadDiag.buldozer_LoadNewRoads.buldozer_reloadOperMap.buttonAction.buttonSetAction.cadetMode.calculatePath.calculatePlayerVisibilityByFriendly.call.callExtension.camCommand.camCommit.camCommitPrepared.camCommitted.camConstuctionSetParams.camCreate.camDestroy.cameraEffect.cameraEffectEnableHUD.cameraInterest.cameraOn.cameraView.campaignConfigFile.camPreload.camPreloaded.camPrepareBank.camPrepareDir.camPrepareDive.camPrepareFocus.camPrepareFov.camPrepareFovRange.camPreparePos.camPrepareRelPos.camPrepareTarget.camSetBank.camSetDir.camSetDive.camSetFocus.camSetFov.camSetFovRange.camSetPos.camSetRelPos.camSetTarget.camTarget.camUseNVG.canAdd.canAddItemToBackpack.canAddItemToUniform.canAddItemToVest.cancelSimpleTaskDestination.canDeployWeapon.canFire.canMove.canSlingLoad.canStand.canSuspend.canTriggerDynamicSimulation.canUnloadInCombat.canVehicleCargo.captive.captiveNum.cbChecked.cbSetChecked.ceil.channelEnabled.cheatsEnabled.checkAIFeature.checkVisibility.className.clear3DENAttribute.clear3DENInventory.clearAllItemsFromBackpack.clearBackpackCargo.clearBackpackCargoGlobal.clearForcesRTD.clearGroupIcons.clearItemCargo.clearItemCargoGlobal.clearItemPool.clearMagazineCargo.clearMagazineCargoGlobal.clearMagazinePool.clearOverlay.clearRadio.clearWeaponCargo.clearWeaponCargoGlobal.clearWeaponPool.clientOwner.closeDialog.closeDisplay.closeOverlay.collapseObjectTree.collect3DENHistory.collectiveRTD.collisionDisabledWith.combatBehaviour.combatMode.commandArtilleryFire.commandChat.commander.commandFire.commandFollow.commandFSM.commandGetOut.commandingMenu.commandMove.commandRadio.commandStop.commandSuppressiveFire.commandTarget.commandWatch.comment.commitOverlay.compatibleItems.compatibleMagazines.compile.compileFinal.compileScript.completedFSM.composeText.configClasses.configFile.configHierarchy.configName.configOf.configProperties.configSourceAddonList.configSourceMod.configSourceModList.confirmSensorTarget.connectTerminalToUAV.connectToServer.controlsGroupCtrl.conversationDisabled.copyFromClipboard.copyToClipboard.copyWaypoints.cos.count.countEnemy.countFriendly.countSide.countType.countUnknown.create3DENComposition.create3DENEntity.createAgent.createCenter.createDialog.createDiaryLink.createDiaryRecord.createDiarySubject.createDisplay.createGearDialog.createGroup.createGuardedPoint.createHashMap.createHashMapFromArray.createLocation.createMarker.createMarkerLocal.createMenu.createMine.createMissionDisplay.createMPCampaignDisplay.createSimpleObject.createSimpleTask.createSite.createSoundSource.createTask.createTeam.createTrigger.createUnit.createVehicle.createVehicleCrew.createVehicleLocal.crew.ctAddHeader.ctAddRow.ctClear.ctCurSel.ctData.ctFindHeaderRows.ctFindRowHeader.ctHeaderControls.ctHeaderCount.ctRemoveHeaders.ctRemoveRows.ctrlActivate.ctrlAddEventHandler.ctrlAngle.ctrlAnimateModel.ctrlAnimationPhaseModel.ctrlAt.ctrlAutoScrollDelay.ctrlAutoScrollRewind.ctrlAutoScrollSpeed.ctrlBackgroundColor.ctrlChecked.ctrlClassName.ctrlCommit.ctrlCommitted.ctrlCreate.ctrlDelete.ctrlEnable.ctrlEnabled.ctrlFade.ctrlFontHeight.ctrlForegroundColor.ctrlHTMLLoaded.ctrlIDC.ctrlIDD.ctrlMapAnimAdd.ctrlMapAnimClear.ctrlMapAnimCommit.ctrlMapAnimDone.ctrlMapCursor.ctrlMapMouseOver.ctrlMapPosition.ctrlMapScale.ctrlMapScreenToWorld.ctrlMapSetPosition.ctrlMapWorldToScreen.ctrlModel.ctrlModelDirAndUp.ctrlModelScale.ctrlMousePosition.ctrlParent.ctrlParentControlsGroup.ctrlPosition.ctrlRemoveAllEventHandlers.ctrlRemoveEventHandler.ctrlScale.ctrlScrollValues.ctrlSetActiveColor.ctrlSetAngle.ctrlSetAutoScrollDelay.ctrlSetAutoScrollRewind.ctrlSetAutoScrollSpeed.ctrlSetBackgroundColor.ctrlSetChecked.ctrlSetDisabledColor.ctrlSetEventHandler.ctrlSetFade.ctrlSetFocus.ctrlSetFont.ctrlSetFontH1.ctrlSetFontH1B.ctrlSetFontH2.ctrlSetFontH2B.ctrlSetFontH3.ctrlSetFontH3B.ctrlSetFontH4.ctrlSetFontH4B.ctrlSetFontH5.ctrlSetFontH5B.ctrlSetFontH6.ctrlSetFontH6B.ctrlSetFontHeight.ctrlSetFontHeightH1.ctrlSetFontHeightH2.ctrlSetFontHeightH3.ctrlSetFontHeightH4.ctrlSetFontHeightH5.ctrlSetFontHeightH6.ctrlSetFontHeightSecondary.ctrlSetFontP.ctrlSetFontPB.ctrlSetFontSecondary.ctrlSetForegroundColor.ctrlSetModel.ctrlSetModelDirAndUp.ctrlSetModelScale.ctrlSetMousePosition.ctrlSetPixelPrecision.ctrlSetPosition.ctrlSetPositionH.ctrlSetPositionW.ctrlSetPositionX.ctrlSetPositionY.ctrlSetScale.ctrlSetScrollValues.ctrlSetShadow.ctrlSetStructuredText.ctrlSetText.ctrlSetTextColor.ctrlSetTextColorSecondary.ctrlSetTextSecondary.ctrlSetTextSelection.ctrlSetTooltip.ctrlSetTooltipColorBox.ctrlSetTooltipColorShade.ctrlSetTooltipColorText.ctrlSetTooltipMaxWidth.ctrlSetURL.ctrlSetURLOverlayMode.ctrlShadow.ctrlShow.ctrlShown.ctrlStyle.ctrlText.ctrlTextColor.ctrlTextHeight.ctrlTextSecondary.ctrlTextSelection.ctrlTextWidth.ctrlTooltip.ctrlType.ctrlURL.ctrlURLOverlayMode.ctrlVisible.ctRowControls.ctRowCount.ctSetCurSel.ctSetData.ctSetHeaderTemplate.ctSetRowTemplate.ctSetValue.ctValue.curatorAddons.curatorCamera.curatorCameraArea.curatorCameraAreaCeiling.curatorCoef.curatorEditableObjects.curatorEditingArea.curatorEditingAreaType.curatorMouseOver.curatorPoints.curatorRegisteredObjects.curatorSelected.curatorWaypointCost.current3DENOperation.currentChannel.currentCommand.currentMagazine.currentMagazineDetail.currentMagazineDetailTurret.currentMagazineTurret.currentMuzzle.currentNamespace.currentPilot.currentTask.currentTasks.currentThrowable.currentVisionMode.currentWaypoint.currentWeapon.currentWeaponMode.currentWeaponTurret.currentZeroing.cursorObject.cursorTarget.customChat.customRadio.customWaypointPosition.cutFadeOut.cutObj.cutRsc.cutText.damage.date.dateToNumber.dayTime.deActivateKey.debriefingText.debugFSM.debugLog.decayGraphValues.deg.delete3DENEntities.deleteAt.deleteCenter.deleteCollection.deleteEditorObject.deleteGroup.deleteGroupWhenEmpty.deleteIdentity.deleteLocation.deleteMarker.deleteMarkerLocal.deleteRange.deleteResources.deleteSite.deleteStatus.deleteTeam.deleteVehicle.deleteVehicleCrew.deleteWaypoint.detach.detectedMines.diag_activeMissionFSMs.diag_activeScripts.diag_activeSQFScripts.diag_activeSQSScripts.diag_allMissionEventHandlers.diag_captureFrame.diag_captureFrameToFile.diag_captureSlowFrame.diag_codePerformance.diag_deltaTime.diag_drawmode.diag_dumpCalltraceToLog.diag_dumpScriptAssembly.diag_dumpTerrainSynth.diag_dynamicSimulationEnd.diag_enable.diag_enabled.diag_exportConfig.diag_exportTerrainSVG.diag_fps.diag_fpsmin.diag_frameno.diag_getTerrainSegmentOffset.diag_lightNewLoad.diag_list.diag_localized.diag_log.diag_logSlowFrame.diag_mergeConfigFile.diag_recordTurretLimits.diag_resetFSM.diag_resetshapes.diag_scope.diag_setLightNew.diag_stacktrace.diag_tickTime.diag_toggle.dialog.diarySubjectExists.didJIP.didJIPOwner.difficulty.difficultyEnabled.difficultyEnabledRTD.difficultyOption.direction.directionStabilizationEnabled.directSay.disableAI.disableBrakes.disableCollisionWith.disableConversation.disableDebriefingStats.disableMapIndicators.disableNVGEquipment.disableRemoteSensors.disableSerialization.disableTIEquipment.disableUAVConnectability.disableUserInput.displayAddEventHandler.displayChild.displayCtrl.displayParent.displayRemoveAllEventHandlers.displayRemoveEventHandler.displaySetEventHandler.displayUniqueName.displayUpdate.dissolveTeam.distance.distance2D.distanceSqr.distributionRegion.do3DENAction.doArtilleryFire.doFire.doFollow.doFSM.doGetOut.doMove.doorPhase.doStop.doSuppressiveFire.doTarget.doWatch.drawArrow.drawEllipse.drawIcon.drawIcon3D.drawLaser.drawLine.drawLine3D.drawLink.drawLocation.drawPolygon.drawRectangle.drawTriangle.driver.drop.dynamicSimulationDistance.dynamicSimulationDistanceCoef.dynamicSimulationEnabled.dynamicSimulationSystemEnabled.echo.edit3DENMissionAttributes.editObject.editorSetEventHandler.effectiveCommander.elevatePeriscope.emptyPositions.enableAI.enableAIFeature.enableAimPrecision.enableAttack.enableAudioFeature.enableAutoStartUpRTD.enableAutoTrimRTD.enableCamShake.enableCaustics.enableChannel.enableCollisionWith.enableCopilot.enableDebriefingStats.enableDiagLegend.enableDirectionStabilization.enableDynamicSimulation.enableDynamicSimulationSystem.enableEndDialog.enableEngineArtillery.enableEnvironment.enableFatigue.enableGunLights.enableInfoPanelComponent.enableIRLasers.enableMimics.enablePersonTurret.enableRadio.enableReload.enableRopeAttach.enableSatNormalOnDetail.enableSaving.enableSentences.enableSimulation.enableSimulationGlobal.enableStamina.enableStressDamage.enableTeamSwitch.enableTraffic.enableUAVConnectability.enableUAVWaypoints.enableVehicleCargo.enableVehicleSensor.enableWeaponDisassembly.endLoadingScreen.endMission.engineOn.enginesIsOnRTD.enginesPowerRTD.enginesRpmRTD.enginesTorqueRTD.entities.environmentEnabled.environmentVolume.equipmentDisabled.estimatedEndServerTime.estimatedTimeLeft.evalObjectArgument.everyBackpack.everyContainer.exec.execEditorScript.execFSM.execVM.exp.expectedDestination.exportJIPMessages.eyeDirection.eyePos.face.faction.fadeEnvironment.fadeMusic.fadeRadio.fadeSound.fadeSpeech.failMission.fileExists.fillWeaponsFromPool.find.findAny.findCover.findDisplay.findEditorObject.findEmptyPosition.findEmptyPositionReady.findIf.findNearestEnemy.finishMissionInit.finite.fire.fireAtTarget.firstBackpack.flag.flagAnimationPhase.flagOwner.flagSide.flagTexture.flatten.fleeing.floor.flyInHeight.flyInHeightASL.focusedCtrl.fog.fogForecast.fogParams.forceAddUniform.forceAtPositionRTD.forceCadetDifficulty.forcedMap.forceEnd.forceFlagTexture.forceFollowRoad.forceGeneratorRTD.forceMap.forceRespawn.forceSpeed.forceUnicode.forceWalk.forceWeaponFire.forceWeatherChange.forEachMember.forEachMemberAgent.forEachMemberTeam.forgetTarget.format.formation.formationDirection.formationLeader.formationMembers.formationPosition.formationTask.formatText.formLeader.freeExtension.freeLook.fromEditor.fuel.fullCrew.gearIDCAmmoCount.gearSlotAmmoCount.gearSlotData.gestureState.get.get3DENActionState.get3DENAttribute.get3DENCamera.get3DENConnections.get3DENEntity.get3DENEntityID.get3DENGrid.get3DENIconsVisible.get3DENLayerEntities.get3DENLinesVisible.get3DENMissionAttribute.get3DENMouseOver.get3DENSelected.getAimingCoef.getAllEnv3DSoundControllers.getAllEnvSoundControllers.getAllHitPointsDamage.getAllOwnedMines.getAllPylonsInfo.getAllSoundControllers.getAllUnitTraits.getAmmoCargo.getAnimAimPrecision.getAnimSpeedCoef.getArray.getArtilleryAmmo.getArtilleryComputerSettings.getArtilleryETA.getAssetDLCInfo.getAssignedCuratorLogic.getAssignedCuratorUnit.getAttackTarget.getAudioOptionVolumes.getBackpackCargo.getBleedingRemaining.getBurningValue.getCalculatePlayerVisibilityByFriendly.getCameraViewDirection.getCargoIndex.getCenterOfMass.getClientState.getClientStateNumber.getCompatiblePylonMagazines.getConnectedUAV.getConnectedUAVUnit.getContainerMaxLoad.getCorpse.getCruiseControl.getCursorObjectParams.getCustomAimCoef.getCustomSoundController.getCustomSoundControllerCount.getDammage.getDebriefingText.getDescription.getDir.getDirVisual.getDiverState.getDLCAssetsUsage.getDLCAssetsUsageByName.getDLCs.getDLCUsageTime.getEditorCamera.getEditorMode.getEditorObjectScope.getElevationOffset.getEngineTargetRPMRTD.getEnv3DSoundController.getEnvSoundController.getEventHandlerInfo.getFatigue.getFieldManualStartPage.getForcedFlagTexture.getForcedSpeed.getFriend.getFSMVariable.getFuelCargo.getGraphValues.getGroupIcon.getGroupIconParams.getGroupIcons.getHideFrom.getHit.getHitIndex.getHitPointDamage.getItemCargo.getLighting.getLightingAt.getLoadedModsInfo.getMagazineCargo.getMarkerColor.getMarkerPos.getMarkerSize.getMarkerType.getMass.getMissionConfig.getMissionConfigValue.getMissionDLCs.getMissionLayerEntities.getMissionLayers.getMissionPath.getModelInfo.getMousePosition.getMusicPlayedTime.getNumber.getObjectArgument.getObjectChildren.getObjectDLC.getObjectFOV.getObjectID.getObjectMaterials.getObjectProxy.getObjectScale.getObjectTextures.getObjectType.getObjectViewDistance.getOpticsMode.getOrDefault.getOrDefaultCall.getOxygenRemaining.getPersonUsedDLCs.getPilotCameraDirection.getPilotCameraPosition.getPilotCameraRotation.getPilotCameraTarget.getPiPViewDistance.getPlateNumber.getPlayerChannel.getPlayerID.getPlayerScores.getPlayerUID.getPlayerVoNVolume.getPos.getPosASL.getPosASLVisual.getPosASLW.getPosATL.getPosATLVisual.getPosVisual.getPosWorld.getPosWorldVisual.getPylonMagazines.getRelDir.getRelPos.getRemoteSensorsDisabled.getRepairCargo.getResolution.getRoadInfo.getRotorBrakeRTD.getSensorTargets.getSensorThreats.getShadowDistance.getShotParents.getSlingLoad.getSoundController.getSoundControllerResult.getSpeed.getStamina.getStatValue.getSteamFriendsServers.getSubtitleOptions.getSuppression.getTerrainGrid.getTerrainHeight.getTerrainHeightASL.getTerrainInfo.getText.getTextRaw.getTextureInfo.getTextWidth.getTiParameters.getTotalDLCUsageTime.getTrimOffsetRTD.getTurretLimits.getTurretOpticsMode.getUnitFreefallInfo.getUnitLoadout.getUnitTrait.getUnloadInCombat.getUserInfo.getUserMFDText.getUserMFDValue.getVariable.getVehicleCargo.getVehicleTiPars.getWeaponCargo.getWeaponSway.getWingsOrientationRTD.getWingsPositionRTD.getWPPos.glanceAt.globalChat.globalRadio.goggles.goto.group.groupChat.groupFromNetId.groupIconSelectable.groupIconsVisible.groupID.groupOwner.groupRadio.groups.groupSelectedUnits.groupSelectUnit.gunner.gusts.halt.handgunItems.handgunMagazine.handgunWeapon.handsHit.hashValue.hasInterface.hasPilotCamera.hasWeapon.hcAllGroups.hcGroupParams.hcLeader.hcRemoveAllGroups.hcRemoveGroup.hcSelected.hcSelectGroup.hcSetGroup.hcShowBar.hcShownBar.headgear.hideBody.hideObject.hideObjectGlobal.hideSelection.hint.hintC.hintCadet.hintSilent.hmd.hostMission.htmlLoad.HUDMovementLevels.humidity.image.importAllGroups.importance.in.inArea.inAreaArray.incapacitatedState.inflame.inflamed.infoPanel.infoPanelComponentEnabled.infoPanelComponents.infoPanels.inGameUISetEventHandler.inheritsFrom.initAmbientLife.inPolygon.inputAction.inputController.inputMouse.inRangeOfArtillery.insert.insertEditorObject.intersect.is3DEN.is3DENMultiplayer.is3DENPreview.isAbleToBreathe.isActionMenuVisible.isAgent.isAimPrecisionEnabled.isAllowedCrewInImmobile.isArray.isAutoHoverOn.isAutonomous.isAutoStartUpEnabledRTD.isAutotest.isAutoTrimOnRTD.isAwake.isBleeding.isBurning.isClass.isCollisionLightOn.isCopilotEnabled.isDamageAllowed.isDedicated.isDLCAvailable.isEngineOn.isEqualRef.isEqualTo.isEqualType.isEqualTypeAll.isEqualTypeAny.isEqualTypeArray.isEqualTypeParams.isFilePatchingEnabled.isFinal.isFlashlightOn.isFlatEmpty.isForcedWalk.isFormationLeader.isGameFocused.isGamePaused.isGroupDeletedWhenEmpty.isHidden.isInRemainsCollector.isInstructorFigureEnabled.isIRLaserOn.isKeyActive.isKindOf.isLaserOn.isLightOn.isLocalized.isManualFire.isMarkedForCollection.isMissionProfileNamespaceLoaded.isMultiplayer.isMultiplayerSolo.isNil.isNotEqualRef.isNotEqualTo.isNull.isNumber.isObjectHidden.isObjectRTD.isOnRoad.isPiPEnabled.isPlayer.isRealTime.isRemoteExecuted.isRemoteExecutedJIP.isSaving.isSensorTargetConfirmed.isServer.isShowing3DIcons.isSimpleObject.isSprintAllowed.isStaminaEnabled.isSteamMission.isSteamOverlayEnabled.isStreamFriendlyUIEnabled.isStressDamageEnabled.isText.isTouchingGround.isTurnedOut.isTutHintsEnabled.isUAVConnectable.isUAVConnected.isUIContext.isUniformAllowed.isVehicleCargo.isVehicleRadarOn.isVehicleSensorEnabled.isWalking.isWeaponDeployed.isWeaponRested.itemCargo.items.itemsWithMagazines.join.joinAs.joinAsSilent.joinSilent.joinString.kbAddDatabase.kbAddDatabaseTargets.kbAddTopic.kbHasTopic.kbReact.kbRemoveTopic.kbTell.kbWasSaid.keyImage.keyName.keys.knowsAbout.land.landAt.landResult.language.laserTarget.lbAdd.lbClear.lbColor.lbColorRight.lbCurSel.lbData.lbDelete.lbIsSelected.lbPicture.lbPictureRight.lbSelection.lbSetColor.lbSetColorRight.lbSetCurSel.lbSetData.lbSetPicture.lbSetPictureColor.lbSetPictureColorDisabled.lbSetPictureColorSelected.lbSetPictureRight.lbSetPictureRightColor.lbSetPictureRightColorDisabled.lbSetPictureRightColorSelected.lbSetSelectColor.lbSetSelectColorRight.lbSetSelected.lbSetText.lbSetTextRight.lbSetTooltip.lbSetValue.lbSize.lbSort.lbSortBy.lbSortByValue.lbText.lbTextRight.lbTooltip.lbValue.leader.leaderboardDeInit.leaderboardGetRows.leaderboardInit.leaderboardRequestRowsFriends.leaderboardRequestRowsGlobal.leaderboardRequestRowsGlobalAroundUser.leaderboardsRequestUploadScore.leaderboardsRequestUploadScoreKeepBest.leaderboardState.leaveVehicle.libraryCredits.libraryDisclaimers.lifeState.lightAttachObject.lightDetachObject.lightIsOn.lightnings.limitSpeed.linearConversion.lineIntersects.lineIntersectsObjs.lineIntersectsSurfaces.lineIntersectsWith.linkItem.list.listObjects.listRemoteTargets.listVehicleSensors.ln.lnbAddArray.lnbAddColumn.lnbAddRow.lnbClear.lnbColor.lnbColorRight.lnbCurSelRow.lnbData.lnbDeleteColumn.lnbDeleteRow.lnbGetColumnsPosition.lnbPicture.lnbPictureRight.lnbSetColor.lnbSetColorRight.lnbSetColumnsPos.lnbSetCurSelRow.lnbSetData.lnbSetPicture.lnbSetPictureColor.lnbSetPictureColorRight.lnbSetPictureColorSelected.lnbSetPictureColorSelectedRight.lnbSetPictureRight.lnbSetText.lnbSetTextRight.lnbSetTooltip.lnbSetValue.lnbSize.lnbSort.lnbSortBy.lnbSortByValue.lnbText.lnbTextRight.lnbValue.load.loadAbs.loadBackpack.loadConfig.loadFile.loadGame.loadIdentity.loadMagazine.loadOverlay.loadStatus.loadUniform.loadVest.localize.localNamespace.locationPosition.lock.lockCameraTo.lockCargo.lockDriver.locked.lockedCameraTo.lockedCargo.lockedDriver.lockedInventory.lockedTurret.lockIdentity.lockInventory.lockTurret.lockWp.log.logEntities.logNetwork.logNetworkTerminate.lookAt.lookAtPos.magazineCargo.magazines.magazinesAllTurrets.magazinesAmmo.magazinesAmmoCargo.magazinesAmmoFull.magazinesDetail.magazinesDetailBackpack.magazinesDetailUniform.magazinesDetailVest.magazinesTurret.magazineTurretAmmo.mapAnimAdd.mapAnimClear.mapAnimCommit.mapAnimDone.mapCenterOnCamera.mapGridPosition.markAsFinishedOnSteam.markerAlpha.markerBrush.markerChannel.markerColor.markerDir.markerPolyline.markerPos.markerShadow.markerShape.markerSize.markerText.markerType.matrixMultiply.matrixTranspose.max.maxLoad.members.menuAction.menuAdd.menuChecked.menuClear.menuCollapse.menuData.menuDelete.menuEnable.menuEnabled.menuExpand.menuHover.menuPicture.menuSetAction.menuSetCheck.menuSetData.menuSetPicture.menuSetShortcut.menuSetText.menuSetURL.menuSetValue.menuShortcut.menuShortcutText.menuSize.menuSort.menuText.menuURL.menuValue.merge.min.mineActive.mineDetectedBy.missileTarget.missileTargetPos.missionConfigFile.missionDifficulty.missionEnd.missionName.missionNameSource.missionNamespace.missionProfileNamespace.missionStart.missionVersion.mod.modelToWorld.modelToWorldVisual.modelToWorldVisualWorld.modelToWorldWorld.modParams.moonIntensity.moonPhase.morale.move.move3DENCamera.moveInAny.moveInCargo.moveInCommander.moveInDriver.moveInGunner.moveInTurret.moveObjectToEnd.moveOut.moveTime.moveTo.moveToCompleted.moveToFailed.musicVolume.name.namedProperties.nameSound.nearEntities.nearestBuilding.nearestLocation.nearestLocations.nearestLocationWithDubbing.nearestMines.nearestObject.nearestObjects.nearestTerrainObjects.nearObjects.nearObjectsReady.nearRoads.nearSupplies.nearTargets.needReload.needService.netId.netObjNull.newOverlay.nextMenuItemIndex.nextWeatherChange.nMenuItems.not.numberOfEnginesRTD.numberToDate.objectCurators.objectFromNetId.objectParent.objStatus.onBriefingGroup.onBriefingNotes.onBriefingPlan.onBriefingTeamSwitch.onCommandModeChanged.onDoubleClick.onEachFrame.onGroupIconClick.onGroupIconOverEnter.onGroupIconOverLeave.onHCGroupSelectionChanged.onMapSingleClick.onPlayerConnected.onPlayerDisconnected.onPreloadFinished.onPreloadStarted.onShowNewObject.onTeamSwitch.openCuratorInterface.openDLCPage.openGPS.openMap.openSteamApp.openYoutubeVideo.or.orderGetIn.overcast.overcastForecast.owner.param.params.parseNumber.parseSimpleArray.parseText.parsingNamespace.particlesQuality.periscopeElevation.pickWeaponPool.pitch.pixelGrid.pixelGridBase.pixelGridNoUIScale.pixelH.pixelW.playableSlotsNumber.playableUnits.playAction.playActionNow.player.playerRespawnTime.playerSide.playersNumber.playGesture.playMission.playMove.playMoveNow.playMusic.playScriptedMission.playSound.playSound3D.playSoundUI.pose.position.positionCameraToWorld.posScreenToWorld.posWorldToScreen.ppEffectAdjust.ppEffectCommit.ppEffectCommitted.ppEffectCreate.ppEffectDestroy.ppEffectEnable.ppEffectEnabled.ppEffectForceInNVG.precision.preloadCamera.preloadObject.preloadSound.preloadTitleObj.preloadTitleRsc.preprocessFile.preprocessFileLineNumbers.primaryWeapon.primaryWeaponItems.primaryWeaponMagazine.priority.processDiaryLink.productVersion.profileName.profileNamespace.profileNameSteam.progressLoadingScreen.progressPosition.progressSetPosition.publicVariable.publicVariableClient.publicVariableServer.pushBack.pushBackUnique.putWeaponPool.queryItemsPool.queryMagazinePool.queryWeaponPool.rad.radioChannelAdd.radioChannelCreate.radioChannelInfo.radioChannelRemove.radioChannelSetCallSign.radioChannelSetLabel.radioEnabled.radioVolume.rain.rainbow.rainParams.random.rank.rankId.rating.rectangular.regexFind.regexMatch.regexReplace.registeredTasks.registerTask.reload.reloadEnabled.remoteControl.remoteExec.remoteExecCall.remoteExecutedOwner.remove3DENConnection.remove3DENEventHandler.remove3DENLayer.removeAction.removeAll3DENEventHandlers.removeAllActions.removeAllAssignedItems.removeAllBinocularItems.removeAllContainers.removeAllCuratorAddons.removeAllCuratorCameraAreas.removeAllCuratorEditingAreas.removeAllEventHandlers.removeAllHandgunItems.removeAllItems.removeAllItemsWithMagazines.removeAllMissionEventHandlers.removeAllMPEventHandlers.removeAllMusicEventHandlers.removeAllOwnedMines.removeAllPrimaryWeaponItems.removeAllSecondaryWeaponItems.removeAllUserActionEventHandlers.removeAllWeapons.removeBackpack.removeBackpackGlobal.removeBinocularItem.removeCuratorAddons.removeCuratorCameraArea.removeCuratorEditableObjects.removeCuratorEditingArea.removeDiaryRecord.removeDiarySubject.removeDrawIcon.removeDrawLinks.removeEventHandler.removeFromRemainsCollector.removeGoggles.removeGroupIcon.removeHandgunItem.removeHeadgear.removeItem.removeItemFromBackpack.removeItemFromUniform.removeItemFromVest.removeItems.removeMagazine.removeMagazineGlobal.removeMagazines.removeMagazinesTurret.removeMagazineTurret.removeMenuItem.removeMissionEventHandler.removeMPEventHandler.removeMusicEventHandler.removeOwnedMine.removePrimaryWeaponItem.removeSecondaryWeaponItem.removeSimpleTask.removeSwitchableUnit.removeTeamMember.removeUniform.removeUserActionEventHandler.removeVest.removeWeapon.removeWeaponAttachmentCargo.removeWeaponCargo.removeWeaponGlobal.removeWeaponTurret.reportRemoteTarget.requiredVersion.resetCamShake.resetSubgroupDirection.resize.resources.respawnVehicle.restartEditorCamera.reveal.revealMine.reverse.reversedMouseY.roadAt.roadsConnectedTo.roleDescription.ropeAttachedObjects.ropeAttachedTo.ropeAttachEnabled.ropeAttachTo.ropeCreate.ropeCut.ropeDestroy.ropeDetach.ropeEndPosition.ropeLength.ropes.ropesAttachedTo.ropeSegments.ropeUnwind.ropeUnwound.rotorsForcesRTD.rotorsRpmRTD.round.runInitScript.safeZoneH.safeZoneW.safeZoneWAbs.safeZoneX.safeZoneXAbs.safeZoneY.save3DENInventory.saveGame.saveIdentity.saveJoysticks.saveMissionProfileNamespace.saveOverlay.saveProfileNamespace.saveStatus.saveVar.savingEnabled.say.say2D.say3D.scopeName.score.scoreSide.screenshot.screenToWorld.scriptDone.scriptName.scudState.secondaryWeapon.secondaryWeaponItems.secondaryWeaponMagazine.select.selectBestPlaces.selectDiarySubject.selectedEditorObjects.selectEditorObject.selectionNames.selectionPosition.selectionVectorDirAndUp.selectLeader.selectMax.selectMin.selectNoPlayer.selectPlayer.selectRandom.selectRandomWeighted.selectWeapon.selectWeaponTurret.sendAUMessage.sendSimpleCommand.sendTask.sendTaskResult.sendUDPMessage.sentencesEnabled.serverCommand.serverCommandAvailable.serverCommandExecutable.serverName.serverNamespace.serverTime.set.set3DENAttribute.set3DENAttributes.set3DENGrid.set3DENIconsVisible.set3DENLayer.set3DENLinesVisible.set3DENLogicType.set3DENMissionAttribute.set3DENMissionAttributes.set3DENModelsVisible.set3DENObjectType.set3DENSelected.setAccTime.setActualCollectiveRTD.setAirplaneThrottle.setAirportSide.setAmmo.setAmmoCargo.setAmmoOnPylon.setAnimSpeedCoef.setAperture.setApertureNew.setArmoryPoints.setAttributes.setAutonomous.setBehaviour.setBehaviourStrong.setBleedingRemaining.setBrakesRTD.setCameraInterest.setCamShakeDefParams.setCamShakeParams.setCamUseTi.setCaptive.setCenterOfMass.setCollisionLight.setCombatBehaviour.setCombatMode.setCompassOscillation.setConvoySeparation.setCruiseControl.setCuratorCameraAreaCeiling.setCuratorCoef.setCuratorEditingAreaType.setCuratorWaypointCost.setCurrentChannel.setCurrentTask.setCurrentWaypoint.setCustomAimCoef.SetCustomMissionData.setCustomSoundController.setCustomWeightRTD.setDamage.setDammage.setDate.setDebriefingText.setDefaultCamera.setDestination.setDetailMapBlendPars.setDiaryRecordText.setDiarySubjectPicture.setDir.setDirection.setDrawIcon.setDriveOnPath.setDropInterval.setDynamicSimulationDistance.setDynamicSimulationDistanceCoef.setEditorMode.setEditorObjectScope.setEffectCondition.setEffectiveCommander.setEngineRpmRTD.setFace.setFaceanimation.setFatigue.setFeatureType.setFlagAnimationPhase.setFlagOwner.setFlagSide.setFlagTexture.setFog.setForceGeneratorRTD.setFormation.setFormationTask.setFormDir.setFriend.setFromEditor.setFSMVariable.setFuel.setFuelCargo.setGroupIcon.setGroupIconParams.setGroupIconsSelectable.setGroupIconsVisible.setGroupid.setGroupIdGlobal.setGroupOwner.setGusts.setHideBehind.setHit.setHitIndex.setHitPointDamage.setHorizonParallaxCoef.setHUDMovementLevels.setHumidity.setIdentity.setImportance.setInfoPanel.setLeader.setLightAmbient.setLightAttenuation.setLightBrightness.setLightColor.setLightConePars.setLightDayLight.setLightFlareMaxDistance.setLightFlareSize.setLightIntensity.setLightIR.setLightnings.setLightUseFlare.setLightVolumeShape.setLocalWindParams.setMagazineTurretAmmo.setMarkerAlpha.setMarkerAlphaLocal.setMarkerBrush.setMarkerBrushLocal.setMarkerColor.setMarkerColorLocal.setMarkerDir.setMarkerDirLocal.setMarkerPolyline.setMarkerPolylineLocal.setMarkerPos.setMarkerPosLocal.setMarkerShadow.setMarkerShadowLocal.setMarkerShape.setMarkerShapeLocal.setMarkerSize.setMarkerSizeLocal.setMarkerText.setMarkerTextLocal.setMarkerType.setMarkerTypeLocal.setMass.setMaxLoad.setMimic.setMissileTarget.setMissileTargetPos.setMousePosition.setMusicEffect.setMusicEventHandler.setName.setNameSound.setObjectArguments.setObjectMaterial.setObjectMaterialGlobal.setObjectProxy.setObjectScale.setObjectTexture.setObjectTextureGlobal.setObjectViewDistance.setOpticsMode.setOvercast.setOwner.setOxygenRemaining.setParticleCircle.setParticleClass.setParticleFire.setParticleParams.setParticleRandom.setPilotCameraDirection.setPilotCameraRotation.setPilotCameraTarget.setPilotLight.setPiPEffect.setPiPViewDistance.setPitch.setPlateNumber.setPlayable.setPlayerRespawnTime.setPlayerVoNVolume.setPos.setPosASL.setPosASL2.setPosASLW.setPosATL.setPosition.setPosWorld.setPylonLoadout.setPylonsPriority.setRadioMsg.setRain.setRainbow.setRandomLip.setRank.setRectangular.setRepairCargo.setRotorBrakeRTD.setShadowDistance.setShotParents.setSide.setSimpleTaskAlwaysVisible.setSimpleTaskCustomData.setSimpleTaskDescription.setSimpleTaskDestination.setSimpleTaskTarget.setSimpleTaskType.setSimulWeatherLayers.setSize.setSkill.setSlingLoad.setSoundEffect.setSpeaker.setSpeech.setSpeedMode.setStamina.setStaminaScheme.setStatValue.setSuppression.setSystemOfUnits.setTargetAge.setTaskMarkerOffset.setTaskResult.setTaskState.setTerrainGrid.setTerrainHeight.setText.setTimeMultiplier.setTiParameter.setTitleEffect.setTowParent.setTrafficDensity.setTrafficDistance.setTrafficGap.setTrafficSpeed.setTriggerActivation.setTriggerArea.setTriggerInterval.setTriggerStatements.setTriggerText.setTriggerTimeout.setTriggerType.setTurretLimits.setTurretOpticsMode.setType.setUnconscious.setUnitAbility.setUnitCombatMode.setUnitFreefallHeight.setUnitLoadout.setUnitPos.setUnitPosWeak.setUnitRank.setUnitRecoilCoefficient.setUnitTrait.setUnloadInCombat.setUserActionText.setUserMFDText.setUserMFDValue.setVariable.setVectorDir.setVectorDirAndUp.setVectorUp.setVehicleAmmo.setVehicleAmmoDef.setVehicleArmor.setVehicleCargo.setVehicleId.setVehicleLock.setVehiclePosition.setVehicleRadar.setVehicleReceiveRemoteTargets.setVehicleReportOwnPosition.setVehicleReportRemoteTargets.setVehicleTiPars.setVehicleVarName.setVelocity.setVelocityModelSpace.setVelocityTransformation.setViewDistance.setVisibleIfTreeCollapsed.setWantedRPMRTD.setWaves.setWaypointBehaviour.setWaypointCombatMode.setWaypointCompletionRadius.setWaypointDescription.setWaypointForceBehaviour.setWaypointFormation.setWaypointHousePosition.setWaypointLoiterAltitude.setWaypointLoiterRadius.setWaypointLoiterType.setWaypointName.setWaypointPosition.setWaypointScript.setWaypointSpeed.setWaypointStatements.setWaypointTimeout.setWaypointType.setWaypointVisible.setWeaponReloadingTime.setWeaponZeroing.setWind.setWindDir.setWindForce.setWindStr.setWingForceScaleRTD.setWPPos.show3DIcons.showChat.showCinemaBorder.showCommandingMenu.showCompass.showCuratorCompass.showGps.showHUD.showLegend.showMap.shownArtilleryComputer.shownChat.shownCompass.shownCuratorCompass.showNewEditorObject.shownGps.shownHUD.shownMap.shownPad.shownRadio.shownScoretable.shownSubtitles.shownUAVFeed.shownWarrant.shownWatch.showPad.showRadio.showScoretable.showSubtitles.showUAVFeed.showWarrant.showWatch.showWaypoint.showWaypoints.side.sideChat.sideRadio.simpleTasks.simulationEnabled.simulCloudDensity.simulCloudOcclusion.simulInClouds.simulWeatherSync.sin.size.sizeOf.skill.skillFinal.skipTime.sleep.sliderPosition.sliderRange.sliderSetPosition.sliderSetRange.sliderSetSpeed.sliderSpeed.slingLoadAssistantShown.soldierMagazines.someAmmo.sort.soundVolume.spawn.speaker.speechVolume.speed.speedMode.splitString.sqrt.squadParams.stance.startLoadingScreen.stop.stopEngineRTD.stopped.str.sunOrMoon.supportInfo.suppressFor.surfaceIsWater.surfaceNormal.surfaceTexture.surfaceType.swimInDepth.switchableUnits.switchAction.switchCamera.switchGesture.switchLight.switchMove.synchronizedObjects.synchronizedTriggers.synchronizedWaypoints.synchronizeObjectsAdd.synchronizeObjectsRemove.synchronizeTrigger.synchronizeWaypoint.systemChat.systemOfUnits.systemTime.systemTimeUTC.tan.targetKnowledge.targets.targetsAggregate.targetsQuery.taskAlwaysVisible.taskChildren.taskCompleted.taskCustomData.taskDescription.taskDestination.taskHint.taskMarkerOffset.taskName.taskParent.taskResult.taskState.taskType.teamMember.teamName.teams.teamSwitch.teamSwitchEnabled.teamType.terminate.terrainIntersect.terrainIntersectASL.terrainIntersectAtASL.text.textLog.textLogFormat.tg.time.timeMultiplier.titleCut.titleFadeOut.titleObj.titleRsc.titleText.toArray.toFixed.toLower.toLowerANSI.toString.toUpper.toUpperANSI.triggerActivated.triggerActivation.triggerAmmo.triggerArea.triggerAttachedVehicle.triggerAttachObject.triggerAttachVehicle.triggerDynamicSimulation.triggerInterval.triggerStatements.triggerText.triggerTimeout.triggerTimeoutCurrent.triggerType.trim.turretLocal.turretOwner.turretUnit.tvAdd.tvClear.tvCollapse.tvCollapseAll.tvCount.tvCurSel.tvData.tvDelete.tvExpand.tvExpandAll.tvIsSelected.tvPicture.tvPictureRight.tvSelection.tvSetColor.tvSetCurSel.tvSetData.tvSetPicture.tvSetPictureColor.tvSetPictureColorDisabled.tvSetPictureColorSelected.tvSetPictureRight.tvSetPictureRightColor.tvSetPictureRightColorDisabled.tvSetPictureRightColorSelected.tvSetSelectColor.tvSetSelected.tvSetText.tvSetTooltip.tvSetValue.tvSort.tvSortAll.tvSortByValue.tvSortByValueAll.tvText.tvTooltip.tvValue.type.typeName.typeOf.UAVControl.uiNamespace.uiSleep.unassignCurator.unassignItem.unassignTeam.unassignVehicle.underwater.uniform.uniformContainer.uniformItems.uniformMagazines.uniqueUnitItems.unitAddons.unitAimPosition.unitAimPositionVisual.unitBackpack.unitCombatMode.unitIsUAV.unitPos.unitReady.unitRecoilCoefficient.units.unitsBelowHeight.unitTurret.unlinkItem.unlockAchievement.unregisterTask.updateDrawIcon.updateMenuItem.updateObjectTree.useAIOperMapObstructionTest.useAISteeringComponent.useAudioTimeForMoves.userInputDisabled.values.vectorAdd.vectorCos.vectorCrossProduct.vectorDiff.vectorDir.vectorDirVisual.vectorDistance.vectorDistanceSqr.vectorDotProduct.vectorFromTo.vectorLinearConversion.vectorMagnitude.vectorMagnitudeSqr.vectorModelToWorld.vectorModelToWorldVisual.vectorMultiply.vectorNormalized.vectorUp.vectorUpVisual.vectorWorldToModel.vectorWorldToModelVisual.vehicle.vehicleCargoEnabled.vehicleChat.vehicleMoveInfo.vehicleRadio.vehicleReceiveRemoteTargets.vehicleReportOwnPosition.vehicleReportRemoteTargets.vehicles.vehicleVarName.velocity.velocityModelSpace.verifySignature.vest.vestContainer.vestItems.vestMagazines.viewDistance.visibleCompass.visibleGps.visibleMap.visiblePosition.visiblePositionASL.visibleScoretable.visibleWatch.waves.waypointAttachedObject.waypointAttachedVehicle.waypointAttachObject.waypointAttachVehicle.waypointBehaviour.waypointCombatMode.waypointCompletionRadius.waypointDescription.waypointForceBehaviour.waypointFormation.waypointHousePosition.waypointLoiterAltitude.waypointLoiterRadius.waypointLoiterType.waypointName.waypointPosition.waypoints.waypointScript.waypointsEnabledUAV.waypointShow.waypointSpeed.waypointStatements.waypointTimeout.waypointTimeoutCurrent.waypointType.waypointVisible.weaponAccessories.weaponAccessoriesCargo.weaponCargo.weaponDirection.weaponInertia.weaponLowered.weaponReloadingTime.weapons.weaponsInfo.weaponsItems.weaponsItemsCargo.weaponState.weaponsTurret.weightRTD.WFSideText.wind.windDir.windRTD.windStr.wingsForcesRTD.worldName.worldSize.worldToModel.worldToModelVisual.worldToScreen`.split(`.`), s = {
                className: `meta`,
                begin: /#\s*[a-z]+\b/,
                end: /$/,
                keywords: `define undef ifdef ifndef else endif include if`,
                contains: [
                    {
                        begin: /\\\n/,
                        relevance: 0
                    },
                    e.inherit(r, {
                        className: `string`
                    }),
                    {
                        begin: /<[^\n>]*>/,
                        end: /$/,
                        illegal: `\\n`
                    },
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE
                ]
            };
            return {
                name: `SQF`,
                case_insensitive: !0,
                keywords: {
                    keyword: i,
                    built_in: o,
                    literal: a
                },
                contains: [
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    e.NUMBER_MODE,
                    t,
                    n,
                    r,
                    s
                ],
                illegal: [
                    /\$[^a-fA-F0-9]/,
                    /\w\$/,
                    /\?/,
                    /@/,
                    / \| /,
                    /[a-zA-Z_]\./,
                    /\:\=/,
                    /\[\:/
                ]
            };
        }
        t.exports = n;
    }), hn = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = e.COMMENT(`--`, `$`), r = {
                scope: `string`,
                variants: [
                    {
                        begin: /'/,
                        end: /'/,
                        contains: [
                            {
                                match: /''/
                            }
                        ]
                    }
                ]
            }, i = {
                begin: /"/,
                end: /"/,
                contains: [
                    {
                        match: /""/
                    }
                ]
            }, a = [
                `true`,
                `false`,
                `unknown`
            ], o = [
                `double precision`,
                `large object`,
                `with timezone`,
                `without timezone`
            ], s = `bigint.binary.blob.boolean.char.character.clob.date.dec.decfloat.decimal.float.int.integer.interval.nchar.nclob.national.numeric.real.row.smallint.time.timestamp.varchar.varying.varbinary`.split(`.`), c = [
                `add`,
                `asc`,
                `collation`,
                `desc`,
                `final`,
                `first`,
                `last`,
                `view`
            ], l = `abs.acos.all.allocate.alter.and.any.are.array.array_agg.array_max_cardinality.as.asensitive.asin.asymmetric.at.atan.atomic.authorization.avg.begin.begin_frame.begin_partition.between.bigint.binary.blob.boolean.both.by.call.called.cardinality.cascaded.case.cast.ceil.ceiling.char.char_length.character.character_length.check.classifier.clob.close.coalesce.collate.collect.column.commit.condition.connect.constraint.contains.convert.copy.corr.corresponding.cos.cosh.count.covar_pop.covar_samp.create.cross.cube.cume_dist.current.current_catalog.current_date.current_default_transform_group.current_path.current_role.current_row.current_schema.current_time.current_timestamp.current_path.current_role.current_transform_group_for_type.current_user.cursor.cycle.date.day.deallocate.dec.decimal.decfloat.declare.default.define.delete.dense_rank.deref.describe.deterministic.disconnect.distinct.double.drop.dynamic.each.element.else.empty.end.end_frame.end_partition.end-exec.equals.escape.every.except.exec.execute.exists.exp.external.extract.false.fetch.filter.first_value.float.floor.for.foreign.frame_row.free.from.full.function.fusion.get.global.grant.group.grouping.groups.having.hold.hour.identity.in.indicator.initial.inner.inout.insensitive.insert.int.integer.intersect.intersection.interval.into.is.join.json_array.json_arrayagg.json_exists.json_object.json_objectagg.json_query.json_table.json_table_primitive.json_value.lag.language.large.last_value.lateral.lead.leading.left.like.like_regex.listagg.ln.local.localtime.localtimestamp.log.log10.lower.match.match_number.match_recognize.matches.max.member.merge.method.min.minute.mod.modifies.module.month.multiset.national.natural.nchar.nclob.new.no.none.normalize.not.nth_value.ntile.null.nullif.numeric.octet_length.occurrences_regex.of.offset.old.omit.on.one.only.open.or.order.out.outer.over.overlaps.overlay.parameter.partition.pattern.per.percent.percent_rank.percentile_cont.percentile_disc.period.portion.position.position_regex.power.precedes.precision.prepare.primary.procedure.ptf.range.rank.reads.real.recursive.ref.references.referencing.regr_avgx.regr_avgy.regr_count.regr_intercept.regr_r2.regr_slope.regr_sxx.regr_sxy.regr_syy.release.result.return.returns.revoke.right.rollback.rollup.row.row_number.rows.running.savepoint.scope.scroll.search.second.seek.select.sensitive.session_user.set.show.similar.sin.sinh.skip.smallint.some.specific.specifictype.sql.sqlexception.sqlstate.sqlwarning.sqrt.start.static.stddev_pop.stddev_samp.submultiset.subset.substring.substring_regex.succeeds.sum.symmetric.system.system_time.system_user.table.tablesample.tan.tanh.then.time.timestamp.timezone_hour.timezone_minute.to.trailing.translate.translate_regex.translation.treat.trigger.trim.trim_array.true.truncate.uescape.union.unique.unknown.unnest.update.upper.user.using.value.values.value_of.var_pop.var_samp.varbinary.varchar.varying.versioning.when.whenever.where.width_bucket.window.with.within.without.year`.split(`.`), u = `abs.acos.array_agg.asin.atan.avg.cast.ceil.ceiling.coalesce.corr.cos.cosh.count.covar_pop.covar_samp.cume_dist.dense_rank.deref.element.exp.extract.first_value.floor.json_array.json_arrayagg.json_exists.json_object.json_objectagg.json_query.json_table.json_table_primitive.json_value.lag.last_value.lead.listagg.ln.log.log10.lower.max.min.mod.nth_value.ntile.nullif.percent_rank.percentile_cont.percentile_disc.position.position_regex.power.rank.regr_avgx.regr_avgy.regr_count.regr_intercept.regr_r2.regr_slope.regr_sxx.regr_sxy.regr_syy.row_number.sin.sinh.sqrt.stddev_pop.stddev_samp.substring.substring_regex.sum.tan.tanh.translate.translate_regex.treat.trim.trim_array.unnest.upper.value_of.var_pop.var_samp.width_bucket`.split(`.`), d = [
                `current_catalog`,
                `current_date`,
                `current_default_transform_group`,
                `current_path`,
                `current_role`,
                `current_schema`,
                `current_transform_group_for_type`,
                `current_user`,
                `session_user`,
                `system_time`,
                `system_user`,
                `current_time`,
                `localtime`,
                `current_timestamp`,
                `localtimestamp`
            ], f = [
                `create table`,
                `insert into`,
                `primary key`,
                `foreign key`,
                `not null`,
                `alter table`,
                `add constraint`,
                `grouping sets`,
                `on overflow`,
                `character set`,
                `respect nulls`,
                `ignore nulls`,
                `nulls first`,
                `nulls last`,
                `depth first`,
                `breadth first`
            ], p = u, m = [
                ...l,
                ...c
            ].filter((e)=>!u.includes(e)), h = {
                scope: `variable`,
                match: /@[a-z0-9][a-z0-9_]*/
            }, g = {
                scope: `operator`,
                match: /[-+*/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?/,
                relevance: 0
            }, _ = {
                match: t.concat(/\b/, t.either(...p), /\s*\(/),
                relevance: 0,
                keywords: {
                    built_in: p
                }
            };
            function v(e) {
                return t.concat(/\b/, t.either(...e.map((e)=>e.replace(/\s+/, `\\s+`))), /\b/);
            }
            let y = {
                scope: `keyword`,
                match: v(f),
                relevance: 0
            };
            function b(e, { exceptions: t, when: n } = {}) {
                let r = n;
                return t ||= [], e.map((e)=>e.match(/\|\d+$/) || t.includes(e) ? e : r(e) ? `${e}|0` : e);
            }
            return {
                name: `SQL`,
                case_insensitive: !0,
                illegal: /[{}]|<\//,
                keywords: {
                    $pattern: /\b[\w\.]+/,
                    keyword: b(m, {
                        when: (e)=>e.length < 3
                    }),
                    literal: a,
                    type: s,
                    built_in: d
                },
                contains: [
                    {
                        scope: `type`,
                        match: v(o)
                    },
                    y,
                    _,
                    h,
                    r,
                    i,
                    e.C_NUMBER_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    n,
                    g
                ]
            };
        }
        t.exports = n;
    }), gn = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = [
                `functions`,
                `model`,
                `data`,
                `parameters`,
                `quantities`,
                `transformed`,
                `generated`
            ], r = [
                `for`,
                `in`,
                `if`,
                `else`,
                `while`,
                `break`,
                `continue`,
                `return`
            ], i = [
                `array`,
                `tuple`,
                `complex`,
                `int`,
                `real`,
                `vector`,
                `complex_vector`,
                `ordered`,
                `positive_ordered`,
                `simplex`,
                `unit_vector`,
                `row_vector`,
                `complex_row_vector`,
                `matrix`,
                `complex_matrix`,
                `cholesky_factor_corr|10`,
                `cholesky_factor_cov|10`,
                `corr_matrix|10`,
                `cov_matrix|10`,
                `void`
            ], a = `abs.acos.acosh.add_diag.algebra_solver.algebra_solver_newton.append_array.append_col.append_row.asin.asinh.atan.atan2.atanh.bessel_first_kind.bessel_second_kind.binary_log_loss.block.cbrt.ceil.chol2inv.cholesky_decompose.choose.col.cols.columns_dot_product.columns_dot_self.complex_schur_decompose.complex_schur_decompose_t.complex_schur_decompose_u.conj.cos.cosh.cov_exp_quad.crossprod.csr_extract.csr_extract_u.csr_extract_v.csr_extract_w.csr_matrix_times_vector.csr_to_dense_matrix.cumulative_sum.dae.dae_tol.determinant.diag_matrix.diagonal.diag_post_multiply.diag_pre_multiply.digamma.dims.distance.dot_product.dot_self.eigendecompose.eigendecompose_sym.eigenvalues.eigenvalues_sym.eigenvectors.eigenvectors_sym.erf.erfc.exp.exp2.expm1.falling_factorial.fdim.fft.fft2.floor.fma.fmax.fmin.fmod.gamma_p.gamma_q.generalized_inverse.get_imag.get_real.head.hmm_hidden_state_prob.hmm_marginal.hypot.identity_matrix.inc_beta.integrate_1d.integrate_ode.integrate_ode_adams.integrate_ode_bdf.integrate_ode_rk45.int_step.inv.inv_cloglog.inv_erfc.inverse.inverse_spd.inv_fft.inv_fft2.inv_inc_beta.inv_logit.inv_Phi.inv_sqrt.inv_square.is_inf.is_nan.lambert_w0.lambert_wm1.lbeta.lchoose.ldexp.lgamma.linspaced_array.linspaced_int_array.linspaced_row_vector.linspaced_vector.lmgamma.lmultiply.log.log1m.log1m_exp.log1m_inv_logit.log1p.log1p_exp.log_determinant.log_diff_exp.log_falling_factorial.log_inv_logit.log_inv_logit_diff.logit.log_mix.log_modified_bessel_first_kind.log_rising_factorial.log_softmax.log_sum_exp.machine_precision.map_rect.matrix_exp.matrix_exp_multiply.matrix_power.max.mdivide_left_spd.mdivide_left_tri_low.mdivide_right_spd.mdivide_right_tri_low.mean.min.modified_bessel_first_kind.modified_bessel_second_kind.multiply_lower_tri_self_transpose.negative_infinity.norm.norm1.norm2.not_a_number.num_elements.ode_adams.ode_adams_tol.ode_adjoint_tol_ctl.ode_bdf.ode_bdf_tol.ode_ckrk.ode_ckrk_tol.ode_rk45.ode_rk45_tol.one_hot_array.one_hot_int_array.one_hot_row_vector.one_hot_vector.ones_array.ones_int_array.ones_row_vector.ones_vector.owens_t.Phi.Phi_approx.polar.positive_infinity.pow.print.prod.proj.qr.qr_Q.qr_R.qr_thin.qr_thin_Q.qr_thin_R.quad_form.quad_form_diag.quad_form_sym.quantile.rank.reduce_sum.reject.rep_array.rep_matrix.rep_row_vector.rep_vector.reverse.rising_factorial.round.row.rows.rows_dot_product.rows_dot_self.scale_matrix_exp_multiply.sd.segment.sin.singular_values.sinh.size.softmax.sort_asc.sort_desc.sort_indices_asc.sort_indices_desc.sqrt.square.squared_distance.step.sub_col.sub_row.sum.svd.svd_U.svd_V.symmetrize_from_lower_tri.tail.tan.tanh.target.tcrossprod.tgamma.to_array_1d.to_array_2d.to_complex.to_int.to_matrix.to_row_vector.to_vector.trace.trace_gen_quad_form.trace_quad_form.trigamma.trunc.uniform_simplex.variance.zeros_array.zeros_int_array.zeros_row_vector`.split(`.`), o = `bernoulli.bernoulli_logit.bernoulli_logit_glm.beta.beta_binomial.beta_proportion.binomial.binomial_logit.categorical.categorical_logit.categorical_logit_glm.cauchy.chi_square.dirichlet.discrete_range.double_exponential.exp_mod_normal.exponential.frechet.gamma.gaussian_dlm_obs.gumbel.hmm_latent.hypergeometric.inv_chi_square.inv_gamma.inv_wishart.inv_wishart_cholesky.lkj_corr.lkj_corr_cholesky.logistic.loglogistic.lognormal.multi_gp.multi_gp_cholesky.multinomial.multinomial_logit.multi_normal.multi_normal_cholesky.multi_normal_prec.multi_student_cholesky_t.multi_student_t.multi_student_t_cholesky.neg_binomial.neg_binomial_2.neg_binomial_2_log.neg_binomial_2_log_glm.normal.normal_id_glm.ordered_logistic.ordered_logistic_glm.ordered_probit.pareto.pareto_type_2.poisson.poisson_log.poisson_log_glm.rayleigh.scaled_inv_chi_square.skew_double_exponential.skew_normal.std_normal.std_normal_log.student_t.uniform.von_mises.weibull.wiener.wishart.wishart_cholesky`.split(`.`), s = e.COMMENT(/\/\*/, /\*\//, {
                relevance: 0,
                contains: [
                    {
                        scope: `doctag`,
                        match: /@(return|param)/
                    }
                ]
            }), c = {
                scope: `meta`,
                begin: /#include\b/,
                end: /$/,
                contains: [
                    {
                        match: /[a-z][a-z-._]+/,
                        scope: `string`
                    },
                    e.C_LINE_COMMENT_MODE
                ]
            }, l = [
                `lower`,
                `upper`,
                `offset`,
                `multiplier`
            ];
            return {
                name: `Stan`,
                aliases: [
                    `stanfuncs`
                ],
                keywords: {
                    $pattern: e.IDENT_RE,
                    title: n,
                    type: i,
                    keyword: r,
                    built_in: a
                },
                contains: [
                    e.C_LINE_COMMENT_MODE,
                    c,
                    e.HASH_COMMENT_MODE,
                    s,
                    {
                        scope: `built_in`,
                        match: /\s(pi|e|sqrt2|log2|log10)(?=\()/,
                        relevance: 0
                    },
                    {
                        match: t.concat(/[<,]\s*/, t.either(...l), /\s*=/),
                        keywords: l
                    },
                    {
                        scope: `keyword`,
                        match: /\btarget(?=\s*\+=)/
                    },
                    {
                        match: [
                            /~\s*/,
                            t.either(...o),
                            /(?:\(\))/,
                            /\s*T(?=\s*\[)/
                        ],
                        scope: {
                            2: `built_in`,
                            4: `keyword`
                        }
                    },
                    {
                        scope: `built_in`,
                        keywords: o,
                        begin: t.concat(/\w*/, t.either(...o), /(_lpdf|_lupdf|_lpmf|_cdf|_lcdf|_lccdf|_qf)(?=\s*[\(.*\)])/)
                    },
                    {
                        begin: [
                            /~/,
                            /\s*/,
                            t.concat(t.either(...o), /(?=\s*[\(.*\)])/)
                        ],
                        scope: {
                            3: `built_in`
                        }
                    },
                    {
                        begin: [
                            /~/,
                            /\s*\w+(?=\s*[\(.*\)])/,
                            `(?!.*/\b(` + t.either(...o) + `)\b)`
                        ],
                        scope: {
                            2: `title.function`
                        }
                    },
                    {
                        scope: `title.function`,
                        begin: /\w*(_lpdf|_lupdf|_lpmf|_cdf|_lcdf|_lccdf|_qf)(?=\s*[\(.*\)])/
                    },
                    {
                        scope: `number`,
                        match: t.concat(/(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)/, /(?:[eE][+-]?\d+(?:_\d+)*)?i?(?!\w)/),
                        relevance: 0
                    },
                    {
                        scope: `string`,
                        begin: /"/,
                        end: /"/
                    }
                ]
            };
        }
        t.exports = n;
    }), _n = o((e, t)=>{
        function n(e) {
            return {
                name: `Stata`,
                aliases: [
                    `do`,
                    `ado`
                ],
                case_insensitive: !0,
                keywords: `if else in foreach for forv forva forval forvalu forvalue forvalues by bys bysort xi quietly qui capture about ac ac_7 acprplot acprplot_7 adjust ado adopath adoupdate alpha ameans an ano anov anova anova_estat anova_terms anovadef aorder ap app appe appen append arch arch_dr arch_estat arch_p archlm areg areg_p args arima arima_dr arima_estat arima_p as asmprobit asmprobit_estat asmprobit_lf asmprobit_mfx__dlg asmprobit_p ass asse asser assert avplot avplot_7 avplots avplots_7 bcskew0 bgodfrey bias binreg bip0_lf biplot bipp_lf bipr_lf bipr_p biprobit bitest bitesti bitowt blogit bmemsize boot bootsamp bootstrap bootstrap_8 boxco_l boxco_p boxcox boxcox_6 boxcox_p bprobit br break brier bro brow brows browse brr brrstat bs bs_7 bsampl_w bsample bsample_7 bsqreg bstat bstat_7 bstat_8 bstrap bstrap_7 bubble bubbleplot ca ca_estat ca_p cabiplot camat canon canon_8 canon_8_p canon_estat canon_p cap caprojection capt captu captur capture cat cc cchart cchart_7 cci cd censobs_table centile cf char chdir checkdlgfiles checkestimationsample checkhlpfiles checksum chelp ci cii cl class classutil clear cli clis clist clo clog clog_lf clog_p clogi clogi_sw clogit clogit_lf clogit_p clogitp clogl_sw cloglog clonevar clslistarray cluster cluster_measures cluster_stop cluster_tree cluster_tree_8 clustermat cmdlog cnr cnre cnreg cnreg_p cnreg_sw cnsreg codebook collaps4 collapse colormult_nb colormult_nw compare compress conf confi confir confirm conren cons const constr constra constrai constrain constraint continue contract copy copyright copysource cor corc corr corr2data corr_anti corr_kmo corr_smc corre correl correla correlat correlate corrgram cou coun count cox cox_p cox_sw coxbase coxhaz coxvar cprplot cprplot_7 crc cret cretu cretur creturn cross cs cscript cscript_log csi ct ct_is ctset ctst_5 ctst_st cttost cumsp cumsp_7 cumul cusum cusum_7 cutil d|0 datasig datasign datasigna datasignat datasignatu datasignatur datasignature datetof db dbeta de dec deco decod decode deff des desc descr descri describ describe destring dfbeta dfgls dfuller di di_g dir dirstats dis discard disp disp_res disp_s displ displa display distinct do doe doed doedi doedit dotplot dotplot_7 dprobit drawnorm drop ds ds_util dstdize duplicates durbina dwstat dydx e|0 ed edi edit egen eivreg emdef en enc enco encod encode eq erase ereg ereg_lf ereg_p ereg_sw ereghet ereghet_glf ereghet_glf_sh ereghet_gp ereghet_ilf ereghet_ilf_sh ereghet_ip eret eretu eretur ereturn err erro error esize est est_cfexist est_cfname est_clickable est_expand est_hold est_table est_unhold est_unholdok estat estat_default estat_summ estat_vce_only esti estimates etodow etof etomdy ex exi exit expand expandcl fac fact facto factor factor_estat factor_p factor_pca_rotated factor_rotate factormat fcast fcast_compute fcast_graph fdades fdadesc fdadescr fdadescri fdadescrib fdadescribe fdasav fdasave fdause fh_st file open file read file close file filefilter fillin find_hlp_file findfile findit findit_7 fit fl fli flis flist for5_0 forest forestplot form forma format fpredict frac_154 frac_adj frac_chk frac_cox frac_ddp frac_dis frac_dv frac_in frac_mun frac_pp frac_pq frac_pv frac_wgt frac_xo fracgen fracplot fracplot_7 fracpoly fracpred fron_ex fron_hn fron_p fron_tn fron_tn2 frontier ftodate ftoe ftomdy ftowdate funnel funnelplot g|0 gamhet_glf gamhet_gp gamhet_ilf gamhet_ip gamma gamma_d2 gamma_p gamma_sw gammahet gdi_hexagon gdi_spokes ge gen gene gener genera generat generate genrank genstd genvmean gettoken gl gladder gladder_7 glim_l01 glim_l02 glim_l03 glim_l04 glim_l05 glim_l06 glim_l07 glim_l08 glim_l09 glim_l10 glim_l11 glim_l12 glim_lf glim_mu glim_nw1 glim_nw2 glim_nw3 glim_p glim_v1 glim_v2 glim_v3 glim_v4 glim_v5 glim_v6 glim_v7 glm glm_6 glm_p glm_sw glmpred glo glob globa global glogit glogit_8 glogit_p gmeans gnbre_lf gnbreg gnbreg_5 gnbreg_p gomp_lf gompe_sw gomper_p gompertz gompertzhet gomphet_glf gomphet_glf_sh gomphet_gp gomphet_ilf gomphet_ilf_sh gomphet_ip gphdot gphpen gphprint gprefs gprobi_p gprobit gprobit_8 gr gr7 gr_copy gr_current gr_db gr_describe gr_dir gr_draw gr_draw_replay gr_drop gr_edit gr_editviewopts gr_example gr_example2 gr_export gr_print gr_qscheme gr_query gr_read gr_rename gr_replay gr_save gr_set gr_setscheme gr_table gr_undo gr_use graph graph7 grebar greigen greigen_7 greigen_8 grmeanby grmeanby_7 gs_fileinfo gs_filetype gs_graphinfo gs_stat gsort gwood h|0 hadimvo hareg hausman haver he heck_d2 heckma_p heckman heckp_lf heckpr_p heckprob hel help hereg hetpr_lf hetpr_p hetprob hettest hexdump hilite hist hist_7 histogram hlogit hlu hmeans hotel hotelling hprobit hreg hsearch icd9 icd9_ff icd9p iis impute imtest inbase include inf infi infil infile infix inp inpu input ins insheet insp inspe inspec inspect integ inten intreg intreg_7 intreg_p intrg2_ll intrg_ll intrg_ll2 ipolate iqreg ir irf irf_create irfm iri is_svy is_svysum isid istdize ivprob_1_lf ivprob_lf ivprobit ivprobit_p ivreg ivreg_footnote ivtob_1_lf ivtob_lf ivtobit ivtobit_p jackknife jacknife jknife jknife_6 jknife_8 jkstat joinby kalarma1 kap kap_3 kapmeier kappa kapwgt kdensity kdensity_7 keep ksm ksmirnov ktau kwallis l|0 la lab labbe labbeplot labe label labelbook ladder levels levelsof leverage lfit lfit_p li lincom line linktest lis list lloghet_glf lloghet_glf_sh lloghet_gp lloghet_ilf lloghet_ilf_sh lloghet_ip llogi_sw llogis_p llogist llogistic llogistichet lnorm_lf lnorm_sw lnorma_p lnormal lnormalhet lnormhet_glf lnormhet_glf_sh lnormhet_gp lnormhet_ilf lnormhet_ilf_sh lnormhet_ip lnskew0 loadingplot loc loca local log logi logis_lf logistic logistic_p logit logit_estat logit_p loglogs logrank loneway lookfor lookup lowess lowess_7 lpredict lrecomp lroc lroc_7 lrtest ls lsens lsens_7 lsens_x lstat ltable ltable_7 ltriang lv lvr2plot lvr2plot_7 m|0 ma mac macr macro makecns man manova manova_estat manova_p manovatest mantel mark markin markout marksample mat mat_capp mat_order mat_put_rr mat_rapp mata mata_clear mata_describe mata_drop mata_matdescribe mata_matsave mata_matuse mata_memory mata_mlib mata_mosave mata_rename mata_which matalabel matcproc matlist matname matr matri matrix matrix_input__dlg matstrik mcc mcci md0_ md1_ md1debug_ md2_ md2debug_ mds mds_estat mds_p mdsconfig mdslong mdsmat mdsshepard mdytoe mdytof me_derd mean means median memory memsize menl meqparse mer merg merge meta mfp mfx mhelp mhodds minbound mixed_ll mixed_ll_reparm mkassert mkdir mkmat mkspline ml ml_5 ml_adjs ml_bhhhs ml_c_d ml_check ml_clear ml_cnt ml_debug ml_defd ml_e0 ml_e0_bfgs ml_e0_cycle ml_e0_dfp ml_e0i ml_e1 ml_e1_bfgs ml_e1_bhhh ml_e1_cycle ml_e1_dfp ml_e2 ml_e2_cycle ml_ebfg0 ml_ebfr0 ml_ebfr1 ml_ebh0q ml_ebhh0 ml_ebhr0 ml_ebr0i ml_ecr0i ml_edfp0 ml_edfr0 ml_edfr1 ml_edr0i ml_eds ml_eer0i ml_egr0i ml_elf ml_elf_bfgs ml_elf_bhhh ml_elf_cycle ml_elf_dfp ml_elfi ml_elfs ml_enr0i ml_enrr0 ml_erdu0 ml_erdu0_bfgs ml_erdu0_bhhh ml_erdu0_bhhhq ml_erdu0_cycle ml_erdu0_dfp ml_erdu0_nrbfgs ml_exde ml_footnote ml_geqnr ml_grad0 ml_graph ml_hbhhh ml_hd0 ml_hold ml_init ml_inv ml_log ml_max ml_mlout ml_mlout_8 ml_model ml_nb0 ml_opt ml_p ml_plot ml_query ml_rdgrd ml_repor ml_s_e ml_score ml_searc ml_technique ml_unhold mleval mlf_ mlmatbysum mlmatsum mlog mlogi mlogit mlogit_footnote mlogit_p mlopts mlsum mlvecsum mnl0_ mor more mov move mprobit mprobit_lf mprobit_p mrdu0_ mrdu1_ mvdecode mvencode mvreg mvreg_estat n|0 nbreg nbreg_al nbreg_lf nbreg_p nbreg_sw nestreg net newey newey_7 newey_p news nl nl_7 nl_9 nl_9_p nl_p nl_p_7 nlcom nlcom_p nlexp2 nlexp2_7 nlexp2a nlexp2a_7 nlexp3 nlexp3_7 nlgom3 nlgom3_7 nlgom4 nlgom4_7 nlinit nllog3 nllog3_7 nllog4 nllog4_7 nlog_rd nlogit nlogit_p nlogitgen nlogittree nlpred no nobreak noi nois noisi noisil noisily note notes notes_dlg nptrend numlabel numlist odbc old_ver olo olog ologi ologi_sw ologit ologit_p ologitp on one onew onewa oneway op_colnm op_comp op_diff op_inv op_str opr opro oprob oprob_sw oprobi oprobi_p oprobit oprobitp opts_exclusive order orthog orthpoly ou out outf outfi outfil outfile outs outsh outshe outshee outsheet ovtest pac pac_7 palette parse parse_dissim pause pca pca_8 pca_display pca_estat pca_p pca_rotate pcamat pchart pchart_7 pchi pchi_7 pcorr pctile pentium pergram pergram_7 permute permute_8 personal peto_st pkcollapse pkcross pkequiv pkexamine pkexamine_7 pkshape pksumm pksumm_7 pl plo plot plugin pnorm pnorm_7 poisgof poiss_lf poiss_sw poisso_p poisson poisson_estat post postclose postfile postutil pperron pr prais prais_e prais_e2 prais_p predict predictnl preserve print pro prob probi probit probit_estat probit_p proc_time procoverlay procrustes procrustes_estat procrustes_p profiler prog progr progra program prop proportion prtest prtesti pwcorr pwd q\\s qby qbys qchi qchi_7 qladder qladder_7 qnorm qnorm_7 qqplot qqplot_7 qreg qreg_c qreg_p qreg_sw qu quadchk quantile quantile_7 que quer query range ranksum ratio rchart rchart_7 rcof recast reclink recode reg reg3 reg3_p regdw regr regre regre_p2 regres regres_p regress regress_estat regriv_p remap ren rena renam rename renpfix repeat replace report reshape restore ret retu retur return rm rmdir robvar roccomp roccomp_7 roccomp_8 rocf_lf rocfit rocfit_8 rocgold rocplot rocplot_7 roctab roctab_7 rolling rologit rologit_p rot rota rotat rotate rotatemat rreg rreg_p ru run runtest rvfplot rvfplot_7 rvpplot rvpplot_7 sa safesum sample sampsi sav save savedresults saveold sc sca scal scala scalar scatter scm_mine sco scob_lf scob_p scobi_sw scobit scor score scoreplot scoreplot_help scree screeplot screeplot_help sdtest sdtesti se search separate seperate serrbar serrbar_7 serset set set_defaults sfrancia sh she shel shell shewhart shewhart_7 signestimationsample signrank signtest simul simul_7 simulate simulate_8 sktest sleep slogit slogit_d2 slogit_p smooth snapspan so sor sort spearman spikeplot spikeplot_7 spikeplt spline_x split sqreg sqreg_p sret sretu sretur sreturn ssc st st_ct st_hc st_hcd st_hcd_sh st_is st_issys st_note st_promo st_set st_show st_smpl st_subid stack statsby statsby_8 stbase stci stci_7 stcox stcox_estat stcox_fr stcox_fr_ll stcox_p stcox_sw stcoxkm stcoxkm_7 stcstat stcurv stcurve stcurve_7 stdes stem stepwise stereg stfill stgen stir stjoin stmc stmh stphplot stphplot_7 stphtest stphtest_7 stptime strate strate_7 streg streg_sw streset sts sts_7 stset stsplit stsum sttocc sttoct stvary stweib su suest suest_8 sum summ summa summar summari summariz summarize sunflower sureg survcurv survsum svar svar_p svmat svy svy_disp svy_dreg svy_est svy_est_7 svy_estat svy_get svy_gnbreg_p svy_head svy_header svy_heckman_p svy_heckprob_p svy_intreg_p svy_ivreg_p svy_logistic_p svy_logit_p svy_mlogit_p svy_nbreg_p svy_ologit_p svy_oprobit_p svy_poisson_p svy_probit_p svy_regress_p svy_sub svy_sub_7 svy_x svy_x_7 svy_x_p svydes svydes_8 svygen svygnbreg svyheckman svyheckprob svyintreg svyintreg_7 svyintrg svyivreg svylc svylog_p svylogit svymarkout svymarkout_8 svymean svymlog svymlogit svynbreg svyolog svyologit svyoprob svyoprobit svyopts svypois svypois_7 svypoisson svyprobit svyprobt svyprop svyprop_7 svyratio svyreg svyreg_p svyregress svyset svyset_7 svyset_8 svytab svytab_7 svytest svytotal sw sw_8 swcnreg swcox swereg swilk swlogis swlogit swologit swoprbt swpois swprobit swqreg swtobit swweib symmetry symmi symplot symplot_7 syntax sysdescribe sysdir sysuse szroeter ta tab tab1 tab2 tab_or tabd tabdi tabdis tabdisp tabi table tabodds tabodds_7 tabstat tabu tabul tabula tabulat tabulate te tempfile tempname tempvar tes test testnl testparm teststd tetrachoric time_it timer tis tob tobi tobit tobit_p tobit_sw token tokeni tokeniz tokenize tostring total translate translator transmap treat_ll treatr_p treatreg trim trimfill trnb_cons trnb_mean trpoiss_d2 trunc_ll truncr_p truncreg tsappend tset tsfill tsline tsline_ex tsreport tsrevar tsrline tsset tssmooth tsunab ttest ttesti tut_chk tut_wait tutorial tw tware_st two twoway twoway__fpfit_serset twoway__function_gen twoway__histogram_gen twoway__ipoint_serset twoway__ipoints_serset twoway__kdensity_gen twoway__lfit_serset twoway__normgen_gen twoway__pci_serset twoway__qfit_serset twoway__scatteri_serset twoway__sunflower_gen twoway_ksm_serset ty typ type typeof u|0 unab unabbrev unabcmd update us use uselabel var var_mkcompanion var_p varbasic varfcast vargranger varirf varirf_add varirf_cgraph varirf_create varirf_ctable varirf_describe varirf_dir varirf_drop varirf_erase varirf_graph varirf_ograph varirf_rename varirf_set varirf_table varlist varlmar varnorm varsoc varstable varstable_w varstable_w2 varwle vce vec vec_fevd vec_mkphi vec_p vec_p_w vecirf_create veclmar veclmar_w vecnorm vecnorm_w vecrank vecstable verinst vers versi versio version view viewsource vif vwls wdatetof webdescribe webseek webuse weib1_lf weib2_lf weib_lf weib_lf0 weibhet_glf weibhet_glf_sh weibhet_glfa weibhet_glfa_sh weibhet_gp weibhet_ilf weibhet_ilf_sh weibhet_ilfa weibhet_ilfa_sh weibhet_ip weibu_sw weibul_p weibull weibull_c weibull_s weibullhet wh whelp whi which whil while wilc_st wilcoxon win wind windo window winexec wntestb wntestb_7 wntestq xchart xchart_7 xcorr xcorr_7 xi xi_6 xmlsav xmlsave xmluse xpose xsh xshe xshel xshell xt_iis xt_tis xtab_p xtabond xtbin_p xtclog xtcloglog xtcloglog_8 xtcloglog_d2 xtcloglog_pa_p xtcloglog_re_p xtcnt_p xtcorr xtdata xtdes xtfront_p xtfrontier xtgee xtgee_elink xtgee_estat xtgee_makeivar xtgee_p xtgee_plink xtgls xtgls_p xthaus xthausman xtht_p xthtaylor xtile xtint_p xtintreg xtintreg_8 xtintreg_d2 xtintreg_p xtivp_1 xtivp_2 xtivreg xtline xtline_ex xtlogit xtlogit_8 xtlogit_d2 xtlogit_fe_p xtlogit_pa_p xtlogit_re_p xtmixed xtmixed_estat xtmixed_p xtnb_fe xtnb_lf xtnbreg xtnbreg_pa_p xtnbreg_refe_p xtpcse xtpcse_p xtpois xtpoisson xtpoisson_d2 xtpoisson_pa_p xtpoisson_refe_p xtpred xtprobit xtprobit_8 xtprobit_d2 xtprobit_re_p xtps_fe xtps_lf xtps_ren xtps_ren_8 xtrar_p xtrc xtrc_p xtrchh xtrefe_p xtreg xtreg_be xtreg_fe xtreg_ml xtreg_pa_p xtreg_re xtregar xtrere_p xtset xtsf_ll xtsf_llti xtsum xttab xttest0 xttobit xttobit_8 xttobit_p xttrans yx yxview__barlike_draw yxview_area_draw yxview_bar_draw yxview_dot_draw yxview_dropline_draw yxview_function_draw yxview_iarrow_draw yxview_ilabels_draw yxview_normal_draw yxview_pcarrow_draw yxview_pcbarrow_draw yxview_pccapsym_draw yxview_pcscatter_draw yxview_pcspike_draw yxview_rarea_draw yxview_rbar_draw yxview_rbarm_draw yxview_rcap_draw yxview_rcapsym_draw yxview_rconnected_draw yxview_rline_draw yxview_rscatter_draw yxview_rspike_draw yxview_spike_draw yxview_sunflower_draw zap_s zinb zinb_llf zinb_plf zip zip_llf zip_p zip_plf zt_ct_5 zt_hc_5 zt_hcd_5 zt_is_5 zt_iss_5 zt_sho_5 zt_smp_5 ztbase_5 ztcox_5 ztdes_5 ztereg_5 ztfill_5 ztgen_5 ztir_5 ztjoin_5 ztnb ztnb_p ztp ztp_p zts_5 ztset_5 ztspli_5 ztsum_5 zttoct_5 ztvary_5 ztweib_5`,
                contains: [
                    {
                        className: `symbol`,
                        begin: /`[a-zA-Z0-9_]+'/
                    },
                    {
                        className: `variable`,
                        begin: /\$\{?[a-zA-Z0-9_]+\}?/,
                        relevance: 0
                    },
                    {
                        className: `string`,
                        variants: [
                            {
                                begin: `\`"[^\r
]*?"'`
                            },
                            {
                                begin: `"[^\r
"]*"`
                            }
                        ]
                    },
                    {
                        className: `built_in`,
                        variants: [
                            {
                                begin: `\\b(abs|acos|asin|atan|atan2|atanh|ceil|cloglog|comb|cos|digamma|exp|floor|invcloglog|invlogit|ln|lnfact|lnfactorial|lngamma|log|log10|max|min|mod|reldif|round|sign|sin|sqrt|sum|tan|tanh|trigamma|trunc|betaden|Binomial|binorm|binormal|chi2|chi2tail|dgammapda|dgammapdada|dgammapdadx|dgammapdx|dgammapdxdx|F|Fden|Ftail|gammaden|gammap|ibeta|invbinomial|invchi2|invchi2tail|invF|invFtail|invgammap|invibeta|invnchi2|invnFtail|invnibeta|invnorm|invnormal|invttail|nbetaden|nchi2|nFden|nFtail|nibeta|norm|normal|normalden|normd|npnchi2|tden|ttail|uniform|abbrev|char|index|indexnot|length|lower|ltrim|match|plural|proper|real|regexm|regexr|regexs|reverse|rtrim|string|strlen|strlower|strltrim|strmatch|strofreal|strpos|strproper|strreverse|strrtrim|strtrim|strupper|subinstr|subinword|substr|trim|upper|word|wordcount|_caller|autocode|byteorder|chop|clip|cond|e|epsdouble|epsfloat|group|inlist|inrange|irecode|matrix|maxbyte|maxdouble|maxfloat|maxint|maxlong|mi|minbyte|mindouble|minfloat|minint|minlong|missing|r|recode|replay|return|s|scalar|d|date|day|dow|doy|halfyear|mdy|month|quarter|week|year|d|daily|dofd|dofh|dofm|dofq|dofw|dofy|h|halfyearly|hofd|m|mofd|monthly|q|qofd|quarterly|tin|twithin|w|weekly|wofd|y|yearly|yh|ym|yofd|yq|yw|cholesky|colnumb|colsof|corr|det|diag|diag0cnt|el|get|hadamard|I|inv|invsym|issym|issymmetric|J|matmissing|matuniform|mreldif|nullmat|rownumb|rowsof|sweep|syminv|trace|vec|vecdiag)(?=\\()`
                            }
                        ]
                    },
                    e.COMMENT(`^[ 	]*\\*.*$`, !1),
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE
                ]
            };
        }
        t.exports = n;
    }), vn = o((e, t)=>{
        function n(e) {
            return {
                name: `STEP Part 21`,
                aliases: [
                    `p21`,
                    `step`,
                    `stp`
                ],
                case_insensitive: !0,
                keywords: {
                    $pattern: `[A-Z_][A-Z0-9_.]*`,
                    keyword: [
                        `HEADER`,
                        `ENDSEC`,
                        `DATA`
                    ]
                },
                contains: [
                    {
                        className: `meta`,
                        begin: `ISO-10303-21;`,
                        relevance: 10
                    },
                    {
                        className: `meta`,
                        begin: `END-ISO-10303-21;`,
                        relevance: 10
                    },
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    e.COMMENT(`/\\*\\*!`, `\\*/`),
                    e.C_NUMBER_MODE,
                    e.inherit(e.APOS_STRING_MODE, {
                        illegal: null
                    }),
                    e.inherit(e.QUOTE_STRING_MODE, {
                        illegal: null
                    }),
                    {
                        className: `string`,
                        begin: `'`,
                        end: `'`
                    },
                    {
                        className: `symbol`,
                        variants: [
                            {
                                begin: `#`,
                                end: `\\d+`,
                                illegal: `\\W`
                            }
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), yn = o((e, t)=>{
        var n = (e)=>({
                IMPORTANT: {
                    scope: `meta`,
                    begin: `!important`
                },
                BLOCK_COMMENT: e.C_BLOCK_COMMENT_MODE,
                HEXCOLOR: {
                    scope: `number`,
                    begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/
                },
                FUNCTION_DISPATCH: {
                    className: `built_in`,
                    begin: /[\w-]+(?=\()/
                },
                ATTRIBUTE_SELECTOR_MODE: {
                    scope: `selector-attr`,
                    begin: /\[/,
                    end: /\]/,
                    illegal: `$`,
                    contains: [
                        e.APOS_STRING_MODE,
                        e.QUOTE_STRING_MODE
                    ]
                },
                CSS_NUMBER_MODE: {
                    scope: `number`,
                    begin: e.NUMBER_RE + `(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?`,
                    relevance: 0
                },
                CSS_VARIABLE: {
                    className: `attr`,
                    begin: /--[A-Za-z_][A-Za-z0-9_-]*/
                }
            }), r = `a.abbr.address.article.aside.audio.b.blockquote.body.button.canvas.caption.cite.code.dd.del.details.dfn.div.dl.dt.em.fieldset.figcaption.figure.footer.form.h1.h2.h3.h4.h5.h6.header.hgroup.html.i.iframe.img.input.ins.kbd.label.legend.li.main.mark.menu.nav.object.ol.optgroup.option.p.picture.q.quote.samp.section.select.source.span.strong.summary.sup.table.tbody.td.textarea.tfoot.th.thead.time.tr.ul.var.video`.split(`.`), i = `defs.g.marker.mask.pattern.svg.switch.symbol.feBlend.feColorMatrix.feComponentTransfer.feComposite.feConvolveMatrix.feDiffuseLighting.feDisplacementMap.feFlood.feGaussianBlur.feImage.feMerge.feMorphology.feOffset.feSpecularLighting.feTile.feTurbulence.linearGradient.radialGradient.stop.circle.ellipse.image.line.path.polygon.polyline.rect.text.use.textPath.tspan.foreignObject.clipPath`.split(`.`), a = [
            ...r,
            ...i
        ], o = `any-hover.any-pointer.aspect-ratio.color.color-gamut.color-index.device-aspect-ratio.device-height.device-width.display-mode.forced-colors.grid.height.hover.inverted-colors.monochrome.orientation.overflow-block.overflow-inline.pointer.prefers-color-scheme.prefers-contrast.prefers-reduced-motion.prefers-reduced-transparency.resolution.scan.scripting.update.width.min-width.max-width.min-height.max-height`.split(`.`).sort().reverse(), s = `active.any-link.blank.checked.current.default.defined.dir.disabled.drop.empty.enabled.first.first-child.first-of-type.fullscreen.future.focus.focus-visible.focus-within.has.host.host-context.hover.indeterminate.in-range.invalid.is.lang.last-child.last-of-type.left.link.local-link.not.nth-child.nth-col.nth-last-child.nth-last-col.nth-last-of-type.nth-of-type.only-child.only-of-type.optional.out-of-range.past.placeholder-shown.read-only.read-write.required.right.root.scope.target.target-within.user-invalid.valid.visited.where`.split(`.`).sort().reverse(), c = [
            `after`,
            `backdrop`,
            `before`,
            `cue`,
            `cue-region`,
            `first-letter`,
            `first-line`,
            `grammar-error`,
            `marker`,
            `part`,
            `placeholder`,
            `selection`,
            `slotted`,
            `spelling-error`
        ].sort().reverse(), l = `accent-color.align-content.align-items.align-self.alignment-baseline.all.anchor-name.animation.animation-composition.animation-delay.animation-direction.animation-duration.animation-fill-mode.animation-iteration-count.animation-name.animation-play-state.animation-range.animation-range-end.animation-range-start.animation-timeline.animation-timing-function.appearance.aspect-ratio.backdrop-filter.backface-visibility.background.background-attachment.background-blend-mode.background-clip.background-color.background-image.background-origin.background-position.background-position-x.background-position-y.background-repeat.background-size.baseline-shift.block-size.border.border-block.border-block-color.border-block-end.border-block-end-color.border-block-end-style.border-block-end-width.border-block-start.border-block-start-color.border-block-start-style.border-block-start-width.border-block-style.border-block-width.border-bottom.border-bottom-color.border-bottom-left-radius.border-bottom-right-radius.border-bottom-style.border-bottom-width.border-collapse.border-color.border-end-end-radius.border-end-start-radius.border-image.border-image-outset.border-image-repeat.border-image-slice.border-image-source.border-image-width.border-inline.border-inline-color.border-inline-end.border-inline-end-color.border-inline-end-style.border-inline-end-width.border-inline-start.border-inline-start-color.border-inline-start-style.border-inline-start-width.border-inline-style.border-inline-width.border-left.border-left-color.border-left-style.border-left-width.border-radius.border-right.border-right-color.border-right-style.border-right-width.border-spacing.border-start-end-radius.border-start-start-radius.border-style.border-top.border-top-color.border-top-left-radius.border-top-right-radius.border-top-style.border-top-width.border-width.bottom.box-align.box-decoration-break.box-direction.box-flex.box-flex-group.box-lines.box-ordinal-group.box-orient.box-pack.box-shadow.box-sizing.break-after.break-before.break-inside.caption-side.caret-color.clear.clip.clip-path.clip-rule.color.color-interpolation.color-interpolation-filters.color-profile.color-rendering.color-scheme.column-count.column-fill.column-gap.column-rule.column-rule-color.column-rule-style.column-rule-width.column-span.column-width.columns.contain.contain-intrinsic-block-size.contain-intrinsic-height.contain-intrinsic-inline-size.contain-intrinsic-size.contain-intrinsic-width.container.container-name.container-type.content.content-visibility.counter-increment.counter-reset.counter-set.cue.cue-after.cue-before.cursor.cx.cy.direction.display.dominant-baseline.empty-cells.enable-background.field-sizing.fill.fill-opacity.fill-rule.filter.flex.flex-basis.flex-direction.flex-flow.flex-grow.flex-shrink.flex-wrap.float.flood-color.flood-opacity.flow.font.font-display.font-family.font-feature-settings.font-kerning.font-language-override.font-optical-sizing.font-palette.font-size.font-size-adjust.font-smooth.font-smoothing.font-stretch.font-style.font-synthesis.font-synthesis-position.font-synthesis-small-caps.font-synthesis-style.font-synthesis-weight.font-variant.font-variant-alternates.font-variant-caps.font-variant-east-asian.font-variant-emoji.font-variant-ligatures.font-variant-numeric.font-variant-position.font-variation-settings.font-weight.forced-color-adjust.gap.glyph-orientation-horizontal.glyph-orientation-vertical.grid.grid-area.grid-auto-columns.grid-auto-flow.grid-auto-rows.grid-column.grid-column-end.grid-column-start.grid-gap.grid-row.grid-row-end.grid-row-start.grid-template.grid-template-areas.grid-template-columns.grid-template-rows.hanging-punctuation.height.hyphenate-character.hyphenate-limit-chars.hyphens.icon.image-orientation.image-rendering.image-resolution.ime-mode.initial-letter.initial-letter-align.inline-size.inset.inset-area.inset-block.inset-block-end.inset-block-start.inset-inline.inset-inline-end.inset-inline-start.isolation.justify-content.justify-items.justify-self.kerning.left.letter-spacing.lighting-color.line-break.line-height.line-height-step.list-style.list-style-image.list-style-position.list-style-type.margin.margin-block.margin-block-end.margin-block-start.margin-bottom.margin-inline.margin-inline-end.margin-inline-start.margin-left.margin-right.margin-top.margin-trim.marker.marker-end.marker-mid.marker-start.marks.mask.mask-border.mask-border-mode.mask-border-outset.mask-border-repeat.mask-border-slice.mask-border-source.mask-border-width.mask-clip.mask-composite.mask-image.mask-mode.mask-origin.mask-position.mask-repeat.mask-size.mask-type.masonry-auto-flow.math-depth.math-shift.math-style.max-block-size.max-height.max-inline-size.max-width.min-block-size.min-height.min-inline-size.min-width.mix-blend-mode.nav-down.nav-index.nav-left.nav-right.nav-up.none.normal.object-fit.object-position.offset.offset-anchor.offset-distance.offset-path.offset-position.offset-rotate.opacity.order.orphans.outline.outline-color.outline-offset.outline-style.outline-width.overflow.overflow-anchor.overflow-block.overflow-clip-margin.overflow-inline.overflow-wrap.overflow-x.overflow-y.overlay.overscroll-behavior.overscroll-behavior-block.overscroll-behavior-inline.overscroll-behavior-x.overscroll-behavior-y.padding.padding-block.padding-block-end.padding-block-start.padding-bottom.padding-inline.padding-inline-end.padding-inline-start.padding-left.padding-right.padding-top.page.page-break-after.page-break-before.page-break-inside.paint-order.pause.pause-after.pause-before.perspective.perspective-origin.place-content.place-items.place-self.pointer-events.position.position-anchor.position-visibility.print-color-adjust.quotes.r.resize.rest.rest-after.rest-before.right.rotate.row-gap.ruby-align.ruby-position.scale.scroll-behavior.scroll-margin.scroll-margin-block.scroll-margin-block-end.scroll-margin-block-start.scroll-margin-bottom.scroll-margin-inline.scroll-margin-inline-end.scroll-margin-inline-start.scroll-margin-left.scroll-margin-right.scroll-margin-top.scroll-padding.scroll-padding-block.scroll-padding-block-end.scroll-padding-block-start.scroll-padding-bottom.scroll-padding-inline.scroll-padding-inline-end.scroll-padding-inline-start.scroll-padding-left.scroll-padding-right.scroll-padding-top.scroll-snap-align.scroll-snap-stop.scroll-snap-type.scroll-timeline.scroll-timeline-axis.scroll-timeline-name.scrollbar-color.scrollbar-gutter.scrollbar-width.shape-image-threshold.shape-margin.shape-outside.shape-rendering.speak.speak-as.src.stop-color.stop-opacity.stroke.stroke-dasharray.stroke-dashoffset.stroke-linecap.stroke-linejoin.stroke-miterlimit.stroke-opacity.stroke-width.tab-size.table-layout.text-align.text-align-all.text-align-last.text-anchor.text-combine-upright.text-decoration.text-decoration-color.text-decoration-line.text-decoration-skip.text-decoration-skip-ink.text-decoration-style.text-decoration-thickness.text-emphasis.text-emphasis-color.text-emphasis-position.text-emphasis-style.text-indent.text-justify.text-orientation.text-overflow.text-rendering.text-shadow.text-size-adjust.text-transform.text-underline-offset.text-underline-position.text-wrap.text-wrap-mode.text-wrap-style.timeline-scope.top.touch-action.transform.transform-box.transform-origin.transform-style.transition.transition-behavior.transition-delay.transition-duration.transition-property.transition-timing-function.translate.unicode-bidi.user-modify.user-select.vector-effect.vertical-align.view-timeline.view-timeline-axis.view-timeline-inset.view-timeline-name.view-transition-name.visibility.voice-balance.voice-duration.voice-family.voice-pitch.voice-range.voice-rate.voice-stress.voice-volume.white-space.white-space-collapse.widows.width.will-change.word-break.word-spacing.word-wrap.writing-mode.x.y.z-index.zoom`.split(`.`).sort().reverse();
        function u(e) {
            let t = n(e), r = {
                className: `variable`,
                begin: `\\$` + e.IDENT_RE
            }, i = [
                `charset`,
                `css`,
                `debug`,
                `extend`,
                `font-face`,
                `for`,
                `import`,
                `include`,
                `keyframes`,
                `media`,
                `mixin`,
                `page`,
                `warn`,
                `while`
            ], u = `(?=[.\\s\\n[:,(])`;
            return {
                name: `Stylus`,
                aliases: [
                    `styl`
                ],
                case_insensitive: !1,
                keywords: `if else for in`,
                illegal: `(` + [
                    `\\?`,
                    `(\\bReturn\\b)`,
                    `(\\bEnd\\b)`,
                    `(\\bend\\b)`,
                    `(\\bdef\\b)`,
                    `;`,
                    `#\\s`,
                    `\\*\\s`,
                    `===\\s`,
                    `\\|`,
                    `%`
                ].join(`|`) + `)`,
                contains: [
                    e.QUOTE_STRING_MODE,
                    e.APOS_STRING_MODE,
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    t.HEXCOLOR,
                    {
                        begin: `\\.[a-zA-Z][a-zA-Z0-9_-]*` + u,
                        className: `selector-class`
                    },
                    {
                        begin: `#[a-zA-Z][a-zA-Z0-9_-]*` + u,
                        className: `selector-id`
                    },
                    {
                        begin: `\\b(` + a.join(`|`) + `)(?=[.\\s\\n[:,(])`,
                        className: `selector-tag`
                    },
                    {
                        className: `selector-pseudo`,
                        begin: `&?:(` + s.join(`|`) + `)(?=[.\\s\\n[:,(])`
                    },
                    {
                        className: `selector-pseudo`,
                        begin: `&?:(:)?(` + c.join(`|`) + `)(?=[.\\s\\n[:,(])`
                    },
                    t.ATTRIBUTE_SELECTOR_MODE,
                    {
                        className: `keyword`,
                        begin: /@media/,
                        starts: {
                            end: /[{;}]/,
                            keywords: {
                                $pattern: /[a-z-]+/,
                                keyword: `and or not only`,
                                attribute: o.join(` `)
                            },
                            contains: [
                                t.CSS_NUMBER_MODE
                            ]
                        }
                    },
                    {
                        className: `keyword`,
                        begin: `@((-(o|moz|ms|webkit)-)?(` + i.join(`|`) + `))\\b`
                    },
                    r,
                    t.CSS_NUMBER_MODE,
                    {
                        className: `function`,
                        begin: `^[a-zA-Z][a-zA-Z0-9_-]*\\(.*\\)`,
                        illegal: `[\\n]`,
                        returnBegin: !0,
                        contains: [
                            {
                                className: `title`,
                                begin: `\\b[a-zA-Z][a-zA-Z0-9_-]*`
                            },
                            {
                                className: `params`,
                                begin: /\(/,
                                end: /\)/,
                                contains: [
                                    t.HEXCOLOR,
                                    r,
                                    e.APOS_STRING_MODE,
                                    t.CSS_NUMBER_MODE,
                                    e.QUOTE_STRING_MODE
                                ]
                            }
                        ]
                    },
                    t.CSS_VARIABLE,
                    {
                        className: `attribute`,
                        begin: `\\b(` + l.join(`|`) + `)\\b`,
                        starts: {
                            end: /;|$/,
                            contains: [
                                t.HEXCOLOR,
                                r,
                                e.APOS_STRING_MODE,
                                e.QUOTE_STRING_MODE,
                                t.CSS_NUMBER_MODE,
                                e.C_BLOCK_COMMENT_MODE,
                                t.IMPORTANT,
                                t.FUNCTION_DISPATCH
                            ],
                            illegal: /\./,
                            relevance: 0
                        }
                    },
                    t.FUNCTION_DISPATCH
                ]
            };
        }
        t.exports = u;
    }), bn = o((e, t)=>{
        function n(e) {
            return {
                name: `SubUnit`,
                case_insensitive: !0,
                contains: [
                    {
                        className: `string`,
                        begin: `\\[
(multipart)?`,
                        end: `\\]
`
                    },
                    {
                        className: `string`,
                        begin: `\\d{4}-\\d{2}-\\d{2}(\\s+)\\d{2}:\\d{2}:\\d{2}.\\d+Z`
                    },
                    {
                        className: `string`,
                        begin: `(\\+|-)\\d+`
                    },
                    {
                        className: `keyword`,
                        relevance: 10,
                        variants: [
                            {
                                begin: `^(test|testing|success|successful|failure|error|skip|xfail|uxsuccess)(:?)\\s+(test)?`
                            },
                            {
                                begin: `^progress(:?)(\\s+)?(pop|push)?`
                            },
                            {
                                begin: `^tags:`
                            },
                            {
                                begin: `^time:`
                            }
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), xn = o((e, t)=>{
        function n(e) {
            return e ? typeof e == `string` ? e : e.source : null;
        }
        function r(e) {
            return i(`(?=`, e, `)`);
        }
        function i(...e) {
            return e.map((e)=>n(e)).join(``);
        }
        function a(e) {
            let t = e[e.length - 1];
            return typeof t == `object` && t.constructor === Object ? (e.splice(e.length - 1, 1), t) : {};
        }
        function o(...e) {
            return `(` + (a(e).capture ? `` : `?:`) + e.map((e)=>n(e)).join(`|`) + `)`;
        }
        var s = (e)=>i(/\b/, e, /\w$/.test(e) ? /\b/ : /\B/), c = [
            `Protocol`,
            `Type`
        ].map(s), l = [
            `init`,
            `self`
        ].map(s), u = [
            `Any`,
            `Self`
        ], d = [
            `actor`,
            `any`,
            `associatedtype`,
            `async`,
            `await`,
            /as\?/,
            /as!/,
            `as`,
            `borrowing`,
            `break`,
            `case`,
            `catch`,
            `class`,
            `consume`,
            `consuming`,
            `continue`,
            `convenience`,
            `copy`,
            `default`,
            `defer`,
            `deinit`,
            `didSet`,
            `distributed`,
            `do`,
            `dynamic`,
            `each`,
            `else`,
            `enum`,
            `extension`,
            `fallthrough`,
            /fileprivate\(set\)/,
            `fileprivate`,
            `final`,
            `for`,
            `func`,
            `get`,
            `guard`,
            `if`,
            `import`,
            `indirect`,
            `infix`,
            /init\?/,
            /init!/,
            `inout`,
            /internal\(set\)/,
            `internal`,
            `in`,
            `is`,
            `isolated`,
            `nonisolated`,
            `lazy`,
            `let`,
            `macro`,
            `mutating`,
            `nonmutating`,
            /open\(set\)/,
            `open`,
            `operator`,
            `optional`,
            `override`,
            `package`,
            `postfix`,
            `precedencegroup`,
            `prefix`,
            /private\(set\)/,
            `private`,
            `protocol`,
            /public\(set\)/,
            `public`,
            `repeat`,
            `required`,
            `rethrows`,
            `return`,
            `set`,
            `some`,
            `static`,
            `struct`,
            `subscript`,
            `super`,
            `switch`,
            `throws`,
            `throw`,
            /try\?/,
            /try!/,
            `try`,
            `typealias`,
            /unowned\(safe\)/,
            /unowned\(unsafe\)/,
            `unowned`,
            `var`,
            `weak`,
            `where`,
            `while`,
            `willSet`
        ], f = [
            `false`,
            `nil`,
            `true`
        ], p = [
            `assignment`,
            `associativity`,
            `higherThan`,
            `left`,
            `lowerThan`,
            `none`,
            `right`
        ], m = [
            `#colorLiteral`,
            `#column`,
            `#dsohandle`,
            `#else`,
            `#elseif`,
            `#endif`,
            `#error`,
            `#file`,
            `#fileID`,
            `#fileLiteral`,
            `#filePath`,
            `#function`,
            `#if`,
            `#imageLiteral`,
            `#keyPath`,
            `#line`,
            `#selector`,
            `#sourceLocation`,
            `#warning`
        ], h = `abs.all.any.assert.assertionFailure.debugPrint.dump.fatalError.getVaList.isKnownUniquelyReferenced.max.min.numericCast.pointwiseMax.pointwiseMin.precondition.preconditionFailure.print.readLine.repeatElement.sequence.stride.swap.swift_unboxFromSwiftValueWithType.transcode.type.unsafeBitCast.unsafeDowncast.withExtendedLifetime.withUnsafeMutablePointer.withUnsafePointer.withVaList.withoutActuallyEscaping.zip`.split(`.`), g = o(/[/=\-+!*%<>&|^~?]/, /[\u00A1-\u00A7]/, /[\u00A9\u00AB]/, /[\u00AC\u00AE]/, /[\u00B0\u00B1]/, /[\u00B6\u00BB\u00BF\u00D7\u00F7]/, /[\u2016-\u2017]/, /[\u2020-\u2027]/, /[\u2030-\u203E]/, /[\u2041-\u2053]/, /[\u2055-\u205E]/, /[\u2190-\u23FF]/, /[\u2500-\u2775]/, /[\u2794-\u2BFF]/, /[\u2E00-\u2E7F]/, /[\u3001-\u3003]/, /[\u3008-\u3020]/, /[\u3030]/), _ = o(g, /[\u0300-\u036F]/, /[\u1DC0-\u1DFF]/, /[\u20D0-\u20FF]/, /[\uFE00-\uFE0F]/, /[\uFE20-\uFE2F]/), v = i(g, _, `*`), y = o(/[a-zA-Z_]/, /[\u00A8\u00AA\u00AD\u00AF\u00B2-\u00B5\u00B7-\u00BA]/, /[\u00BC-\u00BE\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]/, /[\u0100-\u02FF\u0370-\u167F\u1681-\u180D\u180F-\u1DBF]/, /[\u1E00-\u1FFF]/, /[\u200B-\u200D\u202A-\u202E\u203F-\u2040\u2054\u2060-\u206F]/, /[\u2070-\u20CF\u2100-\u218F\u2460-\u24FF\u2776-\u2793]/, /[\u2C00-\u2DFF\u2E80-\u2FFF]/, /[\u3004-\u3007\u3021-\u302F\u3031-\u303F\u3040-\uD7FF]/, /[\uF900-\uFD3D\uFD40-\uFDCF\uFDF0-\uFE1F\uFE30-\uFE44]/, /[\uFE47-\uFEFE\uFF00-\uFFFD]/), b = o(y, /\d/, /[\u0300-\u036F\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]/), x = i(y, b, `*`), S = i(/[A-Z]/, b, `*`), C = [
            `attached`,
            `autoclosure`,
            i(/convention\(/, o(`swift`, `block`, `c`), /\)/),
            `discardableResult`,
            `dynamicCallable`,
            `dynamicMemberLookup`,
            `escaping`,
            `freestanding`,
            `frozen`,
            `GKInspectable`,
            `IBAction`,
            `IBDesignable`,
            `IBInspectable`,
            `IBOutlet`,
            `IBSegueAction`,
            `inlinable`,
            `main`,
            `nonobjc`,
            `NSApplicationMain`,
            `NSCopying`,
            `NSManaged`,
            i(/objc\(/, x, /\)/),
            `objc`,
            `objcMembers`,
            `propertyWrapper`,
            `requires_stored_property_inits`,
            `resultBuilder`,
            `Sendable`,
            `testable`,
            `UIApplicationMain`,
            `unchecked`,
            `unknown`,
            `usableFromInline`,
            `warn_unqualified_access`
        ], w = [
            `iOS`,
            `iOSApplicationExtension`,
            `macOS`,
            `macOSApplicationExtension`,
            `macCatalyst`,
            `macCatalystApplicationExtension`,
            `watchOS`,
            `watchOSApplicationExtension`,
            `tvOS`,
            `tvOSApplicationExtension`,
            `swift`
        ];
        function T(e) {
            let t = {
                match: /\s+/,
                relevance: 0
            }, n = e.COMMENT(`/\\*`, `\\*/`, {
                contains: [
                    `self`
                ]
            }), a = [
                e.C_LINE_COMMENT_MODE,
                n
            ], g = {
                match: [
                    /\./,
                    o(...c, ...l)
                ],
                className: {
                    2: `keyword`
                }
            }, y = {
                match: i(/\./, o(...d)),
                relevance: 0
            }, T = d.filter((e)=>typeof e == `string`).concat([
                `_|0`
            ]), E = {
                variants: [
                    {
                        className: `keyword`,
                        match: o(...d.filter((e)=>typeof e != `string`).concat(u).map(s), ...l)
                    }
                ]
            }, D = {
                $pattern: o(/\b\w+/, /#\w+/),
                keyword: T.concat(m),
                literal: f
            }, O = [
                g,
                y,
                E
            ], k = [
                {
                    match: i(/\./, o(...h)),
                    relevance: 0
                },
                {
                    className: `built_in`,
                    match: i(/\b/, o(...h), /(?=\()/)
                }
            ], A = {
                match: /->/,
                relevance: 0
            }, j = [
                A,
                {
                    className: `operator`,
                    relevance: 0,
                    variants: [
                        {
                            match: v
                        },
                        {
                            match: `\\.(\\.|${_})+`
                        }
                    ]
                }
            ], M = `([0-9]_*)+`, N = `([0-9a-fA-F]_*)+`, P = {
                className: `number`,
                relevance: 0,
                variants: [
                    {
                        match: `\\b(${M})(\\.(${M}))?([eE][+-]?(${M}))?\\b`
                    },
                    {
                        match: `\\b0x(${N})(\\.(${N}))?([pP][+-]?(${M}))?\\b`
                    },
                    {
                        match: /\b0o([0-7]_*)+\b/
                    },
                    {
                        match: /\b0b([01]_*)+\b/
                    }
                ]
            }, F = (e = ``)=>({
                    className: `subst`,
                    variants: [
                        {
                            match: i(/\\/, e, /[0\\tnr"']/)
                        },
                        {
                            match: i(/\\/, e, /u\{[0-9a-fA-F]{1,8}\}/)
                        }
                    ]
                }), I = (e = ``)=>({
                    className: `subst`,
                    match: i(/\\/, e, /[\t ]*(?:[\r\n]|\r\n)/)
                }), L = (e = ``)=>({
                    className: `subst`,
                    label: `interpol`,
                    begin: i(/\\/, e, /\(/),
                    end: /\)/
                }), R = (e = ``)=>({
                    begin: i(e, /"""/),
                    end: i(/"""/, e),
                    contains: [
                        F(e),
                        I(e),
                        L(e)
                    ]
                }), z = (e = ``)=>({
                    begin: i(e, /"/),
                    end: i(/"/, e),
                    contains: [
                        F(e),
                        L(e)
                    ]
                }), B = {
                className: `string`,
                variants: [
                    R(),
                    R(`#`),
                    R(`##`),
                    R(`###`),
                    z(),
                    z(`#`),
                    z(`##`),
                    z(`###`)
                ]
            }, ee = [
                e.BACKSLASH_ESCAPE,
                {
                    begin: /\[/,
                    end: /\]/,
                    relevance: 0,
                    contains: [
                        e.BACKSLASH_ESCAPE
                    ]
                }
            ], te = {
                begin: /\/[^\s](?=[^/\n]*\/)/,
                end: /\//,
                contains: ee
            }, V = (e)=>{
                let t = i(e, /\//), n = i(/\//, e);
                return {
                    begin: t,
                    end: n,
                    contains: [
                        ...ee,
                        {
                            scope: `comment`,
                            begin: `#(?!.*${n})`,
                            end: /$/
                        }
                    ]
                };
            }, ne = {
                scope: `regexp`,
                variants: [
                    V(`###`),
                    V(`##`),
                    V(`#`),
                    te
                ]
            }, H = {
                match: i(/`/, x, /`/)
            }, U = [
                H,
                {
                    className: `variable`,
                    match: /\$\d+/
                },
                {
                    className: `variable`,
                    match: `\\$${b}+`
                }
            ], W = [
                {
                    match: /(@|#(un)?)available/,
                    scope: `keyword`,
                    starts: {
                        contains: [
                            {
                                begin: /\(/,
                                end: /\)/,
                                keywords: w,
                                contains: [
                                    ...j,
                                    P,
                                    B
                                ]
                            }
                        ]
                    }
                },
                {
                    scope: `keyword`,
                    match: i(/@/, o(...C), r(o(/\(/, /\s+/)))
                },
                {
                    scope: `meta`,
                    match: i(/@/, x)
                }
            ], G = {
                match: r(/\b[A-Z]/),
                relevance: 0,
                contains: [
                    {
                        className: `type`,
                        match: i(/(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)/, b, `+`)
                    },
                    {
                        className: `type`,
                        match: S,
                        relevance: 0
                    },
                    {
                        match: /[?!]+/,
                        relevance: 0
                    },
                    {
                        match: /\.\.\./,
                        relevance: 0
                    },
                    {
                        match: i(/\s+&\s+/, r(S)),
                        relevance: 0
                    }
                ]
            }, re = {
                begin: /</,
                end: />/,
                keywords: D,
                contains: [
                    ...a,
                    ...O,
                    ...W,
                    A,
                    G
                ]
            };
            G.contains.push(re);
            let ie = {
                begin: /\(/,
                end: /\)/,
                relevance: 0,
                keywords: D,
                contains: [
                    `self`,
                    {
                        match: i(x, /\s*:/),
                        keywords: `_|0`,
                        relevance: 0
                    },
                    ...a,
                    ne,
                    ...O,
                    ...k,
                    ...j,
                    P,
                    B,
                    ...U,
                    ...W,
                    G
                ]
            }, K = {
                begin: /</,
                end: />/,
                keywords: `repeat each`,
                contains: [
                    ...a,
                    G
                ]
            }, ae = {
                begin: /\(/,
                end: /\)/,
                keywords: D,
                contains: [
                    {
                        begin: o(r(i(x, /\s*:/)), r(i(x, /\s+/, x, /\s*:/))),
                        end: /:/,
                        relevance: 0,
                        contains: [
                            {
                                className: `keyword`,
                                match: /\b_\b/
                            },
                            {
                                className: `params`,
                                match: x
                            }
                        ]
                    },
                    ...a,
                    ...O,
                    ...j,
                    P,
                    B,
                    ...W,
                    G,
                    ie
                ],
                endsParent: !0,
                illegal: /["']/
            }, oe = {
                match: [
                    /(func|macro)/,
                    /\s+/,
                    o(H.match, x, v)
                ],
                className: {
                    1: `keyword`,
                    3: `title.function`
                },
                contains: [
                    K,
                    ae,
                    t
                ],
                illegal: [
                    /\[/,
                    /%/
                ]
            }, se = {
                match: [
                    /\b(?:subscript|init[?!]?)/,
                    /\s*(?=[<(])/
                ],
                className: {
                    1: `keyword`
                },
                contains: [
                    K,
                    ae,
                    t
                ],
                illegal: /\[|%/
            }, ce = {
                match: [
                    /operator/,
                    /\s+/,
                    v
                ],
                className: {
                    1: `keyword`,
                    3: `title`
                }
            }, le = {
                begin: [
                    /precedencegroup/,
                    /\s+/,
                    S
                ],
                className: {
                    1: `keyword`,
                    3: `title`
                },
                contains: [
                    G
                ],
                keywords: [
                    ...p,
                    ...f
                ],
                end: /}/
            }, q = {
                match: [
                    /class\b/,
                    /\s+/,
                    /func\b/,
                    /\s+/,
                    /\b[A-Za-z_][A-Za-z0-9_]*\b/
                ],
                scope: {
                    1: `keyword`,
                    3: `keyword`,
                    5: `title.function`
                }
            }, ue = {
                match: [
                    /class\b/,
                    /\s+/,
                    /var\b/
                ],
                scope: {
                    1: `keyword`,
                    3: `keyword`
                }
            }, de = {
                begin: [
                    /(struct|protocol|class|extension|enum|actor)/,
                    /\s+/,
                    x,
                    /\s*/
                ],
                beginScope: {
                    1: `keyword`,
                    3: `title.class`
                },
                keywords: D,
                contains: [
                    K,
                    ...O,
                    {
                        begin: /:/,
                        end: /\{/,
                        keywords: D,
                        contains: [
                            {
                                scope: `title.class.inherited`,
                                match: S
                            },
                            ...O
                        ],
                        relevance: 0
                    }
                ]
            };
            for (let e of B.variants){
                let t = e.contains.find((e)=>e.label === `interpol`);
                t.keywords = D;
                let n = [
                    ...O,
                    ...k,
                    ...j,
                    P,
                    B,
                    ...U
                ];
                t.contains = [
                    ...n,
                    {
                        begin: /\(/,
                        end: /\)/,
                        contains: [
                            `self`,
                            ...n
                        ]
                    }
                ];
            }
            return {
                name: `Swift`,
                keywords: D,
                contains: [
                    ...a,
                    oe,
                    se,
                    q,
                    ue,
                    de,
                    ce,
                    le,
                    {
                        beginKeywords: `import`,
                        end: /$/,
                        contains: [
                            ...a
                        ],
                        relevance: 0
                    },
                    ne,
                    ...O,
                    ...k,
                    ...j,
                    P,
                    B,
                    ...U,
                    ...W,
                    G,
                    ie
                ]
            };
        }
        t.exports = T;
    }), Sn = o((e, t)=>{
        function n(e) {
            return {
                name: `Tagger Script`,
                contains: [
                    {
                        className: `comment`,
                        begin: /\$noop\(/,
                        end: /\)/,
                        contains: [
                            {
                                begin: /\\[()]/
                            },
                            {
                                begin: /\(/,
                                end: /\)/,
                                contains: [
                                    {
                                        begin: /\\[()]/
                                    },
                                    `self`
                                ]
                            }
                        ],
                        relevance: 10
                    },
                    {
                        className: `keyword`,
                        begin: /\$[_a-zA-Z0-9]+(?=\()/
                    },
                    {
                        className: `variable`,
                        begin: /%[_a-zA-Z0-9:]+%/
                    },
                    {
                        className: `symbol`,
                        begin: /\\[\\nt$%,()]/
                    },
                    {
                        className: `symbol`,
                        begin: /\\u[a-fA-F0-9]{4}/
                    }
                ]
            };
        }
        t.exports = n;
    }), Cn = o((e, t)=>{
        function n(e) {
            let t = `true false yes no null`, n = `[\\w#;/?:@&=+$,.~*'()[\\]]+`, r = {
                className: `attr`,
                variants: [
                    {
                        begin: /[\w*@][\w*@ :()\./-]*:(?=[ \t]|$)/
                    },
                    {
                        begin: /"[\w*@][\w*@ :()\./-]*":(?=[ \t]|$)/
                    },
                    {
                        begin: /'[\w*@][\w*@ :()\./-]*':(?=[ \t]|$)/
                    }
                ]
            }, i = {
                className: `template-variable`,
                variants: [
                    {
                        begin: /\{\{/,
                        end: /\}\}/
                    },
                    {
                        begin: /%\{/,
                        end: /\}/
                    }
                ]
            }, a = {
                className: `string`,
                relevance: 0,
                begin: /'/,
                end: /'/,
                contains: [
                    {
                        match: /''/,
                        scope: `char.escape`,
                        relevance: 0
                    }
                ]
            }, o = {
                className: `string`,
                relevance: 0,
                variants: [
                    {
                        begin: /"/,
                        end: /"/
                    },
                    {
                        begin: /\S+/
                    }
                ],
                contains: [
                    e.BACKSLASH_ESCAPE,
                    i
                ]
            }, s = e.inherit(o, {
                variants: [
                    {
                        begin: /'/,
                        end: /'/,
                        contains: [
                            {
                                begin: /''/,
                                relevance: 0
                            }
                        ]
                    },
                    {
                        begin: /"/,
                        end: /"/
                    },
                    {
                        begin: /[^\s,{}[\]]+/
                    }
                ]
            }), c = {
                className: `number`,
                begin: `\\b[0-9]{4}(-[0-9][0-9]){0,2}([Tt \\t][0-9][0-9]?(:[0-9][0-9]){2})?(\\.[0-9]*)?([ \\t])*(Z|[-+][0-9][0-9]?(:[0-9][0-9])?)?\\b`
            }, l = {
                end: `,`,
                endsWithParent: !0,
                excludeEnd: !0,
                keywords: t,
                relevance: 0
            }, u = {
                begin: /\{/,
                end: /\}/,
                contains: [
                    l
                ],
                illegal: `\\n`,
                relevance: 0
            }, d = {
                begin: `\\[`,
                end: `\\]`,
                contains: [
                    l
                ],
                illegal: `\\n`,
                relevance: 0
            }, f = [
                r,
                {
                    className: `meta`,
                    begin: `^---\\s*$`,
                    relevance: 10
                },
                {
                    className: `string`,
                    begin: `[\\|>]([1-9]?[+-])?[ ]*\\n( +)[^ ][^\\n]*\\n(\\2[^\\n]+\\n?)*`
                },
                {
                    begin: `<%[%=-]?`,
                    end: `[%-]?%>`,
                    subLanguage: `ruby`,
                    excludeBegin: !0,
                    excludeEnd: !0,
                    relevance: 0
                },
                {
                    className: `type`,
                    begin: `!\\w+!` + n
                },
                {
                    className: `type`,
                    begin: `!<` + n + `>`
                },
                {
                    className: `type`,
                    begin: `!` + n
                },
                {
                    className: `type`,
                    begin: `!!` + n
                },
                {
                    className: `meta`,
                    begin: `&` + e.UNDERSCORE_IDENT_RE + `$`
                },
                {
                    className: `meta`,
                    begin: `\\*` + e.UNDERSCORE_IDENT_RE + `$`
                },
                {
                    className: `bullet`,
                    begin: `-(?=[ ]|$)`,
                    relevance: 0
                },
                e.HASH_COMMENT_MODE,
                {
                    beginKeywords: t,
                    keywords: {
                        literal: t
                    }
                },
                c,
                {
                    className: `number`,
                    begin: e.C_NUMBER_RE + `\\b`,
                    relevance: 0
                },
                u,
                d,
                a,
                o
            ], p = [
                ...f
            ];
            return p.pop(), p.push(s), l.contains = p, {
                name: `YAML`,
                case_insensitive: !0,
                aliases: [
                    `yml`
                ],
                contains: f
            };
        }
        t.exports = n;
    }), wn = o((e, t)=>{
        function n(e) {
            return {
                name: `Test Anything Protocol`,
                case_insensitive: !0,
                contains: [
                    e.HASH_COMMENT_MODE,
                    {
                        className: `meta`,
                        variants: [
                            {
                                begin: `^TAP version (\\d+)$`
                            },
                            {
                                begin: `^1\\.\\.(\\d+)$`
                            }
                        ]
                    },
                    {
                        begin: /---$/,
                        end: `\\.\\.\\.$`,
                        subLanguage: `yaml`,
                        relevance: 0
                    },
                    {
                        className: `number`,
                        begin: ` (\\d+) `
                    },
                    {
                        className: `symbol`,
                        variants: [
                            {
                                begin: `^ok`
                            },
                            {
                                begin: `^not ok`
                            }
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), Tn = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = /[a-zA-Z_][a-zA-Z0-9_]*/, r = {
                className: `number`,
                variants: [
                    e.BINARY_NUMBER_MODE,
                    e.C_NUMBER_MODE
                ]
            };
            return {
                name: `Tcl`,
                aliases: [
                    `tk`
                ],
                keywords: `after.append.apply.array.auto_execok.auto_import.auto_load.auto_mkindex.auto_mkindex_old.auto_qualify.auto_reset.bgerror.binary.break.catch.cd.chan.clock.close.concat.continue.dde.dict.encoding.eof.error.eval.exec.exit.expr.fblocked.fconfigure.fcopy.file.fileevent.filename.flush.for.foreach.format.gets.glob.global.history.http.if.incr.info.interp.join.lappend|10.lassign|10.lindex|10.linsert|10.list.llength|10.load.lrange|10.lrepeat|10.lreplace|10.lreverse|10.lsearch|10.lset|10.lsort|10.mathfunc.mathop.memory.msgcat.namespace.open.package.parray.pid.pkg::create.pkg_mkIndex.platform.platform::shell.proc.puts.pwd.read.refchan.regexp.registry.regsub|10.rename.return.safe.scan.seek.set.socket.source.split.string.subst.switch.tcl_endOfWord.tcl_findLibrary.tcl_startOfNextWord.tcl_startOfPreviousWord.tcl_wordBreakAfter.tcl_wordBreakBefore.tcltest.tclvars.tell.time.tm.trace.unknown.unload.unset.update.uplevel.upvar.variable.vwait.while`.split(`.`),
                contains: [
                    e.COMMENT(`;[ \\t]*#`, `$`),
                    e.COMMENT(`^[ \\t]*#`, `$`),
                    {
                        beginKeywords: `proc`,
                        end: `[\\{]`,
                        excludeEnd: !0,
                        contains: [
                            {
                                className: `title`,
                                begin: `[ \\t\\n\\r]+(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*`,
                                end: `[ \\t\\n\\r]`,
                                endsWithParent: !0,
                                excludeEnd: !0
                            }
                        ]
                    },
                    {
                        className: `variable`,
                        variants: [
                            {
                                begin: t.concat(/\$/, t.optional(/::/), n, `(::`, n, `)*`)
                            },
                            {
                                begin: `\\$\\{(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*`,
                                end: `\\}`,
                                contains: [
                                    r
                                ]
                            }
                        ]
                    },
                    {
                        className: `string`,
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ],
                        variants: [
                            e.inherit(e.QUOTE_STRING_MODE, {
                                illegal: null
                            })
                        ]
                    },
                    r
                ]
            };
        }
        t.exports = n;
    }), En = o((e, t)=>{
        function n(e) {
            let t = [
                `bool`,
                `byte`,
                `i16`,
                `i32`,
                `i64`,
                `double`,
                `string`,
                `binary`
            ];
            return {
                name: `Thrift`,
                keywords: {
                    keyword: [
                        `namespace`,
                        `const`,
                        `typedef`,
                        `struct`,
                        `enum`,
                        `service`,
                        `exception`,
                        `void`,
                        `oneway`,
                        `set`,
                        `list`,
                        `map`,
                        `required`,
                        `optional`
                    ],
                    type: t,
                    literal: `true false`
                },
                contains: [
                    e.QUOTE_STRING_MODE,
                    e.NUMBER_MODE,
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    {
                        className: `class`,
                        beginKeywords: `struct enum service exception`,
                        end: /\{/,
                        illegal: /\n/,
                        contains: [
                            e.inherit(e.TITLE_MODE, {
                                starts: {
                                    endsWithParent: !0,
                                    excludeEnd: !0
                                }
                            })
                        ]
                    },
                    {
                        begin: `\\b(set|list|map)\\s*<`,
                        keywords: {
                            type: [
                                ...t,
                                `set`,
                                `list`,
                                `map`
                            ]
                        },
                        end: `>`,
                        contains: [
                            `self`
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), Dn = o((e, t)=>{
        function n(e) {
            let t = {
                className: `number`,
                begin: `[1-9][0-9]*`,
                relevance: 0
            }, n = {
                className: `symbol`,
                begin: `:[^\\]]+`
            };
            return {
                name: `TP`,
                keywords: {
                    keyword: `ABORT.ACC.ADJUST.AND.AP_LD.BREAK.CALL.CNT.COL.CONDITION.CONFIG.DA.DB.DIV.DETECT.ELSE.END.ENDFOR.ERR_NUM.ERROR_PROG.FINE.FOR.GP.GUARD.INC.IF.JMP.LINEAR_MAX_SPEED.LOCK.MOD.MONITOR.OFFSET.Offset.OR.OVERRIDE.PAUSE.PREG.PTH.RT_LD.RUN.SELECT.SKIP.Skip.TA.TB.TO.TOOL_OFFSET.Tool_Offset.UF.UT.UFRAME_NUM.UTOOL_NUM.UNLOCK.WAIT.X.Y.Z.W.P.R.STRLEN.SUBSTR.FINDSTR.VOFFSET.PROG.ATTR.MN.POS`.split(`.`),
                    literal: [
                        `ON`,
                        `OFF`,
                        `max_speed`,
                        `LPOS`,
                        `JPOS`,
                        `ENABLE`,
                        `DISABLE`,
                        `START`,
                        `STOP`,
                        `RESET`
                    ]
                },
                contains: [
                    {
                        className: `built_in`,
                        begin: `(AR|P|PAYLOAD|PR|R|SR|RSR|LBL|VR|UALM|MESSAGE|UTOOL|UFRAME|TIMER|TIMER_OVERFLOW|JOINT_MAX_SPEED|RESUME_PROG|DIAG_REC)\\[`,
                        end: `\\]`,
                        contains: [
                            `self`,
                            t,
                            n
                        ]
                    },
                    {
                        className: `built_in`,
                        begin: `(AI|AO|DI|DO|F|RI|RO|UI|UO|GI|GO|SI|SO)\\[`,
                        end: `\\]`,
                        contains: [
                            `self`,
                            t,
                            e.QUOTE_STRING_MODE,
                            n
                        ]
                    },
                    {
                        className: `keyword`,
                        begin: `/(PROG|ATTR|MN|POS|END)\\b`
                    },
                    {
                        className: `keyword`,
                        begin: `(CALL|RUN|POINT_LOGIC|LBL)\\b`
                    },
                    {
                        className: `keyword`,
                        begin: `\\b(ACC|CNT|Skip|Offset|PSPD|RT_LD|AP_LD|Tool_Offset)`
                    },
                    {
                        className: `number`,
                        begin: `\\d+(sec|msec|mm/sec|cm/min|inch/min|deg/sec|mm|in|cm)?\\b`,
                        relevance: 0
                    },
                    e.COMMENT(`//`, `[;$]`),
                    e.COMMENT(`!`, `[;$]`),
                    e.COMMENT(`--eg:`, `$`),
                    e.QUOTE_STRING_MODE,
                    {
                        className: `string`,
                        begin: `'`,
                        end: `'`
                    },
                    e.C_NUMBER_MODE,
                    {
                        className: `variable`,
                        begin: `\\$[A-Za-z0-9_]+`
                    }
                ]
            };
        }
        t.exports = n;
    }), On = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = `absolute_url.asset|0.asset_version.attribute.block.constant.controller|0.country_timezones.csrf_token.cycle.date.dump.expression.form|0.form_end.form_errors.form_help.form_label.form_rest.form_row.form_start.form_widget.html_classes.include.is_granted.logout_path.logout_url.max.min.parent.path|0.random.range.relative_path.render.render_esi.source.template_from_string.url|0`.split(`.`), r = `abs.abbr_class.abbr_method.batch.capitalize.column.convert_encoding.country_name.currency_name.currency_symbol.data_uri.date.date_modify.default.escape.file_excerpt.file_link.file_relative.filter.first.format.format_args.format_args_as_text.format_currency.format_date.format_datetime.format_file.format_file_from_text.format_number.format_time.html_to_markdown.humanize.inky_to_html.inline_css.join.json_encode.keys.language_name.last.length.locale_name.lower.map.markdown.markdown_to_html.merge.nl2br.number_format.raw.reduce.replace.reverse.round.slice.slug.sort.spaceless.split.striptags.timezone_name.title.trans.transchoice.trim.u|0.upper.url_encode.yaml_dump.yaml_encode`.split(`.`), i = `apply.autoescape.block.cache.deprecated.do.embed.extends.filter.flush.for.form_theme.from.if.import.include.macro.sandbox.set.stopwatch.trans.trans_default_domain.transchoice.use.verbatim.with`.split(`.`);
            i = i.concat(i.map((e)=>`end${e}`));
            let a = {
                scope: `string`,
                variants: [
                    {
                        begin: /'/,
                        end: /'/
                    },
                    {
                        begin: /"/,
                        end: /"/
                    }
                ]
            }, o = {
                scope: `number`,
                match: /\d+/
            }, s = {
                begin: /\(/,
                end: /\)/,
                excludeBegin: !0,
                excludeEnd: !0,
                contains: [
                    a,
                    o
                ]
            }, c = {
                beginKeywords: n.join(` `),
                keywords: {
                    name: n
                },
                relevance: 0,
                contains: [
                    s
                ]
            }, l = {
                match: /\|(?=[A-Za-z_]+:?)/,
                beginScope: `punctuation`,
                relevance: 0,
                contains: [
                    {
                        match: /[A-Za-z_]+:?/,
                        keywords: r
                    }
                ]
            }, u = (e, { relevance: n })=>({
                    beginScope: {
                        1: `template-tag`,
                        3: `name`
                    },
                    relevance: n || 2,
                    endScope: `template-tag`,
                    begin: [
                        /\{%/,
                        /\s*/,
                        t.either(...e)
                    ],
                    end: /%\}/,
                    keywords: `in`,
                    contains: [
                        l,
                        c,
                        a,
                        o
                    ]
                }), d = /[a-z_]+/, f = u(i, {
                relevance: 2
            }), p = u([
                d
            ], {
                relevance: 1
            });
            return {
                name: `Twig`,
                aliases: [
                    `craftcms`
                ],
                case_insensitive: !0,
                subLanguage: `xml`,
                contains: [
                    e.COMMENT(/\{#/, /#\}/),
                    f,
                    p,
                    {
                        className: `template-variable`,
                        begin: /\{\{/,
                        end: /\}\}/,
                        contains: [
                            `self`,
                            l,
                            c,
                            a,
                            o
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), kn = o((e, t)=>{
        var n = `[A-Za-z$_][0-9A-Za-z$_]*`, r = `as.in.of.if.for.while.finally.var.new.function.do.return.void.else.break.catch.instanceof.with.throw.case.default.try.switch.continue.typeof.delete.let.yield.const.class.debugger.async.await.static.import.from.export.extends.using`.split(`.`), i = [
            `true`,
            `false`,
            `null`,
            `undefined`,
            `NaN`,
            `Infinity`
        ], a = `Object.Function.Boolean.Symbol.Math.Date.Number.BigInt.String.RegExp.Array.Float32Array.Float64Array.Int8Array.Uint8Array.Uint8ClampedArray.Int16Array.Int32Array.Uint16Array.Uint32Array.BigInt64Array.BigUint64Array.Set.Map.WeakSet.WeakMap.ArrayBuffer.SharedArrayBuffer.Atomics.DataView.JSON.Promise.Generator.GeneratorFunction.AsyncFunction.Reflect.Proxy.Intl.WebAssembly`.split(`.`), o = [
            `Error`,
            `EvalError`,
            `InternalError`,
            `RangeError`,
            `ReferenceError`,
            `SyntaxError`,
            `TypeError`,
            `URIError`
        ], s = [
            `setInterval`,
            `setTimeout`,
            `clearInterval`,
            `clearTimeout`,
            `require`,
            `exports`,
            `eval`,
            `isFinite`,
            `isNaN`,
            `parseFloat`,
            `parseInt`,
            `decodeURI`,
            `decodeURIComponent`,
            `encodeURI`,
            `encodeURIComponent`,
            `escape`,
            `unescape`
        ], c = [
            `arguments`,
            `this`,
            `super`,
            `console`,
            `window`,
            `document`,
            `localStorage`,
            `sessionStorage`,
            `module`,
            `global`
        ], l = [].concat(s, a, o);
        function u(e) {
            let t = e.regex, u = (e, { after: t })=>{
                let n = `</` + e[0].slice(1);
                return e.input.indexOf(n, t) !== -1;
            }, d = n, f = {
                begin: `<>`,
                end: `</>`
            }, p = /<[A-Za-z0-9\\._:-]+\s*\/>/, m = {
                begin: /<[A-Za-z0-9\\._:-]+/,
                end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
                isTrulyOpeningTag: (e, t)=>{
                    let n = e[0].length + e.index, r = e.input[n];
                    if (r === `<` || r === `,`) {
                        t.ignoreMatch();
                        return;
                    }
                    r === `>` && (u(e, {
                        after: n
                    }) || t.ignoreMatch());
                    let i, a = e.input.substring(n);
                    if (i = a.match(/^\s*=/)) {
                        t.ignoreMatch();
                        return;
                    }
                    if ((i = a.match(/^\s+extends\s+/)) && i.index === 0) {
                        t.ignoreMatch();
                        return;
                    }
                }
            }, h = {
                $pattern: n,
                keyword: r,
                literal: i,
                built_in: l,
                "variable.language": c
            }, g = `[0-9](_?[0-9])*`, _ = `\\.(${g})`, v = `0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*`, y = {
                className: `number`,
                variants: [
                    {
                        begin: `(\\b(${v})((${_})|\\.)?|(${_}))[eE][+-]?(${g})\\b`
                    },
                    {
                        begin: `\\b(${v})\\b((${_})\\b|\\.)?|(${_})\\b`
                    },
                    {
                        begin: `\\b(0|[1-9](_?[0-9])*)n\\b`
                    },
                    {
                        begin: `\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b`
                    },
                    {
                        begin: `\\b0[bB][0-1](_?[0-1])*n?\\b`
                    },
                    {
                        begin: `\\b0[oO][0-7](_?[0-7])*n?\\b`
                    },
                    {
                        begin: `\\b0[0-7]+n?\\b`
                    }
                ],
                relevance: 0
            }, b = {
                className: `subst`,
                begin: `\\$\\{`,
                end: `\\}`,
                keywords: h,
                contains: []
            }, x = {
                begin: ".?html`",
                end: ``,
                starts: {
                    end: "`",
                    returnEnd: !1,
                    contains: [
                        e.BACKSLASH_ESCAPE,
                        b
                    ],
                    subLanguage: `xml`
                }
            }, S = {
                begin: ".?css`",
                end: ``,
                starts: {
                    end: "`",
                    returnEnd: !1,
                    contains: [
                        e.BACKSLASH_ESCAPE,
                        b
                    ],
                    subLanguage: `css`
                }
            }, C = {
                begin: ".?gql`",
                end: ``,
                starts: {
                    end: "`",
                    returnEnd: !1,
                    contains: [
                        e.BACKSLASH_ESCAPE,
                        b
                    ],
                    subLanguage: `graphql`
                }
            }, w = {
                className: `string`,
                begin: "`",
                end: "`",
                contains: [
                    e.BACKSLASH_ESCAPE,
                    b
                ]
            }, T = {
                className: `comment`,
                variants: [
                    e.COMMENT(/\/\*\*(?!\/)/, `\\*/`, {
                        relevance: 0,
                        contains: [
                            {
                                begin: `(?=@[A-Za-z]+)`,
                                relevance: 0,
                                contains: [
                                    {
                                        className: `doctag`,
                                        begin: `@[A-Za-z]+`
                                    },
                                    {
                                        className: `type`,
                                        begin: `\\{`,
                                        end: `\\}`,
                                        excludeEnd: !0,
                                        excludeBegin: !0,
                                        relevance: 0
                                    },
                                    {
                                        className: `variable`,
                                        begin: d + `(?=\\s*(-)|$)`,
                                        endsParent: !0,
                                        relevance: 0
                                    },
                                    {
                                        begin: /(?=[^\n])\s/,
                                        relevance: 0
                                    }
                                ]
                            }
                        ]
                    }),
                    e.C_BLOCK_COMMENT_MODE,
                    e.C_LINE_COMMENT_MODE
                ]
            }, E = [
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE,
                x,
                S,
                C,
                w,
                {
                    match: /\$\d+/
                },
                y
            ];
            b.contains = E.concat({
                begin: /\{/,
                end: /\}/,
                keywords: h,
                contains: [
                    `self`
                ].concat(E)
            });
            let D = [].concat(T, b.contains), O = D.concat([
                {
                    begin: /(\s*)\(/,
                    end: /\)/,
                    keywords: h,
                    contains: [
                        `self`
                    ].concat(D)
                }
            ]), k = {
                className: `params`,
                begin: /(\s*)\(/,
                end: /\)/,
                excludeBegin: !0,
                excludeEnd: !0,
                keywords: h,
                contains: O
            }, A = {
                variants: [
                    {
                        match: [
                            /class/,
                            /\s+/,
                            d,
                            /\s+/,
                            /extends/,
                            /\s+/,
                            t.concat(d, `(`, t.concat(/\./, d), `)*`)
                        ],
                        scope: {
                            1: `keyword`,
                            3: `title.class`,
                            5: `keyword`,
                            7: `title.class.inherited`
                        }
                    },
                    {
                        match: [
                            /class/,
                            /\s+/,
                            d
                        ],
                        scope: {
                            1: `keyword`,
                            3: `title.class`
                        }
                    }
                ]
            }, j = {
                relevance: 0,
                match: t.either(/\bJSON/, /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/, /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/, /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/),
                className: `title.class`,
                keywords: {
                    _: [
                        ...a,
                        ...o
                    ]
                }
            }, M = {
                label: `use_strict`,
                className: `meta`,
                relevance: 10,
                begin: /^\s*['"]use (strict|asm)['"]/
            }, N = {
                variants: [
                    {
                        match: [
                            /function/,
                            /\s+/,
                            d,
                            /(?=\s*\()/
                        ]
                    },
                    {
                        match: [
                            /function/,
                            /\s*(?=\()/
                        ]
                    }
                ],
                className: {
                    1: `keyword`,
                    3: `title.function`
                },
                label: `func.def`,
                contains: [
                    k
                ],
                illegal: /%/
            }, P = {
                relevance: 0,
                match: /\b[A-Z][A-Z_0-9]+\b/,
                className: `variable.constant`
            };
            function F(e) {
                return t.concat(`(?!`, e.join(`|`), `)`);
            }
            let I = {
                match: t.concat(/\b/, F([
                    ...s,
                    `super`,
                    `import`
                ].map((e)=>`${e}\\s*\\(`)), d, t.lookahead(/\s*\(/)),
                className: `title.function`,
                relevance: 0
            }, L = {
                begin: t.concat(/\./, t.lookahead(t.concat(d, /(?![0-9A-Za-z$_(])/))),
                end: d,
                excludeBegin: !0,
                keywords: `prototype`,
                className: `property`,
                relevance: 0
            }, R = {
                match: [
                    /get|set/,
                    /\s+/,
                    d,
                    /(?=\()/
                ],
                className: {
                    1: `keyword`,
                    3: `title.function`
                },
                contains: [
                    {
                        begin: /\(\)/
                    },
                    k
                ]
            }, z = `(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|` + e.UNDERSCORE_IDENT_RE + `)\\s*=>`, B = {
                match: [
                    /const|var|let/,
                    /\s+/,
                    d,
                    /\s*/,
                    /=\s*/,
                    /(async\s*)?/,
                    t.lookahead(z)
                ],
                keywords: `async`,
                className: {
                    1: `keyword`,
                    3: `title.function`
                },
                contains: [
                    k
                ]
            };
            return {
                name: `JavaScript`,
                aliases: [
                    `js`,
                    `jsx`,
                    `mjs`,
                    `cjs`
                ],
                keywords: h,
                exports: {
                    PARAMS_CONTAINS: O,
                    CLASS_REFERENCE: j
                },
                illegal: /#(?![$_A-z])/,
                contains: [
                    e.SHEBANG({
                        label: `shebang`,
                        binary: `node`,
                        relevance: 5
                    }),
                    M,
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE,
                    x,
                    S,
                    C,
                    w,
                    T,
                    {
                        match: /\$\d+/
                    },
                    y,
                    j,
                    {
                        scope: `attr`,
                        match: d + t.lookahead(`:`),
                        relevance: 0
                    },
                    B,
                    {
                        begin: `(` + e.RE_STARTERS_RE + `|\\b(case|return|throw)\\b)\\s*`,
                        keywords: `return throw case`,
                        relevance: 0,
                        contains: [
                            T,
                            e.REGEXP_MODE,
                            {
                                className: `function`,
                                begin: z,
                                returnBegin: !0,
                                end: `\\s*=>`,
                                contains: [
                                    {
                                        className: `params`,
                                        variants: [
                                            {
                                                begin: e.UNDERSCORE_IDENT_RE,
                                                relevance: 0
                                            },
                                            {
                                                className: null,
                                                begin: /\(\s*\)/,
                                                skip: !0
                                            },
                                            {
                                                begin: /(\s*)\(/,
                                                end: /\)/,
                                                excludeBegin: !0,
                                                excludeEnd: !0,
                                                keywords: h,
                                                contains: O
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                begin: /,/,
                                relevance: 0
                            },
                            {
                                match: /\s+/,
                                relevance: 0
                            },
                            {
                                variants: [
                                    {
                                        begin: f.begin,
                                        end: f.end
                                    },
                                    {
                                        match: p
                                    },
                                    {
                                        begin: m.begin,
                                        "on:begin": m.isTrulyOpeningTag,
                                        end: m.end
                                    }
                                ],
                                subLanguage: `xml`,
                                contains: [
                                    {
                                        begin: m.begin,
                                        end: m.end,
                                        skip: !0,
                                        contains: [
                                            `self`
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    N,
                    {
                        beginKeywords: `while if switch catch for`
                    },
                    {
                        begin: `\\b(?!function)` + e.UNDERSCORE_IDENT_RE + `\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{`,
                        returnBegin: !0,
                        label: `func.def`,
                        contains: [
                            k,
                            e.inherit(e.TITLE_MODE, {
                                begin: d,
                                className: `title.function`
                            })
                        ]
                    },
                    {
                        match: /\.\.\./,
                        relevance: 0
                    },
                    L,
                    {
                        match: `\\$` + d,
                        relevance: 0
                    },
                    {
                        match: [
                            /\bconstructor(?=\s*\()/
                        ],
                        className: {
                            1: `title.function`
                        },
                        contains: [
                            k
                        ]
                    },
                    I,
                    P,
                    A,
                    R,
                    {
                        match: /\$[(.]/
                    }
                ]
            };
        }
        function d(e) {
            let t = e.regex, a = u(e), o = n, s = [
                `any`,
                `void`,
                `number`,
                `boolean`,
                `string`,
                `object`,
                `never`,
                `symbol`,
                `bigint`,
                `unknown`
            ], d = {
                begin: [
                    /namespace/,
                    /\s+/,
                    e.IDENT_RE
                ],
                beginScope: {
                    1: `keyword`,
                    3: `title.class`
                }
            }, f = {
                beginKeywords: `interface`,
                end: /\{/,
                excludeEnd: !0,
                keywords: {
                    keyword: `interface extends`,
                    built_in: s
                },
                contains: [
                    a.exports.CLASS_REFERENCE
                ]
            }, p = {
                className: `meta`,
                relevance: 10,
                begin: /^\s*['"]use strict['"]/
            }, m = {
                $pattern: n,
                keyword: r.concat([
                    `type`,
                    `interface`,
                    `public`,
                    `private`,
                    `protected`,
                    `implements`,
                    `declare`,
                    `abstract`,
                    `readonly`,
                    `enum`,
                    `override`,
                    `satisfies`
                ]),
                literal: i,
                built_in: l.concat(s),
                "variable.language": c
            }, h = {
                className: `meta`,
                begin: `@` + o
            }, g = (e, t, n)=>{
                let r = e.contains.findIndex((e)=>e.label === t);
                if (r === -1) throw Error(`can not find mode to replace`);
                e.contains.splice(r, 1, n);
            };
            Object.assign(a.keywords, m), a.exports.PARAMS_CONTAINS.push(h);
            let _ = a.contains.find((e)=>e.scope === `attr`), v = Object.assign({}, _, {
                match: t.concat(o, t.lookahead(/\s*\?:/))
            });
            a.exports.PARAMS_CONTAINS.push([
                a.exports.CLASS_REFERENCE,
                _,
                v
            ]), a.contains = a.contains.concat([
                h,
                d,
                f,
                v
            ]), g(a, `shebang`, e.SHEBANG()), g(a, `use_strict`, p);
            let y = a.contains.find((e)=>e.label === `func.def`);
            return y.relevance = 0, Object.assign(a, {
                name: `TypeScript`,
                aliases: [
                    `ts`,
                    `tsx`,
                    `mts`,
                    `cts`
                ]
            }), a;
        }
        t.exports = d;
    }), An = o((e, t)=>{
        function n(e) {
            return {
                name: `Vala`,
                keywords: {
                    keyword: `char uchar unichar int uint long ulong short ushort int8 int16 int32 int64 uint8 uint16 uint32 uint64 float double bool struct enum string void weak unowned owned async signal static abstract interface override virtual delegate if while do for foreach else switch case break default return try catch public private protected internal using new this get set const stdout stdin stderr var`,
                    built_in: `DBus GLib CCode Gee Object Gtk Posix`,
                    literal: `false true null`
                },
                contains: [
                    {
                        className: `class`,
                        beginKeywords: `class interface namespace`,
                        end: /\{/,
                        excludeEnd: !0,
                        illegal: `[^,:\\n\\s\\.]`,
                        contains: [
                            e.UNDERSCORE_TITLE_MODE
                        ]
                    },
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    {
                        className: `string`,
                        begin: `"""`,
                        end: `"""`,
                        relevance: 5
                    },
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE,
                    e.C_NUMBER_MODE,
                    {
                        className: `meta`,
                        begin: `^#`,
                        end: `$`
                    }
                ]
            };
        }
        t.exports = n;
    }), jn = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = {
                className: `string`,
                begin: /"(""|[^/n])"C\b/
            }, r = {
                className: `string`,
                begin: /"/,
                end: /"/,
                illegal: /\n/,
                contains: [
                    {
                        begin: /""/
                    }
                ]
            }, i = /\d{1,2}\/\d{1,2}\/\d{4}/, a = /\d{4}-\d{1,2}-\d{1,2}/, o = /(\d|1[012])(:\d+){0,2} *(AM|PM)/, s = /\d{1,2}(:\d{1,2}){1,2}/, c = {
                className: `literal`,
                variants: [
                    {
                        begin: t.concat(/# */, t.either(a, i), / *#/)
                    },
                    {
                        begin: t.concat(/# */, s, / *#/)
                    },
                    {
                        begin: t.concat(/# */, o, / *#/)
                    },
                    {
                        begin: t.concat(/# */, t.either(a, i), / +/, t.either(o, s), / *#/)
                    }
                ]
            }, l = {
                className: `number`,
                relevance: 0,
                variants: [
                    {
                        begin: /\b\d[\d_]*((\.[\d_]+(E[+-]?[\d_]+)?)|(E[+-]?[\d_]+))[RFD@!#]?/
                    },
                    {
                        begin: /\b\d[\d_]*((U?[SIL])|[%&])?/
                    },
                    {
                        begin: /&H[\dA-F_]+((U?[SIL])|[%&])?/
                    },
                    {
                        begin: /&O[0-7_]+((U?[SIL])|[%&])?/
                    },
                    {
                        begin: /&B[01_]+((U?[SIL])|[%&])?/
                    }
                ]
            }, u = {
                className: `label`,
                begin: /^\w+:/
            }, d = e.COMMENT(/'''/, /$/, {
                contains: [
                    {
                        className: `doctag`,
                        begin: /<\/?/,
                        end: />/
                    }
                ]
            }), f = e.COMMENT(null, /$/, {
                variants: [
                    {
                        begin: /'/
                    },
                    {
                        begin: /([\t ]|^)REM(?=\s)/
                    }
                ]
            });
            return {
                name: `Visual Basic .NET`,
                aliases: [
                    `vb`
                ],
                case_insensitive: !0,
                classNameAliases: {
                    label: `symbol`
                },
                keywords: {
                    keyword: `addhandler alias aggregate ansi as async assembly auto binary by byref byval call case catch class compare const continue custom declare default delegate dim distinct do each equals else elseif end enum erase error event exit explicit finally for friend from function get global goto group handles if implements imports in inherits interface into iterator join key let lib loop me mid module mustinherit mustoverride mybase myclass namespace narrowing new next notinheritable notoverridable of off on operator option optional order overloads overridable overrides paramarray partial preserve private property protected public raiseevent readonly redim removehandler resume return select set shadows shared skip static step stop structure strict sub synclock take text then throw to try unicode until using when where while widening with withevents writeonly yield`,
                    built_in: `addressof and andalso await directcast gettype getxmlnamespace is isfalse isnot istrue like mod nameof new not or orelse trycast typeof xor cbool cbyte cchar cdate cdbl cdec cint clng cobj csbyte cshort csng cstr cuint culng cushort`,
                    type: `boolean byte char date decimal double integer long object sbyte short single string uinteger ulong ushort`,
                    literal: `true false nothing`
                },
                illegal: `//|\\{|\\}|endif|gosub|variant|wend|^\\$ `,
                contains: [
                    n,
                    r,
                    c,
                    l,
                    u,
                    d,
                    f,
                    {
                        className: `meta`,
                        begin: /[\t ]*#(const|disable|else|elseif|enable|end|externalsource|if|region)\b/,
                        end: /$/,
                        keywords: {
                            keyword: `const disable else elseif enable end externalsource if region then`
                        },
                        contains: [
                            f
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), Mn = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = `lcase.month.vartype.instrrev.ubound.setlocale.getobject.rgb.getref.string.weekdayname.rnd.dateadd.monthname.now.day.minute.isarray.cbool.round.formatcurrency.conversions.csng.timevalue.second.year.space.abs.clng.timeserial.fixs.len.asc.isempty.maths.dateserial.atn.timer.isobject.filter.weekday.datevalue.ccur.isdate.instr.datediff.formatdatetime.replace.isnull.right.sgn.array.snumeric.log.cdbl.hex.chr.lbound.msgbox.ucase.getlocale.cos.cdate.cbyte.rtrim.join.hour.oct.typename.trim.strcomp.int.createobject.loadpicture.tan.formatnumber.mid.split.cint.sin.datepart.ltrim.sqr.time.derived.eval.date.formatpercent.exp.inputbox.left.ascw.chrw.regexp.cstr.err`.split(`.`), r = [
                `server`,
                `response`,
                `request`,
                `scriptengine`,
                `scriptenginebuildversion`,
                `scriptengineminorversion`,
                `scriptenginemajorversion`
            ], i = {
                begin: t.concat(t.either(...n), `\\s*\\(`),
                relevance: 0,
                keywords: {
                    built_in: n
                }
            };
            return {
                name: `VBScript`,
                aliases: [
                    `vbs`
                ],
                case_insensitive: !0,
                keywords: {
                    keyword: `call.class.const.dim.do.loop.erase.execute.executeglobal.exit.for.each.next.function.if.then.else.on.error.option.explicit.new.private.property.let.get.public.randomize.redim.rem.select.case.set.stop.sub.while.wend.with.end.to.elseif.is.or.xor.and.not.class_initialize.class_terminate.default.preserve.in.me.byval.byref.step.resume.goto`.split(`.`),
                    built_in: r,
                    literal: [
                        `true`,
                        `false`,
                        `null`,
                        `nothing`,
                        `empty`
                    ]
                },
                illegal: `//`,
                contains: [
                    i,
                    e.inherit(e.QUOTE_STRING_MODE, {
                        contains: [
                            {
                                begin: `""`
                            }
                        ]
                    }),
                    e.COMMENT(/'/, /$/, {
                        relevance: 0
                    }),
                    e.C_NUMBER_MODE
                ]
            };
        }
        t.exports = n;
    }), Nn = o((e, t)=>{
        function n(e) {
            return {
                name: `VBScript in HTML`,
                subLanguage: `xml`,
                contains: [
                    {
                        begin: `<%`,
                        end: `%>`,
                        subLanguage: `vbscript`
                    }
                ]
            };
        }
        t.exports = n;
    }), Pn = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = {
                $pattern: /\$?[\w]+(\$[\w]+)*/,
                keyword: `accept_on.alias.always.always_comb.always_ff.always_latch.and.assert.assign.assume.automatic.before.begin.bind.bins.binsof.bit.break.buf|0.bufif0.bufif1.byte.case.casex.casez.cell.chandle.checker.class.clocking.cmos.config.const.constraint.context.continue.cover.covergroup.coverpoint.cross.deassign.default.defparam.design.disable.dist.do.edge.else.end.endcase.endchecker.endclass.endclocking.endconfig.endfunction.endgenerate.endgroup.endinterface.endmodule.endpackage.endprimitive.endprogram.endproperty.endspecify.endsequence.endtable.endtask.enum.event.eventually.expect.export.extends.extern.final.first_match.for.force.foreach.forever.fork.forkjoin.function.generate|5.genvar.global.highz0.highz1.if.iff.ifnone.ignore_bins.illegal_bins.implements.implies.import.incdir.include.initial.inout.input.inside.instance.int.integer.interconnect.interface.intersect.join.join_any.join_none.large.let.liblist.library.local.localparam.logic.longint.macromodule.matches.medium.modport.module.nand.negedge.nettype.new.nexttime.nmos.nor.noshowcancelled.not.notif0.notif1.or.output.package.packed.parameter.pmos.posedge.primitive.priority.program.property.protected.pull0.pull1.pulldown.pullup.pulsestyle_ondetect.pulsestyle_onevent.pure.rand.randc.randcase.randsequence.rcmos.real.realtime.ref.reg.reject_on.release.repeat.restrict.return.rnmos.rpmos.rtran.rtranif0.rtranif1.s_always.s_eventually.s_nexttime.s_until.s_until_with.scalared.sequence.shortint.shortreal.showcancelled.signed.small.soft.solve.specify.specparam.static.string.strong.strong0.strong1.struct.super.supply0.supply1.sync_accept_on.sync_reject_on.table.tagged.task.this.throughout.time.timeprecision.timeunit.tran.tranif0.tranif1.tri.tri0.tri1.triand.trior.trireg.type.typedef.union.unique.unique0.unsigned.until.until_with.untyped.use.uwire.var.vectored.virtual.void.wait.wait_order.wand.weak.weak0.weak1.while.wildcard.wire.with.within.wor.xnor.xor`.split(`.`),
                literal: [
                    `null`
                ],
                built_in: `$finish.$stop.$exit.$fatal.$error.$warning.$info.$realtime.$time.$printtimescale.$bitstoreal.$bitstoshortreal.$itor.$signed.$cast.$bits.$stime.$timeformat.$realtobits.$shortrealtobits.$rtoi.$unsigned.$asserton.$assertkill.$assertpasson.$assertfailon.$assertnonvacuouson.$assertoff.$assertcontrol.$assertpassoff.$assertfailoff.$assertvacuousoff.$isunbounded.$sampled.$fell.$changed.$past_gclk.$fell_gclk.$changed_gclk.$rising_gclk.$steady_gclk.$coverage_control.$coverage_get.$coverage_save.$set_coverage_db_name.$rose.$stable.$past.$rose_gclk.$stable_gclk.$future_gclk.$falling_gclk.$changing_gclk.$display.$coverage_get_max.$coverage_merge.$get_coverage.$load_coverage_db.$typename.$unpacked_dimensions.$left.$low.$increment.$clog2.$ln.$log10.$exp.$sqrt.$pow.$floor.$ceil.$sin.$cos.$tan.$countbits.$onehot.$isunknown.$fatal.$warning.$dimensions.$right.$high.$size.$asin.$acos.$atan.$atan2.$hypot.$sinh.$cosh.$tanh.$asinh.$acosh.$atanh.$countones.$onehot0.$error.$info.$random.$dist_chi_square.$dist_erlang.$dist_exponential.$dist_normal.$dist_poisson.$dist_t.$dist_uniform.$q_initialize.$q_remove.$q_exam.$async$and$array.$async$nand$array.$async$or$array.$async$nor$array.$sync$and$array.$sync$nand$array.$sync$or$array.$sync$nor$array.$q_add.$q_full.$psprintf.$async$and$plane.$async$nand$plane.$async$or$plane.$async$nor$plane.$sync$and$plane.$sync$nand$plane.$sync$or$plane.$sync$nor$plane.$system.$display.$displayb.$displayh.$displayo.$strobe.$strobeb.$strobeh.$strobeo.$write.$readmemb.$readmemh.$writememh.$value$plusargs.$dumpvars.$dumpon.$dumplimit.$dumpports.$dumpportson.$dumpportslimit.$writeb.$writeh.$writeo.$monitor.$monitorb.$monitorh.$monitoro.$writememb.$dumpfile.$dumpoff.$dumpall.$dumpflush.$dumpportsoff.$dumpportsall.$dumpportsflush.$fclose.$fdisplay.$fdisplayb.$fdisplayh.$fdisplayo.$fstrobe.$fstrobeb.$fstrobeh.$fstrobeo.$swrite.$swriteb.$swriteh.$swriteo.$fscanf.$fread.$fseek.$fflush.$feof.$fopen.$fwrite.$fwriteb.$fwriteh.$fwriteo.$fmonitor.$fmonitorb.$fmonitorh.$fmonitoro.$sformat.$sformatf.$fgetc.$ungetc.$fgets.$sscanf.$rewind.$ftell.$ferror`.split(`.`)
            }, r = [
                `__FILE__`,
                `__LINE__`
            ], i = `begin_keywords.celldefine.default_nettype.default_decay_time.default_trireg_strength.define.delay_mode_distributed.delay_mode_path.delay_mode_unit.delay_mode_zero.else.elsif.end_keywords.endcelldefine.endif.ifdef.ifndef.include.line.nounconnected_drive.pragma.resetall.timescale.unconnected_drive.undef.undefineall`.split(`.`);
            return {
                name: `Verilog`,
                aliases: [
                    `v`,
                    `sv`,
                    `svh`
                ],
                case_insensitive: !1,
                keywords: n,
                contains: [
                    e.C_BLOCK_COMMENT_MODE,
                    e.C_LINE_COMMENT_MODE,
                    e.QUOTE_STRING_MODE,
                    {
                        scope: `number`,
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ],
                        variants: [
                            {
                                begin: /\b((\d+'([bhodBHOD]))[0-9xzXZa-fA-F_]+)/
                            },
                            {
                                begin: /\B(('([bhodBHOD]))[0-9xzXZa-fA-F_]+)/
                            },
                            {
                                begin: /\b[0-9][0-9_]*/,
                                relevance: 0
                            }
                        ]
                    },
                    {
                        scope: `variable`,
                        variants: [
                            {
                                begin: `#\\((?!parameter).+\\)`
                            },
                            {
                                begin: `\\.\\w+`,
                                relevance: 0
                            }
                        ]
                    },
                    {
                        scope: `variable.constant`,
                        match: t.concat(/`/, t.either(...r))
                    },
                    {
                        scope: `meta`,
                        begin: t.concat(/`/, t.either(...i)),
                        end: /$|\/\/|\/\*/,
                        returnEnd: !0,
                        keywords: i
                    }
                ]
            };
        }
        t.exports = n;
    }), Fn = o((e, t)=>{
        function n(e) {
            let t = `\\d(_|\\d)*`;
            return t, t, t, {
                name: `VHDL`,
                case_insensitive: !0,
                keywords: {
                    keyword: `abs.access.after.alias.all.and.architecture.array.assert.assume.assume_guarantee.attribute.begin.block.body.buffer.bus.case.component.configuration.constant.context.cover.disconnect.downto.default.else.elsif.end.entity.exit.fairness.file.for.force.function.generate.generic.group.guarded.if.impure.in.inertial.inout.is.label.library.linkage.literal.loop.map.mod.nand.new.next.nor.not.null.of.on.open.or.others.out.package.parameter.port.postponed.procedure.process.property.protected.pure.range.record.register.reject.release.rem.report.restrict.restrict_guarantee.return.rol.ror.select.sequence.severity.shared.signal.sla.sll.sra.srl.strong.subtype.then.to.transport.type.unaffected.units.until.use.variable.view.vmode.vprop.vunit.wait.when.while.with.xnor.xor`.split(`.`),
                    built_in: `boolean.bit.character.integer.time.delay_length.natural.positive.string.bit_vector.file_open_kind.file_open_status.std_logic.std_logic_vector.unsigned.signed.boolean_vector.integer_vector.std_ulogic.std_ulogic_vector.unresolved_unsigned.u_unsigned.unresolved_signed.u_signed.real_vector.time_vector`.split(`.`),
                    literal: [
                        `false`,
                        `true`,
                        `note`,
                        `warning`,
                        `error`,
                        `failure`,
                        `line`,
                        `text`,
                        `side`,
                        `width`
                    ]
                },
                illegal: /\{/,
                contains: [
                    e.C_BLOCK_COMMENT_MODE,
                    e.COMMENT(`--`, `$`),
                    e.QUOTE_STRING_MODE,
                    {
                        className: `number`,
                        begin: `\\b(\\d(_|\\d)*#\\w+(\\.\\w+)?#([eE][-+]?\\d(_|\\d)*)?|\\d(_|\\d)*(\\.\\d(_|\\d)*)?([eE][-+]?\\d(_|\\d)*)?)`,
                        relevance: 0
                    },
                    {
                        className: `string`,
                        begin: `'(U|X|0|1|Z|W|L|H|-)'`,
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ]
                    },
                    {
                        className: `symbol`,
                        begin: `'[A-Za-z](_?[A-Za-z0-9])*`,
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), In = o((e, t)=>{
        function n(e) {
            return {
                name: `Vim Script`,
                keywords: {
                    $pattern: /[!#@\w]+/,
                    keyword: `N|0 P|0 X|0 a|0 ab abc abo al am an|0 ar arga argd arge argdo argg argl argu as au aug aun b|0 bN ba bad bd be bel bf bl bm bn bo bp br brea breaka breakd breakl bro bufdo buffers bun bw c|0 cN cNf ca cabc caddb cad caddf cal cat cb cc ccl cd ce cex cf cfir cgetb cgete cg changes chd che checkt cl cla clo cm cmapc cme cn cnew cnf cno cnorea cnoreme co col colo com comc comp con conf cope cp cpf cq cr cs cst cu cuna cunme cw delm deb debugg delc delf dif diffg diffo diffp diffpu diffs diffthis dig di dl dell dj dli do doautoa dp dr ds dsp e|0 ea ec echoe echoh echom echon el elsei em en endfo endf endt endw ene ex exe exi exu f|0 files filet fin fina fini fir fix fo foldc foldd folddoc foldo for fu go gr grepa gu gv ha helpf helpg helpt hi hid his ia iabc if ij il im imapc ime ino inorea inoreme int is isp iu iuna iunme j|0 ju k|0 keepa kee keepj lN lNf l|0 lad laddb laddf la lan lat lb lc lch lcl lcs le lefta let lex lf lfir lgetb lgete lg lgr lgrepa lh ll lla lli lmak lm lmapc lne lnew lnf ln loadk lo loc lockv lol lope lp lpf lr ls lt lu lua luad luaf lv lvimgrepa lw m|0 ma mak map mapc marks mat me menut mes mk mks mksp mkv mkvie mod mz mzf nbc nb nbs new nm nmapc nme nn nnoreme noa no noh norea noreme norm nu nun nunme ol o|0 om omapc ome on ono onoreme opt ou ounme ow p|0 profd prof pro promptr pc ped pe perld po popu pp pre prev ps pt ptN ptf ptj ptl ptn ptp ptr pts pu pw py3 python3 py3d py3f py pyd pyf quita qa rec red redi redr redraws reg res ret retu rew ri rightb rub rubyd rubyf rund ru rv sN san sa sal sav sb sbN sba sbf sbl sbm sbn sbp sbr scrip scripte scs se setf setg setl sf sfir sh sim sig sil sl sla sm smap smapc sme sn sni sno snor snoreme sor so spelld spe spelli spellr spellu spellw sp spr sre st sta startg startr star stopi stj sts sun sunm sunme sus sv sw sy synti sync tN tabN tabc tabdo tabe tabf tabfir tabl tabm tabnew tabn tabo tabp tabr tabs tab ta tags tc tcld tclf te tf th tj tl tm tn to tp tr try ts tu u|0 undoj undol una unh unl unlo unm unme uns up ve verb vert vim vimgrepa vi viu vie vm vmapc vme vne vn vnoreme vs vu vunme windo w|0 wN wa wh wi winc winp wn wp wq wqa ws wu wv x|0 xa xmapc xm xme xn xnoreme xu xunme y|0 z|0 ~ Next Print append abbreviate abclear aboveleft all amenu anoremenu args argadd argdelete argedit argglobal arglocal argument ascii autocmd augroup aunmenu buffer bNext ball badd bdelete behave belowright bfirst blast bmodified bnext botright bprevious brewind break breakadd breakdel breaklist browse bunload bwipeout change cNext cNfile cabbrev cabclear caddbuffer caddexpr caddfile call catch cbuffer cclose center cexpr cfile cfirst cgetbuffer cgetexpr cgetfile chdir checkpath checktime clist clast close cmap cmapclear cmenu cnext cnewer cnfile cnoremap cnoreabbrev cnoremenu copy colder colorscheme command comclear compiler continue confirm copen cprevious cpfile cquit crewind cscope cstag cunmap cunabbrev cunmenu cwindow delete delmarks debug debuggreedy delcommand delfunction diffupdate diffget diffoff diffpatch diffput diffsplit digraphs display deletel djump dlist doautocmd doautoall deletep drop dsearch dsplit edit earlier echo echoerr echohl echomsg else elseif emenu endif endfor endfunction endtry endwhile enew execute exit exusage file filetype find finally finish first fixdel fold foldclose folddoopen folddoclosed foldopen function global goto grep grepadd gui gvim hardcopy help helpfind helpgrep helptags highlight hide history insert iabbrev iabclear ijump ilist imap imapclear imenu inoremap inoreabbrev inoremenu intro isearch isplit iunmap iunabbrev iunmenu join jumps keepalt keepmarks keepjumps lNext lNfile list laddexpr laddbuffer laddfile last language later lbuffer lcd lchdir lclose lcscope left leftabove lexpr lfile lfirst lgetbuffer lgetexpr lgetfile lgrep lgrepadd lhelpgrep llast llist lmake lmap lmapclear lnext lnewer lnfile lnoremap loadkeymap loadview lockmarks lockvar lolder lopen lprevious lpfile lrewind ltag lunmap luado luafile lvimgrep lvimgrepadd lwindow move mark make mapclear match menu menutranslate messages mkexrc mksession mkspell mkvimrc mkview mode mzscheme mzfile nbclose nbkey nbsart next nmap nmapclear nmenu nnoremap nnoremenu noautocmd noremap nohlsearch noreabbrev noremenu normal number nunmap nunmenu oldfiles open omap omapclear omenu only onoremap onoremenu options ounmap ounmenu ownsyntax print profdel profile promptfind promptrepl pclose pedit perl perldo pop popup ppop preserve previous psearch ptag ptNext ptfirst ptjump ptlast ptnext ptprevious ptrewind ptselect put pwd py3do py3file python pydo pyfile quit quitall qall read recover redo redir redraw redrawstatus registers resize retab return rewind right rightbelow ruby rubydo rubyfile rundo runtime rviminfo substitute sNext sandbox sargument sall saveas sbuffer sbNext sball sbfirst sblast sbmodified sbnext sbprevious sbrewind scriptnames scriptencoding scscope set setfiletype setglobal setlocal sfind sfirst shell simalt sign silent sleep slast smagic smapclear smenu snext sniff snomagic snoremap snoremenu sort source spelldump spellgood spellinfo spellrepall spellundo spellwrong split sprevious srewind stop stag startgreplace startreplace startinsert stopinsert stjump stselect sunhide sunmap sunmenu suspend sview swapname syntax syntime syncbind tNext tabNext tabclose tabedit tabfind tabfirst tablast tabmove tabnext tabonly tabprevious tabrewind tag tcl tcldo tclfile tearoff tfirst throw tjump tlast tmenu tnext topleft tprevious trewind tselect tunmenu undo undojoin undolist unabbreviate unhide unlet unlockvar unmap unmenu unsilent update vglobal version verbose vertical vimgrep vimgrepadd visual viusage view vmap vmapclear vmenu vnew vnoremap vnoremenu vsplit vunmap vunmenu write wNext wall while winsize wincmd winpos wnext wprevious wqall wsverb wundo wviminfo xit xall xmapclear xmap xmenu xnoremap xnoremenu xunmap xunmenu yank`,
                    built_in: `synIDtrans atan2 range matcharg did_filetype asin feedkeys xor argv complete_check add getwinposx getqflist getwinposy screencol clearmatches empty extend getcmdpos mzeval garbagecollect setreg ceil sqrt diff_hlID inputsecret get getfperm getpid filewritable shiftwidth max sinh isdirectory synID system inputrestore winline atan visualmode inputlist tabpagewinnr round getregtype mapcheck hasmapto histdel argidx findfile sha256 exists toupper getcmdline taglist string getmatches bufnr strftime winwidth bufexists strtrans tabpagebuflist setcmdpos remote_read printf setloclist getpos getline bufwinnr float2nr len getcmdtype diff_filler luaeval resolve libcallnr foldclosedend reverse filter has_key bufname str2float strlen setline getcharmod setbufvar index searchpos shellescape undofile foldclosed setqflist buflisted strchars str2nr virtcol floor remove undotree remote_expr winheight gettabwinvar reltime cursor tabpagenr finddir localtime acos getloclist search tanh matchend rename gettabvar strdisplaywidth type abs py3eval setwinvar tolower wildmenumode log10 spellsuggest bufloaded synconcealed nextnonblank server2client complete settabwinvar executable input wincol setmatches getftype hlID inputsave searchpair or screenrow line settabvar histadd deepcopy strpart remote_peek and eval getftime submatch screenchar winsaveview matchadd mkdir screenattr getfontname libcall reltimestr getfsize winnr invert pow getbufline byte2line soundfold repeat fnameescape tagfiles sin strwidth spellbadword trunc maparg log lispindent hostname setpos globpath remote_foreground getchar synIDattr fnamemodify cscope_connection stridx winbufnr indent min complete_add nr2char searchpairpos inputdialog values matchlist items hlexists strridx browsedir expand fmod pathshorten line2byte argc count getwinvar glob foldtextresult getreg foreground cosh matchdelete has char2nr simplify histget searchdecl iconv winrestcmd pumvisible writefile foldlevel haslocaldir keys cos matchstr foldtext histnr tan tempname getcwd byteidx getbufvar islocked escape eventhandler remote_send serverlist winrestview synstack pyeval prevnonblank readfile cindent filereadable changenr exp`
                },
                illegal: /;/,
                contains: [
                    e.NUMBER_MODE,
                    {
                        className: `string`,
                        begin: `'`,
                        end: `'`,
                        illegal: `\\n`
                    },
                    {
                        className: `string`,
                        begin: /"(\\"|\n\\|[^"\n])*"/
                    },
                    e.COMMENT(`"`, `$`),
                    {
                        className: `variable`,
                        begin: /[bwtglsav]:[\w\d_]+/
                    },
                    {
                        begin: [
                            /\b(?:function|function!)/,
                            /\s+/,
                            e.IDENT_RE
                        ],
                        className: {
                            1: `keyword`,
                            3: `title`
                        },
                        end: `$`,
                        relevance: 0,
                        contains: [
                            {
                                className: `params`,
                                begin: `\\(`,
                                end: `\\)`
                            }
                        ]
                    },
                    {
                        className: `symbol`,
                        begin: /<[\w-]+>/
                    }
                ]
            };
        }
        t.exports = n;
    }), Ln = o((e, t)=>{
        function n(e) {
            e.regex;
            let t = e.COMMENT(/\(;/, /;\)/);
            return t.contains.push(`self`), {
                name: `WebAssembly`,
                keywords: {
                    $pattern: /[\w.]+/,
                    keyword: `anyfunc,block,br,br_if,br_table,call,call_indirect,data,drop,elem,else,end,export,func,global.get,global.set,local.get,local.set,local.tee,get_global,get_local,global,if,import,local,loop,memory,memory.grow,memory.size,module,mut,nop,offset,param,result,return,select,set_global,set_local,start,table,tee_local,then,type,unreachable`.split(`,`)
                },
                contains: [
                    e.COMMENT(/;;/, /$/),
                    t,
                    {
                        match: [
                            /(?:offset|align)/,
                            /\s*/,
                            /=/
                        ],
                        className: {
                            1: `keyword`,
                            3: `operator`
                        }
                    },
                    {
                        className: `variable`,
                        begin: /\$[\w_]+/
                    },
                    {
                        match: /(\((?!;)|\))+/,
                        className: `punctuation`,
                        relevance: 0
                    },
                    {
                        begin: [
                            /(?:func|call|call_indirect)/,
                            /\s+/,
                            /\$[^\s)]+/
                        ],
                        className: {
                            1: `keyword`,
                            3: `title.function`
                        }
                    },
                    e.QUOTE_STRING_MODE,
                    {
                        match: /(i32|i64|f32|f64)(?!\.)/,
                        className: `type`
                    },
                    {
                        className: `keyword`,
                        match: /\b(f32|f64|i32|i64)(?:\.(?:abs|add|and|ceil|clz|const|convert_[su]\/i(?:32|64)|copysign|ctz|demote\/f64|div(?:_[su])?|eqz?|extend_[su]\/i32|floor|ge(?:_[su])?|gt(?:_[su])?|le(?:_[su])?|load(?:(?:8|16|32)_[su])?|lt(?:_[su])?|max|min|mul|nearest|neg?|or|popcnt|promote\/f32|reinterpret\/[fi](?:32|64)|rem_[su]|rot[lr]|shl|shr_[su]|store(?:8|16|32)?|sqrt|sub|trunc(?:_[su]\/f(?:32|64))?|wrap\/i64|xor))\b/
                    },
                    {
                        className: `number`,
                        relevance: 0,
                        match: /[+-]?\b(?:\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:[eE][+-]?\d(?:_?\d)*)?|0x[\da-fA-F](?:_?[\da-fA-F])*(?:\.[\da-fA-F](?:_?[\da-fA-D])*)?(?:[pP][+-]?\d(?:_?\d)*)?)\b|\binf\b|\bnan(?::0x[\da-fA-F](?:_?[\da-fA-D])*)?\b/
                    }
                ]
            };
        }
        t.exports = n;
    }), Rn = o((e, t)=>{
        function n(e) {
            let t = e.regex, n = /[a-zA-Z]\w*/, r = [
                `as`,
                `break`,
                `class`,
                `construct`,
                `continue`,
                `else`,
                `for`,
                `foreign`,
                `if`,
                `import`,
                `in`,
                `is`,
                `return`,
                `static`,
                `var`,
                `while`
            ], i = [
                `true`,
                `false`,
                `null`
            ], a = [
                `this`,
                `super`
            ], o = [
                `Bool`,
                `Class`,
                `Fiber`,
                `Fn`,
                `List`,
                `Map`,
                `Null`,
                `Num`,
                `Object`,
                `Range`,
                `Sequence`,
                `String`,
                `System`
            ], s = [
                `-`,
                `~`,
                /\*/,
                `%`,
                /\.\.\./,
                /\.\./,
                /\+/,
                `<<`,
                `>>`,
                `>=`,
                `<=`,
                `<`,
                `>`,
                /\^/,
                /!=/,
                /!/,
                /\bis\b/,
                `==`,
                `&&`,
                `&`,
                /\|\|/,
                /\|/,
                /\?:/,
                `=`
            ], c = {
                relevance: 0,
                match: t.concat(/\b(?!(if|while|for|else|super)\b)/, n, /(?=\s*[({])/),
                className: `title.function`
            }, l = {
                match: t.concat(t.either(t.concat(/\b(?!(if|while|for|else|super)\b)/, n), t.either(...s)), /(?=\s*\([^)]+\)\s*\{)/),
                className: `title.function`,
                starts: {
                    contains: [
                        {
                            begin: /\(/,
                            end: /\)/,
                            contains: [
                                {
                                    relevance: 0,
                                    scope: `params`,
                                    match: n
                                }
                            ]
                        }
                    ]
                }
            }, u = {
                variants: [
                    {
                        match: [
                            /class\s+/,
                            n,
                            /\s+is\s+/,
                            n
                        ]
                    },
                    {
                        match: [
                            /class\s+/,
                            n
                        ]
                    }
                ],
                scope: {
                    2: `title.class`,
                    4: `title.class.inherited`
                },
                keywords: r
            }, d = {
                relevance: 0,
                match: t.either(...s),
                className: `operator`
            }, f = {
                className: `string`,
                begin: /"""/,
                end: /"""/
            }, p = {
                className: `property`,
                begin: t.concat(/\./, t.lookahead(n)),
                end: n,
                excludeBegin: !0,
                relevance: 0
            }, m = {
                relevance: 0,
                match: t.concat(/\b_/, n),
                scope: `variable`
            }, h = {
                relevance: 0,
                match: /\b[A-Z]+[a-z]+([A-Z]+[a-z]+)*/,
                scope: `title.class`,
                keywords: {
                    _: o
                }
            }, g = e.C_NUMBER_MODE, _ = {
                match: [
                    n,
                    /\s*/,
                    /=/,
                    /\s*/,
                    /\(/,
                    n,
                    /\)\s*\{/
                ],
                scope: {
                    1: `title.function`,
                    3: `operator`,
                    6: `params`
                }
            }, v = e.COMMENT(/\/\*\*/, /\*\//, {
                contains: [
                    {
                        match: /@[a-z]+/,
                        scope: `doctag`
                    },
                    `self`
                ]
            }), y = {
                scope: `subst`,
                begin: /%\(/,
                end: /\)/,
                contains: [
                    g,
                    h,
                    c,
                    m,
                    d
                ]
            }, b = {
                scope: `string`,
                begin: /"/,
                end: /"/,
                contains: [
                    y,
                    {
                        scope: `char.escape`,
                        variants: [
                            {
                                match: /\\\\|\\["0%abefnrtv]/
                            },
                            {
                                match: /\\x[0-9A-F]{2}/
                            },
                            {
                                match: /\\u[0-9A-F]{4}/
                            },
                            {
                                match: /\\U[0-9A-F]{8}/
                            }
                        ]
                    }
                ]
            };
            y.contains.push(b);
            let x = [
                ...r,
                ...a,
                ...i
            ], S = {
                relevance: 0,
                match: t.concat(`\\b(?!`, x.join(`|`), `\\b)`, /[a-zA-Z_]\w*(?:[?!]|\b)/),
                className: `variable`
            };
            return {
                name: `Wren`,
                keywords: {
                    keyword: r,
                    "variable.language": a,
                    literal: i
                },
                contains: [
                    {
                        scope: `comment`,
                        variants: [
                            {
                                begin: [
                                    /#!?/,
                                    /[A-Za-z_]+(?=\()/
                                ],
                                beginScope: {},
                                keywords: {
                                    literal: i
                                },
                                contains: [],
                                end: /\)/
                            },
                            {
                                begin: [
                                    /#!?/,
                                    /[A-Za-z_]+/
                                ],
                                beginScope: {},
                                end: /$/
                            }
                        ]
                    },
                    g,
                    b,
                    f,
                    v,
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    h,
                    u,
                    _,
                    l,
                    c,
                    d,
                    m,
                    p,
                    S
                ]
            };
        }
        t.exports = n;
    }), zn = o((e, t)=>{
        function n(e) {
            return {
                name: `Intel x86 Assembly`,
                case_insensitive: !0,
                keywords: {
                    $pattern: `[.%]?` + e.IDENT_RE,
                    keyword: `lock rep repe repz repne repnz xaquire xrelease bnd nobnd aaa aad aam aas adc add and arpl bb0_reset bb1_reset bound bsf bsr bswap bt btc btr bts call cbw cdq cdqe clc cld cli clts cmc cmp cmpsb cmpsd cmpsq cmpsw cmpxchg cmpxchg486 cmpxchg8b cmpxchg16b cpuid cpu_read cpu_write cqo cwd cwde daa das dec div dmint emms enter equ f2xm1 fabs fadd faddp fbld fbstp fchs fclex fcmovb fcmovbe fcmove fcmovnb fcmovnbe fcmovne fcmovnu fcmovu fcom fcomi fcomip fcomp fcompp fcos fdecstp fdisi fdiv fdivp fdivr fdivrp femms feni ffree ffreep fiadd ficom ficomp fidiv fidivr fild fimul fincstp finit fist fistp fisttp fisub fisubr fld fld1 fldcw fldenv fldl2e fldl2t fldlg2 fldln2 fldpi fldz fmul fmulp fnclex fndisi fneni fninit fnop fnsave fnstcw fnstenv fnstsw fpatan fprem fprem1 fptan frndint frstor fsave fscale fsetpm fsin fsincos fsqrt fst fstcw fstenv fstp fstsw fsub fsubp fsubr fsubrp ftst fucom fucomi fucomip fucomp fucompp fxam fxch fxtract fyl2x fyl2xp1 hlt ibts icebp idiv imul in inc incbin insb insd insw int int01 int1 int03 int3 into invd invpcid invlpg invlpga iret iretd iretq iretw jcxz jecxz jrcxz jmp jmpe lahf lar lds lea leave les lfence lfs lgdt lgs lidt lldt lmsw loadall loadall286 lodsb lodsd lodsq lodsw loop loope loopne loopnz loopz lsl lss ltr mfence monitor mov movd movq movsb movsd movsq movsw movsx movsxd movzx mul mwait neg nop not or out outsb outsd outsw packssdw packsswb packuswb paddb paddd paddsb paddsiw paddsw paddusb paddusw paddw pand pandn pause paveb pavgusb pcmpeqb pcmpeqd pcmpeqw pcmpgtb pcmpgtd pcmpgtw pdistib pf2id pfacc pfadd pfcmpeq pfcmpge pfcmpgt pfmax pfmin pfmul pfrcp pfrcpit1 pfrcpit2 pfrsqit1 pfrsqrt pfsub pfsubr pi2fd pmachriw pmaddwd pmagw pmulhriw pmulhrwa pmulhrwc pmulhw pmullw pmvgezb pmvlzb pmvnzb pmvzb pop popa popad popaw popf popfd popfq popfw por prefetch prefetchw pslld psllq psllw psrad psraw psrld psrlq psrlw psubb psubd psubsb psubsiw psubsw psubusb psubusw psubw punpckhbw punpckhdq punpckhwd punpcklbw punpckldq punpcklwd push pusha pushad pushaw pushf pushfd pushfq pushfw pxor rcl rcr rdshr rdmsr rdpmc rdtsc rdtscp ret retf retn rol ror rdm rsdc rsldt rsm rsts sahf sal salc sar sbb scasb scasd scasq scasw sfence sgdt shl shld shr shrd sidt sldt skinit smi smint smintold smsw stc std sti stosb stosd stosq stosw str sub svdc svldt svts swapgs syscall sysenter sysexit sysret test ud0 ud1 ud2b ud2 ud2a umov verr verw fwait wbinvd wrshr wrmsr xadd xbts xchg xlatb xlat xor cmove cmovz cmovne cmovnz cmova cmovnbe cmovae cmovnb cmovb cmovnae cmovbe cmovna cmovg cmovnle cmovge cmovnl cmovl cmovnge cmovle cmovng cmovc cmovnc cmovo cmovno cmovs cmovns cmovp cmovpe cmovnp cmovpo je jz jne jnz ja jnbe jae jnb jb jnae jbe jna jg jnle jge jnl jl jnge jle jng jc jnc jo jno js jns jpo jnp jpe jp sete setz setne setnz seta setnbe setae setnb setnc setb setnae setcset setbe setna setg setnle setge setnl setl setnge setle setng sets setns seto setno setpe setp setpo setnp addps addss andnps andps cmpeqps cmpeqss cmpleps cmpless cmpltps cmpltss cmpneqps cmpneqss cmpnleps cmpnless cmpnltps cmpnltss cmpordps cmpordss cmpunordps cmpunordss cmpps cmpss comiss cvtpi2ps cvtps2pi cvtsi2ss cvtss2si cvttps2pi cvttss2si divps divss ldmxcsr maxps maxss minps minss movaps movhps movlhps movlps movhlps movmskps movntps movss movups mulps mulss orps rcpps rcpss rsqrtps rsqrtss shufps sqrtps sqrtss stmxcsr subps subss ucomiss unpckhps unpcklps xorps fxrstor fxrstor64 fxsave fxsave64 xgetbv xsetbv xsave xsave64 xsaveopt xsaveopt64 xrstor xrstor64 prefetchnta prefetcht0 prefetcht1 prefetcht2 maskmovq movntq pavgb pavgw pextrw pinsrw pmaxsw pmaxub pminsw pminub pmovmskb pmulhuw psadbw pshufw pf2iw pfnacc pfpnacc pi2fw pswapd maskmovdqu clflush movntdq movnti movntpd movdqa movdqu movdq2q movq2dq paddq pmuludq pshufd pshufhw pshuflw pslldq psrldq psubq punpckhqdq punpcklqdq addpd addsd andnpd andpd cmpeqpd cmpeqsd cmplepd cmplesd cmpltpd cmpltsd cmpneqpd cmpneqsd cmpnlepd cmpnlesd cmpnltpd cmpnltsd cmpordpd cmpordsd cmpunordpd cmpunordsd cmppd comisd cvtdq2pd cvtdq2ps cvtpd2dq cvtpd2pi cvtpd2ps cvtpi2pd cvtps2dq cvtps2pd cvtsd2si cvtsd2ss cvtsi2sd cvtss2sd cvttpd2pi cvttpd2dq cvttps2dq cvttsd2si divpd divsd maxpd maxsd minpd minsd movapd movhpd movlpd movmskpd movupd mulpd mulsd orpd shufpd sqrtpd sqrtsd subpd subsd ucomisd unpckhpd unpcklpd xorpd addsubpd addsubps haddpd haddps hsubpd hsubps lddqu movddup movshdup movsldup clgi stgi vmcall vmclear vmfunc vmlaunch vmload vmmcall vmptrld vmptrst vmread vmresume vmrun vmsave vmwrite vmxoff vmxon invept invvpid pabsb pabsw pabsd palignr phaddw phaddd phaddsw phsubw phsubd phsubsw pmaddubsw pmulhrsw pshufb psignb psignw psignd extrq insertq movntsd movntss lzcnt blendpd blendps blendvpd blendvps dppd dpps extractps insertps movntdqa mpsadbw packusdw pblendvb pblendw pcmpeqq pextrb pextrd pextrq phminposuw pinsrb pinsrd pinsrq pmaxsb pmaxsd pmaxud pmaxuw pminsb pminsd pminud pminuw pmovsxbw pmovsxbd pmovsxbq pmovsxwd pmovsxwq pmovsxdq pmovzxbw pmovzxbd pmovzxbq pmovzxwd pmovzxwq pmovzxdq pmuldq pmulld ptest roundpd roundps roundsd roundss crc32 pcmpestri pcmpestrm pcmpistri pcmpistrm pcmpgtq popcnt getsec pfrcpv pfrsqrtv movbe aesenc aesenclast aesdec aesdeclast aesimc aeskeygenassist vaesenc vaesenclast vaesdec vaesdeclast vaesimc vaeskeygenassist vaddpd vaddps vaddsd vaddss vaddsubpd vaddsubps vandpd vandps vandnpd vandnps vblendpd vblendps vblendvpd vblendvps vbroadcastss vbroadcastsd vbroadcastf128 vcmpeq_ospd vcmpeqpd vcmplt_ospd vcmpltpd vcmple_ospd vcmplepd vcmpunord_qpd vcmpunordpd vcmpneq_uqpd vcmpneqpd vcmpnlt_uspd vcmpnltpd vcmpnle_uspd vcmpnlepd vcmpord_qpd vcmpordpd vcmpeq_uqpd vcmpnge_uspd vcmpngepd vcmpngt_uspd vcmpngtpd vcmpfalse_oqpd vcmpfalsepd vcmpneq_oqpd vcmpge_ospd vcmpgepd vcmpgt_ospd vcmpgtpd vcmptrue_uqpd vcmptruepd vcmplt_oqpd vcmple_oqpd vcmpunord_spd vcmpneq_uspd vcmpnlt_uqpd vcmpnle_uqpd vcmpord_spd vcmpeq_uspd vcmpnge_uqpd vcmpngt_uqpd vcmpfalse_ospd vcmpneq_ospd vcmpge_oqpd vcmpgt_oqpd vcmptrue_uspd vcmppd vcmpeq_osps vcmpeqps vcmplt_osps vcmpltps vcmple_osps vcmpleps vcmpunord_qps vcmpunordps vcmpneq_uqps vcmpneqps vcmpnlt_usps vcmpnltps vcmpnle_usps vcmpnleps vcmpord_qps vcmpordps vcmpeq_uqps vcmpnge_usps vcmpngeps vcmpngt_usps vcmpngtps vcmpfalse_oqps vcmpfalseps vcmpneq_oqps vcmpge_osps vcmpgeps vcmpgt_osps vcmpgtps vcmptrue_uqps vcmptrueps vcmplt_oqps vcmple_oqps vcmpunord_sps vcmpneq_usps vcmpnlt_uqps vcmpnle_uqps vcmpord_sps vcmpeq_usps vcmpnge_uqps vcmpngt_uqps vcmpfalse_osps vcmpneq_osps vcmpge_oqps vcmpgt_oqps vcmptrue_usps vcmpps vcmpeq_ossd vcmpeqsd vcmplt_ossd vcmpltsd vcmple_ossd vcmplesd vcmpunord_qsd vcmpunordsd vcmpneq_uqsd vcmpneqsd vcmpnlt_ussd vcmpnltsd vcmpnle_ussd vcmpnlesd vcmpord_qsd vcmpordsd vcmpeq_uqsd vcmpnge_ussd vcmpngesd vcmpngt_ussd vcmpngtsd vcmpfalse_oqsd vcmpfalsesd vcmpneq_oqsd vcmpge_ossd vcmpgesd vcmpgt_ossd vcmpgtsd vcmptrue_uqsd vcmptruesd vcmplt_oqsd vcmple_oqsd vcmpunord_ssd vcmpneq_ussd vcmpnlt_uqsd vcmpnle_uqsd vcmpord_ssd vcmpeq_ussd vcmpnge_uqsd vcmpngt_uqsd vcmpfalse_ossd vcmpneq_ossd vcmpge_oqsd vcmpgt_oqsd vcmptrue_ussd vcmpsd vcmpeq_osss vcmpeqss vcmplt_osss vcmpltss vcmple_osss vcmpless vcmpunord_qss vcmpunordss vcmpneq_uqss vcmpneqss vcmpnlt_usss vcmpnltss vcmpnle_usss vcmpnless vcmpord_qss vcmpordss vcmpeq_uqss vcmpnge_usss vcmpngess vcmpngt_usss vcmpngtss vcmpfalse_oqss vcmpfalsess vcmpneq_oqss vcmpge_osss vcmpgess vcmpgt_osss vcmpgtss vcmptrue_uqss vcmptruess vcmplt_oqss vcmple_oqss vcmpunord_sss vcmpneq_usss vcmpnlt_uqss vcmpnle_uqss vcmpord_sss vcmpeq_usss vcmpnge_uqss vcmpngt_uqss vcmpfalse_osss vcmpneq_osss vcmpge_oqss vcmpgt_oqss vcmptrue_usss vcmpss vcomisd vcomiss vcvtdq2pd vcvtdq2ps vcvtpd2dq vcvtpd2ps vcvtps2dq vcvtps2pd vcvtsd2si vcvtsd2ss vcvtsi2sd vcvtsi2ss vcvtss2sd vcvtss2si vcvttpd2dq vcvttps2dq vcvttsd2si vcvttss2si vdivpd vdivps vdivsd vdivss vdppd vdpps vextractf128 vextractps vhaddpd vhaddps vhsubpd vhsubps vinsertf128 vinsertps vlddqu vldqqu vldmxcsr vmaskmovdqu vmaskmovps vmaskmovpd vmaxpd vmaxps vmaxsd vmaxss vminpd vminps vminsd vminss vmovapd vmovaps vmovd vmovq vmovddup vmovdqa vmovqqa vmovdqu vmovqqu vmovhlps vmovhpd vmovhps vmovlhps vmovlpd vmovlps vmovmskpd vmovmskps vmovntdq vmovntqq vmovntdqa vmovntpd vmovntps vmovsd vmovshdup vmovsldup vmovss vmovupd vmovups vmpsadbw vmulpd vmulps vmulsd vmulss vorpd vorps vpabsb vpabsw vpabsd vpacksswb vpackssdw vpackuswb vpackusdw vpaddb vpaddw vpaddd vpaddq vpaddsb vpaddsw vpaddusb vpaddusw vpalignr vpand vpandn vpavgb vpavgw vpblendvb vpblendw vpcmpestri vpcmpestrm vpcmpistri vpcmpistrm vpcmpeqb vpcmpeqw vpcmpeqd vpcmpeqq vpcmpgtb vpcmpgtw vpcmpgtd vpcmpgtq vpermilpd vpermilps vperm2f128 vpextrb vpextrw vpextrd vpextrq vphaddw vphaddd vphaddsw vphminposuw vphsubw vphsubd vphsubsw vpinsrb vpinsrw vpinsrd vpinsrq vpmaddwd vpmaddubsw vpmaxsb vpmaxsw vpmaxsd vpmaxub vpmaxuw vpmaxud vpminsb vpminsw vpminsd vpminub vpminuw vpminud vpmovmskb vpmovsxbw vpmovsxbd vpmovsxbq vpmovsxwd vpmovsxwq vpmovsxdq vpmovzxbw vpmovzxbd vpmovzxbq vpmovzxwd vpmovzxwq vpmovzxdq vpmulhuw vpmulhrsw vpmulhw vpmullw vpmulld vpmuludq vpmuldq vpor vpsadbw vpshufb vpshufd vpshufhw vpshuflw vpsignb vpsignw vpsignd vpslldq vpsrldq vpsllw vpslld vpsllq vpsraw vpsrad vpsrlw vpsrld vpsrlq vptest vpsubb vpsubw vpsubd vpsubq vpsubsb vpsubsw vpsubusb vpsubusw vpunpckhbw vpunpckhwd vpunpckhdq vpunpckhqdq vpunpcklbw vpunpcklwd vpunpckldq vpunpcklqdq vpxor vrcpps vrcpss vrsqrtps vrsqrtss vroundpd vroundps vroundsd vroundss vshufpd vshufps vsqrtpd vsqrtps vsqrtsd vsqrtss vstmxcsr vsubpd vsubps vsubsd vsubss vtestps vtestpd vucomisd vucomiss vunpckhpd vunpckhps vunpcklpd vunpcklps vxorpd vxorps vzeroall vzeroupper pclmullqlqdq pclmulhqlqdq pclmullqhqdq pclmulhqhqdq pclmulqdq vpclmullqlqdq vpclmulhqlqdq vpclmullqhqdq vpclmulhqhqdq vpclmulqdq vfmadd132ps vfmadd132pd vfmadd312ps vfmadd312pd vfmadd213ps vfmadd213pd vfmadd123ps vfmadd123pd vfmadd231ps vfmadd231pd vfmadd321ps vfmadd321pd vfmaddsub132ps vfmaddsub132pd vfmaddsub312ps vfmaddsub312pd vfmaddsub213ps vfmaddsub213pd vfmaddsub123ps vfmaddsub123pd vfmaddsub231ps vfmaddsub231pd vfmaddsub321ps vfmaddsub321pd vfmsub132ps vfmsub132pd vfmsub312ps vfmsub312pd vfmsub213ps vfmsub213pd vfmsub123ps vfmsub123pd vfmsub231ps vfmsub231pd vfmsub321ps vfmsub321pd vfmsubadd132ps vfmsubadd132pd vfmsubadd312ps vfmsubadd312pd vfmsubadd213ps vfmsubadd213pd vfmsubadd123ps vfmsubadd123pd vfmsubadd231ps vfmsubadd231pd vfmsubadd321ps vfmsubadd321pd vfnmadd132ps vfnmadd132pd vfnmadd312ps vfnmadd312pd vfnmadd213ps vfnmadd213pd vfnmadd123ps vfnmadd123pd vfnmadd231ps vfnmadd231pd vfnmadd321ps vfnmadd321pd vfnmsub132ps vfnmsub132pd vfnmsub312ps vfnmsub312pd vfnmsub213ps vfnmsub213pd vfnmsub123ps vfnmsub123pd vfnmsub231ps vfnmsub231pd vfnmsub321ps vfnmsub321pd vfmadd132ss vfmadd132sd vfmadd312ss vfmadd312sd vfmadd213ss vfmadd213sd vfmadd123ss vfmadd123sd vfmadd231ss vfmadd231sd vfmadd321ss vfmadd321sd vfmsub132ss vfmsub132sd vfmsub312ss vfmsub312sd vfmsub213ss vfmsub213sd vfmsub123ss vfmsub123sd vfmsub231ss vfmsub231sd vfmsub321ss vfmsub321sd vfnmadd132ss vfnmadd132sd vfnmadd312ss vfnmadd312sd vfnmadd213ss vfnmadd213sd vfnmadd123ss vfnmadd123sd vfnmadd231ss vfnmadd231sd vfnmadd321ss vfnmadd321sd vfnmsub132ss vfnmsub132sd vfnmsub312ss vfnmsub312sd vfnmsub213ss vfnmsub213sd vfnmsub123ss vfnmsub123sd vfnmsub231ss vfnmsub231sd vfnmsub321ss vfnmsub321sd rdfsbase rdgsbase rdrand wrfsbase wrgsbase vcvtph2ps vcvtps2ph adcx adox rdseed clac stac xstore xcryptecb xcryptcbc xcryptctr xcryptcfb xcryptofb montmul xsha1 xsha256 llwpcb slwpcb lwpval lwpins vfmaddpd vfmaddps vfmaddsd vfmaddss vfmaddsubpd vfmaddsubps vfmsubaddpd vfmsubaddps vfmsubpd vfmsubps vfmsubsd vfmsubss vfnmaddpd vfnmaddps vfnmaddsd vfnmaddss vfnmsubpd vfnmsubps vfnmsubsd vfnmsubss vfrczpd vfrczps vfrczsd vfrczss vpcmov vpcomb vpcomd vpcomq vpcomub vpcomud vpcomuq vpcomuw vpcomw vphaddbd vphaddbq vphaddbw vphadddq vphaddubd vphaddubq vphaddubw vphaddudq vphadduwd vphadduwq vphaddwd vphaddwq vphsubbw vphsubdq vphsubwd vpmacsdd vpmacsdqh vpmacsdql vpmacssdd vpmacssdqh vpmacssdql vpmacsswd vpmacssww vpmacswd vpmacsww vpmadcsswd vpmadcswd vpperm vprotb vprotd vprotq vprotw vpshab vpshad vpshaq vpshaw vpshlb vpshld vpshlq vpshlw vbroadcasti128 vpblendd vpbroadcastb vpbroadcastw vpbroadcastd vpbroadcastq vpermd vpermpd vpermps vpermq vperm2i128 vextracti128 vinserti128 vpmaskmovd vpmaskmovq vpsllvd vpsllvq vpsravd vpsrlvd vpsrlvq vgatherdpd vgatherqpd vgatherdps vgatherqps vpgatherdd vpgatherqd vpgatherdq vpgatherqq xabort xbegin xend xtest andn bextr blci blcic blsi blsic blcfill blsfill blcmsk blsmsk blsr blcs bzhi mulx pdep pext rorx sarx shlx shrx tzcnt tzmsk t1mskc valignd valignq vblendmpd vblendmps vbroadcastf32x4 vbroadcastf64x4 vbroadcasti32x4 vbroadcasti64x4 vcompresspd vcompressps vcvtpd2udq vcvtps2udq vcvtsd2usi vcvtss2usi vcvttpd2udq vcvttps2udq vcvttsd2usi vcvttss2usi vcvtudq2pd vcvtudq2ps vcvtusi2sd vcvtusi2ss vexpandpd vexpandps vextractf32x4 vextractf64x4 vextracti32x4 vextracti64x4 vfixupimmpd vfixupimmps vfixupimmsd vfixupimmss vgetexppd vgetexpps vgetexpsd vgetexpss vgetmantpd vgetmantps vgetmantsd vgetmantss vinsertf32x4 vinsertf64x4 vinserti32x4 vinserti64x4 vmovdqa32 vmovdqa64 vmovdqu32 vmovdqu64 vpabsq vpandd vpandnd vpandnq vpandq vpblendmd vpblendmq vpcmpltd vpcmpled vpcmpneqd vpcmpnltd vpcmpnled vpcmpd vpcmpltq vpcmpleq vpcmpneqq vpcmpnltq vpcmpnleq vpcmpq vpcmpequd vpcmpltud vpcmpleud vpcmpnequd vpcmpnltud vpcmpnleud vpcmpud vpcmpequq vpcmpltuq vpcmpleuq vpcmpnequq vpcmpnltuq vpcmpnleuq vpcmpuq vpcompressd vpcompressq vpermi2d vpermi2pd vpermi2ps vpermi2q vpermt2d vpermt2pd vpermt2ps vpermt2q vpexpandd vpexpandq vpmaxsq vpmaxuq vpminsq vpminuq vpmovdb vpmovdw vpmovqb vpmovqd vpmovqw vpmovsdb vpmovsdw vpmovsqb vpmovsqd vpmovsqw vpmovusdb vpmovusdw vpmovusqb vpmovusqd vpmovusqw vpord vporq vprold vprolq vprolvd vprolvq vprord vprorq vprorvd vprorvq vpscatterdd vpscatterdq vpscatterqd vpscatterqq vpsraq vpsravq vpternlogd vpternlogq vptestmd vptestmq vptestnmd vptestnmq vpxord vpxorq vrcp14pd vrcp14ps vrcp14sd vrcp14ss vrndscalepd vrndscaleps vrndscalesd vrndscaless vrsqrt14pd vrsqrt14ps vrsqrt14sd vrsqrt14ss vscalefpd vscalefps vscalefsd vscalefss vscatterdpd vscatterdps vscatterqpd vscatterqps vshuff32x4 vshuff64x2 vshufi32x4 vshufi64x2 kandnw kandw kmovw knotw kortestw korw kshiftlw kshiftrw kunpckbw kxnorw kxorw vpbroadcastmb2q vpbroadcastmw2d vpconflictd vpconflictq vplzcntd vplzcntq vexp2pd vexp2ps vrcp28pd vrcp28ps vrcp28sd vrcp28ss vrsqrt28pd vrsqrt28ps vrsqrt28sd vrsqrt28ss vgatherpf0dpd vgatherpf0dps vgatherpf0qpd vgatherpf0qps vgatherpf1dpd vgatherpf1dps vgatherpf1qpd vgatherpf1qps vscatterpf0dpd vscatterpf0dps vscatterpf0qpd vscatterpf0qps vscatterpf1dpd vscatterpf1dps vscatterpf1qpd vscatterpf1qps prefetchwt1 bndmk bndcl bndcu bndcn bndmov bndldx bndstx sha1rnds4 sha1nexte sha1msg1 sha1msg2 sha256rnds2 sha256msg1 sha256msg2 hint_nop0 hint_nop1 hint_nop2 hint_nop3 hint_nop4 hint_nop5 hint_nop6 hint_nop7 hint_nop8 hint_nop9 hint_nop10 hint_nop11 hint_nop12 hint_nop13 hint_nop14 hint_nop15 hint_nop16 hint_nop17 hint_nop18 hint_nop19 hint_nop20 hint_nop21 hint_nop22 hint_nop23 hint_nop24 hint_nop25 hint_nop26 hint_nop27 hint_nop28 hint_nop29 hint_nop30 hint_nop31 hint_nop32 hint_nop33 hint_nop34 hint_nop35 hint_nop36 hint_nop37 hint_nop38 hint_nop39 hint_nop40 hint_nop41 hint_nop42 hint_nop43 hint_nop44 hint_nop45 hint_nop46 hint_nop47 hint_nop48 hint_nop49 hint_nop50 hint_nop51 hint_nop52 hint_nop53 hint_nop54 hint_nop55 hint_nop56 hint_nop57 hint_nop58 hint_nop59 hint_nop60 hint_nop61 hint_nop62 hint_nop63`,
                    built_in: `ip eip rip al ah bl bh cl ch dl dh sil dil bpl spl r8b r9b r10b r11b r12b r13b r14b r15b ax bx cx dx si di bp sp r8w r9w r10w r11w r12w r13w r14w r15w eax ebx ecx edx esi edi ebp esp eip r8d r9d r10d r11d r12d r13d r14d r15d rax rbx rcx rdx rsi rdi rbp rsp r8 r9 r10 r11 r12 r13 r14 r15 cs ds es fs gs ss st st0 st1 st2 st3 st4 st5 st6 st7 mm0 mm1 mm2 mm3 mm4 mm5 mm6 mm7 xmm0  xmm1  xmm2  xmm3  xmm4  xmm5  xmm6  xmm7  xmm8  xmm9 xmm10  xmm11 xmm12 xmm13 xmm14 xmm15 xmm16 xmm17 xmm18 xmm19 xmm20 xmm21 xmm22 xmm23 xmm24 xmm25 xmm26 xmm27 xmm28 xmm29 xmm30 xmm31 ymm0  ymm1  ymm2  ymm3  ymm4  ymm5  ymm6  ymm7  ymm8  ymm9 ymm10  ymm11 ymm12 ymm13 ymm14 ymm15 ymm16 ymm17 ymm18 ymm19 ymm20 ymm21 ymm22 ymm23 ymm24 ymm25 ymm26 ymm27 ymm28 ymm29 ymm30 ymm31 zmm0  zmm1  zmm2  zmm3  zmm4  zmm5  zmm6  zmm7  zmm8  zmm9 zmm10  zmm11 zmm12 zmm13 zmm14 zmm15 zmm16 zmm17 zmm18 zmm19 zmm20 zmm21 zmm22 zmm23 zmm24 zmm25 zmm26 zmm27 zmm28 zmm29 zmm30 zmm31 k0 k1 k2 k3 k4 k5 k6 k7 bnd0 bnd1 bnd2 bnd3 cr0 cr1 cr2 cr3 cr4 cr8 dr0 dr1 dr2 dr3 dr8 tr3 tr4 tr5 tr6 tr7 r0 r1 r2 r3 r4 r5 r6 r7 r0b r1b r2b r3b r4b r5b r6b r7b r0w r1w r2w r3w r4w r5w r6w r7w r0d r1d r2d r3d r4d r5d r6d r7d r0h r1h r2h r3h r0l r1l r2l r3l r4l r5l r6l r7l r8l r9l r10l r11l r12l r13l r14l r15l db dw dd dq dt ddq do dy dz resb resw resd resq rest resdq reso resy resz incbin equ times byte word dword qword nosplit rel abs seg wrt strict near far a32 ptr`,
                    meta: `%define %xdefine %+ %undef %defstr %deftok %assign %strcat %strlen %substr %rotate %elif %else %endif %if %ifmacro %ifctx %ifidn %ifidni %ifid %ifnum %ifstr %iftoken %ifempty %ifenv %error %warning %fatal %rep %endrep %include %push %pop %repl %pathsearch %depend %use %arg %stacksize %local %line %comment %endcomment .nolist __FILE__ __LINE__ __SECT__  __BITS__ __OUTPUT_FORMAT__ __DATE__ __TIME__ __DATE_NUM__ __TIME_NUM__ __UTC_DATE__ __UTC_TIME__ __UTC_DATE_NUM__ __UTC_TIME_NUM__  __PASS__ struc endstruc istruc at iend align alignb sectalign daz nodaz up down zero default option assume public bits use16 use32 use64 default section segment absolute extern global common cpu float __utf16__ __utf16le__ __utf16be__ __utf32__ __utf32le__ __utf32be__ __float8__ __float16__ __float32__ __float64__ __float80m__ __float80e__ __float128l__ __float128h__ __Infinity__ __QNaN__ __SNaN__ Inf NaN QNaN SNaN float8 float16 float32 float64 float80m float80e float128l float128h __FLOAT_DAZ__ __FLOAT_ROUND__ __FLOAT__`
                },
                contains: [
                    e.COMMENT(`;`, `$`, {
                        relevance: 0
                    }),
                    {
                        className: `number`,
                        variants: [
                            {
                                begin: `\\b(?:([0-9][0-9_]*)?\\.[0-9_]*(?:[eE][+-]?[0-9_]+)?|(0[Xx])?[0-9][0-9_]*(\\.[0-9_]*)?(?:[pP](?:[+-]?[0-9_]+)?)?)\\b`,
                                relevance: 0
                            },
                            {
                                begin: `\\$[0-9][0-9A-Fa-f]*`,
                                relevance: 0
                            },
                            {
                                begin: `\\b(?:[0-9A-Fa-f][0-9A-Fa-f_]*[Hh]|[0-9][0-9_]*[DdTt]?|[0-7][0-7_]*[QqOo]|[0-1][0-1_]*[BbYy])\\b`
                            },
                            {
                                begin: `\\b(?:0[Xx][0-9A-Fa-f_]+|0[DdTt][0-9_]+|0[QqOo][0-7_]+|0[BbYy][0-1_]+)\\b`
                            }
                        ]
                    },
                    e.QUOTE_STRING_MODE,
                    {
                        className: `string`,
                        variants: [
                            {
                                begin: `'`,
                                end: `[^\\\\]'`
                            },
                            {
                                begin: "`",
                                end: "[^\\\\]`"
                            }
                        ],
                        relevance: 0
                    },
                    {
                        className: `symbol`,
                        variants: [
                            {
                                begin: `^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)`
                            },
                            {
                                begin: `^\\s*%%[A-Za-z0-9_$#@~.?]*:`
                            }
                        ],
                        relevance: 0
                    },
                    {
                        className: `subst`,
                        begin: `%[0-9]+`,
                        relevance: 0
                    },
                    {
                        className: `subst`,
                        begin: `%!S+`,
                        relevance: 0
                    },
                    {
                        className: `meta`,
                        begin: /^\s*\.[\w_-]+/
                    }
                ]
            };
        }
        t.exports = n;
    }), Bn = o((e, t)=>{
        function n(e) {
            let t = {
                $pattern: /[a-zA-Z][a-zA-Z0-9_?]*/,
                keyword: `if.then.else.do.while.until.for.loop.import.with.is.as.where.when.by.data.constant.integer.real.text.name.boolean.symbol.infix.prefix.postfix.block.tree`.split(`.`),
                literal: [
                    `true`,
                    `false`,
                    `nil`
                ],
                built_in: `in.mod.rem.and.or.xor.not.abs.sign.floor.ceil.sqrt.sin.cos.tan.asin.acos.atan.exp.expm1.log.log2.log10.log1p.pi.at.text_length.text_range.text_find.text_replace.contains.page.slide.basic_slide.title_slide.title.subtitle.fade_in.fade_out.fade_at.clear_color.color.line_color.line_width.texture_wrap.texture_transform.texture.scale_?x.scale_?y.scale_?z?.translate_?x.translate_?y.translate_?z?.rotate_?x.rotate_?y.rotate_?z?.rectangle.circle.ellipse.sphere.path.line_to.move_to.quad_to.curve_to.theme.background.contents.locally.time.mouse_?x.mouse_?y.mouse_buttons`.split(`.`).concat([
                    `ObjectLoader`,
                    `Animate`,
                    `MovieCredits`,
                    `Slides`,
                    `Filters`,
                    `Shading`,
                    `Materials`,
                    `LensFlare`,
                    `Mapping`,
                    `VLCAudioVideo`,
                    `StereoDecoder`,
                    `PointCloud`,
                    `NetworkAccess`,
                    `RemoteControl`,
                    `RegExp`,
                    `ChromaKey`,
                    `Snowfall`,
                    `NodeJS`,
                    `Speech`,
                    `Charts`
                ])
            }, n = {
                className: `string`,
                begin: `"`,
                end: `"`,
                illegal: `\\n`
            }, r = {
                className: `string`,
                begin: `'`,
                end: `'`,
                illegal: `\\n`
            }, i = {
                className: `string`,
                begin: `<<`,
                end: `>>`
            }, a = {
                className: `number`,
                begin: `[0-9]+#[0-9A-Z_]+(\\.[0-9-A-Z_]+)?#?([Ee][+-]?[0-9]+)?`
            }, o = {
                beginKeywords: `import`,
                end: `$`,
                keywords: t,
                contains: [
                    n
                ]
            }, s = {
                className: `function`,
                begin: /[a-z][^\n]*->/,
                returnBegin: !0,
                end: /->/,
                contains: [
                    e.inherit(e.TITLE_MODE, {
                        starts: {
                            endsWithParent: !0,
                            keywords: t
                        }
                    })
                ]
            };
            return {
                name: `XL`,
                aliases: [
                    `tao`
                ],
                keywords: t,
                contains: [
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    n,
                    r,
                    i,
                    s,
                    o,
                    a,
                    e.NUMBER_MODE
                ]
            };
        }
        t.exports = n;
    }), Vn = o((e, t)=>{
        function n(e) {
            return {
                name: `XQuery`,
                aliases: [
                    `xpath`,
                    `xq`,
                    `xqm`
                ],
                case_insensitive: !1,
                illegal: /(proc)|(abstract)|(extends)|(until)|(#)/,
                keywords: {
                    $pattern: /[a-zA-Z$][a-zA-Z0-9_:-]*/,
                    keyword: `module.schema.namespace.boundary-space.preserve.no-preserve.strip.default.collation.base-uri.ordering.context.decimal-format.decimal-separator.copy-namespaces.empty-sequence.except.exponent-separator.external.grouping-separator.inherit.no-inherit.lax.minus-sign.per-mille.percent.schema-attribute.schema-element.strict.unordered.zero-digit.declare.import.option.function.validate.variable.for.at.in.let.where.order.group.by.return.if.then.else.tumbling.sliding.window.start.when.only.end.previous.next.stable.ascending.descending.allowing.empty.greatest.least.some.every.satisfies.switch.case.typeswitch.try.catch.and.or.to.union.intersect.instance.of.treat.as.castable.cast.map.array.delete.insert.into.replace.value.rename.copy.modify.update`.split(`.`),
                    type: `item.document-node.node.attribute.document.element.comment.namespace.namespace-node.processing-instruction.text.construction.xs:anyAtomicType.xs:untypedAtomic.xs:duration.xs:time.xs:decimal.xs:float.xs:double.xs:gYearMonth.xs:gYear.xs:gMonthDay.xs:gMonth.xs:gDay.xs:boolean.xs:base64Binary.xs:hexBinary.xs:anyURI.xs:QName.xs:NOTATION.xs:dateTime.xs:dateTimeStamp.xs:date.xs:string.xs:normalizedString.xs:token.xs:language.xs:NMTOKEN.xs:Name.xs:NCName.xs:ID.xs:IDREF.xs:ENTITY.xs:integer.xs:nonPositiveInteger.xs:negativeInteger.xs:long.xs:int.xs:short.xs:byte.xs:nonNegativeInteger.xs:unisignedLong.xs:unsignedInt.xs:unsignedShort.xs:unsignedByte.xs:positiveInteger.xs:yearMonthDuration.xs:dayTimeDuration`.split(`.`),
                    literal: [
                        `eq`,
                        `ne`,
                        `lt`,
                        `le`,
                        `gt`,
                        `ge`,
                        `is`,
                        `self::`,
                        `child::`,
                        `descendant::`,
                        `descendant-or-self::`,
                        `attribute::`,
                        `following::`,
                        `following-sibling::`,
                        `parent::`,
                        `ancestor::`,
                        `ancestor-or-self::`,
                        `preceding::`,
                        `preceding-sibling::`,
                        `NaN`
                    ]
                },
                contains: [
                    {
                        className: `variable`,
                        begin: /[$][\w\-:]+/
                    },
                    {
                        className: `built_in`,
                        variants: [
                            {
                                begin: /\barray:/,
                                end: /(?:append|filter|flatten|fold-(?:left|right)|for-each(?:-pair)?|get|head|insert-before|join|put|remove|reverse|size|sort|subarray|tail)\b/
                            },
                            {
                                begin: /\bmap:/,
                                end: /(?:contains|entry|find|for-each|get|keys|merge|put|remove|size)\b/
                            },
                            {
                                begin: /\bmath:/,
                                end: /(?:a(?:cos|sin|tan[2]?)|cos|exp(?:10)?|log(?:10)?|pi|pow|sin|sqrt|tan)\b/
                            },
                            {
                                begin: /\bop:/,
                                end: /\(/,
                                excludeEnd: !0
                            },
                            {
                                begin: /\bfn:/,
                                end: /\(/,
                                excludeEnd: !0
                            },
                            {
                                begin: /[^</$:'"-]\b(?:abs|accumulator-(?:after|before)|adjust-(?:date(?:Time)?|time)-to-timezone|analyze-string|apply|available-(?:environment-variables|system-properties)|avg|base-uri|boolean|ceiling|codepoints?-(?:equal|to-string)|collation-key|collection|compare|concat|contains(?:-token)?|copy-of|count|current(?:-)?(?:date(?:Time)?|time|group(?:ing-key)?|output-uri|merge-(?:group|key))?data|dateTime|days?-from-(?:date(?:Time)?|duration)|deep-equal|default-(?:collation|language)|distinct-values|document(?:-uri)?|doc(?:-available)?|element-(?:available|with-id)|empty|encode-for-uri|ends-with|environment-variable|error|escape-html-uri|exactly-one|exists|false|filter|floor|fold-(?:left|right)|for-each(?:-pair)?|format-(?:date(?:Time)?|time|integer|number)|function-(?:arity|available|lookup|name)|generate-id|has-children|head|hours-from-(?:dateTime|duration|time)|id(?:ref)?|implicit-timezone|in-scope-prefixes|index-of|innermost|insert-before|iri-to-uri|json-(?:doc|to-xml)|key|lang|last|load-xquery-module|local-name(?:-from-QName)?|(?:lower|upper)-case|matches|max|minutes-from-(?:dateTime|duration|time)|min|months?-from-(?:date(?:Time)?|duration)|name(?:space-uri-?(?:for-prefix|from-QName)?)?|nilled|node-name|normalize-(?:space|unicode)|not|number|one-or-more|outermost|parse-(?:ietf-date|json)|path|position|(?:prefix-from-)?QName|random-number-generator|regex-group|remove|replace|resolve-(?:QName|uri)|reverse|root|round(?:-half-to-even)?|seconds-from-(?:dateTime|duration|time)|snapshot|sort|starts-with|static-base-uri|stream-available|string-?(?:join|length|to-codepoints)?|subsequence|substring-?(?:after|before)?|sum|system-property|tail|timezone-from-(?:date(?:Time)?|time)|tokenize|trace|trans(?:form|late)|true|type-available|unordered|unparsed-(?:entity|text)?-?(?:public-id|uri|available|lines)?|uri-collection|xml-to-json|years?-from-(?:date(?:Time)?|duration)|zero-or-one)\b/
                            },
                            {
                                begin: /\blocal:/,
                                end: /\(/,
                                excludeEnd: !0
                            },
                            {
                                begin: /\bzip:/,
                                end: /(?:zip-file|(?:xml|html|text|binary)-entry| (?:update-)?entries)\b/
                            },
                            {
                                begin: /\b(?:util|db|functx|app|xdmp|xmldb):/,
                                end: /\(/,
                                excludeEnd: !0
                            }
                        ]
                    },
                    {
                        className: `string`,
                        variants: [
                            {
                                begin: /"/,
                                end: /"/,
                                contains: [
                                    {
                                        begin: /""/,
                                        relevance: 0
                                    }
                                ]
                            },
                            {
                                begin: /'/,
                                end: /'/,
                                contains: [
                                    {
                                        begin: /''/,
                                        relevance: 0
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        className: `number`,
                        begin: /(\b0[0-7_]+)|(\b0x[0-9a-fA-F_]+)|(\b[1-9][0-9_]*(\.[0-9_]+)?)|[0_]\b/,
                        relevance: 0
                    },
                    {
                        className: `comment`,
                        begin: /\(:/,
                        end: /:\)/,
                        relevance: 10,
                        contains: [
                            {
                                className: `doctag`,
                                begin: /@\w+/
                            }
                        ]
                    },
                    {
                        className: `meta`,
                        begin: /%[\w\-:]+/
                    },
                    {
                        className: `title`,
                        begin: /\bxquery version "[13]\.[01]"\s?(?:encoding ".+")?/,
                        end: /;/
                    },
                    {
                        beginKeywords: `element attribute comment document processing-instruction`,
                        end: /\{/,
                        excludeEnd: !0
                    },
                    {
                        begin: /<([\w._:-]+)(\s+\S*=('|").*('|"))?>/,
                        end: /(\/[\w._:-]+>)/,
                        subLanguage: `xml`,
                        contains: [
                            {
                                begin: /\{/,
                                end: /\}/,
                                subLanguage: `xquery`
                            },
                            `self`
                        ]
                    }
                ]
            };
        }
        t.exports = n;
    }), Hn = o((e, t)=>{
        function n(e) {
            let t = {
                className: `string`,
                contains: [
                    e.BACKSLASH_ESCAPE
                ],
                variants: [
                    e.inherit(e.APOS_STRING_MODE, {
                        illegal: null
                    }),
                    e.inherit(e.QUOTE_STRING_MODE, {
                        illegal: null
                    })
                ]
            }, n = e.UNDERSCORE_TITLE_MODE, r = {
                variants: [
                    e.BINARY_NUMBER_MODE,
                    e.C_NUMBER_MODE
                ]
            }, i = `namespace class interface use extends function return abstract final public protected private static deprecated throw try catch Exception echo empty isset instanceof unset let var new const self require if else elseif switch case default do while loop for continue break likely unlikely __LINE__ __FILE__ __DIR__ __FUNCTION__ __CLASS__ __TRAIT__ __METHOD__ __NAMESPACE__ array boolean float double integer object resource string char long unsigned bool int uint ulong uchar true false null undefined`;
            return {
                name: `Zephir`,
                aliases: [
                    `zep`
                ],
                keywords: i,
                contains: [
                    e.C_LINE_COMMENT_MODE,
                    e.COMMENT(/\/\*/, /\*\//, {
                        contains: [
                            {
                                className: `doctag`,
                                begin: /@[A-Za-z]+/
                            }
                        ]
                    }),
                    {
                        className: `string`,
                        begin: /<<<['"]?\w+['"]?$/,
                        end: /^\w+;/,
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ]
                    },
                    {
                        begin: /(::|->)+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/
                    },
                    {
                        className: `function`,
                        beginKeywords: `function fn`,
                        end: /[;{]/,
                        excludeEnd: !0,
                        illegal: /\$|\[|%/,
                        contains: [
                            n,
                            {
                                className: `params`,
                                begin: /\(/,
                                end: /\)/,
                                keywords: i,
                                contains: [
                                    `self`,
                                    e.C_BLOCK_COMMENT_MODE,
                                    t,
                                    r
                                ]
                            }
                        ]
                    },
                    {
                        className: `class`,
                        beginKeywords: `class interface`,
                        end: /\{/,
                        excludeEnd: !0,
                        illegal: /[:($"]/,
                        contains: [
                            {
                                beginKeywords: `extends implements`
                            },
                            n
                        ]
                    },
                    {
                        beginKeywords: `namespace`,
                        end: /;/,
                        illegal: /[.']/,
                        contains: [
                            n
                        ]
                    },
                    {
                        beginKeywords: `use`,
                        end: /;/,
                        contains: [
                            n
                        ]
                    },
                    {
                        begin: /=>/
                    },
                    t,
                    r
                ]
            };
        }
        t.exports = n;
    }), Q = c(o((e, t)=>{
        var n = l();
        n.registerLanguage(`1c`, u()), n.registerLanguage(`abnf`, d()), n.registerLanguage(`accesslog`, f()), n.registerLanguage(`actionscript`, p()), n.registerLanguage(`ada`, m()), n.registerLanguage(`angelscript`, h()), n.registerLanguage(`apache`, g()), n.registerLanguage(`applescript`, _()), n.registerLanguage(`arcade`, v()), n.registerLanguage(`arduino`, y()), n.registerLanguage(`armasm`, b()), n.registerLanguage(`xml`, x()), n.registerLanguage(`asciidoc`, S()), n.registerLanguage(`aspectj`, C()), n.registerLanguage(`autohotkey`, w()), n.registerLanguage(`autoit`, T()), n.registerLanguage(`avrasm`, E()), n.registerLanguage(`awk`, D()), n.registerLanguage(`axapta`, O()), n.registerLanguage(`bash`, k()), n.registerLanguage(`basic`, A()), n.registerLanguage(`bnf`, j()), n.registerLanguage(`brainfuck`, M()), n.registerLanguage(`c`, N()), n.registerLanguage(`cal`, P()), n.registerLanguage(`capnproto`, F()), n.registerLanguage(`ceylon`, I()), n.registerLanguage(`clean`, L()), n.registerLanguage(`clojure`, R()), n.registerLanguage(`clojure-repl`, z()), n.registerLanguage(`cmake`, B()), n.registerLanguage(`coffeescript`, ee()), n.registerLanguage(`coq`, te()), n.registerLanguage(`cos`, V()), n.registerLanguage(`cpp`, ne()), n.registerLanguage(`crmsh`, H()), n.registerLanguage(`crystal`, U()), n.registerLanguage(`csharp`, W()), n.registerLanguage(`csp`, G()), n.registerLanguage(`css`, re()), n.registerLanguage(`d`, ie()), n.registerLanguage(`markdown`, K()), n.registerLanguage(`dart`, ae()), n.registerLanguage(`delphi`, oe()), n.registerLanguage(`diff`, se()), n.registerLanguage(`django`, ce()), n.registerLanguage(`dns`, le()), n.registerLanguage(`dockerfile`, q()), n.registerLanguage(`dos`, ue()), n.registerLanguage(`dsconfig`, de()), n.registerLanguage(`dts`, fe()), n.registerLanguage(`dust`, J()), n.registerLanguage(`ebnf`, pe()), n.registerLanguage(`elixir`, Y()), n.registerLanguage(`elm`, X()), n.registerLanguage(`ruby`, me()), n.registerLanguage(`erb`, he()), n.registerLanguage(`erlang-repl`, ge()), n.registerLanguage(`erlang`, _e()), n.registerLanguage(`excel`, ve()), n.registerLanguage(`fix`, ye()), n.registerLanguage(`flix`, be()), n.registerLanguage(`fortran`, xe()), n.registerLanguage(`fsharp`, Se()), n.registerLanguage(`gams`, Ce()), n.registerLanguage(`gauss`, we()), n.registerLanguage(`gcode`, Te()), n.registerLanguage(`gherkin`, Ee()), n.registerLanguage(`glsl`, De()), n.registerLanguage(`gml`, Oe()), n.registerLanguage(`go`, Z()), n.registerLanguage(`golo`, ke()), n.registerLanguage(`gradle`, Ae()), n.registerLanguage(`graphql`, je()), n.registerLanguage(`groovy`, Me()), n.registerLanguage(`haml`, Ne()), n.registerLanguage(`handlebars`, Pe()), n.registerLanguage(`haskell`, Fe()), n.registerLanguage(`haxe`, Ie()), n.registerLanguage(`hsp`, Le()), n.registerLanguage(`http`, Re()), n.registerLanguage(`hy`, ze()), n.registerLanguage(`inform7`, Be()), n.registerLanguage(`ini`, Ve()), n.registerLanguage(`irpf90`, He()), n.registerLanguage(`isbl`, Ue()), n.registerLanguage(`java`, We()), n.registerLanguage(`javascript`, Ge()), n.registerLanguage(`jboss-cli`, Ke()), n.registerLanguage(`json`, qe()), n.registerLanguage(`julia`, Je()), n.registerLanguage(`julia-repl`, Ye()), n.registerLanguage(`kotlin`, Xe()), n.registerLanguage(`lasso`, Ze()), n.registerLanguage(`latex`, Qe()), n.registerLanguage(`ldif`, $e()), n.registerLanguage(`leaf`, et()), n.registerLanguage(`less`, tt()), n.registerLanguage(`lisp`, nt()), n.registerLanguage(`livecodeserver`, rt()), n.registerLanguage(`livescript`, it()), n.registerLanguage(`llvm`, at()), n.registerLanguage(`lsl`, ot()), n.registerLanguage(`lua`, st()), n.registerLanguage(`makefile`, ct()), n.registerLanguage(`mathematica`, lt()), n.registerLanguage(`matlab`, ut()), n.registerLanguage(`maxima`, dt()), n.registerLanguage(`mel`, ft()), n.registerLanguage(`mercury`, pt()), n.registerLanguage(`mipsasm`, mt()), n.registerLanguage(`mizar`, ht()), n.registerLanguage(`perl`, gt()), n.registerLanguage(`mojolicious`, _t()), n.registerLanguage(`monkey`, vt()), n.registerLanguage(`moonscript`, yt()), n.registerLanguage(`n1ql`, bt()), n.registerLanguage(`nestedtext`, xt()), n.registerLanguage(`nginx`, St()), n.registerLanguage(`nim`, Ct()), n.registerLanguage(`nix`, wt()), n.registerLanguage(`node-repl`, Tt()), n.registerLanguage(`nsis`, Et()), n.registerLanguage(`objectivec`, Dt()), n.registerLanguage(`ocaml`, Ot()), n.registerLanguage(`openscad`, kt()), n.registerLanguage(`oxygene`, At()), n.registerLanguage(`parser3`, jt()), n.registerLanguage(`pf`, Mt()), n.registerLanguage(`pgsql`, Nt()), n.registerLanguage(`php`, Pt()), n.registerLanguage(`php-template`, Ft()), n.registerLanguage(`plaintext`, It()), n.registerLanguage(`pony`, Lt()), n.registerLanguage(`powershell`, Rt()), n.registerLanguage(`processing`, zt()), n.registerLanguage(`profile`, Bt()), n.registerLanguage(`prolog`, Vt()), n.registerLanguage(`properties`, Ht()), n.registerLanguage(`protobuf`, Ut()), n.registerLanguage(`puppet`, Wt()), n.registerLanguage(`purebasic`, Gt()), n.registerLanguage(`python`, Kt()), n.registerLanguage(`python-repl`, qt()), n.registerLanguage(`q`, Jt()), n.registerLanguage(`qml`, Yt()), n.registerLanguage(`r`, Xt()), n.registerLanguage(`reasonml`, Zt()), n.registerLanguage(`rib`, Qt()), n.registerLanguage(`roboconf`, $t()), n.registerLanguage(`routeros`, en()), n.registerLanguage(`rsl`, tn()), n.registerLanguage(`ruleslanguage`, nn()), n.registerLanguage(`rust`, rn()), n.registerLanguage(`sas`, an()), n.registerLanguage(`scala`, on()), n.registerLanguage(`scheme`, sn()), n.registerLanguage(`scilab`, cn()), n.registerLanguage(`scss`, ln()), n.registerLanguage(`shell`, un()), n.registerLanguage(`smali`, dn()), n.registerLanguage(`smalltalk`, fn()), n.registerLanguage(`sml`, pn()), n.registerLanguage(`sqf`, mn()), n.registerLanguage(`sql`, hn()), n.registerLanguage(`stan`, gn()), n.registerLanguage(`stata`, _n()), n.registerLanguage(`step21`, vn()), n.registerLanguage(`stylus`, yn()), n.registerLanguage(`subunit`, bn()), n.registerLanguage(`swift`, xn()), n.registerLanguage(`taggerscript`, Sn()), n.registerLanguage(`yaml`, Cn()), n.registerLanguage(`tap`, wn()), n.registerLanguage(`tcl`, Tn()), n.registerLanguage(`thrift`, En()), n.registerLanguage(`tp`, Dn()), n.registerLanguage(`twig`, On()), n.registerLanguage(`typescript`, kn()), n.registerLanguage(`vala`, An()), n.registerLanguage(`vbnet`, jn()), n.registerLanguage(`vbscript`, Mn()), n.registerLanguage(`vbscript-html`, Nn()), n.registerLanguage(`verilog`, Pn()), n.registerLanguage(`vhdl`, Fn()), n.registerLanguage(`vim`, In()), n.registerLanguage(`wasm`, Ln()), n.registerLanguage(`wren`, Rn()), n.registerLanguage(`x86asm`, zn()), n.registerLanguage(`xl`, Bn()), n.registerLanguage(`xquery`, Vn()), n.registerLanguage(`zephir`, Hn()), n.HighlightJS = n, n.default = n, t.exports = n;
    })()).default;
    (function(e, t) {
        "use strict";
        var n, r = `hljs-ln`, i = `hljs-ln-line`, a = `hljs-ln-code`, o = `hljs-ln-numbers`, s = `hljs-ln-n`, c = `data-line-number`, l = /\r\n|\r|\n/g;
        function u(e) {
            for(var t = e.toString(), n = e.anchorNode; n.nodeName !== `TD`;)n = n.parentNode;
            for(var r = e.focusNode; r.nodeName !== `TD`;)r = r.parentNode;
            var i = parseInt(n.dataset.lineNumber), o = parseInt(r.dataset.lineNumber);
            if (i == o) return t;
            var s, l = n.textContent, u = r.textContent;
            for(o < i && (s = i, i = o, o = s, s = l, l = u, u = s); t.indexOf(l) !== 0;)l = l.slice(1);
            for(; t.lastIndexOf(u) === -1;)u = u.slice(0, -1);
            for(var d = l, f = function(e) {
                for(var t = e; t.nodeName !== `TABLE`;)t = t.parentNode;
                return t;
            }(n), p = i + 1; p < o; ++p){
                var m = g(`.{0}[{1}="{2}"]`, [
                    a,
                    c,
                    p
                ]);
                d += `
` + f.querySelector(m).textContent;
            }
            return d += `
` + u;
        }
        function d(n) {
            try {
                var r = t.querySelectorAll(`code.hljs,code.nohighlight`);
                for(var i in r)r.hasOwnProperty(i) && (r[i].classList.contains(`nohljsln`) || f(r[i], n));
            } catch (t) {
                e.console.error(`LineNumbers error: `, t);
            }
        }
        function f(e, t) {
            typeof e == `object` && (e.innerHTML = p(e, t));
        }
        function p(e, t) {
            var n, u, d = (n = e, {
                singleLine: function(e) {
                    return !!e.singleLine && e.singleLine;
                }(u = (u = t) || {}),
                startFrom: function(e, t) {
                    var n = 1;
                    isFinite(t.startFrom) && (n = t.startFrom);
                    var r = function(e, t) {
                        return e.hasAttribute(t) ? e.getAttribute(t) : null;
                    }(e, `data-ln-start-from`);
                    return r !== null && (n = function(e, t) {
                        if (!e) return t;
                        var n = Number(e);
                        return isFinite(n) ? n : t;
                    }(r, 1)), n;
                }(n, u)
            });
            return function e(t) {
                var n = t.childNodes;
                for(var r in n){
                    var i;
                    n.hasOwnProperty(r) && (i = n[r], 0 < (i.textContent.trim().match(l) || []).length && (0 < i.childNodes.length ? e(i) : m(i.parentNode)));
                }
            }(e), function(e, t) {
                var n = h(e);
                if (n[n.length - 1].trim() === `` && n.pop(), 1 < n.length || t.singleLine) {
                    for(var l = ``, u = 0, d = n.length; u < d; u++)l += g(`<tr><td class="{0} {1}" {3}="{5}"><div class="{2}" {3}="{5}"></div></td><td class="{0} {4}" {3}="{5}">{6}</td></tr>`, [
                        i,
                        o,
                        s,
                        c,
                        a,
                        u + t.startFrom,
                        0 < n[u].length ? n[u] : ` `
                    ]);
                    return g(`<table class="{0}">{1}</table>`, [
                        r,
                        l
                    ]);
                }
                return e;
            }(e.innerHTML, d);
        }
        function m(e) {
            var t = e.className;
            if (/hljs-/.test(t)) {
                for(var n = h(e.innerHTML), r = 0, i = ``; r < n.length; r++)i += g(`<span class="{0}">{1}</span>
`, [
                    t,
                    0 < n[r].length ? n[r] : ` `
                ]);
                e.innerHTML = i.trim();
            }
        }
        function h(e) {
            return e.length === 0 ? [] : e.split(l);
        }
        function g(e, t) {
            return e.replace(/\{(\d+)\}/g, function(e, n) {
                return t[n] === void 0 ? e : t[n];
            });
        }
        Q ? (Q.initLineNumbersOnLoad = function(n) {
            t.readyState === `interactive` || t.readyState === `complete` ? d(n) : e.addEventListener(`DOMContentLoaded`, function() {
                d(n);
            });
        }, Q.lineNumbersBlock = f, Q.lineNumbersValue = function(e, t) {
            if (typeof e == `string`) {
                var n = document.createElement(`code`);
                return n.innerHTML = e, p(n, t);
            }
        }, (n = t.createElement(`style`)).type = `text/css`, n.innerHTML = g(`.{0}{border-collapse:collapse}.{0} td{padding:0}.{1}:before{content:attr({2})}`, [
            r,
            s,
            c
        ]), t.getElementsByTagName(`head`)[0].appendChild(n)) : e.console.error(`highlight.js not detected!`), document.addEventListener(`copy`, function(e) {
            var t, n = window.getSelection();
            !function(e) {
                for(var t = e; t;){
                    if (t.className && t.className.indexOf(`hljs-ln-code`) !== -1) return 1;
                    t = t.parentNode;
                }
            }(n.anchorNode) || (t = window.navigator.userAgent.indexOf(`Edge`) === -1 ? n.toString() : u(n), e.clipboardData.setData(`text/plain`, t), e.preventDefault());
        });
    })(window, document);
    var $ = {
        id: `highlight`,
        HIGHLIGHT_STEP_DELIMITER: `|`,
        HIGHLIGHT_LINE_DELIMITER: `,`,
        HIGHLIGHT_LINE_RANGE_DELIMITER: `-`,
        hljs: Q,
        init: function(e) {
            let t = e.getConfig().highlight || {};
            t.highlightOnLoad = typeof t.highlightOnLoad == `boolean` ? t.highlightOnLoad : !0, t.escapeHTML = typeof t.escapeHTML == `boolean` ? t.escapeHTML : !0, Array.from(e.getRevealElement().querySelectorAll(`pre code`)).forEach((e)=>{
                e.parentNode.classList.add(`code-wrapper`);
                let n = e.querySelector(`script[type="text/template"]`);
                n && (e.textContent = n.innerHTML), e.hasAttribute(`data-trim`) && typeof e.innerHTML.trim == `function` && (e.innerHTML = Un(e)), t.escapeHTML && !e.hasAttribute(`data-noescape`) && (e.innerHTML = e.innerHTML.replace(/</g, `&lt;`).replace(/>/g, `&gt;`)), e.addEventListener(`focusout`, function(e) {
                    Q.highlightElement(e.currentTarget);
                }, !1);
            }), typeof t.beforeHighlight == `function` && t.beforeHighlight(Q), t.highlightOnLoad && Array.from(e.getRevealElement().querySelectorAll(`pre code`)).forEach((e)=>{
                $.highlightBlock(e);
            }), e.on(`pdf-ready`, function() {
                [].slice.call(e.getRevealElement().querySelectorAll(`pre code[data-line-numbers].current-fragment`)).forEach(function(e) {
                    $.scrollHighlightedLineIntoView(e, {}, !0);
                });
            });
        },
        highlightBlock: function(e) {
            if (Q.highlightElement(e), e.innerHTML.trim().length !== 0 && e.hasAttribute(`data-line-numbers`)) {
                Q.lineNumbersBlock(e, {
                    singleLine: !0
                });
                var t = {
                    currentBlock: e
                }, n = $.deserializeHighlightSteps(e.getAttribute(`data-line-numbers`));
                if (n.length > 1) {
                    var r = parseInt(e.getAttribute(`data-fragment-index`), 10);
                    (typeof r != `number` || isNaN(r)) && (r = null), n.slice(1).forEach(function(n) {
                        var i = e.cloneNode(!0);
                        i.setAttribute(`data-line-numbers`, $.serializeHighlightSteps([
                            n
                        ])), i.classList.add(`fragment`), e.parentNode.appendChild(i), $.highlightLines(i), typeof r == `number` ? (i.setAttribute(`data-fragment-index`, r), r += 1) : i.removeAttribute(`data-fragment-index`), i.addEventListener(`visible`, $.scrollHighlightedLineIntoView.bind($, i, t)), i.addEventListener(`hidden`, $.scrollHighlightedLineIntoView.bind($, i.previousElementSibling, t));
                    }), e.removeAttribute(`data-fragment-index`), e.setAttribute(`data-line-numbers`, $.serializeHighlightSteps([
                        n[0]
                    ]));
                }
                var i = typeof e.closest == `function` ? e.closest(`section:not(.stack)`) : null;
                if (i) {
                    var a = function() {
                        $.scrollHighlightedLineIntoView(e, t, !0), i.removeEventListener(`visible`, a);
                    };
                    i.addEventListener(`visible`, a);
                }
                $.highlightLines(e);
            }
        },
        scrollHighlightedLineIntoView: function(e, t, n) {
            cancelAnimationFrame(t.animationFrameID), t.currentBlock && (e.scrollTop = t.currentBlock.scrollTop), t.currentBlock = e;
            var r = this.getHighlightedLineBounds(e), i = e.offsetHeight, a = getComputedStyle(e);
            i -= parseInt(a.paddingTop) + parseInt(a.paddingBottom);
            var o = e.scrollTop, s = r.top + (Math.min(r.bottom - r.top, i) - i) / 2, c = e.querySelector(`.hljs-ln`);
            if (c && (s += c.offsetTop - parseInt(a.paddingTop)), s = Math.max(Math.min(s, e.scrollHeight - i), 0), n === !0 || o === s) e.scrollTop = s;
            else {
                if (e.scrollHeight <= i) return;
                var l = 0, u = function() {
                    l = Math.min(l + .02, 1), e.scrollTop = o + (s - o) * $.easeInOutQuart(l), l < 1 && (t.animationFrameID = requestAnimationFrame(u));
                };
                u();
            }
        },
        easeInOutQuart: function(e) {
            return e < .5 ? 8 * e * e * e * e : 1 - 8 * --e * e * e * e;
        },
        getHighlightedLineBounds: function(e) {
            var t = e.querySelectorAll(`.highlight-line`);
            if (t.length === 0) return {
                top: 0,
                bottom: 0
            };
            var n = t[0], r = t[t.length - 1];
            return {
                top: n.offsetTop,
                bottom: r.offsetTop + r.offsetHeight
            };
        },
        highlightLines: function(e, t) {
            var n = $.deserializeHighlightSteps(t || e.getAttribute(`data-line-numbers`));
            n.length && n[0].forEach(function(t) {
                var n = [];
                typeof t.end == `number` ? n = [].slice.call(e.querySelectorAll(`table tr:nth-child(n+` + t.start + `):nth-child(-n+` + t.end + `)`)) : typeof t.start == `number` && (n = [].slice.call(e.querySelectorAll(`table tr:nth-child(` + t.start + `)`))), n.length && (n.forEach(function(e) {
                    e.classList.add(`highlight-line`);
                }), e.classList.add(`has-highlights`));
            });
        },
        deserializeHighlightSteps: function(e) {
            return e = e.replace(/\s/g, ``), e = e.split($.HIGHLIGHT_STEP_DELIMITER), e.map(function(e) {
                return e.split($.HIGHLIGHT_LINE_DELIMITER).map(function(e) {
                    if (/^[\d-]+$/.test(e)) {
                        e = e.split($.HIGHLIGHT_LINE_RANGE_DELIMITER);
                        var t = parseInt(e[0], 10), n = parseInt(e[1], 10);
                        return isNaN(n) ? {
                            start: t
                        } : {
                            start: t,
                            end: n
                        };
                    } else return {};
                });
            });
        },
        serializeHighlightSteps: function(e) {
            return e.map(function(e) {
                return e.map(function(e) {
                    return typeof e.end == `number` ? e.start + $.HIGHLIGHT_LINE_RANGE_DELIMITER + e.end : typeof e.start == `number` ? e.start : ``;
                }).join($.HIGHLIGHT_LINE_DELIMITER);
            }).join($.HIGHLIGHT_STEP_DELIMITER);
        }
    };
    function Un(e) {
        function t(e) {
            return e.replace(/^[\s\uFEFF\xA0]+/g, ``);
        }
        function n(e) {
            for(var t = e.split(`
`), n = 0; n < t.length && t[n].trim() === ``; n++)t.splice(n--, 1);
            for(var n = t.length - 1; n >= 0 && t[n].trim() === ``; n--)t.splice(n, 1);
            return t.join(`
`);
        }
        return function(e) {
            var r = n(e.innerHTML).split(`
`), i = r.reduce(function(e, n) {
                return n.length > 0 && t(n).length > 0 && e > n.length - t(n).length ? n.length - t(n).length : e;
            }, 1 / 0);
            return r.map(function(e, t) {
                return e.slice(i);
            }).join(`
`);
        }(e);
    }
    return ()=>$;
});


var $a6b65334d592261a$exports = {};
(function(e, t) {
    "object" == `object` && "object" < `u` ? $a6b65334d592261a$exports = t() : typeof define == `function` && define.amd ? define([], t) : (e = typeof globalThis < `u` ? globalThis : e || self, e.RevealMarkdown = t());
})($a6b65334d592261a$exports, function() {
    function e() {
        return {
            async: !1,
            breaks: !1,
            extensions: null,
            gfm: !0,
            hooks: null,
            pedantic: !1,
            renderer: null,
            silent: !1,
            tokenizer: null,
            walkTokens: null
        };
    }
    var t = e();
    function n(e) {
        t = e;
    }
    var r = {
        exec: ()=>null
    };
    function i(e, t = ``) {
        let n = typeof e == `string` ? e : e.source, r = {
            replace: (e, t)=>{
                let i = typeof t == `string` ? t : t.source;
                return i = i.replace(o.caret, `$1`), n = n.replace(e, i), r;
            },
            getRegex: ()=>new RegExp(n, t)
        };
        return r;
    }
    var a = (()=>{
        try {
            return !0;
        } catch  {
            return !1;
        }
    })(), o = {
        codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
        outputLinkReplace: /\\([\[\]])/g,
        indentCodeCompensation: /^(\s+)(?:```)/,
        beginningSpace: /^\s+/,
        endingHash: /#$/,
        startingSpaceChar: /^ /,
        endingSpaceChar: / $/,
        nonSpaceChar: /[^ ]/,
        newLineCharGlobal: /\n/g,
        tabCharGlobal: /\t/g,
        multipleSpaceGlobal: /\s+/g,
        blankLine: /^[ \t]*$/,
        doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
        blockquoteStart: /^ {0,3}>/,
        blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
        blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
        listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
        listIsTask: /^\[[ xX]\] +\S/,
        listReplaceTask: /^\[[ xX]\] +/,
        listTaskCheckbox: /\[[ xX]\]/,
        anyLine: /\n.*\n/,
        hrefBrackets: /^<(.*)>$/,
        tableDelimiter: /[:|]/,
        tableAlignChars: /^\||\| *$/g,
        tableRowBlankLine: /\n[ \t]*$/,
        tableAlignRight: /^ *-+: *$/,
        tableAlignCenter: /^ *:-+: *$/,
        tableAlignLeft: /^ *:-+ *$/,
        startATag: /^<a /i,
        endATag: /^<\/a>/i,
        startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
        endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
        startAngleBracket: /^</,
        endAngleBracket: />$/,
        pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
        unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
        escapeTest: /[&<>"']/,
        escapeReplace: /[&<>"']/g,
        escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
        escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
        caret: /(^|[^\[])\^/g,
        percentDecode: /%25/g,
        findPipe: /\|/g,
        splitPipe: / \|/,
        slashPipe: /\\\|/g,
        carriageReturn: /\r\n|\r/g,
        spaceLine: /^ +$/gm,
        notSpaceStart: /^\S*/,
        endingNewline: /\n$/,
        listItemRegex: (e)=>RegExp(`^( {0,3}${e})((?:[	 ][^\\n]*)?(?:\\n|$))`),
        nextBulletRegex: (e)=>RegExp(`^ {0,${Math.min(3, e - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`),
        hrRegex: (e)=>RegExp(`^ {0,${Math.min(3, e - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
        fencesBeginRegex: (e)=>RegExp(`^ {0,${Math.min(3, e - 1)}}(?:\`\`\`|~~~)`),
        headingBeginRegex: (e)=>RegExp(`^ {0,${Math.min(3, e - 1)}}#`),
        htmlBeginRegex: (e)=>RegExp(`^ {0,${Math.min(3, e - 1)}}<(?:[a-z].*>|!--)`, `i`),
        blockquoteBeginRegex: (e)=>RegExp(`^ {0,${Math.min(3, e - 1)}}>`)
    }, s = /^(?:[ \t]*(?:\n|$))+/, c = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/, l = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, u = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, d = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, f = / {0,3}(?:[*+-]|\d{1,9}[.)])/, p = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/, m = i(p).replace(/bull/g, f).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, ``).getRegex(), ee = i(p).replace(/bull/g, f).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex(), h = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, te = /^[^\n]+/, g = /(?!\s*\])(?:\\[\s\S]|[^\[\]\\])+/, ne = i(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace(`label`, g).replace(`title`, /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), re = i(/^(bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, f).getRegex(), _ = `address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul`, v = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, ie = i(`^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))`, `i`).replace(`comment`, v).replace(`tag`, _).replace(`attribute`, / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), y = i(h).replace(`hr`, u).replace(`heading`, ` {0,3}#{1,6}(?:\\s|$)`).replace(`|lheading`, ``).replace(`|table`, ``).replace(`blockquote`, ` {0,3}>`).replace(`fences`, " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace(`list`, ` {0,3}(?:[*+-]|1[.)])[ \\t]`).replace(`html`, `</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)`).replace(`tag`, _).getRegex(), b = {
        blockquote: i(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace(`paragraph`, y).getRegex(),
        code: c,
        def: ne,
        fences: l,
        heading: d,
        hr: u,
        html: ie,
        lheading: m,
        list: re,
        newline: s,
        paragraph: y,
        table: r,
        text: te
    }, x = i(`^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)`).replace(`hr`, u).replace(`heading`, ` {0,3}#{1,6}(?:\\s|$)`).replace(`blockquote`, ` {0,3}>`).replace(`code`, `(?: {4}| {0,3}	)[^\\n]`).replace(`fences`, " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace(`list`, ` {0,3}(?:[*+-]|1[.)])[ \\t]`).replace(`html`, `</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)`).replace(`tag`, _).getRegex(), ae = {
        ...b,
        lheading: ee,
        table: x,
        paragraph: i(h).replace(`hr`, u).replace(`heading`, ` {0,3}#{1,6}(?:\\s|$)`).replace(`|lheading`, ``).replace(`table`, x).replace(`blockquote`, ` {0,3}>`).replace(`fences`, " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace(`list`, ` {0,3}(?:[*+-]|1[.)])[ \\t]`).replace(`html`, `</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)`).replace(`tag`, _).getRegex()
    }, oe = {
        ...b,
        html: i(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace(`comment`, v).replace(/tag/g, `(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b`).getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: r,
        lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        paragraph: i(h).replace(`hr`, u).replace(`heading`, ` *#{1,6} *[^
]`).replace(`lheading`, m).replace(`|table`, ``).replace(`blockquote`, ` {0,3}>`).replace(`|fences`, ``).replace(`|list`, ``).replace(`|html`, ``).replace(`|tag`, ``).getRegex()
    }, se = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, ce = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, S = /^( {2,}|\\)\n(?!\s*$)/, le = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, C = /[\p{P}\p{S}]/u, w = /[\s\p{P}\p{S}]/u, T = /[^\s\p{P}\p{S}]/u, ue = i(/^((?![*_])punctSpace)/, `u`).replace(/punctSpace/g, w).getRegex(), E = /(?!~)[\p{P}\p{S}]/u, de = /(?!~)[\s\p{P}\p{S}]/u, fe = /(?:[^\s\p{P}\p{S}]|~)/u, pe = i(/link|precode-code|html/, `g`).replace(`link`, /\[(?:[^\[\]`]|(?<a>`+)[^`]+\k<a>(?!`))*?\]\((?:\\[\s\S]|[^\\\(\)]|\((?:\\[\s\S]|[^\\\(\)])*\))*\)/).replace(`precode-`, a ? "(?<!`)()" : "(^^|[^`])").replace(`code`, /(?<b>`+)[^`]+\k<b>(?!`)/).replace(`html`, /<(?! )[^<>]*?>/).getRegex(), D = /^(?:\*+(?:((?!\*)punct)|([^\s*]))?)|^_+(?:((?!_)punct)|([^\s_]))?/, me = i(D, `u`).replace(/punct/g, C).getRegex(), he = i(D, `u`).replace(/punct/g, E).getRegex(), O = `^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)`, ge = i(O, `gu`).replace(/notPunctSpace/g, T).replace(/punctSpace/g, w).replace(/punct/g, C).getRegex(), _e = i(O, `gu`).replace(/notPunctSpace/g, fe).replace(/punctSpace/g, de).replace(/punct/g, E).getRegex(), ve = i(`^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)`, `gu`).replace(/notPunctSpace/g, T).replace(/punctSpace/g, w).replace(/punct/g, C).getRegex(), ye = i(/^~~?(?:((?!~)punct)|[^\s~])/, `u`).replace(/punct/g, C).getRegex(), be = i(`^[^~]+(?=[^~])|(?!~)punct(~~?)(?=[\\s]|$)|notPunctSpace(~~?)(?!~)(?=punctSpace|$)|(?!~)punctSpace(~~?)(?=notPunctSpace)|[\\s](~~?)(?!~)(?=punct)|(?!~)punct(~~?)(?!~)(?=punct)|notPunctSpace(~~?)(?=notPunctSpace)`, `gu`).replace(/notPunctSpace/g, T).replace(/punctSpace/g, w).replace(/punct/g, C).getRegex(), xe = i(/\\(punct)/, `gu`).replace(/punct/g, C).getRegex(), Se = i(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace(`scheme`, /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace(`email`, /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), Ce = i(v).replace(`(?:-->|$)`, `-->`).getRegex(), we = i(`^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>`).replace(`comment`, Ce).replace(`attribute`, /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), k = /(?:\[(?:\\[\s\S]|[^\[\]\\])*\]|\\[\s\S]|`+(?!`)[^`]*?`+(?!`)|``+(?=\])|[^\[\]\\`])*?/, Te = i(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]+(?:\n[ \t]*)?|\n[ \t]*)(title))?\s*\)/).replace(`label`, k).replace(`href`, /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace(`title`, /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), A = i(/^!?\[(label)\]\[(ref)\]/).replace(`label`, k).replace(`ref`, g).getRegex(), j = i(/^!?\[(ref)\](?:\[\])?/).replace(`ref`, g).getRegex(), Ee = i(`reflink|nolink(?!\\()`, `g`).replace(`reflink`, A).replace(`nolink`, j).getRegex(), M = /[hH][tT][tT][pP][sS]?|[fF][tT][pP]/, N = {
        _backpedal: r,
        anyPunctuation: xe,
        autolink: Se,
        blockSkip: pe,
        br: S,
        code: ce,
        del: r,
        delLDelim: r,
        delRDelim: r,
        emStrongLDelim: me,
        emStrongRDelimAst: ge,
        emStrongRDelimUnd: ve,
        escape: se,
        link: Te,
        nolink: j,
        punctuation: ue,
        reflink: A,
        reflinkSearch: Ee,
        tag: we,
        text: le,
        url: r
    }, De = {
        ...N,
        link: i(/^!?\[(label)\]\((.*?)\)/).replace(`label`, k).getRegex(),
        reflink: i(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace(`label`, k).getRegex()
    }, P = {
        ...N,
        emStrongRDelimAst: _e,
        emStrongLDelim: he,
        delLDelim: ye,
        delRDelim: be,
        url: i(/^((?:protocol):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/).replace(`protocol`, M).replace(`email`, /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
        _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])((?:\\[\s\S]|[^\\])*?(?:\\[\s\S]|[^\s~\\]))\1(?=[^~]|$)/,
        text: i(/^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|protocol:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/).replace(`protocol`, M).getRegex()
    }, Oe = {
        ...P,
        br: i(S).replace(`{2,}`, `*`).getRegex(),
        text: i(P.text).replace(`\\b_`, `\\b_| {2,}\\n`).replace(/\{2,\}/g, `*`).getRegex()
    }, F = {
        normal: b,
        gfm: ae,
        pedantic: oe
    }, I = {
        normal: N,
        gfm: P,
        breaks: Oe,
        pedantic: De
    }, ke = {
        "&": `&amp;`,
        "<": `&lt;`,
        ">": `&gt;`,
        '"': `&quot;`,
        "'": `&#39;`
    }, L = (e)=>ke[e];
    function R(e, t) {
        if (t) {
            if (o.escapeTest.test(e)) return e.replace(o.escapeReplace, L);
        } else if (o.escapeTestNoEncode.test(e)) return e.replace(o.escapeReplaceNoEncode, L);
        return e;
    }
    function z(e) {
        try {
            e = encodeURI(e).replace(o.percentDecode, `%`);
        } catch  {
            return null;
        }
        return e;
    }
    function B(e, t) {
        let n = e.replace(o.findPipe, (e, t, n)=>{
            let r = !1, i = t;
            for(; --i >= 0 && n[i] === `\\`;)r = !r;
            return r ? `|` : ` |`;
        }).split(o.splitPipe), r = 0;
        if (n[0].trim() || n.shift(), n.length > 0 && !n.at(-1)?.trim() && n.pop(), t) {
            if (n.length > t) n.splice(t);
            else for(; n.length < t;)n.push(``);
        }
        for(; r < n.length; r++)n[r] = n[r].trim().replace(o.slashPipe, `|`);
        return n;
    }
    function V(e, t, n) {
        let r = e.length;
        if (r === 0) return ``;
        let i = 0;
        for(; i < r;){
            let a = e.charAt(r - i - 1);
            if (a === t && !n) i++;
            else if (a !== t && n) i++;
            else break;
        }
        return e.slice(0, r - i);
    }
    function Ae(e, t) {
        if (e.indexOf(t[1]) === -1) return -1;
        let n = 0;
        for(let r = 0; r < e.length; r++)if (e[r] === `\\`) r++;
        else if (e[r] === t[0]) n++;
        else if (e[r] === t[1] && (n--, n < 0)) return r;
        return n > 0 ? -2 : -1;
    }
    function je(e, t = 0) {
        let n = t, r = ``;
        for (let t of e)if (t === `	`) {
            let e = 4 - n % 4;
            r += ` `.repeat(e), n += e;
        } else r += t, n++;
        return r;
    }
    function H(e, t, n, r, i) {
        let a = t.href, o = t.title || null, s = e[1].replace(i.other.outputLinkReplace, `$1`);
        r.state.inLink = !0;
        let c = {
            type: e[0].charAt(0) === `!` ? `image` : `link`,
            raw: n,
            href: a,
            title: o,
            text: s,
            tokens: r.inlineTokens(s)
        };
        return r.state.inLink = !1, c;
    }
    function Me(e, t, n) {
        let r = e.match(n.other.indentCodeCompensation);
        if (r === null) return t;
        let i = r[1];
        return t.split(`
`).map((e)=>{
            let t = e.match(n.other.beginningSpace);
            if (t === null) return e;
            let [r] = t;
            return r.length >= i.length ? e.slice(i.length) : e;
        }).join(`
`);
    }
    var U = class {
        options;
        rules;
        lexer;
        constructor(e){
            this.options = e || t;
        }
        space(e) {
            let t = this.rules.block.newline.exec(e);
            if (t && t[0].length > 0) return {
                type: `space`,
                raw: t[0]
            };
        }
        code(e) {
            let t = this.rules.block.code.exec(e);
            if (t) {
                let e = t[0].replace(this.rules.other.codeRemoveIndent, ``);
                return {
                    type: `code`,
                    raw: t[0],
                    codeBlockStyle: `indented`,
                    text: this.options.pedantic ? e : V(e, `
`)
                };
            }
        }
        fences(e) {
            let t = this.rules.block.fences.exec(e);
            if (t) {
                let e = t[0], n = Me(e, t[3] || ``, this.rules);
                return {
                    type: `code`,
                    raw: e,
                    lang: t[2] ? t[2].trim().replace(this.rules.inline.anyPunctuation, `$1`) : t[2],
                    text: n
                };
            }
        }
        heading(e) {
            let t = this.rules.block.heading.exec(e);
            if (t) {
                let e = t[2].trim();
                if (this.rules.other.endingHash.test(e)) {
                    let t = V(e, `#`);
                    (this.options.pedantic || !t || this.rules.other.endingSpaceChar.test(t)) && (e = t.trim());
                }
                return {
                    type: `heading`,
                    raw: t[0],
                    depth: t[1].length,
                    text: e,
                    tokens: this.lexer.inline(e)
                };
            }
        }
        hr(e) {
            let t = this.rules.block.hr.exec(e);
            if (t) return {
                type: `hr`,
                raw: V(t[0], `
`)
            };
        }
        blockquote(e) {
            let t = this.rules.block.blockquote.exec(e);
            if (t) {
                let e = V(t[0], `
`).split(`
`), n = ``, r = ``, i = [];
                for(; e.length > 0;){
                    let t = !1, a = [], o;
                    for(o = 0; o < e.length; o++)if (this.rules.other.blockquoteStart.test(e[o])) a.push(e[o]), t = !0;
                    else if (!t) a.push(e[o]);
                    else break;
                    e = e.slice(o);
                    let s = a.join(`
`), c = s.replace(this.rules.other.blockquoteSetextReplace, `
    $1`).replace(this.rules.other.blockquoteSetextReplace2, ``);
                    n = n ? `${n}
${s}` : s, r = r ? `${r}
${c}` : c;
                    let l = this.lexer.state.top;
                    if (this.lexer.state.top = !0, this.lexer.blockTokens(c, i, !0), this.lexer.state.top = l, e.length === 0) break;
                    let u = i.at(-1);
                    if (u?.type === `code`) break;
                    if (u?.type === `blockquote`) {
                        let t = u, a = t.raw + `
` + e.join(`
`), o = this.blockquote(a);
                        i[i.length - 1] = o, n = n.substring(0, n.length - t.raw.length) + o.raw, r = r.substring(0, r.length - t.text.length) + o.text;
                        break;
                    } else if (u?.type === `list`) {
                        let t = u, a = t.raw + `
` + e.join(`
`), o = this.list(a);
                        i[i.length - 1] = o, n = n.substring(0, n.length - u.raw.length) + o.raw, r = r.substring(0, r.length - t.raw.length) + o.raw, e = a.substring(i.at(-1).raw.length).split(`
`);
                        continue;
                    }
                }
                return {
                    type: `blockquote`,
                    raw: n,
                    tokens: i,
                    text: r
                };
            }
        }
        list(e) {
            let t = this.rules.block.list.exec(e);
            if (t) {
                let n = t[1].trim(), r = n.length > 1, i = {
                    type: `list`,
                    raw: ``,
                    ordered: r,
                    start: r ? +n.slice(0, -1) : ``,
                    loose: !1,
                    items: []
                };
                n = r ? `\\d{1,9}\\${n.slice(-1)}` : `\\${n}`, this.options.pedantic && (n = r ? n : `[*+-]`);
                let a = this.rules.other.listItemRegex(n), o = !1;
                for(; e;){
                    let n = !1, r = ``, s = ``;
                    if (!(t = a.exec(e)) || this.rules.block.hr.test(e)) break;
                    r = t[0], e = e.substring(r.length);
                    let c = je(t[2].split(`
`, 1)[0], t[1].length), l = e.split(`
`, 1)[0], u = !c.trim(), d = 0;
                    if (this.options.pedantic ? (d = 2, s = c.trimStart()) : u ? d = t[1].length + 1 : (d = c.search(this.rules.other.nonSpaceChar), d = d > 4 ? 1 : d, s = c.slice(d), d += t[1].length), u && this.rules.other.blankLine.test(l) && (r += l + `
`, e = e.substring(l.length + 1), n = !0), !n) {
                        let t = this.rules.other.nextBulletRegex(d), n = this.rules.other.hrRegex(d), i = this.rules.other.fencesBeginRegex(d), a = this.rules.other.headingBeginRegex(d), o = this.rules.other.htmlBeginRegex(d), f = this.rules.other.blockquoteBeginRegex(d);
                        for(; e;){
                            let p = e.split(`
`, 1)[0], m;
                            if (l = p, this.options.pedantic ? (l = l.replace(this.rules.other.listReplaceNesting, `  `), m = l) : m = l.replace(this.rules.other.tabCharGlobal, `    `), i.test(l) || a.test(l) || o.test(l) || f.test(l) || t.test(l) || n.test(l)) break;
                            if (m.search(this.rules.other.nonSpaceChar) >= d || !l.trim()) s += `
` + m.slice(d);
                            else {
                                if (u || c.replace(this.rules.other.tabCharGlobal, `    `).search(this.rules.other.nonSpaceChar) >= 4 || i.test(c) || a.test(c) || n.test(c)) break;
                                s += `
` + l;
                            }
                            u = !l.trim(), r += p + `
`, e = e.substring(p.length + 1), c = m.slice(d);
                        }
                    }
                    i.loose || (o ? i.loose = !0 : this.rules.other.doubleBlankLine.test(r) && (o = !0)), i.items.push({
                        type: `list_item`,
                        raw: r,
                        task: !!this.options.gfm && this.rules.other.listIsTask.test(s),
                        loose: !1,
                        text: s,
                        tokens: []
                    }), i.raw += r;
                }
                let s = i.items.at(-1);
                if (s) s.raw = s.raw.trimEnd(), s.text = s.text.trimEnd();
                else return;
                i.raw = i.raw.trimEnd();
                for (let e of i.items){
                    if (this.lexer.state.top = !1, e.tokens = this.lexer.blockTokens(e.text, []), e.task) {
                        if (e.text = e.text.replace(this.rules.other.listReplaceTask, ``), e.tokens[0]?.type === `text` || e.tokens[0]?.type === `paragraph`) {
                            e.tokens[0].raw = e.tokens[0].raw.replace(this.rules.other.listReplaceTask, ``), e.tokens[0].text = e.tokens[0].text.replace(this.rules.other.listReplaceTask, ``);
                            for(let e = this.lexer.inlineQueue.length - 1; e >= 0; e--)if (this.rules.other.listIsTask.test(this.lexer.inlineQueue[e].src)) {
                                this.lexer.inlineQueue[e].src = this.lexer.inlineQueue[e].src.replace(this.rules.other.listReplaceTask, ``);
                                break;
                            }
                        }
                        let t = this.rules.other.listTaskCheckbox.exec(e.raw);
                        if (t) {
                            let n = {
                                type: `checkbox`,
                                raw: t[0] + ` `,
                                checked: t[0] !== `[ ]`
                            };
                            e.checked = n.checked, i.loose ? e.tokens[0] && [
                                `paragraph`,
                                `text`
                            ].includes(e.tokens[0].type) && `tokens` in e.tokens[0] && e.tokens[0].tokens ? (e.tokens[0].raw = n.raw + e.tokens[0].raw, e.tokens[0].text = n.raw + e.tokens[0].text, e.tokens[0].tokens.unshift(n)) : e.tokens.unshift({
                                type: `paragraph`,
                                raw: n.raw,
                                text: n.raw,
                                tokens: [
                                    n
                                ]
                            }) : e.tokens.unshift(n);
                        }
                    }
                    if (!i.loose) {
                        let t = e.tokens.filter((e)=>e.type === `space`);
                        i.loose = t.length > 0 && t.some((e)=>this.rules.other.anyLine.test(e.raw));
                    }
                }
                if (i.loose) for (let e of i.items){
                    e.loose = !0;
                    for (let t of e.tokens)t.type === `text` && (t.type = `paragraph`);
                }
                return i;
            }
        }
        html(e) {
            let t = this.rules.block.html.exec(e);
            if (t) return {
                type: `html`,
                block: !0,
                raw: t[0],
                pre: t[1] === `pre` || t[1] === `script` || t[1] === `style`,
                text: t[0]
            };
        }
        def(e) {
            let t = this.rules.block.def.exec(e);
            if (t) {
                let e = t[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, ` `), n = t[2] ? t[2].replace(this.rules.other.hrefBrackets, `$1`).replace(this.rules.inline.anyPunctuation, `$1`) : ``, r = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline.anyPunctuation, `$1`) : t[3];
                return {
                    type: `def`,
                    tag: e,
                    raw: t[0],
                    href: n,
                    title: r
                };
            }
        }
        table(e) {
            let t = this.rules.block.table.exec(e);
            if (!t || !this.rules.other.tableDelimiter.test(t[2])) return;
            let n = B(t[1]), r = t[2].replace(this.rules.other.tableAlignChars, ``).split(`|`), i = t[3]?.trim() ? t[3].replace(this.rules.other.tableRowBlankLine, ``).split(`
`) : [], a = {
                type: `table`,
                raw: t[0],
                header: [],
                align: [],
                rows: []
            };
            if (n.length === r.length) {
                for (let e of r)this.rules.other.tableAlignRight.test(e) ? a.align.push(`right`) : this.rules.other.tableAlignCenter.test(e) ? a.align.push(`center`) : this.rules.other.tableAlignLeft.test(e) ? a.align.push(`left`) : a.align.push(null);
                for(let e = 0; e < n.length; e++)a.header.push({
                    text: n[e],
                    tokens: this.lexer.inline(n[e]),
                    header: !0,
                    align: a.align[e]
                });
                for (let e of i)a.rows.push(B(e, a.header.length).map((e, t)=>({
                        text: e,
                        tokens: this.lexer.inline(e),
                        header: !1,
                        align: a.align[t]
                    })));
                return a;
            }
        }
        lheading(e) {
            let t = this.rules.block.lheading.exec(e);
            if (t) {
                let e = t[1].trim();
                return {
                    type: `heading`,
                    raw: t[0],
                    depth: t[2].charAt(0) === `=` ? 1 : 2,
                    text: e,
                    tokens: this.lexer.inline(e)
                };
            }
        }
        paragraph(e) {
            let t = this.rules.block.paragraph.exec(e);
            if (t) {
                let e = t[1].charAt(t[1].length - 1) === `
` ? t[1].slice(0, -1) : t[1];
                return {
                    type: `paragraph`,
                    raw: t[0],
                    text: e,
                    tokens: this.lexer.inline(e)
                };
            }
        }
        text(e) {
            let t = this.rules.block.text.exec(e);
            if (t) return {
                type: `text`,
                raw: t[0],
                text: t[0],
                tokens: this.lexer.inline(t[0])
            };
        }
        escape(e) {
            let t = this.rules.inline.escape.exec(e);
            if (t) return {
                type: `escape`,
                raw: t[0],
                text: t[1]
            };
        }
        tag(e) {
            let t = this.rules.inline.tag.exec(e);
            if (t) return !this.lexer.state.inLink && this.rules.other.startATag.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && this.rules.other.endATag.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
                type: `html`,
                raw: t[0],
                inLink: this.lexer.state.inLink,
                inRawBlock: this.lexer.state.inRawBlock,
                block: !1,
                text: t[0]
            };
        }
        link(e) {
            let t = this.rules.inline.link.exec(e);
            if (t) {
                let e = t[2].trim();
                if (!this.options.pedantic && this.rules.other.startAngleBracket.test(e)) {
                    if (!this.rules.other.endAngleBracket.test(e)) return;
                    let t = V(e.slice(0, -1), `\\`);
                    if ((e.length - t.length) % 2 == 0) return;
                } else {
                    let e = Ae(t[2], `()`);
                    if (e === -2) return;
                    if (e > -1) {
                        let n = (t[0].indexOf(`!`) === 0 ? 5 : 4) + t[1].length + e;
                        t[2] = t[2].substring(0, e), t[0] = t[0].substring(0, n).trim(), t[3] = ``;
                    }
                }
                let n = t[2], r = ``;
                if (this.options.pedantic) {
                    let e = this.rules.other.pedanticHrefTitle.exec(n);
                    e && (n = e[1], r = e[3]);
                } else r = t[3] ? t[3].slice(1, -1) : ``;
                return n = n.trim(), this.rules.other.startAngleBracket.test(n) && (n = this.options.pedantic && !this.rules.other.endAngleBracket.test(e) ? n.slice(1) : n.slice(1, -1)), H(t, {
                    href: n && n.replace(this.rules.inline.anyPunctuation, `$1`),
                    title: r && r.replace(this.rules.inline.anyPunctuation, `$1`)
                }, t[0], this.lexer, this.rules);
            }
        }
        reflink(e, t) {
            let n;
            if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
                let e = t[(n[2] || n[1]).replace(this.rules.other.multipleSpaceGlobal, ` `).toLowerCase()];
                if (!e) {
                    let e = n[0].charAt(0);
                    return {
                        type: `text`,
                        raw: e,
                        text: e
                    };
                }
                return H(n, e, n[0], this.lexer, this.rules);
            }
        }
        emStrong(e, t, n = ``) {
            let r = this.rules.inline.emStrongLDelim.exec(e);
            if (!(!r || !r[1] && !r[2] && !r[3] && !r[4] || r[4] && n.match(this.rules.other.unicodeAlphaNumeric)) && (!(r[1] || r[3]) || !n || this.rules.inline.punctuation.exec(n))) {
                let n = [
                    ...r[0]
                ].length - 1, i, a, o = n, s = 0, c = r[0][0] === `*` ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
                for(c.lastIndex = 0, t = t.slice(-1 * e.length + n); (r = c.exec(t)) != null;){
                    if (i = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !i) continue;
                    if (a = [
                        ...i
                    ].length, r[3] || r[4]) {
                        o += a;
                        continue;
                    } else if ((r[5] || r[6]) && n % 3 && !((n + a) % 3)) {
                        s += a;
                        continue;
                    }
                    if (o -= a, o > 0) continue;
                    a = Math.min(a, a + o + s);
                    let t = [
                        ...r[0]
                    ][0].length, c = e.slice(0, n + r.index + t + a);
                    if (Math.min(n, a) % 2) {
                        let e = c.slice(1, -1);
                        return {
                            type: `em`,
                            raw: c,
                            text: e,
                            tokens: this.lexer.inlineTokens(e)
                        };
                    }
                    let l = c.slice(2, -2);
                    return {
                        type: `strong`,
                        raw: c,
                        text: l,
                        tokens: this.lexer.inlineTokens(l)
                    };
                }
            }
        }
        codespan(e) {
            let t = this.rules.inline.code.exec(e);
            if (t) {
                let e = t[2].replace(this.rules.other.newLineCharGlobal, ` `), n = this.rules.other.nonSpaceChar.test(e), r = this.rules.other.startingSpaceChar.test(e) && this.rules.other.endingSpaceChar.test(e);
                return n && r && (e = e.substring(1, e.length - 1)), {
                    type: `codespan`,
                    raw: t[0],
                    text: e
                };
            }
        }
        br(e) {
            let t = this.rules.inline.br.exec(e);
            if (t) return {
                type: `br`,
                raw: t[0]
            };
        }
        del(e, t, n = ``) {
            let r = this.rules.inline.delLDelim.exec(e);
            if (r && (!r[1] || !n || this.rules.inline.punctuation.exec(n))) {
                let n = [
                    ...r[0]
                ].length - 1, i, a, o = n, s = this.rules.inline.delRDelim;
                for(s.lastIndex = 0, t = t.slice(-1 * e.length + n); (r = s.exec(t)) != null;){
                    if (i = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !i || (a = [
                        ...i
                    ].length, a !== n)) continue;
                    if (r[3] || r[4]) {
                        o += a;
                        continue;
                    }
                    if (o -= a, o > 0) continue;
                    a = Math.min(a, a + o);
                    let t = [
                        ...r[0]
                    ][0].length, s = e.slice(0, n + r.index + t + a), c = s.slice(n, -n);
                    return {
                        type: `del`,
                        raw: s,
                        text: c,
                        tokens: this.lexer.inlineTokens(c)
                    };
                }
            }
        }
        autolink(e) {
            let t = this.rules.inline.autolink.exec(e);
            if (t) {
                let e, n;
                return t[2] === `@` ? (e = t[1], n = `mailto:` + e) : (e = t[1], n = e), {
                    type: `link`,
                    raw: t[0],
                    text: e,
                    href: n,
                    tokens: [
                        {
                            type: `text`,
                            raw: e,
                            text: e
                        }
                    ]
                };
            }
        }
        url(e) {
            let t;
            if (t = this.rules.inline.url.exec(e)) {
                let e, n;
                if (t[2] === `@`) e = t[0], n = `mailto:` + e;
                else {
                    let r;
                    do r = t[0], t[0] = this.rules.inline._backpedal.exec(t[0])?.[0] ?? ``;
                    while (r !== t[0]);
                    e = t[0], n = t[1] === `www.` ? `http://` + t[0] : t[0];
                }
                return {
                    type: `link`,
                    raw: t[0],
                    text: e,
                    href: n,
                    tokens: [
                        {
                            type: `text`,
                            raw: e,
                            text: e
                        }
                    ]
                };
            }
        }
        inlineText(e) {
            let t = this.rules.inline.text.exec(e);
            if (t) {
                let e = this.lexer.state.inRawBlock;
                return {
                    type: `text`,
                    raw: t[0],
                    text: t[0],
                    escaped: e
                };
            }
        }
    }, W = class e {
        tokens;
        options;
        state;
        inlineQueue;
        tokenizer;
        constructor(e){
            this.tokens = [], this.tokens.links = Object.create(null), this.options = e || t, this.options.tokenizer = this.options.tokenizer || new U, this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
                inLink: !1,
                inRawBlock: !1,
                top: !0
            };
            let n = {
                other: o,
                block: F.normal,
                inline: I.normal
            };
            this.options.pedantic ? (n.block = F.pedantic, n.inline = I.pedantic) : this.options.gfm && (n.block = F.gfm, this.options.breaks ? n.inline = I.breaks : n.inline = I.gfm), this.tokenizer.rules = n;
        }
        static get rules() {
            return {
                block: F,
                inline: I
            };
        }
        static lex(t, n) {
            return new e(n).lex(t);
        }
        static lexInline(t, n) {
            return new e(n).inlineTokens(t);
        }
        lex(e) {
            e = e.replace(o.carriageReturn, `
`), this.blockTokens(e, this.tokens);
            for(let e = 0; e < this.inlineQueue.length; e++){
                let t = this.inlineQueue[e];
                this.inlineTokens(t.src, t.tokens);
            }
            return this.inlineQueue = [], this.tokens;
        }
        blockTokens(e, t = [], n = !1) {
            for(this.tokenizer.lexer = this, this.options.pedantic && (e = e.replace(o.tabCharGlobal, `    `).replace(o.spaceLine, ``)); e;){
                let r;
                if (this.options.extensions?.block?.some((n)=>(r = n.call({
                        lexer: this
                    }, e, t)) ? (e = e.substring(r.raw.length), t.push(r), !0) : !1)) continue;
                if (r = this.tokenizer.space(e)) {
                    e = e.substring(r.raw.length);
                    let n = t.at(-1);
                    r.raw.length === 1 && n !== void 0 ? n.raw += `
` : t.push(r);
                    continue;
                }
                if (r = this.tokenizer.code(e)) {
                    e = e.substring(r.raw.length);
                    let n = t.at(-1);
                    n?.type === `paragraph` || n?.type === `text` ? (n.raw += (n.raw.endsWith(`
`) ? `` : `
`) + r.raw, n.text += `
` + r.text, this.inlineQueue.at(-1).src = n.text) : t.push(r);
                    continue;
                }
                if (r = this.tokenizer.fences(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.heading(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.hr(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.blockquote(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.list(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.html(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.def(e)) {
                    e = e.substring(r.raw.length);
                    let n = t.at(-1);
                    n?.type === `paragraph` || n?.type === `text` ? (n.raw += (n.raw.endsWith(`
`) ? `` : `
`) + r.raw, n.text += `
` + r.raw, this.inlineQueue.at(-1).src = n.text) : this.tokens.links[r.tag] || (this.tokens.links[r.tag] = {
                        href: r.href,
                        title: r.title
                    }, t.push(r));
                    continue;
                }
                if (r = this.tokenizer.table(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.lheading(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                let i = e;
                if (this.options.extensions?.startBlock) {
                    let t = 1 / 0, n = e.slice(1), r;
                    this.options.extensions.startBlock.forEach((e)=>{
                        r = e.call({
                            lexer: this
                        }, n), typeof r == `number` && r >= 0 && (t = Math.min(t, r));
                    }), t < 1 / 0 && t >= 0 && (i = e.substring(0, t + 1));
                }
                if (this.state.top && (r = this.tokenizer.paragraph(i))) {
                    let a = t.at(-1);
                    n && a?.type === `paragraph` ? (a.raw += (a.raw.endsWith(`
`) ? `` : `
`) + r.raw, a.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = a.text) : t.push(r), n = i.length !== e.length, e = e.substring(r.raw.length);
                    continue;
                }
                if (r = this.tokenizer.text(e)) {
                    e = e.substring(r.raw.length);
                    let n = t.at(-1);
                    n?.type === `text` ? (n.raw += (n.raw.endsWith(`
`) ? `` : `
`) + r.raw, n.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = n.text) : t.push(r);
                    continue;
                }
                if (e) {
                    let t = `Infinite loop on byte: ` + e.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(t);
                        break;
                    } else throw Error(t);
                }
            }
            return this.state.top = !0, t;
        }
        inline(e, t = []) {
            return this.inlineQueue.push({
                src: e,
                tokens: t
            }), t;
        }
        inlineTokens(e, t = []) {
            this.tokenizer.lexer = this;
            let n = e, r = null;
            if (this.tokens.links) {
                let e = Object.keys(this.tokens.links);
                if (e.length > 0) for(; (r = this.tokenizer.rules.inline.reflinkSearch.exec(n)) != null;)e.includes(r[0].slice(r[0].lastIndexOf(`[`) + 1, -1)) && (n = n.slice(0, r.index) + `[` + `a`.repeat(r[0].length - 2) + `]` + n.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
            }
            for(; (r = this.tokenizer.rules.inline.anyPunctuation.exec(n)) != null;)n = n.slice(0, r.index) + `++` + n.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
            let i;
            for(; (r = this.tokenizer.rules.inline.blockSkip.exec(n)) != null;)i = r[2] ? r[2].length : 0, n = n.slice(0, r.index + i) + `[` + `a`.repeat(r[0].length - i - 2) + `]` + n.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
            n = this.options.hooks?.emStrongMask?.call({
                lexer: this
            }, n) ?? n;
            let a = !1, o = ``;
            for(; e;){
                a || (o = ``), a = !1;
                let r;
                if (this.options.extensions?.inline?.some((n)=>(r = n.call({
                        lexer: this
                    }, e, t)) ? (e = e.substring(r.raw.length), t.push(r), !0) : !1)) continue;
                if (r = this.tokenizer.escape(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.tag(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.link(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.reflink(e, this.tokens.links)) {
                    e = e.substring(r.raw.length);
                    let n = t.at(-1);
                    r.type === `text` && n?.type === `text` ? (n.raw += r.raw, n.text += r.text) : t.push(r);
                    continue;
                }
                if (r = this.tokenizer.emStrong(e, n, o)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.codespan(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.br(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.del(e, n, o)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.autolink(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (!this.state.inLink && (r = this.tokenizer.url(e))) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                let i = e;
                if (this.options.extensions?.startInline) {
                    let t = 1 / 0, n = e.slice(1), r;
                    this.options.extensions.startInline.forEach((e)=>{
                        r = e.call({
                            lexer: this
                        }, n), typeof r == `number` && r >= 0 && (t = Math.min(t, r));
                    }), t < 1 / 0 && t >= 0 && (i = e.substring(0, t + 1));
                }
                if (r = this.tokenizer.inlineText(i)) {
                    e = e.substring(r.raw.length), r.raw.slice(-1) !== `_` && (o = r.raw.slice(-1)), a = !0;
                    let n = t.at(-1);
                    n?.type === `text` ? (n.raw += r.raw, n.text += r.text) : t.push(r);
                    continue;
                }
                if (e) {
                    let t = `Infinite loop on byte: ` + e.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(t);
                        break;
                    } else throw Error(t);
                }
            }
            return t;
        }
    }, G = class {
        options;
        parser;
        constructor(e){
            this.options = e || t;
        }
        space(e) {
            return ``;
        }
        code({ text: e, lang: t, escaped: n }) {
            let r = (t || ``).match(o.notSpaceStart)?.[0], i = e.replace(o.endingNewline, ``) + `
`;
            return r ? `<pre><code class="language-` + R(r) + `">` + (n ? i : R(i, !0)) + `</code></pre>
` : `<pre><code>` + (n ? i : R(i, !0)) + `</code></pre>
`;
        }
        blockquote({ tokens: e }) {
            return `<blockquote>
${this.parser.parse(e)}</blockquote>
`;
        }
        html({ text: e }) {
            return e;
        }
        def(e) {
            return ``;
        }
        heading({ tokens: e, depth: t }) {
            return `<h${t}>${this.parser.parseInline(e)}</h${t}>
`;
        }
        hr(e) {
            return `<hr>
`;
        }
        list(e) {
            let t = e.ordered, n = e.start, r = ``;
            for(let t = 0; t < e.items.length; t++){
                let n = e.items[t];
                r += this.listitem(n);
            }
            let i = t ? `ol` : `ul`, a = t && n !== 1 ? ` start="` + n + `"` : ``;
            return `<` + i + a + `>
` + r + `</` + i + `>
`;
        }
        listitem(e) {
            return `<li>${this.parser.parse(e.tokens)}</li>
`;
        }
        checkbox({ checked: e }) {
            return `<input ` + (e ? `checked="" ` : ``) + `disabled="" type="checkbox"> `;
        }
        paragraph({ tokens: e }) {
            return `<p>${this.parser.parseInline(e)}</p>
`;
        }
        table(e) {
            let t = ``, n = ``;
            for(let t = 0; t < e.header.length; t++)n += this.tablecell(e.header[t]);
            t += this.tablerow({
                text: n
            });
            let r = ``;
            for(let t = 0; t < e.rows.length; t++){
                let i = e.rows[t];
                n = ``;
                for(let e = 0; e < i.length; e++)n += this.tablecell(i[e]);
                r += this.tablerow({
                    text: n
                });
            }
            return r &&= `<tbody>${r}</tbody>`, `<table>
<thead>
` + t + `</thead>
` + r + `</table>
`;
        }
        tablerow({ text: e }) {
            return `<tr>
${e}</tr>
`;
        }
        tablecell(e) {
            let t = this.parser.parseInline(e.tokens), n = e.header ? `th` : `td`;
            return (e.align ? `<${n} align="${e.align}">` : `<${n}>`) + t + `</${n}>
`;
        }
        strong({ tokens: e }) {
            return `<strong>${this.parser.parseInline(e)}</strong>`;
        }
        em({ tokens: e }) {
            return `<em>${this.parser.parseInline(e)}</em>`;
        }
        codespan({ text: e }) {
            return `<code>${R(e, !0)}</code>`;
        }
        br(e) {
            return `<br>`;
        }
        del({ tokens: e }) {
            return `<del>${this.parser.parseInline(e)}</del>`;
        }
        link({ href: e, title: t, tokens: n }) {
            let r = this.parser.parseInline(n), i = z(e);
            if (i === null) return r;
            e = i;
            let a = `<a href="` + e + `"`;
            return t && (a += ` title="` + R(t) + `"`), a += `>` + r + `</a>`, a;
        }
        image({ href: e, title: t, text: n, tokens: r }) {
            r && (n = this.parser.parseInline(r, this.parser.textRenderer));
            let i = z(e);
            if (i === null) return R(n);
            e = i;
            let a = `<img src="${e}" alt="${R(n)}"`;
            return t && (a += ` title="${R(t)}"`), a += `>`, a;
        }
        text(e) {
            return `tokens` in e && e.tokens ? this.parser.parseInline(e.tokens) : `escaped` in e && e.escaped ? e.text : R(e.text);
        }
    }, K = class {
        strong({ text: e }) {
            return e;
        }
        em({ text: e }) {
            return e;
        }
        codespan({ text: e }) {
            return e;
        }
        del({ text: e }) {
            return e;
        }
        html({ text: e }) {
            return e;
        }
        text({ text: e }) {
            return e;
        }
        link({ text: e }) {
            return `` + e;
        }
        image({ text: e }) {
            return `` + e;
        }
        br() {
            return ``;
        }
        checkbox({ raw: e }) {
            return e;
        }
    }, q = class e {
        options;
        renderer;
        textRenderer;
        constructor(e){
            this.options = e || t, this.options.renderer = this.options.renderer || new G, this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new K;
        }
        static parse(t, n) {
            return new e(n).parse(t);
        }
        static parseInline(t, n) {
            return new e(n).parseInline(t);
        }
        parse(e) {
            this.renderer.parser = this;
            let t = ``;
            for(let n = 0; n < e.length; n++){
                let r = e[n];
                if (this.options.extensions?.renderers?.[r.type]) {
                    let e = r, n = this.options.extensions.renderers[e.type].call({
                        parser: this
                    }, e);
                    if (n !== !1 || ![
                        `space`,
                        `hr`,
                        `heading`,
                        `code`,
                        `table`,
                        `blockquote`,
                        `list`,
                        `html`,
                        `def`,
                        `paragraph`,
                        `text`
                    ].includes(e.type)) {
                        t += n || ``;
                        continue;
                    }
                }
                let i = r;
                switch(i.type){
                    case `space`:
                        t += this.renderer.space(i);
                        break;
                    case `hr`:
                        t += this.renderer.hr(i);
                        break;
                    case `heading`:
                        t += this.renderer.heading(i);
                        break;
                    case `code`:
                        t += this.renderer.code(i);
                        break;
                    case `table`:
                        t += this.renderer.table(i);
                        break;
                    case `blockquote`:
                        t += this.renderer.blockquote(i);
                        break;
                    case `list`:
                        t += this.renderer.list(i);
                        break;
                    case `checkbox`:
                        t += this.renderer.checkbox(i);
                        break;
                    case `html`:
                        t += this.renderer.html(i);
                        break;
                    case `def`:
                        t += this.renderer.def(i);
                        break;
                    case `paragraph`:
                        t += this.renderer.paragraph(i);
                        break;
                    case `text`:
                        t += this.renderer.text(i);
                        break;
                    default:
                        {
                            let e = `Token with "` + i.type + `" type was not found.`;
                            if (this.options.silent) return console.error(e), ``;
                            throw Error(e);
                        }
                }
            }
            return t;
        }
        parseInline(e, t = this.renderer) {
            this.renderer.parser = this;
            let n = ``;
            for(let r = 0; r < e.length; r++){
                let i = e[r];
                if (this.options.extensions?.renderers?.[i.type]) {
                    let e = this.options.extensions.renderers[i.type].call({
                        parser: this
                    }, i);
                    if (e !== !1 || ![
                        `escape`,
                        `html`,
                        `link`,
                        `image`,
                        `strong`,
                        `em`,
                        `codespan`,
                        `br`,
                        `del`,
                        `text`
                    ].includes(i.type)) {
                        n += e || ``;
                        continue;
                    }
                }
                let a = i;
                switch(a.type){
                    case `escape`:
                        n += t.text(a);
                        break;
                    case `html`:
                        n += t.html(a);
                        break;
                    case `link`:
                        n += t.link(a);
                        break;
                    case `image`:
                        n += t.image(a);
                        break;
                    case `checkbox`:
                        n += t.checkbox(a);
                        break;
                    case `strong`:
                        n += t.strong(a);
                        break;
                    case `em`:
                        n += t.em(a);
                        break;
                    case `codespan`:
                        n += t.codespan(a);
                        break;
                    case `br`:
                        n += t.br(a);
                        break;
                    case `del`:
                        n += t.del(a);
                        break;
                    case `text`:
                        n += t.text(a);
                        break;
                    default:
                        {
                            let e = `Token with "` + a.type + `" type was not found.`;
                            if (this.options.silent) return console.error(e), ``;
                            throw Error(e);
                        }
                }
            }
            return n;
        }
    }, J = class {
        options;
        block;
        constructor(e){
            this.options = e || t;
        }
        static passThroughHooks = new Set([
            `preprocess`,
            `postprocess`,
            `processAllTokens`,
            `emStrongMask`
        ]);
        static passThroughHooksRespectAsync = new Set([
            `preprocess`,
            `postprocess`,
            `processAllTokens`
        ]);
        preprocess(e) {
            return e;
        }
        postprocess(e) {
            return e;
        }
        processAllTokens(e) {
            return e;
        }
        emStrongMask(e) {
            return e;
        }
        provideLexer() {
            return this.block ? W.lex : W.lexInline;
        }
        provideParser() {
            return this.block ? q.parse : q.parseInline;
        }
    }, Y = class {
        defaults = e();
        options = this.setOptions;
        parse = this.parseMarkdown(!0);
        parseInline = this.parseMarkdown(!1);
        Parser = q;
        Renderer = G;
        TextRenderer = K;
        Lexer = W;
        Tokenizer = U;
        Hooks = J;
        constructor(...e){
            this.use(...e);
        }
        walkTokens(e, t) {
            let n = [];
            for (let r of e)switch(n = n.concat(t.call(this, r)), r.type){
                case `table`:
                    {
                        let e = r;
                        for (let r of e.header)n = n.concat(this.walkTokens(r.tokens, t));
                        for (let r of e.rows)for (let e of r)n = n.concat(this.walkTokens(e.tokens, t));
                        break;
                    }
                case `list`:
                    {
                        let e = r;
                        n = n.concat(this.walkTokens(e.items, t));
                        break;
                    }
                default:
                    {
                        let e = r;
                        this.defaults.extensions?.childTokens?.[e.type] ? this.defaults.extensions.childTokens[e.type].forEach((r)=>{
                            let i = e[r].flat(1 / 0);
                            n = n.concat(this.walkTokens(i, t));
                        }) : e.tokens && (n = n.concat(this.walkTokens(e.tokens, t)));
                    }
            }
            return n;
        }
        use(...e) {
            let t = this.defaults.extensions || {
                renderers: {},
                childTokens: {}
            };
            return e.forEach((e)=>{
                let n = {
                    ...e
                };
                if (n.async = this.defaults.async || n.async || !1, e.extensions && (e.extensions.forEach((e)=>{
                    if (!e.name) throw Error(`extension name required`);
                    if (`renderer` in e) {
                        let n = t.renderers[e.name];
                        n ? t.renderers[e.name] = function(...t) {
                            let r = e.renderer.apply(this, t);
                            return r === !1 && (r = n.apply(this, t)), r;
                        } : t.renderers[e.name] = e.renderer;
                    }
                    if (`tokenizer` in e) {
                        if (!e.level || e.level !== `block` && e.level !== `inline`) throw Error(`extension level must be 'block' or 'inline'`);
                        let n = t[e.level];
                        n ? n.unshift(e.tokenizer) : t[e.level] = [
                            e.tokenizer
                        ], e.start && (e.level === `block` ? t.startBlock ? t.startBlock.push(e.start) : t.startBlock = [
                            e.start
                        ] : e.level === `inline` && (t.startInline ? t.startInline.push(e.start) : t.startInline = [
                            e.start
                        ]));
                    }
                    `childTokens` in e && e.childTokens && (t.childTokens[e.name] = e.childTokens);
                }), n.extensions = t), e.renderer) {
                    let t = this.defaults.renderer || new G(this.defaults);
                    for(let n in e.renderer){
                        if (!(n in t)) throw Error(`renderer '${n}' does not exist`);
                        if ([
                            `options`,
                            `parser`
                        ].includes(n)) continue;
                        let r = n, i = e.renderer[r], a = t[r];
                        t[r] = (...e)=>{
                            let n = i.apply(t, e);
                            return n === !1 && (n = a.apply(t, e)), n || ``;
                        };
                    }
                    n.renderer = t;
                }
                if (e.tokenizer) {
                    let t = this.defaults.tokenizer || new U(this.defaults);
                    for(let n in e.tokenizer){
                        if (!(n in t)) throw Error(`tokenizer '${n}' does not exist`);
                        if ([
                            `options`,
                            `rules`,
                            `lexer`
                        ].includes(n)) continue;
                        let r = n, i = e.tokenizer[r], a = t[r];
                        t[r] = (...e)=>{
                            let n = i.apply(t, e);
                            return n === !1 && (n = a.apply(t, e)), n;
                        };
                    }
                    n.tokenizer = t;
                }
                if (e.hooks) {
                    let t = this.defaults.hooks || new J;
                    for(let n in e.hooks){
                        if (!(n in t)) throw Error(`hook '${n}' does not exist`);
                        if ([
                            `options`,
                            `block`
                        ].includes(n)) continue;
                        let r = n, i = e.hooks[r], a = t[r];
                        J.passThroughHooks.has(n) ? t[r] = (e)=>{
                            if (this.defaults.async && J.passThroughHooksRespectAsync.has(n)) return (async ()=>{
                                let n = await i.call(t, e);
                                return a.call(t, n);
                            })();
                            let r = i.call(t, e);
                            return a.call(t, r);
                        } : t[r] = (...e)=>{
                            if (this.defaults.async) return (async ()=>{
                                let n = await i.apply(t, e);
                                return n === !1 && (n = await a.apply(t, e)), n;
                            })();
                            let n = i.apply(t, e);
                            return n === !1 && (n = a.apply(t, e)), n;
                        };
                    }
                    n.hooks = t;
                }
                if (e.walkTokens) {
                    let t = this.defaults.walkTokens, r = e.walkTokens;
                    n.walkTokens = function(e) {
                        let n = [];
                        return n.push(r.call(this, e)), t && (n = n.concat(t.call(this, e))), n;
                    };
                }
                this.defaults = {
                    ...this.defaults,
                    ...n
                };
            }), this;
        }
        setOptions(e) {
            return this.defaults = {
                ...this.defaults,
                ...e
            }, this;
        }
        lexer(e, t) {
            return W.lex(e, t ?? this.defaults);
        }
        parser(e, t) {
            return q.parse(e, t ?? this.defaults);
        }
        parseMarkdown(e) {
            return (t, n)=>{
                let r = {
                    ...n
                }, i = {
                    ...this.defaults,
                    ...r
                }, a = this.onError(!!i.silent, !!i.async);
                if (this.defaults.async === !0 && r.async === !1) return a(Error(`marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise.`));
                if (typeof t > `u` || t === null) return a(Error(`marked(): input parameter is undefined or null`));
                if (typeof t != `string`) return a(Error(`marked(): input parameter is of type ` + Object.prototype.toString.call(t) + `, string expected`));
                if (i.hooks && (i.hooks.options = i, i.hooks.block = e), i.async) return (async ()=>{
                    let n = i.hooks ? await i.hooks.preprocess(t) : t, r = await (i.hooks ? await i.hooks.provideLexer() : e ? W.lex : W.lexInline)(n, i), a = i.hooks ? await i.hooks.processAllTokens(r) : r;
                    i.walkTokens && await Promise.all(this.walkTokens(a, i.walkTokens));
                    let o = await (i.hooks ? await i.hooks.provideParser() : e ? q.parse : q.parseInline)(a, i);
                    return i.hooks ? await i.hooks.postprocess(o) : o;
                })().catch(a);
                try {
                    i.hooks && (t = i.hooks.preprocess(t));
                    let n = (i.hooks ? i.hooks.provideLexer() : e ? W.lex : W.lexInline)(t, i);
                    i.hooks && (n = i.hooks.processAllTokens(n)), i.walkTokens && this.walkTokens(n, i.walkTokens);
                    let r = (i.hooks ? i.hooks.provideParser() : e ? q.parse : q.parseInline)(n, i);
                    return i.hooks && (r = i.hooks.postprocess(r)), r;
                } catch (e) {
                    return a(e);
                }
            };
        }
        onError(e, t) {
            return (n)=>{
                if (n.message += `
Please report this to https://github.com/markedjs/marked.`, e) {
                    let e = `<p>An error occurred:</p><pre>` + R(n.message + ``, !0) + `</pre>`;
                    return t ? Promise.resolve(e) : e;
                }
                if (t) return Promise.reject(n);
                throw n;
            };
        }
    }, X = new Y;
    function Z(e, t) {
        return X.parse(e, t);
    }
    Z.options = Z.setOptions = function(e) {
        return X.setOptions(e), Z.defaults = X.defaults, n(Z.defaults), Z;
    }, Z.getDefaults = e, Z.defaults = t, Z.use = function(...e) {
        return X.use(...e), Z.defaults = X.defaults, n(Z.defaults), Z;
    }, Z.walkTokens = function(e, t) {
        return X.walkTokens(e, t);
    }, Z.parseInline = X.parseInline, Z.Parser = q, Z.parser = q.parse, Z.Renderer = G, Z.TextRenderer = K, Z.Lexer = W, Z.lexer = W.lex, Z.Tokenizer = U, Z.Hooks = J, Z.parse = Z, Z.options, Z.setOptions, Z.use, Z.walkTokens, Z.parseInline, q.parse, W.lex;
    var Ne = /<(\/?)(?:pre|code|kbd|script|math)[^>]*>/i, Pe = (e = ``, t = `1`)=>{
        var n, r, i, a, o, s = 0;
        if (t = typeof t == `number` ? t.toString() : t.replace(/\s/g, ``), t === `0`) return e;
        if (t === `1`) n = 1, r = 1, i = 1, a = 1;
        else if (t === `2`) n = 1, r = 1, i = 2, a = 1;
        else if (t === `3`) n = 1, r = 1, i = 3, a = 1;
        else if (t === `-1`) o = 1;
        else for(let e = 0; e < t.length; e++){
            let o = t[e];
            o === `q` && (n = 1), o === `b` && (r = 1), o === `B` && (r = 2), o === `d` && (i = 1), o === `D` && (i = 2), o === `i` && (i = 3), o === `e` && (a = 1), o === `w` && (s = 1);
        }
        var c = We(e), l = ``, u = 0, d = ``;
        for(let e = 0; e < c.length; e++){
            let t = c[e];
            if (t[0] === `tag`) {
                l += t[1];
                let e = Ne.exec(t[1]);
                e && (u = e[1] === `/` ? 0 : 1);
            } else {
                let e = t[1], c = e.substring(e.length - 1, e.length);
                u || (e = Ue(e), s && (e = e.replace(/$quot;/g, `"`)), i && (i === 1 && (e = Re(e)), i === 2 && (e = ze(e)), i === 3 && (e = Be(e))), a && (e = Ve(e)), r && (e = Ie(e), r === 2 && (e = Le(e))), n && (e = e === `'` ? /\S/.test(d) ? `&#8217;` : `&#8216;` : e === `"` ? /\S/.test(d) ? `&#8221;` : `&#8220;` : Fe(e)), o && (e = He(e))), d = c, l += e;
            }
        }
        return l;
    }, Fe = (e)=>{
        var t = `[!"#$%'()*+,-./:;<=>?@[\\]^_\`{|}~]`;
        e = e.replace(RegExp(`^'(?=${t}\\B)`), `&#8217;`), e = e.replace(RegExp(`^"(?=${t}\\B)`), `&#8221;`), e = e.replace(/"'(?=\w)/, `&#8220;&#8216;`), e = e.replace(/'"(?=\w)/, `&#8216;&#8220;`), e = e.replace(/'(?=\d\d)/, `&#8217;`);
        var n = `[^\\ \\t\\r\\n\\[\\{\\(\\-]`, r = `[\\ \\t\\r\\n\\[\\{\\(\\-]`, i = `&#8211;|&#8212;`;
        return e = e.replace(RegExp(`(\\s|&nbsp;|--|&[mn]dash;|${i}|&#x201[34])'(?=\\w)`, `g`), `$1&#8216;`), e = e.replace(RegExp(`(${n})'`, `g`), `$1&#8217;`), e = e.replace(RegExp(`(${r}?)'(?=\\s|s\\b)`, `g`), `$1&#8217;`), e = e.replace(/'/g, `&#8216;`), e = e.replace(RegExp(`(\\s|&nbsp;|--|&[mn]dash;|${i}|&#x201[34])"(?=\\w)`, `g`), `$1&#8220;`), e = e.replace(RegExp(`(${n})"`, `g`), `$1&#8221;`), e = e.replace(RegExp(`(${r}?)"(?=\\s)`, `g`), `$1&#8221;`), e = e.replace(/"/g, `&#8220;`), e;
    }, Ie = (e)=>(e = e.replace(/``/g, `&#8220;`), e = e.replace(/''/g, `&#8221;`), e), Le = (e)=>(e = e.replace(/`/g, `&#8216;`), e = e.replace(/'/g, `&#8217;`), e), Re = (e)=>(e = e.replace(/--/g, `&#8212;`), e), ze = (e)=>(e = e.replace(/---/g, `&#8212;`), e = e.replace(/--/g, `&#8211;`), e), Be = (e)=>(e = e.replace(/---/g, `&#8211;`), e = e.replace(/--/g, `&#8212;`), e), Ve = (e)=>(e = e.replace(/\.\.\./g, `&#8230;`), e = e.replace(/\. \. \./g, `&#8230;`), e), He = (e)=>(e = e.replace(/&#8211;/g, `-`), e = e.replace(/&#8212;/g, `--`), e = e.replace(/&#8216;/g, `'`), e = e.replace(/&#8217;/g, `'`), e = e.replace(/&#8220;/g, `"`), e = e.replace(/&#8221;/g, `"`), e = e.replace(/&#8230;/g, `...`), e), Ue = (e)=>(e = e.replace(/\\\\/g, `&#92;`), e = e.replace(/\\"/g, `&#34;`), e = e.replace(/\\'/g, `&#39;`), e = e.replace(/\\\./g, `&#46;`), e = e.replace(/\\-/g, `&#45;`), e = e.replace(/\\`/g, `&#96;`), e), We = (e)=>{
        for(var t = 0, n = e.length, r = [], i = /<!--[\s\S]*?-->|<\?.*?\?>|<[^>]*>/g, a = null; a = i.exec(e);){
            if (t < a.index) {
                let n = [
                    `text`,
                    e.substring(t, a.index)
                ];
                r.push(n);
            }
            let n = [
                `tag`,
                a.toString()
            ];
            r.push(n), t = i.lastIndex;
        }
        if (t < n) {
            let i = [
                `text`,
                e.substring(t, n)
            ];
            r.push(i);
        }
        return r;
    };
    function Ge({ config: e = 2 } = {}) {
        return {
            tokenizer: {
                inlineText (e) {
                    let t = this.rules.inline.text.exec(e);
                    if (t) return {
                        type: `text`,
                        raw: t[0],
                        text: t[0],
                        escaped: !0
                    };
                }
            },
            hooks: {
                postprocess (t) {
                    return Pe(t, e);
                }
            }
        };
    }
    var Ke = `\r?
---\r?
`, qe = null, Je = `^s*notes?:`, Ye = `\\.element\\s*?(.+?)$`, Xe = `\\.slide:\\s*?(\\S.+?)$`, Q = `__SCRIPT_END__`, $ = /\[\s*((\d*):)?\s*([\s\d,|-]*)\]/, Ze = {
        "&": `&amp;`,
        "<": `&lt;`,
        ">": `&gt;`,
        '"': `&quot;`,
        "'": `&#39;`
    };
    return ()=>{
        let e, t = null;
        function n(e) {
            let t = (e.querySelector(`[data-template]`) || e.querySelector(`script`) || e).textContent;
            t = t.replace(new RegExp(Q, `g`), `<\/script>`);
            let n = t.match(/^\n?(\s*)/)[1].length, r = t.match(/^\n?(\t*)/)[1].length;
            return r > 0 ? t = t.replace(RegExp(`\\n?\\t{` + r + `}(.*)`, `g`), function(e, t) {
                return `
` + t;
            }) : n > 1 && (t = t.replace(RegExp(`\\n? {` + n + `}(.*)`, `g`), function(e, t) {
                return `
` + t;
            })), t;
        }
        function r(e) {
            let t = e.attributes, n = [];
            for(let e = 0, r = t.length; e < r; e++){
                let r = t[e].name, i = t[e].value;
                /data\-(markdown|separator|vertical|notes)/gi.test(r) || (i ? n.push(r + `="` + i + `"`) : n.push(r));
            }
            return n.join(` `);
        }
        function i(t) {
            let n = e?.getConfig?.().markdown;
            return t ||= {}, t.separator = t.separator || n?.separator || Ke, t.verticalSeparator = t.verticalSeparator || n?.verticalSeparator || qe, t.notesSeparator = t.notesSeparator || n?.notesSeparator || Je, t.attributes = t.attributes || ``, t;
        }
        function a(e, n) {
            n = i(n);
            let r = e.split(new RegExp(n.notesSeparator, `mgi`));
            return r.length === 2 && t && (e = r[0] + `<aside class="notes">` + t.parse(r[1].trim()) + `</aside>`), e = e.replace(/<\/script>/g, Q), `<script type="text/template">` + e + `<\/script>`;
        }
        function o(e, t) {
            t = i(t);
            let n = RegExp(t.separator + (t.verticalSeparator ? `|` + t.verticalSeparator : ``), `mg`), r = new RegExp(t.separator), o, s = 0, c, l = !0, u, d = [];
            for(; o = n.exec(e);)c = r.test(o[0]), !c && l && d.push([]), u = e.substring(s, o.index), c && l ? d.push(u) : d[d.length - 1].push(u), s = n.lastIndex, l = c;
            (l ? d : d[d.length - 1]).push(e.substring(s));
            let f = ``;
            for(let e = 0, n = d.length; e < n; e++)d[e] instanceof Array ? (f += `<section ` + t.attributes + `>`, d[e].forEach(function(e) {
                f += `<section data-markdown>` + a(e, t) + `</section>`;
            }), f += `</section>`) : f += `<section ` + t.attributes + ` data-markdown>` + a(d[e], t) + `</section>`;
            return f;
        }
        function s(e) {
            return new Promise(function(t) {
                let i = [];
                [].slice.call(e.querySelectorAll(`section[data-markdown]:not([data-markdown-parsed])`)).forEach(function(e, t) {
                    e.getAttribute(`data-markdown`).length ? i.push(c(e).then(function(t, n) {
                        e.outerHTML = o(t.responseText, {
                            separator: e.getAttribute(`data-separator`),
                            verticalSeparator: e.getAttribute(`data-separator-vertical`),
                            notesSeparator: e.getAttribute(`data-separator-notes`),
                            attributes: r(e)
                        });
                    }, function(t, n) {
                        e.outerHTML = `<section data-state="alert">ERROR: The attempt to fetch ` + n + ` failed with HTTP status ` + t.status + `.Check your browser's JavaScript console for more details.<p>Remember that you need to serve the presentation HTML from a HTTP server.</p></section>`;
                    })) : e.outerHTML = o(n(e), {
                        separator: e.getAttribute(`data-separator`),
                        verticalSeparator: e.getAttribute(`data-separator-vertical`),
                        notesSeparator: e.getAttribute(`data-separator-notes`),
                        attributes: r(e)
                    });
                }), Promise.all(i).then(t);
            });
        }
        function c(e) {
            return new Promise(function(t, n) {
                let r = new XMLHttpRequest, i = e.getAttribute(`data-markdown`), a = e.getAttribute(`data-charset`);
                a !== null && a !== `` && r.overrideMimeType(`text/html; charset=` + a), r.onreadystatechange = (function(e, r) {
                    r.readyState === 4 && (r.status >= 200 && r.status < 300 || r.status === 0 ? t(r, i) : n(r, i));
                }).bind(this, e, r), r.open(`GET`, i, !0);
                try {
                    r.send();
                } catch (e) {
                    console.warn(`Failed to get the Markdown file ` + i + `. Make sure that the presentation and the file are served by a HTTP server and the file can be found there. ` + e), t(r, i);
                }
            });
        }
        function l(e, t, n) {
            let r = new RegExp(n, `mg`), i = RegExp(`([^"= ]+?)="([^"]+?)"|(data-[^"= ]+?)(?=[" ])`, `mg`), a = e.nodeValue, o, s;
            if (o = r.exec(a)) {
                let n = o[1];
                for(a = a.substring(0, o.index) + a.substring(r.lastIndex), e.nodeValue = a; s = i.exec(n);)s[2] ? t.setAttribute(s[1], s[2]) : t.setAttribute(s[3], ``);
                return !0;
            }
            return !1;
        }
        function u(e, t, n, r, i) {
            if (t !== null && t.childNodes !== void 0 && t.childNodes.length > 0) {
                let n = t;
                for(let a = 0; a < t.childNodes.length; a++){
                    let o = t.childNodes[a];
                    if (a > 0) {
                        let e = a - 1;
                        for(; e >= 0;){
                            let r = t.childNodes[e];
                            if (typeof r.setAttribute == `function` && r.tagName !== `BR`) {
                                n = r;
                                break;
                            }
                            --e;
                        }
                    }
                    let s = e;
                    o.nodeName === `section` && (s = o, n = o), (typeof o.setAttribute == `function` || o.nodeType === Node.COMMENT_NODE) && u(s, o, n, r, i);
                }
            }
            if (t.nodeType === Node.COMMENT_NODE) {
                let a = n;
                a && (a.tagName === `UL` || a.tagName === `OL`) && (a = a.lastElementChild || a), l(t, a, r) === !1 && l(t, e, i);
            }
        }
        function d() {
            let r = e.getRevealElement().querySelectorAll(`[data-markdown]:not([data-markdown-parsed])`);
            return [].slice.call(r).forEach(function(e) {
                e.setAttribute(`data-markdown-parsed`, !0);
                let r = e.querySelector(`aside.notes`), i = n(e);
                e.innerHTML = t ? t.parse(i) : i, u(e, e, null, e.getAttribute(`data-element-attributes`) || e.parentNode.getAttribute(`data-element-attributes`) || Ye, e.getAttribute(`data-attributes`) || e.parentNode.getAttribute(`data-attributes`) || Xe), r && e.appendChild(r);
            }), Promise.resolve();
        }
        function f(e) {
            return e.replace(/([&<>'"])/g, (e)=>Ze[e]);
        }
        return {
            id: `markdown`,
            init: function(n) {
                e = n;
                let { renderer: r, animateLists: i, smartypants: a, ...o } = e.getConfig().markdown || {}, c = r || {
                    code ({ text: e, lang: t }) {
                        let n = t || ``, r = ``, i = ``;
                        if ($.test(n)) {
                            let e = n.match($)[2];
                            e && (r = `data-ln-start-from="${e.trim()}"`), i = n.match($)[3].trim(), i = `data-line-numbers="${i}"`, n = n.replace($, ``).trim();
                        }
                        return e = f(e), `<pre><code ${i} ${r} class="${n}">${e}</code></pre>`;
                    }
                };
                return i === !0 && !r && (c.listitem = function(e) {
                    return `<li class="fragment">${e.tokens ? this.parser.parseInline(e.tokens) : e.text || ``}</li>`;
                }), t = new Y, t.use({
                    renderer: c,
                    ...o
                }), a && t.use(Ge()), s(e.getRevealElement()).then(d);
            },
            processSlides: s,
            convertSlides: d,
            slidify: o,
            get marked () {
                return t;
            },
            get markdownOptions () {
                return e && e.getConfig().markdown || {};
            }
        };
    };
});


var $f1a25014a4fb78e6$exports = {};
(function(e, t) {
    "object" == `object` && "object" < `u` ? $f1a25014a4fb78e6$exports = t() : typeof define == `function` && define.amd ? define([], t) : (e = typeof globalThis < `u` ? globalThis : e || self, e.RevealZoom = t());
})($f1a25014a4fb78e6$exports, function() {
    var e = {
        id: `zoom`,
        init: function(e) {
            e.getRevealElement().addEventListener(`mousedown`, function(t) {
                var r = /Linux/.test(window.navigator.platform) ? `ctrl` : `alt`, i = (e.getConfig().zoomKey ? e.getConfig().zoomKey : r) + `Key`, a = e.getConfig().zoomLevel ? e.getConfig().zoomLevel : 2;
                t[i] && !e.isOverview() && (t.preventDefault(), n.to({
                    x: t.clientX,
                    y: t.clientY,
                    scale: a,
                    pan: !1
                }));
            });
        },
        destroy: ()=>{
            n.reset();
        }
    }, t = ()=>e, n = function() {
        var e = 1, t = 0, r = 0, i = -1, a = -1, o = `transform` in document.body.style;
        o && (document.body.style.transition = `transform 0.8s ease`), document.addEventListener(`keyup`, function(t) {
            e !== 1 && t.keyCode === 27 && n.out();
        }), document.addEventListener(`mousemove`, function(n) {
            e !== 1 && (t = n.clientX, r = n.clientY);
        });
        function s(t, n) {
            var r = l();
            if (t.width = t.width || 1, t.height = t.height || 1, t.x -= (window.innerWidth - t.width * n) / 2, t.y -= (window.innerHeight - t.height * n) / 2, o) {
                if (n === 1) document.body.style.transform = ``;
                else {
                    var i = r.x + `px ` + r.y + `px`, a = `translate(` + -t.x + `px,` + -t.y + `px) scale(` + n + `)`;
                    document.body.style.transformOrigin = i, document.body.style.transform = a;
                }
            } else n === 1 ? (document.body.style.position = ``, document.body.style.left = ``, document.body.style.top = ``, document.body.style.width = ``, document.body.style.height = ``, document.body.style.zoom = ``) : (document.body.style.position = `relative`, document.body.style.left = -(r.x + t.x) / n + `px`, document.body.style.top = -(r.y + t.y) / n + `px`, document.body.style.width = n * 100 + `%`, document.body.style.height = n * 100 + `%`, document.body.style.zoom = n);
            e = n, document.documentElement.classList && (e === 1 ? document.documentElement.classList.remove(`zoomed`) : document.documentElement.classList.add(`zoomed`));
        }
        function c() {
            var n = .12, i = window.innerWidth * n, a = window.innerHeight * n, o = l();
            r < a ? window.scroll(o.x, o.y - (1 - r / a) * (14 / e)) : r > window.innerHeight - a && window.scroll(o.x, o.y + (1 - (window.innerHeight - r) / a) * (14 / e)), t < i ? window.scroll(o.x - (1 - t / i) * (14 / e), o.y) : t > window.innerWidth - i && window.scroll(o.x + (1 - (window.innerWidth - t) / i) * (14 / e), o.y);
        }
        function l() {
            return {
                x: window.scrollX === void 0 ? window.pageXOffset : window.scrollX,
                y: window.scrollY === void 0 ? window.pageYOffset : window.scrollY
            };
        }
        return {
            to: function(t) {
                if (e !== 1) n.out();
                else {
                    if (t.x = t.x || 0, t.y = t.y || 0, t.element) {
                        var r = 20, o = t.element.getBoundingClientRect();
                        t.x = o.left - r, t.y = o.top - r, t.width = o.width + r * 2, t.height = o.height + r * 2;
                    }
                    t.width !== void 0 && t.height !== void 0 && (t.scale = Math.max(Math.min(window.innerWidth / t.width, window.innerHeight / t.height), 1)), t.scale > 1 && (t.x *= t.scale, t.y *= t.scale, s(t, t.scale), t.pan !== !1 && (i = setTimeout(function() {
                        a = setInterval(c, 1e3 / 60);
                    }, 800)));
                }
            },
            out: function() {
                clearTimeout(i), clearInterval(a), s({
                    x: 0,
                    y: 0
                }, 1), e = 1;
            },
            magnify: function(e) {
                this.to(e);
            },
            reset: function() {
                this.out();
            },
            zoomLevel: function() {
                return e;
            }
        };
    }();
    return t;
});


var $7a7abc3225b4e0de$exports = {};
(function(e, t) {
    "object" == `object` && "object" < `u` ? $7a7abc3225b4e0de$exports = t() : typeof define == `function` && define.amd ? define([], t) : (e = typeof globalThis < `u` ? globalThis : e || self, e.RevealNotes = t());
})($7a7abc3225b4e0de$exports, function() {
    var e = `<!--
	NOTE: You need to build the notes plugin after making changes to this file.
-->
<html lang="en">
	<head>
		<meta charset="utf-8">

		<title>reveal.js - Speaker View</title>

		<style>
			body {
				font-family: Helvetica;
				font-size: 18px;
			}

			#current-slide,
			#upcoming-slide,
			#speaker-controls {
				padding: 6px;
				box-sizing: border-box;
				-moz-box-sizing: border-box;
			}

			#current-slide iframe,
			#upcoming-slide iframe {
				width: 100%;
				height: 100%;
				border: 1px solid #ddd;
			}

			#current-slide .label,
			#upcoming-slide .label {
				position: absolute;
				top: 10px;
				left: 10px;
				z-index: 2;
			}

			#connection-status {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				z-index: 20;
				padding: 30% 20% 20% 20%;
				font-size: 18px;
				color: #222;
				background: #fff;
				text-align: center;
				box-sizing: border-box;
				line-height: 1.4;
			}

			.overlay-element {
				height: 34px;
				line-height: 34px;
				padding: 0 10px;
				text-shadow: none;
				background: rgba( 220, 220, 220, 0.8 );
				color: #222;
				font-size: 14px;
			}

			.overlay-element.interactive:hover {
				background: rgba( 220, 220, 220, 1 );
			}

			#current-slide {
				position: absolute;
				width: 60%;
				height: 100%;
				top: 0;
				left: 0;
				padding-right: 0;
			}

			#upcoming-slide {
				position: absolute;
				width: 40%;
				height: 40%;
				right: 0;
				top: 0;
			}

			/* Speaker controls */
			#speaker-controls {
				position: absolute;
				top: 40%;
				right: 0;
				width: 40%;
				height: 60%;
				overflow: auto;
				font-size: 18px;
			}

				.speaker-controls-time.hidden,
				.speaker-controls-notes.hidden {
					display: none;
				}

				.speaker-controls-time .label,
				.speaker-controls-pace .label,
				.speaker-controls-notes .label {
					text-transform: uppercase;
					font-weight: normal;
					font-size: 0.66em;
					color: #666;
					margin: 0;
				}

				.speaker-controls-time, .speaker-controls-pace {
					border-bottom: 1px solid rgba( 200, 200, 200, 0.5 );
					margin-bottom: 10px;
					padding: 10px 16px;
					padding-bottom: 20px;
					cursor: pointer;
				}

				.speaker-controls-time .reset-button {
					opacity: 0;
					float: right;
					color: #666;
					text-decoration: none;
				}
				.speaker-controls-time:hover .reset-button {
					opacity: 1;
				}

				.speaker-controls-time .timer,
				.speaker-controls-time .clock {
					width: 50%;
				}

				.speaker-controls-time .timer,
				.speaker-controls-time .clock,
				.speaker-controls-time .pacing .hours-value,
				.speaker-controls-time .pacing .minutes-value,
				.speaker-controls-time .pacing .seconds-value {
					font-size: 1.9em;
				}

				.speaker-controls-time .timer {
					float: left;
				}

				.speaker-controls-time .clock {
					float: right;
					text-align: right;
				}

				.speaker-controls-time span.mute {
					opacity: 0.3;
				}

				.speaker-controls-time .pacing-title {
					margin-top: 5px;
				}

				.speaker-controls-time .pacing.ahead {
					color: blue;
				}

				.speaker-controls-time .pacing.on-track {
					color: green;
				}

				.speaker-controls-time .pacing.behind {
					color: red;
				}

				.speaker-controls-notes {
					padding: 10px 16px;
				}

				.speaker-controls-notes .value {
					margin-top: 5px;
					line-height: 1.4;
					font-size: 1.2em;
				}

			/* Layout selector\xa0*/
			#speaker-layout {
				position: absolute;
				top: 10px;
				right: 10px;
				color: #222;
				z-index: 10;
			}
				#speaker-layout select {
					position: absolute;
					width: 100%;
					height: 100%;
					top: 0;
					left: 0;
					border: 0;
					box-shadow: 0;
					cursor: pointer;
					opacity: 0;

					font-size: 1em;
					background-color: transparent;

					-moz-appearance: none;
					-webkit-appearance: none;
					-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
				}

				#speaker-layout select:focus {
					outline: none;
					box-shadow: none;
				}

			.clear {
				clear: both;
			}

			/* Speaker layout: Wide */
			body[data-speaker-layout="wide"] #current-slide,
			body[data-speaker-layout="wide"] #upcoming-slide {
				width: 50%;
				height: 45%;
				padding: 6px;
			}

			body[data-speaker-layout="wide"] #current-slide {
				top: 0;
				left: 0;
			}

			body[data-speaker-layout="wide"] #upcoming-slide {
				top: 0;
				left: 50%;
			}

			body[data-speaker-layout="wide"] #speaker-controls {
				top: 45%;
				left: 0;
				width: 100%;
				height: 50%;
				font-size: 1.25em;
			}

			/* Speaker layout: Tall */
			body[data-speaker-layout="tall"] #current-slide,
			body[data-speaker-layout="tall"] #upcoming-slide {
				width: 45%;
				height: 50%;
				padding: 6px;
			}

			body[data-speaker-layout="tall"] #current-slide {
				top: 0;
				left: 0;
			}

			body[data-speaker-layout="tall"] #upcoming-slide {
				top: 50%;
				left: 0;
			}

			body[data-speaker-layout="tall"] #speaker-controls {
				padding-top: 40px;
				top: 0;
				left: 45%;
				width: 55%;
				height: 100%;
				font-size: 1.25em;
			}

			/* Speaker layout: Notes only */
			body[data-speaker-layout="notes-only"] #current-slide,
			body[data-speaker-layout="notes-only"] #upcoming-slide {
				display: none;
			}

			body[data-speaker-layout="notes-only"] #speaker-controls {
				padding-top: 40px;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				font-size: 1.25em;
			}

			@media screen and (max-width: 1080px) {
				body[data-speaker-layout="default"] #speaker-controls {
					font-size: 16px;
				}
			}

			@media screen and (max-width: 900px) {
				body[data-speaker-layout="default"] #speaker-controls {
					font-size: 14px;
				}
			}

			@media screen and (max-width: 800px) {
				body[data-speaker-layout="default"] #speaker-controls {
					font-size: 12px;
				}
			}

		</style>
	</head>

	<body>

		<div id="connection-status">Loading speaker view...</div>

		<div id="current-slide"></div>
		<div id="upcoming-slide"><span class="overlay-element label">Upcoming</span></div>
		<div id="speaker-controls">
			<div class="speaker-controls-time">
				<h4 class="label">Time <span class="reset-button">Click to Reset</span></h4>
				<div class="clock">
					<span class="clock-value">0:00 AM</span>
				</div>
				<div class="timer">
					<span class="hours-value">00</span><span class="minutes-value">:00</span><span class="seconds-value">:00</span>
				</div>
				<div class="clear"></div>

				<h4 class="label pacing-title" style="display: none">Pacing \u{2013} Time to finish current slide</h4>
				<div class="pacing" style="display: none">
					<span class="hours-value">00</span><span class="minutes-value">:00</span><span class="seconds-value">:00</span>
				</div>
			</div>

			<div class="speaker-controls-notes hidden">
				<h4 class="label">Notes</h4>
				<div class="value"></div>
			</div>
		</div>
		<div id="speaker-layout" class="overlay-element interactive">
			<span class="speaker-layout-label"></span>
			<select class="speaker-layout-dropdown"></select>
		</div>

		<script>

			(function() {

				var notes,
					notesValue,
					currentState,
					currentSlide,
					upcomingSlide,
					layoutLabel,
					layoutDropdown,
					pendingCalls = {},
					lastRevealApiCallId = 0,
					connected = false

				var connectionStatus = document.querySelector( '#connection-status' );

				var SPEAKER_LAYOUTS = {
					'default': 'Default',
					'wide': 'Wide',
					'tall': 'Tall',
					'notes-only': 'Notes only'
				};

				setupLayout();

				let openerOrigin;

				try {
					openerOrigin = window.opener.location.origin;
				}
				catch ( error ) { console.warn( error ) }

				// In order to prevent XSS, the speaker view will only run if its
				// opener has the same origin as itself
				if( window.location.origin !== openerOrigin ) {
					connectionStatus.innerHTML = 'Cross origin error.<br>The speaker window can only be opened from the same origin.';
					return;
				}

				var connectionTimeout = setTimeout( function() {
					connectionStatus.innerHTML = 'Error connecting to main window.<br>Please try closing and reopening the speaker view.';
				}, 5000 );

				window.addEventListener( 'message', function( event ) {

					// Validate the origin of all messages to avoid parsing messages
					// that aren't meant for us. Ignore when running off file:// so
					// that the speaker view continues to work without a web server.
					if( window.location.origin !== event.origin && window.location.origin !== 'file://' ) {
						return
					}

					clearTimeout( connectionTimeout );
					connectionStatus.style.display = 'none';

					var data = JSON.parse( event.data );

					// The overview mode is only useful to the reveal.js instance
					// where navigation occurs so we don't sync it
					if( data.state ) delete data.state.overview;

					// Messages sent by the notes plugin inside of the main window
					if( data && data.namespace === 'reveal-notes' ) {
						if( data.type === 'connect' ) {
							handleConnectMessage( data );
						}
						else if( data.type === 'state' ) {
							handleStateMessage( data );
						}
						else if( data.type === 'return' ) {
							pendingCalls[data.callId](data.result);
							delete pendingCalls[data.callId];
						}
					}
					// Messages sent by the reveal.js inside of the current slide preview
					else if( data && data.namespace === 'reveal' ) {
						const supportedEvents = [
							'slidechanged',
							'fragmentshown',
							'fragmenthidden',
							'paused',
							'resumed',
							'previewiframe',
							'previewimage',
							'previewvideo',
							'closeoverlay'
						];

						if( /ready/.test( data.eventName ) ) {
							// Send a message back to notify that the handshake is complete
							window.opener.postMessage( JSON.stringify({ namespace: 'reveal-notes', type: 'connected'} ), '*' );
						}
						else if( supportedEvents.includes( data.eventName ) && currentState !== JSON.stringify( data.state ) ) {
							dispatchStateToMainWindow( data.state );
						}
					}

				} );

				/**
				 * Updates the presentation in the main window to match the state
				 * of the presentation in the notes window.
				 */
				const dispatchStateToMainWindow = debounce(( state ) => {
					window.opener.postMessage( JSON.stringify({ method: 'setState', args: [ state ]} ), '*' );
				}, 500);

				/**
				 * Asynchronously calls the Reveal.js API of the main frame.
				 */
				function callRevealApi( methodName, methodArguments, callback ) {

					var callId = ++lastRevealApiCallId;
					pendingCalls[callId] = callback;
					window.opener.postMessage( JSON.stringify( {
						namespace: 'reveal-notes',
						type: 'call',
						callId: callId,
						methodName: methodName,
						arguments: methodArguments
					} ), '*' );

				}

				/**
				 * Called when the main window is trying to establish a
				 * connection.
				 */
				function handleConnectMessage( data ) {

					if( connected === false ) {
						connected = true;

						setupIframes( data );
						setupKeyboard();
						setupNotes();
						setupTimer();
						setupHeartbeat();
					}

				}

				/**
				 * Called when the main window sends an updated state.
				 */
				function handleStateMessage( data ) {

					// Store the most recently set state to avoid circular loops
					// applying the same state
					currentState = JSON.stringify( data.state );

					// No need for updating the notes in case of fragment changes
					if ( data.notes ) {
						notes.classList.remove( 'hidden' );
						notesValue.style.whiteSpace = data.whitespace;
						if( data.markdown ) {
							notesValue.innerHTML = marked.parse( data.notes );
						}
						else {
							notesValue.innerHTML = data.notes;
						}
					}
					else {
						notes.classList.add( 'hidden' );
					}

					// Don't show lightboxes in the upcoming slide
					const { previewVideo, previewImage, previewIframe, ...upcomingState } = data.state;

					// Update the note slides
					currentSlide.contentWindow.postMessage( JSON.stringify({ method: 'setState', args: [ data.state ] }), '*' );
					upcomingSlide.contentWindow.postMessage( JSON.stringify({ method: 'setState', args: [ upcomingState ] }), '*' );
					upcomingSlide.contentWindow.postMessage( JSON.stringify({ method: 'next' }), '*' );

				}

				// Limit to max one state update per X ms
				handleStateMessage = debounce( handleStateMessage, 200 );

				/**
				 * Forward keyboard events to the current slide window.
				 * This enables keyboard events to work even if focus
				 * isn't set on the current slide iframe.
				 *
				 * Block F5 default handling, it reloads and disconnects
				 * the speaker notes window.
				 */
				function setupKeyboard() {

					document.addEventListener( 'keydown', function( event ) {
						if( event.keyCode === 116 || ( event.metaKey && event.keyCode === 82 ) ) {
							event.preventDefault();
							return false;
						}
						currentSlide.contentWindow.postMessage( JSON.stringify({ method: 'triggerKey', args: [ event.keyCode ] }), '*' );
					} );

				}

				/**
				 * Creates the preview iframes.
				 */
				function setupIframes( data ) {

					var params = [
						'receiver',
						'progress=false',
						'history=false',
						'transition=none',
						'autoSlide=0',
						'backgroundTransition=none'
					].join( '&' );

					var urlSeparator = /\\?/.test(data.url) ? '&' : '?';
					var hash = '#/' + data.state.indexh + '/' + data.state.indexv;
					var currentURL = data.url + urlSeparator + params + '&scrollActivationWidth=false&postMessageEvents=true' + hash;
					var upcomingURL = data.url + urlSeparator + params + '&scrollActivationWidth=false&controls=false' + hash;

					currentSlide = document.createElement( 'iframe' );
					currentSlide.setAttribute( 'width', 1280 );
					currentSlide.setAttribute( 'height', 1024 );
					currentSlide.setAttribute( 'src', currentURL );
					document.querySelector( '#current-slide' ).appendChild( currentSlide );

					upcomingSlide = document.createElement( 'iframe' );
					upcomingSlide.setAttribute( 'width', 640 );
					upcomingSlide.setAttribute( 'height', 512 );
					upcomingSlide.setAttribute( 'src', upcomingURL );
					document.querySelector( '#upcoming-slide' ).appendChild( upcomingSlide );

				}

				/**
				 * Setup the notes UI.
				 */
				function setupNotes() {

					notes = document.querySelector( '.speaker-controls-notes' );
					notesValue = document.querySelector( '.speaker-controls-notes .value' );

				}

				/**
				 * We send out a heartbeat at all times to ensure we can
				 * reconnect with the main presentation window after reloads.
				 */
				function setupHeartbeat() {

					setInterval( () => {
						window.opener.postMessage( JSON.stringify({ namespace: 'reveal-notes', type: 'heartbeat'} ), '*' );
					}, 1000 );

				}

				function getTimings( callback ) {

					callRevealApi( 'getSlidesAttributes', [], function ( slideAttributes ) {
						callRevealApi( 'getConfig', [], function ( config ) {
							var totalTime = config.totalTime;
							var minTimePerSlide = config.minimumTimePerSlide || 0;
							var defaultTiming = config.defaultTiming;
							if ((defaultTiming == null) && (totalTime == null)) {
								callback(null);
								return;
							}
							// Setting totalTime overrides defaultTiming
							if (totalTime) {
								defaultTiming = 0;
							}
							var timings = [];
							for ( var i in slideAttributes ) {
								var slide = slideAttributes[ i ];
								var timing = defaultTiming;
								if( slide.hasOwnProperty( 'data-timing' )) {
									var t = slide[ 'data-timing' ];
									timing = parseInt(t);
									if( isNaN(timing) ) {
										console.warn("Could not parse timing '" + t + "' of slide " + i + "; using default of " + defaultTiming);
										timing = defaultTiming;
									}
								}
								timings.push(timing);
							}
							if ( totalTime ) {
								// After we've allocated time to individual slides, we summarize it and
								// subtract it from the total time
								var remainingTime = totalTime - timings.reduce( function(a, b) { return a + b; }, 0 );
								// The remaining time is divided by the number of slides that have 0 seconds
								// allocated at the moment, giving the average time-per-slide on the remaining slides
								var remainingSlides = (timings.filter( function(x) { return x == 0 }) ).length
								var timePerSlide = Math.round( remainingTime / remainingSlides, 0 )
								// And now we replace every zero-value timing with that average
								timings = timings.map( function(x) { return (x==0 ? timePerSlide : x) } );
							}
							var slidesUnderMinimum = timings.filter( function(x) { return (x < minTimePerSlide) } ).length
							if ( slidesUnderMinimum ) {
								message = "The pacing time for " + slidesUnderMinimum + " slide(s) is under the configured minimum of " + minTimePerSlide + " seconds. Check the data-timing attribute on individual slides, or consider increasing the totalTime or minimumTimePerSlide configuration options (or removing some slides).";
								alert(message);
							}
							callback( timings );
						} );
					} );

				}

				/**
				 * Return the number of seconds allocated for presenting
				 * all slides up to and including this one.
				 */
				function getTimeAllocated( timings, callback ) {

					callRevealApi( 'getSlidePastCount', [], function ( currentSlide ) {
						var allocated = 0;
						for (var i in timings.slice(0, currentSlide + 1)) {
							allocated += timings[i];
						}
						callback( allocated );
					} );

				}

				/**
				 * Create the timer and clock and start updating them
				 * at an interval.
				 */
				function setupTimer() {

					var start = new Date(),
					timeEl = document.querySelector( '.speaker-controls-time' ),
					clockEl = timeEl.querySelector( '.clock-value' ),
					hoursEl = timeEl.querySelector( '.hours-value' ),
					minutesEl = timeEl.querySelector( '.minutes-value' ),
					secondsEl = timeEl.querySelector( '.seconds-value' ),
					pacingTitleEl = timeEl.querySelector( '.pacing-title' ),
					pacingEl = timeEl.querySelector( '.pacing' ),
					pacingHoursEl = pacingEl.querySelector( '.hours-value' ),
					pacingMinutesEl = pacingEl.querySelector( '.minutes-value' ),
					pacingSecondsEl = pacingEl.querySelector( '.seconds-value' );

					var timings = null;
					getTimings( function ( _timings ) {

						timings = _timings;
						if (_timings !== null) {
							pacingTitleEl.style.removeProperty('display');
							pacingEl.style.removeProperty('display');
						}

						// Update once directly
						_updateTimer();

						// Then update every second
						setInterval( _updateTimer, 1000 );

					} );


					function _resetTimer() {

						if (timings == null) {
							start = new Date();
							_updateTimer();
						}
						else {
							// Reset timer to beginning of current slide
							getTimeAllocated( timings, function ( slideEndTimingSeconds ) {
								var slideEndTiming = slideEndTimingSeconds * 1000;
								callRevealApi( 'getSlidePastCount', [], function ( currentSlide ) {
									var currentSlideTiming = timings[currentSlide] * 1000;
									var previousSlidesTiming = slideEndTiming - currentSlideTiming;
									var now = new Date();
									start = new Date(now.getTime() - previousSlidesTiming);
									_updateTimer();
								} );
							} );
						}

					}

					timeEl.addEventListener( 'click', function() {
						_resetTimer();
						return false;
					} );

					function _displayTime( hrEl, minEl, secEl, time) {

						var sign = Math.sign(time) == -1 ? "-" : "";
						time = Math.abs(Math.round(time / 1000));
						var seconds = time % 60;
						var minutes = Math.floor( time / 60 ) % 60 ;
						var hours = Math.floor( time / ( 60 * 60 )) ;
						hrEl.innerHTML = sign + zeroPadInteger( hours );
						if (hours == 0) {
							hrEl.classList.add( 'mute' );
						}
						else {
							hrEl.classList.remove( 'mute' );
						}
						minEl.innerHTML = ':' + zeroPadInteger( minutes );
						if (hours == 0 && minutes == 0) {
							minEl.classList.add( 'mute' );
						}
						else {
							minEl.classList.remove( 'mute' );
						}
						secEl.innerHTML = ':' + zeroPadInteger( seconds );
					}

					function _updateTimer() {

						var diff, hours, minutes, seconds,
						now = new Date();

						diff = now.getTime() - start.getTime();

						clockEl.innerHTML = now.toLocaleTimeString( 'en-US', { hour12: true, hour: '2-digit', minute:'2-digit' } );
						_displayTime( hoursEl, minutesEl, secondsEl, diff );
						if (timings !== null) {
							_updatePacing(diff);
						}

					}

					function _updatePacing(diff) {

						getTimeAllocated( timings, function ( slideEndTimingSeconds ) {
							var slideEndTiming = slideEndTimingSeconds * 1000;

							callRevealApi( 'getSlidePastCount', [], function ( currentSlide ) {
								var currentSlideTiming = timings[currentSlide] * 1000;
								var timeLeftCurrentSlide = slideEndTiming - diff;
								if (timeLeftCurrentSlide < 0) {
									pacingEl.className = 'pacing behind';
								}
								else if (timeLeftCurrentSlide < currentSlideTiming) {
									pacingEl.className = 'pacing on-track';
								}
								else {
									pacingEl.className = 'pacing ahead';
								}
								_displayTime( pacingHoursEl, pacingMinutesEl, pacingSecondsEl, timeLeftCurrentSlide );
							} );
						} );
					}

				}

				/**
				 * Sets up the speaker view layout and layout selector.
				 */
				function setupLayout() {

					layoutDropdown = document.querySelector( '.speaker-layout-dropdown' );
					layoutLabel = document.querySelector( '.speaker-layout-label' );

					// Render the list of available layouts
					for( var id in SPEAKER_LAYOUTS ) {
						var option = document.createElement( 'option' );
						option.setAttribute( 'value', id );
						option.textContent = SPEAKER_LAYOUTS[ id ];
						layoutDropdown.appendChild( option );
					}

					// Monitor the dropdown for changes
					layoutDropdown.addEventListener( 'change', function( event ) {

						setLayout( layoutDropdown.value );

					}, false );

					// Restore any currently persisted layout
					setLayout( getLayout() );

				}

				/**
				 * Sets a new speaker view layout. The layout is persisted
				 * in local storage.
				 */
				function setLayout( value ) {

					var title = SPEAKER_LAYOUTS[ value ];

					layoutLabel.innerHTML = 'Layout' + ( title ? ( ': ' + title ) : '' );
					layoutDropdown.value = value;

					document.body.setAttribute( 'data-speaker-layout', value );

					// Persist locally
					if( supportsLocalStorage() ) {
						window.localStorage.setItem( 'reveal-speaker-layout', value );
					}

				}

				/**
				 * Returns the ID of the most recently set speaker layout
				 * or our default layout if none has been set.
				 */
				function getLayout() {

					if( supportsLocalStorage() ) {
						var layout = window.localStorage.getItem( 'reveal-speaker-layout' );
						if( layout ) {
							return layout;
						}
					}

					// Default to the first record in the layouts hash
					for( var id in SPEAKER_LAYOUTS ) {
						return id;
					}

				}

				function supportsLocalStorage() {

					try {
						localStorage.setItem('test', 'test');
						localStorage.removeItem('test');
						return true;
					}
					catch( e ) {
						return false;
					}

				}

				function zeroPadInteger( num ) {

					var str = '00' + parseInt( num );
					return str.substring( str.length - 2 );

				}

				/**
				 * Limits the frequency at which a function can be called.
				 */
				function debounce( fn, ms ) {

					var lastTime = 0,
						timeout;

					return function() {

						var args = arguments;
						var context = this;

						clearTimeout( timeout );

						var timeSinceLastCall = Date.now() - lastTime;
						if( timeSinceLastCall > ms ) {
							fn.apply( context, args );
							lastTime = Date.now();
						}
						else {
							timeout = setTimeout( function() {
								fn.apply( context, args );
								lastTime = Date.now();
							}, ms - timeSinceLastCall );
						}

					}

				}

			})();

		</script>
	</body>
</html>`;
    function t() {
        return {
            async: !1,
            breaks: !1,
            extensions: null,
            gfm: !0,
            hooks: null,
            pedantic: !1,
            renderer: null,
            silent: !1,
            tokenizer: null,
            walkTokens: null
        };
    }
    var n = t();
    function r(e) {
        n = e;
    }
    var i = {
        exec: ()=>null
    };
    function a(e, t = ``) {
        let n = typeof e == `string` ? e : e.source, r = {
            replace: (e, t)=>{
                let i = typeof t == `string` ? t : t.source;
                return i = i.replace(s.caret, `$1`), n = n.replace(e, i), r;
            },
            getRegex: ()=>new RegExp(n, t)
        };
        return r;
    }
    var o = (()=>{
        try {
            return !0;
        } catch  {
            return !1;
        }
    })(), s = {
        codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
        outputLinkReplace: /\\([\[\]])/g,
        indentCodeCompensation: /^(\s+)(?:```)/,
        beginningSpace: /^\s+/,
        endingHash: /#$/,
        startingSpaceChar: /^ /,
        endingSpaceChar: / $/,
        nonSpaceChar: /[^ ]/,
        newLineCharGlobal: /\n/g,
        tabCharGlobal: /\t/g,
        multipleSpaceGlobal: /\s+/g,
        blankLine: /^[ \t]*$/,
        doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
        blockquoteStart: /^ {0,3}>/,
        blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
        blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
        listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
        listIsTask: /^\[[ xX]\] +\S/,
        listReplaceTask: /^\[[ xX]\] +/,
        listTaskCheckbox: /\[[ xX]\]/,
        anyLine: /\n.*\n/,
        hrefBrackets: /^<(.*)>$/,
        tableDelimiter: /[:|]/,
        tableAlignChars: /^\||\| *$/g,
        tableRowBlankLine: /\n[ \t]*$/,
        tableAlignRight: /^ *-+: *$/,
        tableAlignCenter: /^ *:-+: *$/,
        tableAlignLeft: /^ *:-+ *$/,
        startATag: /^<a /i,
        endATag: /^<\/a>/i,
        startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
        endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
        startAngleBracket: /^</,
        endAngleBracket: />$/,
        pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
        unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
        escapeTest: /[&<>"']/,
        escapeReplace: /[&<>"']/g,
        escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
        escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
        caret: /(^|[^\[])\^/g,
        percentDecode: /%25/g,
        findPipe: /\|/g,
        splitPipe: / \|/,
        slashPipe: /\\\|/g,
        carriageReturn: /\r\n|\r/g,
        spaceLine: /^ +$/gm,
        notSpaceStart: /^\S*/,
        endingNewline: /\n$/,
        listItemRegex: (e)=>RegExp(`^( {0,3}${e})((?:[	 ][^\\n]*)?(?:\\n|$))`),
        nextBulletRegex: (e)=>RegExp(`^ {0,${Math.min(3, e - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`),
        hrRegex: (e)=>RegExp(`^ {0,${Math.min(3, e - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
        fencesBeginRegex: (e)=>RegExp(`^ {0,${Math.min(3, e - 1)}}(?:\`\`\`|~~~)`),
        headingBeginRegex: (e)=>RegExp(`^ {0,${Math.min(3, e - 1)}}#`),
        htmlBeginRegex: (e)=>RegExp(`^ {0,${Math.min(3, e - 1)}}<(?:[a-z].*>|!--)`, `i`),
        blockquoteBeginRegex: (e)=>RegExp(`^ {0,${Math.min(3, e - 1)}}>`)
    }, c = /^(?:[ \t]*(?:\n|$))+/, l = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/, u = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, d = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, f = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, p = / {0,3}(?:[*+-]|\d{1,9}[.)])/, m = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/, h = a(m).replace(/bull/g, p).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, ``).getRegex(), ee = a(m).replace(/bull/g, p).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex(), g = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, te = /^[^\n]+/, _ = /(?!\s*\])(?:\\[\s\S]|[^\[\]\\])+/, ne = a(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace(`label`, _).replace(`title`, /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), re = a(/^(bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, p).getRegex(), v = `address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul`, y = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, ie = a(`^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))`, `i`).replace(`comment`, y).replace(`tag`, v).replace(`attribute`, / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), b = a(g).replace(`hr`, d).replace(`heading`, ` {0,3}#{1,6}(?:\\s|$)`).replace(`|lheading`, ``).replace(`|table`, ``).replace(`blockquote`, ` {0,3}>`).replace(`fences`, " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace(`list`, ` {0,3}(?:[*+-]|1[.)])[ \\t]`).replace(`html`, `</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)`).replace(`tag`, v).getRegex(), x = {
        blockquote: a(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace(`paragraph`, b).getRegex(),
        code: l,
        def: ne,
        fences: u,
        heading: f,
        hr: d,
        html: ie,
        lheading: h,
        list: re,
        newline: c,
        paragraph: b,
        table: i,
        text: te
    }, S = a(`^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)`).replace(`hr`, d).replace(`heading`, ` {0,3}#{1,6}(?:\\s|$)`).replace(`blockquote`, ` {0,3}>`).replace(`code`, `(?: {4}| {0,3}	)[^\\n]`).replace(`fences`, " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace(`list`, ` {0,3}(?:[*+-]|1[.)])[ \\t]`).replace(`html`, `</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)`).replace(`tag`, v).getRegex(), ae = {
        ...x,
        lheading: ee,
        table: S,
        paragraph: a(g).replace(`hr`, d).replace(`heading`, ` {0,3}#{1,6}(?:\\s|$)`).replace(`|lheading`, ``).replace(`table`, S).replace(`blockquote`, ` {0,3}>`).replace(`fences`, " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace(`list`, ` {0,3}(?:[*+-]|1[.)])[ \\t]`).replace(`html`, `</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)`).replace(`tag`, v).getRegex()
    }, oe = {
        ...x,
        html: a(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace(`comment`, y).replace(/tag/g, `(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b`).getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: i,
        lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        paragraph: a(g).replace(`hr`, d).replace(`heading`, ` *#{1,6} *[^
]`).replace(`lheading`, h).replace(`|table`, ``).replace(`blockquote`, ` {0,3}>`).replace(`|fences`, ``).replace(`|list`, ``).replace(`|html`, ``).replace(`|tag`, ``).getRegex()
    }, se = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, ce = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, C = /^( {2,}|\\)\n(?!\s*$)/, le = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, w = /[\p{P}\p{S}]/u, T = /[\s\p{P}\p{S}]/u, E = /[^\s\p{P}\p{S}]/u, ue = a(/^((?![*_])punctSpace)/, `u`).replace(/punctSpace/g, T).getRegex(), D = /(?!~)[\p{P}\p{S}]/u, de = /(?!~)[\s\p{P}\p{S}]/u, fe = /(?:[^\s\p{P}\p{S}]|~)/u, pe = a(/link|precode-code|html/, `g`).replace(`link`, /\[(?:[^\[\]`]|(?<a>`+)[^`]+\k<a>(?!`))*?\]\((?:\\[\s\S]|[^\\\(\)]|\((?:\\[\s\S]|[^\\\(\)])*\))*\)/).replace(`precode-`, o ? "(?<!`)()" : "(^^|[^`])").replace(`code`, /(?<b>`+)[^`]+\k<b>(?!`)/).replace(`html`, /<(?! )[^<>]*?>/).getRegex(), O = /^(?:\*+(?:((?!\*)punct)|([^\s*]))?)|^_+(?:((?!_)punct)|([^\s_]))?/, me = a(O, `u`).replace(/punct/g, w).getRegex(), he = a(O, `u`).replace(/punct/g, D).getRegex(), k = `^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)`, ge = a(k, `gu`).replace(/notPunctSpace/g, E).replace(/punctSpace/g, T).replace(/punct/g, w).getRegex(), A = a(k, `gu`).replace(/notPunctSpace/g, fe).replace(/punctSpace/g, de).replace(/punct/g, D).getRegex(), _e = a(`^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)`, `gu`).replace(/notPunctSpace/g, E).replace(/punctSpace/g, T).replace(/punct/g, w).getRegex(), ve = a(/^~~?(?:((?!~)punct)|[^\s~])/, `u`).replace(/punct/g, w).getRegex(), ye = a(`^[^~]+(?=[^~])|(?!~)punct(~~?)(?=[\\s]|$)|notPunctSpace(~~?)(?!~)(?=punctSpace|$)|(?!~)punctSpace(~~?)(?=notPunctSpace)|[\\s](~~?)(?!~)(?=punct)|(?!~)punct(~~?)(?!~)(?=punct)|notPunctSpace(~~?)(?=notPunctSpace)`, `gu`).replace(/notPunctSpace/g, E).replace(/punctSpace/g, T).replace(/punct/g, w).getRegex(), be = a(/\\(punct)/, `gu`).replace(/punct/g, w).getRegex(), xe = a(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace(`scheme`, /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace(`email`, /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), j = a(y).replace(`(?:-->|$)`, `-->`).getRegex(), Se = a(`^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>`).replace(`comment`, j).replace(`attribute`, /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), M = /(?:\[(?:\\[\s\S]|[^\[\]\\])*\]|\\[\s\S]|`+(?!`)[^`]*?`+(?!`)|``+(?=\])|[^\[\]\\`])*?/, Ce = a(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]+(?:\n[ \t]*)?|\n[ \t]*)(title))?\s*\)/).replace(`label`, M).replace(`href`, /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace(`title`, /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), N = a(/^!?\[(label)\]\[(ref)\]/).replace(`label`, M).replace(`ref`, _).getRegex(), P = a(/^!?\[(ref)\](?:\[\])?/).replace(`ref`, _).getRegex(), we = a(`reflink|nolink(?!\\()`, `g`).replace(`reflink`, N).replace(`nolink`, P).getRegex(), F = /[hH][tT][tT][pP][sS]?|[fF][tT][pP]/, I = {
        _backpedal: i,
        anyPunctuation: be,
        autolink: xe,
        blockSkip: pe,
        br: C,
        code: ce,
        del: i,
        delLDelim: i,
        delRDelim: i,
        emStrongLDelim: me,
        emStrongRDelimAst: ge,
        emStrongRDelimUnd: _e,
        escape: se,
        link: Ce,
        nolink: P,
        punctuation: ue,
        reflink: N,
        reflinkSearch: we,
        tag: Se,
        text: le,
        url: i
    }, Te = {
        ...I,
        link: a(/^!?\[(label)\]\((.*?)\)/).replace(`label`, M).getRegex(),
        reflink: a(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace(`label`, M).getRegex()
    }, L = {
        ...I,
        emStrongRDelimAst: A,
        emStrongLDelim: he,
        delLDelim: ve,
        delRDelim: ye,
        url: a(/^((?:protocol):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/).replace(`protocol`, F).replace(`email`, /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
        _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])((?:\\[\s\S]|[^\\])*?(?:\\[\s\S]|[^\s~\\]))\1(?=[^~]|$)/,
        text: a(/^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|protocol:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/).replace(`protocol`, F).getRegex()
    }, Ee = {
        ...L,
        br: a(C).replace(`{2,}`, `*`).getRegex(),
        text: a(L.text).replace(`\\b_`, `\\b_| {2,}\\n`).replace(/\{2,\}/g, `*`).getRegex()
    }, R = {
        normal: x,
        gfm: ae,
        pedantic: oe
    }, z = {
        normal: I,
        gfm: L,
        breaks: Ee,
        pedantic: Te
    }, De = {
        "&": `&amp;`,
        "<": `&lt;`,
        ">": `&gt;`,
        '"': `&quot;`,
        "'": `&#39;`
    }, B = (e)=>De[e];
    function V(e, t) {
        if (t) {
            if (s.escapeTest.test(e)) return e.replace(s.escapeReplace, B);
        } else if (s.escapeTestNoEncode.test(e)) return e.replace(s.escapeReplaceNoEncode, B);
        return e;
    }
    function H(e) {
        try {
            e = encodeURI(e).replace(s.percentDecode, `%`);
        } catch  {
            return null;
        }
        return e;
    }
    function U(e, t) {
        let n = e.replace(s.findPipe, (e, t, n)=>{
            let r = !1, i = t;
            for(; --i >= 0 && n[i] === `\\`;)r = !r;
            return r ? `|` : ` |`;
        }).split(s.splitPipe), r = 0;
        if (n[0].trim() || n.shift(), n.length > 0 && !n.at(-1)?.trim() && n.pop(), t) {
            if (n.length > t) n.splice(t);
            else for(; n.length < t;)n.push(``);
        }
        for(; r < n.length; r++)n[r] = n[r].trim().replace(s.slashPipe, `|`);
        return n;
    }
    function W(e, t, n) {
        let r = e.length;
        if (r === 0) return ``;
        let i = 0;
        for(; i < r;){
            let a = e.charAt(r - i - 1);
            if (a === t && !n) i++;
            else if (a !== t && n) i++;
            else break;
        }
        return e.slice(0, r - i);
    }
    function Oe(e, t) {
        if (e.indexOf(t[1]) === -1) return -1;
        let n = 0;
        for(let r = 0; r < e.length; r++)if (e[r] === `\\`) r++;
        else if (e[r] === t[0]) n++;
        else if (e[r] === t[1] && (n--, n < 0)) return r;
        return n > 0 ? -2 : -1;
    }
    function ke(e, t = 0) {
        let n = t, r = ``;
        for (let t of e)if (t === `	`) {
            let e = 4 - n % 4;
            r += ` `.repeat(e), n += e;
        } else r += t, n++;
        return r;
    }
    function G(e, t, n, r, i) {
        let a = t.href, o = t.title || null, s = e[1].replace(i.other.outputLinkReplace, `$1`);
        r.state.inLink = !0;
        let c = {
            type: e[0].charAt(0) === `!` ? `image` : `link`,
            raw: n,
            href: a,
            title: o,
            text: s,
            tokens: r.inlineTokens(s)
        };
        return r.state.inLink = !1, c;
    }
    function Ae(e, t, n) {
        let r = e.match(n.other.indentCodeCompensation);
        if (r === null) return t;
        let i = r[1];
        return t.split(`
`).map((e)=>{
            let t = e.match(n.other.beginningSpace);
            if (t === null) return e;
            let [r] = t;
            return r.length >= i.length ? e.slice(i.length) : e;
        }).join(`
`);
    }
    var K = class {
        options;
        rules;
        lexer;
        constructor(e){
            this.options = e || n;
        }
        space(e) {
            let t = this.rules.block.newline.exec(e);
            if (t && t[0].length > 0) return {
                type: `space`,
                raw: t[0]
            };
        }
        code(e) {
            let t = this.rules.block.code.exec(e);
            if (t) {
                let e = t[0].replace(this.rules.other.codeRemoveIndent, ``);
                return {
                    type: `code`,
                    raw: t[0],
                    codeBlockStyle: `indented`,
                    text: this.options.pedantic ? e : W(e, `
`)
                };
            }
        }
        fences(e) {
            let t = this.rules.block.fences.exec(e);
            if (t) {
                let e = t[0], n = Ae(e, t[3] || ``, this.rules);
                return {
                    type: `code`,
                    raw: e,
                    lang: t[2] ? t[2].trim().replace(this.rules.inline.anyPunctuation, `$1`) : t[2],
                    text: n
                };
            }
        }
        heading(e) {
            let t = this.rules.block.heading.exec(e);
            if (t) {
                let e = t[2].trim();
                if (this.rules.other.endingHash.test(e)) {
                    let t = W(e, `#`);
                    (this.options.pedantic || !t || this.rules.other.endingSpaceChar.test(t)) && (e = t.trim());
                }
                return {
                    type: `heading`,
                    raw: t[0],
                    depth: t[1].length,
                    text: e,
                    tokens: this.lexer.inline(e)
                };
            }
        }
        hr(e) {
            let t = this.rules.block.hr.exec(e);
            if (t) return {
                type: `hr`,
                raw: W(t[0], `
`)
            };
        }
        blockquote(e) {
            let t = this.rules.block.blockquote.exec(e);
            if (t) {
                let e = W(t[0], `
`).split(`
`), n = ``, r = ``, i = [];
                for(; e.length > 0;){
                    let t = !1, a = [], o;
                    for(o = 0; o < e.length; o++)if (this.rules.other.blockquoteStart.test(e[o])) a.push(e[o]), t = !0;
                    else if (!t) a.push(e[o]);
                    else break;
                    e = e.slice(o);
                    let s = a.join(`
`), c = s.replace(this.rules.other.blockquoteSetextReplace, `
    $1`).replace(this.rules.other.blockquoteSetextReplace2, ``);
                    n = n ? `${n}
${s}` : s, r = r ? `${r}
${c}` : c;
                    let l = this.lexer.state.top;
                    if (this.lexer.state.top = !0, this.lexer.blockTokens(c, i, !0), this.lexer.state.top = l, e.length === 0) break;
                    let u = i.at(-1);
                    if (u?.type === `code`) break;
                    if (u?.type === `blockquote`) {
                        let t = u, a = t.raw + `
` + e.join(`
`), o = this.blockquote(a);
                        i[i.length - 1] = o, n = n.substring(0, n.length - t.raw.length) + o.raw, r = r.substring(0, r.length - t.text.length) + o.text;
                        break;
                    } else if (u?.type === `list`) {
                        let t = u, a = t.raw + `
` + e.join(`
`), o = this.list(a);
                        i[i.length - 1] = o, n = n.substring(0, n.length - u.raw.length) + o.raw, r = r.substring(0, r.length - t.raw.length) + o.raw, e = a.substring(i.at(-1).raw.length).split(`
`);
                        continue;
                    }
                }
                return {
                    type: `blockquote`,
                    raw: n,
                    tokens: i,
                    text: r
                };
            }
        }
        list(e) {
            let t = this.rules.block.list.exec(e);
            if (t) {
                let n = t[1].trim(), r = n.length > 1, i = {
                    type: `list`,
                    raw: ``,
                    ordered: r,
                    start: r ? +n.slice(0, -1) : ``,
                    loose: !1,
                    items: []
                };
                n = r ? `\\d{1,9}\\${n.slice(-1)}` : `\\${n}`, this.options.pedantic && (n = r ? n : `[*+-]`);
                let a = this.rules.other.listItemRegex(n), o = !1;
                for(; e;){
                    let n = !1, r = ``, s = ``;
                    if (!(t = a.exec(e)) || this.rules.block.hr.test(e)) break;
                    r = t[0], e = e.substring(r.length);
                    let c = ke(t[2].split(`
`, 1)[0], t[1].length), l = e.split(`
`, 1)[0], u = !c.trim(), d = 0;
                    if (this.options.pedantic ? (d = 2, s = c.trimStart()) : u ? d = t[1].length + 1 : (d = c.search(this.rules.other.nonSpaceChar), d = d > 4 ? 1 : d, s = c.slice(d), d += t[1].length), u && this.rules.other.blankLine.test(l) && (r += l + `
`, e = e.substring(l.length + 1), n = !0), !n) {
                        let t = this.rules.other.nextBulletRegex(d), n = this.rules.other.hrRegex(d), i = this.rules.other.fencesBeginRegex(d), a = this.rules.other.headingBeginRegex(d), o = this.rules.other.htmlBeginRegex(d), f = this.rules.other.blockquoteBeginRegex(d);
                        for(; e;){
                            let p = e.split(`
`, 1)[0], m;
                            if (l = p, this.options.pedantic ? (l = l.replace(this.rules.other.listReplaceNesting, `  `), m = l) : m = l.replace(this.rules.other.tabCharGlobal, `    `), i.test(l) || a.test(l) || o.test(l) || f.test(l) || t.test(l) || n.test(l)) break;
                            if (m.search(this.rules.other.nonSpaceChar) >= d || !l.trim()) s += `
` + m.slice(d);
                            else {
                                if (u || c.replace(this.rules.other.tabCharGlobal, `    `).search(this.rules.other.nonSpaceChar) >= 4 || i.test(c) || a.test(c) || n.test(c)) break;
                                s += `
` + l;
                            }
                            u = !l.trim(), r += p + `
`, e = e.substring(p.length + 1), c = m.slice(d);
                        }
                    }
                    i.loose || (o ? i.loose = !0 : this.rules.other.doubleBlankLine.test(r) && (o = !0)), i.items.push({
                        type: `list_item`,
                        raw: r,
                        task: !!this.options.gfm && this.rules.other.listIsTask.test(s),
                        loose: !1,
                        text: s,
                        tokens: []
                    }), i.raw += r;
                }
                let s = i.items.at(-1);
                if (s) s.raw = s.raw.trimEnd(), s.text = s.text.trimEnd();
                else return;
                i.raw = i.raw.trimEnd();
                for (let e of i.items){
                    if (this.lexer.state.top = !1, e.tokens = this.lexer.blockTokens(e.text, []), e.task) {
                        if (e.text = e.text.replace(this.rules.other.listReplaceTask, ``), e.tokens[0]?.type === `text` || e.tokens[0]?.type === `paragraph`) {
                            e.tokens[0].raw = e.tokens[0].raw.replace(this.rules.other.listReplaceTask, ``), e.tokens[0].text = e.tokens[0].text.replace(this.rules.other.listReplaceTask, ``);
                            for(let e = this.lexer.inlineQueue.length - 1; e >= 0; e--)if (this.rules.other.listIsTask.test(this.lexer.inlineQueue[e].src)) {
                                this.lexer.inlineQueue[e].src = this.lexer.inlineQueue[e].src.replace(this.rules.other.listReplaceTask, ``);
                                break;
                            }
                        }
                        let t = this.rules.other.listTaskCheckbox.exec(e.raw);
                        if (t) {
                            let n = {
                                type: `checkbox`,
                                raw: t[0] + ` `,
                                checked: t[0] !== `[ ]`
                            };
                            e.checked = n.checked, i.loose ? e.tokens[0] && [
                                `paragraph`,
                                `text`
                            ].includes(e.tokens[0].type) && `tokens` in e.tokens[0] && e.tokens[0].tokens ? (e.tokens[0].raw = n.raw + e.tokens[0].raw, e.tokens[0].text = n.raw + e.tokens[0].text, e.tokens[0].tokens.unshift(n)) : e.tokens.unshift({
                                type: `paragraph`,
                                raw: n.raw,
                                text: n.raw,
                                tokens: [
                                    n
                                ]
                            }) : e.tokens.unshift(n);
                        }
                    }
                    if (!i.loose) {
                        let t = e.tokens.filter((e)=>e.type === `space`);
                        i.loose = t.length > 0 && t.some((e)=>this.rules.other.anyLine.test(e.raw));
                    }
                }
                if (i.loose) for (let e of i.items){
                    e.loose = !0;
                    for (let t of e.tokens)t.type === `text` && (t.type = `paragraph`);
                }
                return i;
            }
        }
        html(e) {
            let t = this.rules.block.html.exec(e);
            if (t) return {
                type: `html`,
                block: !0,
                raw: t[0],
                pre: t[1] === `pre` || t[1] === `script` || t[1] === `style`,
                text: t[0]
            };
        }
        def(e) {
            let t = this.rules.block.def.exec(e);
            if (t) {
                let e = t[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, ` `), n = t[2] ? t[2].replace(this.rules.other.hrefBrackets, `$1`).replace(this.rules.inline.anyPunctuation, `$1`) : ``, r = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline.anyPunctuation, `$1`) : t[3];
                return {
                    type: `def`,
                    tag: e,
                    raw: t[0],
                    href: n,
                    title: r
                };
            }
        }
        table(e) {
            let t = this.rules.block.table.exec(e);
            if (!t || !this.rules.other.tableDelimiter.test(t[2])) return;
            let n = U(t[1]), r = t[2].replace(this.rules.other.tableAlignChars, ``).split(`|`), i = t[3]?.trim() ? t[3].replace(this.rules.other.tableRowBlankLine, ``).split(`
`) : [], a = {
                type: `table`,
                raw: t[0],
                header: [],
                align: [],
                rows: []
            };
            if (n.length === r.length) {
                for (let e of r)this.rules.other.tableAlignRight.test(e) ? a.align.push(`right`) : this.rules.other.tableAlignCenter.test(e) ? a.align.push(`center`) : this.rules.other.tableAlignLeft.test(e) ? a.align.push(`left`) : a.align.push(null);
                for(let e = 0; e < n.length; e++)a.header.push({
                    text: n[e],
                    tokens: this.lexer.inline(n[e]),
                    header: !0,
                    align: a.align[e]
                });
                for (let e of i)a.rows.push(U(e, a.header.length).map((e, t)=>({
                        text: e,
                        tokens: this.lexer.inline(e),
                        header: !1,
                        align: a.align[t]
                    })));
                return a;
            }
        }
        lheading(e) {
            let t = this.rules.block.lheading.exec(e);
            if (t) {
                let e = t[1].trim();
                return {
                    type: `heading`,
                    raw: t[0],
                    depth: t[2].charAt(0) === `=` ? 1 : 2,
                    text: e,
                    tokens: this.lexer.inline(e)
                };
            }
        }
        paragraph(e) {
            let t = this.rules.block.paragraph.exec(e);
            if (t) {
                let e = t[1].charAt(t[1].length - 1) === `
` ? t[1].slice(0, -1) : t[1];
                return {
                    type: `paragraph`,
                    raw: t[0],
                    text: e,
                    tokens: this.lexer.inline(e)
                };
            }
        }
        text(e) {
            let t = this.rules.block.text.exec(e);
            if (t) return {
                type: `text`,
                raw: t[0],
                text: t[0],
                tokens: this.lexer.inline(t[0])
            };
        }
        escape(e) {
            let t = this.rules.inline.escape.exec(e);
            if (t) return {
                type: `escape`,
                raw: t[0],
                text: t[1]
            };
        }
        tag(e) {
            let t = this.rules.inline.tag.exec(e);
            if (t) return !this.lexer.state.inLink && this.rules.other.startATag.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && this.rules.other.endATag.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
                type: `html`,
                raw: t[0],
                inLink: this.lexer.state.inLink,
                inRawBlock: this.lexer.state.inRawBlock,
                block: !1,
                text: t[0]
            };
        }
        link(e) {
            let t = this.rules.inline.link.exec(e);
            if (t) {
                let e = t[2].trim();
                if (!this.options.pedantic && this.rules.other.startAngleBracket.test(e)) {
                    if (!this.rules.other.endAngleBracket.test(e)) return;
                    let t = W(e.slice(0, -1), `\\`);
                    if ((e.length - t.length) % 2 == 0) return;
                } else {
                    let e = Oe(t[2], `()`);
                    if (e === -2) return;
                    if (e > -1) {
                        let n = (t[0].indexOf(`!`) === 0 ? 5 : 4) + t[1].length + e;
                        t[2] = t[2].substring(0, e), t[0] = t[0].substring(0, n).trim(), t[3] = ``;
                    }
                }
                let n = t[2], r = ``;
                if (this.options.pedantic) {
                    let e = this.rules.other.pedanticHrefTitle.exec(n);
                    e && (n = e[1], r = e[3]);
                } else r = t[3] ? t[3].slice(1, -1) : ``;
                return n = n.trim(), this.rules.other.startAngleBracket.test(n) && (n = this.options.pedantic && !this.rules.other.endAngleBracket.test(e) ? n.slice(1) : n.slice(1, -1)), G(t, {
                    href: n && n.replace(this.rules.inline.anyPunctuation, `$1`),
                    title: r && r.replace(this.rules.inline.anyPunctuation, `$1`)
                }, t[0], this.lexer, this.rules);
            }
        }
        reflink(e, t) {
            let n;
            if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
                let e = t[(n[2] || n[1]).replace(this.rules.other.multipleSpaceGlobal, ` `).toLowerCase()];
                if (!e) {
                    let e = n[0].charAt(0);
                    return {
                        type: `text`,
                        raw: e,
                        text: e
                    };
                }
                return G(n, e, n[0], this.lexer, this.rules);
            }
        }
        emStrong(e, t, n = ``) {
            let r = this.rules.inline.emStrongLDelim.exec(e);
            if (!(!r || !r[1] && !r[2] && !r[3] && !r[4] || r[4] && n.match(this.rules.other.unicodeAlphaNumeric)) && (!(r[1] || r[3]) || !n || this.rules.inline.punctuation.exec(n))) {
                let n = [
                    ...r[0]
                ].length - 1, i, a, o = n, s = 0, c = r[0][0] === `*` ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
                for(c.lastIndex = 0, t = t.slice(-1 * e.length + n); (r = c.exec(t)) != null;){
                    if (i = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !i) continue;
                    if (a = [
                        ...i
                    ].length, r[3] || r[4]) {
                        o += a;
                        continue;
                    } else if ((r[5] || r[6]) && n % 3 && !((n + a) % 3)) {
                        s += a;
                        continue;
                    }
                    if (o -= a, o > 0) continue;
                    a = Math.min(a, a + o + s);
                    let t = [
                        ...r[0]
                    ][0].length, c = e.slice(0, n + r.index + t + a);
                    if (Math.min(n, a) % 2) {
                        let e = c.slice(1, -1);
                        return {
                            type: `em`,
                            raw: c,
                            text: e,
                            tokens: this.lexer.inlineTokens(e)
                        };
                    }
                    let l = c.slice(2, -2);
                    return {
                        type: `strong`,
                        raw: c,
                        text: l,
                        tokens: this.lexer.inlineTokens(l)
                    };
                }
            }
        }
        codespan(e) {
            let t = this.rules.inline.code.exec(e);
            if (t) {
                let e = t[2].replace(this.rules.other.newLineCharGlobal, ` `), n = this.rules.other.nonSpaceChar.test(e), r = this.rules.other.startingSpaceChar.test(e) && this.rules.other.endingSpaceChar.test(e);
                return n && r && (e = e.substring(1, e.length - 1)), {
                    type: `codespan`,
                    raw: t[0],
                    text: e
                };
            }
        }
        br(e) {
            let t = this.rules.inline.br.exec(e);
            if (t) return {
                type: `br`,
                raw: t[0]
            };
        }
        del(e, t, n = ``) {
            let r = this.rules.inline.delLDelim.exec(e);
            if (r && (!r[1] || !n || this.rules.inline.punctuation.exec(n))) {
                let n = [
                    ...r[0]
                ].length - 1, i, a, o = n, s = this.rules.inline.delRDelim;
                for(s.lastIndex = 0, t = t.slice(-1 * e.length + n); (r = s.exec(t)) != null;){
                    if (i = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !i || (a = [
                        ...i
                    ].length, a !== n)) continue;
                    if (r[3] || r[4]) {
                        o += a;
                        continue;
                    }
                    if (o -= a, o > 0) continue;
                    a = Math.min(a, a + o);
                    let t = [
                        ...r[0]
                    ][0].length, s = e.slice(0, n + r.index + t + a), c = s.slice(n, -n);
                    return {
                        type: `del`,
                        raw: s,
                        text: c,
                        tokens: this.lexer.inlineTokens(c)
                    };
                }
            }
        }
        autolink(e) {
            let t = this.rules.inline.autolink.exec(e);
            if (t) {
                let e, n;
                return t[2] === `@` ? (e = t[1], n = `mailto:` + e) : (e = t[1], n = e), {
                    type: `link`,
                    raw: t[0],
                    text: e,
                    href: n,
                    tokens: [
                        {
                            type: `text`,
                            raw: e,
                            text: e
                        }
                    ]
                };
            }
        }
        url(e) {
            let t;
            if (t = this.rules.inline.url.exec(e)) {
                let e, n;
                if (t[2] === `@`) e = t[0], n = `mailto:` + e;
                else {
                    let r;
                    do r = t[0], t[0] = this.rules.inline._backpedal.exec(t[0])?.[0] ?? ``;
                    while (r !== t[0]);
                    e = t[0], n = t[1] === `www.` ? `http://` + t[0] : t[0];
                }
                return {
                    type: `link`,
                    raw: t[0],
                    text: e,
                    href: n,
                    tokens: [
                        {
                            type: `text`,
                            raw: e,
                            text: e
                        }
                    ]
                };
            }
        }
        inlineText(e) {
            let t = this.rules.inline.text.exec(e);
            if (t) {
                let e = this.lexer.state.inRawBlock;
                return {
                    type: `text`,
                    raw: t[0],
                    text: t[0],
                    escaped: e
                };
            }
        }
    }, q = class e {
        tokens;
        options;
        state;
        inlineQueue;
        tokenizer;
        constructor(e){
            this.tokens = [], this.tokens.links = Object.create(null), this.options = e || n, this.options.tokenizer = this.options.tokenizer || new K, this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
                inLink: !1,
                inRawBlock: !1,
                top: !0
            };
            let t = {
                other: s,
                block: R.normal,
                inline: z.normal
            };
            this.options.pedantic ? (t.block = R.pedantic, t.inline = z.pedantic) : this.options.gfm && (t.block = R.gfm, this.options.breaks ? t.inline = z.breaks : t.inline = z.gfm), this.tokenizer.rules = t;
        }
        static get rules() {
            return {
                block: R,
                inline: z
            };
        }
        static lex(t, n) {
            return new e(n).lex(t);
        }
        static lexInline(t, n) {
            return new e(n).inlineTokens(t);
        }
        lex(e) {
            e = e.replace(s.carriageReturn, `
`), this.blockTokens(e, this.tokens);
            for(let e = 0; e < this.inlineQueue.length; e++){
                let t = this.inlineQueue[e];
                this.inlineTokens(t.src, t.tokens);
            }
            return this.inlineQueue = [], this.tokens;
        }
        blockTokens(e, t = [], n = !1) {
            for(this.tokenizer.lexer = this, this.options.pedantic && (e = e.replace(s.tabCharGlobal, `    `).replace(s.spaceLine, ``)); e;){
                let r;
                if (this.options.extensions?.block?.some((n)=>(r = n.call({
                        lexer: this
                    }, e, t)) ? (e = e.substring(r.raw.length), t.push(r), !0) : !1)) continue;
                if (r = this.tokenizer.space(e)) {
                    e = e.substring(r.raw.length);
                    let n = t.at(-1);
                    r.raw.length === 1 && n !== void 0 ? n.raw += `
` : t.push(r);
                    continue;
                }
                if (r = this.tokenizer.code(e)) {
                    e = e.substring(r.raw.length);
                    let n = t.at(-1);
                    n?.type === `paragraph` || n?.type === `text` ? (n.raw += (n.raw.endsWith(`
`) ? `` : `
`) + r.raw, n.text += `
` + r.text, this.inlineQueue.at(-1).src = n.text) : t.push(r);
                    continue;
                }
                if (r = this.tokenizer.fences(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.heading(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.hr(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.blockquote(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.list(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.html(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.def(e)) {
                    e = e.substring(r.raw.length);
                    let n = t.at(-1);
                    n?.type === `paragraph` || n?.type === `text` ? (n.raw += (n.raw.endsWith(`
`) ? `` : `
`) + r.raw, n.text += `
` + r.raw, this.inlineQueue.at(-1).src = n.text) : this.tokens.links[r.tag] || (this.tokens.links[r.tag] = {
                        href: r.href,
                        title: r.title
                    }, t.push(r));
                    continue;
                }
                if (r = this.tokenizer.table(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.lheading(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                let i = e;
                if (this.options.extensions?.startBlock) {
                    let t = 1 / 0, n = e.slice(1), r;
                    this.options.extensions.startBlock.forEach((e)=>{
                        r = e.call({
                            lexer: this
                        }, n), typeof r == `number` && r >= 0 && (t = Math.min(t, r));
                    }), t < 1 / 0 && t >= 0 && (i = e.substring(0, t + 1));
                }
                if (this.state.top && (r = this.tokenizer.paragraph(i))) {
                    let a = t.at(-1);
                    n && a?.type === `paragraph` ? (a.raw += (a.raw.endsWith(`
`) ? `` : `
`) + r.raw, a.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = a.text) : t.push(r), n = i.length !== e.length, e = e.substring(r.raw.length);
                    continue;
                }
                if (r = this.tokenizer.text(e)) {
                    e = e.substring(r.raw.length);
                    let n = t.at(-1);
                    n?.type === `text` ? (n.raw += (n.raw.endsWith(`
`) ? `` : `
`) + r.raw, n.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = n.text) : t.push(r);
                    continue;
                }
                if (e) {
                    let t = `Infinite loop on byte: ` + e.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(t);
                        break;
                    } else throw Error(t);
                }
            }
            return this.state.top = !0, t;
        }
        inline(e, t = []) {
            return this.inlineQueue.push({
                src: e,
                tokens: t
            }), t;
        }
        inlineTokens(e, t = []) {
            this.tokenizer.lexer = this;
            let n = e, r = null;
            if (this.tokens.links) {
                let e = Object.keys(this.tokens.links);
                if (e.length > 0) for(; (r = this.tokenizer.rules.inline.reflinkSearch.exec(n)) != null;)e.includes(r[0].slice(r[0].lastIndexOf(`[`) + 1, -1)) && (n = n.slice(0, r.index) + `[` + `a`.repeat(r[0].length - 2) + `]` + n.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
            }
            for(; (r = this.tokenizer.rules.inline.anyPunctuation.exec(n)) != null;)n = n.slice(0, r.index) + `++` + n.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
            let i;
            for(; (r = this.tokenizer.rules.inline.blockSkip.exec(n)) != null;)i = r[2] ? r[2].length : 0, n = n.slice(0, r.index + i) + `[` + `a`.repeat(r[0].length - i - 2) + `]` + n.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
            n = this.options.hooks?.emStrongMask?.call({
                lexer: this
            }, n) ?? n;
            let a = !1, o = ``;
            for(; e;){
                a || (o = ``), a = !1;
                let r;
                if (this.options.extensions?.inline?.some((n)=>(r = n.call({
                        lexer: this
                    }, e, t)) ? (e = e.substring(r.raw.length), t.push(r), !0) : !1)) continue;
                if (r = this.tokenizer.escape(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.tag(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.link(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.reflink(e, this.tokens.links)) {
                    e = e.substring(r.raw.length);
                    let n = t.at(-1);
                    r.type === `text` && n?.type === `text` ? (n.raw += r.raw, n.text += r.text) : t.push(r);
                    continue;
                }
                if (r = this.tokenizer.emStrong(e, n, o)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.codespan(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.br(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.del(e, n, o)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.autolink(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (!this.state.inLink && (r = this.tokenizer.url(e))) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                let i = e;
                if (this.options.extensions?.startInline) {
                    let t = 1 / 0, n = e.slice(1), r;
                    this.options.extensions.startInline.forEach((e)=>{
                        r = e.call({
                            lexer: this
                        }, n), typeof r == `number` && r >= 0 && (t = Math.min(t, r));
                    }), t < 1 / 0 && t >= 0 && (i = e.substring(0, t + 1));
                }
                if (r = this.tokenizer.inlineText(i)) {
                    e = e.substring(r.raw.length), r.raw.slice(-1) !== `_` && (o = r.raw.slice(-1)), a = !0;
                    let n = t.at(-1);
                    n?.type === `text` ? (n.raw += r.raw, n.text += r.text) : t.push(r);
                    continue;
                }
                if (e) {
                    let t = `Infinite loop on byte: ` + e.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(t);
                        break;
                    } else throw Error(t);
                }
            }
            return t;
        }
    }, J = class {
        options;
        parser;
        constructor(e){
            this.options = e || n;
        }
        space(e) {
            return ``;
        }
        code({ text: e, lang: t, escaped: n }) {
            let r = (t || ``).match(s.notSpaceStart)?.[0], i = e.replace(s.endingNewline, ``) + `
`;
            return r ? `<pre><code class="language-` + V(r) + `">` + (n ? i : V(i, !0)) + `</code></pre>
` : `<pre><code>` + (n ? i : V(i, !0)) + `</code></pre>
`;
        }
        blockquote({ tokens: e }) {
            return `<blockquote>
${this.parser.parse(e)}</blockquote>
`;
        }
        html({ text: e }) {
            return e;
        }
        def(e) {
            return ``;
        }
        heading({ tokens: e, depth: t }) {
            return `<h${t}>${this.parser.parseInline(e)}</h${t}>
`;
        }
        hr(e) {
            return `<hr>
`;
        }
        list(e) {
            let t = e.ordered, n = e.start, r = ``;
            for(let t = 0; t < e.items.length; t++){
                let n = e.items[t];
                r += this.listitem(n);
            }
            let i = t ? `ol` : `ul`, a = t && n !== 1 ? ` start="` + n + `"` : ``;
            return `<` + i + a + `>
` + r + `</` + i + `>
`;
        }
        listitem(e) {
            return `<li>${this.parser.parse(e.tokens)}</li>
`;
        }
        checkbox({ checked: e }) {
            return `<input ` + (e ? `checked="" ` : ``) + `disabled="" type="checkbox"> `;
        }
        paragraph({ tokens: e }) {
            return `<p>${this.parser.parseInline(e)}</p>
`;
        }
        table(e) {
            let t = ``, n = ``;
            for(let t = 0; t < e.header.length; t++)n += this.tablecell(e.header[t]);
            t += this.tablerow({
                text: n
            });
            let r = ``;
            for(let t = 0; t < e.rows.length; t++){
                let i = e.rows[t];
                n = ``;
                for(let e = 0; e < i.length; e++)n += this.tablecell(i[e]);
                r += this.tablerow({
                    text: n
                });
            }
            return r &&= `<tbody>${r}</tbody>`, `<table>
<thead>
` + t + `</thead>
` + r + `</table>
`;
        }
        tablerow({ text: e }) {
            return `<tr>
${e}</tr>
`;
        }
        tablecell(e) {
            let t = this.parser.parseInline(e.tokens), n = e.header ? `th` : `td`;
            return (e.align ? `<${n} align="${e.align}">` : `<${n}>`) + t + `</${n}>
`;
        }
        strong({ tokens: e }) {
            return `<strong>${this.parser.parseInline(e)}</strong>`;
        }
        em({ tokens: e }) {
            return `<em>${this.parser.parseInline(e)}</em>`;
        }
        codespan({ text: e }) {
            return `<code>${V(e, !0)}</code>`;
        }
        br(e) {
            return `<br>`;
        }
        del({ tokens: e }) {
            return `<del>${this.parser.parseInline(e)}</del>`;
        }
        link({ href: e, title: t, tokens: n }) {
            let r = this.parser.parseInline(n), i = H(e);
            if (i === null) return r;
            e = i;
            let a = `<a href="` + e + `"`;
            return t && (a += ` title="` + V(t) + `"`), a += `>` + r + `</a>`, a;
        }
        image({ href: e, title: t, text: n, tokens: r }) {
            r && (n = this.parser.parseInline(r, this.parser.textRenderer));
            let i = H(e);
            if (i === null) return V(n);
            e = i;
            let a = `<img src="${e}" alt="${V(n)}"`;
            return t && (a += ` title="${V(t)}"`), a += `>`, a;
        }
        text(e) {
            return `tokens` in e && e.tokens ? this.parser.parseInline(e.tokens) : `escaped` in e && e.escaped ? e.text : V(e.text);
        }
    }, Y = class {
        strong({ text: e }) {
            return e;
        }
        em({ text: e }) {
            return e;
        }
        codespan({ text: e }) {
            return e;
        }
        del({ text: e }) {
            return e;
        }
        html({ text: e }) {
            return e;
        }
        text({ text: e }) {
            return e;
        }
        link({ text: e }) {
            return `` + e;
        }
        image({ text: e }) {
            return `` + e;
        }
        br() {
            return ``;
        }
        checkbox({ raw: e }) {
            return e;
        }
    }, X = class e {
        options;
        renderer;
        textRenderer;
        constructor(e){
            this.options = e || n, this.options.renderer = this.options.renderer || new J, this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new Y;
        }
        static parse(t, n) {
            return new e(n).parse(t);
        }
        static parseInline(t, n) {
            return new e(n).parseInline(t);
        }
        parse(e) {
            this.renderer.parser = this;
            let t = ``;
            for(let n = 0; n < e.length; n++){
                let r = e[n];
                if (this.options.extensions?.renderers?.[r.type]) {
                    let e = r, n = this.options.extensions.renderers[e.type].call({
                        parser: this
                    }, e);
                    if (n !== !1 || ![
                        `space`,
                        `hr`,
                        `heading`,
                        `code`,
                        `table`,
                        `blockquote`,
                        `list`,
                        `html`,
                        `def`,
                        `paragraph`,
                        `text`
                    ].includes(e.type)) {
                        t += n || ``;
                        continue;
                    }
                }
                let i = r;
                switch(i.type){
                    case `space`:
                        t += this.renderer.space(i);
                        break;
                    case `hr`:
                        t += this.renderer.hr(i);
                        break;
                    case `heading`:
                        t += this.renderer.heading(i);
                        break;
                    case `code`:
                        t += this.renderer.code(i);
                        break;
                    case `table`:
                        t += this.renderer.table(i);
                        break;
                    case `blockquote`:
                        t += this.renderer.blockquote(i);
                        break;
                    case `list`:
                        t += this.renderer.list(i);
                        break;
                    case `checkbox`:
                        t += this.renderer.checkbox(i);
                        break;
                    case `html`:
                        t += this.renderer.html(i);
                        break;
                    case `def`:
                        t += this.renderer.def(i);
                        break;
                    case `paragraph`:
                        t += this.renderer.paragraph(i);
                        break;
                    case `text`:
                        t += this.renderer.text(i);
                        break;
                    default:
                        {
                            let e = `Token with "` + i.type + `" type was not found.`;
                            if (this.options.silent) return console.error(e), ``;
                            throw Error(e);
                        }
                }
            }
            return t;
        }
        parseInline(e, t = this.renderer) {
            this.renderer.parser = this;
            let n = ``;
            for(let r = 0; r < e.length; r++){
                let i = e[r];
                if (this.options.extensions?.renderers?.[i.type]) {
                    let e = this.options.extensions.renderers[i.type].call({
                        parser: this
                    }, i);
                    if (e !== !1 || ![
                        `escape`,
                        `html`,
                        `link`,
                        `image`,
                        `strong`,
                        `em`,
                        `codespan`,
                        `br`,
                        `del`,
                        `text`
                    ].includes(i.type)) {
                        n += e || ``;
                        continue;
                    }
                }
                let a = i;
                switch(a.type){
                    case `escape`:
                        n += t.text(a);
                        break;
                    case `html`:
                        n += t.html(a);
                        break;
                    case `link`:
                        n += t.link(a);
                        break;
                    case `image`:
                        n += t.image(a);
                        break;
                    case `checkbox`:
                        n += t.checkbox(a);
                        break;
                    case `strong`:
                        n += t.strong(a);
                        break;
                    case `em`:
                        n += t.em(a);
                        break;
                    case `codespan`:
                        n += t.codespan(a);
                        break;
                    case `br`:
                        n += t.br(a);
                        break;
                    case `del`:
                        n += t.del(a);
                        break;
                    case `text`:
                        n += t.text(a);
                        break;
                    default:
                        {
                            let e = `Token with "` + a.type + `" type was not found.`;
                            if (this.options.silent) return console.error(e), ``;
                            throw Error(e);
                        }
                }
            }
            return n;
        }
    }, Z = class {
        options;
        block;
        constructor(e){
            this.options = e || n;
        }
        static passThroughHooks = new Set([
            `preprocess`,
            `postprocess`,
            `processAllTokens`,
            `emStrongMask`
        ]);
        static passThroughHooksRespectAsync = new Set([
            `preprocess`,
            `postprocess`,
            `processAllTokens`
        ]);
        preprocess(e) {
            return e;
        }
        postprocess(e) {
            return e;
        }
        processAllTokens(e) {
            return e;
        }
        emStrongMask(e) {
            return e;
        }
        provideLexer() {
            return this.block ? q.lex : q.lexInline;
        }
        provideParser() {
            return this.block ? X.parse : X.parseInline;
        }
    }, Q = new class {
        defaults = t();
        options = this.setOptions;
        parse = this.parseMarkdown(!0);
        parseInline = this.parseMarkdown(!1);
        Parser = X;
        Renderer = J;
        TextRenderer = Y;
        Lexer = q;
        Tokenizer = K;
        Hooks = Z;
        constructor(...e){
            this.use(...e);
        }
        walkTokens(e, t) {
            let n = [];
            for (let r of e)switch(n = n.concat(t.call(this, r)), r.type){
                case `table`:
                    {
                        let e = r;
                        for (let r of e.header)n = n.concat(this.walkTokens(r.tokens, t));
                        for (let r of e.rows)for (let e of r)n = n.concat(this.walkTokens(e.tokens, t));
                        break;
                    }
                case `list`:
                    {
                        let e = r;
                        n = n.concat(this.walkTokens(e.items, t));
                        break;
                    }
                default:
                    {
                        let e = r;
                        this.defaults.extensions?.childTokens?.[e.type] ? this.defaults.extensions.childTokens[e.type].forEach((r)=>{
                            let i = e[r].flat(1 / 0);
                            n = n.concat(this.walkTokens(i, t));
                        }) : e.tokens && (n = n.concat(this.walkTokens(e.tokens, t)));
                    }
            }
            return n;
        }
        use(...e) {
            let t = this.defaults.extensions || {
                renderers: {},
                childTokens: {}
            };
            return e.forEach((e)=>{
                let n = {
                    ...e
                };
                if (n.async = this.defaults.async || n.async || !1, e.extensions && (e.extensions.forEach((e)=>{
                    if (!e.name) throw Error(`extension name required`);
                    if (`renderer` in e) {
                        let n = t.renderers[e.name];
                        n ? t.renderers[e.name] = function(...t) {
                            let r = e.renderer.apply(this, t);
                            return r === !1 && (r = n.apply(this, t)), r;
                        } : t.renderers[e.name] = e.renderer;
                    }
                    if (`tokenizer` in e) {
                        if (!e.level || e.level !== `block` && e.level !== `inline`) throw Error(`extension level must be 'block' or 'inline'`);
                        let n = t[e.level];
                        n ? n.unshift(e.tokenizer) : t[e.level] = [
                            e.tokenizer
                        ], e.start && (e.level === `block` ? t.startBlock ? t.startBlock.push(e.start) : t.startBlock = [
                            e.start
                        ] : e.level === `inline` && (t.startInline ? t.startInline.push(e.start) : t.startInline = [
                            e.start
                        ]));
                    }
                    `childTokens` in e && e.childTokens && (t.childTokens[e.name] = e.childTokens);
                }), n.extensions = t), e.renderer) {
                    let t = this.defaults.renderer || new J(this.defaults);
                    for(let n in e.renderer){
                        if (!(n in t)) throw Error(`renderer '${n}' does not exist`);
                        if ([
                            `options`,
                            `parser`
                        ].includes(n)) continue;
                        let r = n, i = e.renderer[r], a = t[r];
                        t[r] = (...e)=>{
                            let n = i.apply(t, e);
                            return n === !1 && (n = a.apply(t, e)), n || ``;
                        };
                    }
                    n.renderer = t;
                }
                if (e.tokenizer) {
                    let t = this.defaults.tokenizer || new K(this.defaults);
                    for(let n in e.tokenizer){
                        if (!(n in t)) throw Error(`tokenizer '${n}' does not exist`);
                        if ([
                            `options`,
                            `rules`,
                            `lexer`
                        ].includes(n)) continue;
                        let r = n, i = e.tokenizer[r], a = t[r];
                        t[r] = (...e)=>{
                            let n = i.apply(t, e);
                            return n === !1 && (n = a.apply(t, e)), n;
                        };
                    }
                    n.tokenizer = t;
                }
                if (e.hooks) {
                    let t = this.defaults.hooks || new Z;
                    for(let n in e.hooks){
                        if (!(n in t)) throw Error(`hook '${n}' does not exist`);
                        if ([
                            `options`,
                            `block`
                        ].includes(n)) continue;
                        let r = n, i = e.hooks[r], a = t[r];
                        Z.passThroughHooks.has(n) ? t[r] = (e)=>{
                            if (this.defaults.async && Z.passThroughHooksRespectAsync.has(n)) return (async ()=>{
                                let n = await i.call(t, e);
                                return a.call(t, n);
                            })();
                            let r = i.call(t, e);
                            return a.call(t, r);
                        } : t[r] = (...e)=>{
                            if (this.defaults.async) return (async ()=>{
                                let n = await i.apply(t, e);
                                return n === !1 && (n = await a.apply(t, e)), n;
                            })();
                            let n = i.apply(t, e);
                            return n === !1 && (n = a.apply(t, e)), n;
                        };
                    }
                    n.hooks = t;
                }
                if (e.walkTokens) {
                    let t = this.defaults.walkTokens, r = e.walkTokens;
                    n.walkTokens = function(e) {
                        let n = [];
                        return n.push(r.call(this, e)), t && (n = n.concat(t.call(this, e))), n;
                    };
                }
                this.defaults = {
                    ...this.defaults,
                    ...n
                };
            }), this;
        }
        setOptions(e) {
            return this.defaults = {
                ...this.defaults,
                ...e
            }, this;
        }
        lexer(e, t) {
            return q.lex(e, t ?? this.defaults);
        }
        parser(e, t) {
            return X.parse(e, t ?? this.defaults);
        }
        parseMarkdown(e) {
            return (t, n)=>{
                let r = {
                    ...n
                }, i = {
                    ...this.defaults,
                    ...r
                }, a = this.onError(!!i.silent, !!i.async);
                if (this.defaults.async === !0 && r.async === !1) return a(Error(`marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise.`));
                if (typeof t > `u` || t === null) return a(Error(`marked(): input parameter is undefined or null`));
                if (typeof t != `string`) return a(Error(`marked(): input parameter is of type ` + Object.prototype.toString.call(t) + `, string expected`));
                if (i.hooks && (i.hooks.options = i, i.hooks.block = e), i.async) return (async ()=>{
                    let n = i.hooks ? await i.hooks.preprocess(t) : t, r = await (i.hooks ? await i.hooks.provideLexer() : e ? q.lex : q.lexInline)(n, i), a = i.hooks ? await i.hooks.processAllTokens(r) : r;
                    i.walkTokens && await Promise.all(this.walkTokens(a, i.walkTokens));
                    let o = await (i.hooks ? await i.hooks.provideParser() : e ? X.parse : X.parseInline)(a, i);
                    return i.hooks ? await i.hooks.postprocess(o) : o;
                })().catch(a);
                try {
                    i.hooks && (t = i.hooks.preprocess(t));
                    let n = (i.hooks ? i.hooks.provideLexer() : e ? q.lex : q.lexInline)(t, i);
                    i.hooks && (n = i.hooks.processAllTokens(n)), i.walkTokens && this.walkTokens(n, i.walkTokens);
                    let r = (i.hooks ? i.hooks.provideParser() : e ? X.parse : X.parseInline)(n, i);
                    return i.hooks && (r = i.hooks.postprocess(r)), r;
                } catch (e) {
                    return a(e);
                }
            };
        }
        onError(e, t) {
            return (n)=>{
                if (n.message += `
Please report this to https://github.com/markedjs/marked.`, e) {
                    let e = `<p>An error occurred:</p><pre>` + V(n.message + ``, !0) + `</pre>`;
                    return t ? Promise.resolve(e) : e;
                }
                if (t) return Promise.reject(n);
                throw n;
            };
        }
    };
    function $(e, t) {
        return Q.parse(e, t);
    }
    return $.options = $.setOptions = function(e) {
        return Q.setOptions(e), $.defaults = Q.defaults, r($.defaults), $;
    }, $.getDefaults = t, $.defaults = n, $.use = function(...e) {
        return Q.use(...e), $.defaults = Q.defaults, r($.defaults), $;
    }, $.walkTokens = function(e, t) {
        return Q.walkTokens(e, t);
    }, $.parseInline = Q.parseInline, $.Parser = X, $.parser = X.parse, $.Renderer = J, $.TextRenderer = Y, $.Lexer = q, $.lexer = q.lex, $.Tokenizer = K, $.Hooks = Z, $.parse = $, $.options, $.setOptions, $.use, $.walkTokens, $.parseInline, X.parse, q.lex, ()=>{
        let t, n = null, r;
        function i() {
            if (n && !n.closed) n.focus();
            else {
                if (n = window.open(`about:blank`, `reveal.js - Notes`, `width=1100,height=700`), n.marked = $, n.document.write(e), !n) {
                    alert(`Speaker view popup failed to open. Please make sure popups are allowed and reopen the speaker view.`);
                    return;
                }
                o();
            }
        }
        function a(e) {
            n && !n.closed ? n.focus() : (n = e, window.addEventListener(`message`, u), d());
        }
        function o() {
            let e = r.getConfig().url, i = typeof e == `string` ? e : window.location.protocol + `//` + window.location.host + window.location.pathname + window.location.search;
            t = setInterval(function() {
                n.postMessage(JSON.stringify({
                    namespace: `reveal-notes`,
                    type: `connect`,
                    state: r.getState(),
                    url: i
                }), `*`);
            }, 500), window.addEventListener(`message`, u);
        }
        function s(e, t, i) {
            let a = r[e].apply(r, t);
            n.postMessage(JSON.stringify({
                namespace: `reveal-notes`,
                type: `return`,
                result: a,
                callId: i
            }), `*`);
        }
        function c(e) {
            let t = r.getCurrentSlide(), i = t.querySelectorAll(`aside.notes`), a = t.querySelector(`.current-fragment`), o = {
                namespace: `reveal-notes`,
                type: `state`,
                notes: ``,
                markdown: !1,
                whitespace: `normal`,
                state: r.getState()
            };
            if (t.hasAttribute(`data-notes`) && (o.notes = t.getAttribute(`data-notes`), o.whitespace = `pre-wrap`), a) {
                let e = a.querySelector(`aside.notes`);
                e ? (o.notes = e.innerHTML, o.markdown = typeof e.getAttribute(`data-markdown`) == `string`, i = null) : a.hasAttribute(`data-notes`) && (o.notes = a.getAttribute(`data-notes`), o.whitespace = `pre-wrap`, i = null);
            }
            i && i.length && (i = Array.from(i).filter((e)=>e.closest(`.fragment`) === null), o.notes = i.map((e)=>e.innerHTML).join(`
`), o.markdown = i[0] && typeof i[0].getAttribute(`data-markdown`) == `string`), n.postMessage(JSON.stringify(o), `*`);
        }
        function l(e) {
            try {
                return window.location.origin === e.source.location.origin;
            } catch  {
                return !1;
            }
        }
        function u(e) {
            if (l(e)) try {
                let n = JSON.parse(e.data);
                n && n.namespace === `reveal-notes` && n.type === `connected` ? (clearInterval(t), d()) : n && n.namespace === `reveal-notes` && n.type === `call` && s(n.methodName, n.arguments, n.callId);
            } catch  {}
        }
        function d() {
            r.on(`slidechanged`, c), r.on(`fragmentshown`, c), r.on(`fragmenthidden`, c), r.on(`overviewhidden`, c), r.on(`overviewshown`, c), r.on(`paused`, c), r.on(`resumed`, c), r.on(`previewiframe`, c), r.on(`previewimage`, c), r.on(`previewvideo`, c), r.on(`closeoverlay`, c), c();
        }
        return {
            id: `notes`,
            init: function(e) {
                r = e, /receiver/i.test(window.location.search) || (window.location.search.match(/(\?|\&)notes/gi) === null ? window.addEventListener(`message`, (e)=>{
                    if (!n && typeof e.data == `string`) {
                        let t;
                        try {
                            t = JSON.parse(e.data);
                        } catch  {}
                        t && t.namespace === `reveal-notes` && t.type === `heartbeat` && a(e.source);
                    }
                }) : i(), r.addKeyBinding({
                    keyCode: 83,
                    key: `S`,
                    description: `Speaker notes view`
                }, function() {
                    i();
                }));
            },
            open: i
        };
    };
});


/**
 * Reveal.js Header plugin
 *
 * Keeps a slide-specific <header> element visually pinned and cross-faded
 * between slide transitions.
 *
 * How it works:
 * - On slidechanged: positions previous slide's header off-canvas and hides it,
 *   while the new slide's header is positioned fixed and faded in.
 * - On slidetransitionend: ensures the current slide's header is fully opaque.
 *
 * Notes:
 * - The plugin manipulates inline styles to ensure predictable behavior across
 *   different themes.
 * - This does not create or inject header elements, it only enhances those
 *   already present in slides.

 * Handles opening of and synchronization with the reveal.js
 * notes window.
 *
 * Handshake process:
 * 1. This window posts 'connect' to notes window
 *    - Includes URL of presentation to show
 * 2. Notes window responds with 'connected' when it is available
 * 3. This window proceeds to send the current presentation state
 *    to the notes window
 *
 * Copyright (c) 2025 Emiliano "pixu1980" Pisu

* @returns {{ id: string, init: function, update: function }} A Reveal plugin definition.
 */ const $9c018b1227cb7cf2$var$HeaderPlugin = ()=>{
    let deck;
    const headerPlugin = {
        id: "header",
        /**
		 * Initialize the plugin with the Reveal deck instance.
		 * @param {import('reveal.js').default} reveal - Reveal instance
		 */ init: (reveal)=>{
            deck = reveal;
            deck.addEventListener("slidechanged", (e)=>{
                // Move previous header out of view and reset inline bounds
                if (e.previousSlide) {
                    const prevHeaderElement = e.previousSlide.querySelector("header");
                    if (!!prevHeaderElement) {
                        prevHeaderElement.style.position = "fixed";
                        prevHeaderElement.style.top = 0;
                        prevHeaderElement.style.left = 0;
                        prevHeaderElement.style.right = 0;
                        prevHeaderElement.style.opacity = 0;
                        prevHeaderElement.style.width = "100vw";
                    }
                }
                if (e.currentSlide) {
                    const headerElement = e.currentSlide.querySelector("header");
                    if (!!headerElement) {
                        // Pin the current header and cross-fade it into view
                        headerElement.style.position = "fixed !important";
                        headerElement.style.top = "0 !important";
                        headerElement.style.left = "0 !important";
                        headerElement.style.right = "0 !important";
                        headerElement.style.width = "100vw !important";
                        headerElement.style.opacity = !e.previousSlide;
                        headerElement.style.transition = "opacity .2s ease-in-out";
                    }
                }
            });
            deck.addEventListener("slidetransitionend", (e)=>{
                const headerElement = e.currentSlide.querySelector("header");
                if (!!headerElement) // Ensure final state is fully visible
                headerElement.style.opacity = 1;
            });
        },
        /**
		 * Optional external update hook.
		 * @param {any} e - Event or payload
		 */ update: (e)=>{}
    };
    return headerPlugin;
};
var $9c018b1227cb7cf2$export$2e2bcd8739ae039 = $9c018b1227cb7cf2$var$HeaderPlugin;


/**
 * Reveal.js Menu Plugin
 *
 * Provides a slide navigation side menu with panels for slides, themes, and settings.
 *
 * Features:
 * - Keyboard navigation and toggling
 * - Mouse navigation with selection management
 * - Sticky and auto open options
 * - Panelized UI (slides, themes, transitions, help)
 * - Highlights the current slide and keeps items visible on selection
 *
 * Usage:
 * - Register this plugin with Reveal and configure via `menu` settings.
 * - Default settings are defined in the `defaults` object.
 *
 * Notes:
 * - The plugin manipulates DOM elements within a container added to the Reveal root.
 * - Several helper methods operate on `this.dom` to manage the menu lifecycle.
 * - For very long slide decks, consider debouncing UI updates.

 * Copyright (c) 2025 Emiliano "pixu1980" Pisu
*/ const $d0c3a20e5a4c334e$var$defaults = {
    side: 'right',
    numbers: false,
    titleSelector: 'h1, h2, h3, h4, h5',
    hideMissingTitles: false,
    useTextContentForMissingTitles: false,
    markers: true,
    transitions: [
        'None',
        'Fade',
        'Slide',
        'Convex',
        'Concave',
        'Zoom'
    ],
    openButton: true,
    openSlideNumber: false,
    keyboard: true,
    sticky: false,
    autoOpen: true,
    delayInit: false,
    openOnInit: false
};
class $d0c3a20e5a4c334e$var$Menu {
    deck;
    dom = {
        reveal: null,
        toolbar: null,
        menu: null,
        buttons: []
    };
    settings = {};
    create(tagName, attrs, content) {
        var el = document.createElement(tagName);
        if (attrs) Object.getOwnPropertyNames(attrs).forEach((n)=>el.setAttribute(n, attrs[n]));
        if (content) el.innerHTML = content;
        return el;
    }
    //#region Mouse & Keyboard handling
    mouseSelectionEnabled = true;
    disableMouseSelection() {
        this.mouseSelectionEnabled = false;
    }
    reenableMouseSelection() {
        // wait until the mouse has moved before re-enabling mouse selection
        // to avoid selections on scroll
        const tempMouseMoveEventHandler = (e)=>{
            this.dom.menu.querySelector('nav.slide-menu').removeEventListener('mousemove', tempMouseMoveEventHandler);
            //XXX this should select the item under the mouse
            this.mouseSelectionEnabled = true;
        };
        this.dom.menu.querySelector('nav.slide-menu').addEventListener('mousemove', tempMouseMoveEventHandler);
    }
    keepVisible(el) {
        var offset = window.uiuxEngineering.visibleOffset(el);
        if (offset) {
            this.disableMouseSelection();
            el.scrollIntoView(offset > 0);
            this.reenableMouseSelection();
        }
    }
    scrollItemToTop(el) {
        this.disableMouseSelection();
        el.offsetParent.scrollTop = el.offsetTop;
        this.reenableMouseSelection();
    }
    scrollItemToBottom(el) {
        this.disableMouseSelection();
        el.offsetParent.scrollTop = el.offsetTop - el.offsetParent.offsetHeight + el.offsetHeight;
        this.reenableMouseSelection();
    }
    selectItem(el) {
        el.classList.add('selected');
        this.keepVisible(el);
        if (this.settings.sticky && this.settings.autoOpen) this.openItem(el);
    }
    onDocumentKeyDown(event) {
        // opening menu is handled by registering key binding with Reveal below
        if (this.isOpen()) {
            event.stopImmediatePropagation();
            switch(event.keyCode){
                // case 77:
                // 	closeMenu();
                // 	break;
                // h, left - change panel
                case 72:
                case 37:
                    this.prevPanel();
                    break;
                // l, right - change panel
                case 76:
                case 39:
                    this.nextPanel();
                    break;
                // k, up
                case 75:
                case 38:
                    var currItem = this.dom.menu.querySelector('.active-menu-panel .slide-menu-items li.selected') || this.dom.menu.querySelector('.active-menu-panel .slide-menu-items li.active');
                    if (currItem) {
                        this.dom.menu.querySelectorAll('.active-menu-panel .slide-menu-items li').forEach((item)=>{
                            item.classList.remove('selected');
                        });
                        var nextItem = this.dom.menu.querySelector('.active-menu-panel .slide-menu-items li[data-item="' + (parseInt(currItem.getAttribute('data-item')) - 1) + '"]') || currItem;
                        this.selectItem(nextItem);
                    } else {
                        var item = this.dom.menu.querySelector('.active-menu-panel .slide-menu-items li.slide-menu-item');
                        if (item) this.selectItem(item);
                    }
                    break;
                // j, down
                case 74:
                case 40:
                    var currItem = this.dom.menu.querySelector('.active-menu-panel .slide-menu-items li.selected') || this.dom.menu.querySelector('.active-menu-panel .slide-menu-items li.active');
                    if (currItem) {
                        this.dom.menu.querySelectorAll('.active-menu-panel .slide-menu-items li').forEach((item)=>{
                            item.classList.remove('selected');
                        });
                        var nextItem = this.dom.menu.querySelector('.active-menu-panel .slide-menu-items li[data-item="' + (parseInt(currItem.getAttribute('data-item')) + 1) + '"]') || currItem;
                        this.selectItem(nextItem);
                    } else {
                        var item = this.dom.menu.querySelector('.active-menu-panel .slide-menu-items li.slide-menu-item');
                        if (item) this.selectItem(item);
                    }
                    break;
                // pageup, u
                case 33:
                case 85:
                    var itemsAbove = this.dom.menu.querySelectorAll('.active-menu-panel .slide-menu-items li').filter((item)=>window.uiuxEngineering.visibleOffset(item) > 0);
                    var visibleItems = this.dom.menu.querySelectorAll('.active-menu-panel .slide-menu-items li').filter((item)=>window.uiuxEngineering.visibleOffset(item) == 0);
                    var firstVisible = itemsAbove.length > 0 && Math.abs(window.uiuxEngineering.visibleOffset(itemsAbove[itemsAbove.length - 1])) < itemsAbove[itemsAbove.length - 1].clientHeight ? itemsAbove[itemsAbove.length - 1] : visibleItems[0];
                    if (firstVisible) {
                        if (firstVisible.classList.contains('selected') && itemsAbove.length > 0) {
                            // at top of viewport already, page scroll (if not at start)
                            // ...move selected item to bottom, and change selection to last fully visible item at top
                            this.scrollItemToBottom(firstVisible);
                            visibleItems = this.dom.menu.querySelectorAll('.active-menu-panel .slide-menu-items li').filter((item)=>window.uiuxEngineering.visibleOffset(item) == 0);
                            if (visibleItems[0] == firstVisible) // prev item is still beyond the viewport (for custom panels)
                            firstVisible = itemsAbove[itemsAbove.length - 1];
                            else firstVisible = visibleItems[0];
                        }
                        this.dom.menu.querySelectorAll('.active-menu-panel .slide-menu-items li').forEach((item)=>{
                            item.classList.remove('selected');
                        });
                        this.selectItem(firstVisible);
                        // ensure selected item is positioned at the top of the viewport
                        this.scrollItemToTop(firstVisible);
                    }
                    break;
                // pagedown, d
                case 34:
                case 68:
                    var visibleItems = this.dom.menu.querySelectorAll('.active-menu-panel .slide-menu-items li').filter((item)=>window.uiuxEngineering.visibleOffset(item) == 0);
                    var itemsBelow = this.dom.menu.querySelectorAll('.active-menu-panel .slide-menu-items li').filter((item)=>window.uiuxEngineering.visibleOffset(item) < 0);
                    var lastVisible = itemsBelow.length > 0 && Math.abs(window.uiuxEngineering.visibleOffset(itemsBelow[0])) < itemsBelow[0].clientHeight ? itemsBelow[0] : visibleItems[visibleItems.length - 1];
                    if (lastVisible) {
                        if (lastVisible.classList.contains('selected') && itemsBelow.length > 0) {
                            // at bottom of viewport already, page scroll (if not at end)
                            // ...move selected item to top, and change selection to last fully visible item at bottom
                            this.scrollItemToTop(lastVisible);
                            visibleItems = this.dom.menu.querySelectorAll('.active-menu-panel .slide-menu-items li').filter((item)=>window.uiuxEngineering.visibleOffset(item) == 0);
                            if (visibleItems[visibleItems.length - 1] == lastVisible) // next item is still beyond the viewport (for custom panels)
                            lastVisible = itemsBelow[0];
                            else lastVisible = visibleItems[visibleItems.length - 1];
                        }
                        this.dom.menu.querySelectorAll('.active-menu-panel .slide-menu-items li').forEach((item)=>{
                            item.classList.remove('selected');
                        });
                        this.selectItem(lastVisible);
                        // ensure selected item is positioned at the bottom of the viewport
                        this.scrollItemToBottom(lastVisible);
                    }
                    break;
                // home
                case 36:
                    this.dom.menu.querySelectorAll('.active-menu-panel .slide-menu-items li').forEach((item)=>{
                        item.classList.remove('selected');
                    });
                    var item = this.dom.menu.querySelector('.active-menu-panel .slide-menu-items li:first-of-type');
                    if (item) {
                        item.classList.add('selected');
                        this.keepVisible(item);
                    }
                    break;
                // end
                case 35:
                    this.dom.menu.querySelectorAll('.active-menu-panel .slide-menu-items li').forEach((item)=>{
                        item.classList.remove('selected');
                    });
                    var item = this.dom.menu.querySelector('.active-menu-panel .slide-menu-items:last-of-type li:last-of-type');
                    if (item) {
                        item.classList.add('selected');
                        this.keepVisible(item);
                    }
                    break;
                // space, return
                case 32:
                case 13:
                    var currItem = this.dom.menu.querySelector('.active-menu-panel .slide-menu-items li.selected');
                    if (currItem) this.openItem(currItem, true);
                    break;
                // esc
                case 27:
                    this.closeMenu(null, true);
                    break;
            }
        }
    }
    //#endregion
    //#region Plugin Methods
    openMenu(event) {
        if (event) event.preventDefault();
        if (!this.isOpen()) {
            document.querySelector('body').classList.add('slide-menu-active');
            this.dom.reveal.classList.add('has-' + this.settings.effect + '-' + this.settings.side);
            this.dom.menu.querySelector('.slide-menu').classList.add('active');
            this.dom.menu.querySelector('.slide-menu-overlay').classList.add('active');
            // identify active theme
            // if (this.settings.themes) {
            //   this.dom.menu.querySelectorAll('div[data-panel="Themes"] li').forEach((i) => {
            //     i.classList.remove('active');
            //   });
            //   this.dom.menu.querySelectorAll(
            //     'li[data-theme="' + this.dom.menu.querySelector('link#theme').getAttribute('href') + '"]'
            //   ).forEach((i) => {
            //     i.classList.add('active');
            //   });
            // }
            // identify active transition
            if (this.settings.transitions) {
                this.dom.menu.querySelectorAll('div[data-panel="Transitions"] li').forEach((i)=>{
                    i.classList.remove('active');
                });
                this.dom.menu.querySelectorAll('li[data-transition="' + this.settings.transition + '"]').forEach((i)=>{
                    i.classList.add('active');
                });
            }
            // set item selections to match active items
            var items = this.dom.menu.querySelectorAll('.slide-menu-panel li.active');
            items.forEach((i)=>{
                i.classList.add('selected');
                this.keepVisible(i);
            });
        }
    }
    closeMenu(event, force) {
        if (event) event.preventDefault();
        if (!this.settings.sticky || force) {
            document.querySelector('body').classList.remove('slide-menu-active');
            this.dom.reveal.classList.remove('has-' + this.settings.effect + '-' + this.settings.side);
            this.dom.menu.querySelector('.slide-menu').classList.remove('active');
            this.dom.menu.querySelector('.slide-menu-overlay').classList.remove('active');
            this.dom.menu.querySelectorAll('.slide-menu-panel li.selected').forEach((i)=>{
                i.classList.remove('selected');
            });
        }
    }
    toggle(event) {
        if (this.isOpen()) this.closeMenu(event, true);
        else this.openMenu(event);
    }
    isOpen() {
        return document.querySelector('body').classList.contains('slide-menu-active');
    }
    openPanel(event, ref) {
        this.openMenu(event);
        var panel = ref;
        if (typeof ref !== 'string') panel = event.currentTarget.getAttribute('data-panel');
        this.dom.menu.querySelector('.slide-menu-toolbar > li.active-toolbar-button').classList.remove('active-toolbar-button');
        this.dom.menu.querySelector('li[data-panel="' + panel + '"]').classList.add('active-toolbar-button');
        this.dom.menu.querySelector('.slide-menu-panel.active-menu-panel').classList.remove('active-menu-panel');
        this.dom.menu.querySelector('div[data-panel="' + panel + '"]').classList.add('active-menu-panel');
    }
    nextPanel() {
        var next = (parseInt(this.dom.menu.querySelector('.active-toolbar-button').getAttribute('data-button')) + 1) % this.dom.buttons.length;
        this.openPanel(null, this.dom.menu.querySelector('.toolbar-panel-button[data-button="' + next + '"]').getAttribute('data-panel'));
    }
    prevPanel() {
        var next = parseInt(this.dom.menu.querySelector('.active-toolbar-button').getAttribute('data-button')) - 1;
        if (next < 0) next = this.dom.buttons.length - 1;
        this.openPanel(null, this.dom.menu.querySelector('.toolbar-panel-button[data-button="' + next + '"]').getAttribute('data-panel'));
    }
    openItem(item, force) {
        var h = parseInt(item.getAttribute('data-slide-h'));
        var v = parseInt(item.getAttribute('data-slide-v'));
        // var theme = item.getAttribute('data-theme');
        var highlightTheme = item.getAttribute('data-highlight-theme');
        var transition = item.getAttribute('data-transition');
        if (!isNaN(h) && !isNaN(v)) this.deck.slide(h, v);
        // if (theme) {
        //   this.changeStylesheet('theme', theme);
        // }
        // if (highlightTheme) {
        //   this.changeStylesheet('highlight-theme', highlightTheme);
        // }
        if (transition) this.deck.configure({
            transition: transition
        });
        var link = this.dom.menu.querySelector('a', item);
        if (link) {
            if (force || !this.settings.sticky || this.settings.autoOpen && link.href.startsWith('#') || link.href.startsWith(window.location.origin + window.location.pathname + '#')) link.click();
        }
        this.closeMenu();
    }
    clicked(event) {
        if (event.target.nodeName !== 'A') event.preventDefault();
        this.openItem(event.currentTarget);
    }
    highlightCurrentSlide() {
        var state = this.deck.getState();
        this.dom.menu.querySelectorAll('li.slide-menu-item, li.slide-menu-item-vertical').forEach((item)=>{
            item.classList.remove('past');
            item.classList.remove('active');
            item.classList.remove('future');
            var h = parseInt(item.getAttribute('data-slide-h'));
            var v = parseInt(item.getAttribute('data-slide-v'));
            if (h < state.indexh || h === state.indexh && v < state.indexv) item.classList.add('past');
            else if (h === state.indexh && v === state.indexv) item.classList.add('active');
            else item.classList.add('future');
        });
    }
    // matchRevealStyle() {
    //   var revealStyle = window.getComputedStyle(this.dom.reveal);
    //   var element = this.dom.menu.querySelector('.slide-menu');
    //   element.style.fontFamily = revealStyle.fontFamily;
    //   //XXX could adjust the complete menu style to match the theme, ie colors, etc
    // }
    addToolbarButton(title, ref, icon, style, fn, active) {
        var attrs = {
            'data-button': '' + this.dom.buttons.length + 1,
            class: 'toolbar-panel-button' + (active ? ' active-toolbar-button' : '')
        };
        if (ref) attrs['data-panel'] = ref;
        var button = this.create('li', attrs);
        if (icon.startsWith('fa-')) button.appendChild(this.create('i', {
            class: style + ' ' + icon
        }));
        else button.innerHTML = icon + '</i>';
        button.appendChild(this.create('br'), this.dom.menu.querySelector('i', button));
        button.appendChild(this.create('span', {
            class: 'slide-menu-toolbar-label'
        }, title), this.dom.menu.querySelector('i', button));
        button.onclick = fn;
        this.dom.buttons.push(button);
        this.dom.toolbar.appendChild(button);
        return button;
    }
    //
    // Slide links
    //
    text(selector, parent) {
        if (selector === '') return null;
        var el = parent ? parent.querySelector(selector) : this.dom.menu.querySelector(selector);
        if (el) return el.textContent;
        return null;
    }
    generateItem(type, section, i, h, v) {
        var link = '/#/' + h;
        if (typeof v === 'number' && !isNaN(v)) link += '/' + v;
        var title = this.text('[data-menu-title]', section) || this.text('[data-id="slide-title"]', section) || this.text('.menu-title', section) || this.text(this.settings.titleSelector, section);
        if (!title && this.settings.useTextContentForMissingTitles) {
            // attempt to figure out a title based on the text in the slide
            title = section.textContent.trim();
            if (title) title = title.split('\n').map((t)=>t.trim()).join(' ').trim().replace(/^(.{16}[^\s]*).*/, '$1') // limit to 16 chars plus any consecutive non-whitespace chars (to avoid breaking words)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;') + '...';
        }
        if (!title) {
            if (this.settings.hideMissingTitles) return '';
            type += ' no-title';
            title = 'Slide ' + (i + 1);
        }
        var item = this.create('li', {
            class: type,
            'data-item': i,
            'data-slide-h': h,
            'data-slide-v': v === undefined ? 0 : v
        });
        if (this.settings.markers) {
            item.appendChild(this.create('i', {
                class: 'fas fa-check-circle fa-fw past'
            }));
            item.appendChild(this.create('i', {
                class: 'fas fa-arrow-alt-circle-right fa-fw active'
            }));
            item.appendChild(this.create('i', {
                class: 'far fa-circle fa-fw future'
            }));
        }
        if (this.settings.numbers) {
            // Number formatting taken from reveal.js
            var value = [];
            var format = 'h.v';
            // Check if a custom number format is available
            if (typeof this.settings.numbers === 'string') format = this.settings.numbers;
            else if (typeof this.settings.slideNumber === 'string') // Take user defined number format for slides
            format = this.settings.slideNumber;
            switch(format){
                case 'c':
                    value.push(i + 1);
                    break;
                case 'c/t':
                    value.push(i + 1, '/', this.deck.getTotalSlides());
                    break;
                case 'h/v':
                    value.push(h + 1);
                    if (typeof v === 'number' && !isNaN(v)) value.push('/', v + 1);
                    break;
                default:
                    value.push(h + 1);
                    if (typeof v === 'number' && !isNaN(v)) value.push('.', v + 1);
            }
            item.appendChild(this.create('span', {
                class: 'slide-menu-item-number'
            }, value.join('') + '. '));
        }
        item.appendChild(this.create('span', {
            class: 'slide-menu-item-title'
        }, title));
        return item;
    }
    createSlideMenu() {
        if (!this.dom.menu.querySelector('section[data-markdown]:not([data-markdown-parsed])')) {
            var panel = this.create('div', {
                'data-panel': 'Slides',
                class: 'slide-menu-panel active-menu-panel'
            });
            panel.appendChild(this.create('ul', {
                class: 'slide-menu-items'
            }));
            this.dom.panels.appendChild(panel);
            var items = this.dom.menu.querySelector('.slide-menu-panel[data-panel="Slides"] > .slide-menu-items');
            var slideCount = 0;
            this.dom.reveal.querySelectorAll('.slides > section').forEach((section, h)=>{
                var subsections = section.querySelectorAll('section');
                if (subsections.length > 0) subsections.forEach((subsection, v)=>{
                    var type = v === 0 ? 'slide-menu-item' : 'slide-menu-item-vertical';
                    var item = this.generateItem(type, subsection, slideCount, h, v);
                    if (item) items.appendChild(item);
                    slideCount++;
                });
                else {
                    var item = this.generateItem('slide-menu-item', section, slideCount, h);
                    if (item) items.appendChild(item);
                    slideCount++;
                }
            });
            this.dom.menu.querySelectorAll('.slide-menu-item, .slide-menu-item-vertical').forEach((i)=>{
                i.onclick = (e)=>this.clicked(e);
            });
            this.highlightCurrentSlide();
        } else // wait for markdown to be loaded and parsed
        setTimeout(this.createSlideMenu, 100);
    }
    handleMouseHighlight(event) {
        if (this.mouseSelectionEnabled) {
            this.dom.menu.querySelectorAll('.active-menu-panel .slide-menu-items li.selected').forEach((i)=>{
                i.classList.remove('selected');
            });
            event.currentTarget.classList.add('selected');
        }
    }
    initMenu() {
        // if (!initialized) {
        this.dom.panels = this.create('nav', {
            class: 'slide-menu slide-menu--' + this.settings.side
        });
        if (typeof this.settings.width === 'string') {
            if ([
                'normal',
                'wide',
                'third',
                'half',
                'full'
            ].indexOf(this.settings.width) != -1) this.dom.panels.classList.add('slide-menu--' + this.settings.width);
            else {
                this.dom.panels.classList.add('slide-menu--custom');
                this.dom.panels.style.width = this.settings.width;
            }
        }
        this.dom.menu.appendChild(this.dom.panels);
        // this.matchRevealStyle();
        var overlay = this.create('div', {
            class: 'slide-menu-overlay'
        });
        this.dom.menu.appendChild(overlay);
        overlay.onclick = ()=>{
            this.closeMenu(null, true);
        };
        this.dom.toolbar = this.create('ol', {
            class: 'slide-menu-toolbar'
        });
        this.dom.menu.querySelector('.slide-menu').appendChild(this.dom.toolbar);
        this.addToolbarButton('Slides', 'Slides', 'fa-images', 'fas', this.openPanel.bind(this), true);
        // if (this.settings.custom) {
        //   this.settings.custom.forEach((element, index, array) => {
        //     this.addToolbarButton(
        //       element.title,
        //       'Custom' + index,
        //       element.icon,
        //       null,
        //       openPanel
        //     );
        //   });
        // }
        // if (this.settings.themes) {
        //   this.addToolbarButton('Themes', 'Themes', 'fa-adjust', 'fas', openPanel);
        // }
        if (this.settings.transitions) this.addToolbarButton('Transitions', 'Transitions', 'fa-sticky-note', 'fas', this.openPanel.bind(this));
        var button = this.create('li', {
            id: 'close',
            class: 'toolbar-panel-button'
        });
        button.appendChild(this.create('i', {
            class: 'fas fa-times'
        }));
        button.appendChild(this.create('br'));
        button.appendChild(this.create('span', {
            class: 'slide-menu-toolbar-label'
        }, 'Close'));
        button.onclick = ()=>{
            this.closeMenu(null, true);
        };
        // TODO: add button in this.dom.buttons?
        this.dom.toolbar.appendChild(button);
        this.createSlideMenu();
        this.deck.addEventListener('slidechanged', (e)=>this.highlightCurrentSlide(e));
        //
        // Custom menu panels
        //
        // if (this.settings.custom) {
        //   function xhrSuccess() {
        //     if (this.status >= 200 && this.status < 300) {
        //       this.panel.innerHTML = this.responseText;
        //       this.enableCustomLinks(this.panel);
        //     } else {
        //       this.showErrorMsg(this);
        //     }
        //   }
        //   function xhrError() {
        //     this.showErrorMsg(this);
        //   }
        //   function loadCustomPanelContent(panel, sURL) {
        //     var oReq = new XMLHttpRequest();
        //     oReq.panel = panel;
        //     oReq.arguments = Array.prototype.slice.call(arguments, 2);
        //     oReq.onload = xhrSuccess;
        //     oReq.onerror = xhrError;
        //     oReq.open('get', sURL, true);
        //     oReq.send(null);
        //   }
        //   function enableCustomLinks(panel) {
        //     this.dom.menu.querySelectorAll('ul.slide-menu-items li.slide-menu-item', panel).forEach(
        //       function (item, i) {
        //         item.setAttribute('data-item', i + 1);
        //         item.onclick = clicked;
        //         item.addEventListener('mouseenter', handleMouseHighlight);
        //       }
        //     );
        //   }
        //   function showErrorMsg(response) {
        //     var msg =
        //       '<p>ERROR: The attempt to fetch ' +
        //       response.responseURL +
        //       ' failed with HTTP status ' +
        //       response.status +
        //       ' (' +
        //       response.statusText +
        //       ').</p>' +
        //       '<p>Remember that you need to serve the presentation HTML from a HTTP server.</p>';
        //     response.panel.innerHTML = msg;
        //   }
        //   this.settings.custom.forEach(function (element, index, array) {
        //     var panel = this.create('div', {
        //       'data-panel': 'Custom' + index,
        //       class: 'slide-menu-panel slide-menu-custom-panel'
        //     });
        //     if (element.content) {
        //       panel.innerHTML = element.content;
        //       this.enableCustomLinks(panel);
        //     } else if (element.src) {
        //       this.loadCustomPanelContent(panel, element.src);
        //     }
        //     panels.appendChild(panel);
        //   });
        // }
        //
        // Themes
        //
        // if (this.settings.themes) {
        //   var panel = this.create('div', {
        //     class: 'slide-menu-panel',
        //     'data-panel': 'Themes'
        //   });
        //   panels.appendChild(panel);
        //   var menu = this.create('ul', { class: 'slide-menu-items' });
        //   panel.appendChild(menu);
        //   this.settings.themes.forEach(function (t, i) {
        //     var attrs = {
        //       class: 'slide-menu-item',
        //       'data-item': '' + (i + 1)
        //     };
        //     if (t.theme) {
        //       attrs['data-theme'] = t.theme;
        //     }
        //     if (t.highlightTheme) {
        //       attrs['data-highlight-theme'] = t.highlightTheme;
        //     }
        //     var item = this.create('li', attrs, t.name);
        //     menu.appendChild(item);
        //     item.onclick = clicked;
        //   });
        // }
        //
        // Transitions
        //
        if (this.settings.transitions) {
            var panel = this.create('div', {
                class: 'slide-menu-panel',
                'data-panel': 'Transitions'
            });
            this.dom.panels.appendChild(panel);
            var menu = this.create('ul', {
                class: 'slide-menu-items'
            });
            panel.appendChild(menu);
            this.settings.transitions.forEach((name, i)=>{
                var item = this.create('li', {
                    class: 'slide-menu-item',
                    'data-transition': name.toLowerCase(),
                    'data-item': '' + (i + 1)
                }, name);
                menu.appendChild(item);
                item.onclick = (e)=>this.clicked(e);
            });
        }
        //
        // Open menu options
        //
        if (this.settings.openButton) {
            // add menu button
            var div = this.create('div', {
                class: 'slide-menu-button'
            });
            var link = this.create('a', {
                href: '#'
            });
            link.appendChild(this.create('i', {
                class: 'fas fa-bars'
            }));
            div.appendChild(link);
            this.dom.reveal.appendChild(div);
            div.onclick = (e)=>this.openMenu(e);
        }
        if (this.settings.openSlideNumber) {
            var slideNumber = this.dom.menu.querySelector('div.slide-number');
            slideNumber.onclick = (e)=>this.openMenu(e);
        }
        //
        // Handle mouse overs
        //
        this.dom.menu.querySelectorAll('.slide-menu-panel .slide-menu-items li').forEach((item)=>{
            item.addEventListener('mouseenter', (e)=>this.handleMouseHighlight(e));
        });
        // }
        if (this.settings.keyboard) {
            //XXX add keyboard option for custom key codes, etc.
            document.addEventListener('keydown', (e)=>this.onDocumentKeyDown(e), false);
            // handle key presses within speaker notes
            window.addEventListener('message', (event)=>{
                var data;
                try {
                    data = JSON.parse(event.data);
                } catch (e) {}
                if (data && data.method === 'triggerKey') this.onDocumentKeyDown({
                    keyCode: data.args[0],
                    stopImmediatePropagation: ()=>{}
                });
            });
            // Prevent reveal from processing keyboard events when the menu is open
            if (this.settings.keyboardCondition && typeof this.settings.keyboardCondition === 'function') // combine user defined keyboard condition with the menu's own condition
            this.settings.keyboardCondition = (event)=>this.settings.keyboardCondition(event) && (!this.isOpen() || event.keyCode == 77);
            else this.settings.keyboardCondition = (event)=>!this.isOpen() || event.keyCode == 77;
            this.deck.addKeyBinding({
                keyCode: 77,
                key: 'M',
                description: 'Toggle menu'
            }, (e)=>this.toggle(e));
        }
        if (this.settings.openOnInit) this.openMenu();
    }
    //#endregion
    init() {
        this.dom.menu = document.createElement('div');
        this.dom.menu.classList.add('slide-menu-wrapper');
        this.dom.reveal = document.querySelector('.reveal');
        this.dom.reveal.parentElement.appendChild(this.dom.menu);
        // do not load the menu in the upcoming slide panel in the speaker notes
        if (!(this.deck.isSpeakerNotes() && window.location.search.endsWith('controls=false'))) {
            if (!this.settings.delayInit) this.initMenu();
            this.deck.dispatchEvent('menu-ready', this, true);
        }
    }
    constructor(deck){
        this.deck = deck;
        this.settings = {
            ...$d0c3a20e5a4c334e$var$defaults,
            ...deck.getConfig()?.menu
        };
        this.init();
    }
}
const $d0c3a20e5a4c334e$var$Plugin = ()=>{
    let instance;
    return {
        id: 'menu',
        init: (deck)=>{
            instance = new $d0c3a20e5a4c334e$var$Menu(deck);
        },
        toggleMenu: ()=>{
            instance.toggle();
        }
    };
};
var $d0c3a20e5a4c334e$export$2e2bcd8739ae039 = $d0c3a20e5a4c334e$var$Plugin;


/**
 * Reveal.js toolbar plugin
 * Toolbar plugin defaults.
 *
 * @typedef {Object} ToolbarOptions
 * @property {'top'|'bottom'} [position='top'] - Toolbar position in the viewport
 * @property {boolean|Object} [fullscreen=true] - Enable fullscreen button or pass options
 * @property {boolean|Object} [colorScheme=true] - Enable color scheme switcher button
 * @property {boolean|Object} [overview=true] - Enable overview toggle button
 * @property {boolean|Object} [pause=false] - Enable pause toggle button
 * @property {boolean|Object} [notes=false] - Enable speaker notes button (hidden in notes view)
 * @property {boolean|Object} [help=true] - Enable help overlay toggle
 * @property {boolean|Object} [menu=true] - Enable menu toggle (requires menu plugin)
 * 
 * Copyright (c) 2025 Emiliano "pixu1980" Pisu
 */ /* TODO:
 * - Notes ?
 * - PDF export ?
 * - tooltips
 */ const $218228611f8e80fd$var$defaults = {
    position: "top",
    fullscreen: true,
    colorScheme: true,
    overview: true,
    pause: false,
    notes: false,
    help: true,
    menu: true
};
class $218228611f8e80fd$var$Toolbar {
    deck;
    dom = {
        reveal: null,
        toolbar: null,
        buttons: []
    };
    settings = {};
    /**
	 * Add a generic button to the toolbar.
	 * @param {{class?: string, caption?: string, content?: string, handler?: (e:MouseEvent)=>void}} settings
	 */ addActionButton(settings) {
        const button = document.createElement("button");
        button.setAttribute("type", "button");
        button.classList.add("reveal-toolbar-button");
        settings.class && button.classList.add(settings.class);
        settings.caption && (button.innerText = settings.caption);
        settings.content && (button.innerHTML = settings.content);
        settings.handler && button.addEventListener("click", settings.handler);
        this.dom.buttons.push(button);
        this.dom.toolbar.appendChild(button);
    }
    /**
	 * Add a named action button with default styling and event dispatch.
	 * @param {string} name - Action name, used for classes and events
	 * @param {string} caption - Text caption for the button
	 * @param {Object|boolean} options - Extra options or boolean to enable/disable
	 * @param {(e:MouseEvent)=>void} handler - Click handler
	 */ addAction(name, caption, options, handler) {
        const defaults = {
            class: `reveal-toolbar-button-${name}`,
            caption: caption,
            content: undefined
        };
        const settings = {
            ...defaults,
            ...Object.prototype.toString.call(options) === "[object Object]" && options,
            handler: (e)=>{
                handler && handler(e);
                this.deck.dispatchEvent(`toolbar-${name}-action`, this, true);
            }
        };
        this.addActionButton(settings);
    }
    /**
	 * Cycle through color scheme meta values: 'light' -> 'dark' -> 'light dark'.
	 * Updates a toolbar icon class accordingly.
	 */ toggleColorScheme() {
        let meta = document.querySelector('meta[name="color-scheme"]');
        if (!meta) {
            document.head.insertAdjacentHTML("beforeend", '<meta name="color-scheme" content="light dark" />');
            meta = document.querySelector('meta[name="color-scheme"]');
        }
        const values = [
            "light",
            "dark",
            "light dark"
        ];
        const icons = Object.freeze({
            light: "sun",
            dark: "moon",
            "light dark": "computer"
        });
        const current = meta.content.trim();
        // Applica il nuovo valore
        meta.content = values[(values.indexOf(current) + 1) % values.length];
        const icon = this.dom.toolbar.querySelector("button.reveal-toolbar-button-colorScheme icon");
        icon.setAttribute("class", `draft-ui-icon-${icons[meta.content]}`);
    }
    /**
	 * Initialize toolbar DOM, attach to Reveal container and register default buttons.
	 */ init() {
        this.dom.toolbar = document.createElement("div");
        this.dom.toolbar.classList.add("reveal-toolbar");
        this.dom.toolbar.classList.add(this.settings.position == "top" ? "reveal-toolbar-top" : "reveal-toolbar-bottom");
        this.dom.reveal = document.querySelector(".reveal");
        this.dom.reveal.appendChild(this.dom.toolbar);
        this.settings.menu && this.addAction("menu", "M", this.settings.menu, (e)=>{
            this.deck.getPlugin("menu")?.toggleMenu();
        });
        this.settings.help && this.addAction("help", "?", this.settings.help, (e)=>{
            this.deck.toggleHelp();
            this.dom.reveal.querySelector(".overlay-help header .close").remove();
            this.dom.reveal.querySelector(".overlay-help table tr:nth-child(2) td:first-child").innerText = "SPACE";
            this.dom.reveal.querySelector(".overlay-help table tr:nth-child(3) td:first-child").innerText = "BACKSPACE";
            this.dom.reveal.querySelectorAll(".overlay-help header, .overlay-help .viewport").forEach((item)=>{
                item.addEventListener("click", (e)=>{
                    this.deck.toggleHelp();
                }, {
                    once: true
                });
            });
        });
        this.settings.colorScheme && this.addAction("colorScheme", "C", this.settings.colorScheme, (e)=>{
            this.toggleColorScheme();
        });
        this.settings.overview && this.addAction("overview", "O", this.settings.overview, (e)=>{
            this.deck.toggleOverview();
        });
        this.settings.notes && !this.deck.isSpeakerNotes() && this.addAction("notes", "N", this.settings.notes, (e)=>{
            this.deck.getPlugin("notes")?.open();
        });
        this.settings.fullscreen && this.addAction("fullscreen", "F", this.settings.fullscreen, (e)=>{
            var fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
            !document.exitFullscreen && (document.exitFullscreen = document.mozExitFullscreen || document.webkitExitFullscreen || document.msExitFullscreen);
            fullscreenElement ? document.exitFullscreen() : this.deck.triggerKey(70);
        });
        this.settings.pause && this.addAction("pause", "P", this.settings.pause, (e)=>{
            this.deck.togglePause();
            this.deck.addEventListener("paused", function() {
            // var icon = dom.pauseButton.querySelector('i');
            // icon.classList.remove('fa-eye-slash');
            // icon.classList.add('fa-eye');
            });
            this.deck.addEventListener("resumed", function() {
            // var icon = dom.pauseButton.querySelector('i');
            // icon.classList.remove('fa-eye');
            // icon.classList.add('fa-eye-slash');
            });
        });
    }
    /**
	 * Create a Toolbar instance.
	 * @param {import('reveal.js').default} deck - Reveal instance
	 */ constructor(deck){
        this.deck = deck;
        this.settings = {
            ...$218228611f8e80fd$var$defaults,
            ...deck.getConfig()?.toolbar
        };
        this.init();
        this.deck.dispatchEvent("toolbar-ready", this, true);
    }
}
/**
 * Toolbar plugin factory for Reveal.js.
 * @returns {{ id: string, init: (deck:any)=>void }} Plugin definition
 */ const $218228611f8e80fd$var$Plugin = ()=>{
    return {
        id: "toolbar",
        init: (deck)=>{
            new $218228611f8e80fd$var$Toolbar(deck);
        }
    };
};
var $218228611f8e80fd$export$2e2bcd8739ae039 = $218228611f8e80fd$var$Plugin;




/**
 * DiveIn stacked container component
 *
 * Enhances a `<dive-in>` element that contains a `<stack-container>` with
 * several `<stack-item>` children.
 *
 * Behavior:
 * - Assigns a sequential CSS custom property `--index` to each `stack-item`
 *   (reversed order), which can be used from CSS to create depth and staggered
 *   visual effects.
 * - Listens for mouse movements and computes an offset from the viewport center.
 *   The computed values are written to `--mouse-x` and `--mouse-y` on the
 *   `stack-container`, enabling CSS driven parallax/tilt effects.
 *
 * Lifecycle:
 * - Registered as the `dive-in` custom element.
 * - Initializes when the element is connected and cleans up listeners when it
 *   is disconnected.

 * Performance notes:
 * - The `mousemove` handler writes CSS variables on every event. For complex
 *   scenes consider throttling with requestAnimationFrame.
 */ class $24d74b15d3df6225$var$DiveInElement extends HTMLElement {
    static{
        !customElements.get('dive-in') && customElements.define('dive-in', $24d74b15d3df6225$var$DiveInElement);
    }
    constructor(){
        super();
        this.handleMouseMove = this.handleMouseMove.bind(this);
    }
    connectedCallback() {
        this.refreshStack();
        document.addEventListener('mousemove', this.handleMouseMove);
    }
    disconnectedCallback() {
        document.removeEventListener('mousemove', this.handleMouseMove);
    }
    refreshStack() {
        const stackContainer = this.querySelector('stack-container');
        if (!stackContainer) return;
        const stackItems = [
            ...stackContainer.querySelectorAll('stack-item')
        ].reverse();
        for(let index = 0; index < stackItems.length; index += 1)stackItems[index].style.setProperty('--index', index);
    }
    handleMouseMove(event) {
        const stackContainer = this.querySelector('stack-container');
        if (!stackContainer) return;
        const viewportCenterX = window.innerWidth / 2;
        const viewportCenterY = window.innerHeight / 2;
        const offsetX = viewportCenterX - event.clientX;
        const offsetY = viewportCenterY - event.clientY;
        stackContainer.style.setProperty('--mouse-x', `${offsetX}px`);
        stackContainer.style.setProperty('--mouse-y', `${offsetY}px`);
    }
}


/**
 * Stagger animation components
 *
 * Enhances `<stagger-container>` containers by assigning a per-child CSS variable
 * `--stagger--index` to allow staggered effects in CSS.
 *
 * Usage:
 * ```html
 * <stagger-container>
 *   <div>Item A</div>
 *   <div>Item B</div>
 *   <div>Item C</div>
 * </stagger-container>
 * ```
 * Then in CSS you can refer to `--stagger--index` to offset animations/timings.
 *
 * Lifecycle:
 * - Registered as the `stagger` custom element.
 * - Recomputes child indexes when the element is connected.
 */ class $0cbbebaa814a8c92$var$StaggerElement extends HTMLElement {
    static{
        !customElements.get('stagger-container') && customElements.define('stagger-container', $0cbbebaa814a8c92$var$StaggerElement);
    }
    connectedCallback() {
        this.refreshItems();
    }
    refreshItems() {
        const staggerItems = [
            ...this.querySelectorAll(':scope > *')
        ];
        staggerItems.forEach((element, index)=>{
            element.style.setProperty('--stagger--index', index);
        });
    }
}


/**
 * Tabs component
 *
 * Enhances a semantic HTML structure:
 *
 * ```html
 * <tabs-container>
 *   <tabs-list>
 *     <a href="#panel-1" role="tab">Tab 1</a>
 *     <a href="#panel-2" role="tab">Tab 2</a>
 *   </tabs-list>
 *   <tabs-panels>
 *     <tab-panel id="panel-1" role="tabpanel">...</tab-panel>
 *     <tab-panel id="panel-2" role="tabpanel">...</tab-panel>
 *   </tabs-panels>
 * </tabs-container>
 * ```
 *
 * Behavior:
 * - Manages roving tabindex for tabs.
 * - Sets `aria-selected` on the active tab and `aria-hidden` on inactive panels.
 * - Supports arrow key navigation within the tab list.
 * - Click on a tab activates the linked panel.
 *
 * Accessibility:
 * - Uses ARIA roles and attributes expected by screen readers.
 * - On keyboard navigation, prevents default browser behavior when handling arrows.
 *
 * Lifecycle:
 * - Registered as the `tabs` custom element.
 * - Initializes on connection and removes listeners on disconnection.

 * Notes:
 * - This component assumes a mostly static DOM structure after initialization.
 */ class $d4f7c51f9fc0a2eb$var$TabsElement extends HTMLElement {
    static{
        !customElements.get('tabs-container') && customElements.define('tabs-container', $d4f7c51f9fc0a2eb$var$TabsElement);
    }
    constructor(){
        super();
        this.currentTabIndex = 0;
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }
    connectedCallback() {
        this.tabs = [
            ...this.querySelectorAll('tabs-list > a')
        ];
        this.tabsPanels = [
            ...this.querySelectorAll('tabs-panels > tab-panel')
        ];
        if (!this.tabs.length) return;
        const selectedIndex = this.tabs.findIndex((tab)=>tab.getAttribute('aria-selected') === 'true');
        this.currentTabIndex = selectedIndex >= 0 ? selectedIndex : 0;
        this.addEventListener('keydown', this.handleKeydown);
        this.addEventListener('click', this.handleClick);
        this.activateTab(this.currentTabIndex, false);
    }
    disconnectedCallback() {
        this.removeEventListener('keydown', this.handleKeydown);
        this.removeEventListener('click', this.handleClick);
    }
    resetTabsTabIndex() {
        for (const tab of this.tabs){
            tab.setAttribute('tabindex', '-1');
            tab.setAttribute('aria-selected', 'false');
        }
    }
    resetTabsPanelsVisibility() {
        for (const tabPanel of this.tabsPanels)tabPanel.setAttribute('aria-hidden', 'true');
    }
    activateTab(index, shouldFocus = true) {
        if (!this.tabs.length) return;
        this.currentTabIndex = index;
        this.resetTabsTabIndex();
        this.resetTabsPanelsVisibility();
        const currentTab = this.tabs[this.currentTabIndex];
        currentTab.setAttribute('tabindex', '0');
        currentTab.setAttribute('aria-selected', 'true');
        if (shouldFocus) currentTab.focus();
        const panel = this.querySelector(currentTab.getAttribute('href'));
        if (panel) panel.setAttribute('aria-hidden', 'false');
    }
    handleKeydown(event) {
        const key = event.which || event.keyCode;
        const leftArrow = 37;
        const upArrow = 38;
        const rightArrow = 39;
        const downArrow = 40;
        if (key < leftArrow || key > downArrow || !this.tabs.length) return;
        if (key === leftArrow || key === upArrow) this.currentTabIndex = this.currentTabIndex > 0 ? this.currentTabIndex - 1 : this.tabs.length - 1;
        else if (key === rightArrow || key === downArrow) this.currentTabIndex = this.currentTabIndex < this.tabs.length - 1 ? this.currentTabIndex + 1 : 0;
        this.activateTab(this.currentTabIndex);
        event.preventDefault();
        event.stopPropagation();
    }
    handleClick(event) {
        const target = event.target.closest('a');
        if (!target || !this.contains(target)) return;
        const nextIndex = this.tabs.indexOf(target);
        if (nextIndex < 0) return;
        this.activateTab(nextIndex, false);
        event.preventDefault();
        event.stopPropagation();
    }
}




window.pixuTalks = {
    /**
   * Pass in an element and its CSS Custom Property that you want the value of.
   * Optionally, you can determine what datatype you get back.
   *
   * @param {String} propKey
   * @param {HTMLELement} element=document.documentElement
   * @param {String} castAs='string'
   * @returns {*}
   */ getCustomProperty: (propKey, element = document.documentElement, castAs = 'string')=>{
        let response = getComputedStyle(element).getPropertyValue(propKey);
        // Tidy up the string if there's something to work with
        if (response.length) response = response.replace(/\'|"/g, '').trim();
        // Convert the response into a whatever type we wanted
        switch(castAs){
            case 'number':
            case 'int':
                return parseInt(response, 10);
            case 'float':
                return parseFloat(response, 10);
            case 'boolean':
            case 'bool':
                return response === 'true' || response === '1';
        }
        // Return the string response by default
        return response;
    },
    /**
   * Dispatches an event of the specified type from the
   * reveal DOM element.
   */ dispatchEvent (type, args) {
        var event = document.createEvent('HTMLEvents', 1, 2);
        event.initEvent(type, true, true);
        // extend(event, args);
        document.querySelector('.reveal').dispatchEvent(event);
        // If we're in an iframe, post each reveal.js event to the
        // parent window. Used by the notes plugin
        if (config.postMessageEvents && window.parent !== window.self) window.parent.postMessage(JSON.stringify({
            namespace: 'reveal',
            eventName: type,
            state: getState()
        }), '*');
    },
    getOffset (el) {
        var _x = 0;
        var _y = 0;
        while(el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)){
            _x += el.offsetLeft - el.scrollLeft;
            _y += el.offsetTop - el.scrollTop;
            el = el.offsetParent;
        }
        return {
            top: _y,
            left: _x
        };
    },
    visibleOffset (el) {
        var offsetFromTop = this.getOffset(el).top - el.offsetParent.offsetTop;
        if (offsetFromTop < 0) return -offsetFromTop;
        var offsetFromBottom = el.offsetParent.offsetHeight - (el.offsetTop - el.offsetParent.scrollTop + el.offsetHeight);
        if (offsetFromBottom < 0) return offsetFromBottom;
        return 0;
    },
    // modified from math plugin
    loadResource (url, type, callback) {
        var head = document.querySelector('head');
        var resource;
        if (type === 'script') {
            resource = document.createElement('script');
            resource.type = 'text/javascript';
            resource.src = url;
        } else if (type === 'stylesheet') {
            resource = document.createElement('link');
            resource.rel = 'stylesheet';
            resource.href = url;
        }
        // Wrapper for callback to make sure it only fires once
        var finish = function() {
            if (typeof callback === 'function') {
                callback.call();
                callback = null;
            }
        };
        resource.onload = finish;
        // IE
        resource.onreadystatechange = function() {
            if (this.readyState === 'loaded') finish();
        };
        // Normal browsers
        head.appendChild(resource);
    },
    select (selector, el) {
        if (!el) el = document;
        return el.querySelector(selector);
    },
    selectAll (selector, el) {
        if (!el) el = document;
        return Array.prototype.slice.call(el.querySelectorAll(selector));
    },
    create (tagName, attrs, content) {
        var el = document.createElement(tagName);
        if (attrs) Object.getOwnPropertyNames(attrs).forEach(function(n) {
            el.setAttribute(n, attrs[n]);
        });
        if (content) el.innerHTML = content;
        return el;
    }
};


addEventListener("DOMContentLoaded", ()=>{
    let deck = new (0, $4afc1a8f9e4d93e8$export$2e2bcd8739ae039)(document.querySelector(".reveal"), {
        ...window.location.href.includes("?print-pdf") && {
            pdfSeparateFragments: false
        },
        hash: true,
        // plugins: [Markdown, Highlight, Zoom, Notes, Menu, Toolbar, Header],
        // plugins: [Markdown, Highlight, Zoom, Notes, Toolbar, Menu],
        plugins: [
            (0, (/*@__PURE__*/$parcel$interopDefault($a6b65334d592261a$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($735d64c336cf34fc$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($f1a25014a4fb78e6$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($7a7abc3225b4e0de$exports))),
            (0, $218228611f8e80fd$export$2e2bcd8739ae039)
        ],
        navigationMode: "linear",
        menu: {
            // Specifies which side of the presentation the menu will
            // be shown. Use 'left' or 'right'.
            side: "left",
            // Specifies the width of the menu.
            // Can be one of the following:
            // 'normal', 'wide', 'third', 'half', 'full', or
            // any valid css length value
            width: "normal",
            // Add slide numbers to the titles in the slide list.
            // Use 'true' or format string (same as reveal.js slide numbers)
            numbers: true,
            // Specifies which slide elements will be used for generating
            // the slide titles in the menu. The default selects the first
            // heading element found in the slide, but you can specify any
            // valid css selector and the text from the first matching
            // element will be used.
            // Note: that a section data-menu-title attribute or an element
            // with a menu-title class will take precedence over this option
            titleSelector: "h1, h2, h3, h4, h5, h6",
            // If slides do not have a matching title, attempt to use the
            // start of the text content as the title instead
            useTextContentForMissingTitles: false,
            // Hide slides from the menu that do not have a title.
            // Set to 'true' to only list slides with titles.
            hideMissingTitles: true,
            // Adds markers to the slide titles to indicate the
            // progress through the presentation. Set to 'false'
            // to hide the markers.
            markers: true,
            // Specify custom panels to be included in the menu, by
            // providing an array of objects with 'title', 'icon'
            // properties, and either a 'src' or 'content' property.
            custom: false,
            // // Specifies the themes that will be available in the themes
            // // menu panel. Set to 'true' to show the themes menu panel
            // // with the default themes list. Alternatively, provide an
            // // array to specify the themes to make available in the
            // // themes menu panel, for example...
            // //
            // // [
            // //     { name: 'Black', theme: 'dist/theme/black.css' },
            // //     { name: 'White', theme: 'dist/theme/white.css' },
            // //     { name: 'League', theme: 'dist/theme/league.css' },
            // //     {
            // //       name: 'Dark',
            // //       theme: 'lib/reveal.js/dist/theme/black.css',
            // //       highlightTheme: 'lib/reveal.js/plugin/highlight/monokai.css'
            // //     },
            // //     {
            // //       name: 'Code: Zenburn',
            // //       highlightTheme: 'lib/reveal.js/plugin/highlight/zenburn.css'
            // //     }
            // // ]
            // //
            // // Note: specifying highlightTheme without a theme will
            // // change the code highlight theme while leaving the
            // // presentation theme unchanged.
            // themes: false,
            // // Specifies the path to the default theme files. If your
            // // presentation uses a different path to the standard reveal
            // // layout then you need to provide this option, but only
            // // when 'themes' is set to 'true'. If you provide your own
            // // list of themes or 'themes' is set to 'false' the
            // // 'themesPath' option is ignored.
            // themesPath: 'dist/theme/',
            // Specifies if the transitions menu panel will be shown.
            // Set to 'true' to show the transitions menu panel with
            // the default transitions list. Alternatively, provide an
            // array to specify the transitions to make available in
            // the transitions panel, for example...
            // ['None', 'Fade', 'Slide']
            transitions: false,
            // Adds a menu button to the slides to open the menu panel.
            // Set to 'false' to hide the button.
            openButton: false,
            // If 'true' allows the slide number in the presentation to
            // open the menu panel. The reveal.js slideNumber option must
            // be displayed for this to take effect
            openSlideNumber: false,
            // If true allows the user to open and navigate the menu using
            // the keyboard. Standard keyboard interaction with reveal
            // will be disabled while the menu is open.
            keyboard: true,
            // Normally the menu will close on user actions such as
            // selecting a menu item, or clicking the presentation area.
            // If 'true', the sticky option will leave the menu open
            // until it is explicitly closed, that is, using the close
            // button or pressing the ESC or m key (when the keyboard
            // interaction option is enabled).
            sticky: false,
            // If 'true' standard menu items will be automatically opened
            // when navigating using the keyboard. Note: this only takes
            // effect when both the 'keyboard' and 'sticky' options are enabled.
            autoOpen: true,
            // If 'true' the menu will not be created until it is explicitly
            // requested by calling RevealMenu.init(). Note this will delay
            // the creation of all menu panels, including custom panels, and
            // the menu button.
            delayInit: false,
            // If 'true' the menu will be shown when the menu is initialised.
            openOnInit: false
        },
        toolbar: {
            // Specifies where the toolbar will be shown: 'top' or 'bottom'
            position: "top",
            // // If true, the reveal.js-menu will be moved into the toolbar.
            // // Set to false to leave the menu on its own.
            // menu: {
            //   content: '<icon class="draft-ui-icon-hamburger"></icon>',
            // },
            menu: false,
            // Add button to show the help overlay
            help: {
                content: '<icon class="draft-ui-icon-circle-info"></icon>'
            },
            // Add button to toggle the overview mode on and off
            colorScheme: {
                content: '<icon class="draft-ui-icon-computer"></icon>'
            },
            // Add button to toggle the overview mode on and off
            overview: {
                content: '<icon class="draft-ui-icon-apps"></icon>'
            },
            // Add button to toggle fullscreen mode for the presentation
            fullscreen: {
                content: '<icon class="draft-ui-icon-zoom-in"></icon>'
            },
            // Add button to pause (hide) the presentation display
            pause: false,
            // Add button to show the speaker notes
            notes: false
        }
    });
    // keyboard nav configuration
    deck.configure({
        keyboard: {
            8: "prev",
            // 27: null,
            78: null
        }
    });
    deck.initialize();
    // Make the Reveal object globally available on the /demo page
    window.Reveal = deck;
});




//# sourceMappingURL=talk-reactive-apps-without-frameworks.7f895ddd.js.map
